import * as m$3 from "react";
import React, { Children, Fragment, cloneElement, createContext, createElement, createRef, forwardRef, isValidElement, memo, useCallback, useContext, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useReducer, useRef, useState } from "react";
import ReactDOM, { createPortal, flushSync, unstable_batchedUpdates } from "react-dom";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
//#region \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esmMin = (fn, res, err) => () => {
	if (err) throw err[0];
	try {
		return fn && (res = fn(fn = 0)), res;
	} catch (e) {
		throw err = [e], e;
	}
};
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod, mod.exports), cb = null), mod.exports);
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule || !__hasOwnProp.call(mod, "default") ? __defProp(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
var __toCommonJS = (mod) => __hasOwnProp.call(mod, "module.exports") ? mod["module.exports"] : __copyProps(__defProp({}, "__esModule", { value: true }), mod);
//#endregion
//#region src/theme/colors.ts
var colors = {
	inherit: "inherit",
	current: "currentColor",
	transparent: "transparent",
	black: "#000000",
	white: "#FFFFFF",
	primary: {
		900: "#0A3333",
		800: "#0E4B4B",
		700: "#116363",
		650: "#0D8080",
		600: "#009999",
		500: "#06ABAB",
		400: "#16BDBD",
		300: "#53D7D7",
		200: "#98E9E9",
		100: "#C2F2F2",
		50: "#F0FFFF"
	},
	blue: {
		900: "#0C233E",
		800: "#113054",
		700: "#17406F",
		600: "#1B4A80",
		500: "#215692",
		400: "#2C67AB",
		300: "#4E87C8",
		200: "#6DA0DB",
		100: "#98C0ED",
		50: "#CCE4FF"
	},
	green: {
		900: "#0A3321",
		800: "#0E452D",
		700: "#15593C",
		600: "#258058",
		500: "#42A67B",
		400: "#50C190",
		300: "#60D1A0",
		200: "#71DEAF",
		100: "#9FECCA",
		50: "#C2F2DD"
	},
	orange: {
		900: "#33240A",
		800: "#5A3F11",
		700: "#815916",
		600: "#BB7D13",
		500: "#E19208",
		400: "#F59B00",
		300: "#F3B241",
		200: "#F3C77A",
		100: "#F3D49E",
		50: "#F2E0C2"
	},
	lemon: {
		900: "#332700",
		800: "#5C4701",
		700: "#856704",
		600: "#C29913",
		500: "#D6AB1B",
		400: "#EBBD26",
		300: "#FFCF33",
		200: "#F7D563",
		100: "#F5DD8E",
		50: "#F2E7C2"
	},
	rsbry: {
		900: "#50111F",
		800: "#6D192C",
		700: "#A8364E",
		600: "#C54E68",
		500: "#E26F88",
		400: "#F0839B",
		300: "#FF99AF",
		200: "#F7A5B7",
		100: "#F5B2C0",
		50: "#F2C2CC"
	},
	lime: {
		900: "#14330A",
		800: "#1E4C10",
		700: "#296517",
		600: "#47962F",
		500: "#69BB50",
		400: "#86D46E",
		300: "#96E080",
		200: "#A1E88C",
		100: "#BBEFAB",
		50: "#CDF2C2"
	},
	avocado: {
		900: "#082E18",
		800: "#063D1E",
		700: "#095128",
		600: "#0E6534",
		500: "#157A41",
		400: "#30A262",
		300: "#48B678",
		200: "#68CA92",
		100: "#91DEB3",
		50: "#C2F2D7"
	},
	aqua: {
		900: "#0B333C",
		800: "#0D424E",
		700: "#0D505F",
		600: "#09657A",
		500: "#007994",
		400: "#2096B0",
		300: "#48A1B5",
		200: "#68BACC",
		100: "#89CEDE",
		50: "#C2EAF2"
	},
	gray: {
		900: "#111827",
		800: "#1F2937",
		700: "#374151",
		600: "#4B5563",
		500: "#6B7280",
		400: "#9CA3AF",
		300: "#D1D5DB",
		200: "#E5E7EB",
		100: "#F3F4F6",
		50: "#F9FAFB"
	}
};
//#endregion
//#region src/common/enums/color-variant.enum.ts
var ColorVariant = /* @__PURE__ */ function(ColorVariant) {
	ColorVariant["PRIMARY"] = "PRIMARY";
	ColorVariant["LIGHT_PRIMARY"] = "LIGHT_PRIMARY";
	ColorVariant["BLUE"] = "BLUE";
	ColorVariant["DARK_BLUE"] = "DARK_BLUE";
	ColorVariant["LIGHT_BLUE"] = "LIGHT_BLUE";
	ColorVariant["GREEN"] = "GREEN";
	ColorVariant["LIGHT_GREEN"] = "LIGHT_GREEN";
	ColorVariant["LIME"] = "LIME";
	ColorVariant["LIGHT_LIME"] = "LIGHT_LIME";
	ColorVariant["AQUA"] = "AQUA";
	ColorVariant["DARK_AQUA"] = "DARK_AQUA";
	ColorVariant["LIGHT_AVOCADO"] = "LIGHT_AVOCADO";
	ColorVariant["DARK_AVOCADO"] = "DARK_AVOCADO";
	ColorVariant["LEMON"] = "LEMON";
	ColorVariant["LIGHT_LEMON"] = "LIGHT_LEMON";
	ColorVariant["ORANGE"] = "ORANGE";
	ColorVariant["LIGHT_ORANGE"] = "LIGHT_ORANGE";
	ColorVariant["RSBRY"] = "RSBRY";
	ColorVariant["LIGHT_RSBRY"] = "LIGHT_RSBRY";
	ColorVariant["GRAY"] = "GRAY";
	return ColorVariant;
}({});
//#endregion
//#region src/common/constants/color-recipe.constants.ts
var COLOR_RECIPE_PATTERN = {
	[ColorVariant.PRIMARY]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-primary-50",
				bg: "bg-primary-600"
			},
			color: {
				text: colors.white,
				highlightText: colors.primary[50],
				bg: colors.primary[600]
			}
		},
		darkBg: {
			className: {
				text: "text-primary-500",
				highlightText: "text-primary-500",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.primary[500],
				highlightText: colors.primary[500],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-primary-600",
				highlightText: "text-primary-600",
				bg: "bg-white"
			},
			color: {
				text: colors.primary[600],
				highlightText: colors.primary[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_PRIMARY]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-primary-700",
				bg: "bg-primary-400"
			},
			color: {
				text: colors.white,
				highlightText: colors.primary[700],
				bg: colors.primary[400]
			}
		},
		darkBg: {
			className: {
				text: "text-primary-500",
				highlightText: "text-primary-500",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.primary[500],
				highlightText: colors.primary[500],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-primary-600",
				highlightText: "text-primary-600",
				bg: "bg-white"
			},
			color: {
				text: colors.primary[600],
				highlightText: colors.primary[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.BLUE]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-blue-50",
				bg: "bg-blue-600"
			},
			color: {
				text: colors.white,
				highlightText: colors.blue[50],
				bg: colors.blue[600]
			}
		},
		darkBg: {
			className: {
				text: "text-blue-300",
				highlightText: "text-blue-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.blue[300],
				highlightText: colors.blue[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-blue-600",
				highlightText: "text-blue-600",
				bg: "bg-white"
			},
			color: {
				text: colors.blue[600],
				highlightText: colors.blue[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.DARK_BLUE]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-blue-50",
				bg: "bg-blue-900"
			},
			color: {
				text: colors.white,
				highlightText: colors.blue[50],
				bg: colors.blue[900]
			}
		},
		darkBg: {
			className: {
				text: "text-blue-200",
				highlightText: "text-blue-200",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.blue[200],
				highlightText: colors.blue[200],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-blue-800",
				highlightText: "text-blue-800",
				bg: "bg-white"
			},
			color: {
				text: colors.blue[800],
				highlightText: colors.blue[800],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_BLUE]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-blue-50",
				bg: "bg-blue-300"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.blue[50],
				bg: colors.blue[300]
			}
		},
		darkBg: {
			className: {
				text: "text-blue-100",
				highlightText: "text-blue-100",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.blue[100],
				highlightText: colors.blue[100],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-blue-300",
				highlightText: "text-blue-300",
				bg: "bg-white"
			},
			color: {
				text: colors.blue[300],
				highlightText: colors.blue[300],
				bg: colors.white
			}
		}
	},
	[ColorVariant.GREEN]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-green-100",
				bg: "bg-green-600"
			},
			color: {
				text: colors.white,
				highlightText: colors.green[100],
				bg: colors.green[600]
			}
		},
		darkBg: {
			className: {
				text: "text-green-300",
				highlightText: "text-green-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.green[300],
				highlightText: colors.green[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-green-300",
				highlightText: "text-green-300",
				bg: "bg-white"
			},
			color: {
				text: colors.green[300],
				highlightText: colors.green[300],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_GREEN]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-green-700",
				bg: "bg-green-300"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.green[700],
				bg: colors.green[300]
			}
		},
		darkBg: {
			className: {
				text: "text-green-300",
				highlightText: "text-green-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.green[300],
				highlightText: colors.green[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-green-300",
				highlightText: "text-green-300",
				bg: "bg-white"
			},
			color: {
				text: colors.green[300],
				highlightText: colors.green[300],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIME]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-lime-50",
				bg: "bg-lime-600"
			},
			color: {
				text: colors.white,
				highlightText: colors.lime[50],
				bg: colors.lime[600]
			}
		},
		darkBg: {
			className: {
				text: "text-lime-300",
				highlightText: "text-lime-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.lime[300],
				highlightText: colors.lime[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-lime-500",
				highlightText: "text-lime-500",
				bg: "bg-white"
			},
			color: {
				text: colors.lime[500],
				highlightText: colors.lime[500],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_LIME]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-gray-700",
				bg: "bg-lime-300"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.gray[700],
				bg: colors.lime[300]
			}
		},
		darkBg: {
			className: {
				text: "text-lime-300",
				highlightText: "text-lime-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.lime[300],
				highlightText: colors.lime[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-lime-600",
				highlightText: "text-lime-600",
				bg: "bg-white"
			},
			color: {
				text: colors.lime[600],
				highlightText: colors.lime[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.AQUA]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-aqua-50",
				bg: "bg-aqua-500"
			},
			color: {
				text: colors.white,
				highlightText: colors.aqua[50],
				bg: colors.aqua[500]
			}
		},
		darkBg: {
			className: {
				text: "text-aqua-200",
				highlightText: "text-aqua-200",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.aqua[200],
				highlightText: colors.aqua[200],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-aqua-500",
				highlightText: "text-aqua-500",
				bg: "bg-white"
			},
			color: {
				text: colors.aqua[500],
				highlightText: colors.aqua[500],
				bg: colors.white
			}
		}
	},
	[ColorVariant.DARK_AQUA]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-aqua-50",
				bg: "bg-aqua-700"
			},
			color: {
				text: colors.white,
				highlightText: colors.aqua[50],
				bg: colors.aqua[700]
			}
		},
		darkBg: {
			className: {
				text: "text-aqua-300",
				highlightText: "text-aqua-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.aqua[300],
				highlightText: colors.aqua[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-aqua-500",
				highlightText: "text-aqua-500",
				bg: "bg-white"
			},
			color: {
				text: colors.aqua[500],
				highlightText: colors.aqua[500],
				bg: colors.white
			}
		}
	},
	[ColorVariant.DARK_AVOCADO]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-avocado-50",
				bg: "bg-avocado-800"
			},
			color: {
				text: colors.white,
				highlightText: colors.avocado[50],
				bg: colors.avocado[800]
			}
		},
		darkBg: {
			className: {
				text: "text-avocado-300",
				highlightText: "text-avocado-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.avocado[300],
				highlightText: colors.avocado[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-avocado-800",
				highlightText: "text-avocado-800",
				bg: "bg-white"
			},
			color: {
				text: colors.avocado[800],
				highlightText: colors.avocado[800],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_AVOCADO]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-avocado-700",
				bg: "bg-avocado-300"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.avocado[700],
				bg: colors.avocado[300]
			}
		},
		darkBg: {
			className: {
				text: "text-avocado-200",
				highlightText: "text-avocado-200",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.avocado[200],
				highlightText: colors.avocado[200],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-avocado-300",
				highlightText: "text-avocado-300",
				bg: "bg-white"
			},
			color: {
				text: colors.avocado[300],
				highlightText: colors.avocado[300],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LEMON]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-lemon-800",
				bg: "bg-lemon-600"
			},
			color: {
				text: colors.white,
				highlightText: colors.lemon[800],
				bg: colors.lemon[600]
			}
		},
		darkBg: {
			className: {
				text: "text-lemon-300",
				highlightText: "text-lemon-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.lemon[300],
				highlightText: colors.lemon[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-lemon-600",
				highlightText: "text-lemon-600",
				bg: "bg-white"
			},
			color: {
				text: colors.lemon[600],
				highlightText: colors.lemon[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_LEMON]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-lemon-800",
				bg: "bg-lemon-300"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.lemon[800],
				bg: colors.lemon[300]
			}
		},
		darkBg: {
			className: {
				text: "text-lemon-300",
				highlightText: "text-lemon-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.lemon[300],
				highlightText: colors.lemon[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-lemon-600",
				highlightText: "text-lemon-600",
				bg: "bg-white"
			},
			color: {
				text: colors.lemon[600],
				highlightText: colors.lemon[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.ORANGE]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-orange-800",
				bg: "bg-orange-400"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.orange[800],
				bg: colors.orange[400]
			}
		},
		darkBg: {
			className: {
				text: "text-orange-400",
				highlightText: "text-orange-400",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.orange[400],
				highlightText: colors.orange[400],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-orange-500",
				highlightText: "text-orange-500",
				bg: "bg-white"
			},
			color: {
				text: colors.orange[500],
				highlightText: colors.orange[500],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_ORANGE]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-orange-700",
				bg: "bg-orange-200"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.orange[700],
				bg: colors.orange[200]
			}
		},
		darkBg: {
			className: {
				text: "text-orange-400",
				highlightText: "text-orange-400",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.orange[400],
				highlightText: colors.orange[400],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-orange-500",
				highlightText: "text-orange-500",
				bg: "bg-white"
			},
			color: {
				text: colors.orange[500],
				highlightText: colors.orange[500],
				bg: colors.white
			}
		}
	},
	[ColorVariant.RSBRY]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-rsbry-900",
				bg: "bg-rsbry-600"
			},
			color: {
				text: colors.white,
				highlightText: colors.rsbry[900],
				bg: colors.rsbry[600]
			}
		},
		darkBg: {
			className: {
				text: "text-rsbry-300",
				highlightText: "text-rsbry-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.rsbry[300],
				highlightText: colors.rsbry[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-rsbry-600",
				highlightText: "text-rsbry-600",
				bg: "bg-white"
			},
			color: {
				text: colors.rsbry[600],
				highlightText: colors.rsbry[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.LIGHT_RSBRY]: {
		colorBg: {
			className: {
				text: "text-gray-800",
				highlightText: "text-rsbry-800",
				bg: "bg-rsbry-300"
			},
			color: {
				text: colors.gray[800],
				highlightText: colors.rsbry[800],
				bg: colors.rsbry[300]
			}
		},
		darkBg: {
			className: {
				text: "text-rsbry-300",
				highlightText: "text-rsbry-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.rsbry[300],
				highlightText: colors.rsbry[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-rsbry-600",
				highlightText: "text-rsbry-600",
				bg: "bg-white"
			},
			color: {
				text: colors.rsbry[600],
				highlightText: colors.rsbry[600],
				bg: colors.white
			}
		}
	},
	[ColorVariant.GRAY]: {
		colorBg: {
			className: {
				text: "text-white",
				highlightText: "text-gray-50",
				bg: "bg-gray-700"
			},
			color: {
				text: colors.white,
				highlightText: colors.gray[50],
				bg: colors.gray[700]
			}
		},
		darkBg: {
			className: {
				text: "text-gray-300",
				highlightText: "text-gray-300",
				bg: "bg-gray-800"
			},
			color: {
				text: colors.gray[300],
				highlightText: colors.gray[300],
				bg: colors.gray[800]
			}
		},
		whiteBg: {
			className: {
				text: "text-gray-700",
				highlightText: "text-gray-700",
				bg: "bg-white"
			},
			color: {
				text: colors.gray[700],
				highlightText: colors.gray[700],
				bg: colors.white
			}
		}
	}
};
//#endregion
//#region src/common/utils/color.utils.ts
var colorStopToColorRange = (colorStop) => {
	if (typeof colorStop === "number") return `${colorStop}%`;
	if (Array.isArray(colorStop)) return `${colorStop[0]}% ${colorStop[1]}%`;
	return "";
};
var convertRgbColorsToCss = (rgbColors) => rgbColors.map(([rgb, colorStop]) => [`rgb(${rgb.join()})`, colorStopToColorRange(colorStop)].filter(Boolean).join(" ")).join(", ");
var convertHexColorsToCss = (hexGradient) => hexGradient.map(([hex, colorStop]) => [hex, colorStopToColorRange(colorStop)].filter(Boolean).join(" ")).join(", ");
var createLinearGradientCss = ({ colors, direction = "to right" }) => {
	if (typeof colors[0][0] === "string") return `linear-gradient(${direction}, ${convertHexColorsToCss(colors)})`;
	return `linear-gradient(${direction}, ${convertRgbColorsToCss(colors)})`;
};
var pickColorStop = (colorStop) => {
	if (Array.isArray(colorStop)) return colorStop[0];
	return colorStop;
};
var isValidColorStop = (colorStop) => {
	if (Array.isArray(colorStop)) return colorStop.every(isValidColorStop);
	return typeof colorStop === "number" && colorStop >= 0;
};
var sanitizeRgbGradient = (gradient) => {
	const initialSanitizedGradient = gradient.map(([rgbColor, colorStop], index) => {
		if (index === 0) {
			if (!isValidColorStop(colorStop)) return [rgbColor, 0];
		}
		if (index === gradient.length - 1) {
			if (!isValidColorStop(colorStop)) return [rgbColor, 100];
		}
		return [rgbColor, isValidColorStop(colorStop) ? pickColorStop(colorStop) : -1];
	});
	const gradientStops = initialSanitizedGradient.map(([, colorStop], index) => [index, colorStop]).filter((rgbColorStop) => isValidColorStop(rgbColorStop[1])).map(([index, colorStop]) => [index, pickColorStop(colorStop)]);
	const innerGradients = [];
	for (let index = 0; index < gradientStops.length - 1; index++) {
		const firstGradientStop = gradientStops[index];
		const secondGradientStop = gradientStops[index + 1];
		const firstColorIndex = firstGradientStop[0];
		const secondColorIndex = secondGradientStop[0];
		const [, firstColorStop] = initialSanitizedGradient[firstGradientStop[0]];
		const [, secondColorStop] = initialSanitizedGradient[secondGradientStop[0]];
		if (firstColorIndex + 1 !== secondColorIndex) innerGradients.push([
			firstColorIndex,
			secondColorIndex,
			(firstColorStop + secondColorStop) / (secondColorIndex - firstColorIndex)
		]);
	}
	return initialSanitizedGradient.map(([rgbColor, colorStop], index) => {
		if (colorStop >= 0) return [rgbColor, colorStop];
		const innerGradient = innerGradients.find(([_, secondIndex]) => index < secondIndex);
		if (innerGradient) {
			const [firstColorIndex, , colorStop] = innerGradient;
			return [rgbColor, Math.round((index - firstColorIndex) * colorStop)];
		}
		return [rgbColor, colorStop];
	});
};
var pickRgbFromGradient = (selectedColorStop, gradient) => {
	let [firstColorIndex, secondColorIndex] = [];
	for (let index = gradient.length - 1; index >= 0; index--) {
		const [, colorStop] = gradient[index];
		if (selectedColorStop <= pickColorStop(colorStop)) [firstColorIndex, secondColorIndex] = [index - 1, index];
	}
	if (secondColorIndex === void 0) {
		const [RgbColor] = gradient[gradient.length - 1];
		return RgbColor;
	}
	if (firstColorIndex < 0) {
		const [RgbColor] = gradient[0];
		return RgbColor;
	}
	const [firstRgbColor] = gradient[firstColorIndex];
	const [secondRgbColor] = gradient[secondColorIndex];
	const [, firstColorStop] = gradient[firstColorIndex];
	const [, secondColorStop] = gradient[secondColorIndex];
	const colorsRatio = pickColorStop(secondColorStop) - pickColorStop(firstColorStop);
	return pickRgbColor(secondRgbColor, firstRgbColor, (selectedColorStop - pickColorStop(firstColorStop)) / colorsRatio);
};
var pickRgbColor = (color1, color2, ratio) => {
	const weightColor1 = ((ratio * 2 - 1) / 1 + 1) / 2;
	const weightColor2 = 1 - weightColor1;
	return [
		Math.round(color1[0] * weightColor1 + color2[0] * weightColor2),
		Math.round(color1[1] * weightColor1 + color2[1] * weightColor2),
		Math.round(color1[2] * weightColor1 + color2[2] * weightColor2)
	];
};
var getRecipeClassName = (variant, pattern) => COLOR_RECIPE_PATTERN[variant][pattern]["className"];
var getRecipeColor = (variant, pattern) => COLOR_RECIPE_PATTERN[variant][pattern]["color"];
var convertTextToNumber = (text) => Math.abs(text.split("").reduce((total, letter) => total + (letter.charCodeAt(0) - 97), 0));
var convertTextToColor = (text, colors) => {
	return colors[convertTextToNumber(text) % colors.length];
};
//#endregion
//#region src/common/utils/height.utils.ts
var Height = {
	0: "h-0",
	.5: "h-0.5",
	1: "h-1",
	1.5: "h-1.5",
	2: "h-2",
	2.5: "h-2.5",
	3: "h-3",
	3.5: "h-3.5",
	4: "h-4",
	5: "h-5",
	6: "h-6",
	7: "h-7",
	8: "h-8",
	9: "h-9",
	10: "h-10",
	11: "h-11",
	12: "h-12",
	14: "h-14",
	16: "h-16",
	20: "h-20",
	24: "h-24",
	28: "h-28",
	32: "h-32",
	36: "h-36",
	40: "h-40",
	44: "h-44",
	48: "h-48",
	52: "h-52",
	56: "h-56",
	60: "h-60",
	64: "h-64",
	72: "h-72",
	80: "h-80",
	96: "h-96",
	["1/2"]: "h-1/2",
	["1/3"]: "h-1/3",
	["2/3"]: "h-2/3",
	["1/4"]: "h-1/4",
	["2/4"]: "h-2/4",
	["3/4"]: "h-3/4",
	["1/5"]: "h-1/5",
	["2/5"]: "h-2/5",
	["3/5"]: "h-3/5",
	["4/5"]: "h-4/5",
	["1/6"]: "h-1/6",
	["2/6"]: "h-2/6",
	["3/6"]: "h-3/6",
	["4/6"]: "h-4/6",
	["5/6"]: "h-5/6",
	full: "h-full",
	screen: "h-screen",
	min: "h-min",
	max: "h-max",
	fit: "h-fit"
};
var getHeight = (height) => height ? Height[height] : null;
//#endregion
//#region src/common/utils/width.utils.ts
var Width = {
	0: "w-0",
	.5: "w-0.5",
	1: "w-1",
	1.5: "w-1.5",
	2: "w-2",
	2.5: "w-2.5",
	3: "w-3",
	3.5: "w-3.5",
	4: "w-4",
	5: "w-5",
	6: "w-6",
	7: "w-7",
	8: "w-8",
	9: "w-9",
	10: "w-10",
	11: "w-11",
	12: "w-12",
	14: "w-14",
	16: "w-16",
	20: "w-20",
	24: "w-24",
	28: "w-28",
	32: "w-32",
	36: "w-36",
	40: "w-40",
	44: "w-44",
	48: "w-48",
	52: "w-52",
	56: "w-56",
	60: "w-60",
	64: "w-64",
	72: "w-72",
	80: "w-80",
	96: "w-96",
	["1/2"]: "w-1/2",
	["1/3"]: "w-1/3",
	["2/3"]: "w-2/3",
	["1/4"]: "w-1/4",
	["2/4"]: "w-2/4",
	["3/4"]: "w-3/4",
	["1/5"]: "w-1/5",
	["2/5"]: "w-2/5",
	["3/5"]: "w-3/5",
	["4/5"]: "w-4/5",
	["1/6"]: "w-1/6",
	["2/6"]: "w-2/6",
	["3/6"]: "w-3/6",
	["4/6"]: "w-4/6",
	["5/6"]: "w-5/6",
	full: "w-full",
	screen: "w-screen",
	min: "w-min",
	max: "w-max",
	fit: "w-fit"
};
var getWidth = (width) => width ? Width[width] : null;
//#endregion
//#region src/common/utils/statistics.utils.ts
var normalizeValue = ({ max, min, scaleMaxValue = 100, value }) => (value - min) / (max - min) * scaleMaxValue;
var normalizeValueCubicRootExponentialScale = ({ max, min, scaleMaxValue = 100, value }) => {
	let mx;
	if (max < Math.abs(min)) mx = Math.pow(value - min, 3) / Math.pow(max - min, 3);
	else mx = Math.cbrt(value - min) / Math.cbrt(max - min);
	return mx * scaleMaxValue;
};
var normalizeValueSquareRootExponentialScale = ({ max, min, scaleMaxValue = 100, value }) => {
	let mx;
	if (max < Math.abs(min)) mx = Math.pow(value - min, 2) / Math.pow(max - min, 2);
	else mx = Math.sqrt(value - min) / Math.sqrt(max - min);
	return mx * scaleMaxValue;
};
//#endregion
//#region src/common/utils/gap.utils.ts
var GAP_XY = {
	0: "gap-0",
	.5: "gap-0.5",
	1: "gap-1",
	1.5: "gap-1.5",
	2: "gap-2",
	2.5: "gap-2.5",
	3: "gap-3",
	3.5: "gap-3.5",
	4: "gap-4",
	5: "gap-5",
	6: "gap-6",
	7: "gap-7",
	8: "gap-8",
	9: "gap-9",
	10: "gap-10",
	11: "gap-11",
	12: "gap-12",
	14: "gap-14",
	16: "gap-16",
	20: "gap-20",
	24: "gap-24",
	28: "gap-28",
	32: "gap-32",
	36: "gap-36",
	40: "gap-40",
	44: "gap-44",
	48: "gap-48",
	52: "gap-52",
	56: "gap-56",
	60: "gap-60",
	64: "gap-64",
	72: "gap-72",
	80: "gap-80",
	96: "gap-96",
	px: "gap-px"
};
var GAP_X = {
	0: "gap-x-0",
	.5: "gap-x-0.5",
	1: "gap-x-1",
	1.5: "gap-x-1.5",
	2: "gap-x-2",
	2.5: "gap-x-2.5",
	3: "gap-x-3",
	3.5: "gap-x-3.5",
	4: "gap-x-4",
	5: "gap-x-5",
	6: "gap-x-6",
	7: "gap-x-7",
	8: "gap-x-8",
	9: "gap-x-9",
	10: "gap-x-10",
	11: "gap-x-11",
	12: "gap-x-12",
	14: "gap-x-14",
	16: "gap-x-16",
	20: "gap-x-20",
	24: "gap-x-24",
	28: "gap-x-28",
	32: "gap-x-32",
	36: "gap-x-36",
	40: "gap-x-40",
	44: "gap-x-44",
	48: "gap-x-48",
	52: "gap-x-52",
	56: "gap-x-56",
	60: "gap-x-60",
	64: "gap-x-64",
	72: "gap-x-72",
	80: "gap-x-80",
	96: "gap-x-96",
	px: "gap-x-px"
};
var GAP_Y = {
	0: "gap-y-0",
	.5: "gap-y-0.5",
	1: "gap-y-1",
	1.5: "gap-y-1.5",
	2: "gap-y-2",
	2.5: "gap-y-2.5",
	3: "gap-y-3",
	3.5: "gap-y-3.5",
	4: "gap-y-4",
	5: "gap-y-5",
	6: "gap-y-6",
	7: "gap-y-7",
	8: "gap-y-8",
	9: "gap-y-9",
	10: "gap-y-10",
	11: "gap-y-11",
	12: "gap-y-12",
	14: "gap-y-14",
	16: "gap-y-16",
	20: "gap-y-20",
	24: "gap-y-24",
	28: "gap-y-28",
	32: "gap-y-32",
	36: "gap-y-36",
	40: "gap-y-40",
	44: "gap-y-44",
	48: "gap-y-48",
	52: "gap-y-52",
	56: "gap-y-56",
	60: "gap-y-60",
	64: "gap-y-64",
	72: "gap-y-72",
	80: "gap-y-80",
	96: "gap-y-96",
	px: "gap-y-px"
};
var getGapXY = (gap) => gap != null ? GAP_XY[gap] : "";
var getGapX = (gap) => gap != null ? GAP_X[gap] : "";
var getGapY = (gap) => gap != null ? GAP_Y[gap] : "";
//#endregion
//#region src/common/utils/space.utils.ts
var SpaceX = {
	0: "space-x-0",
	.5: "space-x-0.5",
	1: "space-x-1",
	1.5: "space-x-1.5",
	2: "space-x-2",
	2.5: "space-x-2.5",
	3: "space-x-3",
	3.5: "space-x-3.5",
	4: "space-x-4",
	5: "space-x-5",
	6: "space-x-6",
	7: "space-x-7",
	8: "space-x-8",
	9: "space-x-9",
	10: "space-x-10",
	11: "space-x-11",
	12: "space-x-12",
	14: "space-x-14",
	16: "space-x-16",
	20: "space-x-20",
	24: "space-x-24",
	28: "space-x-28",
	32: "space-x-32",
	36: "space-x-36",
	40: "space-x-40",
	44: "space-x-44",
	48: "space-x-48",
	52: "space-x-52",
	56: "space-x-56",
	60: "space-x-60",
	64: "space-x-64",
	72: "space-x-72",
	80: "space-x-80",
	96: "space-x-96",
	px: "space-x-px",
	reverse: "space-x-reverse"
};
var SpaceY = {
	0: "space-y-0",
	.5: "space-y-0.5",
	1: "space-y-1",
	1.5: "space-y-1.5",
	2: "space-y-2",
	2.5: "space-y-2.5",
	3: "space-y-3",
	3.5: "space-y-3.5",
	4: "space-y-4",
	5: "space-y-5",
	6: "space-y-6",
	7: "space-y-7",
	8: "space-y-8",
	9: "space-y-9",
	10: "space-y-10",
	11: "space-y-11",
	12: "space-y-12",
	14: "space-y-14",
	16: "space-y-16",
	20: "space-y-20",
	24: "space-y-24",
	28: "space-y-28",
	32: "space-y-32",
	36: "space-y-36",
	40: "space-y-40",
	44: "space-y-44",
	48: "space-y-48",
	52: "space-y-52",
	56: "space-y-56",
	60: "space-y-60",
	64: "space-y-64",
	72: "space-y-72",
	80: "space-y-80",
	96: "space-y-96",
	px: "space-y-px",
	reverse: "space-y-reverse"
};
var getSpaceX = (space) => space != null ? SpaceX[space] : "";
var getSpaceY = (space) => space != null ? SpaceY[space] : "";
//#endregion
//#region src/common/utils/padding.utils.ts
var PaddingX = {
	0: "px-0",
	.5: "px-0.5",
	1: "px-1",
	1.5: "px-1.5",
	2: "px-2",
	2.5: "px-2.5",
	3: "px-3",
	3.5: "px-3.5",
	4: "px-4",
	5: "px-5",
	6: "px-6",
	7: "px-7",
	8: "px-8",
	9: "px-9",
	10: "px-10",
	11: "px-11",
	12: "px-12",
	14: "px-14",
	16: "px-16",
	20: "px-20",
	24: "px-24",
	28: "px-28",
	32: "px-32",
	36: "px-36",
	40: "px-40",
	44: "px-44",
	48: "px-48",
	52: "px-52",
	56: "px-56",
	60: "px-60",
	64: "px-64",
	72: "px-72",
	80: "px-80",
	96: "px-96",
	px: "px-px"
};
var PaddingY = {
	0: "py-0",
	.5: "py-0.5",
	1: "py-1",
	1.5: "py-1.5",
	2: "py-2",
	2.5: "py-2.5",
	3: "py-3",
	3.5: "py-3.5",
	4: "py-4",
	5: "py-5",
	6: "py-6",
	7: "py-7",
	8: "py-8",
	9: "py-9",
	10: "py-10",
	11: "py-11",
	12: "py-12",
	14: "py-14",
	16: "py-16",
	20: "py-20",
	24: "py-24",
	28: "py-28",
	32: "py-32",
	36: "py-36",
	40: "py-40",
	44: "py-44",
	48: "py-48",
	52: "py-52",
	56: "py-56",
	60: "py-60",
	64: "py-64",
	72: "py-72",
	80: "py-80",
	96: "py-96",
	px: "py-px"
};
var getPaddingX = (padding) => padding != null ? PaddingX[padding] : "";
var getPaddingY = (padding) => padding != null ? PaddingY[padding] : "";
//#endregion
//#region src/common/utils/boxShadow.utils.ts
var BoxShadow = {
	sm: "shadow-sm",
	base: "shadow",
	md: "shadow-md",
	lg: "shadow-lg",
	xl: "shadow-xl",
	"2xl": "shadow-2xl",
	inner: "shadow-inner",
	none: "shadow-none"
};
var getBoxShadow = (boxShadow) => BoxShadow[boxShadow];
//#endregion
//#region ../common/lib/constants.js
var require_constants = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME = exports.MAX_SEARCH_FIREBASE_IDENTITIES = exports.PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR = exports.TEST_CAPTURED_EMAILS_LOG_PATH = exports.DB_ROUNDING_NUM_DECIMALS = exports.USER_ROUNDING_NUM_DECIMALS = exports.LAST_MONTH_DATE_DICT = exports.OLDEST_SUPPORTED_QRE_PYR_YEAR = exports.COMMON_CONSTANTS = exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023 = exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS = exports.US_COUNTRY_CODE = void 0;
	var MS_IN_DAY = 864e5;
	var MS_IN_YEAR = MS_IN_DAY * 365;
	var STATES = [
		"AL",
		"AK",
		"AS",
		"AZ",
		"AR",
		"CA",
		"CO",
		"CT",
		"DE",
		"DC",
		"FM",
		"FL",
		"GA",
		"GU",
		"HI",
		"ID",
		"IL",
		"IN",
		"IA",
		"KS",
		"KY",
		"LA",
		"ME",
		"MH",
		"MD",
		"MA",
		"MI",
		"MN",
		"MS",
		"MO",
		"MT",
		"NE",
		"NV",
		"NH",
		"NJ",
		"NM",
		"NY",
		"NC",
		"ND",
		"MP",
		"OH",
		"OK",
		"OR",
		"PW",
		"PA",
		"PR",
		"RI",
		"SC",
		"SD",
		"TN",
		"TX",
		"UT",
		"VT",
		"VI",
		"VA",
		"WA",
		"WV",
		"WI",
		"WY"
	];
	exports.US_COUNTRY_CODE = "US";
	exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS = 5e7;
	exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023 = 25e6;
	exports.COMMON_CONSTANTS = {
		SENTRY_ORG_SLUG: "neo-tax",
		NUMBER_OF_MONTHLY_SUBSCRIPTION_ITERATIONS: 12,
		NUMBER_OF_QUARTERLY_SUBSCRIPTION_ITERATIONS: 4,
		NUMBER_OF_SEMI_ANNUAL_SUBSCRIPTION_ITERATIONS: 2,
		NUMBER_OF_ONE_TIME_SUBSCRIPTION_ITERATIONS: 1,
		OUTDATED_VERSION_ERROR_NAME: "OutdatedVersion",
		MS_IN_DAY,
		MS_IN_YEAR,
		STATES,
		MAX_RD_PAYROLL_TAX_CREDIT_CENTS: exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS,
		MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023: exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023
	};
	exports.OLDEST_SUPPORTED_QRE_PYR_YEAR = 1994;
	exports.LAST_MONTH_DATE_DICT = {
		"1": "31",
		"2": "28",
		"3": "31",
		"4": "30",
		"5": "31",
		"6": "30",
		"7": "31",
		"8": "31",
		"9": "30",
		"10": "31",
		"11": "30",
		"12": "31"
	};
	/**
	* One order of magnitude less than the DB rounding (see rd-expense-project.entity.ts), to allow for some rounding error when aggregating
	*
	* Example:
	*
	* ## Setup:
	* - Project A
	* - Project A has 3 months with ticket's with effort m1, m2, and m3
	* - Assume we use simple averaging of the allocation percentage in those 3 months to get the period total allocation
	* - Assume DB_ROUNDING_NUM_DECIMALS = 2 and USER_ROUNDING_NUM_DECIMALS = 0
	*
	* ## Scenario:
	* 1. User sets the total period allocation to 100%
	* 2. We convert that into a per-month allocation percent of 100/3, which rounded using DB_ROUNDING_NUM_DECIMALS is 33.33%
	* 3. We then re-aggregate this per-month allocation percentage to get the total period allocation percentage of 99.99%,
	*   but before displaying to the user, we round to USER_ROUNDING_NUM_DECIMALS = 0 to get 100%.
	*
	* This example shows how using a two layer rounding system can help minimize rounding errors when using transformations that
	* have inherent rounding errors, such as division.
	*/
	exports.USER_ROUNDING_NUM_DECIMALS = 0;
	exports.DB_ROUNDING_NUM_DECIMALS = 8;
	exports.TEST_CAPTURED_EMAILS_LOG_PATH = "/tmp/neo-tax-captured-emails.jsonl";
	/**
	* The maximum allowed rounding error per contributor when summing up the allocation percentages.
	*/
	exports.PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR = 1 / 10 ** (exports.DB_ROUNDING_NUM_DECIMALS - 1);
	exports.MAX_SEARCH_FIREBASE_IDENTITIES = 500;
	exports.MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME = 25;
}));
//#endregion
//#region ../common/lib/neo-tax-fee-details.js
var require_neo_tax_fee_details = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.computeNeoTaxFeeDetails = void 0;
	var STRIPE_MINIMUM_FEE_PER_ITERATION = 50;
	var getIntendedTotalDiscountCents = (totalFeeCentsNoDiscount, amountOffCents, percentOff) => {
		if (amountOffCents && amountOffCents > 0) return amountOffCents;
		else if (percentOff && percentOff > 0) return Math.round(totalFeeCentsNoDiscount * percentOff * .01);
		return 0;
	};
	var computeNeoTaxFeeDetails = ({ amountOffCents, creditAmountCents, feePercent, flatFeeCents, numberOfIterations, percentOff }) => {
		const minimumTotalFeeCents = STRIPE_MINIMUM_FEE_PER_ITERATION * numberOfIterations;
		const totalFeeBeforeDiscountCents = Math.max(minimumTotalFeeCents, typeof flatFeeCents === "number" ? flatFeeCents : Math.round(creditAmountCents * feePercent));
		const intendedTotalDiscountCents = getIntendedTotalDiscountCents(totalFeeBeforeDiscountCents, amountOffCents, percentOff);
		const totalFeeAfterDiscountCents = Math.max(0, totalFeeBeforeDiscountCents - intendedTotalDiscountCents);
		const totalDiscountCents = totalFeeBeforeDiscountCents - totalFeeAfterDiscountCents;
		const iterationFeeBeforeDiscountCents = Math.max(STRIPE_MINIMUM_FEE_PER_ITERATION, Math.floor(totalFeeBeforeDiscountCents / numberOfIterations));
		const iterationFeeAfterDiscountCents = Math.floor(totalFeeAfterDiscountCents / numberOfIterations);
		return {
			iterationFeeBeforeDiscountCents,
			iterationFeeAfterDiscountCents,
			iterationDiscountCents: iterationFeeBeforeDiscountCents - iterationFeeAfterDiscountCents,
			totalFeeBeforeDiscountCents,
			totalFeeAfterDiscountCents,
			totalDiscountCents
		};
	};
	exports.computeNeoTaxFeeDetails = computeNeoTaxFeeDetails;
}));
//#endregion
//#region ../../node_modules/dayjs/dayjs.min.js
var require_dayjs_min = /* @__PURE__ */ __commonJSMin(((exports, module, this$84) => {
	(function(t, e) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
	})(this$84, (function() {
		"use strict";
		var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
		}, m = function(t, e, n) {
			var r = String(t);
			return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
		}, g = {
			s: m,
			z: function(t) {
				var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
				return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
			},
			m: function t(e, n) {
				if (e.date() < n.date()) return -t(n, e);
				var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
				return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
			},
			a: function(t) {
				return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
			},
			p: function(t) {
				return {
					M: f,
					y: c,
					w: o,
					d: a,
					D: d,
					h: u,
					m: s,
					s: i,
					ms: r,
					Q: h
				}[t] || String(t || "").toLowerCase().replace(/s$/, "");
			},
			u: function(t) {
				return void 0 === t;
			}
		}, v = "en", D = {};
		D[v] = M;
		var p = function(t) {
			return t instanceof _;
		}, S = function t(e, n, r) {
			var i;
			if (!e) return v;
			if ("string" == typeof e) {
				var s = e.toLowerCase();
				D[s] && (i = s), n && (D[s] = n, i = s);
				var u = e.split("-");
				if (!i && u.length > 1) return t(u[0]);
			} else {
				var a = e.name;
				D[a] = e, i = a;
			}
			return !r && i && (v = i), i || !r && v;
		}, w = function(t, e) {
			if (p(t)) return t.clone();
			var n = "object" == typeof e ? e : {};
			return n.date = t, n.args = arguments, new _(n);
		}, O = g;
		O.l = S, O.i = p, O.w = function(t, e) {
			return w(t, {
				locale: e.$L,
				utc: e.$u,
				x: e.$x,
				$offset: e.$offset
			});
		};
		var _ = function() {
			function M(t) {
				this.$L = S(t.locale, null, !0), this.parse(t);
			}
			var m = M.prototype;
			return m.parse = function(t) {
				this.$d = function(t) {
					var e = t.date, n = t.utc;
					if (null === e) return /* @__PURE__ */ new Date(NaN);
					if (O.u(e)) return /* @__PURE__ */ new Date();
					if (e instanceof Date) return new Date(e);
					if ("string" == typeof e && !/Z$/i.test(e)) {
						var r = e.match(l);
						if (r) {
							var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
						}
					}
					return new Date(e);
				}(t), this.$x = t.x || {}, this.init();
			}, m.init = function() {
				var t = this.$d;
				this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
			}, m.$utils = function() {
				return O;
			}, m.isValid = function() {
				return !(this.$d.toString() === $);
			}, m.isSame = function(t, e) {
				var n = w(t);
				return this.startOf(e) <= n && n <= this.endOf(e);
			}, m.isAfter = function(t, e) {
				return w(t) < this.startOf(e);
			}, m.isBefore = function(t, e) {
				return this.endOf(e) < w(t);
			}, m.$g = function(t, e, n) {
				return O.u(t) ? this[e] : this.set(n, t);
			}, m.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, m.valueOf = function() {
				return this.$d.getTime();
			}, m.startOf = function(t, e) {
				var n = this, r = !!O.u(e) || e, h = O.p(t), $ = function(t, e) {
					var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
					return r ? i : i.endOf(a);
				}, l = function(t, e) {
					return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(e)), n);
				}, y = this.$W, M = this.$M, m = this.$D, g = "set" + (this.$u ? "UTC" : "");
				switch (h) {
					case c: return r ? $(1, 0) : $(31, 11);
					case f: return r ? $(1, M) : $(0, M + 1);
					case o:
						var v = this.$locale().weekStart || 0, D = (y < v ? y + 7 : y) - v;
						return $(r ? m - D : m + (6 - D), M);
					case a:
					case d: return l(g + "Hours", 0);
					case u: return l(g + "Minutes", 1);
					case s: return l(g + "Seconds", 2);
					case i: return l(g + "Milliseconds", 3);
					default: return this.clone();
				}
			}, m.endOf = function(t) {
				return this.startOf(t, !1);
			}, m.$set = function(t, e) {
				var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), $ = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], l = o === a ? this.$D + (e - this.$W) : e;
				if (o === f || o === c) {
					var y = this.clone().set(d, 1);
					y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
				} else $ && this.$d[$](l);
				return this.init(), this;
			}, m.set = function(t, e) {
				return this.clone().$set(t, e);
			}, m.get = function(t) {
				return this[O.p(t)]();
			}, m.add = function(r, h) {
				var d, $ = this;
				r = Number(r);
				var l = O.p(h), y = function(t) {
					var e = w($);
					return O.w(e.date(e.date() + Math.round(t * r)), $);
				};
				if (l === f) return this.set(f, this.$M + r);
				if (l === c) return this.set(c, this.$y + r);
				if (l === a) return y(1);
				if (l === o) return y(7);
				var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1, m = this.$d.getTime() + r * M;
				return O.w(m, this);
			}, m.subtract = function(t, e) {
				return this.add(-1 * t, e);
			}, m.format = function(t) {
				var e = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || $;
				var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, f = n.months, h = function(t, n, i, s) {
					return t && (t[n] || t(e, r)) || i[n].slice(0, s);
				}, c = function(t) {
					return O.s(s % 12 || 12, t, "0");
				}, d = n.meridiem || function(t, e, n) {
					var r = t < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				}, l = {
					YY: String(this.$y).slice(-2),
					YYYY: this.$y,
					M: a + 1,
					MM: O.s(a + 1, 2, "0"),
					MMM: h(n.monthsShort, a, f, 3),
					MMMM: h(f, a),
					D: this.$D,
					DD: O.s(this.$D, 2, "0"),
					d: String(this.$W),
					dd: h(n.weekdaysMin, this.$W, o, 2),
					ddd: h(n.weekdaysShort, this.$W, o, 3),
					dddd: o[this.$W],
					H: String(s),
					HH: O.s(s, 2, "0"),
					h: c(1),
					hh: c(2),
					a: d(s, u, !0),
					A: d(s, u, !1),
					m: String(u),
					mm: O.s(u, 2, "0"),
					s: String(this.$s),
					ss: O.s(this.$s, 2, "0"),
					SSS: O.s(this.$ms, 3, "0"),
					Z: i
				};
				return r.replace(y, (function(t, e) {
					return e || l[t] || i.replace(":", "");
				}));
			}, m.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, m.diff = function(r, d, $) {
				var l, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, g = this - M, v = O.m(this, M);
				return v = (l = {}, l[c] = v / 12, l[f] = v, l[h] = v / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? v : O.a(v);
			}, m.daysInMonth = function() {
				return this.endOf(f).$D;
			}, m.$locale = function() {
				return D[this.$L];
			}, m.locale = function(t, e) {
				if (!t) return this.$L;
				var n = this.clone(), r = S(t, e, !0);
				return r && (n.$L = r), n;
			}, m.clone = function() {
				return O.w(this.$d, this);
			}, m.toDate = function() {
				return new Date(this.valueOf());
			}, m.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, m.toISOString = function() {
				return this.$d.toISOString();
			}, m.toString = function() {
				return this.$d.toUTCString();
			}, M;
		}(), T = _.prototype;
		return w.prototype = T, [
			["$ms", r],
			["$s", i],
			["$m", s],
			["$H", u],
			["$W", a],
			["$M", f],
			["$y", c],
			["$D", d]
		].forEach((function(t) {
			T[t[1]] = function(e) {
				return this.$g(e, t[0], t[1]);
			};
		})), w.extend = function(t, e) {
			return t.$i || (t(e, _, w), t.$i = !0), w;
		}, w.locale = S, w.isDayjs = p, w.unix = function(t) {
			return w(1e3 * t);
		}, w.en = D[v], w.Ls = D, w.p = {}, w;
	}));
}));
//#endregion
//#region ../../node_modules/dayjs/plugin/customParseFormat.js
var require_customParseFormat = /* @__PURE__ */ __commonJSMin(((exports, module, this$83) => {
	(function(e, t) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = t();
	})(this$83, (function() {
		"use strict";
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		};
		var a = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, f = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone || (this.zone = {})).offset = function(e) {
				if (!e) return 0;
				if ("Z" === e) return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return 0 === n ? 0 : "+" === t[0] ? -n : n;
			}(e);
		}], h = function(e) {
			var t = o[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = o.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * +e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * +e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, a("seconds")],
			ss: [r, a("seconds")],
			m: [r, a("minutes")],
			mm: [r, a("minutes")],
			H: [r, a("hours")],
			h: [r, a("hours")],
			HH: [r, a("hours")],
			hh: [r, a("hours")],
			D: [r, a("day")],
			DD: [n, a("day")],
			Do: [i, function(e) {
				var t = o.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, a("month")],
			MM: [n, a("month")],
			MMM: [i, function(e) {
				var t = h("months"), n = (h("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw new Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = h("months").indexOf(e) + 1;
				if (t < 1) throw new Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, a("year")],
			YY: [n, function(e) {
				this.year = s(e);
			}],
			YYYY: [/\d{4}/, a("year")],
			Z: f,
			ZZ: f
		};
		function c(n) {
			var r = n, i = o && o.formats;
			for (var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var o = r && r.toUpperCase();
				return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), a = s.length, f = 0; f < a; f += 1) {
				var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
				s[f] = l ? {
					regex: c,
					parser: l
				} : h.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < a; n += 1) {
					var i = s[n];
					if ("string" == typeof i) r += i.length;
					else {
						var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
						f.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (void 0 !== t) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, s = e.args;
				this.$u = r;
				var a = s[1];
				if ("string" == typeof a) {
					var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
					h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date(("X" === t ? 1e3 : 1) * e);
							var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = /* @__PURE__ */ new Date(), m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
							i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
							var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
							return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
						} catch (e) {
							return /* @__PURE__ */ new Date("");
						}
					}(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
				} else if (a instanceof Array) for (var l = a.length, m = 1; m <= l; m += 1) {
					s[1] = a[m - 1];
					var M = n.apply(this, s);
					if (M.isValid()) {
						this.$d = M.$d, this.$L = M.$L, this.init();
						break;
					}
					m === l && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/dayjs/plugin/isLeapYear.js
var require_isLeapYear = /* @__PURE__ */ __commonJSMin(((exports, module, this$82) => {
	(function(e, t) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isLeapYear = t();
	})(this$82, (function() {
		"use strict";
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/dayjs/plugin/utc.js
var require_utc = /* @__PURE__ */ __commonJSMin(((exports, module, this$81) => {
	(function(t, i) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_utc = i();
	})(this$81, (function() {
		"use strict";
		var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
		return function(s, f, n) {
			var u = f.prototype;
			n.utc = function(t) {
				return new f({
					date: t,
					utc: !0,
					args: arguments
				});
			}, u.utc = function(i) {
				var e = n(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return i ? e.add(this.utcOffset(), t) : e;
			}, u.local = function() {
				return n(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var o = u.parse;
			u.parse = function(t) {
				t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
			};
			var r = u.init;
			u.init = function() {
				if (this.$u) {
					var t = this.$d;
					this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
				} else r.call(this);
			};
			var a = u.utcOffset;
			u.utcOffset = function(s, f) {
				var n = this.$utils().u;
				if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
				if ("string" == typeof s && (s = function(t) {
					void 0 === t && (t = "");
					var s = t.match(i);
					if (!s) return null;
					var f = ("" + s[0]).match(e) || [
						"-",
						0,
						0
					], n = f[0], u = 60 * +f[1] + +f[2];
					return 0 === u ? 0 : "+" === n ? u : -u;
				}(s), null === s)) return this;
				var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
				if (f) return o.$offset = u, o.$u = 0 === s, o;
				if (0 !== s) {
					var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
				} else o = this.utc();
				return o;
			};
			var h = u.format;
			u.format = function(t) {
				var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return h.call(this, i);
			}, u.valueOf = function() {
				var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * t;
			}, u.isUTC = function() {
				return !!this.$u;
			}, u.toISOString = function() {
				return this.toDate().toISOString();
			}, u.toString = function() {
				return this.toDate().toUTCString();
			};
			var l = u.toDate;
			u.toDate = function(t) {
				return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
			};
			var c = u.diff;
			u.diff = function(t, i, e) {
				if (t && this.$u === t.$u) return c.call(this, t, i, e);
				var s = this.local(), f = n(t).local();
				return c.call(s, f, i, e);
			};
		};
	}));
}));
//#endregion
//#region ../common/lib/enums/analytic-identifier.enum.js
var require_analytic_identifier_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnalyticIdentifier = void 0;
	/**
	* Identifier format - <PROJECT_NAME>_<PROJECT_SECTION>_<CONTEXT>
	* Acronyms
	* - RTC = RD_TAX_CREDIT
	* - RD_CAP = R&D CAPITALIZATION
	* - ELIG = ELIGIBILITY
	*/
	var AnalyticIdentifier;
	(function(AnalyticIdentifier) {
		AnalyticIdentifier[AnalyticIdentifier["HEADER_LOGOUT"] = 1] = "HEADER_LOGOUT";
		AnalyticIdentifier[AnalyticIdentifier["HEADER_CALL_US"] = 2] = "HEADER_CALL_US";
		AnalyticIdentifier[AnalyticIdentifier["HEADER_SCHEDULE_CALL"] = 3] = "HEADER_SCHEDULE_CALL";
		AnalyticIdentifier[AnalyticIdentifier["MOBILE_HEADER_LOGOUT"] = 4] = "MOBILE_HEADER_LOGOUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_LEGAL_NAME"] = 5] = "RTC_PREP_DETAILS_LEGAL_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_SHORT_NAME"] = 6] = "RTC_PREP_DETAILS_SHORT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ADDRESS1"] = 7] = "RTC_PREP_DETAILS_ADDRESS1";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ADDRESS2"] = 8] = "RTC_PREP_DETAILS_ADDRESS2";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_CITY"] = 9] = "RTC_PREP_DETAILS_CITY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_STATE"] = 10] = "RTC_PREP_DETAILS_STATE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ZIPCODE"] = 11] = "RTC_PREP_DETAILS_ZIPCODE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ELEVATOR_PITCH"] = 12] = "RTC_PREP_DETAILS_ELEVATOR_PITCH";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_PARTNERSHIP"] = 13] = "RTC_OTHER_TAX_FACTORS_PARTNERSHIP";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_PRIOR_INC_DATE"] = 14] = "RTC_OTHER_TAX_FACTORS_PRIOR_INC_DATE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_INC_DATE"] = 15] = "RTC_OTHER_TAX_FACTORS_INC_DATE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_EIN"] = 16] = "RTC_PREP_DETAILS_EIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_PAYROLL_PROVIDERS"] = 17] = "RTC_PREP_DETAILS_PAYROLL_PROVIDERS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_HAS_PAYROLL_EIN"] = 18] = "RTC_PREP_DETAILS_HAS_PAYROLL_EIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_PAYROLL_EIN"] = 19] = "RTC_PREP_DETAILS_PAYROLL_EIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_HAS_W2_EMPLOYEES"] = 20] = "RTC_PREP_DETAILS_HAS_W2_EMPLOYEES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_BOOKS_FINALIZED"] = 21] = "RTC_PREP_DETAILS_BOOKS_FINALIZED";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_HAS_ACCOUNTANT"] = 22] = "RTC_PREP_DETAILS_HAS_ACCOUNTANT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ACCOUNTANT_NAME"] = 23] = "RTC_PREP_DETAILS_ACCOUNTANT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ACCOUNTANT_EMAIL"] = 24] = "RTC_PREP_DETAILS_ACCOUNTANT_EMAIL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_HAS_CLAIMED_ERC"] = 25] = "RTC_PREP_DETAILS_HAS_CLAIMED_ERC";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_HAS_FUNDED_RESEARCH"] = 26] = "RTC_PREP_DETAILS_HAS_FUNDED_RESEARCH";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_FUNDING_TYPES"] = 27] = "RTC_PREP_DETAILS_FUNDING_TYPES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_HAS_MADE_PAYMENTS"] = 28] = "RTC_PREP_DETAILS_HAS_MADE_PAYMENTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_RESEARCH"] = 29] = "RTC_PREP_DETAILS_RESEARCH";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_PATENTS"] = 30] = "RTC_PREP_DETAILS_PATENTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_PLANNING_TOOLS"] = 31] = "RTC_PREP_DETAILS_PLANNING_TOOLS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_DESIGN_TOOLS"] = 32] = "RTC_PREP_DETAILS_DESIGN_TOOLS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_IMPLEMENTATION_TOOLS"] = 33] = "RTC_PREP_DETAILS_IMPLEMENTATION_TOOLS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_OTHER_TOOLS"] = 34] = "RTC_PREP_DETAILS_OTHER_TOOLS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_HAS_MADE_REVENUE"] = 35] = "RTC_OTHER_TAX_FACTORS_HAS_MADE_REVENUE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_PYRS"] = 37] = "RTC_OTHER_TAX_FACTORS_PYRS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_HAS_FILED_RTC"] = 38] = "RTC_OTHER_TAX_FACTORS_HAS_FILED_RTC";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_PYQRES"] = 40] = "RTC_OTHER_TAX_FACTORS_PYQRES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_TAX_INCOME"] = 41] = "RTC_PREP_DETAILS_TAX_INCOME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_IS_PROFITABLE"] = 42] = "RTC_PREP_DETAILS_IS_PROFITABLE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_TAX_INCOME_AFTER_DEDUCT"] = 43] = "RTC_PREP_DETAILS_TAX_INCOME_AFTER_DEDUCT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_ADD_MANUALLY"] = 44] = "RTC_EXPENSES_ADD_MANUALLY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_SUBMIT_MANUALLY"] = 45] = "RTC_EXPENSES_SUBMIT_MANUALLY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_LINK_ACCOUNT"] = 46] = "RTC_EXPENSES_LINK_ACCOUNT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_SEARCH_QB"] = 47] = "RTC_EXPENSES_SEARCH_QB";
		AnalyticIdentifier[AnalyticIdentifier["LINK_GUSTO"] = 48] = "LINK_GUSTO";
		AnalyticIdentifier[AnalyticIdentifier["LINK_JUSTWORKS"] = 49] = "LINK_JUSTWORKS";
		AnalyticIdentifier[AnalyticIdentifier["LINK_RIPPLING"] = 50] = "LINK_RIPPLING";
		AnalyticIdentifier[AnalyticIdentifier["LINK_TRINET"] = 51] = "LINK_TRINET";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ZENEFITS"] = 52] = "LINK_ZENEFITS";
		AnalyticIdentifier[AnalyticIdentifier["LINK_QUICKBOOKS"] = 53] = "LINK_QUICKBOOKS";
		AnalyticIdentifier[AnalyticIdentifier["LINK_QUICKBOOKS_PAYROLL"] = 54] = "LINK_QUICKBOOKS_PAYROLL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ADP_RUN"] = 55] = "LINK_ADP_RUN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ADP_WORKFORCE"] = 56] = "LINK_ADP_WORKFORCE";
		AnalyticIdentifier[AnalyticIdentifier["LINK_PAYCHEX"] = 57] = "LINK_PAYCHEX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_MANUAL_UPLOAD"] = 58] = "RTC_EXPENSES_MANUAL_UPLOAD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_UPLOAD_SUPPLIES"] = 59] = "RTC_EXPENSES_UPLOAD_SUPPLIES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_ROLE_GUIDANCE"] = 60] = "RTC_EXPENSES_ROLE_GUIDANCE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_RIPPLING_HELP"] = 61] = "RTC_EXPENSES_RIPPLING_HELP";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_EMPLOYEES_NEXT"] = 62] = "RTC_EXPENSES_EMPLOYEES_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_CONTRACTORS_NEXT"] = 63] = "RTC_EXPENSES_CONTRACTORS_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_CLOUD_NEXT"] = 64] = "RTC_EXPENSES_CLOUD_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_LEGAL_NEXT"] = 65] = "RTC_EXPENSES_LEGAL_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_EMPLOYEES_DONE"] = 66] = "RTC_EXPENSES_EMPLOYEES_DONE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_CONTRACTORS_DONE"] = 67] = "RTC_EXPENSES_CONTRACTORS_DONE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_CLOUD_DONE"] = 68] = "RTC_EXPENSES_CLOUD_DONE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_LEGAL_DONE"] = 69] = "RTC_EXPENSES_LEGAL_DONE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES_SUPPLIES_DONE"] = 70] = "RTC_EXPENSES_SUPPLIES_DONE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_BILLING_CHOOSE_PAYMENT"] = 71] = "RTC_BILLING_CHOOSE_PAYMENT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_BILLING_CHANGE_PAYMENT"] = 72] = "RTC_BILLING_CHANGE_PAYMENT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_BILLING_SAVE_FIRST_PAYMENT"] = 73] = "RTC_BILLING_SAVE_FIRST_PAYMENT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_BILLING_SAVE_NEW_PAYMENT"] = 74] = "RTC_BILLING_SAVE_NEW_PAYMENT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_BILLING_ACCEPT_AND_CONTINUE"] = 75] = "RTC_BILLING_ACCEPT_AND_CONTINUE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_WEBSITE_URL"] = 76] = "RTC_ELIG_WEBSITE_URL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_FILED_TAX_RETURN"] = 77] = "RTC_ELIG_HAS_FILED_TAX_RETURN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HOW_ARE_YOU_TAXED"] = 78] = "RTC_ELIG_HOW_ARE_YOU_TAXED";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_INC_YEAR"] = 79] = "RTC_ELIG_INC_YEAR";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_PARTNERSHIP"] = 80] = "RTC_ELIG_PARTNERSHIP";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_PRIOR_INC_YEAR"] = 81] = "RTC_ELIG_PRIOR_INC_YEAR";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_FISCAL_YEAR_ENDS_DEC"] = 82] = "RTC_ELIG_FISCAL_YEAR_ENDS_DEC";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_TECHNICAL_PROJECTS"] = 84] = "RTC_ELIG_HAS_TECHNICAL_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_US_WORK"] = 85] = "RTC_ELIG_HAS_US_WORK";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_MADE_REVENUE"] = 86] = "RTC_ELIG_HAS_MADE_REVENUE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_FIRST_YEAR_REVENUE"] = 87] = "RTC_ELIG_FIRST_YEAR_REVENUE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_MADE_FIVE_MIL"] = 88] = "RTC_ELIG_HAS_MADE_FIVE_MIL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_FILED_RTC"] = 89] = "RTC_ELIG_HAS_FILED_RTC";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_FIRST_YEAR_FILED_RTC"] = 90] = "RTC_ELIG_FIRST_YEAR_FILED_RTC";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_ACQUIRED_ENTITY"] = 91] = "RTC_ELIG_HAS_ACQUIRED_ENTITY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_SHARED_OWNERSHIP"] = 92] = "RTC_ELIG_HAS_SHARED_OWNERSHIP";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_SIGN_UP"] = 93] = "RTC_ELIG_SIGN_UP";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_SIGN_UP_AS_ACCOUNTANT"] = 94] = "RTC_ELIG_SIGN_UP_AS_ACCOUNTANT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_REVIEW_DOWNLOAD_PDF"] = 95] = "RTC_REVIEW_DOWNLOAD_PDF";
		AnalyticIdentifier[AnalyticIdentifier["SHEETS_TRIAL_BALANCE_ROW_SIZE_BUTTON"] = 96] = "SHEETS_TRIAL_BALANCE_ROW_SIZE_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_RESET_LOGIN_BUTTON"] = 97] = "RTC_RESET_LOGIN_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_LOGIN_BUTTON"] = 98] = "RTC_LOGIN_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIGNUP_BUTTON"] = 99] = "RTC_SIGNUP_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_GOOGLE_OAUTH_BUTTON"] = 100] = "RTC_GOOGLE_OAUTH_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_INTUIT_OAUTH_BUTTON"] = 101] = "RTC_INTUIT_OAUTH_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SWITCH_LOGIN_METHOD_BUTTON"] = 102] = "RTC_SWITCH_LOGIN_METHOD_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["SHEETS_BOOK_FIN_TRIAL_BALANCE_TAB"] = 103] = "SHEETS_BOOK_FIN_TRIAL_BALANCE_TAB";
		AnalyticIdentifier[AnalyticIdentifier["SHEETS_BOOK_FIN_BALANCE_SHEET_TAB"] = 104] = "SHEETS_BOOK_FIN_BALANCE_SHEET_TAB";
		AnalyticIdentifier[AnalyticIdentifier["SHEETS_BOOK_FIN_PROFIT_AND_LOSS_TAB"] = 105] = "SHEETS_BOOK_FIN_PROFIT_AND_LOSS_TAB";
		AnalyticIdentifier[AnalyticIdentifier["SHEETS_BOOK_FIN_BOOK_TAX_DIFF_TAB"] = 106] = "SHEETS_BOOK_FIN_BOOK_TAX_DIFF_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_REVENUE_INPUT"] = 107] = "RD_CAP_REVENUE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_EXPENSES_INPUT"] = 108] = "RD_CAP_EXPENSES_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_RD_PERCENTAGE_INPUT"] = 109] = "RD_CAP_RD_PERCENTAGE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_DOMESTIC_RD_PERCENTAGE_INPUT"] = 110] = "RD_CAP_DOMESTIC_RD_PERCENTAGE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_QRE_PERCENTAGE_INPUT"] = 111] = "RD_CAP_QRE_PERCENTAGE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_OPTIMIZE_BUTTON"] = 112] = "RD_CAP_OPTIMIZE_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_LINK_QUICKBOOKS"] = 113] = "RD_CAP_LINK_QUICKBOOKS";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_EMAIL_INPUT"] = 114] = "ONBOARDING_EMAIL_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_PASSWORD_INPUT"] = 115] = "ONBOARDING_PASSWORD_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_FULL_NAME_INPUT"] = 116] = "ONBOARDING_FULL_NAME_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_PASSWORD_CONFIRMATION_INPUT"] = 117] = "ONBOARDING_PASSWORD_CONFIRMATION_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_COMPANY_NAME_INPUT"] = 119] = "ONBOARDING_COMPANY_NAME_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_CONNECT_ACCOUNT"] = 121] = "RTC_SIDE_NAV_CONNECT_ACCOUNT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_FOREIGN_RD"] = 122] = "RTC_SIDE_NAV_FOREIGN_RD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_DOMESTIC_RD_EMPLOYEE"] = 123] = "RTC_SIDE_NAV_DOMESTIC_RD_EMPLOYEE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_DOMESTIC_RD_CONTRACTOR"] = 124] = "RTC_SIDE_NAV_DOMESTIC_RD_CONTRACTOR";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_DOMESTIC_RD_CLOUD"] = 125] = "RTC_SIDE_NAV_DOMESTIC_RD_CLOUD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_DOMESTIC_RD_PATENT"] = 126] = "RTC_SIDE_NAV_DOMESTIC_RD_PATENT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_DOMESTIC_RD_SUPPLY"] = 127] = "RTC_SIDE_NAV_DOMESTIC_RD_SUPPLY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_DOMESTIC_RD"] = 128] = "RTC_SIDE_NAV_DOMESTIC_RD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_PREPARATION_DETAILS"] = 129] = "RTC_SIDE_NAV_PREPARATION_DETAILS";
		AnalyticIdentifier[AnalyticIdentifier["SELECT_GUSTO_COMPANY"] = 130] = "SELECT_GUSTO_COMPANY";
		AnalyticIdentifier[AnalyticIdentifier["CANCEL_SELECT_GUSTO_COMPANY"] = 131] = "CANCEL_SELECT_GUSTO_COMPANY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_OTHER_TAX_FACTORS"] = 132] = "RTC_SIDE_NAV_OTHER_TAX_FACTORS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_NOL_AFTER_2017"] = 133] = "RTC_OTHER_TAX_FACTORS_NOL_AFTER_2017";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_NOL_BEFORE_2018"] = 134] = "RTC_OTHER_TAX_FACTORS_NOL_BEFORE_2018";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_INC_YEAR"] = 135] = "RTC_OTHER_TAX_FACTORS_INC_YEAR";
		AnalyticIdentifier[AnalyticIdentifier["LINK_GUSTO_CANCEL"] = 136] = "LINK_GUSTO_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_JUSTWORKS_CANCEL"] = 137] = "LINK_JUSTWORKS_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_RIPPLING_CANCEL"] = 138] = "LINK_RIPPLING_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_TRINET_CANCEL"] = 139] = "LINK_TRINET_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ZENEFITS_CANCEL"] = 140] = "LINK_ZENEFITS_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_QUICKBOOKS_CANCEL"] = 141] = "LINK_QUICKBOOKS_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_QUICKBOOKS_PAYROLL_CANCEL"] = 142] = "LINK_QUICKBOOKS_PAYROLL_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ADP_RUN_CANCEL"] = 143] = "LINK_ADP_RUN_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ADP_WORKFORCE_CANCEL"] = 144] = "LINK_ADP_WORKFORCE_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_PAYCHEX_CANCEL"] = 145] = "LINK_PAYCHEX_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_RIPPLING_PREVIOUS_STEP"] = 146] = "LINK_RIPPLING_PREVIOUS_STEP";
		AnalyticIdentifier[AnalyticIdentifier["LINK_GUSTO_TRY_AGAIN"] = 147] = "LINK_GUSTO_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_JUSTWORKS_TRY_AGAIN"] = 148] = "LINK_JUSTWORKS_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_RIPPLING_TRY_AGAIN"] = 149] = "LINK_RIPPLING_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_TRINET_TRY_AGAIN"] = 150] = "LINK_TRINET_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ZENEFITS_TRY_AGAIN"] = 151] = "LINK_ZENEFITS_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_QUICKBOOKS_TRY_AGAIN"] = 152] = "LINK_QUICKBOOKS_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_QUICKBOOKS_PAYROLL_TRY_AGAIN"] = 153] = "LINK_QUICKBOOKS_PAYROLL_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ADP_RUN_TRY_AGAIN"] = 154] = "LINK_ADP_RUN_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_ADP_WORKFORCE_TRY_AGAIN"] = 155] = "LINK_ADP_WORKFORCE_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["LINK_PAYCHEX_TRY_AGAIN"] = 156] = "LINK_PAYCHEX_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_RD_TAX_SUMMARY"] = 157] = "RTC_SIDE_NAV_RD_TAX_SUMMARY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CREATE_PROJECT"] = 158] = "RTC_CREATE_PROJECT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT"] = 159] = "RTC_EDIT_PROJECT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_PROJECTS"] = 160] = "RTC_SIDE_NAV_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PROJECT_NAME"] = 161] = "RTC_PROJECT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DELETE_PROJECT"] = 162] = "RTC_DELETE_PROJECT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_ELIGIBILITY"] = 163] = "RTC_SIDE_NAV_ELIGIBILITY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HARD_SCI_OR_ENG_PROJECTS"] = 164] = "RTC_ELIG_HARD_SCI_OR_ENG_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_HOW_ARE_YOU_TAXED"] = 165] = "RTC_OTHER_TAX_FACTORS_HOW_ARE_YOU_TAXED";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_PRIOR_INC_YEAR"] = 166] = "RTC_OTHER_TAX_FACTORS_PRIOR_INC_YEAR";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_NAME"] = 167] = "RTC_ADD_PROJECT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_ABBREVIATION"] = 168] = "RTC_ADD_PROJECT_ABBREVIATION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_PURPOSE"] = 169] = "RTC_ADD_PROJECT_PURPOSE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_HARD_SCIENCE"] = 170] = "RTC_ADD_PROJECT_HARD_SCIENCE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_IS_THERE_EXPERIMENTATION"] = 171] = "RTC_ADD_PROJECT_IS_THERE_EXPERIMENTATION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_IS_THERE_UNCERTAINTY"] = 172] = "RTC_ADD_PROJECT_IS_THERE_UNCERTAINTY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_NAME"] = 173] = "RTC_EDIT_PROJECT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_ABBREVIATION"] = 174] = "RTC_EDIT_PROJECT_ABBREVIATION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_PURPOSE"] = 175] = "RTC_EDIT_PROJECT_PURPOSE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_HARD_SCIENCE"] = 176] = "RTC_EDIT_PROJECT_HARD_SCIENCE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_IS_THERE_EXPERIMENTATION"] = 177] = "RTC_EDIT_PROJECT_IS_THERE_EXPERIMENTATION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_IS_THERE_UNCERTAINTY"] = 178] = "RTC_EDIT_PROJECT_IS_THERE_UNCERTAINTY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_CREATE_PRODUCT_RADIO"] = 179] = "RTC_ADD_PROJECT_CREATE_PRODUCT_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_IMPROVE_PRODUCT_RADIO"] = 180] = "RTC_ADD_PROJECT_IMPROVE_PRODUCT_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_COMPUTER_SCIENCE_RADIO"] = 181] = "RTC_ADD_PROJECT_COMPUTER_SCIENCE_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_ENGINEERING_RADIO"] = 182] = "RTC_ADD_PROJECT_ENGINEERING_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_PHYSICS_RADIO"] = 183] = "RTC_ADD_PROJECT_PHYSICS_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_CHEMISTRY_RADIO"] = 184] = "RTC_ADD_PROJECT_CHEMISTRY_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_BIOLOGY_RADIO"] = 185] = "RTC_ADD_PROJECT_BIOLOGY_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_CREATE_PRODUCT_RADIO"] = 186] = "RTC_EDIT_PROJECT_CREATE_PRODUCT_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_IMPROVE_PRODUCT_RADIO"] = 187] = "RTC_EDIT_PROJECT_IMPROVE_PRODUCT_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_COMPUTER_SCIENCE_RADIO"] = 188] = "RTC_EDIT_PROJECT_COMPUTER_SCIENCE_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_ENGINEERING_RADIO"] = 189] = "RTC_EDIT_PROJECT_ENGINEERING_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_PHYSICS_RADIO"] = 190] = "RTC_EDIT_PROJECT_PHYSICS_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_CHEMISTRY_RADIO"] = 191] = "RTC_EDIT_PROJECT_CHEMISTRY_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_BIOLOGY_RADIO"] = 192] = "RTC_EDIT_PROJECT_BIOLOGY_RADIO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CREATE_COMPANY_COMPANY_NAME_INPUT"] = 193] = "RTC_CREATE_COMPANY_COMPANY_NAME_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CREATE_COMPANY_WEBSITE_INPUT"] = 194] = "RTC_CREATE_COMPANY_WEBSITE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_WEBSITE"] = 195] = "RTC_PREP_DETAILS_WEBSITE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_GUSTO"] = 196] = "RTC_SELECT_LINK_GUSTO";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_JUSTWORKS"] = 197] = "RTC_SELECT_LINK_JUSTWORKS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_RIPPLING"] = 198] = "RTC_SELECT_LINK_RIPPLING";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_TRINET"] = 199] = "RTC_SELECT_LINK_TRINET";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_QUICKBOOKS_PAYROLL"] = 200] = "RTC_SELECT_LINK_QUICKBOOKS_PAYROLL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_QUICKBOOKS"] = 201] = "RTC_SELECT_LINK_QUICKBOOKS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_RD_PAYMENT"] = 202] = "RTC_SIDE_NAV_RD_PAYMENT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_TERMS_OF_SERVICE_CHECKBOX"] = 203] = "RTC_TERMS_OF_SERVICE_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_INVITE_MEMBER_EMAIL_INPUT"] = 204] = "RTC_INVITE_MEMBER_EMAIL_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DELETE_MEMBER_NAME_INPUT"] = 205] = "RTC_DELETE_MEMBER_NAME_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DELETE_COMPANY_NAME_INPUT"] = 206] = "RTC_DELETE_COMPANY_NAME_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["LINK_NETSUITE"] = 207] = "LINK_NETSUITE";
		AnalyticIdentifier[AnalyticIdentifier["LINK_NETSUITE_CANCEL"] = 208] = "LINK_NETSUITE_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_NETSUITE_TRY_AGAIN"] = 209] = "LINK_NETSUITE_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_NETSUITE"] = 210] = "RTC_SELECT_LINK_NETSUITE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_ADP_RUN"] = 211] = "RTC_SELECT_LINK_ADP_RUN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_ADP_WORKFORCE_NOW"] = 212] = "RTC_SELECT_LINK_ADP_WORKFORCE_NOW";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_PAYCHEX_FLEX"] = 213] = "RTC_SELECT_LINK_PAYCHEX_FLEX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_PAYLOCITY"] = 214] = "RTC_SELECT_LINK_PAYLOCITY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_ZENEFITS"] = 215] = "RTC_SELECT_LINK_ZENEFITS";
		AnalyticIdentifier[AnalyticIdentifier["LINK_PAYLOCITY"] = 216] = "LINK_PAYLOCITY";
		AnalyticIdentifier[AnalyticIdentifier["LINK_PAYLOCITY_CANCEL"] = 217] = "LINK_PAYLOCITY_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_PAYLOCITY_TRY_AGAIN"] = 218] = "LINK_PAYLOCITY_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PAYMENT_TERMS_CHECKBOX"] = 219] = "RTC_PAYMENT_TERMS_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SUBMIT_FOR_HUMAN_REVIEW"] = 220] = "RTC_SUBMIT_FOR_HUMAN_REVIEW";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CANCEL_SUBMIT_FOR_HUMAN_REVIEW"] = 221] = "RTC_CANCEL_SUBMIT_FOR_HUMAN_REVIEW";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CLOSE_SUBMIT_FOR_HUMAN_REVIEW"] = 222] = "RTC_CLOSE_SUBMIT_FOR_HUMAN_REVIEW";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SIDE_NAV_PROJECT_DETAILS"] = 223] = "RTC_SIDE_NAV_PROJECT_DETAILS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_DESCRIPTION"] = 224] = "RTC_EDIT_PROJECT_DESCRIPTION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_PROJECT_TECHNICAL_RISK"] = 225] = "RTC_EDIT_PROJECT_TECHNICAL_RISK";
		AnalyticIdentifier[AnalyticIdentifier["RTC_RIPPLING_CSV_DOWNLOAD_LINK"] = 226] = "RTC_RIPPLING_CSV_DOWNLOAD_LINK";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_EXPENSE_TYPE"] = 227] = "RTC_ADD_MANUAL_EXPENSE_EXPENSE_TYPE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_NAME"] = 228] = "RTC_ADD_MANUAL_EXPENSE_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_AMOUNT"] = 229] = "RTC_ADD_MANUAL_EXPENSE_AMOUNT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_COUNTRY"] = 230] = "RTC_ADD_MANUAL_EXPENSE_COUNTRY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_STATE"] = 231] = "RTC_ADD_MANUAL_EXPENSE_STATE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_JOB_TITLE"] = 232] = "RTC_ADD_MANUAL_EXPENSE_JOB_TITLE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_MANUAL_EXPENSE_WORK_EMAIL"] = 233] = "RTC_ADD_MANUAL_EXPENSE_WORK_EMAIL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_EXPENSE_TYPE"] = 234] = "RTC_EDIT_MANUAL_EXPENSE_EXPENSE_TYPE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_NAME"] = 235] = "RTC_EDIT_MANUAL_EXPENSE_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_AMOUNT"] = 236] = "RTC_EDIT_MANUAL_EXPENSE_AMOUNT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_COUNTRY"] = 237] = "RTC_EDIT_MANUAL_EXPENSE_COUNTRY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_STATE"] = 238] = "RTC_EDIT_MANUAL_EXPENSE_STATE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_JOB_TITLE"] = 239] = "RTC_EDIT_MANUAL_EXPENSE_JOB_TITLE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EDIT_MANUAL_EXPENSE_WORK_EMAIL"] = 240] = "RTC_EDIT_MANUAL_EXPENSE_WORK_EMAIL";
		AnalyticIdentifier[AnalyticIdentifier["RD_CAP_OPEN_ALLOCATION_TROUSER"] = 241] = "RD_CAP_OPEN_ALLOCATION_TROUSER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OPEN_ADD_PROJECT_MODAL"] = 242] = "RTC_OPEN_ADD_PROJECT_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DELETE_PROJECT_BUTTON"] = 243] = "RTC_DELETE_PROJECT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ALLOW_REAL_COMPANY_AVATAR"] = 244] = "RTC_ALLOW_REAL_COMPANY_AVATAR";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_SIGN_UP_USER"] = 245] = "ONBOARDING_SIGN_UP_USER";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_CONTINUE_LOGIN"] = 246] = "ONBOARDING_CONTINUE_LOGIN";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_LOGIN_USER"] = 247] = "ONBOARDING_LOGIN_USER";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_COMPLETE_PROFILE"] = 248] = "ONBOARDING_COMPLETE_PROFILE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PROJECT_DETAILS_ALERT_CARD"] = 249] = "RTC_PROJECT_DETAILS_ALERT_CARD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OTHER_TAX_FACTORS_ALERT_CARD"] = 250] = "RTC_OTHER_TAX_FACTORS_ALERT_CARD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_ALERT_CARD"] = 251] = "RTC_PREP_DETAILS_ALERT_CARD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ADD_PROJECT_CANCEL_BUTTON"] = 252] = "RTC_ADD_PROJECT_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PROJECT_GUIDANCE_MODAL_NEXT"] = 253] = "RTC_PROJECT_GUIDANCE_MODAL_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PROJECT_GUIDANCE_MODAL_CLOSE"] = 254] = "RTC_PROJECT_GUIDANCE_MODAL_CLOSE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OPEN_DELETE_PROJECT_MODAL"] = 255] = "RTC_OPEN_DELETE_PROJECT_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["OPEN_CONNECT_ACCOUNT_MODAL"] = 256] = "OPEN_CONNECT_ACCOUNT_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["CONTINUE_CONNECT_ACCOUNT"] = 257] = "CONTINUE_CONNECT_ACCOUNT";
		AnalyticIdentifier[AnalyticIdentifier["CANCEL_CONNECT_ACCOUNT"] = 258] = "CANCEL_CONNECT_ACCOUNT";
		AnalyticIdentifier[AnalyticIdentifier["RIPPLING_UPLOAD_INPUT"] = 259] = "RIPPLING_UPLOAD_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RIPPLING_CLOSE_AFTER_SUCCESS_BUTTON"] = 260] = "RIPPLING_CLOSE_AFTER_SUCCESS_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_UPLOAD_ACCOUNTING_CSV"] = 261] = "RTC_SELECT_UPLOAD_ACCOUNTING_CSV";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_ACCOUNTING_CSV"] = 262] = "UPLOAD_ACCOUNTING_CSV";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_ACCOUNTING_CSV_CANCEL"] = 263] = "UPLOAD_ACCOUNTING_CSV_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_ACCOUNTING_CSV_PREVIOUS"] = 264] = "UPLOAD_ACCOUNTING_CSV_PREVIOUS";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_ACCOUNTING_CSV_INPUT"] = 265] = "UPLOAD_ACCOUNTING_CSV_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_ACCOUNTING_CSV_CLOSE_AFTER_SUCCESS_BUTTON"] = 266] = "UPLOAD_ACCOUNTING_CSV_CLOSE_AFTER_SUCCESS_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_UPLOAD_PAYROLL_CSV"] = 267] = "RTC_SELECT_UPLOAD_PAYROLL_CSV";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_PAYROLL_CSV"] = 268] = "UPLOAD_PAYROLL_CSV";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_PAYROLL_CSV_CANCEL"] = 269] = "UPLOAD_PAYROLL_CSV_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_PAYROLL_CSV_PREVIOUS"] = 270] = "UPLOAD_PAYROLL_CSV_PREVIOUS";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_PAYROLL_CSV_INPUT"] = 271] = "UPLOAD_PAYROLL_CSV_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["UPLOAD_PAYROLL_CSV_CLOSE_AFTER_SUCCESS_BUTTON"] = 272] = "UPLOAD_PAYROLL_CSV_CLOSE_AFTER_SUCCESS_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CSV_UPLOAD_TEMPLATE_DOWNLOAD_LINK"] = 273] = "RTC_CSV_UPLOAD_TEMPLATE_DOWNLOAD_LINK";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CSV_UPLOAD_EXAMPLE_DOWNLOAD_LINK"] = 274] = "RTC_CSV_UPLOAD_EXAMPLE_DOWNLOAD_LINK";
		AnalyticIdentifier[AnalyticIdentifier["RTC_FOREIGN_ALLOCATION_SLIDER"] = 275] = "RTC_FOREIGN_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_EMPLOYEES_ALLOCATION_SLIDER"] = 276] = "RTC_DOMESTIC_EMPLOYEES_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_FOREIGN_RD_GUIDANCE_MODAL_NEXT"] = 277] = "RTC_FOREIGN_RD_GUIDANCE_MODAL_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_FOREIGN_RD_GUIDANCE_MODAL_CLOSE"] = 278] = "RTC_FOREIGN_RD_GUIDANCE_MODAL_CLOSE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_EMPLOYEES_GUIDANCE_MODAL_NEXT"] = 279] = "RTC_DOMESTIC_EMPLOYEES_GUIDANCE_MODAL_NEXT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_EMPLOYEES_GUIDANCE_MODAL_CLOSE"] = 280] = "RTC_DOMESTIC_EMPLOYEES_GUIDANCE_MODAL_CLOSE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_CONTRACTORS_ALLOCATION_SLIDER"] = 281] = "RTC_DOMESTIC_CONTRACTORS_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_CLOUD_ALLOCATION_SLIDER"] = 282] = "RTC_DOMESTIC_CLOUD_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_PATENTS_ALLOCATION_SLIDER"] = 283] = "RTC_DOMESTIC_PATENTS_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DOMESTIC_SUPPLIES_ALLOCATION_SLIDER"] = 284] = "RTC_DOMESTIC_SUPPLIES_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_GRANT_FUNDING_CHECKBOX"] = 285] = "RTC_PREP_DETAILS_GRANT_FUNDING_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_CONTRACT_FUNDING_CHECKBOX"] = 286] = "RTC_PREP_DETAILS_CONTRACT_FUNDING_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_SBIR_FUNDING_CHECKBOX"] = 287] = "RTC_PREP_DETAILS_SBIR_FUNDING_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_OTHER_FUNDING_CHECKBOX"] = 288] = "RTC_PREP_DETAILS_OTHER_FUNDING_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_RESEARCH_PAPERS_CHECKBOX"] = 289] = "RTC_PREP_DETAILS_RESEARCH_PAPERS_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_PATENTS_CHECKBOX"] = 290] = "RTC_PREP_DETAILS_PATENTS_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PREP_DETAILS_WHITE_PAPERS_CHECKBOX"] = 291] = "RTC_PREP_DETAILS_WHITE_PAPERS_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ACCOUNTANT_OPEN_CREATE_COMPANY_MODAL"] = 292] = "RTC_ACCOUNTANT_OPEN_CREATE_COMPANY_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ACCOUNTANT_OPEN_INVITE_NEW_MEMBER_MODAL"] = 293] = "RTC_ACCOUNTANT_OPEN_INVITE_NEW_MEMBER_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ACCOUNTANT_INVITE_NEW_MEMBER"] = 294] = "RTC_ACCOUNTANT_INVITE_NEW_MEMBER";
		AnalyticIdentifier[AnalyticIdentifier["RTC_COMPANY_LIST_TAB"] = 295] = "RTC_COMPANY_LIST_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RTC_COMPANY_MEMBER_LIST_TAB"] = 296] = "RTC_COMPANY_MEMBER_LIST_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ACCOUNTANT_CREATE_COMPANY"] = 297] = "RTC_ACCOUNTANT_CREATE_COMPANY";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OPEN_SUBMIT_FOR_HUMAN_REVIEW_MODAL"] = 298] = "RTC_OPEN_SUBMIT_FOR_HUMAN_REVIEW_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_NAV_RD_LAUNCHPAD"] = 299] = "COMPANY_NAV_RD_LAUNCHPAD";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_NAV_FORECASTING"] = 300] = "COMPANY_NAV_FORECASTING";
		AnalyticIdentifier[AnalyticIdentifier["RTC_OPEN_MANUAL_EXPENSE_MODAL"] = 301] = "RTC_OPEN_MANUAL_EXPENSE_MODAL";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CANCEL_MANUALLY_ADD_EXPENSE"] = 302] = "RTC_CANCEL_MANUALLY_ADD_EXPENSE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_COMPANY_NAV_BAR_BUTTON"] = 303] = "RTC_COMPANY_NAV_BAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_LAUNCH_PAD"] = 304] = "RTC_LAUNCH_PAD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_REVENUES"] = 305] = "RTC_REVENUES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_EXPENSES"] = 306] = "RTC_EXPENSES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_ASANA"] = 307] = "RTC_SELECT_LINK_ASANA";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_JIRA"] = 308] = "RTC_SELECT_LINK_JIRA";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_LINEAR"] = 309] = "RTC_SELECT_LINK_LINEAR";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_TRELLO"] = 310] = "RTC_SELECT_LINK_TRELLO";
		AnalyticIdentifier[AnalyticIdentifier["GAAP_CAP_LAUNCH_PAD"] = 311] = "GAAP_CAP_LAUNCH_PAD";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_NAV_GAAP_CAP"] = 312] = "COMPANY_NAV_GAAP_CAP";
		AnalyticIdentifier[AnalyticIdentifier["GAAP_CAP_ELEVATOR_PITCH_INPUT"] = 317] = "GAAP_CAP_ELEVATOR_PITCH_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["GAAP_CAP_TECH_STACK_INPUT"] = 318] = "GAAP_CAP_TECH_STACK_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["TOS_ACCEPTED_CHECKBOX"] = 322] = "TOS_ACCEPTED_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RECAPTCHA_CHECKBOX"] = 323] = "RECAPTCHA_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_GITHUB"] = 324] = "RTC_SELECT_LINK_GITHUB";
		AnalyticIdentifier[AnalyticIdentifier["LINK_TICKETING"] = 326] = "LINK_TICKETING";
		AnalyticIdentifier[AnalyticIdentifier["LINK_TICKETING_CANCEL"] = 327] = "LINK_TICKETING_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_TICKETING_TRY_AGAIN"] = 328] = "LINK_TICKETING_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_SHORTCUT"] = 329] = "RTC_SELECT_LINK_SHORTCUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAS_FILED_EXTENSION"] = 332] = "RTC_ELIG_HAS_FILED_EXTENSION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_MONTH_AND_DAY_TAX_YEAR_END"] = 336] = "RTC_ELIG_MONTH_AND_DAY_TAX_YEAR_END";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ELIG_HAD_SHORT_TAX_YEAR"] = 337] = "RTC_ELIG_HAD_SHORT_TAX_YEAR";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DRAWER_DETAIL_TAB"] = 338] = "ASC_PROJECT_DRAWER_DETAIL_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DRAWER_CONTRIBUTOR_TAB"] = 339] = "ASC_PROJECT_DRAWER_CONTRIBUTOR_TAB";
		AnalyticIdentifier[AnalyticIdentifier["GAAP_CAP_TICKETING_SYNC_PERIOD_INPUT"] = 342] = "GAAP_CAP_TICKETING_SYNC_PERIOD_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_ASC_PROJECTS"] = 343] = "ENTERPRISE_NAV_ASC_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_PAYROLL_QRE"] = 344] = "ENTERPRISE_NAV_PAYROLL_QRE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_EXPORT_QRE"] = 345] = "ENTERPRISE_NAV_EXPORT_QRE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_EXPORT_ASC"] = 346] = "ENTERPRISE_NAV_EXPORT_ASC";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_NAME"] = 347] = "ASC_PROJECT_DETAIL_NAME";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_DESCRIPTION"] = 348] = "ASC_PROJECT_DETAIL_DESCRIPTION";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_CAPITALIZATION_START_DATE"] = 349] = "ASC_PROJECT_DETAIL_CAPITALIZATION_START_DATE";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_CAPITALIZATION_END_DATE"] = 350] = "ASC_PROJECT_DETAIL_CAPITALIZATION_END_DATE";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DRAWER_TICKETS_TAB"] = 351] = "ASC_PROJECT_DRAWER_TICKETS_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_ADAPTATION_FOR_CUSTOMER"] = 353] = "ENTERPRISE_PROJECT_ADAPTATION_FOR_CUSTOMER";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_INTERNAL_USE_SOFTWARE"] = 354] = "ENTERPRISE_PROJECT_INTERNAL_USE_SOFTWARE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_RESEARCH_FUNDED_BY_GRANT_CONTRACT_ETC"] = 355] = "ENTERPRISE_PROJECT_RESEARCH_FUNDED_BY_GRANT_CONTRACT_ETC";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_RESEARCH_INTO_SOCIAL_SCIENCES"] = 356] = "ENTERPRISE_PROJECT_RESEARCH_INTO_SOCIAL_SCIENCES";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_RESEARCH_OUTSIDE_US"] = 357] = "ENTERPRISE_PROJECT_RESEARCH_OUTSIDE_US";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_REVERSE_ENGINEERING"] = 358] = "ENTERPRISE_PROJECT_REVERSE_ENGINEERING";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_SURVEY_OR_MARKET_RESEARCH"] = 359] = "ENTERPRISE_PROJECT_SURVEY_OR_MARKET_RESEARCH";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_TESTING_OR_QA_IN_PRODUCTION"] = 360] = "ENTERPRISE_PROJECT_TESTING_OR_QA_IN_PRODUCTION";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_NARRATIVE"] = 361] = "ENTERPRISE_PROJECT_NARRATIVE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_TECHNICAL_CHALLENGES"] = 362] = "ENTERPRISE_PROJECT_TECHNICAL_CHALLENGES";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_PROCESS_OF_EXPERIMENTATION"] = 363] = "ENTERPRISE_PROJECT_PROCESS_OF_EXPERIMENTATION";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_PURPOSE"] = 364] = "ENTERPRISE_PROJECT_PURPOSE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_BUSINESS_COMPONENT"] = 365] = "ENTERPRISE_PROJECT_BUSINESS_COMPONENT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_BUSINESS_PURPOSE"] = 366] = "ENTERPRISE_PROJECT_BUSINESS_PURPOSE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_IMPROVED_FUNCTION"] = 367] = "ENTERPRISE_PROJECT_IMPROVED_FUNCTION";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_IMPROVED_RELIABILITY"] = 368] = "ENTERPRISE_PROJECT_IMPROVED_RELIABILITY";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_IMPROVED_PERFORMANCE"] = 369] = "ENTERPRISE_PROJECT_IMPROVED_PERFORMANCE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_IMPROVED_QUALITY"] = 370] = "ENTERPRISE_PROJECT_IMPROVED_QUALITY";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_TAB"] = 371] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_LINKED_TICKETING"] = 373] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_LINKED_TICKETING";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_NAME"] = 374] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_NAME";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_RD_CATEGORY"] = 375] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_GENERAL_FORM_RD_CATEGORY";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_TAB"] = 376] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_AMOUNT"] = 377] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_AMOUNT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_JOB_TITLE"] = 378] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_JOB_TITLE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_COUNTRY"] = 379] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_COUNTRY";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_STATE"] = 380] = "ENTERPRISE_PAYROLL_QRE_TABLE_DETAIL_DETAILS_FORM_STATE";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_FISCAL_YEAR_END_MONTH"] = 381] = "ONBOARDING_FISCAL_YEAR_END_MONTH";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_COMPANY_INFO"] = 382] = "ENTERPRISE_NAV_COMPANY_INFO";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_CREDIT_CALCULATION"] = 383] = "ENTERPRISE_NAV_CREDIT_CALCULATION";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PRIOR_YEAR_QRES"] = 384] = "ENTERPRISE_PRIOR_YEAR_QRES";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PROJECT_NONE_OF_THE_ABOVE"] = 385] = "ENTERPRISE_PROJECT_NONE_OF_THE_ABOVE";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CREATE_COMPANY_FISCAL_YEAR_END_MONTH"] = 386] = "RTC_CREATE_COMPANY_FISCAL_YEAR_END_MONTH";
		AnalyticIdentifier[AnalyticIdentifier["RTC_INVITE_MEMBER_ROLE_INPUT"] = 387] = "RTC_INVITE_MEMBER_ROLE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_CREATE_PROJECT_NAME"] = 388] = "ENTERPRISE_CREATE_PROJECT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_CREATE_PROJECT_DESCRIPTION"] = 389] = "ENTERPRISE_CREATE_PROJECT_DESCRIPTION";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_ACCOUNTING_QRE"] = 390] = "ENTERPRISE_NAV_ACCOUNTING_QRE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_TAB"] = 391] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_FORM_NAME"] = 392] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_FORM_NAME";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_FORM_RD_CATEGORY"] = 393] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_FORM_RD_CATEGORY";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_TAB"] = 394] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_AMOUNT"] = 395] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_AMOUNT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_COUNTRY"] = 396] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_COUNTRY";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_STATE"] = 397] = "ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_FORM_STATE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_PRIOR_YEAR_REVENUE"] = 398] = "ENTERPRISE_PRIOR_YEAR_REVENUE";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_FILING_METHOD"] = 399] = "ENTERPRISE_FILING_METHOD";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_FIRST_YEAR_QRE_AND_GROSS_RECEIPTS"] = 400] = "ENTERPRISE_FIRST_YEAR_QRE_AND_GROSS_RECEIPTS";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_CREATE_CONTRIBUTOR_NAME"] = 401] = "ENTERPRISE_CREATE_CONTRIBUTOR_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RTC_DELETE_INVITED_MEMBER_EMAIL_INPUT"] = 402] = "RTC_DELETE_INVITED_MEMBER_EMAIL_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_MICROSOFT_OAUTH_BUTTON"] = 403] = "RTC_MICROSOFT_OAUTH_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_UPLOAD_ACCOUNTING_PROJECT_ALLOCATION_REPORT"] = 405] = "ENTERPRISE_UPLOAD_ACCOUNTING_PROJECT_ALLOCATION_REPORT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_DOWNLOAD_ACCOUNTING_PROJECT_ALLOCATION_REPORT"] = 406] = "ENTERPRISE_DOWNLOAD_ACCOUNTING_PROJECT_ALLOCATION_REPORT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_UPLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT"] = 407] = "ENTERPRISE_UPLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_DOWNLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT"] = 408] = "ENTERPRISE_DOWNLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_DOWNLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT_LINK"] = 409] = "ENTERPRISE_DOWNLOAD_PAYROLL_PROJECT_ALLOCATION_REPORT_LINK";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_DOWNLOAD_RD_CREDITS_REPORT_LINK"] = 410] = "ENTERPRISE_DOWNLOAD_RD_CREDITS_REPORT_LINK";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_RD_DATA_SOURCES"] = 411] = "ENTERPRISE_NAV_RD_DATA_SOURCES";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_MEMBER_INFORMATION_TAB"] = 412] = "COMPANY_MEMBER_INFORMATION_TAB";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_MEMBER_SCOPE_TAB"] = 413] = "COMPANY_MEMBER_SCOPE_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_SUPPORTING_DOCUMENT_UPLOAD"] = 414] = "RD_PROJECT_SUPPORTING_DOCUMENT_UPLOAD";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_REMOVE_SUPPORTING_DOCUMENT"] = 415] = "RD_PROJECT_REMOVE_SUPPORTING_DOCUMENT";
		AnalyticIdentifier[AnalyticIdentifier["RAW_TICKETING_PROVIDER_INPUT"] = 416] = "RAW_TICKETING_PROVIDER_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_BULK_TICKETING_DATA_FILE_UPLOAD"] = 417] = "COMPANY_BULK_TICKETING_DATA_FILE_UPLOAD";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CONTINUE_WITH_SSO_LINK"] = 418] = "RTC_CONTINUE_WITH_SSO_LINK";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_PROVIDER_ID_INPUT"] = 419] = "ONBOARDING_PROVIDER_ID_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_SUBMIT_PROVIDER_ID_BUTTON"] = 420] = "ONBOARDING_SUBMIT_PROVIDER_ID_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_BACK_TO_LOGIN_LINK"] = 421] = "RTC_BACK_TO_LOGIN_LINK";
		AnalyticIdentifier[AnalyticIdentifier["ONBOARDING_SSO_PROVIDER_TYPE_INPUT"] = 422] = "ONBOARDING_SSO_PROVIDER_TYPE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["PRIOR_YEAR_TAX_DOCUMENT_UPLOAD"] = 423] = "PRIOR_YEAR_TAX_DOCUMENT_UPLOAD";
		AnalyticIdentifier[AnalyticIdentifier["COMPANY_DASHBOARD_LOGO"] = 424] = "COMPANY_DASHBOARD_LOGO";
		AnalyticIdentifier[AnalyticIdentifier["DELETE_CONNECTED_DATA_SOURCE_CONFIRM_BUTTON"] = 425] = "DELETE_CONNECTED_DATA_SOURCE_CONFIRM_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DELETE_CONNECTED_DATA_SOURCE_CANCEL_BUTTON"] = 426] = "DELETE_CONNECTED_DATA_SOURCE_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ADD_TEAM_MEMBER_BUTTON"] = 427] = "ADD_TEAM_MEMBER_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["TEAM_MEMBER_SEARCH_INPUT"] = 428] = "TEAM_MEMBER_SEARCH_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_PAYROLL_MONTH_EXPENSE_UPLOAD_BUTTON"] = 429] = "DATA_SOURCES_PAYROLL_MONTH_EXPENSE_UPLOAD_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_ASC_WAGES"] = 430] = "ENTERPRISE_NAV_ASC_WAGES";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_PAYROLL_MONTH_EXPENSES"] = 431] = "ENTERPRISE_NAV_PAYROLL_MONTH_EXPENSES";
		AnalyticIdentifier[AnalyticIdentifier["RTC_ASC_MERGE_PROJECTS"] = 432] = "RTC_ASC_MERGE_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_PROJECT_SKIP_AUTO_CONNECT"] = 433] = "RTC_PROJECT_SKIP_AUTO_CONNECT";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CONFIRM_MERGE_ASC_PROJECTS"] = 434] = "RTC_CONFIRM_MERGE_ASC_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CANCEL_MERGE_ASC_PROJECTS"] = 435] = "RTC_CANCEL_MERGE_ASC_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_DOWNLOAD_ASC_WAGES_REPORT_LINK"] = 436] = "ENTERPRISE_DOWNLOAD_ASC_WAGES_REPORT_LINK";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_UPLOAD_ASC_WAGES_REPORT"] = 437] = "ENTERPRISE_UPLOAD_ASC_WAGES_REPORT";
		AnalyticIdentifier[AnalyticIdentifier["PROFILE_PAGE_LOGOUT_BUTTON"] = 438] = "PROFILE_PAGE_LOGOUT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_COMPANY_NAV_PERIOD_PICKER"] = 439] = "RTC_COMPANY_NAV_PERIOD_PICKER";
		AnalyticIdentifier[AnalyticIdentifier["FISCAL_PERIOD_MODAL_CANCEL_BUTTON"] = 440] = "FISCAL_PERIOD_MODAL_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["FISCAL_PERIOD_MODAL_SELECT_BUTTON"] = 441] = "FISCAL_PERIOD_MODAL_SELECT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["PROJECT_DETAIL_CAPITALIZATION_START_DATE_CLEAR_BUTTON"] = 442] = "PROJECT_DETAIL_CAPITALIZATION_START_DATE_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["PROJECT_DETAIL_CAPITALIZATION_END_DATE_CLEAR_BUTTON"] = 443] = "PROJECT_DETAIL_CAPITALIZATION_END_DATE_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_CONNECT_ACCOUNTING_BUTTON"] = 444] = "DATA_SOURCES_CONNECT_ACCOUNTING_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_CONNECT_PAYROLL_BUTTON"] = 445] = "DATA_SOURCES_CONNECT_PAYROLL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_UPLOAD_TICKETING_PROVIDER_BUTTON"] = 446] = "DATA_SOURCES_UPLOAD_TICKETING_PROVIDER_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_UPLOAD_TAX_DOCS_BUTTON"] = 447] = "DATA_SOURCES_UPLOAD_TAX_DOCS_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_UPLOAD_ASC_COST_BUTTON"] = 448] = "DATA_SOURCES_UPLOAD_ASC_COST_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_PAYROLL_MONTH_EXPENSE_CANCEL_BUTTON"] = 449] = "DATA_SOURCES_PAYROLL_MONTH_EXPENSE_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_PAYROLL_MONTH_EXPENSE_UPLOAD_INPUT"] = 450] = "DATA_SOURCES_PAYROLL_MONTH_EXPENSE_UPLOAD_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_UPLOAD_BUTTON"] = 451] = "ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_UPLOAD_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_CANCEL_BUTTON"] = 452] = "ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_UPLOAD_INPUT"] = 453] = "ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_UPLOAD_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["PROJECT_RD_ELIGIBLE_TOGGLE"] = 454] = "PROJECT_RD_ELIGIBLE_TOGGLE";
		AnalyticIdentifier[AnalyticIdentifier["PROJECT_SECTION_174_TOGGLE"] = 455] = "PROJECT_SECTION_174_TOGGLE";
		AnalyticIdentifier[AnalyticIdentifier["HEADER_PROFILE"] = 456] = "HEADER_PROFILE";
		AnalyticIdentifier[AnalyticIdentifier["GAAP_CAP_COMPANY_URL_INPUT"] = 457] = "GAAP_CAP_COMPANY_URL_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_RD_PROJECTS"] = 458] = "ENTERPRISE_NAV_RD_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DRAWER_DETAIL_TAB"] = 459] = "RD_PROJECT_DRAWER_DETAIL_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DRAWER_ELIGIBILITY_TAB"] = 460] = "RD_PROJECT_DRAWER_ELIGIBILITY_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DRAWER_CONTRIBUTOR_TAB"] = 461] = "RD_PROJECT_DRAWER_CONTRIBUTOR_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DRAWER_TICKETS_TAB"] = 462] = "RD_PROJECT_DRAWER_TICKETS_TAB";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DETAIL_NAME"] = 463] = "RD_PROJECT_DETAIL_NAME";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DETAIL_DESCRIPTION"] = 464] = "RD_PROJECT_DETAIL_DESCRIPTION";
		AnalyticIdentifier[AnalyticIdentifier["RTC_RD_MERGE_PROJECTS"] = 465] = "RTC_RD_MERGE_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CONFIRM_MERGE_RD_PROJECTS"] = 466] = "RTC_CONFIRM_MERGE_RD_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_CANCEL_MERGE_RD_PROJECTS"] = 467] = "RTC_CANCEL_MERGE_RD_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["CREATE_PROJECT_BUTTON"] = 468] = "CREATE_PROJECT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["CREATE_ASC_PROJECT_BUTTON"] = 469] = "CREATE_ASC_PROJECT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["CREATE_RD_PROJECT_BUTTON"] = 470] = "CREATE_RD_PROJECT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["PROFILE_MENU"] = 471] = "PROFILE_MENU";
		AnalyticIdentifier[AnalyticIdentifier["COLUMN_VISIBILITY_MENU_BUTTON"] = 472] = "COLUMN_VISIBILITY_MENU_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["COLUMN_VISIBILITY_MENU_SELECT_ALL_CHECKBOX"] = 473] = "COLUMN_VISIBILITY_MENU_SELECT_ALL_CHECKBOX";
		AnalyticIdentifier[AnalyticIdentifier["FISCAL_PERIOD_MODAL_YEAR_SELECT"] = 474] = "FISCAL_PERIOD_MODAL_YEAR_SELECT";
		AnalyticIdentifier[AnalyticIdentifier["FISCAL_PERIOD_MODAL_PERIOD_SELECT"] = 475] = "FISCAL_PERIOD_MODAL_PERIOD_SELECT";
		AnalyticIdentifier[AnalyticIdentifier["ASC_WAGES_LAYOUT_EDIT_IN_BULK_BUTTON"] = 476] = "ASC_WAGES_LAYOUT_EDIT_IN_BULK_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_WAGES_LAYOUT_UPLOAD_BULK_BUTTON"] = 477] = "ASC_WAGES_LAYOUT_UPLOAD_BULK_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_WAGES_LAYOUT_CANCEL_BULK_BUTTON"] = 478] = "ASC_WAGES_LAYOUT_CANCEL_BULK_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_FILTER_MONTH_YEAR_INPUT"] = 479] = "ENTERPRISE_FILTER_MONTH_YEAR_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_FILTER_MONTH_YEAR_CLEAR_BUTTON"] = 480] = "ENTERPRISE_FILTER_MONTH_YEAR_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_PRODUCT"] = 481] = "ASC_PROJECT_DETAIL_PRODUCT";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DETAIL_PRODUCT"] = 482] = "RD_PROJECT_DETAIL_PRODUCT";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_PRODUCT_CLEAR_BUTTON"] = 483] = "ASC_PROJECT_DETAIL_PRODUCT_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DETAIL_PRODUCT_CLEAR_BUTTON"] = 484] = "RD_PROJECT_DETAIL_PRODUCT_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_UPDATE_PRODUCT_NAME"] = 485] = "ENTERPRISE_UPDATE_PRODUCT_NAME";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_SHORT_TAX_YEAR_PERIOD"] = 486] = "ENTERPRISE_SHORT_TAX_YEAR_PERIOD";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_SHORT_TAX_YEAR_PERIOD_START"] = 487] = "ENTERPRISE_SHORT_TAX_YEAR_PERIOD_START";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_SHORT_TAX_YEAR_PERIOD_END"] = 488] = "ENTERPRISE_SHORT_TAX_YEAR_PERIOD_END";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_GENERATE_ASC_REPORT_BUTTON"] = 489] = "ENTERPRISE_GENERATE_ASC_REPORT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_WORKDAY"] = 490] = "RTC_SELECT_LINK_WORKDAY";
		AnalyticIdentifier[AnalyticIdentifier["LINK_WORKDAY"] = 491] = "LINK_WORKDAY";
		AnalyticIdentifier[AnalyticIdentifier["LINK_WORKDAY_CANCEL"] = 492] = "LINK_WORKDAY_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_WORKDAY_TRY_AGAIN"] = 493] = "LINK_WORKDAY_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["CREDIT_CALCULATION_COMPANY_OFFICERS"] = 494] = "CREDIT_CALCULATION_COMPANY_OFFICERS";
		AnalyticIdentifier[AnalyticIdentifier["START_ANALYSIS_MODAL_TICKETING_TOKEN_SELECT"] = 495] = "START_ANALYSIS_MODAL_TICKETING_TOKEN_SELECT";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_CREATE_RD_EXPENSE_NAME"] = 496] = "ENTERPRISE_CREATE_RD_EXPENSE_NAME";
		AnalyticIdentifier[AnalyticIdentifier["FILE_UPLOAD_TICKETING_PROVIDER_INPUT"] = 497] = "FILE_UPLOAD_TICKETING_PROVIDER_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["FILE_UPLOAD_TICKETING_ENTITY_TYPE_INPUT"] = 498] = "FILE_UPLOAD_TICKETING_ENTITY_TYPE_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_CAPITALIZATION_STATUS"] = 499] = "ASC_PROJECT_DETAIL_CAPITALIZATION_STATUS";
		AnalyticIdentifier[AnalyticIdentifier["QRE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN"] = 500] = "QRE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN";
		AnalyticIdentifier[AnalyticIdentifier["QRE_LAYOUT_CONNECT_PROVIDER_BTN"] = 501] = "QRE_LAYOUT_CONNECT_PROVIDER_BTN";
		AnalyticIdentifier[AnalyticIdentifier["QRE_LAYOUT_SET_RD_PERCENTAGE_BTN"] = 502] = "QRE_LAYOUT_SET_RD_PERCENTAGE_BTN";
		AnalyticIdentifier[AnalyticIdentifier["QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_TO_EXPENSES_MODAL_ALLOCATION_SLIDER"] = 503] = "QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_TO_EXPENSES_MODAL_ALLOCATION_SLIDER";
		AnalyticIdentifier[AnalyticIdentifier["QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_TO_EXPENSES_MODAL_CANCEL_BTN"] = 504] = "QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_TO_EXPENSES_MODAL_CANCEL_BTN";
		AnalyticIdentifier[AnalyticIdentifier["QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_TO_EXPENSES_MODAL_SUBMIT_BTN"] = 505] = "QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_TO_EXPENSES_MODAL_SUBMIT_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_UPDATE_PROFILE_FULL_NAME"] = 506] = "ENTERPRISE_UPDATE_PROFILE_FULL_NAME";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_UPLOAD_ONE_SCHEMA_BUTTON"] = 507] = "DATA_SOURCES_UPLOAD_ONE_SCHEMA_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DETAIL_PROJECT_OWNER"] = 508] = "RD_PROJECT_DETAIL_PROJECT_OWNER";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DETAIL_PROJECT_OWNER_CLEAR_BUTTON"] = 509] = "RD_PROJECT_DETAIL_PROJECT_OWNER_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_PROJECT_OWNER"] = 510] = "ASC_PROJECT_DETAIL_PROJECT_OWNER";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_PROJECT_OWNER_CLEAR_BUTTON"] = 511] = "ASC_PROJECT_DETAIL_PROJECT_OWNER_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_LAYOUT_APPLY_WEIGHTED_CAPITALIZED_PERCENTAGE_TO_CONTRIBUTORS_BUTTON"] = 512] = "ASC_LAYOUT_APPLY_WEIGHTED_CAPITALIZED_PERCENTAGE_TO_CONTRIBUTORS_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_LAYOUT_APPLY_WEIGHTED_CAPITALIZED_PERCENTAGE_TO_CONTRIBUTORS_CANCEL_BUTTON"] = 513] = "ASC_LAYOUT_APPLY_WEIGHTED_CAPITALIZED_PERCENTAGE_TO_CONTRIBUTORS_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_COST_UPLOAD_PERIOD_INPUT"] = 514] = "ASC_COST_UPLOAD_PERIOD_INPUT";
		AnalyticIdentifier[AnalyticIdentifier["ASC_COST_UPLOAD_CANCEL_BUTTON"] = 515] = "ASC_COST_UPLOAD_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_COST_UPLOAD_CONTINUE_BUTTON"] = 516] = "ASC_COST_UPLOAD_CONTINUE_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DELETE_BUTTON"] = 517] = "RD_PROJECT_DELETE_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["RD_PROJECT_DELETE_CONFIRMATION_BUTTON"] = 518] = "RD_PROJECT_DELETE_CONFIRMATION_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["NAV_RD_TAX_CREDIT"] = 519] = "NAV_RD_TAX_CREDIT";
		AnalyticIdentifier[AnalyticIdentifier["NAV_ASC_350_40"] = 520] = "NAV_ASC_350_40";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_ASC_DATA_SOURCES"] = 521] = "ENTERPRISE_NAV_ASC_DATA_SOURCES";
		AnalyticIdentifier[AnalyticIdentifier["PRODUCT_SELECTION_MODAL_CANCEL_BUTTON"] = 522] = "PRODUCT_SELECTION_MODAL_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["PRODUCT_SELECTION_MODAL_SELECT_BUTTON"] = 523] = "PRODUCT_SELECTION_MODAL_SELECT_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["PRODUCT_SELECTION_MODAL_PRODUCT_SELECT"] = 524] = "PRODUCT_SELECTION_MODAL_PRODUCT_SELECT";
		AnalyticIdentifier[AnalyticIdentifier["FISCAL_PERIOD_MODAL_BACK_TO_PRODUCT_SELECTION"] = 525] = "FISCAL_PERIOD_MODAL_BACK_TO_PRODUCT_SELECTION";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DRAWER_APPROVAL_TAB"] = 526] = "ASC_PROJECT_DRAWER_APPROVAL_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_PROJECT_OWNER"] = 527] = "ASC_PROJECT_APPROVAL_PROJECT_OWNER";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_PROJECT_OWNER_CLEAR_BUTTON"] = 528] = "ASC_PROJECT_APPROVAL_PROJECT_OWNER_CLEAR_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_COMMENT"] = 529] = "ASC_PROJECT_APPROVAL_COMMENT";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_APPROVE_BUTTON"] = 530] = "ASC_PROJECT_APPROVAL_APPROVE_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_RESET_BUTTON"] = 531] = "ASC_PROJECT_APPROVAL_RESET_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_RESET_CONFIRM_BUTTON"] = 532] = "ASC_PROJECT_APPROVAL_RESET_CONFIRM_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_APPROVAL_RESET_CANCEL_BUTTON"] = 533] = "ASC_PROJECT_APPROVAL_RESET_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_SRED_PROJECTS"] = 534] = "ENTERPRISE_NAV_SRED_PROJECTS";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_CERIDIAN_DAYFORCE"] = 535] = "RTC_SELECT_LINK_CERIDIAN_DAYFORCE";
		AnalyticIdentifier[AnalyticIdentifier["LINK_CERIDIAN_DAYFORCE"] = 536] = "LINK_CERIDIAN_DAYFORCE";
		AnalyticIdentifier[AnalyticIdentifier["LINK_CERIDIAN_DAYFORCE_CANCEL"] = 537] = "LINK_CERIDIAN_DAYFORCE_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["LINK_CERIDIAN_DAYFORCE_TRY_AGAIN"] = 538] = "LINK_CERIDIAN_DAYFORCE_TRY_AGAIN";
		AnalyticIdentifier[AnalyticIdentifier["RTC_SELECT_LINK_JIRA_DATA_CENTER"] = 539] = "RTC_SELECT_LINK_JIRA_DATA_CENTER";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_NAV_SRED_PAYROLL_EXPENSES"] = 540] = "ENTERPRISE_NAV_SRED_PAYROLL_EXPENSES";
		AnalyticIdentifier[AnalyticIdentifier["SRED_PAYROLL_EXPENSE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN"] = 541] = "SRED_PAYROLL_EXPENSE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN";
		AnalyticIdentifier[AnalyticIdentifier["SRED_PAYROLL_EXPENSE_LAYOUT_CONNECT_PROVIDER_BTN"] = 542] = "SRED_PAYROLL_EXPENSE_LAYOUT_CONNECT_PROVIDER_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ACCOUNTING_QRE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN"] = 543] = "ACCOUNTING_QRE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ACCOUNTING_QRE_LAYOUT_CONNECT_PROVIDER_BTN"] = 544] = "ACCOUNTING_QRE_LAYOUT_CONNECT_PROVIDER_BTN";
		AnalyticIdentifier[AnalyticIdentifier["SUPERVISOR_RD_PERCENTAGE_MODAL_GENERATE_PREVIEW_BTN"] = 545] = "SUPERVISOR_RD_PERCENTAGE_MODAL_GENERATE_PREVIEW_BTN";
		AnalyticIdentifier[AnalyticIdentifier["SUPERVISOR_RD_PERCENTAGE_MODAL_DOWNLOAD_PREVIEW_BTN"] = 546] = "SUPERVISOR_RD_PERCENTAGE_MODAL_DOWNLOAD_PREVIEW_BTN";
		AnalyticIdentifier[AnalyticIdentifier["SUPERVISOR_RD_PERCENTAGE_MODAL_CANCEL_BTN"] = 547] = "SUPERVISOR_RD_PERCENTAGE_MODAL_CANCEL_BTN";
		AnalyticIdentifier[AnalyticIdentifier["SUPERVISOR_RD_PERCENTAGE_MODAL_APPLY_BTN"] = 548] = "SUPERVISOR_RD_PERCENTAGE_MODAL_APPLY_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ENTERPRISE_REDUCED_CREDIT"] = 549] = "ENTERPRISE_REDUCED_CREDIT";
		AnalyticIdentifier[AnalyticIdentifier["ACCOUNTING_QRE_LAYOUT_SET_RD_PERCENTAGE_BTN"] = 550] = "ACCOUNTING_QRE_LAYOUT_SET_RD_PERCENTAGE_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ACCOUNTING_QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_CANCEL_BTN"] = 551] = "ACCOUNTING_QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_CANCEL_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ACCOUNTING_QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_SUBMIT_BTN"] = 552] = "ACCOUNTING_QRE_LAYOUT_BULK_APPLY_RD_PERCENTAGE_SUBMIT_BTN";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DETAIL_CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE"] = 553] = "ASC_PROJECT_DETAIL_CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_BULK_UPLOAD_INSTRUCTION_UPLOAD_BUTTON"] = 554] = "ASC_PROJECT_BULK_UPLOAD_INSTRUCTION_UPLOAD_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_BULK_UPLOAD_INSTRUCTION_CANCEL_BUTTON"] = 555] = "ASC_PROJECT_BULK_UPLOAD_INSTRUCTION_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_DRAWER_MATCHING_TAB"] = 556] = "ASC_PROJECT_DRAWER_MATCHING_TAB";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_MATCHING_TEAMS"] = 557] = "ASC_PROJECT_MATCHING_TEAMS";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PROJECT_MATCHING_LAUNCH_DATE"] = 558] = "ASC_PROJECT_MATCHING_LAUNCH_DATE";
		AnalyticIdentifier[AnalyticIdentifier["ASC_PERIOD_LOCK_TOGGLE"] = 559] = "ASC_PERIOD_LOCK_TOGGLE";
		AnalyticIdentifier[AnalyticIdentifier["LINK_GITHUB_METHOD_CONTINUE"] = 560] = "LINK_GITHUB_METHOD_CONTINUE";
		AnalyticIdentifier[AnalyticIdentifier["LINK_GITHUB_METHOD_CANCEL"] = 561] = "LINK_GITHUB_METHOD_CANCEL";
		AnalyticIdentifier[AnalyticIdentifier["ADD_TICKETING_CONNECTION"] = 562] = "ADD_TICKETING_CONNECTION";
		AnalyticIdentifier[AnalyticIdentifier["DISCONNECT_TICKETING_CONNECTION_CONFIRM_BUTTON"] = 563] = "DISCONNECT_TICKETING_CONNECTION_CONFIRM_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["DISCONNECT_TICKETING_CONNECTION_CANCEL_BUTTON"] = 564] = "DISCONNECT_TICKETING_CONNECTION_CANCEL_BUTTON";
		AnalyticIdentifier[AnalyticIdentifier["CHECK_GITHUB_APP_CONNECTION"] = 565] = "CHECK_GITHUB_APP_CONNECTION";
		AnalyticIdentifier[AnalyticIdentifier["DATA_SOURCES_UPLOAD_BUSINESS_COMPONENTS_BUTTON"] = 566] = "DATA_SOURCES_UPLOAD_BUSINESS_COMPONENTS_BUTTON";
	})(AnalyticIdentifier || (exports.AnalyticIdentifier = AnalyticIdentifier = {}));
}));
//#endregion
//#region ../common/lib/enums/expense-category.enums.js
var require_expense_category_enums = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ExpenseCategory = void 0;
	/**
	* Should only be used in the back-end
	*/
	var ExpenseCategory;
	(function(ExpenseCategory) {
		ExpenseCategory[ExpenseCategory["EMPLOYEE"] = 0] = "EMPLOYEE";
		ExpenseCategory[ExpenseCategory["CONTRACTORS"] = 1] = "CONTRACTORS";
		ExpenseCategory[ExpenseCategory["CLOUD"] = 2] = "CLOUD";
		ExpenseCategory[ExpenseCategory["LEGAL"] = 3] = "LEGAL";
		ExpenseCategory[ExpenseCategory["SUPPLIES"] = 4] = "SUPPLIES";
	})(ExpenseCategory || (exports.ExpenseCategory = ExpenseCategory = {}));
}));
//#endregion
//#region ../common/lib/enums/enums.utils.js
var require_enums_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.convertExpenseCategoryToNum = void 0;
	var expense_category_enums_1 = require_expense_category_enums();
	/**
	* Use this function to convert between back-end ExpenseCategory values and string
	* generated through graphql layer
	* @returns -1 if undefined, otherwise the number value of the enum
	*/
	var convertExpenseCategoryToNum = (expenseCategory) => {
		if (!expenseCategory) return -1;
		return expense_category_enums_1.ExpenseCategory[expenseCategory];
	};
	exports.convertExpenseCategoryToNum = convertExpenseCategoryToNum;
}));
//#endregion
//#region ../common/lib/enums/quickbooks/quickbooks-month.enum.js
var require_quickbooks_month_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuickbooksMonth = void 0;
	var QuickbooksMonth;
	(function(QuickbooksMonth) {
		QuickbooksMonth["Jan"] = "Jan";
		QuickbooksMonth["Feb"] = "Feb";
		QuickbooksMonth["Mar"] = "Mar";
		QuickbooksMonth["Apr"] = "Apr";
		QuickbooksMonth["May"] = "May";
		QuickbooksMonth["Jun"] = "Jun";
		QuickbooksMonth["Jul"] = "Jul";
		QuickbooksMonth["Aug"] = "Aug";
		QuickbooksMonth["Sep"] = "Sep";
		QuickbooksMonth["Oct"] = "Oct";
		QuickbooksMonth["Nov"] = "Nov";
		QuickbooksMonth["Dec"] = "Dec";
	})(QuickbooksMonth || (exports.QuickbooksMonth = QuickbooksMonth = {}));
}));
//#endregion
//#region ../common/lib/enums/quickbooks/quickbooks-query-field.enum.js
var require_quickbooks_query_field_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuickbooksQueryField = void 0;
	var QuickbooksQueryField;
	(function(QuickbooksQueryField) {
		QuickbooksQueryField["CONNECTED_STATUS"] = "connected_accounting";
	})(QuickbooksQueryField || (exports.QuickbooksQueryField = QuickbooksQueryField = {}));
}));
//#endregion
//#region ../common/lib/enums/quickbooks/quickbooks-connection-status.enum.js
var require_quickbooks_connection_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuickbooksConnectionStatus = void 0;
	var QuickbooksConnectionStatus;
	(function(QuickbooksConnectionStatus) {
		QuickbooksConnectionStatus["SUCCESS"] = "successful";
		QuickbooksConnectionStatus["FAILED"] = "failed";
	})(QuickbooksConnectionStatus || (exports.QuickbooksConnectionStatus = QuickbooksConnectionStatus = {}));
}));
//#endregion
//#region ../common/lib/enums/quickbooks/index.js
var require_quickbooks = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuickbooksConnectionStatus = exports.QuickbooksQueryField = exports.QuickbooksMonth = void 0;
	var quickbooks_month_enum_1 = require_quickbooks_month_enum();
	Object.defineProperty(exports, "QuickbooksMonth", {
		enumerable: true,
		get: function() {
			return quickbooks_month_enum_1.QuickbooksMonth;
		}
	});
	var quickbooks_query_field_enum_1 = require_quickbooks_query_field_enum();
	Object.defineProperty(exports, "QuickbooksQueryField", {
		enumerable: true,
		get: function() {
			return quickbooks_query_field_enum_1.QuickbooksQueryField;
		}
	});
	var quickbooks_connection_status_enum_1 = require_quickbooks_connection_status_enum();
	Object.defineProperty(exports, "QuickbooksConnectionStatus", {
		enumerable: true,
		get: function() {
			return quickbooks_connection_status_enum_1.QuickbooksConnectionStatus;
		}
	});
}));
//#endregion
//#region ../common/lib/enums/github-app/github-app-install-query-field.enum.js
var require_github_app_install_query_field_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GitHubAppInstallQueryField = void 0;
	var GitHubAppInstallQueryField;
	(function(GitHubAppInstallQueryField) {
		GitHubAppInstallQueryField["CONNECTED_STATUS"] = "connected_github_app";
	})(GitHubAppInstallQueryField || (exports.GitHubAppInstallQueryField = GitHubAppInstallQueryField = {}));
}));
//#endregion
//#region ../common/lib/enums/github-app/github-app-install-status.enum.js
var require_github_app_install_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GitHubAppInstallStatus = void 0;
	var GitHubAppInstallStatus;
	(function(GitHubAppInstallStatus) {
		GitHubAppInstallStatus["PENDING"] = "pending";
		GitHubAppInstallStatus["AWAITING_APPROVAL"] = "awaiting_approval";
		GitHubAppInstallStatus["FAILED"] = "failed";
	})(GitHubAppInstallStatus || (exports.GitHubAppInstallStatus = GitHubAppInstallStatus = {}));
}));
//#endregion
//#region ../common/lib/enums/github-app/index.js
var require_github_app = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GitHubAppInstallStatus = exports.GitHubAppInstallQueryField = void 0;
	var github_app_install_query_field_enum_1 = require_github_app_install_query_field_enum();
	Object.defineProperty(exports, "GitHubAppInstallQueryField", {
		enumerable: true,
		get: function() {
			return github_app_install_query_field_enum_1.GitHubAppInstallQueryField;
		}
	});
	var github_app_install_status_enum_1 = require_github_app_install_status_enum();
	Object.defineProperty(exports, "GitHubAppInstallStatus", {
		enumerable: true,
		get: function() {
			return github_app_install_status_enum_1.GitHubAppInstallStatus;
		}
	});
}));
//#endregion
//#region ../common/lib/enums/sso/sso-query-field.enum.js
var require_sso_query_field_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SsoQueryField = void 0;
	var SsoQueryField;
	(function(SsoQueryField) {
		SsoQueryField["ERROR"] = "sso_error";
		SsoQueryField["TOKEN"] = "firebase_custom_token";
		SsoQueryField["SSO_PROVIDER"] = "sso_provider";
	})(SsoQueryField || (exports.SsoQueryField = SsoQueryField = {}));
}));
//#endregion
//#region ../common/lib/enums/sso/sso-error.enum.js
var require_sso_error_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SsoError = void 0;
	/**
	* These are the expected SSO errors and not a complete list.
	*/
	var SsoError;
	(function(SsoError) {
		SsoError["NEEDS_EMAIL_VERIFICATION"] = "needs_email_verification";
		SsoError["QUICKBOOKS_FAILED"] = "quickbooks_failed";
		SsoError["UNKNOWN_ERROR"] = "unknown_error";
	})(SsoError || (exports.SsoError = SsoError = {}));
}));
//#endregion
//#region ../common/lib/enums/sso/index.js
var require_sso = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SsoError = exports.SsoQueryField = void 0;
	var sso_query_field_enum_1 = require_sso_query_field_enum();
	Object.defineProperty(exports, "SsoQueryField", {
		enumerable: true,
		get: function() {
			return sso_query_field_enum_1.SsoQueryField;
		}
	});
	var sso_error_enum_1 = require_sso_error_enum();
	Object.defineProperty(exports, "SsoError", {
		enumerable: true,
		get: function() {
			return sso_error_enum_1.SsoError;
		}
	});
}));
//#endregion
//#region ../common/lib/enums/neo-tax-environment.enum.js
var require_neo_tax_environment_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NeoTaxEnvironment = void 0;
	var NeoTaxEnvironment;
	(function(NeoTaxEnvironment) {
		NeoTaxEnvironment["TEST"] = "test";
		NeoTaxEnvironment["LOCAL"] = "local";
		NeoTaxEnvironment["DEPLOY_PREVIEW"] = "deploy-preview";
		NeoTaxEnvironment["PRODUCTION_PREVIEW"] = "production-preview";
		NeoTaxEnvironment["DEVELOPMENT"] = "development";
		NeoTaxEnvironment["STAGING"] = "staging";
		NeoTaxEnvironment["PRODUCTION"] = "production";
		NeoTaxEnvironment["TERRAFORM_LOCAL"] = "terraform-local";
		NeoTaxEnvironment["THOMSON_REUTERS"] = "thomson-reuters";
		NeoTaxEnvironment["NARVAR"] = "narvar";
		NeoTaxEnvironment["ZELIS"] = "zelis";
		NeoTaxEnvironment["NBH"] = "nbh";
		NeoTaxEnvironment["ADOBE"] = "adobe";
		NeoTaxEnvironment["LENDINGCLUB"] = "lendingclub";
		NeoTaxEnvironment["SANDBOX"] = "sandbox";
		NeoTaxEnvironment["CAPITALONE"] = "capitalone";
		NeoTaxEnvironment["BULLHORN"] = "bullhorn";
		NeoTaxEnvironment["DEMO"] = "demo";
		NeoTaxEnvironment["QUALCOMM"] = "qualcomm";
		NeoTaxEnvironment["EXPEDIA"] = "expedia";
		NeoTaxEnvironment["SHELL"] = "shell";
	})(NeoTaxEnvironment || (exports.NeoTaxEnvironment = NeoTaxEnvironment = {}));
}));
//#endregion
//#region ../common/lib/enums/service-scope.enum.js
var require_service_scope_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ServiceScope = void 0;
	var ServiceScope;
	(function(ServiceScope) {
		ServiceScope["API_GATEWAY"] = "API_GATEWAY";
		ServiceScope["PROVIDER_ADAPTER"] = "PROVIDER_ADAPTER";
		ServiceScope["PREDICTION_SERVICE"] = "PREDICTION_SERVICE";
	})(ServiceScope || (exports.ServiceScope = ServiceScope = {}));
}));
//#endregion
//#region ../common/lib/enums/account-classification.enum.js
var require_account_classification_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AccountClassification = void 0;
	var AccountClassification;
	(function(AccountClassification) {
		AccountClassification["ASSET"] = "Asset";
		AccountClassification["EQUITY"] = "Equity";
		AccountClassification["EXPENSE"] = "Expense";
		AccountClassification["LIABILITY"] = "Liability";
		AccountClassification["REVENUE"] = "Revenue";
	})(AccountClassification || (exports.AccountClassification = AccountClassification = {}));
}));
//#endregion
//#region ../common/lib/enums/account-type.enum.js
var require_account_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AccountType = void 0;
	var AccountType;
	(function(AccountType) {
		AccountType["ACCOUNTS_PAYABLE"] = "Accounts Payable";
		AccountType["ACCOUNTS_RECEIVABLE"] = "Accounts Receivable";
		AccountType["BANK"] = "Bank";
		AccountType["COST_OF_GOODS_SOLD"] = "Cost of Goods Sold";
		AccountType["CREDIT_CARD"] = "Credit Card";
		AccountType["EQUITY"] = "Equity";
		AccountType["EXPENSE"] = "Expense";
		AccountType["FIXED_ASSET"] = "Fixed Asset";
		AccountType["INCOME"] = "Income";
		AccountType["LONG_TERM_LIABILITY"] = "Long Term Liability";
		AccountType["OTHER_ASSET"] = "Other Asset";
		AccountType["OTHER_CURRENT_ASSET"] = "Other Current Asset";
		AccountType["OTHER_CURRENT_LIABILITY"] = "Other Current Liability";
		AccountType["OTHER_EXPENSE"] = "Other Expense";
		AccountType["OTHER_INCOME"] = "Other Income";
		AccountType["DEFERRED_REVENUE"] = "Deferred Revenue";
		AccountType["DEFERRED_EXPENSE"] = "Deferred Expense";
		AccountType["UNBILLED_RECEIVABLE"] = "Unbilled Receivable";
		AccountType["NON_POSTING"] = "Non Posting";
	})(AccountType || (exports.AccountType = AccountType = {}));
}));
//#endregion
//#region ../common/lib/enums/rounding-method.enum.js
var require_rounding_method_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RoundingMethod = void 0;
	var RoundingMethod;
	(function(RoundingMethod) {
		RoundingMethod["ROUND"] = "ROUND";
		RoundingMethod["FLOOR"] = "FLOOR";
	})(RoundingMethod || (exports.RoundingMethod = RoundingMethod = {}));
}));
//#endregion
//#region ../common/lib/enums/hard-sciences.enum.js
var require_hard_sciences_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HardSciences = void 0;
	var HardSciences;
	(function(HardSciences) {
		HardSciences["ENGINEERING"] = "ENGINEERING";
		HardSciences["PHYSICS"] = "PHYSICS";
		HardSciences["CHEMISTRY"] = "CHEMISTRY";
		HardSciences["BIOLOGY"] = "BIOLOGY";
		HardSciences["COMPUTER_SCIENCE"] = "COMPUTER_SCIENCE";
		HardSciences["NOT_TECHNICAL"] = "NOT_TECHNICAL";
	})(HardSciences || (exports.HardSciences = HardSciences = {}));
}));
//#endregion
//#region ../common/lib/enums/revenue-source.enum.js
var require_revenue_source_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getRevenueSourceRank = exports.RevenueSource = void 0;
	var RevenueSource;
	(function(RevenueSource) {
		RevenueSource["QUICKBOOKS_OR_XERO"] = "QUICKBOOKS/XERO";
		RevenueSource["SELF_REPORTED"] = "SELF_REPORTED";
		RevenueSource["RETOOL"] = "RETOOL";
	})(RevenueSource || (exports.RevenueSource = RevenueSource = {}));
	/**
	*
	* When a company has duplicate prior-year-revenue entries for the same tax year
	* (e.g. one from QuickBooks and one self-reported), we deduplicate to one per year.
	* If createdAt timestamps are identical (common in copyCompany), this priority
	* determines the winner: user-provided data beats automated imports.
	* Lower index = higher priority. Update when adding new RevenueSource values.
	*/
	var REVENUE_SOURCE_PRIORITY = [
		RevenueSource.SELF_REPORTED,
		RevenueSource.QUICKBOOKS_OR_XERO,
		RevenueSource.RETOOL
	];
	var getRevenueSourceRank = (source) => {
		const index = REVENUE_SOURCE_PRIORITY.indexOf(source);
		return index === -1 ? Infinity : index;
	};
	exports.getRevenueSourceRank = getRevenueSourceRank;
}));
//#endregion
//#region ../common/lib/enums/sales-channel.enum.js
var require_sales_channel_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SalesChannel = void 0;
	var SalesChannel;
	(function(SalesChannel) {
		SalesChannel["ACCOUNTANT"] = "accountant";
		SalesChannel["DIRECT"] = "direct";
		SalesChannel["PARTNER"] = "partner";
	})(SalesChannel || (exports.SalesChannel = SalesChannel = {}));
}));
//#endregion
//#region ../common/lib/enums/entity-type.enum.js
var require_entity_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EntityType = void 0;
	var EntityType;
	(function(EntityType) {
		EntityType["VENDOR"] = "Vendor";
		EntityType["CONTACT"] = "Contact";
		EntityType["EMPLOYEE"] = "Employee";
		EntityType["CUSTOM_JOB"] = "CustJob";
		EntityType["UNKNOWN"] = "Unknown";
	})(EntityType || (exports.EntityType = EntityType = {}));
}));
//#endregion
//#region ../common/lib/enums/accounting-acquisition-method.enum.js
var require_accounting_acquisition_method_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AccountingAcquisitionMethod = void 0;
	var AccountingAcquisitionMethod;
	(function(AccountingAcquisitionMethod) {
		AccountingAcquisitionMethod["INTUIT"] = "INTUIT";
		AccountingAcquisitionMethod["MERGE_DEV"] = "MERGE_DEV";
		AccountingAcquisitionMethod["FILE"] = "FILE";
		AccountingAcquisitionMethod["MANUAL"] = "MANUAL";
	})(AccountingAcquisitionMethod || (exports.AccountingAcquisitionMethod = AccountingAcquisitionMethod = {}));
}));
//#endregion
//#region ../common/lib/enums/date-month.enum.js
var require_date_month_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DateMonth = void 0;
	var DateMonth;
	(function(DateMonth) {
		DateMonth[DateMonth["January"] = 0] = "January";
		DateMonth[DateMonth["February"] = 1] = "February";
		DateMonth[DateMonth["March"] = 2] = "March";
		DateMonth[DateMonth["April"] = 3] = "April";
		DateMonth[DateMonth["May"] = 4] = "May";
		DateMonth[DateMonth["June"] = 5] = "June";
		DateMonth[DateMonth["July"] = 6] = "July";
		DateMonth[DateMonth["August"] = 7] = "August";
		DateMonth[DateMonth["September"] = 8] = "September";
		DateMonth[DateMonth["October"] = 9] = "October";
		DateMonth[DateMonth["November"] = 10] = "November";
		DateMonth[DateMonth["December"] = 11] = "December";
	})(DateMonth || (exports.DateMonth = DateMonth = {}));
}));
//#endregion
//#region ../common/lib/enums/payroll-acquisition-method.enum.js
var require_payroll_acquisition_method_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PayrollAcquisitionMethod = void 0;
	var PayrollAcquisitionMethod;
	(function(PayrollAcquisitionMethod) {
		PayrollAcquisitionMethod["GUSTO"] = "GUSTO";
		PayrollAcquisitionMethod["FINCH"] = "FINCH";
		PayrollAcquisitionMethod["FILE"] = "FILE";
		PayrollAcquisitionMethod["MANUAL"] = "MANUAL";
	})(PayrollAcquisitionMethod || (exports.PayrollAcquisitionMethod = PayrollAcquisitionMethod = {}));
}));
//#endregion
//#region ../common/lib/enums/accounting-provider.enum.js
var require_accounting_provider_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AccountingProvider = void 0;
	var AccountingProvider;
	(function(AccountingProvider) {
		AccountingProvider["NETSUITE"] = "NETSUITE";
		AccountingProvider["QUICKBOOKS"] = "QUICKBOOKS";
		AccountingProvider["SELF_REPORTED"] = "SELF_REPORTED";
	})(AccountingProvider || (exports.AccountingProvider = AccountingProvider = {}));
}));
//#endregion
//#region ../common/lib/enums/payroll-provider.enum.js
var require_payroll_provider_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PayrollProvider = void 0;
	var PayrollProvider;
	(function(PayrollProvider) {
		PayrollProvider["ADP_RUN"] = "ADP_RUN";
		PayrollProvider["ADP_WORKFORCE_NOW"] = "ADP_WORKFORCE_NOW";
		PayrollProvider["CERIDIAN_DAYFORCE"] = "CERIDIAN_DAYFORCE";
		PayrollProvider["GUSTO"] = "GUSTO";
		PayrollProvider["JUSTWORKS"] = "JUSTWORKS";
		PayrollProvider["PAYCHEX_FLEX"] = "PAYCHEX_FLEX";
		PayrollProvider["PAYLOCITY"] = "PAYLOCITY";
		PayrollProvider["QUICKBOOKS"] = "QUICKBOOKS";
		PayrollProvider["RIPPLING"] = "RIPPLING";
		PayrollProvider["TRINET"] = "TRINET";
		PayrollProvider["WORKDAY"] = "WORKDAY";
		PayrollProvider["ZENEFITS"] = "ZENEFITS";
		PayrollProvider["SELF_REPORTED"] = "SELF_REPORTED";
	})(PayrollProvider || (exports.PayrollProvider = PayrollProvider = {}));
}));
//#endregion
//#region ../common/lib/enums/wage-type.enum.js
var require_wage_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.WageType = void 0;
	var WageType;
	(function(WageType) {
		WageType["W2"] = "W2";
		WageType["CONTRACTOR"] = "CONTRACTOR";
	})(WageType || (exports.WageType = WageType = {}));
}));
//#endregion
//#region ../common/lib/enums/service-operational-status.enum.js
var require_service_operational_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ServiceOperationalStatus = void 0;
	var ServiceOperationalStatus;
	(function(ServiceOperationalStatus) {
		ServiceOperationalStatus["OPERATIONAL"] = "operational";
		ServiceOperationalStatus["DEGRADED"] = "degraded";
		ServiceOperationalStatus["OUTAGE"] = "outage";
	})(ServiceOperationalStatus || (exports.ServiceOperationalStatus = ServiceOperationalStatus = {}));
}));
//#endregion
//#region ../common/lib/enums/corporation-type.enum.js
var require_corporation_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CorporationType = void 0;
	var CorporationType;
	(function(CorporationType) {
		CorporationType["llc"] = "llc";
		CorporationType["sole_proprietor"] = "sole_proprietor";
		CorporationType["non_profit"] = "non_profit";
		CorporationType["partnership"] = "partnership";
		CorporationType["cooperative"] = "cooperative";
		CorporationType["s_corporation"] = "s_corporation";
		CorporationType["c_corporation"] = "c_corporation";
		CorporationType["b_corporation"] = "b_corporation";
	})(CorporationType || (exports.CorporationType = CorporationType = {}));
}));
//#endregion
//#region ../common/lib/enums/eligibility-status.enum.js
var require_eligibility_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EligibilityStatus = void 0;
	var EligibilityStatus;
	(function(EligibilityStatus) {
		EligibilityStatus["ELIGIBILITY_PENDING"] = "Decision Pending";
		EligibilityStatus["ELIGIBLE"] = "Qualified";
		EligibilityStatus["PROBABLY_ELIGIBLE"] = "Probably Qualified";
		EligibilityStatus["NOT_ELIGIBLE"] = "Not Qualified";
	})(EligibilityStatus || (exports.EligibilityStatus = EligibilityStatus = {}));
}));
//#endregion
//#region ../common/lib/enums/company-entity-type.enum.js
var require_company_entity_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CompanyEntityType = void 0;
	var CompanyEntityType;
	(function(CompanyEntityType) {
		CompanyEntityType["C_CORPORATION"] = "C-Corp (Form 1120)";
		CompanyEntityType["B_CORPORATION"] = "B-Corp (Form 1120)";
		CompanyEntityType["S_CORPORATION"] = "S-Corp (Form 1120-S)";
		CompanyEntityType["PARTNERSHIP"] = "Partnership (Form 1065)";
		CompanyEntityType["LLC_AS_C_CORPORATION"] = "LLC taxed as C-Corp (Form 1120)";
		CompanyEntityType["LLC_AS_S_CORPORATION"] = "LLC taxed as S-Corp (Form 1120-S)";
		CompanyEntityType["LLC_AS_PARTNERSHIP"] = "LLC taxed as Partnership (Form 1065)";
		CompanyEntityType["LLC_AS_SOLE_PROPRIETORSHIP"] = "LLC taxed as Sole Proprietorship";
	})(CompanyEntityType || (exports.CompanyEntityType = CompanyEntityType = {}));
}));
//#endregion
//#region ../common/lib/enums/value-type.enum.js
var require_value_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ValueType = void 0;
	var ValueType;
	(function(ValueType) {
		ValueType["PERCENT"] = "PERCENT";
		ValueType["FRACTION"] = "FRACTION";
		ValueType["DOLLAR"] = "DOLLAR";
		ValueType["CENTS"] = "CENTS";
		ValueType["TEXT"] = "TEXT";
	})(ValueType || (exports.ValueType = ValueType = {}));
}));
//#endregion
//#region ../common/lib/enums/error-status-code.js
var require_error_status_code = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ErrorStatusCode = void 0;
	/** Should be used for HTTP REST requests, not GraphQL. */
	var ErrorStatusCode;
	(function(ErrorStatusCode) {
		ErrorStatusCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
		ErrorStatusCode["OUTDATED_VERSION"] = "OUTDATED_VERSION";
		ErrorStatusCode["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
		ErrorStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
		ErrorStatusCode["UNAUTHORIZED"] = "UNAUTHORIZED";
	})(ErrorStatusCode || (exports.ErrorStatusCode = ErrorStatusCode = {}));
}));
//#endregion
//#region ../common/lib/enums/day-of-week.enum.js
var require_day_of_week_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DayOfWeek = void 0;
	var DayOfWeek;
	(function(DayOfWeek) {
		DayOfWeek[DayOfWeek["SUNDAY"] = 0] = "SUNDAY";
		DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
		DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
		DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
		DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
		DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
		DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
	})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
}));
//#endregion
//#region ../common/lib/enums/payroll-month-expense-provider.enum.js
var require_payroll_month_expense_provider_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PayrollMonthExpenseProvider = void 0;
	var PayrollMonthExpenseProvider;
	(function(PayrollMonthExpenseProvider) {
		PayrollMonthExpenseProvider["SELF_REPORTED"] = "SELF_REPORTED";
	})(PayrollMonthExpenseProvider || (exports.PayrollMonthExpenseProvider = PayrollMonthExpenseProvider = {}));
}));
//#endregion
//#region ../../node_modules/zod/v4/core/core.cjs
var require_core$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.globalConfig = exports.$ZodEncodeError = exports.$ZodAsyncError = exports.$brand = exports.NEVER = void 0;
	exports.$constructor = $constructor;
	exports.config = config;
	/** A special constant with type `never` */
	exports.NEVER = Object.freeze({ status: "aborted" });
	function $constructor(name, initializer, params) {
		function init(inst, def) {
			var _a;
			Object.defineProperty(inst, "_zod", {
				value: inst._zod ?? {},
				enumerable: false
			});
			(_a = inst._zod).traits ?? (_a.traits = /* @__PURE__ */ new Set());
			inst._zod.traits.add(name);
			initializer(inst, def);
			for (const k in _.prototype) if (!(k in inst)) Object.defineProperty(inst, k, { value: _.prototype[k].bind(inst) });
			inst._zod.constr = _;
			inst._zod.def = def;
		}
		const Parent = params?.Parent ?? Object;
		class Definition extends Parent {}
		Object.defineProperty(Definition, "name", { value: name });
		function _(def) {
			var _a;
			const inst = params?.Parent ? new Definition() : this;
			init(inst, def);
			(_a = inst._zod).deferred ?? (_a.deferred = []);
			for (const fn of inst._zod.deferred) fn();
			return inst;
		}
		Object.defineProperty(_, "init", { value: init });
		Object.defineProperty(_, Symbol.hasInstance, { value: (inst) => {
			if (params?.Parent && inst instanceof params.Parent) return true;
			return inst?._zod?.traits?.has(name);
		} });
		Object.defineProperty(_, "name", { value: name });
		return _;
	}
	exports.$brand = Symbol("zod_brand");
	var $ZodAsyncError = class extends Error {
		constructor() {
			super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
		}
	};
	exports.$ZodAsyncError = $ZodAsyncError;
	var $ZodEncodeError = class extends Error {
		constructor(name) {
			super(`Encountered unidirectional transform during encode: ${name}`);
			this.name = "ZodEncodeError";
		}
	};
	exports.$ZodEncodeError = $ZodEncodeError;
	exports.globalConfig = {};
	function config(newConfig) {
		if (newConfig) Object.assign(exports.globalConfig, newConfig);
		return exports.globalConfig;
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/core/util.cjs
var require_util = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Class = exports.BIGINT_FORMAT_RANGES = exports.NUMBER_FORMAT_RANGES = exports.primitiveTypes = exports.propertyKeyTypes = exports.getParsedType = exports.allowsEval = exports.captureStackTrace = void 0;
	exports.assertEqual = assertEqual;
	exports.assertNotEqual = assertNotEqual;
	exports.assertIs = assertIs;
	exports.assertNever = assertNever;
	exports.assert = assert;
	exports.getEnumValues = getEnumValues;
	exports.joinValues = joinValues;
	exports.jsonStringifyReplacer = jsonStringifyReplacer;
	exports.cached = cached;
	exports.nullish = nullish;
	exports.cleanRegex = cleanRegex;
	exports.floatSafeRemainder = floatSafeRemainder;
	exports.defineLazy = defineLazy;
	exports.objectClone = objectClone;
	exports.assignProp = assignProp;
	exports.mergeDefs = mergeDefs;
	exports.cloneDef = cloneDef;
	exports.getElementAtPath = getElementAtPath;
	exports.promiseAllObject = promiseAllObject;
	exports.randomString = randomString;
	exports.esc = esc;
	exports.isObject = isObject;
	exports.isPlainObject = isPlainObject;
	exports.shallowClone = shallowClone;
	exports.numKeys = numKeys;
	exports.escapeRegex = escapeRegex;
	exports.clone = clone;
	exports.normalizeParams = normalizeParams;
	exports.createTransparentProxy = createTransparentProxy;
	exports.stringifyPrimitive = stringifyPrimitive;
	exports.optionalKeys = optionalKeys;
	exports.pick = pick;
	exports.omit = omit;
	exports.extend = extend;
	exports.safeExtend = safeExtend;
	exports.merge = merge;
	exports.partial = partial;
	exports.required = required;
	exports.aborted = aborted;
	exports.prefixIssues = prefixIssues;
	exports.unwrapMessage = unwrapMessage;
	exports.finalizeIssue = finalizeIssue;
	exports.getSizableOrigin = getSizableOrigin;
	exports.getLengthableOrigin = getLengthableOrigin;
	exports.issue = issue;
	exports.cleanEnum = cleanEnum;
	exports.base64ToUint8Array = base64ToUint8Array;
	exports.uint8ArrayToBase64 = uint8ArrayToBase64;
	exports.base64urlToUint8Array = base64urlToUint8Array;
	exports.uint8ArrayToBase64url = uint8ArrayToBase64url;
	exports.hexToUint8Array = hexToUint8Array;
	exports.uint8ArrayToHex = uint8ArrayToHex;
	function assertEqual(val) {
		return val;
	}
	function assertNotEqual(val) {
		return val;
	}
	function assertIs(_arg) {}
	function assertNever(_x) {
		throw new Error();
	}
	function assert(_) {}
	function getEnumValues(entries) {
		const numericValues = Object.values(entries).filter((v) => typeof v === "number");
		return Object.entries(entries).filter(([k, _]) => numericValues.indexOf(+k) === -1).map(([_, v]) => v);
	}
	function joinValues(array, separator = "|") {
		return array.map((val) => stringifyPrimitive(val)).join(separator);
	}
	function jsonStringifyReplacer(_, value) {
		if (typeof value === "bigint") return value.toString();
		return value;
	}
	function cached(getter) {
		return { get value() {
			{
				const value = getter();
				Object.defineProperty(this, "value", { value });
				return value;
			}
		} };
	}
	function nullish(input) {
		return input === null || input === void 0;
	}
	function cleanRegex(source) {
		const start = source.startsWith("^") ? 1 : 0;
		const end = source.endsWith("$") ? source.length - 1 : source.length;
		return source.slice(start, end);
	}
	function floatSafeRemainder(val, step) {
		const valDecCount = (val.toString().split(".")[1] || "").length;
		const stepString = step.toString();
		let stepDecCount = (stepString.split(".")[1] || "").length;
		if (stepDecCount === 0 && /\d?e-\d?/.test(stepString)) {
			const match = stepString.match(/\d?e-(\d?)/);
			if (match?.[1]) stepDecCount = Number.parseInt(match[1]);
		}
		const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
		return Number.parseInt(val.toFixed(decCount).replace(".", "")) % Number.parseInt(step.toFixed(decCount).replace(".", "")) / 10 ** decCount;
	}
	var EVALUATING = Symbol("evaluating");
	function defineLazy(object, key, getter) {
		let value = void 0;
		Object.defineProperty(object, key, {
			get() {
				if (value === EVALUATING) return;
				if (value === void 0) {
					value = EVALUATING;
					value = getter();
				}
				return value;
			},
			set(v) {
				Object.defineProperty(object, key, { value: v });
			},
			configurable: true
		});
	}
	function objectClone(obj) {
		return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
	}
	function assignProp(target, prop, value) {
		Object.defineProperty(target, prop, {
			value,
			writable: true,
			enumerable: true,
			configurable: true
		});
	}
	function mergeDefs(...defs) {
		const mergedDescriptors = {};
		for (const def of defs) {
			const descriptors = Object.getOwnPropertyDescriptors(def);
			Object.assign(mergedDescriptors, descriptors);
		}
		return Object.defineProperties({}, mergedDescriptors);
	}
	function cloneDef(schema) {
		return mergeDefs(schema._zod.def);
	}
	function getElementAtPath(obj, path) {
		if (!path) return obj;
		return path.reduce((acc, key) => acc?.[key], obj);
	}
	function promiseAllObject(promisesObj) {
		const keys = Object.keys(promisesObj);
		const promises = keys.map((key) => promisesObj[key]);
		return Promise.all(promises).then((results) => {
			const resolvedObj = {};
			for (let i = 0; i < keys.length; i++) resolvedObj[keys[i]] = results[i];
			return resolvedObj;
		});
	}
	function randomString(length = 10) {
		const chars = "abcdefghijklmnopqrstuvwxyz";
		let str = "";
		for (let i = 0; i < length; i++) str += chars[Math.floor(Math.random() * 26)];
		return str;
	}
	function esc(str) {
		return JSON.stringify(str);
	}
	exports.captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args) => {};
	function isObject(data) {
		return typeof data === "object" && data !== null && !Array.isArray(data);
	}
	exports.allowsEval = cached(() => {
		if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
		try {
			new Function("");
			return true;
		} catch (_) {
			return false;
		}
	});
	function isPlainObject(o) {
		if (isObject(o) === false) return false;
		const ctor = o.constructor;
		if (ctor === void 0) return true;
		const prot = ctor.prototype;
		if (isObject(prot) === false) return false;
		if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
		return true;
	}
	function shallowClone(o) {
		if (isPlainObject(o)) return { ...o };
		return o;
	}
	function numKeys(data) {
		let keyCount = 0;
		for (const key in data) if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
		return keyCount;
	}
	var getParsedType = (data) => {
		const t = typeof data;
		switch (t) {
			case "undefined": return "undefined";
			case "string": return "string";
			case "number": return Number.isNaN(data) ? "nan" : "number";
			case "boolean": return "boolean";
			case "function": return "function";
			case "bigint": return "bigint";
			case "symbol": return "symbol";
			case "object":
				if (Array.isArray(data)) return "array";
				if (data === null) return "null";
				if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
				if (typeof Map !== "undefined" && data instanceof Map) return "map";
				if (typeof Set !== "undefined" && data instanceof Set) return "set";
				if (typeof Date !== "undefined" && data instanceof Date) return "date";
				if (typeof File !== "undefined" && data instanceof File) return "file";
				return "object";
			default: throw new Error(`Unknown data type: ${t}`);
		}
	};
	exports.getParsedType = getParsedType;
	exports.propertyKeyTypes = /* @__PURE__ */ new Set([
		"string",
		"number",
		"symbol"
	]);
	exports.primitiveTypes = /* @__PURE__ */ new Set([
		"string",
		"number",
		"bigint",
		"boolean",
		"symbol",
		"undefined"
	]);
	function escapeRegex(str) {
		return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}
	function clone(inst, def, params) {
		const cl = new inst._zod.constr(def ?? inst._zod.def);
		if (!def || params?.parent) cl._zod.parent = inst;
		return cl;
	}
	function normalizeParams(_params) {
		const params = _params;
		if (!params) return {};
		if (typeof params === "string") return { error: () => params };
		if (params?.message !== void 0) {
			if (params?.error !== void 0) throw new Error("Cannot specify both `message` and `error` params");
			params.error = params.message;
		}
		delete params.message;
		if (typeof params.error === "string") return {
			...params,
			error: () => params.error
		};
		return params;
	}
	function createTransparentProxy(getter) {
		let target;
		return new Proxy({}, {
			get(_, prop, receiver) {
				target ?? (target = getter());
				return Reflect.get(target, prop, receiver);
			},
			set(_, prop, value, receiver) {
				target ?? (target = getter());
				return Reflect.set(target, prop, value, receiver);
			},
			has(_, prop) {
				target ?? (target = getter());
				return Reflect.has(target, prop);
			},
			deleteProperty(_, prop) {
				target ?? (target = getter());
				return Reflect.deleteProperty(target, prop);
			},
			ownKeys(_) {
				target ?? (target = getter());
				return Reflect.ownKeys(target);
			},
			getOwnPropertyDescriptor(_, prop) {
				target ?? (target = getter());
				return Reflect.getOwnPropertyDescriptor(target, prop);
			},
			defineProperty(_, prop, descriptor) {
				target ?? (target = getter());
				return Reflect.defineProperty(target, prop, descriptor);
			}
		});
	}
	function stringifyPrimitive(value) {
		if (typeof value === "bigint") return value.toString() + "n";
		if (typeof value === "string") return `"${value}"`;
		return `${value}`;
	}
	function optionalKeys(shape) {
		return Object.keys(shape).filter((k) => {
			return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
		});
	}
	exports.NUMBER_FORMAT_RANGES = {
		safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
		int32: [-2147483648, 2147483647],
		uint32: [0, 4294967295],
		float32: [-34028234663852886e22, 34028234663852886e22],
		float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
	};
	exports.BIGINT_FORMAT_RANGES = {
		int64: [/* @__PURE__*/ BigInt("-9223372036854775808"), /* @__PURE__*/ BigInt("9223372036854775807")],
		uint64: [/* @__PURE__*/ BigInt(0), /* @__PURE__*/ BigInt("18446744073709551615")]
	};
	function pick(schema, mask) {
		const currDef = schema._zod.def;
		return clone(schema, mergeDefs(schema._zod.def, {
			get shape() {
				const newShape = {};
				for (const key in mask) {
					if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
					if (!mask[key]) continue;
					newShape[key] = currDef.shape[key];
				}
				assignProp(this, "shape", newShape);
				return newShape;
			},
			checks: []
		}));
	}
	function omit(schema, mask) {
		const currDef = schema._zod.def;
		return clone(schema, mergeDefs(schema._zod.def, {
			get shape() {
				const newShape = { ...schema._zod.def.shape };
				for (const key in mask) {
					if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
					if (!mask[key]) continue;
					delete newShape[key];
				}
				assignProp(this, "shape", newShape);
				return newShape;
			},
			checks: []
		}));
	}
	function extend(schema, shape) {
		if (!isPlainObject(shape)) throw new Error("Invalid input to extend: expected a plain object");
		const checks = schema._zod.def.checks;
		if (checks && checks.length > 0) throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
		return clone(schema, mergeDefs(schema._zod.def, {
			get shape() {
				const _shape = {
					...schema._zod.def.shape,
					...shape
				};
				assignProp(this, "shape", _shape);
				return _shape;
			},
			checks: []
		}));
	}
	function safeExtend(schema, shape) {
		if (!isPlainObject(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
		return clone(schema, {
			...schema._zod.def,
			get shape() {
				const _shape = {
					...schema._zod.def.shape,
					...shape
				};
				assignProp(this, "shape", _shape);
				return _shape;
			},
			checks: schema._zod.def.checks
		});
	}
	function merge(a, b) {
		return clone(a, mergeDefs(a._zod.def, {
			get shape() {
				const _shape = {
					...a._zod.def.shape,
					...b._zod.def.shape
				};
				assignProp(this, "shape", _shape);
				return _shape;
			},
			get catchall() {
				return b._zod.def.catchall;
			},
			checks: []
		}));
	}
	function partial(Class, schema, mask) {
		return clone(schema, mergeDefs(schema._zod.def, {
			get shape() {
				const oldShape = schema._zod.def.shape;
				const shape = { ...oldShape };
				if (mask) for (const key in mask) {
					if (!(key in oldShape)) throw new Error(`Unrecognized key: "${key}"`);
					if (!mask[key]) continue;
					shape[key] = Class ? new Class({
						type: "optional",
						innerType: oldShape[key]
					}) : oldShape[key];
				}
				else for (const key in oldShape) shape[key] = Class ? new Class({
					type: "optional",
					innerType: oldShape[key]
				}) : oldShape[key];
				assignProp(this, "shape", shape);
				return shape;
			},
			checks: []
		}));
	}
	function required(Class, schema, mask) {
		return clone(schema, mergeDefs(schema._zod.def, {
			get shape() {
				const oldShape = schema._zod.def.shape;
				const shape = { ...oldShape };
				if (mask) for (const key in mask) {
					if (!(key in shape)) throw new Error(`Unrecognized key: "${key}"`);
					if (!mask[key]) continue;
					shape[key] = new Class({
						type: "nonoptional",
						innerType: oldShape[key]
					});
				}
				else for (const key in oldShape) shape[key] = new Class({
					type: "nonoptional",
					innerType: oldShape[key]
				});
				assignProp(this, "shape", shape);
				return shape;
			},
			checks: []
		}));
	}
	function aborted(x, startIndex = 0) {
		if (x.aborted === true) return true;
		for (let i = startIndex; i < x.issues.length; i++) if (x.issues[i]?.continue !== true) return true;
		return false;
	}
	function prefixIssues(path, issues) {
		return issues.map((iss) => {
			var _a;
			(_a = iss).path ?? (_a.path = []);
			iss.path.unshift(path);
			return iss;
		});
	}
	function unwrapMessage(message) {
		return typeof message === "string" ? message : message?.message;
	}
	function finalizeIssue(iss, ctx, config) {
		const full = {
			...iss,
			path: iss.path ?? []
		};
		if (!iss.message) full.message = unwrapMessage(iss.inst?._zod.def?.error?.(iss)) ?? unwrapMessage(ctx?.error?.(iss)) ?? unwrapMessage(config.customError?.(iss)) ?? unwrapMessage(config.localeError?.(iss)) ?? "Invalid input";
		delete full.inst;
		delete full.continue;
		if (!ctx?.reportInput) delete full.input;
		return full;
	}
	function getSizableOrigin(input) {
		if (input instanceof Set) return "set";
		if (input instanceof Map) return "map";
		if (input instanceof File) return "file";
		return "unknown";
	}
	function getLengthableOrigin(input) {
		if (Array.isArray(input)) return "array";
		if (typeof input === "string") return "string";
		return "unknown";
	}
	function issue(...args) {
		const [iss, input, inst] = args;
		if (typeof iss === "string") return {
			message: iss,
			code: "custom",
			input,
			inst
		};
		return { ...iss };
	}
	function cleanEnum(obj) {
		return Object.entries(obj).filter(([k, _]) => {
			return Number.isNaN(Number.parseInt(k, 10));
		}).map((el) => el[1]);
	}
	function base64ToUint8Array(base64) {
		const binaryString = atob(base64);
		const bytes = new Uint8Array(binaryString.length);
		for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
		return bytes;
	}
	function uint8ArrayToBase64(bytes) {
		let binaryString = "";
		for (let i = 0; i < bytes.length; i++) binaryString += String.fromCharCode(bytes[i]);
		return btoa(binaryString);
	}
	function base64urlToUint8Array(base64url) {
		const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
		return base64ToUint8Array(base64 + "=".repeat((4 - base64.length % 4) % 4));
	}
	function uint8ArrayToBase64url(bytes) {
		return uint8ArrayToBase64(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
	}
	function hexToUint8Array(hex) {
		const cleanHex = hex.replace(/^0x/, "");
		if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
		const bytes = new Uint8Array(cleanHex.length / 2);
		for (let i = 0; i < cleanHex.length; i += 2) bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
		return bytes;
	}
	function uint8ArrayToHex(bytes) {
		return Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
	}
	var Class = class {
		constructor(..._args) {}
	};
	exports.Class = Class;
}));
//#endregion
//#region ../../node_modules/zod/v4/core/errors.cjs
var require_errors$3 = /* @__PURE__ */ __commonJSMin(((exports, module, this$80) => {
	var __createBinding = this$80 && this$80.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$80 && this$80.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$80 && this$80.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$ZodRealError = exports.$ZodError = void 0;
	exports.flattenError = flattenError;
	exports.formatError = formatError;
	exports.treeifyError = treeifyError;
	exports.toDotPath = toDotPath;
	exports.prettifyError = prettifyError;
	var core_js_1 = require_core$1();
	var util = __importStar(require_util());
	var initializer = (inst, def) => {
		inst.name = "$ZodError";
		Object.defineProperty(inst, "_zod", {
			value: inst._zod,
			enumerable: false
		});
		Object.defineProperty(inst, "issues", {
			value: def,
			enumerable: false
		});
		inst.message = JSON.stringify(def, util.jsonStringifyReplacer, 2);
		Object.defineProperty(inst, "toString", {
			value: () => inst.message,
			enumerable: false
		});
	};
	exports.$ZodError = (0, core_js_1.$constructor)("$ZodError", initializer);
	exports.$ZodRealError = (0, core_js_1.$constructor)("$ZodError", initializer, { Parent: Error });
	function flattenError(error, mapper = (issue) => issue.message) {
		const fieldErrors = {};
		const formErrors = [];
		for (const sub of error.issues) if (sub.path.length > 0) {
			fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
			fieldErrors[sub.path[0]].push(mapper(sub));
		} else formErrors.push(mapper(sub));
		return {
			formErrors,
			fieldErrors
		};
	}
	function formatError(error, _mapper) {
		const mapper = _mapper || function(issue) {
			return issue.message;
		};
		const fieldErrors = { _errors: [] };
		const processError = (error) => {
			for (const issue of error.issues) if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues) => processError({ issues }));
			else if (issue.code === "invalid_key") processError({ issues: issue.issues });
			else if (issue.code === "invalid_element") processError({ issues: issue.issues });
			else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
			else {
				let curr = fieldErrors;
				let i = 0;
				while (i < issue.path.length) {
					const el = issue.path[i];
					if (!(i === issue.path.length - 1)) curr[el] = curr[el] || { _errors: [] };
					else {
						curr[el] = curr[el] || { _errors: [] };
						curr[el]._errors.push(mapper(issue));
					}
					curr = curr[el];
					i++;
				}
			}
		};
		processError(error);
		return fieldErrors;
	}
	function treeifyError(error, _mapper) {
		const mapper = _mapper || function(issue) {
			return issue.message;
		};
		const result = { errors: [] };
		const processError = (error, path = []) => {
			var _a, _b;
			for (const issue of error.issues) if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues) => processError({ issues }, issue.path));
			else if (issue.code === "invalid_key") processError({ issues: issue.issues }, issue.path);
			else if (issue.code === "invalid_element") processError({ issues: issue.issues }, issue.path);
			else {
				const fullpath = [...path, ...issue.path];
				if (fullpath.length === 0) {
					result.errors.push(mapper(issue));
					continue;
				}
				let curr = result;
				let i = 0;
				while (i < fullpath.length) {
					const el = fullpath[i];
					const terminal = i === fullpath.length - 1;
					if (typeof el === "string") {
						curr.properties ?? (curr.properties = {});
						(_a = curr.properties)[el] ?? (_a[el] = { errors: [] });
						curr = curr.properties[el];
					} else {
						curr.items ?? (curr.items = []);
						(_b = curr.items)[el] ?? (_b[el] = { errors: [] });
						curr = curr.items[el];
					}
					if (terminal) curr.errors.push(mapper(issue));
					i++;
				}
			}
		};
		processError(error);
		return result;
	}
	/** Format a ZodError as a human-readable string in the following form.
	*
	* From
	*
	* ```ts
	* ZodError {
	*   issues: [
	*     {
	*       expected: 'string',
	*       code: 'invalid_type',
	*       path: [ 'username' ],
	*       message: 'Invalid input: expected string'
	*     },
	*     {
	*       expected: 'number',
	*       code: 'invalid_type',
	*       path: [ 'favoriteNumbers', 1 ],
	*       message: 'Invalid input: expected number'
	*     }
	*   ];
	* }
	* ```
	*
	* to
	*
	* ```
	* username
	*   ✖ Expected number, received string at "username
	* favoriteNumbers[0]
	*   ✖ Invalid input: expected number
	* ```
	*/
	function toDotPath(_path) {
		const segs = [];
		const path = _path.map((seg) => typeof seg === "object" ? seg.key : seg);
		for (const seg of path) if (typeof seg === "number") segs.push(`[${seg}]`);
		else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
		else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
		else {
			if (segs.length) segs.push(".");
			segs.push(seg);
		}
		return segs.join("");
	}
	function prettifyError(error) {
		const lines = [];
		const issues = [...error.issues].sort((a, b) => (a.path ?? []).length - (b.path ?? []).length);
		for (const issue of issues) {
			lines.push(`✖ ${issue.message}`);
			if (issue.path?.length) lines.push(`  → at ${toDotPath(issue.path)}`);
		}
		return lines.join("\n");
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/core/parse.cjs
var require_parse$2 = /* @__PURE__ */ __commonJSMin(((exports, module, this$79) => {
	var __createBinding = this$79 && this$79.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$79 && this$79.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$79 && this$79.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeDecodeAsync = exports._safeDecodeAsync = exports.safeEncodeAsync = exports._safeEncodeAsync = exports.safeDecode = exports._safeDecode = exports.safeEncode = exports._safeEncode = exports.decodeAsync = exports._decodeAsync = exports.encodeAsync = exports._encodeAsync = exports.decode = exports._decode = exports.encode = exports._encode = exports.safeParseAsync = exports._safeParseAsync = exports.safeParse = exports._safeParse = exports.parseAsync = exports._parseAsync = exports.parse = exports._parse = void 0;
	var core = __importStar(require_core$1());
	var errors = __importStar(require_errors$3());
	var util = __importStar(require_util());
	var _parse = (_Err) => (schema, value, _ctx, _params) => {
		const ctx = _ctx ? Object.assign(_ctx, { async: false }) : { async: false };
		const result = schema._zod.run({
			value,
			issues: []
		}, ctx);
		if (result instanceof Promise) throw new core.$ZodAsyncError();
		if (result.issues.length) {
			const e = new ((_params?.Err) ?? _Err)(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())));
			util.captureStackTrace(e, _params?.callee);
			throw e;
		}
		return result.value;
	};
	exports._parse = _parse;
	exports.parse = (0, exports._parse)(errors.$ZodRealError);
	var _parseAsync = (_Err) => async (schema, value, _ctx, params) => {
		const ctx = _ctx ? Object.assign(_ctx, { async: true }) : { async: true };
		let result = schema._zod.run({
			value,
			issues: []
		}, ctx);
		if (result instanceof Promise) result = await result;
		if (result.issues.length) {
			const e = new ((params?.Err) ?? _Err)(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())));
			util.captureStackTrace(e, params?.callee);
			throw e;
		}
		return result.value;
	};
	exports._parseAsync = _parseAsync;
	exports.parseAsync = (0, exports._parseAsync)(errors.$ZodRealError);
	var _safeParse = (_Err) => (schema, value, _ctx) => {
		const ctx = _ctx ? {
			..._ctx,
			async: false
		} : { async: false };
		const result = schema._zod.run({
			value,
			issues: []
		}, ctx);
		if (result instanceof Promise) throw new core.$ZodAsyncError();
		return result.issues.length ? {
			success: false,
			error: new (_Err ?? errors.$ZodError)(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())))
		} : {
			success: true,
			data: result.value
		};
	};
	exports._safeParse = _safeParse;
	exports.safeParse = (0, exports._safeParse)(errors.$ZodRealError);
	var _safeParseAsync = (_Err) => async (schema, value, _ctx) => {
		const ctx = _ctx ? Object.assign(_ctx, { async: true }) : { async: true };
		let result = schema._zod.run({
			value,
			issues: []
		}, ctx);
		if (result instanceof Promise) result = await result;
		return result.issues.length ? {
			success: false,
			error: new _Err(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())))
		} : {
			success: true,
			data: result.value
		};
	};
	exports._safeParseAsync = _safeParseAsync;
	exports.safeParseAsync = (0, exports._safeParseAsync)(errors.$ZodRealError);
	var _encode = (_Err) => (schema, value, _ctx) => {
		const ctx = _ctx ? Object.assign(_ctx, { direction: "backward" }) : { direction: "backward" };
		return (0, exports._parse)(_Err)(schema, value, ctx);
	};
	exports._encode = _encode;
	exports.encode = (0, exports._encode)(errors.$ZodRealError);
	var _decode = (_Err) => (schema, value, _ctx) => {
		return (0, exports._parse)(_Err)(schema, value, _ctx);
	};
	exports._decode = _decode;
	exports.decode = (0, exports._decode)(errors.$ZodRealError);
	var _encodeAsync = (_Err) => async (schema, value, _ctx) => {
		const ctx = _ctx ? Object.assign(_ctx, { direction: "backward" }) : { direction: "backward" };
		return (0, exports._parseAsync)(_Err)(schema, value, ctx);
	};
	exports._encodeAsync = _encodeAsync;
	exports.encodeAsync = (0, exports._encodeAsync)(errors.$ZodRealError);
	var _decodeAsync = (_Err) => async (schema, value, _ctx) => {
		return (0, exports._parseAsync)(_Err)(schema, value, _ctx);
	};
	exports._decodeAsync = _decodeAsync;
	exports.decodeAsync = (0, exports._decodeAsync)(errors.$ZodRealError);
	var _safeEncode = (_Err) => (schema, value, _ctx) => {
		const ctx = _ctx ? Object.assign(_ctx, { direction: "backward" }) : { direction: "backward" };
		return (0, exports._safeParse)(_Err)(schema, value, ctx);
	};
	exports._safeEncode = _safeEncode;
	exports.safeEncode = (0, exports._safeEncode)(errors.$ZodRealError);
	var _safeDecode = (_Err) => (schema, value, _ctx) => {
		return (0, exports._safeParse)(_Err)(schema, value, _ctx);
	};
	exports._safeDecode = _safeDecode;
	exports.safeDecode = (0, exports._safeDecode)(errors.$ZodRealError);
	var _safeEncodeAsync = (_Err) => async (schema, value, _ctx) => {
		const ctx = _ctx ? Object.assign(_ctx, { direction: "backward" }) : { direction: "backward" };
		return (0, exports._safeParseAsync)(_Err)(schema, value, ctx);
	};
	exports._safeEncodeAsync = _safeEncodeAsync;
	exports.safeEncodeAsync = (0, exports._safeEncodeAsync)(errors.$ZodRealError);
	var _safeDecodeAsync = (_Err) => async (schema, value, _ctx) => {
		return (0, exports._safeParseAsync)(_Err)(schema, value, _ctx);
	};
	exports._safeDecodeAsync = _safeDecodeAsync;
	exports.safeDecodeAsync = (0, exports._safeDecodeAsync)(errors.$ZodRealError);
}));
//#endregion
//#region ../../node_modules/zod/v4/core/regexes.cjs
var require_regexes = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sha384_base64 = exports.sha384_hex = exports.sha256_base64url = exports.sha256_base64 = exports.sha256_hex = exports.sha1_base64url = exports.sha1_base64 = exports.sha1_hex = exports.md5_base64url = exports.md5_base64 = exports.md5_hex = exports.hex = exports.uppercase = exports.lowercase = exports.undefined = exports.null = exports.boolean = exports.number = exports.integer = exports.bigint = exports.string = exports.date = exports.e164 = exports.domain = exports.hostname = exports.base64url = exports.base64 = exports.cidrv6 = exports.cidrv4 = exports.ipv6 = exports.ipv4 = exports.browserEmail = exports.idnEmail = exports.unicodeEmail = exports.rfc5322Email = exports.html5Email = exports.email = exports.uuid7 = exports.uuid6 = exports.uuid4 = exports.uuid = exports.guid = exports.extendedDuration = exports.duration = exports.nanoid = exports.ksuid = exports.xid = exports.ulid = exports.cuid2 = exports.cuid = void 0;
	exports.sha512_base64url = exports.sha512_base64 = exports.sha512_hex = exports.sha384_base64url = void 0;
	exports.emoji = emoji;
	exports.time = time;
	exports.datetime = datetime;
	exports.cuid = /^[cC][^\s-]{8,}$/;
	exports.cuid2 = /^[0-9a-z]+$/;
	exports.ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
	exports.xid = /^[0-9a-vA-V]{20}$/;
	exports.ksuid = /^[A-Za-z0-9]{27}$/;
	exports.nanoid = /^[a-zA-Z0-9_-]{21}$/;
	/** ISO 8601-1 duration regex. Does not support the 8601-2 extensions like negative durations or fractional/negative components. */
	exports.duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
	/** Implements ISO 8601-2 extensions like explicit +- prefixes, mixing weeks with other units, and fractional/negative components. */
	exports.extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
	/** A regex for any UUID-like identifier: 8-4-4-4-12 hex pattern */
	exports.guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
	/** Returns a regex for validating an RFC 9562/4122 UUID.
	*
	* @param version Optionally specify a version 1-8. If no version is specified, all versions are supported. */
	var uuid = (version) => {
		if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
		return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
	};
	exports.uuid = uuid;
	exports.uuid4 = (0, exports.uuid)(4);
	exports.uuid6 = (0, exports.uuid)(6);
	exports.uuid7 = (0, exports.uuid)(7);
	/** Practical email validation */
	exports.email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
	/** Equivalent to the HTML5 input[type=email] validation implemented by browsers. Source: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email */
	exports.html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	/** The classic emailregex.com regex for RFC 5322-compliant emails */
	exports.rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	/** A loose regex that allows Unicode characters, enforces length limits, and that's about it. */
	exports.unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
	exports.idnEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
	exports.browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	var _emoji = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
	function emoji() {
		return new RegExp(_emoji, "u");
	}
	exports.ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
	exports.ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/;
	exports.cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
	exports.cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
	exports.base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
	exports.base64url = /^[A-Za-z0-9_-]*$/;
	exports.hostname = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
	exports.domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
	exports.e164 = /^\+(?:[0-9]){6,14}[0-9]$/;
	var dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
	exports.date = new RegExp(`^${dateSource}$`);
	function timeSource(args) {
		const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
		return typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
	}
	function time(args) {
		return new RegExp(`^${timeSource(args)}$`);
	}
	function datetime(args) {
		const time = timeSource({ precision: args.precision });
		const opts = ["Z"];
		if (args.local) opts.push("");
		if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
		const timeRegex = `${time}(?:${opts.join("|")})`;
		return new RegExp(`^${dateSource}T(?:${timeRegex})$`);
	}
	var string = (params) => {
		const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
		return new RegExp(`^${regex}$`);
	};
	exports.string = string;
	exports.bigint = /^\d+n?$/;
	exports.integer = /^\d+$/;
	exports.number = /^-?\d+(?:\.\d+)?/i;
	exports.boolean = /true|false/i;
	exports.null = /null/i;
	exports.undefined = /undefined/i;
	exports.lowercase = /^[^A-Z]*$/;
	exports.uppercase = /^[^a-z]*$/;
	exports.hex = /^[0-9a-fA-F]*$/;
	function fixedBase64(bodyLength, padding) {
		return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
	}
	function fixedBase64url(length) {
		return new RegExp(`^[A-Za-z0-9-_]{${length}}$`);
	}
	exports.md5_hex = /^[0-9a-fA-F]{32}$/;
	exports.md5_base64 = fixedBase64(22, "==");
	exports.md5_base64url = fixedBase64url(22);
	exports.sha1_hex = /^[0-9a-fA-F]{40}$/;
	exports.sha1_base64 = fixedBase64(27, "=");
	exports.sha1_base64url = fixedBase64url(27);
	exports.sha256_hex = /^[0-9a-fA-F]{64}$/;
	exports.sha256_base64 = fixedBase64(43, "=");
	exports.sha256_base64url = fixedBase64url(43);
	exports.sha384_hex = /^[0-9a-fA-F]{96}$/;
	exports.sha384_base64 = fixedBase64(64, "");
	exports.sha384_base64url = fixedBase64url(64);
	exports.sha512_hex = /^[0-9a-fA-F]{128}$/;
	exports.sha512_base64 = fixedBase64(86, "==");
	exports.sha512_base64url = fixedBase64url(86);
}));
//#endregion
//#region ../../node_modules/zod/v4/core/checks.cjs
var require_checks$1 = /* @__PURE__ */ __commonJSMin(((exports, module, this$78) => {
	var __createBinding = this$78 && this$78.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$78 && this$78.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$78 && this$78.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$ZodCheckOverwrite = exports.$ZodCheckMimeType = exports.$ZodCheckProperty = exports.$ZodCheckEndsWith = exports.$ZodCheckStartsWith = exports.$ZodCheckIncludes = exports.$ZodCheckUpperCase = exports.$ZodCheckLowerCase = exports.$ZodCheckRegex = exports.$ZodCheckStringFormat = exports.$ZodCheckLengthEquals = exports.$ZodCheckMinLength = exports.$ZodCheckMaxLength = exports.$ZodCheckSizeEquals = exports.$ZodCheckMinSize = exports.$ZodCheckMaxSize = exports.$ZodCheckBigIntFormat = exports.$ZodCheckNumberFormat = exports.$ZodCheckMultipleOf = exports.$ZodCheckGreaterThan = exports.$ZodCheckLessThan = exports.$ZodCheck = void 0;
	var core = __importStar(require_core$1());
	var regexes = __importStar(require_regexes());
	var util = __importStar(require_util());
	exports.$ZodCheck = core.$constructor("$ZodCheck", (inst, def) => {
		var _a;
		inst._zod ?? (inst._zod = {});
		inst._zod.def = def;
		(_a = inst._zod).onattach ?? (_a.onattach = []);
	});
	var numericOriginMap = {
		number: "number",
		bigint: "bigint",
		object: "date"
	};
	exports.$ZodCheckLessThan = core.$constructor("$ZodCheckLessThan", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const origin = numericOriginMap[typeof def.value];
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
			if (def.value < curr) {
				if (def.inclusive) bag.maximum = def.value;
				else bag.exclusiveMaximum = def.value;
			}
		});
		inst._zod.check = (payload) => {
			if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
			payload.issues.push({
				origin,
				code: "too_big",
				maximum: def.value,
				input: payload.value,
				inclusive: def.inclusive,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckGreaterThan = core.$constructor("$ZodCheckGreaterThan", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const origin = numericOriginMap[typeof def.value];
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
			if (def.value > curr) {
				if (def.inclusive) bag.minimum = def.value;
				else bag.exclusiveMinimum = def.value;
			}
		});
		inst._zod.check = (payload) => {
			if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
			payload.issues.push({
				origin,
				code: "too_small",
				minimum: def.value,
				input: payload.value,
				inclusive: def.inclusive,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckMultipleOf = /*@__PURE__*/ core.$constructor("$ZodCheckMultipleOf", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		inst._zod.onattach.push((inst) => {
			var _a;
			(_a = inst._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
		});
		inst._zod.check = (payload) => {
			if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
			if (typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : util.floatSafeRemainder(payload.value, def.value) === 0) return;
			payload.issues.push({
				origin: typeof payload.value,
				code: "not_multiple_of",
				divisor: def.value,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckNumberFormat = core.$constructor("$ZodCheckNumberFormat", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		def.format = def.format || "float64";
		const isInt = def.format?.includes("int");
		const origin = isInt ? "int" : "number";
		const [minimum, maximum] = util.NUMBER_FORMAT_RANGES[def.format];
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.format = def.format;
			bag.minimum = minimum;
			bag.maximum = maximum;
			if (isInt) bag.pattern = regexes.integer;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			if (isInt) {
				if (!Number.isInteger(input)) {
					payload.issues.push({
						expected: origin,
						format: def.format,
						code: "invalid_type",
						continue: false,
						input,
						inst
					});
					return;
				}
				if (!Number.isSafeInteger(input)) {
					if (input > 0) payload.issues.push({
						input,
						code: "too_big",
						maximum: Number.MAX_SAFE_INTEGER,
						note: "Integers must be within the safe integer range.",
						inst,
						origin,
						continue: !def.abort
					});
					else payload.issues.push({
						input,
						code: "too_small",
						minimum: Number.MIN_SAFE_INTEGER,
						note: "Integers must be within the safe integer range.",
						inst,
						origin,
						continue: !def.abort
					});
					return;
				}
			}
			if (input < minimum) payload.issues.push({
				origin: "number",
				input,
				code: "too_small",
				minimum,
				inclusive: true,
				inst,
				continue: !def.abort
			});
			if (input > maximum) payload.issues.push({
				origin: "number",
				input,
				code: "too_big",
				maximum,
				inst
			});
		};
	});
	exports.$ZodCheckBigIntFormat = core.$constructor("$ZodCheckBigIntFormat", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const [minimum, maximum] = util.BIGINT_FORMAT_RANGES[def.format];
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.format = def.format;
			bag.minimum = minimum;
			bag.maximum = maximum;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			if (input < minimum) payload.issues.push({
				origin: "bigint",
				input,
				code: "too_small",
				minimum,
				inclusive: true,
				inst,
				continue: !def.abort
			});
			if (input > maximum) payload.issues.push({
				origin: "bigint",
				input,
				code: "too_big",
				maximum,
				inst
			});
		};
	});
	exports.$ZodCheckMaxSize = core.$constructor("$ZodCheckMaxSize", (inst, def) => {
		var _a;
		exports.$ZodCheck.init(inst, def);
		(_a = inst._zod.def).when ?? (_a.when = (payload) => {
			const val = payload.value;
			return !util.nullish(val) && val.size !== void 0;
		});
		inst._zod.onattach.push((inst) => {
			const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
			if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			if (input.size <= def.maximum) return;
			payload.issues.push({
				origin: util.getSizableOrigin(input),
				code: "too_big",
				maximum: def.maximum,
				inclusive: true,
				input,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckMinSize = core.$constructor("$ZodCheckMinSize", (inst, def) => {
		var _a;
		exports.$ZodCheck.init(inst, def);
		(_a = inst._zod.def).when ?? (_a.when = (payload) => {
			const val = payload.value;
			return !util.nullish(val) && val.size !== void 0;
		});
		inst._zod.onattach.push((inst) => {
			const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
			if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			if (input.size >= def.minimum) return;
			payload.issues.push({
				origin: util.getSizableOrigin(input),
				code: "too_small",
				minimum: def.minimum,
				inclusive: true,
				input,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckSizeEquals = core.$constructor("$ZodCheckSizeEquals", (inst, def) => {
		var _a;
		exports.$ZodCheck.init(inst, def);
		(_a = inst._zod.def).when ?? (_a.when = (payload) => {
			const val = payload.value;
			return !util.nullish(val) && val.size !== void 0;
		});
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.minimum = def.size;
			bag.maximum = def.size;
			bag.size = def.size;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			const size = input.size;
			if (size === def.size) return;
			const tooBig = size > def.size;
			payload.issues.push({
				origin: util.getSizableOrigin(input),
				...tooBig ? {
					code: "too_big",
					maximum: def.size
				} : {
					code: "too_small",
					minimum: def.size
				},
				inclusive: true,
				exact: true,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckMaxLength = core.$constructor("$ZodCheckMaxLength", (inst, def) => {
		var _a;
		exports.$ZodCheck.init(inst, def);
		(_a = inst._zod.def).when ?? (_a.when = (payload) => {
			const val = payload.value;
			return !util.nullish(val) && val.length !== void 0;
		});
		inst._zod.onattach.push((inst) => {
			const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
			if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			if (input.length <= def.maximum) return;
			const origin = util.getLengthableOrigin(input);
			payload.issues.push({
				origin,
				code: "too_big",
				maximum: def.maximum,
				inclusive: true,
				input,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckMinLength = core.$constructor("$ZodCheckMinLength", (inst, def) => {
		var _a;
		exports.$ZodCheck.init(inst, def);
		(_a = inst._zod.def).when ?? (_a.when = (payload) => {
			const val = payload.value;
			return !util.nullish(val) && val.length !== void 0;
		});
		inst._zod.onattach.push((inst) => {
			const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
			if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			if (input.length >= def.minimum) return;
			const origin = util.getLengthableOrigin(input);
			payload.issues.push({
				origin,
				code: "too_small",
				minimum: def.minimum,
				inclusive: true,
				input,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckLengthEquals = core.$constructor("$ZodCheckLengthEquals", (inst, def) => {
		var _a;
		exports.$ZodCheck.init(inst, def);
		(_a = inst._zod.def).when ?? (_a.when = (payload) => {
			const val = payload.value;
			return !util.nullish(val) && val.length !== void 0;
		});
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.minimum = def.length;
			bag.maximum = def.length;
			bag.length = def.length;
		});
		inst._zod.check = (payload) => {
			const input = payload.value;
			const length = input.length;
			if (length === def.length) return;
			const origin = util.getLengthableOrigin(input);
			const tooBig = length > def.length;
			payload.issues.push({
				origin,
				...tooBig ? {
					code: "too_big",
					maximum: def.length
				} : {
					code: "too_small",
					minimum: def.length
				},
				inclusive: true,
				exact: true,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckStringFormat = core.$constructor("$ZodCheckStringFormat", (inst, def) => {
		var _a, _b;
		exports.$ZodCheck.init(inst, def);
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.format = def.format;
			if (def.pattern) {
				bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
				bag.patterns.add(def.pattern);
			}
		});
		if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload) => {
			def.pattern.lastIndex = 0;
			if (def.pattern.test(payload.value)) return;
			payload.issues.push({
				origin: "string",
				code: "invalid_format",
				format: def.format,
				input: payload.value,
				...def.pattern ? { pattern: def.pattern.toString() } : {},
				inst,
				continue: !def.abort
			});
		});
		else (_b = inst._zod).check ?? (_b.check = () => {});
	});
	exports.$ZodCheckRegex = core.$constructor("$ZodCheckRegex", (inst, def) => {
		exports.$ZodCheckStringFormat.init(inst, def);
		inst._zod.check = (payload) => {
			def.pattern.lastIndex = 0;
			if (def.pattern.test(payload.value)) return;
			payload.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "regex",
				input: payload.value,
				pattern: def.pattern.toString(),
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckLowerCase = core.$constructor("$ZodCheckLowerCase", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.lowercase);
		exports.$ZodCheckStringFormat.init(inst, def);
	});
	exports.$ZodCheckUpperCase = core.$constructor("$ZodCheckUpperCase", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.uppercase);
		exports.$ZodCheckStringFormat.init(inst, def);
	});
	exports.$ZodCheckIncludes = core.$constructor("$ZodCheckIncludes", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const escapedRegex = util.escapeRegex(def.includes);
		const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position}}${escapedRegex}` : escapedRegex);
		def.pattern = pattern;
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
			bag.patterns.add(pattern);
		});
		inst._zod.check = (payload) => {
			if (payload.value.includes(def.includes, def.position)) return;
			payload.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "includes",
				includes: def.includes,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckStartsWith = core.$constructor("$ZodCheckStartsWith", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const pattern = new RegExp(`^${util.escapeRegex(def.prefix)}.*`);
		def.pattern ?? (def.pattern = pattern);
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
			bag.patterns.add(pattern);
		});
		inst._zod.check = (payload) => {
			if (payload.value.startsWith(def.prefix)) return;
			payload.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "starts_with",
				prefix: def.prefix,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckEndsWith = core.$constructor("$ZodCheckEndsWith", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const pattern = new RegExp(`.*${util.escapeRegex(def.suffix)}$`);
		def.pattern ?? (def.pattern = pattern);
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
			bag.patterns.add(pattern);
		});
		inst._zod.check = (payload) => {
			if (payload.value.endsWith(def.suffix)) return;
			payload.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "ends_with",
				suffix: def.suffix,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	function handleCheckPropertyResult(result, payload, property) {
		if (result.issues.length) payload.issues.push(...util.prefixIssues(property, result.issues));
	}
	exports.$ZodCheckProperty = core.$constructor("$ZodCheckProperty", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		inst._zod.check = (payload) => {
			const result = def.schema._zod.run({
				value: payload.value[def.property],
				issues: []
			}, {});
			if (result instanceof Promise) return result.then((result) => handleCheckPropertyResult(result, payload, def.property));
			handleCheckPropertyResult(result, payload, def.property);
		};
	});
	exports.$ZodCheckMimeType = core.$constructor("$ZodCheckMimeType", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		const mimeSet = new Set(def.mime);
		inst._zod.onattach.push((inst) => {
			inst._zod.bag.mime = def.mime;
		});
		inst._zod.check = (payload) => {
			if (mimeSet.has(payload.value.type)) return;
			payload.issues.push({
				code: "invalid_value",
				values: def.mime,
				input: payload.value.type,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCheckOverwrite = core.$constructor("$ZodCheckOverwrite", (inst, def) => {
		exports.$ZodCheck.init(inst, def);
		inst._zod.check = (payload) => {
			payload.value = def.tx(payload.value);
		};
	});
}));
//#endregion
//#region ../../node_modules/zod/v4/core/doc.cjs
var require_doc = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Doc = void 0;
	var Doc = class {
		constructor(args = []) {
			this.content = [];
			this.indent = 0;
			if (this) this.args = args;
		}
		indented(fn) {
			this.indent += 1;
			fn(this);
			this.indent -= 1;
		}
		write(arg) {
			if (typeof arg === "function") {
				arg(this, { execution: "sync" });
				arg(this, { execution: "async" });
				return;
			}
			const lines = arg.split("\n").filter((x) => x);
			const minIndent = Math.min(...lines.map((x) => x.length - x.trimStart().length));
			const dedented = lines.map((x) => x.slice(minIndent)).map((x) => " ".repeat(this.indent * 2) + x);
			for (const line of dedented) this.content.push(line);
		}
		compile() {
			const F = Function;
			const args = this?.args;
			const lines = [...(this?.content ?? [``]).map((x) => `  ${x}`)];
			return new F(...args, lines.join("\n"));
		}
	};
	exports.Doc = Doc;
}));
//#endregion
//#region ../../node_modules/zod/v4/core/versions.cjs
var require_versions = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.version = void 0;
	exports.version = {
		major: 4,
		minor: 1,
		patch: 5
	};
}));
//#endregion
//#region ../../node_modules/zod/v4/core/schemas.cjs
var require_schemas$1 = /* @__PURE__ */ __commonJSMin(((exports, module, this$77) => {
	var __createBinding = this$77 && this$77.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$77 && this$77.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$77 && this$77.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$ZodMap = exports.$ZodRecord = exports.$ZodTuple = exports.$ZodIntersection = exports.$ZodDiscriminatedUnion = exports.$ZodUnion = exports.$ZodObjectJIT = exports.$ZodObject = exports.$ZodArray = exports.$ZodDate = exports.$ZodVoid = exports.$ZodNever = exports.$ZodUnknown = exports.$ZodAny = exports.$ZodNull = exports.$ZodUndefined = exports.$ZodSymbol = exports.$ZodBigIntFormat = exports.$ZodBigInt = exports.$ZodBoolean = exports.$ZodNumberFormat = exports.$ZodNumber = exports.$ZodCustomStringFormat = exports.$ZodJWT = exports.$ZodE164 = exports.$ZodBase64URL = exports.$ZodBase64 = exports.$ZodCIDRv6 = exports.$ZodCIDRv4 = exports.$ZodIPv6 = exports.$ZodIPv4 = exports.$ZodISODuration = exports.$ZodISOTime = exports.$ZodISODate = exports.$ZodISODateTime = exports.$ZodKSUID = exports.$ZodXID = exports.$ZodULID = exports.$ZodCUID2 = exports.$ZodCUID = exports.$ZodNanoID = exports.$ZodEmoji = exports.$ZodURL = exports.$ZodEmail = exports.$ZodUUID = exports.$ZodGUID = exports.$ZodStringFormat = exports.$ZodString = exports.clone = exports.$ZodType = void 0;
	exports.$ZodCustom = exports.$ZodLazy = exports.$ZodPromise = exports.$ZodFunction = exports.$ZodTemplateLiteral = exports.$ZodReadonly = exports.$ZodCodec = exports.$ZodPipe = exports.$ZodNaN = exports.$ZodCatch = exports.$ZodSuccess = exports.$ZodNonOptional = exports.$ZodPrefault = exports.$ZodDefault = exports.$ZodNullable = exports.$ZodOptional = exports.$ZodTransform = exports.$ZodFile = exports.$ZodLiteral = exports.$ZodEnum = exports.$ZodSet = void 0;
	exports.isValidBase64 = isValidBase64;
	exports.isValidBase64URL = isValidBase64URL;
	exports.isValidJWT = isValidJWT;
	var checks = __importStar(require_checks$1());
	var core = __importStar(require_core$1());
	var doc_js_1 = require_doc();
	var parse_js_1 = require_parse$2();
	var regexes = __importStar(require_regexes());
	var util = __importStar(require_util());
	var versions_js_1 = require_versions();
	exports.$ZodType = core.$constructor("$ZodType", (inst, def) => {
		var _a;
		inst ?? (inst = {});
		inst._zod.def = def;
		inst._zod.bag = inst._zod.bag || {};
		inst._zod.version = versions_js_1.version;
		const checks = [...inst._zod.def.checks ?? []];
		if (inst._zod.traits.has("$ZodCheck")) checks.unshift(inst);
		for (const ch of checks) for (const fn of ch._zod.onattach) fn(inst);
		if (checks.length === 0) {
			(_a = inst._zod).deferred ?? (_a.deferred = []);
			inst._zod.deferred?.push(() => {
				inst._zod.run = inst._zod.parse;
			});
		} else {
			const runChecks = (payload, checks, ctx) => {
				let isAborted = util.aborted(payload);
				let asyncResult;
				for (const ch of checks) {
					if (ch._zod.def.when) {
						if (!ch._zod.def.when(payload)) continue;
					} else if (isAborted) continue;
					const currLen = payload.issues.length;
					const _ = ch._zod.check(payload);
					if (_ instanceof Promise && ctx?.async === false) throw new core.$ZodAsyncError();
					if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async () => {
						await _;
						if (payload.issues.length === currLen) return;
						if (!isAborted) isAborted = util.aborted(payload, currLen);
					});
					else {
						if (payload.issues.length === currLen) continue;
						if (!isAborted) isAborted = util.aborted(payload, currLen);
					}
				}
				if (asyncResult) return asyncResult.then(() => {
					return payload;
				});
				return payload;
			};
			const handleCanaryResult = (canary, payload, ctx) => {
				if (util.aborted(canary)) {
					canary.aborted = true;
					return canary;
				}
				const checkResult = runChecks(payload, checks, ctx);
				if (checkResult instanceof Promise) {
					if (ctx.async === false) throw new core.$ZodAsyncError();
					return checkResult.then((checkResult) => inst._zod.parse(checkResult, ctx));
				}
				return inst._zod.parse(checkResult, ctx);
			};
			inst._zod.run = (payload, ctx) => {
				if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
				if (ctx.direction === "backward") {
					const canary = inst._zod.parse({
						value: payload.value,
						issues: []
					}, {
						...ctx,
						skipChecks: true
					});
					if (canary instanceof Promise) return canary.then((canary) => {
						return handleCanaryResult(canary, payload, ctx);
					});
					return handleCanaryResult(canary, payload, ctx);
				}
				const result = inst._zod.parse(payload, ctx);
				if (result instanceof Promise) {
					if (ctx.async === false) throw new core.$ZodAsyncError();
					return result.then((result) => runChecks(result, checks, ctx));
				}
				return runChecks(result, checks, ctx);
			};
		}
		inst["~standard"] = {
			validate: (value) => {
				try {
					const r = (0, parse_js_1.safeParse)(inst, value);
					return r.success ? { value: r.data } : { issues: r.error?.issues };
				} catch (_) {
					return (0, parse_js_1.safeParseAsync)(inst, value).then((r) => r.success ? { value: r.data } : { issues: r.error?.issues });
				}
			},
			vendor: "zod",
			version: 1
		};
	});
	var util_js_1 = require_util();
	Object.defineProperty(exports, "clone", {
		enumerable: true,
		get: function() {
			return util_js_1.clone;
		}
	});
	exports.$ZodString = core.$constructor("$ZodString", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.pattern = [...inst?._zod.bag?.patterns ?? []].pop() ?? regexes.string(inst._zod.bag);
		inst._zod.parse = (payload, _) => {
			if (def.coerce) try {
				payload.value = String(payload.value);
			} catch (_) {}
			if (typeof payload.value === "string") return payload;
			payload.issues.push({
				expected: "string",
				code: "invalid_type",
				input: payload.value,
				inst
			});
			return payload;
		};
	});
	exports.$ZodStringFormat = core.$constructor("$ZodStringFormat", (inst, def) => {
		checks.$ZodCheckStringFormat.init(inst, def);
		exports.$ZodString.init(inst, def);
	});
	exports.$ZodGUID = core.$constructor("$ZodGUID", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.guid);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodUUID = core.$constructor("$ZodUUID", (inst, def) => {
		if (def.version) {
			const v = {
				v1: 1,
				v2: 2,
				v3: 3,
				v4: 4,
				v5: 5,
				v6: 6,
				v7: 7,
				v8: 8
			}[def.version];
			if (v === void 0) throw new Error(`Invalid UUID version: "${def.version}"`);
			def.pattern ?? (def.pattern = regexes.uuid(v));
		} else def.pattern ?? (def.pattern = regexes.uuid());
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodEmail = core.$constructor("$ZodEmail", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.email);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodURL = core.$constructor("$ZodURL", (inst, def) => {
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.check = (payload) => {
			try {
				const trimmed = payload.value.trim();
				const url = new URL(trimmed);
				if (def.hostname) {
					def.hostname.lastIndex = 0;
					if (!def.hostname.test(url.hostname)) payload.issues.push({
						code: "invalid_format",
						format: "url",
						note: "Invalid hostname",
						pattern: regexes.hostname.source,
						input: payload.value,
						inst,
						continue: !def.abort
					});
				}
				if (def.protocol) {
					def.protocol.lastIndex = 0;
					if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) payload.issues.push({
						code: "invalid_format",
						format: "url",
						note: "Invalid protocol",
						pattern: def.protocol.source,
						input: payload.value,
						inst,
						continue: !def.abort
					});
				}
				if (def.normalize) payload.value = url.href;
				else payload.value = trimmed;
				return;
			} catch (_) {
				payload.issues.push({
					code: "invalid_format",
					format: "url",
					input: payload.value,
					inst,
					continue: !def.abort
				});
			}
		};
	});
	exports.$ZodEmoji = core.$constructor("$ZodEmoji", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.emoji());
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodNanoID = core.$constructor("$ZodNanoID", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.nanoid);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodCUID = core.$constructor("$ZodCUID", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.cuid);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodCUID2 = core.$constructor("$ZodCUID2", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.cuid2);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodULID = core.$constructor("$ZodULID", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.ulid);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodXID = core.$constructor("$ZodXID", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.xid);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodKSUID = core.$constructor("$ZodKSUID", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.ksuid);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodISODateTime = core.$constructor("$ZodISODateTime", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.datetime(def));
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodISODate = core.$constructor("$ZodISODate", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.date);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodISOTime = core.$constructor("$ZodISOTime", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.time(def));
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodISODuration = core.$constructor("$ZodISODuration", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.duration);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodIPv4 = core.$constructor("$ZodIPv4", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.ipv4);
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.format = `ipv4`;
		});
	});
	exports.$ZodIPv6 = core.$constructor("$ZodIPv6", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.ipv6);
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.onattach.push((inst) => {
			const bag = inst._zod.bag;
			bag.format = `ipv6`;
		});
		inst._zod.check = (payload) => {
			try {
				new URL(`http://[${payload.value}]`);
			} catch {
				payload.issues.push({
					code: "invalid_format",
					format: "ipv6",
					input: payload.value,
					inst,
					continue: !def.abort
				});
			}
		};
	});
	exports.$ZodCIDRv4 = core.$constructor("$ZodCIDRv4", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.cidrv4);
		exports.$ZodStringFormat.init(inst, def);
	});
	exports.$ZodCIDRv6 = core.$constructor("$ZodCIDRv6", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.cidrv6);
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.check = (payload) => {
			const [address, prefix] = payload.value.split("/");
			try {
				if (!prefix) throw new Error();
				const prefixNum = Number(prefix);
				if (`${prefixNum}` !== prefix) throw new Error();
				if (prefixNum < 0 || prefixNum > 128) throw new Error();
				new URL(`http://[${address}]`);
			} catch {
				payload.issues.push({
					code: "invalid_format",
					format: "cidrv6",
					input: payload.value,
					inst,
					continue: !def.abort
				});
			}
		};
	});
	function isValidBase64(data) {
		if (data === "") return true;
		if (data.length % 4 !== 0) return false;
		try {
			atob(data);
			return true;
		} catch {
			return false;
		}
	}
	exports.$ZodBase64 = core.$constructor("$ZodBase64", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.base64);
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.onattach.push((inst) => {
			inst._zod.bag.contentEncoding = "base64";
		});
		inst._zod.check = (payload) => {
			if (isValidBase64(payload.value)) return;
			payload.issues.push({
				code: "invalid_format",
				format: "base64",
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	function isValidBase64URL(data) {
		if (!regexes.base64url.test(data)) return false;
		const base64 = data.replace(/[-_]/g, (c) => c === "-" ? "+" : "/");
		return isValidBase64(base64.padEnd(Math.ceil(base64.length / 4) * 4, "="));
	}
	exports.$ZodBase64URL = core.$constructor("$ZodBase64URL", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.base64url);
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.onattach.push((inst) => {
			inst._zod.bag.contentEncoding = "base64url";
		});
		inst._zod.check = (payload) => {
			if (isValidBase64URL(payload.value)) return;
			payload.issues.push({
				code: "invalid_format",
				format: "base64url",
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodE164 = core.$constructor("$ZodE164", (inst, def) => {
		def.pattern ?? (def.pattern = regexes.e164);
		exports.$ZodStringFormat.init(inst, def);
	});
	function isValidJWT(token, algorithm = null) {
		try {
			const tokensParts = token.split(".");
			if (tokensParts.length !== 3) return false;
			const [header] = tokensParts;
			if (!header) return false;
			const parsedHeader = JSON.parse(atob(header));
			if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
			if (!parsedHeader.alg) return false;
			if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
			return true;
		} catch {
			return false;
		}
	}
	exports.$ZodJWT = core.$constructor("$ZodJWT", (inst, def) => {
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.check = (payload) => {
			if (isValidJWT(payload.value, def.alg)) return;
			payload.issues.push({
				code: "invalid_format",
				format: "jwt",
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodCustomStringFormat = core.$constructor("$ZodCustomStringFormat", (inst, def) => {
		exports.$ZodStringFormat.init(inst, def);
		inst._zod.check = (payload) => {
			if (def.fn(payload.value)) return;
			payload.issues.push({
				code: "invalid_format",
				format: def.format,
				input: payload.value,
				inst,
				continue: !def.abort
			});
		};
	});
	exports.$ZodNumber = core.$constructor("$ZodNumber", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.pattern = inst._zod.bag.pattern ?? regexes.number;
		inst._zod.parse = (payload, _ctx) => {
			if (def.coerce) try {
				payload.value = Number(payload.value);
			} catch (_) {}
			const input = payload.value;
			if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
			const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : void 0 : void 0;
			payload.issues.push({
				expected: "number",
				code: "invalid_type",
				input,
				inst,
				...received ? { received } : {}
			});
			return payload;
		};
	});
	exports.$ZodNumberFormat = core.$constructor("$ZodNumber", (inst, def) => {
		checks.$ZodCheckNumberFormat.init(inst, def);
		exports.$ZodNumber.init(inst, def);
	});
	exports.$ZodBoolean = core.$constructor("$ZodBoolean", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.pattern = regexes.boolean;
		inst._zod.parse = (payload, _ctx) => {
			if (def.coerce) try {
				payload.value = Boolean(payload.value);
			} catch (_) {}
			const input = payload.value;
			if (typeof input === "boolean") return payload;
			payload.issues.push({
				expected: "boolean",
				code: "invalid_type",
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodBigInt = core.$constructor("$ZodBigInt", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.pattern = regexes.bigint;
		inst._zod.parse = (payload, _ctx) => {
			if (def.coerce) try {
				payload.value = BigInt(payload.value);
			} catch (_) {}
			if (typeof payload.value === "bigint") return payload;
			payload.issues.push({
				expected: "bigint",
				code: "invalid_type",
				input: payload.value,
				inst
			});
			return payload;
		};
	});
	exports.$ZodBigIntFormat = core.$constructor("$ZodBigInt", (inst, def) => {
		checks.$ZodCheckBigIntFormat.init(inst, def);
		exports.$ZodBigInt.init(inst, def);
	});
	exports.$ZodSymbol = core.$constructor("$ZodSymbol", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (typeof input === "symbol") return payload;
			payload.issues.push({
				expected: "symbol",
				code: "invalid_type",
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodUndefined = core.$constructor("$ZodUndefined", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.pattern = regexes.undefined;
		inst._zod.values = /* @__PURE__ */ new Set([void 0]);
		inst._zod.optin = "optional";
		inst._zod.optout = "optional";
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (typeof input === "undefined") return payload;
			payload.issues.push({
				expected: "undefined",
				code: "invalid_type",
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodNull = core.$constructor("$ZodNull", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.pattern = regexes.null;
		inst._zod.values = /* @__PURE__ */ new Set([null]);
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (input === null) return payload;
			payload.issues.push({
				expected: "null",
				code: "invalid_type",
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodAny = core.$constructor("$ZodAny", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload) => payload;
	});
	exports.$ZodUnknown = core.$constructor("$ZodUnknown", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload) => payload;
	});
	exports.$ZodNever = core.$constructor("$ZodNever", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			payload.issues.push({
				expected: "never",
				code: "invalid_type",
				input: payload.value,
				inst
			});
			return payload;
		};
	});
	exports.$ZodVoid = core.$constructor("$ZodVoid", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (typeof input === "undefined") return payload;
			payload.issues.push({
				expected: "void",
				code: "invalid_type",
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodDate = core.$constructor("$ZodDate", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			if (def.coerce) try {
				payload.value = new Date(payload.value);
			} catch (_err) {}
			const input = payload.value;
			const isDate = input instanceof Date;
			if (isDate && !Number.isNaN(input.getTime())) return payload;
			payload.issues.push({
				expected: "date",
				code: "invalid_type",
				input,
				...isDate ? { received: "Invalid Date" } : {},
				inst
			});
			return payload;
		};
	});
	function handleArrayResult(result, final, index) {
		if (result.issues.length) final.issues.push(...util.prefixIssues(index, result.issues));
		final.value[index] = result.value;
	}
	exports.$ZodArray = core.$constructor("$ZodArray", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			if (!Array.isArray(input)) {
				payload.issues.push({
					expected: "array",
					code: "invalid_type",
					input,
					inst
				});
				return payload;
			}
			payload.value = Array(input.length);
			const proms = [];
			for (let i = 0; i < input.length; i++) {
				const item = input[i];
				const result = def.element._zod.run({
					value: item,
					issues: []
				}, ctx);
				if (result instanceof Promise) proms.push(result.then((result) => handleArrayResult(result, payload, i)));
				else handleArrayResult(result, payload, i);
			}
			if (proms.length) return Promise.all(proms).then(() => payload);
			return payload;
		};
	});
	function handlePropertyResult(result, final, key, input) {
		if (result.issues.length) final.issues.push(...util.prefixIssues(key, result.issues));
		if (result.value === void 0) {
			if (key in input) final.value[key] = void 0;
		} else final.value[key] = result.value;
	}
	function normalizeDef(def) {
		const keys = Object.keys(def.shape);
		for (const k of keys) if (!def.shape[k]._zod.traits.has("$ZodType")) throw new Error(`Invalid element at key "${k}": expected a Zod schema`);
		const okeys = util.optionalKeys(def.shape);
		return {
			...def,
			keys,
			keySet: new Set(keys),
			numKeys: keys.length,
			optionalKeys: new Set(okeys)
		};
	}
	function handleCatchall(proms, input, payload, ctx, def, inst) {
		const unrecognized = [];
		const keySet = def.keySet;
		const _catchall = def.catchall._zod;
		const t = _catchall.def.type;
		for (const key of Object.keys(input)) {
			if (keySet.has(key)) continue;
			if (t === "never") {
				unrecognized.push(key);
				continue;
			}
			const r = _catchall.run({
				value: input[key],
				issues: []
			}, ctx);
			if (r instanceof Promise) proms.push(r.then((r) => handlePropertyResult(r, payload, key, input)));
			else handlePropertyResult(r, payload, key, input);
		}
		if (unrecognized.length) payload.issues.push({
			code: "unrecognized_keys",
			keys: unrecognized,
			input,
			inst
		});
		if (!proms.length) return payload;
		return Promise.all(proms).then(() => {
			return payload;
		});
	}
	exports.$ZodObject = core.$constructor("$ZodObject", (inst, def) => {
		exports.$ZodType.init(inst, def);
		const _normalized = util.cached(() => normalizeDef(def));
		util.defineLazy(inst._zod, "propValues", () => {
			const shape = def.shape;
			const propValues = {};
			for (const key in shape) {
				const field = shape[key]._zod;
				if (field.values) {
					propValues[key] ?? (propValues[key] = /* @__PURE__ */ new Set());
					for (const v of field.values) propValues[key].add(v);
				}
			}
			return propValues;
		});
		const isObject = util.isObject;
		const catchall = def.catchall;
		let value;
		inst._zod.parse = (payload, ctx) => {
			value ?? (value = _normalized.value);
			const input = payload.value;
			if (!isObject(input)) {
				payload.issues.push({
					expected: "object",
					code: "invalid_type",
					input,
					inst
				});
				return payload;
			}
			payload.value = {};
			const proms = [];
			const shape = value.shape;
			for (const key of value.keys) {
				const r = shape[key]._zod.run({
					value: input[key],
					issues: []
				}, ctx);
				if (r instanceof Promise) proms.push(r.then((r) => handlePropertyResult(r, payload, key, input)));
				else handlePropertyResult(r, payload, key, input);
			}
			if (!catchall) return proms.length ? Promise.all(proms).then(() => payload) : payload;
			return handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
		};
	});
	exports.$ZodObjectJIT = core.$constructor("$ZodObjectJIT", (inst, def) => {
		exports.$ZodObject.init(inst, def);
		const superParse = inst._zod.parse;
		const _normalized = util.cached(() => normalizeDef(def));
		const generateFastpass = (shape) => {
			const doc = new doc_js_1.Doc([
				"shape",
				"payload",
				"ctx"
			]);
			const normalized = _normalized.value;
			const parseStr = (key) => {
				const k = util.esc(key);
				return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
			};
			doc.write(`const input = payload.value;`);
			const ids = Object.create(null);
			let counter = 0;
			for (const key of normalized.keys) ids[key] = `key_${counter++}`;
			doc.write(`const newResult = {}`);
			for (const key of normalized.keys) {
				const id = ids[key];
				const k = util.esc(key);
				doc.write(`const ${id} = ${parseStr(key)};`);
				doc.write(`
        if (${id}.issues.length) {
          payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
      `);
			}
			doc.write(`payload.value = newResult;`);
			doc.write(`return payload;`);
			const fn = doc.compile();
			return (payload, ctx) => fn(shape, payload, ctx);
		};
		let fastpass;
		const isObject = util.isObject;
		const jit = !core.globalConfig.jitless;
		const allowsEval = util.allowsEval;
		const fastEnabled = jit && allowsEval.value;
		const catchall = def.catchall;
		let value;
		inst._zod.parse = (payload, ctx) => {
			value ?? (value = _normalized.value);
			const input = payload.value;
			if (!isObject(input)) {
				payload.issues.push({
					expected: "object",
					code: "invalid_type",
					input,
					inst
				});
				return payload;
			}
			if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
				if (!fastpass) fastpass = generateFastpass(def.shape);
				payload = fastpass(payload, ctx);
				if (!catchall) return payload;
				return handleCatchall([], input, payload, ctx, value, inst);
			}
			return superParse(payload, ctx);
		};
	});
	function handleUnionResults(results, final, inst, ctx) {
		for (const result of results) if (result.issues.length === 0) {
			final.value = result.value;
			return final;
		}
		const nonaborted = results.filter((r) => !util.aborted(r));
		if (nonaborted.length === 1) {
			final.value = nonaborted[0].value;
			return nonaborted[0];
		}
		final.issues.push({
			code: "invalid_union",
			input: final.value,
			inst,
			errors: results.map((result) => result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())))
		});
		return final;
	}
	exports.$ZodUnion = core.$constructor("$ZodUnion", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "optin", () => def.options.some((o) => o._zod.optin === "optional") ? "optional" : void 0);
		util.defineLazy(inst._zod, "optout", () => def.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0);
		util.defineLazy(inst._zod, "values", () => {
			if (def.options.every((o) => o._zod.values)) return new Set(def.options.flatMap((option) => Array.from(option._zod.values)));
		});
		util.defineLazy(inst._zod, "pattern", () => {
			if (def.options.every((o) => o._zod.pattern)) {
				const patterns = def.options.map((o) => o._zod.pattern);
				return new RegExp(`^(${patterns.map((p) => util.cleanRegex(p.source)).join("|")})$`);
			}
		});
		const single = def.options.length === 1;
		const first = def.options[0]._zod.run;
		inst._zod.parse = (payload, ctx) => {
			if (single) return first(payload, ctx);
			let async = false;
			const results = [];
			for (const option of def.options) {
				const result = option._zod.run({
					value: payload.value,
					issues: []
				}, ctx);
				if (result instanceof Promise) {
					results.push(result);
					async = true;
				} else {
					if (result.issues.length === 0) return result;
					results.push(result);
				}
			}
			if (!async) return handleUnionResults(results, payload, inst, ctx);
			return Promise.all(results).then((results) => {
				return handleUnionResults(results, payload, inst, ctx);
			});
		};
	});
	exports.$ZodDiscriminatedUnion = /*@__PURE__*/ core.$constructor("$ZodDiscriminatedUnion", (inst, def) => {
		exports.$ZodUnion.init(inst, def);
		const _super = inst._zod.parse;
		util.defineLazy(inst._zod, "propValues", () => {
			const propValues = {};
			for (const option of def.options) {
				const pv = option._zod.propValues;
				if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
				for (const [k, v] of Object.entries(pv)) {
					if (!propValues[k]) propValues[k] = /* @__PURE__ */ new Set();
					for (const val of v) propValues[k].add(val);
				}
			}
			return propValues;
		});
		const disc = util.cached(() => {
			const opts = def.options;
			const map = /* @__PURE__ */ new Map();
			for (const o of opts) {
				const values = o._zod.propValues?.[def.discriminator];
				if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
				for (const v of values) {
					if (map.has(v)) throw new Error(`Duplicate discriminator value "${String(v)}"`);
					map.set(v, o);
				}
			}
			return map;
		});
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			if (!util.isObject(input)) {
				payload.issues.push({
					code: "invalid_type",
					expected: "object",
					input,
					inst
				});
				return payload;
			}
			const opt = disc.value.get(input?.[def.discriminator]);
			if (opt) return opt._zod.run(payload, ctx);
			if (def.unionFallback) return _super(payload, ctx);
			payload.issues.push({
				code: "invalid_union",
				errors: [],
				note: "No matching discriminator",
				discriminator: def.discriminator,
				input,
				path: [def.discriminator],
				inst
			});
			return payload;
		};
	});
	exports.$ZodIntersection = core.$constructor("$ZodIntersection", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			const left = def.left._zod.run({
				value: input,
				issues: []
			}, ctx);
			const right = def.right._zod.run({
				value: input,
				issues: []
			}, ctx);
			if (left instanceof Promise || right instanceof Promise) return Promise.all([left, right]).then(([left, right]) => {
				return handleIntersectionResults(payload, left, right);
			});
			return handleIntersectionResults(payload, left, right);
		};
	});
	function mergeValues(a, b) {
		if (a === b) return {
			valid: true,
			data: a
		};
		if (a instanceof Date && b instanceof Date && +a === +b) return {
			valid: true,
			data: a
		};
		if (util.isPlainObject(a) && util.isPlainObject(b)) {
			const bKeys = Object.keys(b);
			const sharedKeys = Object.keys(a).filter((key) => bKeys.indexOf(key) !== -1);
			const newObj = {
				...a,
				...b
			};
			for (const key of sharedKeys) {
				const sharedValue = mergeValues(a[key], b[key]);
				if (!sharedValue.valid) return {
					valid: false,
					mergeErrorPath: [key, ...sharedValue.mergeErrorPath]
				};
				newObj[key] = sharedValue.data;
			}
			return {
				valid: true,
				data: newObj
			};
		}
		if (Array.isArray(a) && Array.isArray(b)) {
			if (a.length !== b.length) return {
				valid: false,
				mergeErrorPath: []
			};
			const newArray = [];
			for (let index = 0; index < a.length; index++) {
				const itemA = a[index];
				const itemB = b[index];
				const sharedValue = mergeValues(itemA, itemB);
				if (!sharedValue.valid) return {
					valid: false,
					mergeErrorPath: [index, ...sharedValue.mergeErrorPath]
				};
				newArray.push(sharedValue.data);
			}
			return {
				valid: true,
				data: newArray
			};
		}
		return {
			valid: false,
			mergeErrorPath: []
		};
	}
	function handleIntersectionResults(result, left, right) {
		if (left.issues.length) result.issues.push(...left.issues);
		if (right.issues.length) result.issues.push(...right.issues);
		if (util.aborted(result)) return result;
		const merged = mergeValues(left.value, right.value);
		if (!merged.valid) throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(merged.mergeErrorPath)}`);
		result.value = merged.data;
		return result;
	}
	exports.$ZodTuple = core.$constructor("$ZodTuple", (inst, def) => {
		exports.$ZodType.init(inst, def);
		const items = def.items;
		const optStart = items.length - [...items].reverse().findIndex((item) => item._zod.optin !== "optional");
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			if (!Array.isArray(input)) {
				payload.issues.push({
					input,
					inst,
					expected: "tuple",
					code: "invalid_type"
				});
				return payload;
			}
			payload.value = [];
			const proms = [];
			if (!def.rest) {
				const tooBig = input.length > items.length;
				const tooSmall = input.length < optStart - 1;
				if (tooBig || tooSmall) {
					payload.issues.push({
						...tooBig ? {
							code: "too_big",
							maximum: items.length
						} : {
							code: "too_small",
							minimum: items.length
						},
						input,
						inst,
						origin: "array"
					});
					return payload;
				}
			}
			let i = -1;
			for (const item of items) {
				i++;
				if (i >= input.length) {
					if (i >= optStart) continue;
				}
				const result = item._zod.run({
					value: input[i],
					issues: []
				}, ctx);
				if (result instanceof Promise) proms.push(result.then((result) => handleTupleResult(result, payload, i)));
				else handleTupleResult(result, payload, i);
			}
			if (def.rest) {
				const rest = input.slice(items.length);
				for (const el of rest) {
					i++;
					const result = def.rest._zod.run({
						value: el,
						issues: []
					}, ctx);
					if (result instanceof Promise) proms.push(result.then((result) => handleTupleResult(result, payload, i)));
					else handleTupleResult(result, payload, i);
				}
			}
			if (proms.length) return Promise.all(proms).then(() => payload);
			return payload;
		};
	});
	function handleTupleResult(result, final, index) {
		if (result.issues.length) final.issues.push(...util.prefixIssues(index, result.issues));
		final.value[index] = result.value;
	}
	exports.$ZodRecord = core.$constructor("$ZodRecord", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			if (!util.isPlainObject(input)) {
				payload.issues.push({
					expected: "record",
					code: "invalid_type",
					input,
					inst
				});
				return payload;
			}
			const proms = [];
			if (def.keyType._zod.values) {
				const values = def.keyType._zod.values;
				payload.value = {};
				for (const key of values) if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
					const result = def.valueType._zod.run({
						value: input[key],
						issues: []
					}, ctx);
					if (result instanceof Promise) proms.push(result.then((result) => {
						if (result.issues.length) payload.issues.push(...util.prefixIssues(key, result.issues));
						payload.value[key] = result.value;
					}));
					else {
						if (result.issues.length) payload.issues.push(...util.prefixIssues(key, result.issues));
						payload.value[key] = result.value;
					}
				}
				let unrecognized;
				for (const key in input) if (!values.has(key)) {
					unrecognized = unrecognized ?? [];
					unrecognized.push(key);
				}
				if (unrecognized && unrecognized.length > 0) payload.issues.push({
					code: "unrecognized_keys",
					input,
					inst,
					keys: unrecognized
				});
			} else {
				payload.value = {};
				for (const key of Reflect.ownKeys(input)) {
					if (key === "__proto__") continue;
					const keyResult = def.keyType._zod.run({
						value: key,
						issues: []
					}, ctx);
					if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
					if (keyResult.issues.length) {
						payload.issues.push({
							code: "invalid_key",
							origin: "record",
							issues: keyResult.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())),
							input: key,
							path: [key],
							inst
						});
						payload.value[keyResult.value] = keyResult.value;
						continue;
					}
					const result = def.valueType._zod.run({
						value: input[key],
						issues: []
					}, ctx);
					if (result instanceof Promise) proms.push(result.then((result) => {
						if (result.issues.length) payload.issues.push(...util.prefixIssues(key, result.issues));
						payload.value[keyResult.value] = result.value;
					}));
					else {
						if (result.issues.length) payload.issues.push(...util.prefixIssues(key, result.issues));
						payload.value[keyResult.value] = result.value;
					}
				}
			}
			if (proms.length) return Promise.all(proms).then(() => payload);
			return payload;
		};
	});
	exports.$ZodMap = core.$constructor("$ZodMap", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			if (!(input instanceof Map)) {
				payload.issues.push({
					expected: "map",
					code: "invalid_type",
					input,
					inst
				});
				return payload;
			}
			const proms = [];
			payload.value = /* @__PURE__ */ new Map();
			for (const [key, value] of input) {
				const keyResult = def.keyType._zod.run({
					value: key,
					issues: []
				}, ctx);
				const valueResult = def.valueType._zod.run({
					value,
					issues: []
				}, ctx);
				if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([keyResult, valueResult]).then(([keyResult, valueResult]) => {
					handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
				}));
				else handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
			}
			if (proms.length) return Promise.all(proms).then(() => payload);
			return payload;
		};
	});
	function handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
		if (keyResult.issues.length) {
			if (util.propertyKeyTypes.has(typeof key)) final.issues.push(...util.prefixIssues(key, keyResult.issues));
			else final.issues.push({
				code: "invalid_key",
				origin: "map",
				input,
				inst,
				issues: keyResult.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config()))
			});
		}
		if (valueResult.issues.length) {
			if (util.propertyKeyTypes.has(typeof key)) final.issues.push(...util.prefixIssues(key, valueResult.issues));
			else final.issues.push({
				origin: "map",
				code: "invalid_element",
				input,
				inst,
				key,
				issues: valueResult.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config()))
			});
		}
		final.value.set(keyResult.value, valueResult.value);
	}
	exports.$ZodSet = core.$constructor("$ZodSet", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			const input = payload.value;
			if (!(input instanceof Set)) {
				payload.issues.push({
					input,
					inst,
					expected: "set",
					code: "invalid_type"
				});
				return payload;
			}
			const proms = [];
			payload.value = /* @__PURE__ */ new Set();
			for (const item of input) {
				const result = def.valueType._zod.run({
					value: item,
					issues: []
				}, ctx);
				if (result instanceof Promise) proms.push(result.then((result) => handleSetResult(result, payload)));
				else handleSetResult(result, payload);
			}
			if (proms.length) return Promise.all(proms).then(() => payload);
			return payload;
		};
	});
	function handleSetResult(result, final) {
		if (result.issues.length) final.issues.push(...result.issues);
		final.value.add(result.value);
	}
	exports.$ZodEnum = core.$constructor("$ZodEnum", (inst, def) => {
		exports.$ZodType.init(inst, def);
		const values = util.getEnumValues(def.entries);
		const valuesSet = new Set(values);
		inst._zod.values = valuesSet;
		inst._zod.pattern = new RegExp(`^(${values.filter((k) => util.propertyKeyTypes.has(typeof k)).map((o) => typeof o === "string" ? util.escapeRegex(o) : o.toString()).join("|")})$`);
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (valuesSet.has(input)) return payload;
			payload.issues.push({
				code: "invalid_value",
				values,
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodLiteral = core.$constructor("$ZodLiteral", (inst, def) => {
		exports.$ZodType.init(inst, def);
		if (def.values.length === 0) throw new Error("Cannot create literal schema with no valid values");
		inst._zod.values = new Set(def.values);
		inst._zod.pattern = new RegExp(`^(${def.values.map((o) => typeof o === "string" ? util.escapeRegex(o) : o ? util.escapeRegex(o.toString()) : String(o)).join("|")})$`);
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (inst._zod.values.has(input)) return payload;
			payload.issues.push({
				code: "invalid_value",
				values: def.values,
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodFile = core.$constructor("$ZodFile", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			const input = payload.value;
			if (input instanceof File) return payload;
			payload.issues.push({
				expected: "file",
				code: "invalid_type",
				input,
				inst
			});
			return payload;
		};
	});
	exports.$ZodTransform = core.$constructor("$ZodTransform", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") throw new core.$ZodEncodeError(inst.constructor.name);
			const _out = def.transform(payload.value, payload);
			if (ctx.async) return (_out instanceof Promise ? _out : Promise.resolve(_out)).then((output) => {
				payload.value = output;
				return payload;
			});
			if (_out instanceof Promise) throw new core.$ZodAsyncError();
			payload.value = _out;
			return payload;
		};
	});
	function handleOptionalResult(result, input) {
		if (result.issues.length && input === void 0) return {
			issues: [],
			value: void 0
		};
		return result;
	}
	exports.$ZodOptional = core.$constructor("$ZodOptional", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.optin = "optional";
		inst._zod.optout = "optional";
		util.defineLazy(inst._zod, "values", () => {
			return def.innerType._zod.values ? /* @__PURE__ */ new Set([...def.innerType._zod.values, void 0]) : void 0;
		});
		util.defineLazy(inst._zod, "pattern", () => {
			const pattern = def.innerType._zod.pattern;
			return pattern ? new RegExp(`^(${util.cleanRegex(pattern.source)})?$`) : void 0;
		});
		inst._zod.parse = (payload, ctx) => {
			if (def.innerType._zod.optin === "optional") {
				const result = def.innerType._zod.run(payload, ctx);
				if (result instanceof Promise) return result.then((r) => handleOptionalResult(r, payload.value));
				return handleOptionalResult(result, payload.value);
			}
			if (payload.value === void 0) return payload;
			return def.innerType._zod.run(payload, ctx);
		};
	});
	exports.$ZodNullable = core.$constructor("$ZodNullable", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
		util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
		util.defineLazy(inst._zod, "pattern", () => {
			const pattern = def.innerType._zod.pattern;
			return pattern ? new RegExp(`^(${util.cleanRegex(pattern.source)}|null)$`) : void 0;
		});
		util.defineLazy(inst._zod, "values", () => {
			return def.innerType._zod.values ? /* @__PURE__ */ new Set([...def.innerType._zod.values, null]) : void 0;
		});
		inst._zod.parse = (payload, ctx) => {
			if (payload.value === null) return payload;
			return def.innerType._zod.run(payload, ctx);
		};
	});
	exports.$ZodDefault = core.$constructor("$ZodDefault", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.optin = "optional";
		util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
			if (payload.value === void 0) {
				payload.value = def.defaultValue;
				/**
				* $ZodDefault returns the default value immediately in forward direction.
				* It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */
				return payload;
			}
			const result = def.innerType._zod.run(payload, ctx);
			if (result instanceof Promise) return result.then((result) => handleDefaultResult(result, def));
			return handleDefaultResult(result, def);
		};
	});
	function handleDefaultResult(payload, def) {
		if (payload.value === void 0) payload.value = def.defaultValue;
		return payload;
	}
	exports.$ZodPrefault = core.$constructor("$ZodPrefault", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.optin = "optional";
		util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
			if (payload.value === void 0) payload.value = def.defaultValue;
			return def.innerType._zod.run(payload, ctx);
		};
	});
	exports.$ZodNonOptional = core.$constructor("$ZodNonOptional", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "values", () => {
			const v = def.innerType._zod.values;
			return v ? new Set([...v].filter((x) => x !== void 0)) : void 0;
		});
		inst._zod.parse = (payload, ctx) => {
			const result = def.innerType._zod.run(payload, ctx);
			if (result instanceof Promise) return result.then((result) => handleNonOptionalResult(result, inst));
			return handleNonOptionalResult(result, inst);
		};
	});
	function handleNonOptionalResult(payload, inst) {
		if (!payload.issues.length && payload.value === void 0) payload.issues.push({
			code: "invalid_type",
			expected: "nonoptional",
			input: payload.value,
			inst
		});
		return payload;
	}
	exports.$ZodSuccess = core.$constructor("$ZodSuccess", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") throw new core.$ZodEncodeError("ZodSuccess");
			const result = def.innerType._zod.run(payload, ctx);
			if (result instanceof Promise) return result.then((result) => {
				payload.value = result.issues.length === 0;
				return payload;
			});
			payload.value = result.issues.length === 0;
			return payload;
		};
	});
	exports.$ZodCatch = core.$constructor("$ZodCatch", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
		util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
		util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
			const result = def.innerType._zod.run(payload, ctx);
			if (result instanceof Promise) return result.then((result) => {
				payload.value = result.value;
				if (result.issues.length) {
					payload.value = def.catchValue({
						...payload,
						error: { issues: result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())) },
						input: payload.value
					});
					payload.issues = [];
				}
				return payload;
			});
			payload.value = result.value;
			if (result.issues.length) {
				payload.value = def.catchValue({
					...payload,
					error: { issues: result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())) },
					input: payload.value
				});
				payload.issues = [];
			}
			return payload;
		};
	});
	exports.$ZodNaN = core.$constructor("$ZodNaN", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
				payload.issues.push({
					input: payload.value,
					inst,
					expected: "nan",
					code: "invalid_type"
				});
				return payload;
			}
			return payload;
		};
	});
	exports.$ZodPipe = core.$constructor("$ZodPipe", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "values", () => def.in._zod.values);
		util.defineLazy(inst._zod, "optin", () => def.in._zod.optin);
		util.defineLazy(inst._zod, "optout", () => def.out._zod.optout);
		util.defineLazy(inst._zod, "propValues", () => def.in._zod.propValues);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") {
				const right = def.out._zod.run(payload, ctx);
				if (right instanceof Promise) return right.then((right) => handlePipeResult(right, def.in, ctx));
				return handlePipeResult(right, def.in, ctx);
			}
			const left = def.in._zod.run(payload, ctx);
			if (left instanceof Promise) return left.then((left) => handlePipeResult(left, def.out, ctx));
			return handlePipeResult(left, def.out, ctx);
		};
	});
	function handlePipeResult(left, next, ctx) {
		if (left.issues.length) {
			left.aborted = true;
			return left;
		}
		return next._zod.run({
			value: left.value,
			issues: left.issues
		}, ctx);
	}
	exports.$ZodCodec = core.$constructor("$ZodCodec", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "values", () => def.in._zod.values);
		util.defineLazy(inst._zod, "optin", () => def.in._zod.optin);
		util.defineLazy(inst._zod, "optout", () => def.out._zod.optout);
		util.defineLazy(inst._zod, "propValues", () => def.in._zod.propValues);
		inst._zod.parse = (payload, ctx) => {
			if ((ctx.direction || "forward") === "forward") {
				const left = def.in._zod.run(payload, ctx);
				if (left instanceof Promise) return left.then((left) => handleCodecAResult(left, def, ctx));
				return handleCodecAResult(left, def, ctx);
			} else {
				const right = def.out._zod.run(payload, ctx);
				if (right instanceof Promise) return right.then((right) => handleCodecAResult(right, def, ctx));
				return handleCodecAResult(right, def, ctx);
			}
		};
	});
	function handleCodecAResult(result, def, ctx) {
		if (result.issues.length) {
			result.aborted = true;
			return result;
		}
		if ((ctx.direction || "forward") === "forward") {
			const transformed = def.transform(result.value, result);
			if (transformed instanceof Promise) return transformed.then((value) => handleCodecTxResult(result, value, def.out, ctx));
			return handleCodecTxResult(result, transformed, def.out, ctx);
		} else {
			const transformed = def.reverseTransform(result.value, result);
			if (transformed instanceof Promise) return transformed.then((value) => handleCodecTxResult(result, value, def.in, ctx));
			return handleCodecTxResult(result, transformed, def.in, ctx);
		}
	}
	function handleCodecTxResult(left, value, nextSchema, ctx) {
		if (left.issues.length) {
			left.aborted = true;
			return left;
		}
		return nextSchema._zod.run({
			value,
			issues: left.issues
		}, ctx);
	}
	exports.$ZodReadonly = core.$constructor("$ZodReadonly", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "propValues", () => def.innerType._zod.propValues);
		util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
		util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
		util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
		inst._zod.parse = (payload, ctx) => {
			if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
			const result = def.innerType._zod.run(payload, ctx);
			if (result instanceof Promise) return result.then(handleReadonlyResult);
			return handleReadonlyResult(result);
		};
	});
	function handleReadonlyResult(payload) {
		payload.value = Object.freeze(payload.value);
		return payload;
	}
	exports.$ZodTemplateLiteral = core.$constructor("$ZodTemplateLiteral", (inst, def) => {
		exports.$ZodType.init(inst, def);
		const regexParts = [];
		for (const part of def.parts) if (typeof part === "object" && part !== null) {
			if (!part._zod.pattern) throw new Error(`Invalid template literal part, no pattern found: ${[...part._zod.traits].shift()}`);
			const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
			if (!source) throw new Error(`Invalid template literal part: ${part._zod.traits}`);
			const start = source.startsWith("^") ? 1 : 0;
			const end = source.endsWith("$") ? source.length - 1 : source.length;
			regexParts.push(source.slice(start, end));
		} else if (part === null || util.primitiveTypes.has(typeof part)) regexParts.push(util.escapeRegex(`${part}`));
		else throw new Error(`Invalid template literal part: ${part}`);
		inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
		inst._zod.parse = (payload, _ctx) => {
			if (typeof payload.value !== "string") {
				payload.issues.push({
					input: payload.value,
					inst,
					expected: "template_literal",
					code: "invalid_type"
				});
				return payload;
			}
			inst._zod.pattern.lastIndex = 0;
			if (!inst._zod.pattern.test(payload.value)) {
				payload.issues.push({
					input: payload.value,
					inst,
					code: "invalid_format",
					format: def.format ?? "template_literal",
					pattern: inst._zod.pattern.source
				});
				return payload;
			}
			return payload;
		};
	});
	exports.$ZodFunction = core.$constructor("$ZodFunction", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._def = def;
		inst._zod.def = def;
		inst.implement = (func) => {
			if (typeof func !== "function") throw new Error("implement() must be called with a function");
			return function(...args) {
				const parsedArgs = inst._def.input ? (0, parse_js_1.parse)(inst._def.input, args) : args;
				const result = Reflect.apply(func, this, parsedArgs);
				if (inst._def.output) return (0, parse_js_1.parse)(inst._def.output, result);
				return result;
			};
		};
		inst.implementAsync = (func) => {
			if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
			return async function(...args) {
				const parsedArgs = inst._def.input ? await (0, parse_js_1.parseAsync)(inst._def.input, args) : args;
				const result = await Reflect.apply(func, this, parsedArgs);
				if (inst._def.output) return await (0, parse_js_1.parseAsync)(inst._def.output, result);
				return result;
			};
		};
		inst._zod.parse = (payload, _ctx) => {
			if (typeof payload.value !== "function") {
				payload.issues.push({
					code: "invalid_type",
					expected: "function",
					input: payload.value,
					inst
				});
				return payload;
			}
			if (inst._def.output && inst._def.output._zod.def.type === "promise") payload.value = inst.implementAsync(payload.value);
			else payload.value = inst.implement(payload.value);
			return payload;
		};
		inst.input = (...args) => {
			const F = inst.constructor;
			if (Array.isArray(args[0])) return new F({
				type: "function",
				input: new exports.$ZodTuple({
					type: "tuple",
					items: args[0],
					rest: args[1]
				}),
				output: inst._def.output
			});
			return new F({
				type: "function",
				input: args[0],
				output: inst._def.output
			});
		};
		inst.output = (output) => {
			const F = inst.constructor;
			return new F({
				type: "function",
				input: inst._def.input,
				output
			});
		};
		return inst;
	});
	exports.$ZodPromise = core.$constructor("$ZodPromise", (inst, def) => {
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, ctx) => {
			return Promise.resolve(payload.value).then((inner) => def.innerType._zod.run({
				value: inner,
				issues: []
			}, ctx));
		};
	});
	exports.$ZodLazy = core.$constructor("$ZodLazy", (inst, def) => {
		exports.$ZodType.init(inst, def);
		util.defineLazy(inst._zod, "innerType", () => def.getter());
		util.defineLazy(inst._zod, "pattern", () => inst._zod.innerType._zod.pattern);
		util.defineLazy(inst._zod, "propValues", () => inst._zod.innerType._zod.propValues);
		util.defineLazy(inst._zod, "optin", () => inst._zod.innerType._zod.optin ?? void 0);
		util.defineLazy(inst._zod, "optout", () => inst._zod.innerType._zod.optout ?? void 0);
		inst._zod.parse = (payload, ctx) => {
			return inst._zod.innerType._zod.run(payload, ctx);
		};
	});
	exports.$ZodCustom = core.$constructor("$ZodCustom", (inst, def) => {
		checks.$ZodCheck.init(inst, def);
		exports.$ZodType.init(inst, def);
		inst._zod.parse = (payload, _) => {
			return payload;
		};
		inst._zod.check = (payload) => {
			const input = payload.value;
			const r = def.fn(input);
			if (r instanceof Promise) return r.then((r) => handleRefineResult(r, payload, input, inst));
			handleRefineResult(r, payload, input, inst);
		};
	});
	function handleRefineResult(result, payload, input, inst) {
		if (!result) {
			const _iss = {
				code: "custom",
				input,
				inst,
				path: [...inst._zod.def.path ?? []],
				continue: !inst._zod.def.abort
			};
			if (inst._zod.def.params) _iss.params = inst._zod.def.params;
			payload.issues.push(util.issue(_iss));
		}
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ar.cjs
var require_ar = /* @__PURE__ */ __commonJSMin(((exports, module, this$76) => {
	var __createBinding = this$76 && this$76.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$76 && this$76.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$76 && this$76.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "حرف",
				verb: "أن يحوي"
			},
			file: {
				unit: "بايت",
				verb: "أن يحوي"
			},
			array: {
				unit: "عنصر",
				verb: "أن يحوي"
			},
			set: {
				unit: "عنصر",
				verb: "أن يحوي"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "مدخل",
			email: "بريد إلكتروني",
			url: "رابط",
			emoji: "إيموجي",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "تاريخ ووقت بمعيار ISO",
			date: "تاريخ بمعيار ISO",
			time: "وقت بمعيار ISO",
			duration: "مدة بمعيار ISO",
			ipv4: "عنوان IPv4",
			ipv6: "عنوان IPv6",
			cidrv4: "مدى عناوين بصيغة IPv4",
			cidrv6: "مدى عناوين بصيغة IPv6",
			base64: "نَص بترميز base64-encoded",
			base64url: "نَص بترميز base64url-encoded",
			json_string: "نَص على هيئة JSON",
			e164: "رقم هاتف بمعيار E.164",
			jwt: "JWT",
			template_literal: "مدخل"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `مدخلات غير مقبولة: يفترض إدخال ${issue.expected}، ولكن تم إدخال ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `مدخلات غير مقبولة: يفترض إدخال ${util.stringifyPrimitive(issue.values[0])}`;
					return `اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return ` أكبر من اللازم: يفترض أن تكون ${issue.origin ?? "القيمة"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "عنصر"}`;
					return `أكبر من اللازم: يفترض أن تكون ${issue.origin ?? "القيمة"} ${adj} ${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `أصغر من اللازم: يفترض لـ ${issue.origin} أن يكون ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
					return `أصغر من اللازم: يفترض لـ ${issue.origin} أن يكون ${adj} ${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `نَص غير مقبول: يجب أن يبدأ بـ "${issue.prefix}"`;
					if (_issue.format === "ends_with") return `نَص غير مقبول: يجب أن ينتهي بـ "${_issue.suffix}"`;
					if (_issue.format === "includes") return `نَص غير مقبول: يجب أن يتضمَّن "${_issue.includes}"`;
					if (_issue.format === "regex") return `نَص غير مقبول: يجب أن يطابق النمط ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} غير مقبول`;
				}
				case "not_multiple_of": return `رقم غير مقبول: يجب أن يكون من مضاعفات ${issue.divisor}`;
				case "unrecognized_keys": return `معرف${issue.keys.length > 1 ? "ات" : ""} غريب${issue.keys.length > 1 ? "ة" : ""}: ${util.joinValues(issue.keys, "، ")}`;
				case "invalid_key": return `معرف غير مقبول في ${issue.origin}`;
				case "invalid_union": return "مدخل غير مقبول";
				case "invalid_element": return `مدخل غير مقبول في ${issue.origin}`;
				default: return "مدخل غير مقبول";
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/az.cjs
var require_az = /* @__PURE__ */ __commonJSMin(((exports, module, this$75) => {
	var __createBinding = this$75 && this$75.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$75 && this$75.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$75 && this$75.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "simvol",
				verb: "olmalıdır"
			},
			file: {
				unit: "bayt",
				verb: "olmalıdır"
			},
			array: {
				unit: "element",
				verb: "olmalıdır"
			},
			set: {
				unit: "element",
				verb: "olmalıdır"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "input",
			email: "email address",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO datetime",
			date: "ISO date",
			time: "ISO time",
			duration: "ISO duration",
			ipv4: "IPv4 address",
			ipv6: "IPv6 address",
			cidrv4: "IPv4 range",
			cidrv6: "IPv6 range",
			base64: "base64-encoded string",
			base64url: "base64url-encoded string",
			json_string: "JSON string",
			e164: "E.164 number",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Yanlış dəyər: gözlənilən ${issue.expected}, daxil olan ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Yanlış dəyər: gözlənilən ${util.stringifyPrimitive(issue.values[0])}`;
					return `Yanlış seçim: aşağıdakılardan biri olmalıdır: ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Çox böyük: gözlənilən ${issue.origin ?? "dəyər"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
					return `Çox böyük: gözlənilən ${issue.origin ?? "dəyər"} ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Çox kiçik: gözlənilən ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Çox kiçik: gözlənilən ${issue.origin} ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Yanlış mətn: "${_issue.prefix}" ilə başlamalıdır`;
					if (_issue.format === "ends_with") return `Yanlış mətn: "${_issue.suffix}" ilə bitməlidir`;
					if (_issue.format === "includes") return `Yanlış mətn: "${_issue.includes}" daxil olmalıdır`;
					if (_issue.format === "regex") return `Yanlış mətn: ${_issue.pattern} şablonuna uyğun olmalıdır`;
					return `Yanlış ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Yanlış ədəd: ${issue.divisor} ilə bölünə bilən olmalıdır`;
				case "unrecognized_keys": return `Tanınmayan açar${issue.keys.length > 1 ? "lar" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `${issue.origin} daxilində yanlış açar`;
				case "invalid_union": return "Yanlış dəyər";
				case "invalid_element": return `${issue.origin} daxilində yanlış dəyər`;
				default: return `Yanlış dəyər`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/be.cjs
var require_be = /* @__PURE__ */ __commonJSMin(((exports, module, this$74) => {
	var __createBinding = this$74 && this$74.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$74 && this$74.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$74 && this$74.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	function getBelarusianPlural(count, one, few, many) {
		const absCount = Math.abs(count);
		const lastDigit = absCount % 10;
		const lastTwoDigits = absCount % 100;
		if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
		if (lastDigit === 1) return one;
		if (lastDigit >= 2 && lastDigit <= 4) return few;
		return many;
	}
	var error = () => {
		const Sizable = {
			string: {
				unit: {
					one: "сімвал",
					few: "сімвалы",
					many: "сімвалаў"
				},
				verb: "мець"
			},
			array: {
				unit: {
					one: "элемент",
					few: "элементы",
					many: "элементаў"
				},
				verb: "мець"
			},
			set: {
				unit: {
					one: "элемент",
					few: "элементы",
					many: "элементаў"
				},
				verb: "мець"
			},
			file: {
				unit: {
					one: "байт",
					few: "байты",
					many: "байтаў"
				},
				verb: "мець"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "лік";
				case "object":
					if (Array.isArray(data)) return "масіў";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "увод",
			email: "email адрас",
			url: "URL",
			emoji: "эмодзі",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO дата і час",
			date: "ISO дата",
			time: "ISO час",
			duration: "ISO працягласць",
			ipv4: "IPv4 адрас",
			ipv6: "IPv6 адрас",
			cidrv4: "IPv4 дыяпазон",
			cidrv6: "IPv6 дыяпазон",
			base64: "радок у фармаце base64",
			base64url: "радок у фармаце base64url",
			json_string: "JSON радок",
			e164: "нумар E.164",
			jwt: "JWT",
			template_literal: "увод"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Няправільны ўвод: чакаўся ${issue.expected}, атрымана ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Няправільны ўвод: чакалася ${util.stringifyPrimitive(issue.values[0])}`;
					return `Няправільны варыянт: чакаўся адзін з ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) {
						const unit = getBelarusianPlural(Number(issue.maximum), sizing.unit.one, sizing.unit.few, sizing.unit.many);
						return `Занадта вялікі: чакалася, што ${issue.origin ?? "значэнне"} павінна ${sizing.verb} ${adj}${issue.maximum.toString()} ${unit}`;
					}
					return `Занадта вялікі: чакалася, што ${issue.origin ?? "значэнне"} павінна быць ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) {
						const unit = getBelarusianPlural(Number(issue.minimum), sizing.unit.one, sizing.unit.few, sizing.unit.many);
						return `Занадта малы: чакалася, што ${issue.origin} павінна ${sizing.verb} ${adj}${issue.minimum.toString()} ${unit}`;
					}
					return `Занадта малы: чакалася, што ${issue.origin} павінна быць ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Няправільны радок: павінен пачынацца з "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Няправільны радок: павінен заканчвацца на "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Няправільны радок: павінен змяшчаць "${_issue.includes}"`;
					if (_issue.format === "regex") return `Няправільны радок: павінен адпавядаць шаблону ${_issue.pattern}`;
					return `Няправільны ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Няправільны лік: павінен быць кратным ${issue.divisor}`;
				case "unrecognized_keys": return `Нераспазнаны ${issue.keys.length > 1 ? "ключы" : "ключ"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Няправільны ключ у ${issue.origin}`;
				case "invalid_union": return "Няправільны ўвод";
				case "invalid_element": return `Няправільнае значэнне ў ${issue.origin}`;
				default: return `Няправільны ўвод`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ca.cjs
var require_ca = /* @__PURE__ */ __commonJSMin(((exports, module, this$73) => {
	var __createBinding = this$73 && this$73.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$73 && this$73.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$73 && this$73.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "caràcters",
				verb: "contenir"
			},
			file: {
				unit: "bytes",
				verb: "contenir"
			},
			array: {
				unit: "elements",
				verb: "contenir"
			},
			set: {
				unit: "elements",
				verb: "contenir"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "entrada",
			email: "adreça electrònica",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "data i hora ISO",
			date: "data ISO",
			time: "hora ISO",
			duration: "durada ISO",
			ipv4: "adreça IPv4",
			ipv6: "adreça IPv6",
			cidrv4: "rang IPv4",
			cidrv6: "rang IPv6",
			base64: "cadena codificada en base64",
			base64url: "cadena codificada en base64url",
			json_string: "cadena JSON",
			e164: "número E.164",
			jwt: "JWT",
			template_literal: "entrada"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Tipus invàlid: s'esperava ${issue.expected}, s'ha rebut ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Valor invàlid: s'esperava ${util.stringifyPrimitive(issue.values[0])}`;
					return `Opció invàlida: s'esperava una de ${util.joinValues(issue.values, " o ")}`;
				case "too_big": {
					const adj = issue.inclusive ? "com a màxim" : "menys de";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} contingués ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
					return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} fos ${adj} ${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? "com a mínim" : "més de";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Massa petit: s'esperava que ${issue.origin} contingués ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
					return `Massa petit: s'esperava que ${issue.origin} fos ${adj} ${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Format invàlid: ha de començar amb "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Format invàlid: ha d'acabar amb "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Format invàlid: ha d'incloure "${_issue.includes}"`;
					if (_issue.format === "regex") return `Format invàlid: ha de coincidir amb el patró ${_issue.pattern}`;
					return `Format invàlid per a ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Número invàlid: ha de ser múltiple de ${issue.divisor}`;
				case "unrecognized_keys": return `Clau${issue.keys.length > 1 ? "s" : ""} no reconeguda${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Clau invàlida a ${issue.origin}`;
				case "invalid_union": return "Entrada invàlida";
				case "invalid_element": return `Element invàlid a ${issue.origin}`;
				default: return `Entrada invàlida`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/cs.cjs
var require_cs = /* @__PURE__ */ __commonJSMin(((exports, module, this$72) => {
	var __createBinding = this$72 && this$72.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$72 && this$72.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$72 && this$72.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "znaků",
				verb: "mít"
			},
			file: {
				unit: "bajtů",
				verb: "mít"
			},
			array: {
				unit: "prvků",
				verb: "mít"
			},
			set: {
				unit: "prvků",
				verb: "mít"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "číslo";
				case "string": return "řetězec";
				case "boolean": return "boolean";
				case "bigint": return "bigint";
				case "function": return "funkce";
				case "symbol": return "symbol";
				case "undefined": return "undefined";
				case "object":
					if (Array.isArray(data)) return "pole";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "regulární výraz",
			email: "e-mailová adresa",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "datum a čas ve formátu ISO",
			date: "datum ve formátu ISO",
			time: "čas ve formátu ISO",
			duration: "doba trvání ISO",
			ipv4: "IPv4 adresa",
			ipv6: "IPv6 adresa",
			cidrv4: "rozsah IPv4",
			cidrv6: "rozsah IPv6",
			base64: "řetězec zakódovaný ve formátu base64",
			base64url: "řetězec zakódovaný ve formátu base64url",
			json_string: "řetězec ve formátu JSON",
			e164: "číslo E.164",
			jwt: "JWT",
			template_literal: "vstup"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Neplatný vstup: očekáváno ${issue.expected}, obdrženo ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Neplatný vstup: očekáváno ${util.stringifyPrimitive(issue.values[0])}`;
					return `Neplatná možnost: očekávána jedna z hodnot ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Hodnota je příliš velká: ${issue.origin ?? "hodnota"} musí mít ${adj}${issue.maximum.toString()} ${sizing.unit ?? "prvků"}`;
					return `Hodnota je příliš velká: ${issue.origin ?? "hodnota"} musí být ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Hodnota je příliš malá: ${issue.origin ?? "hodnota"} musí mít ${adj}${issue.minimum.toString()} ${sizing.unit ?? "prvků"}`;
					return `Hodnota je příliš malá: ${issue.origin ?? "hodnota"} musí být ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Neplatný řetězec: musí začínat na "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Neplatný řetězec: musí končit na "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Neplatný řetězec: musí obsahovat "${_issue.includes}"`;
					if (_issue.format === "regex") return `Neplatný řetězec: musí odpovídat vzoru ${_issue.pattern}`;
					return `Neplatný formát ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Neplatné číslo: musí být násobkem ${issue.divisor}`;
				case "unrecognized_keys": return `Neznámé klíče: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Neplatný klíč v ${issue.origin}`;
				case "invalid_union": return "Neplatný vstup";
				case "invalid_element": return `Neplatná hodnota v ${issue.origin}`;
				default: return `Neplatný vstup`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/da.cjs
var require_da = /* @__PURE__ */ __commonJSMin(((exports, module, this$71) => {
	var __createBinding = this$71 && this$71.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$71 && this$71.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$71 && this$71.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "tegn",
				verb: "havde"
			},
			file: {
				unit: "bytes",
				verb: "havde"
			},
			array: {
				unit: "elementer",
				verb: "indeholdt"
			},
			set: {
				unit: "elementer",
				verb: "indeholdt"
			}
		};
		const TypeNames = {
			string: "streng",
			number: "tal",
			boolean: "boolean",
			array: "liste",
			object: "objekt",
			set: "sæt",
			file: "fil"
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		function getTypeName(type) {
			return TypeNames[type] ?? type;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "tal";
				case "object":
					if (Array.isArray(data)) return "liste";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
					return "objekt";
			}
			return t;
		};
		const Nouns = {
			regex: "input",
			email: "e-mailadresse",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO dato- og klokkeslæt",
			date: "ISO-dato",
			time: "ISO-klokkeslæt",
			duration: "ISO-varighed",
			ipv4: "IPv4-område",
			ipv6: "IPv6-område",
			cidrv4: "IPv4-spektrum",
			cidrv6: "IPv6-spektrum",
			base64: "base64-kodet streng",
			base64url: "base64url-kodet streng",
			json_string: "JSON-streng",
			e164: "E.164-nummer",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Ugyldigt input: forventede ${getTypeName(issue.expected)}, fik ${getTypeName(parsedType(issue.input))}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Ugyldig værdi: forventede ${util.stringifyPrimitive(issue.values[0])}`;
					return `Ugyldigt valg: forventede en af følgende ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					const origin = getTypeName(issue.origin);
					if (sizing) return `For stor: forventede ${origin ?? "value"} ${sizing.verb} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
					return `For stor: forventede ${origin ?? "value"} havde ${adj} ${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					const origin = getTypeName(issue.origin);
					if (sizing) return `For lille: forventede ${origin} ${sizing.verb} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
					return `For lille: forventede ${origin} havde ${adj} ${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ugyldig streng: skal starte med "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Ugyldig streng: skal ende med "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Ugyldig streng: skal indeholde "${_issue.includes}"`;
					if (_issue.format === "regex") return `Ugyldig streng: skal matche mønsteret ${_issue.pattern}`;
					return `Ugyldig ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Ugyldigt tal: skal være deleligt med ${issue.divisor}`;
				case "unrecognized_keys": return `${issue.keys.length > 1 ? "Ukendte nøgler" : "Ukendt nøgle"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Ugyldig nøgle i ${issue.origin}`;
				case "invalid_union": return "Ugyldigt input: matcher ingen af de tilladte typer";
				case "invalid_element": return `Ugyldig værdi i ${issue.origin}`;
				default: return `Ugyldigt input`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/de.cjs
var require_de = /* @__PURE__ */ __commonJSMin(((exports, module, this$70) => {
	var __createBinding = this$70 && this$70.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$70 && this$70.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$70 && this$70.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "Zeichen",
				verb: "zu haben"
			},
			file: {
				unit: "Bytes",
				verb: "zu haben"
			},
			array: {
				unit: "Elemente",
				verb: "zu haben"
			},
			set: {
				unit: "Elemente",
				verb: "zu haben"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "Zahl";
				case "object":
					if (Array.isArray(data)) return "Array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "Eingabe",
			email: "E-Mail-Adresse",
			url: "URL",
			emoji: "Emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO-Datum und -Uhrzeit",
			date: "ISO-Datum",
			time: "ISO-Uhrzeit",
			duration: "ISO-Dauer",
			ipv4: "IPv4-Adresse",
			ipv6: "IPv6-Adresse",
			cidrv4: "IPv4-Bereich",
			cidrv6: "IPv6-Bereich",
			base64: "Base64-codierter String",
			base64url: "Base64-URL-codierter String",
			json_string: "JSON-String",
			e164: "E.164-Nummer",
			jwt: "JWT",
			template_literal: "Eingabe"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Ungültige Eingabe: erwartet ${issue.expected}, erhalten ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Ungültige Eingabe: erwartet ${util.stringifyPrimitive(issue.values[0])}`;
					return `Ungültige Option: erwartet eine von ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Zu groß: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "Elemente"} hat`;
					return `Zu groß: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ist`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} hat`;
					return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ist`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ungültiger String: muss mit "${_issue.prefix}" beginnen`;
					if (_issue.format === "ends_with") return `Ungültiger String: muss mit "${_issue.suffix}" enden`;
					if (_issue.format === "includes") return `Ungültiger String: muss "${_issue.includes}" enthalten`;
					if (_issue.format === "regex") return `Ungültiger String: muss dem Muster ${_issue.pattern} entsprechen`;
					return `Ungültig: ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Ungültige Zahl: muss ein Vielfaches von ${issue.divisor} sein`;
				case "unrecognized_keys": return `${issue.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Ungültiger Schlüssel in ${issue.origin}`;
				case "invalid_union": return "Ungültige Eingabe";
				case "invalid_element": return `Ungültiger Wert in ${issue.origin}`;
				default: return `Ungültige Eingabe`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/en.cjs
var require_en = /* @__PURE__ */ __commonJSMin(((exports, module, this$69) => {
	var __createBinding = this$69 && this$69.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$69 && this$69.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$69 && this$69.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parsedType = void 0;
	exports.default = default_1;
	var util = __importStar(require_util());
	var parsedType = (data) => {
		const t = typeof data;
		switch (t) {
			case "number": return Number.isNaN(data) ? "NaN" : "number";
			case "object":
				if (Array.isArray(data)) return "array";
				if (data === null) return "null";
				if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
		}
		return t;
	};
	exports.parsedType = parsedType;
	var error = () => {
		const Sizable = {
			string: {
				unit: "characters",
				verb: "to have"
			},
			file: {
				unit: "bytes",
				verb: "to have"
			},
			array: {
				unit: "items",
				verb: "to have"
			},
			set: {
				unit: "items",
				verb: "to have"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const Nouns = {
			regex: "input",
			email: "email address",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO datetime",
			date: "ISO date",
			time: "ISO time",
			duration: "ISO duration",
			ipv4: "IPv4 address",
			ipv6: "IPv6 address",
			cidrv4: "IPv4 range",
			cidrv6: "IPv6 range",
			base64: "base64-encoded string",
			base64url: "base64url-encoded string",
			json_string: "JSON string",
			e164: "E.164 number",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Invalid input: expected ${issue.expected}, received ${(0, exports.parsedType)(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Invalid input: expected ${util.stringifyPrimitive(issue.values[0])}`;
					return `Invalid option: expected one of ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
					return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
					if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
					return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Invalid number: must be a multiple of ${issue.divisor}`;
				case "unrecognized_keys": return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Invalid key in ${issue.origin}`;
				case "invalid_union": return "Invalid input";
				case "invalid_element": return `Invalid value in ${issue.origin}`;
				default: return `Invalid input`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/eo.cjs
var require_eo = /* @__PURE__ */ __commonJSMin(((exports, module, this$68) => {
	var __createBinding = this$68 && this$68.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$68 && this$68.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$68 && this$68.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parsedType = void 0;
	exports.default = default_1;
	var util = __importStar(require_util());
	var parsedType = (data) => {
		const t = typeof data;
		switch (t) {
			case "number": return Number.isNaN(data) ? "NaN" : "nombro";
			case "object":
				if (Array.isArray(data)) return "tabelo";
				if (data === null) return "senvalora";
				if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
		}
		return t;
	};
	exports.parsedType = parsedType;
	var error = () => {
		const Sizable = {
			string: {
				unit: "karaktrojn",
				verb: "havi"
			},
			file: {
				unit: "bajtojn",
				verb: "havi"
			},
			array: {
				unit: "elementojn",
				verb: "havi"
			},
			set: {
				unit: "elementojn",
				verb: "havi"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const Nouns = {
			regex: "enigo",
			email: "retadreso",
			url: "URL",
			emoji: "emoĝio",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO-datotempo",
			date: "ISO-dato",
			time: "ISO-tempo",
			duration: "ISO-daŭro",
			ipv4: "IPv4-adreso",
			ipv6: "IPv6-adreso",
			cidrv4: "IPv4-rango",
			cidrv6: "IPv6-rango",
			base64: "64-ume kodita karaktraro",
			base64url: "URL-64-ume kodita karaktraro",
			json_string: "JSON-karaktraro",
			e164: "E.164-nombro",
			jwt: "JWT",
			template_literal: "enigo"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Nevalida enigo: atendiĝis ${issue.expected}, riceviĝis ${(0, exports.parsedType)(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Nevalida enigo: atendiĝis ${util.stringifyPrimitive(issue.values[0])}`;
					return `Nevalida opcio: atendiĝis unu el ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Tro granda: atendiĝis ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementojn"}`;
					return `Tro granda: atendiĝis ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Tro malgranda: atendiĝis ke ${issue.origin} havu ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Tro malgranda: atendiĝis ke ${issue.origin} estu ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Nevalida karaktraro: devas komenciĝi per "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Nevalida karaktraro: devas finiĝi per "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Nevalida karaktraro: devas inkluzivi "${_issue.includes}"`;
					if (_issue.format === "regex") return `Nevalida karaktraro: devas kongrui kun la modelo ${_issue.pattern}`;
					return `Nevalida ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Nevalida nombro: devas esti oblo de ${issue.divisor}`;
				case "unrecognized_keys": return `Nekonata${issue.keys.length > 1 ? "j" : ""} ŝlosilo${issue.keys.length > 1 ? "j" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Nevalida ŝlosilo en ${issue.origin}`;
				case "invalid_union": return "Nevalida enigo";
				case "invalid_element": return `Nevalida valoro en ${issue.origin}`;
				default: return `Nevalida enigo`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/es.cjs
var require_es$1 = /* @__PURE__ */ __commonJSMin(((exports, module, this$67) => {
	var __createBinding = this$67 && this$67.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$67 && this$67.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$67 && this$67.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "caracteres",
				verb: "tener"
			},
			file: {
				unit: "bytes",
				verb: "tener"
			},
			array: {
				unit: "elementos",
				verb: "tener"
			},
			set: {
				unit: "elementos",
				verb: "tener"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "número";
				case "object":
					if (Array.isArray(data)) return "arreglo";
					if (data === null) return "nulo";
					if (Object.getPrototypeOf(data) !== Object.prototype) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "entrada",
			email: "dirección de correo electrónico",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "fecha y hora ISO",
			date: "fecha ISO",
			time: "hora ISO",
			duration: "duración ISO",
			ipv4: "dirección IPv4",
			ipv6: "dirección IPv6",
			cidrv4: "rango IPv4",
			cidrv6: "rango IPv6",
			base64: "cadena codificada en base64",
			base64url: "URL codificada en base64",
			json_string: "cadena JSON",
			e164: "número E.164",
			jwt: "JWT",
			template_literal: "entrada"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Entrada inválida: se esperaba ${issue.expected}, recibido ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Entrada inválida: se esperaba ${util.stringifyPrimitive(issue.values[0])}`;
					return `Opción inválida: se esperaba una de ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Demasiado grande: se esperaba que ${issue.origin ?? "valor"} tuviera ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
					return `Demasiado grande: se esperaba que ${issue.origin ?? "valor"} fuera ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Demasiado pequeño: se esperaba que ${issue.origin} tuviera ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Demasiado pequeño: se esperaba que ${issue.origin} fuera ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Cadena inválida: debe comenzar con "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Cadena inválida: debe terminar en "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Cadena inválida: debe incluir "${_issue.includes}"`;
					if (_issue.format === "regex") return `Cadena inválida: debe coincidir con el patrón ${_issue.pattern}`;
					return `Inválido ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Número inválido: debe ser múltiplo de ${issue.divisor}`;
				case "unrecognized_keys": return `Llave${issue.keys.length > 1 ? "s" : ""} desconocida${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Llave inválida en ${issue.origin}`;
				case "invalid_union": return "Entrada inválida";
				case "invalid_element": return `Valor inválido en ${issue.origin}`;
				default: return `Entrada inválida`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/fa.cjs
var require_fa = /* @__PURE__ */ __commonJSMin(((exports, module, this$66) => {
	var __createBinding = this$66 && this$66.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$66 && this$66.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$66 && this$66.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "کاراکتر",
				verb: "داشته باشد"
			},
			file: {
				unit: "بایت",
				verb: "داشته باشد"
			},
			array: {
				unit: "آیتم",
				verb: "داشته باشد"
			},
			set: {
				unit: "آیتم",
				verb: "داشته باشد"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "عدد";
				case "object":
					if (Array.isArray(data)) return "آرایه";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ورودی",
			email: "آدرس ایمیل",
			url: "URL",
			emoji: "ایموجی",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "تاریخ و زمان ایزو",
			date: "تاریخ ایزو",
			time: "زمان ایزو",
			duration: "مدت زمان ایزو",
			ipv4: "IPv4 آدرس",
			ipv6: "IPv6 آدرس",
			cidrv4: "IPv4 دامنه",
			cidrv6: "IPv6 دامنه",
			base64: "base64-encoded رشته",
			base64url: "base64url-encoded رشته",
			json_string: "JSON رشته",
			e164: "E.164 عدد",
			jwt: "JWT",
			template_literal: "ورودی"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `ورودی نامعتبر: می‌بایست ${issue.expected} می‌بود، ${parsedType(issue.input)} دریافت شد`;
				case "invalid_value":
					if (issue.values.length === 1) return `ورودی نامعتبر: می‌بایست ${util.stringifyPrimitive(issue.values[0])} می‌بود`;
					return `گزینه نامعتبر: می‌بایست یکی از ${util.joinValues(issue.values, "|")} می‌بود`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `خیلی بزرگ: ${issue.origin ?? "مقدار"} باید ${adj}${issue.maximum.toString()} ${sizing.unit ?? "عنصر"} باشد`;
					return `خیلی بزرگ: ${issue.origin ?? "مقدار"} باید ${adj}${issue.maximum.toString()} باشد`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `خیلی کوچک: ${issue.origin} باید ${adj}${issue.minimum.toString()} ${sizing.unit} باشد`;
					return `خیلی کوچک: ${issue.origin} باید ${adj}${issue.minimum.toString()} باشد`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `رشته نامعتبر: باید با "${_issue.prefix}" شروع شود`;
					if (_issue.format === "ends_with") return `رشته نامعتبر: باید با "${_issue.suffix}" تمام شود`;
					if (_issue.format === "includes") return `رشته نامعتبر: باید شامل "${_issue.includes}" باشد`;
					if (_issue.format === "regex") return `رشته نامعتبر: باید با الگوی ${_issue.pattern} مطابقت داشته باشد`;
					return `${Nouns[_issue.format] ?? issue.format} نامعتبر`;
				}
				case "not_multiple_of": return `عدد نامعتبر: باید مضرب ${issue.divisor} باشد`;
				case "unrecognized_keys": return `کلید${issue.keys.length > 1 ? "های" : ""} ناشناس: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `کلید ناشناس در ${issue.origin}`;
				case "invalid_union": return `ورودی نامعتبر`;
				case "invalid_element": return `مقدار نامعتبر در ${issue.origin}`;
				default: return `ورودی نامعتبر`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/fi.cjs
var require_fi = /* @__PURE__ */ __commonJSMin(((exports, module, this$65) => {
	var __createBinding = this$65 && this$65.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$65 && this$65.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$65 && this$65.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "merkkiä",
				subject: "merkkijonon"
			},
			file: {
				unit: "tavua",
				subject: "tiedoston"
			},
			array: {
				unit: "alkiota",
				subject: "listan"
			},
			set: {
				unit: "alkiota",
				subject: "joukon"
			},
			number: {
				unit: "",
				subject: "luvun"
			},
			bigint: {
				unit: "",
				subject: "suuren kokonaisluvun"
			},
			int: {
				unit: "",
				subject: "kokonaisluvun"
			},
			date: {
				unit: "",
				subject: "päivämäärän"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "säännöllinen lauseke",
			email: "sähköpostiosoite",
			url: "URL-osoite",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO-aikaleima",
			date: "ISO-päivämäärä",
			time: "ISO-aika",
			duration: "ISO-kesto",
			ipv4: "IPv4-osoite",
			ipv6: "IPv6-osoite",
			cidrv4: "IPv4-alue",
			cidrv6: "IPv6-alue",
			base64: "base64-koodattu merkkijono",
			base64url: "base64url-koodattu merkkijono",
			json_string: "JSON-merkkijono",
			e164: "E.164-luku",
			jwt: "JWT",
			template_literal: "templaattimerkkijono"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Virheellinen tyyppi: odotettiin ${issue.expected}, oli ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Virheellinen syöte: täytyy olla ${util.stringifyPrimitive(issue.values[0])}`;
					return `Virheellinen valinta: täytyy olla yksi seuraavista: ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Liian suuri: ${sizing.subject} täytyy olla ${adj}${issue.maximum.toString()} ${sizing.unit}`.trim();
					return `Liian suuri: arvon täytyy olla ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Liian pieni: ${sizing.subject} täytyy olla ${adj}${issue.minimum.toString()} ${sizing.unit}`.trim();
					return `Liian pieni: arvon täytyy olla ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Virheellinen syöte: täytyy alkaa "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Virheellinen syöte: täytyy loppua "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Virheellinen syöte: täytyy sisältää "${_issue.includes}"`;
					if (_issue.format === "regex") return `Virheellinen syöte: täytyy vastata säännöllistä lauseketta ${_issue.pattern}`;
					return `Virheellinen ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Virheellinen luku: täytyy olla luvun ${issue.divisor} monikerta`;
				case "unrecognized_keys": return `${issue.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return "Virheellinen avain tietueessa";
				case "invalid_union": return "Virheellinen unioni";
				case "invalid_element": return "Virheellinen arvo joukossa";
				default: return `Virheellinen syöte`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/fr.cjs
var require_fr = /* @__PURE__ */ __commonJSMin(((exports, module, this$64) => {
	var __createBinding = this$64 && this$64.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$64 && this$64.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$64 && this$64.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "caractères",
				verb: "avoir"
			},
			file: {
				unit: "octets",
				verb: "avoir"
			},
			array: {
				unit: "éléments",
				verb: "avoir"
			},
			set: {
				unit: "éléments",
				verb: "avoir"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "nombre";
				case "object":
					if (Array.isArray(data)) return "tableau";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "entrée",
			email: "adresse e-mail",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "date et heure ISO",
			date: "date ISO",
			time: "heure ISO",
			duration: "durée ISO",
			ipv4: "adresse IPv4",
			ipv6: "adresse IPv6",
			cidrv4: "plage IPv4",
			cidrv6: "plage IPv6",
			base64: "chaîne encodée en base64",
			base64url: "chaîne encodée en base64url",
			json_string: "chaîne JSON",
			e164: "numéro E.164",
			jwt: "JWT",
			template_literal: "entrée"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Entrée invalide : ${issue.expected} attendu, ${parsedType(issue.input)} reçu`;
				case "invalid_value":
					if (issue.values.length === 1) return `Entrée invalide : ${util.stringifyPrimitive(issue.values[0])} attendu`;
					return `Option invalide : une valeur parmi ${util.joinValues(issue.values, "|")} attendue`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Trop grand : ${issue.origin ?? "valeur"} doit ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "élément(s)"}`;
					return `Trop grand : ${issue.origin ?? "valeur"} doit être ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Trop petit : ${issue.origin} doit ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Trop petit : ${issue.origin} doit être ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Chaîne invalide : doit commencer par "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Chaîne invalide : doit se terminer par "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Chaîne invalide : doit inclure "${_issue.includes}"`;
					if (_issue.format === "regex") return `Chaîne invalide : doit correspondre au modèle ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} invalide`;
				}
				case "not_multiple_of": return `Nombre invalide : doit être un multiple de ${issue.divisor}`;
				case "unrecognized_keys": return `Clé${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Clé invalide dans ${issue.origin}`;
				case "invalid_union": return "Entrée invalide";
				case "invalid_element": return `Valeur invalide dans ${issue.origin}`;
				default: return `Entrée invalide`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/fr-CA.cjs
var require_fr_CA = /* @__PURE__ */ __commonJSMin(((exports, module, this$63) => {
	var __createBinding = this$63 && this$63.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$63 && this$63.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$63 && this$63.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "caractères",
				verb: "avoir"
			},
			file: {
				unit: "octets",
				verb: "avoir"
			},
			array: {
				unit: "éléments",
				verb: "avoir"
			},
			set: {
				unit: "éléments",
				verb: "avoir"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "entrée",
			email: "adresse courriel",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "date-heure ISO",
			date: "date ISO",
			time: "heure ISO",
			duration: "durée ISO",
			ipv4: "adresse IPv4",
			ipv6: "adresse IPv6",
			cidrv4: "plage IPv4",
			cidrv6: "plage IPv6",
			base64: "chaîne encodée en base64",
			base64url: "chaîne encodée en base64url",
			json_string: "chaîne JSON",
			e164: "numéro E.164",
			jwt: "JWT",
			template_literal: "entrée"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Entrée invalide : attendu ${issue.expected}, reçu ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Entrée invalide : attendu ${util.stringifyPrimitive(issue.values[0])}`;
					return `Option invalide : attendu l'une des valeurs suivantes ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "≤" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Trop grand : attendu que ${issue.origin ?? "la valeur"} ait ${adj}${issue.maximum.toString()} ${sizing.unit}`;
					return `Trop grand : attendu que ${issue.origin ?? "la valeur"} soit ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? "≥" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Trop petit : attendu que ${issue.origin} ait ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Trop petit : attendu que ${issue.origin} soit ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Chaîne invalide : doit commencer par "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Chaîne invalide : doit se terminer par "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Chaîne invalide : doit inclure "${_issue.includes}"`;
					if (_issue.format === "regex") return `Chaîne invalide : doit correspondre au motif ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} invalide`;
				}
				case "not_multiple_of": return `Nombre invalide : doit être un multiple de ${issue.divisor}`;
				case "unrecognized_keys": return `Clé${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Clé invalide dans ${issue.origin}`;
				case "invalid_union": return "Entrée invalide";
				case "invalid_element": return `Valeur invalide dans ${issue.origin}`;
				default: return `Entrée invalide`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/he.cjs
var require_he = /* @__PURE__ */ __commonJSMin(((exports, module, this$62) => {
	var __createBinding = this$62 && this$62.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$62 && this$62.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$62 && this$62.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "אותיות",
				verb: "לכלול"
			},
			file: {
				unit: "בייטים",
				verb: "לכלול"
			},
			array: {
				unit: "פריטים",
				verb: "לכלול"
			},
			set: {
				unit: "פריטים",
				verb: "לכלול"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "קלט",
			email: "כתובת אימייל",
			url: "כתובת רשת",
			emoji: "אימוג'י",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "תאריך וזמן ISO",
			date: "תאריך ISO",
			time: "זמן ISO",
			duration: "משך זמן ISO",
			ipv4: "כתובת IPv4",
			ipv6: "כתובת IPv6",
			cidrv4: "טווח IPv4",
			cidrv6: "טווח IPv6",
			base64: "מחרוזת בבסיס 64",
			base64url: "מחרוזת בבסיס 64 לכתובות רשת",
			json_string: "מחרוזת JSON",
			e164: "מספר E.164",
			jwt: "JWT",
			template_literal: "קלט"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `קלט לא תקין: צריך ${issue.expected}, התקבל ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `קלט לא תקין: צריך ${util.stringifyPrimitive(issue.values[0])}`;
					return `קלט לא תקין: צריך אחת מהאפשרויות  ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `גדול מדי: ${issue.origin ?? "value"} צריך להיות ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
					return `גדול מדי: ${issue.origin ?? "value"} צריך להיות ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `קטן מדי: ${issue.origin} צריך להיות ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `קטן מדי: ${issue.origin} צריך להיות ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `מחרוזת לא תקינה: חייבת להתחיל ב"${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `מחרוזת לא תקינה: חייבת להסתיים ב "${_issue.suffix}"`;
					if (_issue.format === "includes") return `מחרוזת לא תקינה: חייבת לכלול "${_issue.includes}"`;
					if (_issue.format === "regex") return `מחרוזת לא תקינה: חייבת להתאים לתבנית ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} לא תקין`;
				}
				case "not_multiple_of": return `מספר לא תקין: חייב להיות מכפלה של ${issue.divisor}`;
				case "unrecognized_keys": return `מפתח${issue.keys.length > 1 ? "ות" : ""} לא מזוה${issue.keys.length > 1 ? "ים" : "ה"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `מפתח לא תקין ב${issue.origin}`;
				case "invalid_union": return "קלט לא תקין";
				case "invalid_element": return `ערך לא תקין ב${issue.origin}`;
				default: return `קלט לא תקין`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/hu.cjs
var require_hu = /* @__PURE__ */ __commonJSMin(((exports, module, this$61) => {
	var __createBinding = this$61 && this$61.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$61 && this$61.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$61 && this$61.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "karakter",
				verb: "legyen"
			},
			file: {
				unit: "byte",
				verb: "legyen"
			},
			array: {
				unit: "elem",
				verb: "legyen"
			},
			set: {
				unit: "elem",
				verb: "legyen"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "szám";
				case "object":
					if (Array.isArray(data)) return "tömb";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "bemenet",
			email: "email cím",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO időbélyeg",
			date: "ISO dátum",
			time: "ISO idő",
			duration: "ISO időintervallum",
			ipv4: "IPv4 cím",
			ipv6: "IPv6 cím",
			cidrv4: "IPv4 tartomány",
			cidrv6: "IPv6 tartomány",
			base64: "base64-kódolt string",
			base64url: "base64url-kódolt string",
			json_string: "JSON string",
			e164: "E.164 szám",
			jwt: "JWT",
			template_literal: "bemenet"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Érvénytelen bemenet: a várt érték ${issue.expected}, a kapott érték ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Érvénytelen bemenet: a várt érték ${util.stringifyPrimitive(issue.values[0])}`;
					return `Érvénytelen opció: valamelyik érték várt ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Túl nagy: ${issue.origin ?? "érték"} mérete túl nagy ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elem"}`;
					return `Túl nagy: a bemeneti érték ${issue.origin ?? "érték"} túl nagy: ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Túl kicsi: a bemeneti érték ${issue.origin} mérete túl kicsi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Túl kicsi: a bemeneti érték ${issue.origin} túl kicsi ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Érvénytelen string: "${_issue.prefix}" értékkel kell kezdődnie`;
					if (_issue.format === "ends_with") return `Érvénytelen string: "${_issue.suffix}" értékkel kell végződnie`;
					if (_issue.format === "includes") return `Érvénytelen string: "${_issue.includes}" értéket kell tartalmaznia`;
					if (_issue.format === "regex") return `Érvénytelen string: ${_issue.pattern} mintának kell megfelelnie`;
					return `Érvénytelen ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Érvénytelen szám: ${issue.divisor} többszörösének kell lennie`;
				case "unrecognized_keys": return `Ismeretlen kulcs${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Érvénytelen kulcs ${issue.origin}`;
				case "invalid_union": return "Érvénytelen bemenet";
				case "invalid_element": return `Érvénytelen érték: ${issue.origin}`;
				default: return `Érvénytelen bemenet`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/id.cjs
var require_id = /* @__PURE__ */ __commonJSMin(((exports, module, this$60) => {
	var __createBinding = this$60 && this$60.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$60 && this$60.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$60 && this$60.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "karakter",
				verb: "memiliki"
			},
			file: {
				unit: "byte",
				verb: "memiliki"
			},
			array: {
				unit: "item",
				verb: "memiliki"
			},
			set: {
				unit: "item",
				verb: "memiliki"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "input",
			email: "alamat email",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "tanggal dan waktu format ISO",
			date: "tanggal format ISO",
			time: "jam format ISO",
			duration: "durasi format ISO",
			ipv4: "alamat IPv4",
			ipv6: "alamat IPv6",
			cidrv4: "rentang alamat IPv4",
			cidrv6: "rentang alamat IPv6",
			base64: "string dengan enkode base64",
			base64url: "string dengan enkode base64url",
			json_string: "string JSON",
			e164: "angka E.164",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Input tidak valid: diharapkan ${issue.expected}, diterima ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Input tidak valid: diharapkan ${util.stringifyPrimitive(issue.values[0])}`;
					return `Pilihan tidak valid: diharapkan salah satu dari ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Terlalu besar: diharapkan ${issue.origin ?? "value"} memiliki ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
					return `Terlalu besar: diharapkan ${issue.origin ?? "value"} menjadi ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Terlalu kecil: diharapkan ${issue.origin} memiliki ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Terlalu kecil: diharapkan ${issue.origin} menjadi ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `String tidak valid: harus dimulai dengan "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `String tidak valid: harus berakhir dengan "${_issue.suffix}"`;
					if (_issue.format === "includes") return `String tidak valid: harus menyertakan "${_issue.includes}"`;
					if (_issue.format === "regex") return `String tidak valid: harus sesuai pola ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} tidak valid`;
				}
				case "not_multiple_of": return `Angka tidak valid: harus kelipatan dari ${issue.divisor}`;
				case "unrecognized_keys": return `Kunci tidak dikenali ${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Kunci tidak valid di ${issue.origin}`;
				case "invalid_union": return "Input tidak valid";
				case "invalid_element": return `Nilai tidak valid di ${issue.origin}`;
				default: return `Input tidak valid`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/is.cjs
var require_is = /* @__PURE__ */ __commonJSMin(((exports, module, this$59) => {
	var __createBinding = this$59 && this$59.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$59 && this$59.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$59 && this$59.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parsedType = void 0;
	exports.default = default_1;
	var util = __importStar(require_util());
	var parsedType = (data) => {
		const t = typeof data;
		switch (t) {
			case "number": return Number.isNaN(data) ? "NaN" : "númer";
			case "object":
				if (Array.isArray(data)) return "fylki";
				if (data === null) return "null";
				if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
		}
		return t;
	};
	exports.parsedType = parsedType;
	var error = () => {
		const Sizable = {
			string: {
				unit: "stafi",
				verb: "að hafa"
			},
			file: {
				unit: "bæti",
				verb: "að hafa"
			},
			array: {
				unit: "hluti",
				verb: "að hafa"
			},
			set: {
				unit: "hluti",
				verb: "að hafa"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const Nouns = {
			regex: "gildi",
			email: "netfang",
			url: "vefslóð",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO dagsetning og tími",
			date: "ISO dagsetning",
			time: "ISO tími",
			duration: "ISO tímalengd",
			ipv4: "IPv4 address",
			ipv6: "IPv6 address",
			cidrv4: "IPv4 range",
			cidrv6: "IPv6 range",
			base64: "base64-encoded strengur",
			base64url: "base64url-encoded strengur",
			json_string: "JSON strengur",
			e164: "E.164 tölugildi",
			jwt: "JWT",
			template_literal: "gildi"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Rangt gildi: Þú slóst inn ${(0, exports.parsedType)(issue.input)} þar sem á að vera ${issue.expected}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Rangt gildi: gert ráð fyrir ${util.stringifyPrimitive(issue.values[0])}`;
					return `Ógilt val: má vera eitt af eftirfarandi ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Of stórt: gert er ráð fyrir að ${issue.origin ?? "gildi"} hafi ${adj}${issue.maximum.toString()} ${sizing.unit ?? "hluti"}`;
					return `Of stórt: gert er ráð fyrir að ${issue.origin ?? "gildi"} sé ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Of lítið: gert er ráð fyrir að ${issue.origin} hafi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Of lítið: gert er ráð fyrir að ${issue.origin} sé ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ógildur strengur: verður að byrja á "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Ógildur strengur: verður að enda á "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Ógildur strengur: verður að innihalda "${_issue.includes}"`;
					if (_issue.format === "regex") return `Ógildur strengur: verður að fylgja mynstri ${_issue.pattern}`;
					return `Rangt ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Röng tala: verður að vera margfeldi af ${issue.divisor}`;
				case "unrecognized_keys": return `Óþekkt ${issue.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Rangur lykill í ${issue.origin}`;
				case "invalid_union": return "Rangt gildi";
				case "invalid_element": return `Rangt gildi í ${issue.origin}`;
				default: return `Rangt gildi`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/it.cjs
var require_it = /* @__PURE__ */ __commonJSMin(((exports, module, this$58) => {
	var __createBinding = this$58 && this$58.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$58 && this$58.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$58 && this$58.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "caratteri",
				verb: "avere"
			},
			file: {
				unit: "byte",
				verb: "avere"
			},
			array: {
				unit: "elementi",
				verb: "avere"
			},
			set: {
				unit: "elementi",
				verb: "avere"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "numero";
				case "object":
					if (Array.isArray(data)) return "vettore";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "input",
			email: "indirizzo email",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "data e ora ISO",
			date: "data ISO",
			time: "ora ISO",
			duration: "durata ISO",
			ipv4: "indirizzo IPv4",
			ipv6: "indirizzo IPv6",
			cidrv4: "intervallo IPv4",
			cidrv6: "intervallo IPv6",
			base64: "stringa codificata in base64",
			base64url: "URL codificata in base64",
			json_string: "stringa JSON",
			e164: "numero E.164",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Input non valido: atteso ${issue.expected}, ricevuto ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Input non valido: atteso ${util.stringifyPrimitive(issue.values[0])}`;
					return `Opzione non valida: atteso uno tra ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Troppo grande: ${issue.origin ?? "valore"} deve avere ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementi"}`;
					return `Troppo grande: ${issue.origin ?? "valore"} deve essere ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Troppo piccolo: ${issue.origin} deve avere ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Troppo piccolo: ${issue.origin} deve essere ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Stringa non valida: deve iniziare con "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Stringa non valida: deve terminare con "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Stringa non valida: deve includere "${_issue.includes}"`;
					if (_issue.format === "regex") return `Stringa non valida: deve corrispondere al pattern ${_issue.pattern}`;
					return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Numero non valido: deve essere un multiplo di ${issue.divisor}`;
				case "unrecognized_keys": return `Chiav${issue.keys.length > 1 ? "i" : "e"} non riconosciut${issue.keys.length > 1 ? "e" : "a"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Chiave non valida in ${issue.origin}`;
				case "invalid_union": return "Input non valido";
				case "invalid_element": return `Valore non valido in ${issue.origin}`;
				default: return `Input non valido`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ja.cjs
var require_ja = /* @__PURE__ */ __commonJSMin(((exports, module, this$57) => {
	var __createBinding = this$57 && this$57.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$57 && this$57.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$57 && this$57.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "文字",
				verb: "である"
			},
			file: {
				unit: "バイト",
				verb: "である"
			},
			array: {
				unit: "要素",
				verb: "である"
			},
			set: {
				unit: "要素",
				verb: "である"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "数値";
				case "object":
					if (Array.isArray(data)) return "配列";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "入力値",
			email: "メールアドレス",
			url: "URL",
			emoji: "絵文字",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO日時",
			date: "ISO日付",
			time: "ISO時刻",
			duration: "ISO期間",
			ipv4: "IPv4アドレス",
			ipv6: "IPv6アドレス",
			cidrv4: "IPv4範囲",
			cidrv6: "IPv6範囲",
			base64: "base64エンコード文字列",
			base64url: "base64urlエンコード文字列",
			json_string: "JSON文字列",
			e164: "E.164番号",
			jwt: "JWT",
			template_literal: "入力値"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `無効な入力: ${issue.expected}が期待されましたが、${parsedType(issue.input)}が入力されました`;
				case "invalid_value":
					if (issue.values.length === 1) return `無効な入力: ${util.stringifyPrimitive(issue.values[0])}が期待されました`;
					return `無効な選択: ${util.joinValues(issue.values, "、")}のいずれかである必要があります`;
				case "too_big": {
					const adj = issue.inclusive ? "以下である" : "より小さい";
					const sizing = getSizing(issue.origin);
					if (sizing) return `大きすぎる値: ${issue.origin ?? "値"}は${issue.maximum.toString()}${sizing.unit ?? "要素"}${adj}必要があります`;
					return `大きすぎる値: ${issue.origin ?? "値"}は${issue.maximum.toString()}${adj}必要があります`;
				}
				case "too_small": {
					const adj = issue.inclusive ? "以上である" : "より大きい";
					const sizing = getSizing(issue.origin);
					if (sizing) return `小さすぎる値: ${issue.origin}は${issue.minimum.toString()}${sizing.unit}${adj}必要があります`;
					return `小さすぎる値: ${issue.origin}は${issue.minimum.toString()}${adj}必要があります`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `無効な文字列: "${_issue.prefix}"で始まる必要があります`;
					if (_issue.format === "ends_with") return `無効な文字列: "${_issue.suffix}"で終わる必要があります`;
					if (_issue.format === "includes") return `無効な文字列: "${_issue.includes}"を含む必要があります`;
					if (_issue.format === "regex") return `無効な文字列: パターン${_issue.pattern}に一致する必要があります`;
					return `無効な${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `無効な数値: ${issue.divisor}の倍数である必要があります`;
				case "unrecognized_keys": return `認識されていないキー${issue.keys.length > 1 ? "群" : ""}: ${util.joinValues(issue.keys, "、")}`;
				case "invalid_key": return `${issue.origin}内の無効なキー`;
				case "invalid_union": return "無効な入力";
				case "invalid_element": return `${issue.origin}内の無効な値`;
				default: return `無効な入力`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/kh.cjs
var require_kh = /* @__PURE__ */ __commonJSMin(((exports, module, this$56) => {
	var __createBinding = this$56 && this$56.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$56 && this$56.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$56 && this$56.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "តួអក្សរ",
				verb: "គួរមាន"
			},
			file: {
				unit: "បៃ",
				verb: "គួរមាន"
			},
			array: {
				unit: "ធាតុ",
				verb: "គួរមាន"
			},
			set: {
				unit: "ធាតុ",
				verb: "គួរមាន"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "មិនមែនជាលេខ (NaN)" : "លេខ";
				case "object":
					if (Array.isArray(data)) return "អារេ (Array)";
					if (data === null) return "គ្មានតម្លៃ (null)";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ទិន្នន័យបញ្ចូល",
			email: "អាសយដ្ឋានអ៊ីមែល",
			url: "URL",
			emoji: "សញ្ញាអារម្មណ៍",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
			date: "កាលបរិច្ឆេទ ISO",
			time: "ម៉ោង ISO",
			duration: "រយៈពេល ISO",
			ipv4: "អាសយដ្ឋាន IPv4",
			ipv6: "អាសយដ្ឋាន IPv6",
			cidrv4: "ដែនអាសយដ្ឋាន IPv4",
			cidrv6: "ដែនអាសយដ្ឋាន IPv6",
			base64: "ខ្សែអក្សរអ៊ិកូដ base64",
			base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
			json_string: "ខ្សែអក្សរ JSON",
			e164: "លេខ E.164",
			jwt: "JWT",
			template_literal: "ទិន្នន័យបញ្ចូល"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${issue.expected} ប៉ុន្តែទទួលបាន ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${util.stringifyPrimitive(issue.values[0])}`;
					return `ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `ធំពេក៖ ត្រូវការ ${issue.origin ?? "តម្លៃ"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "ធាតុ"}`;
					return `ធំពេក៖ ត្រូវការ ${issue.origin ?? "តម្លៃ"} ${adj} ${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `តូចពេក៖ ត្រូវការ ${issue.origin} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
					return `តូចពេក៖ ត្រូវការ ${issue.origin} ${adj} ${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "${_issue.suffix}"`;
					if (_issue.format === "includes") return `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "${_issue.includes}"`;
					if (_issue.format === "regex") return `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ${_issue.pattern}`;
					return `មិនត្រឹមត្រូវ៖ ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ${issue.divisor}`;
				case "unrecognized_keys": return `រកឃើញសោមិនស្គាល់៖ ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `សោមិនត្រឹមត្រូវនៅក្នុង ${issue.origin}`;
				case "invalid_union": return `ទិន្នន័យមិនត្រឹមត្រូវ`;
				case "invalid_element": return `ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ${issue.origin}`;
				default: return `ទិន្នន័យមិនត្រឹមត្រូវ`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ko.cjs
var require_ko = /* @__PURE__ */ __commonJSMin(((exports, module, this$55) => {
	var __createBinding = this$55 && this$55.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$55 && this$55.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$55 && this$55.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "문자",
				verb: "to have"
			},
			file: {
				unit: "바이트",
				verb: "to have"
			},
			array: {
				unit: "개",
				verb: "to have"
			},
			set: {
				unit: "개",
				verb: "to have"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "입력",
			email: "이메일 주소",
			url: "URL",
			emoji: "이모지",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO 날짜시간",
			date: "ISO 날짜",
			time: "ISO 시간",
			duration: "ISO 기간",
			ipv4: "IPv4 주소",
			ipv6: "IPv6 주소",
			cidrv4: "IPv4 범위",
			cidrv6: "IPv6 범위",
			base64: "base64 인코딩 문자열",
			base64url: "base64url 인코딩 문자열",
			json_string: "JSON 문자열",
			e164: "E.164 번호",
			jwt: "JWT",
			template_literal: "입력"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `잘못된 입력: 예상 타입은 ${issue.expected}, 받은 타입은 ${parsedType(issue.input)}입니다`;
				case "invalid_value":
					if (issue.values.length === 1) return `잘못된 입력: 값은 ${util.stringifyPrimitive(issue.values[0])} 이어야 합니다`;
					return `잘못된 옵션: ${util.joinValues(issue.values, "또는 ")} 중 하나여야 합니다`;
				case "too_big": {
					const adj = issue.inclusive ? "이하" : "미만";
					const suffix = adj === "미만" ? "이어야 합니다" : "여야 합니다";
					const sizing = getSizing(issue.origin);
					const unit = sizing?.unit ?? "요소";
					if (sizing) return `${issue.origin ?? "값"}이 너무 큽니다: ${issue.maximum.toString()}${unit} ${adj}${suffix}`;
					return `${issue.origin ?? "값"}이 너무 큽니다: ${issue.maximum.toString()} ${adj}${suffix}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? "이상" : "초과";
					const suffix = adj === "이상" ? "이어야 합니다" : "여야 합니다";
					const sizing = getSizing(issue.origin);
					const unit = sizing?.unit ?? "요소";
					if (sizing) return `${issue.origin ?? "값"}이 너무 작습니다: ${issue.minimum.toString()}${unit} ${adj}${suffix}`;
					return `${issue.origin ?? "값"}이 너무 작습니다: ${issue.minimum.toString()} ${adj}${suffix}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `잘못된 문자열: "${_issue.prefix}"(으)로 시작해야 합니다`;
					if (_issue.format === "ends_with") return `잘못된 문자열: "${_issue.suffix}"(으)로 끝나야 합니다`;
					if (_issue.format === "includes") return `잘못된 문자열: "${_issue.includes}"을(를) 포함해야 합니다`;
					if (_issue.format === "regex") return `잘못된 문자열: 정규식 ${_issue.pattern} 패턴과 일치해야 합니다`;
					return `잘못된 ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `잘못된 숫자: ${issue.divisor}의 배수여야 합니다`;
				case "unrecognized_keys": return `인식할 수 없는 키: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `잘못된 키: ${issue.origin}`;
				case "invalid_union": return `잘못된 입력`;
				case "invalid_element": return `잘못된 값: ${issue.origin}`;
				default: return `잘못된 입력`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/mk.cjs
var require_mk = /* @__PURE__ */ __commonJSMin(((exports, module, this$54) => {
	var __createBinding = this$54 && this$54.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$54 && this$54.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$54 && this$54.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "знаци",
				verb: "да имаат"
			},
			file: {
				unit: "бајти",
				verb: "да имаат"
			},
			array: {
				unit: "ставки",
				verb: "да имаат"
			},
			set: {
				unit: "ставки",
				verb: "да имаат"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "број";
				case "object":
					if (Array.isArray(data)) return "низа";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "внес",
			email: "адреса на е-пошта",
			url: "URL",
			emoji: "емоџи",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO датум и време",
			date: "ISO датум",
			time: "ISO време",
			duration: "ISO времетраење",
			ipv4: "IPv4 адреса",
			ipv6: "IPv6 адреса",
			cidrv4: "IPv4 опсег",
			cidrv6: "IPv6 опсег",
			base64: "base64-енкодирана низа",
			base64url: "base64url-енкодирана низа",
			json_string: "JSON низа",
			e164: "E.164 број",
			jwt: "JWT",
			template_literal: "внес"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Грешен внес: се очекува ${issue.expected}, примено ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Invalid input: expected ${util.stringifyPrimitive(issue.values[0])}`;
					return `Грешана опција: се очекува една ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Премногу голем: се очекува ${issue.origin ?? "вредноста"} да има ${adj}${issue.maximum.toString()} ${sizing.unit ?? "елементи"}`;
					return `Премногу голем: се очекува ${issue.origin ?? "вредноста"} да биде ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Премногу мал: се очекува ${issue.origin} да има ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Премногу мал: се очекува ${issue.origin} да биде ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Неважечка низа: мора да започнува со "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Неважечка низа: мора да завршува со "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Неважечка низа: мора да вклучува "${_issue.includes}"`;
					if (_issue.format === "regex") return `Неважечка низа: мора да одгоара на патернот ${_issue.pattern}`;
					return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Грешен број: мора да биде делив со ${issue.divisor}`;
				case "unrecognized_keys": return `${issue.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Грешен клуч во ${issue.origin}`;
				case "invalid_union": return "Грешен внес";
				case "invalid_element": return `Грешна вредност во ${issue.origin}`;
				default: return `Грешен внес`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ms.cjs
var require_ms = /* @__PURE__ */ __commonJSMin(((exports, module, this$53) => {
	var __createBinding = this$53 && this$53.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$53 && this$53.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$53 && this$53.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "aksara",
				verb: "mempunyai"
			},
			file: {
				unit: "bait",
				verb: "mempunyai"
			},
			array: {
				unit: "elemen",
				verb: "mempunyai"
			},
			set: {
				unit: "elemen",
				verb: "mempunyai"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "nombor";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "input",
			email: "alamat e-mel",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "tarikh masa ISO",
			date: "tarikh ISO",
			time: "masa ISO",
			duration: "tempoh ISO",
			ipv4: "alamat IPv4",
			ipv6: "alamat IPv6",
			cidrv4: "julat IPv4",
			cidrv6: "julat IPv6",
			base64: "string dikodkan base64",
			base64url: "string dikodkan base64url",
			json_string: "string JSON",
			e164: "nombor E.164",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Input tidak sah: dijangka ${issue.expected}, diterima ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Input tidak sah: dijangka ${util.stringifyPrimitive(issue.values[0])}`;
					return `Pilihan tidak sah: dijangka salah satu daripada ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
					return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} adalah ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Terlalu kecil: dijangka ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Terlalu kecil: dijangka ${issue.origin} adalah ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `String tidak sah: mesti bermula dengan "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `String tidak sah: mesti berakhir dengan "${_issue.suffix}"`;
					if (_issue.format === "includes") return `String tidak sah: mesti mengandungi "${_issue.includes}"`;
					if (_issue.format === "regex") return `String tidak sah: mesti sepadan dengan corak ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} tidak sah`;
				}
				case "not_multiple_of": return `Nombor tidak sah: perlu gandaan ${issue.divisor}`;
				case "unrecognized_keys": return `Kunci tidak dikenali: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Kunci tidak sah dalam ${issue.origin}`;
				case "invalid_union": return "Input tidak sah";
				case "invalid_element": return `Nilai tidak sah dalam ${issue.origin}`;
				default: return `Input tidak sah`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/nl.cjs
var require_nl = /* @__PURE__ */ __commonJSMin(((exports, module, this$52) => {
	var __createBinding = this$52 && this$52.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$52 && this$52.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$52 && this$52.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: { unit: "tekens" },
			file: { unit: "bytes" },
			array: { unit: "elementen" },
			set: { unit: "elementen" }
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "getal";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "invoer",
			email: "emailadres",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO datum en tijd",
			date: "ISO datum",
			time: "ISO tijd",
			duration: "ISO duur",
			ipv4: "IPv4-adres",
			ipv6: "IPv6-adres",
			cidrv4: "IPv4-bereik",
			cidrv6: "IPv6-bereik",
			base64: "base64-gecodeerde tekst",
			base64url: "base64 URL-gecodeerde tekst",
			json_string: "JSON string",
			e164: "E.164-nummer",
			jwt: "JWT",
			template_literal: "invoer"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Ongeldige invoer: verwacht ${issue.expected}, ontving ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Ongeldige invoer: verwacht ${util.stringifyPrimitive(issue.values[0])}`;
					return `Ongeldige optie: verwacht één van ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Te lang: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementen"} bevat`;
					return `Te lang: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} is`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Te kort: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} bevat`;
					return `Te kort: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} is`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ongeldige tekst: moet met "${_issue.prefix}" beginnen`;
					if (_issue.format === "ends_with") return `Ongeldige tekst: moet op "${_issue.suffix}" eindigen`;
					if (_issue.format === "includes") return `Ongeldige tekst: moet "${_issue.includes}" bevatten`;
					if (_issue.format === "regex") return `Ongeldige tekst: moet overeenkomen met patroon ${_issue.pattern}`;
					return `Ongeldig: ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Ongeldig getal: moet een veelvoud van ${issue.divisor} zijn`;
				case "unrecognized_keys": return `Onbekende key${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Ongeldige key in ${issue.origin}`;
				case "invalid_union": return "Ongeldige invoer";
				case "invalid_element": return `Ongeldige waarde in ${issue.origin}`;
				default: return `Ongeldige invoer`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/no.cjs
var require_no = /* @__PURE__ */ __commonJSMin(((exports, module, this$51) => {
	var __createBinding = this$51 && this$51.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$51 && this$51.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$51 && this$51.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "tegn",
				verb: "å ha"
			},
			file: {
				unit: "bytes",
				verb: "å ha"
			},
			array: {
				unit: "elementer",
				verb: "å inneholde"
			},
			set: {
				unit: "elementer",
				verb: "å inneholde"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "tall";
				case "object":
					if (Array.isArray(data)) return "liste";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "input",
			email: "e-postadresse",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO dato- og klokkeslett",
			date: "ISO-dato",
			time: "ISO-klokkeslett",
			duration: "ISO-varighet",
			ipv4: "IPv4-område",
			ipv6: "IPv6-område",
			cidrv4: "IPv4-spekter",
			cidrv6: "IPv6-spekter",
			base64: "base64-enkodet streng",
			base64url: "base64url-enkodet streng",
			json_string: "JSON-streng",
			e164: "E.164-nummer",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Ugyldig input: forventet ${issue.expected}, fikk ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Ugyldig verdi: forventet ${util.stringifyPrimitive(issue.values[0])}`;
					return `Ugyldig valg: forventet en av ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `For stor(t): forventet ${issue.origin ?? "value"} til å ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
					return `For stor(t): forventet ${issue.origin ?? "value"} til å ha ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `For lite(n): forventet ${issue.origin} til å ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `For lite(n): forventet ${issue.origin} til å ha ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ugyldig streng: må starte med "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Ugyldig streng: må ende med "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Ugyldig streng: må inneholde "${_issue.includes}"`;
					if (_issue.format === "regex") return `Ugyldig streng: må matche mønsteret ${_issue.pattern}`;
					return `Ugyldig ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Ugyldig tall: må være et multiplum av ${issue.divisor}`;
				case "unrecognized_keys": return `${issue.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Ugyldig nøkkel i ${issue.origin}`;
				case "invalid_union": return "Ugyldig input";
				case "invalid_element": return `Ugyldig verdi i ${issue.origin}`;
				default: return `Ugyldig input`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ota.cjs
var require_ota = /* @__PURE__ */ __commonJSMin(((exports, module, this$50) => {
	var __createBinding = this$50 && this$50.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$50 && this$50.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$50 && this$50.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "harf",
				verb: "olmalıdır"
			},
			file: {
				unit: "bayt",
				verb: "olmalıdır"
			},
			array: {
				unit: "unsur",
				verb: "olmalıdır"
			},
			set: {
				unit: "unsur",
				verb: "olmalıdır"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "numara";
				case "object":
					if (Array.isArray(data)) return "saf";
					if (data === null) return "gayb";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "giren",
			email: "epostagâh",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO hengâmı",
			date: "ISO tarihi",
			time: "ISO zamanı",
			duration: "ISO müddeti",
			ipv4: "IPv4 nişânı",
			ipv6: "IPv6 nişânı",
			cidrv4: "IPv4 menzili",
			cidrv6: "IPv6 menzili",
			base64: "base64-şifreli metin",
			base64url: "base64url-şifreli metin",
			json_string: "JSON metin",
			e164: "E.164 sayısı",
			jwt: "JWT",
			template_literal: "giren"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Fâsit giren: umulan ${issue.expected}, alınan ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Fâsit giren: umulan ${util.stringifyPrimitive(issue.values[0])}`;
					return `Fâsit tercih: mûteberler ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Fazla büyük: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"} sahip olmalıydı.`;
					return `Fazla büyük: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} olmalıydı.`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Fazla küçük: ${issue.origin}, ${adj}${issue.minimum.toString()} ${sizing.unit} sahip olmalıydı.`;
					return `Fazla küçük: ${issue.origin}, ${adj}${issue.minimum.toString()} olmalıydı.`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Fâsit metin: "${_issue.prefix}" ile başlamalı.`;
					if (_issue.format === "ends_with") return `Fâsit metin: "${_issue.suffix}" ile bitmeli.`;
					if (_issue.format === "includes") return `Fâsit metin: "${_issue.includes}" ihtivâ etmeli.`;
					if (_issue.format === "regex") return `Fâsit metin: ${_issue.pattern} nakşına uymalı.`;
					return `Fâsit ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Fâsit sayı: ${issue.divisor} katı olmalıydı.`;
				case "unrecognized_keys": return `Tanınmayan anahtar ${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `${issue.origin} için tanınmayan anahtar var.`;
				case "invalid_union": return "Giren tanınamadı.";
				case "invalid_element": return `${issue.origin} için tanınmayan kıymet var.`;
				default: return `Kıymet tanınamadı.`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ps.cjs
var require_ps = /* @__PURE__ */ __commonJSMin(((exports, module, this$49) => {
	var __createBinding = this$49 && this$49.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$49 && this$49.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$49 && this$49.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "توکي",
				verb: "ولري"
			},
			file: {
				unit: "بایټس",
				verb: "ولري"
			},
			array: {
				unit: "توکي",
				verb: "ولري"
			},
			set: {
				unit: "توکي",
				verb: "ولري"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "عدد";
				case "object":
					if (Array.isArray(data)) return "ارې";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ورودي",
			email: "بریښنالیک",
			url: "یو آر ال",
			emoji: "ایموجي",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "نیټه او وخت",
			date: "نېټه",
			time: "وخت",
			duration: "موده",
			ipv4: "د IPv4 پته",
			ipv6: "د IPv6 پته",
			cidrv4: "د IPv4 ساحه",
			cidrv6: "د IPv6 ساحه",
			base64: "base64-encoded متن",
			base64url: "base64url-encoded متن",
			json_string: "JSON متن",
			e164: "د E.164 شمېره",
			jwt: "JWT",
			template_literal: "ورودي"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `ناسم ورودي: باید ${issue.expected} وای, مګر ${parsedType(issue.input)} ترلاسه شو`;
				case "invalid_value":
					if (issue.values.length === 1) return `ناسم ورودي: باید ${util.stringifyPrimitive(issue.values[0])} وای`;
					return `ناسم انتخاب: باید یو له ${util.joinValues(issue.values, "|")} څخه وای`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `ډیر لوی: ${issue.origin ?? "ارزښت"} باید ${adj}${issue.maximum.toString()} ${sizing.unit ?? "عنصرونه"} ولري`;
					return `ډیر لوی: ${issue.origin ?? "ارزښت"} باید ${adj}${issue.maximum.toString()} وي`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `ډیر کوچنی: ${issue.origin} باید ${adj}${issue.minimum.toString()} ${sizing.unit} ولري`;
					return `ډیر کوچنی: ${issue.origin} باید ${adj}${issue.minimum.toString()} وي`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `ناسم متن: باید د "${_issue.prefix}" سره پیل شي`;
					if (_issue.format === "ends_with") return `ناسم متن: باید د "${_issue.suffix}" سره پای ته ورسيږي`;
					if (_issue.format === "includes") return `ناسم متن: باید "${_issue.includes}" ولري`;
					if (_issue.format === "regex") return `ناسم متن: باید د ${_issue.pattern} سره مطابقت ولري`;
					return `${Nouns[_issue.format] ?? issue.format} ناسم دی`;
				}
				case "not_multiple_of": return `ناسم عدد: باید د ${issue.divisor} مضرب وي`;
				case "unrecognized_keys": return `ناسم ${issue.keys.length > 1 ? "کلیډونه" : "کلیډ"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `ناسم کلیډ په ${issue.origin} کې`;
				case "invalid_union": return `ناسمه ورودي`;
				case "invalid_element": return `ناسم عنصر په ${issue.origin} کې`;
				default: return `ناسمه ورودي`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/pl.cjs
var require_pl = /* @__PURE__ */ __commonJSMin(((exports, module, this$48) => {
	var __createBinding = this$48 && this$48.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$48 && this$48.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$48 && this$48.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "znaków",
				verb: "mieć"
			},
			file: {
				unit: "bajtów",
				verb: "mieć"
			},
			array: {
				unit: "elementów",
				verb: "mieć"
			},
			set: {
				unit: "elementów",
				verb: "mieć"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "liczba";
				case "object":
					if (Array.isArray(data)) return "tablica";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "wyrażenie",
			email: "adres email",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "data i godzina w formacie ISO",
			date: "data w formacie ISO",
			time: "godzina w formacie ISO",
			duration: "czas trwania ISO",
			ipv4: "adres IPv4",
			ipv6: "adres IPv6",
			cidrv4: "zakres IPv4",
			cidrv6: "zakres IPv6",
			base64: "ciąg znaków zakodowany w formacie base64",
			base64url: "ciąg znaków zakodowany w formacie base64url",
			json_string: "ciąg znaków w formacie JSON",
			e164: "liczba E.164",
			jwt: "JWT",
			template_literal: "wejście"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Nieprawidłowe dane wejściowe: oczekiwano ${issue.expected}, otrzymano ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Nieprawidłowe dane wejściowe: oczekiwano ${util.stringifyPrimitive(issue.values[0])}`;
					return `Nieprawidłowa opcja: oczekiwano jednej z wartości ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Za duża wartość: oczekiwano, że ${issue.origin ?? "wartość"} będzie mieć ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementów"}`;
					return `Zbyt duż(y/a/e): oczekiwano, że ${issue.origin ?? "wartość"} będzie wynosić ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Za mała wartość: oczekiwano, że ${issue.origin ?? "wartość"} będzie mieć ${adj}${issue.minimum.toString()} ${sizing.unit ?? "elementów"}`;
					return `Zbyt mał(y/a/e): oczekiwano, że ${issue.origin ?? "wartość"} będzie wynosić ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Nieprawidłowy ciąg znaków: musi zaczynać się od "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Nieprawidłowy ciąg znaków: musi kończyć się na "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Nieprawidłowy ciąg znaków: musi zawierać "${_issue.includes}"`;
					if (_issue.format === "regex") return `Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ${_issue.pattern}`;
					return `Nieprawidłow(y/a/e) ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Nieprawidłowa liczba: musi być wielokrotnością ${issue.divisor}`;
				case "unrecognized_keys": return `Nierozpoznane klucze${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Nieprawidłowy klucz w ${issue.origin}`;
				case "invalid_union": return "Nieprawidłowe dane wejściowe";
				case "invalid_element": return `Nieprawidłowa wartość w ${issue.origin}`;
				default: return `Nieprawidłowe dane wejściowe`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/pt.cjs
var require_pt = /* @__PURE__ */ __commonJSMin(((exports, module, this$47) => {
	var __createBinding = this$47 && this$47.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$47 && this$47.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$47 && this$47.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "caracteres",
				verb: "ter"
			},
			file: {
				unit: "bytes",
				verb: "ter"
			},
			array: {
				unit: "itens",
				verb: "ter"
			},
			set: {
				unit: "itens",
				verb: "ter"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "número";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "nulo";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "padrão",
			email: "endereço de e-mail",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "data e hora ISO",
			date: "data ISO",
			time: "hora ISO",
			duration: "duração ISO",
			ipv4: "endereço IPv4",
			ipv6: "endereço IPv6",
			cidrv4: "faixa de IPv4",
			cidrv6: "faixa de IPv6",
			base64: "texto codificado em base64",
			base64url: "URL codificada em base64",
			json_string: "texto JSON",
			e164: "número E.164",
			jwt: "JWT",
			template_literal: "entrada"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Tipo inválido: esperado ${issue.expected}, recebido ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Entrada inválida: esperado ${util.stringifyPrimitive(issue.values[0])}`;
					return `Opção inválida: esperada uma das ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Muito grande: esperado que ${issue.origin ?? "valor"} tivesse ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
					return `Muito grande: esperado que ${issue.origin ?? "valor"} fosse ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Muito pequeno: esperado que ${issue.origin} tivesse ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Muito pequeno: esperado que ${issue.origin} fosse ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Texto inválido: deve começar com "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Texto inválido: deve terminar com "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Texto inválido: deve incluir "${_issue.includes}"`;
					if (_issue.format === "regex") return `Texto inválido: deve corresponder ao padrão ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} inválido`;
				}
				case "not_multiple_of": return `Número inválido: deve ser múltiplo de ${issue.divisor}`;
				case "unrecognized_keys": return `Chave${issue.keys.length > 1 ? "s" : ""} desconhecida${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Chave inválida em ${issue.origin}`;
				case "invalid_union": return "Entrada inválida";
				case "invalid_element": return `Valor inválido em ${issue.origin}`;
				default: return `Campo inválido`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ru.cjs
var require_ru = /* @__PURE__ */ __commonJSMin(((exports, module, this$46) => {
	var __createBinding = this$46 && this$46.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$46 && this$46.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$46 && this$46.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	function getRussianPlural(count, one, few, many) {
		const absCount = Math.abs(count);
		const lastDigit = absCount % 10;
		const lastTwoDigits = absCount % 100;
		if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
		if (lastDigit === 1) return one;
		if (lastDigit >= 2 && lastDigit <= 4) return few;
		return many;
	}
	var error = () => {
		const Sizable = {
			string: {
				unit: {
					one: "символ",
					few: "символа",
					many: "символов"
				},
				verb: "иметь"
			},
			file: {
				unit: {
					one: "байт",
					few: "байта",
					many: "байт"
				},
				verb: "иметь"
			},
			array: {
				unit: {
					one: "элемент",
					few: "элемента",
					many: "элементов"
				},
				verb: "иметь"
			},
			set: {
				unit: {
					one: "элемент",
					few: "элемента",
					many: "элементов"
				},
				verb: "иметь"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "число";
				case "object":
					if (Array.isArray(data)) return "массив";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ввод",
			email: "email адрес",
			url: "URL",
			emoji: "эмодзи",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO дата и время",
			date: "ISO дата",
			time: "ISO время",
			duration: "ISO длительность",
			ipv4: "IPv4 адрес",
			ipv6: "IPv6 адрес",
			cidrv4: "IPv4 диапазон",
			cidrv6: "IPv6 диапазон",
			base64: "строка в формате base64",
			base64url: "строка в формате base64url",
			json_string: "JSON строка",
			e164: "номер E.164",
			jwt: "JWT",
			template_literal: "ввод"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Неверный ввод: ожидалось ${issue.expected}, получено ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Неверный ввод: ожидалось ${util.stringifyPrimitive(issue.values[0])}`;
					return `Неверный вариант: ожидалось одно из ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) {
						const unit = getRussianPlural(Number(issue.maximum), sizing.unit.one, sizing.unit.few, sizing.unit.many);
						return `Слишком большое значение: ожидалось, что ${issue.origin ?? "значение"} будет иметь ${adj}${issue.maximum.toString()} ${unit}`;
					}
					return `Слишком большое значение: ожидалось, что ${issue.origin ?? "значение"} будет ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) {
						const unit = getRussianPlural(Number(issue.minimum), sizing.unit.one, sizing.unit.few, sizing.unit.many);
						return `Слишком маленькое значение: ожидалось, что ${issue.origin} будет иметь ${adj}${issue.minimum.toString()} ${unit}`;
					}
					return `Слишком маленькое значение: ожидалось, что ${issue.origin} будет ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Неверная строка: должна начинаться с "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Неверная строка: должна заканчиваться на "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Неверная строка: должна содержать "${_issue.includes}"`;
					if (_issue.format === "regex") return `Неверная строка: должна соответствовать шаблону ${_issue.pattern}`;
					return `Неверный ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Неверное число: должно быть кратным ${issue.divisor}`;
				case "unrecognized_keys": return `Нераспознанн${issue.keys.length > 1 ? "ые" : "ый"} ключ${issue.keys.length > 1 ? "и" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Неверный ключ в ${issue.origin}`;
				case "invalid_union": return "Неверные входные данные";
				case "invalid_element": return `Неверное значение в ${issue.origin}`;
				default: return `Неверные входные данные`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/sl.cjs
var require_sl = /* @__PURE__ */ __commonJSMin(((exports, module, this$45) => {
	var __createBinding = this$45 && this$45.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$45 && this$45.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$45 && this$45.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "znakov",
				verb: "imeti"
			},
			file: {
				unit: "bajtov",
				verb: "imeti"
			},
			array: {
				unit: "elementov",
				verb: "imeti"
			},
			set: {
				unit: "elementov",
				verb: "imeti"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "število";
				case "object":
					if (Array.isArray(data)) return "tabela";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "vnos",
			email: "e-poštni naslov",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO datum in čas",
			date: "ISO datum",
			time: "ISO čas",
			duration: "ISO trajanje",
			ipv4: "IPv4 naslov",
			ipv6: "IPv6 naslov",
			cidrv4: "obseg IPv4",
			cidrv6: "obseg IPv6",
			base64: "base64 kodiran niz",
			base64url: "base64url kodiran niz",
			json_string: "JSON niz",
			e164: "E.164 številka",
			jwt: "JWT",
			template_literal: "vnos"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Neveljaven vnos: pričakovano ${issue.expected}, prejeto ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Neveljaven vnos: pričakovano ${util.stringifyPrimitive(issue.values[0])}`;
					return `Neveljavna možnost: pričakovano eno izmed ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Preveliko: pričakovano, da bo ${issue.origin ?? "vrednost"} imelo ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementov"}`;
					return `Preveliko: pričakovano, da bo ${issue.origin ?? "vrednost"} ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Premajhno: pričakovano, da bo ${issue.origin} imelo ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Premajhno: pričakovano, da bo ${issue.origin} ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Neveljaven niz: mora se začeti z "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Neveljaven niz: mora se končati z "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Neveljaven niz: mora vsebovati "${_issue.includes}"`;
					if (_issue.format === "regex") return `Neveljaven niz: mora ustrezati vzorcu ${_issue.pattern}`;
					return `Neveljaven ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Neveljavno število: mora biti večkratnik ${issue.divisor}`;
				case "unrecognized_keys": return `Neprepoznan${issue.keys.length > 1 ? "i ključi" : " ključ"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Neveljaven ključ v ${issue.origin}`;
				case "invalid_union": return "Neveljaven vnos";
				case "invalid_element": return `Neveljavna vrednost v ${issue.origin}`;
				default: return "Neveljaven vnos";
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/sv.cjs
var require_sv = /* @__PURE__ */ __commonJSMin(((exports, module, this$44) => {
	var __createBinding = this$44 && this$44.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$44 && this$44.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$44 && this$44.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "tecken",
				verb: "att ha"
			},
			file: {
				unit: "bytes",
				verb: "att ha"
			},
			array: {
				unit: "objekt",
				verb: "att innehålla"
			},
			set: {
				unit: "objekt",
				verb: "att innehålla"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "antal";
				case "object":
					if (Array.isArray(data)) return "lista";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "reguljärt uttryck",
			email: "e-postadress",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO-datum och tid",
			date: "ISO-datum",
			time: "ISO-tid",
			duration: "ISO-varaktighet",
			ipv4: "IPv4-intervall",
			ipv6: "IPv6-intervall",
			cidrv4: "IPv4-spektrum",
			cidrv6: "IPv6-spektrum",
			base64: "base64-kodad sträng",
			base64url: "base64url-kodad sträng",
			json_string: "JSON-sträng",
			e164: "E.164-nummer",
			jwt: "JWT",
			template_literal: "mall-literal"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Ogiltig inmatning: förväntat ${issue.expected}, fick ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Ogiltig inmatning: förväntat ${util.stringifyPrimitive(issue.values[0])}`;
					return `Ogiltigt val: förväntade en av ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `För stor(t): förväntade ${issue.origin ?? "värdet"} att ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
					return `För stor(t): förväntat ${issue.origin ?? "värdet"} att ha ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `För lite(t): förväntade ${issue.origin ?? "värdet"} att ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `För lite(t): förväntade ${issue.origin ?? "värdet"} att ha ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ogiltig sträng: måste börja med "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Ogiltig sträng: måste sluta med "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Ogiltig sträng: måste innehålla "${_issue.includes}"`;
					if (_issue.format === "regex") return `Ogiltig sträng: måste matcha mönstret "${_issue.pattern}"`;
					return `Ogiltig(t) ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Ogiltigt tal: måste vara en multipel av ${issue.divisor}`;
				case "unrecognized_keys": return `${issue.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel"}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Ogiltig nyckel i ${issue.origin ?? "värdet"}`;
				case "invalid_union": return "Ogiltig input";
				case "invalid_element": return `Ogiltigt värde i ${issue.origin ?? "värdet"}`;
				default: return `Ogiltig input`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ta.cjs
var require_ta = /* @__PURE__ */ __commonJSMin(((exports, module, this$43) => {
	var __createBinding = this$43 && this$43.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$43 && this$43.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$43 && this$43.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "எழுத்துக்கள்",
				verb: "கொண்டிருக்க வேண்டும்"
			},
			file: {
				unit: "பைட்டுகள்",
				verb: "கொண்டிருக்க வேண்டும்"
			},
			array: {
				unit: "உறுப்புகள்",
				verb: "கொண்டிருக்க வேண்டும்"
			},
			set: {
				unit: "உறுப்புகள்",
				verb: "கொண்டிருக்க வேண்டும்"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "எண் அல்லாதது" : "எண்";
				case "object":
					if (Array.isArray(data)) return "அணி";
					if (data === null) return "வெறுமை";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "உள்ளீடு",
			email: "மின்னஞ்சல் முகவரி",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO தேதி நேரம்",
			date: "ISO தேதி",
			time: "ISO நேரம்",
			duration: "ISO கால அளவு",
			ipv4: "IPv4 முகவரி",
			ipv6: "IPv6 முகவரி",
			cidrv4: "IPv4 வரம்பு",
			cidrv6: "IPv6 வரம்பு",
			base64: "base64-encoded சரம்",
			base64url: "base64url-encoded சரம்",
			json_string: "JSON சரம்",
			e164: "E.164 எண்",
			jwt: "JWT",
			template_literal: "input"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${issue.expected}, பெறப்பட்டது ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${util.stringifyPrimitive(issue.values[0])}`;
					return `தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ${util.joinValues(issue.values, "|")} இல் ஒன்று`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${issue.origin ?? "மதிப்பு"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "உறுப்புகள்"} ஆக இருக்க வேண்டும்`;
					return `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${issue.origin ?? "மதிப்பு"} ${adj}${issue.maximum.toString()} ஆக இருக்க வேண்டும்`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} ஆக இருக்க வேண்டும்`;
					return `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${issue.origin} ${adj}${issue.minimum.toString()} ஆக இருக்க வேண்டும்`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `தவறான சரம்: "${_issue.prefix}" இல் தொடங்க வேண்டும்`;
					if (_issue.format === "ends_with") return `தவறான சரம்: "${_issue.suffix}" இல் முடிவடைய வேண்டும்`;
					if (_issue.format === "includes") return `தவறான சரம்: "${_issue.includes}" ஐ உள்ளடக்க வேண்டும்`;
					if (_issue.format === "regex") return `தவறான சரம்: ${_issue.pattern} முறைபாட்டுடன் பொருந்த வேண்டும்`;
					return `தவறான ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `தவறான எண்: ${issue.divisor} இன் பலமாக இருக்க வேண்டும்`;
				case "unrecognized_keys": return `அடையாளம் தெரியாத விசை${issue.keys.length > 1 ? "கள்" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `${issue.origin} இல் தவறான விசை`;
				case "invalid_union": return "தவறான உள்ளீடு";
				case "invalid_element": return `${issue.origin} இல் தவறான மதிப்பு`;
				default: return `தவறான உள்ளீடு`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/th.cjs
var require_th = /* @__PURE__ */ __commonJSMin(((exports, module, this$42) => {
	var __createBinding = this$42 && this$42.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$42 && this$42.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$42 && this$42.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "ตัวอักษร",
				verb: "ควรมี"
			},
			file: {
				unit: "ไบต์",
				verb: "ควรมี"
			},
			array: {
				unit: "รายการ",
				verb: "ควรมี"
			},
			set: {
				unit: "รายการ",
				verb: "ควรมี"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "ไม่ใช่ตัวเลข (NaN)" : "ตัวเลข";
				case "object":
					if (Array.isArray(data)) return "อาร์เรย์ (Array)";
					if (data === null) return "ไม่มีค่า (null)";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ข้อมูลที่ป้อน",
			email: "ที่อยู่อีเมล",
			url: "URL",
			emoji: "อิโมจิ",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "วันที่เวลาแบบ ISO",
			date: "วันที่แบบ ISO",
			time: "เวลาแบบ ISO",
			duration: "ช่วงเวลาแบบ ISO",
			ipv4: "ที่อยู่ IPv4",
			ipv6: "ที่อยู่ IPv6",
			cidrv4: "ช่วง IP แบบ IPv4",
			cidrv6: "ช่วง IP แบบ IPv6",
			base64: "ข้อความแบบ Base64",
			base64url: "ข้อความแบบ Base64 สำหรับ URL",
			json_string: "ข้อความแบบ JSON",
			e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
			jwt: "โทเคน JWT",
			template_literal: "ข้อมูลที่ป้อน"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ${issue.expected} แต่ได้รับ ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `ค่าไม่ถูกต้อง: ควรเป็น ${util.stringifyPrimitive(issue.values[0])}`;
					return `ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "ไม่เกิน" : "น้อยกว่า";
					const sizing = getSizing(issue.origin);
					if (sizing) return `เกินกำหนด: ${issue.origin ?? "ค่า"} ควรมี${adj} ${issue.maximum.toString()} ${sizing.unit ?? "รายการ"}`;
					return `เกินกำหนด: ${issue.origin ?? "ค่า"} ควรมี${adj} ${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? "อย่างน้อย" : "มากกว่า";
					const sizing = getSizing(issue.origin);
					if (sizing) return `น้อยกว่ากำหนด: ${issue.origin} ควรมี${adj} ${issue.minimum.toString()} ${sizing.unit}`;
					return `น้อยกว่ากำหนด: ${issue.origin} ควรมี${adj} ${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "${_issue.suffix}"`;
					if (_issue.format === "includes") return `รูปแบบไม่ถูกต้อง: ข้อความต้องมี "${_issue.includes}" อยู่ในข้อความ`;
					if (_issue.format === "regex") return `รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ${_issue.pattern}`;
					return `รูปแบบไม่ถูกต้อง: ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ${issue.divisor} ได้ลงตัว`;
				case "unrecognized_keys": return `พบคีย์ที่ไม่รู้จัก: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `คีย์ไม่ถูกต้องใน ${issue.origin}`;
				case "invalid_union": return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
				case "invalid_element": return `ข้อมูลไม่ถูกต้องใน ${issue.origin}`;
				default: return `ข้อมูลไม่ถูกต้อง`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/tr.cjs
var require_tr = /* @__PURE__ */ __commonJSMin(((exports, module, this$41) => {
	var __createBinding = this$41 && this$41.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$41 && this$41.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$41 && this$41.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parsedType = void 0;
	exports.default = default_1;
	var util = __importStar(require_util());
	var parsedType = (data) => {
		const t = typeof data;
		switch (t) {
			case "number": return Number.isNaN(data) ? "NaN" : "number";
			case "object":
				if (Array.isArray(data)) return "array";
				if (data === null) return "null";
				if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
		}
		return t;
	};
	exports.parsedType = parsedType;
	var error = () => {
		const Sizable = {
			string: {
				unit: "karakter",
				verb: "olmalı"
			},
			file: {
				unit: "bayt",
				verb: "olmalı"
			},
			array: {
				unit: "öğe",
				verb: "olmalı"
			},
			set: {
				unit: "öğe",
				verb: "olmalı"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const Nouns = {
			regex: "girdi",
			email: "e-posta adresi",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO tarih ve saat",
			date: "ISO tarih",
			time: "ISO saat",
			duration: "ISO süre",
			ipv4: "IPv4 adresi",
			ipv6: "IPv6 adresi",
			cidrv4: "IPv4 aralığı",
			cidrv6: "IPv6 aralığı",
			base64: "base64 ile şifrelenmiş metin",
			base64url: "base64url ile şifrelenmiş metin",
			json_string: "JSON dizesi",
			e164: "E.164 sayısı",
			jwt: "JWT",
			template_literal: "Şablon dizesi"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Geçersiz değer: beklenen ${issue.expected}, alınan ${(0, exports.parsedType)(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Geçersiz değer: beklenen ${util.stringifyPrimitive(issue.values[0])}`;
					return `Geçersiz seçenek: aşağıdakilerden biri olmalı: ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Çok büyük: beklenen ${issue.origin ?? "değer"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "öğe"}`;
					return `Çok büyük: beklenen ${issue.origin ?? "değer"} ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Çok küçük: beklenen ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Çok küçük: beklenen ${issue.origin} ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Geçersiz metin: "${_issue.prefix}" ile başlamalı`;
					if (_issue.format === "ends_with") return `Geçersiz metin: "${_issue.suffix}" ile bitmeli`;
					if (_issue.format === "includes") return `Geçersiz metin: "${_issue.includes}" içermeli`;
					if (_issue.format === "regex") return `Geçersiz metin: ${_issue.pattern} desenine uymalı`;
					return `Geçersiz ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Geçersiz sayı: ${issue.divisor} ile tam bölünebilmeli`;
				case "unrecognized_keys": return `Tanınmayan anahtar${issue.keys.length > 1 ? "lar" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `${issue.origin} içinde geçersiz anahtar`;
				case "invalid_union": return "Geçersiz değer";
				case "invalid_element": return `${issue.origin} içinde geçersiz değer`;
				default: return `Geçersiz değer`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ua.cjs
var require_ua = /* @__PURE__ */ __commonJSMin(((exports, module, this$40) => {
	var __createBinding = this$40 && this$40.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$40 && this$40.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$40 && this$40.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "символів",
				verb: "матиме"
			},
			file: {
				unit: "байтів",
				verb: "матиме"
			},
			array: {
				unit: "елементів",
				verb: "матиме"
			},
			set: {
				unit: "елементів",
				verb: "матиме"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "число";
				case "object":
					if (Array.isArray(data)) return "масив";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "вхідні дані",
			email: "адреса електронної пошти",
			url: "URL",
			emoji: "емодзі",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "дата та час ISO",
			date: "дата ISO",
			time: "час ISO",
			duration: "тривалість ISO",
			ipv4: "адреса IPv4",
			ipv6: "адреса IPv6",
			cidrv4: "діапазон IPv4",
			cidrv6: "діапазон IPv6",
			base64: "рядок у кодуванні base64",
			base64url: "рядок у кодуванні base64url",
			json_string: "рядок JSON",
			e164: "номер E.164",
			jwt: "JWT",
			template_literal: "вхідні дані"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Неправильні вхідні дані: очікується ${issue.expected}, отримано ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Неправильні вхідні дані: очікується ${util.stringifyPrimitive(issue.values[0])}`;
					return `Неправильна опція: очікується одне з ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Занадто велике: очікується, що ${issue.origin ?? "значення"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "елементів"}`;
					return `Занадто велике: очікується, що ${issue.origin ?? "значення"} буде ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Занадто мале: очікується, що ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Занадто мале: очікується, що ${issue.origin} буде ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Неправильний рядок: повинен починатися з "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Неправильний рядок: повинен закінчуватися на "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Неправильний рядок: повинен містити "${_issue.includes}"`;
					if (_issue.format === "regex") return `Неправильний рядок: повинен відповідати шаблону ${_issue.pattern}`;
					return `Неправильний ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Неправильне число: повинно бути кратним ${issue.divisor}`;
				case "unrecognized_keys": return `Нерозпізнаний ключ${issue.keys.length > 1 ? "і" : ""}: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Неправильний ключ у ${issue.origin}`;
				case "invalid_union": return "Неправильні вхідні дані";
				case "invalid_element": return `Неправильне значення у ${issue.origin}`;
				default: return `Неправильні вхідні дані`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/ur.cjs
var require_ur = /* @__PURE__ */ __commonJSMin(((exports, module, this$39) => {
	var __createBinding = this$39 && this$39.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$39 && this$39.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$39 && this$39.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "حروف",
				verb: "ہونا"
			},
			file: {
				unit: "بائٹس",
				verb: "ہونا"
			},
			array: {
				unit: "آئٹمز",
				verb: "ہونا"
			},
			set: {
				unit: "آئٹمز",
				verb: "ہونا"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "نمبر";
				case "object":
					if (Array.isArray(data)) return "آرے";
					if (data === null) return "نل";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ان پٹ",
			email: "ای میل ایڈریس",
			url: "یو آر ایل",
			emoji: "ایموجی",
			uuid: "یو یو آئی ڈی",
			uuidv4: "یو یو آئی ڈی وی 4",
			uuidv6: "یو یو آئی ڈی وی 6",
			nanoid: "نینو آئی ڈی",
			guid: "جی یو آئی ڈی",
			cuid: "سی یو آئی ڈی",
			cuid2: "سی یو آئی ڈی 2",
			ulid: "یو ایل آئی ڈی",
			xid: "ایکس آئی ڈی",
			ksuid: "کے ایس یو آئی ڈی",
			datetime: "آئی ایس او ڈیٹ ٹائم",
			date: "آئی ایس او تاریخ",
			time: "آئی ایس او وقت",
			duration: "آئی ایس او مدت",
			ipv4: "آئی پی وی 4 ایڈریس",
			ipv6: "آئی پی وی 6 ایڈریس",
			cidrv4: "آئی پی وی 4 رینج",
			cidrv6: "آئی پی وی 6 رینج",
			base64: "بیس 64 ان کوڈڈ سٹرنگ",
			base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
			json_string: "جے ایس او این سٹرنگ",
			e164: "ای 164 نمبر",
			jwt: "جے ڈبلیو ٹی",
			template_literal: "ان پٹ"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `غلط ان پٹ: ${issue.expected} متوقع تھا، ${parsedType(issue.input)} موصول ہوا`;
				case "invalid_value":
					if (issue.values.length === 1) return `غلط ان پٹ: ${util.stringifyPrimitive(issue.values[0])} متوقع تھا`;
					return `غلط آپشن: ${util.joinValues(issue.values, "|")} میں سے ایک متوقع تھا`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `بہت بڑا: ${issue.origin ?? "ویلیو"} کے ${adj}${issue.maximum.toString()} ${sizing.unit ?? "عناصر"} ہونے متوقع تھے`;
					return `بہت بڑا: ${issue.origin ?? "ویلیو"} کا ${adj}${issue.maximum.toString()} ہونا متوقع تھا`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `بہت چھوٹا: ${issue.origin} کے ${adj}${issue.minimum.toString()} ${sizing.unit} ہونے متوقع تھے`;
					return `بہت چھوٹا: ${issue.origin} کا ${adj}${issue.minimum.toString()} ہونا متوقع تھا`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `غلط سٹرنگ: "${_issue.prefix}" سے شروع ہونا چاہیے`;
					if (_issue.format === "ends_with") return `غلط سٹرنگ: "${_issue.suffix}" پر ختم ہونا چاہیے`;
					if (_issue.format === "includes") return `غلط سٹرنگ: "${_issue.includes}" شامل ہونا چاہیے`;
					if (_issue.format === "regex") return `غلط سٹرنگ: پیٹرن ${_issue.pattern} سے میچ ہونا چاہیے`;
					return `غلط ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `غلط نمبر: ${issue.divisor} کا مضاعف ہونا چاہیے`;
				case "unrecognized_keys": return `غیر تسلیم شدہ کی${issue.keys.length > 1 ? "ز" : ""}: ${util.joinValues(issue.keys, "، ")}`;
				case "invalid_key": return `${issue.origin} میں غلط کی`;
				case "invalid_union": return "غلط ان پٹ";
				case "invalid_element": return `${issue.origin} میں غلط ویلیو`;
				default: return `غلط ان پٹ`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/vi.cjs
var require_vi = /* @__PURE__ */ __commonJSMin(((exports, module, this$38) => {
	var __createBinding = this$38 && this$38.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$38 && this$38.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$38 && this$38.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "ký tự",
				verb: "có"
			},
			file: {
				unit: "byte",
				verb: "có"
			},
			array: {
				unit: "phần tử",
				verb: "có"
			},
			set: {
				unit: "phần tử",
				verb: "có"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "số";
				case "object":
					if (Array.isArray(data)) return "mảng";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "đầu vào",
			email: "địa chỉ email",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ngày giờ ISO",
			date: "ngày ISO",
			time: "giờ ISO",
			duration: "khoảng thời gian ISO",
			ipv4: "địa chỉ IPv4",
			ipv6: "địa chỉ IPv6",
			cidrv4: "dải IPv4",
			cidrv6: "dải IPv6",
			base64: "chuỗi mã hóa base64",
			base64url: "chuỗi mã hóa base64url",
			json_string: "chuỗi JSON",
			e164: "số E.164",
			jwt: "JWT",
			template_literal: "đầu vào"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Đầu vào không hợp lệ: mong đợi ${issue.expected}, nhận được ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Đầu vào không hợp lệ: mong đợi ${util.stringifyPrimitive(issue.values[0])}`;
					return `Tùy chọn không hợp lệ: mong đợi một trong các giá trị ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Quá lớn: mong đợi ${issue.origin ?? "giá trị"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "phần tử"}`;
					return `Quá lớn: mong đợi ${issue.origin ?? "giá trị"} ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Quá nhỏ: mong đợi ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `Quá nhỏ: mong đợi ${issue.origin} ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Chuỗi không hợp lệ: phải bắt đầu bằng "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Chuỗi không hợp lệ: phải kết thúc bằng "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Chuỗi không hợp lệ: phải bao gồm "${_issue.includes}"`;
					if (_issue.format === "regex") return `Chuỗi không hợp lệ: phải khớp với mẫu ${_issue.pattern}`;
					return `${Nouns[_issue.format] ?? issue.format} không hợp lệ`;
				}
				case "not_multiple_of": return `Số không hợp lệ: phải là bội số của ${issue.divisor}`;
				case "unrecognized_keys": return `Khóa không được nhận dạng: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Khóa không hợp lệ trong ${issue.origin}`;
				case "invalid_union": return "Đầu vào không hợp lệ";
				case "invalid_element": return `Giá trị không hợp lệ trong ${issue.origin}`;
				default: return `Đầu vào không hợp lệ`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/zh-CN.cjs
var require_zh_CN = /* @__PURE__ */ __commonJSMin(((exports, module, this$37) => {
	var __createBinding = this$37 && this$37.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$37 && this$37.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$37 && this$37.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "字符",
				verb: "包含"
			},
			file: {
				unit: "字节",
				verb: "包含"
			},
			array: {
				unit: "项",
				verb: "包含"
			},
			set: {
				unit: "项",
				verb: "包含"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "非数字(NaN)" : "数字";
				case "object":
					if (Array.isArray(data)) return "数组";
					if (data === null) return "空值(null)";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "输入",
			email: "电子邮件",
			url: "URL",
			emoji: "表情符号",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO日期时间",
			date: "ISO日期",
			time: "ISO时间",
			duration: "ISO时长",
			ipv4: "IPv4地址",
			ipv6: "IPv6地址",
			cidrv4: "IPv4网段",
			cidrv6: "IPv6网段",
			base64: "base64编码字符串",
			base64url: "base64url编码字符串",
			json_string: "JSON字符串",
			e164: "E.164号码",
			jwt: "JWT",
			template_literal: "输入"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `无效输入：期望 ${issue.expected}，实际接收 ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `无效输入：期望 ${util.stringifyPrimitive(issue.values[0])}`;
					return `无效选项：期望以下之一 ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `数值过大：期望 ${issue.origin ?? "值"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "个元素"}`;
					return `数值过大：期望 ${issue.origin ?? "值"} ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `数值过小：期望 ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `数值过小：期望 ${issue.origin} ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `无效字符串：必须以 "${_issue.prefix}" 开头`;
					if (_issue.format === "ends_with") return `无效字符串：必须以 "${_issue.suffix}" 结尾`;
					if (_issue.format === "includes") return `无效字符串：必须包含 "${_issue.includes}"`;
					if (_issue.format === "regex") return `无效字符串：必须满足正则表达式 ${_issue.pattern}`;
					return `无效${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `无效数字：必须是 ${issue.divisor} 的倍数`;
				case "unrecognized_keys": return `出现未知的键(key): ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `${issue.origin} 中的键(key)无效`;
				case "invalid_union": return "无效输入";
				case "invalid_element": return `${issue.origin} 中包含无效值(value)`;
				default: return `无效输入`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/zh-TW.cjs
var require_zh_TW = /* @__PURE__ */ __commonJSMin(((exports, module, this$36) => {
	var __createBinding = this$36 && this$36.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$36 && this$36.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$36 && this$36.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "字元",
				verb: "擁有"
			},
			file: {
				unit: "位元組",
				verb: "擁有"
			},
			array: {
				unit: "項目",
				verb: "擁有"
			},
			set: {
				unit: "項目",
				verb: "擁有"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "number";
				case "object":
					if (Array.isArray(data)) return "array";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "輸入",
			email: "郵件地址",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO 日期時間",
			date: "ISO 日期",
			time: "ISO 時間",
			duration: "ISO 期間",
			ipv4: "IPv4 位址",
			ipv6: "IPv6 位址",
			cidrv4: "IPv4 範圍",
			cidrv6: "IPv6 範圍",
			base64: "base64 編碼字串",
			base64url: "base64url 編碼字串",
			json_string: "JSON 字串",
			e164: "E.164 數值",
			jwt: "JWT",
			template_literal: "輸入"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `無效的輸入值：預期為 ${issue.expected}，但收到 ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `無效的輸入值：預期為 ${util.stringifyPrimitive(issue.values[0])}`;
					return `無效的選項：預期為以下其中之一 ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `數值過大：預期 ${issue.origin ?? "值"} 應為 ${adj}${issue.maximum.toString()} ${sizing.unit ?? "個元素"}`;
					return `數值過大：預期 ${issue.origin ?? "值"} 應為 ${adj}${issue.maximum.toString()}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `數值過小：預期 ${issue.origin} 應為 ${adj}${issue.minimum.toString()} ${sizing.unit}`;
					return `數值過小：預期 ${issue.origin} 應為 ${adj}${issue.minimum.toString()}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `無效的字串：必須以 "${_issue.prefix}" 開頭`;
					if (_issue.format === "ends_with") return `無效的字串：必須以 "${_issue.suffix}" 結尾`;
					if (_issue.format === "includes") return `無效的字串：必須包含 "${_issue.includes}"`;
					if (_issue.format === "regex") return `無效的字串：必須符合格式 ${_issue.pattern}`;
					return `無效的 ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `無效的數字：必須為 ${issue.divisor} 的倍數`;
				case "unrecognized_keys": return `無法識別的鍵值${issue.keys.length > 1 ? "們" : ""}：${util.joinValues(issue.keys, "、")}`;
				case "invalid_key": return `${issue.origin} 中有無效的鍵值`;
				case "invalid_union": return "無效的輸入值";
				case "invalid_element": return `${issue.origin} 中有無效的值`;
				default: return `無效的輸入值`;
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/yo.cjs
var require_yo = /* @__PURE__ */ __commonJSMin(((exports, module, this$35) => {
	var __createBinding = this$35 && this$35.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$35 && this$35.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$35 && this$35.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;
	var util = __importStar(require_util());
	var error = () => {
		const Sizable = {
			string: {
				unit: "àmi",
				verb: "ní"
			},
			file: {
				unit: "bytes",
				verb: "ní"
			},
			array: {
				unit: "nkan",
				verb: "ní"
			},
			set: {
				unit: "nkan",
				verb: "ní"
			}
		};
		function getSizing(origin) {
			return Sizable[origin] ?? null;
		}
		const parsedType = (data) => {
			const t = typeof data;
			switch (t) {
				case "number": return Number.isNaN(data) ? "NaN" : "nọ́mbà";
				case "object":
					if (Array.isArray(data)) return "akopọ";
					if (data === null) return "null";
					if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
			}
			return t;
		};
		const Nouns = {
			regex: "ẹ̀rọ ìbáwọlé",
			email: "àdírẹ́sì ìmẹ́lì",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "àkókò ISO",
			date: "ọjọ́ ISO",
			time: "àkókò ISO",
			duration: "àkókò tó pé ISO",
			ipv4: "àdírẹ́sì IPv4",
			ipv6: "àdírẹ́sì IPv6",
			cidrv4: "àgbègbè IPv4",
			cidrv6: "àgbègbè IPv6",
			base64: "ọ̀rọ̀ tí a kọ́ ní base64",
			base64url: "ọ̀rọ̀ base64url",
			json_string: "ọ̀rọ̀ JSON",
			e164: "nọ́mbà E.164",
			jwt: "JWT",
			template_literal: "ẹ̀rọ ìbáwọlé"
		};
		return (issue) => {
			switch (issue.code) {
				case "invalid_type": return `Ìbáwọlé aṣìṣe: a ní láti fi ${issue.expected}, àmọ̀ a rí ${parsedType(issue.input)}`;
				case "invalid_value":
					if (issue.values.length === 1) return `Ìbáwọlé aṣìṣe: a ní láti fi ${util.stringifyPrimitive(issue.values[0])}`;
					return `Àṣàyàn aṣìṣe: yan ọ̀kan lára ${util.joinValues(issue.values, "|")}`;
				case "too_big": {
					const adj = issue.inclusive ? "<=" : "<";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Tó pọ̀ jù: a ní láti jẹ́ pé ${issue.origin ?? "iye"} ${sizing.verb} ${adj}${issue.maximum} ${sizing.unit}`;
					return `Tó pọ̀ jù: a ní láti jẹ́ ${adj}${issue.maximum}`;
				}
				case "too_small": {
					const adj = issue.inclusive ? ">=" : ">";
					const sizing = getSizing(issue.origin);
					if (sizing) return `Kéré ju: a ní láti jẹ́ pé ${issue.origin} ${sizing.verb} ${adj}${issue.minimum} ${sizing.unit}`;
					return `Kéré ju: a ní láti jẹ́ ${adj}${issue.minimum}`;
				}
				case "invalid_format": {
					const _issue = issue;
					if (_issue.format === "starts_with") return `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bẹ̀rẹ̀ pẹ̀lú "${_issue.prefix}"`;
					if (_issue.format === "ends_with") return `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ parí pẹ̀lú "${_issue.suffix}"`;
					if (_issue.format === "includes") return `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ ní "${_issue.includes}"`;
					if (_issue.format === "regex") return `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bá àpẹẹrẹ mu ${_issue.pattern}`;
					return `Aṣìṣe: ${Nouns[_issue.format] ?? issue.format}`;
				}
				case "not_multiple_of": return `Nọ́mbà aṣìṣe: gbọ́dọ̀ jẹ́ èyà pípín ti ${issue.divisor}`;
				case "unrecognized_keys": return `Bọtìnì àìmọ̀: ${util.joinValues(issue.keys, ", ")}`;
				case "invalid_key": return `Bọtìnì aṣìṣe nínú ${issue.origin}`;
				case "invalid_union": return "Ìbáwọlé aṣìṣe";
				case "invalid_element": return `Iye aṣìṣe nínú ${issue.origin}`;
				default: return "Ìbáwọlé aṣìṣe";
			}
		};
	};
	function default_1() {
		return { localeError: error() };
	}
	module.exports = exports.default;
}));
//#endregion
//#region ../../node_modules/zod/v4/locales/index.cjs
var require_locales = /* @__PURE__ */ __commonJSMin(((exports, module, this$34) => {
	var __importDefault = this$34 && this$34.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.yo = exports.zhTW = exports.zhCN = exports.vi = exports.ur = exports.ua = exports.tr = exports.th = exports.ta = exports.sv = exports.sl = exports.ru = exports.pt = exports.pl = exports.ps = exports.ota = exports.no = exports.nl = exports.ms = exports.mk = exports.ko = exports.kh = exports.ja = exports.it = exports.is = exports.id = exports.hu = exports.he = exports.frCA = exports.fr = exports.fi = exports.fa = exports.es = exports.eo = exports.en = exports.de = exports.da = exports.cs = exports.ca = exports.be = exports.az = exports.ar = void 0;
	var ar_js_1 = require_ar();
	Object.defineProperty(exports, "ar", {
		enumerable: true,
		get: function() {
			return __importDefault(ar_js_1).default;
		}
	});
	var az_js_1 = require_az();
	Object.defineProperty(exports, "az", {
		enumerable: true,
		get: function() {
			return __importDefault(az_js_1).default;
		}
	});
	var be_js_1 = require_be();
	Object.defineProperty(exports, "be", {
		enumerable: true,
		get: function() {
			return __importDefault(be_js_1).default;
		}
	});
	var ca_js_1 = require_ca();
	Object.defineProperty(exports, "ca", {
		enumerable: true,
		get: function() {
			return __importDefault(ca_js_1).default;
		}
	});
	var cs_js_1 = require_cs();
	Object.defineProperty(exports, "cs", {
		enumerable: true,
		get: function() {
			return __importDefault(cs_js_1).default;
		}
	});
	var da_js_1 = require_da();
	Object.defineProperty(exports, "da", {
		enumerable: true,
		get: function() {
			return __importDefault(da_js_1).default;
		}
	});
	var de_js_1 = require_de();
	Object.defineProperty(exports, "de", {
		enumerable: true,
		get: function() {
			return __importDefault(de_js_1).default;
		}
	});
	var en_js_1 = require_en();
	Object.defineProperty(exports, "en", {
		enumerable: true,
		get: function() {
			return __importDefault(en_js_1).default;
		}
	});
	var eo_js_1 = require_eo();
	Object.defineProperty(exports, "eo", {
		enumerable: true,
		get: function() {
			return __importDefault(eo_js_1).default;
		}
	});
	var es_js_1 = require_es$1();
	Object.defineProperty(exports, "es", {
		enumerable: true,
		get: function() {
			return __importDefault(es_js_1).default;
		}
	});
	var fa_js_1 = require_fa();
	Object.defineProperty(exports, "fa", {
		enumerable: true,
		get: function() {
			return __importDefault(fa_js_1).default;
		}
	});
	var fi_js_1 = require_fi();
	Object.defineProperty(exports, "fi", {
		enumerable: true,
		get: function() {
			return __importDefault(fi_js_1).default;
		}
	});
	var fr_js_1 = require_fr();
	Object.defineProperty(exports, "fr", {
		enumerable: true,
		get: function() {
			return __importDefault(fr_js_1).default;
		}
	});
	var fr_CA_js_1 = require_fr_CA();
	Object.defineProperty(exports, "frCA", {
		enumerable: true,
		get: function() {
			return __importDefault(fr_CA_js_1).default;
		}
	});
	var he_js_1 = require_he();
	Object.defineProperty(exports, "he", {
		enumerable: true,
		get: function() {
			return __importDefault(he_js_1).default;
		}
	});
	var hu_js_1 = require_hu();
	Object.defineProperty(exports, "hu", {
		enumerable: true,
		get: function() {
			return __importDefault(hu_js_1).default;
		}
	});
	var id_js_1 = require_id();
	Object.defineProperty(exports, "id", {
		enumerable: true,
		get: function() {
			return __importDefault(id_js_1).default;
		}
	});
	var is_js_1 = require_is();
	Object.defineProperty(exports, "is", {
		enumerable: true,
		get: function() {
			return __importDefault(is_js_1).default;
		}
	});
	var it_js_1 = require_it();
	Object.defineProperty(exports, "it", {
		enumerable: true,
		get: function() {
			return __importDefault(it_js_1).default;
		}
	});
	var ja_js_1 = require_ja();
	Object.defineProperty(exports, "ja", {
		enumerable: true,
		get: function() {
			return __importDefault(ja_js_1).default;
		}
	});
	var kh_js_1 = require_kh();
	Object.defineProperty(exports, "kh", {
		enumerable: true,
		get: function() {
			return __importDefault(kh_js_1).default;
		}
	});
	var ko_js_1 = require_ko();
	Object.defineProperty(exports, "ko", {
		enumerable: true,
		get: function() {
			return __importDefault(ko_js_1).default;
		}
	});
	var mk_js_1 = require_mk();
	Object.defineProperty(exports, "mk", {
		enumerable: true,
		get: function() {
			return __importDefault(mk_js_1).default;
		}
	});
	var ms_js_1 = require_ms();
	Object.defineProperty(exports, "ms", {
		enumerable: true,
		get: function() {
			return __importDefault(ms_js_1).default;
		}
	});
	var nl_js_1 = require_nl();
	Object.defineProperty(exports, "nl", {
		enumerable: true,
		get: function() {
			return __importDefault(nl_js_1).default;
		}
	});
	var no_js_1 = require_no();
	Object.defineProperty(exports, "no", {
		enumerable: true,
		get: function() {
			return __importDefault(no_js_1).default;
		}
	});
	var ota_js_1 = require_ota();
	Object.defineProperty(exports, "ota", {
		enumerable: true,
		get: function() {
			return __importDefault(ota_js_1).default;
		}
	});
	var ps_js_1 = require_ps();
	Object.defineProperty(exports, "ps", {
		enumerable: true,
		get: function() {
			return __importDefault(ps_js_1).default;
		}
	});
	var pl_js_1 = require_pl();
	Object.defineProperty(exports, "pl", {
		enumerable: true,
		get: function() {
			return __importDefault(pl_js_1).default;
		}
	});
	var pt_js_1 = require_pt();
	Object.defineProperty(exports, "pt", {
		enumerable: true,
		get: function() {
			return __importDefault(pt_js_1).default;
		}
	});
	var ru_js_1 = require_ru();
	Object.defineProperty(exports, "ru", {
		enumerable: true,
		get: function() {
			return __importDefault(ru_js_1).default;
		}
	});
	var sl_js_1 = require_sl();
	Object.defineProperty(exports, "sl", {
		enumerable: true,
		get: function() {
			return __importDefault(sl_js_1).default;
		}
	});
	var sv_js_1 = require_sv();
	Object.defineProperty(exports, "sv", {
		enumerable: true,
		get: function() {
			return __importDefault(sv_js_1).default;
		}
	});
	var ta_js_1 = require_ta();
	Object.defineProperty(exports, "ta", {
		enumerable: true,
		get: function() {
			return __importDefault(ta_js_1).default;
		}
	});
	var th_js_1 = require_th();
	Object.defineProperty(exports, "th", {
		enumerable: true,
		get: function() {
			return __importDefault(th_js_1).default;
		}
	});
	var tr_js_1 = require_tr();
	Object.defineProperty(exports, "tr", {
		enumerable: true,
		get: function() {
			return __importDefault(tr_js_1).default;
		}
	});
	var ua_js_1 = require_ua();
	Object.defineProperty(exports, "ua", {
		enumerable: true,
		get: function() {
			return __importDefault(ua_js_1).default;
		}
	});
	var ur_js_1 = require_ur();
	Object.defineProperty(exports, "ur", {
		enumerable: true,
		get: function() {
			return __importDefault(ur_js_1).default;
		}
	});
	var vi_js_1 = require_vi();
	Object.defineProperty(exports, "vi", {
		enumerable: true,
		get: function() {
			return __importDefault(vi_js_1).default;
		}
	});
	var zh_CN_js_1 = require_zh_CN();
	Object.defineProperty(exports, "zhCN", {
		enumerable: true,
		get: function() {
			return __importDefault(zh_CN_js_1).default;
		}
	});
	var zh_TW_js_1 = require_zh_TW();
	Object.defineProperty(exports, "zhTW", {
		enumerable: true,
		get: function() {
			return __importDefault(zh_TW_js_1).default;
		}
	});
	var yo_js_1 = require_yo();
	Object.defineProperty(exports, "yo", {
		enumerable: true,
		get: function() {
			return __importDefault(yo_js_1).default;
		}
	});
}));
//#endregion
//#region ../../node_modules/zod/v4/core/registries.cjs
var require_registries = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.globalRegistry = exports.$ZodRegistry = exports.$input = exports.$output = void 0;
	exports.registry = registry;
	exports.$output = Symbol("ZodOutput");
	exports.$input = Symbol("ZodInput");
	var $ZodRegistry = class {
		constructor() {
			this._map = /* @__PURE__ */ new Map();
			this._idmap = /* @__PURE__ */ new Map();
		}
		add(schema, ..._meta) {
			const meta = _meta[0];
			this._map.set(schema, meta);
			if (meta && typeof meta === "object" && "id" in meta) {
				if (this._idmap.has(meta.id)) throw new Error(`ID ${meta.id} already exists in the registry`);
				this._idmap.set(meta.id, schema);
			}
			return this;
		}
		clear() {
			this._map = /* @__PURE__ */ new Map();
			this._idmap = /* @__PURE__ */ new Map();
			return this;
		}
		remove(schema) {
			const meta = this._map.get(schema);
			if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
			this._map.delete(schema);
			return this;
		}
		get(schema) {
			const p = schema._zod.parent;
			if (p) {
				const pm = { ...this.get(p) ?? {} };
				delete pm.id;
				const f = {
					...pm,
					...this._map.get(schema)
				};
				return Object.keys(f).length ? f : void 0;
			}
			return this._map.get(schema);
		}
		has(schema) {
			return this._map.has(schema);
		}
	};
	exports.$ZodRegistry = $ZodRegistry;
	function registry() {
		return new $ZodRegistry();
	}
	exports.globalRegistry = registry();
}));
//#endregion
//#region ../../node_modules/zod/v4/core/api.cjs
var require_api = /* @__PURE__ */ __commonJSMin(((exports, module, this$33) => {
	var __createBinding = this$33 && this$33.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$33 && this$33.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$33 && this$33.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TimePrecision = void 0;
	exports._string = _string;
	exports._coercedString = _coercedString;
	exports._email = _email;
	exports._guid = _guid;
	exports._uuid = _uuid;
	exports._uuidv4 = _uuidv4;
	exports._uuidv6 = _uuidv6;
	exports._uuidv7 = _uuidv7;
	exports._url = _url;
	exports._emoji = _emoji;
	exports._nanoid = _nanoid;
	exports._cuid = _cuid;
	exports._cuid2 = _cuid2;
	exports._ulid = _ulid;
	exports._xid = _xid;
	exports._ksuid = _ksuid;
	exports._ipv4 = _ipv4;
	exports._ipv6 = _ipv6;
	exports._cidrv4 = _cidrv4;
	exports._cidrv6 = _cidrv6;
	exports._base64 = _base64;
	exports._base64url = _base64url;
	exports._e164 = _e164;
	exports._jwt = _jwt;
	exports._isoDateTime = _isoDateTime;
	exports._isoDate = _isoDate;
	exports._isoTime = _isoTime;
	exports._isoDuration = _isoDuration;
	exports._number = _number;
	exports._coercedNumber = _coercedNumber;
	exports._int = _int;
	exports._float32 = _float32;
	exports._float64 = _float64;
	exports._int32 = _int32;
	exports._uint32 = _uint32;
	exports._boolean = _boolean;
	exports._coercedBoolean = _coercedBoolean;
	exports._bigint = _bigint;
	exports._coercedBigint = _coercedBigint;
	exports._int64 = _int64;
	exports._uint64 = _uint64;
	exports._symbol = _symbol;
	exports._undefined = _undefined;
	exports._null = _null;
	exports._any = _any;
	exports._unknown = _unknown;
	exports._never = _never;
	exports._void = _void;
	exports._date = _date;
	exports._coercedDate = _coercedDate;
	exports._nan = _nan;
	exports._lt = _lt;
	exports._lte = _lte;
	exports._max = _lte;
	exports._lte = _lte;
	exports._max = _lte;
	exports._gt = _gt;
	exports._gte = _gte;
	exports._min = _gte;
	exports._gte = _gte;
	exports._min = _gte;
	exports._positive = _positive;
	exports._negative = _negative;
	exports._nonpositive = _nonpositive;
	exports._nonnegative = _nonnegative;
	exports._multipleOf = _multipleOf;
	exports._maxSize = _maxSize;
	exports._minSize = _minSize;
	exports._size = _size;
	exports._maxLength = _maxLength;
	exports._minLength = _minLength;
	exports._length = _length;
	exports._regex = _regex;
	exports._lowercase = _lowercase;
	exports._uppercase = _uppercase;
	exports._includes = _includes;
	exports._startsWith = _startsWith;
	exports._endsWith = _endsWith;
	exports._property = _property;
	exports._mime = _mime;
	exports._overwrite = _overwrite;
	exports._normalize = _normalize;
	exports._trim = _trim;
	exports._toLowerCase = _toLowerCase;
	exports._toUpperCase = _toUpperCase;
	exports._array = _array;
	exports._union = _union;
	exports._discriminatedUnion = _discriminatedUnion;
	exports._intersection = _intersection;
	exports._tuple = _tuple;
	exports._record = _record;
	exports._map = _map;
	exports._set = _set;
	exports._enum = _enum;
	exports._nativeEnum = _nativeEnum;
	exports._literal = _literal;
	exports._file = _file;
	exports._transform = _transform;
	exports._optional = _optional;
	exports._nullable = _nullable;
	exports._default = _default;
	exports._nonoptional = _nonoptional;
	exports._success = _success;
	exports._catch = _catch;
	exports._pipe = _pipe;
	exports._readonly = _readonly;
	exports._templateLiteral = _templateLiteral;
	exports._lazy = _lazy;
	exports._promise = _promise;
	exports._custom = _custom;
	exports._refine = _refine;
	exports._superRefine = _superRefine;
	exports._check = _check;
	exports._stringbool = _stringbool;
	exports._stringFormat = _stringFormat;
	var checks = __importStar(require_checks$1());
	var schemas = __importStar(require_schemas$1());
	var util = __importStar(require_util());
	function _string(Class, params) {
		return new Class({
			type: "string",
			...util.normalizeParams(params)
		});
	}
	function _coercedString(Class, params) {
		return new Class({
			type: "string",
			coerce: true,
			...util.normalizeParams(params)
		});
	}
	function _email(Class, params) {
		return new Class({
			type: "string",
			format: "email",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _guid(Class, params) {
		return new Class({
			type: "string",
			format: "guid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _uuid(Class, params) {
		return new Class({
			type: "string",
			format: "uuid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _uuidv4(Class, params) {
		return new Class({
			type: "string",
			format: "uuid",
			check: "string_format",
			abort: false,
			version: "v4",
			...util.normalizeParams(params)
		});
	}
	function _uuidv6(Class, params) {
		return new Class({
			type: "string",
			format: "uuid",
			check: "string_format",
			abort: false,
			version: "v6",
			...util.normalizeParams(params)
		});
	}
	function _uuidv7(Class, params) {
		return new Class({
			type: "string",
			format: "uuid",
			check: "string_format",
			abort: false,
			version: "v7",
			...util.normalizeParams(params)
		});
	}
	function _url(Class, params) {
		return new Class({
			type: "string",
			format: "url",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _emoji(Class, params) {
		return new Class({
			type: "string",
			format: "emoji",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _nanoid(Class, params) {
		return new Class({
			type: "string",
			format: "nanoid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _cuid(Class, params) {
		return new Class({
			type: "string",
			format: "cuid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _cuid2(Class, params) {
		return new Class({
			type: "string",
			format: "cuid2",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _ulid(Class, params) {
		return new Class({
			type: "string",
			format: "ulid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _xid(Class, params) {
		return new Class({
			type: "string",
			format: "xid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _ksuid(Class, params) {
		return new Class({
			type: "string",
			format: "ksuid",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _ipv4(Class, params) {
		return new Class({
			type: "string",
			format: "ipv4",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _ipv6(Class, params) {
		return new Class({
			type: "string",
			format: "ipv6",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _cidrv4(Class, params) {
		return new Class({
			type: "string",
			format: "cidrv4",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _cidrv6(Class, params) {
		return new Class({
			type: "string",
			format: "cidrv6",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _base64(Class, params) {
		return new Class({
			type: "string",
			format: "base64",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _base64url(Class, params) {
		return new Class({
			type: "string",
			format: "base64url",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _e164(Class, params) {
		return new Class({
			type: "string",
			format: "e164",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	function _jwt(Class, params) {
		return new Class({
			type: "string",
			format: "jwt",
			check: "string_format",
			abort: false,
			...util.normalizeParams(params)
		});
	}
	exports.TimePrecision = {
		Any: null,
		Minute: -1,
		Second: 0,
		Millisecond: 3,
		Microsecond: 6
	};
	function _isoDateTime(Class, params) {
		return new Class({
			type: "string",
			format: "datetime",
			check: "string_format",
			offset: false,
			local: false,
			precision: null,
			...util.normalizeParams(params)
		});
	}
	function _isoDate(Class, params) {
		return new Class({
			type: "string",
			format: "date",
			check: "string_format",
			...util.normalizeParams(params)
		});
	}
	function _isoTime(Class, params) {
		return new Class({
			type: "string",
			format: "time",
			check: "string_format",
			precision: null,
			...util.normalizeParams(params)
		});
	}
	function _isoDuration(Class, params) {
		return new Class({
			type: "string",
			format: "duration",
			check: "string_format",
			...util.normalizeParams(params)
		});
	}
	function _number(Class, params) {
		return new Class({
			type: "number",
			checks: [],
			...util.normalizeParams(params)
		});
	}
	function _coercedNumber(Class, params) {
		return new Class({
			type: "number",
			coerce: true,
			checks: [],
			...util.normalizeParams(params)
		});
	}
	function _int(Class, params) {
		return new Class({
			type: "number",
			check: "number_format",
			abort: false,
			format: "safeint",
			...util.normalizeParams(params)
		});
	}
	function _float32(Class, params) {
		return new Class({
			type: "number",
			check: "number_format",
			abort: false,
			format: "float32",
			...util.normalizeParams(params)
		});
	}
	function _float64(Class, params) {
		return new Class({
			type: "number",
			check: "number_format",
			abort: false,
			format: "float64",
			...util.normalizeParams(params)
		});
	}
	function _int32(Class, params) {
		return new Class({
			type: "number",
			check: "number_format",
			abort: false,
			format: "int32",
			...util.normalizeParams(params)
		});
	}
	function _uint32(Class, params) {
		return new Class({
			type: "number",
			check: "number_format",
			abort: false,
			format: "uint32",
			...util.normalizeParams(params)
		});
	}
	function _boolean(Class, params) {
		return new Class({
			type: "boolean",
			...util.normalizeParams(params)
		});
	}
	function _coercedBoolean(Class, params) {
		return new Class({
			type: "boolean",
			coerce: true,
			...util.normalizeParams(params)
		});
	}
	function _bigint(Class, params) {
		return new Class({
			type: "bigint",
			...util.normalizeParams(params)
		});
	}
	function _coercedBigint(Class, params) {
		return new Class({
			type: "bigint",
			coerce: true,
			...util.normalizeParams(params)
		});
	}
	function _int64(Class, params) {
		return new Class({
			type: "bigint",
			check: "bigint_format",
			abort: false,
			format: "int64",
			...util.normalizeParams(params)
		});
	}
	function _uint64(Class, params) {
		return new Class({
			type: "bigint",
			check: "bigint_format",
			abort: false,
			format: "uint64",
			...util.normalizeParams(params)
		});
	}
	function _symbol(Class, params) {
		return new Class({
			type: "symbol",
			...util.normalizeParams(params)
		});
	}
	function _undefined(Class, params) {
		return new Class({
			type: "undefined",
			...util.normalizeParams(params)
		});
	}
	function _null(Class, params) {
		return new Class({
			type: "null",
			...util.normalizeParams(params)
		});
	}
	function _any(Class) {
		return new Class({ type: "any" });
	}
	function _unknown(Class) {
		return new Class({ type: "unknown" });
	}
	function _never(Class, params) {
		return new Class({
			type: "never",
			...util.normalizeParams(params)
		});
	}
	function _void(Class, params) {
		return new Class({
			type: "void",
			...util.normalizeParams(params)
		});
	}
	function _date(Class, params) {
		return new Class({
			type: "date",
			...util.normalizeParams(params)
		});
	}
	function _coercedDate(Class, params) {
		return new Class({
			type: "date",
			coerce: true,
			...util.normalizeParams(params)
		});
	}
	function _nan(Class, params) {
		return new Class({
			type: "nan",
			...util.normalizeParams(params)
		});
	}
	function _lt(value, params) {
		return new checks.$ZodCheckLessThan({
			check: "less_than",
			...util.normalizeParams(params),
			value,
			inclusive: false
		});
	}
	function _lte(value, params) {
		return new checks.$ZodCheckLessThan({
			check: "less_than",
			...util.normalizeParams(params),
			value,
			inclusive: true
		});
	}
	function _gt(value, params) {
		return new checks.$ZodCheckGreaterThan({
			check: "greater_than",
			...util.normalizeParams(params),
			value,
			inclusive: false
		});
	}
	function _gte(value, params) {
		return new checks.$ZodCheckGreaterThan({
			check: "greater_than",
			...util.normalizeParams(params),
			value,
			inclusive: true
		});
	}
	function _positive(params) {
		return _gt(0, params);
	}
	function _negative(params) {
		return _lt(0, params);
	}
	function _nonpositive(params) {
		return _lte(0, params);
	}
	function _nonnegative(params) {
		return _gte(0, params);
	}
	function _multipleOf(value, params) {
		return new checks.$ZodCheckMultipleOf({
			check: "multiple_of",
			...util.normalizeParams(params),
			value
		});
	}
	function _maxSize(maximum, params) {
		return new checks.$ZodCheckMaxSize({
			check: "max_size",
			...util.normalizeParams(params),
			maximum
		});
	}
	function _minSize(minimum, params) {
		return new checks.$ZodCheckMinSize({
			check: "min_size",
			...util.normalizeParams(params),
			minimum
		});
	}
	function _size(size, params) {
		return new checks.$ZodCheckSizeEquals({
			check: "size_equals",
			...util.normalizeParams(params),
			size
		});
	}
	function _maxLength(maximum, params) {
		return new checks.$ZodCheckMaxLength({
			check: "max_length",
			...util.normalizeParams(params),
			maximum
		});
	}
	function _minLength(minimum, params) {
		return new checks.$ZodCheckMinLength({
			check: "min_length",
			...util.normalizeParams(params),
			minimum
		});
	}
	function _length(length, params) {
		return new checks.$ZodCheckLengthEquals({
			check: "length_equals",
			...util.normalizeParams(params),
			length
		});
	}
	function _regex(pattern, params) {
		return new checks.$ZodCheckRegex({
			check: "string_format",
			format: "regex",
			...util.normalizeParams(params),
			pattern
		});
	}
	function _lowercase(params) {
		return new checks.$ZodCheckLowerCase({
			check: "string_format",
			format: "lowercase",
			...util.normalizeParams(params)
		});
	}
	function _uppercase(params) {
		return new checks.$ZodCheckUpperCase({
			check: "string_format",
			format: "uppercase",
			...util.normalizeParams(params)
		});
	}
	function _includes(includes, params) {
		return new checks.$ZodCheckIncludes({
			check: "string_format",
			format: "includes",
			...util.normalizeParams(params),
			includes
		});
	}
	function _startsWith(prefix, params) {
		return new checks.$ZodCheckStartsWith({
			check: "string_format",
			format: "starts_with",
			...util.normalizeParams(params),
			prefix
		});
	}
	function _endsWith(suffix, params) {
		return new checks.$ZodCheckEndsWith({
			check: "string_format",
			format: "ends_with",
			...util.normalizeParams(params),
			suffix
		});
	}
	function _property(property, schema, params) {
		return new checks.$ZodCheckProperty({
			check: "property",
			property,
			schema,
			...util.normalizeParams(params)
		});
	}
	function _mime(types, params) {
		return new checks.$ZodCheckMimeType({
			check: "mime_type",
			mime: types,
			...util.normalizeParams(params)
		});
	}
	function _overwrite(tx) {
		return new checks.$ZodCheckOverwrite({
			check: "overwrite",
			tx
		});
	}
	function _normalize(form) {
		return _overwrite((input) => input.normalize(form));
	}
	function _trim() {
		return _overwrite((input) => input.trim());
	}
	function _toLowerCase() {
		return _overwrite((input) => input.toLowerCase());
	}
	function _toUpperCase() {
		return _overwrite((input) => input.toUpperCase());
	}
	function _array(Class, element, params) {
		return new Class({
			type: "array",
			element,
			...util.normalizeParams(params)
		});
	}
	function _union(Class, options, params) {
		return new Class({
			type: "union",
			options,
			...util.normalizeParams(params)
		});
	}
	function _discriminatedUnion(Class, discriminator, options, params) {
		return new Class({
			type: "union",
			options,
			discriminator,
			...util.normalizeParams(params)
		});
	}
	function _intersection(Class, left, right) {
		return new Class({
			type: "intersection",
			left,
			right
		});
	}
	function _tuple(Class, items, _paramsOrRest, _params) {
		const hasRest = _paramsOrRest instanceof schemas.$ZodType;
		const params = hasRest ? _params : _paramsOrRest;
		return new Class({
			type: "tuple",
			items,
			rest: hasRest ? _paramsOrRest : null,
			...util.normalizeParams(params)
		});
	}
	function _record(Class, keyType, valueType, params) {
		return new Class({
			type: "record",
			keyType,
			valueType,
			...util.normalizeParams(params)
		});
	}
	function _map(Class, keyType, valueType, params) {
		return new Class({
			type: "map",
			keyType,
			valueType,
			...util.normalizeParams(params)
		});
	}
	function _set(Class, valueType, params) {
		return new Class({
			type: "set",
			valueType,
			...util.normalizeParams(params)
		});
	}
	function _enum(Class, values, params) {
		return new Class({
			type: "enum",
			entries: Array.isArray(values) ? Object.fromEntries(values.map((v) => [v, v])) : values,
			...util.normalizeParams(params)
		});
	}
	/** @deprecated This API has been merged into `z.enum()`. Use `z.enum()` instead.
	*
	* ```ts
	* enum Colors { red, green, blue }
	* z.enum(Colors);
	* ```
	*/
	function _nativeEnum(Class, entries, params) {
		return new Class({
			type: "enum",
			entries,
			...util.normalizeParams(params)
		});
	}
	function _literal(Class, value, params) {
		return new Class({
			type: "literal",
			values: Array.isArray(value) ? value : [value],
			...util.normalizeParams(params)
		});
	}
	function _file(Class, params) {
		return new Class({
			type: "file",
			...util.normalizeParams(params)
		});
	}
	function _transform(Class, fn) {
		return new Class({
			type: "transform",
			transform: fn
		});
	}
	function _optional(Class, innerType) {
		return new Class({
			type: "optional",
			innerType
		});
	}
	function _nullable(Class, innerType) {
		return new Class({
			type: "nullable",
			innerType
		});
	}
	function _default(Class, innerType, defaultValue) {
		return new Class({
			type: "default",
			innerType,
			get defaultValue() {
				return typeof defaultValue === "function" ? defaultValue() : util.shallowClone(defaultValue);
			}
		});
	}
	function _nonoptional(Class, innerType, params) {
		return new Class({
			type: "nonoptional",
			innerType,
			...util.normalizeParams(params)
		});
	}
	function _success(Class, innerType) {
		return new Class({
			type: "success",
			innerType
		});
	}
	function _catch(Class, innerType, catchValue) {
		return new Class({
			type: "catch",
			innerType,
			catchValue: typeof catchValue === "function" ? catchValue : () => catchValue
		});
	}
	function _pipe(Class, in_, out) {
		return new Class({
			type: "pipe",
			in: in_,
			out
		});
	}
	function _readonly(Class, innerType) {
		return new Class({
			type: "readonly",
			innerType
		});
	}
	function _templateLiteral(Class, parts, params) {
		return new Class({
			type: "template_literal",
			parts,
			...util.normalizeParams(params)
		});
	}
	function _lazy(Class, getter) {
		return new Class({
			type: "lazy",
			getter
		});
	}
	function _promise(Class, innerType) {
		return new Class({
			type: "promise",
			innerType
		});
	}
	function _custom(Class, fn, _params) {
		const norm = util.normalizeParams(_params);
		norm.abort ?? (norm.abort = true);
		return new Class({
			type: "custom",
			check: "custom",
			fn,
			...norm
		});
	}
	function _refine(Class, fn, _params) {
		return new Class({
			type: "custom",
			check: "custom",
			fn,
			...util.normalizeParams(_params)
		});
	}
	function _superRefine(fn) {
		const ch = _check((payload) => {
			payload.addIssue = (issue) => {
				if (typeof issue === "string") payload.issues.push(util.issue(issue, payload.value, ch._zod.def));
				else {
					const _issue = issue;
					if (_issue.fatal) _issue.continue = false;
					_issue.code ?? (_issue.code = "custom");
					_issue.input ?? (_issue.input = payload.value);
					_issue.inst ?? (_issue.inst = ch);
					_issue.continue ?? (_issue.continue = !ch._zod.def.abort);
					payload.issues.push(util.issue(_issue));
				}
			};
			return fn(payload.value, payload);
		});
		return ch;
	}
	function _check(fn, params) {
		const ch = new checks.$ZodCheck({
			check: "custom",
			...util.normalizeParams(params)
		});
		ch._zod.check = fn;
		return ch;
	}
	function _stringbool(Classes, _params) {
		const params = util.normalizeParams(_params);
		let truthyArray = params.truthy ?? [
			"true",
			"1",
			"yes",
			"on",
			"y",
			"enabled"
		];
		let falsyArray = params.falsy ?? [
			"false",
			"0",
			"no",
			"off",
			"n",
			"disabled"
		];
		if (params.case !== "sensitive") {
			truthyArray = truthyArray.map((v) => typeof v === "string" ? v.toLowerCase() : v);
			falsyArray = falsyArray.map((v) => typeof v === "string" ? v.toLowerCase() : v);
		}
		const truthySet = new Set(truthyArray);
		const falsySet = new Set(falsyArray);
		const _Codec = Classes.Codec ?? schemas.$ZodCodec;
		const _Boolean = Classes.Boolean ?? schemas.$ZodBoolean;
		const codec = new _Codec({
			type: "pipe",
			in: new (Classes.String ?? schemas.$ZodString)({
				type: "string",
				error: params.error
			}),
			out: new _Boolean({
				type: "boolean",
				error: params.error
			}),
			transform: ((input, payload) => {
				let data = input;
				if (params.case !== "sensitive") data = data.toLowerCase();
				if (truthySet.has(data)) return true;
				else if (falsySet.has(data)) return false;
				else {
					payload.issues.push({
						code: "invalid_value",
						expected: "stringbool",
						values: [...truthySet, ...falsySet],
						input: payload.value,
						inst: codec,
						continue: false
					});
					return {};
				}
			}),
			reverseTransform: ((input, _payload) => {
				if (input === true) return truthyArray[0] || "true";
				else return falsyArray[0] || "false";
			}),
			error: params.error
		});
		return codec;
	}
	function _stringFormat(Class, format, fnOrRegex, _params = {}) {
		const params = util.normalizeParams(_params);
		const def = {
			...util.normalizeParams(_params),
			check: "string_format",
			type: "string",
			format,
			fn: typeof fnOrRegex === "function" ? fnOrRegex : (val) => fnOrRegex.test(val),
			...params
		};
		if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
		return new Class(def);
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/core/to-json-schema.cjs
var require_to_json_schema = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.JSONSchemaGenerator = void 0;
	exports.toJSONSchema = toJSONSchema;
	var registries_js_1 = require_registries();
	var util_js_1 = require_util();
	var JSONSchemaGenerator = class {
		constructor(params) {
			this.counter = 0;
			this.metadataRegistry = params?.metadata ?? registries_js_1.globalRegistry;
			this.target = params?.target ?? "draft-2020-12";
			this.unrepresentable = params?.unrepresentable ?? "throw";
			this.override = params?.override ?? (() => {});
			this.io = params?.io ?? "output";
			this.seen = /* @__PURE__ */ new Map();
		}
		process(schema, _params = {
			path: [],
			schemaPath: []
		}) {
			var _a;
			const def = schema._zod.def;
			const formatMap = {
				guid: "uuid",
				url: "uri",
				datetime: "date-time",
				json_string: "json-string",
				regex: ""
			};
			const seen = this.seen.get(schema);
			if (seen) {
				seen.count++;
				if (_params.schemaPath.includes(schema)) seen.cycle = _params.path;
				return seen.schema;
			}
			const result = {
				schema: {},
				count: 1,
				cycle: void 0,
				path: _params.path
			};
			this.seen.set(schema, result);
			const overrideSchema = schema._zod.toJSONSchema?.();
			if (overrideSchema) result.schema = overrideSchema;
			else {
				const params = {
					..._params,
					schemaPath: [..._params.schemaPath, schema],
					path: _params.path
				};
				const parent = schema._zod.parent;
				if (parent) {
					result.ref = parent;
					this.process(parent, params);
					this.seen.get(parent).isParent = true;
				} else {
					const _json = result.schema;
					switch (def.type) {
						case "string": {
							const json = _json;
							json.type = "string";
							const { minimum, maximum, format, patterns, contentEncoding } = schema._zod.bag;
							if (typeof minimum === "number") json.minLength = minimum;
							if (typeof maximum === "number") json.maxLength = maximum;
							if (format) {
								json.format = formatMap[format] ?? format;
								if (json.format === "") delete json.format;
							}
							if (contentEncoding) json.contentEncoding = contentEncoding;
							if (patterns && patterns.size > 0) {
								const regexes = [...patterns];
								if (regexes.length === 1) json.pattern = regexes[0].source;
								else if (regexes.length > 1) result.schema.allOf = [...regexes.map((regex) => ({
									...this.target === "draft-7" || this.target === "draft-4" || this.target === "openapi-3.0" ? { type: "string" } : {},
									pattern: regex.source
								}))];
							}
							break;
						}
						case "number": {
							const json = _json;
							const { minimum, maximum, format, multipleOf, exclusiveMaximum, exclusiveMinimum } = schema._zod.bag;
							if (typeof format === "string" && format.includes("int")) json.type = "integer";
							else json.type = "number";
							if (typeof exclusiveMinimum === "number") {
								if (this.target === "draft-4" || this.target === "openapi-3.0") {
									json.minimum = exclusiveMinimum;
									json.exclusiveMinimum = true;
								} else json.exclusiveMinimum = exclusiveMinimum;
							}
							if (typeof minimum === "number") {
								json.minimum = minimum;
								if (typeof exclusiveMinimum === "number" && this.target !== "draft-4") {
									if (exclusiveMinimum >= minimum) delete json.minimum;
									else delete json.exclusiveMinimum;
								}
							}
							if (typeof exclusiveMaximum === "number") {
								if (this.target === "draft-4" || this.target === "openapi-3.0") {
									json.maximum = exclusiveMaximum;
									json.exclusiveMaximum = true;
								} else json.exclusiveMaximum = exclusiveMaximum;
							}
							if (typeof maximum === "number") {
								json.maximum = maximum;
								if (typeof exclusiveMaximum === "number" && this.target !== "draft-4") {
									if (exclusiveMaximum <= maximum) delete json.maximum;
									else delete json.exclusiveMaximum;
								}
							}
							if (typeof multipleOf === "number") json.multipleOf = multipleOf;
							break;
						}
						case "boolean": {
							const json = _json;
							json.type = "boolean";
							break;
						}
						case "bigint":
							if (this.unrepresentable === "throw") throw new Error("BigInt cannot be represented in JSON Schema");
							break;
						case "symbol":
							if (this.unrepresentable === "throw") throw new Error("Symbols cannot be represented in JSON Schema");
							break;
						case "null":
							if (this.target === "openapi-3.0") {
								_json.type = "string";
								_json.nullable = true;
								_json.enum = [null];
							} else _json.type = "null";
							break;
						case "any": break;
						case "unknown": break;
						case "undefined":
							if (this.unrepresentable === "throw") throw new Error("Undefined cannot be represented in JSON Schema");
							break;
						case "void":
							if (this.unrepresentable === "throw") throw new Error("Void cannot be represented in JSON Schema");
							break;
						case "never":
							_json.not = {};
							break;
						case "date":
							if (this.unrepresentable === "throw") throw new Error("Date cannot be represented in JSON Schema");
							break;
						case "array": {
							const json = _json;
							const { minimum, maximum } = schema._zod.bag;
							if (typeof minimum === "number") json.minItems = minimum;
							if (typeof maximum === "number") json.maxItems = maximum;
							json.type = "array";
							json.items = this.process(def.element, {
								...params,
								path: [...params.path, "items"]
							});
							break;
						}
						case "object": {
							const json = _json;
							json.type = "object";
							json.properties = {};
							const shape = def.shape;
							for (const key in shape) json.properties[key] = this.process(shape[key], {
								...params,
								path: [
									...params.path,
									"properties",
									key
								]
							});
							const allKeys = new Set(Object.keys(shape));
							const requiredKeys = new Set([...allKeys].filter((key) => {
								const v = def.shape[key]._zod;
								if (this.io === "input") return v.optin === void 0;
								else return v.optout === void 0;
							}));
							if (requiredKeys.size > 0) json.required = Array.from(requiredKeys);
							if (def.catchall?._zod.def.type === "never") json.additionalProperties = false;
							else if (!def.catchall) {
								if (this.io === "output") json.additionalProperties = false;
							} else if (def.catchall) json.additionalProperties = this.process(def.catchall, {
								...params,
								path: [...params.path, "additionalProperties"]
							});
							break;
						}
						case "union": {
							const json = _json;
							json.anyOf = def.options.map((x, i) => this.process(x, {
								...params,
								path: [
									...params.path,
									"anyOf",
									i
								]
							}));
							break;
						}
						case "intersection": {
							const json = _json;
							const a = this.process(def.left, {
								...params,
								path: [
									...params.path,
									"allOf",
									0
								]
							});
							const b = this.process(def.right, {
								...params,
								path: [
									...params.path,
									"allOf",
									1
								]
							});
							const isSimpleIntersection = (val) => "allOf" in val && Object.keys(val).length === 1;
							json.allOf = [...isSimpleIntersection(a) ? a.allOf : [a], ...isSimpleIntersection(b) ? b.allOf : [b]];
							break;
						}
						case "tuple": {
							const json = _json;
							json.type = "array";
							const prefixPath = this.target === "draft-2020-12" ? "prefixItems" : "items";
							const restPath = this.target === "draft-2020-12" ? "items" : this.target === "openapi-3.0" ? "items" : "additionalItems";
							const prefixItems = def.items.map((x, i) => this.process(x, {
								...params,
								path: [
									...params.path,
									prefixPath,
									i
								]
							}));
							const rest = def.rest ? this.process(def.rest, {
								...params,
								path: [
									...params.path,
									restPath,
									...this.target === "openapi-3.0" ? [def.items.length] : []
								]
							}) : null;
							if (this.target === "draft-2020-12") {
								json.prefixItems = prefixItems;
								if (rest) json.items = rest;
							} else if (this.target === "openapi-3.0") {
								json.items = { anyOf: prefixItems };
								if (rest) json.items.anyOf.push(rest);
								json.minItems = prefixItems.length;
								if (!rest) json.maxItems = prefixItems.length;
							} else {
								json.items = prefixItems;
								if (rest) json.additionalItems = rest;
							}
							const { minimum, maximum } = schema._zod.bag;
							if (typeof minimum === "number") json.minItems = minimum;
							if (typeof maximum === "number") json.maxItems = maximum;
							break;
						}
						case "record": {
							const json = _json;
							json.type = "object";
							if (this.target === "draft-7" || this.target === "draft-2020-12") json.propertyNames = this.process(def.keyType, {
								...params,
								path: [...params.path, "propertyNames"]
							});
							json.additionalProperties = this.process(def.valueType, {
								...params,
								path: [...params.path, "additionalProperties"]
							});
							break;
						}
						case "map":
							if (this.unrepresentable === "throw") throw new Error("Map cannot be represented in JSON Schema");
							break;
						case "set":
							if (this.unrepresentable === "throw") throw new Error("Set cannot be represented in JSON Schema");
							break;
						case "enum": {
							const json = _json;
							const values = (0, util_js_1.getEnumValues)(def.entries);
							if (values.every((v) => typeof v === "number")) json.type = "number";
							if (values.every((v) => typeof v === "string")) json.type = "string";
							json.enum = values;
							break;
						}
						case "literal": {
							const json = _json;
							const vals = [];
							for (const val of def.values) if (val === void 0) {
								if (this.unrepresentable === "throw") throw new Error("Literal `undefined` cannot be represented in JSON Schema");
							} else if (typeof val === "bigint") {
								if (this.unrepresentable === "throw") throw new Error("BigInt literals cannot be represented in JSON Schema");
								else vals.push(Number(val));
							} else vals.push(val);
							if (vals.length === 0) {} else if (vals.length === 1) {
								const val = vals[0];
								json.type = val === null ? "null" : typeof val;
								if (this.target === "draft-4" || this.target === "openapi-3.0") json.enum = [val];
								else json.const = val;
							} else {
								if (vals.every((v) => typeof v === "number")) json.type = "number";
								if (vals.every((v) => typeof v === "string")) json.type = "string";
								if (vals.every((v) => typeof v === "boolean")) json.type = "string";
								if (vals.every((v) => v === null)) json.type = "null";
								json.enum = vals;
							}
							break;
						}
						case "file": {
							const json = _json;
							const file = {
								type: "string",
								format: "binary",
								contentEncoding: "binary"
							};
							const { minimum, maximum, mime } = schema._zod.bag;
							if (minimum !== void 0) file.minLength = minimum;
							if (maximum !== void 0) file.maxLength = maximum;
							if (mime) {
								if (mime.length === 1) {
									file.contentMediaType = mime[0];
									Object.assign(json, file);
								} else json.anyOf = mime.map((m) => {
									return {
										...file,
										contentMediaType: m
									};
								});
							} else Object.assign(json, file);
							break;
						}
						case "transform":
							if (this.unrepresentable === "throw") throw new Error("Transforms cannot be represented in JSON Schema");
							break;
						case "nullable": {
							const inner = this.process(def.innerType, params);
							if (this.target === "openapi-3.0") {
								result.ref = def.innerType;
								_json.nullable = true;
							} else _json.anyOf = [inner, { type: "null" }];
							break;
						}
						case "nonoptional":
							this.process(def.innerType, params);
							result.ref = def.innerType;
							break;
						case "success": {
							const json = _json;
							json.type = "boolean";
							break;
						}
						case "default":
							this.process(def.innerType, params);
							result.ref = def.innerType;
							_json.default = JSON.parse(JSON.stringify(def.defaultValue));
							break;
						case "prefault":
							this.process(def.innerType, params);
							result.ref = def.innerType;
							if (this.io === "input") _json._prefault = JSON.parse(JSON.stringify(def.defaultValue));
							break;
						case "catch": {
							this.process(def.innerType, params);
							result.ref = def.innerType;
							let catchValue;
							try {
								catchValue = def.catchValue(void 0);
							} catch {
								throw new Error("Dynamic catch values are not supported in JSON Schema");
							}
							_json.default = catchValue;
							break;
						}
						case "nan":
							if (this.unrepresentable === "throw") throw new Error("NaN cannot be represented in JSON Schema");
							break;
						case "template_literal": {
							const json = _json;
							const pattern = schema._zod.pattern;
							if (!pattern) throw new Error("Pattern not found in template literal");
							json.type = "string";
							json.pattern = pattern.source;
							break;
						}
						case "pipe": {
							const innerType = this.io === "input" ? def.in._zod.def.type === "transform" ? def.out : def.in : def.out;
							this.process(innerType, params);
							result.ref = innerType;
							break;
						}
						case "readonly":
							this.process(def.innerType, params);
							result.ref = def.innerType;
							_json.readOnly = true;
							break;
						case "promise":
							this.process(def.innerType, params);
							result.ref = def.innerType;
							break;
						case "optional":
							this.process(def.innerType, params);
							result.ref = def.innerType;
							break;
						case "lazy": {
							const innerType = schema._zod.innerType;
							this.process(innerType, params);
							result.ref = innerType;
							break;
						}
						case "custom":
							if (this.unrepresentable === "throw") throw new Error("Custom types cannot be represented in JSON Schema");
							break;
						case "function": if (this.unrepresentable === "throw") throw new Error("Function types cannot be represented in JSON Schema");
					}
				}
			}
			const meta = this.metadataRegistry.get(schema);
			if (meta) Object.assign(result.schema, meta);
			if (this.io === "input" && isTransforming(schema)) {
				delete result.schema.examples;
				delete result.schema.default;
			}
			if (this.io === "input" && result.schema._prefault) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
			delete result.schema._prefault;
			return this.seen.get(schema).schema;
		}
		emit(schema, _params) {
			const params = {
				cycles: _params?.cycles ?? "ref",
				reused: _params?.reused ?? "inline",
				external: _params?.external ?? void 0
			};
			const root = this.seen.get(schema);
			if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
			const makeURI = (entry) => {
				const defsSegment = this.target === "draft-2020-12" ? "$defs" : "definitions";
				if (params.external) {
					const externalId = params.external.registry.get(entry[0])?.id;
					const uriGenerator = params.external.uri ?? ((id) => id);
					if (externalId) return { ref: uriGenerator(externalId) };
					const id = entry[1].defId ?? entry[1].schema.id ?? `schema${this.counter++}`;
					entry[1].defId = id;
					return {
						defId: id,
						ref: `${uriGenerator("__shared")}#/${defsSegment}/${id}`
					};
				}
				if (entry[1] === root) return { ref: "#" };
				const defUriPrefix = `#/${defsSegment}/`;
				const defId = entry[1].schema.id ?? `__schema${this.counter++}`;
				return {
					defId,
					ref: defUriPrefix + defId
				};
			};
			const extractToDef = (entry) => {
				if (entry[1].schema.$ref) return;
				const seen = entry[1];
				const { ref, defId } = makeURI(entry);
				seen.def = { ...seen.schema };
				if (defId) seen.defId = defId;
				const schema = seen.schema;
				for (const key in schema) delete schema[key];
				schema.$ref = ref;
			};
			if (params.cycles === "throw") for (const entry of this.seen.entries()) {
				const seen = entry[1];
				if (seen.cycle) throw new Error(`Cycle detected: #/${seen.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
			}
			for (const entry of this.seen.entries()) {
				const seen = entry[1];
				if (schema === entry[0]) {
					extractToDef(entry);
					continue;
				}
				if (params.external) {
					const ext = params.external.registry.get(entry[0])?.id;
					if (schema !== entry[0] && ext) {
						extractToDef(entry);
						continue;
					}
				}
				if (this.metadataRegistry.get(entry[0])?.id) {
					extractToDef(entry);
					continue;
				}
				if (seen.cycle) {
					extractToDef(entry);
					continue;
				}
				if (seen.count > 1) {
					if (params.reused === "ref") {
						extractToDef(entry);
						continue;
					}
				}
			}
			const flattenRef = (zodSchema, params) => {
				const seen = this.seen.get(zodSchema);
				const schema = seen.def ?? seen.schema;
				const _cached = { ...schema };
				if (seen.ref === null) return;
				const ref = seen.ref;
				seen.ref = null;
				if (ref) {
					flattenRef(ref, params);
					const refSchema = this.seen.get(ref).schema;
					if (refSchema.$ref && (params.target === "draft-7" || params.target === "draft-4" || params.target === "openapi-3.0")) {
						schema.allOf = schema.allOf ?? [];
						schema.allOf.push(refSchema);
					} else {
						Object.assign(schema, refSchema);
						Object.assign(schema, _cached);
					}
				}
				if (!seen.isParent) this.override({
					zodSchema,
					jsonSchema: schema,
					path: seen.path ?? []
				});
			};
			for (const entry of [...this.seen.entries()].reverse()) flattenRef(entry[0], { target: this.target });
			const result = {};
			if (this.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
			else if (this.target === "draft-7") result.$schema = "http://json-schema.org/draft-07/schema#";
			else if (this.target === "draft-4") result.$schema = "http://json-schema.org/draft-04/schema#";
			else if (this.target === "openapi-3.0") {} else console.warn(`Invalid target: ${this.target}`);
			if (params.external?.uri) {
				const id = params.external.registry.get(schema)?.id;
				if (!id) throw new Error("Schema is missing an `id` property");
				result.$id = params.external.uri(id);
			}
			Object.assign(result, root.def);
			const defs = params.external?.defs ?? {};
			for (const entry of this.seen.entries()) {
				const seen = entry[1];
				if (seen.def && seen.defId) defs[seen.defId] = seen.def;
			}
			if (params.external) {} else if (Object.keys(defs).length > 0) {
				if (this.target === "draft-2020-12") result.$defs = defs;
				else result.definitions = defs;
			}
			try {
				return JSON.parse(JSON.stringify(result));
			} catch (_err) {
				throw new Error("Error converting schema to JSON.");
			}
		}
	};
	exports.JSONSchemaGenerator = JSONSchemaGenerator;
	function toJSONSchema(input, _params) {
		if (input instanceof registries_js_1.$ZodRegistry) {
			const gen = new JSONSchemaGenerator(_params);
			const defs = {};
			for (const entry of input._idmap.entries()) {
				const [_, schema] = entry;
				gen.process(schema);
			}
			const schemas = {};
			const external = {
				registry: input,
				uri: _params?.uri,
				defs
			};
			for (const entry of input._idmap.entries()) {
				const [key, schema] = entry;
				schemas[key] = gen.emit(schema, {
					..._params,
					external
				});
			}
			if (Object.keys(defs).length > 0) schemas.__shared = { [gen.target === "draft-2020-12" ? "$defs" : "definitions"]: defs };
			return { schemas };
		}
		const gen = new JSONSchemaGenerator(_params);
		gen.process(input);
		return gen.emit(input, _params);
	}
	function isTransforming(_schema, _ctx) {
		const ctx = _ctx ?? { seen: /* @__PURE__ */ new Set() };
		if (ctx.seen.has(_schema)) return false;
		ctx.seen.add(_schema);
		const def = _schema._zod.def;
		switch (def.type) {
			case "string":
			case "number":
			case "bigint":
			case "boolean":
			case "date":
			case "symbol":
			case "undefined":
			case "null":
			case "any":
			case "unknown":
			case "never":
			case "void":
			case "literal":
			case "enum":
			case "nan":
			case "file":
			case "template_literal": return false;
			case "array": return isTransforming(def.element, ctx);
			case "object":
				for (const key in def.shape) if (isTransforming(def.shape[key], ctx)) return true;
				return false;
			case "union":
				for (const option of def.options) if (isTransforming(option, ctx)) return true;
				return false;
			case "intersection": return isTransforming(def.left, ctx) || isTransforming(def.right, ctx);
			case "tuple":
				for (const item of def.items) if (isTransforming(item, ctx)) return true;
				if (def.rest && isTransforming(def.rest, ctx)) return true;
				return false;
			case "record": return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
			case "map": return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
			case "set": return isTransforming(def.valueType, ctx);
			case "promise":
			case "optional":
			case "nonoptional":
			case "nullable":
			case "readonly": return isTransforming(def.innerType, ctx);
			case "lazy": return isTransforming(def.getter(), ctx);
			case "default": return isTransforming(def.innerType, ctx);
			case "prefault": return isTransforming(def.innerType, ctx);
			case "custom": return false;
			case "transform": return true;
			case "pipe": return isTransforming(def.in, ctx) || isTransforming(def.out, ctx);
			case "success": return false;
			case "catch": return false;
			case "function": return false;
		}
		throw new Error(`Unknown schema type: ${def.type}`);
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/core/json-schema.cjs
var require_json_schema = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
}));
//#endregion
//#region ../../node_modules/zod/v4/core/index.cjs
var require_core = /* @__PURE__ */ __commonJSMin(((exports, module, this$32) => {
	var __createBinding = this$32 && this$32.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$32 && this$32.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __exportStar = this$32 && this$32.__exportStar || function(m, exports) {
		for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	var __importStar = this$32 && this$32.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.JSONSchema = exports.locales = exports.regexes = exports.util = void 0;
	__exportStar(require_core$1(), exports);
	__exportStar(require_parse$2(), exports);
	__exportStar(require_errors$3(), exports);
	__exportStar(require_schemas$1(), exports);
	__exportStar(require_checks$1(), exports);
	__exportStar(require_versions(), exports);
	exports.util = __importStar(require_util());
	exports.regexes = __importStar(require_regexes());
	exports.locales = __importStar(require_locales());
	__exportStar(require_registries(), exports);
	__exportStar(require_doc(), exports);
	__exportStar(require_api(), exports);
	__exportStar(require_to_json_schema(), exports);
	exports.JSONSchema = __importStar(require_json_schema());
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/checks.cjs
var require_checks = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.toUpperCase = exports.toLowerCase = exports.trim = exports.normalize = exports.overwrite = exports.mime = exports.property = exports.endsWith = exports.startsWith = exports.includes = exports.uppercase = exports.lowercase = exports.regex = exports.length = exports.minLength = exports.maxLength = exports.size = exports.minSize = exports.maxSize = exports.multipleOf = exports.nonnegative = exports.nonpositive = exports.negative = exports.positive = exports.gte = exports.gt = exports.lte = exports.lt = void 0;
	var index_js_1 = require_core();
	Object.defineProperty(exports, "lt", {
		enumerable: true,
		get: function() {
			return index_js_1._lt;
		}
	});
	Object.defineProperty(exports, "lte", {
		enumerable: true,
		get: function() {
			return index_js_1._lte;
		}
	});
	Object.defineProperty(exports, "gt", {
		enumerable: true,
		get: function() {
			return index_js_1._gt;
		}
	});
	Object.defineProperty(exports, "gte", {
		enumerable: true,
		get: function() {
			return index_js_1._gte;
		}
	});
	Object.defineProperty(exports, "positive", {
		enumerable: true,
		get: function() {
			return index_js_1._positive;
		}
	});
	Object.defineProperty(exports, "negative", {
		enumerable: true,
		get: function() {
			return index_js_1._negative;
		}
	});
	Object.defineProperty(exports, "nonpositive", {
		enumerable: true,
		get: function() {
			return index_js_1._nonpositive;
		}
	});
	Object.defineProperty(exports, "nonnegative", {
		enumerable: true,
		get: function() {
			return index_js_1._nonnegative;
		}
	});
	Object.defineProperty(exports, "multipleOf", {
		enumerable: true,
		get: function() {
			return index_js_1._multipleOf;
		}
	});
	Object.defineProperty(exports, "maxSize", {
		enumerable: true,
		get: function() {
			return index_js_1._maxSize;
		}
	});
	Object.defineProperty(exports, "minSize", {
		enumerable: true,
		get: function() {
			return index_js_1._minSize;
		}
	});
	Object.defineProperty(exports, "size", {
		enumerable: true,
		get: function() {
			return index_js_1._size;
		}
	});
	Object.defineProperty(exports, "maxLength", {
		enumerable: true,
		get: function() {
			return index_js_1._maxLength;
		}
	});
	Object.defineProperty(exports, "minLength", {
		enumerable: true,
		get: function() {
			return index_js_1._minLength;
		}
	});
	Object.defineProperty(exports, "length", {
		enumerable: true,
		get: function() {
			return index_js_1._length;
		}
	});
	Object.defineProperty(exports, "regex", {
		enumerable: true,
		get: function() {
			return index_js_1._regex;
		}
	});
	Object.defineProperty(exports, "lowercase", {
		enumerable: true,
		get: function() {
			return index_js_1._lowercase;
		}
	});
	Object.defineProperty(exports, "uppercase", {
		enumerable: true,
		get: function() {
			return index_js_1._uppercase;
		}
	});
	Object.defineProperty(exports, "includes", {
		enumerable: true,
		get: function() {
			return index_js_1._includes;
		}
	});
	Object.defineProperty(exports, "startsWith", {
		enumerable: true,
		get: function() {
			return index_js_1._startsWith;
		}
	});
	Object.defineProperty(exports, "endsWith", {
		enumerable: true,
		get: function() {
			return index_js_1._endsWith;
		}
	});
	Object.defineProperty(exports, "property", {
		enumerable: true,
		get: function() {
			return index_js_1._property;
		}
	});
	Object.defineProperty(exports, "mime", {
		enumerable: true,
		get: function() {
			return index_js_1._mime;
		}
	});
	Object.defineProperty(exports, "overwrite", {
		enumerable: true,
		get: function() {
			return index_js_1._overwrite;
		}
	});
	Object.defineProperty(exports, "normalize", {
		enumerable: true,
		get: function() {
			return index_js_1._normalize;
		}
	});
	Object.defineProperty(exports, "trim", {
		enumerable: true,
		get: function() {
			return index_js_1._trim;
		}
	});
	Object.defineProperty(exports, "toLowerCase", {
		enumerable: true,
		get: function() {
			return index_js_1._toLowerCase;
		}
	});
	Object.defineProperty(exports, "toUpperCase", {
		enumerable: true,
		get: function() {
			return index_js_1._toUpperCase;
		}
	});
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/iso.cjs
var require_iso = /* @__PURE__ */ __commonJSMin(((exports, module, this$31) => {
	var __createBinding = this$31 && this$31.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$31 && this$31.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$31 && this$31.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZodISODuration = exports.ZodISOTime = exports.ZodISODate = exports.ZodISODateTime = void 0;
	exports.datetime = datetime;
	exports.date = date;
	exports.time = time;
	exports.duration = duration;
	var core = __importStar(require_core());
	var schemas = __importStar(require_schemas());
	exports.ZodISODateTime = core.$constructor("ZodISODateTime", (inst, def) => {
		core.$ZodISODateTime.init(inst, def);
		schemas.ZodStringFormat.init(inst, def);
	});
	function datetime(params) {
		return core._isoDateTime(exports.ZodISODateTime, params);
	}
	exports.ZodISODate = core.$constructor("ZodISODate", (inst, def) => {
		core.$ZodISODate.init(inst, def);
		schemas.ZodStringFormat.init(inst, def);
	});
	function date(params) {
		return core._isoDate(exports.ZodISODate, params);
	}
	exports.ZodISOTime = core.$constructor("ZodISOTime", (inst, def) => {
		core.$ZodISOTime.init(inst, def);
		schemas.ZodStringFormat.init(inst, def);
	});
	function time(params) {
		return core._isoTime(exports.ZodISOTime, params);
	}
	exports.ZodISODuration = core.$constructor("ZodISODuration", (inst, def) => {
		core.$ZodISODuration.init(inst, def);
		schemas.ZodStringFormat.init(inst, def);
	});
	function duration(params) {
		return core._isoDuration(exports.ZodISODuration, params);
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/errors.cjs
var require_errors$2 = /* @__PURE__ */ __commonJSMin(((exports, module, this$30) => {
	var __createBinding = this$30 && this$30.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$30 && this$30.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$30 && this$30.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZodRealError = exports.ZodError = void 0;
	var core = __importStar(require_core());
	var index_js_1 = require_core();
	var util = __importStar(require_util());
	var initializer = (inst, issues) => {
		index_js_1.$ZodError.init(inst, issues);
		inst.name = "ZodError";
		Object.defineProperties(inst, {
			format: { value: (mapper) => core.formatError(inst, mapper) },
			flatten: { value: (mapper) => core.flattenError(inst, mapper) },
			addIssue: { value: (issue) => {
				inst.issues.push(issue);
				inst.message = JSON.stringify(inst.issues, util.jsonStringifyReplacer, 2);
			} },
			addIssues: { value: (issues) => {
				inst.issues.push(...issues);
				inst.message = JSON.stringify(inst.issues, util.jsonStringifyReplacer, 2);
			} },
			isEmpty: { get() {
				return inst.issues.length === 0;
			} }
		});
	};
	exports.ZodError = core.$constructor("ZodError", initializer);
	exports.ZodRealError = core.$constructor("ZodError", initializer, { Parent: Error });
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/parse.cjs
var require_parse$1 = /* @__PURE__ */ __commonJSMin(((exports, module, this$29) => {
	var __createBinding = this$29 && this$29.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$29 && this$29.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$29 && this$29.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeDecodeAsync = exports.safeEncodeAsync = exports.safeDecode = exports.safeEncode = exports.decodeAsync = exports.encodeAsync = exports.decode = exports.encode = exports.safeParseAsync = exports.safeParse = exports.parseAsync = exports.parse = void 0;
	var core = __importStar(require_core());
	var errors_js_1 = require_errors$2();
	exports.parse = core._parse(errors_js_1.ZodRealError);
	exports.parseAsync = core._parseAsync(errors_js_1.ZodRealError);
	exports.safeParse = core._safeParse(errors_js_1.ZodRealError);
	exports.safeParseAsync = core._safeParseAsync(errors_js_1.ZodRealError);
	exports.encode = core._encode(errors_js_1.ZodRealError);
	exports.decode = core._decode(errors_js_1.ZodRealError);
	exports.encodeAsync = core._encodeAsync(errors_js_1.ZodRealError);
	exports.decodeAsync = core._decodeAsync(errors_js_1.ZodRealError);
	exports.safeEncode = core._safeEncode(errors_js_1.ZodRealError);
	exports.safeDecode = core._safeDecode(errors_js_1.ZodRealError);
	exports.safeEncodeAsync = core._safeEncodeAsync(errors_js_1.ZodRealError);
	exports.safeDecodeAsync = core._safeDecodeAsync(errors_js_1.ZodRealError);
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/schemas.cjs
var require_schemas = /* @__PURE__ */ __commonJSMin(((exports, module, this$28) => {
	var __createBinding = this$28 && this$28.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$28 && this$28.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$28 && this$28.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZodTransform = exports.ZodFile = exports.ZodLiteral = exports.ZodEnum = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodDate = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodBigIntFormat = exports.ZodBigInt = exports.ZodBoolean = exports.ZodNumberFormat = exports.ZodNumber = exports.ZodCustomStringFormat = exports.ZodJWT = exports.ZodE164 = exports.ZodBase64URL = exports.ZodBase64 = exports.ZodCIDRv6 = exports.ZodCIDRv4 = exports.ZodIPv6 = exports.ZodIPv4 = exports.ZodKSUID = exports.ZodXID = exports.ZodULID = exports.ZodCUID2 = exports.ZodCUID = exports.ZodNanoID = exports.ZodEmoji = exports.ZodURL = exports.ZodUUID = exports.ZodGUID = exports.ZodEmail = exports.ZodStringFormat = exports.ZodString = exports._ZodString = exports.ZodType = void 0;
	exports.stringbool = exports.ZodCustom = exports.ZodFunction = exports.ZodPromise = exports.ZodLazy = exports.ZodTemplateLiteral = exports.ZodReadonly = exports.ZodCodec = exports.ZodPipe = exports.ZodNaN = exports.ZodCatch = exports.ZodSuccess = exports.ZodNonOptional = exports.ZodPrefault = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = void 0;
	exports.string = string;
	exports.email = email;
	exports.guid = guid;
	exports.uuid = uuid;
	exports.uuidv4 = uuidv4;
	exports.uuidv6 = uuidv6;
	exports.uuidv7 = uuidv7;
	exports.url = url;
	exports.httpUrl = httpUrl;
	exports.emoji = emoji;
	exports.nanoid = nanoid;
	exports.cuid = cuid;
	exports.cuid2 = cuid2;
	exports.ulid = ulid;
	exports.xid = xid;
	exports.ksuid = ksuid;
	exports.ipv4 = ipv4;
	exports.ipv6 = ipv6;
	exports.cidrv4 = cidrv4;
	exports.cidrv6 = cidrv6;
	exports.base64 = base64;
	exports.base64url = base64url;
	exports.e164 = e164;
	exports.jwt = jwt;
	exports.stringFormat = stringFormat;
	exports.hostname = hostname;
	exports.hex = hex;
	exports.hash = hash;
	exports.number = number;
	exports.int = int;
	exports.float32 = float32;
	exports.float64 = float64;
	exports.int32 = int32;
	exports.uint32 = uint32;
	exports.boolean = boolean;
	exports.bigint = bigint;
	exports.int64 = int64;
	exports.uint64 = uint64;
	exports.symbol = symbol;
	exports.undefined = _undefined;
	exports.null = _null;
	exports.any = any;
	exports.unknown = unknown;
	exports.never = never;
	exports.void = _void;
	exports.date = date;
	exports.array = array;
	exports.keyof = keyof;
	exports.object = object;
	exports.strictObject = strictObject;
	exports.looseObject = looseObject;
	exports.union = union;
	exports.discriminatedUnion = discriminatedUnion;
	exports.intersection = intersection;
	exports.tuple = tuple;
	exports.record = record;
	exports.partialRecord = partialRecord;
	exports.map = map;
	exports.set = set;
	exports.enum = _enum;
	exports.nativeEnum = nativeEnum;
	exports.literal = literal;
	exports.file = file;
	exports.transform = transform;
	exports.optional = optional;
	exports.nullable = nullable;
	exports.nullish = nullish;
	exports._default = _default;
	exports.prefault = prefault;
	exports.nonoptional = nonoptional;
	exports.success = success;
	exports.catch = _catch;
	exports.nan = nan;
	exports.pipe = pipe;
	exports.codec = codec;
	exports.readonly = readonly;
	exports.templateLiteral = templateLiteral;
	exports.lazy = lazy;
	exports.promise = promise;
	exports._function = _function;
	exports.function = _function;
	exports._function = _function;
	exports.function = _function;
	exports.check = check;
	exports.custom = custom;
	exports.refine = refine;
	exports.superRefine = superRefine;
	exports.instanceof = _instanceof;
	exports.json = json;
	exports.preprocess = preprocess;
	var core = __importStar(require_core());
	var index_js_1 = require_core();
	var checks = __importStar(require_checks());
	var iso = __importStar(require_iso());
	var parse = __importStar(require_parse$1());
	exports.ZodType = core.$constructor("ZodType", (inst, def) => {
		core.$ZodType.init(inst, def);
		inst.def = def;
		inst.type = def.type;
		Object.defineProperty(inst, "_def", { value: def });
		inst.check = (...checks) => {
			return inst.clone({
				...def,
				checks: [...def.checks ?? [], ...checks.map((ch) => typeof ch === "function" ? { _zod: {
					check: ch,
					def: { check: "custom" },
					onattach: []
				} } : ch)]
			});
		};
		inst.clone = (def, params) => core.clone(inst, def, params);
		inst.brand = () => inst;
		inst.register = ((reg, meta) => {
			reg.add(inst, meta);
			return inst;
		});
		inst.parse = (data, params) => parse.parse(inst, data, params, { callee: inst.parse });
		inst.safeParse = (data, params) => parse.safeParse(inst, data, params);
		inst.parseAsync = async (data, params) => parse.parseAsync(inst, data, params, { callee: inst.parseAsync });
		inst.safeParseAsync = async (data, params) => parse.safeParseAsync(inst, data, params);
		inst.spa = inst.safeParseAsync;
		inst.encode = (data, params) => parse.encode(inst, data, params);
		inst.decode = (data, params) => parse.decode(inst, data, params);
		inst.encodeAsync = async (data, params) => parse.encodeAsync(inst, data, params);
		inst.decodeAsync = async (data, params) => parse.decodeAsync(inst, data, params);
		inst.safeEncode = (data, params) => parse.safeEncode(inst, data, params);
		inst.safeDecode = (data, params) => parse.safeDecode(inst, data, params);
		inst.safeEncodeAsync = async (data, params) => parse.safeEncodeAsync(inst, data, params);
		inst.safeDecodeAsync = async (data, params) => parse.safeDecodeAsync(inst, data, params);
		inst.refine = (check, params) => inst.check(refine(check, params));
		inst.superRefine = (refinement) => inst.check(superRefine(refinement));
		inst.overwrite = (fn) => inst.check(checks.overwrite(fn));
		inst.optional = () => optional(inst);
		inst.nullable = () => nullable(inst);
		inst.nullish = () => optional(nullable(inst));
		inst.nonoptional = (params) => nonoptional(inst, params);
		inst.array = () => array(inst);
		inst.or = (arg) => union([inst, arg]);
		inst.and = (arg) => intersection(inst, arg);
		inst.transform = (tx) => pipe(inst, transform(tx));
		inst.default = (def) => _default(inst, def);
		inst.prefault = (def) => prefault(inst, def);
		inst.catch = (params) => _catch(inst, params);
		inst.pipe = (target) => pipe(inst, target);
		inst.readonly = () => readonly(inst);
		inst.describe = (description) => {
			const cl = inst.clone();
			core.globalRegistry.add(cl, { description });
			return cl;
		};
		Object.defineProperty(inst, "description", {
			get() {
				return core.globalRegistry.get(inst)?.description;
			},
			configurable: true
		});
		inst.meta = (...args) => {
			if (args.length === 0) return core.globalRegistry.get(inst);
			const cl = inst.clone();
			core.globalRegistry.add(cl, args[0]);
			return cl;
		};
		inst.isOptional = () => inst.safeParse(void 0).success;
		inst.isNullable = () => inst.safeParse(null).success;
		return inst;
	});
	/** @internal */
	exports._ZodString = core.$constructor("_ZodString", (inst, def) => {
		core.$ZodString.init(inst, def);
		exports.ZodType.init(inst, def);
		const bag = inst._zod.bag;
		inst.format = bag.format ?? null;
		inst.minLength = bag.minimum ?? null;
		inst.maxLength = bag.maximum ?? null;
		inst.regex = (...args) => inst.check(checks.regex(...args));
		inst.includes = (...args) => inst.check(checks.includes(...args));
		inst.startsWith = (...args) => inst.check(checks.startsWith(...args));
		inst.endsWith = (...args) => inst.check(checks.endsWith(...args));
		inst.min = (...args) => inst.check(checks.minLength(...args));
		inst.max = (...args) => inst.check(checks.maxLength(...args));
		inst.length = (...args) => inst.check(checks.length(...args));
		inst.nonempty = (...args) => inst.check(checks.minLength(1, ...args));
		inst.lowercase = (params) => inst.check(checks.lowercase(params));
		inst.uppercase = (params) => inst.check(checks.uppercase(params));
		inst.trim = () => inst.check(checks.trim());
		inst.normalize = (...args) => inst.check(checks.normalize(...args));
		inst.toLowerCase = () => inst.check(checks.toLowerCase());
		inst.toUpperCase = () => inst.check(checks.toUpperCase());
	});
	exports.ZodString = core.$constructor("ZodString", (inst, def) => {
		core.$ZodString.init(inst, def);
		exports._ZodString.init(inst, def);
		inst.email = (params) => inst.check(core._email(exports.ZodEmail, params));
		inst.url = (params) => inst.check(core._url(exports.ZodURL, params));
		inst.jwt = (params) => inst.check(core._jwt(exports.ZodJWT, params));
		inst.emoji = (params) => inst.check(core._emoji(exports.ZodEmoji, params));
		inst.guid = (params) => inst.check(core._guid(exports.ZodGUID, params));
		inst.uuid = (params) => inst.check(core._uuid(exports.ZodUUID, params));
		inst.uuidv4 = (params) => inst.check(core._uuidv4(exports.ZodUUID, params));
		inst.uuidv6 = (params) => inst.check(core._uuidv6(exports.ZodUUID, params));
		inst.uuidv7 = (params) => inst.check(core._uuidv7(exports.ZodUUID, params));
		inst.nanoid = (params) => inst.check(core._nanoid(exports.ZodNanoID, params));
		inst.guid = (params) => inst.check(core._guid(exports.ZodGUID, params));
		inst.cuid = (params) => inst.check(core._cuid(exports.ZodCUID, params));
		inst.cuid2 = (params) => inst.check(core._cuid2(exports.ZodCUID2, params));
		inst.ulid = (params) => inst.check(core._ulid(exports.ZodULID, params));
		inst.base64 = (params) => inst.check(core._base64(exports.ZodBase64, params));
		inst.base64url = (params) => inst.check(core._base64url(exports.ZodBase64URL, params));
		inst.xid = (params) => inst.check(core._xid(exports.ZodXID, params));
		inst.ksuid = (params) => inst.check(core._ksuid(exports.ZodKSUID, params));
		inst.ipv4 = (params) => inst.check(core._ipv4(exports.ZodIPv4, params));
		inst.ipv6 = (params) => inst.check(core._ipv6(exports.ZodIPv6, params));
		inst.cidrv4 = (params) => inst.check(core._cidrv4(exports.ZodCIDRv4, params));
		inst.cidrv6 = (params) => inst.check(core._cidrv6(exports.ZodCIDRv6, params));
		inst.e164 = (params) => inst.check(core._e164(exports.ZodE164, params));
		inst.datetime = (params) => inst.check(iso.datetime(params));
		inst.date = (params) => inst.check(iso.date(params));
		inst.time = (params) => inst.check(iso.time(params));
		inst.duration = (params) => inst.check(iso.duration(params));
	});
	function string(params) {
		return core._string(exports.ZodString, params);
	}
	exports.ZodStringFormat = core.$constructor("ZodStringFormat", (inst, def) => {
		core.$ZodStringFormat.init(inst, def);
		exports._ZodString.init(inst, def);
	});
	exports.ZodEmail = core.$constructor("ZodEmail", (inst, def) => {
		core.$ZodEmail.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function email(params) {
		return core._email(exports.ZodEmail, params);
	}
	exports.ZodGUID = core.$constructor("ZodGUID", (inst, def) => {
		core.$ZodGUID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function guid(params) {
		return core._guid(exports.ZodGUID, params);
	}
	exports.ZodUUID = core.$constructor("ZodUUID", (inst, def) => {
		core.$ZodUUID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function uuid(params) {
		return core._uuid(exports.ZodUUID, params);
	}
	function uuidv4(params) {
		return core._uuidv4(exports.ZodUUID, params);
	}
	function uuidv6(params) {
		return core._uuidv6(exports.ZodUUID, params);
	}
	function uuidv7(params) {
		return core._uuidv7(exports.ZodUUID, params);
	}
	exports.ZodURL = core.$constructor("ZodURL", (inst, def) => {
		core.$ZodURL.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function url(params) {
		return core._url(exports.ZodURL, params);
	}
	function httpUrl(params) {
		return core._url(exports.ZodURL, {
			protocol: /^https?$/,
			hostname: core.regexes.domain,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodEmoji = core.$constructor("ZodEmoji", (inst, def) => {
		core.$ZodEmoji.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function emoji(params) {
		return core._emoji(exports.ZodEmoji, params);
	}
	exports.ZodNanoID = core.$constructor("ZodNanoID", (inst, def) => {
		core.$ZodNanoID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function nanoid(params) {
		return core._nanoid(exports.ZodNanoID, params);
	}
	exports.ZodCUID = core.$constructor("ZodCUID", (inst, def) => {
		core.$ZodCUID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function cuid(params) {
		return core._cuid(exports.ZodCUID, params);
	}
	exports.ZodCUID2 = core.$constructor("ZodCUID2", (inst, def) => {
		core.$ZodCUID2.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function cuid2(params) {
		return core._cuid2(exports.ZodCUID2, params);
	}
	exports.ZodULID = core.$constructor("ZodULID", (inst, def) => {
		core.$ZodULID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function ulid(params) {
		return core._ulid(exports.ZodULID, params);
	}
	exports.ZodXID = core.$constructor("ZodXID", (inst, def) => {
		core.$ZodXID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function xid(params) {
		return core._xid(exports.ZodXID, params);
	}
	exports.ZodKSUID = core.$constructor("ZodKSUID", (inst, def) => {
		core.$ZodKSUID.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function ksuid(params) {
		return core._ksuid(exports.ZodKSUID, params);
	}
	exports.ZodIPv4 = core.$constructor("ZodIPv4", (inst, def) => {
		core.$ZodIPv4.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function ipv4(params) {
		return core._ipv4(exports.ZodIPv4, params);
	}
	exports.ZodIPv6 = core.$constructor("ZodIPv6", (inst, def) => {
		core.$ZodIPv6.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function ipv6(params) {
		return core._ipv6(exports.ZodIPv6, params);
	}
	exports.ZodCIDRv4 = core.$constructor("ZodCIDRv4", (inst, def) => {
		core.$ZodCIDRv4.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function cidrv4(params) {
		return core._cidrv4(exports.ZodCIDRv4, params);
	}
	exports.ZodCIDRv6 = core.$constructor("ZodCIDRv6", (inst, def) => {
		core.$ZodCIDRv6.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function cidrv6(params) {
		return core._cidrv6(exports.ZodCIDRv6, params);
	}
	exports.ZodBase64 = core.$constructor("ZodBase64", (inst, def) => {
		core.$ZodBase64.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function base64(params) {
		return core._base64(exports.ZodBase64, params);
	}
	exports.ZodBase64URL = core.$constructor("ZodBase64URL", (inst, def) => {
		core.$ZodBase64URL.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function base64url(params) {
		return core._base64url(exports.ZodBase64URL, params);
	}
	exports.ZodE164 = core.$constructor("ZodE164", (inst, def) => {
		core.$ZodE164.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function e164(params) {
		return core._e164(exports.ZodE164, params);
	}
	exports.ZodJWT = core.$constructor("ZodJWT", (inst, def) => {
		core.$ZodJWT.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function jwt(params) {
		return core._jwt(exports.ZodJWT, params);
	}
	exports.ZodCustomStringFormat = core.$constructor("ZodCustomStringFormat", (inst, def) => {
		core.$ZodCustomStringFormat.init(inst, def);
		exports.ZodStringFormat.init(inst, def);
	});
	function stringFormat(format, fnOrRegex, _params = {}) {
		return core._stringFormat(exports.ZodCustomStringFormat, format, fnOrRegex, _params);
	}
	function hostname(_params) {
		return core._stringFormat(exports.ZodCustomStringFormat, "hostname", core.regexes.hostname, _params);
	}
	function hex(_params) {
		return core._stringFormat(exports.ZodCustomStringFormat, "hex", core.regexes.hex, _params);
	}
	function hash(alg, params) {
		const format = `${alg}_${params?.enc ?? "hex"}`;
		const regex = core.regexes[format];
		if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
		return core._stringFormat(exports.ZodCustomStringFormat, format, regex, params);
	}
	exports.ZodNumber = core.$constructor("ZodNumber", (inst, def) => {
		core.$ZodNumber.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.gt = (value, params) => inst.check(checks.gt(value, params));
		inst.gte = (value, params) => inst.check(checks.gte(value, params));
		inst.min = (value, params) => inst.check(checks.gte(value, params));
		inst.lt = (value, params) => inst.check(checks.lt(value, params));
		inst.lte = (value, params) => inst.check(checks.lte(value, params));
		inst.max = (value, params) => inst.check(checks.lte(value, params));
		inst.int = (params) => inst.check(int(params));
		inst.safe = (params) => inst.check(int(params));
		inst.positive = (params) => inst.check(checks.gt(0, params));
		inst.nonnegative = (params) => inst.check(checks.gte(0, params));
		inst.negative = (params) => inst.check(checks.lt(0, params));
		inst.nonpositive = (params) => inst.check(checks.lte(0, params));
		inst.multipleOf = (value, params) => inst.check(checks.multipleOf(value, params));
		inst.step = (value, params) => inst.check(checks.multipleOf(value, params));
		inst.finite = () => inst;
		const bag = inst._zod.bag;
		inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
		inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
		inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? .5);
		inst.isFinite = true;
		inst.format = bag.format ?? null;
	});
	function number(params) {
		return core._number(exports.ZodNumber, params);
	}
	exports.ZodNumberFormat = core.$constructor("ZodNumberFormat", (inst, def) => {
		core.$ZodNumberFormat.init(inst, def);
		exports.ZodNumber.init(inst, def);
	});
	function int(params) {
		return core._int(exports.ZodNumberFormat, params);
	}
	function float32(params) {
		return core._float32(exports.ZodNumberFormat, params);
	}
	function float64(params) {
		return core._float64(exports.ZodNumberFormat, params);
	}
	function int32(params) {
		return core._int32(exports.ZodNumberFormat, params);
	}
	function uint32(params) {
		return core._uint32(exports.ZodNumberFormat, params);
	}
	exports.ZodBoolean = core.$constructor("ZodBoolean", (inst, def) => {
		core.$ZodBoolean.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function boolean(params) {
		return core._boolean(exports.ZodBoolean, params);
	}
	exports.ZodBigInt = core.$constructor("ZodBigInt", (inst, def) => {
		core.$ZodBigInt.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.gte = (value, params) => inst.check(checks.gte(value, params));
		inst.min = (value, params) => inst.check(checks.gte(value, params));
		inst.gt = (value, params) => inst.check(checks.gt(value, params));
		inst.gte = (value, params) => inst.check(checks.gte(value, params));
		inst.min = (value, params) => inst.check(checks.gte(value, params));
		inst.lt = (value, params) => inst.check(checks.lt(value, params));
		inst.lte = (value, params) => inst.check(checks.lte(value, params));
		inst.max = (value, params) => inst.check(checks.lte(value, params));
		inst.positive = (params) => inst.check(checks.gt(BigInt(0), params));
		inst.negative = (params) => inst.check(checks.lt(BigInt(0), params));
		inst.nonpositive = (params) => inst.check(checks.lte(BigInt(0), params));
		inst.nonnegative = (params) => inst.check(checks.gte(BigInt(0), params));
		inst.multipleOf = (value, params) => inst.check(checks.multipleOf(value, params));
		const bag = inst._zod.bag;
		inst.minValue = bag.minimum ?? null;
		inst.maxValue = bag.maximum ?? null;
		inst.format = bag.format ?? null;
	});
	function bigint(params) {
		return core._bigint(exports.ZodBigInt, params);
	}
	exports.ZodBigIntFormat = core.$constructor("ZodBigIntFormat", (inst, def) => {
		core.$ZodBigIntFormat.init(inst, def);
		exports.ZodBigInt.init(inst, def);
	});
	function int64(params) {
		return core._int64(exports.ZodBigIntFormat, params);
	}
	function uint64(params) {
		return core._uint64(exports.ZodBigIntFormat, params);
	}
	exports.ZodSymbol = core.$constructor("ZodSymbol", (inst, def) => {
		core.$ZodSymbol.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function symbol(params) {
		return core._symbol(exports.ZodSymbol, params);
	}
	exports.ZodUndefined = core.$constructor("ZodUndefined", (inst, def) => {
		core.$ZodUndefined.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function _undefined(params) {
		return core._undefined(exports.ZodUndefined, params);
	}
	exports.ZodNull = core.$constructor("ZodNull", (inst, def) => {
		core.$ZodNull.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function _null(params) {
		return core._null(exports.ZodNull, params);
	}
	exports.ZodAny = core.$constructor("ZodAny", (inst, def) => {
		core.$ZodAny.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function any() {
		return core._any(exports.ZodAny);
	}
	exports.ZodUnknown = core.$constructor("ZodUnknown", (inst, def) => {
		core.$ZodUnknown.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function unknown() {
		return core._unknown(exports.ZodUnknown);
	}
	exports.ZodNever = core.$constructor("ZodNever", (inst, def) => {
		core.$ZodNever.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function never(params) {
		return core._never(exports.ZodNever, params);
	}
	exports.ZodVoid = core.$constructor("ZodVoid", (inst, def) => {
		core.$ZodVoid.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function _void(params) {
		return core._void(exports.ZodVoid, params);
	}
	exports.ZodDate = core.$constructor("ZodDate", (inst, def) => {
		core.$ZodDate.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.min = (value, params) => inst.check(checks.gte(value, params));
		inst.max = (value, params) => inst.check(checks.lte(value, params));
		const c = inst._zod.bag;
		inst.minDate = c.minimum ? new Date(c.minimum) : null;
		inst.maxDate = c.maximum ? new Date(c.maximum) : null;
	});
	function date(params) {
		return core._date(exports.ZodDate, params);
	}
	exports.ZodArray = core.$constructor("ZodArray", (inst, def) => {
		core.$ZodArray.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.element = def.element;
		inst.min = (minLength, params) => inst.check(checks.minLength(minLength, params));
		inst.nonempty = (params) => inst.check(checks.minLength(1, params));
		inst.max = (maxLength, params) => inst.check(checks.maxLength(maxLength, params));
		inst.length = (len, params) => inst.check(checks.length(len, params));
		inst.unwrap = () => inst.element;
	});
	function array(element, params) {
		return core._array(exports.ZodArray, element, params);
	}
	function keyof(schema) {
		const shape = schema._zod.def.shape;
		return _enum(Object.keys(shape));
	}
	exports.ZodObject = core.$constructor("ZodObject", (inst, def) => {
		core.$ZodObjectJIT.init(inst, def);
		exports.ZodType.init(inst, def);
		index_js_1.util.defineLazy(inst, "shape", () => def.shape);
		inst.keyof = () => _enum(Object.keys(inst._zod.def.shape));
		inst.catchall = (catchall) => inst.clone({
			...inst._zod.def,
			catchall
		});
		inst.passthrough = () => inst.clone({
			...inst._zod.def,
			catchall: unknown()
		});
		inst.loose = () => inst.clone({
			...inst._zod.def,
			catchall: unknown()
		});
		inst.strict = () => inst.clone({
			...inst._zod.def,
			catchall: never()
		});
		inst.strip = () => inst.clone({
			...inst._zod.def,
			catchall: void 0
		});
		inst.extend = (incoming) => {
			return index_js_1.util.extend(inst, incoming);
		};
		inst.safeExtend = (incoming) => {
			return index_js_1.util.safeExtend(inst, incoming);
		};
		inst.merge = (other) => index_js_1.util.merge(inst, other);
		inst.pick = (mask) => index_js_1.util.pick(inst, mask);
		inst.omit = (mask) => index_js_1.util.omit(inst, mask);
		inst.partial = (...args) => index_js_1.util.partial(exports.ZodOptional, inst, args[0]);
		inst.required = (...args) => index_js_1.util.required(exports.ZodNonOptional, inst, args[0]);
	});
	function object(shape, params) {
		const def = {
			type: "object",
			get shape() {
				index_js_1.util.assignProp(this, "shape", shape ? index_js_1.util.objectClone(shape) : {});
				return this.shape;
			},
			...index_js_1.util.normalizeParams(params)
		};
		return new exports.ZodObject(def);
	}
	function strictObject(shape, params) {
		return new exports.ZodObject({
			type: "object",
			get shape() {
				index_js_1.util.assignProp(this, "shape", index_js_1.util.objectClone(shape));
				return this.shape;
			},
			catchall: never(),
			...index_js_1.util.normalizeParams(params)
		});
	}
	function looseObject(shape, params) {
		return new exports.ZodObject({
			type: "object",
			get shape() {
				index_js_1.util.assignProp(this, "shape", index_js_1.util.objectClone(shape));
				return this.shape;
			},
			catchall: unknown(),
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodUnion = core.$constructor("ZodUnion", (inst, def) => {
		core.$ZodUnion.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.options = def.options;
	});
	function union(options, params) {
		return new exports.ZodUnion({
			type: "union",
			options,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodDiscriminatedUnion = core.$constructor("ZodDiscriminatedUnion", (inst, def) => {
		exports.ZodUnion.init(inst, def);
		core.$ZodDiscriminatedUnion.init(inst, def);
	});
	function discriminatedUnion(discriminator, options, params) {
		return new exports.ZodDiscriminatedUnion({
			type: "union",
			options,
			discriminator,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodIntersection = core.$constructor("ZodIntersection", (inst, def) => {
		core.$ZodIntersection.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function intersection(left, right) {
		return new exports.ZodIntersection({
			type: "intersection",
			left,
			right
		});
	}
	exports.ZodTuple = core.$constructor("ZodTuple", (inst, def) => {
		core.$ZodTuple.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.rest = (rest) => inst.clone({
			...inst._zod.def,
			rest
		});
	});
	function tuple(items, _paramsOrRest, _params) {
		const hasRest = _paramsOrRest instanceof core.$ZodType;
		const params = hasRest ? _params : _paramsOrRest;
		const rest = hasRest ? _paramsOrRest : null;
		return new exports.ZodTuple({
			type: "tuple",
			items,
			rest,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodRecord = core.$constructor("ZodRecord", (inst, def) => {
		core.$ZodRecord.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.keyType = def.keyType;
		inst.valueType = def.valueType;
	});
	function record(keyType, valueType, params) {
		return new exports.ZodRecord({
			type: "record",
			keyType,
			valueType,
			...index_js_1.util.normalizeParams(params)
		});
	}
	function partialRecord(keyType, valueType, params) {
		const k = core.clone(keyType);
		k._zod.values = void 0;
		return new exports.ZodRecord({
			type: "record",
			keyType: k,
			valueType,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodMap = core.$constructor("ZodMap", (inst, def) => {
		core.$ZodMap.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.keyType = def.keyType;
		inst.valueType = def.valueType;
	});
	function map(keyType, valueType, params) {
		return new exports.ZodMap({
			type: "map",
			keyType,
			valueType,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodSet = core.$constructor("ZodSet", (inst, def) => {
		core.$ZodSet.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.min = (...args) => inst.check(core._minSize(...args));
		inst.nonempty = (params) => inst.check(core._minSize(1, params));
		inst.max = (...args) => inst.check(core._maxSize(...args));
		inst.size = (...args) => inst.check(core._size(...args));
	});
	function set(valueType, params) {
		return new exports.ZodSet({
			type: "set",
			valueType,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodEnum = core.$constructor("ZodEnum", (inst, def) => {
		core.$ZodEnum.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.enum = def.entries;
		inst.options = Object.values(def.entries);
		const keys = new Set(Object.keys(def.entries));
		inst.extract = (values, params) => {
			const newEntries = {};
			for (const value of values) if (keys.has(value)) newEntries[value] = def.entries[value];
			else throw new Error(`Key ${value} not found in enum`);
			return new exports.ZodEnum({
				...def,
				checks: [],
				...index_js_1.util.normalizeParams(params),
				entries: newEntries
			});
		};
		inst.exclude = (values, params) => {
			const newEntries = { ...def.entries };
			for (const value of values) if (keys.has(value)) delete newEntries[value];
			else throw new Error(`Key ${value} not found in enum`);
			return new exports.ZodEnum({
				...def,
				checks: [],
				...index_js_1.util.normalizeParams(params),
				entries: newEntries
			});
		};
	});
	function _enum(values, params) {
		const entries = Array.isArray(values) ? Object.fromEntries(values.map((v) => [v, v])) : values;
		return new exports.ZodEnum({
			type: "enum",
			entries,
			...index_js_1.util.normalizeParams(params)
		});
	}
	/** @deprecated This API has been merged into `z.enum()`. Use `z.enum()` instead.
	*
	* ```ts
	* enum Colors { red, green, blue }
	* z.enum(Colors);
	* ```
	*/
	function nativeEnum(entries, params) {
		return new exports.ZodEnum({
			type: "enum",
			entries,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodLiteral = core.$constructor("ZodLiteral", (inst, def) => {
		core.$ZodLiteral.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.values = new Set(def.values);
		Object.defineProperty(inst, "value", { get() {
			if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
			return def.values[0];
		} });
	});
	function literal(value, params) {
		return new exports.ZodLiteral({
			type: "literal",
			values: Array.isArray(value) ? value : [value],
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodFile = core.$constructor("ZodFile", (inst, def) => {
		core.$ZodFile.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.min = (size, params) => inst.check(core._minSize(size, params));
		inst.max = (size, params) => inst.check(core._maxSize(size, params));
		inst.mime = (types, params) => inst.check(core._mime(Array.isArray(types) ? types : [types], params));
	});
	function file(params) {
		return core._file(exports.ZodFile, params);
	}
	exports.ZodTransform = core.$constructor("ZodTransform", (inst, def) => {
		core.$ZodTransform.init(inst, def);
		exports.ZodType.init(inst, def);
		inst._zod.parse = (payload, _ctx) => {
			if (_ctx.direction === "backward") throw new core.$ZodEncodeError(inst.constructor.name);
			payload.addIssue = (issue) => {
				if (typeof issue === "string") payload.issues.push(index_js_1.util.issue(issue, payload.value, def));
				else {
					const _issue = issue;
					if (_issue.fatal) _issue.continue = false;
					_issue.code ?? (_issue.code = "custom");
					_issue.input ?? (_issue.input = payload.value);
					_issue.inst ?? (_issue.inst = inst);
					payload.issues.push(index_js_1.util.issue(_issue));
				}
			};
			const output = def.transform(payload.value, payload);
			if (output instanceof Promise) return output.then((output) => {
				payload.value = output;
				return payload;
			});
			payload.value = output;
			return payload;
		};
	});
	function transform(fn) {
		return new exports.ZodTransform({
			type: "transform",
			transform: fn
		});
	}
	exports.ZodOptional = core.$constructor("ZodOptional", (inst, def) => {
		core.$ZodOptional.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function optional(innerType) {
		return new exports.ZodOptional({
			type: "optional",
			innerType
		});
	}
	exports.ZodNullable = core.$constructor("ZodNullable", (inst, def) => {
		core.$ZodNullable.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function nullable(innerType) {
		return new exports.ZodNullable({
			type: "nullable",
			innerType
		});
	}
	function nullish(innerType) {
		return optional(nullable(innerType));
	}
	exports.ZodDefault = core.$constructor("ZodDefault", (inst, def) => {
		core.$ZodDefault.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
		inst.removeDefault = inst.unwrap;
	});
	function _default(innerType, defaultValue) {
		return new exports.ZodDefault({
			type: "default",
			innerType,
			get defaultValue() {
				return typeof defaultValue === "function" ? defaultValue() : index_js_1.util.shallowClone(defaultValue);
			}
		});
	}
	exports.ZodPrefault = core.$constructor("ZodPrefault", (inst, def) => {
		core.$ZodPrefault.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function prefault(innerType, defaultValue) {
		return new exports.ZodPrefault({
			type: "prefault",
			innerType,
			get defaultValue() {
				return typeof defaultValue === "function" ? defaultValue() : index_js_1.util.shallowClone(defaultValue);
			}
		});
	}
	exports.ZodNonOptional = core.$constructor("ZodNonOptional", (inst, def) => {
		core.$ZodNonOptional.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function nonoptional(innerType, params) {
		return new exports.ZodNonOptional({
			type: "nonoptional",
			innerType,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodSuccess = core.$constructor("ZodSuccess", (inst, def) => {
		core.$ZodSuccess.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function success(innerType) {
		return new exports.ZodSuccess({
			type: "success",
			innerType
		});
	}
	exports.ZodCatch = core.$constructor("ZodCatch", (inst, def) => {
		core.$ZodCatch.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
		inst.removeCatch = inst.unwrap;
	});
	function _catch(innerType, catchValue) {
		return new exports.ZodCatch({
			type: "catch",
			innerType,
			catchValue: typeof catchValue === "function" ? catchValue : () => catchValue
		});
	}
	exports.ZodNaN = core.$constructor("ZodNaN", (inst, def) => {
		core.$ZodNaN.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function nan(params) {
		return core._nan(exports.ZodNaN, params);
	}
	exports.ZodPipe = core.$constructor("ZodPipe", (inst, def) => {
		core.$ZodPipe.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.in = def.in;
		inst.out = def.out;
	});
	function pipe(in_, out) {
		return new exports.ZodPipe({
			type: "pipe",
			in: in_,
			out
		});
	}
	exports.ZodCodec = core.$constructor("ZodCodec", (inst, def) => {
		exports.ZodPipe.init(inst, def);
		core.$ZodCodec.init(inst, def);
	});
	function codec(in_, out, params) {
		return new exports.ZodCodec({
			type: "pipe",
			in: in_,
			out,
			transform: params.decode,
			reverseTransform: params.encode
		});
	}
	exports.ZodReadonly = core.$constructor("ZodReadonly", (inst, def) => {
		core.$ZodReadonly.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function readonly(innerType) {
		return new exports.ZodReadonly({
			type: "readonly",
			innerType
		});
	}
	exports.ZodTemplateLiteral = core.$constructor("ZodTemplateLiteral", (inst, def) => {
		core.$ZodTemplateLiteral.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function templateLiteral(parts, params) {
		return new exports.ZodTemplateLiteral({
			type: "template_literal",
			parts,
			...index_js_1.util.normalizeParams(params)
		});
	}
	exports.ZodLazy = core.$constructor("ZodLazy", (inst, def) => {
		core.$ZodLazy.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.getter();
	});
	function lazy(getter) {
		return new exports.ZodLazy({
			type: "lazy",
			getter
		});
	}
	exports.ZodPromise = core.$constructor("ZodPromise", (inst, def) => {
		core.$ZodPromise.init(inst, def);
		exports.ZodType.init(inst, def);
		inst.unwrap = () => inst._zod.def.innerType;
	});
	function promise(innerType) {
		return new exports.ZodPromise({
			type: "promise",
			innerType
		});
	}
	exports.ZodFunction = core.$constructor("ZodFunction", (inst, def) => {
		core.$ZodFunction.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function _function(params) {
		return new exports.ZodFunction({
			type: "function",
			input: Array.isArray(params?.input) ? tuple(params?.input) : params?.input ?? array(unknown()),
			output: params?.output ?? unknown()
		});
	}
	exports.ZodCustom = core.$constructor("ZodCustom", (inst, def) => {
		core.$ZodCustom.init(inst, def);
		exports.ZodType.init(inst, def);
	});
	function check(fn) {
		const ch = new core.$ZodCheck({ check: "custom" });
		ch._zod.check = fn;
		return ch;
	}
	function custom(fn, _params) {
		return core._custom(exports.ZodCustom, fn ?? (() => true), _params);
	}
	function refine(fn, _params = {}) {
		return core._refine(exports.ZodCustom, fn, _params);
	}
	function superRefine(fn) {
		return core._superRefine(fn);
	}
	function _instanceof(cls, params = { error: `Input not instance of ${cls.name}` }) {
		const inst = new exports.ZodCustom({
			type: "custom",
			check: "custom",
			fn: (data) => data instanceof cls,
			abort: true,
			...index_js_1.util.normalizeParams(params)
		});
		inst._zod.bag.Class = cls;
		return inst;
	}
	var stringbool = (...args) => core._stringbool({
		Codec: exports.ZodCodec,
		Boolean: exports.ZodBoolean,
		String: exports.ZodString
	}, ...args);
	exports.stringbool = stringbool;
	function json(params) {
		const jsonSchema = lazy(() => {
			return union([
				string(params),
				number(),
				boolean(),
				_null(),
				array(jsonSchema),
				record(string(), jsonSchema)
			]);
		});
		return jsonSchema;
	}
	function preprocess(fn, schema) {
		return pipe(transform(fn), schema);
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/compat.cjs
var require_compat = /* @__PURE__ */ __commonJSMin(((exports, module, this$27) => {
	var __createBinding = this$27 && this$27.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$27 && this$27.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$27 && this$27.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZodFirstPartyTypeKind = exports.config = exports.$brand = exports.ZodIssueCode = void 0;
	exports.setErrorMap = setErrorMap;
	exports.getErrorMap = getErrorMap;
	var core = __importStar(require_core());
	/** @deprecated Use the raw string literal codes instead, e.g. "invalid_type". */
	exports.ZodIssueCode = {
		invalid_type: "invalid_type",
		too_big: "too_big",
		too_small: "too_small",
		invalid_format: "invalid_format",
		not_multiple_of: "not_multiple_of",
		unrecognized_keys: "unrecognized_keys",
		invalid_union: "invalid_union",
		invalid_key: "invalid_key",
		invalid_element: "invalid_element",
		invalid_value: "invalid_value",
		custom: "custom"
	};
	var index_js_1 = require_core();
	Object.defineProperty(exports, "$brand", {
		enumerable: true,
		get: function() {
			return index_js_1.$brand;
		}
	});
	Object.defineProperty(exports, "config", {
		enumerable: true,
		get: function() {
			return index_js_1.config;
		}
	});
	/** @deprecated Use `z.config(params)` instead. */
	function setErrorMap(map) {
		core.config({ customError: map });
	}
	/** @deprecated Use `z.config()` instead. */
	function getErrorMap() {
		return core.config().customError;
	}
	/** @deprecated Do not use. Stub definition, only included for zod-to-json-schema compatibility. */
	var ZodFirstPartyTypeKind;
	ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = ZodFirstPartyTypeKind = {});
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/coerce.cjs
var require_coerce = /* @__PURE__ */ __commonJSMin(((exports, module, this$26) => {
	var __createBinding = this$26 && this$26.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$26 && this$26.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$26 && this$26.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.string = string;
	exports.number = number;
	exports.boolean = boolean;
	exports.bigint = bigint;
	exports.date = date;
	var core = __importStar(require_core());
	var schemas = __importStar(require_schemas());
	function string(params) {
		return core._coercedString(schemas.ZodString, params);
	}
	function number(params) {
		return core._coercedNumber(schemas.ZodNumber, params);
	}
	function boolean(params) {
		return core._coercedBoolean(schemas.ZodBoolean, params);
	}
	function bigint(params) {
		return core._coercedBigint(schemas.ZodBigInt, params);
	}
	function date(params) {
		return core._coercedDate(schemas.ZodDate, params);
	}
}));
//#endregion
//#region ../../node_modules/zod/v4/classic/external.cjs
var require_external = /* @__PURE__ */ __commonJSMin(((exports, module, this$25) => {
	var __createBinding = this$25 && this$25.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$25 && this$25.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$25 && this$25.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	var __exportStar = this$25 && this$25.__exportStar || function(m, exports) {
		for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	var __importDefault = this$25 && this$25.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.coerce = exports.iso = exports.ZodISODuration = exports.ZodISOTime = exports.ZodISODate = exports.ZodISODateTime = exports.locales = exports.NEVER = exports.util = exports.TimePrecision = exports.toJSONSchema = exports.flattenError = exports.formatError = exports.prettifyError = exports.treeifyError = exports.regexes = exports.clone = exports.$brand = exports.$input = exports.$output = exports.config = exports.registry = exports.globalRegistry = exports.core = void 0;
	exports.core = __importStar(require_core());
	__exportStar(require_schemas(), exports);
	__exportStar(require_checks(), exports);
	__exportStar(require_errors$2(), exports);
	__exportStar(require_parse$1(), exports);
	__exportStar(require_compat(), exports);
	var index_js_1 = require_core();
	var en_js_1 = __importDefault(require_en());
	(0, index_js_1.config)((0, en_js_1.default)());
	var index_js_2 = require_core();
	Object.defineProperty(exports, "globalRegistry", {
		enumerable: true,
		get: function() {
			return index_js_2.globalRegistry;
		}
	});
	Object.defineProperty(exports, "registry", {
		enumerable: true,
		get: function() {
			return index_js_2.registry;
		}
	});
	Object.defineProperty(exports, "config", {
		enumerable: true,
		get: function() {
			return index_js_2.config;
		}
	});
	Object.defineProperty(exports, "$output", {
		enumerable: true,
		get: function() {
			return index_js_2.$output;
		}
	});
	Object.defineProperty(exports, "$input", {
		enumerable: true,
		get: function() {
			return index_js_2.$input;
		}
	});
	Object.defineProperty(exports, "$brand", {
		enumerable: true,
		get: function() {
			return index_js_2.$brand;
		}
	});
	Object.defineProperty(exports, "clone", {
		enumerable: true,
		get: function() {
			return index_js_2.clone;
		}
	});
	Object.defineProperty(exports, "regexes", {
		enumerable: true,
		get: function() {
			return index_js_2.regexes;
		}
	});
	Object.defineProperty(exports, "treeifyError", {
		enumerable: true,
		get: function() {
			return index_js_2.treeifyError;
		}
	});
	Object.defineProperty(exports, "prettifyError", {
		enumerable: true,
		get: function() {
			return index_js_2.prettifyError;
		}
	});
	Object.defineProperty(exports, "formatError", {
		enumerable: true,
		get: function() {
			return index_js_2.formatError;
		}
	});
	Object.defineProperty(exports, "flattenError", {
		enumerable: true,
		get: function() {
			return index_js_2.flattenError;
		}
	});
	Object.defineProperty(exports, "toJSONSchema", {
		enumerable: true,
		get: function() {
			return index_js_2.toJSONSchema;
		}
	});
	Object.defineProperty(exports, "TimePrecision", {
		enumerable: true,
		get: function() {
			return index_js_2.TimePrecision;
		}
	});
	Object.defineProperty(exports, "util", {
		enumerable: true,
		get: function() {
			return index_js_2.util;
		}
	});
	Object.defineProperty(exports, "NEVER", {
		enumerable: true,
		get: function() {
			return index_js_2.NEVER;
		}
	});
	exports.locales = __importStar(require_locales());
	var iso_js_1 = require_iso();
	Object.defineProperty(exports, "ZodISODateTime", {
		enumerable: true,
		get: function() {
			return iso_js_1.ZodISODateTime;
		}
	});
	Object.defineProperty(exports, "ZodISODate", {
		enumerable: true,
		get: function() {
			return iso_js_1.ZodISODate;
		}
	});
	Object.defineProperty(exports, "ZodISOTime", {
		enumerable: true,
		get: function() {
			return iso_js_1.ZodISOTime;
		}
	});
	Object.defineProperty(exports, "ZodISODuration", {
		enumerable: true,
		get: function() {
			return iso_js_1.ZodISODuration;
		}
	});
	exports.iso = __importStar(require_iso());
	exports.coerce = __importStar(require_coerce());
}));
//#endregion
//#region ../../node_modules/zod/index.cjs
var require_zod = /* @__PURE__ */ __commonJSMin(((exports, module, this$24) => {
	var __createBinding = this$24 && this$24.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$24 && this$24.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$24 && this$24.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	var __exportStar = this$24 && this$24.__exportStar || function(m, exports) {
		for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.z = void 0;
	var z = __importStar(require_external());
	exports.z = z;
	__exportStar(require_external(), exports);
	exports.default = z;
}));
//#endregion
//#region ../common/lib/enums/period-name.enum.js
var require_period_name_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.periodNameSchema = exports.PeriodName = void 0;
	var zod_1 = require_zod();
	var PeriodName;
	(function(PeriodName) {
		PeriodName["A"] = "A";
		PeriodName["Q1"] = "Q1";
		PeriodName["Q2"] = "Q2";
		PeriodName["Q3"] = "Q3";
		PeriodName["Q4"] = "Q4";
		PeriodName["H1"] = "H1";
		PeriodName["H2"] = "H2";
		PeriodName["M1"] = "M1";
		PeriodName["M2"] = "M2";
		PeriodName["M3"] = "M3";
		PeriodName["M4"] = "M4";
		PeriodName["M5"] = "M5";
		PeriodName["M6"] = "M6";
		PeriodName["M7"] = "M7";
		PeriodName["M8"] = "M8";
		PeriodName["M9"] = "M9";
		PeriodName["M10"] = "M10";
		PeriodName["M11"] = "M11";
		PeriodName["M12"] = "M12";
		PeriodName["YTD1"] = "YTD1";
		PeriodName["YTD2"] = "YTD2";
		PeriodName["YTD3"] = "YTD3";
		PeriodName["YTD4"] = "YTD4";
		PeriodName["YTD5"] = "YTD5";
		PeriodName["YTD6"] = "YTD6";
		PeriodName["YTD7"] = "YTD7";
		PeriodName["YTD8"] = "YTD8";
		PeriodName["YTD9"] = "YTD9";
		PeriodName["YTD10"] = "YTD10";
		PeriodName["YTD11"] = "YTD11";
		PeriodName["YTD12"] = "YTD12";
	})(PeriodName || (exports.PeriodName = PeriodName = {}));
	exports.periodNameSchema = zod_1.z.enum(PeriodName);
}));
//#endregion
//#region ../common/lib/enums/selected-rd-project-category.enum.js
var require_selected_rd_project_category_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.rdProjectCategoryLabel = exports.SelectedRdProjectCategory = void 0;
	var SelectedRdProjectCategory;
	(function(SelectedRdProjectCategory) {
		SelectedRdProjectCategory["RD_CREDIT"] = "RD_CREDIT";
		SelectedRdProjectCategory["SECTION_174_ONLY"] = "SECTION_174_ONLY";
		SelectedRdProjectCategory["EXCLUDED"] = "EXCLUDED";
	})(SelectedRdProjectCategory || (exports.SelectedRdProjectCategory = SelectedRdProjectCategory = {}));
	exports.rdProjectCategoryLabel = {
		[SelectedRdProjectCategory.RD_CREDIT]: "R&D Credit",
		[SelectedRdProjectCategory.SECTION_174_ONLY]: "§174 Only",
		[SelectedRdProjectCategory.EXCLUDED]: "Excluded"
	};
}));
//#endregion
//#region ../common/lib/enums/rd-documentation-status.enum.js
var require_rd_documentation_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.rdDocumentationStatusLabel = exports.RdDocumentationStatus = void 0;
	var RdDocumentationStatus;
	(function(RdDocumentationStatus) {
		RdDocumentationStatus["COMPLETE"] = "COMPLETE";
		RdDocumentationStatus["INCOMPLETE"] = "INCOMPLETE";
		RdDocumentationStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
	})(RdDocumentationStatus || (exports.RdDocumentationStatus = RdDocumentationStatus = {}));
	exports.rdDocumentationStatusLabel = {
		[RdDocumentationStatus.COMPLETE]: "Complete",
		[RdDocumentationStatus.INCOMPLETE]: "Incomplete",
		[RdDocumentationStatus.NOT_APPLICABLE]: "Not Applicable"
	};
}));
//#endregion
//#region ../common/lib/enums/selected-sred-project-category.enum.js
var require_selected_sred_project_category_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sredProjectCategoryLabel = exports.SelectedSredProjectCategory = void 0;
	var SelectedSredProjectCategory;
	(function(SelectedSredProjectCategory) {
		SelectedSredProjectCategory["SRED_CREDIT"] = "SRED_CREDIT";
		SelectedSredProjectCategory["NOT_STARTED_OR_NONE"] = "NOT_STARTED_OR_NONE";
	})(SelectedSredProjectCategory || (exports.SelectedSredProjectCategory = SelectedSredProjectCategory = {}));
	exports.sredProjectCategoryLabel = {
		[SelectedSredProjectCategory.SRED_CREDIT]: "SR&ED Credit",
		[SelectedSredProjectCategory.NOT_STARTED_OR_NONE]: "Not Started / None"
	};
}));
//#endregion
//#region ../common/lib/enums/sred-documentation-status.enum.js
var require_sred_documentation_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sredDocumentationStatusLabel = exports.SredDocumentationStatus = void 0;
	var SredDocumentationStatus;
	(function(SredDocumentationStatus) {
		SredDocumentationStatus["COMPLETE"] = "COMPLETE";
		SredDocumentationStatus["INCOMPLETE"] = "INCOMPLETE";
		SredDocumentationStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
	})(SredDocumentationStatus || (exports.SredDocumentationStatus = SredDocumentationStatus = {}));
	exports.sredDocumentationStatusLabel = {
		[SredDocumentationStatus.COMPLETE]: "Complete",
		[SredDocumentationStatus.INCOMPLETE]: "Incomplete",
		[SredDocumentationStatus.NOT_APPLICABLE]: "Not Applicable"
	};
}));
//#endregion
//#region ../common/lib/enums/predicted-capitalization-status.enum.js
var require_predicted_capitalization_status_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PREDICTED_CAPITALIZATION_STATUS_LABELS = exports.PredictedCapitalizationStatus = void 0;
	var PredictedCapitalizationStatus;
	(function(PredictedCapitalizationStatus) {
		PredictedCapitalizationStatus["CAPITALIZABLE"] = "CAPITALIZABLE";
		PredictedCapitalizationStatus["NOT_CAPITALIZABLE"] = "NOT_CAPITALIZABLE";
		PredictedCapitalizationStatus["UNCERTAIN"] = "UNCERTAIN";
	})(PredictedCapitalizationStatus || (exports.PredictedCapitalizationStatus = PredictedCapitalizationStatus = {}));
	exports.PREDICTED_CAPITALIZATION_STATUS_LABELS = {
		[PredictedCapitalizationStatus.CAPITALIZABLE]: "Capitalizable",
		[PredictedCapitalizationStatus.NOT_CAPITALIZABLE]: "Not Capitalizable",
		[PredictedCapitalizationStatus.UNCERTAIN]: "Uncertain"
	};
}));
//#endregion
//#region ../common/lib/enums/finch-scope-type.enum.js
var require_finch_scope_type_enum = /* @__PURE__ */ __commonJSMin(((exports, module, this$23) => {
	var __importDefault = this$23 && this$23.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FinchScopeTypeSchema = exports.FinchScopeType = void 0;
	var zod_1 = __importDefault(require_zod());
	var FinchScopeType;
	(function(FinchScopeType) {
		FinchScopeType["HR_ONLY"] = "HR_ONLY";
		FinchScopeType["FULL_PAYROLL"] = "FULL_PAYROLL";
	})(FinchScopeType || (exports.FinchScopeType = FinchScopeType = {}));
	exports.FinchScopeTypeSchema = zod_1.default.enum([FinchScopeType.HR_ONLY, FinchScopeType.FULL_PAYROLL]);
}));
//#endregion
//#region ../common/lib/enums/asc-fixed-cost-trigger.enum.js
var require_asc_fixed_cost_trigger_enum = /* @__PURE__ */ __commonJSMin(((exports, module, this$22) => {
	var __importDefault = this$22 && this$22.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AscFixedCostTriggerSchema = exports.AscFixedCostTrigger = void 0;
	var zod_1 = __importDefault(require_zod());
	/**
	* What caused a Fixed Cost to be applied. Staff-initiated applies are attributable to a user;
	* sync-initiated ones run inside the ticketing flow with no authenticated user, so this is the
	* only reliable way to tell the two apart when reading the run log.
	*/
	var AscFixedCostTrigger;
	(function(AscFixedCostTrigger) {
		AscFixedCostTrigger["MANUAL"] = "MANUAL";
		AscFixedCostTrigger["TICKETING_SYNC"] = "TICKETING_SYNC";
	})(AscFixedCostTrigger || (exports.AscFixedCostTrigger = AscFixedCostTrigger = {}));
	exports.AscFixedCostTriggerSchema = zod_1.default.enum([AscFixedCostTrigger.MANUAL, AscFixedCostTrigger.TICKETING_SYNC]);
}));
//#endregion
//#region ../common/lib/enums/product-type.enum.js
var require_product_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProductType = void 0;
	var ProductType;
	(function(ProductType) {
		ProductType["US_RD"] = "US_RD";
		ProductType["US_ASC"] = "US_ASC";
		ProductType["CA_SRED"] = "CA_SRED";
	})(ProductType || (exports.ProductType = ProductType = {}));
}));
//#endregion
//#region ../common/lib/enums/auth-error-code.enum.js
var require_auth_error_code_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AuthErrorCode = void 0;
	/**
	* Error codes surfaced on `ExtendedGraphQLErrors.extensions.errors[*].code` by
	* auth-related mutations and guards. Defined in `@common/neo.tax` so server
	* throws and frontend branches reference the exact same strings — prevents
	* typo drift between ends.
	*
	* Add a new member here whenever the backend starts throwing a new coded auth
	* error; referenced places will break at compile time and point you at every
	* caller that needs to handle it.
	*/
	var AuthErrorCode;
	(function(AuthErrorCode) {
		AuthErrorCode["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
		/** The organization admits only its enterprise SSO provider, and this session signed in some other way. */
		AuthErrorCode["ENTERPRISE_SSO_REQUIRED"] = "ENTERPRISE_SSO_REQUIRED";
		AuthErrorCode["EMAIL_VERIFICATION_TOO_FREQUENT"] = "EMAIL_VERIFICATION_TOO_FREQUENT";
		AuthErrorCode["EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS_TRY_LATER"] = "EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS_TRY_LATER";
		AuthErrorCode["INVALID_CONTINUE_URL"] = "INVALID_CONTINUE_URL";
	})(AuthErrorCode || (exports.AuthErrorCode = AuthErrorCode = {}));
}));
//#endregion
//#region ../common/lib/enums/azure-devops-granularity-refusal-code.enum.js
var require_azure_devops_granularity_refusal_code_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AzureDevopsGranularityRefusalCode = void 0;
	/** Sent in `extensions.errors[*].code` when an ADO workstream granularity save is refused, so clients never read the error text. */
	var AzureDevopsGranularityRefusalCode;
	(function(AzureDevopsGranularityRefusalCode) {
		AzureDevopsGranularityRefusalCode["AzureDevopsGranularityColumnHasBlanks"] = "AzureDevopsGranularityColumnHasBlanks";
		AzureDevopsGranularityRefusalCode["AzureDevopsGranularityLocked"] = "AzureDevopsGranularityLocked";
		AzureDevopsGranularityRefusalCode["AzureDevopsGranularityOrganizationHostIdOnly"] = "AzureDevopsGranularityOrganizationHostIdOnly";
	})(AzureDevopsGranularityRefusalCode || (exports.AzureDevopsGranularityRefusalCode = AzureDevopsGranularityRefusalCode = {}));
}));
//#endregion
//#region ../common/lib/enums/index.js
var require_enums = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AscFixedCostTriggerSchema = exports.AscFixedCostTrigger = exports.FinchScopeTypeSchema = exports.FinchScopeType = exports.PREDICTED_CAPITALIZATION_STATUS_LABELS = exports.PredictedCapitalizationStatus = exports.sredDocumentationStatusLabel = exports.SredDocumentationStatus = exports.sredProjectCategoryLabel = exports.SelectedSredProjectCategory = exports.rdDocumentationStatusLabel = exports.RdDocumentationStatus = exports.rdProjectCategoryLabel = exports.SelectedRdProjectCategory = exports.periodNameSchema = exports.PeriodName = exports.PayrollMonthExpenseProvider = exports.DayOfWeek = exports.ErrorStatusCode = exports.ValueType = exports.CompanyEntityType = exports.EligibilityStatus = exports.CorporationType = exports.ServiceOperationalStatus = exports.WageType = exports.PayrollProvider = exports.AccountingProvider = exports.PayrollAcquisitionMethod = exports.DateMonth = exports.AccountingAcquisitionMethod = exports.EntityType = exports.SalesChannel = exports.getRevenueSourceRank = exports.RevenueSource = exports.HardSciences = exports.RoundingMethod = exports.AccountType = exports.AccountClassification = exports.ServiceScope = exports.NeoTaxEnvironment = exports.SsoError = exports.SsoQueryField = exports.GitHubAppInstallStatus = exports.GitHubAppInstallQueryField = exports.QuickbooksMonth = exports.QuickbooksConnectionStatus = exports.QuickbooksQueryField = exports.convertExpenseCategoryToNum = exports.ExpenseCategory = exports.AnalyticIdentifier = void 0;
	exports.AzureDevopsGranularityRefusalCode = exports.AuthErrorCode = exports.ProductType = void 0;
	var analytic_identifier_enum_1 = require_analytic_identifier_enum();
	Object.defineProperty(exports, "AnalyticIdentifier", {
		enumerable: true,
		get: function() {
			return analytic_identifier_enum_1.AnalyticIdentifier;
		}
	});
	var expense_category_enums_1 = require_expense_category_enums();
	Object.defineProperty(exports, "ExpenseCategory", {
		enumerable: true,
		get: function() {
			return expense_category_enums_1.ExpenseCategory;
		}
	});
	var enums_utils_1 = require_enums_utils();
	Object.defineProperty(exports, "convertExpenseCategoryToNum", {
		enumerable: true,
		get: function() {
			return enums_utils_1.convertExpenseCategoryToNum;
		}
	});
	var quickbooks_1 = require_quickbooks();
	Object.defineProperty(exports, "QuickbooksQueryField", {
		enumerable: true,
		get: function() {
			return quickbooks_1.QuickbooksQueryField;
		}
	});
	Object.defineProperty(exports, "QuickbooksConnectionStatus", {
		enumerable: true,
		get: function() {
			return quickbooks_1.QuickbooksConnectionStatus;
		}
	});
	Object.defineProperty(exports, "QuickbooksMonth", {
		enumerable: true,
		get: function() {
			return quickbooks_1.QuickbooksMonth;
		}
	});
	var github_app_1 = require_github_app();
	Object.defineProperty(exports, "GitHubAppInstallQueryField", {
		enumerable: true,
		get: function() {
			return github_app_1.GitHubAppInstallQueryField;
		}
	});
	Object.defineProperty(exports, "GitHubAppInstallStatus", {
		enumerable: true,
		get: function() {
			return github_app_1.GitHubAppInstallStatus;
		}
	});
	var sso_1 = require_sso();
	Object.defineProperty(exports, "SsoQueryField", {
		enumerable: true,
		get: function() {
			return sso_1.SsoQueryField;
		}
	});
	Object.defineProperty(exports, "SsoError", {
		enumerable: true,
		get: function() {
			return sso_1.SsoError;
		}
	});
	var neo_tax_environment_enum_1 = require_neo_tax_environment_enum();
	Object.defineProperty(exports, "NeoTaxEnvironment", {
		enumerable: true,
		get: function() {
			return neo_tax_environment_enum_1.NeoTaxEnvironment;
		}
	});
	var service_scope_enum_1 = require_service_scope_enum();
	Object.defineProperty(exports, "ServiceScope", {
		enumerable: true,
		get: function() {
			return service_scope_enum_1.ServiceScope;
		}
	});
	var account_classification_enum_1 = require_account_classification_enum();
	Object.defineProperty(exports, "AccountClassification", {
		enumerable: true,
		get: function() {
			return account_classification_enum_1.AccountClassification;
		}
	});
	var account_type_enum_1 = require_account_type_enum();
	Object.defineProperty(exports, "AccountType", {
		enumerable: true,
		get: function() {
			return account_type_enum_1.AccountType;
		}
	});
	var rounding_method_enum_1 = require_rounding_method_enum();
	Object.defineProperty(exports, "RoundingMethod", {
		enumerable: true,
		get: function() {
			return rounding_method_enum_1.RoundingMethod;
		}
	});
	var hard_sciences_enum_1 = require_hard_sciences_enum();
	Object.defineProperty(exports, "HardSciences", {
		enumerable: true,
		get: function() {
			return hard_sciences_enum_1.HardSciences;
		}
	});
	var revenue_source_enum_1 = require_revenue_source_enum();
	Object.defineProperty(exports, "RevenueSource", {
		enumerable: true,
		get: function() {
			return revenue_source_enum_1.RevenueSource;
		}
	});
	Object.defineProperty(exports, "getRevenueSourceRank", {
		enumerable: true,
		get: function() {
			return revenue_source_enum_1.getRevenueSourceRank;
		}
	});
	var sales_channel_enum_1 = require_sales_channel_enum();
	Object.defineProperty(exports, "SalesChannel", {
		enumerable: true,
		get: function() {
			return sales_channel_enum_1.SalesChannel;
		}
	});
	var entity_type_enum_1 = require_entity_type_enum();
	Object.defineProperty(exports, "EntityType", {
		enumerable: true,
		get: function() {
			return entity_type_enum_1.EntityType;
		}
	});
	var accounting_acquisition_method_enum_1 = require_accounting_acquisition_method_enum();
	Object.defineProperty(exports, "AccountingAcquisitionMethod", {
		enumerable: true,
		get: function() {
			return accounting_acquisition_method_enum_1.AccountingAcquisitionMethod;
		}
	});
	var date_month_enum_1 = require_date_month_enum();
	Object.defineProperty(exports, "DateMonth", {
		enumerable: true,
		get: function() {
			return date_month_enum_1.DateMonth;
		}
	});
	var payroll_acquisition_method_enum_1 = require_payroll_acquisition_method_enum();
	Object.defineProperty(exports, "PayrollAcquisitionMethod", {
		enumerable: true,
		get: function() {
			return payroll_acquisition_method_enum_1.PayrollAcquisitionMethod;
		}
	});
	var accounting_provider_enum_1 = require_accounting_provider_enum();
	Object.defineProperty(exports, "AccountingProvider", {
		enumerable: true,
		get: function() {
			return accounting_provider_enum_1.AccountingProvider;
		}
	});
	var payroll_provider_enum_1 = require_payroll_provider_enum();
	Object.defineProperty(exports, "PayrollProvider", {
		enumerable: true,
		get: function() {
			return payroll_provider_enum_1.PayrollProvider;
		}
	});
	var wage_type_enum_1 = require_wage_type_enum();
	Object.defineProperty(exports, "WageType", {
		enumerable: true,
		get: function() {
			return wage_type_enum_1.WageType;
		}
	});
	var service_operational_status_enum_1 = require_service_operational_status_enum();
	Object.defineProperty(exports, "ServiceOperationalStatus", {
		enumerable: true,
		get: function() {
			return service_operational_status_enum_1.ServiceOperationalStatus;
		}
	});
	var corporation_type_enum_1 = require_corporation_type_enum();
	Object.defineProperty(exports, "CorporationType", {
		enumerable: true,
		get: function() {
			return corporation_type_enum_1.CorporationType;
		}
	});
	var eligibility_status_enum_1 = require_eligibility_status_enum();
	Object.defineProperty(exports, "EligibilityStatus", {
		enumerable: true,
		get: function() {
			return eligibility_status_enum_1.EligibilityStatus;
		}
	});
	var company_entity_type_enum_1 = require_company_entity_type_enum();
	Object.defineProperty(exports, "CompanyEntityType", {
		enumerable: true,
		get: function() {
			return company_entity_type_enum_1.CompanyEntityType;
		}
	});
	var value_type_enum_1 = require_value_type_enum();
	Object.defineProperty(exports, "ValueType", {
		enumerable: true,
		get: function() {
			return value_type_enum_1.ValueType;
		}
	});
	var error_status_code_1 = require_error_status_code();
	Object.defineProperty(exports, "ErrorStatusCode", {
		enumerable: true,
		get: function() {
			return error_status_code_1.ErrorStatusCode;
		}
	});
	var day_of_week_enum_1 = require_day_of_week_enum();
	Object.defineProperty(exports, "DayOfWeek", {
		enumerable: true,
		get: function() {
			return day_of_week_enum_1.DayOfWeek;
		}
	});
	var payroll_month_expense_provider_enum_1 = require_payroll_month_expense_provider_enum();
	Object.defineProperty(exports, "PayrollMonthExpenseProvider", {
		enumerable: true,
		get: function() {
			return payroll_month_expense_provider_enum_1.PayrollMonthExpenseProvider;
		}
	});
	var period_name_enum_1 = require_period_name_enum();
	Object.defineProperty(exports, "PeriodName", {
		enumerable: true,
		get: function() {
			return period_name_enum_1.PeriodName;
		}
	});
	Object.defineProperty(exports, "periodNameSchema", {
		enumerable: true,
		get: function() {
			return period_name_enum_1.periodNameSchema;
		}
	});
	var selected_rd_project_category_enum_1 = require_selected_rd_project_category_enum();
	Object.defineProperty(exports, "SelectedRdProjectCategory", {
		enumerable: true,
		get: function() {
			return selected_rd_project_category_enum_1.SelectedRdProjectCategory;
		}
	});
	Object.defineProperty(exports, "rdProjectCategoryLabel", {
		enumerable: true,
		get: function() {
			return selected_rd_project_category_enum_1.rdProjectCategoryLabel;
		}
	});
	var rd_documentation_status_enum_1 = require_rd_documentation_status_enum();
	Object.defineProperty(exports, "RdDocumentationStatus", {
		enumerable: true,
		get: function() {
			return rd_documentation_status_enum_1.RdDocumentationStatus;
		}
	});
	Object.defineProperty(exports, "rdDocumentationStatusLabel", {
		enumerable: true,
		get: function() {
			return rd_documentation_status_enum_1.rdDocumentationStatusLabel;
		}
	});
	var selected_sred_project_category_enum_1 = require_selected_sred_project_category_enum();
	Object.defineProperty(exports, "SelectedSredProjectCategory", {
		enumerable: true,
		get: function() {
			return selected_sred_project_category_enum_1.SelectedSredProjectCategory;
		}
	});
	Object.defineProperty(exports, "sredProjectCategoryLabel", {
		enumerable: true,
		get: function() {
			return selected_sred_project_category_enum_1.sredProjectCategoryLabel;
		}
	});
	var sred_documentation_status_enum_1 = require_sred_documentation_status_enum();
	Object.defineProperty(exports, "SredDocumentationStatus", {
		enumerable: true,
		get: function() {
			return sred_documentation_status_enum_1.SredDocumentationStatus;
		}
	});
	Object.defineProperty(exports, "sredDocumentationStatusLabel", {
		enumerable: true,
		get: function() {
			return sred_documentation_status_enum_1.sredDocumentationStatusLabel;
		}
	});
	var predicted_capitalization_status_enum_1 = require_predicted_capitalization_status_enum();
	Object.defineProperty(exports, "PredictedCapitalizationStatus", {
		enumerable: true,
		get: function() {
			return predicted_capitalization_status_enum_1.PredictedCapitalizationStatus;
		}
	});
	Object.defineProperty(exports, "PREDICTED_CAPITALIZATION_STATUS_LABELS", {
		enumerable: true,
		get: function() {
			return predicted_capitalization_status_enum_1.PREDICTED_CAPITALIZATION_STATUS_LABELS;
		}
	});
	var finch_scope_type_enum_1 = require_finch_scope_type_enum();
	Object.defineProperty(exports, "FinchScopeType", {
		enumerable: true,
		get: function() {
			return finch_scope_type_enum_1.FinchScopeType;
		}
	});
	Object.defineProperty(exports, "FinchScopeTypeSchema", {
		enumerable: true,
		get: function() {
			return finch_scope_type_enum_1.FinchScopeTypeSchema;
		}
	});
	var asc_fixed_cost_trigger_enum_1 = require_asc_fixed_cost_trigger_enum();
	Object.defineProperty(exports, "AscFixedCostTrigger", {
		enumerable: true,
		get: function() {
			return asc_fixed_cost_trigger_enum_1.AscFixedCostTrigger;
		}
	});
	Object.defineProperty(exports, "AscFixedCostTriggerSchema", {
		enumerable: true,
		get: function() {
			return asc_fixed_cost_trigger_enum_1.AscFixedCostTriggerSchema;
		}
	});
	var product_type_enum_1 = require_product_type_enum();
	Object.defineProperty(exports, "ProductType", {
		enumerable: true,
		get: function() {
			return product_type_enum_1.ProductType;
		}
	});
	var auth_error_code_enum_1 = require_auth_error_code_enum();
	Object.defineProperty(exports, "AuthErrorCode", {
		enumerable: true,
		get: function() {
			return auth_error_code_enum_1.AuthErrorCode;
		}
	});
	var azure_devops_granularity_refusal_code_enum_1 = require_azure_devops_granularity_refusal_code_enum();
	Object.defineProperty(exports, "AzureDevopsGranularityRefusalCode", {
		enumerable: true,
		get: function() {
			return azure_devops_granularity_refusal_code_enum_1.AzureDevopsGranularityRefusalCode;
		}
	});
}));
//#endregion
//#region ../../node_modules/graphql/version.mjs
var version, versionInfo;
var init_version = __esmMin((() => {
	version = "16.8.1";
	versionInfo = Object.freeze({
		major: 16,
		minor: 8,
		patch: 1,
		preReleaseTag: null
	});
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
	if (!Boolean(condition)) throw new Error(message);
}
var init_devAssert = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/isPromise.mjs
/**
* Returns true if the value acts like a Promise, i.e. has a "then" function,
* otherwise returns false.
*/
function isPromise(value) {
	return typeof (value === null || value === void 0 ? void 0 : value.then) === "function";
}
var init_isPromise = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/isObjectLike.mjs
/**
* Return true if `value` is object-like. A value is object-like if it's not
* `null` and has a `typeof` result of "object".
*/
function isObjectLike(value) {
	return typeof value == "object" && value !== null;
}
var init_isObjectLike = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
	if (!Boolean(condition)) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}
var init_invariant = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/language/location.mjs
/**
* Represents a location in a Source.
*/
/**
* Takes a Source and a UTF-8 character offset, and returns the corresponding
* line and column as a SourceLocation.
*/
function getLocation(source, position) {
	let lastLineStart = 0;
	let line = 1;
	for (const match of source.body.matchAll(LineRegExp)) {
		typeof match.index === "number" || invariant(false);
		if (match.index >= position) break;
		lastLineStart = match.index + match[0].length;
		line += 1;
	}
	return {
		line,
		column: position + 1 - lastLineStart
	};
}
var LineRegExp;
var init_location = __esmMin((() => {
	init_invariant();
	LineRegExp = /\r\n|[\n\r]/g;
}));
//#endregion
//#region ../../node_modules/graphql/language/printLocation.mjs
/**
* Render a helpful description of the location in the GraphQL Source document.
*/
function printLocation(location) {
	return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
* Render a helpful description of the location in the GraphQL Source document.
*/
function printSourceLocation(source, sourceLocation) {
	const firstLineColumnOffset = source.locationOffset.column - 1;
	const body = "".padStart(firstLineColumnOffset) + source.body;
	const lineIndex = sourceLocation.line - 1;
	const lineOffset = source.locationOffset.line - 1;
	const lineNum = sourceLocation.line + lineOffset;
	const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
	const columnNum = sourceLocation.column + columnOffset;
	const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
	const lines = body.split(/\r\n|[\n\r]/g);
	const locationLine = lines[lineIndex];
	if (locationLine.length > 120) {
		const subLineIndex = Math.floor(columnNum / 80);
		const subLineColumnNum = columnNum % 80;
		const subLines = [];
		for (let i = 0; i < locationLine.length; i += 80) subLines.push(locationLine.slice(i, i + 80));
		return locationStr + printPrefixedLines([
			[`${lineNum} |`, subLines[0]],
			...subLines.slice(1, subLineIndex + 1).map((subLine) => ["|", subLine]),
			["|", "^".padStart(subLineColumnNum)],
			["|", subLines[subLineIndex + 1]]
		]);
	}
	return locationStr + printPrefixedLines([
		[`${lineNum - 1} |`, lines[lineIndex - 1]],
		[`${lineNum} |`, locationLine],
		["|", "^".padStart(columnNum)],
		[`${lineNum + 1} |`, lines[lineIndex + 1]]
	]);
}
function printPrefixedLines(lines) {
	const existingLines = lines.filter(([_, line]) => line !== void 0);
	const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
	return existingLines.map(([prefix, line]) => prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}
var init_printLocation = __esmMin((() => {
	init_location();
}));
//#endregion
//#region ../../node_modules/graphql/error/GraphQLError.mjs
function toNormalizedOptions(args) {
	const firstArg = args[0];
	if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
		nodes: firstArg,
		source: args[1],
		positions: args[2],
		path: args[3],
		originalError: args[4],
		extensions: args[5]
	};
	return firstArg;
}
function undefinedIfEmpty(array) {
	return array === void 0 || array.length === 0 ? void 0 : array;
}
/**
* See: https://spec.graphql.org/draft/#sec-Errors
*/
/**
* Prints a GraphQLError to a string, representing useful location information
* about the error's position in the source.
*
* @deprecated Please use `error.toString` instead. Will be removed in v17
*/
function printError(error) {
	return error.toString();
}
/**
* Given a GraphQLError, format it according to the rules described by the
* Response Format, Errors section of the GraphQL Specification.
*
* @deprecated Please use `error.toJSON` instead. Will be removed in v17
*/
function formatError(error) {
	return error.toJSON();
}
var GraphQLError;
var init_GraphQLError = __esmMin((() => {
	init_isObjectLike();
	init_location();
	init_printLocation();
	GraphQLError = class GraphQLError extends Error {
		/**
		* An array of `{ line, column }` locations within the source GraphQL document
		* which correspond to this error.
		*
		* Errors during validation often contain multiple locations, for example to
		* point out two things with the same name. Errors during execution include a
		* single location, the field which produced the error.
		*
		* Enumerable, and appears in the result of JSON.stringify().
		*/
		/**
		* An array describing the JSON-path into the execution response which
		* corresponds to this error. Only included for errors during execution.
		*
		* Enumerable, and appears in the result of JSON.stringify().
		*/
		/**
		* An array of GraphQL AST Nodes corresponding to this error.
		*/
		/**
		* The source GraphQL document for the first location of this error.
		*
		* Note that if this Error represents more than one node, the source may not
		* represent nodes after the first node.
		*/
		/**
		* An array of character offsets within the source GraphQL document
		* which correspond to this error.
		*/
		/**
		* The original error thrown from a field resolver during execution.
		*/
		/**
		* Extension fields to add to the formatted error.
		*/
		/**
		* @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
		*/
		constructor(message, ...rawArgs) {
			var _this$nodes, _nodeLocations$, _ref;
			const { nodes, source, positions, path, originalError, extensions } = toNormalizedOptions(rawArgs);
			super(message);
			this.name = "GraphQLError";
			this.path = path !== null && path !== void 0 ? path : void 0;
			this.originalError = originalError !== null && originalError !== void 0 ? originalError : void 0;
			this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : void 0);
			const nodeLocations = undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node) => node.loc).filter((loc) => loc != null));
			this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
			this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc) => loc.start);
			this.locations = positions && source ? positions.map((pos) => getLocation(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
			const originalExtensions = isObjectLike(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : void 0;
			this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null);
			Object.defineProperties(this, {
				message: {
					writable: true,
					enumerable: true
				},
				name: { enumerable: false },
				nodes: { enumerable: false },
				source: { enumerable: false },
				positions: { enumerable: false },
				originalError: { enumerable: false }
			});
			/* c8 ignore start */
			if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
				value: originalError.stack,
				writable: true,
				configurable: true
			});
			else if (Error.captureStackTrace) Error.captureStackTrace(this, GraphQLError);
			else Object.defineProperty(this, "stack", {
				value: Error().stack,
				writable: true,
				configurable: true
			});
			/* c8 ignore stop */
		}
		get [Symbol.toStringTag]() {
			return "GraphQLError";
		}
		toString() {
			let output = this.message;
			if (this.nodes) {
				for (const node of this.nodes) if (node.loc) output += "\n\n" + printLocation(node.loc);
			} else if (this.source && this.locations) for (const location of this.locations) output += "\n\n" + printSourceLocation(this.source, location);
			return output;
		}
		toJSON() {
			const formattedError = { message: this.message };
			if (this.locations != null) formattedError.locations = this.locations;
			if (this.path != null) formattedError.path = this.path;
			if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
			return formattedError;
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/error/syntaxError.mjs
/**
* Produces a GraphQLError representing a syntax error, containing useful
* descriptive information about the syntax error's position in the source.
*/
function syntaxError(source, position, description) {
	return new GraphQLError(`Syntax Error: ${description}`, {
		source,
		positions: [position]
	});
}
var init_syntaxError = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/language/ast.mjs
/**
* @internal
*/
function isNode$2(maybeNode) {
	const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
	return typeof maybeKind === "string" && kindValues.has(maybeKind);
}
var Location, Token, QueryDocumentKeys, kindValues, OperationTypeNode;
var init_ast = __esmMin((() => {
	Location = class {
		/**
		* The character offset at which this Node begins.
		*/
		/**
		* The character offset at which this Node ends.
		*/
		/**
		* The Token at which this Node begins.
		*/
		/**
		* The Token at which this Node ends.
		*/
		/**
		* The Source document the AST represents.
		*/
		constructor(startToken, endToken, source) {
			this.start = startToken.start;
			this.end = endToken.end;
			this.startToken = startToken;
			this.endToken = endToken;
			this.source = source;
		}
		get [Symbol.toStringTag]() {
			return "Location";
		}
		toJSON() {
			return {
				start: this.start,
				end: this.end
			};
		}
	};
	Token = class {
		/**
		* The kind of Token.
		*/
		/**
		* The character offset at which this Node begins.
		*/
		/**
		* The character offset at which this Node ends.
		*/
		/**
		* The 1-indexed line number on which this Token appears.
		*/
		/**
		* The 1-indexed column number at which this Token begins.
		*/
		/**
		* For non-punctuation tokens, represents the interpreted value of the token.
		*
		* Note: is undefined for punctuation tokens, but typed as string for
		* convenience in the parser.
		*/
		/**
		* Tokens exist as nodes in a double-linked-list amongst all tokens
		* including ignored tokens. <SOF> is always the first node and <EOF>
		* the last.
		*/
		constructor(kind, start, end, line, column, value) {
			this.kind = kind;
			this.start = start;
			this.end = end;
			this.line = line;
			this.column = column;
			this.value = value;
			this.prev = null;
			this.next = null;
		}
		get [Symbol.toStringTag]() {
			return "Token";
		}
		toJSON() {
			return {
				kind: this.kind,
				value: this.value,
				line: this.line,
				column: this.column
			};
		}
	};
	QueryDocumentKeys = {
		Name: [],
		Document: ["definitions"],
		OperationDefinition: [
			"name",
			"variableDefinitions",
			"directives",
			"selectionSet"
		],
		VariableDefinition: [
			"variable",
			"type",
			"defaultValue",
			"directives"
		],
		Variable: ["name"],
		SelectionSet: ["selections"],
		Field: [
			"alias",
			"name",
			"arguments",
			"directives",
			"selectionSet"
		],
		Argument: ["name", "value"],
		FragmentSpread: ["name", "directives"],
		InlineFragment: [
			"typeCondition",
			"directives",
			"selectionSet"
		],
		FragmentDefinition: [
			"name",
			"variableDefinitions",
			"typeCondition",
			"directives",
			"selectionSet"
		],
		IntValue: [],
		FloatValue: [],
		StringValue: [],
		BooleanValue: [],
		NullValue: [],
		EnumValue: [],
		ListValue: ["values"],
		ObjectValue: ["fields"],
		ObjectField: ["name", "value"],
		Directive: ["name", "arguments"],
		NamedType: ["name"],
		ListType: ["type"],
		NonNullType: ["type"],
		SchemaDefinition: [
			"description",
			"directives",
			"operationTypes"
		],
		OperationTypeDefinition: ["type"],
		ScalarTypeDefinition: [
			"description",
			"name",
			"directives"
		],
		ObjectTypeDefinition: [
			"description",
			"name",
			"interfaces",
			"directives",
			"fields"
		],
		FieldDefinition: [
			"description",
			"name",
			"arguments",
			"type",
			"directives"
		],
		InputValueDefinition: [
			"description",
			"name",
			"type",
			"defaultValue",
			"directives"
		],
		InterfaceTypeDefinition: [
			"description",
			"name",
			"interfaces",
			"directives",
			"fields"
		],
		UnionTypeDefinition: [
			"description",
			"name",
			"directives",
			"types"
		],
		EnumTypeDefinition: [
			"description",
			"name",
			"directives",
			"values"
		],
		EnumValueDefinition: [
			"description",
			"name",
			"directives"
		],
		InputObjectTypeDefinition: [
			"description",
			"name",
			"directives",
			"fields"
		],
		DirectiveDefinition: [
			"description",
			"name",
			"arguments",
			"locations"
		],
		SchemaExtension: ["directives", "operationTypes"],
		ScalarTypeExtension: ["name", "directives"],
		ObjectTypeExtension: [
			"name",
			"interfaces",
			"directives",
			"fields"
		],
		InterfaceTypeExtension: [
			"name",
			"interfaces",
			"directives",
			"fields"
		],
		UnionTypeExtension: [
			"name",
			"directives",
			"types"
		],
		EnumTypeExtension: [
			"name",
			"directives",
			"values"
		],
		InputObjectTypeExtension: [
			"name",
			"directives",
			"fields"
		]
	};
	kindValues = new Set(Object.keys(QueryDocumentKeys));
	(function(OperationTypeNode) {
		OperationTypeNode["QUERY"] = "query";
		OperationTypeNode["MUTATION"] = "mutation";
		OperationTypeNode["SUBSCRIPTION"] = "subscription";
	})(OperationTypeNode || (OperationTypeNode = {}));
}));
//#endregion
//#region ../../node_modules/graphql/language/directiveLocation.mjs
var DirectiveLocation;
var init_directiveLocation = __esmMin((() => {
	(function(DirectiveLocation) {
		DirectiveLocation["QUERY"] = "QUERY";
		DirectiveLocation["MUTATION"] = "MUTATION";
		DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
		DirectiveLocation["FIELD"] = "FIELD";
		DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
		DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
		DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
		DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
		DirectiveLocation["SCHEMA"] = "SCHEMA";
		DirectiveLocation["SCALAR"] = "SCALAR";
		DirectiveLocation["OBJECT"] = "OBJECT";
		DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
		DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
		DirectiveLocation["INTERFACE"] = "INTERFACE";
		DirectiveLocation["UNION"] = "UNION";
		DirectiveLocation["ENUM"] = "ENUM";
		DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
		DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
		DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
	})(DirectiveLocation || (DirectiveLocation = {}));
}));
/**
* The enum type representing the directive location values.
*
* @deprecated Please use `DirectiveLocation`. Will be remove in v17.
*/
//#endregion
//#region ../../node_modules/graphql/language/kinds.mjs
var Kind;
var init_kinds = __esmMin((() => {
	(function(Kind) {
		Kind["NAME"] = "Name";
		Kind["DOCUMENT"] = "Document";
		Kind["OPERATION_DEFINITION"] = "OperationDefinition";
		Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
		Kind["SELECTION_SET"] = "SelectionSet";
		Kind["FIELD"] = "Field";
		Kind["ARGUMENT"] = "Argument";
		Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
		Kind["INLINE_FRAGMENT"] = "InlineFragment";
		Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
		Kind["VARIABLE"] = "Variable";
		Kind["INT"] = "IntValue";
		Kind["FLOAT"] = "FloatValue";
		Kind["STRING"] = "StringValue";
		Kind["BOOLEAN"] = "BooleanValue";
		Kind["NULL"] = "NullValue";
		Kind["ENUM"] = "EnumValue";
		Kind["LIST"] = "ListValue";
		Kind["OBJECT"] = "ObjectValue";
		Kind["OBJECT_FIELD"] = "ObjectField";
		Kind["DIRECTIVE"] = "Directive";
		Kind["NAMED_TYPE"] = "NamedType";
		Kind["LIST_TYPE"] = "ListType";
		Kind["NON_NULL_TYPE"] = "NonNullType";
		Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
		Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
		Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
		Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
		Kind["FIELD_DEFINITION"] = "FieldDefinition";
		Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
		Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
		Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
		Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
		Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
		Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
		Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
		Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
		Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
		Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
		Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
		Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
		Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
		Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
	})(Kind || (Kind = {}));
}));
/**
* The enum type representing the possible kind values of AST nodes.
*
* @deprecated Please use `Kind`. Will be remove in v17.
*/
//#endregion
//#region ../../node_modules/graphql/language/characterClasses.mjs
/**
* ```
* WhiteSpace ::
*   - "Horizontal Tab (U+0009)"
*   - "Space (U+0020)"
* ```
* @internal
*/
function isWhiteSpace(code) {
	return code === 9 || code === 32;
}
/**
* ```
* Digit :: one of
*   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
* ```
* @internal
*/
function isDigit$1(code) {
	return code >= 48 && code <= 57;
}
/**
* ```
* Letter :: one of
*   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
*   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
*   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
*   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
* ```
* @internal
*/
function isLetter(code) {
	return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}
/**
* ```
* NameStart ::
*   - Letter
*   - `_`
* ```
* @internal
*/
function isNameStart(code) {
	return isLetter(code) || code === 95;
}
/**
* ```
* NameContinue ::
*   - Letter
*   - Digit
*   - `_`
* ```
* @internal
*/
function isNameContinue(code) {
	return isLetter(code) || isDigit$1(code) || code === 95;
}
var init_characterClasses = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/language/blockString.mjs
/**
* Produces the value of a block string from its parsed raw value, similar to
* CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
*
* This implements the GraphQL spec's BlockStringValue() static algorithm.
*
* @internal
*/
function dedentBlockStringLines(lines) {
	var _firstNonEmptyLine2;
	let commonIndent = Number.MAX_SAFE_INTEGER;
	let firstNonEmptyLine = null;
	let lastNonEmptyLine = -1;
	for (let i = 0; i < lines.length; ++i) {
		var _firstNonEmptyLine;
		const line = lines[i];
		const indent = leadingWhitespace(line);
		if (indent === line.length) continue;
		firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
		lastNonEmptyLine = i;
		if (i !== 0 && indent < commonIndent) commonIndent = indent;
	}
	return lines.map((line, i) => i === 0 ? line : line.slice(commonIndent)).slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function leadingWhitespace(str) {
	let i = 0;
	while (i < str.length && isWhiteSpace(str.charCodeAt(i))) ++i;
	return i;
}
/**
* @internal
*/
function isPrintableAsBlockString(value) {
	if (value === "") return true;
	let isEmptyLine = true;
	let hasIndent = false;
	let hasCommonIndent = true;
	let seenNonEmptyLine = false;
	for (let i = 0; i < value.length; ++i) switch (value.codePointAt(i)) {
		case 0:
		case 1:
		case 2:
		case 3:
		case 4:
		case 5:
		case 6:
		case 7:
		case 8:
		case 11:
		case 12:
		case 14:
		case 15: return false;
		case 13: return false;
		case 10:
			if (isEmptyLine && !seenNonEmptyLine) return false;
			seenNonEmptyLine = true;
			isEmptyLine = true;
			hasIndent = false;
			break;
		case 9:
		case 32:
			hasIndent || (hasIndent = isEmptyLine);
			break;
		default:
			hasCommonIndent && (hasCommonIndent = hasIndent);
			isEmptyLine = false;
	}
	if (isEmptyLine) return false;
	if (hasCommonIndent && seenNonEmptyLine) return false;
	return true;
}
/**
* Print a block string in the indented block form by adding a leading and
* trailing blank line. However, if a block string starts with whitespace and is
* a single-line, adding a leading blank line would strip that whitespace.
*
* @internal
*/
function printBlockString(value, options) {
	const escapedValue = value.replace(/"""/g, "\\\"\"\"");
	const lines = escapedValue.split(/\r\n|[\n\r]/g);
	const isSingleLine = lines.length === 1;
	const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0)));
	const hasTrailingTripleQuotes = escapedValue.endsWith("\\\"\"\"");
	const hasTrailingQuote = value.endsWith("\"") && !hasTrailingTripleQuotes;
	const hasTrailingSlash = value.endsWith("\\");
	const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
	const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
	let result = "";
	const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));
	if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
	result += escapedValue;
	if (printAsMultipleLines || forceTrailingNewline) result += "\n";
	return "\"\"\"" + result + "\"\"\"";
}
var init_blockString = __esmMin((() => {
	init_characterClasses();
}));
//#endregion
//#region ../../node_modules/graphql/language/tokenKind.mjs
var TokenKind;
var init_tokenKind = __esmMin((() => {
	(function(TokenKind) {
		TokenKind["SOF"] = "<SOF>";
		TokenKind["EOF"] = "<EOF>";
		TokenKind["BANG"] = "!";
		TokenKind["DOLLAR"] = "$";
		TokenKind["AMP"] = "&";
		TokenKind["PAREN_L"] = "(";
		TokenKind["PAREN_R"] = ")";
		TokenKind["SPREAD"] = "...";
		TokenKind["COLON"] = ":";
		TokenKind["EQUALS"] = "=";
		TokenKind["AT"] = "@";
		TokenKind["BRACKET_L"] = "[";
		TokenKind["BRACKET_R"] = "]";
		TokenKind["BRACE_L"] = "{";
		TokenKind["PIPE"] = "|";
		TokenKind["BRACE_R"] = "}";
		TokenKind["NAME"] = "Name";
		TokenKind["INT"] = "Int";
		TokenKind["FLOAT"] = "Float";
		TokenKind["STRING"] = "String";
		TokenKind["BLOCK_STRING"] = "BlockString";
		TokenKind["COMMENT"] = "Comment";
	})(TokenKind || (TokenKind = {}));
}));
/**
* The enum type representing the token kinds values.
*
* @deprecated Please use `TokenKind`. Will be remove in v17.
*/
//#endregion
//#region ../../node_modules/graphql/language/lexer.mjs
/**
* @internal
*/
function isPunctuatorTokenKind(kind) {
	return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
/**
* A Unicode scalar value is any Unicode code point except surrogate code
* points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
* 0xE000 to 0x10FFFF.
*
* SourceCharacter ::
*   - "Any Unicode scalar value"
*/
function isUnicodeScalarValue(code) {
	return code >= 0 && code <= 55295 || code >= 57344 && code <= 1114111;
}
/**
* The GraphQL specification defines source text as a sequence of unicode scalar
* values (which Unicode defines to exclude surrogate code points). However
* JavaScript defines strings as a sequence of UTF-16 code units which may
* include surrogates. A surrogate pair is a valid source character as it
* encodes a supplementary code point (above U+FFFF), but unpaired surrogate
* code points are not valid source characters.
*/
function isSupplementaryCodePoint(body, location) {
	return isLeadingSurrogate(body.charCodeAt(location)) && isTrailingSurrogate(body.charCodeAt(location + 1));
}
function isLeadingSurrogate(code) {
	return code >= 55296 && code <= 56319;
}
function isTrailingSurrogate(code) {
	return code >= 56320 && code <= 57343;
}
/**
* Prints the code point (or end of file reference) at a given location in a
* source for use in error messages.
*
* Printable ASCII is printed quoted, while other points are printed in Unicode
* code point form (ie. U+1234).
*/
function printCodePointAt(lexer, location) {
	const code = lexer.source.body.codePointAt(location);
	if (code === void 0) return TokenKind.EOF;
	else if (code >= 32 && code <= 126) {
		const char = String.fromCodePoint(code);
		return char === "\"" ? "'\"'" : `"${char}"`;
	}
	return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
* Create a token with line and column location information.
*/
function createToken(lexer, kind, start, end, value) {
	const line = lexer.line;
	const col = 1 + start - lexer.lineStart;
	return new Token(kind, start, end, line, col, value);
}
/**
* Gets the next token from the source starting at the given position.
*
* This skips over whitespace until it finds the next lexable token, then lexes
* punctuators immediately or calls the appropriate helper function for more
* complicated tokens.
*/
function readNextToken(lexer, start) {
	const body = lexer.source.body;
	const bodyLength = body.length;
	let position = start;
	while (position < bodyLength) {
		const code = body.charCodeAt(position);
		switch (code) {
			case 65279:
			case 9:
			case 32:
			case 44:
				++position;
				continue;
			case 10:
				++position;
				++lexer.line;
				lexer.lineStart = position;
				continue;
			case 13:
				if (body.charCodeAt(position + 1) === 10) position += 2;
				else ++position;
				++lexer.line;
				lexer.lineStart = position;
				continue;
			case 35: return readComment(lexer, position);
			case 33: return createToken(lexer, TokenKind.BANG, position, position + 1);
			case 36: return createToken(lexer, TokenKind.DOLLAR, position, position + 1);
			case 38: return createToken(lexer, TokenKind.AMP, position, position + 1);
			case 40: return createToken(lexer, TokenKind.PAREN_L, position, position + 1);
			case 41: return createToken(lexer, TokenKind.PAREN_R, position, position + 1);
			case 46:
				if (body.charCodeAt(position + 1) === 46 && body.charCodeAt(position + 2) === 46) return createToken(lexer, TokenKind.SPREAD, position, position + 3);
				break;
			case 58: return createToken(lexer, TokenKind.COLON, position, position + 1);
			case 61: return createToken(lexer, TokenKind.EQUALS, position, position + 1);
			case 64: return createToken(lexer, TokenKind.AT, position, position + 1);
			case 91: return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);
			case 93: return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);
			case 123: return createToken(lexer, TokenKind.BRACE_L, position, position + 1);
			case 124: return createToken(lexer, TokenKind.PIPE, position, position + 1);
			case 125: return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
			case 34:
				if (body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) return readBlockString(lexer, position);
				return readString(lexer, position);
		}
		if (isDigit$1(code) || code === 45) return readNumber(lexer, position, code);
		if (isNameStart(code)) return readName(lexer, position);
		throw syntaxError(lexer.source, position, code === 39 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position) ? `Unexpected character: ${printCodePointAt(lexer, position)}.` : `Invalid character: ${printCodePointAt(lexer, position)}.`);
	}
	return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
/**
* Reads a comment token from the source file.
*
* ```
* Comment :: # CommentChar* [lookahead != CommentChar]
*
* CommentChar :: SourceCharacter but not LineTerminator
* ```
*/
function readComment(lexer, start) {
	const body = lexer.source.body;
	const bodyLength = body.length;
	let position = start + 1;
	while (position < bodyLength) {
		const code = body.charCodeAt(position);
		if (code === 10 || code === 13) break;
		if (isUnicodeScalarValue(code)) ++position;
		else if (isSupplementaryCodePoint(body, position)) position += 2;
		else break;
	}
	return createToken(lexer, TokenKind.COMMENT, start, position, body.slice(start + 1, position));
}
/**
* Reads a number token from the source file, either a FloatValue or an IntValue
* depending on whether a FractionalPart or ExponentPart is encountered.
*
* ```
* IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
*
* IntegerPart ::
*   - NegativeSign? 0
*   - NegativeSign? NonZeroDigit Digit*
*
* NegativeSign :: -
*
* NonZeroDigit :: Digit but not `0`
*
* FloatValue ::
*   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
*   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
*   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
*
* FractionalPart :: . Digit+
*
* ExponentPart :: ExponentIndicator Sign? Digit+
*
* ExponentIndicator :: one of `e` `E`
*
* Sign :: one of + -
* ```
*/
function readNumber(lexer, start, firstCode) {
	const body = lexer.source.body;
	let position = start;
	let code = firstCode;
	let isFloat = false;
	if (code === 45) code = body.charCodeAt(++position);
	if (code === 48) {
		code = body.charCodeAt(++position);
		if (isDigit$1(code)) throw syntaxError(lexer.source, position, `Invalid number, unexpected digit after 0: ${printCodePointAt(lexer, position)}.`);
	} else {
		position = readDigits(lexer, position, code);
		code = body.charCodeAt(position);
	}
	if (code === 46) {
		isFloat = true;
		code = body.charCodeAt(++position);
		position = readDigits(lexer, position, code);
		code = body.charCodeAt(position);
	}
	if (code === 69 || code === 101) {
		isFloat = true;
		code = body.charCodeAt(++position);
		if (code === 43 || code === 45) code = body.charCodeAt(++position);
		position = readDigits(lexer, position, code);
		code = body.charCodeAt(position);
	}
	if (code === 46 || isNameStart(code)) throw syntaxError(lexer.source, position, `Invalid number, expected digit but got: ${printCodePointAt(lexer, position)}.`);
	return createToken(lexer, isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, body.slice(start, position));
}
/**
* Returns the new position in the source after reading one or more digits.
*/
function readDigits(lexer, start, firstCode) {
	if (!isDigit$1(firstCode)) throw syntaxError(lexer.source, start, `Invalid number, expected digit but got: ${printCodePointAt(lexer, start)}.`);
	const body = lexer.source.body;
	let position = start + 1;
	while (isDigit$1(body.charCodeAt(position))) ++position;
	return position;
}
/**
* Reads a single-quote string token from the source file.
*
* ```
* StringValue ::
*   - `""` [lookahead != `"`]
*   - `"` StringCharacter+ `"`
*
* StringCharacter ::
*   - SourceCharacter but not `"` or `\` or LineTerminator
*   - `\u` EscapedUnicode
*   - `\` EscapedCharacter
*
* EscapedUnicode ::
*   - `{` HexDigit+ `}`
*   - HexDigit HexDigit HexDigit HexDigit
*
* EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
* ```
*/
function readString(lexer, start) {
	const body = lexer.source.body;
	const bodyLength = body.length;
	let position = start + 1;
	let chunkStart = position;
	let value = "";
	while (position < bodyLength) {
		const code = body.charCodeAt(position);
		if (code === 34) {
			value += body.slice(chunkStart, position);
			return createToken(lexer, TokenKind.STRING, start, position + 1, value);
		}
		if (code === 92) {
			value += body.slice(chunkStart, position);
			const escape = body.charCodeAt(position + 1) === 117 ? body.charCodeAt(position + 2) === 123 ? readEscapedUnicodeVariableWidth(lexer, position) : readEscapedUnicodeFixedWidth(lexer, position) : readEscapedCharacter(lexer, position);
			value += escape.value;
			position += escape.size;
			chunkStart = position;
			continue;
		}
		if (code === 10 || code === 13) break;
		if (isUnicodeScalarValue(code)) ++position;
		else if (isSupplementaryCodePoint(body, position)) position += 2;
		else throw syntaxError(lexer.source, position, `Invalid character within String: ${printCodePointAt(lexer, position)}.`);
	}
	throw syntaxError(lexer.source, position, "Unterminated string.");
}
function readEscapedUnicodeVariableWidth(lexer, position) {
	const body = lexer.source.body;
	let point = 0;
	let size = 3;
	while (size < 12) {
		const code = body.charCodeAt(position + size++);
		if (code === 125) {
			if (size < 5 || !isUnicodeScalarValue(point)) break;
			return {
				value: String.fromCodePoint(point),
				size
			};
		}
		point = point << 4 | readHexDigit(code);
		if (point < 0) break;
	}
	throw syntaxError(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function readEscapedUnicodeFixedWidth(lexer, position) {
	const body = lexer.source.body;
	const code = read16BitHexCode(body, position + 2);
	if (isUnicodeScalarValue(code)) return {
		value: String.fromCodePoint(code),
		size: 6
	};
	if (isLeadingSurrogate(code)) {
		if (body.charCodeAt(position + 6) === 92 && body.charCodeAt(position + 7) === 117) {
			const trailingCode = read16BitHexCode(body, position + 8);
			if (isTrailingSurrogate(trailingCode)) return {
				value: String.fromCodePoint(code, trailingCode),
				size: 12
			};
		}
	}
	throw syntaxError(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
* Reads four hexadecimal characters and returns the positive integer that 16bit
* hexadecimal string represents. For example, "000f" will return 15, and "dead"
* will return 57005.
*
* Returns a negative number if any char was not a valid hexadecimal digit.
*/
function read16BitHexCode(body, position) {
	return readHexDigit(body.charCodeAt(position)) << 12 | readHexDigit(body.charCodeAt(position + 1)) << 8 | readHexDigit(body.charCodeAt(position + 2)) << 4 | readHexDigit(body.charCodeAt(position + 3));
}
/**
* Reads a hexadecimal character and returns its positive integer value (0-15).
*
* '0' becomes 0, '9' becomes 9
* 'A' becomes 10, 'F' becomes 15
* 'a' becomes 10, 'f' becomes 15
*
* Returns -1 if the provided character code was not a valid hexadecimal digit.
*
* HexDigit :: one of
*   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
*   - `A` `B` `C` `D` `E` `F`
*   - `a` `b` `c` `d` `e` `f`
*/
function readHexDigit(code) {
	return code >= 48 && code <= 57 ? code - 48 : code >= 65 && code <= 70 ? code - 55 : code >= 97 && code <= 102 ? code - 87 : -1;
}
/**
* | Escaped Character | Code Point | Character Name               |
* | ----------------- | ---------- | ---------------------------- |
* | `"`               | U+0022     | double quote                 |
* | `\`               | U+005C     | reverse solidus (back slash) |
* | `/`               | U+002F     | solidus (forward slash)      |
* | `b`               | U+0008     | backspace                    |
* | `f`               | U+000C     | form feed                    |
* | `n`               | U+000A     | line feed (new line)         |
* | `r`               | U+000D     | carriage return              |
* | `t`               | U+0009     | horizontal tab               |
*/
function readEscapedCharacter(lexer, position) {
	const body = lexer.source.body;
	switch (body.charCodeAt(position + 1)) {
		case 34: return {
			value: "\"",
			size: 2
		};
		case 92: return {
			value: "\\",
			size: 2
		};
		case 47: return {
			value: "/",
			size: 2
		};
		case 98: return {
			value: "\b",
			size: 2
		};
		case 102: return {
			value: "\f",
			size: 2
		};
		case 110: return {
			value: "\n",
			size: 2
		};
		case 114: return {
			value: "\r",
			size: 2
		};
		case 116: return {
			value: "	",
			size: 2
		};
	}
	throw syntaxError(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
* Reads a block string token from the source file.
*
* ```
* StringValue ::
*   - `"""` BlockStringCharacter* `"""`
*
* BlockStringCharacter ::
*   - SourceCharacter but not `"""` or `\"""`
*   - `\"""`
* ```
*/
function readBlockString(lexer, start) {
	const body = lexer.source.body;
	const bodyLength = body.length;
	let lineStart = lexer.lineStart;
	let position = start + 3;
	let chunkStart = position;
	let currentLine = "";
	const blockLines = [];
	while (position < bodyLength) {
		const code = body.charCodeAt(position);
		if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
			currentLine += body.slice(chunkStart, position);
			blockLines.push(currentLine);
			const token = createToken(lexer, TokenKind.BLOCK_STRING, start, position + 3, dedentBlockStringLines(blockLines).join("\n"));
			lexer.line += blockLines.length - 1;
			lexer.lineStart = lineStart;
			return token;
		}
		if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
			currentLine += body.slice(chunkStart, position);
			chunkStart = position + 1;
			position += 4;
			continue;
		}
		if (code === 10 || code === 13) {
			currentLine += body.slice(chunkStart, position);
			blockLines.push(currentLine);
			if (code === 13 && body.charCodeAt(position + 1) === 10) position += 2;
			else ++position;
			currentLine = "";
			chunkStart = position;
			lineStart = position;
			continue;
		}
		if (isUnicodeScalarValue(code)) ++position;
		else if (isSupplementaryCodePoint(body, position)) position += 2;
		else throw syntaxError(lexer.source, position, `Invalid character within String: ${printCodePointAt(lexer, position)}.`);
	}
	throw syntaxError(lexer.source, position, "Unterminated string.");
}
/**
* Reads an alphanumeric + underscore name from the source.
*
* ```
* Name ::
*   - NameStart NameContinue* [lookahead != NameContinue]
* ```
*/
function readName(lexer, start) {
	const body = lexer.source.body;
	const bodyLength = body.length;
	let position = start + 1;
	while (position < bodyLength) if (isNameContinue(body.charCodeAt(position))) ++position;
	else break;
	return createToken(lexer, TokenKind.NAME, start, position, body.slice(start, position));
}
var Lexer;
var init_lexer = __esmMin((() => {
	init_syntaxError();
	init_ast();
	init_blockString();
	init_characterClasses();
	init_tokenKind();
	Lexer = class {
		/**
		* The previously focused non-ignored token.
		*/
		/**
		* The currently focused non-ignored token.
		*/
		/**
		* The (1-indexed) line containing the current token.
		*/
		/**
		* The character offset at which the current line begins.
		*/
		constructor(source) {
			const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
			this.source = source;
			this.lastToken = startOfFileToken;
			this.token = startOfFileToken;
			this.line = 1;
			this.lineStart = 0;
		}
		get [Symbol.toStringTag]() {
			return "Lexer";
		}
		/**
		* Advances the token stream to the next non-ignored token.
		*/
		advance() {
			this.lastToken = this.token;
			return this.token = this.lookahead();
		}
		/**
		* Looks ahead and returns the next non-ignored token, but does not change
		* the state of Lexer.
		*/
		lookahead() {
			let token = this.token;
			if (token.kind !== TokenKind.EOF) do
				if (token.next) token = token.next;
				else {
					const nextToken = readNextToken(this, token.end);
					token.next = nextToken;
					nextToken.prev = token;
					token = nextToken;
				}
			while (token.kind === TokenKind.COMMENT);
			return token;
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/inspect.mjs
/**
* Used to print values in error messages.
*/
function inspect(value) {
	return formatValue(value, []);
}
function formatValue(value, seenValues) {
	switch (typeof value) {
		case "string": return JSON.stringify(value);
		case "function": return value.name ? `[function ${value.name}]` : "[function]";
		case "object": return formatObjectValue(value, seenValues);
		default: return String(value);
	}
}
function formatObjectValue(value, previouslySeenValues) {
	if (value === null) return "null";
	if (previouslySeenValues.includes(value)) return "[Circular]";
	const seenValues = [...previouslySeenValues, value];
	if (isJSONable(value)) {
		const jsonValue = value.toJSON();
		if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : formatValue(jsonValue, seenValues);
	} else if (Array.isArray(value)) return formatArray(value, seenValues);
	return formatObject(value, seenValues);
}
function isJSONable(value) {
	return typeof value.toJSON === "function";
}
function formatObject(object, seenValues) {
	const entries = Object.entries(object);
	if (entries.length === 0) return "{}";
	if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[" + getObjectTag(object) + "]";
	return "{ " + entries.map(([key, value]) => key + ": " + formatValue(value, seenValues)).join(", ") + " }";
}
function formatArray(array, seenValues) {
	if (array.length === 0) return "[]";
	if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[Array]";
	const len = Math.min(MAX_ARRAY_LENGTH, array.length);
	const remaining = array.length - len;
	const items = [];
	for (let i = 0; i < len; ++i) items.push(formatValue(array[i], seenValues));
	if (remaining === 1) items.push("... 1 more item");
	else if (remaining > 1) items.push(`... ${remaining} more items`);
	return "[" + items.join(", ") + "]";
}
function getObjectTag(object) {
	const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
	if (tag === "Object" && typeof object.constructor === "function") {
		const name = object.constructor.name;
		if (typeof name === "string" && name !== "") return name;
	}
	return tag;
}
var MAX_ARRAY_LENGTH, MAX_RECURSIVE_DEPTH;
var init_inspect = __esmMin((() => {
	MAX_ARRAY_LENGTH = 10;
	MAX_RECURSIVE_DEPTH = 2;
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/instanceOf.mjs
var instanceOf;
var init_instanceOf = __esmMin((() => {
	init_inspect();
	instanceOf = globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
		return value instanceof constructor;
	} : function instanceOf(value, constructor) {
		if (value instanceof constructor) return true;
		if (typeof value === "object" && value !== null) {
			var _value$constructor;
			const className = constructor.prototype[Symbol.toStringTag];
			if (className === (Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name)) {
				const stringifiedValue = inspect(value);
				throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
			}
		}
		return false;
	};
}));
//#endregion
//#region ../../node_modules/graphql/language/source.mjs
/**
* Test if the given value is a Source object.
*
* @internal
*/
function isSource(source) {
	return instanceOf(source, Source);
}
var Source;
var init_source = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_instanceOf();
	Source = class {
		constructor(body, name = "GraphQL request", locationOffset = {
			line: 1,
			column: 1
		}) {
			typeof body === "string" || devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
			this.body = body;
			this.name = name;
			this.locationOffset = locationOffset;
			this.locationOffset.line > 0 || devAssert(false, "line in locationOffset is 1-indexed and must be positive.");
			this.locationOffset.column > 0 || devAssert(false, "column in locationOffset is 1-indexed and must be positive.");
		}
		get [Symbol.toStringTag]() {
			return "Source";
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/language/parser.mjs
/**
* Configuration options to control parser behavior
*/
/**
* Given a GraphQL source, parses it into a Document.
* Throws GraphQLError if a syntax error is encountered.
*/
function parse(source, options) {
	return new Parser(source, options).parseDocument();
}
/**
* Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
* that value.
* Throws GraphQLError if a syntax error is encountered.
*
* This is useful within tools that operate upon GraphQL Values directly and
* in isolation of complete GraphQL documents.
*
* Consider providing the results to the utility function: valueFromAST().
*/
function parseValue(source, options) {
	const parser = new Parser(source, options);
	parser.expectToken(TokenKind.SOF);
	const value = parser.parseValueLiteral(false);
	parser.expectToken(TokenKind.EOF);
	return value;
}
/**
* Similar to parseValue(), but raises a parse error if it encounters a
* variable. The return type will be a constant value.
*/
function parseConstValue(source, options) {
	const parser = new Parser(source, options);
	parser.expectToken(TokenKind.SOF);
	const value = parser.parseConstValueLiteral();
	parser.expectToken(TokenKind.EOF);
	return value;
}
/**
* Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
* that type.
* Throws GraphQLError if a syntax error is encountered.
*
* This is useful within tools that operate upon GraphQL Types directly and
* in isolation of complete GraphQL documents.
*
* Consider providing the results to the utility function: typeFromAST().
*/
function parseType(source, options) {
	const parser = new Parser(source, options);
	parser.expectToken(TokenKind.SOF);
	const type = parser.parseTypeReference();
	parser.expectToken(TokenKind.EOF);
	return type;
}
/**
* A helper function to describe a token as a string for debugging.
*/
function getTokenDesc(token) {
	const value = token.value;
	return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
* A helper function to describe a token kind as a string for debugging.
*/
function getTokenKindDesc(kind) {
	return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}
var Parser;
var init_parser = __esmMin((() => {
	init_syntaxError();
	init_ast();
	init_directiveLocation();
	init_kinds();
	init_lexer();
	init_source();
	init_tokenKind();
	Parser = class {
		constructor(source, options = {}) {
			const sourceObj = isSource(source) ? source : new Source(source);
			this._lexer = new Lexer(sourceObj);
			this._options = options;
			this._tokenCounter = 0;
		}
		/**
		* Converts a name lex token into a name parse node.
		*/
		parseName() {
			const token = this.expectToken(TokenKind.NAME);
			return this.node(token, {
				kind: Kind.NAME,
				value: token.value
			});
		}
		/**
		* Document : Definition+
		*/
		parseDocument() {
			return this.node(this._lexer.token, {
				kind: Kind.DOCUMENT,
				definitions: this.many(TokenKind.SOF, this.parseDefinition, TokenKind.EOF)
			});
		}
		/**
		* Definition :
		*   - ExecutableDefinition
		*   - TypeSystemDefinition
		*   - TypeSystemExtension
		*
		* ExecutableDefinition :
		*   - OperationDefinition
		*   - FragmentDefinition
		*
		* TypeSystemDefinition :
		*   - SchemaDefinition
		*   - TypeDefinition
		*   - DirectiveDefinition
		*
		* TypeDefinition :
		*   - ScalarTypeDefinition
		*   - ObjectTypeDefinition
		*   - InterfaceTypeDefinition
		*   - UnionTypeDefinition
		*   - EnumTypeDefinition
		*   - InputObjectTypeDefinition
		*/
		parseDefinition() {
			if (this.peek(TokenKind.BRACE_L)) return this.parseOperationDefinition();
			const hasDescription = this.peekDescription();
			const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
			if (keywordToken.kind === TokenKind.NAME) {
				switch (keywordToken.value) {
					case "schema": return this.parseSchemaDefinition();
					case "scalar": return this.parseScalarTypeDefinition();
					case "type": return this.parseObjectTypeDefinition();
					case "interface": return this.parseInterfaceTypeDefinition();
					case "union": return this.parseUnionTypeDefinition();
					case "enum": return this.parseEnumTypeDefinition();
					case "input": return this.parseInputObjectTypeDefinition();
					case "directive": return this.parseDirectiveDefinition();
				}
				if (hasDescription) throw syntaxError(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
				switch (keywordToken.value) {
					case "query":
					case "mutation":
					case "subscription": return this.parseOperationDefinition();
					case "fragment": return this.parseFragmentDefinition();
					case "extend": return this.parseTypeSystemExtension();
				}
			}
			throw this.unexpected(keywordToken);
		}
		/**
		* OperationDefinition :
		*  - SelectionSet
		*  - OperationType Name? VariableDefinitions? Directives? SelectionSet
		*/
		parseOperationDefinition() {
			const start = this._lexer.token;
			if (this.peek(TokenKind.BRACE_L)) return this.node(start, {
				kind: Kind.OPERATION_DEFINITION,
				operation: OperationTypeNode.QUERY,
				name: void 0,
				variableDefinitions: [],
				directives: [],
				selectionSet: this.parseSelectionSet()
			});
			const operation = this.parseOperationType();
			let name;
			if (this.peek(TokenKind.NAME)) name = this.parseName();
			return this.node(start, {
				kind: Kind.OPERATION_DEFINITION,
				operation,
				name,
				variableDefinitions: this.parseVariableDefinitions(),
				directives: this.parseDirectives(false),
				selectionSet: this.parseSelectionSet()
			});
		}
		/**
		* OperationType : one of query mutation subscription
		*/
		parseOperationType() {
			const operationToken = this.expectToken(TokenKind.NAME);
			switch (operationToken.value) {
				case "query": return OperationTypeNode.QUERY;
				case "mutation": return OperationTypeNode.MUTATION;
				case "subscription": return OperationTypeNode.SUBSCRIPTION;
			}
			throw this.unexpected(operationToken);
		}
		/**
		* VariableDefinitions : ( VariableDefinition+ )
		*/
		parseVariableDefinitions() {
			return this.optionalMany(TokenKind.PAREN_L, this.parseVariableDefinition, TokenKind.PAREN_R);
		}
		/**
		* VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
		*/
		parseVariableDefinition() {
			return this.node(this._lexer.token, {
				kind: Kind.VARIABLE_DEFINITION,
				variable: this.parseVariable(),
				type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
				defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseConstValueLiteral() : void 0,
				directives: this.parseConstDirectives()
			});
		}
		/**
		* Variable : $ Name
		*/
		parseVariable() {
			const start = this._lexer.token;
			this.expectToken(TokenKind.DOLLAR);
			return this.node(start, {
				kind: Kind.VARIABLE,
				name: this.parseName()
			});
		}
		/**
		* ```
		* SelectionSet : { Selection+ }
		* ```
		*/
		parseSelectionSet() {
			return this.node(this._lexer.token, {
				kind: Kind.SELECTION_SET,
				selections: this.many(TokenKind.BRACE_L, this.parseSelection, TokenKind.BRACE_R)
			});
		}
		/**
		* Selection :
		*   - Field
		*   - FragmentSpread
		*   - InlineFragment
		*/
		parseSelection() {
			return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
		}
		/**
		* Field : Alias? Name Arguments? Directives? SelectionSet?
		*
		* Alias : Name :
		*/
		parseField() {
			const start = this._lexer.token;
			const nameOrAlias = this.parseName();
			let alias;
			let name;
			if (this.expectOptionalToken(TokenKind.COLON)) {
				alias = nameOrAlias;
				name = this.parseName();
			} else name = nameOrAlias;
			return this.node(start, {
				kind: Kind.FIELD,
				alias,
				name,
				arguments: this.parseArguments(false),
				directives: this.parseDirectives(false),
				selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : void 0
			});
		}
		/**
		* Arguments[Const] : ( Argument[?Const]+ )
		*/
		parseArguments(isConst) {
			const item = isConst ? this.parseConstArgument : this.parseArgument;
			return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
		}
		/**
		* Argument[Const] : Name : Value[?Const]
		*/
		parseArgument(isConst = false) {
			const start = this._lexer.token;
			const name = this.parseName();
			this.expectToken(TokenKind.COLON);
			return this.node(start, {
				kind: Kind.ARGUMENT,
				name,
				value: this.parseValueLiteral(isConst)
			});
		}
		parseConstArgument() {
			return this.parseArgument(true);
		}
		/**
		* Corresponds to both FragmentSpread and InlineFragment in the spec.
		*
		* FragmentSpread : ... FragmentName Directives?
		*
		* InlineFragment : ... TypeCondition? Directives? SelectionSet
		*/
		parseFragment() {
			const start = this._lexer.token;
			this.expectToken(TokenKind.SPREAD);
			const hasTypeCondition = this.expectOptionalKeyword("on");
			if (!hasTypeCondition && this.peek(TokenKind.NAME)) return this.node(start, {
				kind: Kind.FRAGMENT_SPREAD,
				name: this.parseFragmentName(),
				directives: this.parseDirectives(false)
			});
			return this.node(start, {
				kind: Kind.INLINE_FRAGMENT,
				typeCondition: hasTypeCondition ? this.parseNamedType() : void 0,
				directives: this.parseDirectives(false),
				selectionSet: this.parseSelectionSet()
			});
		}
		/**
		* FragmentDefinition :
		*   - fragment FragmentName on TypeCondition Directives? SelectionSet
		*
		* TypeCondition : NamedType
		*/
		parseFragmentDefinition() {
			const start = this._lexer.token;
			this.expectKeyword("fragment");
			if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
				kind: Kind.FRAGMENT_DEFINITION,
				name: this.parseFragmentName(),
				variableDefinitions: this.parseVariableDefinitions(),
				typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
				directives: this.parseDirectives(false),
				selectionSet: this.parseSelectionSet()
			});
			return this.node(start, {
				kind: Kind.FRAGMENT_DEFINITION,
				name: this.parseFragmentName(),
				typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
				directives: this.parseDirectives(false),
				selectionSet: this.parseSelectionSet()
			});
		}
		/**
		* FragmentName : Name but not `on`
		*/
		parseFragmentName() {
			if (this._lexer.token.value === "on") throw this.unexpected();
			return this.parseName();
		}
		/**
		* Value[Const] :
		*   - [~Const] Variable
		*   - IntValue
		*   - FloatValue
		*   - StringValue
		*   - BooleanValue
		*   - NullValue
		*   - EnumValue
		*   - ListValue[?Const]
		*   - ObjectValue[?Const]
		*
		* BooleanValue : one of `true` `false`
		*
		* NullValue : `null`
		*
		* EnumValue : Name but not `true`, `false` or `null`
		*/
		parseValueLiteral(isConst) {
			const token = this._lexer.token;
			switch (token.kind) {
				case TokenKind.BRACKET_L: return this.parseList(isConst);
				case TokenKind.BRACE_L: return this.parseObject(isConst);
				case TokenKind.INT:
					this.advanceLexer();
					return this.node(token, {
						kind: Kind.INT,
						value: token.value
					});
				case TokenKind.FLOAT:
					this.advanceLexer();
					return this.node(token, {
						kind: Kind.FLOAT,
						value: token.value
					});
				case TokenKind.STRING:
				case TokenKind.BLOCK_STRING: return this.parseStringLiteral();
				case TokenKind.NAME:
					this.advanceLexer();
					switch (token.value) {
						case "true": return this.node(token, {
							kind: Kind.BOOLEAN,
							value: true
						});
						case "false": return this.node(token, {
							kind: Kind.BOOLEAN,
							value: false
						});
						case "null": return this.node(token, { kind: Kind.NULL });
						default: return this.node(token, {
							kind: Kind.ENUM,
							value: token.value
						});
					}
				case TokenKind.DOLLAR:
					if (isConst) {
						this.expectToken(TokenKind.DOLLAR);
						if (this._lexer.token.kind === TokenKind.NAME) {
							const varName = this._lexer.token.value;
							throw syntaxError(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
						} else throw this.unexpected(token);
					}
					return this.parseVariable();
				default: throw this.unexpected();
			}
		}
		parseConstValueLiteral() {
			return this.parseValueLiteral(true);
		}
		parseStringLiteral() {
			const token = this._lexer.token;
			this.advanceLexer();
			return this.node(token, {
				kind: Kind.STRING,
				value: token.value,
				block: token.kind === TokenKind.BLOCK_STRING
			});
		}
		/**
		* ListValue[Const] :
		*   - [ ]
		*   - [ Value[?Const]+ ]
		*/
		parseList(isConst) {
			const item = () => this.parseValueLiteral(isConst);
			return this.node(this._lexer.token, {
				kind: Kind.LIST,
				values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R)
			});
		}
		/**
		* ```
		* ObjectValue[Const] :
		*   - { }
		*   - { ObjectField[?Const]+ }
		* ```
		*/
		parseObject(isConst) {
			const item = () => this.parseObjectField(isConst);
			return this.node(this._lexer.token, {
				kind: Kind.OBJECT,
				fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R)
			});
		}
		/**
		* ObjectField[Const] : Name : Value[?Const]
		*/
		parseObjectField(isConst) {
			const start = this._lexer.token;
			const name = this.parseName();
			this.expectToken(TokenKind.COLON);
			return this.node(start, {
				kind: Kind.OBJECT_FIELD,
				name,
				value: this.parseValueLiteral(isConst)
			});
		}
		/**
		* Directives[Const] : Directive[?Const]+
		*/
		parseDirectives(isConst) {
			const directives = [];
			while (this.peek(TokenKind.AT)) directives.push(this.parseDirective(isConst));
			return directives;
		}
		parseConstDirectives() {
			return this.parseDirectives(true);
		}
		/**
		* ```
		* Directive[Const] : @ Name Arguments[?Const]?
		* ```
		*/
		parseDirective(isConst) {
			const start = this._lexer.token;
			this.expectToken(TokenKind.AT);
			return this.node(start, {
				kind: Kind.DIRECTIVE,
				name: this.parseName(),
				arguments: this.parseArguments(isConst)
			});
		}
		/**
		* Type :
		*   - NamedType
		*   - ListType
		*   - NonNullType
		*/
		parseTypeReference() {
			const start = this._lexer.token;
			let type;
			if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
				const innerType = this.parseTypeReference();
				this.expectToken(TokenKind.BRACKET_R);
				type = this.node(start, {
					kind: Kind.LIST_TYPE,
					type: innerType
				});
			} else type = this.parseNamedType();
			if (this.expectOptionalToken(TokenKind.BANG)) return this.node(start, {
				kind: Kind.NON_NULL_TYPE,
				type
			});
			return type;
		}
		/**
		* NamedType : Name
		*/
		parseNamedType() {
			return this.node(this._lexer.token, {
				kind: Kind.NAMED_TYPE,
				name: this.parseName()
			});
		}
		peekDescription() {
			return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
		}
		/**
		* Description : StringValue
		*/
		parseDescription() {
			if (this.peekDescription()) return this.parseStringLiteral();
		}
		/**
		* ```
		* SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
		* ```
		*/
		parseSchemaDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("schema");
			const directives = this.parseConstDirectives();
			const operationTypes = this.many(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
			return this.node(start, {
				kind: Kind.SCHEMA_DEFINITION,
				description,
				directives,
				operationTypes
			});
		}
		/**
		* OperationTypeDefinition : OperationType : NamedType
		*/
		parseOperationTypeDefinition() {
			const start = this._lexer.token;
			const operation = this.parseOperationType();
			this.expectToken(TokenKind.COLON);
			const type = this.parseNamedType();
			return this.node(start, {
				kind: Kind.OPERATION_TYPE_DEFINITION,
				operation,
				type
			});
		}
		/**
		* ScalarTypeDefinition : Description? scalar Name Directives[Const]?
		*/
		parseScalarTypeDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("scalar");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			return this.node(start, {
				kind: Kind.SCALAR_TYPE_DEFINITION,
				description,
				name,
				directives
			});
		}
		/**
		* ObjectTypeDefinition :
		*   Description?
		*   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
		*/
		parseObjectTypeDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("type");
			const name = this.parseName();
			const interfaces = this.parseImplementsInterfaces();
			const directives = this.parseConstDirectives();
			const fields = this.parseFieldsDefinition();
			return this.node(start, {
				kind: Kind.OBJECT_TYPE_DEFINITION,
				description,
				name,
				interfaces,
				directives,
				fields
			});
		}
		/**
		* ImplementsInterfaces :
		*   - implements `&`? NamedType
		*   - ImplementsInterfaces & NamedType
		*/
		parseImplementsInterfaces() {
			return this.expectOptionalKeyword("implements") ? this.delimitedMany(TokenKind.AMP, this.parseNamedType) : [];
		}
		/**
		* ```
		* FieldsDefinition : { FieldDefinition+ }
		* ```
		*/
		parseFieldsDefinition() {
			return this.optionalMany(TokenKind.BRACE_L, this.parseFieldDefinition, TokenKind.BRACE_R);
		}
		/**
		* FieldDefinition :
		*   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
		*/
		parseFieldDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			const name = this.parseName();
			const args = this.parseArgumentDefs();
			this.expectToken(TokenKind.COLON);
			const type = this.parseTypeReference();
			const directives = this.parseConstDirectives();
			return this.node(start, {
				kind: Kind.FIELD_DEFINITION,
				description,
				name,
				arguments: args,
				type,
				directives
			});
		}
		/**
		* ArgumentsDefinition : ( InputValueDefinition+ )
		*/
		parseArgumentDefs() {
			return this.optionalMany(TokenKind.PAREN_L, this.parseInputValueDef, TokenKind.PAREN_R);
		}
		/**
		* InputValueDefinition :
		*   - Description? Name : Type DefaultValue? Directives[Const]?
		*/
		parseInputValueDef() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			const name = this.parseName();
			this.expectToken(TokenKind.COLON);
			const type = this.parseTypeReference();
			let defaultValue;
			if (this.expectOptionalToken(TokenKind.EQUALS)) defaultValue = this.parseConstValueLiteral();
			const directives = this.parseConstDirectives();
			return this.node(start, {
				kind: Kind.INPUT_VALUE_DEFINITION,
				description,
				name,
				type,
				defaultValue,
				directives
			});
		}
		/**
		* InterfaceTypeDefinition :
		*   - Description? interface Name Directives[Const]? FieldsDefinition?
		*/
		parseInterfaceTypeDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("interface");
			const name = this.parseName();
			const interfaces = this.parseImplementsInterfaces();
			const directives = this.parseConstDirectives();
			const fields = this.parseFieldsDefinition();
			return this.node(start, {
				kind: Kind.INTERFACE_TYPE_DEFINITION,
				description,
				name,
				interfaces,
				directives,
				fields
			});
		}
		/**
		* UnionTypeDefinition :
		*   - Description? union Name Directives[Const]? UnionMemberTypes?
		*/
		parseUnionTypeDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("union");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			const types = this.parseUnionMemberTypes();
			return this.node(start, {
				kind: Kind.UNION_TYPE_DEFINITION,
				description,
				name,
				directives,
				types
			});
		}
		/**
		* UnionMemberTypes :
		*   - = `|`? NamedType
		*   - UnionMemberTypes | NamedType
		*/
		parseUnionMemberTypes() {
			return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
		}
		/**
		* EnumTypeDefinition :
		*   - Description? enum Name Directives[Const]? EnumValuesDefinition?
		*/
		parseEnumTypeDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("enum");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			const values = this.parseEnumValuesDefinition();
			return this.node(start, {
				kind: Kind.ENUM_TYPE_DEFINITION,
				description,
				name,
				directives,
				values
			});
		}
		/**
		* ```
		* EnumValuesDefinition : { EnumValueDefinition+ }
		* ```
		*/
		parseEnumValuesDefinition() {
			return this.optionalMany(TokenKind.BRACE_L, this.parseEnumValueDefinition, TokenKind.BRACE_R);
		}
		/**
		* EnumValueDefinition : Description? EnumValue Directives[Const]?
		*/
		parseEnumValueDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			const name = this.parseEnumValueName();
			const directives = this.parseConstDirectives();
			return this.node(start, {
				kind: Kind.ENUM_VALUE_DEFINITION,
				description,
				name,
				directives
			});
		}
		/**
		* EnumValue : Name but not `true`, `false` or `null`
		*/
		parseEnumValueName() {
			if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw syntaxError(this._lexer.source, this._lexer.token.start, `${getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
			return this.parseName();
		}
		/**
		* InputObjectTypeDefinition :
		*   - Description? input Name Directives[Const]? InputFieldsDefinition?
		*/
		parseInputObjectTypeDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("input");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			const fields = this.parseInputFieldsDefinition();
			return this.node(start, {
				kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
				description,
				name,
				directives,
				fields
			});
		}
		/**
		* ```
		* InputFieldsDefinition : { InputValueDefinition+ }
		* ```
		*/
		parseInputFieldsDefinition() {
			return this.optionalMany(TokenKind.BRACE_L, this.parseInputValueDef, TokenKind.BRACE_R);
		}
		/**
		* TypeSystemExtension :
		*   - SchemaExtension
		*   - TypeExtension
		*
		* TypeExtension :
		*   - ScalarTypeExtension
		*   - ObjectTypeExtension
		*   - InterfaceTypeExtension
		*   - UnionTypeExtension
		*   - EnumTypeExtension
		*   - InputObjectTypeDefinition
		*/
		parseTypeSystemExtension() {
			const keywordToken = this._lexer.lookahead();
			if (keywordToken.kind === TokenKind.NAME) switch (keywordToken.value) {
				case "schema": return this.parseSchemaExtension();
				case "scalar": return this.parseScalarTypeExtension();
				case "type": return this.parseObjectTypeExtension();
				case "interface": return this.parseInterfaceTypeExtension();
				case "union": return this.parseUnionTypeExtension();
				case "enum": return this.parseEnumTypeExtension();
				case "input": return this.parseInputObjectTypeExtension();
			}
			throw this.unexpected(keywordToken);
		}
		/**
		* ```
		* SchemaExtension :
		*  - extend schema Directives[Const]? { OperationTypeDefinition+ }
		*  - extend schema Directives[Const]
		* ```
		*/
		parseSchemaExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("schema");
			const directives = this.parseConstDirectives();
			const operationTypes = this.optionalMany(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
			if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.SCHEMA_EXTENSION,
				directives,
				operationTypes
			});
		}
		/**
		* ScalarTypeExtension :
		*   - extend scalar Name Directives[Const]
		*/
		parseScalarTypeExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("scalar");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			if (directives.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.SCALAR_TYPE_EXTENSION,
				name,
				directives
			});
		}
		/**
		* ObjectTypeExtension :
		*  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
		*  - extend type Name ImplementsInterfaces? Directives[Const]
		*  - extend type Name ImplementsInterfaces
		*/
		parseObjectTypeExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("type");
			const name = this.parseName();
			const interfaces = this.parseImplementsInterfaces();
			const directives = this.parseConstDirectives();
			const fields = this.parseFieldsDefinition();
			if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.OBJECT_TYPE_EXTENSION,
				name,
				interfaces,
				directives,
				fields
			});
		}
		/**
		* InterfaceTypeExtension :
		*  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
		*  - extend interface Name ImplementsInterfaces? Directives[Const]
		*  - extend interface Name ImplementsInterfaces
		*/
		parseInterfaceTypeExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("interface");
			const name = this.parseName();
			const interfaces = this.parseImplementsInterfaces();
			const directives = this.parseConstDirectives();
			const fields = this.parseFieldsDefinition();
			if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.INTERFACE_TYPE_EXTENSION,
				name,
				interfaces,
				directives,
				fields
			});
		}
		/**
		* UnionTypeExtension :
		*   - extend union Name Directives[Const]? UnionMemberTypes
		*   - extend union Name Directives[Const]
		*/
		parseUnionTypeExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("union");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			const types = this.parseUnionMemberTypes();
			if (directives.length === 0 && types.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.UNION_TYPE_EXTENSION,
				name,
				directives,
				types
			});
		}
		/**
		* EnumTypeExtension :
		*   - extend enum Name Directives[Const]? EnumValuesDefinition
		*   - extend enum Name Directives[Const]
		*/
		parseEnumTypeExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("enum");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			const values = this.parseEnumValuesDefinition();
			if (directives.length === 0 && values.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.ENUM_TYPE_EXTENSION,
				name,
				directives,
				values
			});
		}
		/**
		* InputObjectTypeExtension :
		*   - extend input Name Directives[Const]? InputFieldsDefinition
		*   - extend input Name Directives[Const]
		*/
		parseInputObjectTypeExtension() {
			const start = this._lexer.token;
			this.expectKeyword("extend");
			this.expectKeyword("input");
			const name = this.parseName();
			const directives = this.parseConstDirectives();
			const fields = this.parseInputFieldsDefinition();
			if (directives.length === 0 && fields.length === 0) throw this.unexpected();
			return this.node(start, {
				kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
				name,
				directives,
				fields
			});
		}
		/**
		* ```
		* DirectiveDefinition :
		*   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
		* ```
		*/
		parseDirectiveDefinition() {
			const start = this._lexer.token;
			const description = this.parseDescription();
			this.expectKeyword("directive");
			this.expectToken(TokenKind.AT);
			const name = this.parseName();
			const args = this.parseArgumentDefs();
			const repeatable = this.expectOptionalKeyword("repeatable");
			this.expectKeyword("on");
			const locations = this.parseDirectiveLocations();
			return this.node(start, {
				kind: Kind.DIRECTIVE_DEFINITION,
				description,
				name,
				arguments: args,
				repeatable,
				locations
			});
		}
		/**
		* DirectiveLocations :
		*   - `|`? DirectiveLocation
		*   - DirectiveLocations | DirectiveLocation
		*/
		parseDirectiveLocations() {
			return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
		}
		parseDirectiveLocation() {
			const start = this._lexer.token;
			const name = this.parseName();
			if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) return name;
			throw this.unexpected(start);
		}
		/**
		* Returns a node that, if configured to do so, sets a "loc" field as a
		* location object, used to identify the place in the source that created a
		* given parsed object.
		*/
		node(startToken, node) {
			if (this._options.noLocation !== true) node.loc = new Location(startToken, this._lexer.lastToken, this._lexer.source);
			return node;
		}
		/**
		* Determines if the next token is of a given kind
		*/
		peek(kind) {
			return this._lexer.token.kind === kind;
		}
		/**
		* If the next token is of the given kind, return that token after advancing the lexer.
		* Otherwise, do not change the parser state and throw an error.
		*/
		expectToken(kind) {
			const token = this._lexer.token;
			if (token.kind === kind) {
				this.advanceLexer();
				return token;
			}
			throw syntaxError(this._lexer.source, token.start, `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`);
		}
		/**
		* If the next token is of the given kind, return "true" after advancing the lexer.
		* Otherwise, do not change the parser state and return "false".
		*/
		expectOptionalToken(kind) {
			if (this._lexer.token.kind === kind) {
				this.advanceLexer();
				return true;
			}
			return false;
		}
		/**
		* If the next token is a given keyword, advance the lexer.
		* Otherwise, do not change the parser state and throw an error.
		*/
		expectKeyword(value) {
			const token = this._lexer.token;
			if (token.kind === TokenKind.NAME && token.value === value) this.advanceLexer();
			else throw syntaxError(this._lexer.source, token.start, `Expected "${value}", found ${getTokenDesc(token)}.`);
		}
		/**
		* If the next token is a given keyword, return "true" after advancing the lexer.
		* Otherwise, do not change the parser state and return "false".
		*/
		expectOptionalKeyword(value) {
			const token = this._lexer.token;
			if (token.kind === TokenKind.NAME && token.value === value) {
				this.advanceLexer();
				return true;
			}
			return false;
		}
		/**
		* Helper function for creating an error when an unexpected lexed token is encountered.
		*/
		unexpected(atToken) {
			const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
			return syntaxError(this._lexer.source, token.start, `Unexpected ${getTokenDesc(token)}.`);
		}
		/**
		* Returns a possibly empty list of parse nodes, determined by the parseFn.
		* This list begins with a lex token of openKind and ends with a lex token of closeKind.
		* Advances the parser to the next lex token after the closing token.
		*/
		any(openKind, parseFn, closeKind) {
			this.expectToken(openKind);
			const nodes = [];
			while (!this.expectOptionalToken(closeKind)) nodes.push(parseFn.call(this));
			return nodes;
		}
		/**
		* Returns a list of parse nodes, determined by the parseFn.
		* It can be empty only if open token is missing otherwise it will always return non-empty list
		* that begins with a lex token of openKind and ends with a lex token of closeKind.
		* Advances the parser to the next lex token after the closing token.
		*/
		optionalMany(openKind, parseFn, closeKind) {
			if (this.expectOptionalToken(openKind)) {
				const nodes = [];
				do
					nodes.push(parseFn.call(this));
				while (!this.expectOptionalToken(closeKind));
				return nodes;
			}
			return [];
		}
		/**
		* Returns a non-empty list of parse nodes, determined by the parseFn.
		* This list begins with a lex token of openKind and ends with a lex token of closeKind.
		* Advances the parser to the next lex token after the closing token.
		*/
		many(openKind, parseFn, closeKind) {
			this.expectToken(openKind);
			const nodes = [];
			do
				nodes.push(parseFn.call(this));
			while (!this.expectOptionalToken(closeKind));
			return nodes;
		}
		/**
		* Returns a non-empty list of parse nodes, determined by the parseFn.
		* This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
		* Advances the parser to the next lex token after last item in the list.
		*/
		delimitedMany(delimiterKind, parseFn) {
			this.expectOptionalToken(delimiterKind);
			const nodes = [];
			do
				nodes.push(parseFn.call(this));
			while (this.expectOptionalToken(delimiterKind));
			return nodes;
		}
		advanceLexer() {
			const { maxTokens } = this._options;
			const token = this._lexer.advance();
			if (maxTokens !== void 0 && token.kind !== TokenKind.EOF) {
				++this._tokenCounter;
				if (this._tokenCounter > maxTokens) throw syntaxError(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
			}
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/didYouMean.mjs
/**
* Given [ A, B, C ] return ' Did you mean A, B, or C?'.
*/
function didYouMean(firstArg, secondArg) {
	const [subMessage, suggestionsArg] = secondArg ? [firstArg, secondArg] : [void 0, firstArg];
	let message = " Did you mean ";
	if (subMessage) message += subMessage + " ";
	const suggestions = suggestionsArg.map((x) => `"${x}"`);
	switch (suggestions.length) {
		case 0: return "";
		case 1: return message + suggestions[0] + "?";
		case 2: return message + suggestions[0] + " or " + suggestions[1] + "?";
	}
	const selected = suggestions.slice(0, MAX_SUGGESTIONS);
	const lastItem = selected.pop();
	return message + selected.join(", ") + ", or " + lastItem + "?";
}
var MAX_SUGGESTIONS;
var init_didYouMean = __esmMin((() => {
	MAX_SUGGESTIONS = 5;
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/identityFunc.mjs
/**
* Returns the first argument it receives.
*/
function identityFunc(x) {
	return x;
}
var init_identityFunc = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/keyMap.mjs
/**
* Creates a keyed JS object from an array, given a function to produce the keys
* for each value in the array.
*
* This provides a convenient lookup for the array items if the key function
* produces unique results.
* ```ts
* const phoneBook = [
*   { name: 'Jon', num: '555-1234' },
*   { name: 'Jenny', num: '867-5309' }
* ]
*
* const entriesByName = keyMap(
*   phoneBook,
*   entry => entry.name
* )
*
* // {
* //   Jon: { name: 'Jon', num: '555-1234' },
* //   Jenny: { name: 'Jenny', num: '867-5309' }
* // }
*
* const jennyEntry = entriesByName['Jenny']
*
* // { name: 'Jenny', num: '857-6309' }
* ```
*/
function keyMap(list, keyFn) {
	const result = Object.create(null);
	for (const item of list) result[keyFn(item)] = item;
	return result;
}
var init_keyMap = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/keyValMap.mjs
/**
* Creates a keyed JS object from an array, given a function to produce the keys
* and a function to produce the values from each item in the array.
* ```ts
* const phoneBook = [
*   { name: 'Jon', num: '555-1234' },
*   { name: 'Jenny', num: '867-5309' }
* ]
*
* // { Jon: '555-1234', Jenny: '867-5309' }
* const phonesByName = keyValMap(
*   phoneBook,
*   entry => entry.name,
*   entry => entry.num
* )
* ```
*/
function keyValMap(list, keyFn, valFn) {
	const result = Object.create(null);
	for (const item of list) result[keyFn(item)] = valFn(item);
	return result;
}
var init_keyValMap = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/mapValue.mjs
/**
* Creates an object map with the same keys as `map` and values generated by
* running each value of `map` thru `fn`.
*/
function mapValue(map, fn) {
	const result = Object.create(null);
	for (const key of Object.keys(map)) result[key] = fn(map[key], key);
	return result;
}
var init_mapValue = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/naturalCompare.mjs
/**
* Returns a number indicating whether a reference string comes before, or after,
* or is the same as the given string in natural sort order.
*
* See: https://en.wikipedia.org/wiki/Natural_sort_order
*
*/
function naturalCompare(aStr, bStr) {
	let aIndex = 0;
	let bIndex = 0;
	while (aIndex < aStr.length && bIndex < bStr.length) {
		let aChar = aStr.charCodeAt(aIndex);
		let bChar = bStr.charCodeAt(bIndex);
		if (isDigit(aChar) && isDigit(bChar)) {
			let aNum = 0;
			do {
				++aIndex;
				aNum = aNum * 10 + aChar - DIGIT_0;
				aChar = aStr.charCodeAt(aIndex);
			} while (isDigit(aChar) && aNum > 0);
			let bNum = 0;
			do {
				++bIndex;
				bNum = bNum * 10 + bChar - DIGIT_0;
				bChar = bStr.charCodeAt(bIndex);
			} while (isDigit(bChar) && bNum > 0);
			if (aNum < bNum) return -1;
			if (aNum > bNum) return 1;
		} else {
			if (aChar < bChar) return -1;
			if (aChar > bChar) return 1;
			++aIndex;
			++bIndex;
		}
	}
	return aStr.length - bStr.length;
}
function isDigit(code) {
	return !isNaN(code) && DIGIT_0 <= code && code <= DIGIT_9;
}
var DIGIT_0, DIGIT_9;
var init_naturalCompare = __esmMin((() => {
	DIGIT_0 = 48;
	DIGIT_9 = 57;
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/suggestionList.mjs
/**
* Given an invalid input string and a list of valid options, returns a filtered
* list of valid options sorted based on their similarity with the input.
*/
function suggestionList(input, options) {
	const optionsByDistance = Object.create(null);
	const lexicalDistance = new LexicalDistance(input);
	const threshold = Math.floor(input.length * .4) + 1;
	for (const option of options) {
		const distance = lexicalDistance.measure(option, threshold);
		if (distance !== void 0) optionsByDistance[option] = distance;
	}
	return Object.keys(optionsByDistance).sort((a, b) => {
		const distanceDiff = optionsByDistance[a] - optionsByDistance[b];
		return distanceDiff !== 0 ? distanceDiff : naturalCompare(a, b);
	});
}
function stringToArray(str) {
	const strLength = str.length;
	const array = new Array(strLength);
	for (let i = 0; i < strLength; ++i) array[i] = str.charCodeAt(i);
	return array;
}
var LexicalDistance;
var init_suggestionList = __esmMin((() => {
	init_naturalCompare();
	LexicalDistance = class {
		constructor(input) {
			this._input = input;
			this._inputLowerCase = input.toLowerCase();
			this._inputArray = stringToArray(this._inputLowerCase);
			this._rows = [
				new Array(input.length + 1).fill(0),
				new Array(input.length + 1).fill(0),
				new Array(input.length + 1).fill(0)
			];
		}
		measure(option, threshold) {
			if (this._input === option) return 0;
			const optionLowerCase = option.toLowerCase();
			if (this._inputLowerCase === optionLowerCase) return 1;
			let a = stringToArray(optionLowerCase);
			let b = this._inputArray;
			if (a.length < b.length) {
				const tmp = a;
				a = b;
				b = tmp;
			}
			const aLength = a.length;
			const bLength = b.length;
			if (aLength - bLength > threshold) return;
			const rows = this._rows;
			for (let j = 0; j <= bLength; j++) rows[0][j] = j;
			for (let i = 1; i <= aLength; i++) {
				const upRow = rows[(i - 1) % 3];
				const currentRow = rows[i % 3];
				let smallestCell = currentRow[0] = i;
				for (let j = 1; j <= bLength; j++) {
					const cost = a[i - 1] === b[j - 1] ? 0 : 1;
					let currentCell = Math.min(upRow[j] + 1, currentRow[j - 1] + 1, upRow[j - 1] + cost);
					if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
						const doubleDiagonalCell = rows[(i - 2) % 3][j - 2];
						currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
					}
					if (currentCell < smallestCell) smallestCell = currentCell;
					currentRow[j] = currentCell;
				}
				if (smallestCell > threshold) return;
			}
			const distance = rows[aLength % 3][bLength];
			return distance <= threshold ? distance : void 0;
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/toObjMap.mjs
function toObjMap(obj) {
	if (obj == null) return Object.create(null);
	if (Object.getPrototypeOf(obj) === null) return obj;
	const map = Object.create(null);
	for (const [key, value] of Object.entries(obj)) map[key] = value;
	return map;
}
var init_toObjMap = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/language/printString.mjs
/**
* Prints a string as a GraphQL StringValue literal. Replaces control characters
* and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
*/
function printString(str) {
	return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
}
function escapedReplacer(str) {
	return escapeSequences[str.charCodeAt(0)];
}
var escapedRegExp, escapeSequences;
var init_printString = __esmMin((() => {
	escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
	escapeSequences = [
		"\\u0000",
		"\\u0001",
		"\\u0002",
		"\\u0003",
		"\\u0004",
		"\\u0005",
		"\\u0006",
		"\\u0007",
		"\\b",
		"\\t",
		"\\n",
		"\\u000B",
		"\\f",
		"\\r",
		"\\u000E",
		"\\u000F",
		"\\u0010",
		"\\u0011",
		"\\u0012",
		"\\u0013",
		"\\u0014",
		"\\u0015",
		"\\u0016",
		"\\u0017",
		"\\u0018",
		"\\u0019",
		"\\u001A",
		"\\u001B",
		"\\u001C",
		"\\u001D",
		"\\u001E",
		"\\u001F",
		"",
		"",
		"\\\"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"\\\\",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"\\u007F",
		"\\u0080",
		"\\u0081",
		"\\u0082",
		"\\u0083",
		"\\u0084",
		"\\u0085",
		"\\u0086",
		"\\u0087",
		"\\u0088",
		"\\u0089",
		"\\u008A",
		"\\u008B",
		"\\u008C",
		"\\u008D",
		"\\u008E",
		"\\u008F",
		"\\u0090",
		"\\u0091",
		"\\u0092",
		"\\u0093",
		"\\u0094",
		"\\u0095",
		"\\u0096",
		"\\u0097",
		"\\u0098",
		"\\u0099",
		"\\u009A",
		"\\u009B",
		"\\u009C",
		"\\u009D",
		"\\u009E",
		"\\u009F"
	];
}));
//#endregion
//#region ../../node_modules/graphql/language/visitor.mjs
/**
* visit() will walk through an AST using a depth-first traversal, calling
* the visitor's enter function at each node in the traversal, and calling the
* leave function after visiting that node and all of its child nodes.
*
* By returning different values from the enter and leave functions, the
* behavior of the visitor can be altered, including skipping over a sub-tree of
* the AST (by returning false), editing the AST by returning a value or null
* to remove the value, or to stop the whole traversal by returning BREAK.
*
* When using visit() to edit an AST, the original AST will not be modified, and
* a new version of the AST with the changes applied will be returned from the
* visit function.
*
* ```ts
* const editedAST = visit(ast, {
*   enter(node, key, parent, path, ancestors) {
*     // @return
*     //   undefined: no action
*     //   false: skip visiting this node
*     //   visitor.BREAK: stop visiting altogether
*     //   null: delete this node
*     //   any value: replace this node with the returned value
*   },
*   leave(node, key, parent, path, ancestors) {
*     // @return
*     //   undefined: no action
*     //   false: no action
*     //   visitor.BREAK: stop visiting altogether
*     //   null: delete this node
*     //   any value: replace this node with the returned value
*   }
* });
* ```
*
* Alternatively to providing enter() and leave() functions, a visitor can
* instead provide functions named the same as the kinds of AST nodes, or
* enter/leave visitors at a named key, leading to three permutations of the
* visitor API:
*
* 1) Named visitors triggered when entering a node of a specific kind.
*
* ```ts
* visit(ast, {
*   Kind(node) {
*     // enter the "Kind" node
*   }
* })
* ```
*
* 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
*
* ```ts
* visit(ast, {
*   Kind: {
*     enter(node) {
*       // enter the "Kind" node
*     }
*     leave(node) {
*       // leave the "Kind" node
*     }
*   }
* })
* ```
*
* 3) Generic visitors that trigger upon entering and leaving any node.
*
* ```ts
* visit(ast, {
*   enter(node) {
*     // enter any node
*   },
*   leave(node) {
*     // leave any node
*   }
* })
* ```
*/
function visit(root, visitor, visitorKeys = QueryDocumentKeys) {
	const enterLeaveMap = /* @__PURE__ */ new Map();
	for (const kind of Object.values(Kind)) enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
	let stack = void 0;
	let inArray = Array.isArray(root);
	let keys = [root];
	let index = -1;
	let edits = [];
	let node = root;
	let key = void 0;
	let parent = void 0;
	const path = [];
	const ancestors = [];
	do {
		index++;
		const isLeaving = index === keys.length;
		const isEdited = isLeaving && edits.length !== 0;
		if (isLeaving) {
			key = ancestors.length === 0 ? void 0 : path[path.length - 1];
			node = parent;
			parent = ancestors.pop();
			if (isEdited) {
				if (inArray) {
					node = node.slice();
					let editOffset = 0;
					for (const [editKey, editValue] of edits) {
						const arrayKey = editKey - editOffset;
						if (editValue === null) {
							node.splice(arrayKey, 1);
							editOffset++;
						} else node[arrayKey] = editValue;
					}
				} else {
					node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
					for (const [editKey, editValue] of edits) node[editKey] = editValue;
				}
			}
			index = stack.index;
			keys = stack.keys;
			edits = stack.edits;
			inArray = stack.inArray;
			stack = stack.prev;
		} else if (parent) {
			key = inArray ? index : keys[index];
			node = parent[key];
			if (node === null || node === void 0) continue;
			path.push(key);
		}
		let result;
		if (!Array.isArray(node)) {
			var _enterLeaveMap$get, _enterLeaveMap$get2;
			isNode$2(node) || devAssert(false, `Invalid AST Node: ${inspect(node)}.`);
			const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
			result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
			if (result === BREAK) break;
			if (result === false) {
				if (!isLeaving) {
					path.pop();
					continue;
				}
			} else if (result !== void 0) {
				edits.push([key, result]);
				if (!isLeaving) {
					if (isNode$2(result)) node = result;
					else {
						path.pop();
						continue;
					}
				}
			}
		}
		if (result === void 0 && isEdited) edits.push([key, node]);
		if (isLeaving) path.pop();
		else {
			var _node$kind;
			stack = {
				inArray,
				index,
				keys,
				edits,
				prev: stack
			};
			inArray = Array.isArray(node);
			keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
			index = -1;
			edits = [];
			if (parent) ancestors.push(parent);
			parent = node;
		}
	} while (stack !== void 0);
	if (edits.length !== 0) return edits[edits.length - 1][1];
	return root;
}
/**
* Creates a new visitor instance which delegates to many visitors to run in
* parallel. Each visitor will be visited for each node before moving on.
*
* If a prior visitor edits a node, no following visitors will see that node.
*/
function visitInParallel(visitors) {
	const skipping = new Array(visitors.length).fill(null);
	const mergedVisitor = Object.create(null);
	for (const kind of Object.values(Kind)) {
		let hasVisitor = false;
		const enterList = new Array(visitors.length).fill(void 0);
		const leaveList = new Array(visitors.length).fill(void 0);
		for (let i = 0; i < visitors.length; ++i) {
			const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
			hasVisitor || (hasVisitor = enter != null || leave != null);
			enterList[i] = enter;
			leaveList[i] = leave;
		}
		if (!hasVisitor) continue;
		mergedVisitor[kind] = {
			enter(...args) {
				const node = args[0];
				for (let i = 0; i < visitors.length; i++) if (skipping[i] === null) {
					var _enterList$i;
					const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
					if (result === false) skipping[i] = node;
					else if (result === BREAK) skipping[i] = BREAK;
					else if (result !== void 0) return result;
				}
			},
			leave(...args) {
				const node = args[0];
				for (let i = 0; i < visitors.length; i++) if (skipping[i] === null) {
					var _leaveList$i;
					const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
					if (result === BREAK) skipping[i] = BREAK;
					else if (result !== void 0 && result !== false) return result;
				} else if (skipping[i] === node) skipping[i] = null;
			}
		};
	}
	return mergedVisitor;
}
/**
* Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
*/
function getEnterLeaveForKind(visitor, kind) {
	const kindVisitor = visitor[kind];
	if (typeof kindVisitor === "object") return kindVisitor;
	else if (typeof kindVisitor === "function") return {
		enter: kindVisitor,
		leave: void 0
	};
	return {
		enter: visitor.enter,
		leave: visitor.leave
	};
}
/**
* Given a visitor instance, if it is leaving or not, and a node kind, return
* the function the visitor runtime should call.
*
* @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
*/
/* c8 ignore next 8 */
function getVisitFn(visitor, kind, isLeaving) {
	const { enter, leave } = getEnterLeaveForKind(visitor, kind);
	return isLeaving ? leave : enter;
}
var BREAK;
var init_visitor = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_ast();
	init_kinds();
	BREAK = Object.freeze({});
}));
//#endregion
//#region ../../node_modules/graphql/language/printer.mjs
/**
* Converts an AST into a string, using one set of reasonable
* formatting rules.
*/
function print(ast) {
	return visit(ast, printDocASTReducer);
}
/**
* Given maybeArray, print an empty string if it is null or empty, otherwise
* print all items together separated by separator if provided
*/
function join(maybeArray, separator = "") {
	var _maybeArray$filter$jo;
	return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x) => x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
* Given array, print each item on its own line, wrapped in an indented `{ }` block.
*/
function block(array) {
	return wrap("{\n", indent(join(array, "\n")), "\n}");
}
/**
* If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
*/
function wrap(start, maybeString, end = "") {
	return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function indent(str) {
	return wrap("  ", str.replace(/\n/g, "\n  "));
}
function hasMultilineItems(maybeArray) {
	var _maybeArray$some;
	/* c8 ignore next */
	return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str) => str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}
var MAX_LINE_LENGTH, printDocASTReducer;
var init_printer = __esmMin((() => {
	init_blockString();
	init_printString();
	init_visitor();
	MAX_LINE_LENGTH = 80;
	printDocASTReducer = {
		Name: { leave: (node) => node.value },
		Variable: { leave: (node) => "$" + node.name },
		Document: { leave: (node) => join(node.definitions, "\n\n") },
		OperationDefinition: { leave(node) {
			const varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
			const prefix = join([
				node.operation,
				join([node.name, varDefs]),
				join(node.directives, " ")
			], " ");
			return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
		} },
		VariableDefinition: { leave: ({ variable, type, defaultValue, directives }) => variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " ")) },
		SelectionSet: { leave: ({ selections }) => block(selections) },
		Field: { leave({ alias, name, arguments: args, directives, selectionSet }) {
			const prefix = wrap("", alias, ": ") + name;
			let argsLine = prefix + wrap("(", join(args, ", "), ")");
			if (argsLine.length > MAX_LINE_LENGTH) argsLine = prefix + wrap("(\n", indent(join(args, "\n")), "\n)");
			return join([
				argsLine,
				join(directives, " "),
				selectionSet
			], " ");
		} },
		Argument: { leave: ({ name, value }) => name + ": " + value },
		FragmentSpread: { leave: ({ name, directives }) => "..." + name + wrap(" ", join(directives, " ")) },
		InlineFragment: { leave: ({ typeCondition, directives, selectionSet }) => join([
			"...",
			wrap("on ", typeCondition),
			join(directives, " "),
			selectionSet
		], " ") },
		FragmentDefinition: { leave: ({ name, typeCondition, variableDefinitions, directives, selectionSet }) => `fragment ${name}${wrap("(", join(variableDefinitions, ", "), ")")} on ${typeCondition} ${wrap("", join(directives, " "), " ")}` + selectionSet },
		IntValue: { leave: ({ value }) => value },
		FloatValue: { leave: ({ value }) => value },
		StringValue: { leave: ({ value, block: isBlockString }) => isBlockString ? printBlockString(value) : printString(value) },
		BooleanValue: { leave: ({ value }) => value ? "true" : "false" },
		NullValue: { leave: () => "null" },
		EnumValue: { leave: ({ value }) => value },
		ListValue: { leave: ({ values }) => "[" + join(values, ", ") + "]" },
		ObjectValue: { leave: ({ fields }) => "{" + join(fields, ", ") + "}" },
		ObjectField: { leave: ({ name, value }) => name + ": " + value },
		Directive: { leave: ({ name, arguments: args }) => "@" + name + wrap("(", join(args, ", "), ")") },
		NamedType: { leave: ({ name }) => name },
		ListType: { leave: ({ type }) => "[" + type + "]" },
		NonNullType: { leave: ({ type }) => type + "!" },
		SchemaDefinition: { leave: ({ description, directives, operationTypes }) => wrap("", description, "\n") + join([
			"schema",
			join(directives, " "),
			block(operationTypes)
		], " ") },
		OperationTypeDefinition: { leave: ({ operation, type }) => operation + ": " + type },
		ScalarTypeDefinition: { leave: ({ description, name, directives }) => wrap("", description, "\n") + join([
			"scalar",
			name,
			join(directives, " ")
		], " ") },
		ObjectTypeDefinition: { leave: ({ description, name, interfaces, directives, fields }) => wrap("", description, "\n") + join([
			"type",
			name,
			wrap("implements ", join(interfaces, " & ")),
			join(directives, " "),
			block(fields)
		], " ") },
		FieldDefinition: { leave: ({ description, name, arguments: args, type, directives }) => wrap("", description, "\n") + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " ")) },
		InputValueDefinition: { leave: ({ description, name, type, defaultValue, directives }) => wrap("", description, "\n") + join([
			name + ": " + type,
			wrap("= ", defaultValue),
			join(directives, " ")
		], " ") },
		InterfaceTypeDefinition: { leave: ({ description, name, interfaces, directives, fields }) => wrap("", description, "\n") + join([
			"interface",
			name,
			wrap("implements ", join(interfaces, " & ")),
			join(directives, " "),
			block(fields)
		], " ") },
		UnionTypeDefinition: { leave: ({ description, name, directives, types }) => wrap("", description, "\n") + join([
			"union",
			name,
			join(directives, " "),
			wrap("= ", join(types, " | "))
		], " ") },
		EnumTypeDefinition: { leave: ({ description, name, directives, values }) => wrap("", description, "\n") + join([
			"enum",
			name,
			join(directives, " "),
			block(values)
		], " ") },
		EnumValueDefinition: { leave: ({ description, name, directives }) => wrap("", description, "\n") + join([name, join(directives, " ")], " ") },
		InputObjectTypeDefinition: { leave: ({ description, name, directives, fields }) => wrap("", description, "\n") + join([
			"input",
			name,
			join(directives, " "),
			block(fields)
		], " ") },
		DirectiveDefinition: { leave: ({ description, name, arguments: args, repeatable, locations }) => wrap("", description, "\n") + "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ") },
		SchemaExtension: { leave: ({ directives, operationTypes }) => join([
			"extend schema",
			join(directives, " "),
			block(operationTypes)
		], " ") },
		ScalarTypeExtension: { leave: ({ name, directives }) => join([
			"extend scalar",
			name,
			join(directives, " ")
		], " ") },
		ObjectTypeExtension: { leave: ({ name, interfaces, directives, fields }) => join([
			"extend type",
			name,
			wrap("implements ", join(interfaces, " & ")),
			join(directives, " "),
			block(fields)
		], " ") },
		InterfaceTypeExtension: { leave: ({ name, interfaces, directives, fields }) => join([
			"extend interface",
			name,
			wrap("implements ", join(interfaces, " & ")),
			join(directives, " "),
			block(fields)
		], " ") },
		UnionTypeExtension: { leave: ({ name, directives, types }) => join([
			"extend union",
			name,
			join(directives, " "),
			wrap("= ", join(types, " | "))
		], " ") },
		EnumTypeExtension: { leave: ({ name, directives, values }) => join([
			"extend enum",
			name,
			join(directives, " "),
			block(values)
		], " ") },
		InputObjectTypeExtension: { leave: ({ name, directives, fields }) => join([
			"extend input",
			name,
			join(directives, " "),
			block(fields)
		], " ") }
	};
}));
//#endregion
//#region ../../node_modules/graphql/utilities/valueFromASTUntyped.mjs
/**
* Produces a JavaScript value given a GraphQL Value AST.
*
* Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
* will reflect the provided GraphQL value AST.
*
* | GraphQL Value        | JavaScript Value |
* | -------------------- | ---------------- |
* | Input Object         | Object           |
* | List                 | Array            |
* | Boolean              | Boolean          |
* | String / Enum        | String           |
* | Int / Float          | Number           |
* | Null                 | null             |
*
*/
function valueFromASTUntyped(valueNode, variables) {
	switch (valueNode.kind) {
		case Kind.NULL: return null;
		case Kind.INT: return parseInt(valueNode.value, 10);
		case Kind.FLOAT: return parseFloat(valueNode.value);
		case Kind.STRING:
		case Kind.ENUM:
		case Kind.BOOLEAN: return valueNode.value;
		case Kind.LIST: return valueNode.values.map((node) => valueFromASTUntyped(node, variables));
		case Kind.OBJECT: return keyValMap(valueNode.fields, (field) => field.name.value, (field) => valueFromASTUntyped(field.value, variables));
		case Kind.VARIABLE: return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
	}
}
var init_valueFromASTUntyped = __esmMin((() => {
	init_keyValMap();
	init_kinds();
}));
//#endregion
//#region ../../node_modules/graphql/type/assertName.mjs
/**
* Upholds the spec rules about naming.
*/
function assertName(name) {
	name ?? devAssert(false, "Must provide name.");
	typeof name === "string" || devAssert(false, "Expected name to be a string.");
	if (name.length === 0) throw new GraphQLError("Expected name to be a non-empty string.");
	for (let i = 1; i < name.length; ++i) if (!isNameContinue(name.charCodeAt(i))) throw new GraphQLError(`Names must only contain [_a-zA-Z0-9] but "${name}" does not.`);
	if (!isNameStart(name.charCodeAt(0))) throw new GraphQLError(`Names must start with [_a-zA-Z] but "${name}" does not.`);
	return name;
}
/**
* Upholds the spec rules about naming enum values.
*
* @internal
*/
function assertEnumValueName(name) {
	if (name === "true" || name === "false" || name === "null") throw new GraphQLError(`Enum values cannot be named: ${name}`);
	return assertName(name);
}
var init_assertName = __esmMin((() => {
	init_devAssert();
	init_GraphQLError();
	init_characterClasses();
}));
//#endregion
//#region ../../node_modules/graphql/type/definition.mjs
function isType(type) {
	return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type) || isListType(type) || isNonNullType(type);
}
function assertType(type) {
	if (!isType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL type.`);
	return type;
}
/**
* There are predicates for each kind of GraphQL type.
*/
function isScalarType(type) {
	return instanceOf(type, GraphQLScalarType);
}
function assertScalarType(type) {
	if (!isScalarType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Scalar type.`);
	return type;
}
function isObjectType(type) {
	return instanceOf(type, GraphQLObjectType);
}
function assertObjectType(type) {
	if (!isObjectType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Object type.`);
	return type;
}
function isInterfaceType(type) {
	return instanceOf(type, GraphQLInterfaceType);
}
function assertInterfaceType(type) {
	if (!isInterfaceType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Interface type.`);
	return type;
}
function isUnionType(type) {
	return instanceOf(type, GraphQLUnionType);
}
function assertUnionType(type) {
	if (!isUnionType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Union type.`);
	return type;
}
function isEnumType(type) {
	return instanceOf(type, GraphQLEnumType);
}
function assertEnumType(type) {
	if (!isEnumType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Enum type.`);
	return type;
}
function isInputObjectType(type) {
	return instanceOf(type, GraphQLInputObjectType);
}
function assertInputObjectType(type) {
	if (!isInputObjectType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Input Object type.`);
	return type;
}
function isListType(type) {
	return instanceOf(type, GraphQLList);
}
function assertListType(type) {
	if (!isListType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL List type.`);
	return type;
}
function isNonNullType(type) {
	return instanceOf(type, GraphQLNonNull);
}
function assertNonNullType(type) {
	if (!isNonNullType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL Non-Null type.`);
	return type;
}
/**
* These types may be used as input types for arguments and directives.
*/
function isInputType(type) {
	return isScalarType(type) || isEnumType(type) || isInputObjectType(type) || isWrappingType(type) && isInputType(type.ofType);
}
function assertInputType(type) {
	if (!isInputType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL input type.`);
	return type;
}
/**
* These types may be used as output types as the result of fields.
*/
function isOutputType(type) {
	return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isWrappingType(type) && isOutputType(type.ofType);
}
function assertOutputType(type) {
	if (!isOutputType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL output type.`);
	return type;
}
/**
* These types may describe types which may be leaf values.
*/
function isLeafType(type) {
	return isScalarType(type) || isEnumType(type);
}
function assertLeafType(type) {
	if (!isLeafType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL leaf type.`);
	return type;
}
/**
* These types may describe the parent context of a selection set.
*/
function isCompositeType(type) {
	return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}
function assertCompositeType(type) {
	if (!isCompositeType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL composite type.`);
	return type;
}
/**
* These types may describe the parent context of a selection set.
*/
function isAbstractType(type) {
	return isInterfaceType(type) || isUnionType(type);
}
function assertAbstractType(type) {
	if (!isAbstractType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL abstract type.`);
	return type;
}
/**
* These types wrap and modify other types
*/
function isWrappingType(type) {
	return isListType(type) || isNonNullType(type);
}
function assertWrappingType(type) {
	if (!isWrappingType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL wrapping type.`);
	return type;
}
/**
* These types can all accept null as a value.
*/
function isNullableType(type) {
	return isType(type) && !isNonNullType(type);
}
function assertNullableType(type) {
	if (!isNullableType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL nullable type.`);
	return type;
}
function getNullableType(type) {
	if (type) return isNonNullType(type) ? type.ofType : type;
}
/**
* These named types do not include modifiers like List or NonNull.
*/
function isNamedType(type) {
	return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type);
}
function assertNamedType(type) {
	if (!isNamedType(type)) throw new Error(`Expected ${inspect(type)} to be a GraphQL named type.`);
	return type;
}
function getNamedType(type) {
	if (type) {
		let unwrappedType = type;
		while (isWrappingType(unwrappedType)) unwrappedType = unwrappedType.ofType;
		return unwrappedType;
	}
}
/**
* Used while defining GraphQL types to allow for circular references in
* otherwise immutable type definitions.
*/
function resolveReadonlyArrayThunk(thunk) {
	return typeof thunk === "function" ? thunk() : thunk;
}
function resolveObjMapThunk(thunk) {
	return typeof thunk === "function" ? thunk() : thunk;
}
function defineInterfaces(config) {
	var _config$interfaces;
	const interfaces = resolveReadonlyArrayThunk((_config$interfaces = config.interfaces) !== null && _config$interfaces !== void 0 ? _config$interfaces : []);
	Array.isArray(interfaces) || devAssert(false, `${config.name} interfaces must be an Array or a function which returns an Array.`);
	return interfaces;
}
function defineFieldMap(config) {
	const fieldMap = resolveObjMapThunk(config.fields);
	isPlainObj(fieldMap) || devAssert(false, `${config.name} fields must be an object with field names as keys or a function which returns such an object.`);
	return mapValue(fieldMap, (fieldConfig, fieldName) => {
		var _fieldConfig$args;
		isPlainObj(fieldConfig) || devAssert(false, `${config.name}.${fieldName} field config must be an object.`);
		fieldConfig.resolve == null || typeof fieldConfig.resolve === "function" || devAssert(false, `${config.name}.${fieldName} field resolver must be a function if provided, but got: ${inspect(fieldConfig.resolve)}.`);
		const argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
		isPlainObj(argsConfig) || devAssert(false, `${config.name}.${fieldName} args must be an object with argument names as keys.`);
		return {
			name: assertName(fieldName),
			description: fieldConfig.description,
			type: fieldConfig.type,
			args: defineArguments(argsConfig),
			resolve: fieldConfig.resolve,
			subscribe: fieldConfig.subscribe,
			deprecationReason: fieldConfig.deprecationReason,
			extensions: toObjMap(fieldConfig.extensions),
			astNode: fieldConfig.astNode
		};
	});
}
function defineArguments(config) {
	return Object.entries(config).map(([argName, argConfig]) => ({
		name: assertName(argName),
		description: argConfig.description,
		type: argConfig.type,
		defaultValue: argConfig.defaultValue,
		deprecationReason: argConfig.deprecationReason,
		extensions: toObjMap(argConfig.extensions),
		astNode: argConfig.astNode
	}));
}
function isPlainObj(obj) {
	return isObjectLike(obj) && !Array.isArray(obj);
}
function fieldsToFieldsConfig(fields) {
	return mapValue(fields, (field) => ({
		description: field.description,
		type: field.type,
		args: argsToArgsConfig(field.args),
		resolve: field.resolve,
		subscribe: field.subscribe,
		deprecationReason: field.deprecationReason,
		extensions: field.extensions,
		astNode: field.astNode
	}));
}
/**
* @internal
*/
function argsToArgsConfig(args) {
	return keyValMap(args, (arg) => arg.name, (arg) => ({
		description: arg.description,
		type: arg.type,
		defaultValue: arg.defaultValue,
		deprecationReason: arg.deprecationReason,
		extensions: arg.extensions,
		astNode: arg.astNode
	}));
}
function isRequiredArgument(arg) {
	return isNonNullType(arg.type) && arg.defaultValue === void 0;
}
function defineTypes(config) {
	const types = resolveReadonlyArrayThunk(config.types);
	Array.isArray(types) || devAssert(false, `Must provide Array of types or a function which returns such an array for Union ${config.name}.`);
	return types;
}
function didYouMeanEnumValue(enumType, unknownValueStr) {
	return didYouMean("the enum value", suggestionList(unknownValueStr, enumType.getValues().map((value) => value.name)));
}
function defineEnumValues(typeName, valueMap) {
	isPlainObj(valueMap) || devAssert(false, `${typeName} values must be an object with value names as keys.`);
	return Object.entries(valueMap).map(([valueName, valueConfig]) => {
		isPlainObj(valueConfig) || devAssert(false, `${typeName}.${valueName} must refer to an object with a "value" key representing an internal value but got: ${inspect(valueConfig)}.`);
		return {
			name: assertEnumValueName(valueName),
			description: valueConfig.description,
			value: valueConfig.value !== void 0 ? valueConfig.value : valueName,
			deprecationReason: valueConfig.deprecationReason,
			extensions: toObjMap(valueConfig.extensions),
			astNode: valueConfig.astNode
		};
	});
}
function defineInputFieldMap(config) {
	const fieldMap = resolveObjMapThunk(config.fields);
	isPlainObj(fieldMap) || devAssert(false, `${config.name} fields must be an object with field names as keys or a function which returns such an object.`);
	return mapValue(fieldMap, (fieldConfig, fieldName) => {
		!("resolve" in fieldConfig) || devAssert(false, `${config.name}.${fieldName} field has a resolve property, but Input Types cannot define resolvers.`);
		return {
			name: assertName(fieldName),
			description: fieldConfig.description,
			type: fieldConfig.type,
			defaultValue: fieldConfig.defaultValue,
			deprecationReason: fieldConfig.deprecationReason,
			extensions: toObjMap(fieldConfig.extensions),
			astNode: fieldConfig.astNode
		};
	});
}
function isRequiredInputField(field) {
	return isNonNullType(field.type) && field.defaultValue === void 0;
}
var GraphQLList, GraphQLNonNull, GraphQLScalarType, GraphQLObjectType, GraphQLInterfaceType, GraphQLUnionType, GraphQLEnumType, GraphQLInputObjectType;
var init_definition = __esmMin((() => {
	init_devAssert();
	init_didYouMean();
	init_identityFunc();
	init_inspect();
	init_instanceOf();
	init_isObjectLike();
	init_keyMap();
	init_keyValMap();
	init_mapValue();
	init_suggestionList();
	init_toObjMap();
	init_GraphQLError();
	init_kinds();
	init_printer();
	init_valueFromASTUntyped();
	init_assertName();
	GraphQLList = class {
		constructor(ofType) {
			isType(ofType) || devAssert(false, `Expected ${inspect(ofType)} to be a GraphQL type.`);
			this.ofType = ofType;
		}
		get [Symbol.toStringTag]() {
			return "GraphQLList";
		}
		toString() {
			return "[" + String(this.ofType) + "]";
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLNonNull = class {
		constructor(ofType) {
			isNullableType(ofType) || devAssert(false, `Expected ${inspect(ofType)} to be a GraphQL nullable type.`);
			this.ofType = ofType;
		}
		get [Symbol.toStringTag]() {
			return "GraphQLNonNull";
		}
		toString() {
			return String(this.ofType) + "!";
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLScalarType = class {
		constructor(config) {
			var _config$parseValue, _config$serialize, _config$parseLiteral, _config$extensionASTN;
			const parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : identityFunc;
			this.name = assertName(config.name);
			this.description = config.description;
			this.specifiedByURL = config.specifiedByURL;
			this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : identityFunc;
			this.parseValue = parseValue;
			this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : (node, variables) => parseValue(valueFromASTUntyped(node, variables));
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN = config.extensionASTNodes) !== null && _config$extensionASTN !== void 0 ? _config$extensionASTN : [];
			config.specifiedByURL == null || typeof config.specifiedByURL === "string" || devAssert(false, `${this.name} must provide "specifiedByURL" as a string, but got: ${inspect(config.specifiedByURL)}.`);
			config.serialize == null || typeof config.serialize === "function" || devAssert(false, `${this.name} must provide "serialize" function. If this custom Scalar is also used as an input type, ensure "parseValue" and "parseLiteral" functions are also provided.`);
			if (config.parseLiteral) typeof config.parseValue === "function" && typeof config.parseLiteral === "function" || devAssert(false, `${this.name} must provide both "parseValue" and "parseLiteral" functions.`);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLScalarType";
		}
		toConfig() {
			return {
				name: this.name,
				description: this.description,
				specifiedByURL: this.specifiedByURL,
				serialize: this.serialize,
				parseValue: this.parseValue,
				parseLiteral: this.parseLiteral,
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes
			};
		}
		toString() {
			return this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLObjectType = class {
		constructor(config) {
			var _config$extensionASTN2;
			this.name = assertName(config.name);
			this.description = config.description;
			this.isTypeOf = config.isTypeOf;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN2 = config.extensionASTNodes) !== null && _config$extensionASTN2 !== void 0 ? _config$extensionASTN2 : [];
			this._fields = () => defineFieldMap(config);
			this._interfaces = () => defineInterfaces(config);
			config.isTypeOf == null || typeof config.isTypeOf === "function" || devAssert(false, `${this.name} must provide "isTypeOf" as a function, but got: ${inspect(config.isTypeOf)}.`);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLObjectType";
		}
		getFields() {
			if (typeof this._fields === "function") this._fields = this._fields();
			return this._fields;
		}
		getInterfaces() {
			if (typeof this._interfaces === "function") this._interfaces = this._interfaces();
			return this._interfaces;
		}
		toConfig() {
			return {
				name: this.name,
				description: this.description,
				interfaces: this.getInterfaces(),
				fields: fieldsToFieldsConfig(this.getFields()),
				isTypeOf: this.isTypeOf,
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes
			};
		}
		toString() {
			return this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLInterfaceType = class {
		constructor(config) {
			var _config$extensionASTN3;
			this.name = assertName(config.name);
			this.description = config.description;
			this.resolveType = config.resolveType;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN3 = config.extensionASTNodes) !== null && _config$extensionASTN3 !== void 0 ? _config$extensionASTN3 : [];
			this._fields = defineFieldMap.bind(void 0, config);
			this._interfaces = defineInterfaces.bind(void 0, config);
			config.resolveType == null || typeof config.resolveType === "function" || devAssert(false, `${this.name} must provide "resolveType" as a function, but got: ${inspect(config.resolveType)}.`);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLInterfaceType";
		}
		getFields() {
			if (typeof this._fields === "function") this._fields = this._fields();
			return this._fields;
		}
		getInterfaces() {
			if (typeof this._interfaces === "function") this._interfaces = this._interfaces();
			return this._interfaces;
		}
		toConfig() {
			return {
				name: this.name,
				description: this.description,
				interfaces: this.getInterfaces(),
				fields: fieldsToFieldsConfig(this.getFields()),
				resolveType: this.resolveType,
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes
			};
		}
		toString() {
			return this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLUnionType = class {
		constructor(config) {
			var _config$extensionASTN4;
			this.name = assertName(config.name);
			this.description = config.description;
			this.resolveType = config.resolveType;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN4 = config.extensionASTNodes) !== null && _config$extensionASTN4 !== void 0 ? _config$extensionASTN4 : [];
			this._types = defineTypes.bind(void 0, config);
			config.resolveType == null || typeof config.resolveType === "function" || devAssert(false, `${this.name} must provide "resolveType" as a function, but got: ${inspect(config.resolveType)}.`);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLUnionType";
		}
		getTypes() {
			if (typeof this._types === "function") this._types = this._types();
			return this._types;
		}
		toConfig() {
			return {
				name: this.name,
				description: this.description,
				types: this.getTypes(),
				resolveType: this.resolveType,
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes
			};
		}
		toString() {
			return this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLEnumType = class {
		constructor(config) {
			var _config$extensionASTN5;
			this.name = assertName(config.name);
			this.description = config.description;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN5 = config.extensionASTNodes) !== null && _config$extensionASTN5 !== void 0 ? _config$extensionASTN5 : [];
			this._values = defineEnumValues(this.name, config.values);
			this._valueLookup = new Map(this._values.map((enumValue) => [enumValue.value, enumValue]));
			this._nameLookup = keyMap(this._values, (value) => value.name);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLEnumType";
		}
		getValues() {
			return this._values;
		}
		getValue(name) {
			return this._nameLookup[name];
		}
		serialize(outputValue) {
			const enumValue = this._valueLookup.get(outputValue);
			if (enumValue === void 0) throw new GraphQLError(`Enum "${this.name}" cannot represent value: ${inspect(outputValue)}`);
			return enumValue.name;
		}
		parseValue(inputValue) {
			if (typeof inputValue !== "string") {
				const valueStr = inspect(inputValue);
				throw new GraphQLError(`Enum "${this.name}" cannot represent non-string value: ${valueStr}.` + didYouMeanEnumValue(this, valueStr));
			}
			const enumValue = this.getValue(inputValue);
			if (enumValue == null) throw new GraphQLError(`Value "${inputValue}" does not exist in "${this.name}" enum.` + didYouMeanEnumValue(this, inputValue));
			return enumValue.value;
		}
		parseLiteral(valueNode, _variables) {
			if (valueNode.kind !== Kind.ENUM) {
				const valueStr = print(valueNode);
				throw new GraphQLError(`Enum "${this.name}" cannot represent non-enum value: ${valueStr}.` + didYouMeanEnumValue(this, valueStr), { nodes: valueNode });
			}
			const enumValue = this.getValue(valueNode.value);
			if (enumValue == null) {
				const valueStr = print(valueNode);
				throw new GraphQLError(`Value "${valueStr}" does not exist in "${this.name}" enum.` + didYouMeanEnumValue(this, valueStr), { nodes: valueNode });
			}
			return enumValue.value;
		}
		toConfig() {
			const values = keyValMap(this.getValues(), (value) => value.name, (value) => ({
				description: value.description,
				value: value.value,
				deprecationReason: value.deprecationReason,
				extensions: value.extensions,
				astNode: value.astNode
			}));
			return {
				name: this.name,
				description: this.description,
				values,
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes
			};
		}
		toString() {
			return this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLInputObjectType = class {
		constructor(config) {
			var _config$extensionASTN6;
			this.name = assertName(config.name);
			this.description = config.description;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN6 = config.extensionASTNodes) !== null && _config$extensionASTN6 !== void 0 ? _config$extensionASTN6 : [];
			this._fields = defineInputFieldMap.bind(void 0, config);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLInputObjectType";
		}
		getFields() {
			if (typeof this._fields === "function") this._fields = this._fields();
			return this._fields;
		}
		toConfig() {
			const fields = mapValue(this.getFields(), (field) => ({
				description: field.description,
				type: field.type,
				defaultValue: field.defaultValue,
				deprecationReason: field.deprecationReason,
				extensions: field.extensions,
				astNode: field.astNode
			}));
			return {
				name: this.name,
				description: this.description,
				fields,
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes
			};
		}
		toString() {
			return this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/utilities/typeComparators.mjs
/**
* Provided two types, return true if the types are equal (invariant).
*/
function isEqualType(typeA, typeB) {
	if (typeA === typeB) return true;
	if (isNonNullType(typeA) && isNonNullType(typeB)) return isEqualType(typeA.ofType, typeB.ofType);
	if (isListType(typeA) && isListType(typeB)) return isEqualType(typeA.ofType, typeB.ofType);
	return false;
}
/**
* Provided a type and a super type, return true if the first type is either
* equal or a subset of the second super type (covariant).
*/
function isTypeSubTypeOf(schema, maybeSubType, superType) {
	if (maybeSubType === superType) return true;
	if (isNonNullType(superType)) {
		if (isNonNullType(maybeSubType)) return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
		return false;
	}
	if (isNonNullType(maybeSubType)) return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
	if (isListType(superType)) {
		if (isListType(maybeSubType)) return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
		return false;
	}
	if (isListType(maybeSubType)) return false;
	return isAbstractType(superType) && (isInterfaceType(maybeSubType) || isObjectType(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
/**
* Provided two composite types, determine if they "overlap". Two composite
* types overlap when the Sets of possible concrete types for each intersect.
*
* This is often used to determine if a fragment of a given type could possibly
* be visited in a context of another type.
*
* This function is commutative.
*/
function doTypesOverlap(schema, typeA, typeB) {
	if (typeA === typeB) return true;
	if (isAbstractType(typeA)) {
		if (isAbstractType(typeB)) return schema.getPossibleTypes(typeA).some((type) => schema.isSubType(typeB, type));
		return schema.isSubType(typeA, typeB);
	}
	if (isAbstractType(typeB)) return schema.isSubType(typeB, typeA);
	return false;
}
var init_typeComparators = __esmMin((() => {
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/type/scalars.mjs
function isSpecifiedScalarType(type) {
	return specifiedScalarTypes.some(({ name }) => type.name === name);
}
function serializeObject(outputValue) {
	if (isObjectLike(outputValue)) {
		if (typeof outputValue.valueOf === "function") {
			const valueOfResult = outputValue.valueOf();
			if (!isObjectLike(valueOfResult)) return valueOfResult;
		}
		if (typeof outputValue.toJSON === "function") return outputValue.toJSON();
	}
	return outputValue;
}
var GRAPHQL_MAX_INT, GRAPHQL_MIN_INT, GraphQLInt, GraphQLFloat, GraphQLString, GraphQLBoolean, GraphQLID, specifiedScalarTypes;
var init_scalars = __esmMin((() => {
	init_inspect();
	init_isObjectLike();
	init_GraphQLError();
	init_kinds();
	init_printer();
	init_definition();
	GRAPHQL_MAX_INT = 2147483647;
	GRAPHQL_MIN_INT = -2147483648;
	GraphQLInt = new GraphQLScalarType({
		name: "Int",
		description: "The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.",
		serialize(outputValue) {
			const coercedValue = serializeObject(outputValue);
			if (typeof coercedValue === "boolean") return coercedValue ? 1 : 0;
			let num = coercedValue;
			if (typeof coercedValue === "string" && coercedValue !== "") num = Number(coercedValue);
			if (typeof num !== "number" || !Number.isInteger(num)) throw new GraphQLError(`Int cannot represent non-integer value: ${inspect(coercedValue)}`);
			if (num > 2147483647 || num < -2147483648) throw new GraphQLError("Int cannot represent non 32-bit signed integer value: " + inspect(coercedValue));
			return num;
		},
		parseValue(inputValue) {
			if (typeof inputValue !== "number" || !Number.isInteger(inputValue)) throw new GraphQLError(`Int cannot represent non-integer value: ${inspect(inputValue)}`);
			if (inputValue > 2147483647 || inputValue < -2147483648) throw new GraphQLError(`Int cannot represent non 32-bit signed integer value: ${inputValue}`);
			return inputValue;
		},
		parseLiteral(valueNode) {
			if (valueNode.kind !== Kind.INT) throw new GraphQLError(`Int cannot represent non-integer value: ${print(valueNode)}`, { nodes: valueNode });
			const num = parseInt(valueNode.value, 10);
			if (num > 2147483647 || num < -2147483648) throw new GraphQLError(`Int cannot represent non 32-bit signed integer value: ${valueNode.value}`, { nodes: valueNode });
			return num;
		}
	});
	GraphQLFloat = new GraphQLScalarType({
		name: "Float",
		description: "The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).",
		serialize(outputValue) {
			const coercedValue = serializeObject(outputValue);
			if (typeof coercedValue === "boolean") return coercedValue ? 1 : 0;
			let num = coercedValue;
			if (typeof coercedValue === "string" && coercedValue !== "") num = Number(coercedValue);
			if (typeof num !== "number" || !Number.isFinite(num)) throw new GraphQLError(`Float cannot represent non numeric value: ${inspect(coercedValue)}`);
			return num;
		},
		parseValue(inputValue) {
			if (typeof inputValue !== "number" || !Number.isFinite(inputValue)) throw new GraphQLError(`Float cannot represent non numeric value: ${inspect(inputValue)}`);
			return inputValue;
		},
		parseLiteral(valueNode) {
			if (valueNode.kind !== Kind.FLOAT && valueNode.kind !== Kind.INT) throw new GraphQLError(`Float cannot represent non numeric value: ${print(valueNode)}`, valueNode);
			return parseFloat(valueNode.value);
		}
	});
	GraphQLString = new GraphQLScalarType({
		name: "String",
		description: "The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
		serialize(outputValue) {
			const coercedValue = serializeObject(outputValue);
			if (typeof coercedValue === "string") return coercedValue;
			if (typeof coercedValue === "boolean") return coercedValue ? "true" : "false";
			if (typeof coercedValue === "number" && Number.isFinite(coercedValue)) return coercedValue.toString();
			throw new GraphQLError(`String cannot represent value: ${inspect(outputValue)}`);
		},
		parseValue(inputValue) {
			if (typeof inputValue !== "string") throw new GraphQLError(`String cannot represent a non string value: ${inspect(inputValue)}`);
			return inputValue;
		},
		parseLiteral(valueNode) {
			if (valueNode.kind !== Kind.STRING) throw new GraphQLError(`String cannot represent a non string value: ${print(valueNode)}`, { nodes: valueNode });
			return valueNode.value;
		}
	});
	GraphQLBoolean = new GraphQLScalarType({
		name: "Boolean",
		description: "The `Boolean` scalar type represents `true` or `false`.",
		serialize(outputValue) {
			const coercedValue = serializeObject(outputValue);
			if (typeof coercedValue === "boolean") return coercedValue;
			if (Number.isFinite(coercedValue)) return coercedValue !== 0;
			throw new GraphQLError(`Boolean cannot represent a non boolean value: ${inspect(coercedValue)}`);
		},
		parseValue(inputValue) {
			if (typeof inputValue !== "boolean") throw new GraphQLError(`Boolean cannot represent a non boolean value: ${inspect(inputValue)}`);
			return inputValue;
		},
		parseLiteral(valueNode) {
			if (valueNode.kind !== Kind.BOOLEAN) throw new GraphQLError(`Boolean cannot represent a non boolean value: ${print(valueNode)}`, { nodes: valueNode });
			return valueNode.value;
		}
	});
	GraphQLID = new GraphQLScalarType({
		name: "ID",
		description: "The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `\"4\"`) or integer (such as `4`) input value will be accepted as an ID.",
		serialize(outputValue) {
			const coercedValue = serializeObject(outputValue);
			if (typeof coercedValue === "string") return coercedValue;
			if (Number.isInteger(coercedValue)) return String(coercedValue);
			throw new GraphQLError(`ID cannot represent value: ${inspect(outputValue)}`);
		},
		parseValue(inputValue) {
			if (typeof inputValue === "string") return inputValue;
			if (typeof inputValue === "number" && Number.isInteger(inputValue)) return inputValue.toString();
			throw new GraphQLError(`ID cannot represent value: ${inspect(inputValue)}`);
		},
		parseLiteral(valueNode) {
			if (valueNode.kind !== Kind.STRING && valueNode.kind !== Kind.INT) throw new GraphQLError("ID cannot represent a non-string and non-integer value: " + print(valueNode), { nodes: valueNode });
			return valueNode.value;
		}
	});
	specifiedScalarTypes = Object.freeze([
		GraphQLString,
		GraphQLInt,
		GraphQLFloat,
		GraphQLBoolean,
		GraphQLID
	]);
}));
//#endregion
//#region ../../node_modules/graphql/type/directives.mjs
/**
* Test if the given value is a GraphQL directive.
*/
function isDirective(directive) {
	return instanceOf(directive, GraphQLDirective);
}
function assertDirective(directive) {
	if (!isDirective(directive)) throw new Error(`Expected ${inspect(directive)} to be a GraphQL directive.`);
	return directive;
}
function isSpecifiedDirective(directive) {
	return specifiedDirectives.some(({ name }) => name === directive.name);
}
var GraphQLDirective, GraphQLIncludeDirective, GraphQLSkipDirective, DEFAULT_DEPRECATION_REASON, GraphQLDeprecatedDirective, GraphQLSpecifiedByDirective, specifiedDirectives;
var init_directives = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_instanceOf();
	init_isObjectLike();
	init_toObjMap();
	init_directiveLocation();
	init_assertName();
	init_definition();
	init_scalars();
	GraphQLDirective = class {
		constructor(config) {
			var _config$isRepeatable, _config$args;
			this.name = assertName(config.name);
			this.description = config.description;
			this.locations = config.locations;
			this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			Array.isArray(config.locations) || devAssert(false, `@${config.name} locations must be an Array.`);
			const args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
			isObjectLike(args) && !Array.isArray(args) || devAssert(false, `@${config.name} args must be an object with argument names as keys.`);
			this.args = defineArguments(args);
		}
		get [Symbol.toStringTag]() {
			return "GraphQLDirective";
		}
		toConfig() {
			return {
				name: this.name,
				description: this.description,
				locations: this.locations,
				args: argsToArgsConfig(this.args),
				isRepeatable: this.isRepeatable,
				extensions: this.extensions,
				astNode: this.astNode
			};
		}
		toString() {
			return "@" + this.name;
		}
		toJSON() {
			return this.toString();
		}
	};
	GraphQLIncludeDirective = new GraphQLDirective({
		name: "include",
		description: "Directs the executor to include this field or fragment only when the `if` argument is true.",
		locations: [
			DirectiveLocation.FIELD,
			DirectiveLocation.FRAGMENT_SPREAD,
			DirectiveLocation.INLINE_FRAGMENT
		],
		args: { if: {
			type: new GraphQLNonNull(GraphQLBoolean),
			description: "Included when true."
		} }
	});
	GraphQLSkipDirective = new GraphQLDirective({
		name: "skip",
		description: "Directs the executor to skip this field or fragment when the `if` argument is true.",
		locations: [
			DirectiveLocation.FIELD,
			DirectiveLocation.FRAGMENT_SPREAD,
			DirectiveLocation.INLINE_FRAGMENT
		],
		args: { if: {
			type: new GraphQLNonNull(GraphQLBoolean),
			description: "Skipped when true."
		} }
	});
	DEFAULT_DEPRECATION_REASON = "No longer supported";
	GraphQLDeprecatedDirective = new GraphQLDirective({
		name: "deprecated",
		description: "Marks an element of a GraphQL schema as no longer supported.",
		locations: [
			DirectiveLocation.FIELD_DEFINITION,
			DirectiveLocation.ARGUMENT_DEFINITION,
			DirectiveLocation.INPUT_FIELD_DEFINITION,
			DirectiveLocation.ENUM_VALUE
		],
		args: { reason: {
			type: GraphQLString,
			description: "Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).",
			defaultValue: DEFAULT_DEPRECATION_REASON
		} }
	});
	GraphQLSpecifiedByDirective = new GraphQLDirective({
		name: "specifiedBy",
		description: "Exposes a URL that specifies the behavior of this scalar.",
		locations: [DirectiveLocation.SCALAR],
		args: { url: {
			type: new GraphQLNonNull(GraphQLString),
			description: "The URL that specifies the behavior of this scalar."
		} }
	});
	specifiedDirectives = Object.freeze([
		GraphQLIncludeDirective,
		GraphQLSkipDirective,
		GraphQLDeprecatedDirective,
		GraphQLSpecifiedByDirective
	]);
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/isIterableObject.mjs
/**
* Returns true if the provided object is an Object (i.e. not a string literal)
* and implements the Iterator protocol.
*
* This may be used in place of [Array.isArray()][isArray] to determine if
* an object should be iterated-over e.g. Array, Map, Set, Int8Array,
* TypedArray, etc. but excludes string literals.
*
* @example
* ```ts
* isIterableObject([ 1, 2, 3 ]) // true
* isIterableObject(new Map()) // true
* isIterableObject('ABC') // false
* isIterableObject({ key: 'value' }) // false
* isIterableObject({ length: 1, 0: 'Alpha' }) // false
* ```
*/
function isIterableObject(maybeIterable) {
	return typeof maybeIterable === "object" && typeof (maybeIterable === null || maybeIterable === void 0 ? void 0 : maybeIterable[Symbol.iterator]) === "function";
}
var init_isIterableObject = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/utilities/astFromValue.mjs
/**
* Produces a GraphQL Value AST given a JavaScript object.
* Function will match JavaScript/JSON values to GraphQL AST schema format
* by using suggested GraphQLInputType. For example:
*
*     astFromValue("value", GraphQLString)
*
* A GraphQL type must be provided, which will be used to interpret different
* JavaScript values.
*
* | JSON Value    | GraphQL Value        |
* | ------------- | -------------------- |
* | Object        | Input Object         |
* | Array         | List                 |
* | Boolean       | Boolean              |
* | String        | String / Enum Value  |
* | Number        | Int / Float          |
* | Unknown       | Enum Value           |
* | null          | NullValue            |
*
*/
function astFromValue(value, type) {
	if (isNonNullType(type)) {
		const astValue = astFromValue(value, type.ofType);
		if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === Kind.NULL) return null;
		return astValue;
	}
	if (value === null) return { kind: Kind.NULL };
	if (value === void 0) return null;
	if (isListType(type)) {
		const itemType = type.ofType;
		if (isIterableObject(value)) {
			const valuesNodes = [];
			for (const item of value) {
				const itemNode = astFromValue(item, itemType);
				if (itemNode != null) valuesNodes.push(itemNode);
			}
			return {
				kind: Kind.LIST,
				values: valuesNodes
			};
		}
		return astFromValue(value, itemType);
	}
	if (isInputObjectType(type)) {
		if (!isObjectLike(value)) return null;
		const fieldNodes = [];
		for (const field of Object.values(type.getFields())) {
			const fieldValue = astFromValue(value[field.name], field.type);
			if (fieldValue) fieldNodes.push({
				kind: Kind.OBJECT_FIELD,
				name: {
					kind: Kind.NAME,
					value: field.name
				},
				value: fieldValue
			});
		}
		return {
			kind: Kind.OBJECT,
			fields: fieldNodes
		};
	}
	if (isLeafType(type)) {
		const serialized = type.serialize(value);
		if (serialized == null) return null;
		if (typeof serialized === "boolean") return {
			kind: Kind.BOOLEAN,
			value: serialized
		};
		if (typeof serialized === "number" && Number.isFinite(serialized)) {
			const stringNum = String(serialized);
			return integerStringRegExp.test(stringNum) ? {
				kind: Kind.INT,
				value: stringNum
			} : {
				kind: Kind.FLOAT,
				value: stringNum
			};
		}
		if (typeof serialized === "string") {
			if (isEnumType(type)) return {
				kind: Kind.ENUM,
				value: serialized
			};
			if (type === GraphQLID && integerStringRegExp.test(serialized)) return {
				kind: Kind.INT,
				value: serialized
			};
			return {
				kind: Kind.STRING,
				value: serialized
			};
		}
		throw new TypeError(`Cannot convert value to AST: ${inspect(serialized)}.`);
	}
	/* c8 ignore next 3 */
	invariant(false, "Unexpected input type: " + inspect(type));
}
var integerStringRegExp;
var init_astFromValue = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_isIterableObject();
	init_isObjectLike();
	init_kinds();
	init_definition();
	init_scalars();
	integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;
}));
//#endregion
//#region ../../node_modules/graphql/type/introspection.mjs
function isIntrospectionType(type) {
	return introspectionTypes.some(({ name }) => type.name === name);
}
var __Schema, __Directive, __DirectiveLocation, __Type, __Field, __InputValue, __EnumValue, TypeKind, __TypeKind, SchemaMetaFieldDef, TypeMetaFieldDef, TypeNameMetaFieldDef, introspectionTypes;
var init_introspection = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_directiveLocation();
	init_printer();
	init_astFromValue();
	init_definition();
	init_scalars();
	__Schema = new GraphQLObjectType({
		name: "__Schema",
		description: "A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.",
		fields: () => ({
			description: {
				type: GraphQLString,
				resolve: (schema) => schema.description
			},
			types: {
				description: "A list of all types supported by this server.",
				type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__Type))),
				resolve(schema) {
					return Object.values(schema.getTypeMap());
				}
			},
			queryType: {
				description: "The type that query operations will be rooted at.",
				type: new GraphQLNonNull(__Type),
				resolve: (schema) => schema.getQueryType()
			},
			mutationType: {
				description: "If this server supports mutation, the type that mutation operations will be rooted at.",
				type: __Type,
				resolve: (schema) => schema.getMutationType()
			},
			subscriptionType: {
				description: "If this server support subscription, the type that subscription operations will be rooted at.",
				type: __Type,
				resolve: (schema) => schema.getSubscriptionType()
			},
			directives: {
				description: "A list of all directives supported by this server.",
				type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__Directive))),
				resolve: (schema) => schema.getDirectives()
			}
		})
	});
	__Directive = new GraphQLObjectType({
		name: "__Directive",
		description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
		fields: () => ({
			name: {
				type: new GraphQLNonNull(GraphQLString),
				resolve: (directive) => directive.name
			},
			description: {
				type: GraphQLString,
				resolve: (directive) => directive.description
			},
			isRepeatable: {
				type: new GraphQLNonNull(GraphQLBoolean),
				resolve: (directive) => directive.isRepeatable
			},
			locations: {
				type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__DirectiveLocation))),
				resolve: (directive) => directive.locations
			},
			args: {
				type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__InputValue))),
				args: { includeDeprecated: {
					type: GraphQLBoolean,
					defaultValue: false
				} },
				resolve(field, { includeDeprecated }) {
					return includeDeprecated ? field.args : field.args.filter((arg) => arg.deprecationReason == null);
				}
			}
		})
	});
	__DirectiveLocation = new GraphQLEnumType({
		name: "__DirectiveLocation",
		description: "A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.",
		values: {
			QUERY: {
				value: DirectiveLocation.QUERY,
				description: "Location adjacent to a query operation."
			},
			MUTATION: {
				value: DirectiveLocation.MUTATION,
				description: "Location adjacent to a mutation operation."
			},
			SUBSCRIPTION: {
				value: DirectiveLocation.SUBSCRIPTION,
				description: "Location adjacent to a subscription operation."
			},
			FIELD: {
				value: DirectiveLocation.FIELD,
				description: "Location adjacent to a field."
			},
			FRAGMENT_DEFINITION: {
				value: DirectiveLocation.FRAGMENT_DEFINITION,
				description: "Location adjacent to a fragment definition."
			},
			FRAGMENT_SPREAD: {
				value: DirectiveLocation.FRAGMENT_SPREAD,
				description: "Location adjacent to a fragment spread."
			},
			INLINE_FRAGMENT: {
				value: DirectiveLocation.INLINE_FRAGMENT,
				description: "Location adjacent to an inline fragment."
			},
			VARIABLE_DEFINITION: {
				value: DirectiveLocation.VARIABLE_DEFINITION,
				description: "Location adjacent to a variable definition."
			},
			SCHEMA: {
				value: DirectiveLocation.SCHEMA,
				description: "Location adjacent to a schema definition."
			},
			SCALAR: {
				value: DirectiveLocation.SCALAR,
				description: "Location adjacent to a scalar definition."
			},
			OBJECT: {
				value: DirectiveLocation.OBJECT,
				description: "Location adjacent to an object type definition."
			},
			FIELD_DEFINITION: {
				value: DirectiveLocation.FIELD_DEFINITION,
				description: "Location adjacent to a field definition."
			},
			ARGUMENT_DEFINITION: {
				value: DirectiveLocation.ARGUMENT_DEFINITION,
				description: "Location adjacent to an argument definition."
			},
			INTERFACE: {
				value: DirectiveLocation.INTERFACE,
				description: "Location adjacent to an interface definition."
			},
			UNION: {
				value: DirectiveLocation.UNION,
				description: "Location adjacent to a union definition."
			},
			ENUM: {
				value: DirectiveLocation.ENUM,
				description: "Location adjacent to an enum definition."
			},
			ENUM_VALUE: {
				value: DirectiveLocation.ENUM_VALUE,
				description: "Location adjacent to an enum value definition."
			},
			INPUT_OBJECT: {
				value: DirectiveLocation.INPUT_OBJECT,
				description: "Location adjacent to an input object type definition."
			},
			INPUT_FIELD_DEFINITION: {
				value: DirectiveLocation.INPUT_FIELD_DEFINITION,
				description: "Location adjacent to an input object field definition."
			}
		}
	});
	__Type = new GraphQLObjectType({
		name: "__Type",
		description: "The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.",
		fields: () => ({
			kind: {
				type: new GraphQLNonNull(__TypeKind),
				resolve(type) {
					if (isScalarType(type)) return TypeKind.SCALAR;
					if (isObjectType(type)) return TypeKind.OBJECT;
					if (isInterfaceType(type)) return TypeKind.INTERFACE;
					if (isUnionType(type)) return TypeKind.UNION;
					if (isEnumType(type)) return TypeKind.ENUM;
					if (isInputObjectType(type)) return TypeKind.INPUT_OBJECT;
					if (isListType(type)) return TypeKind.LIST;
					if (isNonNullType(type)) return TypeKind.NON_NULL;
					/* c8 ignore next 3 */
					invariant(false, `Unexpected type: "${inspect(type)}".`);
				}
			},
			name: {
				type: GraphQLString,
				resolve: (type) => "name" in type ? type.name : void 0
			},
			description: {
				type: GraphQLString,
				resolve: (type) => "description" in type ? type.description : void 0
			},
			specifiedByURL: {
				type: GraphQLString,
				resolve: (obj) => "specifiedByURL" in obj ? obj.specifiedByURL : void 0
			},
			fields: {
				type: new GraphQLList(new GraphQLNonNull(__Field)),
				args: { includeDeprecated: {
					type: GraphQLBoolean,
					defaultValue: false
				} },
				resolve(type, { includeDeprecated }) {
					if (isObjectType(type) || isInterfaceType(type)) {
						const fields = Object.values(type.getFields());
						return includeDeprecated ? fields : fields.filter((field) => field.deprecationReason == null);
					}
				}
			},
			interfaces: {
				type: new GraphQLList(new GraphQLNonNull(__Type)),
				resolve(type) {
					if (isObjectType(type) || isInterfaceType(type)) return type.getInterfaces();
				}
			},
			possibleTypes: {
				type: new GraphQLList(new GraphQLNonNull(__Type)),
				resolve(type, _args, _context, { schema }) {
					if (isAbstractType(type)) return schema.getPossibleTypes(type);
				}
			},
			enumValues: {
				type: new GraphQLList(new GraphQLNonNull(__EnumValue)),
				args: { includeDeprecated: {
					type: GraphQLBoolean,
					defaultValue: false
				} },
				resolve(type, { includeDeprecated }) {
					if (isEnumType(type)) {
						const values = type.getValues();
						return includeDeprecated ? values : values.filter((field) => field.deprecationReason == null);
					}
				}
			},
			inputFields: {
				type: new GraphQLList(new GraphQLNonNull(__InputValue)),
				args: { includeDeprecated: {
					type: GraphQLBoolean,
					defaultValue: false
				} },
				resolve(type, { includeDeprecated }) {
					if (isInputObjectType(type)) {
						const values = Object.values(type.getFields());
						return includeDeprecated ? values : values.filter((field) => field.deprecationReason == null);
					}
				}
			},
			ofType: {
				type: __Type,
				resolve: (type) => "ofType" in type ? type.ofType : void 0
			}
		})
	});
	__Field = new GraphQLObjectType({
		name: "__Field",
		description: "Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.",
		fields: () => ({
			name: {
				type: new GraphQLNonNull(GraphQLString),
				resolve: (field) => field.name
			},
			description: {
				type: GraphQLString,
				resolve: (field) => field.description
			},
			args: {
				type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__InputValue))),
				args: { includeDeprecated: {
					type: GraphQLBoolean,
					defaultValue: false
				} },
				resolve(field, { includeDeprecated }) {
					return includeDeprecated ? field.args : field.args.filter((arg) => arg.deprecationReason == null);
				}
			},
			type: {
				type: new GraphQLNonNull(__Type),
				resolve: (field) => field.type
			},
			isDeprecated: {
				type: new GraphQLNonNull(GraphQLBoolean),
				resolve: (field) => field.deprecationReason != null
			},
			deprecationReason: {
				type: GraphQLString,
				resolve: (field) => field.deprecationReason
			}
		})
	});
	__InputValue = new GraphQLObjectType({
		name: "__InputValue",
		description: "Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.",
		fields: () => ({
			name: {
				type: new GraphQLNonNull(GraphQLString),
				resolve: (inputValue) => inputValue.name
			},
			description: {
				type: GraphQLString,
				resolve: (inputValue) => inputValue.description
			},
			type: {
				type: new GraphQLNonNull(__Type),
				resolve: (inputValue) => inputValue.type
			},
			defaultValue: {
				type: GraphQLString,
				description: "A GraphQL-formatted string representing the default value for this input value.",
				resolve(inputValue) {
					const { type, defaultValue } = inputValue;
					const valueAST = astFromValue(defaultValue, type);
					return valueAST ? print(valueAST) : null;
				}
			},
			isDeprecated: {
				type: new GraphQLNonNull(GraphQLBoolean),
				resolve: (field) => field.deprecationReason != null
			},
			deprecationReason: {
				type: GraphQLString,
				resolve: (obj) => obj.deprecationReason
			}
		})
	});
	__EnumValue = new GraphQLObjectType({
		name: "__EnumValue",
		description: "One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.",
		fields: () => ({
			name: {
				type: new GraphQLNonNull(GraphQLString),
				resolve: (enumValue) => enumValue.name
			},
			description: {
				type: GraphQLString,
				resolve: (enumValue) => enumValue.description
			},
			isDeprecated: {
				type: new GraphQLNonNull(GraphQLBoolean),
				resolve: (enumValue) => enumValue.deprecationReason != null
			},
			deprecationReason: {
				type: GraphQLString,
				resolve: (enumValue) => enumValue.deprecationReason
			}
		})
	});
	(function(TypeKind) {
		TypeKind["SCALAR"] = "SCALAR";
		TypeKind["OBJECT"] = "OBJECT";
		TypeKind["INTERFACE"] = "INTERFACE";
		TypeKind["UNION"] = "UNION";
		TypeKind["ENUM"] = "ENUM";
		TypeKind["INPUT_OBJECT"] = "INPUT_OBJECT";
		TypeKind["LIST"] = "LIST";
		TypeKind["NON_NULL"] = "NON_NULL";
	})(TypeKind || (TypeKind = {}));
	__TypeKind = new GraphQLEnumType({
		name: "__TypeKind",
		description: "An enum describing what kind of type a given `__Type` is.",
		values: {
			SCALAR: {
				value: TypeKind.SCALAR,
				description: "Indicates this type is a scalar."
			},
			OBJECT: {
				value: TypeKind.OBJECT,
				description: "Indicates this type is an object. `fields` and `interfaces` are valid fields."
			},
			INTERFACE: {
				value: TypeKind.INTERFACE,
				description: "Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields."
			},
			UNION: {
				value: TypeKind.UNION,
				description: "Indicates this type is a union. `possibleTypes` is a valid field."
			},
			ENUM: {
				value: TypeKind.ENUM,
				description: "Indicates this type is an enum. `enumValues` is a valid field."
			},
			INPUT_OBJECT: {
				value: TypeKind.INPUT_OBJECT,
				description: "Indicates this type is an input object. `inputFields` is a valid field."
			},
			LIST: {
				value: TypeKind.LIST,
				description: "Indicates this type is a list. `ofType` is a valid field."
			},
			NON_NULL: {
				value: TypeKind.NON_NULL,
				description: "Indicates this type is a non-null. `ofType` is a valid field."
			}
		}
	});
	SchemaMetaFieldDef = {
		name: "__schema",
		type: new GraphQLNonNull(__Schema),
		description: "Access the current type schema of this server.",
		args: [],
		resolve: (_source, _args, _context, { schema }) => schema,
		deprecationReason: void 0,
		extensions: Object.create(null),
		astNode: void 0
	};
	TypeMetaFieldDef = {
		name: "__type",
		type: __Type,
		description: "Request the type information of a single type.",
		args: [{
			name: "name",
			description: void 0,
			type: new GraphQLNonNull(GraphQLString),
			defaultValue: void 0,
			deprecationReason: void 0,
			extensions: Object.create(null),
			astNode: void 0
		}],
		resolve: (_source, { name }, _context, { schema }) => schema.getType(name),
		deprecationReason: void 0,
		extensions: Object.create(null),
		astNode: void 0
	};
	TypeNameMetaFieldDef = {
		name: "__typename",
		type: new GraphQLNonNull(GraphQLString),
		description: "The name of the current Object type at runtime.",
		args: [],
		resolve: (_source, _args, _context, { parentType }) => parentType.name,
		deprecationReason: void 0,
		extensions: Object.create(null),
		astNode: void 0
	};
	introspectionTypes = Object.freeze([
		__Schema,
		__Directive,
		__DirectiveLocation,
		__Type,
		__Field,
		__InputValue,
		__EnumValue,
		__TypeKind
	]);
}));
//#endregion
//#region ../../node_modules/graphql/type/schema.mjs
/**
* Test if the given value is a GraphQL schema.
*/
function isSchema(schema) {
	return instanceOf(schema, GraphQLSchema);
}
function assertSchema(schema) {
	if (!isSchema(schema)) throw new Error(`Expected ${inspect(schema)} to be a GraphQL schema.`);
	return schema;
}
function collectReferencedTypes(type, typeSet) {
	const namedType = getNamedType(type);
	if (!typeSet.has(namedType)) {
		typeSet.add(namedType);
		if (isUnionType(namedType)) for (const memberType of namedType.getTypes()) collectReferencedTypes(memberType, typeSet);
		else if (isObjectType(namedType) || isInterfaceType(namedType)) {
			for (const interfaceType of namedType.getInterfaces()) collectReferencedTypes(interfaceType, typeSet);
			for (const field of Object.values(namedType.getFields())) {
				collectReferencedTypes(field.type, typeSet);
				for (const arg of field.args) collectReferencedTypes(arg.type, typeSet);
			}
		} else if (isInputObjectType(namedType)) for (const field of Object.values(namedType.getFields())) collectReferencedTypes(field.type, typeSet);
	}
	return typeSet;
}
var GraphQLSchema;
var init_schema = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_instanceOf();
	init_isObjectLike();
	init_toObjMap();
	init_ast();
	init_definition();
	init_directives();
	init_introspection();
	GraphQLSchema = class {
		constructor(config) {
			var _config$extensionASTN, _config$directives;
			this.__validationErrors = config.assumeValid === true ? [] : void 0;
			isObjectLike(config) || devAssert(false, "Must provide configuration object.");
			!config.types || Array.isArray(config.types) || devAssert(false, `"types" must be Array if provided but got: ${inspect(config.types)}.`);
			!config.directives || Array.isArray(config.directives) || devAssert(false, `"directives" must be Array if provided but got: ${inspect(config.directives)}.`);
			this.description = config.description;
			this.extensions = toObjMap(config.extensions);
			this.astNode = config.astNode;
			this.extensionASTNodes = (_config$extensionASTN = config.extensionASTNodes) !== null && _config$extensionASTN !== void 0 ? _config$extensionASTN : [];
			this._queryType = config.query;
			this._mutationType = config.mutation;
			this._subscriptionType = config.subscription;
			this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : specifiedDirectives;
			const allReferencedTypes = new Set(config.types);
			if (config.types != null) for (const type of config.types) {
				allReferencedTypes.delete(type);
				collectReferencedTypes(type, allReferencedTypes);
			}
			if (this._queryType != null) collectReferencedTypes(this._queryType, allReferencedTypes);
			if (this._mutationType != null) collectReferencedTypes(this._mutationType, allReferencedTypes);
			if (this._subscriptionType != null) collectReferencedTypes(this._subscriptionType, allReferencedTypes);
			for (const directive of this._directives) if (isDirective(directive)) for (const arg of directive.args) collectReferencedTypes(arg.type, allReferencedTypes);
			collectReferencedTypes(__Schema, allReferencedTypes);
			this._typeMap = Object.create(null);
			this._subTypeMap = Object.create(null);
			this._implementationsMap = Object.create(null);
			for (const namedType of allReferencedTypes) {
				if (namedType == null) continue;
				const typeName = namedType.name;
				typeName || devAssert(false, "One of the provided types for building the Schema is missing a name.");
				if (this._typeMap[typeName] !== void 0) throw new Error(`Schema must contain uniquely named types but contains multiple types named "${typeName}".`);
				this._typeMap[typeName] = namedType;
				if (isInterfaceType(namedType)) {
					for (const iface of namedType.getInterfaces()) if (isInterfaceType(iface)) {
						let implementations = this._implementationsMap[iface.name];
						if (implementations === void 0) implementations = this._implementationsMap[iface.name] = {
							objects: [],
							interfaces: []
						};
						implementations.interfaces.push(namedType);
					}
				} else if (isObjectType(namedType)) {
					for (const iface of namedType.getInterfaces()) if (isInterfaceType(iface)) {
						let implementations = this._implementationsMap[iface.name];
						if (implementations === void 0) implementations = this._implementationsMap[iface.name] = {
							objects: [],
							interfaces: []
						};
						implementations.objects.push(namedType);
					}
				}
			}
		}
		get [Symbol.toStringTag]() {
			return "GraphQLSchema";
		}
		getQueryType() {
			return this._queryType;
		}
		getMutationType() {
			return this._mutationType;
		}
		getSubscriptionType() {
			return this._subscriptionType;
		}
		getRootType(operation) {
			switch (operation) {
				case OperationTypeNode.QUERY: return this.getQueryType();
				case OperationTypeNode.MUTATION: return this.getMutationType();
				case OperationTypeNode.SUBSCRIPTION: return this.getSubscriptionType();
			}
		}
		getTypeMap() {
			return this._typeMap;
		}
		getType(name) {
			return this.getTypeMap()[name];
		}
		getPossibleTypes(abstractType) {
			return isUnionType(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
		}
		getImplementations(interfaceType) {
			const implementations = this._implementationsMap[interfaceType.name];
			return implementations !== null && implementations !== void 0 ? implementations : {
				objects: [],
				interfaces: []
			};
		}
		isSubType(abstractType, maybeSubType) {
			let map = this._subTypeMap[abstractType.name];
			if (map === void 0) {
				map = Object.create(null);
				if (isUnionType(abstractType)) for (const type of abstractType.getTypes()) map[type.name] = true;
				else {
					const implementations = this.getImplementations(abstractType);
					for (const type of implementations.objects) map[type.name] = true;
					for (const type of implementations.interfaces) map[type.name] = true;
				}
				this._subTypeMap[abstractType.name] = map;
			}
			return map[maybeSubType.name] !== void 0;
		}
		getDirectives() {
			return this._directives;
		}
		getDirective(name) {
			return this.getDirectives().find((directive) => directive.name === name);
		}
		toConfig() {
			return {
				description: this.description,
				query: this.getQueryType(),
				mutation: this.getMutationType(),
				subscription: this.getSubscriptionType(),
				types: Object.values(this.getTypeMap()),
				directives: this.getDirectives(),
				extensions: this.extensions,
				astNode: this.astNode,
				extensionASTNodes: this.extensionASTNodes,
				assumeValid: this.__validationErrors !== void 0
			};
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/type/validate.mjs
/**
* Implements the "Type Validation" sub-sections of the specification's
* "Type System" section.
*
* Validation runs synchronously, returning an array of encountered errors, or
* an empty array if no errors were encountered and the Schema is valid.
*/
function validateSchema(schema) {
	assertSchema(schema);
	if (schema.__validationErrors) return schema.__validationErrors;
	const context = new SchemaValidationContext(schema);
	validateRootTypes(context);
	validateDirectives(context);
	validateTypes(context);
	const errors = context.getErrors();
	schema.__validationErrors = errors;
	return errors;
}
/**
* Utility function which asserts a schema is valid by throwing an error if
* it is invalid.
*/
function assertValidSchema(schema) {
	const errors = validateSchema(schema);
	if (errors.length !== 0) throw new Error(errors.map((error) => error.message).join("\n\n"));
}
function validateRootTypes(context) {
	const schema = context.schema;
	const queryType = schema.getQueryType();
	if (!queryType) context.reportError("Query root type must be provided.", schema.astNode);
	else if (!isObjectType(queryType)) {
		var _getOperationTypeNode;
		context.reportError(`Query root type must be Object type, it cannot be ${inspect(queryType)}.`, (_getOperationTypeNode = getOperationTypeNode(schema, OperationTypeNode.QUERY)) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
	}
	const mutationType = schema.getMutationType();
	if (mutationType && !isObjectType(mutationType)) {
		var _getOperationTypeNode2;
		context.reportError(`Mutation root type must be Object type if provided, it cannot be ${inspect(mutationType)}.`, (_getOperationTypeNode2 = getOperationTypeNode(schema, OperationTypeNode.MUTATION)) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
	}
	const subscriptionType = schema.getSubscriptionType();
	if (subscriptionType && !isObjectType(subscriptionType)) {
		var _getOperationTypeNode3;
		context.reportError(`Subscription root type must be Object type if provided, it cannot be ${inspect(subscriptionType)}.`, (_getOperationTypeNode3 = getOperationTypeNode(schema, OperationTypeNode.SUBSCRIPTION)) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
	}
}
function getOperationTypeNode(schema, operation) {
	var _flatMap$find;
	return (_flatMap$find = [schema.astNode, ...schema.extensionASTNodes].flatMap((schemaNode) => {
		var _schemaNode$operation;
		return (_schemaNode$operation = schemaNode === null || schemaNode === void 0 ? void 0 : schemaNode.operationTypes) !== null && _schemaNode$operation !== void 0 ? _schemaNode$operation : [];
	}).find((operationNode) => operationNode.operation === operation)) === null || _flatMap$find === void 0 ? void 0 : _flatMap$find.type;
}
function validateDirectives(context) {
	for (const directive of context.schema.getDirectives()) {
		if (!isDirective(directive)) {
			context.reportError(`Expected directive but got: ${inspect(directive)}.`, directive === null || directive === void 0 ? void 0 : directive.astNode);
			continue;
		}
		validateName(context, directive);
		for (const arg of directive.args) {
			validateName(context, arg);
			if (!isInputType(arg.type)) context.reportError(`The type of @${directive.name}(${arg.name}:) must be Input Type but got: ${inspect(arg.type)}.`, arg.astNode);
			if (isRequiredArgument(arg) && arg.deprecationReason != null) {
				var _arg$astNode;
				context.reportError(`Required argument @${directive.name}(${arg.name}:) cannot be deprecated.`, [getDeprecatedDirectiveNode(arg.astNode), (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type]);
			}
		}
	}
}
function validateName(context, node) {
	if (node.name.startsWith("__")) context.reportError(`Name "${node.name}" must not begin with "__", which is reserved by GraphQL introspection.`, node.astNode);
}
function validateTypes(context) {
	const validateInputObjectCircularRefs = createInputObjectCircularRefsValidator(context);
	const typeMap = context.schema.getTypeMap();
	for (const type of Object.values(typeMap)) {
		if (!isNamedType(type)) {
			context.reportError(`Expected GraphQL named type but got: ${inspect(type)}.`, type.astNode);
			continue;
		}
		if (!isIntrospectionType(type)) validateName(context, type);
		if (isObjectType(type)) {
			validateFields(context, type);
			validateInterfaces(context, type);
		} else if (isInterfaceType(type)) {
			validateFields(context, type);
			validateInterfaces(context, type);
		} else if (isUnionType(type)) validateUnionMembers(context, type);
		else if (isEnumType(type)) validateEnumValues(context, type);
		else if (isInputObjectType(type)) {
			validateInputFields(context, type);
			validateInputObjectCircularRefs(type);
		}
	}
}
function validateFields(context, type) {
	const fields = Object.values(type.getFields());
	if (fields.length === 0) context.reportError(`Type ${type.name} must define one or more fields.`, [type.astNode, ...type.extensionASTNodes]);
	for (const field of fields) {
		validateName(context, field);
		if (!isOutputType(field.type)) {
			var _field$astNode;
			context.reportError(`The type of ${type.name}.${field.name} must be Output Type but got: ${inspect(field.type)}.`, (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
		}
		for (const arg of field.args) {
			const argName = arg.name;
			validateName(context, arg);
			if (!isInputType(arg.type)) {
				var _arg$astNode2;
				context.reportError(`The type of ${type.name}.${field.name}(${argName}:) must be Input Type but got: ${inspect(arg.type)}.`, (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
			}
			if (isRequiredArgument(arg) && arg.deprecationReason != null) {
				var _arg$astNode3;
				context.reportError(`Required argument ${type.name}.${field.name}(${argName}:) cannot be deprecated.`, [getDeprecatedDirectiveNode(arg.astNode), (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type]);
			}
		}
	}
}
function validateInterfaces(context, type) {
	const ifaceTypeNames = Object.create(null);
	for (const iface of type.getInterfaces()) {
		if (!isInterfaceType(iface)) {
			context.reportError(`Type ${inspect(type)} must only implement Interface types, it cannot implement ${inspect(iface)}.`, getAllImplementsInterfaceNodes(type, iface));
			continue;
		}
		if (type === iface) {
			context.reportError(`Type ${type.name} cannot implement itself because it would create a circular reference.`, getAllImplementsInterfaceNodes(type, iface));
			continue;
		}
		if (ifaceTypeNames[iface.name]) {
			context.reportError(`Type ${type.name} can only implement ${iface.name} once.`, getAllImplementsInterfaceNodes(type, iface));
			continue;
		}
		ifaceTypeNames[iface.name] = true;
		validateTypeImplementsAncestors(context, type, iface);
		validateTypeImplementsInterface(context, type, iface);
	}
}
function validateTypeImplementsInterface(context, type, iface) {
	const typeFieldMap = type.getFields();
	for (const ifaceField of Object.values(iface.getFields())) {
		const fieldName = ifaceField.name;
		const typeField = typeFieldMap[fieldName];
		if (!typeField) {
			context.reportError(`Interface field ${iface.name}.${fieldName} expected but ${type.name} does not provide it.`, [
				ifaceField.astNode,
				type.astNode,
				...type.extensionASTNodes
			]);
			continue;
		}
		if (!isTypeSubTypeOf(context.schema, typeField.type, ifaceField.type)) {
			var _ifaceField$astNode, _typeField$astNode;
			context.reportError(`Interface field ${iface.name}.${fieldName} expects type ${inspect(ifaceField.type)} but ${type.name}.${fieldName} is type ${inspect(typeField.type)}.`, [(_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type, (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type]);
		}
		for (const ifaceArg of ifaceField.args) {
			const argName = ifaceArg.name;
			const typeArg = typeField.args.find((arg) => arg.name === argName);
			if (!typeArg) {
				context.reportError(`Interface field argument ${iface.name}.${fieldName}(${argName}:) expected but ${type.name}.${fieldName} does not provide it.`, [ifaceArg.astNode, typeField.astNode]);
				continue;
			}
			if (!isEqualType(ifaceArg.type, typeArg.type)) {
				var _ifaceArg$astNode, _typeArg$astNode;
				context.reportError(`Interface field argument ${iface.name}.${fieldName}(${argName}:) expects type ${inspect(ifaceArg.type)} but ${type.name}.${fieldName}(${argName}:) is type ${inspect(typeArg.type)}.`, [(_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type, (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type]);
			}
		}
		for (const typeArg of typeField.args) {
			const argName = typeArg.name;
			if (!ifaceField.args.find((arg) => arg.name === argName) && isRequiredArgument(typeArg)) context.reportError(`Object field ${type.name}.${fieldName} includes required argument ${argName} that is missing from the Interface field ${iface.name}.${fieldName}.`, [typeArg.astNode, ifaceField.astNode]);
		}
	}
}
function validateTypeImplementsAncestors(context, type, iface) {
	const ifaceInterfaces = type.getInterfaces();
	for (const transitive of iface.getInterfaces()) if (!ifaceInterfaces.includes(transitive)) context.reportError(transitive === type ? `Type ${type.name} cannot implement ${iface.name} because it would create a circular reference.` : `Type ${type.name} must implement ${transitive.name} because it is implemented by ${iface.name}.`, [...getAllImplementsInterfaceNodes(iface, transitive), ...getAllImplementsInterfaceNodes(type, iface)]);
}
function validateUnionMembers(context, union) {
	const memberTypes = union.getTypes();
	if (memberTypes.length === 0) context.reportError(`Union type ${union.name} must define one or more member types.`, [union.astNode, ...union.extensionASTNodes]);
	const includedTypeNames = Object.create(null);
	for (const memberType of memberTypes) {
		if (includedTypeNames[memberType.name]) {
			context.reportError(`Union type ${union.name} can only include type ${memberType.name} once.`, getUnionMemberTypeNodes(union, memberType.name));
			continue;
		}
		includedTypeNames[memberType.name] = true;
		if (!isObjectType(memberType)) context.reportError(`Union type ${union.name} can only include Object types, it cannot include ${inspect(memberType)}.`, getUnionMemberTypeNodes(union, String(memberType)));
	}
}
function validateEnumValues(context, enumType) {
	const enumValues = enumType.getValues();
	if (enumValues.length === 0) context.reportError(`Enum type ${enumType.name} must define one or more values.`, [enumType.astNode, ...enumType.extensionASTNodes]);
	for (const enumValue of enumValues) validateName(context, enumValue);
}
function validateInputFields(context, inputObj) {
	const fields = Object.values(inputObj.getFields());
	if (fields.length === 0) context.reportError(`Input Object type ${inputObj.name} must define one or more fields.`, [inputObj.astNode, ...inputObj.extensionASTNodes]);
	for (const field of fields) {
		validateName(context, field);
		if (!isInputType(field.type)) {
			var _field$astNode2;
			context.reportError(`The type of ${inputObj.name}.${field.name} must be Input Type but got: ${inspect(field.type)}.`, (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
		}
		if (isRequiredInputField(field) && field.deprecationReason != null) {
			var _field$astNode3;
			context.reportError(`Required input field ${inputObj.name}.${field.name} cannot be deprecated.`, [getDeprecatedDirectiveNode(field.astNode), (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type]);
		}
	}
}
function createInputObjectCircularRefsValidator(context) {
	const visitedTypes = Object.create(null);
	const fieldPath = [];
	const fieldPathIndexByTypeName = Object.create(null);
	return detectCycleRecursive;
	function detectCycleRecursive(inputObj) {
		if (visitedTypes[inputObj.name]) return;
		visitedTypes[inputObj.name] = true;
		fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
		const fields = Object.values(inputObj.getFields());
		for (const field of fields) if (isNonNullType(field.type) && isInputObjectType(field.type.ofType)) {
			const fieldType = field.type.ofType;
			const cycleIndex = fieldPathIndexByTypeName[fieldType.name];
			fieldPath.push(field);
			if (cycleIndex === void 0) detectCycleRecursive(fieldType);
			else {
				const cyclePath = fieldPath.slice(cycleIndex);
				const pathStr = cyclePath.map((fieldObj) => fieldObj.name).join(".");
				context.reportError(`Cannot reference Input Object "${fieldType.name}" within itself through a series of non-null fields: "${pathStr}".`, cyclePath.map((fieldObj) => fieldObj.astNode));
			}
			fieldPath.pop();
		}
		fieldPathIndexByTypeName[inputObj.name] = void 0;
	}
}
function getAllImplementsInterfaceNodes(type, iface) {
	const { astNode, extensionASTNodes } = type;
	return (astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes).flatMap((typeNode) => {
		var _typeNode$interfaces;
		return (_typeNode$interfaces = typeNode.interfaces) !== null && _typeNode$interfaces !== void 0 ? _typeNode$interfaces : [];
	}).filter((ifaceNode) => ifaceNode.name.value === iface.name);
}
function getUnionMemberTypeNodes(union, typeName) {
	const { astNode, extensionASTNodes } = union;
	return (astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes).flatMap((unionNode) => {
		var _unionNode$types;
		return (_unionNode$types = unionNode.types) !== null && _unionNode$types !== void 0 ? _unionNode$types : [];
	}).filter((typeNode) => typeNode.name.value === typeName);
}
function getDeprecatedDirectiveNode(definitionNode) {
	var _definitionNode$direc;
	return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find((node) => node.name.value === GraphQLDeprecatedDirective.name);
}
var SchemaValidationContext;
var init_validate$1 = __esmMin((() => {
	init_inspect();
	init_GraphQLError();
	init_ast();
	init_typeComparators();
	init_definition();
	init_directives();
	init_introspection();
	init_schema();
	SchemaValidationContext = class {
		constructor(schema) {
			this._errors = [];
			this.schema = schema;
		}
		reportError(message, nodes) {
			const _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
			this._errors.push(new GraphQLError(message, { nodes: _nodes }));
		}
		getErrors() {
			return this._errors;
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/utilities/typeFromAST.mjs
function typeFromAST(schema, typeNode) {
	switch (typeNode.kind) {
		case Kind.LIST_TYPE: {
			const innerType = typeFromAST(schema, typeNode.type);
			return innerType && new GraphQLList(innerType);
		}
		case Kind.NON_NULL_TYPE: {
			const innerType = typeFromAST(schema, typeNode.type);
			return innerType && new GraphQLNonNull(innerType);
		}
		case Kind.NAMED_TYPE: return schema.getType(typeNode.name.value);
	}
}
var init_typeFromAST = __esmMin((() => {
	init_kinds();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/TypeInfo.mjs
/**
* Not exactly the same as the executor's definition of getFieldDef, in this
* statically evaluated environment we do not always have an Object type,
* and need to handle Interface and Union types.
*/
function getFieldDef$1(schema, parentType, fieldNode) {
	const name = fieldNode.name.value;
	if (name === SchemaMetaFieldDef.name && schema.getQueryType() === parentType) return SchemaMetaFieldDef;
	if (name === TypeMetaFieldDef.name && schema.getQueryType() === parentType) return TypeMetaFieldDef;
	if (name === TypeNameMetaFieldDef.name && isCompositeType(parentType)) return TypeNameMetaFieldDef;
	if (isObjectType(parentType) || isInterfaceType(parentType)) return parentType.getFields()[name];
}
/**
* Creates a new visitor instance which maintains a provided TypeInfo instance
* along with visiting visitor.
*/
function visitWithTypeInfo(typeInfo, visitor) {
	return {
		enter(...args) {
			const node = args[0];
			typeInfo.enter(node);
			const fn = getEnterLeaveForKind(visitor, node.kind).enter;
			if (fn) {
				const result = fn.apply(visitor, args);
				if (result !== void 0) {
					typeInfo.leave(node);
					if (isNode$2(result)) typeInfo.enter(result);
				}
				return result;
			}
		},
		leave(...args) {
			const node = args[0];
			const fn = getEnterLeaveForKind(visitor, node.kind).leave;
			let result;
			if (fn) result = fn.apply(visitor, args);
			typeInfo.leave(node);
			return result;
		}
	};
}
var TypeInfo;
var init_TypeInfo = __esmMin((() => {
	init_ast();
	init_kinds();
	init_visitor();
	init_definition();
	init_introspection();
	init_typeFromAST();
	TypeInfo = class {
		constructor(schema, initialType, getFieldDefFn) {
			this._schema = schema;
			this._typeStack = [];
			this._parentTypeStack = [];
			this._inputTypeStack = [];
			this._fieldDefStack = [];
			this._defaultValueStack = [];
			this._directive = null;
			this._argument = null;
			this._enumValue = null;
			this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : getFieldDef$1;
			if (initialType) {
				if (isInputType(initialType)) this._inputTypeStack.push(initialType);
				if (isCompositeType(initialType)) this._parentTypeStack.push(initialType);
				if (isOutputType(initialType)) this._typeStack.push(initialType);
			}
		}
		get [Symbol.toStringTag]() {
			return "TypeInfo";
		}
		getType() {
			if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
		}
		getParentType() {
			if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
		}
		getInputType() {
			if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
		}
		getParentInputType() {
			if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
		}
		getFieldDef() {
			if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
		}
		getDefaultValue() {
			if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
		}
		getDirective() {
			return this._directive;
		}
		getArgument() {
			return this._argument;
		}
		getEnumValue() {
			return this._enumValue;
		}
		enter(node) {
			const schema = this._schema;
			switch (node.kind) {
				case Kind.SELECTION_SET: {
					const namedType = getNamedType(this.getType());
					this._parentTypeStack.push(isCompositeType(namedType) ? namedType : void 0);
					break;
				}
				case Kind.FIELD: {
					const parentType = this.getParentType();
					let fieldDef;
					let fieldType;
					if (parentType) {
						fieldDef = this._getFieldDef(schema, parentType, node);
						if (fieldDef) fieldType = fieldDef.type;
					}
					this._fieldDefStack.push(fieldDef);
					this._typeStack.push(isOutputType(fieldType) ? fieldType : void 0);
					break;
				}
				case Kind.DIRECTIVE:
					this._directive = schema.getDirective(node.name.value);
					break;
				case Kind.OPERATION_DEFINITION: {
					const rootType = schema.getRootType(node.operation);
					this._typeStack.push(isObjectType(rootType) ? rootType : void 0);
					break;
				}
				case Kind.INLINE_FRAGMENT:
				case Kind.FRAGMENT_DEFINITION: {
					const typeConditionAST = node.typeCondition;
					const outputType = typeConditionAST ? typeFromAST(schema, typeConditionAST) : getNamedType(this.getType());
					this._typeStack.push(isOutputType(outputType) ? outputType : void 0);
					break;
				}
				case Kind.VARIABLE_DEFINITION: {
					const inputType = typeFromAST(schema, node.type);
					this._inputTypeStack.push(isInputType(inputType) ? inputType : void 0);
					break;
				}
				case Kind.ARGUMENT: {
					var _this$getDirective;
					let argDef;
					let argType;
					const fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
					if (fieldOrDirective) {
						argDef = fieldOrDirective.args.find((arg) => arg.name === node.name.value);
						if (argDef) argType = argDef.type;
					}
					this._argument = argDef;
					this._defaultValueStack.push(argDef ? argDef.defaultValue : void 0);
					this._inputTypeStack.push(isInputType(argType) ? argType : void 0);
					break;
				}
				case Kind.LIST: {
					const listType = getNullableType(this.getInputType());
					const itemType = isListType(listType) ? listType.ofType : listType;
					this._defaultValueStack.push(void 0);
					this._inputTypeStack.push(isInputType(itemType) ? itemType : void 0);
					break;
				}
				case Kind.OBJECT_FIELD: {
					const objectType = getNamedType(this.getInputType());
					let inputFieldType;
					let inputField;
					if (isInputObjectType(objectType)) {
						inputField = objectType.getFields()[node.name.value];
						if (inputField) inputFieldType = inputField.type;
					}
					this._defaultValueStack.push(inputField ? inputField.defaultValue : void 0);
					this._inputTypeStack.push(isInputType(inputFieldType) ? inputFieldType : void 0);
					break;
				}
				case Kind.ENUM: {
					const enumType = getNamedType(this.getInputType());
					let enumValue;
					if (isEnumType(enumType)) enumValue = enumType.getValue(node.value);
					this._enumValue = enumValue;
					break;
				}
			}
		}
		leave(node) {
			switch (node.kind) {
				case Kind.SELECTION_SET:
					this._parentTypeStack.pop();
					break;
				case Kind.FIELD:
					this._fieldDefStack.pop();
					this._typeStack.pop();
					break;
				case Kind.DIRECTIVE:
					this._directive = null;
					break;
				case Kind.OPERATION_DEFINITION:
				case Kind.INLINE_FRAGMENT:
				case Kind.FRAGMENT_DEFINITION:
					this._typeStack.pop();
					break;
				case Kind.VARIABLE_DEFINITION:
					this._inputTypeStack.pop();
					break;
				case Kind.ARGUMENT:
					this._argument = null;
					this._defaultValueStack.pop();
					this._inputTypeStack.pop();
					break;
				case Kind.LIST:
				case Kind.OBJECT_FIELD:
					this._defaultValueStack.pop();
					this._inputTypeStack.pop();
					break;
				case Kind.ENUM: this._enumValue = null;
			}
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/language/predicates.mjs
function isDefinitionNode(node) {
	return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
	return node.kind === Kind.OPERATION_DEFINITION || node.kind === Kind.FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
	return node.kind === Kind.FIELD || node.kind === Kind.FRAGMENT_SPREAD || node.kind === Kind.INLINE_FRAGMENT;
}
function isValueNode(node) {
	return node.kind === Kind.VARIABLE || node.kind === Kind.INT || node.kind === Kind.FLOAT || node.kind === Kind.STRING || node.kind === Kind.BOOLEAN || node.kind === Kind.NULL || node.kind === Kind.ENUM || node.kind === Kind.LIST || node.kind === Kind.OBJECT;
}
function isConstValueNode(node) {
	return isValueNode(node) && (node.kind === Kind.LIST ? node.values.some(isConstValueNode) : node.kind === Kind.OBJECT ? node.fields.some((field) => isConstValueNode(field.value)) : node.kind !== Kind.VARIABLE);
}
function isTypeNode(node) {
	return node.kind === Kind.NAMED_TYPE || node.kind === Kind.LIST_TYPE || node.kind === Kind.NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
	return node.kind === Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === Kind.DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
	return node.kind === Kind.SCALAR_TYPE_DEFINITION || node.kind === Kind.OBJECT_TYPE_DEFINITION || node.kind === Kind.INTERFACE_TYPE_DEFINITION || node.kind === Kind.UNION_TYPE_DEFINITION || node.kind === Kind.ENUM_TYPE_DEFINITION || node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
	return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
	return node.kind === Kind.SCALAR_TYPE_EXTENSION || node.kind === Kind.OBJECT_TYPE_EXTENSION || node.kind === Kind.INTERFACE_TYPE_EXTENSION || node.kind === Kind.UNION_TYPE_EXTENSION || node.kind === Kind.ENUM_TYPE_EXTENSION || node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION;
}
var init_predicates = __esmMin((() => {
	init_kinds();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/ExecutableDefinitionsRule.mjs
/**
* Executable definitions
*
* A GraphQL document is only valid for execution if all definitions are either
* operation or fragment definitions.
*
* See https://spec.graphql.org/draft/#sec-Executable-Definitions
*/
function ExecutableDefinitionsRule(context) {
	return { Document(node) {
		for (const definition of node.definitions) if (!isExecutableDefinitionNode(definition)) {
			const defName = definition.kind === Kind.SCHEMA_DEFINITION || definition.kind === Kind.SCHEMA_EXTENSION ? "schema" : "\"" + definition.name.value + "\"";
			context.reportError(new GraphQLError(`The ${defName} definition is not executable.`, { nodes: definition }));
		}
		return false;
	} };
}
var init_ExecutableDefinitionsRule = __esmMin((() => {
	init_GraphQLError();
	init_kinds();
	init_predicates();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/FieldsOnCorrectTypeRule.mjs
/**
* Fields on correct type
*
* A GraphQL document is only valid if all fields selected are defined by the
* parent type, or are an allowed meta field such as __typename.
*
* See https://spec.graphql.org/draft/#sec-Field-Selections
*/
function FieldsOnCorrectTypeRule(context) {
	return { Field(node) {
		const type = context.getParentType();
		if (type) {
			if (!context.getFieldDef()) {
				const schema = context.getSchema();
				const fieldName = node.name.value;
				let suggestion = didYouMean("to use an inline fragment on", getSuggestedTypeNames(schema, type, fieldName));
				if (suggestion === "") suggestion = didYouMean(getSuggestedFieldNames(type, fieldName));
				context.reportError(new GraphQLError(`Cannot query field "${fieldName}" on type "${type.name}".` + suggestion, { nodes: node }));
			}
		}
	} };
}
/**
* Go through all of the implementations of type, as well as the interfaces that
* they implement. If any of those types include the provided field, suggest them,
* sorted by how often the type is referenced.
*/
function getSuggestedTypeNames(schema, type, fieldName) {
	if (!isAbstractType(type)) return [];
	const suggestedTypes = /* @__PURE__ */ new Set();
	const usageCount = Object.create(null);
	for (const possibleType of schema.getPossibleTypes(type)) {
		if (!possibleType.getFields()[fieldName]) continue;
		suggestedTypes.add(possibleType);
		usageCount[possibleType.name] = 1;
		for (const possibleInterface of possibleType.getInterfaces()) {
			var _usageCount$possibleI;
			if (!possibleInterface.getFields()[fieldName]) continue;
			suggestedTypes.add(possibleInterface);
			usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
		}
	}
	return [...suggestedTypes].sort((typeA, typeB) => {
		const usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
		if (usageCountDiff !== 0) return usageCountDiff;
		if (isInterfaceType(typeA) && schema.isSubType(typeA, typeB)) return -1;
		if (isInterfaceType(typeB) && schema.isSubType(typeB, typeA)) return 1;
		return naturalCompare(typeA.name, typeB.name);
	}).map((x) => x.name);
}
/**
* For the field name provided, determine if there are any similar field names
* that may be the result of a typo.
*/
function getSuggestedFieldNames(type, fieldName) {
	if (isObjectType(type) || isInterfaceType(type)) return suggestionList(fieldName, Object.keys(type.getFields()));
	return [];
}
var init_FieldsOnCorrectTypeRule = __esmMin((() => {
	init_didYouMean();
	init_naturalCompare();
	init_suggestionList();
	init_GraphQLError();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/FragmentsOnCompositeTypesRule.mjs
/**
* Fragments on composite type
*
* Fragments use a type condition to determine if they apply, since fragments
* can only be spread into a composite type (object, interface, or union), the
* type condition must also be a composite type.
*
* See https://spec.graphql.org/draft/#sec-Fragments-On-Composite-Types
*/
function FragmentsOnCompositeTypesRule(context) {
	return {
		InlineFragment(node) {
			const typeCondition = node.typeCondition;
			if (typeCondition) {
				const type = typeFromAST(context.getSchema(), typeCondition);
				if (type && !isCompositeType(type)) {
					const typeStr = print(typeCondition);
					context.reportError(new GraphQLError(`Fragment cannot condition on non composite type "${typeStr}".`, { nodes: typeCondition }));
				}
			}
		},
		FragmentDefinition(node) {
			const type = typeFromAST(context.getSchema(), node.typeCondition);
			if (type && !isCompositeType(type)) {
				const typeStr = print(node.typeCondition);
				context.reportError(new GraphQLError(`Fragment "${node.name.value}" cannot condition on non composite type "${typeStr}".`, { nodes: node.typeCondition }));
			}
		}
	};
}
var init_FragmentsOnCompositeTypesRule = __esmMin((() => {
	init_GraphQLError();
	init_printer();
	init_definition();
	init_typeFromAST();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/KnownArgumentNamesRule.mjs
/**
* Known argument names
*
* A GraphQL field is only valid if all supplied arguments are defined by
* that field.
*
* See https://spec.graphql.org/draft/#sec-Argument-Names
* See https://spec.graphql.org/draft/#sec-Directives-Are-In-Valid-Locations
*/
function KnownArgumentNamesRule(context) {
	return {
		...KnownArgumentNamesOnDirectivesRule(context),
		Argument(argNode) {
			const argDef = context.getArgument();
			const fieldDef = context.getFieldDef();
			const parentType = context.getParentType();
			if (!argDef && fieldDef && parentType) {
				const argName = argNode.name.value;
				const suggestions = suggestionList(argName, fieldDef.args.map((arg) => arg.name));
				context.reportError(new GraphQLError(`Unknown argument "${argName}" on field "${parentType.name}.${fieldDef.name}".` + didYouMean(suggestions), { nodes: argNode }));
			}
		}
	};
}
/**
* @internal
*/
function KnownArgumentNamesOnDirectivesRule(context) {
	const directiveArgs = Object.create(null);
	const schema = context.getSchema();
	const definedDirectives = schema ? schema.getDirectives() : specifiedDirectives;
	for (const directive of definedDirectives) directiveArgs[directive.name] = directive.args.map((arg) => arg.name);
	const astDefinitions = context.getDocument().definitions;
	for (const def of astDefinitions) if (def.kind === Kind.DIRECTIVE_DEFINITION) {
		var _def$arguments;
		/* c8 ignore next */
		const argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
		directiveArgs[def.name.value] = argsNodes.map((arg) => arg.name.value);
	}
	return { Directive(directiveNode) {
		const directiveName = directiveNode.name.value;
		const knownArgs = directiveArgs[directiveName];
		if (directiveNode.arguments && knownArgs) for (const argNode of directiveNode.arguments) {
			const argName = argNode.name.value;
			if (!knownArgs.includes(argName)) {
				const suggestions = suggestionList(argName, knownArgs);
				context.reportError(new GraphQLError(`Unknown argument "${argName}" on directive "@${directiveName}".` + didYouMean(suggestions), { nodes: argNode }));
			}
		}
		return false;
	} };
}
var init_KnownArgumentNamesRule = __esmMin((() => {
	init_didYouMean();
	init_suggestionList();
	init_GraphQLError();
	init_kinds();
	init_directives();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/KnownDirectivesRule.mjs
/**
* Known directives
*
* A GraphQL document is only valid if all `@directives` are known by the
* schema and legally positioned.
*
* See https://spec.graphql.org/draft/#sec-Directives-Are-Defined
*/
function KnownDirectivesRule(context) {
	const locationsMap = Object.create(null);
	const schema = context.getSchema();
	const definedDirectives = schema ? schema.getDirectives() : specifiedDirectives;
	for (const directive of definedDirectives) locationsMap[directive.name] = directive.locations;
	const astDefinitions = context.getDocument().definitions;
	for (const def of astDefinitions) if (def.kind === Kind.DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map((name) => name.value);
	return { Directive(node, _key, _parent, _path, ancestors) {
		const name = node.name.value;
		const locations = locationsMap[name];
		if (!locations) {
			context.reportError(new GraphQLError(`Unknown directive "@${name}".`, { nodes: node }));
			return;
		}
		const candidateLocation = getDirectiveLocationForASTPath(ancestors);
		if (candidateLocation && !locations.includes(candidateLocation)) context.reportError(new GraphQLError(`Directive "@${name}" may not be used on ${candidateLocation}.`, { nodes: node }));
	} };
}
function getDirectiveLocationForASTPath(ancestors) {
	const appliedTo = ancestors[ancestors.length - 1];
	"kind" in appliedTo || invariant(false);
	switch (appliedTo.kind) {
		case Kind.OPERATION_DEFINITION: return getDirectiveLocationForOperation(appliedTo.operation);
		case Kind.FIELD: return DirectiveLocation.FIELD;
		case Kind.FRAGMENT_SPREAD: return DirectiveLocation.FRAGMENT_SPREAD;
		case Kind.INLINE_FRAGMENT: return DirectiveLocation.INLINE_FRAGMENT;
		case Kind.FRAGMENT_DEFINITION: return DirectiveLocation.FRAGMENT_DEFINITION;
		case Kind.VARIABLE_DEFINITION: return DirectiveLocation.VARIABLE_DEFINITION;
		case Kind.SCHEMA_DEFINITION:
		case Kind.SCHEMA_EXTENSION: return DirectiveLocation.SCHEMA;
		case Kind.SCALAR_TYPE_DEFINITION:
		case Kind.SCALAR_TYPE_EXTENSION: return DirectiveLocation.SCALAR;
		case Kind.OBJECT_TYPE_DEFINITION:
		case Kind.OBJECT_TYPE_EXTENSION: return DirectiveLocation.OBJECT;
		case Kind.FIELD_DEFINITION: return DirectiveLocation.FIELD_DEFINITION;
		case Kind.INTERFACE_TYPE_DEFINITION:
		case Kind.INTERFACE_TYPE_EXTENSION: return DirectiveLocation.INTERFACE;
		case Kind.UNION_TYPE_DEFINITION:
		case Kind.UNION_TYPE_EXTENSION: return DirectiveLocation.UNION;
		case Kind.ENUM_TYPE_DEFINITION:
		case Kind.ENUM_TYPE_EXTENSION: return DirectiveLocation.ENUM;
		case Kind.ENUM_VALUE_DEFINITION: return DirectiveLocation.ENUM_VALUE;
		case Kind.INPUT_OBJECT_TYPE_DEFINITION:
		case Kind.INPUT_OBJECT_TYPE_EXTENSION: return DirectiveLocation.INPUT_OBJECT;
		case Kind.INPUT_VALUE_DEFINITION: {
			const parentNode = ancestors[ancestors.length - 3];
			"kind" in parentNode || invariant(false);
			return parentNode.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION ? DirectiveLocation.INPUT_FIELD_DEFINITION : DirectiveLocation.ARGUMENT_DEFINITION;
		}
		/* c8 ignore next */
		default: invariant(false, "Unexpected kind: " + inspect(appliedTo.kind));
	}
}
function getDirectiveLocationForOperation(operation) {
	switch (operation) {
		case OperationTypeNode.QUERY: return DirectiveLocation.QUERY;
		case OperationTypeNode.MUTATION: return DirectiveLocation.MUTATION;
		case OperationTypeNode.SUBSCRIPTION: return DirectiveLocation.SUBSCRIPTION;
	}
}
var init_KnownDirectivesRule = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_GraphQLError();
	init_ast();
	init_directiveLocation();
	init_kinds();
	init_directives();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/KnownFragmentNamesRule.mjs
/**
* Known fragment names
*
* A GraphQL document is only valid if all `...Fragment` fragment spreads refer
* to fragments defined in the same document.
*
* See https://spec.graphql.org/draft/#sec-Fragment-spread-target-defined
*/
function KnownFragmentNamesRule(context) {
	return { FragmentSpread(node) {
		const fragmentName = node.name.value;
		if (!context.getFragment(fragmentName)) context.reportError(new GraphQLError(`Unknown fragment "${fragmentName}".`, { nodes: node.name }));
	} };
}
var init_KnownFragmentNamesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/KnownTypeNamesRule.mjs
/**
* Known type names
*
* A GraphQL document is only valid if referenced types (specifically
* variable definitions and fragment conditions) are defined by the type schema.
*
* See https://spec.graphql.org/draft/#sec-Fragment-Spread-Type-Existence
*/
function KnownTypeNamesRule(context) {
	const schema = context.getSchema();
	const existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
	const definedTypes = Object.create(null);
	for (const def of context.getDocument().definitions) if (isTypeDefinitionNode(def)) definedTypes[def.name.value] = true;
	const typeNames = [...Object.keys(existingTypesMap), ...Object.keys(definedTypes)];
	return { NamedType(node, _1, parent, _2, ancestors) {
		const typeName = node.name.value;
		if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
			var _ancestors$;
			const definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
			const isSDL = definitionNode != null && isSDLNode(definitionNode);
			if (isSDL && standardTypeNames.includes(typeName)) return;
			const suggestedTypes = suggestionList(typeName, isSDL ? standardTypeNames.concat(typeNames) : typeNames);
			context.reportError(new GraphQLError(`Unknown type "${typeName}".` + didYouMean(suggestedTypes), { nodes: node }));
		}
	} };
}
function isSDLNode(value) {
	return "kind" in value && (isTypeSystemDefinitionNode(value) || isTypeSystemExtensionNode(value));
}
var standardTypeNames;
var init_KnownTypeNamesRule = __esmMin((() => {
	init_didYouMean();
	init_suggestionList();
	init_GraphQLError();
	init_predicates();
	init_introspection();
	init_scalars();
	standardTypeNames = [...specifiedScalarTypes, ...introspectionTypes].map((type) => type.name);
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/LoneAnonymousOperationRule.mjs
/**
* Lone anonymous operation
*
* A GraphQL document is only valid if when it contains an anonymous operation
* (the query short-hand) that it contains only that one operation definition.
*
* See https://spec.graphql.org/draft/#sec-Lone-Anonymous-Operation
*/
function LoneAnonymousOperationRule(context) {
	let operationCount = 0;
	return {
		Document(node) {
			operationCount = node.definitions.filter((definition) => definition.kind === Kind.OPERATION_DEFINITION).length;
		},
		OperationDefinition(node) {
			if (!node.name && operationCount > 1) context.reportError(new GraphQLError("This anonymous operation must be the only defined operation.", { nodes: node }));
		}
	};
}
var init_LoneAnonymousOperationRule = __esmMin((() => {
	init_GraphQLError();
	init_kinds();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/LoneSchemaDefinitionRule.mjs
/**
* Lone Schema definition
*
* A GraphQL document is only valid if it contains only one schema definition.
*/
function LoneSchemaDefinitionRule(context) {
	var _ref, _ref2, _oldSchema$astNode;
	const oldSchema = context.getSchema();
	const alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
	let schemaDefinitionsCount = 0;
	return { SchemaDefinition(node) {
		if (alreadyDefined) {
			context.reportError(new GraphQLError("Cannot define a new schema within a schema extension.", { nodes: node }));
			return;
		}
		if (schemaDefinitionsCount > 0) context.reportError(new GraphQLError("Must provide only one schema definition.", { nodes: node }));
		++schemaDefinitionsCount;
	} };
}
var init_LoneSchemaDefinitionRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/NoFragmentCyclesRule.mjs
/**
* No fragment cycles
*
* The graph of fragment spreads must not form any cycles including spreading itself.
* Otherwise an operation could infinitely spread or infinitely execute on cycles in the underlying data.
*
* See https://spec.graphql.org/draft/#sec-Fragment-spreads-must-not-form-cycles
*/
function NoFragmentCyclesRule(context) {
	const visitedFrags = Object.create(null);
	const spreadPath = [];
	const spreadPathIndexByName = Object.create(null);
	return {
		OperationDefinition: () => false,
		FragmentDefinition(node) {
			detectCycleRecursive(node);
			return false;
		}
	};
	function detectCycleRecursive(fragment) {
		if (visitedFrags[fragment.name.value]) return;
		const fragmentName = fragment.name.value;
		visitedFrags[fragmentName] = true;
		const spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
		if (spreadNodes.length === 0) return;
		spreadPathIndexByName[fragmentName] = spreadPath.length;
		for (const spreadNode of spreadNodes) {
			const spreadName = spreadNode.name.value;
			const cycleIndex = spreadPathIndexByName[spreadName];
			spreadPath.push(spreadNode);
			if (cycleIndex === void 0) {
				const spreadFragment = context.getFragment(spreadName);
				if (spreadFragment) detectCycleRecursive(spreadFragment);
			} else {
				const cyclePath = spreadPath.slice(cycleIndex);
				const viaPath = cyclePath.slice(0, -1).map((s) => "\"" + s.name.value + "\"").join(", ");
				context.reportError(new GraphQLError(`Cannot spread fragment "${spreadName}" within itself` + (viaPath !== "" ? ` via ${viaPath}.` : "."), { nodes: cyclePath }));
			}
			spreadPath.pop();
		}
		spreadPathIndexByName[fragmentName] = void 0;
	}
}
var init_NoFragmentCyclesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/NoUndefinedVariablesRule.mjs
/**
* No undefined variables
*
* A GraphQL operation is only valid if all variables encountered, both directly
* and via fragment spreads, are defined by that operation.
*
* See https://spec.graphql.org/draft/#sec-All-Variable-Uses-Defined
*/
function NoUndefinedVariablesRule(context) {
	let variableNameDefined = Object.create(null);
	return {
		OperationDefinition: {
			enter() {
				variableNameDefined = Object.create(null);
			},
			leave(operation) {
				const usages = context.getRecursiveVariableUsages(operation);
				for (const { node } of usages) {
					const varName = node.name.value;
					if (variableNameDefined[varName] !== true) context.reportError(new GraphQLError(operation.name ? `Variable "$${varName}" is not defined by operation "${operation.name.value}".` : `Variable "$${varName}" is not defined.`, { nodes: [node, operation] }));
				}
			}
		},
		VariableDefinition(node) {
			variableNameDefined[node.variable.name.value] = true;
		}
	};
}
var init_NoUndefinedVariablesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/NoUnusedFragmentsRule.mjs
/**
* No unused fragments
*
* A GraphQL document is only valid if all fragment definitions are spread
* within operations, or spread within other fragments spread within operations.
*
* See https://spec.graphql.org/draft/#sec-Fragments-Must-Be-Used
*/
function NoUnusedFragmentsRule(context) {
	const operationDefs = [];
	const fragmentDefs = [];
	return {
		OperationDefinition(node) {
			operationDefs.push(node);
			return false;
		},
		FragmentDefinition(node) {
			fragmentDefs.push(node);
			return false;
		},
		Document: { leave() {
			const fragmentNameUsed = Object.create(null);
			for (const operation of operationDefs) for (const fragment of context.getRecursivelyReferencedFragments(operation)) fragmentNameUsed[fragment.name.value] = true;
			for (const fragmentDef of fragmentDefs) {
				const fragName = fragmentDef.name.value;
				if (fragmentNameUsed[fragName] !== true) context.reportError(new GraphQLError(`Fragment "${fragName}" is never used.`, { nodes: fragmentDef }));
			}
		} }
	};
}
var init_NoUnusedFragmentsRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/NoUnusedVariablesRule.mjs
/**
* No unused variables
*
* A GraphQL operation is only valid if all variables defined by an operation
* are used, either directly or within a spread fragment.
*
* See https://spec.graphql.org/draft/#sec-All-Variables-Used
*/
function NoUnusedVariablesRule(context) {
	let variableDefs = [];
	return {
		OperationDefinition: {
			enter() {
				variableDefs = [];
			},
			leave(operation) {
				const variableNameUsed = Object.create(null);
				const usages = context.getRecursiveVariableUsages(operation);
				for (const { node } of usages) variableNameUsed[node.name.value] = true;
				for (const variableDef of variableDefs) {
					const variableName = variableDef.variable.name.value;
					if (variableNameUsed[variableName] !== true) context.reportError(new GraphQLError(operation.name ? `Variable "$${variableName}" is never used in operation "${operation.name.value}".` : `Variable "$${variableName}" is never used.`, { nodes: variableDef }));
				}
			}
		},
		VariableDefinition(def) {
			variableDefs.push(def);
		}
	};
}
var init_NoUnusedVariablesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/sortValueNode.mjs
/**
* Sort ValueNode.
*
* This function returns a sorted copy of the given ValueNode.
*
* @internal
*/
function sortValueNode(valueNode) {
	switch (valueNode.kind) {
		case Kind.OBJECT: return {
			...valueNode,
			fields: sortFields(valueNode.fields)
		};
		case Kind.LIST: return {
			...valueNode,
			values: valueNode.values.map(sortValueNode)
		};
		case Kind.INT:
		case Kind.FLOAT:
		case Kind.STRING:
		case Kind.BOOLEAN:
		case Kind.NULL:
		case Kind.ENUM:
		case Kind.VARIABLE: return valueNode;
	}
}
function sortFields(fields) {
	return fields.map((fieldNode) => ({
		...fieldNode,
		value: sortValueNode(fieldNode.value)
	})).sort((fieldA, fieldB) => naturalCompare(fieldA.name.value, fieldB.name.value));
}
var init_sortValueNode = __esmMin((() => {
	init_naturalCompare();
	init_kinds();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/OverlappingFieldsCanBeMergedRule.mjs
function reasonMessage(reason) {
	if (Array.isArray(reason)) return reason.map(([responseName, subReason]) => `subfields "${responseName}" conflict because ` + reasonMessage(subReason)).join(" and ");
	return reason;
}
/**
* Overlapping fields can be merged
*
* A selection set is only valid if all fields (including spreading any
* fragments) either correspond to distinct response names or can be merged
* without ambiguity.
*
* See https://spec.graphql.org/draft/#sec-Field-Selection-Merging
*/
function OverlappingFieldsCanBeMergedRule(context) {
	const comparedFragmentPairs = new PairSet();
	const cachedFieldsAndFragmentNames = /* @__PURE__ */ new Map();
	return { SelectionSet(selectionSet) {
		const conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
		for (const [[responseName, reason], fields1, fields2] of conflicts) {
			const reasonMsg = reasonMessage(reason);
			context.reportError(new GraphQLError(`Fields "${responseName}" conflict because ${reasonMsg}. Use different aliases on the fields to fetch both if this was intentional.`, { nodes: fields1.concat(fields2) }));
		}
	} };
}
/**
* Algorithm:
*
* Conflicts occur when two fields exist in a query which will produce the same
* response name, but represent differing values, thus creating a conflict.
* The algorithm below finds all conflicts via making a series of comparisons
* between fields. In order to compare as few fields as possible, this makes
* a series of comparisons "within" sets of fields and "between" sets of fields.
*
* Given any selection set, a collection produces both a set of fields by
* also including all inline fragments, as well as a list of fragments
* referenced by fragment spreads.
*
* A) Each selection set represented in the document first compares "within" its
* collected set of fields, finding any conflicts between every pair of
* overlapping fields.
* Note: This is the *only time* that a the fields "within" a set are compared
* to each other. After this only fields "between" sets are compared.
*
* B) Also, if any fragment is referenced in a selection set, then a
* comparison is made "between" the original set of fields and the
* referenced fragment.
*
* C) Also, if multiple fragments are referenced, then comparisons
* are made "between" each referenced fragment.
*
* D) When comparing "between" a set of fields and a referenced fragment, first
* a comparison is made between each field in the original set of fields and
* each field in the the referenced set of fields.
*
* E) Also, if any fragment is referenced in the referenced selection set,
* then a comparison is made "between" the original set of fields and the
* referenced fragment (recursively referring to step D).
*
* F) When comparing "between" two fragments, first a comparison is made between
* each field in the first referenced set of fields and each field in the the
* second referenced set of fields.
*
* G) Also, any fragments referenced by the first must be compared to the
* second, and any fragments referenced by the second must be compared to the
* first (recursively referring to step F).
*
* H) When comparing two fields, if both have selection sets, then a comparison
* is made "between" both selection sets, first comparing the set of fields in
* the first selection set with the set of fields in the second.
*
* I) Also, if any fragment is referenced in either selection set, then a
* comparison is made "between" the other set of fields and the
* referenced fragment.
*
* J) Also, if two fragments are referenced in both selection sets, then a
* comparison is made "between" the two fragments.
*
*/
function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
	const conflicts = [];
	const [fieldMap, fragmentNames] = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet);
	collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
	if (fragmentNames.length !== 0) for (let i = 0; i < fragmentNames.length; i++) {
		collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]);
		for (let j = i + 1; j < fragmentNames.length; j++) collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
	}
	return conflicts;
}
function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
	const fragment = context.getFragment(fragmentName);
	if (!fragment) return;
	const [fieldMap2, referencedFragmentNames] = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment);
	if (fieldMap === fieldMap2) return;
	collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2);
	for (const referencedFragmentName of referencedFragmentNames) {
		if (comparedFragmentPairs.has(referencedFragmentName, fragmentName, areMutuallyExclusive)) continue;
		comparedFragmentPairs.add(referencedFragmentName, fragmentName, areMutuallyExclusive);
		collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, referencedFragmentName);
	}
}
function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
	if (fragmentName1 === fragmentName2) return;
	if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
	comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
	const fragment1 = context.getFragment(fragmentName1);
	const fragment2 = context.getFragment(fragmentName2);
	if (!fragment1 || !fragment2) return;
	const [fieldMap1, referencedFragmentNames1] = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1);
	const [fieldMap2, referencedFragmentNames2] = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2);
	collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2);
	for (const referencedFragmentName2 of referencedFragmentNames2) collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, referencedFragmentName2);
	for (const referencedFragmentName1 of referencedFragmentNames1) collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, referencedFragmentName1, fragmentName2);
}
function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
	const conflicts = [];
	const [fieldMap1, fragmentNames1] = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1);
	const [fieldMap2, fragmentNames2] = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2);
	collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2);
	for (const fragmentName2 of fragmentNames2) collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentName2);
	for (const fragmentName1 of fragmentNames1) collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentName1);
	for (const fragmentName1 of fragmentNames1) for (const fragmentName2 of fragmentNames2) collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2);
	return conflicts;
}
function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
	for (const [responseName, fields] of Object.entries(fieldMap)) if (fields.length > 1) for (let i = 0; i < fields.length; i++) for (let j = i + 1; j < fields.length; j++) {
		const conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
		if (conflict) conflicts.push(conflict);
	}
}
function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
	for (const [responseName, fields1] of Object.entries(fieldMap1)) {
		const fields2 = fieldMap2[responseName];
		if (fields2) for (const field1 of fields1) for (const field2 of fields2) {
			const conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2);
			if (conflict) conflicts.push(conflict);
		}
	}
}
function findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
	const [parentType1, node1, def1] = field1;
	const [parentType2, node2, def2] = field2;
	const areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && isObjectType(parentType1) && isObjectType(parentType2);
	if (!areMutuallyExclusive) {
		const name1 = node1.name.value;
		const name2 = node2.name.value;
		if (name1 !== name2) return [
			[responseName, `"${name1}" and "${name2}" are different fields`],
			[node1],
			[node2]
		];
		if (!sameArguments(node1, node2)) return [
			[responseName, "they have differing arguments"],
			[node1],
			[node2]
		];
	}
	const type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
	const type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
	if (type1 && type2 && doTypesConflict(type1, type2)) return [
		[responseName, `they return conflicting types "${inspect(type1)}" and "${inspect(type2)}"`],
		[node1],
		[node2]
	];
	const selectionSet1 = node1.selectionSet;
	const selectionSet2 = node2.selectionSet;
	if (selectionSet1 && selectionSet2) return subfieldConflicts(findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, getNamedType(type1), selectionSet1, getNamedType(type2), selectionSet2), responseName, node1, node2);
}
function sameArguments(node1, node2) {
	const args1 = node1.arguments;
	const args2 = node2.arguments;
	if (args1 === void 0 || args1.length === 0) return args2 === void 0 || args2.length === 0;
	if (args2 === void 0 || args2.length === 0) return false;
	/* c8 ignore next */
	if (args1.length !== args2.length)
 /* c8 ignore next */
	return false;
	const values2 = new Map(args2.map(({ name, value }) => [name.value, value]));
	return args1.every((arg1) => {
		const value1 = arg1.value;
		const value2 = values2.get(arg1.name.value);
		if (value2 === void 0) return false;
		return stringifyValue$1(value1) === stringifyValue$1(value2);
	});
}
function stringifyValue$1(value) {
	return print(sortValueNode(value));
}
function doTypesConflict(type1, type2) {
	if (isListType(type1)) return isListType(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
	if (isListType(type2)) return true;
	if (isNonNullType(type1)) return isNonNullType(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
	if (isNonNullType(type2)) return true;
	if (isLeafType(type1) || isLeafType(type2)) return type1 !== type2;
	return false;
}
function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
	const cached = cachedFieldsAndFragmentNames.get(selectionSet);
	if (cached) return cached;
	const nodeAndDefs = Object.create(null);
	const fragmentNames = Object.create(null);
	_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
	const result = [nodeAndDefs, Object.keys(fragmentNames)];
	cachedFieldsAndFragmentNames.set(selectionSet, result);
	return result;
}
function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
	const cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
	if (cached) return cached;
	return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, typeFromAST(context.getSchema(), fragment.typeCondition), fragment.selectionSet);
}
function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
	for (const selection of selectionSet.selections) switch (selection.kind) {
		case Kind.FIELD: {
			const fieldName = selection.name.value;
			let fieldDef;
			if (isObjectType(parentType) || isInterfaceType(parentType)) fieldDef = parentType.getFields()[fieldName];
			const responseName = selection.alias ? selection.alias.value : fieldName;
			if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
			nodeAndDefs[responseName].push([
				parentType,
				selection,
				fieldDef
			]);
			break;
		}
		case Kind.FRAGMENT_SPREAD:
			fragmentNames[selection.name.value] = true;
			break;
		case Kind.INLINE_FRAGMENT: {
			const typeCondition = selection.typeCondition;
			_collectFieldsAndFragmentNames(context, typeCondition ? typeFromAST(context.getSchema(), typeCondition) : parentType, selection.selectionSet, nodeAndDefs, fragmentNames);
			break;
		}
	}
}
function subfieldConflicts(conflicts, responseName, node1, node2) {
	if (conflicts.length > 0) return [
		[responseName, conflicts.map(([reason]) => reason)],
		[node1, ...conflicts.map(([, fields1]) => fields1).flat()],
		[node2, ...conflicts.map(([, , fields2]) => fields2).flat()]
	];
}
var PairSet;
var init_OverlappingFieldsCanBeMergedRule = __esmMin((() => {
	init_inspect();
	init_GraphQLError();
	init_kinds();
	init_printer();
	init_definition();
	init_sortValueNode();
	init_typeFromAST();
	PairSet = class {
		constructor() {
			this._data = /* @__PURE__ */ new Map();
		}
		has(a, b, areMutuallyExclusive) {
			var _this$_data$get;
			const [key1, key2] = a < b ? [a, b] : [b, a];
			const result = (_this$_data$get = this._data.get(key1)) === null || _this$_data$get === void 0 ? void 0 : _this$_data$get.get(key2);
			if (result === void 0) return false;
			return areMutuallyExclusive ? true : areMutuallyExclusive === result;
		}
		add(a, b, areMutuallyExclusive) {
			const [key1, key2] = a < b ? [a, b] : [b, a];
			const map = this._data.get(key1);
			if (map === void 0) this._data.set(key1, /* @__PURE__ */ new Map([[key2, areMutuallyExclusive]]));
			else map.set(key2, areMutuallyExclusive);
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/PossibleFragmentSpreadsRule.mjs
/**
* Possible fragment spread
*
* A fragment spread is only valid if the type condition could ever possibly
* be true: if there is a non-empty intersection of the possible parent types,
* and possible types which pass the type condition.
*/
function PossibleFragmentSpreadsRule(context) {
	return {
		InlineFragment(node) {
			const fragType = context.getType();
			const parentType = context.getParentType();
			if (isCompositeType(fragType) && isCompositeType(parentType) && !doTypesOverlap(context.getSchema(), fragType, parentType)) {
				const parentTypeStr = inspect(parentType);
				const fragTypeStr = inspect(fragType);
				context.reportError(new GraphQLError(`Fragment cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`, { nodes: node }));
			}
		},
		FragmentSpread(node) {
			const fragName = node.name.value;
			const fragType = getFragmentType(context, fragName);
			const parentType = context.getParentType();
			if (fragType && parentType && !doTypesOverlap(context.getSchema(), fragType, parentType)) {
				const parentTypeStr = inspect(parentType);
				const fragTypeStr = inspect(fragType);
				context.reportError(new GraphQLError(`Fragment "${fragName}" cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`, { nodes: node }));
			}
		}
	};
}
function getFragmentType(context, name) {
	const frag = context.getFragment(name);
	if (frag) {
		const type = typeFromAST(context.getSchema(), frag.typeCondition);
		if (isCompositeType(type)) return type;
	}
}
var init_PossibleFragmentSpreadsRule = __esmMin((() => {
	init_inspect();
	init_GraphQLError();
	init_definition();
	init_typeComparators();
	init_typeFromAST();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/PossibleTypeExtensionsRule.mjs
/**
* Possible type extension
*
* A type extension is only valid if the type is defined and has the same kind.
*/
function PossibleTypeExtensionsRule(context) {
	const schema = context.getSchema();
	const definedTypes = Object.create(null);
	for (const def of context.getDocument().definitions) if (isTypeDefinitionNode(def)) definedTypes[def.name.value] = def;
	return {
		ScalarTypeExtension: checkExtension,
		ObjectTypeExtension: checkExtension,
		InterfaceTypeExtension: checkExtension,
		UnionTypeExtension: checkExtension,
		EnumTypeExtension: checkExtension,
		InputObjectTypeExtension: checkExtension
	};
	function checkExtension(node) {
		const typeName = node.name.value;
		const defNode = definedTypes[typeName];
		const existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
		let expectedKind;
		if (defNode) expectedKind = defKindToExtKind[defNode.kind];
		else if (existingType) expectedKind = typeToExtKind(existingType);
		if (expectedKind) {
			if (expectedKind !== node.kind) {
				const kindStr = extensionKindToTypeName(node.kind);
				context.reportError(new GraphQLError(`Cannot extend non-${kindStr} type "${typeName}".`, { nodes: defNode ? [defNode, node] : node }));
			}
		} else {
			const suggestedTypes = suggestionList(typeName, Object.keys({
				...definedTypes,
				...schema === null || schema === void 0 ? void 0 : schema.getTypeMap()
			}));
			context.reportError(new GraphQLError(`Cannot extend type "${typeName}" because it is not defined.` + didYouMean(suggestedTypes), { nodes: node.name }));
		}
	}
}
function typeToExtKind(type) {
	if (isScalarType(type)) return Kind.SCALAR_TYPE_EXTENSION;
	if (isObjectType(type)) return Kind.OBJECT_TYPE_EXTENSION;
	if (isInterfaceType(type)) return Kind.INTERFACE_TYPE_EXTENSION;
	if (isUnionType(type)) return Kind.UNION_TYPE_EXTENSION;
	if (isEnumType(type)) return Kind.ENUM_TYPE_EXTENSION;
	if (isInputObjectType(type)) return Kind.INPUT_OBJECT_TYPE_EXTENSION;
	/* c8 ignore next 3 */
	invariant(false, "Unexpected type: " + inspect(type));
}
function extensionKindToTypeName(kind) {
	switch (kind) {
		case Kind.SCALAR_TYPE_EXTENSION: return "scalar";
		case Kind.OBJECT_TYPE_EXTENSION: return "object";
		case Kind.INTERFACE_TYPE_EXTENSION: return "interface";
		case Kind.UNION_TYPE_EXTENSION: return "union";
		case Kind.ENUM_TYPE_EXTENSION: return "enum";
		case Kind.INPUT_OBJECT_TYPE_EXTENSION: return "input object";
		/* c8 ignore next */
		default: invariant(false, "Unexpected kind: " + inspect(kind));
	}
}
var defKindToExtKind;
var init_PossibleTypeExtensionsRule = __esmMin((() => {
	init_didYouMean();
	init_inspect();
	init_invariant();
	init_suggestionList();
	init_GraphQLError();
	init_kinds();
	init_predicates();
	init_definition();
	defKindToExtKind = {
		[Kind.SCALAR_TYPE_DEFINITION]: Kind.SCALAR_TYPE_EXTENSION,
		[Kind.OBJECT_TYPE_DEFINITION]: Kind.OBJECT_TYPE_EXTENSION,
		[Kind.INTERFACE_TYPE_DEFINITION]: Kind.INTERFACE_TYPE_EXTENSION,
		[Kind.UNION_TYPE_DEFINITION]: Kind.UNION_TYPE_EXTENSION,
		[Kind.ENUM_TYPE_DEFINITION]: Kind.ENUM_TYPE_EXTENSION,
		[Kind.INPUT_OBJECT_TYPE_DEFINITION]: Kind.INPUT_OBJECT_TYPE_EXTENSION
	};
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/ProvidedRequiredArgumentsRule.mjs
/**
* Provided required arguments
*
* A field or directive is only valid if all required (non-null without a
* default value) field arguments have been provided.
*/
function ProvidedRequiredArgumentsRule(context) {
	return {
		...ProvidedRequiredArgumentsOnDirectivesRule(context),
		Field: { leave(fieldNode) {
			var _fieldNode$arguments;
			const fieldDef = context.getFieldDef();
			if (!fieldDef) return false;
			const providedArgs = new Set(
				/* c8 ignore next */
				(_fieldNode$arguments = fieldNode.arguments) === null || _fieldNode$arguments === void 0 ? void 0 : _fieldNode$arguments.map((arg) => arg.name.value)
			);
			for (const argDef of fieldDef.args) if (!providedArgs.has(argDef.name) && isRequiredArgument(argDef)) {
				const argTypeStr = inspect(argDef.type);
				context.reportError(new GraphQLError(`Field "${fieldDef.name}" argument "${argDef.name}" of type "${argTypeStr}" is required, but it was not provided.`, { nodes: fieldNode }));
			}
		} }
	};
}
/**
* @internal
*/
function ProvidedRequiredArgumentsOnDirectivesRule(context) {
	var _schema$getDirectives;
	const requiredArgsMap = Object.create(null);
	const schema = context.getSchema();
	const definedDirectives = (_schema$getDirectives = schema === null || schema === void 0 ? void 0 : schema.getDirectives()) !== null && _schema$getDirectives !== void 0 ? _schema$getDirectives : specifiedDirectives;
	for (const directive of definedDirectives) requiredArgsMap[directive.name] = keyMap(directive.args.filter(isRequiredArgument), (arg) => arg.name);
	const astDefinitions = context.getDocument().definitions;
	for (const def of astDefinitions) if (def.kind === Kind.DIRECTIVE_DEFINITION) {
		var _def$arguments;
		/* c8 ignore next */
		const argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
		requiredArgsMap[def.name.value] = keyMap(argNodes.filter(isRequiredArgumentNode), (arg) => arg.name.value);
	}
	return { Directive: { leave(directiveNode) {
		const directiveName = directiveNode.name.value;
		const requiredArgs = requiredArgsMap[directiveName];
		if (requiredArgs) {
			var _directiveNode$argume;
			/* c8 ignore next */
			const argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
			const argNodeMap = new Set(argNodes.map((arg) => arg.name.value));
			for (const [argName, argDef] of Object.entries(requiredArgs)) if (!argNodeMap.has(argName)) {
				const argType = isType(argDef.type) ? inspect(argDef.type) : print(argDef.type);
				context.reportError(new GraphQLError(`Directive "@${directiveName}" argument "${argName}" of type "${argType}" is required, but it was not provided.`, { nodes: directiveNode }));
			}
		}
	} } };
}
function isRequiredArgumentNode(arg) {
	return arg.type.kind === Kind.NON_NULL_TYPE && arg.defaultValue == null;
}
var init_ProvidedRequiredArgumentsRule = __esmMin((() => {
	init_inspect();
	init_keyMap();
	init_GraphQLError();
	init_kinds();
	init_printer();
	init_definition();
	init_directives();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/ScalarLeafsRule.mjs
/**
* Scalar leafs
*
* A GraphQL document is valid only if all leaf fields (fields without
* sub selections) are of scalar or enum types.
*/
function ScalarLeafsRule(context) {
	return { Field(node) {
		const type = context.getType();
		const selectionSet = node.selectionSet;
		if (type) {
			if (isLeafType(getNamedType(type))) {
				if (selectionSet) {
					const fieldName = node.name.value;
					const typeStr = inspect(type);
					context.reportError(new GraphQLError(`Field "${fieldName}" must not have a selection since type "${typeStr}" has no subfields.`, { nodes: selectionSet }));
				}
			} else if (!selectionSet) {
				const fieldName = node.name.value;
				const typeStr = inspect(type);
				context.reportError(new GraphQLError(`Field "${fieldName}" of type "${typeStr}" must have a selection of subfields. Did you mean "${fieldName} { ... }"?`, { nodes: node }));
			}
		}
	} };
}
var init_ScalarLeafsRule = __esmMin((() => {
	init_inspect();
	init_GraphQLError();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/printPathArray.mjs
/**
* Build a string describing the path.
*/
function printPathArray(path) {
	return path.map((key) => typeof key === "number" ? "[" + key.toString() + "]" : "." + key).join("");
}
var init_printPathArray = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/Path.mjs
/**
* Given a Path and a key, return a new Path containing the new key.
*/
function addPath(prev, key, typename) {
	return {
		prev,
		key,
		typename
	};
}
/**
* Given a Path, return an Array of the path keys.
*/
function pathToArray(path) {
	const flattened = [];
	let curr = path;
	while (curr) {
		flattened.push(curr.key);
		curr = curr.prev;
	}
	return flattened.reverse();
}
var init_Path = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/utilities/coerceInputValue.mjs
/**
* Coerces a JavaScript value given a GraphQL Input Type.
*/
function coerceInputValue(inputValue, type, onError = defaultOnError) {
	return coerceInputValueImpl(inputValue, type, onError, void 0);
}
function defaultOnError(path, invalidValue, error) {
	let errorPrefix = "Invalid value " + inspect(invalidValue);
	if (path.length > 0) errorPrefix += ` at "value${printPathArray(path)}"`;
	error.message = errorPrefix + ": " + error.message;
	throw error;
}
function coerceInputValueImpl(inputValue, type, onError, path) {
	if (isNonNullType(type)) {
		if (inputValue != null) return coerceInputValueImpl(inputValue, type.ofType, onError, path);
		onError(pathToArray(path), inputValue, new GraphQLError(`Expected non-nullable type "${inspect(type)}" not to be null.`));
		return;
	}
	if (inputValue == null) return null;
	if (isListType(type)) {
		const itemType = type.ofType;
		if (isIterableObject(inputValue)) return Array.from(inputValue, (itemValue, index) => {
			const itemPath = addPath(path, index, void 0);
			return coerceInputValueImpl(itemValue, itemType, onError, itemPath);
		});
		return [coerceInputValueImpl(inputValue, itemType, onError, path)];
	}
	if (isInputObjectType(type)) {
		if (!isObjectLike(inputValue)) {
			onError(pathToArray(path), inputValue, new GraphQLError(`Expected type "${type.name}" to be an object.`));
			return;
		}
		const coercedValue = {};
		const fieldDefs = type.getFields();
		for (const field of Object.values(fieldDefs)) {
			const fieldValue = inputValue[field.name];
			if (fieldValue === void 0) {
				if (field.defaultValue !== void 0) coercedValue[field.name] = field.defaultValue;
				else if (isNonNullType(field.type)) {
					const typeStr = inspect(field.type);
					onError(pathToArray(path), inputValue, new GraphQLError(`Field "${field.name}" of required type "${typeStr}" was not provided.`));
				}
				continue;
			}
			coercedValue[field.name] = coerceInputValueImpl(fieldValue, field.type, onError, addPath(path, field.name, type.name));
		}
		for (const fieldName of Object.keys(inputValue)) if (!fieldDefs[fieldName]) {
			const suggestions = suggestionList(fieldName, Object.keys(type.getFields()));
			onError(pathToArray(path), inputValue, new GraphQLError(`Field "${fieldName}" is not defined by type "${type.name}".` + didYouMean(suggestions)));
		}
		return coercedValue;
	}
	if (isLeafType(type)) {
		let parseResult;
		try {
			parseResult = type.parseValue(inputValue);
		} catch (error) {
			if (error instanceof GraphQLError) onError(pathToArray(path), inputValue, error);
			else onError(pathToArray(path), inputValue, new GraphQLError(`Expected type "${type.name}". ` + error.message, { originalError: error }));
			return;
		}
		if (parseResult === void 0) onError(pathToArray(path), inputValue, new GraphQLError(`Expected type "${type.name}".`));
		return parseResult;
	}
	/* c8 ignore next 3 */
	invariant(false, "Unexpected input type: " + inspect(type));
}
var init_coerceInputValue = __esmMin((() => {
	init_didYouMean();
	init_inspect();
	init_invariant();
	init_isIterableObject();
	init_isObjectLike();
	init_Path();
	init_printPathArray();
	init_suggestionList();
	init_GraphQLError();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/valueFromAST.mjs
/**
* Produces a JavaScript value given a GraphQL Value AST.
*
* A GraphQL type must be provided, which will be used to interpret different
* GraphQL Value literals.
*
* Returns `undefined` when the value could not be validly coerced according to
* the provided type.
*
* | GraphQL Value        | JSON Value    |
* | -------------------- | ------------- |
* | Input Object         | Object        |
* | List                 | Array         |
* | Boolean              | Boolean       |
* | String               | String        |
* | Int / Float          | Number        |
* | Enum Value           | Unknown       |
* | NullValue            | null          |
*
*/
function valueFromAST(valueNode, type, variables) {
	if (!valueNode) return;
	if (valueNode.kind === Kind.VARIABLE) {
		const variableName = valueNode.name.value;
		if (variables == null || variables[variableName] === void 0) return;
		const variableValue = variables[variableName];
		if (variableValue === null && isNonNullType(type)) return;
		return variableValue;
	}
	if (isNonNullType(type)) {
		if (valueNode.kind === Kind.NULL) return;
		return valueFromAST(valueNode, type.ofType, variables);
	}
	if (valueNode.kind === Kind.NULL) return null;
	if (isListType(type)) {
		const itemType = type.ofType;
		if (valueNode.kind === Kind.LIST) {
			const coercedValues = [];
			for (const itemNode of valueNode.values) if (isMissingVariable(itemNode, variables)) {
				if (isNonNullType(itemType)) return;
				coercedValues.push(null);
			} else {
				const itemValue = valueFromAST(itemNode, itemType, variables);
				if (itemValue === void 0) return;
				coercedValues.push(itemValue);
			}
			return coercedValues;
		}
		const coercedValue = valueFromAST(valueNode, itemType, variables);
		if (coercedValue === void 0) return;
		return [coercedValue];
	}
	if (isInputObjectType(type)) {
		if (valueNode.kind !== Kind.OBJECT) return;
		const coercedObj = Object.create(null);
		const fieldNodes = keyMap(valueNode.fields, (field) => field.name.value);
		for (const field of Object.values(type.getFields())) {
			const fieldNode = fieldNodes[field.name];
			if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
				if (field.defaultValue !== void 0) coercedObj[field.name] = field.defaultValue;
				else if (isNonNullType(field.type)) return;
				continue;
			}
			const fieldValue = valueFromAST(fieldNode.value, field.type, variables);
			if (fieldValue === void 0) return;
			coercedObj[field.name] = fieldValue;
		}
		return coercedObj;
	}
	if (isLeafType(type)) {
		let result;
		try {
			result = type.parseLiteral(valueNode, variables);
		} catch (_error) {
			return;
		}
		if (result === void 0) return;
		return result;
	}
	/* c8 ignore next 3 */
	invariant(false, "Unexpected input type: " + inspect(type));
}
function isMissingVariable(valueNode, variables) {
	return valueNode.kind === Kind.VARIABLE && (variables == null || variables[valueNode.name.value] === void 0);
}
var init_valueFromAST = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_keyMap();
	init_kinds();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/execution/values.mjs
/**
* Prepares an object map of variableValues of the correct type based on the
* provided variable definitions and arbitrary input. If the input cannot be
* parsed to match the variable definitions, a GraphQLError will be thrown.
*
* Note: The returned value is a plain Object with a prototype, since it is
* exposed to user code. Care should be taken to not pull values from the
* Object prototype.
*/
function getVariableValues(schema, varDefNodes, inputs, options) {
	const errors = [];
	const maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
	try {
		const coerced = coerceVariableValues(schema, varDefNodes, inputs, (error) => {
			if (maxErrors != null && errors.length >= maxErrors) throw new GraphQLError("Too many errors processing variables, error limit reached. Execution aborted.");
			errors.push(error);
		});
		if (errors.length === 0) return { coerced };
	} catch (error) {
		errors.push(error);
	}
	return { errors };
}
function coerceVariableValues(schema, varDefNodes, inputs, onError) {
	const coercedValues = {};
	for (const varDefNode of varDefNodes) {
		const varName = varDefNode.variable.name.value;
		const varType = typeFromAST(schema, varDefNode.type);
		if (!isInputType(varType)) {
			const varTypeStr = print(varDefNode.type);
			onError(new GraphQLError(`Variable "$${varName}" expected value of type "${varTypeStr}" which cannot be used as an input type.`, { nodes: varDefNode.type }));
			continue;
		}
		if (!hasOwnProperty$1(inputs, varName)) {
			if (varDefNode.defaultValue) coercedValues[varName] = valueFromAST(varDefNode.defaultValue, varType);
			else if (isNonNullType(varType)) {
				const varTypeStr = inspect(varType);
				onError(new GraphQLError(`Variable "$${varName}" of required type "${varTypeStr}" was not provided.`, { nodes: varDefNode }));
			}
			continue;
		}
		const value = inputs[varName];
		if (value === null && isNonNullType(varType)) {
			const varTypeStr = inspect(varType);
			onError(new GraphQLError(`Variable "$${varName}" of non-null type "${varTypeStr}" must not be null.`, { nodes: varDefNode }));
			continue;
		}
		coercedValues[varName] = coerceInputValue(value, varType, (path, invalidValue, error) => {
			let prefix = `Variable "$${varName}" got invalid value ` + inspect(invalidValue);
			if (path.length > 0) prefix += ` at "${varName}${printPathArray(path)}"`;
			onError(new GraphQLError(prefix + "; " + error.message, {
				nodes: varDefNode,
				originalError: error
			}));
		});
	}
	return coercedValues;
}
/**
* Prepares an object map of argument values given a list of argument
* definitions and list of argument AST nodes.
*
* Note: The returned value is a plain Object with a prototype, since it is
* exposed to user code. Care should be taken to not pull values from the
* Object prototype.
*/
function getArgumentValues(def, node, variableValues) {
	var _node$arguments;
	const coercedValues = {};
	const argNodeMap = keyMap((_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [], (arg) => arg.name.value);
	for (const argDef of def.args) {
		const name = argDef.name;
		const argType = argDef.type;
		const argumentNode = argNodeMap[name];
		if (!argumentNode) {
			if (argDef.defaultValue !== void 0) coercedValues[name] = argDef.defaultValue;
			else if (isNonNullType(argType)) throw new GraphQLError(`Argument "${name}" of required type "${inspect(argType)}" was not provided.`, { nodes: node });
			continue;
		}
		const valueNode = argumentNode.value;
		let isNull = valueNode.kind === Kind.NULL;
		if (valueNode.kind === Kind.VARIABLE) {
			const variableName = valueNode.name.value;
			if (variableValues == null || !hasOwnProperty$1(variableValues, variableName)) {
				if (argDef.defaultValue !== void 0) coercedValues[name] = argDef.defaultValue;
				else if (isNonNullType(argType)) throw new GraphQLError(`Argument "${name}" of required type "${inspect(argType)}" was provided the variable "$${variableName}" which was not provided a runtime value.`, { nodes: valueNode });
				continue;
			}
			isNull = variableValues[variableName] == null;
		}
		if (isNull && isNonNullType(argType)) throw new GraphQLError(`Argument "${name}" of non-null type "${inspect(argType)}" must not be null.`, { nodes: valueNode });
		const coercedValue = valueFromAST(valueNode, argType, variableValues);
		if (coercedValue === void 0) throw new GraphQLError(`Argument "${name}" has invalid value ${print(valueNode)}.`, { nodes: valueNode });
		coercedValues[name] = coercedValue;
	}
	return coercedValues;
}
/**
* Prepares an object map of argument values given a directive definition
* and a AST node which may contain directives. Optionally also accepts a map
* of variable values.
*
* If the directive does not exist on the node, returns undefined.
*
* Note: The returned value is a plain Object with a prototype, since it is
* exposed to user code. Care should be taken to not pull values from the
* Object prototype.
*/
function getDirectiveValues(directiveDef, node, variableValues) {
	var _node$directives;
	const directiveNode = (_node$directives = node.directives) === null || _node$directives === void 0 ? void 0 : _node$directives.find((directive) => directive.name.value === directiveDef.name);
	if (directiveNode) return getArgumentValues(directiveDef, directiveNode, variableValues);
}
function hasOwnProperty$1(obj, prop) {
	return Object.prototype.hasOwnProperty.call(obj, prop);
}
var init_values = __esmMin((() => {
	init_inspect();
	init_keyMap();
	init_printPathArray();
	init_GraphQLError();
	init_kinds();
	init_printer();
	init_definition();
	init_coerceInputValue();
	init_typeFromAST();
	init_valueFromAST();
}));
//#endregion
//#region ../../node_modules/graphql/execution/collectFields.mjs
/**
* Given a selectionSet, collects all of the fields and returns them.
*
* CollectFields requires the "runtime type" of an object. For a field that
* returns an Interface or Union type, the "runtime type" will be the actual
* object type returned by that field.
*
* @internal
*/
function collectFields(schema, fragments, variableValues, runtimeType, selectionSet) {
	const fields = /* @__PURE__ */ new Map();
	collectFieldsImpl(schema, fragments, variableValues, runtimeType, selectionSet, fields, /* @__PURE__ */ new Set());
	return fields;
}
/**
* Given an array of field nodes, collects all of the subfields of the passed
* in fields, and returns them at the end.
*
* CollectSubFields requires the "return type" of an object. For a field that
* returns an Interface or Union type, the "return type" will be the actual
* object type returned by that field.
*
* @internal
*/
function collectSubfields$1(schema, fragments, variableValues, returnType, fieldNodes) {
	const subFieldNodes = /* @__PURE__ */ new Map();
	const visitedFragmentNames = /* @__PURE__ */ new Set();
	for (const node of fieldNodes) if (node.selectionSet) collectFieldsImpl(schema, fragments, variableValues, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
	return subFieldNodes;
}
function collectFieldsImpl(schema, fragments, variableValues, runtimeType, selectionSet, fields, visitedFragmentNames) {
	for (const selection of selectionSet.selections) switch (selection.kind) {
		case Kind.FIELD: {
			if (!shouldIncludeNode(variableValues, selection)) continue;
			const name = getFieldEntryKey(selection);
			const fieldList = fields.get(name);
			if (fieldList !== void 0) fieldList.push(selection);
			else fields.set(name, [selection]);
			break;
		}
		case Kind.INLINE_FRAGMENT:
			if (!shouldIncludeNode(variableValues, selection) || !doesFragmentConditionMatch(schema, selection, runtimeType)) continue;
			collectFieldsImpl(schema, fragments, variableValues, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
			break;
		case Kind.FRAGMENT_SPREAD: {
			const fragName = selection.name.value;
			if (visitedFragmentNames.has(fragName) || !shouldIncludeNode(variableValues, selection)) continue;
			visitedFragmentNames.add(fragName);
			const fragment = fragments[fragName];
			if (!fragment || !doesFragmentConditionMatch(schema, fragment, runtimeType)) continue;
			collectFieldsImpl(schema, fragments, variableValues, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
			break;
		}
	}
}
/**
* Determines if a field should be included based on the `@include` and `@skip`
* directives, where `@skip` has higher precedence than `@include`.
*/
function shouldIncludeNode(variableValues, node) {
	const skip = getDirectiveValues(GraphQLSkipDirective, node, variableValues);
	if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
	const include = getDirectiveValues(GraphQLIncludeDirective, node, variableValues);
	if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
	return true;
}
/**
* Determines if a fragment is applicable to the given type.
*/
function doesFragmentConditionMatch(schema, fragment, type) {
	const typeConditionNode = fragment.typeCondition;
	if (!typeConditionNode) return true;
	const conditionalType = typeFromAST(schema, typeConditionNode);
	if (conditionalType === type) return true;
	if (isAbstractType(conditionalType)) return schema.isSubType(conditionalType, type);
	return false;
}
/**
* Implements the logic to compute the key of a given field's entry
*/
function getFieldEntryKey(node) {
	return node.alias ? node.alias.value : node.name.value;
}
var init_collectFields = __esmMin((() => {
	init_kinds();
	init_definition();
	init_directives();
	init_typeFromAST();
	init_values();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/SingleFieldSubscriptionsRule.mjs
/**
* Subscriptions must only include a non-introspection field.
*
* A GraphQL subscription is valid only if it contains a single root field and
* that root field is not an introspection field.
*
* See https://spec.graphql.org/draft/#sec-Single-root-field
*/
function SingleFieldSubscriptionsRule(context) {
	return { OperationDefinition(node) {
		if (node.operation === "subscription") {
			const schema = context.getSchema();
			const subscriptionType = schema.getSubscriptionType();
			if (subscriptionType) {
				const operationName = node.name ? node.name.value : null;
				const variableValues = Object.create(null);
				const document = context.getDocument();
				const fragments = Object.create(null);
				for (const definition of document.definitions) if (definition.kind === Kind.FRAGMENT_DEFINITION) fragments[definition.name.value] = definition;
				const fields = collectFields(schema, fragments, variableValues, subscriptionType, node.selectionSet);
				if (fields.size > 1) {
					const extraFieldSelections = [...fields.values()].slice(1).flat();
					context.reportError(new GraphQLError(operationName != null ? `Subscription "${operationName}" must select only one top level field.` : "Anonymous Subscription must select only one top level field.", { nodes: extraFieldSelections }));
				}
				for (const fieldNodes of fields.values()) if (fieldNodes[0].name.value.startsWith("__")) context.reportError(new GraphQLError(operationName != null ? `Subscription "${operationName}" must not select an introspection top level field.` : "Anonymous Subscription must not select an introspection top level field.", { nodes: fieldNodes }));
			}
		}
	} };
}
var init_SingleFieldSubscriptionsRule = __esmMin((() => {
	init_GraphQLError();
	init_kinds();
	init_collectFields();
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/groupBy.mjs
/**
* Groups array items into a Map, given a function to produce grouping key.
*/
function groupBy(list, keyFn) {
	const result = /* @__PURE__ */ new Map();
	for (const item of list) {
		const key = keyFn(item);
		const group = result.get(key);
		if (group === void 0) result.set(key, [item]);
		else group.push(item);
	}
	return result;
}
var init_groupBy = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueArgumentDefinitionNamesRule.mjs
/**
* Unique argument definition names
*
* A GraphQL Object or Interface type is only valid if all its fields have uniquely named arguments.
* A GraphQL Directive is only valid if all its arguments are uniquely named.
*/
function UniqueArgumentDefinitionNamesRule(context) {
	return {
		DirectiveDefinition(directiveNode) {
			var _directiveNode$argume;
			/* c8 ignore next */
			const argumentNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
			return checkArgUniqueness(`@${directiveNode.name.value}`, argumentNodes);
		},
		InterfaceTypeDefinition: checkArgUniquenessPerField,
		InterfaceTypeExtension: checkArgUniquenessPerField,
		ObjectTypeDefinition: checkArgUniquenessPerField,
		ObjectTypeExtension: checkArgUniquenessPerField
	};
	function checkArgUniquenessPerField(typeNode) {
		var _typeNode$fields;
		const typeName = typeNode.name.value;
		/* c8 ignore next */
		const fieldNodes = (_typeNode$fields = typeNode.fields) !== null && _typeNode$fields !== void 0 ? _typeNode$fields : [];
		for (const fieldDef of fieldNodes) {
			var _fieldDef$arguments;
			const fieldName = fieldDef.name.value;
			/* c8 ignore next */
			const argumentNodes = (_fieldDef$arguments = fieldDef.arguments) !== null && _fieldDef$arguments !== void 0 ? _fieldDef$arguments : [];
			checkArgUniqueness(`${typeName}.${fieldName}`, argumentNodes);
		}
		return false;
	}
	function checkArgUniqueness(parentName, argumentNodes) {
		const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);
		for (const [argName, argNodes] of seenArgs) if (argNodes.length > 1) context.reportError(new GraphQLError(`Argument "${parentName}(${argName}:)" can only be defined once.`, { nodes: argNodes.map((node) => node.name) }));
		return false;
	}
}
var init_UniqueArgumentDefinitionNamesRule = __esmMin((() => {
	init_groupBy();
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueArgumentNamesRule.mjs
/**
* Unique argument names
*
* A GraphQL field or directive is only valid if all supplied arguments are
* uniquely named.
*
* See https://spec.graphql.org/draft/#sec-Argument-Names
*/
function UniqueArgumentNamesRule(context) {
	return {
		Field: checkArgUniqueness,
		Directive: checkArgUniqueness
	};
	function checkArgUniqueness(parentNode) {
		var _parentNode$arguments;
		const seenArgs = groupBy((_parentNode$arguments = parentNode.arguments) !== null && _parentNode$arguments !== void 0 ? _parentNode$arguments : [], (arg) => arg.name.value);
		for (const [argName, argNodes] of seenArgs) if (argNodes.length > 1) context.reportError(new GraphQLError(`There can be only one argument named "${argName}".`, { nodes: argNodes.map((node) => node.name) }));
	}
}
var init_UniqueArgumentNamesRule = __esmMin((() => {
	init_groupBy();
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueDirectiveNamesRule.mjs
/**
* Unique directive names
*
* A GraphQL document is only valid if all defined directives have unique names.
*/
function UniqueDirectiveNamesRule(context) {
	const knownDirectiveNames = Object.create(null);
	const schema = context.getSchema();
	return { DirectiveDefinition(node) {
		const directiveName = node.name.value;
		if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
			context.reportError(new GraphQLError(`Directive "@${directiveName}" already exists in the schema. It cannot be redefined.`, { nodes: node.name }));
			return;
		}
		if (knownDirectiveNames[directiveName]) context.reportError(new GraphQLError(`There can be only one directive named "@${directiveName}".`, { nodes: [knownDirectiveNames[directiveName], node.name] }));
		else knownDirectiveNames[directiveName] = node.name;
		return false;
	} };
}
var init_UniqueDirectiveNamesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueDirectivesPerLocationRule.mjs
/**
* Unique directive names per location
*
* A GraphQL document is only valid if all non-repeatable directives at
* a given location are uniquely named.
*
* See https://spec.graphql.org/draft/#sec-Directives-Are-Unique-Per-Location
*/
function UniqueDirectivesPerLocationRule(context) {
	const uniqueDirectiveMap = Object.create(null);
	const schema = context.getSchema();
	const definedDirectives = schema ? schema.getDirectives() : specifiedDirectives;
	for (const directive of definedDirectives) uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
	const astDefinitions = context.getDocument().definitions;
	for (const def of astDefinitions) if (def.kind === Kind.DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
	const schemaDirectives = Object.create(null);
	const typeDirectivesMap = Object.create(null);
	return { enter(node) {
		if (!("directives" in node) || !node.directives) return;
		let seenDirectives;
		if (node.kind === Kind.SCHEMA_DEFINITION || node.kind === Kind.SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
		else if (isTypeDefinitionNode(node) || isTypeExtensionNode(node)) {
			const typeName = node.name.value;
			seenDirectives = typeDirectivesMap[typeName];
			if (seenDirectives === void 0) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
		} else seenDirectives = Object.create(null);
		for (const directive of node.directives) {
			const directiveName = directive.name.value;
			if (uniqueDirectiveMap[directiveName]) {
				if (seenDirectives[directiveName]) context.reportError(new GraphQLError(`The directive "@${directiveName}" can only be used once at this location.`, { nodes: [seenDirectives[directiveName], directive] }));
				else seenDirectives[directiveName] = directive;
			}
		}
	} };
}
var init_UniqueDirectivesPerLocationRule = __esmMin((() => {
	init_GraphQLError();
	init_kinds();
	init_predicates();
	init_directives();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueEnumValueNamesRule.mjs
/**
* Unique enum value names
*
* A GraphQL enum type is only valid if all its values are uniquely named.
*/
function UniqueEnumValueNamesRule(context) {
	const schema = context.getSchema();
	const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
	const knownValueNames = Object.create(null);
	return {
		EnumTypeDefinition: checkValueUniqueness,
		EnumTypeExtension: checkValueUniqueness
	};
	function checkValueUniqueness(node) {
		var _node$values;
		const typeName = node.name.value;
		if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
		/* c8 ignore next */
		const valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
		const valueNames = knownValueNames[typeName];
		for (const valueDef of valueNodes) {
			const valueName = valueDef.name.value;
			const existingType = existingTypeMap[typeName];
			if (isEnumType(existingType) && existingType.getValue(valueName)) context.reportError(new GraphQLError(`Enum value "${typeName}.${valueName}" already exists in the schema. It cannot also be defined in this type extension.`, { nodes: valueDef.name }));
			else if (valueNames[valueName]) context.reportError(new GraphQLError(`Enum value "${typeName}.${valueName}" can only be defined once.`, { nodes: [valueNames[valueName], valueDef.name] }));
			else valueNames[valueName] = valueDef.name;
		}
		return false;
	}
}
var init_UniqueEnumValueNamesRule = __esmMin((() => {
	init_GraphQLError();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueFieldDefinitionNamesRule.mjs
/**
* Unique field definition names
*
* A GraphQL complex type is only valid if all its fields are uniquely named.
*/
function UniqueFieldDefinitionNamesRule(context) {
	const schema = context.getSchema();
	const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
	const knownFieldNames = Object.create(null);
	return {
		InputObjectTypeDefinition: checkFieldUniqueness,
		InputObjectTypeExtension: checkFieldUniqueness,
		InterfaceTypeDefinition: checkFieldUniqueness,
		InterfaceTypeExtension: checkFieldUniqueness,
		ObjectTypeDefinition: checkFieldUniqueness,
		ObjectTypeExtension: checkFieldUniqueness
	};
	function checkFieldUniqueness(node) {
		var _node$fields;
		const typeName = node.name.value;
		if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
		/* c8 ignore next */
		const fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
		const fieldNames = knownFieldNames[typeName];
		for (const fieldDef of fieldNodes) {
			const fieldName = fieldDef.name.value;
			if (hasField(existingTypeMap[typeName], fieldName)) context.reportError(new GraphQLError(`Field "${typeName}.${fieldName}" already exists in the schema. It cannot also be defined in this type extension.`, { nodes: fieldDef.name }));
			else if (fieldNames[fieldName]) context.reportError(new GraphQLError(`Field "${typeName}.${fieldName}" can only be defined once.`, { nodes: [fieldNames[fieldName], fieldDef.name] }));
			else fieldNames[fieldName] = fieldDef.name;
		}
		return false;
	}
}
function hasField(type, fieldName) {
	if (isObjectType(type) || isInterfaceType(type) || isInputObjectType(type)) return type.getFields()[fieldName] != null;
	return false;
}
var init_UniqueFieldDefinitionNamesRule = __esmMin((() => {
	init_GraphQLError();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueFragmentNamesRule.mjs
/**
* Unique fragment names
*
* A GraphQL document is only valid if all defined fragments have unique names.
*
* See https://spec.graphql.org/draft/#sec-Fragment-Name-Uniqueness
*/
function UniqueFragmentNamesRule(context) {
	const knownFragmentNames = Object.create(null);
	return {
		OperationDefinition: () => false,
		FragmentDefinition(node) {
			const fragmentName = node.name.value;
			if (knownFragmentNames[fragmentName]) context.reportError(new GraphQLError(`There can be only one fragment named "${fragmentName}".`, { nodes: [knownFragmentNames[fragmentName], node.name] }));
			else knownFragmentNames[fragmentName] = node.name;
			return false;
		}
	};
}
var init_UniqueFragmentNamesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueInputFieldNamesRule.mjs
/**
* Unique input field names
*
* A GraphQL input object value is only valid if all supplied fields are
* uniquely named.
*
* See https://spec.graphql.org/draft/#sec-Input-Object-Field-Uniqueness
*/
function UniqueInputFieldNamesRule(context) {
	const knownNameStack = [];
	let knownNames = Object.create(null);
	return {
		ObjectValue: {
			enter() {
				knownNameStack.push(knownNames);
				knownNames = Object.create(null);
			},
			leave() {
				const prevKnownNames = knownNameStack.pop();
				prevKnownNames || invariant(false);
				knownNames = prevKnownNames;
			}
		},
		ObjectField(node) {
			const fieldName = node.name.value;
			if (knownNames[fieldName]) context.reportError(new GraphQLError(`There can be only one input field named "${fieldName}".`, { nodes: [knownNames[fieldName], node.name] }));
			else knownNames[fieldName] = node.name;
		}
	};
}
var init_UniqueInputFieldNamesRule = __esmMin((() => {
	init_invariant();
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueOperationNamesRule.mjs
/**
* Unique operation names
*
* A GraphQL document is only valid if all defined operations have unique names.
*
* See https://spec.graphql.org/draft/#sec-Operation-Name-Uniqueness
*/
function UniqueOperationNamesRule(context) {
	const knownOperationNames = Object.create(null);
	return {
		OperationDefinition(node) {
			const operationName = node.name;
			if (operationName) {
				if (knownOperationNames[operationName.value]) context.reportError(new GraphQLError(`There can be only one operation named "${operationName.value}".`, { nodes: [knownOperationNames[operationName.value], operationName] }));
				else knownOperationNames[operationName.value] = operationName;
			}
			return false;
		},
		FragmentDefinition: () => false
	};
}
var init_UniqueOperationNamesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueOperationTypesRule.mjs
/**
* Unique operation types
*
* A GraphQL document is only valid if it has only one type per operation.
*/
function UniqueOperationTypesRule(context) {
	const schema = context.getSchema();
	const definedOperationTypes = Object.create(null);
	const existingOperationTypes = schema ? {
		query: schema.getQueryType(),
		mutation: schema.getMutationType(),
		subscription: schema.getSubscriptionType()
	} : {};
	return {
		SchemaDefinition: checkOperationTypes,
		SchemaExtension: checkOperationTypes
	};
	function checkOperationTypes(node) {
		var _node$operationTypes;
		/* c8 ignore next */
		const operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
		for (const operationType of operationTypesNodes) {
			const operation = operationType.operation;
			const alreadyDefinedOperationType = definedOperationTypes[operation];
			if (existingOperationTypes[operation]) context.reportError(new GraphQLError(`Type for ${operation} already defined in the schema. It cannot be redefined.`, { nodes: operationType }));
			else if (alreadyDefinedOperationType) context.reportError(new GraphQLError(`There can be only one ${operation} type in schema.`, { nodes: [alreadyDefinedOperationType, operationType] }));
			else definedOperationTypes[operation] = operationType;
		}
		return false;
	}
}
var init_UniqueOperationTypesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueTypeNamesRule.mjs
/**
* Unique type names
*
* A GraphQL document is only valid if all defined types have unique names.
*/
function UniqueTypeNamesRule(context) {
	const knownTypeNames = Object.create(null);
	const schema = context.getSchema();
	return {
		ScalarTypeDefinition: checkTypeName,
		ObjectTypeDefinition: checkTypeName,
		InterfaceTypeDefinition: checkTypeName,
		UnionTypeDefinition: checkTypeName,
		EnumTypeDefinition: checkTypeName,
		InputObjectTypeDefinition: checkTypeName
	};
	function checkTypeName(node) {
		const typeName = node.name.value;
		if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
			context.reportError(new GraphQLError(`Type "${typeName}" already exists in the schema. It cannot also be defined in this type definition.`, { nodes: node.name }));
			return;
		}
		if (knownTypeNames[typeName]) context.reportError(new GraphQLError(`There can be only one type named "${typeName}".`, { nodes: [knownTypeNames[typeName], node.name] }));
		else knownTypeNames[typeName] = node.name;
		return false;
	}
}
var init_UniqueTypeNamesRule = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/UniqueVariableNamesRule.mjs
/**
* Unique variable names
*
* A GraphQL operation is only valid if all its variables are uniquely named.
*/
function UniqueVariableNamesRule(context) {
	return { OperationDefinition(operationNode) {
		var _operationNode$variab;
		const seenVariableDefinitions = groupBy((_operationNode$variab = operationNode.variableDefinitions) !== null && _operationNode$variab !== void 0 ? _operationNode$variab : [], (node) => node.variable.name.value);
		for (const [variableName, variableNodes] of seenVariableDefinitions) if (variableNodes.length > 1) context.reportError(new GraphQLError(`There can be only one variable named "$${variableName}".`, { nodes: variableNodes.map((node) => node.variable.name) }));
	} };
}
var init_UniqueVariableNamesRule = __esmMin((() => {
	init_groupBy();
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/ValuesOfCorrectTypeRule.mjs
/**
* Value literals of correct type
*
* A GraphQL document is only valid if all value literals are of the type
* expected at their position.
*
* See https://spec.graphql.org/draft/#sec-Values-of-Correct-Type
*/
function ValuesOfCorrectTypeRule(context) {
	return {
		ListValue(node) {
			if (!isListType(getNullableType(context.getParentInputType()))) {
				isValidValueNode(context, node);
				return false;
			}
		},
		ObjectValue(node) {
			const type = getNamedType(context.getInputType());
			if (!isInputObjectType(type)) {
				isValidValueNode(context, node);
				return false;
			}
			const fieldNodeMap = keyMap(node.fields, (field) => field.name.value);
			for (const fieldDef of Object.values(type.getFields())) if (!fieldNodeMap[fieldDef.name] && isRequiredInputField(fieldDef)) {
				const typeStr = inspect(fieldDef.type);
				context.reportError(new GraphQLError(`Field "${type.name}.${fieldDef.name}" of required type "${typeStr}" was not provided.`, { nodes: node }));
			}
		},
		ObjectField(node) {
			const parentType = getNamedType(context.getParentInputType());
			if (!context.getInputType() && isInputObjectType(parentType)) {
				const suggestions = suggestionList(node.name.value, Object.keys(parentType.getFields()));
				context.reportError(new GraphQLError(`Field "${node.name.value}" is not defined by type "${parentType.name}".` + didYouMean(suggestions), { nodes: node }));
			}
		},
		NullValue(node) {
			const type = context.getInputType();
			if (isNonNullType(type)) context.reportError(new GraphQLError(`Expected value of type "${inspect(type)}", found ${print(node)}.`, { nodes: node }));
		},
		EnumValue: (node) => isValidValueNode(context, node),
		IntValue: (node) => isValidValueNode(context, node),
		FloatValue: (node) => isValidValueNode(context, node),
		StringValue: (node) => isValidValueNode(context, node),
		BooleanValue: (node) => isValidValueNode(context, node)
	};
}
/**
* Any value literal may be a valid representation of a Scalar, depending on
* that scalar type.
*/
function isValidValueNode(context, node) {
	const locationType = context.getInputType();
	if (!locationType) return;
	const type = getNamedType(locationType);
	if (!isLeafType(type)) {
		const typeStr = inspect(locationType);
		context.reportError(new GraphQLError(`Expected value of type "${typeStr}", found ${print(node)}.`, { nodes: node }));
		return;
	}
	try {
		if (type.parseLiteral(node, void 0) === void 0) {
			const typeStr = inspect(locationType);
			context.reportError(new GraphQLError(`Expected value of type "${typeStr}", found ${print(node)}.`, { nodes: node }));
		}
	} catch (error) {
		const typeStr = inspect(locationType);
		if (error instanceof GraphQLError) context.reportError(error);
		else context.reportError(new GraphQLError(`Expected value of type "${typeStr}", found ${print(node)}; ` + error.message, {
			nodes: node,
			originalError: error
		}));
	}
}
var init_ValuesOfCorrectTypeRule = __esmMin((() => {
	init_didYouMean();
	init_inspect();
	init_keyMap();
	init_suggestionList();
	init_GraphQLError();
	init_printer();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/VariablesAreInputTypesRule.mjs
/**
* Variables are input types
*
* A GraphQL operation is only valid if all the variables it defines are of
* input types (scalar, enum, or input object).
*
* See https://spec.graphql.org/draft/#sec-Variables-Are-Input-Types
*/
function VariablesAreInputTypesRule(context) {
	return { VariableDefinition(node) {
		const type = typeFromAST(context.getSchema(), node.type);
		if (type !== void 0 && !isInputType(type)) {
			const variableName = node.variable.name.value;
			const typeName = print(node.type);
			context.reportError(new GraphQLError(`Variable "$${variableName}" cannot be non-input type "${typeName}".`, { nodes: node.type }));
		}
	} };
}
var init_VariablesAreInputTypesRule = __esmMin((() => {
	init_GraphQLError();
	init_printer();
	init_definition();
	init_typeFromAST();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/VariablesInAllowedPositionRule.mjs
/**
* Variables in allowed position
*
* Variable usages must be compatible with the arguments they are passed to.
*
* See https://spec.graphql.org/draft/#sec-All-Variable-Usages-are-Allowed
*/
function VariablesInAllowedPositionRule(context) {
	let varDefMap = Object.create(null);
	return {
		OperationDefinition: {
			enter() {
				varDefMap = Object.create(null);
			},
			leave(operation) {
				const usages = context.getRecursiveVariableUsages(operation);
				for (const { node, type, defaultValue } of usages) {
					const varName = node.name.value;
					const varDef = varDefMap[varName];
					if (varDef && type) {
						const schema = context.getSchema();
						const varType = typeFromAST(schema, varDef.type);
						if (varType && !allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
							const varTypeStr = inspect(varType);
							const typeStr = inspect(type);
							context.reportError(new GraphQLError(`Variable "$${varName}" of type "${varTypeStr}" used in position expecting type "${typeStr}".`, { nodes: [varDef, node] }));
						}
					}
				}
			}
		},
		VariableDefinition(node) {
			varDefMap[node.variable.name.value] = node;
		}
	};
}
/**
* Returns true if the variable is allowed in the location it was found,
* which includes considering if default values exist for either the variable
* or the location at which it is located.
*/
function allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
	if (isNonNullType(locationType) && !isNonNullType(varType)) {
		if (!(varDefaultValue != null && varDefaultValue.kind !== Kind.NULL) && !(locationDefaultValue !== void 0)) return false;
		const nullableLocationType = locationType.ofType;
		return isTypeSubTypeOf(schema, varType, nullableLocationType);
	}
	return isTypeSubTypeOf(schema, varType, locationType);
}
var init_VariablesInAllowedPositionRule = __esmMin((() => {
	init_inspect();
	init_GraphQLError();
	init_kinds();
	init_definition();
	init_typeComparators();
	init_typeFromAST();
}));
//#endregion
//#region ../../node_modules/graphql/validation/specifiedRules.mjs
var specifiedRules, specifiedSDLRules;
var init_specifiedRules = __esmMin((() => {
	init_ExecutableDefinitionsRule();
	init_FieldsOnCorrectTypeRule();
	init_FragmentsOnCompositeTypesRule();
	init_KnownArgumentNamesRule();
	init_KnownDirectivesRule();
	init_KnownFragmentNamesRule();
	init_KnownTypeNamesRule();
	init_LoneAnonymousOperationRule();
	init_LoneSchemaDefinitionRule();
	init_NoFragmentCyclesRule();
	init_NoUndefinedVariablesRule();
	init_NoUnusedFragmentsRule();
	init_NoUnusedVariablesRule();
	init_OverlappingFieldsCanBeMergedRule();
	init_PossibleFragmentSpreadsRule();
	init_PossibleTypeExtensionsRule();
	init_ProvidedRequiredArgumentsRule();
	init_ScalarLeafsRule();
	init_SingleFieldSubscriptionsRule();
	init_UniqueArgumentDefinitionNamesRule();
	init_UniqueArgumentNamesRule();
	init_UniqueDirectiveNamesRule();
	init_UniqueDirectivesPerLocationRule();
	init_UniqueEnumValueNamesRule();
	init_UniqueFieldDefinitionNamesRule();
	init_UniqueFragmentNamesRule();
	init_UniqueInputFieldNamesRule();
	init_UniqueOperationNamesRule();
	init_UniqueOperationTypesRule();
	init_UniqueTypeNamesRule();
	init_UniqueVariableNamesRule();
	init_ValuesOfCorrectTypeRule();
	init_VariablesAreInputTypesRule();
	init_VariablesInAllowedPositionRule();
	specifiedRules = Object.freeze([
		ExecutableDefinitionsRule,
		UniqueOperationNamesRule,
		LoneAnonymousOperationRule,
		SingleFieldSubscriptionsRule,
		KnownTypeNamesRule,
		FragmentsOnCompositeTypesRule,
		VariablesAreInputTypesRule,
		ScalarLeafsRule,
		FieldsOnCorrectTypeRule,
		UniqueFragmentNamesRule,
		KnownFragmentNamesRule,
		NoUnusedFragmentsRule,
		PossibleFragmentSpreadsRule,
		NoFragmentCyclesRule,
		UniqueVariableNamesRule,
		NoUndefinedVariablesRule,
		NoUnusedVariablesRule,
		KnownDirectivesRule,
		UniqueDirectivesPerLocationRule,
		KnownArgumentNamesRule,
		UniqueArgumentNamesRule,
		ValuesOfCorrectTypeRule,
		ProvidedRequiredArgumentsRule,
		VariablesInAllowedPositionRule,
		OverlappingFieldsCanBeMergedRule,
		UniqueInputFieldNamesRule
	]);
	specifiedSDLRules = Object.freeze([
		LoneSchemaDefinitionRule,
		UniqueOperationTypesRule,
		UniqueTypeNamesRule,
		UniqueEnumValueNamesRule,
		UniqueFieldDefinitionNamesRule,
		UniqueArgumentDefinitionNamesRule,
		UniqueDirectiveNamesRule,
		KnownTypeNamesRule,
		KnownDirectivesRule,
		UniqueDirectivesPerLocationRule,
		PossibleTypeExtensionsRule,
		KnownArgumentNamesOnDirectivesRule,
		UniqueArgumentNamesRule,
		UniqueInputFieldNamesRule,
		ProvidedRequiredArgumentsOnDirectivesRule
	]);
}));
//#endregion
//#region ../../node_modules/graphql/validation/ValidationContext.mjs
var ASTValidationContext, SDLValidationContext, ValidationContext;
var init_ValidationContext = __esmMin((() => {
	init_kinds();
	init_visitor();
	init_TypeInfo();
	ASTValidationContext = class {
		constructor(ast, onError) {
			this._ast = ast;
			this._fragments = void 0;
			this._fragmentSpreads = /* @__PURE__ */ new Map();
			this._recursivelyReferencedFragments = /* @__PURE__ */ new Map();
			this._onError = onError;
		}
		get [Symbol.toStringTag]() {
			return "ASTValidationContext";
		}
		reportError(error) {
			this._onError(error);
		}
		getDocument() {
			return this._ast;
		}
		getFragment(name) {
			let fragments;
			if (this._fragments) fragments = this._fragments;
			else {
				fragments = Object.create(null);
				for (const defNode of this.getDocument().definitions) if (defNode.kind === Kind.FRAGMENT_DEFINITION) fragments[defNode.name.value] = defNode;
				this._fragments = fragments;
			}
			return fragments[name];
		}
		getFragmentSpreads(node) {
			let spreads = this._fragmentSpreads.get(node);
			if (!spreads) {
				spreads = [];
				const setsToVisit = [node];
				let set;
				while (set = setsToVisit.pop()) for (const selection of set.selections) if (selection.kind === Kind.FRAGMENT_SPREAD) spreads.push(selection);
				else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
				this._fragmentSpreads.set(node, spreads);
			}
			return spreads;
		}
		getRecursivelyReferencedFragments(operation) {
			let fragments = this._recursivelyReferencedFragments.get(operation);
			if (!fragments) {
				fragments = [];
				const collectedNames = Object.create(null);
				const nodesToVisit = [operation.selectionSet];
				let node;
				while (node = nodesToVisit.pop()) for (const spread of this.getFragmentSpreads(node)) {
					const fragName = spread.name.value;
					if (collectedNames[fragName] !== true) {
						collectedNames[fragName] = true;
						const fragment = this.getFragment(fragName);
						if (fragment) {
							fragments.push(fragment);
							nodesToVisit.push(fragment.selectionSet);
						}
					}
				}
				this._recursivelyReferencedFragments.set(operation, fragments);
			}
			return fragments;
		}
	};
	SDLValidationContext = class extends ASTValidationContext {
		constructor(ast, schema, onError) {
			super(ast, onError);
			this._schema = schema;
		}
		get [Symbol.toStringTag]() {
			return "SDLValidationContext";
		}
		getSchema() {
			return this._schema;
		}
	};
	ValidationContext = class extends ASTValidationContext {
		constructor(schema, ast, typeInfo, onError) {
			super(ast, onError);
			this._schema = schema;
			this._typeInfo = typeInfo;
			this._variableUsages = /* @__PURE__ */ new Map();
			this._recursiveVariableUsages = /* @__PURE__ */ new Map();
		}
		get [Symbol.toStringTag]() {
			return "ValidationContext";
		}
		getSchema() {
			return this._schema;
		}
		getVariableUsages(node) {
			let usages = this._variableUsages.get(node);
			if (!usages) {
				const newUsages = [];
				const typeInfo = new TypeInfo(this._schema);
				visit(node, visitWithTypeInfo(typeInfo, {
					VariableDefinition: () => false,
					Variable(variable) {
						newUsages.push({
							node: variable,
							type: typeInfo.getInputType(),
							defaultValue: typeInfo.getDefaultValue()
						});
					}
				}));
				usages = newUsages;
				this._variableUsages.set(node, usages);
			}
			return usages;
		}
		getRecursiveVariableUsages(operation) {
			let usages = this._recursiveVariableUsages.get(operation);
			if (!usages) {
				usages = this.getVariableUsages(operation);
				for (const frag of this.getRecursivelyReferencedFragments(operation)) usages = usages.concat(this.getVariableUsages(frag));
				this._recursiveVariableUsages.set(operation, usages);
			}
			return usages;
		}
		getType() {
			return this._typeInfo.getType();
		}
		getParentType() {
			return this._typeInfo.getParentType();
		}
		getInputType() {
			return this._typeInfo.getInputType();
		}
		getParentInputType() {
			return this._typeInfo.getParentInputType();
		}
		getFieldDef() {
			return this._typeInfo.getFieldDef();
		}
		getDirective() {
			return this._typeInfo.getDirective();
		}
		getArgument() {
			return this._typeInfo.getArgument();
		}
		getEnumValue() {
			return this._typeInfo.getEnumValue();
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/validation/validate.mjs
/**
* Implements the "Validation" section of the spec.
*
* Validation runs synchronously, returning an array of encountered errors, or
* an empty array if no errors were encountered and the document is valid.
*
* A list of specific validation rules may be provided. If not provided, the
* default list of rules defined by the GraphQL specification will be used.
*
* Each validation rules is a function which returns a visitor
* (see the language/visitor API). Visitor methods are expected to return
* GraphQLErrors, or Arrays of GraphQLErrors when invalid.
*
* Validate will stop validation after a `maxErrors` limit has been reached.
* Attackers can send pathologically invalid queries to induce a DoS attack,
* so by default `maxErrors` set to 100 errors.
*
* Optionally a custom TypeInfo instance may be provided. If not provided, one
* will be created from the provided schema.
*/
function validate(schema, documentAST, rules = specifiedRules, options, typeInfo = new TypeInfo(schema)) {
	var _options$maxErrors;
	const maxErrors = (_options$maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors) !== null && _options$maxErrors !== void 0 ? _options$maxErrors : 100;
	documentAST || devAssert(false, "Must provide document.");
	assertValidSchema(schema);
	const abortObj = Object.freeze({});
	const errors = [];
	const context = new ValidationContext(schema, documentAST, typeInfo, (error) => {
		if (errors.length >= maxErrors) {
			errors.push(new GraphQLError("Too many validation errors, error limit reached. Validation aborted."));
			throw abortObj;
		}
		errors.push(error);
	});
	const visitor = visitInParallel(rules.map((rule) => rule(context)));
	try {
		visit(documentAST, visitWithTypeInfo(typeInfo, visitor));
	} catch (e) {
		if (e !== abortObj) throw e;
	}
	return errors;
}
/**
* @internal
*/
function validateSDL(documentAST, schemaToExtend, rules = specifiedSDLRules) {
	const errors = [];
	const context = new SDLValidationContext(documentAST, schemaToExtend, (error) => {
		errors.push(error);
	});
	visit(documentAST, visitInParallel(rules.map((rule) => rule(context))));
	return errors;
}
/**
* Utility function which asserts a SDL document is valid by throwing an error
* if it is invalid.
*
* @internal
*/
function assertValidSDL(documentAST) {
	const errors = validateSDL(documentAST);
	if (errors.length !== 0) throw new Error(errors.map((error) => error.message).join("\n\n"));
}
/**
* Utility function which asserts a SDL document is valid by throwing an error
* if it is invalid.
*
* @internal
*/
function assertValidSDLExtension(documentAST, schema) {
	const errors = validateSDL(documentAST, schema);
	if (errors.length !== 0) throw new Error(errors.map((error) => error.message).join("\n\n"));
}
var init_validate = __esmMin((() => {
	init_devAssert();
	init_GraphQLError();
	init_visitor();
	init_validate$1();
	init_TypeInfo();
	init_specifiedRules();
	init_ValidationContext();
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/memoize3.mjs
/**
* Memoizes the provided three-argument function.
*/
function memoize3(fn) {
	let cache0;
	return function memoized(a1, a2, a3) {
		if (cache0 === void 0) cache0 = /* @__PURE__ */ new WeakMap();
		let cache1 = cache0.get(a1);
		if (cache1 === void 0) {
			cache1 = /* @__PURE__ */ new WeakMap();
			cache0.set(a1, cache1);
		}
		let cache2 = cache1.get(a2);
		if (cache2 === void 0) {
			cache2 = /* @__PURE__ */ new WeakMap();
			cache1.set(a2, cache2);
		}
		let fnResult = cache2.get(a3);
		if (fnResult === void 0) {
			fnResult = fn(a1, a2, a3);
			cache2.set(a3, fnResult);
		}
		return fnResult;
	};
}
var init_memoize3 = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/promiseForObject.mjs
/**
* This function transforms a JS object `ObjMap<Promise<T>>` into
* a `Promise<ObjMap<T>>`
*
* This is akin to bluebird's `Promise.props`, but implemented only using
* `Promise.all` so it will work with any implementation of ES6 promises.
*/
function promiseForObject(object) {
	return Promise.all(Object.values(object)).then((resolvedValues) => {
		const resolvedObject = Object.create(null);
		for (const [i, key] of Object.keys(object).entries()) resolvedObject[key] = resolvedValues[i];
		return resolvedObject;
	});
}
var init_promiseForObject = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/jsutils/promiseReduce.mjs
/**
* Similar to Array.prototype.reduce(), however the reducing callback may return
* a Promise, in which case reduction will continue after each promise resolves.
*
* If the callback does not return a Promise, then this function will also not
* return a Promise.
*/
function promiseReduce(values, callbackFn, initialValue) {
	let accumulator = initialValue;
	for (const value of values) accumulator = isPromise(accumulator) ? accumulator.then((resolved) => callbackFn(resolved, value)) : callbackFn(accumulator, value);
	return accumulator;
}
var init_promiseReduce = __esmMin((() => {
	init_isPromise();
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/toError.mjs
/**
* Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
*/
function toError(thrownValue) {
	return thrownValue instanceof Error ? thrownValue : new NonErrorThrown(thrownValue);
}
var NonErrorThrown;
var init_toError = __esmMin((() => {
	init_inspect();
	NonErrorThrown = class extends Error {
		constructor(thrownValue) {
			super("Unexpected error value: " + inspect(thrownValue));
			this.name = "NonErrorThrown";
			this.thrownValue = thrownValue;
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/error/locatedError.mjs
/**
* Given an arbitrary value, presumably thrown while attempting to execute a
* GraphQL operation, produce a new GraphQLError aware of the location in the
* document responsible for the original Error.
*/
function locatedError(rawOriginalError, nodes, path) {
	var _nodes;
	const originalError = toError(rawOriginalError);
	if (isLocatedGraphQLError(originalError)) return originalError;
	return new GraphQLError(originalError.message, {
		nodes: (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes,
		source: originalError.source,
		positions: originalError.positions,
		path,
		originalError
	});
}
function isLocatedGraphQLError(error) {
	return Array.isArray(error.path);
}
var init_locatedError = __esmMin((() => {
	init_toError();
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/execution/execute.mjs
/**
* Terminology
*
* "Definitions" are the generic name for top-level statements in the document.
* Examples of this include:
* 1) Operations (such as a query)
* 2) Fragments
*
* "Operations" are a generic name for requests in the document.
* Examples of this include:
* 1) query,
* 2) mutation
*
* "Selections" are the definitions that can appear legally and at
* single level of the query. These include:
* 1) field references e.g `a`
* 2) fragment "spreads" e.g. `...c`
* 3) inline fragment "spreads" e.g. `...on Type { a }`
*/
/**
* Data that must be available at all points during query execution.
*
* Namely, schema of the type system that is currently executing,
* and the fragments defined in the query document
*/
/**
* Implements the "Executing requests" section of the GraphQL specification.
*
* Returns either a synchronous ExecutionResult (if all encountered resolvers
* are synchronous), or a Promise of an ExecutionResult that will eventually be
* resolved and never rejected.
*
* If the arguments to this function do not result in a legal execution context,
* a GraphQLError will be thrown immediately explaining the invalid input.
*/
function execute(args) {
	arguments.length < 2 || devAssert(false, "graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.");
	const { schema, document, variableValues, rootValue } = args;
	assertValidExecutionArguments(schema, document, variableValues);
	const exeContext = buildExecutionContext(args);
	if (!("schema" in exeContext)) return { errors: exeContext };
	try {
		const { operation } = exeContext;
		const result = executeOperation(exeContext, operation, rootValue);
		if (isPromise(result)) return result.then((data) => buildResponse(data, exeContext.errors), (error) => {
			exeContext.errors.push(error);
			return buildResponse(null, exeContext.errors);
		});
		return buildResponse(result, exeContext.errors);
	} catch (error) {
		exeContext.errors.push(error);
		return buildResponse(null, exeContext.errors);
	}
}
/**
* Also implements the "Executing requests" section of the GraphQL specification.
* However, it guarantees to complete synchronously (or throw an error) assuming
* that all field resolvers are also synchronous.
*/
function executeSync(args) {
	const result = execute(args);
	if (isPromise(result)) throw new Error("GraphQL execution failed to complete synchronously.");
	return result;
}
/**
* Given a completed execution context and data, build the `{ errors, data }`
* response defined by the "Response" section of the GraphQL specification.
*/
function buildResponse(data, errors) {
	return errors.length === 0 ? { data } : {
		errors,
		data
	};
}
/**
* Essential assertions before executing to provide developer feedback for
* improper use of the GraphQL library.
*
* @internal
*/
function assertValidExecutionArguments(schema, document, rawVariableValues) {
	document || devAssert(false, "Must provide document.");
	assertValidSchema(schema);
	rawVariableValues == null || isObjectLike(rawVariableValues) || devAssert(false, "Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.");
}
/**
* Constructs a ExecutionContext object from the arguments passed to
* execute, which we will pass throughout the other execution methods.
*
* Throws a GraphQLError if a valid execution context cannot be created.
*
* @internal
*/
function buildExecutionContext(args) {
	var _definition$name, _operation$variableDe;
	const { schema, document, rootValue, contextValue, variableValues: rawVariableValues, operationName, fieldResolver, typeResolver, subscribeFieldResolver } = args;
	let operation;
	const fragments = Object.create(null);
	for (const definition of document.definitions) switch (definition.kind) {
		case Kind.OPERATION_DEFINITION:
			if (operationName == null) {
				if (operation !== void 0) return [new GraphQLError("Must provide operation name if query contains multiple operations.")];
				operation = definition;
			} else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
			break;
		case Kind.FRAGMENT_DEFINITION: fragments[definition.name.value] = definition;
	}
	if (!operation) {
		if (operationName != null) return [new GraphQLError(`Unknown operation named "${operationName}".`)];
		return [new GraphQLError("Must provide an operation.")];
	}
	const coercedVariableValues = getVariableValues(schema, (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [], rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, { maxErrors: 50 });
	if (coercedVariableValues.errors) return coercedVariableValues.errors;
	return {
		schema,
		fragments,
		rootValue,
		contextValue,
		operation,
		variableValues: coercedVariableValues.coerced,
		fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : defaultFieldResolver,
		typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : defaultTypeResolver,
		subscribeFieldResolver: subscribeFieldResolver !== null && subscribeFieldResolver !== void 0 ? subscribeFieldResolver : defaultFieldResolver,
		errors: []
	};
}
/**
* Implements the "Executing operations" section of the spec.
*/
function executeOperation(exeContext, operation, rootValue) {
	const rootType = exeContext.schema.getRootType(operation.operation);
	if (rootType == null) throw new GraphQLError(`Schema is not configured to execute ${operation.operation} operation.`, { nodes: operation });
	const rootFields = collectFields(exeContext.schema, exeContext.fragments, exeContext.variableValues, rootType, operation.selectionSet);
	const path = void 0;
	switch (operation.operation) {
		case OperationTypeNode.QUERY: return executeFields(exeContext, rootType, rootValue, path, rootFields);
		case OperationTypeNode.MUTATION: return executeFieldsSerially(exeContext, rootType, rootValue, path, rootFields);
		case OperationTypeNode.SUBSCRIPTION: return executeFields(exeContext, rootType, rootValue, path, rootFields);
	}
}
/**
* Implements the "Executing selection sets" section of the spec
* for fields that must be executed serially.
*/
function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
	return promiseReduce(fields.entries(), (results, [responseName, fieldNodes]) => {
		const result = executeField(exeContext, parentType, sourceValue, fieldNodes, addPath(path, responseName, parentType.name));
		if (result === void 0) return results;
		if (isPromise(result)) return result.then((resolvedResult) => {
			results[responseName] = resolvedResult;
			return results;
		});
		results[responseName] = result;
		return results;
	}, Object.create(null));
}
/**
* Implements the "Executing selection sets" section of the spec
* for fields that may be executed in parallel.
*/
function executeFields(exeContext, parentType, sourceValue, path, fields) {
	const results = Object.create(null);
	let containsPromise = false;
	try {
		for (const [responseName, fieldNodes] of fields.entries()) {
			const result = executeField(exeContext, parentType, sourceValue, fieldNodes, addPath(path, responseName, parentType.name));
			if (result !== void 0) {
				results[responseName] = result;
				if (isPromise(result)) containsPromise = true;
			}
		}
	} catch (error) {
		if (containsPromise) return promiseForObject(results).finally(() => {
			throw error;
		});
		throw error;
	}
	if (!containsPromise) return results;
	return promiseForObject(results);
}
/**
* Implements the "Executing fields" section of the spec
* In particular, this function figures out the value that the field returns by
* calling its resolve function, then calls completeValue to complete promises,
* serialize scalars, or execute the sub-selection-set for objects.
*/
function executeField(exeContext, parentType, source, fieldNodes, path) {
	var _fieldDef$resolve;
	const fieldDef = getFieldDef(exeContext.schema, parentType, fieldNodes[0]);
	if (!fieldDef) return;
	const returnType = fieldDef.type;
	const resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
	const info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path);
	try {
		const args = getArgumentValues(fieldDef, fieldNodes[0], exeContext.variableValues);
		const contextValue = exeContext.contextValue;
		const result = resolveFn(source, args, contextValue, info);
		let completed;
		if (isPromise(result)) completed = result.then((resolved) => completeValue(exeContext, returnType, fieldNodes, info, path, resolved));
		else completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
		if (isPromise(completed)) return completed.then(void 0, (rawError) => {
			return handleFieldError(locatedError(rawError, fieldNodes, pathToArray(path)), returnType, exeContext);
		});
		return completed;
	} catch (rawError) {
		return handleFieldError(locatedError(rawError, fieldNodes, pathToArray(path)), returnType, exeContext);
	}
}
/**
* @internal
*/
function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
	return {
		fieldName: fieldDef.name,
		fieldNodes,
		returnType: fieldDef.type,
		parentType,
		path,
		schema: exeContext.schema,
		fragments: exeContext.fragments,
		rootValue: exeContext.rootValue,
		operation: exeContext.operation,
		variableValues: exeContext.variableValues
	};
}
function handleFieldError(error, returnType, exeContext) {
	if (isNonNullType(returnType)) throw error;
	exeContext.errors.push(error);
	return null;
}
/**
* Implements the instructions for completeValue as defined in the
* "Value Completion" section of the spec.
*
* If the field type is Non-Null, then this recursively completes the value
* for the inner type. It throws a field error if that completion returns null,
* as per the "Nullability" section of the spec.
*
* If the field type is a List, then this recursively completes the value
* for the inner type on each item in the list.
*
* If the field type is a Scalar or Enum, ensures the completed value is a legal
* value of the type by calling the `serialize` method of GraphQL type
* definition.
*
* If the field is an abstract type, determine the runtime type of the value
* and then complete based on that type
*
* Otherwise, the field type expects a sub-selection set, and will complete the
* value by executing all sub-selections.
*/
function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
	if (result instanceof Error) throw result;
	if (isNonNullType(returnType)) {
		const completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
		if (completed === null) throw new Error(`Cannot return null for non-nullable field ${info.parentType.name}.${info.fieldName}.`);
		return completed;
	}
	if (result == null) return null;
	if (isListType(returnType)) return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
	if (isLeafType(returnType)) return completeLeafValue(returnType, result);
	if (isAbstractType(returnType)) return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
	if (isObjectType(returnType)) return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
	/* c8 ignore next 6 */
	invariant(false, "Cannot complete value of unexpected output type: " + inspect(returnType));
}
/**
* Complete a list value by completing each item in the list with the
* inner type
*/
function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
	if (!isIterableObject(result)) throw new GraphQLError(`Expected Iterable, but did not find one for field "${info.parentType.name}.${info.fieldName}".`);
	const itemType = returnType.ofType;
	let containsPromise = false;
	const completedResults = Array.from(result, (item, index) => {
		const itemPath = addPath(path, index, void 0);
		try {
			let completedItem;
			if (isPromise(item)) completedItem = item.then((resolved) => completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved));
			else completedItem = completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
			if (isPromise(completedItem)) {
				containsPromise = true;
				return completedItem.then(void 0, (rawError) => {
					return handleFieldError(locatedError(rawError, fieldNodes, pathToArray(itemPath)), itemType, exeContext);
				});
			}
			return completedItem;
		} catch (rawError) {
			return handleFieldError(locatedError(rawError, fieldNodes, pathToArray(itemPath)), itemType, exeContext);
		}
	});
	return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
* Complete a Scalar or Enum by serializing to a valid value, returning
* null if serialization is not possible.
*/
function completeLeafValue(returnType, result) {
	const serializedResult = returnType.serialize(result);
	if (serializedResult == null) throw new Error(`Expected \`${inspect(returnType)}.serialize(${inspect(result)})\` to return non-nullable value, returned: ${inspect(serializedResult)}`);
	return serializedResult;
}
/**
* Complete a value of an abstract type by determining the runtime object type
* of that value, then complete the value for that type.
*/
function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
	var _returnType$resolveTy;
	const resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
	const contextValue = exeContext.contextValue;
	const runtimeType = resolveTypeFn(result, contextValue, info, returnType);
	if (isPromise(runtimeType)) return runtimeType.then((resolvedRuntimeType) => completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result));
	return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}
function ensureValidRuntimeType(runtimeTypeName, exeContext, returnType, fieldNodes, info, result) {
	if (runtimeTypeName == null) throw new GraphQLError(`Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}". Either the "${returnType.name}" type should provide a "resolveType" function or each possible type should provide an "isTypeOf" function.`, fieldNodes);
	if (isObjectType(runtimeTypeName)) throw new GraphQLError("Support for returning GraphQLObjectType from resolveType was removed in graphql-js@16.0.0 please return type name instead.");
	if (typeof runtimeTypeName !== "string") throw new GraphQLError(`Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}" with value ${inspect(result)}, received "${inspect(runtimeTypeName)}".`);
	const runtimeType = exeContext.schema.getType(runtimeTypeName);
	if (runtimeType == null) throw new GraphQLError(`Abstract type "${returnType.name}" was resolved to a type "${runtimeTypeName}" that does not exist inside the schema.`, { nodes: fieldNodes });
	if (!isObjectType(runtimeType)) throw new GraphQLError(`Abstract type "${returnType.name}" was resolved to a non-object type "${runtimeTypeName}".`, { nodes: fieldNodes });
	if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new GraphQLError(`Runtime Object type "${runtimeType.name}" is not a possible type for "${returnType.name}".`, { nodes: fieldNodes });
	return runtimeType;
}
/**
* Complete an Object value by executing all sub-selections.
*/
function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
	const subFieldNodes = collectSubfields(exeContext, returnType, fieldNodes);
	if (returnType.isTypeOf) {
		const isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
		if (isPromise(isTypeOf)) return isTypeOf.then((resolvedIsTypeOf) => {
			if (!resolvedIsTypeOf) throw invalidReturnTypeError(returnType, result, fieldNodes);
			return executeFields(exeContext, returnType, result, path, subFieldNodes);
		});
		if (!isTypeOf) throw invalidReturnTypeError(returnType, result, fieldNodes);
	}
	return executeFields(exeContext, returnType, result, path, subFieldNodes);
}
function invalidReturnTypeError(returnType, result, fieldNodes) {
	return new GraphQLError(`Expected value of type "${returnType.name}" but got: ${inspect(result)}.`, { nodes: fieldNodes });
}
/**
* This method looks up the field on the given type definition.
* It has special casing for the three introspection fields,
* __schema, __type and __typename. __typename is special because
* it can always be queried as a field, even in situations where no
* other fields are allowed, like on a Union. __schema and __type
* could get automatically added to the query type, but that would
* require mutating type definitions, which would cause issues.
*
* @internal
*/
function getFieldDef(schema, parentType, fieldNode) {
	const fieldName = fieldNode.name.value;
	if (fieldName === SchemaMetaFieldDef.name && schema.getQueryType() === parentType) return SchemaMetaFieldDef;
	else if (fieldName === TypeMetaFieldDef.name && schema.getQueryType() === parentType) return TypeMetaFieldDef;
	else if (fieldName === TypeNameMetaFieldDef.name) return TypeNameMetaFieldDef;
	return parentType.getFields()[fieldName];
}
var collectSubfields, defaultTypeResolver, defaultFieldResolver;
var init_execute = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_invariant();
	init_isIterableObject();
	init_isObjectLike();
	init_isPromise();
	init_memoize3();
	init_Path();
	init_promiseForObject();
	init_promiseReduce();
	init_GraphQLError();
	init_locatedError();
	init_ast();
	init_kinds();
	init_definition();
	init_introspection();
	init_validate$1();
	init_collectFields();
	init_values();
	collectSubfields = memoize3((exeContext, returnType, fieldNodes) => collectSubfields$1(exeContext.schema, exeContext.fragments, exeContext.variableValues, returnType, fieldNodes));
	defaultTypeResolver = function(value, contextValue, info, abstractType) {
		if (isObjectLike(value) && typeof value.__typename === "string") return value.__typename;
		const possibleTypes = info.schema.getPossibleTypes(abstractType);
		const promisedIsTypeOfResults = [];
		for (let i = 0; i < possibleTypes.length; i++) {
			const type = possibleTypes[i];
			if (type.isTypeOf) {
				const isTypeOfResult = type.isTypeOf(value, contextValue, info);
				if (isPromise(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
				else if (isTypeOfResult) return type.name;
			}
		}
		if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then((isTypeOfResults) => {
			for (let i = 0; i < isTypeOfResults.length; i++) if (isTypeOfResults[i]) return possibleTypes[i].name;
		});
	};
	defaultFieldResolver = function(source, args, contextValue, info) {
		if (isObjectLike(source) || typeof source === "function") {
			const property = source[info.fieldName];
			if (typeof property === "function") return source[info.fieldName](args, contextValue, info);
			return property;
		}
	};
}));
//#endregion
//#region ../../node_modules/graphql/graphql.mjs
/**
* This is the primary entry point function for fulfilling GraphQL operations
* by parsing, validating, and executing a GraphQL document along side a
* GraphQL schema.
*
* More sophisticated GraphQL servers, such as those which persist queries,
* may wish to separate the validation and execution phases to a static time
* tooling step, and a server runtime step.
*
* Accepts either an object with named arguments, or individual arguments:
*
* schema:
*    The GraphQL type system to use when validating and executing a query.
* source:
*    A GraphQL language formatted string representing the requested operation.
* rootValue:
*    The value provided as the first argument to resolver functions on the top
*    level type (e.g. the query object type).
* contextValue:
*    The context value is provided as an argument to resolver functions after
*    field arguments. It is used to pass shared information useful at any point
*    during executing this query, for example the currently logged in user and
*    connections to databases or other services.
* variableValues:
*    A mapping of variable name to runtime value to use for all variables
*    defined in the requestString.
* operationName:
*    The name of the operation to use if requestString contains multiple
*    possible operations. Can be omitted if requestString contains only
*    one operation.
* fieldResolver:
*    A resolver function to use when one is not provided by the schema.
*    If not provided, the default field resolver is used (which looks for a
*    value or method on the source value with the field's name).
* typeResolver:
*    A type resolver function to use when none is provided by the schema.
*    If not provided, the default type resolver is used (which looks for a
*    `__typename` field or alternatively calls the `isTypeOf` method).
*/
function graphql(args) {
	return new Promise((resolve) => resolve(graphqlImpl(args)));
}
/**
* The graphqlSync function also fulfills GraphQL operations by parsing,
* validating, and executing a GraphQL document along side a GraphQL schema.
* However, it guarantees to complete synchronously (or throw an error) assuming
* that all field resolvers are also synchronous.
*/
function graphqlSync(args) {
	const result = graphqlImpl(args);
	if (isPromise(result)) throw new Error("GraphQL execution failed to complete synchronously.");
	return result;
}
function graphqlImpl(args) {
	arguments.length < 2 || devAssert(false, "graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.");
	const { schema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver } = args;
	const schemaValidationErrors = validateSchema(schema);
	if (schemaValidationErrors.length > 0) return { errors: schemaValidationErrors };
	let document;
	try {
		document = parse(source);
	} catch (syntaxError) {
		return { errors: [syntaxError] };
	}
	const validationErrors = validate(schema, document);
	if (validationErrors.length > 0) return { errors: validationErrors };
	return execute({
		schema,
		document,
		rootValue,
		contextValue,
		variableValues,
		operationName,
		fieldResolver,
		typeResolver
	});
}
var init_graphql$1 = __esmMin((() => {
	init_devAssert();
	init_isPromise();
	init_parser();
	init_validate$1();
	init_validate();
	init_execute();
}));
//#endregion
//#region ../../node_modules/graphql/type/index.mjs
var init_type = __esmMin((() => {
	init_schema();
	init_definition();
	init_directives();
	init_scalars();
	init_introspection();
	init_validate$1();
	init_assertName();
}));
//#endregion
//#region ../../node_modules/graphql/language/index.mjs
var init_language = __esmMin((() => {
	init_source();
	init_location();
	init_printLocation();
	init_kinds();
	init_tokenKind();
	init_lexer();
	init_parser();
	init_printer();
	init_visitor();
	init_ast();
	init_predicates();
	init_directiveLocation();
}));
//#endregion
//#region ../../node_modules/graphql/jsutils/isAsyncIterable.mjs
/**
* Returns true if the provided object implements the AsyncIterator protocol via
* implementing a `Symbol.asyncIterator` method.
*/
function isAsyncIterable(maybeAsyncIterable) {
	return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[Symbol.asyncIterator]) === "function";
}
var init_isAsyncIterable = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/execution/mapAsyncIterator.mjs
/**
* Given an AsyncIterable and a callback function, return an AsyncIterator
* which produces values mapped via calling the callback function.
*/
function mapAsyncIterator(iterable, callback) {
	const iterator = iterable[Symbol.asyncIterator]();
	async function mapResult(result) {
		if (result.done) return result;
		try {
			return {
				value: await callback(result.value),
				done: false
			};
		} catch (error) {
			/* c8 ignore start */
			if (typeof iterator.return === "function") try {
				await iterator.return();
			} catch (_e) {}
			throw error;
		}
	}
	return {
		async next() {
			return mapResult(await iterator.next());
		},
		async return() {
			return typeof iterator.return === "function" ? mapResult(await iterator.return()) : {
				value: void 0,
				done: true
			};
		},
		async throw(error) {
			if (typeof iterator.throw === "function") return mapResult(await iterator.throw(error));
			throw error;
		},
		[Symbol.asyncIterator]() {
			return this;
		}
	};
}
var init_mapAsyncIterator = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/execution/subscribe.mjs
/**
* Implements the "Subscribe" algorithm described in the GraphQL specification.
*
* Returns a Promise which resolves to either an AsyncIterator (if successful)
* or an ExecutionResult (error). The promise will be rejected if the schema or
* other arguments to this function are invalid, or if the resolved event stream
* is not an async iterable.
*
* If the client-provided arguments to this function do not result in a
* compliant subscription, a GraphQL Response (ExecutionResult) with
* descriptive errors and no data will be returned.
*
* If the source stream could not be created due to faulty subscription
* resolver logic or underlying systems, the promise will resolve to a single
* ExecutionResult containing `errors` and no `data`.
*
* If the operation succeeded, the promise resolves to an AsyncIterator, which
* yields a stream of ExecutionResults representing the response stream.
*
* Accepts either an object with named arguments, or individual arguments.
*/
async function subscribe$1(args) {
	arguments.length < 2 || devAssert(false, "graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.");
	const resultOrStream = await createSourceEventStream(args);
	if (!isAsyncIterable(resultOrStream)) return resultOrStream;
	const mapSourceToResponse = (payload) => execute({
		...args,
		rootValue: payload
	});
	return mapAsyncIterator(resultOrStream, mapSourceToResponse);
}
function toNormalizedArgs(args) {
	const firstArg = args[0];
	if (firstArg && "document" in firstArg) return firstArg;
	return {
		schema: firstArg,
		document: args[1],
		rootValue: args[2],
		contextValue: args[3],
		variableValues: args[4],
		operationName: args[5],
		subscribeFieldResolver: args[6]
	};
}
/**
* Implements the "CreateSourceEventStream" algorithm described in the
* GraphQL specification, resolving the subscription source event stream.
*
* Returns a Promise which resolves to either an AsyncIterable (if successful)
* or an ExecutionResult (error). The promise will be rejected if the schema or
* other arguments to this function are invalid, or if the resolved event stream
* is not an async iterable.
*
* If the client-provided arguments to this function do not result in a
* compliant subscription, a GraphQL Response (ExecutionResult) with
* descriptive errors and no data will be returned.
*
* If the the source stream could not be created due to faulty subscription
* resolver logic or underlying systems, the promise will resolve to a single
* ExecutionResult containing `errors` and no `data`.
*
* If the operation succeeded, the promise resolves to the AsyncIterable for the
* event stream returned by the resolver.
*
* A Source Event Stream represents a sequence of events, each of which triggers
* a GraphQL execution for that event.
*
* This may be useful when hosting the stateful subscription service in a
* different process or machine than the stateless GraphQL execution engine,
* or otherwise separating these two steps. For more on this, see the
* "Supporting Subscriptions at Scale" information in the GraphQL specification.
*/
async function createSourceEventStream(...rawArgs) {
	const args = toNormalizedArgs(rawArgs);
	const { schema, document, variableValues } = args;
	assertValidExecutionArguments(schema, document, variableValues);
	const exeContext = buildExecutionContext(args);
	if (!("schema" in exeContext)) return { errors: exeContext };
	try {
		const eventStream = await executeSubscription(exeContext);
		if (!isAsyncIterable(eventStream)) throw new Error(`Subscription field must return Async Iterable. Received: ${inspect(eventStream)}.`);
		return eventStream;
	} catch (error) {
		if (error instanceof GraphQLError) return { errors: [error] };
		throw error;
	}
}
async function executeSubscription(exeContext) {
	const { schema, fragments, operation, variableValues, rootValue } = exeContext;
	const rootType = schema.getSubscriptionType();
	if (rootType == null) throw new GraphQLError("Schema is not configured to execute subscription operation.", { nodes: operation });
	const [responseName, fieldNodes] = [...collectFields(schema, fragments, variableValues, rootType, operation.selectionSet).entries()][0];
	const fieldDef = getFieldDef(schema, rootType, fieldNodes[0]);
	if (!fieldDef) {
		const fieldName = fieldNodes[0].name.value;
		throw new GraphQLError(`The subscription field "${fieldName}" is not defined.`, { nodes: fieldNodes });
	}
	const path = addPath(void 0, responseName, rootType.name);
	const info = buildResolveInfo(exeContext, fieldDef, fieldNodes, rootType, path);
	try {
		var _fieldDef$subscribe;
		const args = getArgumentValues(fieldDef, fieldNodes[0], variableValues);
		const contextValue = exeContext.contextValue;
		const eventStream = await ((_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.subscribeFieldResolver)(rootValue, args, contextValue, info);
		if (eventStream instanceof Error) throw eventStream;
		return eventStream;
	} catch (error) {
		throw locatedError(error, fieldNodes, pathToArray(path));
	}
}
var init_subscribe = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_isAsyncIterable();
	init_Path();
	init_GraphQLError();
	init_locatedError();
	init_collectFields();
	init_execute();
	init_mapAsyncIterator();
	init_values();
}));
//#endregion
//#region ../../node_modules/graphql/execution/index.mjs
var init_execution = __esmMin((() => {
	init_Path();
	init_execute();
	init_subscribe();
	init_values();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/custom/NoDeprecatedCustomRule.mjs
/**
* No deprecated
*
* A GraphQL document is only valid if all selected fields and all used enum values have not been
* deprecated.
*
* Note: This rule is optional and is not part of the Validation section of the GraphQL
* Specification. The main purpose of this rule is detection of deprecated usages and not
* necessarily to forbid their use when querying a service.
*/
function NoDeprecatedCustomRule(context) {
	return {
		Field(node) {
			const fieldDef = context.getFieldDef();
			const deprecationReason = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.deprecationReason;
			if (fieldDef && deprecationReason != null) {
				const parentType = context.getParentType();
				parentType ?? invariant(false);
				context.reportError(new GraphQLError(`The field ${parentType.name}.${fieldDef.name} is deprecated. ${deprecationReason}`, { nodes: node }));
			}
		},
		Argument(node) {
			const argDef = context.getArgument();
			const deprecationReason = argDef === null || argDef === void 0 ? void 0 : argDef.deprecationReason;
			if (argDef && deprecationReason != null) {
				const directiveDef = context.getDirective();
				if (directiveDef != null) context.reportError(new GraphQLError(`Directive "@${directiveDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`, { nodes: node }));
				else {
					const parentType = context.getParentType();
					const fieldDef = context.getFieldDef();
					parentType != null && fieldDef != null || invariant(false);
					context.reportError(new GraphQLError(`Field "${parentType.name}.${fieldDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`, { nodes: node }));
				}
			}
		},
		ObjectField(node) {
			const inputObjectDef = getNamedType(context.getParentInputType());
			if (isInputObjectType(inputObjectDef)) {
				const inputFieldDef = inputObjectDef.getFields()[node.name.value];
				const deprecationReason = inputFieldDef === null || inputFieldDef === void 0 ? void 0 : inputFieldDef.deprecationReason;
				if (deprecationReason != null) context.reportError(new GraphQLError(`The input field ${inputObjectDef.name}.${inputFieldDef.name} is deprecated. ${deprecationReason}`, { nodes: node }));
			}
		},
		EnumValue(node) {
			const enumValueDef = context.getEnumValue();
			const deprecationReason = enumValueDef === null || enumValueDef === void 0 ? void 0 : enumValueDef.deprecationReason;
			if (enumValueDef && deprecationReason != null) {
				const enumTypeDef = getNamedType(context.getInputType());
				enumTypeDef ?? invariant(false);
				context.reportError(new GraphQLError(`The enum value "${enumTypeDef.name}.${enumValueDef.name}" is deprecated. ${deprecationReason}`, { nodes: node }));
			}
		}
	};
}
var init_NoDeprecatedCustomRule = __esmMin((() => {
	init_invariant();
	init_GraphQLError();
	init_definition();
}));
//#endregion
//#region ../../node_modules/graphql/validation/rules/custom/NoSchemaIntrospectionCustomRule.mjs
/**
* Prohibit introspection queries
*
* A GraphQL document is only valid if all fields selected are not fields that
* return an introspection type.
*
* Note: This rule is optional and is not part of the Validation section of the
* GraphQL Specification. This rule effectively disables introspection, which
* does not reflect best practices and should only be done if absolutely necessary.
*/
function NoSchemaIntrospectionCustomRule(context) {
	return { Field(node) {
		const type = getNamedType(context.getType());
		if (type && isIntrospectionType(type)) context.reportError(new GraphQLError(`GraphQL introspection has been disabled, but the requested query contained the field "${node.name.value}".`, { nodes: node }));
	} };
}
var init_NoSchemaIntrospectionCustomRule = __esmMin((() => {
	init_GraphQLError();
	init_definition();
	init_introspection();
}));
//#endregion
//#region ../../node_modules/graphql/validation/index.mjs
var init_validation = __esmMin((() => {
	init_validate();
	init_ValidationContext();
	init_specifiedRules();
	init_ExecutableDefinitionsRule();
	init_FieldsOnCorrectTypeRule();
	init_FragmentsOnCompositeTypesRule();
	init_KnownArgumentNamesRule();
	init_KnownDirectivesRule();
	init_KnownFragmentNamesRule();
	init_KnownTypeNamesRule();
	init_LoneAnonymousOperationRule();
	init_NoFragmentCyclesRule();
	init_NoUndefinedVariablesRule();
	init_NoUnusedFragmentsRule();
	init_NoUnusedVariablesRule();
	init_OverlappingFieldsCanBeMergedRule();
	init_PossibleFragmentSpreadsRule();
	init_ProvidedRequiredArgumentsRule();
	init_ScalarLeafsRule();
	init_SingleFieldSubscriptionsRule();
	init_UniqueArgumentNamesRule();
	init_UniqueDirectivesPerLocationRule();
	init_UniqueFragmentNamesRule();
	init_UniqueInputFieldNamesRule();
	init_UniqueOperationNamesRule();
	init_UniqueVariableNamesRule();
	init_ValuesOfCorrectTypeRule();
	init_VariablesAreInputTypesRule();
	init_VariablesInAllowedPositionRule();
	init_LoneSchemaDefinitionRule();
	init_UniqueOperationTypesRule();
	init_UniqueTypeNamesRule();
	init_UniqueEnumValueNamesRule();
	init_UniqueFieldDefinitionNamesRule();
	init_UniqueArgumentDefinitionNamesRule();
	init_UniqueDirectiveNamesRule();
	init_PossibleTypeExtensionsRule();
	init_NoDeprecatedCustomRule();
	init_NoSchemaIntrospectionCustomRule();
}));
//#endregion
//#region ../../node_modules/graphql/error/index.mjs
var init_error = __esmMin((() => {
	init_GraphQLError();
	init_syntaxError();
	init_locatedError();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/getIntrospectionQuery.mjs
/**
* Produce the GraphQL query recommended for a full schema introspection.
* Accepts optional IntrospectionOptions.
*/
function getIntrospectionQuery(options) {
	const optionsWithDefault = {
		descriptions: true,
		specifiedByUrl: false,
		directiveIsRepeatable: false,
		schemaDescription: false,
		inputValueDeprecation: false,
		...options
	};
	const descriptions = optionsWithDefault.descriptions ? "description" : "";
	const specifiedByUrl = optionsWithDefault.specifiedByUrl ? "specifiedByURL" : "";
	const directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? "isRepeatable" : "";
	const schemaDescription = optionsWithDefault.schemaDescription ? descriptions : "";
	function inputDeprecation(str) {
		return optionsWithDefault.inputValueDeprecation ? str : "";
	}
	return `
    query IntrospectionQuery {
      __schema {
        ${schemaDescription}
        queryType { name }
        mutationType { name }
        subscriptionType { name }
        types {
          ...FullType
        }
        directives {
          name
          ${descriptions}
          ${directiveIsRepeatable}
          locations
          args${inputDeprecation("(includeDeprecated: true)")} {
            ...InputValue
          }
        }
      }
    }

    fragment FullType on __Type {
      kind
      name
      ${descriptions}
      ${specifiedByUrl}
      fields(includeDeprecated: true) {
        name
        ${descriptions}
        args${inputDeprecation("(includeDeprecated: true)")} {
          ...InputValue
        }
        type {
          ...TypeRef
        }
        isDeprecated
        deprecationReason
      }
      inputFields${inputDeprecation("(includeDeprecated: true)")} {
        ...InputValue
      }
      interfaces {
        ...TypeRef
      }
      enumValues(includeDeprecated: true) {
        name
        ${descriptions}
        isDeprecated
        deprecationReason
      }
      possibleTypes {
        ...TypeRef
      }
    }

    fragment InputValue on __InputValue {
      name
      ${descriptions}
      type { ...TypeRef }
      defaultValue
      ${inputDeprecation("isDeprecated")}
      ${inputDeprecation("deprecationReason")}
    }

    fragment TypeRef on __Type {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                  ofType {
                    kind
                    name
                    ofType {
                      kind
                      name
                      ofType {
                        kind
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}
var init_getIntrospectionQuery = __esmMin((() => {}));
//#endregion
//#region ../../node_modules/graphql/utilities/getOperationAST.mjs
/**
* Returns an operation AST given a document AST and optionally an operation
* name. If a name is not provided, an operation is only returned if only one is
* provided in the document.
*/
function getOperationAST(documentAST, operationName) {
	let operation = null;
	for (const definition of documentAST.definitions) if (definition.kind === Kind.OPERATION_DEFINITION) {
		var _definition$name;
		if (operationName == null) {
			if (operation) return null;
			operation = definition;
		} else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
	}
	return operation;
}
var init_getOperationAST = __esmMin((() => {
	init_kinds();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/getOperationRootType.mjs
/**
* Extracts the root type of the operation from the schema.
*
* @deprecated Please use `GraphQLSchema.getRootType` instead. Will be removed in v17
*/
function getOperationRootType(schema, operation) {
	if (operation.operation === "query") {
		const queryType = schema.getQueryType();
		if (!queryType) throw new GraphQLError("Schema does not define the required query root type.", { nodes: operation });
		return queryType;
	}
	if (operation.operation === "mutation") {
		const mutationType = schema.getMutationType();
		if (!mutationType) throw new GraphQLError("Schema is not configured for mutations.", { nodes: operation });
		return mutationType;
	}
	if (operation.operation === "subscription") {
		const subscriptionType = schema.getSubscriptionType();
		if (!subscriptionType) throw new GraphQLError("Schema is not configured for subscriptions.", { nodes: operation });
		return subscriptionType;
	}
	throw new GraphQLError("Can only have query, mutation and subscription operations.", { nodes: operation });
}
var init_getOperationRootType = __esmMin((() => {
	init_GraphQLError();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/introspectionFromSchema.mjs
/**
* Build an IntrospectionQuery from a GraphQLSchema
*
* IntrospectionQuery is useful for utilities that care about type and field
* relationships, but do not need to traverse through those relationships.
*
* This is the inverse of buildClientSchema. The primary use case is outside
* of the server context, for instance when doing schema comparisons.
*/
function introspectionFromSchema(schema, options) {
	const result = executeSync({
		schema,
		document: parse(getIntrospectionQuery({
			specifiedByUrl: true,
			directiveIsRepeatable: true,
			schemaDescription: true,
			inputValueDeprecation: true,
			...options
		}))
	});
	!result.errors && result.data || invariant(false);
	return result.data;
}
var init_introspectionFromSchema = __esmMin((() => {
	init_invariant();
	init_parser();
	init_execute();
	init_getIntrospectionQuery();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/buildClientSchema.mjs
/**
* Build a GraphQLSchema for use by client tools.
*
* Given the result of a client running the introspection query, creates and
* returns a GraphQLSchema instance which can be then used with all graphql-js
* tools, but cannot be used to execute a query, as introspection does not
* represent the "resolver", "parse" or "serialize" functions or any other
* server-internal mechanisms.
*
* This function expects a complete introspection result. Don't forget to check
* the "errors" field of a server response before calling this function.
*/
function buildClientSchema(introspection, options) {
	isObjectLike(introspection) && isObjectLike(introspection.__schema) || devAssert(false, `Invalid or incomplete introspection result. Ensure that you are passing "data" property of introspection response and no "errors" was returned alongside: ${inspect(introspection)}.`);
	const schemaIntrospection = introspection.__schema;
	const typeMap = keyValMap(schemaIntrospection.types, (typeIntrospection) => typeIntrospection.name, (typeIntrospection) => buildType(typeIntrospection));
	for (const stdType of [...specifiedScalarTypes, ...introspectionTypes]) if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
	const queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
	const mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
	const subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null;
	const directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : [];
	return new GraphQLSchema({
		description: schemaIntrospection.description,
		query: queryType,
		mutation: mutationType,
		subscription: subscriptionType,
		types: Object.values(typeMap),
		directives,
		assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
	});
	function getType(typeRef) {
		if (typeRef.kind === TypeKind.LIST) {
			const itemRef = typeRef.ofType;
			if (!itemRef) throw new Error("Decorated type deeper than introspection query.");
			return new GraphQLList(getType(itemRef));
		}
		if (typeRef.kind === TypeKind.NON_NULL) {
			const nullableRef = typeRef.ofType;
			if (!nullableRef) throw new Error("Decorated type deeper than introspection query.");
			const nullableType = getType(nullableRef);
			return new GraphQLNonNull(assertNullableType(nullableType));
		}
		return getNamedType(typeRef);
	}
	function getNamedType(typeRef) {
		const typeName = typeRef.name;
		if (!typeName) throw new Error(`Unknown type reference: ${inspect(typeRef)}.`);
		const type = typeMap[typeName];
		if (!type) throw new Error(`Invalid or incomplete schema, unknown type: ${typeName}. Ensure that a full introspection query is used in order to build a client schema.`);
		return type;
	}
	function getObjectType(typeRef) {
		return assertObjectType(getNamedType(typeRef));
	}
	function getInterfaceType(typeRef) {
		return assertInterfaceType(getNamedType(typeRef));
	}
	function buildType(type) {
		if (type != null && type.name != null && type.kind != null) switch (type.kind) {
			case TypeKind.SCALAR: return buildScalarDef(type);
			case TypeKind.OBJECT: return buildObjectDef(type);
			case TypeKind.INTERFACE: return buildInterfaceDef(type);
			case TypeKind.UNION: return buildUnionDef(type);
			case TypeKind.ENUM: return buildEnumDef(type);
			case TypeKind.INPUT_OBJECT: return buildInputObjectDef(type);
		}
		const typeStr = inspect(type);
		throw new Error(`Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ${typeStr}.`);
	}
	function buildScalarDef(scalarIntrospection) {
		return new GraphQLScalarType({
			name: scalarIntrospection.name,
			description: scalarIntrospection.description,
			specifiedByURL: scalarIntrospection.specifiedByURL
		});
	}
	function buildImplementationsList(implementingIntrospection) {
		if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === TypeKind.INTERFACE) return [];
		if (!implementingIntrospection.interfaces) {
			const implementingIntrospectionStr = inspect(implementingIntrospection);
			throw new Error(`Introspection result missing interfaces: ${implementingIntrospectionStr}.`);
		}
		return implementingIntrospection.interfaces.map(getInterfaceType);
	}
	function buildObjectDef(objectIntrospection) {
		return new GraphQLObjectType({
			name: objectIntrospection.name,
			description: objectIntrospection.description,
			interfaces: () => buildImplementationsList(objectIntrospection),
			fields: () => buildFieldDefMap(objectIntrospection)
		});
	}
	function buildInterfaceDef(interfaceIntrospection) {
		return new GraphQLInterfaceType({
			name: interfaceIntrospection.name,
			description: interfaceIntrospection.description,
			interfaces: () => buildImplementationsList(interfaceIntrospection),
			fields: () => buildFieldDefMap(interfaceIntrospection)
		});
	}
	function buildUnionDef(unionIntrospection) {
		if (!unionIntrospection.possibleTypes) {
			const unionIntrospectionStr = inspect(unionIntrospection);
			throw new Error(`Introspection result missing possibleTypes: ${unionIntrospectionStr}.`);
		}
		return new GraphQLUnionType({
			name: unionIntrospection.name,
			description: unionIntrospection.description,
			types: () => unionIntrospection.possibleTypes.map(getObjectType)
		});
	}
	function buildEnumDef(enumIntrospection) {
		if (!enumIntrospection.enumValues) {
			const enumIntrospectionStr = inspect(enumIntrospection);
			throw new Error(`Introspection result missing enumValues: ${enumIntrospectionStr}.`);
		}
		return new GraphQLEnumType({
			name: enumIntrospection.name,
			description: enumIntrospection.description,
			values: keyValMap(enumIntrospection.enumValues, (valueIntrospection) => valueIntrospection.name, (valueIntrospection) => ({
				description: valueIntrospection.description,
				deprecationReason: valueIntrospection.deprecationReason
			}))
		});
	}
	function buildInputObjectDef(inputObjectIntrospection) {
		if (!inputObjectIntrospection.inputFields) {
			const inputObjectIntrospectionStr = inspect(inputObjectIntrospection);
			throw new Error(`Introspection result missing inputFields: ${inputObjectIntrospectionStr}.`);
		}
		return new GraphQLInputObjectType({
			name: inputObjectIntrospection.name,
			description: inputObjectIntrospection.description,
			fields: () => buildInputValueDefMap(inputObjectIntrospection.inputFields)
		});
	}
	function buildFieldDefMap(typeIntrospection) {
		if (!typeIntrospection.fields) throw new Error(`Introspection result missing fields: ${inspect(typeIntrospection)}.`);
		return keyValMap(typeIntrospection.fields, (fieldIntrospection) => fieldIntrospection.name, buildField);
	}
	function buildField(fieldIntrospection) {
		const type = getType(fieldIntrospection.type);
		if (!isOutputType(type)) {
			const typeStr = inspect(type);
			throw new Error(`Introspection must provide output type for fields, but received: ${typeStr}.`);
		}
		if (!fieldIntrospection.args) {
			const fieldIntrospectionStr = inspect(fieldIntrospection);
			throw new Error(`Introspection result missing field args: ${fieldIntrospectionStr}.`);
		}
		return {
			description: fieldIntrospection.description,
			deprecationReason: fieldIntrospection.deprecationReason,
			type,
			args: buildInputValueDefMap(fieldIntrospection.args)
		};
	}
	function buildInputValueDefMap(inputValueIntrospections) {
		return keyValMap(inputValueIntrospections, (inputValue) => inputValue.name, buildInputValue);
	}
	function buildInputValue(inputValueIntrospection) {
		const type = getType(inputValueIntrospection.type);
		if (!isInputType(type)) {
			const typeStr = inspect(type);
			throw new Error(`Introspection must provide input type for arguments, but received: ${typeStr}.`);
		}
		const defaultValue = inputValueIntrospection.defaultValue != null ? valueFromAST(parseValue(inputValueIntrospection.defaultValue), type) : void 0;
		return {
			description: inputValueIntrospection.description,
			type,
			defaultValue,
			deprecationReason: inputValueIntrospection.deprecationReason
		};
	}
	function buildDirective(directiveIntrospection) {
		if (!directiveIntrospection.args) {
			const directiveIntrospectionStr = inspect(directiveIntrospection);
			throw new Error(`Introspection result missing directive args: ${directiveIntrospectionStr}.`);
		}
		if (!directiveIntrospection.locations) {
			const directiveIntrospectionStr = inspect(directiveIntrospection);
			throw new Error(`Introspection result missing directive locations: ${directiveIntrospectionStr}.`);
		}
		return new GraphQLDirective({
			name: directiveIntrospection.name,
			description: directiveIntrospection.description,
			isRepeatable: directiveIntrospection.isRepeatable,
			locations: directiveIntrospection.locations.slice(),
			args: buildInputValueDefMap(directiveIntrospection.args)
		});
	}
}
var init_buildClientSchema = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_isObjectLike();
	init_keyValMap();
	init_parser();
	init_definition();
	init_directives();
	init_introspection();
	init_scalars();
	init_schema();
	init_valueFromAST();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/extendSchema.mjs
/**
* Produces a new schema given an existing schema and a document which may
* contain GraphQL type extensions and definitions. The original schema will
* remain unaltered.
*
* Because a schema represents a graph of references, a schema cannot be
* extended without effectively making an entire copy. We do not know until it's
* too late if subgraphs remain unchanged.
*
* This algorithm copies the provided schema, applying extensions while
* producing the copy. The original schema remains unaltered.
*/
function extendSchema(schema, documentAST, options) {
	assertSchema(schema);
	documentAST != null && documentAST.kind === Kind.DOCUMENT || devAssert(false, "Must provide valid Document AST.");
	if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) assertValidSDLExtension(documentAST, schema);
	const schemaConfig = schema.toConfig();
	const extendedConfig = extendSchemaImpl(schemaConfig, documentAST, options);
	return schemaConfig === extendedConfig ? schema : new GraphQLSchema(extendedConfig);
}
/**
* @internal
*/
function extendSchemaImpl(schemaConfig, documentAST, options) {
	var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
	const typeDefs = [];
	const typeExtensionsMap = Object.create(null);
	const directiveDefs = [];
	let schemaDef;
	const schemaExtensions = [];
	for (const def of documentAST.definitions) if (def.kind === Kind.SCHEMA_DEFINITION) schemaDef = def;
	else if (def.kind === Kind.SCHEMA_EXTENSION) schemaExtensions.push(def);
	else if (isTypeDefinitionNode(def)) typeDefs.push(def);
	else if (isTypeExtensionNode(def)) {
		const extendedTypeName = def.name.value;
		const existingTypeExtensions = typeExtensionsMap[extendedTypeName];
		typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([def]) : [def];
	} else if (def.kind === Kind.DIRECTIVE_DEFINITION) directiveDefs.push(def);
	if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
	const typeMap = Object.create(null);
	for (const existingType of schemaConfig.types) typeMap[existingType.name] = extendNamedType(existingType);
	for (const typeNode of typeDefs) {
		var _stdTypeMap$name;
		const name = typeNode.name.value;
		typeMap[name] = (_stdTypeMap$name = stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
	}
	const operationTypes = {
		query: schemaConfig.query && replaceNamedType(schemaConfig.query),
		mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
		subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription),
		...schemaDef && getOperationTypes([schemaDef]),
		...getOperationTypes(schemaExtensions)
	};
	return {
		description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value,
		...operationTypes,
		types: Object.values(typeMap),
		directives: [...schemaConfig.directives.map(replaceDirective), ...directiveDefs.map(buildDirective)],
		extensions: Object.create(null),
		astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
		extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
		assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
	};
	function replaceType(type) {
		if (isListType(type)) return new GraphQLList(replaceType(type.ofType));
		if (isNonNullType(type)) return new GraphQLNonNull(replaceType(type.ofType));
		return replaceNamedType(type);
	}
	function replaceNamedType(type) {
		return typeMap[type.name];
	}
	function replaceDirective(directive) {
		const config = directive.toConfig();
		return new GraphQLDirective({
			...config,
			args: mapValue(config.args, extendArg)
		});
	}
	function extendNamedType(type) {
		if (isIntrospectionType(type) || isSpecifiedScalarType(type)) return type;
		if (isScalarType(type)) return extendScalarType(type);
		if (isObjectType(type)) return extendObjectType(type);
		if (isInterfaceType(type)) return extendInterfaceType(type);
		if (isUnionType(type)) return extendUnionType(type);
		if (isEnumType(type)) return extendEnumType(type);
		if (isInputObjectType(type)) return extendInputObjectType(type);
		/* c8 ignore next 3 */
		invariant(false, "Unexpected type: " + inspect(type));
	}
	function extendInputObjectType(type) {
		var _typeExtensionsMap$co;
		const config = type.toConfig();
		const extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
		return new GraphQLInputObjectType({
			...config,
			fields: () => ({
				...mapValue(config.fields, (field) => ({
					...field,
					type: replaceType(field.type)
				})),
				...buildInputFieldMap(extensions)
			}),
			extensionASTNodes: config.extensionASTNodes.concat(extensions)
		});
	}
	function extendEnumType(type) {
		var _typeExtensionsMap$ty;
		const config = type.toConfig();
		const extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
		return new GraphQLEnumType({
			...config,
			values: {
				...config.values,
				...buildEnumValueMap(extensions)
			},
			extensionASTNodes: config.extensionASTNodes.concat(extensions)
		});
	}
	function extendScalarType(type) {
		var _typeExtensionsMap$co2;
		const config = type.toConfig();
		const extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
		let specifiedByURL = config.specifiedByURL;
		for (const extensionNode of extensions) {
			var _getSpecifiedByURL;
			specifiedByURL = (_getSpecifiedByURL = getSpecifiedByURL(extensionNode)) !== null && _getSpecifiedByURL !== void 0 ? _getSpecifiedByURL : specifiedByURL;
		}
		return new GraphQLScalarType({
			...config,
			specifiedByURL,
			extensionASTNodes: config.extensionASTNodes.concat(extensions)
		});
	}
	function extendObjectType(type) {
		var _typeExtensionsMap$co3;
		const config = type.toConfig();
		const extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
		return new GraphQLObjectType({
			...config,
			interfaces: () => [...type.getInterfaces().map(replaceNamedType), ...buildInterfaces(extensions)],
			fields: () => ({
				...mapValue(config.fields, extendField),
				...buildFieldMap(extensions)
			}),
			extensionASTNodes: config.extensionASTNodes.concat(extensions)
		});
	}
	function extendInterfaceType(type) {
		var _typeExtensionsMap$co4;
		const config = type.toConfig();
		const extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
		return new GraphQLInterfaceType({
			...config,
			interfaces: () => [...type.getInterfaces().map(replaceNamedType), ...buildInterfaces(extensions)],
			fields: () => ({
				...mapValue(config.fields, extendField),
				...buildFieldMap(extensions)
			}),
			extensionASTNodes: config.extensionASTNodes.concat(extensions)
		});
	}
	function extendUnionType(type) {
		var _typeExtensionsMap$co5;
		const config = type.toConfig();
		const extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
		return new GraphQLUnionType({
			...config,
			types: () => [...type.getTypes().map(replaceNamedType), ...buildUnionTypes(extensions)],
			extensionASTNodes: config.extensionASTNodes.concat(extensions)
		});
	}
	function extendField(field) {
		return {
			...field,
			type: replaceType(field.type),
			args: field.args && mapValue(field.args, extendArg)
		};
	}
	function extendArg(arg) {
		return {
			...arg,
			type: replaceType(arg.type)
		};
	}
	function getOperationTypes(nodes) {
		const opTypes = {};
		for (const node of nodes) {
			var _node$operationTypes;
			const operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
			for (const operationType of operationTypesNodes) opTypes[operationType.operation] = getNamedType(operationType.type);
		}
		return opTypes;
	}
	function getNamedType(node) {
		var _stdTypeMap$name2;
		const name = node.name.value;
		const type = (_stdTypeMap$name2 = stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
		if (type === void 0) throw new Error(`Unknown type: "${name}".`);
		return type;
	}
	function getWrappedType(node) {
		if (node.kind === Kind.LIST_TYPE) return new GraphQLList(getWrappedType(node.type));
		if (node.kind === Kind.NON_NULL_TYPE) return new GraphQLNonNull(getWrappedType(node.type));
		return getNamedType(node);
	}
	function buildDirective(node) {
		var _node$description;
		return new GraphQLDirective({
			name: node.name.value,
			description: (_node$description = node.description) === null || _node$description === void 0 ? void 0 : _node$description.value,
			locations: node.locations.map(({ value }) => value),
			isRepeatable: node.repeatable,
			args: buildArgumentMap(node.arguments),
			astNode: node
		});
	}
	function buildFieldMap(nodes) {
		const fieldConfigMap = Object.create(null);
		for (const node of nodes) {
			var _node$fields;
			const nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
			for (const field of nodeFields) {
				var _field$description;
				fieldConfigMap[field.name.value] = {
					type: getWrappedType(field.type),
					description: (_field$description = field.description) === null || _field$description === void 0 ? void 0 : _field$description.value,
					args: buildArgumentMap(field.arguments),
					deprecationReason: getDeprecationReason(field),
					astNode: field
				};
			}
		}
		return fieldConfigMap;
	}
	function buildArgumentMap(args) {
		const argsNodes = args !== null && args !== void 0 ? args : [];
		const argConfigMap = Object.create(null);
		for (const arg of argsNodes) {
			var _arg$description;
			const type = getWrappedType(arg.type);
			argConfigMap[arg.name.value] = {
				type,
				description: (_arg$description = arg.description) === null || _arg$description === void 0 ? void 0 : _arg$description.value,
				defaultValue: valueFromAST(arg.defaultValue, type),
				deprecationReason: getDeprecationReason(arg),
				astNode: arg
			};
		}
		return argConfigMap;
	}
	function buildInputFieldMap(nodes) {
		const inputFieldMap = Object.create(null);
		for (const node of nodes) {
			var _node$fields2;
			const fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
			for (const field of fieldsNodes) {
				var _field$description2;
				const type = getWrappedType(field.type);
				inputFieldMap[field.name.value] = {
					type,
					description: (_field$description2 = field.description) === null || _field$description2 === void 0 ? void 0 : _field$description2.value,
					defaultValue: valueFromAST(field.defaultValue, type),
					deprecationReason: getDeprecationReason(field),
					astNode: field
				};
			}
		}
		return inputFieldMap;
	}
	function buildEnumValueMap(nodes) {
		const enumValueMap = Object.create(null);
		for (const node of nodes) {
			var _node$values;
			const valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
			for (const value of valuesNodes) {
				var _value$description;
				enumValueMap[value.name.value] = {
					description: (_value$description = value.description) === null || _value$description === void 0 ? void 0 : _value$description.value,
					deprecationReason: getDeprecationReason(value),
					astNode: value
				};
			}
		}
		return enumValueMap;
	}
	function buildInterfaces(nodes) {
		return nodes.flatMap((node) => {
			var _node$interfaces$map, _node$interfaces;
			return (_node$interfaces$map = (_node$interfaces = node.interfaces) === null || _node$interfaces === void 0 ? void 0 : _node$interfaces.map(getNamedType)) !== null && _node$interfaces$map !== void 0 ? _node$interfaces$map : [];
		});
	}
	function buildUnionTypes(nodes) {
		return nodes.flatMap((node) => {
			var _node$types$map, _node$types;
			return (_node$types$map = (_node$types = node.types) === null || _node$types === void 0 ? void 0 : _node$types.map(getNamedType)) !== null && _node$types$map !== void 0 ? _node$types$map : [];
		});
	}
	function buildType(astNode) {
		var _typeExtensionsMap$na;
		const name = astNode.name.value;
		const extensionASTNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
		switch (astNode.kind) {
			case Kind.OBJECT_TYPE_DEFINITION: {
				var _astNode$description;
				const allNodes = [astNode, ...extensionASTNodes];
				return new GraphQLObjectType({
					name,
					description: (_astNode$description = astNode.description) === null || _astNode$description === void 0 ? void 0 : _astNode$description.value,
					interfaces: () => buildInterfaces(allNodes),
					fields: () => buildFieldMap(allNodes),
					astNode,
					extensionASTNodes
				});
			}
			case Kind.INTERFACE_TYPE_DEFINITION: {
				var _astNode$description2;
				const allNodes = [astNode, ...extensionASTNodes];
				return new GraphQLInterfaceType({
					name,
					description: (_astNode$description2 = astNode.description) === null || _astNode$description2 === void 0 ? void 0 : _astNode$description2.value,
					interfaces: () => buildInterfaces(allNodes),
					fields: () => buildFieldMap(allNodes),
					astNode,
					extensionASTNodes
				});
			}
			case Kind.ENUM_TYPE_DEFINITION: {
				var _astNode$description3;
				const allNodes = [astNode, ...extensionASTNodes];
				return new GraphQLEnumType({
					name,
					description: (_astNode$description3 = astNode.description) === null || _astNode$description3 === void 0 ? void 0 : _astNode$description3.value,
					values: buildEnumValueMap(allNodes),
					astNode,
					extensionASTNodes
				});
			}
			case Kind.UNION_TYPE_DEFINITION: {
				var _astNode$description4;
				const allNodes = [astNode, ...extensionASTNodes];
				return new GraphQLUnionType({
					name,
					description: (_astNode$description4 = astNode.description) === null || _astNode$description4 === void 0 ? void 0 : _astNode$description4.value,
					types: () => buildUnionTypes(allNodes),
					astNode,
					extensionASTNodes
				});
			}
			case Kind.SCALAR_TYPE_DEFINITION:
				var _astNode$description5;
				return new GraphQLScalarType({
					name,
					description: (_astNode$description5 = astNode.description) === null || _astNode$description5 === void 0 ? void 0 : _astNode$description5.value,
					specifiedByURL: getSpecifiedByURL(astNode),
					astNode,
					extensionASTNodes
				});
			case Kind.INPUT_OBJECT_TYPE_DEFINITION: {
				var _astNode$description6;
				const allNodes = [astNode, ...extensionASTNodes];
				return new GraphQLInputObjectType({
					name,
					description: (_astNode$description6 = astNode.description) === null || _astNode$description6 === void 0 ? void 0 : _astNode$description6.value,
					fields: () => buildInputFieldMap(allNodes),
					astNode,
					extensionASTNodes
				});
			}
		}
	}
}
/**
* Given a field or enum value node, returns the string value for the
* deprecation reason.
*/
function getDeprecationReason(node) {
	const deprecated = getDirectiveValues(GraphQLDeprecatedDirective, node);
	return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
* Given a scalar node, returns the string value for the specifiedByURL.
*/
function getSpecifiedByURL(node) {
	const specifiedBy = getDirectiveValues(GraphQLSpecifiedByDirective, node);
	return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
var stdTypeMap;
var init_extendSchema = __esmMin((() => {
	init_devAssert();
	init_inspect();
	init_invariant();
	init_keyMap();
	init_mapValue();
	init_kinds();
	init_predicates();
	init_definition();
	init_directives();
	init_introspection();
	init_scalars();
	init_schema();
	init_validate();
	init_values();
	init_valueFromAST();
	stdTypeMap = keyMap([...specifiedScalarTypes, ...introspectionTypes], (type) => type.name);
}));
//#endregion
//#region ../../node_modules/graphql/utilities/buildASTSchema.mjs
/**
* This takes the ast of a schema document produced by the parse function in
* src/language/parser.js.
*
* If no schema definition is provided, then it will look for types named Query,
* Mutation and Subscription.
*
* Given that AST it constructs a GraphQLSchema. The resulting schema
* has no resolve methods, so execution will use default resolvers.
*/
function buildASTSchema(documentAST, options) {
	documentAST != null && documentAST.kind === Kind.DOCUMENT || devAssert(false, "Must provide valid Document AST.");
	if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) assertValidSDL(documentAST);
	const config = extendSchemaImpl({
		description: void 0,
		types: [],
		directives: [],
		extensions: Object.create(null),
		extensionASTNodes: [],
		assumeValid: false
	}, documentAST, options);
	if (config.astNode == null) for (const type of config.types) switch (type.name) {
		case "Query":
			config.query = type;
			break;
		case "Mutation":
			config.mutation = type;
			break;
		case "Subscription": config.subscription = type;
	}
	const directives = [...config.directives, ...specifiedDirectives.filter((stdDirective) => config.directives.every((directive) => directive.name !== stdDirective.name))];
	return new GraphQLSchema({
		...config,
		directives
	});
}
/**
* A helper function to build a GraphQLSchema directly from a source
* document.
*/
function buildSchema(source, options) {
	return buildASTSchema(parse(source, {
		noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
		allowLegacyFragmentVariables: options === null || options === void 0 ? void 0 : options.allowLegacyFragmentVariables
	}), {
		assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
		assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
	});
}
var init_buildASTSchema = __esmMin((() => {
	init_devAssert();
	init_kinds();
	init_parser();
	init_directives();
	init_schema();
	init_validate();
	init_extendSchema();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/lexicographicSortSchema.mjs
/**
* Sort GraphQLSchema.
*
* This function returns a sorted copy of the given GraphQLSchema.
*/
function lexicographicSortSchema(schema) {
	const schemaConfig = schema.toConfig();
	const typeMap = keyValMap(sortByName(schemaConfig.types), (type) => type.name, sortNamedType);
	return new GraphQLSchema({
		...schemaConfig,
		types: Object.values(typeMap),
		directives: sortByName(schemaConfig.directives).map(sortDirective),
		query: replaceMaybeType(schemaConfig.query),
		mutation: replaceMaybeType(schemaConfig.mutation),
		subscription: replaceMaybeType(schemaConfig.subscription)
	});
	function replaceType(type) {
		if (isListType(type)) return new GraphQLList(replaceType(type.ofType));
		else if (isNonNullType(type)) return new GraphQLNonNull(replaceType(type.ofType));
		return replaceNamedType(type);
	}
	function replaceNamedType(type) {
		return typeMap[type.name];
	}
	function replaceMaybeType(maybeType) {
		return maybeType && replaceNamedType(maybeType);
	}
	function sortDirective(directive) {
		const config = directive.toConfig();
		return new GraphQLDirective({
			...config,
			locations: sortBy(config.locations, (x) => x),
			args: sortArgs(config.args)
		});
	}
	function sortArgs(args) {
		return sortObjMap(args, (arg) => ({
			...arg,
			type: replaceType(arg.type)
		}));
	}
	function sortFields(fieldsMap) {
		return sortObjMap(fieldsMap, (field) => ({
			...field,
			type: replaceType(field.type),
			args: field.args && sortArgs(field.args)
		}));
	}
	function sortInputFields(fieldsMap) {
		return sortObjMap(fieldsMap, (field) => ({
			...field,
			type: replaceType(field.type)
		}));
	}
	function sortTypes(array) {
		return sortByName(array).map(replaceNamedType);
	}
	function sortNamedType(type) {
		if (isScalarType(type) || isIntrospectionType(type)) return type;
		if (isObjectType(type)) {
			const config = type.toConfig();
			return new GraphQLObjectType({
				...config,
				interfaces: () => sortTypes(config.interfaces),
				fields: () => sortFields(config.fields)
			});
		}
		if (isInterfaceType(type)) {
			const config = type.toConfig();
			return new GraphQLInterfaceType({
				...config,
				interfaces: () => sortTypes(config.interfaces),
				fields: () => sortFields(config.fields)
			});
		}
		if (isUnionType(type)) {
			const config = type.toConfig();
			return new GraphQLUnionType({
				...config,
				types: () => sortTypes(config.types)
			});
		}
		if (isEnumType(type)) {
			const config = type.toConfig();
			return new GraphQLEnumType({
				...config,
				values: sortObjMap(config.values, (value) => value)
			});
		}
		if (isInputObjectType(type)) {
			const config = type.toConfig();
			return new GraphQLInputObjectType({
				...config,
				fields: () => sortInputFields(config.fields)
			});
		}
		/* c8 ignore next 3 */
		invariant(false, "Unexpected type: " + inspect(type));
	}
}
function sortObjMap(map, sortValueFn) {
	const sortedMap = Object.create(null);
	for (const key of Object.keys(map).sort(naturalCompare)) sortedMap[key] = sortValueFn(map[key]);
	return sortedMap;
}
function sortByName(array) {
	return sortBy(array, (obj) => obj.name);
}
function sortBy(array, mapToKey) {
	return array.slice().sort((obj1, obj2) => {
		return naturalCompare(mapToKey(obj1), mapToKey(obj2));
	});
}
var init_lexicographicSortSchema = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_keyValMap();
	init_naturalCompare();
	init_definition();
	init_directives();
	init_introspection();
	init_schema();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/printSchema.mjs
function printSchema(schema) {
	return printFilteredSchema(schema, (n) => !isSpecifiedDirective(n), isDefinedType);
}
function printIntrospectionSchema(schema) {
	return printFilteredSchema(schema, isSpecifiedDirective, isIntrospectionType);
}
function isDefinedType(type) {
	return !isSpecifiedScalarType(type) && !isIntrospectionType(type);
}
function printFilteredSchema(schema, directiveFilter, typeFilter) {
	const directives = schema.getDirectives().filter(directiveFilter);
	const types = Object.values(schema.getTypeMap()).filter(typeFilter);
	return [
		printSchemaDefinition(schema),
		...directives.map((directive) => printDirective(directive)),
		...types.map((type) => printType(type))
	].filter(Boolean).join("\n\n");
}
function printSchemaDefinition(schema) {
	if (schema.description == null && isSchemaOfCommonNames(schema)) return;
	const operationTypes = [];
	const queryType = schema.getQueryType();
	if (queryType) operationTypes.push(`  query: ${queryType.name}`);
	const mutationType = schema.getMutationType();
	if (mutationType) operationTypes.push(`  mutation: ${mutationType.name}`);
	const subscriptionType = schema.getSubscriptionType();
	if (subscriptionType) operationTypes.push(`  subscription: ${subscriptionType.name}`);
	return printDescription(schema) + `schema {\n${operationTypes.join("\n")}\n}`;
}
/**
* GraphQL schema define root types for each type of operation. These types are
* the same as any other type and can be named in any manner, however there is
* a common naming convention:
*
* ```graphql
*   schema {
*     query: Query
*     mutation: Mutation
*     subscription: Subscription
*   }
* ```
*
* When using this naming convention, the schema description can be omitted.
*/
function isSchemaOfCommonNames(schema) {
	const queryType = schema.getQueryType();
	if (queryType && queryType.name !== "Query") return false;
	const mutationType = schema.getMutationType();
	if (mutationType && mutationType.name !== "Mutation") return false;
	const subscriptionType = schema.getSubscriptionType();
	if (subscriptionType && subscriptionType.name !== "Subscription") return false;
	return true;
}
function printType(type) {
	if (isScalarType(type)) return printScalar(type);
	if (isObjectType(type)) return printObject(type);
	if (isInterfaceType(type)) return printInterface(type);
	if (isUnionType(type)) return printUnion(type);
	if (isEnumType(type)) return printEnum(type);
	if (isInputObjectType(type)) return printInputObject(type);
	/* c8 ignore next 3 */
	invariant(false, "Unexpected type: " + inspect(type));
}
function printScalar(type) {
	return printDescription(type) + `scalar ${type.name}` + printSpecifiedByURL(type);
}
function printImplementedInterfaces(type) {
	const interfaces = type.getInterfaces();
	return interfaces.length ? " implements " + interfaces.map((i) => i.name).join(" & ") : "";
}
function printObject(type) {
	return printDescription(type) + `type ${type.name}` + printImplementedInterfaces(type) + printFields(type);
}
function printInterface(type) {
	return printDescription(type) + `interface ${type.name}` + printImplementedInterfaces(type) + printFields(type);
}
function printUnion(type) {
	const types = type.getTypes();
	const possibleTypes = types.length ? " = " + types.join(" | ") : "";
	return printDescription(type) + "union " + type.name + possibleTypes;
}
function printEnum(type) {
	const values = type.getValues().map((value, i) => printDescription(value, "  ", !i) + "  " + value.name + printDeprecated(value.deprecationReason));
	return printDescription(type) + `enum ${type.name}` + printBlock(values);
}
function printInputObject(type) {
	const fields = Object.values(type.getFields()).map((f, i) => printDescription(f, "  ", !i) + "  " + printInputValue(f));
	return printDescription(type) + `input ${type.name}` + printBlock(fields);
}
function printFields(type) {
	return printBlock(Object.values(type.getFields()).map((f, i) => printDescription(f, "  ", !i) + "  " + f.name + printArgs(f.args, "  ") + ": " + String(f.type) + printDeprecated(f.deprecationReason)));
}
function printBlock(items) {
	return items.length !== 0 ? " {\n" + items.join("\n") + "\n}" : "";
}
function printArgs(args, indentation = "") {
	if (args.length === 0) return "";
	if (args.every((arg) => !arg.description)) return "(" + args.map(printInputValue).join(", ") + ")";
	return "(\n" + args.map((arg, i) => printDescription(arg, "  " + indentation, !i) + "  " + indentation + printInputValue(arg)).join("\n") + "\n" + indentation + ")";
}
function printInputValue(arg) {
	const defaultAST = astFromValue(arg.defaultValue, arg.type);
	let argDecl = arg.name + ": " + String(arg.type);
	if (defaultAST) argDecl += ` = ${print(defaultAST)}`;
	return argDecl + printDeprecated(arg.deprecationReason);
}
function printDirective(directive) {
	return printDescription(directive) + "directive @" + directive.name + printArgs(directive.args) + (directive.isRepeatable ? " repeatable" : "") + " on " + directive.locations.join(" | ");
}
function printDeprecated(reason) {
	if (reason == null) return "";
	if (reason !== "No longer supported") return ` @deprecated(reason: ${print({
		kind: Kind.STRING,
		value: reason
	})})`;
	return " @deprecated";
}
function printSpecifiedByURL(scalar) {
	if (scalar.specifiedByURL == null) return "";
	return ` @specifiedBy(url: ${print({
		kind: Kind.STRING,
		value: scalar.specifiedByURL
	})})`;
}
function printDescription(def, indentation = "", firstInBlock = true) {
	const { description } = def;
	if (description == null) return "";
	const blockString = print({
		kind: Kind.STRING,
		value: description,
		block: isPrintableAsBlockString(description)
	});
	return (indentation && !firstInBlock ? "\n" + indentation : indentation) + blockString.replace(/\n/g, "\n" + indentation) + "\n";
}
var init_printSchema = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_blockString();
	init_kinds();
	init_printer();
	init_definition();
	init_directives();
	init_introspection();
	init_scalars();
	init_astFromValue();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/concatAST.mjs
/**
* Provided a collection of ASTs, presumably each from different files,
* concatenate the ASTs together into batched AST, useful for validating many
* GraphQL source files which together represent one conceptual application.
*/
function concatAST(documents) {
	const definitions = [];
	for (const doc of documents) definitions.push(...doc.definitions);
	return {
		kind: Kind.DOCUMENT,
		definitions
	};
}
var init_concatAST = __esmMin((() => {
	init_kinds();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/separateOperations.mjs
/**
* separateOperations accepts a single AST document which may contain many
* operations and fragments and returns a collection of AST documents each of
* which contains a single operation as well the fragment definitions it
* refers to.
*/
function separateOperations(documentAST) {
	const operations = [];
	const depGraph = Object.create(null);
	for (const definitionNode of documentAST.definitions) switch (definitionNode.kind) {
		case Kind.OPERATION_DEFINITION:
			operations.push(definitionNode);
			break;
		case Kind.FRAGMENT_DEFINITION: depGraph[definitionNode.name.value] = collectDependencies(definitionNode.selectionSet);
	}
	const separatedDocumentASTs = Object.create(null);
	for (const operation of operations) {
		const dependencies = /* @__PURE__ */ new Set();
		for (const fragmentName of collectDependencies(operation.selectionSet)) collectTransitiveDependencies(dependencies, depGraph, fragmentName);
		const operationName = operation.name ? operation.name.value : "";
		separatedDocumentASTs[operationName] = {
			kind: Kind.DOCUMENT,
			definitions: documentAST.definitions.filter((node) => node === operation || node.kind === Kind.FRAGMENT_DEFINITION && dependencies.has(node.name.value))
		};
	}
	return separatedDocumentASTs;
}
function collectTransitiveDependencies(collected, depGraph, fromName) {
	if (!collected.has(fromName)) {
		collected.add(fromName);
		const immediateDeps = depGraph[fromName];
		if (immediateDeps !== void 0) for (const toName of immediateDeps) collectTransitiveDependencies(collected, depGraph, toName);
	}
}
function collectDependencies(selectionSet) {
	const dependencies = [];
	visit(selectionSet, { FragmentSpread(node) {
		dependencies.push(node.name.value);
	} });
	return dependencies;
}
var init_separateOperations = __esmMin((() => {
	init_kinds();
	init_visitor();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/stripIgnoredCharacters.mjs
/**
* Strips characters that are not significant to the validity or execution
* of a GraphQL document:
*   - UnicodeBOM
*   - WhiteSpace
*   - LineTerminator
*   - Comment
*   - Comma
*   - BlockString indentation
*
* Note: It is required to have a delimiter character between neighboring
* non-punctuator tokens and this function always uses single space as delimiter.
*
* It is guaranteed that both input and output documents if parsed would result
* in the exact same AST except for nodes location.
*
* Warning: It is guaranteed that this function will always produce stable results.
* However, it's not guaranteed that it will stay the same between different
* releases due to bugfixes or changes in the GraphQL specification.
*
* Query example:
*
* ```graphql
* query SomeQuery($foo: String!, $bar: String) {
*   someField(foo: $foo, bar: $bar) {
*     a
*     b {
*       c
*       d
*     }
*   }
* }
* ```
*
* Becomes:
*
* ```graphql
* query SomeQuery($foo:String!$bar:String){someField(foo:$foo bar:$bar){a b{c d}}}
* ```
*
* SDL example:
*
* ```graphql
* """
* Type description
* """
* type Foo {
*   """
*   Field description
*   """
*   bar: String
* }
* ```
*
* Becomes:
*
* ```graphql
* """Type description""" type Foo{"""Field description""" bar:String}
* ```
*/
function stripIgnoredCharacters(source) {
	const sourceObj = isSource(source) ? source : new Source(source);
	const body = sourceObj.body;
	const lexer = new Lexer(sourceObj);
	let strippedBody = "";
	let wasLastAddedTokenNonPunctuator = false;
	while (lexer.advance().kind !== TokenKind.EOF) {
		const currentToken = lexer.token;
		const tokenKind = currentToken.kind;
		/**
		* Every two non-punctuator tokens should have space between them.
		* Also prevent case of non-punctuator token following by spread resulting
		* in invalid token (e.g. `1...` is invalid Float token).
		*/
		const isNonPunctuator = !isPunctuatorTokenKind(currentToken.kind);
		if (wasLastAddedTokenNonPunctuator) {
			if (isNonPunctuator || currentToken.kind === TokenKind.SPREAD) strippedBody += " ";
		}
		const tokenBody = body.slice(currentToken.start, currentToken.end);
		if (tokenKind === TokenKind.BLOCK_STRING) strippedBody += printBlockString(currentToken.value, { minimize: true });
		else strippedBody += tokenBody;
		wasLastAddedTokenNonPunctuator = isNonPunctuator;
	}
	return strippedBody;
}
var init_stripIgnoredCharacters = __esmMin((() => {
	init_blockString();
	init_lexer();
	init_source();
	init_tokenKind();
}));
//#endregion
//#region ../../node_modules/graphql/utilities/assertValidName.mjs
/* c8 ignore start */
/**
* Upholds the spec rules about naming.
* @deprecated Please use `assertName` instead. Will be removed in v17
*/
function assertValidName(name) {
	const error = isValidNameError(name);
	if (error) throw error;
	return name;
}
/**
* Returns an Error if a name is invalid.
* @deprecated Please use `assertName` instead. Will be removed in v17
*/
function isValidNameError(name) {
	typeof name === "string" || devAssert(false, "Expected name to be a string.");
	if (name.startsWith("__")) return new GraphQLError(`Name "${name}" must not begin with "__", which is reserved by GraphQL introspection.`);
	try {
		assertName(name);
	} catch (error) {
		return error;
	}
}
var init_assertValidName = __esmMin((() => {
	init_devAssert();
	init_GraphQLError();
	init_assertName();
}));
/* c8 ignore stop */
//#endregion
//#region ../../node_modules/graphql/utilities/findBreakingChanges.mjs
/**
* Given two schemas, returns an Array containing descriptions of all the types
* of breaking changes covered by the other functions down below.
*/
function findBreakingChanges(oldSchema, newSchema) {
	return findSchemaChanges(oldSchema, newSchema).filter((change) => change.type in BreakingChangeType);
}
/**
* Given two schemas, returns an Array containing descriptions of all the types
* of potentially dangerous changes covered by the other functions down below.
*/
function findDangerousChanges(oldSchema, newSchema) {
	return findSchemaChanges(oldSchema, newSchema).filter((change) => change.type in DangerousChangeType);
}
function findSchemaChanges(oldSchema, newSchema) {
	return [...findTypeChanges(oldSchema, newSchema), ...findDirectiveChanges(oldSchema, newSchema)];
}
function findDirectiveChanges(oldSchema, newSchema) {
	const schemaChanges = [];
	const directivesDiff = diff(oldSchema.getDirectives(), newSchema.getDirectives());
	for (const oldDirective of directivesDiff.removed) schemaChanges.push({
		type: BreakingChangeType.DIRECTIVE_REMOVED,
		description: `${oldDirective.name} was removed.`
	});
	for (const [oldDirective, newDirective] of directivesDiff.persisted) {
		const argsDiff = diff(oldDirective.args, newDirective.args);
		for (const newArg of argsDiff.added) if (isRequiredArgument(newArg)) schemaChanges.push({
			type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
			description: `A required arg ${newArg.name} on directive ${oldDirective.name} was added.`
		});
		for (const oldArg of argsDiff.removed) schemaChanges.push({
			type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
			description: `${oldArg.name} was removed from ${oldDirective.name}.`
		});
		if (oldDirective.isRepeatable && !newDirective.isRepeatable) schemaChanges.push({
			type: BreakingChangeType.DIRECTIVE_REPEATABLE_REMOVED,
			description: `Repeatable flag was removed from ${oldDirective.name}.`
		});
		for (const location of oldDirective.locations) if (!newDirective.locations.includes(location)) schemaChanges.push({
			type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
			description: `${location} was removed from ${oldDirective.name}.`
		});
	}
	return schemaChanges;
}
function findTypeChanges(oldSchema, newSchema) {
	const schemaChanges = [];
	const typesDiff = diff(Object.values(oldSchema.getTypeMap()), Object.values(newSchema.getTypeMap()));
	for (const oldType of typesDiff.removed) schemaChanges.push({
		type: BreakingChangeType.TYPE_REMOVED,
		description: isSpecifiedScalarType(oldType) ? `Standard scalar ${oldType.name} was removed because it is not referenced anymore.` : `${oldType.name} was removed.`
	});
	for (const [oldType, newType] of typesDiff.persisted) if (isEnumType(oldType) && isEnumType(newType)) schemaChanges.push(...findEnumTypeChanges(oldType, newType));
	else if (isUnionType(oldType) && isUnionType(newType)) schemaChanges.push(...findUnionTypeChanges(oldType, newType));
	else if (isInputObjectType(oldType) && isInputObjectType(newType)) schemaChanges.push(...findInputObjectTypeChanges(oldType, newType));
	else if (isObjectType(oldType) && isObjectType(newType)) schemaChanges.push(...findFieldChanges(oldType, newType), ...findImplementedInterfacesChanges(oldType, newType));
	else if (isInterfaceType(oldType) && isInterfaceType(newType)) schemaChanges.push(...findFieldChanges(oldType, newType), ...findImplementedInterfacesChanges(oldType, newType));
	else if (oldType.constructor !== newType.constructor) schemaChanges.push({
		type: BreakingChangeType.TYPE_CHANGED_KIND,
		description: `${oldType.name} changed from ${typeKindName(oldType)} to ${typeKindName(newType)}.`
	});
	return schemaChanges;
}
function findInputObjectTypeChanges(oldType, newType) {
	const schemaChanges = [];
	const fieldsDiff = diff(Object.values(oldType.getFields()), Object.values(newType.getFields()));
	for (const newField of fieldsDiff.added) if (isRequiredInputField(newField)) schemaChanges.push({
		type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
		description: `A required field ${newField.name} on input type ${oldType.name} was added.`
	});
	else schemaChanges.push({
		type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
		description: `An optional field ${newField.name} on input type ${oldType.name} was added.`
	});
	for (const oldField of fieldsDiff.removed) schemaChanges.push({
		type: BreakingChangeType.FIELD_REMOVED,
		description: `${oldType.name}.${oldField.name} was removed.`
	});
	for (const [oldField, newField] of fieldsDiff.persisted) if (!isChangeSafeForInputObjectFieldOrFieldArg(oldField.type, newField.type)) schemaChanges.push({
		type: BreakingChangeType.FIELD_CHANGED_KIND,
		description: `${oldType.name}.${oldField.name} changed type from ${String(oldField.type)} to ${String(newField.type)}.`
	});
	return schemaChanges;
}
function findUnionTypeChanges(oldType, newType) {
	const schemaChanges = [];
	const possibleTypesDiff = diff(oldType.getTypes(), newType.getTypes());
	for (const newPossibleType of possibleTypesDiff.added) schemaChanges.push({
		type: DangerousChangeType.TYPE_ADDED_TO_UNION,
		description: `${newPossibleType.name} was added to union type ${oldType.name}.`
	});
	for (const oldPossibleType of possibleTypesDiff.removed) schemaChanges.push({
		type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
		description: `${oldPossibleType.name} was removed from union type ${oldType.name}.`
	});
	return schemaChanges;
}
function findEnumTypeChanges(oldType, newType) {
	const schemaChanges = [];
	const valuesDiff = diff(oldType.getValues(), newType.getValues());
	for (const newValue of valuesDiff.added) schemaChanges.push({
		type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
		description: `${newValue.name} was added to enum type ${oldType.name}.`
	});
	for (const oldValue of valuesDiff.removed) schemaChanges.push({
		type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
		description: `${oldValue.name} was removed from enum type ${oldType.name}.`
	});
	return schemaChanges;
}
function findImplementedInterfacesChanges(oldType, newType) {
	const schemaChanges = [];
	const interfacesDiff = diff(oldType.getInterfaces(), newType.getInterfaces());
	for (const newInterface of interfacesDiff.added) schemaChanges.push({
		type: DangerousChangeType.IMPLEMENTED_INTERFACE_ADDED,
		description: `${newInterface.name} added to interfaces implemented by ${oldType.name}.`
	});
	for (const oldInterface of interfacesDiff.removed) schemaChanges.push({
		type: BreakingChangeType.IMPLEMENTED_INTERFACE_REMOVED,
		description: `${oldType.name} no longer implements interface ${oldInterface.name}.`
	});
	return schemaChanges;
}
function findFieldChanges(oldType, newType) {
	const schemaChanges = [];
	const fieldsDiff = diff(Object.values(oldType.getFields()), Object.values(newType.getFields()));
	for (const oldField of fieldsDiff.removed) schemaChanges.push({
		type: BreakingChangeType.FIELD_REMOVED,
		description: `${oldType.name}.${oldField.name} was removed.`
	});
	for (const [oldField, newField] of fieldsDiff.persisted) {
		schemaChanges.push(...findArgChanges(oldType, oldField, newField));
		if (!isChangeSafeForObjectOrInterfaceField(oldField.type, newField.type)) schemaChanges.push({
			type: BreakingChangeType.FIELD_CHANGED_KIND,
			description: `${oldType.name}.${oldField.name} changed type from ${String(oldField.type)} to ${String(newField.type)}.`
		});
	}
	return schemaChanges;
}
function findArgChanges(oldType, oldField, newField) {
	const schemaChanges = [];
	const argsDiff = diff(oldField.args, newField.args);
	for (const oldArg of argsDiff.removed) schemaChanges.push({
		type: BreakingChangeType.ARG_REMOVED,
		description: `${oldType.name}.${oldField.name} arg ${oldArg.name} was removed.`
	});
	for (const [oldArg, newArg] of argsDiff.persisted) if (!isChangeSafeForInputObjectFieldOrFieldArg(oldArg.type, newArg.type)) schemaChanges.push({
		type: BreakingChangeType.ARG_CHANGED_KIND,
		description: `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed type from ${String(oldArg.type)} to ${String(newArg.type)}.`
	});
	else if (oldArg.defaultValue !== void 0) {
		if (newArg.defaultValue === void 0) schemaChanges.push({
			type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
			description: `${oldType.name}.${oldField.name} arg ${oldArg.name} defaultValue was removed.`
		});
		else {
			const oldValueStr = stringifyValue(oldArg.defaultValue, oldArg.type);
			const newValueStr = stringifyValue(newArg.defaultValue, newArg.type);
			if (oldValueStr !== newValueStr) schemaChanges.push({
				type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
				description: `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed defaultValue from ${oldValueStr} to ${newValueStr}.`
			});
		}
	}
	for (const newArg of argsDiff.added) if (isRequiredArgument(newArg)) schemaChanges.push({
		type: BreakingChangeType.REQUIRED_ARG_ADDED,
		description: `A required arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`
	});
	else schemaChanges.push({
		type: DangerousChangeType.OPTIONAL_ARG_ADDED,
		description: `An optional arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`
	});
	return schemaChanges;
}
function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
	if (isListType(oldType)) return isListType(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) || isNonNullType(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType);
	if (isNonNullType(oldType)) return isNonNullType(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
	return isNamedType(newType) && oldType.name === newType.name || isNonNullType(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType);
}
function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
	if (isListType(oldType)) return isListType(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
	if (isNonNullType(oldType)) return isNonNullType(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) || !isNonNullType(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType);
	return isNamedType(newType) && oldType.name === newType.name;
}
function typeKindName(type) {
	if (isScalarType(type)) return "a Scalar type";
	if (isObjectType(type)) return "an Object type";
	if (isInterfaceType(type)) return "an Interface type";
	if (isUnionType(type)) return "a Union type";
	if (isEnumType(type)) return "an Enum type";
	if (isInputObjectType(type)) return "an Input type";
	/* c8 ignore next 3 */
	invariant(false, "Unexpected type: " + inspect(type));
}
function stringifyValue(value, type) {
	const ast = astFromValue(value, type);
	ast ?? invariant(false);
	return print(sortValueNode(ast));
}
function diff(oldArray, newArray) {
	const added = [];
	const removed = [];
	const persisted = [];
	const oldMap = keyMap(oldArray, ({ name }) => name);
	const newMap = keyMap(newArray, ({ name }) => name);
	for (const oldItem of oldArray) {
		const newItem = newMap[oldItem.name];
		if (newItem === void 0) removed.push(oldItem);
		else persisted.push([oldItem, newItem]);
	}
	for (const newItem of newArray) if (oldMap[newItem.name] === void 0) added.push(newItem);
	return {
		added,
		persisted,
		removed
	};
}
var BreakingChangeType, DangerousChangeType;
var init_findBreakingChanges = __esmMin((() => {
	init_inspect();
	init_invariant();
	init_keyMap();
	init_printer();
	init_definition();
	init_scalars();
	init_astFromValue();
	init_sortValueNode();
	(function(BreakingChangeType) {
		BreakingChangeType["TYPE_REMOVED"] = "TYPE_REMOVED";
		BreakingChangeType["TYPE_CHANGED_KIND"] = "TYPE_CHANGED_KIND";
		BreakingChangeType["TYPE_REMOVED_FROM_UNION"] = "TYPE_REMOVED_FROM_UNION";
		BreakingChangeType["VALUE_REMOVED_FROM_ENUM"] = "VALUE_REMOVED_FROM_ENUM";
		BreakingChangeType["REQUIRED_INPUT_FIELD_ADDED"] = "REQUIRED_INPUT_FIELD_ADDED";
		BreakingChangeType["IMPLEMENTED_INTERFACE_REMOVED"] = "IMPLEMENTED_INTERFACE_REMOVED";
		BreakingChangeType["FIELD_REMOVED"] = "FIELD_REMOVED";
		BreakingChangeType["FIELD_CHANGED_KIND"] = "FIELD_CHANGED_KIND";
		BreakingChangeType["REQUIRED_ARG_ADDED"] = "REQUIRED_ARG_ADDED";
		BreakingChangeType["ARG_REMOVED"] = "ARG_REMOVED";
		BreakingChangeType["ARG_CHANGED_KIND"] = "ARG_CHANGED_KIND";
		BreakingChangeType["DIRECTIVE_REMOVED"] = "DIRECTIVE_REMOVED";
		BreakingChangeType["DIRECTIVE_ARG_REMOVED"] = "DIRECTIVE_ARG_REMOVED";
		BreakingChangeType["REQUIRED_DIRECTIVE_ARG_ADDED"] = "REQUIRED_DIRECTIVE_ARG_ADDED";
		BreakingChangeType["DIRECTIVE_REPEATABLE_REMOVED"] = "DIRECTIVE_REPEATABLE_REMOVED";
		BreakingChangeType["DIRECTIVE_LOCATION_REMOVED"] = "DIRECTIVE_LOCATION_REMOVED";
	})(BreakingChangeType || (BreakingChangeType = {}));
	(function(DangerousChangeType) {
		DangerousChangeType["VALUE_ADDED_TO_ENUM"] = "VALUE_ADDED_TO_ENUM";
		DangerousChangeType["TYPE_ADDED_TO_UNION"] = "TYPE_ADDED_TO_UNION";
		DangerousChangeType["OPTIONAL_INPUT_FIELD_ADDED"] = "OPTIONAL_INPUT_FIELD_ADDED";
		DangerousChangeType["OPTIONAL_ARG_ADDED"] = "OPTIONAL_ARG_ADDED";
		DangerousChangeType["IMPLEMENTED_INTERFACE_ADDED"] = "IMPLEMENTED_INTERFACE_ADDED";
		DangerousChangeType["ARG_DEFAULT_VALUE_CHANGE"] = "ARG_DEFAULT_VALUE_CHANGE";
	})(DangerousChangeType || (DangerousChangeType = {}));
}));
//#endregion
//#region ../../node_modules/graphql/utilities/index.mjs
var init_utilities = __esmMin((() => {
	init_getIntrospectionQuery();
	init_getOperationAST();
	init_getOperationRootType();
	init_introspectionFromSchema();
	init_buildClientSchema();
	init_buildASTSchema();
	init_extendSchema();
	init_lexicographicSortSchema();
	init_printSchema();
	init_typeFromAST();
	init_valueFromAST();
	init_valueFromASTUntyped();
	init_astFromValue();
	init_TypeInfo();
	init_coerceInputValue();
	init_concatAST();
	init_separateOperations();
	init_stripIgnoredCharacters();
	init_typeComparators();
	init_assertValidName();
	init_findBreakingChanges();
}));
//#endregion
//#region ../../node_modules/graphql/index.mjs
var graphql_exports = /* @__PURE__ */ __exportAll({
	BREAK: () => BREAK,
	BreakingChangeType: () => BreakingChangeType,
	DEFAULT_DEPRECATION_REASON: () => DEFAULT_DEPRECATION_REASON,
	DangerousChangeType: () => DangerousChangeType,
	DirectiveLocation: () => DirectiveLocation,
	ExecutableDefinitionsRule: () => ExecutableDefinitionsRule,
	FieldsOnCorrectTypeRule: () => FieldsOnCorrectTypeRule,
	FragmentsOnCompositeTypesRule: () => FragmentsOnCompositeTypesRule,
	GRAPHQL_MAX_INT: () => GRAPHQL_MAX_INT,
	GRAPHQL_MIN_INT: () => GRAPHQL_MIN_INT,
	GraphQLBoolean: () => GraphQLBoolean,
	GraphQLDeprecatedDirective: () => GraphQLDeprecatedDirective,
	GraphQLDirective: () => GraphQLDirective,
	GraphQLEnumType: () => GraphQLEnumType,
	GraphQLError: () => GraphQLError,
	GraphQLFloat: () => GraphQLFloat,
	GraphQLID: () => GraphQLID,
	GraphQLIncludeDirective: () => GraphQLIncludeDirective,
	GraphQLInputObjectType: () => GraphQLInputObjectType,
	GraphQLInt: () => GraphQLInt,
	GraphQLInterfaceType: () => GraphQLInterfaceType,
	GraphQLList: () => GraphQLList,
	GraphQLNonNull: () => GraphQLNonNull,
	GraphQLObjectType: () => GraphQLObjectType,
	GraphQLScalarType: () => GraphQLScalarType,
	GraphQLSchema: () => GraphQLSchema,
	GraphQLSkipDirective: () => GraphQLSkipDirective,
	GraphQLSpecifiedByDirective: () => GraphQLSpecifiedByDirective,
	GraphQLString: () => GraphQLString,
	GraphQLUnionType: () => GraphQLUnionType,
	Kind: () => Kind,
	KnownArgumentNamesRule: () => KnownArgumentNamesRule,
	KnownDirectivesRule: () => KnownDirectivesRule,
	KnownFragmentNamesRule: () => KnownFragmentNamesRule,
	KnownTypeNamesRule: () => KnownTypeNamesRule,
	Lexer: () => Lexer,
	Location: () => Location,
	LoneAnonymousOperationRule: () => LoneAnonymousOperationRule,
	LoneSchemaDefinitionRule: () => LoneSchemaDefinitionRule,
	NoDeprecatedCustomRule: () => NoDeprecatedCustomRule,
	NoFragmentCyclesRule: () => NoFragmentCyclesRule,
	NoSchemaIntrospectionCustomRule: () => NoSchemaIntrospectionCustomRule,
	NoUndefinedVariablesRule: () => NoUndefinedVariablesRule,
	NoUnusedFragmentsRule: () => NoUnusedFragmentsRule,
	NoUnusedVariablesRule: () => NoUnusedVariablesRule,
	OperationTypeNode: () => OperationTypeNode,
	OverlappingFieldsCanBeMergedRule: () => OverlappingFieldsCanBeMergedRule,
	PossibleFragmentSpreadsRule: () => PossibleFragmentSpreadsRule,
	PossibleTypeExtensionsRule: () => PossibleTypeExtensionsRule,
	ProvidedRequiredArgumentsRule: () => ProvidedRequiredArgumentsRule,
	ScalarLeafsRule: () => ScalarLeafsRule,
	SchemaMetaFieldDef: () => SchemaMetaFieldDef,
	SingleFieldSubscriptionsRule: () => SingleFieldSubscriptionsRule,
	Source: () => Source,
	Token: () => Token,
	TokenKind: () => TokenKind,
	TypeInfo: () => TypeInfo,
	TypeKind: () => TypeKind,
	TypeMetaFieldDef: () => TypeMetaFieldDef,
	TypeNameMetaFieldDef: () => TypeNameMetaFieldDef,
	UniqueArgumentDefinitionNamesRule: () => UniqueArgumentDefinitionNamesRule,
	UniqueArgumentNamesRule: () => UniqueArgumentNamesRule,
	UniqueDirectiveNamesRule: () => UniqueDirectiveNamesRule,
	UniqueDirectivesPerLocationRule: () => UniqueDirectivesPerLocationRule,
	UniqueEnumValueNamesRule: () => UniqueEnumValueNamesRule,
	UniqueFieldDefinitionNamesRule: () => UniqueFieldDefinitionNamesRule,
	UniqueFragmentNamesRule: () => UniqueFragmentNamesRule,
	UniqueInputFieldNamesRule: () => UniqueInputFieldNamesRule,
	UniqueOperationNamesRule: () => UniqueOperationNamesRule,
	UniqueOperationTypesRule: () => UniqueOperationTypesRule,
	UniqueTypeNamesRule: () => UniqueTypeNamesRule,
	UniqueVariableNamesRule: () => UniqueVariableNamesRule,
	ValidationContext: () => ValidationContext,
	ValuesOfCorrectTypeRule: () => ValuesOfCorrectTypeRule,
	VariablesAreInputTypesRule: () => VariablesAreInputTypesRule,
	VariablesInAllowedPositionRule: () => VariablesInAllowedPositionRule,
	__Directive: () => __Directive,
	__DirectiveLocation: () => __DirectiveLocation,
	__EnumValue: () => __EnumValue,
	__Field: () => __Field,
	__InputValue: () => __InputValue,
	__Schema: () => __Schema,
	__Type: () => __Type,
	__TypeKind: () => __TypeKind,
	assertAbstractType: () => assertAbstractType,
	assertCompositeType: () => assertCompositeType,
	assertDirective: () => assertDirective,
	assertEnumType: () => assertEnumType,
	assertEnumValueName: () => assertEnumValueName,
	assertInputObjectType: () => assertInputObjectType,
	assertInputType: () => assertInputType,
	assertInterfaceType: () => assertInterfaceType,
	assertLeafType: () => assertLeafType,
	assertListType: () => assertListType,
	assertName: () => assertName,
	assertNamedType: () => assertNamedType,
	assertNonNullType: () => assertNonNullType,
	assertNullableType: () => assertNullableType,
	assertObjectType: () => assertObjectType,
	assertOutputType: () => assertOutputType,
	assertScalarType: () => assertScalarType,
	assertSchema: () => assertSchema,
	assertType: () => assertType,
	assertUnionType: () => assertUnionType,
	assertValidName: () => assertValidName,
	assertValidSchema: () => assertValidSchema,
	assertWrappingType: () => assertWrappingType,
	astFromValue: () => astFromValue,
	buildASTSchema: () => buildASTSchema,
	buildClientSchema: () => buildClientSchema,
	buildSchema: () => buildSchema,
	coerceInputValue: () => coerceInputValue,
	concatAST: () => concatAST,
	createSourceEventStream: () => createSourceEventStream,
	defaultFieldResolver: () => defaultFieldResolver,
	defaultTypeResolver: () => defaultTypeResolver,
	doTypesOverlap: () => doTypesOverlap,
	execute: () => execute,
	executeSync: () => executeSync,
	extendSchema: () => extendSchema,
	findBreakingChanges: () => findBreakingChanges,
	findDangerousChanges: () => findDangerousChanges,
	formatError: () => formatError,
	getArgumentValues: () => getArgumentValues,
	getDirectiveValues: () => getDirectiveValues,
	getEnterLeaveForKind: () => getEnterLeaveForKind,
	getIntrospectionQuery: () => getIntrospectionQuery,
	getLocation: () => getLocation,
	getNamedType: () => getNamedType,
	getNullableType: () => getNullableType,
	getOperationAST: () => getOperationAST,
	getOperationRootType: () => getOperationRootType,
	getVariableValues: () => getVariableValues,
	getVisitFn: () => getVisitFn,
	graphql: () => graphql,
	graphqlSync: () => graphqlSync,
	introspectionFromSchema: () => introspectionFromSchema,
	introspectionTypes: () => introspectionTypes,
	isAbstractType: () => isAbstractType,
	isCompositeType: () => isCompositeType,
	isConstValueNode: () => isConstValueNode,
	isDefinitionNode: () => isDefinitionNode,
	isDirective: () => isDirective,
	isEnumType: () => isEnumType,
	isEqualType: () => isEqualType,
	isExecutableDefinitionNode: () => isExecutableDefinitionNode,
	isInputObjectType: () => isInputObjectType,
	isInputType: () => isInputType,
	isInterfaceType: () => isInterfaceType,
	isIntrospectionType: () => isIntrospectionType,
	isLeafType: () => isLeafType,
	isListType: () => isListType,
	isNamedType: () => isNamedType,
	isNonNullType: () => isNonNullType,
	isNullableType: () => isNullableType,
	isObjectType: () => isObjectType,
	isOutputType: () => isOutputType,
	isRequiredArgument: () => isRequiredArgument,
	isRequiredInputField: () => isRequiredInputField,
	isScalarType: () => isScalarType,
	isSchema: () => isSchema,
	isSelectionNode: () => isSelectionNode,
	isSpecifiedDirective: () => isSpecifiedDirective,
	isSpecifiedScalarType: () => isSpecifiedScalarType,
	isType: () => isType,
	isTypeDefinitionNode: () => isTypeDefinitionNode,
	isTypeExtensionNode: () => isTypeExtensionNode,
	isTypeNode: () => isTypeNode,
	isTypeSubTypeOf: () => isTypeSubTypeOf,
	isTypeSystemDefinitionNode: () => isTypeSystemDefinitionNode,
	isTypeSystemExtensionNode: () => isTypeSystemExtensionNode,
	isUnionType: () => isUnionType,
	isValidNameError: () => isValidNameError,
	isValueNode: () => isValueNode,
	isWrappingType: () => isWrappingType,
	lexicographicSortSchema: () => lexicographicSortSchema,
	locatedError: () => locatedError,
	parse: () => parse,
	parseConstValue: () => parseConstValue,
	parseType: () => parseType,
	parseValue: () => parseValue,
	print: () => print,
	printError: () => printError,
	printIntrospectionSchema: () => printIntrospectionSchema,
	printLocation: () => printLocation,
	printSchema: () => printSchema,
	printSourceLocation: () => printSourceLocation,
	printType: () => printType,
	resolveObjMapThunk: () => resolveObjMapThunk,
	resolveReadonlyArrayThunk: () => resolveReadonlyArrayThunk,
	responsePathAsArray: () => pathToArray,
	separateOperations: () => separateOperations,
	specifiedDirectives: () => specifiedDirectives,
	specifiedRules: () => specifiedRules,
	specifiedScalarTypes: () => specifiedScalarTypes,
	stripIgnoredCharacters: () => stripIgnoredCharacters,
	subscribe: () => subscribe$1,
	syntaxError: () => syntaxError,
	typeFromAST: () => typeFromAST,
	validate: () => validate,
	validateSchema: () => validateSchema,
	valueFromAST: () => valueFromAST,
	valueFromASTUntyped: () => valueFromASTUntyped,
	version: () => version,
	versionInfo: () => versionInfo,
	visit: () => visit,
	visitInParallel: () => visitInParallel,
	visitWithTypeInfo: () => visitWithTypeInfo
});
var init_graphql = __esmMin((() => {
	init_version();
	init_graphql$1();
	init_type();
	init_language();
	init_execution();
	init_validation();
	init_error();
	init_utilities();
}));
//#endregion
//#region ../common/lib/errors.js
var require_errors$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.handleCaughtError = exports.createClientErrors = exports.createClientError = exports.createError = exports.createNamedErrorClass = exports.ErrorWithStatusCode = exports.ExtendedGraphQLErrors = void 0;
	var graphql_1 = (init_graphql(), __toCommonJS(graphql_exports));
	var enums_1 = require_enums();
	var ExtendedGraphQLErrors = class extends graphql_1.GraphQLError {
		constructor(errors) {
			super("Operation failed with one or more errors.");
			this.extensions = {
				code: "EXTENDED_GRAPHQL_ERRORS",
				errors
			};
		}
	};
	exports.ExtendedGraphQLErrors = ExtendedGraphQLErrors;
	var ErrorWithStatusCode = class extends Error {
		constructor(message, name, statusCode = enums_1.ErrorStatusCode.INTERNAL_SERVER_ERROR) {
			super(message);
			this.name = name || this.constructor.name;
			this.statusCode = statusCode;
		}
	};
	exports.ErrorWithStatusCode = ErrorWithStatusCode;
	/**
	* Factory function to create a simple named Error class.
	*
	* @param className class name
	* @param statusCode error status code
	*/
	var createNamedErrorClass = (className, errorStatusCode = enums_1.ErrorStatusCode.INTERNAL_SERVER_ERROR) => {
		const NewErrorClass = class extends ErrorWithStatusCode {
			constructor(message, name = className, statusCode = errorStatusCode) {
				super(message);
				this.name = name;
				this.statusCode = statusCode;
			}
		};
		Object.defineProperty(NewErrorClass, "name", { value: className });
		return NewErrorClass;
	};
	exports.createNamedErrorClass = createNamedErrorClass;
	/**
	* Factory function to create one off named error for sentry. Named errors are useful for grouping errors in sentry and
	* improving the way they are displayed in Slack.
	*
	* @param name class name
	* @param message error message
	* @param statusCode error status code
	*/
	var createError = (name, message, statusCode) => new ((0, exports.createNamedErrorClass)(name, statusCode))(message);
	exports.createError = createError;
	var createClientError = (description, code = "BAD_REQUEST", className = "ExtendedGraphQLErrors") => {
		const error = new ExtendedGraphQLErrors([{
			code,
			description
		}]);
		Object.defineProperty(error, "name", { value: className });
		return error;
	};
	exports.createClientError = createClientError;
	var createClientErrors = (errors, className = "ExtendedGraphQLErrors") => {
		const error = new ExtendedGraphQLErrors(errors);
		Object.defineProperty(error, "name", { value: className });
		return error;
	};
	exports.createClientErrors = createClientErrors;
	/**
	* @param err error caught in a try/catch
	* @param expectedErrorClass class expected to be in the error's prototype chain
	* @param errorHandler function used to handle error if class expectedInPrototype is found in its prototype chain
	* @throws UnexpectedPrimitiveErrorType is error is a primitive type.
	*/
	var handleCaughtError = (err, expectedErrorClass, errorHandler) => {
		if (err instanceof expectedErrorClass) return errorHandler(err);
		console.error((0, exports.createError)("UnexpectedErrorType", err));
		throw (0, exports.createError)("UnexpectedErrorType", "Please check logs for details.");
	};
	exports.handleCaughtError = handleCaughtError;
}));
//#endregion
//#region ../common/lib/date.utils.js
var require_date_utils = /* @__PURE__ */ __commonJSMin(((exports, module, this$21) => {
	var __importDefault = this$21 && this$21.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getNextMonthYear = exports.getPreviousMonthYear = exports.isDateInMonthYearRange = exports.isTaxYearTraditional = exports.subtractMonths = exports.addMonths = exports.getEndOfDay = exports.getFirstDayOfTheMonth = exports.getLastDayOfTheMonth = exports.getMonthLongAbbreviation = exports.getMonthShortAbbreviation = exports.placedInServiceDate = exports.isStandardFiscalYear = exports.getFirstDayOfPeriodByLastDay = exports.removeZeroPadding = exports.addZeroPadding = exports.isAfterInitialTaxDeadline = exports.toIsoDateString = exports.currentDateToIsoString = exports.getLastDayOfTheYear = exports.sameDateString = exports.isLeapYear = exports.upperBoundForTaxReturnFilingDate = exports.getEndOfYear = exports.getStartOfYear = exports.getEntryForTaxYear = exports.getEntryForCurrentTaxYear = exports.getYearFromStringDate = exports.isDateString = exports.isDatetime = exports.getDatetime = exports.getCurrentDatetime = exports.getCurrentYear = exports.getCurrentDateObject = exports.getCurrentDate = exports.longDateFormat = exports.americanDateFormat = exports.formatDate = exports.formatDayjs = exports.endOfFiscalYearDate = exports.getCurrentTaxYear = exports.getExtensionTaxDeadline = exports.getInitialTaxDeadline = exports.isYyyyMmDd = exports.dateToDayjs = void 0;
	var dayjs_1 = __importDefault(require_dayjs_min());
	var customParseFormat_1 = __importDefault(require_customParseFormat());
	var isLeapYear_1 = __importDefault(require_isLeapYear());
	var utc_1 = __importDefault(require_utc());
	var enums_1 = require_enums();
	var errors_1 = require_errors$1();
	dayjs_1.default.extend(utc_1.default);
	dayjs_1.default.extend(customParseFormat_1.default);
	dayjs_1.default.extend(isLeapYear_1.default);
	var avoidWeekend = (date) => {
		if (date.get("day") === enums_1.DayOfWeek.SATURDAY) return date.add(2, "day");
		if (date.get("day") === enums_1.DayOfWeek.SUNDAY) return date.add(1, "day");
		return date;
	};
	var dateToDayjs = (date) => (0, dayjs_1.default)(date).utc();
	exports.dateToDayjs = dateToDayjs;
	var isYyyyMmDd = (date) => (0, dayjs_1.default)(date, "YYYY-MM-DD").isValid();
	exports.isYyyyMmDd = isYyyyMmDd;
	var getInitialTaxDeadline = (lastDayOfPeriod) => {
		if (!(0, exports.isYyyyMmDd)(lastDayOfPeriod)) throw (0, errors_1.createError)("InvalidDate", `Input (${lastDayOfPeriod}) could not be parsed into a Dayjs object`);
		const deadlineSetFifteen = (0, exports.dateToDayjs)(lastDayOfPeriod).add(4, "month").set("date", 15).endOf("day");
		switch (deadlineSetFifteen.day()) {
			case enums_1.DayOfWeek.FRIDAY:
			case enums_1.DayOfWeek.SATURDAY: return deadlineSetFifteen.add(3, "day");
			case enums_1.DayOfWeek.SUNDAY: return deadlineSetFifteen.add(2, "day");
			default: return deadlineSetFifteen;
		}
	};
	exports.getInitialTaxDeadline = getInitialTaxDeadline;
	/**
	* @param lastDayOfPeriod
	* lastDayOfPeriod should be in format: "YYYY-MM-DD"
	*/
	var getExtensionTaxDeadline = (lastDayOfPeriod) => {
		return avoidWeekend((0, exports.getInitialTaxDeadline)(lastDayOfPeriod).add(6, "month"));
	};
	exports.getExtensionTaxDeadline = getExtensionTaxDeadline;
	/**
	* @param lastDayOfPeriod
	* lastDayOfPeriod should be in format: "YYYY-MM-DD"
	*/
	var getCurrentTaxYear = (lastDayOfPeriod) => {
		const firstDayOfPeriod = (0, exports.getFirstDayOfPeriodByLastDay)(lastDayOfPeriod);
		return (0, exports.dateToDayjs)(firstDayOfPeriod).get("year");
	};
	exports.getCurrentTaxYear = getCurrentTaxYear;
	var endOfFiscalYearDate = (endOfFiscalYearMonth, year) => dayjs_1.default.utc().set("month", endOfFiscalYearMonth - 1).endOf("month").set("year", year).toDate();
	exports.endOfFiscalYearDate = endOfFiscalYearDate;
	var formatDayjs = (date) => date.format("YYYY-MM-DD");
	exports.formatDayjs = formatDayjs;
	var formatDate = (date) => dayjs_1.default.utc(date).format("YYYY-MM-DD");
	exports.formatDate = formatDate;
	var americanDateFormat = (date, options = { zeroPadded: true }) => (0, exports.dateToDayjs)(date).format(options.zeroPadded ? "MM/DD/YYYY" : "M/D/YYYY");
	exports.americanDateFormat = americanDateFormat;
	var longDateFormat = (date) => (0, exports.dateToDayjs)(date).format("MMMM D, YYYY");
	exports.longDateFormat = longDateFormat;
	var getCurrentDate = () => (0, exports.formatDayjs)(dayjs_1.default.utc());
	exports.getCurrentDate = getCurrentDate;
	var getCurrentDateObject = () => dayjs_1.default.utc().toDate();
	exports.getCurrentDateObject = getCurrentDateObject;
	var getCurrentYear = () => dayjs_1.default.utc().year();
	exports.getCurrentYear = getCurrentYear;
	var getCurrentDatetime = () => `${dayjs_1.default.utc().format("YYYYMMDDTHHmmssSSS")}Z`;
	exports.getCurrentDatetime = getCurrentDatetime;
	var getDatetime = (date) => `${dayjs_1.default.utc(date).format("YYYYMMDDTHHmmssSSS")}Z`;
	exports.getDatetime = getDatetime;
	var isDatetime = (date) => (0, dayjs_1.default)(date.substring(0, date.length - 1), "YYYYMMDDTHHmmssSSS").isValid();
	exports.isDatetime = isDatetime;
	var isDateString = (date) => new Date(date).toString() != "Invalid Date";
	exports.isDateString = isDateString;
	var getYearFromStringDate = (date) => {
		if (!(0, exports.isDateString)(date)) throw (0, errors_1.createError)("InvalidDate", `Input (${date}) could not be parsed into a Date object`);
		return new Date(date).getUTCFullYear();
	};
	exports.getYearFromStringDate = getYearFromStringDate;
	var getEntryForCurrentTaxYear = (entries, lastDayOfPeriod) => (0, exports.getEntryForTaxYear)(entries, (0, exports.getCurrentTaxYear)(lastDayOfPeriod));
	exports.getEntryForCurrentTaxYear = getEntryForCurrentTaxYear;
	var getEntryForTaxYear = (entries, year) => entries.find((e) => e.year === year) || null;
	exports.getEntryForTaxYear = getEntryForTaxYear;
	var getStartOfYear = (year) => `${year}-01-01`;
	exports.getStartOfYear = getStartOfYear;
	var getEndOfYear = (year) => `${year}-12-31`;
	exports.getEndOfYear = getEndOfYear;
	var upperBoundForTaxReturnFilingDate = (lastDayOfPeriod) => {
		const currentDate = dayjs_1.default.utc();
		return currentDate.isBefore((0, exports.getExtensionTaxDeadline)(lastDayOfPeriod)) ? currentDate : (0, exports.getExtensionTaxDeadline)(lastDayOfPeriod);
	};
	exports.upperBoundForTaxReturnFilingDate = upperBoundForTaxReturnFilingDate;
	var isLeapYear = (year) => (0, dayjs_1.default)(`${year}-01-01`).isLeapYear();
	exports.isLeapYear = isLeapYear;
	var sameDateString = (a, b) => (0, dayjs_1.default)(a).diff((0, dayjs_1.default)(b)) === 0;
	exports.sameDateString = sameDateString;
	var getLastDayOfTheYear = (date) => {
		const lastDayOfTheYear = new Date(date);
		lastDayOfTheYear.setUTCMonth(11);
		lastDayOfTheYear.setUTCDate(31);
		return lastDayOfTheYear;
	};
	exports.getLastDayOfTheYear = getLastDayOfTheYear;
	var currentDateToIsoString = () => dayjs_1.default.utc().toDate().toISOString();
	exports.currentDateToIsoString = currentDateToIsoString;
	/**
	* @param date Date object
	* @returns String with date in ISO format (YYYY-MM-DD)
	*/
	var toIsoDateString = (date) => date.toISOString().split("T")[0];
	exports.toIsoDateString = toIsoDateString;
	/**
	* @param date {Date} Defaults to current date if no value supplied
	* @returns {boolean} True if date is after the initial tax deadline for the year, otherwise false
	*/
	var isAfterInitialTaxDeadline = (lastDayOfPeriod, date = /* @__PURE__ */ new Date()) => {
		const initialTaxDeadline = (0, exports.getInitialTaxDeadline)(lastDayOfPeriod);
		return (0, dayjs_1.default)(date).isAfter(initialTaxDeadline);
	};
	exports.isAfterInitialTaxDeadline = isAfterInitialTaxDeadline;
	/**
	* Takes a string and adds zero in the beginning if value is a single digit. This ensures months/days will always be two characters long.
	* e.g '1' turns into '01'
	* @param monthOrDay string representation of a month or day. Not zero indexed. (1-12 for month) (1-31 for day)
	* @returns {string} returns value but adds zero padding if needed
	*/
	var addZeroPadding = (monthOrDay) => (0 + monthOrDay).slice(-2);
	exports.addZeroPadding = addZeroPadding;
	var removeZeroPadding = (zeroPaddedMonthOrDay) => parseInt(zeroPaddedMonthOrDay).toString();
	exports.removeZeroPadding = removeZeroPadding;
	var getFirstDayOfPeriodByLastDay = (lastDayOfPeriod) => {
		return (0, dayjs_1.default)(lastDayOfPeriod).utc().subtract(11, "months").startOf("month").toISOString();
	};
	exports.getFirstDayOfPeriodByLastDay = getFirstDayOfPeriodByLastDay;
	var isStandardFiscalYear = (startDate, endDate) => {
		if (!(0, exports.isYyyyMmDd)(startDate) || !(0, exports.isYyyyMmDd)(endDate)) throw (0, errors_1.createError)("InvalidDate", `Input (startDate: ${startDate} or endDate: ${endDate}) is not YYYY-MM-DD format.`);
		return startDate.endsWith("01-01") && endDate.endsWith("12-31");
	};
	exports.isStandardFiscalYear = isStandardFiscalYear;
	var placedInServiceDate = (endDate) => (0, exports.dateToDayjs)(endDate).subtract(6, "months").toDate();
	exports.placedInServiceDate = placedInServiceDate;
	/**
	* Get the 3-letter month abbreviation (Jan, Feb, ...)
	* @param month - value of the month to get abbreviation for (range 0 ~ 11)
	* @returns the month abbreviation
	*/
	var getMonthShortAbbreviation = (month) => {
		const date = /* @__PURE__ */ new Date();
		date.setDate(1);
		return Intl.DateTimeFormat("en-US", { month: "short" }).format(date.setMonth(month));
	};
	exports.getMonthShortAbbreviation = getMonthShortAbbreviation;
	var getMonthLongAbbreviation = (month) => {
		const date = /* @__PURE__ */ new Date();
		date.setDate(1);
		return Intl.DateTimeFormat("en-US", { month: "long" }).format(date.setMonth(month));
	};
	exports.getMonthLongAbbreviation = getMonthLongAbbreviation;
	var getLastDayOfTheMonth = (date) => {
		const lastDayOfTheMonth = new Date(date);
		lastDayOfTheMonth.setUTCDate(1);
		lastDayOfTheMonth.setUTCMonth(date.getUTCMonth() + 1);
		lastDayOfTheMonth.setUTCDate(0);
		return lastDayOfTheMonth;
	};
	exports.getLastDayOfTheMonth = getLastDayOfTheMonth;
	var getFirstDayOfTheMonth = (date) => {
		const firstDayOfTheMonth = new Date(date);
		firstDayOfTheMonth.setUTCDate(1);
		return firstDayOfTheMonth;
	};
	exports.getFirstDayOfTheMonth = getFirstDayOfTheMonth;
	var getEndOfDay = (date = /* @__PURE__ */ new Date()) => {
		const datetime = new Date(date);
		datetime.setUTCHours(23, 59, 59, 999);
		return datetime;
	};
	exports.getEndOfDay = getEndOfDay;
	var addMonths = (date, numberMonths) => {
		let datejs = (0, dayjs_1.default)(date).utc();
		datejs = datejs.add(numberMonths, "month");
		return datejs.format("YYYY-MM-DD");
	};
	exports.addMonths = addMonths;
	var subtractMonths = (date, monthCount) => (0, dayjs_1.default)(date).utc().subtract(monthCount, "month").toDate();
	exports.subtractMonths = subtractMonths;
	var isTaxYearTraditional = ({ firstDayOfPeriod, lastDayOfPeriod }) => {
		const firstDay = (0, exports.dateToDayjs)(firstDayOfPeriod).utc();
		const lastDay = (0, exports.dateToDayjs)(lastDayOfPeriod).utc();
		return firstDay.get("month") === 0 && firstDay.get("date") === 1 && lastDay.get("month") === 11 && lastDay.get("date") === 31;
	};
	exports.isTaxYearTraditional = isTaxYearTraditional;
	var isDateInMonthYearRange = (date, startMonthYear, endMonthYear) => {
		const year = date.getUTCFullYear();
		const month = date.getUTCMonth();
		if (year < startMonthYear.year || year > endMonthYear.year) return false;
		if (year === startMonthYear.year && month < startMonthYear.month) return false;
		if (year === endMonthYear.year && month > endMonthYear.month) return false;
		return true;
	};
	exports.isDateInMonthYearRange = isDateInMonthYearRange;
	var getPreviousMonthYear = (monthYear) => ({
		month: monthYear.month === 0 ? 11 : monthYear.month - 1,
		year: monthYear.month === 0 ? monthYear.year - 1 : monthYear.year
	});
	exports.getPreviousMonthYear = getPreviousMonthYear;
	var getNextMonthYear = (monthYear) => ({
		month: monthYear.month === 11 ? 0 : monthYear.month + 1,
		year: monthYear.month === 11 ? monthYear.year + 1 : monthYear.year
	});
	exports.getNextMonthYear = getNextMonthYear;
}));
//#endregion
//#region ../common/lib/organization-members-export.utils.js
var require_organization_members_export_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.organizationMembersFileName = void 0;
	/**
	* Names an organization members export after the organization and the UTC date it was taken, so a
	* reviewer collecting these every quarter can tell two exports apart without opening them. UTC
	* matches the dates written inside the file, so the name and the contents never disagree.
	*/
	var organizationMembersFileName = (organizationName, exportedOn) => {
		return `${organizationName.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "organization"}-members-${exportedOn.toISOString().slice(0, 10)}.csv`;
	};
	exports.organizationMembersFileName = organizationMembersFileName;
}));
//#endregion
//#region ../common/lib/month-year.utils.js
var require_month_year_utils = /* @__PURE__ */ __commonJSMin(((exports, module, this$20) => {
	var __importDefault = this$20 && this$20.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.calculateEarliestAffectedCapitalizationMonth = exports.CapitalizationChangeReason = exports.getMonthYearPeriodSuperset = exports.dateStringToReadableMonthYearString = exports.applyCompletedEndMonthYearRule = exports.getMonthYearPeriodUsingDates = exports.getTaxYearMonthYearPeriod = exports.getCurrentFiscalYearMonthYearPeriod = exports.getEarliestAndLatestMonthYear = exports.formatTaxPeriod = exports.formatFiscalPeriod = exports.formatFiscalOrTaxPeriod = exports.getPeriodName = exports.getMonthPeriodName = exports.MONTH_PERIOD_NAMES = exports.getLastQuarterInPeriod = exports.formatMonthYearPeriod = exports.formatMonthYear = exports.calculateQuarter = exports.doPeriodsOverlap = exports.getMonthYearPeriodIntersection = exports.areSameMonthYearPeriod = exports.isPeriodFullYear = exports.getNumberOfMonthsInPeriod = exports.getNumMonthsBetweenInclusively = exports.areMonthYearEqual = exports.isMonthYearBefore = exports.minMonthYear = exports.maxMonthYear = exports.sameMonthYear = exports.getMonthName = exports.getMonthsBetweenAsc = exports.generateMonthYearInRange = exports.getLastDateStringOfMonthYear = exports.getLastDateOfMonthYear = exports.getFirstDateOfMonthYear = exports.getFirstDateStringOfMonthYear = exports.stringToMonthYear = exports.dateToMonthYearString = exports.toMonthYearString = exports.toMonthYearPeriod = exports.dateToMonthYear = exports.isMonthYearInRange = exports.isMonthYearAfterOrEqual = exports.isMonthYearBeforeOrEqual = exports.isMonthYear = void 0;
	var dayjs_1 = __importDefault(require_dayjs_min());
	var utc_1 = __importDefault(require_utc());
	var date_utils_1 = require_date_utils();
	var enums_1 = require_enums();
	var errors_1 = require_errors$1();
	dayjs_1.default.extend(utc_1.default);
	var isMonthYear = (monthYear) => {
		if (!monthYear) return false;
		const { month, year } = monthYear;
		return typeof month === "number" && typeof year === "number";
	};
	exports.isMonthYear = isMonthYear;
	var isMonthYearBeforeOrEqual = (a, b) => a.year < b.year || a.year === b.year && a.month <= b.month;
	exports.isMonthYearBeforeOrEqual = isMonthYearBeforeOrEqual;
	var isMonthYearAfterOrEqual = (a, b) => a.year > b.year || a.year === b.year && a.month >= b.month;
	exports.isMonthYearAfterOrEqual = isMonthYearAfterOrEqual;
	/**
	* Check whether the <month, year> is inclusively within the given range
	* @param monthYear - the pair of month year
	* @param startMonthYear - the start of the range (inclusive)
	* @param endMonthYear - the end of the range (inclusive)
	* @example
	* isMonthYearInRange({ month: 2, year: 2020 }, { month: 1, year: 2020 }, { month: 3, year: 2020 }) // true
	* isMonthYearInRange({ month: 6, year: 2020 }, { month: 1, year: 2020 }, { month: 3, year: 2020 }) // false
	*/
	var isMonthYearInRange = (monthYear, startMonthYear, endMonthYear) => {
		const isAfterStart = (0, exports.isMonthYearAfterOrEqual)(monthYear, startMonthYear);
		const isBeforeEnd = (0, exports.isMonthYearBeforeOrEqual)(monthYear, endMonthYear);
		return isAfterStart && isBeforeEnd;
	};
	exports.isMonthYearInRange = isMonthYearInRange;
	/**
	* Convert a date to the <month, year> (ignoring the day of the month)
	*/
	var dateToMonthYear = (date) => {
		const result = new Date(date);
		result.setUTCDate(1);
		return {
			month: result.getUTCMonth(),
			year: result.getUTCFullYear()
		};
	};
	exports.dateToMonthYear = dateToMonthYear;
	var toMonthYearPeriod = (start, end) => {
		if (start > end) throw (0, errors_1.createError)("InvalidPeriod", "start must be before end");
		return {
			startMonthYear: (0, exports.dateToMonthYear)(start),
			endMonthYear: (0, exports.dateToMonthYear)(end)
		};
	};
	exports.toMonthYearPeriod = toMonthYearPeriod;
	/**
	* Get the YYYY-MM string of the {@link MonthYear} object.
	* @param monthYear - the month-year as a {@link MonthYear}
	* @returns a string in the format of YYYY-MM
	* @example
	* toMonthYearString({ month: 0, year: 2020 }) // '2020-01'
	* toMonthYearString({ month: 11, year: 2020 }) // '2020-12'
	*/
	var toMonthYearString = (monthYear) => {
		const month = (monthYear.month + 1).toString().padStart(2, "0");
		return `${monthYear.year}-${month}`;
	};
	exports.toMonthYearString = toMonthYearString;
	var dateToMonthYearString = (date) => {
		const monthYear = (0, exports.dateToMonthYear)(date);
		return (0, exports.toMonthYearString)(monthYear);
	};
	exports.dateToMonthYearString = dateToMonthYearString;
	/**
	* Get a {@link MonthYear} object from a YYYY-MM string.
	* @param monthYearString - a string in the format of YYYY-MM
	* @returns the month-year as a {@link MonthYear}
	* @example
	* stringToMonthYear('2020-01') // { month: 0, year: 2020 }
	* stringToMonthYear('2020-12') // { month: 11, year: 2020 }
	*/
	var stringToMonthYear = (monthYearString) => (0, exports.dateToMonthYear)(/* @__PURE__ */ new Date(`${monthYearString}-01`));
	exports.stringToMonthYear = stringToMonthYear;
	/**
	* Get the first day of the month in the given <month, year> as a string
	*/
	var getFirstDateStringOfMonthYear = (monthYear) => {
		return `${(0, exports.toMonthYearString)(monthYear)}-01`;
	};
	exports.getFirstDateStringOfMonthYear = getFirstDateStringOfMonthYear;
	/**
	* Get the first day of the month in the given <month, year> as a Date
	*/
	var getFirstDateOfMonthYear = (monthYear) => {
		const monthYearString = (0, exports.toMonthYearString)(monthYear);
		return dayjs_1.default.utc(`${monthYearString}-01`).toDate();
	};
	exports.getFirstDateOfMonthYear = getFirstDateOfMonthYear;
	/**
	* Get the last day of the month in the given <month, year> as a Date
	*/
	var getLastDateOfMonthYear = (monthYear) => {
		const monthYearString = (0, exports.toMonthYearString)(monthYear);
		return dayjs_1.default.utc(`${monthYearString}-01`).endOf("month").toDate();
	};
	exports.getLastDateOfMonthYear = getLastDateOfMonthYear;
	/**
	* Get the last day of the month in the given <month, year> as a string
	*/
	var getLastDateStringOfMonthYear = (monthYear) => {
		const monthYearString = typeof monthYear === "string" ? monthYear : (0, exports.toMonthYearString)(monthYear);
		return dayjs_1.default.utc(`${monthYearString}-01`).endOf("month").format("YYYY-MM-DD");
	};
	exports.getLastDateStringOfMonthYear = getLastDateStringOfMonthYear;
	var generateMonthYearInRange = (period) => {
		const nextMonthYear = (current) => ({
			year: current.month === 11 ? current.year + 1 : current.year,
			month: current.month === 11 ? 0 : current.month + 1
		});
		const inner = (startMonthYear, endMonthYear) => startMonthYear.year === endMonthYear.year && startMonthYear.month > endMonthYear.month || startMonthYear.year > endMonthYear.year ? [] : [startMonthYear, ...inner(nextMonthYear(startMonthYear), endMonthYear)];
		return inner(period.startMonthYear, period.endMonthYear);
	};
	exports.generateMonthYearInRange = generateMonthYearInRange;
	/**
	* @param startDate - inclusive
	* @param endDate - inclusive
	*/
	var getMonthsBetweenAsc = (startDate, endDate) => {
		if (startDate > endDate) throw new Error("startDate must be before endDate");
		const months = [];
		const date = new Date(startDate);
		while (date <= endDate) {
			date.setUTCDate(1);
			const month = date.getUTCMonth();
			months.push({
				month,
				year: date.getUTCFullYear()
			});
			date.setUTCMonth(date.getUTCMonth() + 1);
		}
		return months;
	};
	exports.getMonthsBetweenAsc = getMonthsBetweenAsc;
	var DAY_OF_MONTH = 15;
	var getMonthName = (month, formatOption = "short") => {
		const date = /* @__PURE__ */ new Date();
		date.setUTCMonth(month, DAY_OF_MONTH);
		return date.toLocaleString("default", { month: formatOption });
	};
	exports.getMonthName = getMonthName;
	var sameMonthYear = (a, b) => a.year === b.year && a.month === b.month;
	exports.sameMonthYear = sameMonthYear;
	/**
	* Given two month years return the greater month year
	*/
	var maxMonthYear = (a, b) => {
		if ((0, exports.isMonthYearBefore)(a, b)) return b;
		return a;
	};
	exports.maxMonthYear = maxMonthYear;
	var minMonthYear = (a, b) => {
		if ((0, exports.isMonthYearBefore)(a, b)) return a;
		return b;
	};
	exports.minMonthYear = minMonthYear;
	var isMonthYearBefore = (a, b) => {
		if (a.year < b.year) return true;
		else if (a.year > b.year) return false;
		return a.month < b.month;
	};
	exports.isMonthYearBefore = isMonthYearBefore;
	var areMonthYearEqual = (a, b) => a.year === b.year && a.month === b.month;
	exports.areMonthYearEqual = areMonthYearEqual;
	/**
	* Get the number of months between two MonthYear objects inclusively.
	*
	* @deprecated use {@link getNumberOfMonthsInPeriod} instead
	*/
	var getNumMonthsBetweenInclusively = (a, b) => {
		const yearDiff = b.year - a.year;
		const monthDiff = b.month - a.month;
		return yearDiff * 12 + monthDiff + 1;
	};
	exports.getNumMonthsBetweenInclusively = getNumMonthsBetweenInclusively;
	/**
	* Get the number of months between the time period (inclusive).
	*
	* @param monthYearPeriod - the period to calculate from
	* @returns number of months
	* @example calling getNumberOfMonthsInPeriod() on period { start: 2022/4, end: 2022/5 } returns 2
	* @example calling getNumberOfMonthsInPeriod() on period { start: 2021/10, end: 2022/5 } returns 8
	*/
	var getNumberOfMonthsInPeriod = (monthYearPeriod) => {
		const { endMonthYear, startMonthYear } = monthYearPeriod;
		const difference = 12 * (endMonthYear.year - startMonthYear.year) + (endMonthYear.month - startMonthYear.month);
		if (difference < 0) throw (0, errors_1.createError)("InvalidPeriodError", "Start of the period should be earlier than the end of it");
		return difference + 1;
	};
	exports.getNumberOfMonthsInPeriod = getNumberOfMonthsInPeriod;
	var isPeriodFullYear = (period) => {
		return (0, exports.getNumberOfMonthsInPeriod)(period) === 12;
	};
	exports.isPeriodFullYear = isPeriodFullYear;
	var areSameMonthYearPeriod = (a, b) => a.startMonthYear.month === b.startMonthYear.month && a.startMonthYear.year === b.startMonthYear.year && a.endMonthYear.month === b.endMonthYear.month && a.endMonthYear.year === b.endMonthYear.year;
	exports.areSameMonthYearPeriod = areSameMonthYearPeriod;
	/**
	* Determines the intersection of two MonthYearPeriods, which is defined as the maximum of the start MonthYears and the
	* minimum of the end MonthYears. If the maximum start MonthYear is later than the minimum end MonthYear, there is no
	* intersection.
	*/
	var getMonthYearPeriodIntersection = (periods) => {
		if (periods.length < 2) throw new Error("Must provide at least two MonthYearPeriods to find intersection");
		const periodIntersection = periods.reduce((memo, period) => {
			return {
				startMonthYear: (0, exports.maxMonthYear)(memo.startMonthYear, period.startMonthYear),
				endMonthYear: (0, exports.minMonthYear)(memo.endMonthYear, period.endMonthYear)
			};
		}, { ...periods[0] });
		if ((0, exports.isMonthYearBefore)(periodIntersection.endMonthYear, periodIntersection.startMonthYear)) throw new Error("No intersection between the given MonthYearPeriods");
		return periodIntersection;
	};
	exports.getMonthYearPeriodIntersection = getMonthYearPeriodIntersection;
	/**
	* Returns true if the two periods overlap, false otherwise.
	* @param period1 - the first period
	* @param period2 - the second period
	* @returns true if the periods overlap, false otherwise
	*/
	var doPeriodsOverlap = (period1, period2) => {
		const startMonthYear = (0, exports.maxMonthYear)(period1.startMonthYear, period2.startMonthYear);
		const endMonthYear = (0, exports.minMonthYear)(period1.endMonthYear, period2.endMonthYear);
		return !(0, exports.isMonthYearBefore)(endMonthYear, startMonthYear);
	};
	exports.doPeriodsOverlap = doPeriodsOverlap;
	/**
	* Returns the quarter number for a given month.
	* @param month represents a month in a year, 0-indexed like Date.getMonth()
	* @param fiscalYearEndMonth represents the last month in the year, 0-indexed like Date.getMonth()
	* @returns quarter number
	*/
	var calculateQuarter = (month, fiscalYearEndMonth = 11) => {
		const normalizedMonth = (month + (11 - fiscalYearEndMonth)) % 12 + 1;
		return Math.ceil(normalizedMonth / 3);
	};
	exports.calculateQuarter = calculateQuarter;
	/**
	* @example Jan '23
	*/
	var formatMonthYear = (monthYear) => {
		return `${(0, exports.getFirstDateOfMonthYear)(monthYear).toLocaleString("default", {
			month: "short",
			timeZone: "UTC"
		})} '${monthYear.year.toString().slice(-2)}`;
	};
	exports.formatMonthYear = formatMonthYear;
	/**
	* @example { start: "Feb '22", end: "Jan '23" }
	*/
	var formatMonthYearPeriod = (period) => ({
		start: (0, exports.formatMonthYear)(period.startMonthYear),
		end: (0, exports.formatMonthYear)(period.endMonthYear)
	});
	exports.formatMonthYearPeriod = formatMonthYearPeriod;
	var getLastQuarterInPeriod = (period, fiscalYearEndMonth) => {
		if (period.endMonthYear.month === fiscalYearEndMonth) return enums_1.PeriodName.Q4;
		if ((period.endMonthYear.month + 3 - fiscalYearEndMonth + 12) % 12 === 0) return enums_1.PeriodName.Q3;
		if ((period.endMonthYear.month + 6 - fiscalYearEndMonth + 12) % 12 === 0) return enums_1.PeriodName.Q2;
		if ((period.endMonthYear.month + 9 - fiscalYearEndMonth + 12) % 12 === 0) return enums_1.PeriodName.Q1;
		throw (0, errors_1.createError)("InvalidPeriodError", "Period doesn't end with a quarter");
	};
	exports.getLastQuarterInPeriod = getLastQuarterInPeriod;
	exports.MONTH_PERIOD_NAMES = [
		enums_1.PeriodName.M1,
		enums_1.PeriodName.M2,
		enums_1.PeriodName.M3,
		enums_1.PeriodName.M4,
		enums_1.PeriodName.M5,
		enums_1.PeriodName.M6,
		enums_1.PeriodName.M7,
		enums_1.PeriodName.M8,
		enums_1.PeriodName.M9,
		enums_1.PeriodName.M10,
		enums_1.PeriodName.M11,
		enums_1.PeriodName.M12
	];
	/**
	* Examples of fiscal month indexing:
	*
	* Case 1: December fiscal year end (fiscalYearEndMonth = 11)
	* - January (month = 0) becomes fiscal month 1
	* - February (month = 1) becomes fiscal month 2
	* - December (month = 11) becomes fiscal month 12
	*
	* Case 2: January fiscal year end (fiscalYearEndMonth = 0)
	* - February (month = 1) becomes fiscal month 1
	* - March (month = 2) becomes fiscal month 2
	* - January (month = 0) becomes fiscal month 12
	*
	* The formula (month + 11 - fiscalYearEndMonth) % 12 normalizes any month
	* to its corresponding fiscal month index (0-11) based on the fiscal year end.
	*/
	var getMonthPeriodName = (month, fiscalYearEndMonth) => {
		const fiscalMonthIndex = (month + 11 - fiscalYearEndMonth) % 12;
		return exports.MONTH_PERIOD_NAMES[fiscalMonthIndex];
	};
	exports.getMonthPeriodName = getMonthPeriodName;
	/**
	* Validates and returns Year-to-Date (YTD) period based on fiscal year settings.
	*
	* For a period to be a valid YTD:
	* 1. It must start in the first month of the fiscal year
	*    - Example: If fiscal year ends in December (11), YTD must start in January (0)
	*    - Example: If fiscal year ends in March (2), YTD must start in April (3)
	*
	* 2. It must end in the expected month based on the number of months in the period
	*    - Example: For a 3-month YTD with December year-end:
	*      Start: January (0), End: March (2)
	*    - Example: For a 6-month YTD with March year-end:
	*      Start: April (3), End: September (8)
	*
	* @param period - The period to validate
	* @param fiscalYearEndMonth - The last month of the fiscal year (0-11, where 0 is January)
	* @param numberOfMonthsInPeriod - How many months the period should contain
	* @throws {InvalidPeriodError} If the period doesn't match expected start/end months
	* @returns {PeriodName.YTD} If the period is a valid YTD
	*/
	var returnYtdWhenValid = (period, fiscalYearEndMonth, numberOfMonthsInPeriod) => {
		const expectedStartMonth = (fiscalYearEndMonth + 1) % 12;
		const expectedEndMonth = (fiscalYearEndMonth + numberOfMonthsInPeriod + 12) % 12;
		if (period.startMonthYear.month !== expectedStartMonth) throw (0, errors_1.createError)("InvalidPeriodError", `Start month of the period must be ${(0, date_utils_1.getMonthShortAbbreviation)(expectedStartMonth)} to be a valid period`);
		if (period.endMonthYear.month !== expectedEndMonth) throw (0, errors_1.createError)("InvalidPeriodError", `End month of the period must be ${(0, date_utils_1.getMonthShortAbbreviation)(expectedEndMonth)} to be a valid period`);
		switch (numberOfMonthsInPeriod) {
			case 1: return enums_1.PeriodName.YTD1;
			case 2: return enums_1.PeriodName.YTD2;
			case 3: return enums_1.PeriodName.YTD3;
			case 4: return enums_1.PeriodName.YTD4;
			case 5: return enums_1.PeriodName.YTD5;
			case 6: return enums_1.PeriodName.YTD6;
			case 7: return enums_1.PeriodName.YTD7;
			case 8: return enums_1.PeriodName.YTD8;
			case 9: return enums_1.PeriodName.YTD9;
			case 10: return enums_1.PeriodName.YTD10;
			case 11: return enums_1.PeriodName.YTD11;
			case 12: return enums_1.PeriodName.YTD12;
			default: throw (0, errors_1.createError)("InvalidPeriodError", "Period must be a valid period");
		}
	};
	var getPeriodName = (period, fiscalYearEndMonth) => {
		const numberOfMonthsInPeriod = (0, exports.getNumberOfMonthsInPeriod)(period);
		if (numberOfMonthsInPeriod > 12) throw (0, errors_1.createError)("InvalidPeriodError", `invalid period: ${period}`);
		switch (numberOfMonthsInPeriod) {
			case 12:
				if (period.endMonthYear.month !== fiscalYearEndMonth) throw (0, errors_1.createError)("InvalidPeriodError", "End month of the period must be the fiscal year end month");
				return enums_1.PeriodName.A;
			case 11:
			case 10:
			case 9:
			case 8:
			case 7: return returnYtdWhenValid(period, fiscalYearEndMonth, numberOfMonthsInPeriod);
			case 6: switch ((0, exports.getLastQuarterInPeriod)(period, fiscalYearEndMonth)) {
				case enums_1.PeriodName.Q1: throw (0, errors_1.createError)("InvalidPeriodError", "Period must be a valid period");
				case enums_1.PeriodName.Q2: return enums_1.PeriodName.H1;
				case enums_1.PeriodName.Q3: throw (0, errors_1.createError)("InvalidPeriodError", "Period must be a valid period");
				case enums_1.PeriodName.Q4: return enums_1.PeriodName.H2;
				default: throw (0, errors_1.createError)("InvalidPeriodError", "Period must be a valid period");
			}
			case 5:
			case 4: return returnYtdWhenValid(period, fiscalYearEndMonth, numberOfMonthsInPeriod);
			case 3: return (0, exports.getLastQuarterInPeriod)(period, fiscalYearEndMonth);
			case 2: return returnYtdWhenValid(period, fiscalYearEndMonth, numberOfMonthsInPeriod);
			case 1: return (0, exports.getMonthPeriodName)(period.startMonthYear.month, fiscalYearEndMonth);
			default: throw (0, errors_1.createError)("InvalidPeriodError", "Period must be a valid period");
		}
	};
	exports.getPeriodName = getPeriodName;
	var formatFiscalOrTaxPeriod = (period, fiscalYearEndMonth, periodType) => {
		const numberOfMonthsInPeriod = (0, exports.getNumberOfMonthsInPeriod)(period);
		const periodLabel = periodType === "fiscal" ? "FY" : "TY";
		const year = periodType === "fiscal" ? period.endMonthYear.year : period.startMonthYear.year;
		const yearLabel = `${periodLabel} ${year}`;
		switch (numberOfMonthsInPeriod) {
			case 3: {
				const quarter = (0, exports.calculateQuarter)(period.endMonthYear.month, fiscalYearEndMonth);
				return {
					periodLabel,
					year,
					yearLabel,
					quarter,
					quarterLabel: `Q${quarter}`
				};
			}
			case 12: return {
				periodLabel,
				year,
				yearLabel,
				quarter: null,
				quarterLabel: null
			};
			default: throw (0, errors_1.createError)("UnexpectedFiscalOrTaxPeriod", `Unexpected number of months in period: ${numberOfMonthsInPeriod}`);
		}
	};
	exports.formatFiscalOrTaxPeriod = formatFiscalOrTaxPeriod;
	var formatFiscalPeriod = (period, fiscalYearEndMonth) => (0, exports.formatFiscalOrTaxPeriod)(period, fiscalYearEndMonth, "fiscal");
	exports.formatFiscalPeriod = formatFiscalPeriod;
	var formatTaxPeriod = (period, fiscalYearEndMonth) => (0, exports.formatFiscalOrTaxPeriod)(period, fiscalYearEndMonth, "tax");
	exports.formatTaxPeriod = formatTaxPeriod;
	var getEarliestAndLatestMonthYear = (monthYears) => {
		if (monthYears.length === 0) throw (0, errors_1.createError)("MissingMonthYearError", "Must provide at least one MonthYear");
		let earliestMonthYear = monthYears[0];
		let latestMonthYear = monthYears[0];
		for (const monthYear of monthYears) {
			if ((0, exports.isMonthYearBefore)(monthYear, earliestMonthYear)) earliestMonthYear = monthYear;
			if ((0, exports.isMonthYearBefore)(latestMonthYear, monthYear)) latestMonthYear = monthYear;
		}
		return {
			startMonthYear: earliestMonthYear,
			endMonthYear: latestMonthYear
		};
	};
	exports.getEarliestAndLatestMonthYear = getEarliestAndLatestMonthYear;
	var getCurrentFiscalYearMonthYearPeriod = (yearEndDateMonth) => {
		const currentDate = (0, date_utils_1.getCurrentDateObject)();
		const currentYear = currentDate.getFullYear();
		const taxYearEndDateThisYear = (0, date_utils_1.getLastDayOfTheMonth)(new Date(currentYear, yearEndDateMonth, 1));
		const taxYearEndDateLastYear = (0, date_utils_1.getLastDayOfTheMonth)(new Date(currentYear - 1, yearEndDateMonth, 1));
		const currentTaxYearEndDate = taxYearEndDateThisYear > currentDate ? taxYearEndDateLastYear : taxYearEndDateThisYear;
		const currentTaxEndYear = currentTaxYearEndDate.getFullYear();
		const startYear = currentTaxYearEndDate.getMonth() === enums_1.DateMonth.December ? currentTaxEndYear : currentTaxEndYear - 1;
		const endYear = currentTaxEndYear;
		return {
			startMonthYear: {
				month: (yearEndDateMonth + 1) % 12,
				year: startYear
			},
			endMonthYear: {
				month: yearEndDateMonth,
				year: endYear
			}
		};
	};
	exports.getCurrentFiscalYearMonthYearPeriod = getCurrentFiscalYearMonthYearPeriod;
	var getTaxYearMonthYearPeriod = (yearEndDateMonth, taxYear) => {
		return {
			startMonthYear: {
				month: (yearEndDateMonth + 1) % 12,
				year: taxYear
			},
			endMonthYear: {
				month: yearEndDateMonth,
				year: yearEndDateMonth === enums_1.DateMonth.December ? taxYear : taxYear + 1
			}
		};
	};
	exports.getTaxYearMonthYearPeriod = getTaxYearMonthYearPeriod;
	var getMonthYearPeriodUsingDates = (startDate, endDate) => {
		const startMonth = new Date(startDate).getUTCMonth();
		const startYear = new Date(startDate).getUTCFullYear();
		const endMonth = new Date(endDate).getUTCMonth();
		const endYear = new Date(endDate).getUTCFullYear();
		return {
			startMonthYear: {
				month: startMonth,
				year: startYear
			},
			endMonthYear: {
				month: endMonth,
				year: endYear
			}
		};
	};
	exports.getMonthYearPeriodUsingDates = getMonthYearPeriodUsingDates;
	var applyCompletedEndMonthYearRule = (monthYearPeriod) => {
		const currentDate = (0, date_utils_1.getCurrentDateObject)();
		const currentMonthYear = {
			month: currentDate.getMonth(),
			year: currentDate.getFullYear()
		};
		if ((0, exports.isMonthYearBefore)(currentMonthYear, monthYearPeriod.startMonthYear)) throw (0, errors_1.createError)("CurrentEndMonthYearError", `Today's month-year ${currentMonthYear.month}-${currentMonthYear.year} before start month-year ${monthYearPeriod.startMonthYear.month}-${monthYearPeriod.startMonthYear.year}`);
		if ((0, exports.isMonthYearBefore)(currentMonthYear, monthYearPeriod.endMonthYear)) return {
			startMonthYear: monthYearPeriod.startMonthYear,
			endMonthYear: currentMonthYear
		};
		return monthYearPeriod;
	};
	exports.applyCompletedEndMonthYearRule = applyCompletedEndMonthYearRule;
	var dateStringToReadableMonthYearString = (dateString) => {
		return dayjs_1.default.utc(dateString).format("MMMM YYYY");
	};
	exports.dateStringToReadableMonthYearString = dateStringToReadableMonthYearString;
	/**
	* Determines the superset (union) of MonthYearPeriods, which is defined as the minimum of the start MonthYears and the
	* maximum of the end MonthYears. This creates a single period that encompasses all the provided periods.
	*
	* @param periods - Array of MonthYearPeriods to find the superset of
	* @returns A single MonthYearPeriod that encompasses all input periods
	* @throws Error if the input array is empty
	*/
	var getMonthYearPeriodSuperset = (periods) => {
		if (periods.length === 0) throw (0, errors_1.createError)("MissingMonthYearPeriodError", "Must provide at least one MonthYearPeriod to find superset");
		if (periods.length === 1) return { ...periods[0] };
		return periods.reduce((acc, period) => {
			return {
				startMonthYear: (0, exports.minMonthYear)(acc.startMonthYear, period.startMonthYear),
				endMonthYear: (0, exports.maxMonthYear)(acc.endMonthYear, period.endMonthYear)
			};
		}, { ...periods[0] });
	};
	exports.getMonthYearPeriodSuperset = getMonthYearPeriodSuperset;
	var CapitalizationChangeReason;
	(function(CapitalizationChangeReason) {
		CapitalizationChangeReason["MONTHS_NOW_CAPITALIZED"] = "MONTHS_NOW_CAPITALIZED";
		CapitalizationChangeReason["MONTHS_NO_LONGER_CAPITALIZED"] = "MONTHS_NO_LONGER_CAPITALIZED";
		CapitalizationChangeReason["CAPITALIZATION_PERIOD_CHANGED"] = "CAPITALIZATION_PERIOD_CHANGED";
	})(CapitalizationChangeReason || (exports.CapitalizationChangeReason = CapitalizationChangeReason = {}));
	/**
	* Calculates the earliest month that would be affected by a capitalization period change.
	* Returns null if no approved months would be affected.
	*
	* This is used to determine which approval months need to be reset when capitalization
	* dates are modified.
	*
	* @returns The earliest affected month-year with reason, or null if no approvals would be affected
	*/
	var calculateEarliestAffectedCapitalizationMonth = (input) => {
		const { approvedThrough, newCapitalizationEnd, newCapitalizationStart, oldCapitalizationEnd, oldCapitalizationStart } = input;
		if (!newCapitalizationStart && !newCapitalizationEnd && (oldCapitalizationStart || oldCapitalizationEnd)) return {
			monthYear: oldCapitalizationStart ?? {
				month: 1,
				year: 1970
			},
			reason: CapitalizationChangeReason.MONTHS_NO_LONGER_CAPITALIZED
		};
		if (oldCapitalizationStart?.month === newCapitalizationStart?.month && oldCapitalizationStart?.year === newCapitalizationStart?.year && oldCapitalizationEnd?.month === newCapitalizationEnd?.month && oldCapitalizationEnd?.year === newCapitalizationEnd?.year) return null;
		if (!oldCapitalizationStart && newCapitalizationStart) {
			if ((0, exports.isMonthYearBeforeOrEqual)(newCapitalizationStart, approvedThrough)) return {
				monthYear: newCapitalizationStart,
				reason: CapitalizationChangeReason.MONTHS_NOW_CAPITALIZED
			};
			return null;
		}
		if (!oldCapitalizationStart) return null;
		let earliestAffected = null;
		let earliestReason = null;
		if (newCapitalizationStart && !(0, exports.areMonthYearEqual)(newCapitalizationStart, oldCapitalizationStart)) {
			earliestAffected = (0, exports.minMonthYear)(oldCapitalizationStart, newCapitalizationStart);
			earliestReason = CapitalizationChangeReason.CAPITALIZATION_PERIOD_CHANGED;
		}
		if (oldCapitalizationEnd && newCapitalizationEnd && (0, exports.isMonthYearBefore)(newCapitalizationEnd, oldCapitalizationEnd)) {
			const firstRemoved = {
				month: newCapitalizationEnd.month === 11 ? 0 : newCapitalizationEnd.month + 1,
				year: newCapitalizationEnd.month === 11 ? newCapitalizationEnd.year + 1 : newCapitalizationEnd.year
			};
			if (!(0, exports.isMonthYearBefore)(approvedThrough, firstRemoved)) {
				if (!earliestAffected || (0, exports.isMonthYearBefore)(firstRemoved, earliestAffected)) {
					earliestAffected = firstRemoved;
					earliestReason = CapitalizationChangeReason.MONTHS_NO_LONGER_CAPITALIZED;
				}
			}
		}
		if (oldCapitalizationEnd && newCapitalizationEnd && (0, exports.isMonthYearBefore)(oldCapitalizationEnd, newCapitalizationEnd)) {
			const firstAdded = {
				month: oldCapitalizationEnd.month === 11 ? 0 : oldCapitalizationEnd.month + 1,
				year: oldCapitalizationEnd.month === 11 ? oldCapitalizationEnd.year + 1 : oldCapitalizationEnd.year
			};
			if (!(0, exports.isMonthYearBefore)(approvedThrough, firstAdded)) {
				if (!earliestAffected || (0, exports.isMonthYearBefore)(firstAdded, earliestAffected)) {
					earliestAffected = firstAdded;
					earliestReason = CapitalizationChangeReason.MONTHS_NOW_CAPITALIZED;
				}
			}
		}
		if (oldCapitalizationEnd && !newCapitalizationEnd && newCapitalizationStart) {
			const firstAdded = {
				month: oldCapitalizationEnd.month === 11 ? 0 : oldCapitalizationEnd.month + 1,
				year: oldCapitalizationEnd.month === 11 ? oldCapitalizationEnd.year + 1 : oldCapitalizationEnd.year
			};
			if (!(0, exports.isMonthYearBefore)(approvedThrough, firstAdded)) {
				if (!earliestAffected || (0, exports.isMonthYearBefore)(firstAdded, earliestAffected)) {
					earliestAffected = firstAdded;
					earliestReason = CapitalizationChangeReason.MONTHS_NOW_CAPITALIZED;
				}
			}
		}
		if (!oldCapitalizationEnd && newCapitalizationEnd && oldCapitalizationStart) {
			const firstRemoved = {
				month: newCapitalizationEnd.month === 11 ? 0 : newCapitalizationEnd.month + 1,
				year: newCapitalizationEnd.month === 11 ? newCapitalizationEnd.year + 1 : newCapitalizationEnd.year
			};
			if (!(0, exports.isMonthYearBefore)(approvedThrough, firstRemoved)) {
				if (!earliestAffected || (0, exports.isMonthYearBefore)(firstRemoved, earliestAffected)) {
					earliestAffected = firstRemoved;
					earliestReason = CapitalizationChangeReason.MONTHS_NO_LONGER_CAPITALIZED;
				}
			}
		}
		if (!earliestAffected || !earliestReason || (0, exports.isMonthYearBefore)(approvedThrough, earliestAffected)) return null;
		return {
			monthYear: earliestAffected,
			reason: earliestReason
		};
	};
	exports.calculateEarliestAffectedCapitalizationMonth = calculateEarliestAffectedCapitalizationMonth;
}));
//#endregion
//#region ../../node_modules/numeral/numeral.js
var require_numeral = /* @__PURE__ */ __commonJSMin(((exports, module, this$19) => {
	/*! @preserve
	* numeral.js
	* version : 2.0.6
	* author : Adam Draper
	* license : MIT
	* http://adamwdraper.github.com/Numeral-js/
	*/
	(function(global, factory) {
		if (typeof define === "function" && define.amd) define(factory);
		else if (typeof module === "object" && module.exports) module.exports = factory();
		else global.numeral = factory();
	})(this$19, function() {
		/************************************
		Variables
		************************************/
		var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
			currentLocale: "en",
			zeroFormat: null,
			nullFormat: null,
			defaultFormat: "0,0",
			scalePercentBy100: true
		}, options = {
			currentLocale: defaults.currentLocale,
			zeroFormat: defaults.zeroFormat,
			nullFormat: defaults.nullFormat,
			defaultFormat: defaults.defaultFormat,
			scalePercentBy100: defaults.scalePercentBy100
		};
		/************************************
		Constructors
		************************************/
		function Numeral(input, number) {
			this._input = input;
			this._value = number;
		}
		numeral = function(input) {
			var value, kind, unformatFunction, regexp;
			if (numeral.isNumeral(input)) value = input.value();
			else if (input === 0 || typeof input === "undefined") value = 0;
			else if (input === null || _.isNaN(input)) value = null;
			else if (typeof input === "string") {
				if (options.zeroFormat && input === options.zeroFormat) value = 0;
				else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
				else {
					for (kind in formats) {
						regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
						if (regexp && input.match(regexp)) {
							unformatFunction = formats[kind].unformat;
							break;
						}
					}
					unformatFunction = unformatFunction || numeral._.stringToNumber;
					value = unformatFunction(input);
				}
			} else value = Number(input) || null;
			return new Numeral(input, value);
		};
		numeral.version = VERSION;
		numeral.isNumeral = function(obj) {
			return obj instanceof Numeral;
		};
		numeral._ = _ = {
			numberToFormat: function(value, format, roundingFunction) {
				var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 0xe8d4a51000, billion = 1e9, million = 1e6, thousand = 1e3, decimal = "", neg = false, abbrForce, abs, int, precision, signed, thousands, output;
				value = value || 0;
				abs = Math.abs(value);
				if (numeral._.includes(format, "(")) {
					negP = true;
					format = format.replace(/[\(|\)]/g, "");
				} else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
					signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
					format = format.replace(/[\+|\-]/g, "");
				}
				if (numeral._.includes(format, "a")) {
					abbrForce = format.match(/a(k|m|b|t)?/);
					abbrForce = abbrForce ? abbrForce[1] : false;
					if (numeral._.includes(format, " a")) abbr = " ";
					format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
					if (abs >= trillion && !abbrForce || abbrForce === "t") {
						abbr += locale.abbreviations.trillion;
						value = value / trillion;
					} else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
						abbr += locale.abbreviations.billion;
						value = value / billion;
					} else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
						abbr += locale.abbreviations.million;
						value = value / million;
					} else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
						abbr += locale.abbreviations.thousand;
						value = value / thousand;
					}
				}
				if (numeral._.includes(format, "[.]")) {
					optDec = true;
					format = format.replace("[.]", ".");
				}
				int = value.toString().split(".")[0];
				precision = format.split(".")[1];
				thousands = format.indexOf(",");
				leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
				if (precision) {
					if (numeral._.includes(precision, "[")) {
						precision = precision.replace("]", "");
						precision = precision.split("[");
						decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
					} else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
					int = decimal.split(".")[0];
					if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
					else decimal = "";
					if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
				} else int = numeral._.toFixed(value, 0, roundingFunction);
				if (abbr && !abbrForce && Number(int) >= 1e3 && abbr !== locale.abbreviations.trillion) {
					int = String(Number(int) / 1e3);
					switch (abbr) {
						case locale.abbreviations.thousand:
							abbr = locale.abbreviations.million;
							break;
						case locale.abbreviations.million:
							abbr = locale.abbreviations.billion;
							break;
						case locale.abbreviations.billion: abbr = locale.abbreviations.trillion;
					}
				}
				if (numeral._.includes(int, "-")) {
					int = int.slice(1);
					neg = true;
				}
				if (int.length < leadingCount) for (var i = leadingCount - int.length; i > 0; i--) int = "0" + int;
				if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
				if (format.indexOf(".") === 0) int = "";
				output = int + decimal + (abbr ? abbr : "");
				if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
				else if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
				else if (neg) output = "-" + output;
				return output;
			},
			stringToNumber: function(string) {
				var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
					thousand: 3,
					million: 6,
					billion: 9,
					trillion: 12
				}, abbreviation, value, regexp;
				if (options.zeroFormat && string === options.zeroFormat) value = 0;
				else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
				else {
					value = 1;
					if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
					for (abbreviation in abbreviations) {
						regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
						if (stringOriginal.match(regexp)) {
							value *= Math.pow(10, abbreviations[abbreviation]);
							break;
						}
					}
					value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
					string = string.replace(/[^0-9\.]+/g, "");
					value *= Number(string);
				}
				return value;
			},
			isNaN: function(value) {
				return typeof value === "number" && isNaN(value);
			},
			includes: function(string, search) {
				return string.indexOf(search) !== -1;
			},
			insert: function(string, subString, start) {
				return string.slice(0, start) + subString + string.slice(start);
			},
			reduce: function(array, callback) {
				if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
				if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
				var t = Object(array), len = t.length >>> 0, k = 0, value;
				if (arguments.length === 3) value = arguments[2];
				else {
					while (k < len && !(k in t)) k++;
					if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
					value = t[k++];
				}
				for (; k < len; k++) if (k in t) value = callback(value, t[k], k, t);
				return value;
			},
			/**
			* Computes the multiplier necessary to make x >= 1,
			* effectively eliminating miscalculations caused by
			* finite precision.
			*/
			multiplier: function(x) {
				var parts = x.toString().split(".");
				return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
			},
			/**
			* Given a variable number of arguments, returns the maximum
			* multiplier that must be used to normalize an operation involving
			* all of them.
			*/
			correctionFactor: function() {
				return Array.prototype.slice.call(arguments).reduce(function(accum, next) {
					var mn = _.multiplier(next);
					return accum > mn ? accum : mn;
				}, 1);
			},
			/**
			* Implementation of toFixed() that treats floats more like decimals
			*
			* Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
			* problems for accounting- and finance-related software.
			*/
			toFixed: function(value, maxDecimals, roundingFunction, optionals) {
				var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
				if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
				else boundedPrecision = minDecimals;
				power = Math.pow(10, boundedPrecision);
				output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
				if (optionals > maxDecimals - boundedPrecision) {
					optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
					output = output.replace(optionalsRegExp, "");
				}
				return output;
			}
		};
		numeral.options = options;
		numeral.formats = formats;
		numeral.locales = locales;
		numeral.locale = function(key) {
			if (key) options.currentLocale = key.toLowerCase();
			return options.currentLocale;
		};
		numeral.localeData = function(key) {
			if (!key) return locales[options.currentLocale];
			key = key.toLowerCase();
			if (!locales[key]) throw new Error("Unknown locale : " + key);
			return locales[key];
		};
		numeral.reset = function() {
			for (var property in defaults) options[property] = defaults[property];
		};
		numeral.zeroFormat = function(format) {
			options.zeroFormat = typeof format === "string" ? format : null;
		};
		numeral.nullFormat = function(format) {
			options.nullFormat = typeof format === "string" ? format : null;
		};
		numeral.defaultFormat = function(format) {
			options.defaultFormat = typeof format === "string" ? format : "0.0";
		};
		numeral.register = function(type, name, format) {
			name = name.toLowerCase();
			if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
			this[type + "s"][name] = format;
			return format;
		};
		numeral.validate = function(val, culture) {
			var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
			if (typeof val !== "string") {
				val += "";
				if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
			}
			val = val.trim();
			if (!!val.match(/^\d+$/)) return true;
			if (val === "") return false;
			try {
				localeData = numeral.localeData(culture);
			} catch (e) {
				localeData = numeral.localeData(numeral.locale());
			}
			_currSymbol = localeData.currency.symbol;
			_abbrObj = localeData.abbreviations;
			_decimalSep = localeData.delimiters.decimal;
			if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
			else _thousandSep = localeData.delimiters.thousands;
			temp = val.match(/^[^\d]+/);
			if (temp !== null) {
				val = val.substr(1);
				if (temp[0] !== _currSymbol) return false;
			}
			temp = val.match(/[^\d]+$/);
			if (temp !== null) {
				val = val.slice(0, -1);
				if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
			}
			_thousandRegEx = new RegExp(_thousandSep + "{2}");
			if (!val.match(/[^\d.,]/g)) {
				_valArray = val.split(_decimalSep);
				if (_valArray.length > 2) return false;
				else if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
				else if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
				else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
			}
			return false;
		};
		/************************************
		Numeral Prototype
		************************************/
		numeral.fn = Numeral.prototype = {
			clone: function() {
				return numeral(this);
			},
			format: function(inputString, roundingFunction) {
				var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
				roundingFunction = roundingFunction || Math.round;
				if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
				else if (value === null && options.nullFormat !== null) output = options.nullFormat;
				else {
					for (kind in formats) if (format.match(formats[kind].regexps.format)) {
						formatFunction = formats[kind].format;
						break;
					}
					formatFunction = formatFunction || numeral._.numberToFormat;
					output = formatFunction(value, format, roundingFunction);
				}
				return output;
			},
			value: function() {
				return this._value;
			},
			input: function() {
				return this._input;
			},
			set: function(value) {
				this._value = Number(value);
				return this;
			},
			add: function(value) {
				var corrFactor = _.correctionFactor.call(null, this._value, value);
				function cback(accum, curr, currI, O) {
					return accum + Math.round(corrFactor * curr);
				}
				this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
				return this;
			},
			subtract: function(value) {
				var corrFactor = _.correctionFactor.call(null, this._value, value);
				function cback(accum, curr, currI, O) {
					return accum - Math.round(corrFactor * curr);
				}
				this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
				return this;
			},
			multiply: function(value) {
				function cback(accum, curr, currI, O) {
					var corrFactor = _.correctionFactor(accum, curr);
					return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
				}
				this._value = _.reduce([this._value, value], cback, 1);
				return this;
			},
			divide: function(value) {
				function cback(accum, curr, currI, O) {
					var corrFactor = _.correctionFactor(accum, curr);
					return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
				}
				this._value = _.reduce([this._value, value], cback);
				return this;
			},
			difference: function(value) {
				return Math.abs(numeral(this._value).subtract(value).value());
			}
		};
		/************************************
		Default Locale && Format
		************************************/
		numeral.register("locale", "en", {
			delimiters: {
				thousands: ",",
				decimal: "."
			},
			abbreviations: {
				thousand: "k",
				million: "m",
				billion: "b",
				trillion: "t"
			},
			ordinal: function(number) {
				var b = number % 10;
				return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
			},
			currency: { symbol: "$" }
		});
		(function() {
			numeral.register("format", "bps", {
				regexps: {
					format: /(BPS)/,
					unformat: /(BPS)/
				},
				format: function(value, format, roundingFunction) {
					var space = numeral._.includes(format, " BPS") ? " " : "", output;
					value = value * 1e4;
					format = format.replace(/\s?BPS/, "");
					output = numeral._.numberToFormat(value, format, roundingFunction);
					if (numeral._.includes(output, ")")) {
						output = output.split("");
						output.splice(-1, 0, space + "BPS");
						output = output.join("");
					} else output = output + space + "BPS";
					return output;
				},
				unformat: function(string) {
					return +(numeral._.stringToNumber(string) * 1e-4).toFixed(15);
				}
			});
		})();
		(function() {
			var decimal = {
				base: 1e3,
				suffixes: [
					"B",
					"KB",
					"MB",
					"GB",
					"TB",
					"PB",
					"EB",
					"ZB",
					"YB"
				]
			}, binary = {
				base: 1024,
				suffixes: [
					"B",
					"KiB",
					"MiB",
					"GiB",
					"TiB",
					"PiB",
					"EiB",
					"ZiB",
					"YiB"
				]
			};
			var unformatRegex = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
				return decimal.suffixes.indexOf(item) < 0;
			})).join("|");
			unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
			numeral.register("format", "bytes", {
				regexps: {
					format: /([0\s]i?b)/,
					unformat: new RegExp(unformatRegex)
				},
				format: function(value, format, roundingFunction) {
					var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
					format = format.replace(/\s?i?b/, "");
					for (power = 0; power <= bytes.suffixes.length; power++) {
						min = Math.pow(bytes.base, power);
						max = Math.pow(bytes.base, power + 1);
						if (value === null || value === 0 || value >= min && value < max) {
							suffix += bytes.suffixes[power];
							if (min > 0) value = value / min;
							break;
						}
					}
					output = numeral._.numberToFormat(value, format, roundingFunction);
					return output + suffix;
				},
				unformat: function(string) {
					var value = numeral._.stringToNumber(string), power, bytesMultiplier;
					if (value) {
						for (power = decimal.suffixes.length - 1; power >= 0; power--) {
							if (numeral._.includes(string, decimal.suffixes[power])) {
								bytesMultiplier = Math.pow(decimal.base, power);
								break;
							}
							if (numeral._.includes(string, binary.suffixes[power])) {
								bytesMultiplier = Math.pow(binary.base, power);
								break;
							}
						}
						value *= bytesMultiplier || 1;
					}
					return value;
				}
			});
		})();
		(function() {
			numeral.register("format", "currency", {
				regexps: { format: /(\$)/ },
				format: function(value, format, roundingFunction) {
					var locale = numeral.locales[numeral.options.currentLocale], symbols = {
						before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
						after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
					}, output, symbol, i;
					format = format.replace(/\s?\$\s?/, "");
					output = numeral._.numberToFormat(value, format, roundingFunction);
					if (value >= 0) {
						symbols.before = symbols.before.replace(/[\-\(]/, "");
						symbols.after = symbols.after.replace(/[\-\)]/, "");
					} else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
					for (i = 0; i < symbols.before.length; i++) {
						symbol = symbols.before[i];
						switch (symbol) {
							case "$":
								output = numeral._.insert(output, locale.currency.symbol, i);
								break;
							case " ": output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
						}
					}
					for (i = symbols.after.length - 1; i >= 0; i--) {
						symbol = symbols.after[i];
						switch (symbol) {
							case "$":
								output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
								break;
							case " ": output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
						}
					}
					return output;
				}
			});
		})();
		(function() {
			numeral.register("format", "exponential", {
				regexps: {
					format: /(e\+|e-)/,
					unformat: /(e\+|e-)/
				},
				format: function(value, format, roundingFunction) {
					var output, parts = (typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0").split("e");
					format = format.replace(/e[\+|\-]{1}0/, "");
					output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
					return output + "e" + parts[1];
				},
				unformat: function(string) {
					var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
					power = numeral._.includes(string, "e-") ? power *= -1 : power;
					function cback(accum, curr, currI, O) {
						var corrFactor = numeral._.correctionFactor(accum, curr);
						return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
					}
					return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
				}
			});
		})();
		(function() {
			numeral.register("format", "ordinal", {
				regexps: { format: /(o)/ },
				format: function(value, format, roundingFunction) {
					var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
					format = format.replace(/\s?o/, "");
					ordinal += locale.ordinal(value);
					output = numeral._.numberToFormat(value, format, roundingFunction);
					return output + ordinal;
				}
			});
		})();
		(function() {
			numeral.register("format", "percentage", {
				regexps: {
					format: /(%)/,
					unformat: /(%)/
				},
				format: function(value, format, roundingFunction) {
					var space = numeral._.includes(format, " %") ? " " : "", output;
					if (numeral.options.scalePercentBy100) value = value * 100;
					format = format.replace(/\s?\%/, "");
					output = numeral._.numberToFormat(value, format, roundingFunction);
					if (numeral._.includes(output, ")")) {
						output = output.split("");
						output.splice(-1, 0, space + "%");
						output = output.join("");
					} else output = output + space + "%";
					return output;
				},
				unformat: function(string) {
					var number = numeral._.stringToNumber(string);
					if (numeral.options.scalePercentBy100) return number * .01;
					return number;
				}
			});
		})();
		(function() {
			numeral.register("format", "time", {
				regexps: {
					format: /(:)/,
					unformat: /(:)/
				},
				format: function(value, format, roundingFunction) {
					var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 60 * 60) / 60), seconds = Math.round(value - hours * 60 * 60 - minutes * 60);
					return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
				},
				unformat: function(string) {
					var timeArray = string.split(":"), seconds = 0;
					if (timeArray.length === 3) {
						seconds = seconds + Number(timeArray[0]) * 60 * 60;
						seconds = seconds + Number(timeArray[1]) * 60;
						seconds = seconds + Number(timeArray[2]);
					} else if (timeArray.length === 2) {
						seconds = seconds + Number(timeArray[0]) * 60;
						seconds = seconds + Number(timeArray[1]);
					}
					return Number(seconds);
				}
			});
		})();
		return numeral;
	});
}));
//#endregion
//#region ../common/lib/number.utils.js
var require_number_utils = /* @__PURE__ */ __commonJSMin(((exports, module, this$18) => {
	var __importDefault = this$18 && this$18.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.floorToNearest = exports.roundToNearest = exports.isBetweenNumbersInclusively = exports.isNotPositiveNumber = exports.round80To100TaxRule = exports.toNumOrZero = exports.divideBy100 = exports.areTwoNumbersCloseEnough = exports.abbreviateNumber = exports.formatNumberWithCommas = void 0;
	var numeral_1 = __importDefault(require_numeral());
	var enums_1 = require_enums();
	var errors_1 = require_errors$1();
	var formatNumberWithCommas = (num) => (0, numeral_1.default)(num).format("0,0");
	exports.formatNumberWithCommas = formatNumberWithCommas;
	var SUFFIXES = [
		"",
		"K",
		"M",
		"B",
		"T"
	];
	var abbreviateNumber = ({ inputNumber, sigFigs = 3 }) => {
		const absoluteInputNumber = Math.abs(inputNumber);
		if (absoluteInputNumber <= 1) {
			const baseRound = absoluteInputNumber.toPrecision(sigFigs);
			return {
				abbreviation: baseRound,
				base: +baseRound
			};
		}
		const suffixNum = Math.floor(Math.log10(absoluteInputNumber) / 3);
		const suffix = SUFFIXES[suffixNum];
		const baseRound = (absoluteInputNumber / Math.pow(10, suffixNum * 3) * Math.sign(inputNumber)).toPrecision(sigFigs);
		return {
			abbreviation: `${baseRound}${suffix}`,
			base: +baseRound,
			suffix
		};
	};
	exports.abbreviateNumber = abbreviateNumber;
	var areTwoNumbersCloseEnough = (a, b, discrepancy = .01) => {
		if (a === b) return true;
		if (a === 0 || b === 0) return false;
		return Math.abs(a / b - 1) < discrepancy;
	};
	exports.areTwoNumbersCloseEnough = areTwoNumbersCloseEnough;
	var divideBy100 = (a) => a / 100;
	exports.divideBy100 = divideBy100;
	var toNumOrZero = (a) => a ?? 0;
	exports.toNumOrZero = toNumOrZero;
	var round80To100TaxRule = ({ type, value }) => {
		if (value < 0) throw (0, errors_1.createError)("Round80To100TaxRuleError", "Must be 0 or greater");
		if (type === enums_1.ValueType.PERCENT) {
			if (value > 100) throw (0, errors_1.createError)("Round80To100TaxRuleError", "Fractions must be within 100 or less");
			return value >= 80 ? 100 : value;
		}
		if (type === enums_1.ValueType.FRACTION) {
			if (value > 1) throw (0, errors_1.createError)("Round80To100TaxRuleError", "Fractions must be 1 or less");
			return value >= .8 ? 1 : value;
		}
		throw (0, errors_1.createError)(`Round80To100TaxRuleError: Invalid ValueType passed for this function: ${type}`);
	};
	exports.round80To100TaxRule = round80To100TaxRule;
	var isNotPositiveNumber = (value) => isNaN(value) || value < 0;
	exports.isNotPositiveNumber = isNotPositiveNumber;
	var isBetweenNumbersInclusively = (value, min, max) => value >= min && value <= max;
	exports.isBetweenNumbersInclusively = isBetweenNumbersInclusively;
	var roundToNearest = (value, decimals) => {
		const factor = 10 ** decimals;
		return Math.round(value * factor) / factor;
	};
	exports.roundToNearest = roundToNearest;
	var floorToNearest = (value, decimals) => {
		const factor = 10 ** decimals;
		return Math.floor(value * factor) / factor;
	};
	exports.floorToNearest = floorToNearest;
}));
//#endregion
//#region ../common/lib/money.utils.js
var require_money_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.centsToNumberWithCommas = exports.convertToCents = exports.centsToDollars = exports.dollarsToCents = exports.removeDollarSignAndCommas = exports.parseCents = exports.formatDollarsFromCents = exports.formatNumberToUsd = exports.roundNumber = void 0;
	var enums_1 = require_enums();
	var errors_1 = require_errors$1();
	var number_utils_1 = require_number_utils();
	var roundNumber = (number, roundingMethod) => {
		if (roundingMethod === enums_1.RoundingMethod.FLOOR) return Math.floor(number);
		return Math.round(number);
	};
	exports.roundNumber = roundNumber;
	var formatNumberToUsd = (number, options) => {
		const { minimumFractionDigits = 0, roundingMethod = enums_1.RoundingMethod.ROUND, showCents = true, withDollarSign = true } = options || {};
		const value = showCents ? number : (0, exports.roundNumber)(number, roundingMethod);
		return new Intl.NumberFormat("en-US", {
			currency: "USD",
			minimumFractionDigits,
			style: withDollarSign ? "currency" : "decimal"
		}).format(value);
	};
	exports.formatNumberToUsd = formatNumberToUsd;
	var formatDollarsFromCents = (amountInCents, options) => (0, exports.formatNumberToUsd)((0, number_utils_1.divideBy100)((0, exports.parseCents)(amountInCents)), options);
	exports.formatDollarsFromCents = formatDollarsFromCents;
	/**
	* Format cents function that takes in a number representing the amount of something
	* in cents and formats it according to our rules:
	*  1. Check for NaN
	*  2. We use floor to remove decimals. This is used when dealing with money
	*     amounts, and since all our money values are stored in cents as integers this
	*     will remove decimals that happen as a byproduct of a math operation.
	*
	* @param n cents to format
	* @returns formatted number
	*/
	var parseCents = (n) => {
		if (isNaN(n)) throw (0, errors_1.createError)("CentsError", `Invalid number, n: ${n}`);
		return n === 0 ? 0 : parseInt(n.toFixed(2));
	};
	exports.parseCents = parseCents;
	var removeDollarSignAndCommas = (input) => input.replace(/\$|,/g, "");
	exports.removeDollarSignAndCommas = removeDollarSignAndCommas;
	/**
	* Format dollars number to cents number. e.g. 1.00 -> 100
	* @param dollarsFloat dollars number to format
	* @returns cents number
	*/
	var dollarsToCents = (dollarsFloat) => (0, exports.parseCents)(dollarsFloat * 100);
	exports.dollarsToCents = dollarsToCents;
	/**
	* Format cents number to dollars number with 2 decimal places. e.g. 100 -> 1.00
	* @param centsFloat cents number to format
	* @returns dollars number
	*/
	var centsToDollars = (centsFloat) => {
		const dollarsFloat = centsFloat / 100;
		return parseFloat(dollarsFloat.toFixed(2));
	};
	exports.centsToDollars = centsToDollars;
	/**
	* Format dollar string to cents number, or return null if the value isn't a valid number (empty, invalid string).
	* @param dollar dollar string or number to format. In case of string, it can have a dollar sign and commas. e.g. "$1,000.00"
	* @returns cents number
	*/
	var convertToCents = (dollars) => {
		if (!dollars || !dollars.trim()) return null;
		const stringValue = (0, exports.removeDollarSignAndCommas)(dollars.trim());
		if (!/^-?\d*\.?\d*$/.test(stringValue)) return null;
		const numericValue = Number.parseFloat(stringValue);
		return (0, exports.dollarsToCents)(numericValue);
	};
	exports.convertToCents = convertToCents;
	/**
	* Convert a cents to a string with commas taking into account 2 decimal points.
	*/
	var centsToNumberWithCommas = (cents) => {
		return (cents / 100).toLocaleString("en", { maximumFractionDigits: 2 });
	};
	exports.centsToNumberWithCommas = centsToNumberWithCommas;
}));
//#endregion
//#region ../common/lib/company.utils.js
var require_company_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getActualBusinessStartIsoDate = void 0;
	/**
	* @returns earliest incorporation date in ISO format or null. When it derives the date from only the year
	* it will assume Jan 1st of the available year.
	*/
	var getActualBusinessStartIsoDate = (businessStartValues, options = {}) => {
		const { incorporationDate, incorporationYear, originalBusinessStartYear, priorBusinessIncorporationDate } = options;
		const currentIncorporation = incorporationDate || businessStartValues.incorporationDate;
		const currentIncorporationDateNum = currentIncorporation ? new Date(currentIncorporation).getTime() : null;
		const currentIncorporationYear = incorporationYear || businessStartValues.incorporationYear;
		const currentIncorporationYearDateNum = currentIncorporationYear ? (/* @__PURE__ */ new Date(`${currentIncorporationYear}-01-01T00:00:00.000Z`)).getTime() : null;
		const currentPriorBusinessIncorporationDate = priorBusinessIncorporationDate || businessStartValues.priorBusinessIncorporationDate;
		const currentPriorBusinessIncorporationDateYearNum = currentPriorBusinessIncorporationDate ? new Date(currentPriorBusinessIncorporationDate).getTime() : null;
		const currentOriginalBusinessStartYear = originalBusinessStartYear || businessStartValues.originalBusinessStartYear;
		const currentOriginalBusinessStartYearDateNum = currentOriginalBusinessStartYear ? (/* @__PURE__ */ new Date(`${currentOriginalBusinessStartYear}-01-01T00:00:00.000Z`)).getTime() : null;
		const currentIncorporationDate = currentIncorporationDateNum || currentIncorporationYearDateNum;
		let earliestIncorporationDate = currentPriorBusinessIncorporationDateYearNum || currentOriginalBusinessStartYearDateNum || currentIncorporationDate;
		if (!earliestIncorporationDate) return null;
		if (currentIncorporationDate && currentIncorporationDate < earliestIncorporationDate) earliestIncorporationDate = currentIncorporationDate;
		return new Date(earliestIncorporationDate).toISOString();
	};
	exports.getActualBusinessStartIsoDate = getActualBusinessStartIsoDate;
}));
//#endregion
//#region ../common/lib/promise.js
var require_promise = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pause = void 0;
	/**
	* Function used in async/await to pause execution for a set number of milliseconds.
	* Note, the number of milliseconds in a minimum, not a guarantee.
	*/
	var pause = (milliseconds) => new Promise((resolve) => {
		setTimeout(() => resolve(), milliseconds);
	});
	exports.pause = pause;
}));
//#endregion
//#region ../common/lib/questions/types.js
var require_types = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResearchActivities = exports.DocumentationTools = void 0;
	var DocumentationTools;
	(function(DocumentationTools) {
		DocumentationTools["EMPLOYEE_CALENDARS"] = "Employee Calendars";
		DocumentationTools["MEETING_AGENDAS"] = "Meeting Agendas";
		DocumentationTools["EMAILS"] = "E-mails";
		DocumentationTools["MEETING_MINUTES"] = "Meeting Minutes";
		DocumentationTools["GANTT_CHARTS"] = "Gantt Charts";
		DocumentationTools["PROJECT_MANAGEMENT_SOFTWARE"] = "Project Management Software";
		DocumentationTools["ARCHITECTURE_DIAGRAMS"] = "Architecture Diagrams";
		DocumentationTools["PROTOTYPE_BUILD_SHEETS"] = "Prototype Build Sheets";
		DocumentationTools["COMPUTATIONAL_DOCUMENTS"] = "Computational Documents";
		DocumentationTools["PROCESS_CHARTS"] = "Process Charts";
		DocumentationTools["DESIGN_PROTOTYPES"] = "Design Prototypes";
		DocumentationTools["CONCEPT_DRAWINGS"] = "Concept Drawings";
		DocumentationTools["MOCKUPS"] = "Mockups";
		DocumentationTools["SOFTWARE_SOURCE_CODE"] = "Software Source Code";
		DocumentationTools["COMMIT_LOGS"] = "Commit Logs";
		DocumentationTools["PULL_REQUESTS"] = "Pull Requests";
		DocumentationTools["CLOUD_COMPUTING"] = "Cloud Computing Usage Records";
		DocumentationTools["RELEASE_NOTES"] = "Release Notes";
		DocumentationTools["API_USAGE"] = "API Usage Logs";
		DocumentationTools["API_DOCS"] = "API Documentation";
		DocumentationTools["LAB_TESTS"] = "Lab Test Results";
	})(DocumentationTools || (exports.DocumentationTools = DocumentationTools = {}));
	var ResearchActivities;
	(function(ResearchActivities) {
		ResearchActivities["RESEARCH_PAPERS"] = "Research Papers/Drafts";
		ResearchActivities["WHITE_PAPERS"] = "White Papers";
		ResearchActivities["PATENTS"] = "Patents";
	})(ResearchActivities || (exports.ResearchActivities = ResearchActivities = {}));
}));
//#endregion
//#region ../common/lib/questions/utils.js
var require_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.divideResearchActivities = exports.combineTools = exports.divideTools = void 0;
	var types_1 = require_types();
	var divideTools = (tools) => {
		const planningTools = [];
		const designTools = [];
		const implementationTools = [];
		const otherTools = [];
		tools.forEach((tool) => {
			switch (tool) {
				case types_1.DocumentationTools.EMPLOYEE_CALENDARS:
				case types_1.DocumentationTools.MEETING_AGENDAS:
				case types_1.DocumentationTools.EMAILS:
				case types_1.DocumentationTools.MEETING_MINUTES:
				case types_1.DocumentationTools.GANTT_CHARTS:
				case types_1.DocumentationTools.PROJECT_MANAGEMENT_SOFTWARE:
					planningTools.push(tool);
					break;
				case types_1.DocumentationTools.ARCHITECTURE_DIAGRAMS:
				case types_1.DocumentationTools.PROTOTYPE_BUILD_SHEETS:
				case types_1.DocumentationTools.COMPUTATIONAL_DOCUMENTS:
				case types_1.DocumentationTools.PROCESS_CHARTS:
				case types_1.DocumentationTools.DESIGN_PROTOTYPES:
				case types_1.DocumentationTools.CONCEPT_DRAWINGS:
				case types_1.DocumentationTools.MOCKUPS:
					designTools.push(tool);
					break;
				case types_1.DocumentationTools.SOFTWARE_SOURCE_CODE:
				case types_1.DocumentationTools.COMMIT_LOGS:
				case types_1.DocumentationTools.PULL_REQUESTS:
				case types_1.DocumentationTools.CLOUD_COMPUTING:
				case types_1.DocumentationTools.RELEASE_NOTES:
				case types_1.DocumentationTools.API_USAGE:
				case types_1.DocumentationTools.API_DOCS:
				case types_1.DocumentationTools.LAB_TESTS:
					implementationTools.push(tool);
					break;
				default: otherTools.push(tool);
			}
		});
		return {
			planningTools,
			designTools,
			implementationTools,
			otherTools
		};
	};
	exports.divideTools = divideTools;
	var combineTools = (toolsArrays) => {
		const { designTools, implementationTools, otherTools, planningTools } = toolsArrays;
		return [
			...planningTools,
			...designTools,
			...implementationTools,
			...otherTools
		];
	};
	exports.combineTools = combineTools;
	var divideResearchActivities = (allActivities) => {
		const researchActivities = [];
		const patentDescriptions = [];
		allActivities.forEach((activity) => {
			switch (activity) {
				case types_1.ResearchActivities.RESEARCH_PAPERS:
				case types_1.ResearchActivities.WHITE_PAPERS:
				case types_1.ResearchActivities.PATENTS:
					researchActivities.push(activity);
					break;
				default: patentDescriptions.push(activity);
			}
		});
		return {
			researchActivities,
			patentDescriptions
		};
	};
	exports.divideResearchActivities = divideResearchActivities;
}));
//#endregion
//#region ../common/lib/questions/index.js
var require_questions = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.divideResearchActivities = exports.combineTools = exports.divideTools = exports.ResearchActivities = exports.DocumentationTools = void 0;
	var types_1 = require_types();
	Object.defineProperty(exports, "DocumentationTools", {
		enumerable: true,
		get: function() {
			return types_1.DocumentationTools;
		}
	});
	Object.defineProperty(exports, "ResearchActivities", {
		enumerable: true,
		get: function() {
			return types_1.ResearchActivities;
		}
	});
	var utils_1 = require_utils();
	Object.defineProperty(exports, "divideTools", {
		enumerable: true,
		get: function() {
			return utils_1.divideTools;
		}
	});
	Object.defineProperty(exports, "combineTools", {
		enumerable: true,
		get: function() {
			return utils_1.combineTools;
		}
	});
	Object.defineProperty(exports, "divideResearchActivities", {
		enumerable: true,
		get: function() {
			return utils_1.divideResearchActivities;
		}
	});
}));
//#endregion
//#region ../common/lib/email.utils.js
var require_email_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.normalizeEmail = normalizeEmail;
	exports.isEmailIdentifier = isEmailIdentifier;
	exports.normalizeEmailIdentifier = normalizeEmailIdentifier;
	exports.isNeoTaxEmail = isNeoTaxEmail;
	function normalizeEmail(email) {
		if (email === null) return null;
		return email.trim().toLowerCase();
	}
	/**
	* Whether a provider identifier carries an email address, and is therefore safe to case-normalize.
	*
	* An email address is a case-insensitive identifier: `Dev@Example.com` and `dev@example.com` reach
	* the same inbox and are the same person. Contributor matching already relies on that when it joins
	* ticketing users to payroll users by email, so identifiers are treated the same way.
	*
	* The test is `@`-presence rather than an email pattern, which keeps it expressible identically as
	* SQL `LIKE '%@%'`. `LowercaseEmailShapedTicketingPids1787356800000` normalized the already-stored
	* identifiers on that predicate, and the two have to agree exactly: a value the migration lowercased
	* but this function skips is stored lowercase while its incoming counterpart is not, which is the
	* mismatch the whole mechanism exists to prevent. A pattern also has to be written twice, once for
	* JavaScript and once for POSIX, and the two disagree on Unicode whitespace and on non-ASCII
	* addresses that this deliberately still normalizes.
	*
	* The cost is that a provider issuing two case-differing non-email tokens containing an `@` would
	* have them folded onto one identifier. No company in production holds such a pair — the migration's
	* pre-flight guard checks for exactly that and came back empty.
	*/
	function isEmailIdentifier(identifier) {
		return identifier !== null && identifier.includes("@");
	}
	function normalizeEmailIdentifier(identifier) {
		if (!isEmailIdentifier(identifier)) return identifier;
		return normalizeEmail(identifier);
	}
	/** Whether an address belongs to Neo.Tax staff rather than to a customer. Case-insensitive. */
	function isNeoTaxEmail(email) {
		return normalizeEmail(email).endsWith("@neo.tax");
	}
}));
//#endregion
//#region ../../node_modules/retry/lib/retry_operation.js
var require_retry_operation = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function RetryOperation(timeouts, options) {
		if (typeof options === "boolean") options = { forever: options };
		this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
		this._timeouts = timeouts;
		this._options = options || {};
		this._maxRetryTime = options && options.maxRetryTime || Infinity;
		this._fn = null;
		this._errors = [];
		this._attempts = 1;
		this._operationTimeout = null;
		this._operationTimeoutCb = null;
		this._timeout = null;
		this._operationStart = null;
		this._timer = null;
		if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
	}
	module.exports = RetryOperation;
	RetryOperation.prototype.reset = function() {
		this._attempts = 1;
		this._timeouts = this._originalTimeouts.slice(0);
	};
	RetryOperation.prototype.stop = function() {
		if (this._timeout) clearTimeout(this._timeout);
		if (this._timer) clearTimeout(this._timer);
		this._timeouts = [];
		this._cachedTimeouts = null;
	};
	RetryOperation.prototype.retry = function(err) {
		if (this._timeout) clearTimeout(this._timeout);
		if (!err) return false;
		var currentTime = (/* @__PURE__ */ new Date()).getTime();
		if (err && currentTime - this._operationStart >= this._maxRetryTime) {
			this._errors.push(err);
			this._errors.unshift(/* @__PURE__ */ new Error("RetryOperation timeout occurred"));
			return false;
		}
		this._errors.push(err);
		var timeout = this._timeouts.shift();
		if (timeout === void 0) {
			if (this._cachedTimeouts) {
				this._errors.splice(0, this._errors.length - 1);
				timeout = this._cachedTimeouts.slice(-1);
			} else return false;
		}
		var self = this;
		this._timer = setTimeout(function() {
			self._attempts++;
			if (self._operationTimeoutCb) {
				self._timeout = setTimeout(function() {
					self._operationTimeoutCb(self._attempts);
				}, self._operationTimeout);
				if (self._options.unref) self._timeout.unref();
			}
			self._fn(self._attempts);
		}, timeout);
		if (this._options.unref) this._timer.unref();
		return true;
	};
	RetryOperation.prototype.attempt = function(fn, timeoutOps) {
		this._fn = fn;
		if (timeoutOps) {
			if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
			if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
		}
		var self = this;
		if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
			self._operationTimeoutCb();
		}, self._operationTimeout);
		this._operationStart = (/* @__PURE__ */ new Date()).getTime();
		this._fn(this._attempts);
	};
	RetryOperation.prototype.try = function(fn) {
		console.log("Using RetryOperation.try() is deprecated");
		this.attempt(fn);
	};
	RetryOperation.prototype.start = function(fn) {
		console.log("Using RetryOperation.start() is deprecated");
		this.attempt(fn);
	};
	RetryOperation.prototype.start = RetryOperation.prototype.try;
	RetryOperation.prototype.errors = function() {
		return this._errors;
	};
	RetryOperation.prototype.attempts = function() {
		return this._attempts;
	};
	RetryOperation.prototype.mainError = function() {
		if (this._errors.length === 0) return null;
		var counts = {};
		var mainError = null;
		var mainErrorCount = 0;
		for (var i = 0; i < this._errors.length; i++) {
			var error = this._errors[i];
			var message = error.message;
			var count = (counts[message] || 0) + 1;
			counts[message] = count;
			if (count >= mainErrorCount) {
				mainError = error;
				mainErrorCount = count;
			}
		}
		return mainError;
	};
}));
//#endregion
//#region ../../node_modules/retry/lib/retry.js
var require_retry$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	var RetryOperation = require_retry_operation();
	exports.operation = function(options) {
		return new RetryOperation(exports.timeouts(options), {
			forever: options && (options.forever || options.retries === Infinity),
			unref: options && options.unref,
			maxRetryTime: options && options.maxRetryTime
		});
	};
	exports.timeouts = function(options) {
		if (options instanceof Array) return [].concat(options);
		var opts = {
			retries: 10,
			factor: 2,
			minTimeout: 1e3,
			maxTimeout: Infinity,
			randomize: false
		};
		for (var key in options) opts[key] = options[key];
		if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
		var timeouts = [];
		for (var i = 0; i < opts.retries; i++) timeouts.push(this.createTimeout(i, opts));
		if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
		timeouts.sort(function(a, b) {
			return a - b;
		});
		return timeouts;
	};
	exports.createTimeout = function(attempt, opts) {
		var random = opts.randomize ? Math.random() + 1 : 1;
		var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
		timeout = Math.min(timeout, opts.maxTimeout);
		return timeout;
	};
	exports.wrap = function(obj, options, methods) {
		if (options instanceof Array) {
			methods = options;
			options = null;
		}
		if (!methods) {
			methods = [];
			for (var key in obj) if (typeof obj[key] === "function") methods.push(key);
		}
		for (var i = 0; i < methods.length; i++) {
			var method = methods[i];
			var original = obj[method];
			obj[method] = function retryWrapper(original) {
				var op = exports.operation(options);
				var args = Array.prototype.slice.call(arguments, 1);
				var callback = args.pop();
				args.push(function(err) {
					if (op.retry(err)) return;
					if (err) arguments[0] = op.mainError();
					callback.apply(this, arguments);
				});
				op.attempt(function() {
					original.apply(obj, args);
				});
			}.bind(obj, original);
			obj[method].options = options;
		}
	};
}));
//#endregion
//#region ../../node_modules/retry/index.js
var require_retry = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require_retry$1();
}));
//#endregion
//#region ../../node_modules/p-retry/index.js
var require_p_retry = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var retry = require_retry();
	var networkErrorMsgs = [
		"Failed to fetch",
		"NetworkError when attempting to fetch resource.",
		"The Internet connection appears to be offline.",
		"Network request failed"
	];
	var AbortError = class extends Error {
		constructor(message) {
			super();
			if (message instanceof Error) {
				this.originalError = message;
				({message} = message);
			} else {
				this.originalError = new Error(message);
				this.originalError.stack = this.stack;
			}
			this.name = "AbortError";
			this.message = message;
		}
	};
	var decorateErrorWithCounts = (error, attemptNumber, options) => {
		const retriesLeft = options.retries - (attemptNumber - 1);
		error.attemptNumber = attemptNumber;
		error.retriesLeft = retriesLeft;
		return error;
	};
	var isNetworkError = (errorMessage) => networkErrorMsgs.includes(errorMessage);
	var pRetry = (input, options) => new Promise((resolve, reject) => {
		options = {
			onFailedAttempt: () => {},
			retries: 10,
			...options
		};
		const operation = retry.operation(options);
		operation.attempt(async (attemptNumber) => {
			try {
				resolve(await input(attemptNumber));
			} catch (error) {
				if (!(error instanceof Error)) {
					reject(/* @__PURE__ */ new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
					return;
				}
				if (error instanceof AbortError) {
					operation.stop();
					reject(error.originalError);
				} else if (error instanceof TypeError && !isNetworkError(error.message)) {
					operation.stop();
					reject(error);
				} else {
					decorateErrorWithCounts(error, attemptNumber, options);
					try {
						await options.onFailedAttempt(error);
					} catch (error) {
						reject(error);
						return;
					}
					if (!operation.retry(error)) reject(operation.mainError());
				}
			}
		});
	});
	module.exports = pRetry;
	module.exports.default = pRetry;
	module.exports.AbortError = AbortError;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/rng.js
var require_rng = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = rng;
	var getRandomValues;
	var rnds8 = /* @__PURE__ */ new Uint8Array(16);
	function rng() {
		if (!getRandomValues) {
			getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
			if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
		}
		return getRandomValues(rnds8);
	}
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/regex.js
var require_regex = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/validate.js
var require_validate = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _regex = _interopRequireDefault(require_regex());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	function validate(uuid) {
		return typeof uuid === "string" && _regex.default.test(uuid);
	}
	exports.default = validate;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/stringify.js
var require_stringify = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	exports.unsafeStringify = unsafeStringify;
	var _validate = _interopRequireDefault(require_validate());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	/**
	* Convert array of 16 byte values to UUID string format of the form:
	* XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	*/
	var byteToHex = [];
	for (let i = 0; i < 256; ++i) byteToHex.push((i + 256).toString(16).slice(1));
	function unsafeStringify(arr, offset = 0) {
		return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
	}
	function stringify(arr, offset = 0) {
		const uuid = unsafeStringify(arr, offset);
		if (!(0, _validate.default)(uuid)) throw TypeError("Stringified UUID is invalid");
		return uuid;
	}
	exports.default = stringify;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/v1.js
var require_v1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _rng = _interopRequireDefault(require_rng());
	var _stringify = require_stringify();
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	var _nodeId;
	var _clockseq;
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	function v1(options, buf, offset) {
		let i = buf && offset || 0;
		const b = buf || new Array(16);
		options = options || {};
		let node = options.node || _nodeId;
		let clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
		if (node == null || clockseq == null) {
			const seedBytes = options.random || (options.rng || _rng.default)();
			if (node == null) node = _nodeId = [
				seedBytes[0] | 1,
				seedBytes[1],
				seedBytes[2],
				seedBytes[3],
				seedBytes[4],
				seedBytes[5]
			];
			if (clockseq == null) clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
		}
		let msecs = options.msecs !== void 0 ? options.msecs : Date.now();
		let nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
		const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
		if (dt < 0 && options.clockseq === void 0) clockseq = clockseq + 1 & 16383;
		if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) nsecs = 0;
		if (nsecs >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
		_lastMSecs = msecs;
		_lastNSecs = nsecs;
		_clockseq = clockseq;
		msecs += 0xb1d069b5400;
		const tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
		b[i++] = tl >>> 24 & 255;
		b[i++] = tl >>> 16 & 255;
		b[i++] = tl >>> 8 & 255;
		b[i++] = tl & 255;
		const tmh = msecs / 4294967296 * 1e4 & 268435455;
		b[i++] = tmh >>> 8 & 255;
		b[i++] = tmh & 255;
		b[i++] = tmh >>> 24 & 15 | 16;
		b[i++] = tmh >>> 16 & 255;
		b[i++] = clockseq >>> 8 | 128;
		b[i++] = clockseq & 255;
		for (let n = 0; n < 6; ++n) b[i + n] = node[n];
		return buf || (0, _stringify.unsafeStringify)(b);
	}
	exports.default = v1;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/parse.js
var require_parse = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _validate = _interopRequireDefault(require_validate());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	function parse(uuid) {
		if (!(0, _validate.default)(uuid)) throw TypeError("Invalid UUID");
		let v;
		const arr = /* @__PURE__ */ new Uint8Array(16);
		arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
		arr[1] = v >>> 16 & 255;
		arr[2] = v >>> 8 & 255;
		arr[3] = v & 255;
		arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
		arr[5] = v & 255;
		arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
		arr[7] = v & 255;
		arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
		arr[9] = v & 255;
		arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255;
		arr[11] = v / 4294967296 & 255;
		arr[12] = v >>> 24 & 255;
		arr[13] = v >>> 16 & 255;
		arr[14] = v >>> 8 & 255;
		arr[15] = v & 255;
		return arr;
	}
	exports.default = parse;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/v35.js
var require_v35 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.URL = exports.DNS = void 0;
	exports.default = v35;
	var _stringify = require_stringify();
	var _parse = _interopRequireDefault(require_parse());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	function stringToBytes(str) {
		str = unescape(encodeURIComponent(str));
		const bytes = [];
		for (let i = 0; i < str.length; ++i) bytes.push(str.charCodeAt(i));
		return bytes;
	}
	var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
	exports.DNS = DNS;
	var URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
	exports.URL = URL;
	function v35(name, version, hashfunc) {
		function generateUUID(value, namespace, buf, offset) {
			var _namespace;
			if (typeof value === "string") value = stringToBytes(value);
			if (typeof namespace === "string") namespace = (0, _parse.default)(namespace);
			if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
			let bytes = new Uint8Array(16 + value.length);
			bytes.set(namespace);
			bytes.set(value, namespace.length);
			bytes = hashfunc(bytes);
			bytes[6] = bytes[6] & 15 | version;
			bytes[8] = bytes[8] & 63 | 128;
			if (buf) {
				offset = offset || 0;
				for (let i = 0; i < 16; ++i) buf[offset + i] = bytes[i];
				return buf;
			}
			return (0, _stringify.unsafeStringify)(bytes);
		}
		try {
			generateUUID.name = name;
		} catch (err) {}
		generateUUID.DNS = DNS;
		generateUUID.URL = URL;
		return generateUUID;
	}
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/md5.js
var require_md5 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	function md5(bytes) {
		if (typeof bytes === "string") {
			const msg = unescape(encodeURIComponent(bytes));
			bytes = new Uint8Array(msg.length);
			for (let i = 0; i < msg.length; ++i) bytes[i] = msg.charCodeAt(i);
		}
		return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
	}
	function md5ToHexEncodedArray(input) {
		const output = [];
		const length32 = input.length * 32;
		const hexTab = "0123456789abcdef";
		for (let i = 0; i < length32; i += 8) {
			const x = input[i >> 5] >>> i % 32 & 255;
			const hex = parseInt(hexTab.charAt(x >>> 4 & 15) + hexTab.charAt(x & 15), 16);
			output.push(hex);
		}
		return output;
	}
	/**
	* Calculate output length with padding and bit length
	*/
	function getOutputLength(inputLength8) {
		return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
	}
	function wordsToMd5(x, len) {
		x[len >> 5] |= 128 << len % 32;
		x[getOutputLength(len) - 1] = len;
		let a = 1732584193;
		let b = -271733879;
		let c = -1732584194;
		let d = 271733878;
		for (let i = 0; i < x.length; i += 16) {
			const olda = a;
			const oldb = b;
			const oldc = c;
			const oldd = d;
			a = md5ff(a, b, c, d, x[i], 7, -680876936);
			d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
			c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
			b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
			a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
			d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
			c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
			b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
			a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
			d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
			c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
			b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
			a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
			d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
			c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
			b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
			a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
			d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
			c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
			b = md5gg(b, c, d, a, x[i], 20, -373897302);
			a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
			d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
			c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
			b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
			a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
			d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
			c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
			b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
			a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
			d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
			c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
			b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
			a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
			d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
			c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
			b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
			a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
			d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
			c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
			b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
			a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
			d = md5hh(d, a, b, c, x[i], 11, -358537222);
			c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
			b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
			a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
			d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
			c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
			b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
			a = md5ii(a, b, c, d, x[i], 6, -198630844);
			d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
			c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
			b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
			a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
			d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
			c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
			b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
			a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
			d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
			c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
			b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
			a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
			d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
			c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
			b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
			a = safeAdd(a, olda);
			b = safeAdd(b, oldb);
			c = safeAdd(c, oldc);
			d = safeAdd(d, oldd);
		}
		return [
			a,
			b,
			c,
			d
		];
	}
	function bytesToWords(input) {
		if (input.length === 0) return [];
		const length8 = input.length * 8;
		const output = new Uint32Array(getOutputLength(length8));
		for (let i = 0; i < length8; i += 8) output[i >> 5] |= (input[i / 8] & 255) << i % 32;
		return output;
	}
	function safeAdd(x, y) {
		const lsw = (x & 65535) + (y & 65535);
		return (x >> 16) + (y >> 16) + (lsw >> 16) << 16 | lsw & 65535;
	}
	function bitRotateLeft(num, cnt) {
		return num << cnt | num >>> 32 - cnt;
	}
	function md5cmn(q, a, b, x, s, t) {
		return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	function md5ff(a, b, c, d, x, s, t) {
		return md5cmn(b & c | ~b & d, a, b, x, s, t);
	}
	function md5gg(a, b, c, d, x, s, t) {
		return md5cmn(b & d | c & ~d, a, b, x, s, t);
	}
	function md5hh(a, b, c, d, x, s, t) {
		return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5ii(a, b, c, d, x, s, t) {
		return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	exports.default = md5;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/v3.js
var require_v3 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _v = _interopRequireDefault(require_v35());
	var _md = _interopRequireDefault(require_md5());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	exports.default = (0, _v.default)("v3", 48, _md.default);
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/native.js
var require_native = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	exports.default = { randomUUID: typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/v4.js
var require_v4 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _native = _interopRequireDefault(require_native());
	var _rng = _interopRequireDefault(require_rng());
	var _stringify = require_stringify();
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	function v4(options, buf, offset) {
		if (_native.default.randomUUID && !buf && !options) return _native.default.randomUUID();
		options = options || {};
		const rnds = options.random || (options.rng || _rng.default)();
		rnds[6] = rnds[6] & 15 | 64;
		rnds[8] = rnds[8] & 63 | 128;
		if (buf) {
			offset = offset || 0;
			for (let i = 0; i < 16; ++i) buf[offset + i] = rnds[i];
			return buf;
		}
		return (0, _stringify.unsafeStringify)(rnds);
	}
	exports.default = v4;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/sha1.js
var require_sha1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	function f(s, x, y, z) {
		switch (s) {
			case 0: return x & y ^ ~x & z;
			case 1: return x ^ y ^ z;
			case 2: return x & y ^ x & z ^ y & z;
			case 3: return x ^ y ^ z;
		}
	}
	function ROTL(x, n) {
		return x << n | x >>> 32 - n;
	}
	function sha1(bytes) {
		const K = [
			1518500249,
			1859775393,
			2400959708,
			3395469782
		];
		const H = [
			1732584193,
			4023233417,
			2562383102,
			271733878,
			3285377520
		];
		if (typeof bytes === "string") {
			const msg = unescape(encodeURIComponent(bytes));
			bytes = [];
			for (let i = 0; i < msg.length; ++i) bytes.push(msg.charCodeAt(i));
		} else if (!Array.isArray(bytes)) bytes = Array.prototype.slice.call(bytes);
		bytes.push(128);
		const l = bytes.length / 4 + 2;
		const N = Math.ceil(l / 16);
		const M = new Array(N);
		for (let i = 0; i < N; ++i) {
			const arr = /* @__PURE__ */ new Uint32Array(16);
			for (let j = 0; j < 16; ++j) arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
			M[i] = arr;
		}
		M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
		M[N - 1][14] = Math.floor(M[N - 1][14]);
		M[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
		for (let i = 0; i < N; ++i) {
			const W = /* @__PURE__ */ new Uint32Array(80);
			for (let t = 0; t < 16; ++t) W[t] = M[i][t];
			for (let t = 16; t < 80; ++t) W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
			let a = H[0];
			let b = H[1];
			let c = H[2];
			let d = H[3];
			let e = H[4];
			for (let t = 0; t < 80; ++t) {
				const s = Math.floor(t / 20);
				const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
				e = d;
				d = c;
				c = ROTL(b, 30) >>> 0;
				b = a;
				a = T;
			}
			H[0] = H[0] + a >>> 0;
			H[1] = H[1] + b >>> 0;
			H[2] = H[2] + c >>> 0;
			H[3] = H[3] + d >>> 0;
			H[4] = H[4] + e >>> 0;
		}
		return [
			H[0] >> 24 & 255,
			H[0] >> 16 & 255,
			H[0] >> 8 & 255,
			H[0] & 255,
			H[1] >> 24 & 255,
			H[1] >> 16 & 255,
			H[1] >> 8 & 255,
			H[1] & 255,
			H[2] >> 24 & 255,
			H[2] >> 16 & 255,
			H[2] >> 8 & 255,
			H[2] & 255,
			H[3] >> 24 & 255,
			H[3] >> 16 & 255,
			H[3] >> 8 & 255,
			H[3] & 255,
			H[4] >> 24 & 255,
			H[4] >> 16 & 255,
			H[4] >> 8 & 255,
			H[4] & 255
		];
	}
	exports.default = sha1;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/v5.js
var require_v5 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _v = _interopRequireDefault(require_v35());
	var _sha = _interopRequireDefault(require_sha1());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	exports.default = (0, _v.default)("v5", 80, _sha.default);
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/nil.js
var require_nil = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	exports.default = "00000000-0000-0000-0000-000000000000";
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/version.js
var require_version = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	var _validate = _interopRequireDefault(require_validate());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	function version(uuid) {
		if (!(0, _validate.default)(uuid)) throw TypeError("Invalid UUID");
		return parseInt(uuid.slice(14, 15), 16);
	}
	exports.default = version;
}));
//#endregion
//#region ../common/node_modules/uuid/dist/commonjs-browser/index.js
var require_commonjs_browser = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	Object.defineProperty(exports, "NIL", {
		enumerable: true,
		get: function get() {
			return _nil.default;
		}
	});
	Object.defineProperty(exports, "parse", {
		enumerable: true,
		get: function get() {
			return _parse.default;
		}
	});
	Object.defineProperty(exports, "stringify", {
		enumerable: true,
		get: function get() {
			return _stringify.default;
		}
	});
	Object.defineProperty(exports, "v1", {
		enumerable: true,
		get: function get() {
			return _v.default;
		}
	});
	Object.defineProperty(exports, "v3", {
		enumerable: true,
		get: function get() {
			return _v2.default;
		}
	});
	Object.defineProperty(exports, "v4", {
		enumerable: true,
		get: function get() {
			return _v3.default;
		}
	});
	Object.defineProperty(exports, "v5", {
		enumerable: true,
		get: function get() {
			return _v4.default;
		}
	});
	Object.defineProperty(exports, "validate", {
		enumerable: true,
		get: function get() {
			return _validate.default;
		}
	});
	Object.defineProperty(exports, "version", {
		enumerable: true,
		get: function get() {
			return _version.default;
		}
	});
	var _v = _interopRequireDefault(require_v1());
	var _v2 = _interopRequireDefault(require_v3());
	var _v3 = _interopRequireDefault(require_v4());
	var _v4 = _interopRequireDefault(require_v5());
	var _nil = _interopRequireDefault(require_nil());
	var _version = _interopRequireDefault(require_version());
	var _validate = _interopRequireDefault(require_validate());
	var _stringify = _interopRequireDefault(require_stringify());
	var _parse = _interopRequireDefault(require_parse());
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
}));
//#endregion
//#region ../common/lib/string.utils.js
var require_string_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatAsElementId = exports.capitalizeFirstLetter = exports.formatArrayToCommaAndString = exports.sanitizeString = exports.normalizeWhitespaceAndCase = exports.escapeLikePattern = exports.parsePercentageIntegerValue = exports.spaceToDash = exports.combineAddresses = exports.truncateString = exports.snakeCase = exports.kebabCase = exports.constantCase = exports.capitalCase = void 0;
	/**
	* Like sentence case, but with the first letter of each word capitalized. Not the same as PascalCase because this function includes spaces between words.
	*
	* Handles camelCase, PascalCase, kebab-case, snake_case, and CONSTANT_CASE.
	*/
	var capitalCase = (str) => str.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2").replace(/[_-]+/g, " ").replace(/[\s]+/g, " ").toLowerCase().replace(/(^|\s)([a-z])/g, (match) => match.toUpperCase());
	exports.capitalCase = capitalCase;
	/**
	* Handles camelCase, PascalCase, snake_case, kebab-case, and sentence case.
	*/
	var constantCase = (str) => str.replace(/([a-z])([A-Z])/g, "$1_$2").replace(/([A-Z])([A-Z][a-z])/g, "$1_$2").replace(/[/\s-]+/g, "_").replace(/['",.!?]+/g, "").toUpperCase();
	exports.constantCase = constantCase;
	/**
	* Handles camelCase, PascalCase, snake_case, CONSTANT_CASE, and sentence case.
	*/
	var kebabCase = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").replace(/[_/\s]+/g, "-").replace(/['",.!?]+/g, "").toLowerCase();
	exports.kebabCase = kebabCase;
	var snakeCase = (str) => str.replace(/([a-z])([A-Z])/g, "$1_$2").replace(/([A-Z])([A-Z][a-z])/g, "$1_$2").toLowerCase();
	exports.snakeCase = snakeCase;
	/**
	* Truncates a string if it is longer than the specified maximum length. Truncates after last whole word and adds ellipses by default.
	*/
	var truncateString = (text, maxLength, options = {}) => {
		if (text === void 0 || text === null || text.length <= maxLength) return text;
		const optionsMerged = {
			includeEllipses: true,
			truncateWords: false,
			...options
		};
		let truncatedText = text.slice(0, maxLength);
		if (!optionsMerged.truncateWords) {
			const lastSpaceIndex = truncatedText.lastIndexOf(" ");
			if (lastSpaceIndex > 0) truncatedText = truncatedText.slice(0, lastSpaceIndex);
		}
		if (optionsMerged.includeEllipses) truncatedText += "...";
		return truncatedText;
	};
	exports.truncateString = truncateString;
	var combineAddresses = (addresses) => addresses.filter((address) => !!address).map((address) => address.trim()).join(", ");
	exports.combineAddresses = combineAddresses;
	var spaceToDash = (str) => str.replace(/ /g, "-");
	exports.spaceToDash = spaceToDash;
	var parsePercentageIntegerValue = (value) => {
		if (!value) return null;
		const trimmed = value.trim().replace(/%$/, "");
		if (!trimmed) return null;
		const integerValue = parseInt(trimmed);
		if (isNaN(integerValue) || integerValue < 0 || integerValue > 100) return null;
		return integerValue;
	};
	exports.parsePercentageIntegerValue = parsePercentageIntegerValue;
	/**
	* Escapes SQL LIKE/ILIKE special characters (%, _, \) and normalizes
	* empty/whitespace-only strings to null. Use before passing user input
	* to queries that build patterns like `'%' || :keyword || '%'`.
	*/
	var escapeLikePattern = (keyword) => {
		const trimmed = keyword?.trim();
		if (!trimmed) return null;
		return trimmed.replace(/[\\%_]/g, "\\$&");
	};
	exports.escapeLikePattern = escapeLikePattern;
	/**
	* Trims, collapses internal whitespace runs to a single space, and lowercases — so strings differing only
	* in casing or spacing compare equal. The mechanical half of a comparison key; what counts as "the same
	* value" is the caller's rule to name and own.
	*/
	var normalizeWhitespaceAndCase = (str) => str.trim().replace(/\s+/g, " ").toLowerCase();
	exports.normalizeWhitespaceAndCase = normalizeWhitespaceAndCase;
	var sanitizeString = (s) => {
		const pattern = String.raw`[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]`;
		return s.replace(new RegExp(pattern, "g"), "");
	};
	exports.sanitizeString = sanitizeString;
	var formatArrayToCommaAndString = (arr) => {
		if (arr.length === 0) return "";
		else if (arr.length === 1) return arr[0];
		else if (arr.length === 2) return arr.join(" and ");
		else {
			const lastItem = arr[arr.length - 1];
			return `${arr.slice(0, arr.length - 1).join(", ")}, and ${lastItem}`;
		}
	};
	exports.formatArrayToCommaAndString = formatArrayToCommaAndString;
	var capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	/**
	* - Converts to lowercase
	* - Replaces spaces with dashes
	* - Removes unsupported characters (keeping only letters, numbers, dashes, underscores)
	*/
	var formatAsElementId = (str) => str.toLowerCase().replace(/ /g, "-").replace(/[^a-z0-9-_]/g, "");
	exports.formatAsElementId = formatAsElementId;
}));
//#endregion
//#region ../common/lib/json.utils.js
var require_json_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeDateExtractFromJson = exports.areJsonEqual = exports.sanitizeJson = exports.sortJsonByKeys = exports.toJson = exports.getStaticCopy = void 0;
	var string_utils_1 = require_string_utils();
	var executeUpThePrototypeChain = (obj, func) => {
		if (!(obj instanceof Object)) return [];
		const results = [];
		let prototype = obj;
		do {
			results.push(func(prototype));
			prototype = Object.getPrototypeOf(prototype);
		} while (prototype);
		return results;
	};
	var getEvaluatedGetters = (obj) => {
		if (!(obj instanceof Object)) return {};
		return Object.entries(Object.getOwnPropertyDescriptors(obj)).reduce((acc, [name, descriptor]) => {
			if (typeof descriptor.get === "function") acc.push([name, descriptor.get]);
			return acc;
		}, []).reduce((acc, [name, getter]) => {
			try {
				acc[name] = getter.call(obj);
			} catch (err) {
				acc[name] = "message" in err ? err.message : "Error when calling getter";
			}
			return acc;
		}, {});
	};
	var getAllEvaluatedGetters = (obj) => {
		if (!(obj instanceof Object)) return {};
		return executeUpThePrototypeChain(obj, (prototype) => getEvaluatedGetters(prototype)).reduce((acc, getter) => ({
			...acc,
			...getter
		}), {});
	};
	/**
	* Returns an object containing all the fields of the given object even if they are not enumerable, excluding getters or methods.
	* One exception is Dates, which are objects with only methods in JS. Dates will be converted to ISO strings.
	*/
	var getOwnFields = (obj) => {
		if (!(obj instanceof Object)) return {};
		return Object.entries(Object.getOwnPropertyDescriptors(obj)).reduce((acc, [name, descriptor]) => {
			if (typeof descriptor.value !== "undefined" && typeof descriptor.value !== "function") acc[name] = descriptor.value instanceof Date ? descriptor.value.toISOString() : descriptor.value;
			return acc;
		}, {});
	};
	var getAllFields = (obj) => {
		if (!(obj instanceof Object)) return {};
		return executeUpThePrototypeChain(obj, (prototype) => getOwnFields(prototype)).reduce((acc, field) => ({
			...acc,
			...field
		}), {});
	};
	/**
	* Constructs a static copy of an object, including all getters which have been evaluated and added to the copy with the
	* same key as the getter in the original object. This function is recursive, so all nested objects will also be copied.
	*
	* Circular references will be replaced with the string '[Circular <ClassName>]' in the copy.
	* Symbol values will be replaced with the string '[Symbol(<SymbolName>)]' in the copy.
	*
	* @param obj - The object to copy
	* @param fieldsToCopy - An optional list of fields to copy if {@link obj} is an Object. If this is not provided, all fields will be copied.
	* @param seenBranches - A set of objects that have already been copied. This is used to detect circular references.
	* @returns - A deep copy of the object, including all evaluated getters.
	*/
	var getStaticCopy = (obj, fieldsToCopy = null, seenBranches = /* @__PURE__ */ new Set()) => {
		if (!(obj instanceof Object)) return obj;
		seenBranches.add(obj);
		const getters = getAllEvaluatedGetters(obj);
		const fields = getAllFields(obj);
		let entries = Object.entries({
			...fields,
			...getters
		});
		if (fieldsToCopy) {
			const fieldsToCopySet = new Set(fieldsToCopy);
			entries = entries.filter(([key]) => fieldsToCopySet.has(key));
		}
		const newFields = entries.map(([key, value]) => {
			if (value instanceof Object) {
				if (seenBranches.has(value)) return [key, `[Circular ${value.constructor.name}]`];
				seenBranches.add(value);
				return [key, (0, exports.getStaticCopy)(value, null, seenBranches)];
			}
			if (typeof value === "symbol") return [key, `[Symbol(${value.description})]`];
			return [key, value];
		});
		return Object.fromEntries(newFields);
	};
	exports.getStaticCopy = getStaticCopy;
	/**
	* Convert just about anything to JSON. The following limitations prevent the generated JSON from being used to reconstruct the
	* original object:
	* - objects will be ignored
	* - circular references will be replaced with the string '[Circular <ClassName>]'
	* - Symbol values will be replaced with the string '[Symbol(<SymbolName>)]' in the copy
	*
	* @param value - The value to convert to JSON
	* @param replacer — An array of strings and numbers that acts as an approved list for selecting the object properties that will be stringified.
	* Defaults to null, which means all properties will be included.
	* @param space — Adds indentation, white space, and line break characters to the return-value JSON text to make it easier to read.
	* Defaults to 2.
	* @returns - The JSON representation of the value, including all evaluated getters and fields up the prototype chain.
	*/
	var toJson = (value, replacer = null, space = 2) => JSON.stringify((0, exports.getStaticCopy)(value, replacer), null, space);
	exports.toJson = toJson;
	var sortJsonByKeys = (json) => {
		if (Array.isArray(json)) return json.map(exports.sortJsonByKeys);
		else if (json !== null && typeof json === "object") return Object.keys(json).sort().reduce((acc, key) => {
			acc[key] = (0, exports.sortJsonByKeys)(json[key]);
			return acc;
		}, {});
		return json;
	};
	exports.sortJsonByKeys = sortJsonByKeys;
	/**
	* Recursively sanitizes all strings in a JSON structure by removing control characters.
	* This prevents postgres errors when saving text/jsonb containing null bytes or other control chars.
	*/
	var sanitizeJson = (json) => {
		if (Array.isArray(json)) return json.map(exports.sanitizeJson);
		else if (json !== null && typeof json === "object") return Object.keys(json).reduce((acc, key) => {
			acc[(0, string_utils_1.sanitizeString)(key)] = (0, exports.sanitizeJson)(json[key]);
			return acc;
		}, {});
		else if (typeof json === "string") return (0, string_utils_1.sanitizeString)(json);
		return json;
	};
	exports.sanitizeJson = sanitizeJson;
	var areJsonEqual = (json1, json2) => JSON.stringify((0, exports.sortJsonByKeys)(json1)) === JSON.stringify((0, exports.sortJsonByKeys)(json2));
	exports.areJsonEqual = areJsonEqual;
	/**
	* Safely extracts a nested property from a Json object and converts it to the specified type
	* @param obj - The Json object to extract from
	* @param path - Array of property names to traverse
	* @returns The converted value or null if the path doesn't exist or validation fails
	*/
	var safeDateExtractFromJson = (obj, path) => {
		if (!obj || typeof obj !== "object" || obj === null) return null;
		let current = obj;
		for (const key of path) {
			if (typeof current !== "object" || current === null || !(key in current)) return null;
			current = current[key];
		}
		if (typeof current !== "string" && typeof current !== "number") return null;
		if (typeof current === "string" && current.trim() === "") return null;
		const date = new Date(current);
		if (isNaN(date.getTime())) return null;
		return date;
	};
	exports.safeDateExtractFromJson = safeDateExtractFromJson;
}));
//#endregion
//#region ../common/lib/retry.utils.js
var require_retry_utils = /* @__PURE__ */ __commonJSMin(((exports, module, this$17) => {
	var __importDefault = this$17 && this$17.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.retry = exports.MAX_NUM_RETRY_REQUESTS = void 0;
	var p_retry_1 = __importDefault(require_p_retry());
	var uuid_1 = require_commonjs_browser();
	var errors_1 = require_errors$1();
	var json_utils_1 = require_json_utils();
	var MIN_RETRY_REQUESTS = 1;
	exports.MAX_NUM_RETRY_REQUESTS = 6;
	/**
	* {@link retry} requires that the thrown value is an instance of {@link Error} for it to work. Since any data type
	* can be thrown, this function converts an unknown thrown value into an error that extends {@link Error} so that
	* retry can work as expected.
	*/
	var wrapWithThrownError = (func) => async (attemptNumber) => {
		try {
			return await func(attemptNumber);
		} catch (err) {
			console.error(err);
			if (err instanceof Error) throw err;
			throw (0, errors_1.createError)("NonErrorThrownInRetry", (0, json_utils_1.toJson)(err));
		}
	};
	/**
	* Retry resolving a function until it resolves or the max number of retries is reached. Exponential back-off is used between retries. The formula
	* used to calculate the individual timeouts is: minTimeout * Math.pow(factor, attempt). If all retries fail, the last error is thrown.
	*
	* For example if minTimeout = 1000, exponent = 2, and numRetries = 6:
	*
	* - 1000 * 2^(1 - 1) = 1000 ms
	* - 1000 * 2^(2 - 1) = 2000 ms
	* - 1000 * 2^(3 - 1) = 4000 ms
	* - 1000 * 2^(4 - 1) = 8000 ms
	* - 1000 * 2^(5 - 1) = 16000 ms
	* - 1000 * 2^(6 - 1) = 32000 ms
	*
	* total = 63 seconds
	*
	* @param fn - The function to retry
	* @param options.errorMessage - The error message to include in log when a retry occurs.
	* @param options.numRetries - The number of times to retry the function. Defaults to 6.
	* @param options.minTimeout - The minimum timeout between retries. Defaults to 1000 ms.
	* @param options.exponent - The exponent to use when calculating the timeout between retries. Defaults to 2.
	* @param options.suppressErrors - If true, errors will not be logged to the console each time the function is retried. Defaults to false.
	* @param options.randomize - If true, the timeout between retries will be randomized. Defaults to false.
	* @returns The resolved value of the function
	* @throws The last error thrown by the function
	*/
	var retry = (fn, options = {}) => {
		const retries = options.numRetries ?? 6;
		if (retries < MIN_RETRY_REQUESTS || retries > exports.MAX_NUM_RETRY_REQUESTS) throw new Error(`Configured max number of retries must be between ${MIN_RETRY_REQUESTS} and ${exports.MAX_NUM_RETRY_REQUESTS}`);
		const minTimeout = options.minTimeout ?? 1e3;
		const exponent = options.exponent ?? 2;
		const randomize = options.randomize ?? false;
		const retryTraceId = (0, uuid_1.v4)();
		return (0, p_retry_1.default)(wrapWithThrownError(fn), {
			retries,
			minTimeout,
			factor: exponent,
			randomize,
			onFailedAttempt: (error) => {
				if (options.suppressErrors) return;
				if (error.retriesLeft > 0) {
					const errorMessage = error.message ?? options.errorMessage ?? "Unknown error";
					console.error("RetryAttemptFailure", `${errorMessage} attempt ${error.attemptNumber} of ${error.attemptNumber + error.retriesLeft} traceId ${retryTraceId} using function ${fn.toString()}`);
				}
			}
		});
	};
	exports.retry = retry;
}));
//#endregion
//#region ../common/lib/types.utils.js
var require_types_utils = /* @__PURE__ */ __commonJSMin(((exports, module, this$16) => {
	var __importDefault = this$16 && this$16.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.singleTenantDomainRedirectInputSchema = exports.singleTenantRedirectUrlSchema = exports.singleTenantEmailDomainSchema = exports.parseOrThrowClientError = exports.enumSchemaFromDynamicArray = exports.ssoProviderNameSchema = exports.SSO_PROVIDER_NAME_REGEX = exports.monthYearStringSchema = exports.monthYearPeriodNullableSchema = exports.monthYearPeriodSchema = exports.monthYearSchema = exports.vendorSchema = exports.notSpecifiedTransform = exports.dollarsToCentsSchema = exports.emailSchema = exports.uuidSchema = exports.monthSchema = exports.yearSchema = exports.intSchema = exports.positiveIntSchema = exports.nonNegativeNumberSchema = exports.isoDateTimeStringSchema = exports.dateTimeOptionalTimeZoneStringSchema = exports.dateTimeOptionalTimeZoneRegex = exports.dateCoercionSchema = exports.dateStringSchema = exports.datetimeSchema = exports.commaDelimitedStringSchema = exports.nullableOptionalStringSchema = exports.nullableStringSchema = exports.stringSchema = exports.jsonArraySchema = exports.jsonObjectSchema = exports.jsonSchema = exports.assertNeverType = exports.assertNever = void 0;
	var zod_1 = __importDefault(require_zod());
	var errors_1 = require_errors$1();
	var money_utils_1 = require_money_utils();
	var assertNever = (value) => {
		throw (0, errors_1.createError)("ImpossibleValueError", `Unexpected code path with value: ${value}`);
	};
	exports.assertNever = assertNever;
	var assertNeverType = (typeValue, typeName = "type") => {
		throw new TypeError(`Unexpected ${typeName}: ${typeValue}`);
	};
	exports.assertNeverType = assertNeverType;
	var literalSchema = zod_1.default.union([
		zod_1.default.string(),
		zod_1.default.number(),
		zod_1.default.boolean(),
		zod_1.default.null(),
		zod_1.default.date()
	]);
	exports.jsonSchema = zod_1.default.lazy(() => zod_1.default.union([
		literalSchema,
		zod_1.default.array(exports.jsonSchema),
		zod_1.default.record(zod_1.default.string(), exports.jsonSchema)
	]));
	exports.jsonObjectSchema = zod_1.default.record(zod_1.default.string(), exports.jsonSchema);
	exports.jsonArraySchema = exports.jsonSchema.array();
	exports.stringSchema = zod_1.default.string().min(1);
	exports.nullableStringSchema = zod_1.default.preprocess((arg) => {
		if (typeof arg === "string" && arg.length === 0) return null;
		return arg;
	}, exports.stringSchema.nullable());
	exports.nullableOptionalStringSchema = exports.nullableStringSchema.optional();
	/**
	* Parse a comma-delimited string into an array of strings. Trims whitespace from each value. Allows empty strings.
	*/
	exports.commaDelimitedStringSchema = zod_1.default.preprocess((arg) => {
		if (typeof arg === "string") return arg.split(",").map((value) => value.trim());
		return arg;
	}, zod_1.default.array(zod_1.default.string()));
	exports.datetimeSchema = zod_1.default.preprocess((arg) => {
		if (typeof arg == "string" || arg instanceof Date) return new Date(arg);
	}, zod_1.default.date());
	exports.dateStringSchema = zod_1.default.preprocess((arg) => {
		if (typeof arg == "string") return arg.slice(0, 10);
	}, exports.stringSchema.regex(/\d{4}-(0\d|1[0-2])-([0-2]\d|3[01])/));
	exports.dateCoercionSchema = zod_1.default.coerce.date();
	exports.dateTimeOptionalTimeZoneRegex = /\d{4}-?(0\d|1[0-2])-?([0-2]\d|3[01])T\d\d:?\d\d:?\d\d(.\d\d\d)?([Z]|[+-]\d\d:?\d\d)?/;
	exports.dateTimeOptionalTimeZoneStringSchema = exports.stringSchema.regex(exports.dateTimeOptionalTimeZoneRegex);
	/**
	* Schema that validates and converts datetime strings to ISO format for external API consumption.
	* Accepts various datetime formats and ensures output is a valid ISO string.
	*/
	exports.isoDateTimeStringSchema = zod_1.default.preprocess((arg) => {
		if (!arg || typeof arg !== "string") throw new zod_1.default.ZodError([{
			code: "custom",
			message: "Missing or invalid datetime value",
			path: []
		}]);
		try {
			const date = new Date(arg);
			if (isNaN(date.getTime())) throw new zod_1.default.ZodError([{
				code: "custom",
				message: `Invalid datetime format: ${arg}`,
				path: []
			}]);
			return date.toISOString();
		} catch (error) {
			if (error instanceof zod_1.default.ZodError) throw error;
			throw new zod_1.default.ZodError([{
				code: "custom",
				message: `Failed to parse datetime: ${arg}`,
				path: []
			}]);
		}
	}, exports.stringSchema);
	exports.nonNegativeNumberSchema = zod_1.default.number().nonnegative();
	exports.positiveIntSchema = exports.nonNegativeNumberSchema.int();
	exports.intSchema = zod_1.default.int();
	exports.yearSchema = zod_1.default.number().gte(1900).lte(9999);
	exports.monthSchema = zod_1.default.number().gte(0).lte(11);
	exports.uuidSchema = exports.stringSchema.uuid();
	exports.emailSchema = zod_1.default.email();
	exports.dollarsToCentsSchema = zod_1.default.preprocess((arg) => {
		if (typeof arg == "number") return (0, money_utils_1.parseCents)(arg * 100);
	}, zod_1.default.number());
	var notSpecifiedTransform = (name) => {
		if (!name || name.length === 0 || name === "Not Specified") return "Not Specified";
		return name;
	};
	exports.notSpecifiedTransform = notSpecifiedTransform;
	exports.vendorSchema = zod_1.default.preprocess((arg) => {
		if (typeof arg == "string") return (0, exports.notSpecifiedTransform)(arg);
	}, zod_1.default.string());
	exports.monthYearSchema = zod_1.default.object({
		month: exports.monthSchema,
		year: exports.yearSchema
	});
	exports.monthYearPeriodSchema = zod_1.default.object({
		startMonthYear: exports.monthYearSchema,
		endMonthYear: exports.monthYearSchema
	});
	exports.monthYearPeriodNullableSchema = zod_1.default.object({
		startMonthYear: exports.monthYearSchema.nullable(),
		endMonthYear: exports.monthYearSchema.nullable()
	});
	exports.monthYearStringSchema = zod_1.default.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/);
	exports.SSO_PROVIDER_NAME_REGEX = /^(oidc\.|saml\.)/;
	exports.ssoProviderNameSchema = zod_1.default.string().regex(exports.SSO_PROVIDER_NAME_REGEX, "Must start with 'oidc.' or 'saml.'");
	/** Intended to be used with dynamic arrays only. Static arrays are easily created with `z.enum`. */
	var enumSchemaFromDynamicArray = (array) => {
		if (array.length === 0) throw new Error("Array must contain at least one element to create a Zod enum");
		return zod_1.default.enum([array[0], ...array.slice(1)]);
	};
	exports.enumSchemaFromDynamicArray = enumSchemaFromDynamicArray;
	var parseOrThrowClientError = (schema, value) => {
		const parsed = schema.safeParse(value);
		if (!parsed.success) {
			const errors = parsed.error.issues.map((zodError) => ({
				code: zodError.code.toUpperCase(),
				description: `${zodError.message} at ${zodError.path.join(".")} field`
			}));
			throw (0, errors_1.createClientErrors)(errors);
		}
		return parsed.data;
	};
	exports.parseOrThrowClientError = parseOrThrowClientError;
	var isHttpUrl = (value) => {
		try {
			const { protocol } = new URL(value);
			return protocol === "https:" || protocol === "http:";
		} catch {
			return false;
		}
	};
	/** Labels of letters/digits/hyphens (not starting/ending with a hyphen), at least one dot + a TLD. */
	var SINGLE_TENANT_DOMAIN_REGEX = /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;
	/** Validates an email domain (e.g. "acme.com") for a single-tenant redirect; trims + lowercases. */
	exports.singleTenantEmailDomainSchema = zod_1.default.string().transform((value) => value.trim().toLowerCase()).refine((value) => value.length > 0, "Domain is required.").refine((value) => !value.includes("@"), "Enter just the domain, not an email address (e.g. acme.com).").refine((value) => SINGLE_TENANT_DOMAIN_REGEX.test(value), "Enter a valid domain, e.g. acme.com.");
	/** Validates a single-tenant instance redirect URL; must be a full http(s) URL. */
	exports.singleTenantRedirectUrlSchema = zod_1.default.string().transform((value) => value.trim()).refine((value) => value.length > 0, "Redirect URL is required.").refine((value) => isHttpUrl(value), "Enter a full URL, e.g. https://acme.neo.tax.");
	/** Combined input schema for creating/updating a single-tenant domain redirect. */
	exports.singleTenantDomainRedirectInputSchema = zod_1.default.object({
		emailDomain: exports.singleTenantEmailDomainSchema,
		redirectUrl: exports.singleTenantRedirectUrlSchema
	});
}));
//#endregion
//#region ../common/lib/slack.types.js
var require_slack_types = /* @__PURE__ */ __commonJSMin(((exports, module, this$15) => {
	var __importDefault = this$15 && this$15.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.slackEventDtoSchema = void 0;
	var zod_1 = __importDefault(require_zod());
	var additionalDataSchema = zod_1.default.record(zod_1.default.string(), zod_1.default.string());
	var slackEventBaseSchema = zod_1.default.object({
		eventName: zod_1.default.string(),
		additionalData: additionalDataSchema.optional()
	});
	var companyInfoSchema = zod_1.default.object({
		userEmail: zod_1.default.string().optional(),
		companyId: zod_1.default.string(),
		companyName: zod_1.default.string()
	});
	var userInfoSchema = zod_1.default.object({
		userEmail: zod_1.default.string(),
		companyId: zod_1.default.string().optional(),
		companyName: zod_1.default.string().optional()
	});
	exports.slackEventDtoSchema = slackEventBaseSchema.and(companyInfoSchema.or(userInfoSchema));
}));
//#endregion
//#region ../common/lib/interfaces/errors/base-error.interface.js
var require_base_error_interface = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseErrorSchema = void 0;
	var zod_1 = require_zod();
	/**
	* This schema should not be used to parse most errors especially known errors.
	* It should be used to create and extend new error schemas. It acts as a pattern.
	* `code` is always required whereas `description` should be either required or
	* replaced by other more descriptive properties.
	**/
	exports.BaseErrorSchema = zod_1.z.object({
		code: zod_1.z.string().min(1),
		description: zod_1.z.string().min(1).optional()
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/graphql-error.interface.js
var require_graphql_error_interface = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeParseExtendedGraphQlError = exports.safeParseExtendedApolloError = exports.parseExtendedGraphQlError = exports.parseExtendedApolloError = void 0;
	var zod_1 = require_zod();
	var makeApolloErrorSchema = (errorSchema) => {
		const GraphQlErrorSchema = makeGraphQlErrorSchema(errorSchema);
		return zod_1.z.object({ graphQLErrors: zod_1.z.array(GraphQlErrorSchema) });
	};
	var makeGraphQlErrorSchema = (errorSchema) => zod_1.z.object({
		message: zod_1.z.string().min(1),
		extensions: zod_1.z.object({
			code: zod_1.z.string().min(1),
			errors: zod_1.z.array(errorSchema)
		})
	});
	var parseExtendedApolloError = (error, errorSchema) => {
		return makeApolloErrorSchema(errorSchema).parse(error);
	};
	exports.parseExtendedApolloError = parseExtendedApolloError;
	var parseExtendedGraphQlError = (error, errorSchema) => {
		return makeGraphQlErrorSchema(errorSchema).parse(error);
	};
	exports.parseExtendedGraphQlError = parseExtendedGraphQlError;
	var safeParseExtendedApolloError = (error, errorSchema) => {
		return makeApolloErrorSchema(errorSchema).safeParse(error);
	};
	exports.safeParseExtendedApolloError = safeParseExtendedApolloError;
	var safeParseExtendedGraphQlError = (error, errorSchema) => {
		return makeGraphQlErrorSchema(errorSchema).safeParse(error);
	};
	exports.safeParseExtendedGraphQlError = safeParseExtendedGraphQlError;
}));
//#endregion
//#region ../common/lib/interfaces/errors/project-deletion-error.interface.js
var require_project_deletion_error_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$14) => {
	var __createBinding = this$14 && this$14.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$14 && this$14.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$14 && this$14.__importStar || (function() {
		var ownKeys = function(o) {
			ownKeys = Object.getOwnPropertyNames || function(o) {
				var ar = [];
				for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
				return ar;
			};
			return ownKeys(o);
		};
		return function(mod) {
			if (mod && mod.__esModule) return mod;
			var result = {};
			if (mod != null) {
				for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
			}
			__setModuleDefault(result, mod);
			return result;
		};
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RdProjectDeletionErrorSchema = exports.AscProjectDeletionErrorSchema = void 0;
	var z = __importStar(require_zod());
	var base_error_interface_1 = require_base_error_interface();
	exports.AscProjectDeletionErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
		code: z.enum(["ASC_PROJECT_HAS_TICKETS"]),
		description: z.string().min(1)
	});
	exports.RdProjectDeletionErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
		code: z.enum(["RD_PROJECT_HAS_TICKETS"]),
		description: z.string().min(1)
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/question-answer-error.interface.js
var require_question_answer_error_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$13) => {
	var __createBinding = this$13 && this$13.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$13 && this$13.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$13 && this$13.__importStar || (function() {
		var ownKeys = function(o) {
			ownKeys = Object.getOwnPropertyNames || function(o) {
				var ar = [];
				for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
				return ar;
			};
			return ownKeys(o);
		};
		return function(mod) {
			if (mod && mod.__esModule) return mod;
			var result = {};
			if (mod != null) {
				for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
			}
			__setModuleDefault(result, mod);
			return result;
		};
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuestionAnswerErrorSchema = void 0;
	var z = __importStar(require_zod());
	exports.QuestionAnswerErrorSchema = require_base_error_interface().BaseErrorSchema.extend({
		code: z.enum(["INVALID_ANSWER"]),
		questionCode: z.string().min(1),
		description: z.string().min(1)
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/standard-error.interface.js
var require_standard_error_interface = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StandardErrorSchema = void 0;
	var zod_1 = require_zod();
	/**
	* This schema can be used for generic errors when making a new schema is not necessary.
	**/
	exports.StandardErrorSchema = require_base_error_interface().BaseErrorSchema.extend({
		code: zod_1.z.enum([
			"BAD_REQUEST",
			"CONFLICT",
			"NOT_FOUND"
		]),
		description: zod_1.z.string()
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/project-document-parsing-error.interface.js
var require_project_document_parsing_error_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$12) => {
	var __createBinding = this$12 && this$12.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$12 && this$12.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$12 && this$12.__importStar || (function() {
		var ownKeys = function(o) {
			ownKeys = Object.getOwnPropertyNames || function(o) {
				var ar = [];
				for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
				return ar;
			};
			return ownKeys(o);
		};
		return function(mod) {
			if (mod && mod.__esModule) return mod;
			var result = {};
			if (mod != null) {
				for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
			}
			__setModuleDefault(result, mod);
			return result;
		};
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DocumentNotParsableErrorSchema = void 0;
	var z = __importStar(require_zod());
	exports.DocumentNotParsableErrorSchema = require_base_error_interface().BaseErrorSchema.extend({
		code: z.enum(["DOCUMENT_NOT_PARSABLE"]),
		description: z.string().min(1)
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/apply-weighted-rd-percentage-to-expenses-error.interface.js
var require_apply_weighted_rd_percentage_to_expenses_error_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$11) => {
	var __createBinding = this$11 && this$11.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$11 && this$11.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$11 && this$11.__importStar || (function() {
		var ownKeys = function(o) {
			ownKeys = Object.getOwnPropertyNames || function(o) {
				var ar = [];
				for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
				return ar;
			};
			return ownKeys(o);
		};
		return function(mod) {
			if (mod && mod.__esModule) return mod;
			var result = {};
			if (mod != null) {
				for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
			}
			__setModuleDefault(result, mod);
			return result;
		};
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ApplyWeightedRdPercentageToExpensesErrorSchema = exports.ApplyWeightedRdPercentageToExpensesErrorCodes = void 0;
	var z = __importStar(require_zod());
	var base_error_interface_1 = require_base_error_interface();
	exports.ApplyWeightedRdPercentageToExpensesErrorCodes = {
		INVALID_QUALIFIED_EXPENSES: "APPLY_WEIGHTED_RD_PERCENTAGE_TO_EXPENSES_INVALID_QUALIFIED_EXPENSES",
		INVALID_QUALIFIED_AMOUNT: "APPLY_WEIGHTED_RD_PERCENTAGE_TO_EXPENSES_INVALID_QUALIFIED_AMOUNT"
	};
	exports.ApplyWeightedRdPercentageToExpensesErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
		code: z.enum([exports.ApplyWeightedRdPercentageToExpensesErrorCodes.INVALID_QUALIFIED_EXPENSES, exports.ApplyWeightedRdPercentageToExpensesErrorCodes.INVALID_QUALIFIED_AMOUNT]),
		description: z.string().min(1)
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/organization-invitation-error.interface.js
var require_organization_invitation_error_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$10) => {
	var __createBinding = this$10 && this$10.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = this$10 && this$10.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = this$10 && this$10.__importStar || (function() {
		var ownKeys = function(o) {
			ownKeys = Object.getOwnPropertyNames || function(o) {
				var ar = [];
				for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
				return ar;
			};
			return ownKeys(o);
		};
		return function(mod) {
			if (mod && mod.__esModule) return mod;
			var result = {};
			if (mod != null) {
				for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
			}
			__setModuleDefault(result, mod);
			return result;
		};
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.OrganizationInvitationErrorSchema = exports.OrganizationInvitationErrorCodes = void 0;
	var z = __importStar(require_zod());
	var base_error_interface_1 = require_base_error_interface();
	exports.OrganizationInvitationErrorCodes = {
		NOT_FOUND: "INVITATION_NOT_FOUND",
		EXPIRED: "INVITATION_EXPIRED",
		REVOKED: "INVITATION_REVOKED",
		ALREADY_ACCEPTED: "INVITATION_ALREADY_ACCEPTED",
		EMAIL_MISMATCH: "INVITATION_EMAIL_MISMATCH",
		SSO_PROVIDER_MISMATCH: "SSO_PROVIDER_MISMATCH",
		INVITEE_ALREADY_IN_ORGANIZATION: "INVITEE_ALREADY_IN_ORGANIZATION",
		CONFLICT_ALREADY_MEMBER: "INVITATION_CONFLICT_ALREADY_MEMBER",
		CONFLICT_MEMBER_OF_OTHER_ORG: "INVITATION_CONFLICT_MEMBER_OF_OTHER_ORG",
		CONFLICT_PENDING_TO_OTHER_ORG: "INVITATION_CONFLICT_PENDING_TO_OTHER_ORG",
		RESEND_TOO_FREQUENT: "INVITATION_RESEND_TOO_FREQUENT"
	};
	exports.OrganizationInvitationErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
		code: z.enum([
			exports.OrganizationInvitationErrorCodes.NOT_FOUND,
			exports.OrganizationInvitationErrorCodes.EXPIRED,
			exports.OrganizationInvitationErrorCodes.REVOKED,
			exports.OrganizationInvitationErrorCodes.ALREADY_ACCEPTED,
			exports.OrganizationInvitationErrorCodes.EMAIL_MISMATCH,
			exports.OrganizationInvitationErrorCodes.SSO_PROVIDER_MISMATCH,
			exports.OrganizationInvitationErrorCodes.INVITEE_ALREADY_IN_ORGANIZATION,
			exports.OrganizationInvitationErrorCodes.CONFLICT_ALREADY_MEMBER,
			exports.OrganizationInvitationErrorCodes.CONFLICT_MEMBER_OF_OTHER_ORG,
			exports.OrganizationInvitationErrorCodes.CONFLICT_PENDING_TO_OTHER_ORG,
			exports.OrganizationInvitationErrorCodes.RESEND_TOO_FREQUENT
		]),
		description: z.string().min(1)
	});
}));
//#endregion
//#region ../common/lib/interfaces/errors/index.js
var require_errors = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.OrganizationInvitationErrorCodes = exports.OrganizationInvitationErrorSchema = exports.ApplyWeightedRdPercentageToExpensesErrorCodes = exports.ApplyWeightedRdPercentageToExpensesErrorSchema = exports.DocumentNotParsableErrorSchema = exports.StandardErrorSchema = exports.QuestionAnswerErrorSchema = exports.RdProjectDeletionErrorSchema = exports.AscProjectDeletionErrorSchema = exports.safeParseExtendedGraphQlError = exports.safeParseExtendedApolloError = exports.parseExtendedGraphQlError = exports.parseExtendedApolloError = exports.BaseErrorSchema = void 0;
	var base_error_interface_1 = require_base_error_interface();
	Object.defineProperty(exports, "BaseErrorSchema", {
		enumerable: true,
		get: function() {
			return base_error_interface_1.BaseErrorSchema;
		}
	});
	var graphql_error_interface_1 = require_graphql_error_interface();
	Object.defineProperty(exports, "parseExtendedApolloError", {
		enumerable: true,
		get: function() {
			return graphql_error_interface_1.parseExtendedApolloError;
		}
	});
	Object.defineProperty(exports, "parseExtendedGraphQlError", {
		enumerable: true,
		get: function() {
			return graphql_error_interface_1.parseExtendedGraphQlError;
		}
	});
	Object.defineProperty(exports, "safeParseExtendedApolloError", {
		enumerable: true,
		get: function() {
			return graphql_error_interface_1.safeParseExtendedApolloError;
		}
	});
	Object.defineProperty(exports, "safeParseExtendedGraphQlError", {
		enumerable: true,
		get: function() {
			return graphql_error_interface_1.safeParseExtendedGraphQlError;
		}
	});
	var project_deletion_error_interface_1 = require_project_deletion_error_interface();
	Object.defineProperty(exports, "AscProjectDeletionErrorSchema", {
		enumerable: true,
		get: function() {
			return project_deletion_error_interface_1.AscProjectDeletionErrorSchema;
		}
	});
	Object.defineProperty(exports, "RdProjectDeletionErrorSchema", {
		enumerable: true,
		get: function() {
			return project_deletion_error_interface_1.RdProjectDeletionErrorSchema;
		}
	});
	var question_answer_error_interface_1 = require_question_answer_error_interface();
	Object.defineProperty(exports, "QuestionAnswerErrorSchema", {
		enumerable: true,
		get: function() {
			return question_answer_error_interface_1.QuestionAnswerErrorSchema;
		}
	});
	var standard_error_interface_1 = require_standard_error_interface();
	Object.defineProperty(exports, "StandardErrorSchema", {
		enumerable: true,
		get: function() {
			return standard_error_interface_1.StandardErrorSchema;
		}
	});
	var project_document_parsing_error_interface_1 = require_project_document_parsing_error_interface();
	Object.defineProperty(exports, "DocumentNotParsableErrorSchema", {
		enumerable: true,
		get: function() {
			return project_document_parsing_error_interface_1.DocumentNotParsableErrorSchema;
		}
	});
	var apply_weighted_rd_percentage_to_expenses_error_interface_1 = require_apply_weighted_rd_percentage_to_expenses_error_interface();
	Object.defineProperty(exports, "ApplyWeightedRdPercentageToExpensesErrorSchema", {
		enumerable: true,
		get: function() {
			return apply_weighted_rd_percentage_to_expenses_error_interface_1.ApplyWeightedRdPercentageToExpensesErrorSchema;
		}
	});
	Object.defineProperty(exports, "ApplyWeightedRdPercentageToExpensesErrorCodes", {
		enumerable: true,
		get: function() {
			return apply_weighted_rd_percentage_to_expenses_error_interface_1.ApplyWeightedRdPercentageToExpensesErrorCodes;
		}
	});
	var organization_invitation_error_interface_1 = require_organization_invitation_error_interface();
	Object.defineProperty(exports, "OrganizationInvitationErrorSchema", {
		enumerable: true,
		get: function() {
			return organization_invitation_error_interface_1.OrganizationInvitationErrorSchema;
		}
	});
	Object.defineProperty(exports, "OrganizationInvitationErrorCodes", {
		enumerable: true,
		get: function() {
			return organization_invitation_error_interface_1.OrganizationInvitationErrorCodes;
		}
	});
}));
//#endregion
//#region ../common/lib/interfaces/web-app/sso-state.interface.js
var require_sso_state_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$9) => {
	var __importDefault = this$9 && this$9.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SsoStateSchema = void 0;
	var zod_1 = __importDefault(require_zod());
	exports.SsoStateSchema = zod_1.default.object({
		existingQueryParams: zod_1.default.string().optional(),
		successRedirectUrl: zod_1.default.string(),
		errorRedirectUrl: zod_1.default.string()
	});
}));
//#endregion
//#region ../common/lib/interfaces/web-app/base-callback-state.interface.js
var require_base_callback_state_interface = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseCallbackPayloadState = void 0;
	var types_utils_1 = require_types_utils();
	exports.BaseCallbackPayloadState = {
		userId: types_utils_1.stringSchema,
		companyId: types_utils_1.stringSchema,
		existingQueryParams: types_utils_1.stringSchema.optional(),
		successRedirectUrl: types_utils_1.stringSchema,
		errorRedirectUrl: types_utils_1.stringSchema
	};
}));
//#endregion
//#region ../common/lib/interfaces/web-app/intuit-sso-state.interface.js
var require_intuit_sso_state_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$8) => {
	var __importDefault = this$8 && this$8.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuickbooksCallbackPayloadStateSchema = exports.IntuitSsoCallbackPayloadStateSchema = exports.QuickbooksDataLinkingCallbackPayloadStateSchema = void 0;
	var zod_1 = __importDefault(require_zod());
	var types_utils_1 = require_types_utils();
	var base_callback_state_interface_1 = require_base_callback_state_interface();
	exports.QuickbooksDataLinkingCallbackPayloadStateSchema = zod_1.default.object({
		...base_callback_state_interface_1.BaseCallbackPayloadState,
		isSso: zod_1.default.literal(false)
	});
	exports.IntuitSsoCallbackPayloadStateSchema = zod_1.default.object({
		successRedirectUrl: types_utils_1.stringSchema,
		errorRedirectUrl: types_utils_1.stringSchema,
		isSso: zod_1.default.literal(true)
	});
	exports.QuickbooksCallbackPayloadStateSchema = zod_1.default.union([exports.QuickbooksDataLinkingCallbackPayloadStateSchema, exports.IntuitSsoCallbackPayloadStateSchema]);
}));
//#endregion
//#region ../common/lib/interfaces/web-app/gusto-sso-state.interface.js
var require_gusto_sso_state_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$7) => {
	var __importDefault = this$7 && this$7.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GustoCallbackPayloadStateSchema = void 0;
	var zod_1 = __importDefault(require_zod());
	var base_callback_state_interface_1 = require_base_callback_state_interface();
	exports.GustoCallbackPayloadStateSchema = zod_1.default.object(base_callback_state_interface_1.BaseCallbackPayloadState);
}));
//#endregion
//#region ../common/lib/interfaces/web-app/thomson-reuters-sso-state.interface.js
var require_thomson_reuters_sso_state_interface = /* @__PURE__ */ __commonJSMin(((exports, module, this$6) => {
	var __importDefault = this$6 && this$6.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ThomsonReutersCallbackPayloadStateSchema = void 0;
	var zod_1 = __importDefault(require_zod());
	var types_utils_1 = require_types_utils();
	var base_callback_state_interface_1 = require_base_callback_state_interface();
	exports.ThomsonReutersCallbackPayloadStateSchema = zod_1.default.object({
		...base_callback_state_interface_1.BaseCallbackPayloadState,
		action: types_utils_1.stringSchema,
		binderId: types_utils_1.stringSchema,
		taxYear: types_utils_1.yearSchema,
		userId: types_utils_1.stringSchema
	});
}));
//#endregion
//#region ../common/lib/interfaces/web-app/index.js
var require_web_app = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ThomsonReutersCallbackPayloadStateSchema = exports.GustoCallbackPayloadStateSchema = exports.QuickbooksCallbackPayloadStateSchema = exports.IntuitSsoCallbackPayloadStateSchema = exports.QuickbooksDataLinkingCallbackPayloadStateSchema = exports.SsoStateSchema = void 0;
	var sso_state_interface_1 = require_sso_state_interface();
	Object.defineProperty(exports, "SsoStateSchema", {
		enumerable: true,
		get: function() {
			return sso_state_interface_1.SsoStateSchema;
		}
	});
	var intuit_sso_state_interface_1 = require_intuit_sso_state_interface();
	Object.defineProperty(exports, "QuickbooksDataLinkingCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return intuit_sso_state_interface_1.QuickbooksDataLinkingCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "IntuitSsoCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return intuit_sso_state_interface_1.IntuitSsoCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "QuickbooksCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return intuit_sso_state_interface_1.QuickbooksCallbackPayloadStateSchema;
		}
	});
	var gusto_sso_state_interface_1 = require_gusto_sso_state_interface();
	Object.defineProperty(exports, "GustoCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return gusto_sso_state_interface_1.GustoCallbackPayloadStateSchema;
		}
	});
	var thomson_reuters_sso_state_interface_1 = require_thomson_reuters_sso_state_interface();
	Object.defineProperty(exports, "ThomsonReutersCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return thomson_reuters_sso_state_interface_1.ThomsonReutersCallbackPayloadStateSchema;
		}
	});
}));
//#endregion
//#region ../common/lib/interfaces/finch.interface.js
var require_finch_interface = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FinchProviderKeySchema = void 0;
	/**
	* https://developer.tryfinch.com/integrations/providers
	*/
	exports.FinchProviderKeySchema = require_zod().z.enum([
		"justworks",
		"trinet",
		"quickbooks",
		"adp_run",
		"adp_workforce_now",
		"ceridian_dayforce",
		"paychex_flex",
		"paylocity",
		"workday",
		"zenefits"
	]);
}));
//#endregion
//#region ../common/lib/interfaces/index.js
var require_interfaces = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FinchProviderKeySchema = exports.ThomsonReutersCallbackPayloadStateSchema = exports.GustoCallbackPayloadStateSchema = exports.QuickbooksCallbackPayloadStateSchema = exports.IntuitSsoCallbackPayloadStateSchema = exports.QuickbooksDataLinkingCallbackPayloadStateSchema = exports.SsoStateSchema = exports.OrganizationInvitationErrorCodes = exports.OrganizationInvitationErrorSchema = exports.DocumentNotParsableErrorSchema = exports.ApplyWeightedRdPercentageToExpensesErrorSchema = exports.QuestionAnswerErrorSchema = exports.RdProjectDeletionErrorSchema = exports.AscProjectDeletionErrorSchema = exports.StandardErrorSchema = exports.BaseErrorSchema = exports.safeParseExtendedGraphQlError = exports.safeParseExtendedApolloError = exports.parseExtendedGraphQlError = exports.parseExtendedApolloError = void 0;
	var errors_1 = require_errors();
	Object.defineProperty(exports, "parseExtendedApolloError", {
		enumerable: true,
		get: function() {
			return errors_1.parseExtendedApolloError;
		}
	});
	Object.defineProperty(exports, "parseExtendedGraphQlError", {
		enumerable: true,
		get: function() {
			return errors_1.parseExtendedGraphQlError;
		}
	});
	Object.defineProperty(exports, "safeParseExtendedApolloError", {
		enumerable: true,
		get: function() {
			return errors_1.safeParseExtendedApolloError;
		}
	});
	Object.defineProperty(exports, "safeParseExtendedGraphQlError", {
		enumerable: true,
		get: function() {
			return errors_1.safeParseExtendedGraphQlError;
		}
	});
	Object.defineProperty(exports, "BaseErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.BaseErrorSchema;
		}
	});
	Object.defineProperty(exports, "StandardErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.StandardErrorSchema;
		}
	});
	Object.defineProperty(exports, "AscProjectDeletionErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.AscProjectDeletionErrorSchema;
		}
	});
	Object.defineProperty(exports, "RdProjectDeletionErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.RdProjectDeletionErrorSchema;
		}
	});
	Object.defineProperty(exports, "QuestionAnswerErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.QuestionAnswerErrorSchema;
		}
	});
	Object.defineProperty(exports, "ApplyWeightedRdPercentageToExpensesErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.ApplyWeightedRdPercentageToExpensesErrorSchema;
		}
	});
	Object.defineProperty(exports, "DocumentNotParsableErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.DocumentNotParsableErrorSchema;
		}
	});
	Object.defineProperty(exports, "OrganizationInvitationErrorSchema", {
		enumerable: true,
		get: function() {
			return errors_1.OrganizationInvitationErrorSchema;
		}
	});
	Object.defineProperty(exports, "OrganizationInvitationErrorCodes", {
		enumerable: true,
		get: function() {
			return errors_1.OrganizationInvitationErrorCodes;
		}
	});
	var web_app_1 = require_web_app();
	Object.defineProperty(exports, "SsoStateSchema", {
		enumerable: true,
		get: function() {
			return web_app_1.SsoStateSchema;
		}
	});
	Object.defineProperty(exports, "QuickbooksDataLinkingCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return web_app_1.QuickbooksDataLinkingCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "IntuitSsoCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return web_app_1.IntuitSsoCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "QuickbooksCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return web_app_1.QuickbooksCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "GustoCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return web_app_1.GustoCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "ThomsonReutersCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return web_app_1.ThomsonReutersCallbackPayloadStateSchema;
		}
	});
	var finch_interface_1 = require_finch_interface();
	Object.defineProperty(exports, "FinchProviderKeySchema", {
		enumerable: true,
		get: function() {
			return finch_interface_1.FinchProviderKeySchema;
		}
	});
}));
//#endregion
//#region ../common/lib/array.utils.js
var require_array_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.deduplicate = exports.chunk = exports.removeElement = exports.range = exports.moveElement = exports.insertElements = exports.calculateStep = void 0;
	var errors_1 = require_errors$1();
	var calculateStep = (difference, step) => {
		if (typeof step === "number") {
			if (step > 0 && difference < 0 || step < 0 && difference > 0) throw (0, errors_1.createError)("CalculateStepError", `step: ${step}, difference: ${difference}`);
			return step;
		}
		if (difference > 0) return 1;
		return -1;
	};
	exports.calculateStep = calculateStep;
	/**
	* Returns a new array with the elements at `index` inserted.
	*/
	var insertElements = (arr, index, ...items) => {
		if (index < 0 || index > arr.length) throw new Error(`index is out of bounds: ${index}`);
		const newArr = [...arr];
		newArr.splice(index, 0, ...items);
		return newArr;
	};
	exports.insertElements = insertElements;
	/**
	* Returns a new array moving the element at `fromIndex` to `toIndex`.
	*/
	var moveElement = (arr, fromIndex, toIndex) => {
		if (fromIndex < 0 || fromIndex >= arr.length) throw new Error(`fromIndex is out of bounds: ${fromIndex}`);
		if (toIndex < 0 || toIndex >= arr.length) throw new Error(`toIndex is out of bounds: ${toIndex}`);
		const element = arr[fromIndex];
		const newArr = [...arr];
		newArr.splice(fromIndex, 1);
		newArr.splice(toIndex, 0, element);
		return newArr;
	};
	exports.moveElement = moveElement;
	/**
	* Range function with configurable step and non-inclusive `end` value.
	*/
	var range = (start, end, step) => {
		if (step === 0) throw (0, errors_1.createError)("RangeStepError", "Step cannot be 0");
		const difference = end - start;
		if (typeof step === "number" && (step > 0 && difference < 0 || step < 0 && difference > 0)) throw (0, errors_1.createError)("RangeStepError", `The step ${step} is not compatible with the range ${start} to ${end}. You can not reach the end from the current start using that step polarity.`);
		const calculatedStep = (0, exports.calculateStep)(difference, step);
		const length = Math.floor(difference / calculatedStep);
		return Array.from({ length }, (_, i) => start + i * calculatedStep);
	};
	exports.range = range;
	/**
	* Returns a new array with the element at `index` removed.
	*/
	var removeElement = (arr, index, deleteCount = 1) => {
		if (index < 0 || index >= arr.length) throw new Error(`index is out of bounds: ${index}`);
		const newArr = [...arr];
		newArr.splice(index, deleteCount);
		return newArr;
	};
	exports.removeElement = removeElement;
	var chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, (i + 1) * size));
	exports.chunk = chunk;
	var deduplicate = (arr) => [...new Set(arr)];
	exports.deduplicate = deduplicate;
}));
//#endregion
//#region ../common/lib/page-status/page-status.utils.js
var require_page_status_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.questionKeyForPyr = exports.questionKeyForQre = void 0;
	var questionKeyForQre = (taxYearStartDate) => `qre-${taxYearStartDate}`;
	exports.questionKeyForQre = questionKeyForQre;
	var questionKeyForPyr = (taxYearStartDate) => `pyr-${taxYearStartDate}`;
	exports.questionKeyForPyr = questionKeyForPyr;
}));
//#endregion
//#region ../common/lib/page-status/index.js
var require_page_status = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.questionKeyForPyr = exports.questionKeyForQre = void 0;
	var page_status_utils_1 = require_page_status_utils();
	Object.defineProperty(exports, "questionKeyForQre", {
		enumerable: true,
		get: function() {
			return page_status_utils_1.questionKeyForQre;
		}
	});
	Object.defineProperty(exports, "questionKeyForPyr", {
		enumerable: true,
		get: function() {
			return page_status_utils_1.questionKeyForPyr;
		}
	});
}));
//#endregion
//#region ../common/lib/csv/csv.constants.js
var require_csv_constants = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS = void 0;
	exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS = {
		rdCategory: "Expense Category",
		name: "Name",
		amount: "Amount",
		state: "State",
		country: "Country",
		account: "Account",
		department: "Department",
		costCenter: "Cost Center",
		entity: "Entity"
	};
	exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = {
		rdCategory: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.rdCategory + " (Required) (Enter ONE category for each expense: Contractors, Cloud, Patents, Supplies)",
		name: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.name + " (Required)",
		amount: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.amount + " (Required)",
		state: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.state + " (Required if Country is US) (Use the two-letter code)",
		country: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.country + " (Recommended)",
		account: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.account + " (Recommended)",
		department: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.department + " (Recommended)",
		costCenter: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.costCenter + " (Recommended)",
		entity: exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS.entity + " (Required when multiple entities perform R&D)"
	};
	exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS = {
		fullName: "Name",
		title: "Job Title",
		department: "Department",
		pid: "Employee ID",
		managerPid: "Manager ID",
		email: "Work Email",
		employeeWages: "W-2 Box 1 Wages",
		contractorWages: "Contractor Wages",
		state: "State",
		country: "Country",
		hireDate: "Hire Date",
		terminationDate: "Termination Date",
		costCenter: "Cost Center",
		entity: "Entity"
	};
	exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = {
		fullName: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.fullName + " (Required)",
		title: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.title + " (Required)",
		department: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.department + " (Recommended)",
		pid: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.pid + " (Recommended)",
		managerPid: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.managerPid + " (Recommended)",
		email: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.email + " (Recommended)",
		employeeWages: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.employeeWages + " (Required) (For international employees, enter the equivalent)",
		contractorWages: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.contractorWages + " (Required for Contractors) (For non-W2 contractors, enter the amount in this column)",
		state: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.state + " (Required if Country is US) (Use the two-letter code)",
		country: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.country + " (Required)",
		hireDate: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.hireDate + " (Recommended) (Format: MM/DD/YYYY)",
		terminationDate: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.terminationDate + " (Recommended) (Format: MM/DD/YYYY)",
		costCenter: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.costCenter + " (Recommended)",
		entity: exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS.entity + " (Required when multiple entities perform R&D)"
	};
	exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS = {
		fullName: "Name",
		title: "Job Title",
		department: "Department",
		email: "Work Email",
		salaryCompensationDollars: "Salary/Benefits Cost",
		stockCompensationDollars: "Stock Based Comp Cost",
		country: "Country",
		pid: "Employee ID",
		managerPid: "Manager ID",
		hireDate: "Hire Date",
		terminationDate: "Termination Date",
		costCenter: "Cost Center",
		entity: "Entity"
	};
	exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = {
		fullName: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.fullName + " (Required)",
		title: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.title + " (Required)",
		department: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.department + " (Recommended)",
		email: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.email + " (Required)",
		salaryCompensationDollars: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.salaryCompensationDollars + " (Required)",
		stockCompensationDollars: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.stockCompensationDollars + " (Recommended)",
		country: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.country + " (Required)",
		pid: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.pid + " (Recommended)",
		managerPid: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.managerPid + " (Recommended)",
		hireDate: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.hireDate + " (Recommended) (Format: MM/DD/YYYY)",
		terminationDate: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.terminationDate + " (Recommended) (Format: MM/DD/YYYY)",
		costCenter: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.costCenter + " (Recommended)",
		entity: exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS.entity + " (Required when multiple entities perform R&D)"
	};
}));
//#endregion
//#region ../common/lib/csv/index.js
var require_csv = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS = void 0;
	var csv_constants_1 = require_csv_constants();
	Object.defineProperty(exports, "GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS", {
		enumerable: true,
		get: function() {
			return csv_constants_1.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS;
		}
	});
	Object.defineProperty(exports, "GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED", {
		enumerable: true,
		get: function() {
			return csv_constants_1.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS", {
		enumerable: true,
		get: function() {
			return csv_constants_1.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED", {
		enumerable: true,
		get: function() {
			return csv_constants_1.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS", {
		enumerable: true,
		get: function() {
			return csv_constants_1.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED", {
		enumerable: true,
		get: function() {
			return csv_constants_1.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED;
		}
	});
}));
//#endregion
//#region ../common/lib/function.utils.js
var require_function_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throttle = void 0;
	var throttle = (fn, delay) => {
		let lastCallTime = 0;
		const throttledFn = (...args) => {
			const now = Date.now();
			if (now - lastCallTime >= delay) {
				lastCallTime = now;
				fn(...args);
				return;
			}
		};
		return throttledFn;
	};
	exports.throttle = throttle;
}));
//#endregion
//#region ../common/lib/login-method-header.js
var require_login_method_header = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LOGIN_METHOD_WINDOW_SECONDS = exports.LOGIN_METHOD_MAGIC_LINK = exports.LOGIN_METHOD_HEADER_NAME = void 0;
	/**
	* Cross-workspace contract for disambiguating magic-link from email/password logins.
	*
	* Firebase reports BOTH email/password and email-link (magic-link) sign-ins as
	* `sign_in_provider === 'password'`, so the two are indistinguishable from the decoded token alone.
	* The web app stamps this short-lived request header on a magic-link sign-in and the server's auth
	* guard reads it to record the correct login method in the audit log.
	*
	* It travels as a request header rather than a cookie because the API is a different origin than the
	* web app in every environment (a different port locally, an `*.api.neo.tax` subdomain in
	* staging/production). A host-only cookie set on the web-app origin is never sent to `/graphql`, so
	* the cookie this replaces always read as empty server-side and every magic-link login mis-recorded
	* as EMAIL_PASSWORD. Custom request headers ride cross-origin under the API's `origin: '*'` CORS, the
	* same way the existing `version` header already does.
	*
	* The value is client-supplied, so it is an audit-quality hint, not a security control — a caller
	* could stamp it on any login. That trust level is identical to the cookie it replaces.
	*/
	exports.LOGIN_METHOD_HEADER_NAME = "x-login-method";
	exports.LOGIN_METHOD_MAGIC_LINK = "magic_link";
	exports.LOGIN_METHOD_WINDOW_SECONDS = 62;
}));
//#endregion
//#region ../common/lib/blocking-function.js
var require_blocking_function = /* @__PURE__ */ __commonJSMin(((exports) => {
	/**
	* Cross-workspace contract for telling the web app *which* sign-in failure happened, so its copy can differ
	* wherever the remedy does.
	*
	* The codes travel by two routes, hence the two objects below. A sign-in blocking function's rejection reaches
	* the browser as `auth/internal-error` whatever the cause, carrying the function's own message inside the error
	* string, so those codes are matched within that message. Provisioning refuses inside a mutation, so its codes
	* arrive as coded GraphQL errors. Either way the web app keys on the code rather than on prose that could be
	* reworded, which is why they live here instead of as string literals on each side.
	*
	* Of everything these distinguish, only a backend that could not answer is worth retrying — whether Identity
	* Platform timed out on the function or the function could not read the account. Showing "please try again"
	* for any of the rest is a loop that cannot succeed.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EMAIL_SESSION_CLAIM = exports.ProvisioningErrorCodes = exports.BlockingFunctionRejectionCodes = void 0;
	/** Markers the sign-in blocking function embeds in the rejection Identity Platform relays to the browser. */
	exports.BlockingFunctionRejectionCodes = {
		/** The identity provider authenticated the user but published no email address under any name we searched. */
		NO_PROVIDER_EMAIL: "NEOTAX_NO_PROVIDER_EMAIL",
		/**
		* An enterprise provider would have joined an account that already signs in another way. Refused because an
		* OIDC/SAML provider asserts its own email addresses, so accepting the match would let anyone controlling a
		* configured provider claim an existing account. The user can resolve it by signing in as they did originally.
		*/
		ENTERPRISE_LINK_REFUSED: "NEOTAX_ENTERPRISE_LINK_REFUSED",
		/**
		* The account could not be read to vet an enterprise sign-in, so the sign-in was refused rather than let
		* through unvetted. A failed or slow read, not a conflict: a retry normally succeeds.
		*/
		ACCOUNT_UNREADABLE: "NEOTAX_ACCOUNT_UNREADABLE",
		/**
		* The email address is on a domain we refuse accounts for (BLACKLISTED_DOMAINS — e.g. disposable-email
		* providers). Applied at both account creation and sign-in, so a junk-domain account is turned away
		* before it exists and any that predate the list can no longer sign in.
		*/
		BLACKLISTED_DOMAIN: "NEOTAX_BLACKLISTED_DOMAIN"
	};
	/**
	* Codes on the GraphQL errors provisioning raises when it will not attach a sign-in to an existing account.
	*
	* Neither code's copy may name the provider the organization requires: reaching this point takes only
	* persuading some identity provider to assert an address, so naming it would tell whoever did that what to
	* configure next. The id belongs on the login audit row.
	*/
	exports.ProvisioningErrorCodes = {
		/** The organization requires a different enterprise provider than the one signing in. */
		SSO_PROVIDER_MISMATCH: "SSO_PROVIDER_MISMATCH",
		/** The address belongs to an account whose sign-in identity this is not, for any other reason. */
		ACCOUNT_LINKED_TO_ANOTHER_IDENTITY: "ACCOUNT_LINKED_TO_ANOTHER_IDENTITY"
	};
	/**
	* Session claim carrying the address for providers Firebase stored without one.
	*
	* A blocking function cannot write `email` onto the Firebase user record — the reserved fields it may
	* set are `emailVerified`, `displayName`, `photoURL`, `customClaims` and session claims — so for a
	* provider that publishes the address under a non-standard name, `user.email` stays empty and this
	* claim is the only place the address appears. Both the web app reading it off the signed-in session
	* and the backend reading it off the verified token depend on the same name, which is why it lives
	* here rather than as a literal in each.
	*
	* A *session* claim rather than a custom one, so the address lives only in this session's tokens
	* instead of being persisted onto the Firebase user.
	*/
	exports.EMAIL_SESSION_CLAIM = "neoTaxEmail";
}));
//#endregion
//#region ../common/lib/status-codes.utils.js
var require_status_codes_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ErrorStatusToHttpStatusCode = void 0;
	var enums_1 = require_enums();
	/** Should be used for HTTP REST requests, generally not GraphQL. */
	exports.ErrorStatusToHttpStatusCode = {
		[enums_1.ErrorStatusCode.OUTDATED_VERSION]: 400,
		[enums_1.ErrorStatusCode.UNAUTHENTICATED]: 401,
		[enums_1.ErrorStatusCode.UNAUTHORIZED]: 403,
		[enums_1.ErrorStatusCode.TOO_MANY_REQUESTS]: 429,
		[enums_1.ErrorStatusCode.INTERNAL_SERVER_ERROR]: 500
	};
}));
//#endregion
//#region ../common/lib/asc-projects/asc-projects-allocation.utils.js
var require_asc_projects_allocation_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getAverageAllocationInPeriod = exports.updateAllocationsInPeriod = exports.updateAllocationPercent = exports.getAdjustedPercent = exports.calculateMaxLimit = exports.sortAllAscProjectAllocations = exports.assignPriority = exports.roundProjectAllocationPercents = exports.roundAllocationsToTotal = exports.removeUseAllocationPercent = exports.getLatestAllocationPercent = exports.ALLOCATION_DIFF_THRESHOLD = exports.AllocationPriority = void 0;
	var constants_1 = require_constants();
	var errors_1 = require_errors$1();
	var month_year_utils_1 = require_month_year_utils();
	var number_utils_1 = require_number_utils();
	var AllocationPriority;
	(function(AllocationPriority) {
		AllocationPriority["LOW"] = "LOW";
		AllocationPriority["MEDIUM"] = "MEDIUM";
		AllocationPriority["HIGH"] = "HIGH";
	})(AllocationPriority || (exports.AllocationPriority = AllocationPriority = {}));
	var ALLOCATION_PRIORITY_ORDER = [
		AllocationPriority.HIGH,
		AllocationPriority.MEDIUM,
		AllocationPriority.LOW
	];
	exports.ALLOCATION_DIFF_THRESHOLD = .01;
	var getLatestAllocationPercent = (ascProjectMonthAllocation) => ascProjectMonthAllocation.useAllocationPercent ?? ascProjectMonthAllocation.allocationPercent;
	exports.getLatestAllocationPercent = getLatestAllocationPercent;
	var removeUseAllocationPercent = (ascProjectIdToPmas) => Object.fromEntries(Object.entries(ascProjectIdToPmas).map(([ascProjectId, ascProjectAllocations]) => [ascProjectId, ascProjectAllocations.map((ascProjectAllocation) => ({
		...ascProjectAllocation,
		useAllocationPercent: null
	}))]));
	exports.removeUseAllocationPercent = removeUseAllocationPercent;
	/**
	* Rounds allocation percentages and adjusts them to ensure the total equals at most 100%.
	* If rounding causes the total to exceed 100%, the largest allocations are reduced.
	* This prevents negative non-project percentages and ensures consistent rounding behavior.
	*
	* @param allocations - Array of raw allocation percentages (can have decimals)
	* @returns Array of rounded percentages that sum to at most 100%
	*/
	var roundAllocationsToTotal = (allocations) => {
		const rounded = allocations.map((allocation) => (0, number_utils_1.roundToNearest)(allocation, constants_1.USER_ROUNDING_NUM_DECIMALS));
		let total = rounded.reduce((sum, val) => sum + val, 0);
		if (total > 100) {
			const excess = total - 100;
			const originalTotal = total;
			const indexedValues = rounded.map((value, index) => ({
				value,
				index
			})).sort((a, b) => b.value - a.value);
			let remainingExcess = excess;
			for (const item of indexedValues) {
				if (remainingExcess <= 0) break;
				if (rounded[item.index] <= 0) continue;
				const proportionalReduction = item.value / originalTotal * excess;
				const finalReduction = Math.min(Math.round(proportionalReduction), rounded[item.index], remainingExcess);
				rounded[item.index] -= finalReduction;
				total -= finalReduction;
				remainingExcess -= finalReduction;
			}
			const step = 10 ** -constants_1.USER_ROUNDING_NUM_DECIMALS;
			while (remainingExcess > 0) {
				const reducibleIndexes = rounded.map((value, index) => ({
					value,
					index
				})).filter((item) => item.value > 0).sort((a, b) => b.value - a.value).map((item) => item.index);
				if (reducibleIndexes.length === 0) break;
				for (const index of reducibleIndexes) {
					if (remainingExcess <= 0) break;
					const reduction = Math.min(step, rounded[index], remainingExcess);
					rounded[index] -= reduction;
					total -= reduction;
					remainingExcess -= reduction;
				}
			}
		}
		return rounded;
	};
	exports.roundAllocationsToTotal = roundAllocationsToTotal;
	/**
	* The single normalization primitive for a contributor's per-project allocation percentages.
	* Rounds the raw percents as a group (see {@link roundAllocationsToTotal}) so they can never sum
	* past 100, and derives the residual non-project percent (100 − Σ).
	*
	* Every path that turns raw per-project allocations into stored/whole percents (wage-report upload,
	* report generation, the client allocation modal) funnels through this so rounding stays consistent
	* and non-project time can never go negative. Rounding each project independently can push the total
	* to 101% even when the raw values sum to exactly 100% (e.g. two 12.5% projects each round up to
	* 13%), which drives non-project time negative and lets the overshoot survive into a capitalized
	* percentage above 100%.
	*
	* @param rawProjectPercents - Raw per-project allocation percentages (may have decimals), assumed
	*   non-negative; input order is preserved in `projectPercents`.
	*/
	var roundProjectAllocationPercents = (rawProjectPercents) => {
		const projectPercents = (0, exports.roundAllocationsToTotal)(rawProjectPercents);
		return {
			projectPercents,
			nonProjectPercent: 100 - projectPercents.reduce((sum, percent) => sum + percent, 0)
		};
	};
	exports.roundProjectAllocationPercents = roundProjectAllocationPercents;
	var assignPriority = (ascProjectIdToCurrentPma, ascProjectIdToDeltaAveragePercent) => {
		const result = {};
		Object.entries(ascProjectIdToCurrentPma).forEach(([ascProjectId, ascProjectAllocations]) => {
			const delta = ascProjectIdToDeltaAveragePercent.get(ascProjectId);
			if (typeof delta !== "number") throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project ${ascProjectId} does not have a delta. This should not happen.`);
			if (delta < 0) result[ascProjectId] = ascProjectAllocations.map((allocation) => {
				const { allocationPercent } = allocation;
				if (allocationPercent > 0) return {
					...allocation,
					priority: AllocationPriority.HIGH
				};
				return {
					...allocation,
					priority: AllocationPriority.LOW
				};
			});
			else result[ascProjectId] = ascProjectAllocations.map((allocation, index) => {
				const { allocationPercent } = allocation;
				if (allocationPercent > 0) return {
					...allocation,
					priority: AllocationPriority.HIGH
				};
				const prev = index > 0 ? ascProjectAllocations[index - 1] : void 0;
				const next = index < ascProjectAllocations.length - 1 ? ascProjectAllocations[index + 1] : void 0;
				const prevHasAllocation = prev && prev.allocationPercent > 0;
				const nextHasAllocation = next && next.allocationPercent > 0;
				if (prevHasAllocation || nextHasAllocation) return {
					...allocation,
					priority: AllocationPriority.MEDIUM
				};
				return {
					...allocation,
					priority: AllocationPriority.LOW
				};
			});
		});
		return result;
	};
	exports.assignPriority = assignPriority;
	var sortAllAscProjectAllocations = (allAscProjectAllocationsMap, ascProjectIdToDeltaAveragePercent) => {
		return Object.entries(allAscProjectAllocationsMap).sort(([ascProjectIdA], [ascProjectIdB]) => {
			const deltaA = ascProjectIdToDeltaAveragePercent.get(ascProjectIdA);
			const deltaB = ascProjectIdToDeltaAveragePercent.get(ascProjectIdB);
			if (typeof deltaA !== "number" || typeof deltaB !== "number") throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project ${!deltaA ? ascProjectIdA : ascProjectIdB} does not have a delta average percent. This should not happen.`);
			if (deltaA <= 0 || deltaB <= 0) return deltaA - deltaB;
			const ascProjectAllocationsA = allAscProjectAllocationsMap[ascProjectIdA];
			const ascProjectAllocationsB = allAscProjectAllocationsMap[ascProjectIdB];
			const numberOfZeroPercentMonthsInAscProjectA = ascProjectAllocationsA.filter((allocation) => allocation.allocationPercent === 0).length;
			return ascProjectAllocationsB.filter((allocation) => allocation.allocationPercent === 0).length - numberOfZeroPercentMonthsInAscProjectA;
		}).map(([ascProjectId]) => ascProjectId);
	};
	exports.sortAllAscProjectAllocations = sortAllAscProjectAllocations;
	var calculateMaxLimit = ({ ascProjectId, ascProjectIdToPmas, month, nonProjectTime, year }) => {
		const otherAscProjectAllocationsInSameMonth = Object.entries(ascProjectIdToPmas).reduce((acc, [id, ascProjectAllocations]) => {
			if (id === ascProjectId) return acc;
			const ascProjectAllocationInSameMonth = ascProjectAllocations.find((a) => a.month === month && a.year === year);
			if (!ascProjectAllocationInSameMonth) throw (0, errors_1.createError)(`ASC Project allocation not found for month:${month} and year:${year}, ascProjectId ${ascProjectId}`);
			acc += (0, exports.getLatestAllocationPercent)(ascProjectAllocationInSameMonth);
			return acc;
		}, 0);
		return Math.abs(100 - (otherAscProjectAllocationsInSameMonth + nonProjectTime));
	};
	exports.calculateMaxLimit = calculateMaxLimit;
	var getAdjustedPercent = ({ ascProjectAllocation, currentPriorityAllocations, currentPriorityTotal, deltaTotal, maxLimit }) => Math.max(0, Math.min(maxLimit, (0, exports.getLatestAllocationPercent)(ascProjectAllocation) + deltaTotal * (currentPriorityTotal === 0 ? 1 / currentPriorityAllocations.length : (0, exports.getLatestAllocationPercent)(ascProjectAllocation) / currentPriorityTotal)));
	exports.getAdjustedPercent = getAdjustedPercent;
	var updateAllocationPercent = ({ ascProjectId, ascProjectIdToPmas, newAverage, newNonProjectTime, priority, shouldFill }) => {
		const currentAscProjectAllocations = ascProjectIdToPmas[ascProjectId];
		if (!currentAscProjectAllocations) throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project ${ascProjectId} does not have any allocations. This should not happen.`);
		const newTotal = newAverage * currentAscProjectAllocations.length;
		const deltaTotal = newTotal - currentAscProjectAllocations.reduce((a, b) => a + (0, exports.getLatestAllocationPercent)(b), 0);
		const currentPriorityAllocations = currentAscProjectAllocations.filter((ascProjectAllocation) => ascProjectAllocation.priority === priority);
		if (currentPriorityAllocations.length === 0) return {
			done: false,
			ascProjectIdToPmas
		};
		const currentPriorityTotal = currentPriorityAllocations.reduce((a, b) => a + (0, exports.getLatestAllocationPercent)(b), 0);
		const newAllocations = currentAscProjectAllocations.map((ascProjectAllocation) => {
			if (ascProjectAllocation.priority !== priority) return {
				...ascProjectAllocation,
				maxLimitReached: false
			};
			const { month, year } = ascProjectAllocation;
			const maxLimit = (0, exports.calculateMaxLimit)({
				month,
				year,
				nonProjectTime: newNonProjectTime,
				ascProjectIdToPmas,
				ascProjectId
			});
			const adjustedPercent = shouldFill ? maxLimit : (0, exports.getAdjustedPercent)({
				currentPriorityAllocations,
				currentPriorityTotal,
				deltaTotal,
				maxLimit,
				ascProjectAllocation
			});
			const maxLimitReached = Math.abs(adjustedPercent - maxLimit) < exports.ALLOCATION_DIFF_THRESHOLD;
			return {
				...ascProjectAllocation,
				useAllocationPercent: adjustedPercent,
				maxLimitReached
			};
		});
		ascProjectIdToPmas[ascProjectId] = newAllocations;
		const diff = newAllocations.reduce((a, b) => a + (0, exports.getLatestAllocationPercent)(b), 0) - newTotal;
		const done = Math.abs(diff) < exports.ALLOCATION_DIFF_THRESHOLD;
		const allMonthsHitMaxLimit = newAllocations.filter((allocation) => allocation.priority === priority).every((allocation) => allocation.maxLimitReached);
		if (!done && !allMonthsHitMaxLimit) return (0, exports.updateAllocationPercent)({
			ascProjectIdToPmas,
			newAverage,
			newNonProjectTime,
			priority,
			ascProjectId,
			shouldFill
		});
		return {
			done,
			ascProjectIdToPmas
		};
	};
	exports.updateAllocationPercent = updateAllocationPercent;
	/**
	* Clamp every month's `useAllocationPercent` into the valid [0, 100] range. A single month's
	* allocation can exceed 100 because {@link calculateMaxLimit} bounds each month by
	* `Math.abs(100 - (otherAllocations + nonProjectTime))`, which grows past 100 when non-project time
	* is negative (e.g. project averages that sum past 100% due to rounding). A monthly allocation
	* above 100% is meaningless and is rejected when the PMA is persisted, so this guarantees callers
	* always receive a valid range.
	*/
	var clampUseAllocationPercentInPeriod = (ascProjectIdToPmas) => Object.fromEntries(Object.entries(ascProjectIdToPmas).map(([ascProjectId, pmas]) => [ascProjectId, pmas.map((pma) => ({
		...pma,
		useAllocationPercent: pma.useAllocationPercent == null ? pma.useAllocationPercent : Math.min(100, Math.max(0, pma.useAllocationPercent))
	}))]));
	/**
	* Will attempt to use {@link updateAllocationsUsingProportionateMethod} to update the allocations. There is not always a solution to the allocation
	* problem. In this case, we will assign the average percent to all the months uniformly.
	*/
	var updateAllocationsInPeriod = ({ ascProjectIdToPmas, newAverages, newNonProjectTime }) => {
		if (newNonProjectTime < 0) throw (0, errors_1.createError)("UpdateAllocationsError", `Non project time cannot be negative, meaning the project allocations sum to more than 100%. Non project time: ${newNonProjectTime}`);
		if (newAverages.length !== Object.keys(ascProjectIdToPmas).length) throw (0, errors_1.createError)("UpdateAllocationsError", `Number of ASC projects in the new averages does not match the number of ASC projects in the current allocations. new averages: ${newAverages.length}, current allocations: ${ascProjectIdToPmas.length}`);
		if (new Set(Object.entries(ascProjectIdToPmas).map(([_key, pmas]) => pmas.length)).size > 1) throw (0, errors_1.createError)("UpdateAllocationsError", "Not all ASC project have the same number of PMAs");
		const newAllocationSum = newAverages.reduce((acc, average) => {
			acc += average.allocationPercent;
			return acc;
		}, newNonProjectTime);
		if (Math.abs(newAllocationSum - 100) > exports.ALLOCATION_DIFF_THRESHOLD) throw (0, errors_1.createError)("UpdateAllocationsError", `The sum of new averages and the new non project time is not 100. Sum: ${newAllocationSum}`);
		const ascProjectIdToPmasWithoutUseAllocationPercent = (0, exports.removeUseAllocationPercent)(ascProjectIdToPmas);
		const ascProjectIdToNewAveragePercent = new Map(newAverages.map((average) => [average.ascProjectId, average.allocationPercent]));
		const ascProjectIdToOriginalAveragePercent = new Map(Object.entries(ascProjectIdToPmasWithoutUseAllocationPercent).map(([ascProjectId, pmas]) => {
			return [ascProjectId, pmas.reduce((a, b) => a + b.allocationPercent, 0) / pmas.length];
		}));
		const ascProjectIdToDeltaAveragePercent = new Map([...ascProjectIdToNewAveragePercent.entries()].map(([ascProjectId, newAverage]) => {
			const originalAverage = ascProjectIdToOriginalAveragePercent.get(ascProjectId);
			if (typeof originalAverage !== "number") throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project ${ascProjectId} does not have an original average percent. This should not happen.`);
			return [ascProjectId, newAverage - originalAverage];
		}));
		if ([...ascProjectIdToDeltaAveragePercent.values()].every((delta) => Math.abs(delta) < exports.ALLOCATION_DIFF_THRESHOLD)) return {
			newAscProjectIdToPmas: ascProjectIdToPmasWithoutUseAllocationPercent,
			fallbackError: null
		};
		try {
			return {
				newAscProjectIdToPmas: clampUseAllocationPercentInPeriod(updateAllocationsUsingProportionateMethod({
					newNonProjectTime,
					ascProjectIdToDeltaAveragePercent,
					ascProjectIdToNewAveragePercent,
					ascProjectIdToPmas: ascProjectIdToPmasWithoutUseAllocationPercent
				})),
				fallbackError: null
			};
		} catch (error) {
			return {
				newAscProjectIdToPmas: clampUseAllocationPercentInPeriod(updateAllocationsUsingUniformMethod({
					ascProjectIdToNewAveragePercent,
					ascProjectIdToPmas: ascProjectIdToPmasWithoutUseAllocationPercent
				})),
				fallbackError: error instanceof Error ? error : new Error(String(error))
			};
		}
	};
	exports.updateAllocationsInPeriod = updateAllocationsInPeriod;
	/**
	* Steps to calculate the new allocations is described in the notion doc
	* https://www.notion.so/neo-tax/Soft-Cap-Allocation-Edit-Strategy-54d37ce0116a401a9ad29a819788351c?pvs=4
	*/
	var updateAllocationsUsingProportionateMethod = ({ ascProjectIdToDeltaAveragePercent, ascProjectIdToNewAveragePercent, ascProjectIdToPmas, newNonProjectTime }) => {
		const ascProjectIdToPmaWithPriority = (0, exports.assignPriority)(ascProjectIdToPmas, ascProjectIdToDeltaAveragePercent);
		const sortedAscProjectIds = (0, exports.sortAllAscProjectAllocations)(ascProjectIdToPmaWithPriority, ascProjectIdToDeltaAveragePercent);
		let currentAllAscProjectAllocations = ascProjectIdToPmaWithPriority;
		sortedAscProjectIds.map((ascProjectId, index) => {
			const isLastAscProject = index === sortedAscProjectIds.length - 1;
			let currentPriorityIndex = 0;
			let currentDone = false;
			while (!currentDone && currentPriorityIndex < ALLOCATION_PRIORITY_ORDER.length) {
				const priority = ALLOCATION_PRIORITY_ORDER[currentPriorityIndex];
				const newAverage = ascProjectIdToNewAveragePercent.get(ascProjectId);
				if (typeof newAverage !== "number") throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project ${ascProjectId} does not have a new average percent. This should not happen.`);
				const allocationResults = (0, exports.updateAllocationPercent)({
					ascProjectIdToPmas: ascProjectIdToPmaWithPriority,
					newAverage,
					newNonProjectTime,
					priority,
					ascProjectId,
					shouldFill: isLastAscProject
				});
				currentAllAscProjectAllocations = allocationResults.ascProjectIdToPmas;
				currentDone = allocationResults.done;
				currentPriorityIndex += 1;
			}
			return {
				ascProjectId,
				done: currentDone
			};
		});
		const currentAllAscProjectAllocationsEntries = Object.entries(currentAllAscProjectAllocations);
		const months = currentAllAscProjectAllocationsEntries[0][1];
		for (const { month, year } of months) {
			const totalAllocationAcrossAllProjectsForMonthYear = currentAllAscProjectAllocationsEntries.reduce((acc, [_ascProjectId, pmasWithPriority]) => {
				const ascProjectAllocation = pmasWithPriority.find((allocation) => allocation.month === month && allocation.year === year);
				if (!ascProjectAllocation) throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project allocation not found for month:${month} and year:${year}`);
				acc += (0, exports.getLatestAllocationPercent)(ascProjectAllocation);
				return acc;
			}, 0);
			if (Math.abs(totalAllocationAcrossAllProjectsForMonthYear + newNonProjectTime - 100) > exports.ALLOCATION_DIFF_THRESHOLD) throw (0, errors_1.createError)("UpdateAllocationsError", `The sum of allocations for month ${month} and year ${year} is not 100. Sum: ${totalAllocationAcrossAllProjectsForMonthYear}`);
		}
		return currentAllAscProjectAllocations;
	};
	var updateAllocationsUsingUniformMethod = ({ ascProjectIdToNewAveragePercent, ascProjectIdToPmas }) => {
		for (const [ascProjectId, averagePercent] of ascProjectIdToNewAveragePercent.entries()) {
			const pmas = ascProjectIdToPmas[ascProjectId];
			if (!pmas) throw (0, errors_1.createError)("UpdateAllocationsError", `ASC Project ${ascProjectId} does not have any allocations. This should not happen.`);
			ascProjectIdToPmas[ascProjectId] = pmas.map((pma) => ({
				...pma,
				useAllocationPercent: averagePercent
			}));
		}
		return ascProjectIdToPmas;
	};
	/**
	* HACK: this is an approximation at best, because we do not consider the number of work days in each month while averaging
	* the allocation percentages. However, because using constant non-project turns pmas into a relative and approximate value this
	* is considered good enough for now.
	*
	* @returns the float average percent without any rounding
	*/
	var getAverageAllocationInPeriod = (ascProjectMonthAllocations, monthYearPeriod) => {
		const fixedMonthYearPeriod = (0, month_year_utils_1.applyCompletedEndMonthYearRule)(monthYearPeriod);
		const { endMonthYear, startMonthYear } = fixedMonthYearPeriod;
		const numberOfMonths = (0, month_year_utils_1.getNumberOfMonthsInPeriod)(fixedMonthYearPeriod);
		return ascProjectMonthAllocations.filter((pma) => (0, month_year_utils_1.isMonthYearInRange)(pma, startMonthYear, endMonthYear)).reduce((acc, pma) => acc + (pma.useAllocationPercent ?? pma.allocationPercent), 0) / numberOfMonths;
	};
	exports.getAverageAllocationInPeriod = getAverageAllocationInPeriod;
}));
//#endregion
//#region ../common/lib/asc-projects/asc-lock-boundary.utils.js
var require_asc_lock_boundary_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.maxMonthYearNullable = exports.isProjectDateRangeFullyLocked = exports.formatLockBoundary = exports.validateNotBeforeLockBoundary = exports.isBeforeOrOnLockBoundary = exports.getFirstAllowableCapitalizationStartMonthYear = exports.isCapitalizationEndDateLocked = exports.isCapitalizationStartDateLocked = exports.isCapitalizationStatusLocked = void 0;
	var date_utils_1 = require_date_utils();
	var month_year_utils_1 = require_month_year_utils();
	var LOCK_BOUNDARY_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;
	/**
	* Parses and validates a lock boundary string.
	* @param lockBoundary - The lock boundary in YYYY-MM format
	* @returns The parsed MonthYear
	* @throws Error if the lock boundary is not in valid YYYY-MM format
	*/
	var parseLockBoundary = (lockBoundary) => {
		if (!LOCK_BOUNDARY_REGEX.test(lockBoundary)) throw new Error(`Invalid lock boundary format: "${lockBoundary}". Expected YYYY-MM format (e.g., "2024-06").`);
		return (0, month_year_utils_1.stringToMonthYear)(lockBoundary);
	};
	/**
	* Determines if capitalization status is locked based on lock boundary.
	* Status is locked when a capitalization start date exists and is on or before the lock boundary.
	*
	* @param capitalizationStartDate - The project's capitalization start date (Date, string, or null)
	* @param lockBoundary - The lock boundary in YYYY-MM format (or null if not set)
	* @returns true if status is locked, false otherwise
	*/
	var isCapitalizationStatusLocked = (capitalizationStartDate, lockBoundary) => {
		if (!lockBoundary) return false;
		if (!capitalizationStartDate) return false;
		const lockBoundaryMonthYear = parseLockBoundary(lockBoundary);
		const startDateMonthYear = (0, month_year_utils_1.dateToMonthYear)(capitalizationStartDate);
		return (0, month_year_utils_1.isMonthYearBeforeOrEqual)(startDateMonthYear, lockBoundaryMonthYear);
	};
	exports.isCapitalizationStatusLocked = isCapitalizationStatusLocked;
	/**
	* Determines if capitalization start date is locked based on lock boundary.
	* Same logic as status - both are locked together.
	*/
	var isCapitalizationStartDateLocked = (capitalizationStartDate, lockBoundary) => (0, exports.isCapitalizationStatusLocked)(capitalizationStartDate, lockBoundary);
	exports.isCapitalizationStartDateLocked = isCapitalizationStartDateLocked;
	/**
	* Determines if capitalization end date is locked based on lock boundary.
	* End date is more permissive - it can be modified if it's on or after the lock boundary.
	*
	* @param capitalizationEndDate - The project's capitalization end date (Date, string, or null)
	* @param lockBoundary - The lock boundary in YYYY-MM format (or null if not set)
	* @returns true if end date is locked, false otherwise
	*/
	var isCapitalizationEndDateLocked = (capitalizationEndDate, lockBoundary) => {
		if (!lockBoundary) return false;
		if (!capitalizationEndDate) return false;
		const lockBoundaryMonthYear = parseLockBoundary(lockBoundary);
		const endDateMonthYear = (0, month_year_utils_1.dateToMonthYear)(capitalizationEndDate);
		return (0, month_year_utils_1.isMonthYearBefore)(endDateMonthYear, lockBoundaryMonthYear);
	};
	exports.isCapitalizationEndDateLocked = isCapitalizationEndDateLocked;
	/**
	* Gets the first allowable month/year for capitalization start date.
	* Returns the month AFTER the lock boundary, or null if no lock boundary.
	*/
	var getFirstAllowableCapitalizationStartMonthYear = (lockBoundary) => {
		if (!lockBoundary) return null;
		const lockBoundaryMonthYear = parseLockBoundary(lockBoundary);
		return (0, date_utils_1.getNextMonthYear)(lockBoundaryMonthYear);
	};
	exports.getFirstAllowableCapitalizationStartMonthYear = getFirstAllowableCapitalizationStartMonthYear;
	/**
	* Checks if a MonthYear value is before or on the lock boundary.
	* Used for form validation.
	*/
	var isBeforeOrOnLockBoundary = (value, lockBoundary) => {
		if (!value || !lockBoundary) return false;
		const lockBoundaryMonthYear = parseLockBoundary(lockBoundary);
		return (0, month_year_utils_1.isMonthYearBeforeOrEqual)(value, lockBoundaryMonthYear);
	};
	exports.isBeforeOrOnLockBoundary = isBeforeOrOnLockBoundary;
	/**
	* Validates a MonthYear value against the lock boundary and returns an error message if invalid.
	* Returns null if the value is valid (after the lock boundary or no lock boundary set).
	* Used for form validation to DRY up error message generation.
	*/
	var validateNotBeforeLockBoundary = (value, lockBoundary) => {
		if ((0, exports.isBeforeOrOnLockBoundary)(value, lockBoundary)) return `Cannot set date before locked period (${(0, exports.formatLockBoundary)(lockBoundary)})`;
		return null;
	};
	exports.validateNotBeforeLockBoundary = validateNotBeforeLockBoundary;
	/**
	* Formats a lock boundary string for display.
	* @example "2024-06" → "Jun 2024"
	*/
	var formatLockBoundary = (lockBoundary) => {
		if (!lockBoundary) return "";
		const monthYear = parseLockBoundary(lockBoundary);
		return `${(0, date_utils_1.getMonthLongAbbreviation)(monthYear.month)} ${monthYear.year}`;
	};
	exports.formatLockBoundary = formatLockBoundary;
	/**
	* Checks if a project's date range falls entirely within the locked period.
	* This means no valid capitalization dates can be set (all dates within project range are locked).
	*
	* @param projectEndDate - The project's end date (Date, string, or null)
	* @param lockBoundary - The lock boundary in YYYY-MM format (or null if not set)
	* @returns true if the entire project date range is locked, false otherwise
	*/
	var isProjectDateRangeFullyLocked = (projectEndDate, lockBoundary) => {
		if (!lockBoundary || !projectEndDate) return false;
		const lockBoundaryMonthYear = parseLockBoundary(lockBoundary);
		const endDateMonthYear = (0, month_year_utils_1.dateToMonthYear)(projectEndDate);
		return (0, month_year_utils_1.isMonthYearBeforeOrEqual)(endDateMonthYear, lockBoundaryMonthYear);
	};
	exports.isProjectDateRangeFullyLocked = isProjectDateRangeFullyLocked;
	/**
	* Returns the maximum of two MonthYear values, or the one that's not null.
	* Used for determining the best date when toggling capitalization on.
	*/
	var maxMonthYearNullable = (a, b) => {
		if (!a) return b;
		if (!b) return a;
		return (0, month_year_utils_1.getFirstDateOfMonthYear)(a) > (0, month_year_utils_1.getFirstDateOfMonthYear)(b) ? a : b;
	};
	exports.maxMonthYearNullable = maxMonthYearNullable;
}));
//#endregion
//#region ../common/lib/asc-projects/asc-cluster-type.enum.js
var require_asc_cluster_type_enum = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ASC_NOISE_CLUSTER_TYPES = exports.AscClusterType = void 0;
	exports.isAscNoiseClusterType = isAscNoiseClusterType;
	var AscClusterType;
	(function(AscClusterType) {
		AscClusterType["SMART_MAIN"] = "SMART_MAIN";
		AscClusterType["SMART_NOISE"] = "SMART_NOISE";
		AscClusterType["CAPITALIZABLE_PROJECT_MAIN"] = "CAPITALIZABLE_PROJECT_MAIN";
		AscClusterType["CAPITALIZABLE_PROJECT_NOISE"] = "CAPITALIZABLE_PROJECT_NOISE";
		AscClusterType["DETERMINISTIC_HAS_ROOT"] = "DETERMINISTIC_HAS_ROOT";
		AscClusterType["DETERMINISTIC_NO_ROOT"] = "DETERMINISTIC_NO_ROOT";
		AscClusterType["MANUALLY_CREATED"] = "MANUALLY_CREATED";
		AscClusterType["MERGED"] = "MERGED";
	})(AscClusterType || (exports.AscClusterType = AscClusterType = {}));
	exports.ASC_NOISE_CLUSTER_TYPES = [AscClusterType.SMART_NOISE, AscClusterType.CAPITALIZABLE_PROJECT_NOISE];
	function isAscNoiseClusterType(type) {
		return exports.ASC_NOISE_CLUSTER_TYPES.includes(type);
	}
}));
//#endregion
//#region ../common/lib/asc-projects/capitalizable-project-clustering.utils.js
var require_capitalizable_project_clustering_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isUsedInCapitalizableProjectClustering = exports.getCapitalizableProjectClusteringStatus = exports.CLUSTERING_METHOD = exports.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE = void 0;
	var month_year_utils_1 = require_month_year_utils();
	var asc_cluster_type_enum_1 = require_asc_cluster_type_enum();
	exports.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE = {
		INCLUDED: "INCLUDED",
		EXCLUDED: "EXCLUDED"
	};
	exports.CLUSTERING_METHOD = {
		CAPITALIZABLE_PROJECT: "CAPITALIZABLE_PROJECT",
		DETERMINISTIC: "DETERMINISTIC",
		SMART: "SMART"
	};
	/**
	* Active matching target list (mirrors `AscProjectRepository.findActiveAscProjectMatchTargets`):
	*   1. override = INCLUDED                                                       -> active
	*   2. override IS NULL AND cap_start IS NOT NULL AND
	*      (cap_end IS NULL OR cap_end in/after the last completed ASC sync's
	*      end month) AND activity is current (end_date in/after that month)         -> active (default rule)
	*   3. override IS NULL AND cluster_type = MAIN AND start_date IS NULL           -> active (fresh MAIN)
	* Otherwise inactive. EXCLUDED override always inactive. A capitalizing project whose activity has
	* gone stale (end_date before the boundary month) is 'no-recent-activity' (inactive).
	*
	* `lastCompletedAscSyncPeriodEnd` is the period-end date of the company's last
	* completed ASC sync (`Company.lastCompletedAscSyncPeriodEnd` in GraphQL). A cap_end
	* in/after that month is a "boundary" end date — an auto-set artifact of that sync's
	* data horizon that the next sync may extend — so the project is still an active
	* matching target. When null/omitted, clause 2 requires cap_end IS NULL as before.
	*/
	var getCapitalizableProjectClusteringStatus = (project, clusteringMethod, lastCompletedAscSyncPeriodEnd) => {
		if (clusteringMethod !== exports.CLUSTERING_METHOD.CAPITALIZABLE_PROJECT) return {
			isActive: false,
			reason: "not-applicable"
		};
		const override = project.capitalizableProjectClusteringOverride ?? null;
		if (override === exports.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE.INCLUDED) return {
			isActive: true,
			reason: "included"
		};
		if (override === exports.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE.EXCLUDED) return {
			isActive: false,
			reason: "excluded"
		};
		if (project.capitalizationStartDate) {
			const hasRecentActivity = lastCompletedAscSyncPeriodEnd == null || project.endDate == null || !(0, month_year_utils_1.isMonthYearBefore)((0, month_year_utils_1.dateToMonthYear)(project.endDate), (0, month_year_utils_1.dateToMonthYear)(lastCompletedAscSyncPeriodEnd));
			if (project.capitalizationEndDate) {
				if (lastCompletedAscSyncPeriodEnd != null && !(0, month_year_utils_1.isMonthYearBefore)((0, month_year_utils_1.dateToMonthYear)(project.capitalizationEndDate), (0, month_year_utils_1.dateToMonthYear)(lastCompletedAscSyncPeriodEnd))) return hasRecentActivity ? {
					isActive: true,
					reason: "default-active-boundary-extend"
				} : {
					isActive: false,
					reason: "no-recent-activity"
				};
				return {
					isActive: false,
					reason: "capitalization-ended"
				};
			}
			return hasRecentActivity ? {
				isActive: true,
				reason: "default-active"
			} : {
				isActive: false,
				reason: "no-recent-activity"
			};
		}
		if (project.clusterType === asc_cluster_type_enum_1.AscClusterType.CAPITALIZABLE_PROJECT_MAIN && !project.startDate) return {
			isActive: true,
			reason: "default-active-fresh-main"
		};
		return {
			isActive: false,
			reason: "capitalization-not-started"
		};
	};
	exports.getCapitalizableProjectClusteringStatus = getCapitalizableProjectClusteringStatus;
	var isUsedInCapitalizableProjectClustering = (project, clusteringMethod, lastCompletedAscSyncPeriodEnd) => (0, exports.getCapitalizableProjectClusteringStatus)(project, clusteringMethod, lastCompletedAscSyncPeriodEnd).isActive;
	exports.isUsedInCapitalizableProjectClustering = isUsedInCapitalizableProjectClustering;
}));
//#endregion
//#region ../common/lib/asc-projects/index.js
var require_asc_projects = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ASC_NOISE_CLUSTER_TYPES = exports.isAscNoiseClusterType = exports.AscClusterType = exports.isUsedInCapitalizableProjectClustering = exports.getCapitalizableProjectClusteringStatus = exports.CLUSTERING_METHOD = exports.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE = exports.maxMonthYearNullable = exports.formatLockBoundary = exports.validateNotBeforeLockBoundary = exports.isBeforeOrOnLockBoundary = exports.getFirstAllowableCapitalizationStartMonthYear = exports.isProjectDateRangeFullyLocked = exports.isCapitalizationEndDateLocked = exports.isCapitalizationStartDateLocked = exports.isCapitalizationStatusLocked = exports.getAverageAllocationInPeriod = exports.ALLOCATION_DIFF_THRESHOLD = exports.roundProjectAllocationPercents = exports.roundAllocationsToTotal = exports.updateAllocationsInPeriod = exports.getLatestAllocationPercent = void 0;
	var asc_projects_allocation_utils_1 = require_asc_projects_allocation_utils();
	Object.defineProperty(exports, "getLatestAllocationPercent", {
		enumerable: true,
		get: function() {
			return asc_projects_allocation_utils_1.getLatestAllocationPercent;
		}
	});
	Object.defineProperty(exports, "updateAllocationsInPeriod", {
		enumerable: true,
		get: function() {
			return asc_projects_allocation_utils_1.updateAllocationsInPeriod;
		}
	});
	Object.defineProperty(exports, "roundAllocationsToTotal", {
		enumerable: true,
		get: function() {
			return asc_projects_allocation_utils_1.roundAllocationsToTotal;
		}
	});
	Object.defineProperty(exports, "roundProjectAllocationPercents", {
		enumerable: true,
		get: function() {
			return asc_projects_allocation_utils_1.roundProjectAllocationPercents;
		}
	});
	Object.defineProperty(exports, "ALLOCATION_DIFF_THRESHOLD", {
		enumerable: true,
		get: function() {
			return asc_projects_allocation_utils_1.ALLOCATION_DIFF_THRESHOLD;
		}
	});
	Object.defineProperty(exports, "getAverageAllocationInPeriod", {
		enumerable: true,
		get: function() {
			return asc_projects_allocation_utils_1.getAverageAllocationInPeriod;
		}
	});
	var asc_lock_boundary_utils_1 = require_asc_lock_boundary_utils();
	Object.defineProperty(exports, "isCapitalizationStatusLocked", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.isCapitalizationStatusLocked;
		}
	});
	Object.defineProperty(exports, "isCapitalizationStartDateLocked", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.isCapitalizationStartDateLocked;
		}
	});
	Object.defineProperty(exports, "isCapitalizationEndDateLocked", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.isCapitalizationEndDateLocked;
		}
	});
	Object.defineProperty(exports, "isProjectDateRangeFullyLocked", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.isProjectDateRangeFullyLocked;
		}
	});
	Object.defineProperty(exports, "getFirstAllowableCapitalizationStartMonthYear", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.getFirstAllowableCapitalizationStartMonthYear;
		}
	});
	Object.defineProperty(exports, "isBeforeOrOnLockBoundary", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.isBeforeOrOnLockBoundary;
		}
	});
	Object.defineProperty(exports, "validateNotBeforeLockBoundary", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.validateNotBeforeLockBoundary;
		}
	});
	Object.defineProperty(exports, "formatLockBoundary", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.formatLockBoundary;
		}
	});
	Object.defineProperty(exports, "maxMonthYearNullable", {
		enumerable: true,
		get: function() {
			return asc_lock_boundary_utils_1.maxMonthYearNullable;
		}
	});
	var capitalizable_project_clustering_utils_1 = require_capitalizable_project_clustering_utils();
	Object.defineProperty(exports, "CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE", {
		enumerable: true,
		get: function() {
			return capitalizable_project_clustering_utils_1.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE;
		}
	});
	Object.defineProperty(exports, "CLUSTERING_METHOD", {
		enumerable: true,
		get: function() {
			return capitalizable_project_clustering_utils_1.CLUSTERING_METHOD;
		}
	});
	Object.defineProperty(exports, "getCapitalizableProjectClusteringStatus", {
		enumerable: true,
		get: function() {
			return capitalizable_project_clustering_utils_1.getCapitalizableProjectClusteringStatus;
		}
	});
	Object.defineProperty(exports, "isUsedInCapitalizableProjectClustering", {
		enumerable: true,
		get: function() {
			return capitalizable_project_clustering_utils_1.isUsedInCapitalizableProjectClustering;
		}
	});
	var asc_cluster_type_enum_1 = require_asc_cluster_type_enum();
	Object.defineProperty(exports, "AscClusterType", {
		enumerable: true,
		get: function() {
			return asc_cluster_type_enum_1.AscClusterType;
		}
	});
	Object.defineProperty(exports, "isAscNoiseClusterType", {
		enumerable: true,
		get: function() {
			return asc_cluster_type_enum_1.isAscNoiseClusterType;
		}
	});
	Object.defineProperty(exports, "ASC_NOISE_CLUSTER_TYPES", {
		enumerable: true,
		get: function() {
			return asc_cluster_type_enum_1.ASC_NOISE_CLUSTER_TYPES;
		}
	});
}));
//#endregion
//#region ../common/lib/error.utils.js
var require_error_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.extendedGraphQlErrorHasErrorCode = exports.extendedApolloErrorHasErrorCode = exports.hasStandardErrorCode = exports.hasErrorCode = exports.getStandardErrors = exports.getExtendedErrors = void 0;
	var interfaces_1 = require_interfaces();
	/**
	* Extracts errors from an error object.
	*
	* @param error An error object that should be an ApolloError or GraphQlError
	* @param schema The schema of the anticipated errors.
	*/
	var getExtendedErrors = (error, schema) => {
		const parsedApolloError = (0, interfaces_1.safeParseExtendedApolloError)(error, schema);
		if (parsedApolloError.success) return parsedApolloError.data.graphQLErrors.flatMap((graphQlError) => graphQlError.extensions.errors);
		const parsedGraphQlError = (0, interfaces_1.safeParseExtendedGraphQlError)(error, schema);
		if (parsedGraphQlError.success) return parsedGraphQlError.data.extensions.errors;
		console.error(error);
		throw error;
	};
	exports.getExtendedErrors = getExtendedErrors;
	var getStandardErrors = (error) => (0, exports.getExtendedErrors)(error, interfaces_1.StandardErrorSchema);
	exports.getStandardErrors = getStandardErrors;
	/**
	* Parses the error and checks if it has a specific error code.
	*/
	var hasErrorCode = (error, errorCode, schema) => {
		const parsedApolloError = (0, interfaces_1.safeParseExtendedApolloError)(error, schema);
		if (parsedApolloError.success) return (0, exports.extendedApolloErrorHasErrorCode)(parsedApolloError.data, errorCode);
		const parsedGraphQlError = (0, interfaces_1.safeParseExtendedGraphQlError)(error, schema);
		if (parsedGraphQlError.success) return (0, exports.extendedGraphQlErrorHasErrorCode)(parsedGraphQlError.data, errorCode);
		return false;
	};
	exports.hasErrorCode = hasErrorCode;
	/**
	* Parses the error and checks if it has a StandardError code.
	*/
	var hasStandardErrorCode = (error, errorCode) => (0, exports.hasErrorCode)(error, errorCode, interfaces_1.StandardErrorSchema);
	exports.hasStandardErrorCode = hasStandardErrorCode;
	/**
	* Accepts a previously parsed error and checks if it has a specific error code.
	*/
	var extendedApolloErrorHasErrorCode = (extendedApolloError, errorCode) => extendedApolloError.graphQLErrors.some((graphQlError) => graphQlError.extensions.errors.some((error) => error.code === errorCode));
	exports.extendedApolloErrorHasErrorCode = extendedApolloErrorHasErrorCode;
	/**
	* Accepts a previously parsed error and checks if it has a specific error code.
	*/
	var extendedGraphQlErrorHasErrorCode = (extendedGraphQlError, errorCode) => extendedGraphQlError.extensions.errors.some((error) => error.code === errorCode);
	exports.extendedGraphQlErrorHasErrorCode = extendedGraphQlErrorHasErrorCode;
}));
//#endregion
//#region ../common/lib/environment.utils.js
var require_environment_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isProductionLikeEnvironment = void 0;
	var neo_tax_environment_enum_1 = require_neo_tax_environment_enum();
	/**
	* @returns true if environment is production-like
	*/
	var isProductionLikeEnvironment = (neoTaxEnvironment) => [
		neo_tax_environment_enum_1.NeoTaxEnvironment.PRODUCTION,
		neo_tax_environment_enum_1.NeoTaxEnvironment.THOMSON_REUTERS,
		neo_tax_environment_enum_1.NeoTaxEnvironment.NARVAR,
		neo_tax_environment_enum_1.NeoTaxEnvironment.ZELIS,
		neo_tax_environment_enum_1.NeoTaxEnvironment.NBH,
		neo_tax_environment_enum_1.NeoTaxEnvironment.ADOBE,
		neo_tax_environment_enum_1.NeoTaxEnvironment.LENDINGCLUB,
		neo_tax_environment_enum_1.NeoTaxEnvironment.CAPITALONE,
		neo_tax_environment_enum_1.NeoTaxEnvironment.BULLHORN,
		neo_tax_environment_enum_1.NeoTaxEnvironment.DEMO,
		neo_tax_environment_enum_1.NeoTaxEnvironment.QUALCOMM,
		neo_tax_environment_enum_1.NeoTaxEnvironment.EXPEDIA,
		neo_tax_environment_enum_1.NeoTaxEnvironment.SHELL
	].includes(neoTaxEnvironment);
	exports.isProductionLikeEnvironment = isProductionLikeEnvironment;
}));
//#endregion
//#region ../common/lib/fiscal-year.utils.js
var require_fiscal_year_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.findFiscalYearsInPeriod = void 0;
	var findFiscalYearsInPeriod = (fiscalYears, period) => {
		return fiscalYears.filter((fiscalYear) => {
			const taxYearStartDate = new Date(fiscalYear.taxYearStartDate);
			const taxYearEndDate = new Date(fiscalYear.taxYearEndDate);
			const { endMonthYear, startMonthYear } = period;
			const periodStartDate = new Date(startMonthYear.year, startMonthYear.month, 1);
			const periodEndDate = new Date(endMonthYear.year, endMonthYear.month, 1);
			return taxYearStartDate <= periodStartDate && periodStartDate <= taxYearEndDate || taxYearStartDate <= periodEndDate && periodEndDate <= taxYearEndDate || periodStartDate <= taxYearStartDate && taxYearEndDate <= periodEndDate;
		});
	};
	exports.findFiscalYearsInPeriod = findFiscalYearsInPeriod;
}));
//#endregion
//#region ../common/lib/prior-year-data.utils.js
var require_prior_year_data_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getFiscalPeriodsForRevenues = exports.getFiscalPeriodsForQres = exports.determineTaxYearEndDate = exports.determineTaxYearStartDate = void 0;
	var array_utils_1 = require_array_utils();
	var date_utils_1 = require_date_utils();
	var month_year_utils_1 = require_month_year_utils();
	var determineTaxYearStartDate = ({ periodDates, shortYearPeriod, year }) => {
		if (!shortYearPeriod && periodDates) return year + periodDates.firstDayOfPeriod.slice(4);
		if (!shortYearPeriod) throw new Error("Either shortYearPeriod or periodDates must be provided to determine tax year start date");
		return shortYearPeriod.startMonthYear.month === 0 ? getStandardYearToFiscalYearConversionStartDate(year, shortYearPeriod) : getFiscalYearToStandardYearConversionStartDate(year, shortYearPeriod);
	};
	exports.determineTaxYearStartDate = determineTaxYearStartDate;
	var getFiscalYearToStandardYearConversionStartDate = (year, shortYearPeriod) => {
		const { endMonthYear, startMonthYear } = shortYearPeriod;
		const shortYearStartYear = startMonthYear.year;
		const shortYearStartMonth = startMonthYear.month;
		const shortYearEndMonth = endMonthYear.month;
		const shortYearStartMonthYear = (0, month_year_utils_1.toMonthYearString)(startMonthYear);
		if (year === shortYearStartYear) return `${shortYearStartMonthYear}-01`;
		else if (year > shortYearStartYear) return (0, date_utils_1.addMonths)(new Date(year - 1, shortYearEndMonth, 1), 1);
		else return `${year}-${(shortYearStartMonth + 1).toString().padStart(2, "0")}-01`;
	};
	var getStandardYearToFiscalYearConversionStartDate = (year, shortYearPeriod) => {
		const { endMonthYear, startMonthYear } = shortYearPeriod;
		const shortYearStartYear = startMonthYear.year;
		const shortYearStartMonth = startMonthYear.month;
		const shortYearEndMonth = endMonthYear.month;
		const shortYearStartMonthYear = (0, month_year_utils_1.toMonthYearString)(startMonthYear);
		if (year === shortYearStartYear) return `${shortYearStartMonthYear}-01`;
		else if (year > shortYearStartYear) return (0, date_utils_1.addMonths)(new Date(year, shortYearEndMonth, 1), 1);
		else return `${year}-${(shortYearStartMonth + 1).toString().padStart(2, "0")}-01`;
	};
	var determineTaxYearEndDate = ({ periodDates, shortYearPeriod, year }) => {
		if (!shortYearPeriod && periodDates) return (periodDates.firstDayOfPeriod.slice(0, 4) === periodDates.lastDayOfPeriod.slice(0, 4) ? year : year + 1) + periodDates.lastDayOfPeriod.slice(4);
		if (!shortYearPeriod) throw new Error("Either shortYearPeriod or periodDates must be provided to determine tax year end date");
		return shortYearPeriod.startMonthYear.month === 0 ? getStandardYearToFiscalYearConversionEndDate(year, shortYearPeriod) : getFiscalYearToStandardYearConversionEndDate(year, shortYearPeriod);
	};
	exports.determineTaxYearEndDate = determineTaxYearEndDate;
	var getFiscalYearToStandardYearConversionEndDate = (year, shortYearPeriod) => {
		const { endMonthYear, startMonthYear } = shortYearPeriod;
		const shortYearStartYear = startMonthYear.year;
		const shortYearStartMonth = startMonthYear.month;
		const shortYearEndMonth = endMonthYear.month;
		const shortYearEndYear = endMonthYear.year;
		if (year === shortYearStartYear) return (0, month_year_utils_1.getLastDateStringOfMonthYear)(endMonthYear);
		else if (year > shortYearEndYear && shortYearEndMonth === 11) return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year, shortYearEndMonth, 1)).toISOString().slice(0, 10);
		else if (year > shortYearStartYear && shortYearEndMonth != 11) return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year + 1, shortYearEndMonth, 1)).toISOString().slice(0, 10);
		else {
			const taxYearEndDate = new Date(year + 1, shortYearStartMonth, 1);
			taxYearEndDate.setDate(taxYearEndDate.getDate() - 1);
			return taxYearEndDate.toISOString().slice(0, 10);
		}
	};
	var getStandardYearToFiscalYearConversionEndDate = (year, shortYearPeriod) => {
		const { endMonthYear, startMonthYear } = shortYearPeriod;
		const shortYearStartYear = startMonthYear.year;
		const shortYearStartMonth = startMonthYear.month;
		const shortYearEndMonth = endMonthYear.month;
		const shortYearEndYear = endMonthYear.year;
		if (year === shortYearStartYear) return (0, month_year_utils_1.getLastDateStringOfMonthYear)(endMonthYear);
		else if (year > shortYearEndYear && shortYearEndMonth === 11) return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year, shortYearEndMonth, 1)).toISOString().slice(0, 10);
		else if (year > shortYearStartYear && shortYearEndMonth != 11) return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year + 1, shortYearEndMonth, 1)).toISOString().slice(0, 10);
		else if (year < shortYearStartYear && shortYearStartMonth === 0) {
			const taxYearEndDate = new Date(year + 1, shortYearStartMonth, 1);
			taxYearEndDate.setDate(taxYearEndDate.getDate() - 1);
			return taxYearEndDate.toISOString().slice(0, 10);
		} else {
			const taxYearEndDate = new Date(year, shortYearStartMonth, 1);
			taxYearEndDate.setDate(taxYearEndDate.getDate() - 1);
			return taxYearEndDate.toISOString().slice(0, 10);
		}
	};
	/**
	* Get the prior fiscal periods for QREs.
	* @param firstYear - The first year of the range of years to get the tax year and period for.
	* @param shortYearPeriod - The short tax year period to use for the tax year and period.
	* @param periodDates - The period dates to use when there is no shortYearPeriod. This is most likely the tax filing start and end dates.
	* @returns The tax year and period for the given years.
	*/
	var getFiscalPeriodsForQres = ({ firstYear, periodDates, shortYearPeriod }) => {
		const currentTaxYear = (0, date_utils_1.getCurrentTaxYear)(periodDates.lastDayOfPeriod);
		return getFiscalPeriodsBasedOnYears({
			years: getYearsForQres({
				firstYear,
				shortYearPeriod,
				currentTaxYear
			}),
			periodDates,
			shortYearPeriod,
			includeYearAfterShortYear: currentTaxYear !== shortYearPeriod?.startMonthYear.year
		});
	};
	exports.getFiscalPeriodsForQres = getFiscalPeriodsForQres;
	/**
	* Get the prior fiscal periods for Revenues.
	* @param firstYear - The first year of the range of years to get the tax year and period for.
	* @param shortYearPeriod - The short tax year period to use for the tax year and period.
	* @param periodDates - The period dates to use when there is no shortYearPeriod. This is most likely the tax filing start and end dates.
	* @returns The tax year and period for the given years.
	*/
	var getFiscalPeriodsForRevenues = ({ firstYear, periodDates, shortYearPeriod }) => {
		return getFiscalPeriodsBasedOnYears({
			years: getYearsForRevenues({
				firstYear,
				currentTaxYear: (0, date_utils_1.getCurrentTaxYear)(periodDates.lastDayOfPeriod)
			}),
			periodDates,
			shortYearPeriod,
			includeYearAfterShortYear: true
		});
	};
	exports.getFiscalPeriodsForRevenues = getFiscalPeriodsForRevenues;
	var getFiscalPeriodsBasedOnYears = ({ includeYearAfterShortYear = false, periodDates, shortYearPeriod, years }) => {
		if (!years.length) return [];
		if (!shortYearPeriod) {
			if (!periodDates) throw new Error("Either shortYearPeriod or periodDates must be provided");
			return years.map((year) => ({
				firstDayOfPeriod: (0, exports.determineTaxYearStartDate)({
					year,
					periodDates
				}),
				lastDayOfPeriod: (0, exports.determineTaxYearEndDate)({
					year,
					periodDates
				})
			}));
		}
		const sortedYears = years.sort((a, b) => b - a);
		const periods = [];
		const shortYearStartYear = shortYearPeriod.startMonthYear.year;
		sortedYears.filter((year) => year <= shortYearStartYear).forEach((year) => {
			periods.push({
				firstDayOfPeriod: (0, exports.determineTaxYearStartDate)({
					year,
					shortYearPeriod
				}),
				lastDayOfPeriod: (0, exports.determineTaxYearEndDate)({
					year,
					shortYearPeriod
				})
			});
		});
		const shortYearEndDate = new Date(shortYearPeriod.endMonthYear.year, shortYearPeriod.endMonthYear.month, 1);
		const firstDayOfTaxPeriodAfterShortYear = (0, date_utils_1.addMonths)(shortYearEndDate, 1);
		const shortYearEndDatePlusOneYear = new Date(shortYearPeriod.endMonthYear.year + 1, shortYearPeriod.endMonthYear.month, 1);
		const lastDayOfTaxPeriodAfterShortYear = (0, date_utils_1.getLastDayOfTheMonth)(shortYearEndDatePlusOneYear).toISOString().slice(0, 10);
		if (years.includes(shortYearPeriod.startMonthYear.year) && includeYearAfterShortYear) periods.push({
			firstDayOfPeriod: firstDayOfTaxPeriodAfterShortYear,
			lastDayOfPeriod: lastDayOfTaxPeriodAfterShortYear
		});
		sortedYears.filter((year) => year > shortYearStartYear).forEach((year) => {
			periods.push({
				firstDayOfPeriod: (0, exports.determineTaxYearStartDate)({
					year,
					shortYearPeriod
				}),
				lastDayOfPeriod: (0, exports.determineTaxYearEndDate)({
					year,
					shortYearPeriod
				})
			});
		});
		return periods.sort((a, b) => {
			const dateA = new Date(a.firstDayOfPeriod);
			return new Date(b.firstDayOfPeriod).getTime() - dateA.getTime();
		});
	};
	var getYearsForQres = ({ currentTaxYear, firstYear, shortYearPeriod }) => {
		const mostRecentClosedTaxYear = shortYearPeriod?.startMonthYear.year === currentTaxYear ? currentTaxYear : currentTaxYear - 1;
		const upperBoundForQreYears = firstYear ? Math.min(mostRecentClosedTaxYear, firstYear + 9) : mostRecentClosedTaxYear;
		const lowerBoundForQreYears = firstYear ? firstYear - 1 : currentTaxYear - 4;
		return (0, array_utils_1.range)(upperBoundForQreYears, lowerBoundForQreYears, -1);
	};
	var getYearsForRevenues = ({ currentTaxYear, firstYear }) => {
		const upperBoundForRevenueYears = firstYear ? Math.min(currentTaxYear, firstYear + 9) : currentTaxYear;
		const lowerBoundForRevenueYears = firstYear ? firstYear - 1 : currentTaxYear - 5;
		return (0, array_utils_1.range)(upperBoundForRevenueYears, lowerBoundForRevenueYears, -1);
	};
}));
//#endregion
//#region ../common/lib/rd-project-category.utils.js
var require_rd_project_category_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.calculateRdProjectCategory = void 0;
	var selected_rd_project_category_enum_1 = require_selected_rd_project_category_enum();
	var calculateRdProjectCategory = ({ consideredForRd, isSection174Eligible }) => {
		if (consideredForRd) return selected_rd_project_category_enum_1.SelectedRdProjectCategory.RD_CREDIT;
		if (isSection174Eligible) return selected_rd_project_category_enum_1.SelectedRdProjectCategory.SECTION_174_ONLY;
		return selected_rd_project_category_enum_1.SelectedRdProjectCategory.EXCLUDED;
	};
	exports.calculateRdProjectCategory = calculateRdProjectCategory;
}));
//#endregion
//#region ../common/lib/injector.js
var require_injector = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Injector = void 0;
	exports.Injector = class Injector {
		static setModuleRef(ref) {
			Injector.moduleRef = ref;
		}
		static get(type) {
			return Injector.moduleRef.get(type);
		}
	};
}));
//#endregion
//#region ../common/lib/use-cases/phased-use-case.js
var require_phased_use_case = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PhasedUseCase = void 0;
	var PhasedUseCase = class {
		/**
		* Identifier used by subclasses to label metrics/logging.
		* Defaults to the runtime class name; override to pin a stable identifier
		* (e.g. against future build-time name mangling).
		*/
		get useCaseName() {
			return this.constructor.name;
		}
		/**
		* Hook for wrapping a phase (e.g. with timing/memory instrumentation).
		* Default is pass-through; override in a subclass to add measurement.
		*/
		async _runPhase(_phase, _input, run) {
			return await run();
		}
	};
	exports.PhasedUseCase = PhasedUseCase;
}));
//#endregion
//#region ../common/lib/use-cases/standard-use-case.js
var require_standard_use_case = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StandardUseCase = void 0;
	var phased_use_case_1 = require_phased_use_case();
	/**
	* @/deprecated Use CommandUseCase or QueryUseCase instead. (@miguel - this has not been agreed to yet, there is active WIP on design here)
	*/
	var StandardUseCase = class extends phased_use_case_1.PhasedUseCase {
		async execute(input) {
			const loaded = await this._runPhase("load", input, () => this._load(input));
			const transformed = await this._runPhase("transform", loaded, () => this._transform(loaded));
			return {
				loaded,
				transformed,
				saved: await this._runPhase("save", transformed, () => this._save(transformed))
			};
		}
		/**
		* Preview the use case result without saving to database.
		* Runs _load and _transform phases but skips _save.
		* Useful for showing users what changes would be made before committing.
		*/
		async preview(input) {
			const loaded = await this._runPhase("load", input, () => this._load(input));
			return {
				loaded,
				transformed: await this._runPhase("transform", loaded, () => this._transform(loaded))
			};
		}
	};
	exports.StandardUseCase = StandardUseCase;
}));
//#endregion
//#region ../common/lib/use-cases/command-use-case.js
var require_command_use_case = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CommandUseCase = void 0;
	var phased_use_case_1 = require_phased_use_case();
	var CommandUseCase = class extends phased_use_case_1.PhasedUseCase {
		async execute(input) {
			const loadResult = await this._runPhase("load", input, () => this._load(input));
			if (!loadResult.success) return loadResult;
			const transformResult = await this._runPhase("transform", loadResult, () => this._transform(input, loadResult.result));
			if (!transformResult.success) return transformResult;
			const saveResult = await this._runPhase("save", transformResult, () => this._save(loadResult.result, transformResult.result));
			if (!saveResult.success) return saveResult;
			return {
				success: true,
				result: await this._runPhase("present", saveResult, () => this._present(input, loadResult.result, transformResult.result, saveResult.result))
			};
		}
	};
	exports.CommandUseCase = CommandUseCase;
}));
//#endregion
//#region ../common/lib/use-cases/query-use-case.js
var require_query_use_case = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QueryUseCase = void 0;
	var phased_use_case_1 = require_phased_use_case();
	var QueryUseCase = class extends phased_use_case_1.PhasedUseCase {
		_transform(_input, _loaded) {
			return {
				success: true,
				result: null
			};
		}
		async execute(input) {
			const loadResult = await this._runPhase("load", input, () => this._load(input));
			if (!loadResult.success) return loadResult;
			const transformResult = await this._runPhase("transform", loadResult, () => this._transform(input, loadResult.result));
			if (!transformResult.success) return transformResult;
			return {
				success: true,
				result: await this._runPhase("present", transformResult, () => this._present(input, loadResult.result, transformResult.result))
			};
		}
	};
	exports.QueryUseCase = QueryUseCase;
}));
//#endregion
//#region ../common/lib/random.js
var require_random = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Random = void 0;
	var uuid_1 = require_commonjs_browser();
	exports.Random = class Random {
		static uuid() {
			return (0, uuid_1.v4)();
		}
		static hash() {
			return Random.uuid().replace(/-/g, "");
		}
	};
}));
//#endregion
//#region ../common/lib/stack.js
var require_stack = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.trackStackDepth = void 0;
	var maxStackDepth = 0;
	/**
	* Tracks the current stack depth by temporarily increasing V8's stack trace limit.
	* This gives us a more accurate measurement of actual stack depth.
	* Note: This is a temporary solution and should be used carefully as it can impact performance.
	*/
	var trackStackDepth = (location) => {
		const originalLimit = Error.stackTraceLimit;
		try {
			Error.stackTraceLimit = Infinity;
			const depth = (/* @__PURE__ */ new Error()).stack?.split("\n").length ?? 0;
			if (depth > maxStackDepth) {
				maxStackDepth = depth;
				console.log(`New max stack depth: ${depth} at ${location}`);
			}
		} finally {
			Error.stackTraceLimit = originalLimit;
		}
	};
	exports.trackStackDepth = trackStackDepth;
}));
//#endregion
//#region ../common/lib/rd-project-eligibility/determine-rd-project-eligibility.utils.js
var require_determine_rd_project_eligibility_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.determineRdProjectEligibility = exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING = void 0;
	exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING = {
		NotQualifiedTechnicalUncertaintyReasoning: "The project does not meet the permitted purpose requirement for the R&D Credit under Sections 41 and 174, because substantially all of the project did not involve technical uncertainties.",
		EligibleCustomerFacingReasoning: "This project meets the permitted purpose requirement for the R&D Credit under Sections 41 and 174. Substantially all of the project's work involved addressing core technical uncertainties and followed a process of experimentation and the project was focused on customer-facing product/process.",
		EligibleInternalUseInnovativeReasoning: "This project meets the permitted purpose requirement for the R&D Credit under Sections 41 and 174. Substantially all of the project's work involved addressing core technical uncertainties and followed a process of experimentation. The project focused on internal-use software, but it meets the high threshold for innovation, involved significant economic risk, and was not commercially available.",
		NotQualifiedInternalUseReasoning: "The project does not meet the permitted purpose requirement for the R&D Credit under Sections 41 and 174. The project focuses on internal use software and does not meet the more stringent requirements of high innovation, significant economic risk, and not being commercially available."
	};
	var determineRdProjectEligibility = (answers) => {
		if (answers.isTechnicallyUncertain == null) return {
			status: "pending",
			currentQuestionIndex: 1
		};
		if (answers.isTechnicallyUncertain === false) return {
			status: "complete",
			outcome: "NOT_QUALIFIED",
			currentQuestionIndex: 1,
			qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.NotQualifiedTechnicalUncertaintyReasoning
		};
		if (answers.isCustomerFacingDevelopment == null) return {
			status: "pending",
			currentQuestionIndex: 2
		};
		if (answers.isCustomerFacingDevelopment === true) return {
			status: "complete",
			outcome: "ELIGIBLE",
			currentQuestionIndex: 2,
			qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.EligibleCustomerFacingReasoning
		};
		if (answers.isInnovativeAndRisky == null) return {
			status: "pending",
			currentQuestionIndex: 3
		};
		if (answers.isInnovativeAndRisky === true) return {
			status: "complete",
			outcome: "ELIGIBLE",
			currentQuestionIndex: 3,
			qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.EligibleInternalUseInnovativeReasoning
		};
		else return {
			status: "complete",
			outcome: "NOT_QUALIFIED",
			currentQuestionIndex: 3,
			qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.NotQualifiedInternalUseReasoning
		};
	};
	exports.determineRdProjectEligibility = determineRdProjectEligibility;
}));
//#endregion
//#region ../common/lib/rd-project-eligibility/index.js
var require_rd_project_eligibility = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING = exports.determineRdProjectEligibility = void 0;
	var determine_rd_project_eligibility_utils_1 = require_determine_rd_project_eligibility_utils();
	Object.defineProperty(exports, "determineRdProjectEligibility", {
		enumerable: true,
		get: function() {
			return determine_rd_project_eligibility_utils_1.determineRdProjectEligibility;
		}
	});
	Object.defineProperty(exports, "RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING", {
		enumerable: true,
		get: function() {
			return determine_rd_project_eligibility_utils_1.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING;
		}
	});
}));
//#endregion
//#region ../common/lib/name-matching/name-parser.js
var require_name_parser = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parsePersonName = exports.isSurnameParticle = void 0;
	var SUFFIXES = /* @__PURE__ */ new Set([
		"jr",
		"sr",
		"ii",
		"iii",
		"iv",
		"v",
		"phd",
		"md",
		"esq",
		"cpa"
	]);
	var PREFIXES = /* @__PURE__ */ new Set([
		"dr",
		"mr",
		"mrs",
		"ms",
		"mx"
	]);
	var LAST_NAME_PARTICLES = /* @__PURE__ */ new Set([
		"van",
		"von",
		"der",
		"den",
		"de",
		"del",
		"della",
		"di",
		"da",
		"du",
		"la",
		"le",
		"los",
		"las",
		"dos",
		"do",
		"ten",
		"ter",
		"bin",
		"ibn",
		"ben",
		"al",
		"el"
	]);
	var stripTrailingPunctuation = (token) => token.replace(/[.,;]+$/u, "");
	var normalizeToken = (token) => stripTrailingPunctuation(token).toLowerCase();
	var isSuffix = (token) => SUFFIXES.has(normalizeToken(token));
	var isPrefix = (token) => PREFIXES.has(normalizeToken(token));
	/** Whether a token is a surname particle rather than a name in its own right, as in "van der Berg". */
	var isSurnameParticle = (token) => LAST_NAME_PARTICLES.has(normalizeToken(token));
	exports.isSurnameParticle = isSurnameParticle;
	var splitWhitespace = (input) => input.split(/\s+/u).filter((t) => t.length > 0);
	/**
	* Parse a person name string into a normalized full form and a last-name key suitable for
	* cohort indexing. Handles both "First Last" and "Last, First" formats and strips common
	* honorific prefixes (Dr/Mr/Mrs/Ms/Mx) and generational/professional suffixes
	* (Jr/Sr/II/III/IV/V/PhD/MD/Esq/CPA).
	*
	* Returns null if the input is empty or contains no recognizable last token.
	*/
	var parsePersonName = (raw) => {
		if (raw === null || raw === void 0) return null;
		const trimmed = raw.trim();
		if (trimmed.length === 0) return null;
		let firstTokens;
		let lastTokens;
		const commaIndex = trimmed.indexOf(",");
		const postCommaTokens = commaIndex !== -1 ? splitWhitespace(trimmed.slice(commaIndex + 1)).filter((t) => !isPrefix(t)) : [];
		if (commaIndex !== -1 && postCommaTokens.some((t) => !isSuffix(t))) {
			lastTokens = splitWhitespace(trimmed.slice(0, commaIndex)).filter((t) => !isSuffix(t));
			firstTokens = postCommaTokens.filter((t) => !isSuffix(t));
		} else {
			const allTokens = splitWhitespace(trimmed).filter((t) => !isPrefix(t) && !isSuffix(t));
			if (allTokens.length === 0) return null;
			const particleIdx = allTokens.findIndex((t) => (0, exports.isSurnameParticle)(t));
			if (particleIdx >= 1 && particleIdx < allTokens.length - 1) {
				firstTokens = allTokens.slice(0, particleIdx);
				lastTokens = allTokens.slice(particleIdx);
			} else {
				lastTokens = [allTokens[allTokens.length - 1]];
				firstTokens = allTokens.slice(0, -1);
			}
		}
		if (lastTokens.length === 0) return null;
		const lastNormalized = lastTokens.map(normalizeToken).join(" ");
		if (lastNormalized.length === 0) return null;
		const firstNormalized = firstTokens.map(normalizeToken).filter((t) => t.length > 0).join(" ");
		return {
			full: [...firstTokens, ...lastTokens].map(normalizeToken).filter((t) => t.length > 0).join(" "),
			first: firstNormalized,
			last: lastNormalized
		};
	};
	exports.parsePersonName = parsePersonName;
}));
//#endregion
//#region ../common/lib/name-matching/jaro-winkler.js
var require_jaro_winkler = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.jaroWinklerSimilarity = exports.jaroSimilarity = void 0;
	/**
	* Jaro similarity: a metric in [0, 1] over two strings, where 1 is identical.
	* Counts matching characters (within a sliding window) and penalizes transpositions.
	*/
	var jaroSimilarity = (s1, s2) => {
		if (s1 === s2) return 1;
		if (s1.length === 0 || s2.length === 0) return 0;
		const matchWindow = Math.max(0, Math.floor(Math.max(s1.length, s2.length) / 2) - 1);
		const s1Matches = new Array(s1.length).fill(false);
		const s2Matches = new Array(s2.length).fill(false);
		let matches = 0;
		for (let i = 0; i < s1.length; i += 1) {
			const start = Math.max(0, i - matchWindow);
			const end = Math.min(i + matchWindow + 1, s2.length);
			for (let j = start; j < end; j += 1) {
				if (s2Matches[j]) continue;
				if (s1[i] !== s2[j]) continue;
				s1Matches[i] = true;
				s2Matches[j] = true;
				matches += 1;
				break;
			}
		}
		if (matches === 0) return 0;
		let transpositions = 0;
		let k = 0;
		for (let i = 0; i < s1.length; i += 1) {
			if (!s1Matches[i]) continue;
			while (!s2Matches[k]) k += 1;
			if (s1[i] !== s2[k]) transpositions += 1;
			k += 1;
		}
		return (matches / s1.length + matches / s2.length + (matches - transpositions / 2) / matches) / 3;
	};
	exports.jaroSimilarity = jaroSimilarity;
	/**
	* Jaro-Winkler similarity: Jaro with an explicit bonus for shared prefix characters
	* (up to 4 chars). Designed for name matching — used by the US Census Bureau and credit
	* bureaus because it weights the start of a string heavily, which matches human intuition
	* about typos vs different names.
	*
	* @param prefixScale - Per-prefix-char boost. Standard value 0.1; max 0.25.
	* @param maxPrefixLength - Cap on how many leading shared chars contribute. Standard 4.
	*/
	var jaroWinklerSimilarity = (s1, s2, prefixScale = .1, maxPrefixLength = 4) => {
		const jaro = (0, exports.jaroSimilarity)(s1, s2);
		if (jaro === 0 || jaro === 1) return jaro;
		let prefixLength = 0;
		const limit = Math.min(maxPrefixLength, s1.length, s2.length);
		while (prefixLength < limit && s1[prefixLength] === s2[prefixLength]) prefixLength += 1;
		return jaro + prefixLength * prefixScale * (1 - jaro);
	};
	exports.jaroWinklerSimilarity = jaroWinklerSimilarity;
}));
//#endregion
//#region ../common/lib/name-matching/contributor-matcher.js
var require_contributor_matcher = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.findBestContributorMatch = exports.buildContributorMatchIndex = exports.DEFAULT_FUZZY_MATCH_THRESHOLD = void 0;
	var jaro_winkler_1 = require_jaro_winkler();
	var name_parser_1 = require_name_parser();
	/** Fallback threshold when no per-company override is configured. */
	exports.DEFAULT_FUZZY_MATCH_THRESHOLD = .9;
	var pushIntoMultimap = (map, key, value) => {
		const existing = map.get(key);
		if (existing) existing.push(value);
		else map.set(key, [value]);
	};
	/**
	* Build an index over a list of candidate items keyed by normalized full name and last name.
	*
	* Cost is O(n) and the resulting index is intended to be reused across many lookups
	* (e.g. one per payroll row) so each lookup is bounded by the size of the last-name
	* cohort rather than the full candidate set.
	*/
	var buildContributorMatchIndex = (items, getName) => {
		const byExactName = /* @__PURE__ */ new Map();
		const byLastName = /* @__PURE__ */ new Map();
		for (const item of items) {
			const raw = getName(item);
			const parsed = (0, name_parser_1.parsePersonName)(raw);
			if (!parsed) continue;
			pushIntoMultimap(byExactName, parsed.full, item);
			pushIntoMultimap(byLastName, parsed.last, {
				item,
				full: parsed.full,
				first: parsed.first
			});
		}
		return {
			byExactName,
			byLastName
		};
	};
	exports.buildContributorMatchIndex = buildContributorMatchIndex;
	/**
	* Find the best contributor for a query name using:
	* 1. Exact full-name fast path. When multiple DB rows share the same canonical name they
	*    are treated as duplicates of the same person — first one is picked deterministically.
	* 2. Jaro-Winkler scoring against the candidates that share the query's last name. JW is
	*    prefix-weighted, which matches human intuition about typos: "Jhon"/"John" scores
	*    high, "DoriAnn"/"Brianna" does not.
	*
	* Cohort entries are first grouped by normalized full name so duplicates compete as a
	* single candidate. Ties **between distinct names** at the top score are rejected (returns
	* null) to avoid silently picking between two genuinely different people.
	*/
	var findBestContributorMatch = (index, rawName, threshold) => {
		const parsed = (0, name_parser_1.parsePersonName)(rawName);
		if (!parsed) return null;
		const exactMatches = index.byExactName.get(parsed.full);
		if (exactMatches !== void 0 && exactMatches.length > 0) return {
			item: exactMatches[0],
			score: 1,
			winners: exactMatches
		};
		const cohort = index.byLastName.get(parsed.last);
		if (!cohort || cohort.length === 0) return null;
		if (parsed.first.length === 0) return null;
		const itemsByFull = /* @__PURE__ */ new Map();
		for (const entry of cohort) {
			const existing = itemsByFull.get(entry.full);
			if (existing) existing.items.push(entry.item);
			else itemsByFull.set(entry.full, {
				items: [entry.item],
				first: entry.first
			});
		}
		let bestScore = -1;
		let bestFull = null;
		let tied = false;
		for (const [full, { first }] of itemsByFull) {
			if (first.length === 0) continue;
			const score = (0, jaro_winkler_1.jaroWinklerSimilarity)(parsed.first, first);
			if (score < threshold) continue;
			if (score > bestScore) {
				bestScore = score;
				bestFull = full;
				tied = false;
			} else if (score === bestScore) tied = true;
		}
		if (bestFull === null || tied) return null;
		const winners = itemsByFull.get(bestFull).items;
		return {
			item: winners[0],
			score: bestScore,
			winners
		};
	};
	exports.findBestContributorMatch = findBestContributorMatch;
}));
//#endregion
//#region src/common/utils/date.utils.ts
var import_lib = (/* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isDatetime = exports.getDatetime = exports.getMonthLongAbbreviation = exports.getMonthShortAbbreviation = exports.getEndOfDay = exports.getFirstDayOfTheMonth = exports.getLastDayOfTheMonth = exports.longDateFormat = exports.placedInServiceDate = exports.americanDateFormat = exports.dateToDayjs = exports.isStandardFiscalYear = exports.getFirstDayOfPeriodByLastDay = exports.removeZeroPadding = exports.addZeroPadding = exports.isAfterInitialTaxDeadline = exports.toIsoDateString = exports.getEntryForTaxYear = exports.currentDateToIsoString = exports.getLastDayOfTheYear = exports.sameDateString = exports.isLeapYear = exports.upperBoundForTaxReturnFilingDate = exports.getEndOfYear = exports.getStartOfYear = exports.getEntryForCurrentTaxYear = exports.getYearFromStringDate = exports.isDateString = exports.getCurrentDatetime = exports.getCurrentYear = exports.getCurrentDateObject = exports.getCurrentDate = exports.formatDate = exports.formatDayjs = exports.endOfFiscalYearDate = exports.getCurrentTaxYear = exports.getExtensionTaxDeadline = exports.getInitialTaxDeadline = exports.computeNeoTaxFeeDetails = exports.MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME = exports.MAX_SEARCH_FIREBASE_IDENTITIES = exports.TEST_CAPTURED_EMAILS_LOG_PATH = exports.PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR = exports.DB_ROUNDING_NUM_DECIMALS = exports.USER_ROUNDING_NUM_DECIMALS = exports.US_COUNTRY_CODE = exports.LAST_MONTH_DATE_DICT = exports.OLDEST_SUPPORTED_QRE_PYR_YEAR = exports.COMMON_CONSTANTS = exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS = void 0;
	exports.CapitalizationChangeReason = exports.calculateEarliestAffectedCapitalizationMonth = exports.getMonthYearPeriodSuperset = exports.dateStringToReadableMonthYearString = exports.getMonthYearPeriodUsingDates = exports.getTaxYearMonthYearPeriod = exports.MONTH_PERIOD_NAMES = exports.getPeriodName = exports.getCurrentFiscalYearMonthYearPeriod = exports.getEarliestAndLatestMonthYear = exports.isMonthYear = exports.formatMonthYear = exports.formatMonthYearPeriod = exports.formatTaxPeriod = exports.formatFiscalPeriod = exports.formatFiscalOrTaxPeriod = exports.calculateQuarter = exports.areSameMonthYearPeriod = exports.isPeriodFullYear = exports.doPeriodsOverlap = exports.getMonthYearPeriodIntersection = exports.getNumberOfMonthsInPeriod = exports.getNumMonthsBetweenInclusively = exports.toMonthYearPeriod = exports.isMonthYearBefore = exports.sameMonthYear = exports.minMonthYear = exports.maxMonthYear = exports.getMonthName = exports.getMonthsBetweenAsc = exports.generateMonthYearInRange = exports.getLastDateStringOfMonthYear = exports.getLastDateOfMonthYear = exports.getFirstDateStringOfMonthYear = exports.getFirstDateOfMonthYear = exports.stringToMonthYear = exports.dateToMonthYearString = exports.toMonthYearString = exports.dateToMonthYear = exports.areMonthYearEqual = exports.isMonthYearInRange = exports.isMonthYearAfterOrEqual = exports.isMonthYearBeforeOrEqual = exports.organizationMembersFileName = exports.getNextMonthYear = exports.getPreviousMonthYear = exports.isDateInMonthYearRange = exports.isTaxYearTraditional = exports.subtractMonths = exports.addMonths = void 0;
	exports.GitHubAppInstallQueryField = exports.QuickbooksMonth = exports.QuickbooksConnectionStatus = exports.AccountingAcquisitionMethod = exports.EntityType = exports.SalesChannel = exports.getRevenueSourceRank = exports.RevenueSource = exports.HardSciences = exports.RoundingMethod = exports.AccountType = exports.AccountClassification = exports.ServiceScope = exports.NeoTaxEnvironment = exports.SsoQueryField = exports.QuickbooksQueryField = exports.convertExpenseCategoryToNum = exports.ExpenseCategory = exports.AnalyticIdentifier = exports.ResearchActivities = exports.DocumentationTools = exports.divideResearchActivities = exports.combineTools = exports.divideTools = exports.ExtendedGraphQLErrors = exports.ErrorWithStatusCode = exports.handleCaughtError = exports.createClientErrors = exports.createClientError = exports.createError = exports.createNamedErrorClass = exports.pause = exports.getActualBusinessStartIsoDate = exports.centsToNumberWithCommas = exports.centsToDollars = exports.dollarsToCents = exports.convertToCents = exports.removeDollarSignAndCommas = exports.parseCents = exports.formatDollarsFromCents = exports.formatNumberToUsd = exports.floorToNearest = exports.roundToNearest = exports.isNotPositiveNumber = exports.round80To100TaxRule = exports.toNumOrZero = exports.divideBy100 = exports.areTwoNumbersCloseEnough = exports.abbreviateNumber = exports.formatNumberWithCommas = void 0;
	exports.dollarsToCentsSchema = exports.commaDelimitedStringSchema = exports.nullableOptionalStringSchema = exports.nullableStringSchema = exports.stringSchema = exports.positiveIntSchema = exports.datetimeSchema = exports.jsonObjectSchema = exports.jsonSchema = exports.assertNeverType = exports.assertNever = exports.MAX_NUM_RETRY_REQUESTS = exports.retry = exports.isNeoTaxEmail = exports.isEmailIdentifier = exports.normalizeEmailIdentifier = exports.normalizeEmail = exports.AzureDevopsGranularityRefusalCode = exports.AuthErrorCode = exports.ProductType = exports.AscFixedCostTriggerSchema = exports.AscFixedCostTrigger = exports.FinchScopeTypeSchema = exports.FinchScopeType = exports.sredDocumentationStatusLabel = exports.SredDocumentationStatus = exports.sredProjectCategoryLabel = exports.SelectedSredProjectCategory = exports.rdDocumentationStatusLabel = exports.RdDocumentationStatus = exports.PredictedCapitalizationStatus = exports.PREDICTED_CAPITALIZATION_STATUS_LABELS = exports.rdProjectCategoryLabel = exports.SelectedRdProjectCategory = exports.periodNameSchema = exports.PeriodName = exports.PayrollMonthExpenseProvider = exports.ErrorStatusCode = exports.ValueType = exports.CompanyEntityType = exports.EligibilityStatus = exports.CorporationType = exports.ServiceOperationalStatus = exports.WageType = exports.PayrollProvider = exports.AccountingProvider = exports.PayrollAcquisitionMethod = exports.SsoError = exports.DateMonth = exports.GitHubAppInstallStatus = void 0;
	exports.safeParseExtendedGraphQlError = exports.safeParseExtendedApolloError = exports.parseExtendedGraphQlError = exports.parseExtendedApolloError = exports.ThomsonReutersCallbackPayloadStateSchema = exports.GustoCallbackPayloadStateSchema = exports.QuickbooksCallbackPayloadStateSchema = exports.IntuitSsoCallbackPayloadStateSchema = exports.QuickbooksDataLinkingCallbackPayloadStateSchema = exports.SsoStateSchema = exports.formatAsElementId = exports.capitalizeFirstLetter = exports.snakeCase = exports.formatArrayToCommaAndString = exports.escapeLikePattern = exports.normalizeWhitespaceAndCase = exports.sanitizeString = exports.combineAddresses = exports.truncateString = exports.spaceToDash = exports.kebabCase = exports.constantCase = exports.capitalCase = exports.parsePercentageIntegerValue = exports.slackEventDtoSchema = exports.singleTenantDomainRedirectInputSchema = exports.singleTenantRedirectUrlSchema = exports.singleTenantEmailDomainSchema = exports.SSO_PROVIDER_NAME_REGEX = exports.ssoProviderNameSchema = exports.monthYearStringSchema = exports.parseOrThrowClientError = exports.enumSchemaFromDynamicArray = exports.monthYearPeriodNullableSchema = exports.monthYearPeriodSchema = exports.monthYearSchema = exports.monthSchema = exports.emailSchema = exports.yearSchema = exports.nonNegativeNumberSchema = exports.intSchema = exports.jsonArraySchema = exports.notSpecifiedTransform = exports.dateCoercionSchema = exports.dateTimeOptionalTimeZoneRegex = exports.dateStringSchema = exports.isoDateTimeStringSchema = exports.dateTimeOptionalTimeZoneStringSchema = exports.uuidSchema = exports.vendorSchema = void 0;
	exports.isBeforeOrOnLockBoundary = exports.getFirstAllowableCapitalizationStartMonthYear = exports.isProjectDateRangeFullyLocked = exports.isCapitalizationEndDateLocked = exports.isCapitalizationStartDateLocked = exports.isCapitalizationStatusLocked = exports.getAverageAllocationInPeriod = exports.ALLOCATION_DIFF_THRESHOLD = exports.roundProjectAllocationPercents = exports.roundAllocationsToTotal = exports.updateAllocationsInPeriod = exports.getLatestAllocationPercent = exports.ErrorStatusToHttpStatusCode = exports.ProvisioningErrorCodes = exports.EMAIL_SESSION_CLAIM = exports.BlockingFunctionRejectionCodes = exports.LOGIN_METHOD_WINDOW_SECONDS = exports.LOGIN_METHOD_MAGIC_LINK = exports.LOGIN_METHOD_HEADER_NAME = exports.throttle = exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED = exports.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS = exports.toJson = exports.sortJsonByKeys = exports.sanitizeJson = exports.safeDateExtractFromJson = exports.getStaticCopy = exports.areJsonEqual = exports.questionKeyForPyr = exports.questionKeyForQre = exports.deduplicate = exports.chunk = exports.removeElement = exports.range = exports.moveElement = exports.insertElements = exports.OrganizationInvitationErrorCodes = exports.OrganizationInvitationErrorSchema = exports.DocumentNotParsableErrorSchema = exports.FinchProviderKeySchema = exports.ApplyWeightedRdPercentageToExpensesErrorSchema = exports.QuestionAnswerErrorSchema = exports.RdProjectDeletionErrorSchema = exports.AscProjectDeletionErrorSchema = exports.StandardErrorSchema = exports.BaseErrorSchema = void 0;
	exports.findBestContributorMatch = exports.buildContributorMatchIndex = exports.DEFAULT_FUZZY_MATCH_THRESHOLD = exports.jaroWinklerSimilarity = exports.parsePersonName = exports.isSurnameParticle = exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING = exports.determineRdProjectEligibility = exports.trackStackDepth = exports.Random = exports.QueryUseCase = exports.CommandUseCase = exports.StandardUseCase = exports.Injector = exports.calculateRdProjectCategory = exports.getFiscalPeriodsForRevenues = exports.getFiscalPeriodsForQres = exports.determineTaxYearEndDate = exports.determineTaxYearStartDate = exports.findFiscalYearsInPeriod = exports.isProductionLikeEnvironment = exports.hasStandardErrorCode = exports.hasErrorCode = exports.getStandardErrors = exports.getExtendedErrors = exports.extendedGraphQlErrorHasErrorCode = exports.extendedApolloErrorHasErrorCode = exports.ASC_NOISE_CLUSTER_TYPES = exports.isAscNoiseClusterType = exports.AscClusterType = exports.isUsedInCapitalizableProjectClustering = exports.getCapitalizableProjectClusteringStatus = exports.CLUSTERING_METHOD = exports.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE = exports.maxMonthYearNullable = exports.formatLockBoundary = exports.validateNotBeforeLockBoundary = void 0;
	var constants_1 = require_constants();
	Object.defineProperty(exports, "MAX_RD_PAYROLL_TAX_CREDIT_CENTS", {
		enumerable: true,
		get: function() {
			return constants_1.MAX_RD_PAYROLL_TAX_CREDIT_CENTS;
		}
	});
	Object.defineProperty(exports, "COMMON_CONSTANTS", {
		enumerable: true,
		get: function() {
			return constants_1.COMMON_CONSTANTS;
		}
	});
	Object.defineProperty(exports, "OLDEST_SUPPORTED_QRE_PYR_YEAR", {
		enumerable: true,
		get: function() {
			return constants_1.OLDEST_SUPPORTED_QRE_PYR_YEAR;
		}
	});
	Object.defineProperty(exports, "LAST_MONTH_DATE_DICT", {
		enumerable: true,
		get: function() {
			return constants_1.LAST_MONTH_DATE_DICT;
		}
	});
	Object.defineProperty(exports, "US_COUNTRY_CODE", {
		enumerable: true,
		get: function() {
			return constants_1.US_COUNTRY_CODE;
		}
	});
	Object.defineProperty(exports, "USER_ROUNDING_NUM_DECIMALS", {
		enumerable: true,
		get: function() {
			return constants_1.USER_ROUNDING_NUM_DECIMALS;
		}
	});
	Object.defineProperty(exports, "DB_ROUNDING_NUM_DECIMALS", {
		enumerable: true,
		get: function() {
			return constants_1.DB_ROUNDING_NUM_DECIMALS;
		}
	});
	Object.defineProperty(exports, "PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR", {
		enumerable: true,
		get: function() {
			return constants_1.PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR;
		}
	});
	Object.defineProperty(exports, "TEST_CAPTURED_EMAILS_LOG_PATH", {
		enumerable: true,
		get: function() {
			return constants_1.TEST_CAPTURED_EMAILS_LOG_PATH;
		}
	});
	Object.defineProperty(exports, "MAX_SEARCH_FIREBASE_IDENTITIES", {
		enumerable: true,
		get: function() {
			return constants_1.MAX_SEARCH_FIREBASE_IDENTITIES;
		}
	});
	Object.defineProperty(exports, "MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME", {
		enumerable: true,
		get: function() {
			return constants_1.MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME;
		}
	});
	var neo_tax_fee_details_1 = require_neo_tax_fee_details();
	Object.defineProperty(exports, "computeNeoTaxFeeDetails", {
		enumerable: true,
		get: function() {
			return neo_tax_fee_details_1.computeNeoTaxFeeDetails;
		}
	});
	var date_utils_1 = require_date_utils();
	Object.defineProperty(exports, "getInitialTaxDeadline", {
		enumerable: true,
		get: function() {
			return date_utils_1.getInitialTaxDeadline;
		}
	});
	Object.defineProperty(exports, "getExtensionTaxDeadline", {
		enumerable: true,
		get: function() {
			return date_utils_1.getExtensionTaxDeadline;
		}
	});
	Object.defineProperty(exports, "getCurrentTaxYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getCurrentTaxYear;
		}
	});
	Object.defineProperty(exports, "endOfFiscalYearDate", {
		enumerable: true,
		get: function() {
			return date_utils_1.endOfFiscalYearDate;
		}
	});
	Object.defineProperty(exports, "formatDayjs", {
		enumerable: true,
		get: function() {
			return date_utils_1.formatDayjs;
		}
	});
	Object.defineProperty(exports, "formatDate", {
		enumerable: true,
		get: function() {
			return date_utils_1.formatDate;
		}
	});
	Object.defineProperty(exports, "getCurrentDate", {
		enumerable: true,
		get: function() {
			return date_utils_1.getCurrentDate;
		}
	});
	Object.defineProperty(exports, "getCurrentDateObject", {
		enumerable: true,
		get: function() {
			return date_utils_1.getCurrentDateObject;
		}
	});
	Object.defineProperty(exports, "getCurrentYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getCurrentYear;
		}
	});
	Object.defineProperty(exports, "getCurrentDatetime", {
		enumerable: true,
		get: function() {
			return date_utils_1.getCurrentDatetime;
		}
	});
	Object.defineProperty(exports, "isDateString", {
		enumerable: true,
		get: function() {
			return date_utils_1.isDateString;
		}
	});
	Object.defineProperty(exports, "getYearFromStringDate", {
		enumerable: true,
		get: function() {
			return date_utils_1.getYearFromStringDate;
		}
	});
	Object.defineProperty(exports, "getEntryForCurrentTaxYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getEntryForCurrentTaxYear;
		}
	});
	Object.defineProperty(exports, "getStartOfYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getStartOfYear;
		}
	});
	Object.defineProperty(exports, "getEndOfYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getEndOfYear;
		}
	});
	Object.defineProperty(exports, "upperBoundForTaxReturnFilingDate", {
		enumerable: true,
		get: function() {
			return date_utils_1.upperBoundForTaxReturnFilingDate;
		}
	});
	Object.defineProperty(exports, "isLeapYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.isLeapYear;
		}
	});
	Object.defineProperty(exports, "sameDateString", {
		enumerable: true,
		get: function() {
			return date_utils_1.sameDateString;
		}
	});
	Object.defineProperty(exports, "getLastDayOfTheYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getLastDayOfTheYear;
		}
	});
	Object.defineProperty(exports, "currentDateToIsoString", {
		enumerable: true,
		get: function() {
			return date_utils_1.currentDateToIsoString;
		}
	});
	Object.defineProperty(exports, "getEntryForTaxYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getEntryForTaxYear;
		}
	});
	Object.defineProperty(exports, "toIsoDateString", {
		enumerable: true,
		get: function() {
			return date_utils_1.toIsoDateString;
		}
	});
	Object.defineProperty(exports, "isAfterInitialTaxDeadline", {
		enumerable: true,
		get: function() {
			return date_utils_1.isAfterInitialTaxDeadline;
		}
	});
	Object.defineProperty(exports, "addZeroPadding", {
		enumerable: true,
		get: function() {
			return date_utils_1.addZeroPadding;
		}
	});
	Object.defineProperty(exports, "removeZeroPadding", {
		enumerable: true,
		get: function() {
			return date_utils_1.removeZeroPadding;
		}
	});
	Object.defineProperty(exports, "getFirstDayOfPeriodByLastDay", {
		enumerable: true,
		get: function() {
			return date_utils_1.getFirstDayOfPeriodByLastDay;
		}
	});
	Object.defineProperty(exports, "isStandardFiscalYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.isStandardFiscalYear;
		}
	});
	Object.defineProperty(exports, "dateToDayjs", {
		enumerable: true,
		get: function() {
			return date_utils_1.dateToDayjs;
		}
	});
	Object.defineProperty(exports, "americanDateFormat", {
		enumerable: true,
		get: function() {
			return date_utils_1.americanDateFormat;
		}
	});
	Object.defineProperty(exports, "placedInServiceDate", {
		enumerable: true,
		get: function() {
			return date_utils_1.placedInServiceDate;
		}
	});
	Object.defineProperty(exports, "longDateFormat", {
		enumerable: true,
		get: function() {
			return date_utils_1.longDateFormat;
		}
	});
	Object.defineProperty(exports, "getLastDayOfTheMonth", {
		enumerable: true,
		get: function() {
			return date_utils_1.getLastDayOfTheMonth;
		}
	});
	Object.defineProperty(exports, "getFirstDayOfTheMonth", {
		enumerable: true,
		get: function() {
			return date_utils_1.getFirstDayOfTheMonth;
		}
	});
	Object.defineProperty(exports, "getEndOfDay", {
		enumerable: true,
		get: function() {
			return date_utils_1.getEndOfDay;
		}
	});
	Object.defineProperty(exports, "getMonthShortAbbreviation", {
		enumerable: true,
		get: function() {
			return date_utils_1.getMonthShortAbbreviation;
		}
	});
	Object.defineProperty(exports, "getMonthLongAbbreviation", {
		enumerable: true,
		get: function() {
			return date_utils_1.getMonthLongAbbreviation;
		}
	});
	Object.defineProperty(exports, "getDatetime", {
		enumerable: true,
		get: function() {
			return date_utils_1.getDatetime;
		}
	});
	Object.defineProperty(exports, "isDatetime", {
		enumerable: true,
		get: function() {
			return date_utils_1.isDatetime;
		}
	});
	Object.defineProperty(exports, "addMonths", {
		enumerable: true,
		get: function() {
			return date_utils_1.addMonths;
		}
	});
	Object.defineProperty(exports, "subtractMonths", {
		enumerable: true,
		get: function() {
			return date_utils_1.subtractMonths;
		}
	});
	Object.defineProperty(exports, "isTaxYearTraditional", {
		enumerable: true,
		get: function() {
			return date_utils_1.isTaxYearTraditional;
		}
	});
	Object.defineProperty(exports, "isDateInMonthYearRange", {
		enumerable: true,
		get: function() {
			return date_utils_1.isDateInMonthYearRange;
		}
	});
	Object.defineProperty(exports, "getPreviousMonthYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getPreviousMonthYear;
		}
	});
	Object.defineProperty(exports, "getNextMonthYear", {
		enumerable: true,
		get: function() {
			return date_utils_1.getNextMonthYear;
		}
	});
	var organization_members_export_utils_1 = require_organization_members_export_utils();
	Object.defineProperty(exports, "organizationMembersFileName", {
		enumerable: true,
		get: function() {
			return organization_members_export_utils_1.organizationMembersFileName;
		}
	});
	var month_year_utils_1 = require_month_year_utils();
	Object.defineProperty(exports, "isMonthYearBeforeOrEqual", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.isMonthYearBeforeOrEqual;
		}
	});
	Object.defineProperty(exports, "isMonthYearAfterOrEqual", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.isMonthYearAfterOrEqual;
		}
	});
	Object.defineProperty(exports, "isMonthYearInRange", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.isMonthYearInRange;
		}
	});
	Object.defineProperty(exports, "areMonthYearEqual", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.areMonthYearEqual;
		}
	});
	Object.defineProperty(exports, "dateToMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.dateToMonthYear;
		}
	});
	Object.defineProperty(exports, "toMonthYearString", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.toMonthYearString;
		}
	});
	Object.defineProperty(exports, "dateToMonthYearString", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.dateToMonthYearString;
		}
	});
	Object.defineProperty(exports, "stringToMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.stringToMonthYear;
		}
	});
	Object.defineProperty(exports, "getFirstDateOfMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getFirstDateOfMonthYear;
		}
	});
	Object.defineProperty(exports, "getFirstDateStringOfMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getFirstDateStringOfMonthYear;
		}
	});
	Object.defineProperty(exports, "getLastDateOfMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getLastDateOfMonthYear;
		}
	});
	Object.defineProperty(exports, "getLastDateStringOfMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getLastDateStringOfMonthYear;
		}
	});
	Object.defineProperty(exports, "generateMonthYearInRange", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.generateMonthYearInRange;
		}
	});
	Object.defineProperty(exports, "getMonthsBetweenAsc", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getMonthsBetweenAsc;
		}
	});
	Object.defineProperty(exports, "getMonthName", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getMonthName;
		}
	});
	Object.defineProperty(exports, "maxMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.maxMonthYear;
		}
	});
	Object.defineProperty(exports, "minMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.minMonthYear;
		}
	});
	Object.defineProperty(exports, "sameMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.sameMonthYear;
		}
	});
	Object.defineProperty(exports, "isMonthYearBefore", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.isMonthYearBefore;
		}
	});
	Object.defineProperty(exports, "toMonthYearPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.toMonthYearPeriod;
		}
	});
	Object.defineProperty(exports, "getNumMonthsBetweenInclusively", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getNumMonthsBetweenInclusively;
		}
	});
	Object.defineProperty(exports, "getNumberOfMonthsInPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getNumberOfMonthsInPeriod;
		}
	});
	Object.defineProperty(exports, "getMonthYearPeriodIntersection", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getMonthYearPeriodIntersection;
		}
	});
	Object.defineProperty(exports, "doPeriodsOverlap", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.doPeriodsOverlap;
		}
	});
	Object.defineProperty(exports, "isPeriodFullYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.isPeriodFullYear;
		}
	});
	Object.defineProperty(exports, "areSameMonthYearPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.areSameMonthYearPeriod;
		}
	});
	Object.defineProperty(exports, "calculateQuarter", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.calculateQuarter;
		}
	});
	Object.defineProperty(exports, "formatFiscalOrTaxPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.formatFiscalOrTaxPeriod;
		}
	});
	Object.defineProperty(exports, "formatFiscalPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.formatFiscalPeriod;
		}
	});
	Object.defineProperty(exports, "formatTaxPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.formatTaxPeriod;
		}
	});
	Object.defineProperty(exports, "formatMonthYearPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.formatMonthYearPeriod;
		}
	});
	Object.defineProperty(exports, "formatMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.formatMonthYear;
		}
	});
	Object.defineProperty(exports, "isMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.isMonthYear;
		}
	});
	Object.defineProperty(exports, "getEarliestAndLatestMonthYear", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getEarliestAndLatestMonthYear;
		}
	});
	Object.defineProperty(exports, "getCurrentFiscalYearMonthYearPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getCurrentFiscalYearMonthYearPeriod;
		}
	});
	Object.defineProperty(exports, "getPeriodName", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getPeriodName;
		}
	});
	Object.defineProperty(exports, "MONTH_PERIOD_NAMES", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.MONTH_PERIOD_NAMES;
		}
	});
	Object.defineProperty(exports, "getTaxYearMonthYearPeriod", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getTaxYearMonthYearPeriod;
		}
	});
	Object.defineProperty(exports, "getMonthYearPeriodUsingDates", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getMonthYearPeriodUsingDates;
		}
	});
	Object.defineProperty(exports, "dateStringToReadableMonthYearString", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.dateStringToReadableMonthYearString;
		}
	});
	Object.defineProperty(exports, "getMonthYearPeriodSuperset", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.getMonthYearPeriodSuperset;
		}
	});
	Object.defineProperty(exports, "calculateEarliestAffectedCapitalizationMonth", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.calculateEarliestAffectedCapitalizationMonth;
		}
	});
	Object.defineProperty(exports, "CapitalizationChangeReason", {
		enumerable: true,
		get: function() {
			return month_year_utils_1.CapitalizationChangeReason;
		}
	});
	var number_utils_1 = require_number_utils();
	Object.defineProperty(exports, "formatNumberWithCommas", {
		enumerable: true,
		get: function() {
			return number_utils_1.formatNumberWithCommas;
		}
	});
	Object.defineProperty(exports, "abbreviateNumber", {
		enumerable: true,
		get: function() {
			return number_utils_1.abbreviateNumber;
		}
	});
	Object.defineProperty(exports, "areTwoNumbersCloseEnough", {
		enumerable: true,
		get: function() {
			return number_utils_1.areTwoNumbersCloseEnough;
		}
	});
	Object.defineProperty(exports, "divideBy100", {
		enumerable: true,
		get: function() {
			return number_utils_1.divideBy100;
		}
	});
	Object.defineProperty(exports, "toNumOrZero", {
		enumerable: true,
		get: function() {
			return number_utils_1.toNumOrZero;
		}
	});
	Object.defineProperty(exports, "round80To100TaxRule", {
		enumerable: true,
		get: function() {
			return number_utils_1.round80To100TaxRule;
		}
	});
	Object.defineProperty(exports, "isNotPositiveNumber", {
		enumerable: true,
		get: function() {
			return number_utils_1.isNotPositiveNumber;
		}
	});
	Object.defineProperty(exports, "roundToNearest", {
		enumerable: true,
		get: function() {
			return number_utils_1.roundToNearest;
		}
	});
	Object.defineProperty(exports, "floorToNearest", {
		enumerable: true,
		get: function() {
			return number_utils_1.floorToNearest;
		}
	});
	var money_utils_1 = require_money_utils();
	Object.defineProperty(exports, "formatNumberToUsd", {
		enumerable: true,
		get: function() {
			return money_utils_1.formatNumberToUsd;
		}
	});
	Object.defineProperty(exports, "formatDollarsFromCents", {
		enumerable: true,
		get: function() {
			return money_utils_1.formatDollarsFromCents;
		}
	});
	Object.defineProperty(exports, "parseCents", {
		enumerable: true,
		get: function() {
			return money_utils_1.parseCents;
		}
	});
	Object.defineProperty(exports, "removeDollarSignAndCommas", {
		enumerable: true,
		get: function() {
			return money_utils_1.removeDollarSignAndCommas;
		}
	});
	Object.defineProperty(exports, "convertToCents", {
		enumerable: true,
		get: function() {
			return money_utils_1.convertToCents;
		}
	});
	Object.defineProperty(exports, "dollarsToCents", {
		enumerable: true,
		get: function() {
			return money_utils_1.dollarsToCents;
		}
	});
	Object.defineProperty(exports, "centsToDollars", {
		enumerable: true,
		get: function() {
			return money_utils_1.centsToDollars;
		}
	});
	Object.defineProperty(exports, "centsToNumberWithCommas", {
		enumerable: true,
		get: function() {
			return money_utils_1.centsToNumberWithCommas;
		}
	});
	var company_utils_1 = require_company_utils();
	Object.defineProperty(exports, "getActualBusinessStartIsoDate", {
		enumerable: true,
		get: function() {
			return company_utils_1.getActualBusinessStartIsoDate;
		}
	});
	var promise_1 = require_promise();
	Object.defineProperty(exports, "pause", {
		enumerable: true,
		get: function() {
			return promise_1.pause;
		}
	});
	var errors_1 = require_errors$1();
	Object.defineProperty(exports, "createNamedErrorClass", {
		enumerable: true,
		get: function() {
			return errors_1.createNamedErrorClass;
		}
	});
	Object.defineProperty(exports, "createError", {
		enumerable: true,
		get: function() {
			return errors_1.createError;
		}
	});
	Object.defineProperty(exports, "createClientError", {
		enumerable: true,
		get: function() {
			return errors_1.createClientError;
		}
	});
	Object.defineProperty(exports, "createClientErrors", {
		enumerable: true,
		get: function() {
			return errors_1.createClientErrors;
		}
	});
	Object.defineProperty(exports, "handleCaughtError", {
		enumerable: true,
		get: function() {
			return errors_1.handleCaughtError;
		}
	});
	Object.defineProperty(exports, "ErrorWithStatusCode", {
		enumerable: true,
		get: function() {
			return errors_1.ErrorWithStatusCode;
		}
	});
	Object.defineProperty(exports, "ExtendedGraphQLErrors", {
		enumerable: true,
		get: function() {
			return errors_1.ExtendedGraphQLErrors;
		}
	});
	var questions_1 = require_questions();
	Object.defineProperty(exports, "divideTools", {
		enumerable: true,
		get: function() {
			return questions_1.divideTools;
		}
	});
	Object.defineProperty(exports, "combineTools", {
		enumerable: true,
		get: function() {
			return questions_1.combineTools;
		}
	});
	Object.defineProperty(exports, "divideResearchActivities", {
		enumerable: true,
		get: function() {
			return questions_1.divideResearchActivities;
		}
	});
	Object.defineProperty(exports, "DocumentationTools", {
		enumerable: true,
		get: function() {
			return questions_1.DocumentationTools;
		}
	});
	Object.defineProperty(exports, "ResearchActivities", {
		enumerable: true,
		get: function() {
			return questions_1.ResearchActivities;
		}
	});
	var enums_1 = require_enums();
	Object.defineProperty(exports, "AnalyticIdentifier", {
		enumerable: true,
		get: function() {
			return enums_1.AnalyticIdentifier;
		}
	});
	Object.defineProperty(exports, "ExpenseCategory", {
		enumerable: true,
		get: function() {
			return enums_1.ExpenseCategory;
		}
	});
	Object.defineProperty(exports, "convertExpenseCategoryToNum", {
		enumerable: true,
		get: function() {
			return enums_1.convertExpenseCategoryToNum;
		}
	});
	Object.defineProperty(exports, "QuickbooksQueryField", {
		enumerable: true,
		get: function() {
			return enums_1.QuickbooksQueryField;
		}
	});
	Object.defineProperty(exports, "SsoQueryField", {
		enumerable: true,
		get: function() {
			return enums_1.SsoQueryField;
		}
	});
	Object.defineProperty(exports, "NeoTaxEnvironment", {
		enumerable: true,
		get: function() {
			return enums_1.NeoTaxEnvironment;
		}
	});
	Object.defineProperty(exports, "ServiceScope", {
		enumerable: true,
		get: function() {
			return enums_1.ServiceScope;
		}
	});
	Object.defineProperty(exports, "AccountClassification", {
		enumerable: true,
		get: function() {
			return enums_1.AccountClassification;
		}
	});
	Object.defineProperty(exports, "AccountType", {
		enumerable: true,
		get: function() {
			return enums_1.AccountType;
		}
	});
	Object.defineProperty(exports, "RoundingMethod", {
		enumerable: true,
		get: function() {
			return enums_1.RoundingMethod;
		}
	});
	Object.defineProperty(exports, "HardSciences", {
		enumerable: true,
		get: function() {
			return enums_1.HardSciences;
		}
	});
	Object.defineProperty(exports, "RevenueSource", {
		enumerable: true,
		get: function() {
			return enums_1.RevenueSource;
		}
	});
	Object.defineProperty(exports, "getRevenueSourceRank", {
		enumerable: true,
		get: function() {
			return enums_1.getRevenueSourceRank;
		}
	});
	Object.defineProperty(exports, "SalesChannel", {
		enumerable: true,
		get: function() {
			return enums_1.SalesChannel;
		}
	});
	Object.defineProperty(exports, "EntityType", {
		enumerable: true,
		get: function() {
			return enums_1.EntityType;
		}
	});
	Object.defineProperty(exports, "AccountingAcquisitionMethod", {
		enumerable: true,
		get: function() {
			return enums_1.AccountingAcquisitionMethod;
		}
	});
	Object.defineProperty(exports, "QuickbooksConnectionStatus", {
		enumerable: true,
		get: function() {
			return enums_1.QuickbooksConnectionStatus;
		}
	});
	Object.defineProperty(exports, "QuickbooksMonth", {
		enumerable: true,
		get: function() {
			return enums_1.QuickbooksMonth;
		}
	});
	Object.defineProperty(exports, "GitHubAppInstallQueryField", {
		enumerable: true,
		get: function() {
			return enums_1.GitHubAppInstallQueryField;
		}
	});
	Object.defineProperty(exports, "GitHubAppInstallStatus", {
		enumerable: true,
		get: function() {
			return enums_1.GitHubAppInstallStatus;
		}
	});
	Object.defineProperty(exports, "DateMonth", {
		enumerable: true,
		get: function() {
			return enums_1.DateMonth;
		}
	});
	Object.defineProperty(exports, "SsoError", {
		enumerable: true,
		get: function() {
			return enums_1.SsoError;
		}
	});
	Object.defineProperty(exports, "PayrollAcquisitionMethod", {
		enumerable: true,
		get: function() {
			return enums_1.PayrollAcquisitionMethod;
		}
	});
	Object.defineProperty(exports, "AccountingProvider", {
		enumerable: true,
		get: function() {
			return enums_1.AccountingProvider;
		}
	});
	Object.defineProperty(exports, "PayrollProvider", {
		enumerable: true,
		get: function() {
			return enums_1.PayrollProvider;
		}
	});
	Object.defineProperty(exports, "WageType", {
		enumerable: true,
		get: function() {
			return enums_1.WageType;
		}
	});
	Object.defineProperty(exports, "ServiceOperationalStatus", {
		enumerable: true,
		get: function() {
			return enums_1.ServiceOperationalStatus;
		}
	});
	Object.defineProperty(exports, "CorporationType", {
		enumerable: true,
		get: function() {
			return enums_1.CorporationType;
		}
	});
	Object.defineProperty(exports, "EligibilityStatus", {
		enumerable: true,
		get: function() {
			return enums_1.EligibilityStatus;
		}
	});
	Object.defineProperty(exports, "CompanyEntityType", {
		enumerable: true,
		get: function() {
			return enums_1.CompanyEntityType;
		}
	});
	Object.defineProperty(exports, "ValueType", {
		enumerable: true,
		get: function() {
			return enums_1.ValueType;
		}
	});
	Object.defineProperty(exports, "ErrorStatusCode", {
		enumerable: true,
		get: function() {
			return enums_1.ErrorStatusCode;
		}
	});
	Object.defineProperty(exports, "PayrollMonthExpenseProvider", {
		enumerable: true,
		get: function() {
			return enums_1.PayrollMonthExpenseProvider;
		}
	});
	Object.defineProperty(exports, "PeriodName", {
		enumerable: true,
		get: function() {
			return enums_1.PeriodName;
		}
	});
	Object.defineProperty(exports, "periodNameSchema", {
		enumerable: true,
		get: function() {
			return enums_1.periodNameSchema;
		}
	});
	Object.defineProperty(exports, "SelectedRdProjectCategory", {
		enumerable: true,
		get: function() {
			return enums_1.SelectedRdProjectCategory;
		}
	});
	Object.defineProperty(exports, "rdProjectCategoryLabel", {
		enumerable: true,
		get: function() {
			return enums_1.rdProjectCategoryLabel;
		}
	});
	Object.defineProperty(exports, "PREDICTED_CAPITALIZATION_STATUS_LABELS", {
		enumerable: true,
		get: function() {
			return enums_1.PREDICTED_CAPITALIZATION_STATUS_LABELS;
		}
	});
	Object.defineProperty(exports, "PredictedCapitalizationStatus", {
		enumerable: true,
		get: function() {
			return enums_1.PredictedCapitalizationStatus;
		}
	});
	Object.defineProperty(exports, "RdDocumentationStatus", {
		enumerable: true,
		get: function() {
			return enums_1.RdDocumentationStatus;
		}
	});
	Object.defineProperty(exports, "rdDocumentationStatusLabel", {
		enumerable: true,
		get: function() {
			return enums_1.rdDocumentationStatusLabel;
		}
	});
	Object.defineProperty(exports, "SelectedSredProjectCategory", {
		enumerable: true,
		get: function() {
			return enums_1.SelectedSredProjectCategory;
		}
	});
	Object.defineProperty(exports, "sredProjectCategoryLabel", {
		enumerable: true,
		get: function() {
			return enums_1.sredProjectCategoryLabel;
		}
	});
	Object.defineProperty(exports, "SredDocumentationStatus", {
		enumerable: true,
		get: function() {
			return enums_1.SredDocumentationStatus;
		}
	});
	Object.defineProperty(exports, "sredDocumentationStatusLabel", {
		enumerable: true,
		get: function() {
			return enums_1.sredDocumentationStatusLabel;
		}
	});
	Object.defineProperty(exports, "FinchScopeType", {
		enumerable: true,
		get: function() {
			return enums_1.FinchScopeType;
		}
	});
	Object.defineProperty(exports, "FinchScopeTypeSchema", {
		enumerable: true,
		get: function() {
			return enums_1.FinchScopeTypeSchema;
		}
	});
	Object.defineProperty(exports, "AscFixedCostTrigger", {
		enumerable: true,
		get: function() {
			return enums_1.AscFixedCostTrigger;
		}
	});
	Object.defineProperty(exports, "AscFixedCostTriggerSchema", {
		enumerable: true,
		get: function() {
			return enums_1.AscFixedCostTriggerSchema;
		}
	});
	Object.defineProperty(exports, "ProductType", {
		enumerable: true,
		get: function() {
			return enums_1.ProductType;
		}
	});
	Object.defineProperty(exports, "AuthErrorCode", {
		enumerable: true,
		get: function() {
			return enums_1.AuthErrorCode;
		}
	});
	Object.defineProperty(exports, "AzureDevopsGranularityRefusalCode", {
		enumerable: true,
		get: function() {
			return enums_1.AzureDevopsGranularityRefusalCode;
		}
	});
	var email_utils_1 = require_email_utils();
	Object.defineProperty(exports, "normalizeEmail", {
		enumerable: true,
		get: function() {
			return email_utils_1.normalizeEmail;
		}
	});
	Object.defineProperty(exports, "normalizeEmailIdentifier", {
		enumerable: true,
		get: function() {
			return email_utils_1.normalizeEmailIdentifier;
		}
	});
	Object.defineProperty(exports, "isEmailIdentifier", {
		enumerable: true,
		get: function() {
			return email_utils_1.isEmailIdentifier;
		}
	});
	Object.defineProperty(exports, "isNeoTaxEmail", {
		enumerable: true,
		get: function() {
			return email_utils_1.isNeoTaxEmail;
		}
	});
	var retry_utils_1 = require_retry_utils();
	Object.defineProperty(exports, "retry", {
		enumerable: true,
		get: function() {
			return retry_utils_1.retry;
		}
	});
	Object.defineProperty(exports, "MAX_NUM_RETRY_REQUESTS", {
		enumerable: true,
		get: function() {
			return retry_utils_1.MAX_NUM_RETRY_REQUESTS;
		}
	});
	var types_utils_1 = require_types_utils();
	Object.defineProperty(exports, "assertNever", {
		enumerable: true,
		get: function() {
			return types_utils_1.assertNever;
		}
	});
	Object.defineProperty(exports, "assertNeverType", {
		enumerable: true,
		get: function() {
			return types_utils_1.assertNeverType;
		}
	});
	Object.defineProperty(exports, "jsonSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.jsonSchema;
		}
	});
	Object.defineProperty(exports, "jsonObjectSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.jsonObjectSchema;
		}
	});
	Object.defineProperty(exports, "datetimeSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.datetimeSchema;
		}
	});
	Object.defineProperty(exports, "positiveIntSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.positiveIntSchema;
		}
	});
	Object.defineProperty(exports, "stringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.stringSchema;
		}
	});
	Object.defineProperty(exports, "nullableStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.nullableStringSchema;
		}
	});
	Object.defineProperty(exports, "nullableOptionalStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.nullableOptionalStringSchema;
		}
	});
	Object.defineProperty(exports, "commaDelimitedStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.commaDelimitedStringSchema;
		}
	});
	Object.defineProperty(exports, "dollarsToCentsSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.dollarsToCentsSchema;
		}
	});
	Object.defineProperty(exports, "vendorSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.vendorSchema;
		}
	});
	Object.defineProperty(exports, "uuidSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.uuidSchema;
		}
	});
	Object.defineProperty(exports, "dateTimeOptionalTimeZoneStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.dateTimeOptionalTimeZoneStringSchema;
		}
	});
	Object.defineProperty(exports, "isoDateTimeStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.isoDateTimeStringSchema;
		}
	});
	Object.defineProperty(exports, "dateStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.dateStringSchema;
		}
	});
	Object.defineProperty(exports, "dateTimeOptionalTimeZoneRegex", {
		enumerable: true,
		get: function() {
			return types_utils_1.dateTimeOptionalTimeZoneRegex;
		}
	});
	Object.defineProperty(exports, "dateCoercionSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.dateCoercionSchema;
		}
	});
	Object.defineProperty(exports, "notSpecifiedTransform", {
		enumerable: true,
		get: function() {
			return types_utils_1.notSpecifiedTransform;
		}
	});
	Object.defineProperty(exports, "jsonArraySchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.jsonArraySchema;
		}
	});
	Object.defineProperty(exports, "intSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.intSchema;
		}
	});
	Object.defineProperty(exports, "nonNegativeNumberSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.nonNegativeNumberSchema;
		}
	});
	Object.defineProperty(exports, "yearSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.yearSchema;
		}
	});
	Object.defineProperty(exports, "emailSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.emailSchema;
		}
	});
	Object.defineProperty(exports, "monthSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.monthSchema;
		}
	});
	Object.defineProperty(exports, "monthYearSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.monthYearSchema;
		}
	});
	Object.defineProperty(exports, "monthYearPeriodSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.monthYearPeriodSchema;
		}
	});
	Object.defineProperty(exports, "monthYearPeriodNullableSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.monthYearPeriodNullableSchema;
		}
	});
	Object.defineProperty(exports, "enumSchemaFromDynamicArray", {
		enumerable: true,
		get: function() {
			return types_utils_1.enumSchemaFromDynamicArray;
		}
	});
	Object.defineProperty(exports, "parseOrThrowClientError", {
		enumerable: true,
		get: function() {
			return types_utils_1.parseOrThrowClientError;
		}
	});
	Object.defineProperty(exports, "monthYearStringSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.monthYearStringSchema;
		}
	});
	Object.defineProperty(exports, "ssoProviderNameSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.ssoProviderNameSchema;
		}
	});
	Object.defineProperty(exports, "SSO_PROVIDER_NAME_REGEX", {
		enumerable: true,
		get: function() {
			return types_utils_1.SSO_PROVIDER_NAME_REGEX;
		}
	});
	Object.defineProperty(exports, "singleTenantEmailDomainSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.singleTenantEmailDomainSchema;
		}
	});
	Object.defineProperty(exports, "singleTenantRedirectUrlSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.singleTenantRedirectUrlSchema;
		}
	});
	Object.defineProperty(exports, "singleTenantDomainRedirectInputSchema", {
		enumerable: true,
		get: function() {
			return types_utils_1.singleTenantDomainRedirectInputSchema;
		}
	});
	var slack_types_1 = require_slack_types();
	Object.defineProperty(exports, "slackEventDtoSchema", {
		enumerable: true,
		get: function() {
			return slack_types_1.slackEventDtoSchema;
		}
	});
	var string_utils_1 = require_string_utils();
	Object.defineProperty(exports, "parsePercentageIntegerValue", {
		enumerable: true,
		get: function() {
			return string_utils_1.parsePercentageIntegerValue;
		}
	});
	Object.defineProperty(exports, "capitalCase", {
		enumerable: true,
		get: function() {
			return string_utils_1.capitalCase;
		}
	});
	Object.defineProperty(exports, "constantCase", {
		enumerable: true,
		get: function() {
			return string_utils_1.constantCase;
		}
	});
	Object.defineProperty(exports, "kebabCase", {
		enumerable: true,
		get: function() {
			return string_utils_1.kebabCase;
		}
	});
	Object.defineProperty(exports, "spaceToDash", {
		enumerable: true,
		get: function() {
			return string_utils_1.spaceToDash;
		}
	});
	Object.defineProperty(exports, "truncateString", {
		enumerable: true,
		get: function() {
			return string_utils_1.truncateString;
		}
	});
	Object.defineProperty(exports, "combineAddresses", {
		enumerable: true,
		get: function() {
			return string_utils_1.combineAddresses;
		}
	});
	Object.defineProperty(exports, "sanitizeString", {
		enumerable: true,
		get: function() {
			return string_utils_1.sanitizeString;
		}
	});
	Object.defineProperty(exports, "normalizeWhitespaceAndCase", {
		enumerable: true,
		get: function() {
			return string_utils_1.normalizeWhitespaceAndCase;
		}
	});
	Object.defineProperty(exports, "escapeLikePattern", {
		enumerable: true,
		get: function() {
			return string_utils_1.escapeLikePattern;
		}
	});
	Object.defineProperty(exports, "formatArrayToCommaAndString", {
		enumerable: true,
		get: function() {
			return string_utils_1.formatArrayToCommaAndString;
		}
	});
	Object.defineProperty(exports, "snakeCase", {
		enumerable: true,
		get: function() {
			return string_utils_1.snakeCase;
		}
	});
	Object.defineProperty(exports, "capitalizeFirstLetter", {
		enumerable: true,
		get: function() {
			return string_utils_1.capitalizeFirstLetter;
		}
	});
	Object.defineProperty(exports, "formatAsElementId", {
		enumerable: true,
		get: function() {
			return string_utils_1.formatAsElementId;
		}
	});
	var interfaces_1 = require_interfaces();
	Object.defineProperty(exports, "SsoStateSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.SsoStateSchema;
		}
	});
	Object.defineProperty(exports, "QuickbooksDataLinkingCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.QuickbooksDataLinkingCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "IntuitSsoCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.IntuitSsoCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "QuickbooksCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.QuickbooksCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "GustoCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.GustoCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "ThomsonReutersCallbackPayloadStateSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.ThomsonReutersCallbackPayloadStateSchema;
		}
	});
	Object.defineProperty(exports, "parseExtendedApolloError", {
		enumerable: true,
		get: function() {
			return interfaces_1.parseExtendedApolloError;
		}
	});
	Object.defineProperty(exports, "parseExtendedGraphQlError", {
		enumerable: true,
		get: function() {
			return interfaces_1.parseExtendedGraphQlError;
		}
	});
	Object.defineProperty(exports, "safeParseExtendedApolloError", {
		enumerable: true,
		get: function() {
			return interfaces_1.safeParseExtendedApolloError;
		}
	});
	Object.defineProperty(exports, "safeParseExtendedGraphQlError", {
		enumerable: true,
		get: function() {
			return interfaces_1.safeParseExtendedGraphQlError;
		}
	});
	Object.defineProperty(exports, "BaseErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.BaseErrorSchema;
		}
	});
	Object.defineProperty(exports, "StandardErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.StandardErrorSchema;
		}
	});
	Object.defineProperty(exports, "AscProjectDeletionErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.AscProjectDeletionErrorSchema;
		}
	});
	Object.defineProperty(exports, "RdProjectDeletionErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.RdProjectDeletionErrorSchema;
		}
	});
	Object.defineProperty(exports, "QuestionAnswerErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.QuestionAnswerErrorSchema;
		}
	});
	Object.defineProperty(exports, "ApplyWeightedRdPercentageToExpensesErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.ApplyWeightedRdPercentageToExpensesErrorSchema;
		}
	});
	Object.defineProperty(exports, "FinchProviderKeySchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.FinchProviderKeySchema;
		}
	});
	Object.defineProperty(exports, "DocumentNotParsableErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.DocumentNotParsableErrorSchema;
		}
	});
	Object.defineProperty(exports, "OrganizationInvitationErrorSchema", {
		enumerable: true,
		get: function() {
			return interfaces_1.OrganizationInvitationErrorSchema;
		}
	});
	Object.defineProperty(exports, "OrganizationInvitationErrorCodes", {
		enumerable: true,
		get: function() {
			return interfaces_1.OrganizationInvitationErrorCodes;
		}
	});
	var array_utils_1 = require_array_utils();
	Object.defineProperty(exports, "insertElements", {
		enumerable: true,
		get: function() {
			return array_utils_1.insertElements;
		}
	});
	Object.defineProperty(exports, "moveElement", {
		enumerable: true,
		get: function() {
			return array_utils_1.moveElement;
		}
	});
	Object.defineProperty(exports, "range", {
		enumerable: true,
		get: function() {
			return array_utils_1.range;
		}
	});
	Object.defineProperty(exports, "removeElement", {
		enumerable: true,
		get: function() {
			return array_utils_1.removeElement;
		}
	});
	Object.defineProperty(exports, "chunk", {
		enumerable: true,
		get: function() {
			return array_utils_1.chunk;
		}
	});
	Object.defineProperty(exports, "deduplicate", {
		enumerable: true,
		get: function() {
			return array_utils_1.deduplicate;
		}
	});
	var page_status_1 = require_page_status();
	Object.defineProperty(exports, "questionKeyForQre", {
		enumerable: true,
		get: function() {
			return page_status_1.questionKeyForQre;
		}
	});
	Object.defineProperty(exports, "questionKeyForPyr", {
		enumerable: true,
		get: function() {
			return page_status_1.questionKeyForPyr;
		}
	});
	var json_utils_1 = require_json_utils();
	Object.defineProperty(exports, "areJsonEqual", {
		enumerable: true,
		get: function() {
			return json_utils_1.areJsonEqual;
		}
	});
	Object.defineProperty(exports, "getStaticCopy", {
		enumerable: true,
		get: function() {
			return json_utils_1.getStaticCopy;
		}
	});
	Object.defineProperty(exports, "safeDateExtractFromJson", {
		enumerable: true,
		get: function() {
			return json_utils_1.safeDateExtractFromJson;
		}
	});
	Object.defineProperty(exports, "sanitizeJson", {
		enumerable: true,
		get: function() {
			return json_utils_1.sanitizeJson;
		}
	});
	Object.defineProperty(exports, "sortJsonByKeys", {
		enumerable: true,
		get: function() {
			return json_utils_1.sortJsonByKeys;
		}
	});
	Object.defineProperty(exports, "toJson", {
		enumerable: true,
		get: function() {
			return json_utils_1.toJson;
		}
	});
	var csv_1 = require_csv();
	Object.defineProperty(exports, "GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS", {
		enumerable: true,
		get: function() {
			return csv_1.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS;
		}
	});
	Object.defineProperty(exports, "GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED", {
		enumerable: true,
		get: function() {
			return csv_1.GENERIC_ACCOUNTING_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS", {
		enumerable: true,
		get: function() {
			return csv_1.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED", {
		enumerable: true,
		get: function() {
			return csv_1.GENERIC_PAYROLL_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS", {
		enumerable: true,
		get: function() {
			return csv_1.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS;
		}
	});
	Object.defineProperty(exports, "GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED", {
		enumerable: true,
		get: function() {
			return csv_1.GENERIC_PAYROLL_MONTH_EXPENSE_CSV_COLUMN_LABELS_AUGMENTED;
		}
	});
	var function_utils_1 = require_function_utils();
	Object.defineProperty(exports, "throttle", {
		enumerable: true,
		get: function() {
			return function_utils_1.throttle;
		}
	});
	var login_method_header_1 = require_login_method_header();
	Object.defineProperty(exports, "LOGIN_METHOD_HEADER_NAME", {
		enumerable: true,
		get: function() {
			return login_method_header_1.LOGIN_METHOD_HEADER_NAME;
		}
	});
	Object.defineProperty(exports, "LOGIN_METHOD_MAGIC_LINK", {
		enumerable: true,
		get: function() {
			return login_method_header_1.LOGIN_METHOD_MAGIC_LINK;
		}
	});
	Object.defineProperty(exports, "LOGIN_METHOD_WINDOW_SECONDS", {
		enumerable: true,
		get: function() {
			return login_method_header_1.LOGIN_METHOD_WINDOW_SECONDS;
		}
	});
	var blocking_function_1 = require_blocking_function();
	Object.defineProperty(exports, "BlockingFunctionRejectionCodes", {
		enumerable: true,
		get: function() {
			return blocking_function_1.BlockingFunctionRejectionCodes;
		}
	});
	Object.defineProperty(exports, "EMAIL_SESSION_CLAIM", {
		enumerable: true,
		get: function() {
			return blocking_function_1.EMAIL_SESSION_CLAIM;
		}
	});
	Object.defineProperty(exports, "ProvisioningErrorCodes", {
		enumerable: true,
		get: function() {
			return blocking_function_1.ProvisioningErrorCodes;
		}
	});
	var status_codes_utils_1 = require_status_codes_utils();
	Object.defineProperty(exports, "ErrorStatusToHttpStatusCode", {
		enumerable: true,
		get: function() {
			return status_codes_utils_1.ErrorStatusToHttpStatusCode;
		}
	});
	var asc_projects_1 = require_asc_projects();
	Object.defineProperty(exports, "getLatestAllocationPercent", {
		enumerable: true,
		get: function() {
			return asc_projects_1.getLatestAllocationPercent;
		}
	});
	Object.defineProperty(exports, "updateAllocationsInPeriod", {
		enumerable: true,
		get: function() {
			return asc_projects_1.updateAllocationsInPeriod;
		}
	});
	Object.defineProperty(exports, "roundAllocationsToTotal", {
		enumerable: true,
		get: function() {
			return asc_projects_1.roundAllocationsToTotal;
		}
	});
	Object.defineProperty(exports, "roundProjectAllocationPercents", {
		enumerable: true,
		get: function() {
			return asc_projects_1.roundProjectAllocationPercents;
		}
	});
	Object.defineProperty(exports, "ALLOCATION_DIFF_THRESHOLD", {
		enumerable: true,
		get: function() {
			return asc_projects_1.ALLOCATION_DIFF_THRESHOLD;
		}
	});
	Object.defineProperty(exports, "getAverageAllocationInPeriod", {
		enumerable: true,
		get: function() {
			return asc_projects_1.getAverageAllocationInPeriod;
		}
	});
	Object.defineProperty(exports, "isCapitalizationStatusLocked", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isCapitalizationStatusLocked;
		}
	});
	Object.defineProperty(exports, "isCapitalizationStartDateLocked", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isCapitalizationStartDateLocked;
		}
	});
	Object.defineProperty(exports, "isCapitalizationEndDateLocked", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isCapitalizationEndDateLocked;
		}
	});
	Object.defineProperty(exports, "isProjectDateRangeFullyLocked", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isProjectDateRangeFullyLocked;
		}
	});
	Object.defineProperty(exports, "getFirstAllowableCapitalizationStartMonthYear", {
		enumerable: true,
		get: function() {
			return asc_projects_1.getFirstAllowableCapitalizationStartMonthYear;
		}
	});
	Object.defineProperty(exports, "isBeforeOrOnLockBoundary", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isBeforeOrOnLockBoundary;
		}
	});
	Object.defineProperty(exports, "validateNotBeforeLockBoundary", {
		enumerable: true,
		get: function() {
			return asc_projects_1.validateNotBeforeLockBoundary;
		}
	});
	Object.defineProperty(exports, "formatLockBoundary", {
		enumerable: true,
		get: function() {
			return asc_projects_1.formatLockBoundary;
		}
	});
	Object.defineProperty(exports, "maxMonthYearNullable", {
		enumerable: true,
		get: function() {
			return asc_projects_1.maxMonthYearNullable;
		}
	});
	Object.defineProperty(exports, "CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE", {
		enumerable: true,
		get: function() {
			return asc_projects_1.CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE;
		}
	});
	Object.defineProperty(exports, "CLUSTERING_METHOD", {
		enumerable: true,
		get: function() {
			return asc_projects_1.CLUSTERING_METHOD;
		}
	});
	Object.defineProperty(exports, "getCapitalizableProjectClusteringStatus", {
		enumerable: true,
		get: function() {
			return asc_projects_1.getCapitalizableProjectClusteringStatus;
		}
	});
	Object.defineProperty(exports, "isUsedInCapitalizableProjectClustering", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isUsedInCapitalizableProjectClustering;
		}
	});
	Object.defineProperty(exports, "AscClusterType", {
		enumerable: true,
		get: function() {
			return asc_projects_1.AscClusterType;
		}
	});
	Object.defineProperty(exports, "isAscNoiseClusterType", {
		enumerable: true,
		get: function() {
			return asc_projects_1.isAscNoiseClusterType;
		}
	});
	Object.defineProperty(exports, "ASC_NOISE_CLUSTER_TYPES", {
		enumerable: true,
		get: function() {
			return asc_projects_1.ASC_NOISE_CLUSTER_TYPES;
		}
	});
	var error_utils_1 = require_error_utils();
	Object.defineProperty(exports, "extendedApolloErrorHasErrorCode", {
		enumerable: true,
		get: function() {
			return error_utils_1.extendedApolloErrorHasErrorCode;
		}
	});
	Object.defineProperty(exports, "extendedGraphQlErrorHasErrorCode", {
		enumerable: true,
		get: function() {
			return error_utils_1.extendedGraphQlErrorHasErrorCode;
		}
	});
	Object.defineProperty(exports, "getExtendedErrors", {
		enumerable: true,
		get: function() {
			return error_utils_1.getExtendedErrors;
		}
	});
	Object.defineProperty(exports, "getStandardErrors", {
		enumerable: true,
		get: function() {
			return error_utils_1.getStandardErrors;
		}
	});
	Object.defineProperty(exports, "hasErrorCode", {
		enumerable: true,
		get: function() {
			return error_utils_1.hasErrorCode;
		}
	});
	Object.defineProperty(exports, "hasStandardErrorCode", {
		enumerable: true,
		get: function() {
			return error_utils_1.hasStandardErrorCode;
		}
	});
	var environment_utils_1 = require_environment_utils();
	Object.defineProperty(exports, "isProductionLikeEnvironment", {
		enumerable: true,
		get: function() {
			return environment_utils_1.isProductionLikeEnvironment;
		}
	});
	var fiscal_year_utils_1 = require_fiscal_year_utils();
	Object.defineProperty(exports, "findFiscalYearsInPeriod", {
		enumerable: true,
		get: function() {
			return fiscal_year_utils_1.findFiscalYearsInPeriod;
		}
	});
	var prior_year_data_utils_1 = require_prior_year_data_utils();
	Object.defineProperty(exports, "determineTaxYearStartDate", {
		enumerable: true,
		get: function() {
			return prior_year_data_utils_1.determineTaxYearStartDate;
		}
	});
	Object.defineProperty(exports, "determineTaxYearEndDate", {
		enumerable: true,
		get: function() {
			return prior_year_data_utils_1.determineTaxYearEndDate;
		}
	});
	Object.defineProperty(exports, "getFiscalPeriodsForQres", {
		enumerable: true,
		get: function() {
			return prior_year_data_utils_1.getFiscalPeriodsForQres;
		}
	});
	Object.defineProperty(exports, "getFiscalPeriodsForRevenues", {
		enumerable: true,
		get: function() {
			return prior_year_data_utils_1.getFiscalPeriodsForRevenues;
		}
	});
	var rd_project_category_utils_1 = require_rd_project_category_utils();
	Object.defineProperty(exports, "calculateRdProjectCategory", {
		enumerable: true,
		get: function() {
			return rd_project_category_utils_1.calculateRdProjectCategory;
		}
	});
	var injector_1 = require_injector();
	Object.defineProperty(exports, "Injector", {
		enumerable: true,
		get: function() {
			return injector_1.Injector;
		}
	});
	var standard_use_case_1 = require_standard_use_case();
	Object.defineProperty(exports, "StandardUseCase", {
		enumerable: true,
		get: function() {
			return standard_use_case_1.StandardUseCase;
		}
	});
	var command_use_case_1 = require_command_use_case();
	Object.defineProperty(exports, "CommandUseCase", {
		enumerable: true,
		get: function() {
			return command_use_case_1.CommandUseCase;
		}
	});
	var query_use_case_1 = require_query_use_case();
	Object.defineProperty(exports, "QueryUseCase", {
		enumerable: true,
		get: function() {
			return query_use_case_1.QueryUseCase;
		}
	});
	var random_1 = require_random();
	Object.defineProperty(exports, "Random", {
		enumerable: true,
		get: function() {
			return random_1.Random;
		}
	});
	var stack_1 = require_stack();
	Object.defineProperty(exports, "trackStackDepth", {
		enumerable: true,
		get: function() {
			return stack_1.trackStackDepth;
		}
	});
	var rd_project_eligibility_1 = require_rd_project_eligibility();
	Object.defineProperty(exports, "determineRdProjectEligibility", {
		enumerable: true,
		get: function() {
			return rd_project_eligibility_1.determineRdProjectEligibility;
		}
	});
	Object.defineProperty(exports, "RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING", {
		enumerable: true,
		get: function() {
			return rd_project_eligibility_1.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING;
		}
	});
	var name_parser_1 = require_name_parser();
	Object.defineProperty(exports, "isSurnameParticle", {
		enumerable: true,
		get: function() {
			return name_parser_1.isSurnameParticle;
		}
	});
	Object.defineProperty(exports, "parsePersonName", {
		enumerable: true,
		get: function() {
			return name_parser_1.parsePersonName;
		}
	});
	var jaro_winkler_1 = require_jaro_winkler();
	Object.defineProperty(exports, "jaroWinklerSimilarity", {
		enumerable: true,
		get: function() {
			return jaro_winkler_1.jaroWinklerSimilarity;
		}
	});
	var contributor_matcher_1 = require_contributor_matcher();
	Object.defineProperty(exports, "DEFAULT_FUZZY_MATCH_THRESHOLD", {
		enumerable: true,
		get: function() {
			return contributor_matcher_1.DEFAULT_FUZZY_MATCH_THRESHOLD;
		}
	});
	Object.defineProperty(exports, "buildContributorMatchIndex", {
		enumerable: true,
		get: function() {
			return contributor_matcher_1.buildContributorMatchIndex;
		}
	});
	Object.defineProperty(exports, "findBestContributorMatch", {
		enumerable: true,
		get: function() {
			return contributor_matcher_1.findBestContributorMatch;
		}
	});
})))();
var monthOptions = Object.entries(import_lib.DateMonth).filter(([key]) => isNaN(Number(key))).map(([key, value]) => ({
	label: (0, import_lib.capitalCase)(key),
	value: value.toString()
}));
var possibleMonthDateOptions = Array.from({ length: 31 }, (_, i) => i + 1).map((day) => ({
	value: day.toString(),
	label: day.toString()
}));
var getMonthDateOptions = (month) => month !== null && month !== void 0 && month in import_lib.LAST_MONTH_DATE_DICT ? possibleMonthDateOptions.slice(0, Number.parseInt(import_lib.LAST_MONTH_DATE_DICT[month], 10)) : possibleMonthDateOptions;
//#endregion
//#region src/common/utils/overflow.utils.ts
var Overflow = {
	auto: "overflow-auto",
	hidden: "overflow-hidden",
	clip: "overflow-clip",
	visible: "overflow-visible",
	scroll: "overflow-scroll",
	"x-auto": "overflow-x-auto",
	"y-auto": "overflow-y-auto",
	"x-hidden": "overflow-x-hidden",
	"y-hidden": "overflow-y-hidden",
	"x-clip": "overflow-x-clip",
	"y-clip": "overflow-y-clip",
	"x-visible": "overflow-x-visible",
	"y-visible": "overflow-y-visible",
	"x-scroll": "overflow-x-scroll",
	"y-scroll": "overflow-y-scroll"
};
var getOverflow = (overflow) => Overflow[overflow];
//#endregion
//#region src/common/utils/borderRadius.utils.ts
var BorderRadius = {
	none: "rounded-none",
	sm: "rounded-sm",
	base: "rounded",
	md: "rounded-md",
	lg: "rounded-lg",
	full: "rounded-full"
};
var getBorderRadius = (borderRadius) => BorderRadius[borderRadius];
//#endregion
//#region src/common/utils/whiteSpace.utils.ts
var WHITE_SPACE = {
	inherit: "",
	normal: "whitespace-normal",
	nowrap: "whitespace-nowrap",
	pre: "whitespace-pre",
	"pre-line": "whitespace-pre-line",
	"pre-wrap": "whitespace-pre-wrap",
	"break-spaces": "whitespace-break-spaces"
};
var getWhiteSpace = (whiteSpace) => WHITE_SPACE[whiteSpace];
//#endregion
//#region src/common/utils/string.utils.ts
var getInitials = (name, { maxInitials }) => name.split(/\s/).map((part, _, parts) => part.substring(0, parts.length > 1 ? 1 : maxInitials)).filter((value) => !!value).slice(0, maxInitials).join("").toUpperCase();
//#endregion
//#region src/common/utils/textTransform.utils.ts
var TEXT_TRANSFORM = {
	inherit: "",
	normal: "normal-case",
	uppercase: "uppercase",
	lowercase: "lowercase",
	capitalize: "capitalize"
};
var getTextTransform = (textTransform) => TEXT_TRANSFORM[textTransform];
//#endregion
//#region src/common/utils/textOverflow.utils.ts
var TEXT_OVERFLOW = {
	inherit: "",
	/** `truncate` class sets the following CSS:
	* overflow: hidden;
	* text-overflow: ellipsis;
	* white-space: nowrap;
	**/
	truncate: "truncate",
	ellipsis: "text-ellipsis",
	clip: "text-clip"
};
var getTextOverflow = (textOverflow) => TEXT_OVERFLOW[textOverflow];
//#endregion
//#region src/common/utils/textDecoration.utils.ts
var TEXT_DECORATION = {
	inherit: "",
	underline: "underline",
	"line-through": "line-through",
	none: "no-underline"
};
var getTextDecoration = (textDecoration) => TEXT_DECORATION[textDecoration];
//#endregion
//#region src/common/hooks/useEventListener.ts
var useEventListener = ({ element, eventName, handler }) => {
	useLayoutEffect(() => {
		const htmlElement = typeof element === "function" ? element() : element || window;
		htmlElement?.addEventListener(eventName, handler);
		return () => {
			htmlElement?.removeEventListener(eventName, handler);
		};
	}, [
		element,
		eventName,
		handler
	]);
};
//#endregion
//#region src/common/hooks/useScrollbarWidth.ts
var useScrollbarWidth = () => React.useMemo(() => {
	const scrollDiv = document.createElement("div");
	scrollDiv.setAttribute("style", "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;");
	document.body.appendChild(scrollDiv);
	const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	document.body.removeChild(scrollDiv);
	return scrollbarWidth;
}, []);
//#endregion
//#region src/common/hooks/useElementSize.ts
var useElementSize = () => {
	const [ref, setRef] = useState(null);
	const [size, setSize] = useState({
		width: 0,
		height: 0
	});
	const handleSize = useCallback(() => {
		setSize({
			width: ref?.offsetWidth || window.innerWidth,
			height: ref?.offsetHeight || window.innerHeight
		});
	}, [ref?.offsetHeight, ref?.offsetWidth]);
	useEventListener({
		eventName: "resize",
		handler: handleSize
	});
	useLayoutEffect(() => {
		handleSize();
	}, [handleSize]);
	return [setRef, size];
};
//#endregion
//#region src/common/hooks/useSelectable.ts
var useSelectable = (initialState) => {
	const [selectedItem, setSelectedItem] = useState(initialState);
	const onSelect = (newSelectedItem) => {
		setSelectedItem(newSelectedItem);
	};
	return {
		onSelect,
		selectedItem,
		setSelectedItem
	};
};
//#endregion
//#region src/common/hooks/useHoverIntent.ts
var useHoverIntent = ({ defaultTimeout } = { defaultTimeout: 350 }) => {
	const hoverTimeoutRef = useRef(null);
	const onMouseEnterHoverIntent = (onMouseEnter, msTimeout) => (event) => {
		if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
		hoverTimeoutRef.current = setTimeout(() => {
			onMouseEnter(event);
		}, msTimeout ?? defaultTimeout);
	};
	const onMouseLeaveHoverIntent = (onMouseLeave) => (event) => {
		onMouseLeave?.(event);
		if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
	};
	return {
		onMouseEnterHoverIntent,
		onMouseLeaveHoverIntent
	};
};
//#endregion
//#region src/common/hooks/useStepper.ts
var useStepper = ({ onStepsComplete, steps }) => {
	const [currentStep, setCurrentStep] = useState(0);
	const hasPreviousStep = currentStep - 1 >= 0;
	const hasNextStep = currentStep + 1 < steps;
	useEffect(() => {
		if (currentStep === steps - 1) onStepsComplete?.();
	}, [
		currentStep,
		onStepsComplete,
		steps
	]);
	const nextStep = () => {
		if (hasNextStep) setCurrentStep((current) => current + 1);
	};
	const prevStep = () => {
		if (hasPreviousStep) setCurrentStep((current) => current - 1);
	};
	return {
		currentStep,
		hasNextStep,
		hasPreviousStep,
		nextStep,
		prevStep,
		setCurrentStep
	};
};
//#endregion
//#region src/common/hooks/useSympatheticHighlight.tsx
var SympatheticHighlightOrchestrator = class {
	elements;
	constructor() {
		this.elements = {};
		this.highlight = this.highlight.bind(this);
		this.removeHighlight = this.removeHighlight.bind(this);
	}
	subscribe(elementId, cb) {
		this.elements = {
			...this.elements,
			[elementId]: {
				highlight: () => {
					cb.onHighlight();
				},
				removeHighlight: () => {
					cb.onRemoveHighlight();
				}
			}
		};
	}
	unsubscribe(elementId) {
		const { [elementId]: _, ...restElements } = this.elements;
		this.elements = restElements;
	}
	highlight(elementId) {
		this.elements[elementId]?.highlight();
	}
	removeHighlight(elementId) {
		this.elements[elementId]?.removeHighlight();
	}
};
var SympatheticHighlightContext = createContext(null);
var useSympatheticHighlightContext = () => {
	const sympatheticHighlightOrchestrator = useContext(SympatheticHighlightContext);
	if (!sympatheticHighlightOrchestrator) throw new Error("Sympathetic Highlight context cannot be used outside a SympatheticHighlightProvider");
	return sympatheticHighlightOrchestrator;
};
var useSympatheticHighlight = (elementId) => {
	const orchestrator = useSympatheticHighlightContext();
	const [isSympatheticHighlighted, setIsSympatheticHighlighted] = useState(false);
	useEffect(() => {
		orchestrator.subscribe(elementId, {
			onHighlight: () => {
				setIsSympatheticHighlighted(true);
			},
			onRemoveHighlight: () => {
				setIsSympatheticHighlighted(false);
			}
		});
		return () => {
			orchestrator.unsubscribe(elementId);
			setIsSympatheticHighlighted(false);
		};
	}, [elementId, orchestrator]);
	return {
		highlight: orchestrator.highlight,
		isSympatheticHighlighted,
		removeHighlight: orchestrator.removeHighlight
	};
};
var SympatheticHighlightProvider = ({ children }) => {
	const orchestrator = new SympatheticHighlightOrchestrator();
	return /* @__PURE__ */ React.createElement(SympatheticHighlightContext.Provider, { value: orchestrator }, children);
};
//#endregion
//#region src/common/hooks/useScrollableElement.ts
var useScrollableElement = () => {
	const componentRef = useRef();
	const [hasScroll, setHasScroll] = useState(false);
	useEffect(() => {
		if (!componentRef.current) return;
		const resizeObserver = new ResizeObserver(() => {
			const isComponentScrollable = componentRef.current && componentRef.current.clientHeight < componentRef.current.scrollHeight;
			if (!hasScroll && isComponentScrollable) setHasScroll(true);
			else if (hasScroll && !isComponentScrollable) setHasScroll(false);
		});
		resizeObserver.observe(componentRef.current);
		return () => resizeObserver.disconnect();
	}, [hasScroll]);
	return {
		componentRef,
		hasScroll
	};
};
//#endregion
//#region src/common/types/array.utils.ts
var pipe = (...fns) => (...x) => fns.reduce((v, f) => f(...v), x);
//#endregion
//#region ../../node_modules/classnames/index.js
var require_classnames = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
	*/
	(function() {
		"use strict";
		var hasOwn = {}.hasOwnProperty;
		function classNames() {
			var classes = [];
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
				var argType = typeof arg;
				if (argType === "string" || argType === "number") classes.push(arg);
				else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) classes.push(inner);
					}
				} else if (argType === "object") {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
					} else classes.push(arg.toString());
				}
			}
			return classes.join(" ");
		}
		if (typeof module !== "undefined" && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (typeof define === "function" && typeof define.amd === "object" && define.amd) define("classnames", [], function() {
			return classNames;
		});
		else window.classNames = classNames;
	})();
}));
//#endregion
//#region builtin:esm-external-require-react
var require_builtin_esm_external_require_react = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = Object.prototype.hasOwnProperty.call(m$3, "module.exports") ? m$3["module.exports"] : { ...m$3 };
}));
//#endregion
//#region ../../node_modules/tailwind-styled-components/dist/domElements.js
var require_domElements = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = [
		"a",
		"abbr",
		"address",
		"area",
		"article",
		"aside",
		"audio",
		"b",
		"base",
		"bdi",
		"bdo",
		"big",
		"blockquote",
		"body",
		"br",
		"button",
		"canvas",
		"caption",
		"cite",
		"code",
		"col",
		"colgroup",
		"data",
		"datalist",
		"dd",
		"del",
		"details",
		"dfn",
		"dialog",
		"div",
		"dl",
		"dt",
		"em",
		"embed",
		"fieldset",
		"figcaption",
		"figure",
		"footer",
		"form",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"head",
		"header",
		"hgroup",
		"hr",
		"html",
		"i",
		"iframe",
		"img",
		"input",
		"ins",
		"kbd",
		"keygen",
		"label",
		"legend",
		"li",
		"link",
		"main",
		"map",
		"mark",
		"menu",
		"menuitem",
		"meta",
		"meter",
		"nav",
		"noscript",
		"object",
		"ol",
		"optgroup",
		"option",
		"output",
		"p",
		"param",
		"picture",
		"pre",
		"progress",
		"q",
		"rp",
		"rt",
		"ruby",
		"s",
		"samp",
		"script",
		"section",
		"select",
		"small",
		"source",
		"span",
		"strong",
		"style",
		"sub",
		"summary",
		"sup",
		"table",
		"tbody",
		"td",
		"textarea",
		"tfoot",
		"th",
		"thead",
		"time",
		"title",
		"tr",
		"track",
		"u",
		"ul",
		"var",
		"video",
		"wbr",
		"circle",
		"clipPath",
		"defs",
		"ellipse",
		"foreignObject",
		"g",
		"image",
		"line",
		"linearGradient",
		"marker",
		"mask",
		"path",
		"pattern",
		"polygon",
		"polyline",
		"radialGradient",
		"rect",
		"stop",
		"svg",
		"text",
		"tspan"
	];
}));
//#endregion
//#region ../../node_modules/tailwind-merge/dist/tailwind-merge.cjs.production.min.js
var require_tailwind_merge_cjs_production_min = /* @__PURE__ */ __commonJSMin(((exports) => {
	function r() {
		for (var r, o, t = 0, n = ""; t < arguments.length;) (r = arguments[t++]) && (o = e(r)) && (n && (n += " "), n += o);
		return n;
	}
	function e(r) {
		if ("string" == typeof r) return r;
		for (var o, t = "", n = 0; n < r.length; n++) r[n] && (o = e(r[n])) && (t && (t += " "), t += o);
		return t;
	}
	Object.defineProperty(exports, "__esModule", { value: !0 });
	var o = "-";
	function t(r) {
		var e = function(r) {
			var e = r.theme, o = r.prefix, t = {
				nextPart: /* @__PURE__ */ new Map(),
				validators: []
			};
			return function(r, e) {
				return e ? r.map((function(r) {
					return [r[0], r[1].map((function(r) {
						return "string" == typeof r ? e + r : "object" == typeof r ? Object.fromEntries(Object.entries(r).map((function(r) {
							return [e + r[0], r[1]];
						}))) : r;
					}))];
				})) : r;
			}(Object.entries(r.classGroups), o).forEach((function(r) {
				a(r[1], t, r[0], e);
			})), t;
		}(r), t = r.conflictingClassGroups, l = r.conflictingClassGroupModifiers, s = void 0 === l ? {} : l;
		return {
			getClassGroupId: function(r) {
				var t = r.split(o);
				return "" === t[0] && 1 !== t.length && t.shift(), n(t, e) || function(r) {
					if (i.test(r)) {
						var e = i.exec(r)[1], o = e?.substring(0, e.indexOf(":"));
						if (o) return "arbitrary.." + o;
					}
				}(r);
			},
			getConflictingClassGroupIds: function(r, e) {
				var o = t[r] || [];
				return e && s[r] ? [].concat(o, s[r]) : o;
			}
		};
	}
	function n(r, e) {
		if (0 === r.length) return e.classGroupId;
		var t = e.nextPart.get(r[0]), i = t ? n(r.slice(1), t) : void 0;
		if (i) return i;
		if (0 !== e.validators.length) {
			var a = r.join(o);
			return e.validators.find((function(r) {
				return (0, r.validator)(a);
			}))?.classGroupId;
		}
	}
	var i = /^\[(.+)\]$/;
	function a(r, e, o, t) {
		r.forEach((function(r) {
			if ("string" != typeof r) {
				if ("function" == typeof r) return r.isThemeGetter ? void a(r(t), e, o, t) : void e.validators.push({
					validator: r,
					classGroupId: o
				});
				Object.entries(r).forEach((function(r) {
					a(r[1], l(e, r[0]), o, t);
				}));
			} else ("" === r ? e : l(e, r)).classGroupId = o;
		}));
	}
	function l(r, e) {
		var t = r;
		return e.split(o).forEach((function(r) {
			t.nextPart.has(r) || t.nextPart.set(r, {
				nextPart: /* @__PURE__ */ new Map(),
				validators: []
			}), t = t.nextPart.get(r);
		})), t;
	}
	function s(r) {
		if (r < 1) return {
			get: function() {},
			set: function() {}
		};
		var e = 0, o = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
		function n(n, i) {
			o.set(n, i), ++e > r && (e = 0, t = o, o = /* @__PURE__ */ new Map());
		}
		return {
			get: function(r) {
				var e = o.get(r);
				return void 0 !== e ? e : void 0 !== (e = t.get(r)) ? (n(r, e), e) : void 0;
			},
			set: function(r, e) {
				o.has(r) ? o.set(r, e) : n(r, e);
			}
		};
	}
	var c = "!";
	function d(r) {
		var e = r.separator || ":", o = 1 === e.length, t = e[0], n = e.length;
		return function(r) {
			for (var i, a = [], l = 0, s = 0, d = 0; d < r.length; d++) {
				var u = r[d];
				if (0 === l) {
					if (u === t && (o || r.slice(d, d + n) === e)) {
						a.push(r.slice(s, d)), s = d + n;
						continue;
					}
					if ("/" === u) {
						i = d;
						continue;
					}
				}
				"[" === u ? l++ : "]" === u && l--;
			}
			var p = 0 === a.length ? r : r.substring(s), f = p.startsWith(c);
			return {
				modifiers: a,
				hasImportantModifier: f,
				baseClassName: f ? p.substring(1) : p,
				maybePostfixModifierPosition: i && i > s ? i - s : void 0
			};
		};
	}
	var u = /\s+/;
	function p() {
		for (var e = arguments.length, o = new Array(e), n = 0; n < e; n++) o[n] = arguments[n];
		var i, a, l, p = function(r) {
			var e = o[0];
			return i = function(r) {
				return {
					cache: s(r.cacheSize),
					splitModifiers: d(r),
					...t(r)
				};
			}(o.slice(1).reduce((function(r, e) {
				return e(r);
			}), e())), a = i.cache.get, l = i.cache.set, p = f, f(r);
		};
		function f(r) {
			var e = a(r);
			if (e) return e;
			var o = function(r, e) {
				var o = e.splitModifiers, t = e.getClassGroupId, n = e.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
				return r.trim().split(u).map((function(r) {
					var e = o(r), n = e.modifiers, i = e.hasImportantModifier, a = e.baseClassName, l = e.maybePostfixModifierPosition, s = t(l ? a.substring(0, l) : a), d = Boolean(l);
					if (!s) {
						if (!l) return {
							isTailwindClass: !1,
							originalClassName: r
						};
						if (!(s = t(a))) return {
							isTailwindClass: !1,
							originalClassName: r
						};
						d = !1;
					}
					var u = function(r) {
						if (r.length <= 1) return r;
						var e = [], o = [];
						return r.forEach((function(r) {
							"[" === r[0] ? (e.push.apply(e, o.sort().concat([r])), o = []) : o.push(r);
						})), e.push.apply(e, o.sort()), e;
					}(n).join(":");
					return {
						isTailwindClass: !0,
						modifierId: i ? u + c : u,
						classGroupId: s,
						originalClassName: r,
						hasPostfixModifier: d
					};
				})).reverse().filter((function(r) {
					if (!r.isTailwindClass) return !0;
					var e = r.modifierId, o = r.classGroupId, t = r.hasPostfixModifier, a = e + o;
					return !i.has(a) && (i.add(a), n(o, t).forEach((function(r) {
						return i.add(e + r);
					})), !0);
				})).reverse().map((function(r) {
					return r.originalClassName;
				})).join(" ");
			}(r, i);
			return l(r, o), o;
		}
		return function() {
			return p(r.apply(null, arguments));
		};
	}
	function f(r) {
		var e = function(e) {
			return e[r] || [];
		};
		return e.isThemeGetter = !0, e;
	}
	var b = /^\[(?:([a-z-]+):)?(.+)\]$/i;
	var m = /^\d+\/\d+$/;
	var g = /* @__PURE__ */ new Set([
		"px",
		"full",
		"screen"
	]);
	var h = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
	var v = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
	var y = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
	function x(r) {
		return M(r) || g.has(r) || m.test(r) || w(r);
	}
	function w(r) {
		return T(r, "length", O);
	}
	function k(r) {
		return T(r, "size", E);
	}
	function z(r) {
		return T(r, "position", E);
	}
	function C(r) {
		return T(r, "url", _);
	}
	function j(r) {
		return T(r, "number", M);
	}
	function M(r) {
		return !Number.isNaN(Number(r));
	}
	function G(r) {
		return r.endsWith("%") && M(r.slice(0, -1));
	}
	function P(r) {
		return W(r) || T(r, "number", W);
	}
	function I(r) {
		return b.test(r);
	}
	function A() {
		return !0;
	}
	function N(r) {
		return h.test(r);
	}
	function S(r) {
		return T(r, "", $);
	}
	function T(r, e, o) {
		var t = b.exec(r);
		return !!t && (t[1] ? t[1] === e : o(t[2]));
	}
	function O(r) {
		return v.test(r);
	}
	function E() {
		return !1;
	}
	function _(r) {
		return r.startsWith("url(");
	}
	function W(r) {
		return Number.isInteger(Number(r));
	}
	function $(r) {
		return y.test(r);
	}
	var R = {
		__proto__: null,
		isAny: A,
		isArbitraryLength: w,
		isArbitraryNumber: j,
		isArbitraryPosition: z,
		isArbitraryShadow: S,
		isArbitrarySize: k,
		isArbitraryUrl: C,
		isArbitraryValue: I,
		isArbitraryWeight: j,
		isInteger: P,
		isLength: x,
		isNumber: M,
		isPercent: G,
		isTshirtSize: N
	};
	function q() {
		var r = f("colors"), e = f("spacing"), o = f("blur"), t = f("brightness"), n = f("borderColor"), i = f("borderRadius"), a = f("borderSpacing"), l = f("borderWidth"), s = f("contrast"), c = f("grayscale"), d = f("hueRotate"), u = f("invert"), p = f("gap"), b = f("gradientColorStops"), m = f("gradientColorStopPositions"), g = f("inset"), h = f("margin"), v = f("opacity"), y = f("padding"), T = f("saturate"), O = f("scale"), E = f("sepia"), _ = f("skew"), W = f("space"), $ = f("translate"), R = function() {
			return [
				"auto",
				I,
				e
			];
		}, q = function() {
			return [I, e];
		}, L = function() {
			return ["", x];
		}, B = function() {
			return [
				"auto",
				M,
				I
			];
		}, D = function() {
			return [
				"",
				"0",
				I
			];
		}, J = function() {
			return [M, j];
		}, U = function() {
			return [M, I];
		};
		return {
			cacheSize: 500,
			theme: {
				colors: [A],
				spacing: [x],
				blur: [
					"none",
					"",
					N,
					I
				],
				brightness: J(),
				borderColor: [r],
				borderRadius: [
					"none",
					"",
					"full",
					N,
					I
				],
				borderSpacing: q(),
				borderWidth: L(),
				contrast: J(),
				grayscale: D(),
				hueRotate: U(),
				invert: D(),
				gap: q(),
				gradientColorStops: [r],
				gradientColorStopPositions: [G, w],
				inset: R(),
				margin: R(),
				opacity: J(),
				padding: q(),
				saturate: J(),
				scale: J(),
				sepia: D(),
				skew: U(),
				space: q(),
				translate: q()
			},
			classGroups: {
				aspect: [{ aspect: [
					"auto",
					"square",
					"video",
					I
				] }],
				container: ["container"],
				columns: [{ columns: [N] }],
				"break-after": [{ "break-after": [
					"auto",
					"avoid",
					"all",
					"avoid-page",
					"page",
					"left",
					"right",
					"column"
				] }],
				"break-before": [{ "break-before": [
					"auto",
					"avoid",
					"all",
					"avoid-page",
					"page",
					"left",
					"right",
					"column"
				] }],
				"break-inside": [{ "break-inside": [
					"auto",
					"avoid",
					"avoid-page",
					"avoid-column"
				] }],
				"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
				box: [{ box: ["border", "content"] }],
				display: [
					"block",
					"inline-block",
					"inline",
					"flex",
					"inline-flex",
					"table",
					"inline-table",
					"table-caption",
					"table-cell",
					"table-column",
					"table-column-group",
					"table-footer-group",
					"table-header-group",
					"table-row-group",
					"table-row",
					"flow-root",
					"grid",
					"inline-grid",
					"contents",
					"list-item",
					"hidden"
				],
				float: [{ float: [
					"right",
					"left",
					"none"
				] }],
				clear: [{ clear: [
					"left",
					"right",
					"both",
					"none"
				] }],
				isolation: ["isolate", "isolation-auto"],
				"object-fit": [{ object: [
					"contain",
					"cover",
					"fill",
					"none",
					"scale-down"
				] }],
				"object-position": [{ object: [].concat([
					"bottom",
					"center",
					"left",
					"left-bottom",
					"left-top",
					"right",
					"right-bottom",
					"right-top",
					"top"
				], [I]) }],
				overflow: [{ overflow: [
					"auto",
					"hidden",
					"clip",
					"visible",
					"scroll"
				] }],
				"overflow-x": [{ "overflow-x": [
					"auto",
					"hidden",
					"clip",
					"visible",
					"scroll"
				] }],
				"overflow-y": [{ "overflow-y": [
					"auto",
					"hidden",
					"clip",
					"visible",
					"scroll"
				] }],
				overscroll: [{ overscroll: [
					"auto",
					"contain",
					"none"
				] }],
				"overscroll-x": [{ "overscroll-x": [
					"auto",
					"contain",
					"none"
				] }],
				"overscroll-y": [{ "overscroll-y": [
					"auto",
					"contain",
					"none"
				] }],
				position: [
					"static",
					"fixed",
					"absolute",
					"relative",
					"sticky"
				],
				inset: [{ inset: [g] }],
				"inset-x": [{ "inset-x": [g] }],
				"inset-y": [{ "inset-y": [g] }],
				start: [{ start: [g] }],
				end: [{ end: [g] }],
				top: [{ top: [g] }],
				right: [{ right: [g] }],
				bottom: [{ bottom: [g] }],
				left: [{ left: [g] }],
				visibility: [
					"visible",
					"invisible",
					"collapse"
				],
				z: [{ z: ["auto", P] }],
				basis: [{ basis: R() }],
				"flex-direction": [{ flex: [
					"row",
					"row-reverse",
					"col",
					"col-reverse"
				] }],
				"flex-wrap": [{ flex: [
					"wrap",
					"wrap-reverse",
					"nowrap"
				] }],
				flex: [{ flex: [
					"1",
					"auto",
					"initial",
					"none",
					I
				] }],
				grow: [{ grow: D() }],
				shrink: [{ shrink: D() }],
				order: [{ order: [
					"first",
					"last",
					"none",
					P
				] }],
				"grid-cols": [{ "grid-cols": [A] }],
				"col-start-end": [{ col: [
					"auto",
					{ span: ["full", P] },
					I
				] }],
				"col-start": [{ "col-start": B() }],
				"col-end": [{ "col-end": B() }],
				"grid-rows": [{ "grid-rows": [A] }],
				"row-start-end": [{ row: [
					"auto",
					{ span: [P] },
					I
				] }],
				"row-start": [{ "row-start": B() }],
				"row-end": [{ "row-end": B() }],
				"grid-flow": [{ "grid-flow": [
					"row",
					"col",
					"dense",
					"row-dense",
					"col-dense"
				] }],
				"auto-cols": [{ "auto-cols": [
					"auto",
					"min",
					"max",
					"fr",
					I
				] }],
				"auto-rows": [{ "auto-rows": [
					"auto",
					"min",
					"max",
					"fr",
					I
				] }],
				gap: [{ gap: [p] }],
				"gap-x": [{ "gap-x": [p] }],
				"gap-y": [{ "gap-y": [p] }],
				"justify-content": [{ justify: ["normal"].concat([
					"start",
					"end",
					"center",
					"between",
					"around",
					"evenly",
					"stretch"
				]) }],
				"justify-items": [{ "justify-items": [
					"start",
					"end",
					"center",
					"stretch"
				] }],
				"justify-self": [{ "justify-self": [
					"auto",
					"start",
					"end",
					"center",
					"stretch"
				] }],
				"align-content": [{ content: ["normal"].concat([
					"start",
					"end",
					"center",
					"between",
					"around",
					"evenly",
					"stretch"
				], ["baseline"]) }],
				"align-items": [{ items: [
					"start",
					"end",
					"center",
					"baseline",
					"stretch"
				] }],
				"align-self": [{ self: [
					"auto",
					"start",
					"end",
					"center",
					"stretch",
					"baseline"
				] }],
				"place-content": [{ "place-content": [].concat([
					"start",
					"end",
					"center",
					"between",
					"around",
					"evenly",
					"stretch"
				], ["baseline"]) }],
				"place-items": [{ "place-items": [
					"start",
					"end",
					"center",
					"baseline",
					"stretch"
				] }],
				"place-self": [{ "place-self": [
					"auto",
					"start",
					"end",
					"center",
					"stretch"
				] }],
				p: [{ p: [y] }],
				px: [{ px: [y] }],
				py: [{ py: [y] }],
				ps: [{ ps: [y] }],
				pe: [{ pe: [y] }],
				pt: [{ pt: [y] }],
				pr: [{ pr: [y] }],
				pb: [{ pb: [y] }],
				pl: [{ pl: [y] }],
				m: [{ m: [h] }],
				mx: [{ mx: [h] }],
				my: [{ my: [h] }],
				ms: [{ ms: [h] }],
				me: [{ me: [h] }],
				mt: [{ mt: [h] }],
				mr: [{ mr: [h] }],
				mb: [{ mb: [h] }],
				ml: [{ ml: [h] }],
				"space-x": [{ "space-x": [W] }],
				"space-x-reverse": ["space-x-reverse"],
				"space-y": [{ "space-y": [W] }],
				"space-y-reverse": ["space-y-reverse"],
				w: [{ w: [
					"auto",
					"min",
					"max",
					"fit",
					I,
					e
				] }],
				"min-w": [{ "min-w": [
					"min",
					"max",
					"fit",
					I,
					x
				] }],
				"max-w": [{ "max-w": [
					"0",
					"none",
					"full",
					"min",
					"max",
					"fit",
					"prose",
					{ screen: [N] },
					N,
					I
				] }],
				h: [{ h: [
					I,
					e,
					"auto",
					"min",
					"max",
					"fit"
				] }],
				"min-h": [{ "min-h": [
					"min",
					"max",
					"fit",
					I,
					x
				] }],
				"max-h": [{ "max-h": [
					I,
					e,
					"min",
					"max",
					"fit"
				] }],
				"font-size": [{ text: [
					"base",
					N,
					w
				] }],
				"font-smoothing": ["antialiased", "subpixel-antialiased"],
				"font-style": ["italic", "not-italic"],
				"font-weight": [{ font: [
					"thin",
					"extralight",
					"light",
					"normal",
					"medium",
					"semibold",
					"bold",
					"extrabold",
					"black",
					j
				] }],
				"font-family": [{ font: [A] }],
				"fvn-normal": ["normal-nums"],
				"fvn-ordinal": ["ordinal"],
				"fvn-slashed-zero": ["slashed-zero"],
				"fvn-figure": ["lining-nums", "oldstyle-nums"],
				"fvn-spacing": ["proportional-nums", "tabular-nums"],
				"fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
				tracking: [{ tracking: [
					"tighter",
					"tight",
					"normal",
					"wide",
					"wider",
					"widest",
					I
				] }],
				"line-clamp": [{ "line-clamp": [
					"none",
					M,
					j
				] }],
				leading: [{ leading: [
					"none",
					"tight",
					"snug",
					"normal",
					"relaxed",
					"loose",
					I,
					x
				] }],
				"list-image": [{ "list-image": ["none", I] }],
				"list-style-type": [{ list: [
					"none",
					"disc",
					"decimal",
					I
				] }],
				"list-style-position": [{ list: ["inside", "outside"] }],
				"placeholder-color": [{ placeholder: [r] }],
				"placeholder-opacity": [{ "placeholder-opacity": [v] }],
				"text-alignment": [{ text: [
					"left",
					"center",
					"right",
					"justify",
					"start",
					"end"
				] }],
				"text-color": [{ text: [r] }],
				"text-opacity": [{ "text-opacity": [v] }],
				"text-decoration": [
					"underline",
					"overline",
					"line-through",
					"no-underline"
				],
				"text-decoration-style": [{ decoration: [].concat([
					"solid",
					"dashed",
					"dotted",
					"double",
					"none"
				], ["wavy"]) }],
				"text-decoration-thickness": [{ decoration: [
					"auto",
					"from-font",
					x
				] }],
				"underline-offset": [{ "underline-offset": [
					"auto",
					I,
					x
				] }],
				"text-decoration-color": [{ decoration: [r] }],
				"text-transform": [
					"uppercase",
					"lowercase",
					"capitalize",
					"normal-case"
				],
				"text-overflow": [
					"truncate",
					"text-ellipsis",
					"text-clip"
				],
				indent: [{ indent: q() }],
				"vertical-align": [{ align: [
					"baseline",
					"top",
					"middle",
					"bottom",
					"text-top",
					"text-bottom",
					"sub",
					"super",
					I
				] }],
				whitespace: [{ whitespace: [
					"normal",
					"nowrap",
					"pre",
					"pre-line",
					"pre-wrap",
					"break-spaces"
				] }],
				break: [{ break: [
					"normal",
					"words",
					"all",
					"keep"
				] }],
				hyphens: [{ hyphens: [
					"none",
					"manual",
					"auto"
				] }],
				content: [{ content: ["none", I] }],
				"bg-attachment": [{ bg: [
					"fixed",
					"local",
					"scroll"
				] }],
				"bg-clip": [{ "bg-clip": [
					"border",
					"padding",
					"content",
					"text"
				] }],
				"bg-opacity": [{ "bg-opacity": [v] }],
				"bg-origin": [{ "bg-origin": [
					"border",
					"padding",
					"content"
				] }],
				"bg-position": [{ bg: [].concat([
					"bottom",
					"center",
					"left",
					"left-bottom",
					"left-top",
					"right",
					"right-bottom",
					"right-top",
					"top"
				], [z]) }],
				"bg-repeat": [{ bg: ["no-repeat", { repeat: [
					"",
					"x",
					"y",
					"round",
					"space"
				] }] }],
				"bg-size": [{ bg: [
					"auto",
					"cover",
					"contain",
					k
				] }],
				"bg-image": [{ bg: [
					"none",
					{ "gradient-to": [
						"t",
						"tr",
						"r",
						"br",
						"b",
						"bl",
						"l",
						"tl"
					] },
					C
				] }],
				"bg-color": [{ bg: [r] }],
				"gradient-from-pos": [{ from: [m] }],
				"gradient-via-pos": [{ via: [m] }],
				"gradient-to-pos": [{ to: [m] }],
				"gradient-from": [{ from: [b] }],
				"gradient-via": [{ via: [b] }],
				"gradient-to": [{ to: [b] }],
				rounded: [{ rounded: [i] }],
				"rounded-s": [{ "rounded-s": [i] }],
				"rounded-e": [{ "rounded-e": [i] }],
				"rounded-t": [{ "rounded-t": [i] }],
				"rounded-r": [{ "rounded-r": [i] }],
				"rounded-b": [{ "rounded-b": [i] }],
				"rounded-l": [{ "rounded-l": [i] }],
				"rounded-ss": [{ "rounded-ss": [i] }],
				"rounded-se": [{ "rounded-se": [i] }],
				"rounded-ee": [{ "rounded-ee": [i] }],
				"rounded-es": [{ "rounded-es": [i] }],
				"rounded-tl": [{ "rounded-tl": [i] }],
				"rounded-tr": [{ "rounded-tr": [i] }],
				"rounded-br": [{ "rounded-br": [i] }],
				"rounded-bl": [{ "rounded-bl": [i] }],
				"border-w": [{ border: [l] }],
				"border-w-x": [{ "border-x": [l] }],
				"border-w-y": [{ "border-y": [l] }],
				"border-w-s": [{ "border-s": [l] }],
				"border-w-e": [{ "border-e": [l] }],
				"border-w-t": [{ "border-t": [l] }],
				"border-w-r": [{ "border-r": [l] }],
				"border-w-b": [{ "border-b": [l] }],
				"border-w-l": [{ "border-l": [l] }],
				"border-opacity": [{ "border-opacity": [v] }],
				"border-style": [{ border: [].concat([
					"solid",
					"dashed",
					"dotted",
					"double",
					"none"
				], ["hidden"]) }],
				"divide-x": [{ "divide-x": [l] }],
				"divide-x-reverse": ["divide-x-reverse"],
				"divide-y": [{ "divide-y": [l] }],
				"divide-y-reverse": ["divide-y-reverse"],
				"divide-opacity": [{ "divide-opacity": [v] }],
				"divide-style": [{ divide: [
					"solid",
					"dashed",
					"dotted",
					"double",
					"none"
				] }],
				"border-color": [{ border: [n] }],
				"border-color-x": [{ "border-x": [n] }],
				"border-color-y": [{ "border-y": [n] }],
				"border-color-t": [{ "border-t": [n] }],
				"border-color-r": [{ "border-r": [n] }],
				"border-color-b": [{ "border-b": [n] }],
				"border-color-l": [{ "border-l": [n] }],
				"divide-color": [{ divide: [n] }],
				"outline-style": [{ outline: [""].concat([
					"solid",
					"dashed",
					"dotted",
					"double",
					"none"
				]) }],
				"outline-offset": [{ "outline-offset": [I, x] }],
				"outline-w": [{ outline: [x] }],
				"outline-color": [{ outline: [r] }],
				"ring-w": [{ ring: L() }],
				"ring-w-inset": ["ring-inset"],
				"ring-color": [{ ring: [r] }],
				"ring-opacity": [{ "ring-opacity": [v] }],
				"ring-offset-w": [{ "ring-offset": [x] }],
				"ring-offset-color": [{ "ring-offset": [r] }],
				shadow: [{ shadow: [
					"",
					"inner",
					"none",
					N,
					S
				] }],
				"shadow-color": [{ shadow: [A] }],
				opacity: [{ opacity: [v] }],
				"mix-blend": [{ "mix-blend": [
					"normal",
					"multiply",
					"screen",
					"overlay",
					"darken",
					"lighten",
					"color-dodge",
					"color-burn",
					"hard-light",
					"soft-light",
					"difference",
					"exclusion",
					"hue",
					"saturation",
					"color",
					"luminosity",
					"plus-lighter"
				] }],
				"bg-blend": [{ "bg-blend": [
					"normal",
					"multiply",
					"screen",
					"overlay",
					"darken",
					"lighten",
					"color-dodge",
					"color-burn",
					"hard-light",
					"soft-light",
					"difference",
					"exclusion",
					"hue",
					"saturation",
					"color",
					"luminosity",
					"plus-lighter"
				] }],
				filter: [{ filter: ["", "none"] }],
				blur: [{ blur: [o] }],
				brightness: [{ brightness: [t] }],
				contrast: [{ contrast: [s] }],
				"drop-shadow": [{ "drop-shadow": [
					"",
					"none",
					N,
					I
				] }],
				grayscale: [{ grayscale: [c] }],
				"hue-rotate": [{ "hue-rotate": [d] }],
				invert: [{ invert: [u] }],
				saturate: [{ saturate: [T] }],
				sepia: [{ sepia: [E] }],
				"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
				"backdrop-blur": [{ "backdrop-blur": [o] }],
				"backdrop-brightness": [{ "backdrop-brightness": [t] }],
				"backdrop-contrast": [{ "backdrop-contrast": [s] }],
				"backdrop-grayscale": [{ "backdrop-grayscale": [c] }],
				"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [d] }],
				"backdrop-invert": [{ "backdrop-invert": [u] }],
				"backdrop-opacity": [{ "backdrop-opacity": [v] }],
				"backdrop-saturate": [{ "backdrop-saturate": [T] }],
				"backdrop-sepia": [{ "backdrop-sepia": [E] }],
				"border-collapse": [{ border: ["collapse", "separate"] }],
				"border-spacing": [{ "border-spacing": [a] }],
				"border-spacing-x": [{ "border-spacing-x": [a] }],
				"border-spacing-y": [{ "border-spacing-y": [a] }],
				"table-layout": [{ table: ["auto", "fixed"] }],
				caption: [{ caption: ["top", "bottom"] }],
				transition: [{ transition: [
					"none",
					"all",
					"",
					"colors",
					"opacity",
					"shadow",
					"transform",
					I
				] }],
				duration: [{ duration: U() }],
				ease: [{ ease: [
					"linear",
					"in",
					"out",
					"in-out",
					I
				] }],
				delay: [{ delay: U() }],
				animate: [{ animate: [
					"none",
					"spin",
					"ping",
					"pulse",
					"bounce",
					I
				] }],
				transform: [{ transform: [
					"",
					"gpu",
					"none"
				] }],
				scale: [{ scale: [O] }],
				"scale-x": [{ "scale-x": [O] }],
				"scale-y": [{ "scale-y": [O] }],
				rotate: [{ rotate: [P, I] }],
				"translate-x": [{ "translate-x": [$] }],
				"translate-y": [{ "translate-y": [$] }],
				"skew-x": [{ "skew-x": [_] }],
				"skew-y": [{ "skew-y": [_] }],
				"transform-origin": [{ origin: [
					"center",
					"top",
					"top-right",
					"right",
					"bottom-right",
					"bottom",
					"bottom-left",
					"left",
					"top-left",
					I
				] }],
				accent: [{ accent: ["auto", r] }],
				appearance: ["appearance-none"],
				cursor: [{ cursor: [
					"auto",
					"default",
					"pointer",
					"wait",
					"text",
					"move",
					"help",
					"not-allowed",
					"none",
					"context-menu",
					"progress",
					"cell",
					"crosshair",
					"vertical-text",
					"alias",
					"copy",
					"no-drop",
					"grab",
					"grabbing",
					"all-scroll",
					"col-resize",
					"row-resize",
					"n-resize",
					"e-resize",
					"s-resize",
					"w-resize",
					"ne-resize",
					"nw-resize",
					"se-resize",
					"sw-resize",
					"ew-resize",
					"ns-resize",
					"nesw-resize",
					"nwse-resize",
					"zoom-in",
					"zoom-out",
					I
				] }],
				"caret-color": [{ caret: [r] }],
				"pointer-events": [{ "pointer-events": ["none", "auto"] }],
				resize: [{ resize: [
					"none",
					"y",
					"x",
					""
				] }],
				"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
				"scroll-m": [{ "scroll-m": q() }],
				"scroll-mx": [{ "scroll-mx": q() }],
				"scroll-my": [{ "scroll-my": q() }],
				"scroll-ms": [{ "scroll-ms": q() }],
				"scroll-me": [{ "scroll-me": q() }],
				"scroll-mt": [{ "scroll-mt": q() }],
				"scroll-mr": [{ "scroll-mr": q() }],
				"scroll-mb": [{ "scroll-mb": q() }],
				"scroll-ml": [{ "scroll-ml": q() }],
				"scroll-p": [{ "scroll-p": q() }],
				"scroll-px": [{ "scroll-px": q() }],
				"scroll-py": [{ "scroll-py": q() }],
				"scroll-ps": [{ "scroll-ps": q() }],
				"scroll-pe": [{ "scroll-pe": q() }],
				"scroll-pt": [{ "scroll-pt": q() }],
				"scroll-pr": [{ "scroll-pr": q() }],
				"scroll-pb": [{ "scroll-pb": q() }],
				"scroll-pl": [{ "scroll-pl": q() }],
				"snap-align": [{ snap: [
					"start",
					"end",
					"center",
					"align-none"
				] }],
				"snap-stop": [{ snap: ["normal", "always"] }],
				"snap-type": [{ snap: [
					"none",
					"x",
					"y",
					"both"
				] }],
				"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
				touch: [{ touch: [
					"auto",
					"none",
					"pinch-zoom",
					"manipulation",
					{ pan: [
						"x",
						"left",
						"right",
						"y",
						"up",
						"down"
					] }
				] }],
				select: [{ select: [
					"none",
					"text",
					"all",
					"auto"
				] }],
				"will-change": [{ "will-change": [
					"auto",
					"scroll",
					"contents",
					"transform",
					I
				] }],
				fill: [{ fill: [r, "none"] }],
				"stroke-w": [{ stroke: [x, j] }],
				stroke: [{ stroke: [r, "none"] }],
				sr: ["sr-only", "not-sr-only"]
			},
			conflictingClassGroups: {
				overflow: ["overflow-x", "overflow-y"],
				overscroll: ["overscroll-x", "overscroll-y"],
				inset: [
					"inset-x",
					"inset-y",
					"start",
					"end",
					"top",
					"right",
					"bottom",
					"left"
				],
				"inset-x": ["right", "left"],
				"inset-y": ["top", "bottom"],
				flex: [
					"basis",
					"grow",
					"shrink"
				],
				gap: ["gap-x", "gap-y"],
				p: [
					"px",
					"py",
					"ps",
					"pe",
					"pt",
					"pr",
					"pb",
					"pl"
				],
				px: ["pr", "pl"],
				py: ["pt", "pb"],
				m: [
					"mx",
					"my",
					"ms",
					"me",
					"mt",
					"mr",
					"mb",
					"ml"
				],
				mx: ["mr", "ml"],
				my: ["mt", "mb"],
				"font-size": ["leading"],
				"fvn-normal": [
					"fvn-ordinal",
					"fvn-slashed-zero",
					"fvn-figure",
					"fvn-spacing",
					"fvn-fraction"
				],
				"fvn-ordinal": ["fvn-normal"],
				"fvn-slashed-zero": ["fvn-normal"],
				"fvn-figure": ["fvn-normal"],
				"fvn-spacing": ["fvn-normal"],
				"fvn-fraction": ["fvn-normal"],
				rounded: [
					"rounded-s",
					"rounded-e",
					"rounded-t",
					"rounded-r",
					"rounded-b",
					"rounded-l",
					"rounded-ss",
					"rounded-se",
					"rounded-ee",
					"rounded-es",
					"rounded-tl",
					"rounded-tr",
					"rounded-br",
					"rounded-bl"
				],
				"rounded-s": ["rounded-ss", "rounded-es"],
				"rounded-e": ["rounded-se", "rounded-ee"],
				"rounded-t": ["rounded-tl", "rounded-tr"],
				"rounded-r": ["rounded-tr", "rounded-br"],
				"rounded-b": ["rounded-br", "rounded-bl"],
				"rounded-l": ["rounded-tl", "rounded-bl"],
				"border-spacing": ["border-spacing-x", "border-spacing-y"],
				"border-w": [
					"border-w-s",
					"border-w-e",
					"border-w-t",
					"border-w-r",
					"border-w-b",
					"border-w-l"
				],
				"border-w-x": ["border-w-r", "border-w-l"],
				"border-w-y": ["border-w-t", "border-w-b"],
				"border-color": [
					"border-color-t",
					"border-color-r",
					"border-color-b",
					"border-color-l"
				],
				"border-color-x": ["border-color-r", "border-color-l"],
				"border-color-y": ["border-color-t", "border-color-b"],
				"scroll-m": [
					"scroll-mx",
					"scroll-my",
					"scroll-ms",
					"scroll-me",
					"scroll-mt",
					"scroll-mr",
					"scroll-mb",
					"scroll-ml"
				],
				"scroll-mx": ["scroll-mr", "scroll-ml"],
				"scroll-my": ["scroll-mt", "scroll-mb"],
				"scroll-p": [
					"scroll-px",
					"scroll-py",
					"scroll-ps",
					"scroll-pe",
					"scroll-pt",
					"scroll-pr",
					"scroll-pb",
					"scroll-pl"
				],
				"scroll-px": ["scroll-pr", "scroll-pl"],
				"scroll-py": ["scroll-pt", "scroll-pb"]
			},
			conflictingClassGroupModifiers: { "font-size": ["leading"] }
		};
	}
	function L(r, e) {
		for (var o in e) J(r, o, e[o]);
		return r;
	}
	var B = Object.prototype.hasOwnProperty;
	var D = /* @__PURE__ */ new Set([
		"string",
		"number",
		"boolean"
	]);
	function J(r, e, o) {
		if (B.call(r, e) && !D.has(typeof o) && null !== o) {
			if (Array.isArray(o) && Array.isArray(r[e])) r[e] = r[e].concat(o);
			else if ("object" == typeof o && "object" == typeof r[e]) {
				if (null === r[e]) return void (r[e] = o);
				for (var t in o) J(r[e], t, o[t]);
			}
		} else r[e] = o;
	}
	var U = p(q);
	var V = r;
	exports.createTailwindMerge = p, exports.extendTailwindMerge = function(r) {
		for (var e = arguments.length, o = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++) o[t - 1] = arguments[t];
		return p.apply(void 0, "function" == typeof r ? [q, r].concat(o) : [function() {
			return L(q(), r);
		}].concat(o));
	}, exports.fromTheme = f, exports.getDefaultConfig = q, exports.join = V, exports.mergeConfigs = L, exports.twJoin = r, exports.twMerge = U, exports.validators = R;
}));
//#endregion
//#region ../../node_modules/tailwind-merge/dist/tailwind-merge.cjs.development.js
var require_tailwind_merge_cjs_development = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	* The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
	*
	* Specifically:
	* - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
	* - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
	*
	* Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
	*/
	function twJoin() {
		var index = 0;
		var argument;
		var resolvedValue;
		var string = "";
		while (index < arguments.length) if (argument = arguments[index++]) {
			if (resolvedValue = toValue(argument)) {
				string && (string += " ");
				string += resolvedValue;
			}
		}
		return string;
	}
	function toValue(mix) {
		if (typeof mix === "string") return mix;
		var resolvedValue;
		var string = "";
		for (var k = 0; k < mix.length; k++) if (mix[k]) {
			if (resolvedValue = toValue(mix[k])) {
				string && (string += " ");
				string += resolvedValue;
			}
		}
		return string;
	}
	var CLASS_PART_SEPARATOR = "-";
	function createClassUtils(config) {
		var classMap = createClassMap(config);
		var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
		function getClassGroupId(className) {
			var classParts = className.split(CLASS_PART_SEPARATOR);
			if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
			return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
		}
		function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
			var conflicts = conflictingClassGroups[classGroupId] || [];
			if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
			return conflicts;
		}
		return {
			getClassGroupId,
			getConflictingClassGroupIds
		};
	}
	function getGroupRecursive(classParts, classPartObject) {
		if (classParts.length === 0) return classPartObject.classGroupId;
		var currentClassPart = classParts[0];
		var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
		var classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
		if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
		if (classPartObject.validators.length === 0) return;
		var classRest = classParts.join(CLASS_PART_SEPARATOR);
		return classPartObject.validators.find(function(_ref) {
			var validator = _ref.validator;
			return validator(classRest);
		})?.classGroupId;
	}
	var arbitraryPropertyRegex = /^\[(.+)\]$/;
	function getGroupIdForArbitraryProperty(className) {
		if (arbitraryPropertyRegex.test(className)) {
			var arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
			var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
			if (property) return "arbitrary.." + property;
		}
	}
	/**
	* Exported for testing only
	*/
	function createClassMap(config) {
		var theme = config.theme, prefix = config.prefix;
		var classMap = {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		};
		getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix).forEach(function(_ref2) {
			var classGroupId = _ref2[0], classGroup = _ref2[1];
			processClassesRecursively(classGroup, classMap, classGroupId, theme);
		});
		return classMap;
	}
	function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
		classGroup.forEach(function(classDefinition) {
			if (typeof classDefinition === "string") {
				var classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
				classPartObjectToEdit.classGroupId = classGroupId;
				return;
			}
			if (typeof classDefinition === "function") {
				if (isThemeGetter(classDefinition)) {
					processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
					return;
				}
				classPartObject.validators.push({
					validator: classDefinition,
					classGroupId
				});
				return;
			}
			Object.entries(classDefinition).forEach(function(_ref3) {
				var key = _ref3[0], classGroup = _ref3[1];
				processClassesRecursively(classGroup, getPart(classPartObject, key), classGroupId, theme);
			});
		});
	}
	function getPart(classPartObject, path) {
		var currentClassPartObject = classPartObject;
		path.split(CLASS_PART_SEPARATOR).forEach(function(pathPart) {
			if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
				nextPart: /* @__PURE__ */ new Map(),
				validators: []
			});
			currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
		});
		return currentClassPartObject;
	}
	function isThemeGetter(func) {
		return func.isThemeGetter;
	}
	function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
		if (!prefix) return classGroupEntries;
		return classGroupEntries.map(function(_ref4) {
			return [_ref4[0], _ref4[1].map(function(classDefinition) {
				if (typeof classDefinition === "string") return prefix + classDefinition;
				if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
					var key = _ref5[0], value = _ref5[1];
					return [prefix + key, value];
				}));
				return classDefinition;
			})];
		});
	}
	function createLruCache(maxCacheSize) {
		if (maxCacheSize < 1) return {
			get: function get() {},
			set: function set() {}
		};
		var cacheSize = 0;
		var cache = /* @__PURE__ */ new Map();
		var previousCache = /* @__PURE__ */ new Map();
		function update(key, value) {
			cache.set(key, value);
			cacheSize++;
			if (cacheSize > maxCacheSize) {
				cacheSize = 0;
				previousCache = cache;
				cache = /* @__PURE__ */ new Map();
			}
		}
		return {
			get: function get(key) {
				var value = cache.get(key);
				if (value !== void 0) return value;
				if ((value = previousCache.get(key)) !== void 0) {
					update(key, value);
					return value;
				}
			},
			set: function set(key, value) {
				if (cache.has(key)) cache.set(key, value);
				else update(key, value);
			}
		};
	}
	var IMPORTANT_MODIFIER = "!";
	function createSplitModifiers(config) {
		var separator = config.separator || ":";
		var isSeparatorSingleCharacter = separator.length === 1;
		var firstSeparatorCharacter = separator[0];
		var separatorLength = separator.length;
		return function splitModifiers(className) {
			var modifiers = [];
			var bracketDepth = 0;
			var modifierStart = 0;
			var postfixModifierPosition;
			for (var index = 0; index < className.length; index++) {
				var currentCharacter = className[index];
				if (bracketDepth === 0) {
					if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
						modifiers.push(className.slice(modifierStart, index));
						modifierStart = index + separatorLength;
						continue;
					}
					if (currentCharacter === "/") {
						postfixModifierPosition = index;
						continue;
					}
				}
				if (currentCharacter === "[") bracketDepth++;
				else if (currentCharacter === "]") bracketDepth--;
			}
			var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
			var hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
			return {
				modifiers,
				hasImportantModifier,
				baseClassName: hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier,
				maybePostfixModifierPosition: postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0
			};
		};
	}
	/**
	* Sorts modifiers according to following schema:
	* - Predefined modifiers are sorted alphabetically
	* - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
	*/
	function sortModifiers(modifiers) {
		if (modifiers.length <= 1) return modifiers;
		var sortedModifiers = [];
		var unsortedModifiers = [];
		modifiers.forEach(function(modifier) {
			if (modifier[0] === "[") {
				sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([modifier]));
				unsortedModifiers = [];
			} else unsortedModifiers.push(modifier);
		});
		sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
		return sortedModifiers;
	}
	function createConfigUtils(config) {
		return {
			cache: createLruCache(config.cacheSize),
			splitModifiers: createSplitModifiers(config),
			...createClassUtils(config)
		};
	}
	var SPLIT_CLASSES_REGEX = /\s+/;
	function mergeClassList(classList, configUtils) {
		var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
		/**
		* Set of classGroupIds in following format:
		* `{importantModifier}{variantModifiers}{classGroupId}`
		* @example 'float'
		* @example 'hover:focus:bg-color'
		* @example 'md:!pr'
		*/
		var classGroupsInConflict = /* @__PURE__ */ new Set();
		return classList.trim().split(SPLIT_CLASSES_REGEX).map(function(originalClassName) {
			var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
			var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
			var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
			if (!classGroupId) {
				if (!maybePostfixModifierPosition) return {
					isTailwindClass: false,
					originalClassName
				};
				classGroupId = getClassGroupId(baseClassName);
				if (!classGroupId) return {
					isTailwindClass: false,
					originalClassName
				};
				hasPostfixModifier = false;
			}
			var variantModifier = sortModifiers(modifiers).join(":");
			return {
				isTailwindClass: true,
				modifierId: hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier,
				classGroupId,
				originalClassName,
				hasPostfixModifier
			};
		}).reverse().filter(function(parsed) {
			if (!parsed.isTailwindClass) return true;
			var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
			var classId = modifierId + classGroupId;
			if (classGroupsInConflict.has(classId)) return false;
			classGroupsInConflict.add(classId);
			getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
				return classGroupsInConflict.add(modifierId + group);
			});
			return true;
		}).reverse().map(function(parsed) {
			return parsed.originalClassName;
		}).join(" ");
	}
	function createTailwindMerge() {
		for (var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++) createConfig[_key] = arguments[_key];
		var configUtils;
		var cacheGet;
		var cacheSet;
		var functionToCall = initTailwindMerge;
		function initTailwindMerge(classList) {
			var firstCreateConfig = createConfig[0];
			configUtils = createConfigUtils(createConfig.slice(1).reduce(function(previousConfig, createConfigCurrent) {
				return createConfigCurrent(previousConfig);
			}, firstCreateConfig()));
			cacheGet = configUtils.cache.get;
			cacheSet = configUtils.cache.set;
			functionToCall = tailwindMerge;
			return tailwindMerge(classList);
		}
		function tailwindMerge(classList) {
			var cachedResult = cacheGet(classList);
			if (cachedResult) return cachedResult;
			var result = mergeClassList(classList, configUtils);
			cacheSet(classList, result);
			return result;
		}
		return function callTailwindMerge() {
			return functionToCall(twJoin.apply(null, arguments));
		};
	}
	function fromTheme(key) {
		var themeGetter = function themeGetter(theme) {
			return theme[key] || [];
		};
		themeGetter.isThemeGetter = true;
		return themeGetter;
	}
	var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
	var fractionRegex = /^\d+\/\d+$/;
	var stringLengths = /*#__PURE__*/ new Set([
		"px",
		"full",
		"screen"
	]);
	var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
	var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
	var shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
	function isLength(value) {
		return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value) || isArbitraryLength(value);
	}
	function isArbitraryLength(value) {
		return getIsArbitraryValue(value, "length", isLengthOnly);
	}
	function isArbitrarySize(value) {
		return getIsArbitraryValue(value, "size", isNever);
	}
	function isArbitraryPosition(value) {
		return getIsArbitraryValue(value, "position", isNever);
	}
	function isArbitraryUrl(value) {
		return getIsArbitraryValue(value, "url", isUrl);
	}
	function isArbitraryNumber(value) {
		return getIsArbitraryValue(value, "number", isNumber);
	}
	/**
	* @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
	*/
	var isArbitraryWeight = isArbitraryNumber;
	function isNumber(value) {
		return !Number.isNaN(Number(value));
	}
	function isPercent(value) {
		return value.endsWith("%") && isNumber(value.slice(0, -1));
	}
	function isInteger(value) {
		return isIntegerOnly(value) || getIsArbitraryValue(value, "number", isIntegerOnly);
	}
	function isArbitraryValue(value) {
		return arbitraryValueRegex.test(value);
	}
	function isAny() {
		return true;
	}
	function isTshirtSize(value) {
		return tshirtUnitRegex.test(value);
	}
	function isArbitraryShadow(value) {
		return getIsArbitraryValue(value, "", isShadow);
	}
	function getIsArbitraryValue(value, label, testValue) {
		var result = arbitraryValueRegex.exec(value);
		if (result) {
			if (result[1]) return result[1] === label;
			return testValue(result[2]);
		}
		return false;
	}
	function isLengthOnly(value) {
		return lengthUnitRegex.test(value);
	}
	function isNever() {
		return false;
	}
	function isUrl(value) {
		return value.startsWith("url(");
	}
	function isIntegerOnly(value) {
		return Number.isInteger(Number(value));
	}
	function isShadow(value) {
		return shadowRegex.test(value);
	}
	var validators = {
		__proto__: null,
		isAny,
		isArbitraryLength,
		isArbitraryNumber,
		isArbitraryPosition,
		isArbitraryShadow,
		isArbitrarySize,
		isArbitraryUrl,
		isArbitraryValue,
		isArbitraryWeight,
		isInteger,
		isLength,
		isNumber,
		isPercent,
		isTshirtSize
	};
	function getDefaultConfig() {
		var colors = fromTheme("colors");
		var spacing = fromTheme("spacing");
		var blur = fromTheme("blur");
		var brightness = fromTheme("brightness");
		var borderColor = fromTheme("borderColor");
		var borderRadius = fromTheme("borderRadius");
		var borderSpacing = fromTheme("borderSpacing");
		var borderWidth = fromTheme("borderWidth");
		var contrast = fromTheme("contrast");
		var grayscale = fromTheme("grayscale");
		var hueRotate = fromTheme("hueRotate");
		var invert = fromTheme("invert");
		var gap = fromTheme("gap");
		var gradientColorStops = fromTheme("gradientColorStops");
		var gradientColorStopPositions = fromTheme("gradientColorStopPositions");
		var inset = fromTheme("inset");
		var margin = fromTheme("margin");
		var opacity = fromTheme("opacity");
		var padding = fromTheme("padding");
		var saturate = fromTheme("saturate");
		var scale = fromTheme("scale");
		var sepia = fromTheme("sepia");
		var skew = fromTheme("skew");
		var space = fromTheme("space");
		var translate = fromTheme("translate");
		var getOverscroll = function getOverscroll() {
			return [
				"auto",
				"contain",
				"none"
			];
		};
		var getOverflow = function getOverflow() {
			return [
				"auto",
				"hidden",
				"clip",
				"visible",
				"scroll"
			];
		};
		var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
			return [
				"auto",
				isArbitraryValue,
				spacing
			];
		};
		var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
			return [isArbitraryValue, spacing];
		};
		var getLengthWithEmpty = function getLengthWithEmpty() {
			return ["", isLength];
		};
		var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
			return [
				"auto",
				isNumber,
				isArbitraryValue
			];
		};
		var getPositions = function getPositions() {
			return [
				"bottom",
				"center",
				"left",
				"left-bottom",
				"left-top",
				"right",
				"right-bottom",
				"right-top",
				"top"
			];
		};
		var getLineStyles = function getLineStyles() {
			return [
				"solid",
				"dashed",
				"dotted",
				"double",
				"none"
			];
		};
		var getBlendModes = function getBlendModes() {
			return [
				"normal",
				"multiply",
				"screen",
				"overlay",
				"darken",
				"lighten",
				"color-dodge",
				"color-burn",
				"hard-light",
				"soft-light",
				"difference",
				"exclusion",
				"hue",
				"saturation",
				"color",
				"luminosity",
				"plus-lighter"
			];
		};
		var getAlign = function getAlign() {
			return [
				"start",
				"end",
				"center",
				"between",
				"around",
				"evenly",
				"stretch"
			];
		};
		var getZeroAndEmpty = function getZeroAndEmpty() {
			return [
				"",
				"0",
				isArbitraryValue
			];
		};
		var getBreaks = function getBreaks() {
			return [
				"auto",
				"avoid",
				"all",
				"avoid-page",
				"page",
				"left",
				"right",
				"column"
			];
		};
		var getNumber = function getNumber() {
			return [isNumber, isArbitraryNumber];
		};
		var getNumberAndArbitrary = function getNumberAndArbitrary() {
			return [isNumber, isArbitraryValue];
		};
		return {
			cacheSize: 500,
			theme: {
				colors: [isAny],
				spacing: [isLength],
				blur: [
					"none",
					"",
					isTshirtSize,
					isArbitraryValue
				],
				brightness: getNumber(),
				borderColor: [colors],
				borderRadius: [
					"none",
					"",
					"full",
					isTshirtSize,
					isArbitraryValue
				],
				borderSpacing: getSpacingWithArbitrary(),
				borderWidth: getLengthWithEmpty(),
				contrast: getNumber(),
				grayscale: getZeroAndEmpty(),
				hueRotate: getNumberAndArbitrary(),
				invert: getZeroAndEmpty(),
				gap: getSpacingWithArbitrary(),
				gradientColorStops: [colors],
				gradientColorStopPositions: [isPercent, isArbitraryLength],
				inset: getSpacingWithAutoAndArbitrary(),
				margin: getSpacingWithAutoAndArbitrary(),
				opacity: getNumber(),
				padding: getSpacingWithArbitrary(),
				saturate: getNumber(),
				scale: getNumber(),
				sepia: getZeroAndEmpty(),
				skew: getNumberAndArbitrary(),
				space: getSpacingWithArbitrary(),
				translate: getSpacingWithArbitrary()
			},
			classGroups: {
				/**
				* Aspect Ratio
				* @see https://tailwindcss.com/docs/aspect-ratio
				*/
				aspect: [{ aspect: [
					"auto",
					"square",
					"video",
					isArbitraryValue
				] }],
				/**
				* Container
				* @see https://tailwindcss.com/docs/container
				*/
				container: ["container"],
				/**
				* Columns
				* @see https://tailwindcss.com/docs/columns
				*/
				columns: [{ columns: [isTshirtSize] }],
				/**
				* Break After
				* @see https://tailwindcss.com/docs/break-after
				*/
				"break-after": [{ "break-after": getBreaks() }],
				/**
				* Break Before
				* @see https://tailwindcss.com/docs/break-before
				*/
				"break-before": [{ "break-before": getBreaks() }],
				/**
				* Break Inside
				* @see https://tailwindcss.com/docs/break-inside
				*/
				"break-inside": [{ "break-inside": [
					"auto",
					"avoid",
					"avoid-page",
					"avoid-column"
				] }],
				/**
				* Box Decoration Break
				* @see https://tailwindcss.com/docs/box-decoration-break
				*/
				"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
				/**
				* Box Sizing
				* @see https://tailwindcss.com/docs/box-sizing
				*/
				box: [{ box: ["border", "content"] }],
				/**
				* Display
				* @see https://tailwindcss.com/docs/display
				*/
				display: [
					"block",
					"inline-block",
					"inline",
					"flex",
					"inline-flex",
					"table",
					"inline-table",
					"table-caption",
					"table-cell",
					"table-column",
					"table-column-group",
					"table-footer-group",
					"table-header-group",
					"table-row-group",
					"table-row",
					"flow-root",
					"grid",
					"inline-grid",
					"contents",
					"list-item",
					"hidden"
				],
				/**
				* Floats
				* @see https://tailwindcss.com/docs/float
				*/
				"float": [{ "float": [
					"right",
					"left",
					"none"
				] }],
				/**
				* Clear
				* @see https://tailwindcss.com/docs/clear
				*/
				clear: [{ clear: [
					"left",
					"right",
					"both",
					"none"
				] }],
				/**
				* Isolation
				* @see https://tailwindcss.com/docs/isolation
				*/
				isolation: ["isolate", "isolation-auto"],
				/**
				* Object Fit
				* @see https://tailwindcss.com/docs/object-fit
				*/
				"object-fit": [{ object: [
					"contain",
					"cover",
					"fill",
					"none",
					"scale-down"
				] }],
				/**
				* Object Position
				* @see https://tailwindcss.com/docs/object-position
				*/
				"object-position": [{ object: [].concat(getPositions(), [isArbitraryValue]) }],
				/**
				* Overflow
				* @see https://tailwindcss.com/docs/overflow
				*/
				overflow: [{ overflow: getOverflow() }],
				/**
				* Overflow X
				* @see https://tailwindcss.com/docs/overflow
				*/
				"overflow-x": [{ "overflow-x": getOverflow() }],
				/**
				* Overflow Y
				* @see https://tailwindcss.com/docs/overflow
				*/
				"overflow-y": [{ "overflow-y": getOverflow() }],
				/**
				* Overscroll Behavior
				* @see https://tailwindcss.com/docs/overscroll-behavior
				*/
				overscroll: [{ overscroll: getOverscroll() }],
				/**
				* Overscroll Behavior X
				* @see https://tailwindcss.com/docs/overscroll-behavior
				*/
				"overscroll-x": [{ "overscroll-x": getOverscroll() }],
				/**
				* Overscroll Behavior Y
				* @see https://tailwindcss.com/docs/overscroll-behavior
				*/
				"overscroll-y": [{ "overscroll-y": getOverscroll() }],
				/**
				* Position
				* @see https://tailwindcss.com/docs/position
				*/
				position: [
					"static",
					"fixed",
					"absolute",
					"relative",
					"sticky"
				],
				/**
				* Top / Right / Bottom / Left
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				inset: [{ inset: [inset] }],
				/**
				* Right / Left
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				"inset-x": [{ "inset-x": [inset] }],
				/**
				* Top / Bottom
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				"inset-y": [{ "inset-y": [inset] }],
				/**
				* Start
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				start: [{ start: [inset] }],
				/**
				* End
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				end: [{ end: [inset] }],
				/**
				* Top
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				top: [{ top: [inset] }],
				/**
				* Right
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				right: [{ right: [inset] }],
				/**
				* Bottom
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				bottom: [{ bottom: [inset] }],
				/**
				* Left
				* @see https://tailwindcss.com/docs/top-right-bottom-left
				*/
				left: [{ left: [inset] }],
				/**
				* Visibility
				* @see https://tailwindcss.com/docs/visibility
				*/
				visibility: [
					"visible",
					"invisible",
					"collapse"
				],
				/**
				* Z-Index
				* @see https://tailwindcss.com/docs/z-index
				*/
				z: [{ z: ["auto", isInteger] }],
				/**
				* Flex Basis
				* @see https://tailwindcss.com/docs/flex-basis
				*/
				basis: [{ basis: getSpacingWithAutoAndArbitrary() }],
				/**
				* Flex Direction
				* @see https://tailwindcss.com/docs/flex-direction
				*/
				"flex-direction": [{ flex: [
					"row",
					"row-reverse",
					"col",
					"col-reverse"
				] }],
				/**
				* Flex Wrap
				* @see https://tailwindcss.com/docs/flex-wrap
				*/
				"flex-wrap": [{ flex: [
					"wrap",
					"wrap-reverse",
					"nowrap"
				] }],
				/**
				* Flex
				* @see https://tailwindcss.com/docs/flex
				*/
				flex: [{ flex: [
					"1",
					"auto",
					"initial",
					"none",
					isArbitraryValue
				] }],
				/**
				* Flex Grow
				* @see https://tailwindcss.com/docs/flex-grow
				*/
				grow: [{ grow: getZeroAndEmpty() }],
				/**
				* Flex Shrink
				* @see https://tailwindcss.com/docs/flex-shrink
				*/
				shrink: [{ shrink: getZeroAndEmpty() }],
				/**
				* Order
				* @see https://tailwindcss.com/docs/order
				*/
				order: [{ order: [
					"first",
					"last",
					"none",
					isInteger
				] }],
				/**
				* Grid Template Columns
				* @see https://tailwindcss.com/docs/grid-template-columns
				*/
				"grid-cols": [{ "grid-cols": [isAny] }],
				/**
				* Grid Column Start / End
				* @see https://tailwindcss.com/docs/grid-column
				*/
				"col-start-end": [{ col: [
					"auto",
					{ span: ["full", isInteger] },
					isArbitraryValue
				] }],
				/**
				* Grid Column Start
				* @see https://tailwindcss.com/docs/grid-column
				*/
				"col-start": [{ "col-start": getNumberWithAutoAndArbitrary() }],
				/**
				* Grid Column End
				* @see https://tailwindcss.com/docs/grid-column
				*/
				"col-end": [{ "col-end": getNumberWithAutoAndArbitrary() }],
				/**
				* Grid Template Rows
				* @see https://tailwindcss.com/docs/grid-template-rows
				*/
				"grid-rows": [{ "grid-rows": [isAny] }],
				/**
				* Grid Row Start / End
				* @see https://tailwindcss.com/docs/grid-row
				*/
				"row-start-end": [{ row: [
					"auto",
					{ span: [isInteger] },
					isArbitraryValue
				] }],
				/**
				* Grid Row Start
				* @see https://tailwindcss.com/docs/grid-row
				*/
				"row-start": [{ "row-start": getNumberWithAutoAndArbitrary() }],
				/**
				* Grid Row End
				* @see https://tailwindcss.com/docs/grid-row
				*/
				"row-end": [{ "row-end": getNumberWithAutoAndArbitrary() }],
				/**
				* Grid Auto Flow
				* @see https://tailwindcss.com/docs/grid-auto-flow
				*/
				"grid-flow": [{ "grid-flow": [
					"row",
					"col",
					"dense",
					"row-dense",
					"col-dense"
				] }],
				/**
				* Grid Auto Columns
				* @see https://tailwindcss.com/docs/grid-auto-columns
				*/
				"auto-cols": [{ "auto-cols": [
					"auto",
					"min",
					"max",
					"fr",
					isArbitraryValue
				] }],
				/**
				* Grid Auto Rows
				* @see https://tailwindcss.com/docs/grid-auto-rows
				*/
				"auto-rows": [{ "auto-rows": [
					"auto",
					"min",
					"max",
					"fr",
					isArbitraryValue
				] }],
				/**
				* Gap
				* @see https://tailwindcss.com/docs/gap
				*/
				gap: [{ gap: [gap] }],
				/**
				* Gap X
				* @see https://tailwindcss.com/docs/gap
				*/
				"gap-x": [{ "gap-x": [gap] }],
				/**
				* Gap Y
				* @see https://tailwindcss.com/docs/gap
				*/
				"gap-y": [{ "gap-y": [gap] }],
				/**
				* Justify Content
				* @see https://tailwindcss.com/docs/justify-content
				*/
				"justify-content": [{ justify: ["normal"].concat(getAlign()) }],
				/**
				* Justify Items
				* @see https://tailwindcss.com/docs/justify-items
				*/
				"justify-items": [{ "justify-items": [
					"start",
					"end",
					"center",
					"stretch"
				] }],
				/**
				* Justify Self
				* @see https://tailwindcss.com/docs/justify-self
				*/
				"justify-self": [{ "justify-self": [
					"auto",
					"start",
					"end",
					"center",
					"stretch"
				] }],
				/**
				* Align Content
				* @see https://tailwindcss.com/docs/align-content
				*/
				"align-content": [{ content: ["normal"].concat(getAlign(), ["baseline"]) }],
				/**
				* Align Items
				* @see https://tailwindcss.com/docs/align-items
				*/
				"align-items": [{ items: [
					"start",
					"end",
					"center",
					"baseline",
					"stretch"
				] }],
				/**
				* Align Self
				* @see https://tailwindcss.com/docs/align-self
				*/
				"align-self": [{ self: [
					"auto",
					"start",
					"end",
					"center",
					"stretch",
					"baseline"
				] }],
				/**
				* Place Content
				* @see https://tailwindcss.com/docs/place-content
				*/
				"place-content": [{ "place-content": [].concat(getAlign(), ["baseline"]) }],
				/**
				* Place Items
				* @see https://tailwindcss.com/docs/place-items
				*/
				"place-items": [{ "place-items": [
					"start",
					"end",
					"center",
					"baseline",
					"stretch"
				] }],
				/**
				* Place Self
				* @see https://tailwindcss.com/docs/place-self
				*/
				"place-self": [{ "place-self": [
					"auto",
					"start",
					"end",
					"center",
					"stretch"
				] }],
				/**
				* Padding
				* @see https://tailwindcss.com/docs/padding
				*/
				p: [{ p: [padding] }],
				/**
				* Padding X
				* @see https://tailwindcss.com/docs/padding
				*/
				px: [{ px: [padding] }],
				/**
				* Padding Y
				* @see https://tailwindcss.com/docs/padding
				*/
				py: [{ py: [padding] }],
				/**
				* Padding Start
				* @see https://tailwindcss.com/docs/padding
				*/
				ps: [{ ps: [padding] }],
				/**
				* Padding End
				* @see https://tailwindcss.com/docs/padding
				*/
				pe: [{ pe: [padding] }],
				/**
				* Padding Top
				* @see https://tailwindcss.com/docs/padding
				*/
				pt: [{ pt: [padding] }],
				/**
				* Padding Right
				* @see https://tailwindcss.com/docs/padding
				*/
				pr: [{ pr: [padding] }],
				/**
				* Padding Bottom
				* @see https://tailwindcss.com/docs/padding
				*/
				pb: [{ pb: [padding] }],
				/**
				* Padding Left
				* @see https://tailwindcss.com/docs/padding
				*/
				pl: [{ pl: [padding] }],
				/**
				* Margin
				* @see https://tailwindcss.com/docs/margin
				*/
				m: [{ m: [margin] }],
				/**
				* Margin X
				* @see https://tailwindcss.com/docs/margin
				*/
				mx: [{ mx: [margin] }],
				/**
				* Margin Y
				* @see https://tailwindcss.com/docs/margin
				*/
				my: [{ my: [margin] }],
				/**
				* Margin Start
				* @see https://tailwindcss.com/docs/margin
				*/
				ms: [{ ms: [margin] }],
				/**
				* Margin End
				* @see https://tailwindcss.com/docs/margin
				*/
				me: [{ me: [margin] }],
				/**
				* Margin Top
				* @see https://tailwindcss.com/docs/margin
				*/
				mt: [{ mt: [margin] }],
				/**
				* Margin Right
				* @see https://tailwindcss.com/docs/margin
				*/
				mr: [{ mr: [margin] }],
				/**
				* Margin Bottom
				* @see https://tailwindcss.com/docs/margin
				*/
				mb: [{ mb: [margin] }],
				/**
				* Margin Left
				* @see https://tailwindcss.com/docs/margin
				*/
				ml: [{ ml: [margin] }],
				/**
				* Space Between X
				* @see https://tailwindcss.com/docs/space
				*/
				"space-x": [{ "space-x": [space] }],
				/**
				* Space Between X Reverse
				* @see https://tailwindcss.com/docs/space
				*/
				"space-x-reverse": ["space-x-reverse"],
				/**
				* Space Between Y
				* @see https://tailwindcss.com/docs/space
				*/
				"space-y": [{ "space-y": [space] }],
				/**
				* Space Between Y Reverse
				* @see https://tailwindcss.com/docs/space
				*/
				"space-y-reverse": ["space-y-reverse"],
				/**
				* Width
				* @see https://tailwindcss.com/docs/width
				*/
				w: [{ w: [
					"auto",
					"min",
					"max",
					"fit",
					isArbitraryValue,
					spacing
				] }],
				/**
				* Min-Width
				* @see https://tailwindcss.com/docs/min-width
				*/
				"min-w": [{ "min-w": [
					"min",
					"max",
					"fit",
					isArbitraryValue,
					isLength
				] }],
				/**
				* Max-Width
				* @see https://tailwindcss.com/docs/max-width
				*/
				"max-w": [{ "max-w": [
					"0",
					"none",
					"full",
					"min",
					"max",
					"fit",
					"prose",
					{ screen: [isTshirtSize] },
					isTshirtSize,
					isArbitraryValue
				] }],
				/**
				* Height
				* @see https://tailwindcss.com/docs/height
				*/
				h: [{ h: [
					isArbitraryValue,
					spacing,
					"auto",
					"min",
					"max",
					"fit"
				] }],
				/**
				* Min-Height
				* @see https://tailwindcss.com/docs/min-height
				*/
				"min-h": [{ "min-h": [
					"min",
					"max",
					"fit",
					isArbitraryValue,
					isLength
				] }],
				/**
				* Max-Height
				* @see https://tailwindcss.com/docs/max-height
				*/
				"max-h": [{ "max-h": [
					isArbitraryValue,
					spacing,
					"min",
					"max",
					"fit"
				] }],
				/**
				* Font Size
				* @see https://tailwindcss.com/docs/font-size
				*/
				"font-size": [{ text: [
					"base",
					isTshirtSize,
					isArbitraryLength
				] }],
				/**
				* Font Smoothing
				* @see https://tailwindcss.com/docs/font-smoothing
				*/
				"font-smoothing": ["antialiased", "subpixel-antialiased"],
				/**
				* Font Style
				* @see https://tailwindcss.com/docs/font-style
				*/
				"font-style": ["italic", "not-italic"],
				/**
				* Font Weight
				* @see https://tailwindcss.com/docs/font-weight
				*/
				"font-weight": [{ font: [
					"thin",
					"extralight",
					"light",
					"normal",
					"medium",
					"semibold",
					"bold",
					"extrabold",
					"black",
					isArbitraryNumber
				] }],
				/**
				* Font Family
				* @see https://tailwindcss.com/docs/font-family
				*/
				"font-family": [{ font: [isAny] }],
				/**
				* Font Variant Numeric
				* @see https://tailwindcss.com/docs/font-variant-numeric
				*/
				"fvn-normal": ["normal-nums"],
				/**
				* Font Variant Numeric
				* @see https://tailwindcss.com/docs/font-variant-numeric
				*/
				"fvn-ordinal": ["ordinal"],
				/**
				* Font Variant Numeric
				* @see https://tailwindcss.com/docs/font-variant-numeric
				*/
				"fvn-slashed-zero": ["slashed-zero"],
				/**
				* Font Variant Numeric
				* @see https://tailwindcss.com/docs/font-variant-numeric
				*/
				"fvn-figure": ["lining-nums", "oldstyle-nums"],
				/**
				* Font Variant Numeric
				* @see https://tailwindcss.com/docs/font-variant-numeric
				*/
				"fvn-spacing": ["proportional-nums", "tabular-nums"],
				/**
				* Font Variant Numeric
				* @see https://tailwindcss.com/docs/font-variant-numeric
				*/
				"fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
				/**
				* Letter Spacing
				* @see https://tailwindcss.com/docs/letter-spacing
				*/
				tracking: [{ tracking: [
					"tighter",
					"tight",
					"normal",
					"wide",
					"wider",
					"widest",
					isArbitraryValue
				] }],
				/**
				* Line Clamp
				* @see https://tailwindcss.com/docs/line-clamp
				*/
				"line-clamp": [{ "line-clamp": [
					"none",
					isNumber,
					isArbitraryNumber
				] }],
				/**
				* Line Height
				* @see https://tailwindcss.com/docs/line-height
				*/
				leading: [{ leading: [
					"none",
					"tight",
					"snug",
					"normal",
					"relaxed",
					"loose",
					isArbitraryValue,
					isLength
				] }],
				/**
				* List Style Image
				* @see https://tailwindcss.com/docs/list-style-image
				*/
				"list-image": [{ "list-image": ["none", isArbitraryValue] }],
				/**
				* List Style Type
				* @see https://tailwindcss.com/docs/list-style-type
				*/
				"list-style-type": [{ list: [
					"none",
					"disc",
					"decimal",
					isArbitraryValue
				] }],
				/**
				* List Style Position
				* @see https://tailwindcss.com/docs/list-style-position
				*/
				"list-style-position": [{ list: ["inside", "outside"] }],
				/**
				* Placeholder Color
				* @deprecated since Tailwind CSS v3.0.0
				* @see https://tailwindcss.com/docs/placeholder-color
				*/
				"placeholder-color": [{ placeholder: [colors] }],
				/**
				* Placeholder Opacity
				* @see https://tailwindcss.com/docs/placeholder-opacity
				*/
				"placeholder-opacity": [{ "placeholder-opacity": [opacity] }],
				/**
				* Text Alignment
				* @see https://tailwindcss.com/docs/text-align
				*/
				"text-alignment": [{ text: [
					"left",
					"center",
					"right",
					"justify",
					"start",
					"end"
				] }],
				/**
				* Text Color
				* @see https://tailwindcss.com/docs/text-color
				*/
				"text-color": [{ text: [colors] }],
				/**
				* Text Opacity
				* @see https://tailwindcss.com/docs/text-opacity
				*/
				"text-opacity": [{ "text-opacity": [opacity] }],
				/**
				* Text Decoration
				* @see https://tailwindcss.com/docs/text-decoration
				*/
				"text-decoration": [
					"underline",
					"overline",
					"line-through",
					"no-underline"
				],
				/**
				* Text Decoration Style
				* @see https://tailwindcss.com/docs/text-decoration-style
				*/
				"text-decoration-style": [{ decoration: [].concat(getLineStyles(), ["wavy"]) }],
				/**
				* Text Decoration Thickness
				* @see https://tailwindcss.com/docs/text-decoration-thickness
				*/
				"text-decoration-thickness": [{ decoration: [
					"auto",
					"from-font",
					isLength
				] }],
				/**
				* Text Underline Offset
				* @see https://tailwindcss.com/docs/text-underline-offset
				*/
				"underline-offset": [{ "underline-offset": [
					"auto",
					isArbitraryValue,
					isLength
				] }],
				/**
				* Text Decoration Color
				* @see https://tailwindcss.com/docs/text-decoration-color
				*/
				"text-decoration-color": [{ decoration: [colors] }],
				/**
				* Text Transform
				* @see https://tailwindcss.com/docs/text-transform
				*/
				"text-transform": [
					"uppercase",
					"lowercase",
					"capitalize",
					"normal-case"
				],
				/**
				* Text Overflow
				* @see https://tailwindcss.com/docs/text-overflow
				*/
				"text-overflow": [
					"truncate",
					"text-ellipsis",
					"text-clip"
				],
				/**
				* Text Indent
				* @see https://tailwindcss.com/docs/text-indent
				*/
				indent: [{ indent: getSpacingWithArbitrary() }],
				/**
				* Vertical Alignment
				* @see https://tailwindcss.com/docs/vertical-align
				*/
				"vertical-align": [{ align: [
					"baseline",
					"top",
					"middle",
					"bottom",
					"text-top",
					"text-bottom",
					"sub",
					"super",
					isArbitraryValue
				] }],
				/**
				* Whitespace
				* @see https://tailwindcss.com/docs/whitespace
				*/
				whitespace: [{ whitespace: [
					"normal",
					"nowrap",
					"pre",
					"pre-line",
					"pre-wrap",
					"break-spaces"
				] }],
				/**
				* Word Break
				* @see https://tailwindcss.com/docs/word-break
				*/
				"break": [{ "break": [
					"normal",
					"words",
					"all",
					"keep"
				] }],
				/**
				* Hyphens
				* @see https://tailwindcss.com/docs/hyphens
				*/
				hyphens: [{ hyphens: [
					"none",
					"manual",
					"auto"
				] }],
				/**
				* Content
				* @see https://tailwindcss.com/docs/content
				*/
				content: [{ content: ["none", isArbitraryValue] }],
				/**
				* Background Attachment
				* @see https://tailwindcss.com/docs/background-attachment
				*/
				"bg-attachment": [{ bg: [
					"fixed",
					"local",
					"scroll"
				] }],
				/**
				* Background Clip
				* @see https://tailwindcss.com/docs/background-clip
				*/
				"bg-clip": [{ "bg-clip": [
					"border",
					"padding",
					"content",
					"text"
				] }],
				/**
				* Background Opacity
				* @deprecated since Tailwind CSS v3.0.0
				* @see https://tailwindcss.com/docs/background-opacity
				*/
				"bg-opacity": [{ "bg-opacity": [opacity] }],
				/**
				* Background Origin
				* @see https://tailwindcss.com/docs/background-origin
				*/
				"bg-origin": [{ "bg-origin": [
					"border",
					"padding",
					"content"
				] }],
				/**
				* Background Position
				* @see https://tailwindcss.com/docs/background-position
				*/
				"bg-position": [{ bg: [].concat(getPositions(), [isArbitraryPosition]) }],
				/**
				* Background Repeat
				* @see https://tailwindcss.com/docs/background-repeat
				*/
				"bg-repeat": [{ bg: ["no-repeat", { repeat: [
					"",
					"x",
					"y",
					"round",
					"space"
				] }] }],
				/**
				* Background Size
				* @see https://tailwindcss.com/docs/background-size
				*/
				"bg-size": [{ bg: [
					"auto",
					"cover",
					"contain",
					isArbitrarySize
				] }],
				/**
				* Background Image
				* @see https://tailwindcss.com/docs/background-image
				*/
				"bg-image": [{ bg: [
					"none",
					{ "gradient-to": [
						"t",
						"tr",
						"r",
						"br",
						"b",
						"bl",
						"l",
						"tl"
					] },
					isArbitraryUrl
				] }],
				/**
				* Background Color
				* @see https://tailwindcss.com/docs/background-color
				*/
				"bg-color": [{ bg: [colors] }],
				/**
				* Gradient Color Stops From Position
				* @see https://tailwindcss.com/docs/gradient-color-stops
				*/
				"gradient-from-pos": [{ from: [gradientColorStopPositions] }],
				/**
				* Gradient Color Stops Via Position
				* @see https://tailwindcss.com/docs/gradient-color-stops
				*/
				"gradient-via-pos": [{ via: [gradientColorStopPositions] }],
				/**
				* Gradient Color Stops To Position
				* @see https://tailwindcss.com/docs/gradient-color-stops
				*/
				"gradient-to-pos": [{ to: [gradientColorStopPositions] }],
				/**
				* Gradient Color Stops From
				* @see https://tailwindcss.com/docs/gradient-color-stops
				*/
				"gradient-from": [{ from: [gradientColorStops] }],
				/**
				* Gradient Color Stops Via
				* @see https://tailwindcss.com/docs/gradient-color-stops
				*/
				"gradient-via": [{ via: [gradientColorStops] }],
				/**
				* Gradient Color Stops To
				* @see https://tailwindcss.com/docs/gradient-color-stops
				*/
				"gradient-to": [{ to: [gradientColorStops] }],
				/**
				* Border Radius
				* @see https://tailwindcss.com/docs/border-radius
				*/
				rounded: [{ rounded: [borderRadius] }],
				/**
				* Border Radius Start
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-s": [{ "rounded-s": [borderRadius] }],
				/**
				* Border Radius End
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-e": [{ "rounded-e": [borderRadius] }],
				/**
				* Border Radius Top
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-t": [{ "rounded-t": [borderRadius] }],
				/**
				* Border Radius Right
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-r": [{ "rounded-r": [borderRadius] }],
				/**
				* Border Radius Bottom
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-b": [{ "rounded-b": [borderRadius] }],
				/**
				* Border Radius Left
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-l": [{ "rounded-l": [borderRadius] }],
				/**
				* Border Radius Start Start
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-ss": [{ "rounded-ss": [borderRadius] }],
				/**
				* Border Radius Start End
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-se": [{ "rounded-se": [borderRadius] }],
				/**
				* Border Radius End End
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-ee": [{ "rounded-ee": [borderRadius] }],
				/**
				* Border Radius End Start
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-es": [{ "rounded-es": [borderRadius] }],
				/**
				* Border Radius Top Left
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-tl": [{ "rounded-tl": [borderRadius] }],
				/**
				* Border Radius Top Right
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-tr": [{ "rounded-tr": [borderRadius] }],
				/**
				* Border Radius Bottom Right
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-br": [{ "rounded-br": [borderRadius] }],
				/**
				* Border Radius Bottom Left
				* @see https://tailwindcss.com/docs/border-radius
				*/
				"rounded-bl": [{ "rounded-bl": [borderRadius] }],
				/**
				* Border Width
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w": [{ border: [borderWidth] }],
				/**
				* Border Width X
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-x": [{ "border-x": [borderWidth] }],
				/**
				* Border Width Y
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-y": [{ "border-y": [borderWidth] }],
				/**
				* Border Width Start
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-s": [{ "border-s": [borderWidth] }],
				/**
				* Border Width End
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-e": [{ "border-e": [borderWidth] }],
				/**
				* Border Width Top
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-t": [{ "border-t": [borderWidth] }],
				/**
				* Border Width Right
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-r": [{ "border-r": [borderWidth] }],
				/**
				* Border Width Bottom
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-b": [{ "border-b": [borderWidth] }],
				/**
				* Border Width Left
				* @see https://tailwindcss.com/docs/border-width
				*/
				"border-w-l": [{ "border-l": [borderWidth] }],
				/**
				* Border Opacity
				* @see https://tailwindcss.com/docs/border-opacity
				*/
				"border-opacity": [{ "border-opacity": [opacity] }],
				/**
				* Border Style
				* @see https://tailwindcss.com/docs/border-style
				*/
				"border-style": [{ border: [].concat(getLineStyles(), ["hidden"]) }],
				/**
				* Divide Width X
				* @see https://tailwindcss.com/docs/divide-width
				*/
				"divide-x": [{ "divide-x": [borderWidth] }],
				/**
				* Divide Width X Reverse
				* @see https://tailwindcss.com/docs/divide-width
				*/
				"divide-x-reverse": ["divide-x-reverse"],
				/**
				* Divide Width Y
				* @see https://tailwindcss.com/docs/divide-width
				*/
				"divide-y": [{ "divide-y": [borderWidth] }],
				/**
				* Divide Width Y Reverse
				* @see https://tailwindcss.com/docs/divide-width
				*/
				"divide-y-reverse": ["divide-y-reverse"],
				/**
				* Divide Opacity
				* @see https://tailwindcss.com/docs/divide-opacity
				*/
				"divide-opacity": [{ "divide-opacity": [opacity] }],
				/**
				* Divide Style
				* @see https://tailwindcss.com/docs/divide-style
				*/
				"divide-style": [{ divide: getLineStyles() }],
				/**
				* Border Color
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color": [{ border: [borderColor] }],
				/**
				* Border Color X
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color-x": [{ "border-x": [borderColor] }],
				/**
				* Border Color Y
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color-y": [{ "border-y": [borderColor] }],
				/**
				* Border Color Top
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color-t": [{ "border-t": [borderColor] }],
				/**
				* Border Color Right
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color-r": [{ "border-r": [borderColor] }],
				/**
				* Border Color Bottom
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color-b": [{ "border-b": [borderColor] }],
				/**
				* Border Color Left
				* @see https://tailwindcss.com/docs/border-color
				*/
				"border-color-l": [{ "border-l": [borderColor] }],
				/**
				* Divide Color
				* @see https://tailwindcss.com/docs/divide-color
				*/
				"divide-color": [{ divide: [borderColor] }],
				/**
				* Outline Style
				* @see https://tailwindcss.com/docs/outline-style
				*/
				"outline-style": [{ outline: [""].concat(getLineStyles()) }],
				/**
				* Outline Offset
				* @see https://tailwindcss.com/docs/outline-offset
				*/
				"outline-offset": [{ "outline-offset": [isArbitraryValue, isLength] }],
				/**
				* Outline Width
				* @see https://tailwindcss.com/docs/outline-width
				*/
				"outline-w": [{ outline: [isLength] }],
				/**
				* Outline Color
				* @see https://tailwindcss.com/docs/outline-color
				*/
				"outline-color": [{ outline: [colors] }],
				/**
				* Ring Width
				* @see https://tailwindcss.com/docs/ring-width
				*/
				"ring-w": [{ ring: getLengthWithEmpty() }],
				/**
				* Ring Width Inset
				* @see https://tailwindcss.com/docs/ring-width
				*/
				"ring-w-inset": ["ring-inset"],
				/**
				* Ring Color
				* @see https://tailwindcss.com/docs/ring-color
				*/
				"ring-color": [{ ring: [colors] }],
				/**
				* Ring Opacity
				* @see https://tailwindcss.com/docs/ring-opacity
				*/
				"ring-opacity": [{ "ring-opacity": [opacity] }],
				/**
				* Ring Offset Width
				* @see https://tailwindcss.com/docs/ring-offset-width
				*/
				"ring-offset-w": [{ "ring-offset": [isLength] }],
				/**
				* Ring Offset Color
				* @see https://tailwindcss.com/docs/ring-offset-color
				*/
				"ring-offset-color": [{ "ring-offset": [colors] }],
				/**
				* Box Shadow
				* @see https://tailwindcss.com/docs/box-shadow
				*/
				shadow: [{ shadow: [
					"",
					"inner",
					"none",
					isTshirtSize,
					isArbitraryShadow
				] }],
				/**
				* Box Shadow Color
				* @see https://tailwindcss.com/docs/box-shadow-color
				*/
				"shadow-color": [{ shadow: [isAny] }],
				/**
				* Opacity
				* @see https://tailwindcss.com/docs/opacity
				*/
				opacity: [{ opacity: [opacity] }],
				/**
				* Mix Blend Mode
				* @see https://tailwindcss.com/docs/mix-blend-mode
				*/
				"mix-blend": [{ "mix-blend": getBlendModes() }],
				/**
				* Background Blend Mode
				* @see https://tailwindcss.com/docs/background-blend-mode
				*/
				"bg-blend": [{ "bg-blend": getBlendModes() }],
				/**
				* Filter
				* @deprecated since Tailwind CSS v3.0.0
				* @see https://tailwindcss.com/docs/filter
				*/
				filter: [{ filter: ["", "none"] }],
				/**
				* Blur
				* @see https://tailwindcss.com/docs/blur
				*/
				blur: [{ blur: [blur] }],
				/**
				* Brightness
				* @see https://tailwindcss.com/docs/brightness
				*/
				brightness: [{ brightness: [brightness] }],
				/**
				* Contrast
				* @see https://tailwindcss.com/docs/contrast
				*/
				contrast: [{ contrast: [contrast] }],
				/**
				* Drop Shadow
				* @see https://tailwindcss.com/docs/drop-shadow
				*/
				"drop-shadow": [{ "drop-shadow": [
					"",
					"none",
					isTshirtSize,
					isArbitraryValue
				] }],
				/**
				* Grayscale
				* @see https://tailwindcss.com/docs/grayscale
				*/
				grayscale: [{ grayscale: [grayscale] }],
				/**
				* Hue Rotate
				* @see https://tailwindcss.com/docs/hue-rotate
				*/
				"hue-rotate": [{ "hue-rotate": [hueRotate] }],
				/**
				* Invert
				* @see https://tailwindcss.com/docs/invert
				*/
				invert: [{ invert: [invert] }],
				/**
				* Saturate
				* @see https://tailwindcss.com/docs/saturate
				*/
				saturate: [{ saturate: [saturate] }],
				/**
				* Sepia
				* @see https://tailwindcss.com/docs/sepia
				*/
				sepia: [{ sepia: [sepia] }],
				/**
				* Backdrop Filter
				* @deprecated since Tailwind CSS v3.0.0
				* @see https://tailwindcss.com/docs/backdrop-filter
				*/
				"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
				/**
				* Backdrop Blur
				* @see https://tailwindcss.com/docs/backdrop-blur
				*/
				"backdrop-blur": [{ "backdrop-blur": [blur] }],
				/**
				* Backdrop Brightness
				* @see https://tailwindcss.com/docs/backdrop-brightness
				*/
				"backdrop-brightness": [{ "backdrop-brightness": [brightness] }],
				/**
				* Backdrop Contrast
				* @see https://tailwindcss.com/docs/backdrop-contrast
				*/
				"backdrop-contrast": [{ "backdrop-contrast": [contrast] }],
				/**
				* Backdrop Grayscale
				* @see https://tailwindcss.com/docs/backdrop-grayscale
				*/
				"backdrop-grayscale": [{ "backdrop-grayscale": [grayscale] }],
				/**
				* Backdrop Hue Rotate
				* @see https://tailwindcss.com/docs/backdrop-hue-rotate
				*/
				"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [hueRotate] }],
				/**
				* Backdrop Invert
				* @see https://tailwindcss.com/docs/backdrop-invert
				*/
				"backdrop-invert": [{ "backdrop-invert": [invert] }],
				/**
				* Backdrop Opacity
				* @see https://tailwindcss.com/docs/backdrop-opacity
				*/
				"backdrop-opacity": [{ "backdrop-opacity": [opacity] }],
				/**
				* Backdrop Saturate
				* @see https://tailwindcss.com/docs/backdrop-saturate
				*/
				"backdrop-saturate": [{ "backdrop-saturate": [saturate] }],
				/**
				* Backdrop Sepia
				* @see https://tailwindcss.com/docs/backdrop-sepia
				*/
				"backdrop-sepia": [{ "backdrop-sepia": [sepia] }],
				/**
				* Border Collapse
				* @see https://tailwindcss.com/docs/border-collapse
				*/
				"border-collapse": [{ border: ["collapse", "separate"] }],
				/**
				* Border Spacing
				* @see https://tailwindcss.com/docs/border-spacing
				*/
				"border-spacing": [{ "border-spacing": [borderSpacing] }],
				/**
				* Border Spacing X
				* @see https://tailwindcss.com/docs/border-spacing
				*/
				"border-spacing-x": [{ "border-spacing-x": [borderSpacing] }],
				/**
				* Border Spacing Y
				* @see https://tailwindcss.com/docs/border-spacing
				*/
				"border-spacing-y": [{ "border-spacing-y": [borderSpacing] }],
				/**
				* Table Layout
				* @see https://tailwindcss.com/docs/table-layout
				*/
				"table-layout": [{ table: ["auto", "fixed"] }],
				/**
				* Caption Side
				* @see https://tailwindcss.com/docs/caption-side
				*/
				caption: [{ caption: ["top", "bottom"] }],
				/**
				* Tranisition Property
				* @see https://tailwindcss.com/docs/transition-property
				*/
				transition: [{ transition: [
					"none",
					"all",
					"",
					"colors",
					"opacity",
					"shadow",
					"transform",
					isArbitraryValue
				] }],
				/**
				* Transition Duration
				* @see https://tailwindcss.com/docs/transition-duration
				*/
				duration: [{ duration: getNumberAndArbitrary() }],
				/**
				* Transition Timing Function
				* @see https://tailwindcss.com/docs/transition-timing-function
				*/
				ease: [{ ease: [
					"linear",
					"in",
					"out",
					"in-out",
					isArbitraryValue
				] }],
				/**
				* Transition Delay
				* @see https://tailwindcss.com/docs/transition-delay
				*/
				delay: [{ delay: getNumberAndArbitrary() }],
				/**
				* Animation
				* @see https://tailwindcss.com/docs/animation
				*/
				animate: [{ animate: [
					"none",
					"spin",
					"ping",
					"pulse",
					"bounce",
					isArbitraryValue
				] }],
				/**
				* Transform
				* @see https://tailwindcss.com/docs/transform
				*/
				transform: [{ transform: [
					"",
					"gpu",
					"none"
				] }],
				/**
				* Scale
				* @see https://tailwindcss.com/docs/scale
				*/
				scale: [{ scale: [scale] }],
				/**
				* Scale X
				* @see https://tailwindcss.com/docs/scale
				*/
				"scale-x": [{ "scale-x": [scale] }],
				/**
				* Scale Y
				* @see https://tailwindcss.com/docs/scale
				*/
				"scale-y": [{ "scale-y": [scale] }],
				/**
				* Rotate
				* @see https://tailwindcss.com/docs/rotate
				*/
				rotate: [{ rotate: [isInteger, isArbitraryValue] }],
				/**
				* Translate X
				* @see https://tailwindcss.com/docs/translate
				*/
				"translate-x": [{ "translate-x": [translate] }],
				/**
				* Translate Y
				* @see https://tailwindcss.com/docs/translate
				*/
				"translate-y": [{ "translate-y": [translate] }],
				/**
				* Skew X
				* @see https://tailwindcss.com/docs/skew
				*/
				"skew-x": [{ "skew-x": [skew] }],
				/**
				* Skew Y
				* @see https://tailwindcss.com/docs/skew
				*/
				"skew-y": [{ "skew-y": [skew] }],
				/**
				* Transform Origin
				* @see https://tailwindcss.com/docs/transform-origin
				*/
				"transform-origin": [{ origin: [
					"center",
					"top",
					"top-right",
					"right",
					"bottom-right",
					"bottom",
					"bottom-left",
					"left",
					"top-left",
					isArbitraryValue
				] }],
				/**
				* Accent Color
				* @see https://tailwindcss.com/docs/accent-color
				*/
				accent: [{ accent: ["auto", colors] }],
				/**
				* Appearance
				* @see https://tailwindcss.com/docs/appearance
				*/
				appearance: ["appearance-none"],
				/**
				* Cursor
				* @see https://tailwindcss.com/docs/cursor
				*/
				cursor: [{ cursor: [
					"auto",
					"default",
					"pointer",
					"wait",
					"text",
					"move",
					"help",
					"not-allowed",
					"none",
					"context-menu",
					"progress",
					"cell",
					"crosshair",
					"vertical-text",
					"alias",
					"copy",
					"no-drop",
					"grab",
					"grabbing",
					"all-scroll",
					"col-resize",
					"row-resize",
					"n-resize",
					"e-resize",
					"s-resize",
					"w-resize",
					"ne-resize",
					"nw-resize",
					"se-resize",
					"sw-resize",
					"ew-resize",
					"ns-resize",
					"nesw-resize",
					"nwse-resize",
					"zoom-in",
					"zoom-out",
					isArbitraryValue
				] }],
				/**
				* Caret Color
				* @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
				*/
				"caret-color": [{ caret: [colors] }],
				/**
				* Pointer Events
				* @see https://tailwindcss.com/docs/pointer-events
				*/
				"pointer-events": [{ "pointer-events": ["none", "auto"] }],
				/**
				* Resize
				* @see https://tailwindcss.com/docs/resize
				*/
				resize: [{ resize: [
					"none",
					"y",
					"x",
					""
				] }],
				/**
				* Scroll Behavior
				* @see https://tailwindcss.com/docs/scroll-behavior
				*/
				"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
				/**
				* Scroll Margin
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-m": [{ "scroll-m": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin X
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-mx": [{ "scroll-mx": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin Y
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-my": [{ "scroll-my": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin Start
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-ms": [{ "scroll-ms": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin End
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-me": [{ "scroll-me": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin Top
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-mt": [{ "scroll-mt": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin Right
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-mr": [{ "scroll-mr": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin Bottom
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-mb": [{ "scroll-mb": getSpacingWithArbitrary() }],
				/**
				* Scroll Margin Left
				* @see https://tailwindcss.com/docs/scroll-margin
				*/
				"scroll-ml": [{ "scroll-ml": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-p": [{ "scroll-p": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding X
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-px": [{ "scroll-px": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding Y
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-py": [{ "scroll-py": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding Start
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-ps": [{ "scroll-ps": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding End
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-pe": [{ "scroll-pe": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding Top
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-pt": [{ "scroll-pt": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding Right
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-pr": [{ "scroll-pr": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding Bottom
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-pb": [{ "scroll-pb": getSpacingWithArbitrary() }],
				/**
				* Scroll Padding Left
				* @see https://tailwindcss.com/docs/scroll-padding
				*/
				"scroll-pl": [{ "scroll-pl": getSpacingWithArbitrary() }],
				/**
				* Scroll Snap Align
				* @see https://tailwindcss.com/docs/scroll-snap-align
				*/
				"snap-align": [{ snap: [
					"start",
					"end",
					"center",
					"align-none"
				] }],
				/**
				* Scroll Snap Stop
				* @see https://tailwindcss.com/docs/scroll-snap-stop
				*/
				"snap-stop": [{ snap: ["normal", "always"] }],
				/**
				* Scroll Snap Type
				* @see https://tailwindcss.com/docs/scroll-snap-type
				*/
				"snap-type": [{ snap: [
					"none",
					"x",
					"y",
					"both"
				] }],
				/**
				* Scroll Snap Type Strictness
				* @see https://tailwindcss.com/docs/scroll-snap-type
				*/
				"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
				/**
				* Touch Action
				* @see https://tailwindcss.com/docs/touch-action
				*/
				touch: [{ touch: [
					"auto",
					"none",
					"pinch-zoom",
					"manipulation",
					{ pan: [
						"x",
						"left",
						"right",
						"y",
						"up",
						"down"
					] }
				] }],
				/**
				* User Select
				* @see https://tailwindcss.com/docs/user-select
				*/
				select: [{ select: [
					"none",
					"text",
					"all",
					"auto"
				] }],
				/**
				* Will Change
				* @see https://tailwindcss.com/docs/will-change
				*/
				"will-change": [{ "will-change": [
					"auto",
					"scroll",
					"contents",
					"transform",
					isArbitraryValue
				] }],
				/**
				* Fill
				* @see https://tailwindcss.com/docs/fill
				*/
				fill: [{ fill: [colors, "none"] }],
				/**
				* Stroke Width
				* @see https://tailwindcss.com/docs/stroke-width
				*/
				"stroke-w": [{ stroke: [isLength, isArbitraryNumber] }],
				/**
				* Stroke
				* @see https://tailwindcss.com/docs/stroke
				*/
				stroke: [{ stroke: [colors, "none"] }],
				/**
				* Screen Readers
				* @see https://tailwindcss.com/docs/screen-readers
				*/
				sr: ["sr-only", "not-sr-only"]
			},
			conflictingClassGroups: {
				overflow: ["overflow-x", "overflow-y"],
				overscroll: ["overscroll-x", "overscroll-y"],
				inset: [
					"inset-x",
					"inset-y",
					"start",
					"end",
					"top",
					"right",
					"bottom",
					"left"
				],
				"inset-x": ["right", "left"],
				"inset-y": ["top", "bottom"],
				flex: [
					"basis",
					"grow",
					"shrink"
				],
				gap: ["gap-x", "gap-y"],
				p: [
					"px",
					"py",
					"ps",
					"pe",
					"pt",
					"pr",
					"pb",
					"pl"
				],
				px: ["pr", "pl"],
				py: ["pt", "pb"],
				m: [
					"mx",
					"my",
					"ms",
					"me",
					"mt",
					"mr",
					"mb",
					"ml"
				],
				mx: ["mr", "ml"],
				my: ["mt", "mb"],
				"font-size": ["leading"],
				"fvn-normal": [
					"fvn-ordinal",
					"fvn-slashed-zero",
					"fvn-figure",
					"fvn-spacing",
					"fvn-fraction"
				],
				"fvn-ordinal": ["fvn-normal"],
				"fvn-slashed-zero": ["fvn-normal"],
				"fvn-figure": ["fvn-normal"],
				"fvn-spacing": ["fvn-normal"],
				"fvn-fraction": ["fvn-normal"],
				rounded: [
					"rounded-s",
					"rounded-e",
					"rounded-t",
					"rounded-r",
					"rounded-b",
					"rounded-l",
					"rounded-ss",
					"rounded-se",
					"rounded-ee",
					"rounded-es",
					"rounded-tl",
					"rounded-tr",
					"rounded-br",
					"rounded-bl"
				],
				"rounded-s": ["rounded-ss", "rounded-es"],
				"rounded-e": ["rounded-se", "rounded-ee"],
				"rounded-t": ["rounded-tl", "rounded-tr"],
				"rounded-r": ["rounded-tr", "rounded-br"],
				"rounded-b": ["rounded-br", "rounded-bl"],
				"rounded-l": ["rounded-tl", "rounded-bl"],
				"border-spacing": ["border-spacing-x", "border-spacing-y"],
				"border-w": [
					"border-w-s",
					"border-w-e",
					"border-w-t",
					"border-w-r",
					"border-w-b",
					"border-w-l"
				],
				"border-w-x": ["border-w-r", "border-w-l"],
				"border-w-y": ["border-w-t", "border-w-b"],
				"border-color": [
					"border-color-t",
					"border-color-r",
					"border-color-b",
					"border-color-l"
				],
				"border-color-x": ["border-color-r", "border-color-l"],
				"border-color-y": ["border-color-t", "border-color-b"],
				"scroll-m": [
					"scroll-mx",
					"scroll-my",
					"scroll-ms",
					"scroll-me",
					"scroll-mt",
					"scroll-mr",
					"scroll-mb",
					"scroll-ml"
				],
				"scroll-mx": ["scroll-mr", "scroll-ml"],
				"scroll-my": ["scroll-mt", "scroll-mb"],
				"scroll-p": [
					"scroll-px",
					"scroll-py",
					"scroll-ps",
					"scroll-pe",
					"scroll-pt",
					"scroll-pr",
					"scroll-pb",
					"scroll-pl"
				],
				"scroll-px": ["scroll-pr", "scroll-pl"],
				"scroll-py": ["scroll-pt", "scroll-pb"]
			},
			conflictingClassGroupModifiers: { "font-size": ["leading"] }
		};
	}
	/**
	* @param baseConfig Config where other config will be merged into. This object will be mutated.
	* @param configExtension Partial config to merge into the `baseConfig`.
	*/
	function mergeConfigs(baseConfig, configExtension) {
		for (var key in configExtension) mergePropertyRecursively(baseConfig, key, configExtension[key]);
		return baseConfig;
	}
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var overrideTypes = /*#__PURE__*/ new Set([
		"string",
		"number",
		"boolean"
	]);
	function mergePropertyRecursively(baseObject, mergeKey, mergeValue) {
		if (!hasOwnProperty.call(baseObject, mergeKey) || overrideTypes.has(typeof mergeValue) || mergeValue === null) {
			baseObject[mergeKey] = mergeValue;
			return;
		}
		if (Array.isArray(mergeValue) && Array.isArray(baseObject[mergeKey])) {
			baseObject[mergeKey] = baseObject[mergeKey].concat(mergeValue);
			return;
		}
		if (typeof mergeValue === "object" && typeof baseObject[mergeKey] === "object") {
			if (baseObject[mergeKey] === null) {
				baseObject[mergeKey] = mergeValue;
				return;
			}
			for (var nextKey in mergeValue) mergePropertyRecursively(baseObject[mergeKey], nextKey, mergeValue[nextKey]);
		}
	}
	function extendTailwindMerge(configExtension) {
		for (var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) createConfig[_key - 1] = arguments[_key];
		return typeof configExtension === "function" ? createTailwindMerge.apply(void 0, [getDefaultConfig, configExtension].concat(createConfig)) : createTailwindMerge.apply(void 0, [function() {
			return mergeConfigs(getDefaultConfig(), configExtension);
		}].concat(createConfig));
	}
	var twMerge = /*#__PURE__*/ createTailwindMerge(getDefaultConfig);
	/**
	* @deprecated Will be removed in next major version. Use `twJoin` instead.
	*/
	var join = twJoin;
	exports.createTailwindMerge = createTailwindMerge;
	exports.extendTailwindMerge = extendTailwindMerge;
	exports.fromTheme = fromTheme;
	exports.getDefaultConfig = getDefaultConfig;
	exports.join = join;
	exports.mergeConfigs = mergeConfigs;
	exports.twJoin = twJoin;
	exports.twMerge = twMerge;
	exports.validators = validators;
}));
//#endregion
//#region ../../node_modules/tailwind-merge/dist/index.js
var require_dist$1 = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_tailwind_merge_cjs_production_min();
	else module.exports = require_tailwind_merge_cjs_development();
}));
//#endregion
//#region ../../node_modules/tailwind-styled-components/dist/tailwind.js
var require_tailwind = /* @__PURE__ */ __commonJSMin(((exports, module, this$5) => {
	var __importDefault = this$5 && this$5.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cleanTemplate = exports.mergeArrays = void 0;
	var react_1 = __importDefault(require_builtin_esm_external_require_react());
	var domElements_1 = __importDefault(require_domElements());
	var tailwind_merge_1 = require_dist$1();
	var isTwElement = Symbol("isTwElement?");
	var mergeArrays = (template, templateElements) => {
		return template.reduce((acc, c, i) => acc.concat(c || [], templateElements[i] || []), []);
	};
	exports.mergeArrays = mergeArrays;
	var cleanTemplate = (template, inheritedClasses = "") => {
		const newClasses = template.join(" ").trim().replace(/\n/g, " ").replace(/\s{2,}/g, " ").split(" ").filter((c) => c !== ",");
		const inheritedClassesArray = inheritedClasses ? inheritedClasses.split(" ") : [];
		return (0, tailwind_merge_1.twMerge)(...newClasses.concat(inheritedClassesArray).filter((c) => c !== " "));
	};
	exports.cleanTemplate = cleanTemplate;
	var removeTransientProps = ([key]) => key.charAt(0) !== "$";
	var templateFunctionFactory = (Element) => {
		return (template, ...templateElements) => {
			const TwComponent = react_1.default.forwardRef(({ $as, ...props }, ref) => {
				const FinalElement = $as || Element;
				const filteredProps = FinalElement[isTwElement] === true ? props : Object.fromEntries(Object.entries(props).filter(removeTransientProps));
				return react_1.default.createElement(FinalElement, {
					...filteredProps,
					ref,
					className: (0, exports.cleanTemplate)((0, exports.mergeArrays)(template, templateElements.map((t) => t({
						...props,
						$as
					}))), props.className)
				});
			});
			TwComponent[isTwElement] = true;
			if (typeof Element !== "string") TwComponent.displayName = Element.displayName || Element.name || "tw.Component";
			else TwComponent.displayName = "tw." + Element;
			return TwComponent;
		};
	};
	var intrinsicElementsMap = domElements_1.default.reduce((acc, DomElement) => ({
		...acc,
		[DomElement]: templateFunctionFactory(DomElement)
	}), {});
	exports.default = Object.assign(templateFunctionFactory, intrinsicElementsMap);
}));
//#endregion
//#region ../../node_modules/tailwind-styled-components/dist/index.js
var require_dist = /* @__PURE__ */ __commonJSMin(((exports, module, this$4) => {
	var __importDefault = this$4 && this$4.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = void 0;
	exports.default = __importDefault(require_tailwind()).default;
}));
//#endregion
//#region src/components/atoms/avatar/styled.ts
var import_classnames = /* @__PURE__ */ __toESM(require_classnames());
var import_dist = /* @__PURE__ */ __toESM(require_dist());
var AvatarVariantStyles = {
	circular: "rounded-full",
	rounded: "rounded-md"
};
var AvatarSizesStyle = {
	4: "h-4 w-4 text-xs",
	6: "h-6 w-6 text-xs",
	8: "h-8 w-8 text-sm",
	10: "h-10 w-10 text-medium",
	12: "h-12 w-12 text-lg",
	14: "h-14 w-14 text-xl",
	16: "h-16 w-16 text-2xl"
};
var StyledImgAvatar = import_dist.default.img`
  ${({ $variant }) => AvatarVariantStyles[$variant]}
  ${({ $size }) => AvatarSizesStyle[$size]}
  inline-block
`;
var StyledImgAvatarStacked = import_dist.default.img`
  ${({ $variant }) => AvatarVariantStyles[$variant]}
  ${({ $size }) => AvatarSizesStyle[$size]}
  inline-block
  ring-2
  ring-white
`;
var StyledSpanAvatar = import_dist.default.span`
  ${({ $variant }) => AvatarVariantStyles[$variant]}
  ${({ $size }) => AvatarSizesStyle[$size]}
  inline-flex
  items-center
  justify-center
  bg-gray-500
  select-none
`;
var StyledSpanAvatarStacked = import_dist.default.span`
  ${({ $variant }) => AvatarVariantStyles[$variant]}
  ${({ $size }) => AvatarSizesStyle[$size]}
  select-none
  inline-flex
  items-center
  justify-center
  bg-gray-500
  ring-2
  ring-white
`;
var StyledSpanAvatarInitials = import_dist.default.span`
  ${({ $size }) => AvatarSizesStyle[$size]}
  font-medium
  leading-none
  text-white
`;
var StyledSvgAvatar = import_dist.default.svg`
  h-full
  w-full
  text-gray-300
`;
//#endregion
//#region src/components/atoms/avatar/Avatar.tsx
var avatarColorsMap = [
	"bg-orange-700",
	"bg-lemon-700",
	"bg-green-700",
	"bg-aqua-700",
	"bg-blue-700",
	"bg-avocado-700",
	"bg-lime-700"
];
var Avatar = ({ className, imgSrc, size = 10, stacked, text, variant = "circular" }) => {
	const ImgAvatar = stacked ? StyledImgAvatarStacked : StyledImgAvatar;
	const SpanAvatar = stacked ? StyledSpanAvatarStacked : StyledSpanAvatar;
	if (imgSrc) return /* @__PURE__ */ React.createElement(ImgAvatar, {
		$size: size,
		$variant: variant,
		alt: "avatar",
		className,
		src: imgSrc
	});
	else if (text) {
		const initials = getInitials(text, { maxInitials: 2 });
		const color = convertTextToColor(initials, avatarColorsMap);
		return /* @__PURE__ */ React.createElement(SpanAvatar, {
			$size: size,
			$variant: variant,
			className: (0, import_classnames.default)(color, className)
		}, /* @__PURE__ */ React.createElement(StyledSpanAvatarInitials, null, initials));
	}
	return /* @__PURE__ */ React.createElement(SpanAvatar, {
		$size: size,
		$variant: variant,
		className: (0, import_classnames.default)("overflow-hidden bg-gray-100", className)
	}, /* @__PURE__ */ React.createElement(StyledSvgAvatar, {
		fill: "currentColor",
		viewBox: "0 0 24 24"
	}, /* @__PURE__ */ React.createElement("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })));
};
var AvatarMemo = memo(Avatar);
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var t$3 = typeof window != "undefined" ? useLayoutEffect : useEffect;
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-latest-value.js
function s$6(e) {
	let r = useRef(e);
	return t$3(() => {
		r.current = e;
	}, [e]), r;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-computed.js
function i$3(e, o) {
	let [u, t] = useState(e), r = s$6(e);
	return t$3(() => t(r.current), [
		r,
		t,
		...o
	]), u;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/disposables.js
function o$5() {
	let a = [], i = [], n = {
		enqueue(e) {
			i.push(e);
		},
		addEventListener(e, t, r, s) {
			return e.addEventListener(t, r, s), n.add(() => e.removeEventListener(t, r, s));
		},
		requestAnimationFrame(...e) {
			let t = requestAnimationFrame(...e);
			return n.add(() => cancelAnimationFrame(t));
		},
		nextFrame(...e) {
			return n.requestAnimationFrame(() => n.requestAnimationFrame(...e));
		},
		setTimeout(...e) {
			let t = setTimeout(...e);
			return n.add(() => clearTimeout(t));
		},
		add(e) {
			return a.push(e), () => {
				let t = a.indexOf(e);
				if (t >= 0) {
					let [r] = a.splice(t, 1);
					r();
				}
			};
		},
		dispose() {
			for (let e of a.splice(0)) e();
		},
		async workQueue() {
			for (let e of i.splice(0)) await e();
		}
	};
	return n;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-disposables.js
function p$5() {
	let [e] = useState(o$5);
	return useEffect(() => () => e.dispose(), [e]), e;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-event.js
var o$4 = function(t) {
	let e = s$6(t);
	return React.useCallback((...r) => e.current(...r), [e]);
};
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var r$4 = { serverHandoffComplete: !1 };
function a$4() {
	let [e, f] = useState(r$4.serverHandoffComplete);
	return useEffect(() => {
		e !== !0 && f(!0);
	}, [e]), useEffect(() => {
		r$4.serverHandoffComplete === !1 && (r$4.serverHandoffComplete = !0);
	}, []), e;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-id.js
var u$5;
var l$3 = 0;
function r$3() {
	return ++l$3;
}
var I = (u$5 = React.useId) != null ? u$5 : function() {
	let n = a$4(), [e, o] = React.useState(n ? r$3 : null);
	return t$3(() => {
		e === null && o(r$3());
	}, [e]), e != null ? "" + e : void 0;
};
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/match.js
function u$4(r, n, ...a) {
	if (r in n) {
		let e = n[r];
		return typeof e == "function" ? e(...a) : e;
	}
	let t = /* @__PURE__ */ new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e) => `"${e}"`).join(", ")}.`);
	throw Error.captureStackTrace && Error.captureStackTrace(t, u$4), t;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/owner.js
function t$2(n) {
	return typeof window == "undefined" ? null : n instanceof Node ? n.ownerDocument : n != null && n.hasOwnProperty("current") && n.current instanceof Node ? n.current.ownerDocument : document;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/focus-management.js
var f$6 = [
	"[contentEditable=true]",
	"[tabindex]",
	"a[href]",
	"area[href]",
	"button:not([disabled])",
	"iframe",
	"input:not([disabled])",
	"select:not([disabled])",
	"textarea:not([disabled])"
].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var p$4 = ((o) => (o[o.First = 1] = "First", o[o.Previous = 2] = "Previous", o[o.Next = 4] = "Next", o[o.Last = 8] = "Last", o[o.WrapAround = 16] = "WrapAround", o[o.NoScroll = 32] = "NoScroll", o))(p$4 || {});
var L$3 = ((n) => (n[n.Error = 0] = "Error", n[n.Overflow = 1] = "Overflow", n[n.Success = 2] = "Success", n[n.Underflow = 3] = "Underflow", n))(L$3 || {});
var N$7 = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(N$7 || {});
function T$5(e = document.body) {
	return e == null ? [] : Array.from(e.querySelectorAll(f$6));
}
var b$5 = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(b$5 || {});
function S$4(e, r = 0) {
	var t;
	return e === ((t = t$2(e)) == null ? void 0 : t.body) ? !1 : u$4(r, {
		[0]() {
			return e.matches(f$6);
		},
		[1]() {
			let l = e;
			for (; l !== null;) {
				if (l.matches(f$6)) return !0;
				l = l.parentElement;
			}
			return !1;
		}
	});
}
function F$5(e) {
	e?.focus({ preventScroll: !0 });
}
var M$4 = ["textarea", "input"].join(",");
function h$4(e) {
	var r, t;
	return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, M$4)) != null ? t : !1;
}
function v$4(e, r = (t) => t) {
	return e.slice().sort((t, l) => {
		let n = r(t), i = r(l);
		if (n === null || i === null) return 0;
		let o = n.compareDocumentPosition(i);
		return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
	});
}
function H$4(e, r, t = !0) {
	let l = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? v$4(e) : e : T$5(e), i = l.activeElement, o = (() => {
		if (r & 5) return 1;
		if (r & 10) return -1;
		throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
	})(), d = (() => {
		if (r & 1) return 0;
		if (r & 2) return Math.max(0, n.indexOf(i)) - 1;
		if (r & 4) return Math.max(0, n.indexOf(i)) + 1;
		if (r & 8) return n.length - 1;
		throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
	})(), m = r & 32 ? { preventScroll: !0 } : {}, c = 0, s = n.length, u;
	do {
		if (c >= s || c + s <= 0) return 0;
		let a = d + c;
		if (r & 16) a = (a + s) % s;
		else {
			if (a < 0) return 3;
			if (a >= s) return 1;
		}
		u = n[a], u?.focus(m), c += o;
	} while (u !== l.activeElement);
	return r & 6 && h$4(u) && u.select(), u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-window-event.js
function s$5(e, r, n) {
	let o = s$6(r);
	useEffect(() => {
		function t(i) {
			o.current(i);
		}
		return window.addEventListener(e, t, n), () => window.removeEventListener(e, t, n);
	}, [e, n]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-outside-click.js
function L$2(f, c, u = !0) {
	let l = useRef(!1);
	useEffect(() => {
		requestAnimationFrame(() => {
			l.current = u;
		});
	}, [u]);
	function i(t, o) {
		if (!l.current || t.defaultPrevented) return;
		let E = function r(e) {
			return typeof e == "function" ? r(e()) : Array.isArray(e) || e instanceof Set ? e : [e];
		}(f), n = o(t);
		if (n !== null && !!n.ownerDocument.documentElement.contains(n)) {
			for (let r of E) {
				if (r === null) continue;
				let e = r instanceof HTMLElement ? r : r.current;
				if (e != null && e.contains(n)) return;
			}
			return !S$4(n, b$5.Loose) && n.tabIndex !== -1 && t.preventDefault(), c(t, n);
		}
	}
	s$5("click", (t) => i(t, (o) => o.target), !0), s$5("blur", (t) => i(t, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
function i$2(t) {
	var n;
	if (t.type) return t.type;
	let e = (n = t.as) != null ? n : "button";
	if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function s$4(t, e) {
	let [n, u] = useState(() => i$2(t));
	return t$3(() => {
		u(i$2(t));
	}, [t.type, t.as]), t$3(() => {
		n || !e.current || e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
	}, [n, e]), n;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var u$3 = Symbol();
function T$4(t, n = !0) {
	return Object.assign(t, { [u$3]: n });
}
function y$3(...t) {
	let n = useRef(t);
	useEffect(() => {
		n.current = t;
	}, [t]);
	let c = o$4((e) => {
		for (let o of n.current) o != null && (typeof o == "function" ? o(e) : o.current = e);
	});
	return t.every((e) => e == null || (e == null ? void 0 : e[u$3])) ? void 0 : c;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-tree-walker.js
function F$4({ container: e, accept: t, walk: r, enabled: c = !0 }) {
	let o = useRef(t), l = useRef(r);
	useEffect(() => {
		o.current = t, l.current = r;
	}, [t, r]), t$3(() => {
		if (!e || !c) return;
		let n = t$2(e);
		if (!n) return;
		let f = o.current, p = l.current, d = Object.assign((i) => f(i), { acceptNode: f }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
		for (; u.nextNode();) p(u.currentNode);
	}, [
		e,
		c,
		o,
		l
	]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/calculate-active-index.js
function f$5(r) {
	throw new Error("Unexpected object: " + r);
}
var a$3 = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(a$3 || {});
function x$7(r, n) {
	let t = n.resolveItems();
	if (t.length <= 0) return null;
	let l = n.resolveActiveIndex(), s = l != null ? l : -1, d = (() => {
		switch (r.focus) {
			case 0: return t.findIndex((e) => !n.resolveDisabled(e));
			case 1: {
				let e = t.slice().reverse().findIndex((i, c, u) => s !== -1 && u.length - c - 1 >= s ? !1 : !n.resolveDisabled(i));
				return e === -1 ? e : t.length - 1 - e;
			}
			case 2: return t.findIndex((e, i) => i <= s ? !1 : !n.resolveDisabled(e));
			case 3: {
				let e = t.slice().reverse().findIndex((i) => !n.resolveDisabled(i));
				return e === -1 ? e : t.length - 1 - e;
			}
			case 4: return t.findIndex((e) => n.resolveId(e) === r.id);
			case 5: return null;
			default: f$5(r);
		}
	})();
	return d === -1 ? l : d;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/render.js
var x$6 = ((n) => (n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))(x$6 || {});
var R = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(R || {});
function _$2({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: a, visible: s = !0, name: l }) {
	let o = y$2(t, r);
	if (s) return f$4(o, e, n, l);
	let d = a != null ? a : 0;
	if (d & 2) {
		let { static: i = !1, ...u } = o;
		if (i) return f$4(u, e, n, l);
	}
	if (d & 1) {
		let { unmount: i = !0, ...u } = o;
		return u$4(i ? 0 : 1, {
			[0]() {
				return null;
			},
			[1]() {
				return f$4({
					...u,
					hidden: !0,
					style: { display: "none" }
				}, e, n, l);
			}
		});
	}
	return f$4(o, e, n, l);
}
function f$4(r, t = {}, e, n) {
	let { as: a = e, children: s, refName: l = "ref", ...o } = m$2(r, ["unmount", "static"]), d = r.ref !== void 0 ? { [l]: r.ref } : {}, i = typeof s == "function" ? s(t) : s;
	o.className && typeof o.className == "function" && (o.className = o.className(t));
	let u = {};
	if (a === Fragment && Object.keys(g$4(o)).length > 0) {
		if (!isValidElement(i) || Array.isArray(i) && i.length > 1) throw new Error([
			"Passing props on \"Fragment\"!",
			"",
			`The current component <${n} /> is rendering a "Fragment".`,
			"However we need to passthrough the following props:",
			Object.keys(o).map((p) => `  - ${p}`).join(`
`),
			"",
			"You can apply a few solutions:",
			["Add an `as=\"...\"` prop, to ensure that we render an actual element instead of a \"Fragment\".", "Render a single element as the child so that we can forward the props onto that element."].map((p) => `  - ${p}`).join(`
`)
		].join(`
`));
		return cloneElement(i, Object.assign({}, y$2(i.props, g$4(m$2(o, ["ref"]))), u, d));
	}
	return createElement(a, Object.assign({}, m$2(o, ["ref"]), a !== Fragment && d, a !== Fragment && u), i);
}
function y$2(...r) {
	if (r.length === 0) return {};
	if (r.length === 1) return r[0];
	let t = {}, e = {};
	for (let a of r) for (let s in a) s.startsWith("on") && typeof a[s] == "function" ? (e[s] ?? (e[s] = []), e[s].push(a[s])) : t[s] = a[s];
	if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((a) => [a, void 0])));
	for (let a in e) Object.assign(t, { [a](s, ...l) {
		let o = e[a];
		for (let d of o) {
			if (s.defaultPrevented) return;
			d(s, ...l);
		}
	} });
	return t;
}
function H$3(r) {
	var t;
	return Object.assign(forwardRef(r), { displayName: (t = r.displayName) != null ? t : r.name });
}
function g$4(r) {
	let t = Object.assign({}, r);
	for (let e in t) t[e] === void 0 && delete t[e];
	return t;
}
function m$2(r, t = []) {
	let e = Object.assign({}, r);
	for (let n of t) n in e && delete e[n];
	return e;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/bugs.js
function r$2(n) {
	let e = n.parentElement, l = null;
	for (; e && !(e instanceof HTMLFieldSetElement);) e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
	let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
	return t && i$1(l) ? !1 : t;
}
function i$1(n) {
	if (!n) return !1;
	let e = n.previousElementSibling;
	for (; e !== null;) {
		if (e instanceof HTMLLegendElement) return !1;
		e = e.previousElementSibling;
	}
	return !0;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/form.js
function e$3(n = {}, r = null, t = []) {
	for (let [i, o] of Object.entries(n)) f$3(t, s$3(r, i), o);
	return t;
}
function s$3(n, r) {
	return n ? n + "[" + r + "]" : r;
}
function f$3(n, r, t) {
	if (Array.isArray(t)) for (let [i, o] of t.entries()) f$3(n, s$3(r, i.toString()), o);
	else t instanceof Date ? n.push([r, t.toISOString()]) : typeof t == "boolean" ? n.push([r, t ? "1" : "0"]) : typeof t == "string" ? n.push([r, t]) : typeof t == "number" ? n.push([r, `${t}`]) : t == null ? n.push([r, ""]) : e$3(t, r, n);
}
function p$3(n) {
	var t;
	let r = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");
	if (!!r) {
		for (let i of r.elements) if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
			i.click();
			return;
		}
	}
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/internal/hidden.js
var a$2 = "div";
var s$2 = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(s$2 || {});
var h$3 = H$3(function(t, o) {
	let { features: e = 1, ...r } = t;
	return _$2({
		ourProps: {
			ref: o,
			"aria-hidden": (e & 2) === 2 ? !0 : void 0,
			style: {
				position: "absolute",
				width: 1,
				height: 1,
				padding: 0,
				margin: -1,
				overflow: "hidden",
				clip: "rect(0, 0, 0, 0)",
				whiteSpace: "nowrap",
				borderWidth: "0",
				...(e & 4) === 4 && (e & 2) !== 2 && { display: "none" }
			}
		},
		theirProps: r,
		slot: {},
		defaultTag: a$2,
		name: "Hidden"
	});
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/internal/open-closed.js
var o$3 = createContext(null);
o$3.displayName = "OpenClosedContext";
var p$2 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(p$2 || {});
function s$1() {
	return useContext(o$3);
}
function C$6({ value: t, children: n }) {
	return React.createElement(o$3.Provider, { value: t }, n);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/keyboard.js
var o$2 = ((r) => (r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))(o$2 || {});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/combobox/combobox.js
var Se$3 = ((o) => (o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))(Se$3 || {});
var Pe$1 = ((o) => (o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))(Pe$1 || {});
var Ae$1 = ((o) => (o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))(Ae$1 || {});
var Ie$2 = ((t) => (t[t.OpenCombobox = 0] = "OpenCombobox", t[t.CloseCombobox = 1] = "CloseCombobox", t[t.GoToOption = 2] = "GoToOption", t[t.RegisterOption = 3] = "RegisterOption", t[t.UnregisterOption = 4] = "UnregisterOption", t))(Ie$2 || {});
function q$2(n, a = (o) => o) {
	let o = n.activeOptionIndex !== null ? n.options[n.activeOptionIndex] : null, e = v$4(a(n.options.slice()), (t) => t.dataRef.current.domRef.current), i = o ? e.indexOf(o) : null;
	return i === -1 && (i = null), {
		options: e,
		activeOptionIndex: i
	};
}
var De$2 = {
	[1](n) {
		return n.dataRef.current.disabled || n.comboboxState === 1 ? n : {
			...n,
			activeOptionIndex: null,
			comboboxState: 1
		};
	},
	[0](n) {
		if (n.dataRef.current.disabled || n.comboboxState === 0) return n;
		let a = n.activeOptionIndex, { isSelected: o } = n.dataRef.current, e = n.options.findIndex((i) => o(i.dataRef.current.value));
		return e !== -1 && (a = e), {
			...n,
			comboboxState: 0,
			activeOptionIndex: a
		};
	},
	[2](n, a) {
		var i;
		if (n.dataRef.current.disabled || n.dataRef.current.optionsRef.current && !n.dataRef.current.optionsPropsRef.current.static && n.comboboxState === 1) return n;
		let o = q$2(n);
		if (o.activeOptionIndex === null) {
			let t = o.options.findIndex((p) => !p.dataRef.current.disabled);
			t !== -1 && (o.activeOptionIndex = t);
		}
		let e = x$7(a, {
			resolveItems: () => o.options,
			resolveActiveIndex: () => o.activeOptionIndex,
			resolveId: (t) => t.id,
			resolveDisabled: (t) => t.dataRef.current.disabled
		});
		return {
			...n,
			...o,
			activeOptionIndex: e,
			activationTrigger: (i = a.trigger) != null ? i : 1
		};
	},
	[3]: (n, a) => {
		let o = {
			id: a.id,
			dataRef: a.dataRef
		}, e = q$2(n, (t) => [...t, o]);
		n.activeOptionIndex === null && n.dataRef.current.isSelected(a.dataRef.current.value) && (e.activeOptionIndex = e.options.indexOf(o));
		let i = {
			...n,
			...e,
			activationTrigger: 1
		};
		return n.dataRef.current.__demoMode && n.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
	},
	[4]: (n, a) => {
		let o = q$2(n, (e) => {
			let i = e.findIndex((t) => t.id === a.id);
			return i !== -1 && e.splice(i, 1), e;
		});
		return {
			...n,
			...o,
			activationTrigger: 1
		};
	}
};
var X$2 = createContext(null);
X$2.displayName = "ComboboxActionsContext";
function N$6(n) {
	let a = useContext(X$2);
	if (a === null) {
		let o = /* @__PURE__ */ new Error(`<${n} /> is missing a parent <Combobox /> component.`);
		throw Error.captureStackTrace && Error.captureStackTrace(o, N$6), o;
	}
	return a;
}
var z$3 = createContext(null);
z$3.displayName = "ComboboxDataContext";
function k$3(n) {
	let a = useContext(z$3);
	if (a === null) {
		let o = /* @__PURE__ */ new Error(`<${n} /> is missing a parent <Combobox /> component.`);
		throw Error.captureStackTrace && Error.captureStackTrace(o, k$3), o;
	}
	return a;
}
function Ee$1(n, a) {
	return u$4(a.type, De$2, n, a);
}
var he$1 = Fragment;
var Le$3 = H$3(function(a, o) {
	let { name: e, value: i, onChange: t, disabled: p = !1, __demoMode: b = !1, nullable: r = !1, multiple: u = !1, ...C } = a, [f, R] = useReducer(Ee$1, {
		dataRef: createRef(),
		comboboxState: b ? 0 : 1,
		options: [],
		activeOptionIndex: null,
		activationTrigger: 1
	}), g = useRef(!1), x = useRef({
		static: !1,
		hold: !1
	}), c = useRef({ displayValue: void 0 }), m = useRef(null), U = useRef(null), M = useRef(null), h = useRef(null), D = o$4((s, d) => s === d), T = useCallback((s) => u$4(l.mode, {
		[1]: () => i.some((d) => D(d, s)),
		[0]: () => D(i, s)
	}), [i]), l = useMemo(() => ({
		...f,
		optionsPropsRef: x,
		inputPropsRef: c,
		labelRef: m,
		inputRef: U,
		buttonRef: M,
		optionsRef: h,
		value: i,
		disabled: p,
		mode: u ? 1 : 0,
		get activeOptionIndex() {
			if (g.current && f.activeOptionIndex === null && f.options.length > 0) {
				let s = f.options.findIndex((d) => !d.dataRef.current.disabled);
				if (s !== -1) return s;
			}
			return f.activeOptionIndex;
		},
		compare: D,
		isSelected: T,
		nullable: r,
		__demoMode: b
	}), [
		i,
		p,
		u,
		r,
		b,
		f
	]);
	t$3(() => {
		f.dataRef.current = l;
	}, [l]), L$2([
		l.buttonRef,
		l.inputRef,
		l.optionsRef
	], () => R({ type: 1 }), l.comboboxState === 0);
	let j = useMemo(() => ({
		open: l.comboboxState === 0,
		disabled: p,
		activeIndex: l.activeOptionIndex,
		activeOption: l.activeOptionIndex === null ? null : l.options[l.activeOptionIndex].dataRef.current.value
	}), [l, p]), v = useCallback(() => {
		var d;
		if (!l.inputRef.current) return;
		let s = c.current.displayValue;
		typeof s == "function" ? l.inputRef.current.value = (d = s(i)) != null ? d : "" : typeof i == "string" ? l.inputRef.current.value = i : l.inputRef.current.value = "";
	}, [
		i,
		l.inputRef,
		c
	]), P = o$4((s) => {
		let d = l.options.find((L) => L.id === s);
		!d || (K(d.dataRef.current.value), v());
	}), G = o$4(() => {
		if (l.activeOptionIndex !== null) {
			let { dataRef: s, id: d } = l.options[l.activeOptionIndex];
			K(s.current.value), v(), R({
				type: 2,
				focus: a$3.Specific,
				id: d
			});
		}
	}), oe = o$4(() => {
		R({ type: 0 }), g.current = !0;
	}), ne = o$4(() => {
		R({ type: 1 }), g.current = !1;
	}), re = o$4((s, d, L) => (g.current = !1, s === a$3.Specific ? R({
		type: 2,
		focus: a$3.Specific,
		id: d,
		trigger: L
	}) : R({
		type: 2,
		focus: s,
		trigger: L
	}))), ie = o$4((s, d) => (R({
		type: 3,
		id: s,
		dataRef: d
	}), () => R({
		type: 4,
		id: s
	}))), K = o$4((s) => u$4(l.mode, {
		[0]() {
			return t(s);
		},
		[1]() {
			let d = l.value.slice(), L = d.indexOf(s);
			return L === -1 ? d.push(s) : d.splice(L, 1), t(d);
		}
	})), ae = useMemo(() => ({
		onChange: K,
		registerOption: ie,
		goToOption: re,
		closeCombobox: ne,
		openCombobox: oe,
		selectActiveOption: G,
		selectOption: P
	}), []);
	t$3(() => {
		l.comboboxState === 1 && v();
	}, [v, l.comboboxState]), t$3(v, [v]);
	let le = o === null ? {} : { ref: o };
	return React.createElement(X$2.Provider, { value: ae }, React.createElement(z$3.Provider, { value: l }, React.createElement(C$6, { value: u$4(l.comboboxState, {
		[0]: p$2.Open,
		[1]: p$2.Closed
	}) }, e != null && i != null && e$3({ [e]: i }).map(([s, d]) => React.createElement(h$3, {
		features: s$2.Hidden,
		...g$4({
			key: s,
			as: "input",
			type: "hidden",
			hidden: !0,
			readOnly: !0,
			name: s,
			value: d
		})
	})), _$2({
		ourProps: le,
		theirProps: C,
		slot: j,
		defaultTag: he$1,
		name: "Combobox"
	}))));
});
var Me$3 = "input";
var _e$3 = H$3(function(a, o) {
	var h, D;
	let { value: e, onChange: i, displayValue: t, type: p = "text", ...b } = a, r = k$3("Combobox.Input"), u = N$6("Combobox.Input"), C = y$3(r.inputRef, o), f = r.inputPropsRef, R = `headlessui-combobox-input-${I()}`, g = p$5();
	t$3(() => {
		f.current.displayValue = t;
	}, [t, f]);
	let x = o$4((T) => {
		switch (T.key) {
			case o$2.Backspace:
			case o$2.Delete:
				if (r.mode !== 0 || !r.nullable) return;
				let l = T.currentTarget;
				g.requestAnimationFrame(() => {
					l.value === "" && (u.onChange(null), r.optionsRef.current && (r.optionsRef.current.scrollTop = 0), u.goToOption(a$3.Nothing));
				});
				break;
			case o$2.Enter:
				if (r.comboboxState !== 0) return;
				if (T.preventDefault(), T.stopPropagation(), r.activeOptionIndex === null) {
					u.closeCombobox();
					return;
				}
				u.selectActiveOption(), r.mode === 0 && u.closeCombobox();
				break;
			case o$2.ArrowDown: return T.preventDefault(), T.stopPropagation(), u$4(r.comboboxState, {
				[0]: () => {
					u.goToOption(a$3.Next);
				},
				[1]: () => {
					u.openCombobox();
				}
			});
			case o$2.ArrowUp: return T.preventDefault(), T.stopPropagation(), u$4(r.comboboxState, {
				[0]: () => {
					u.goToOption(a$3.Previous);
				},
				[1]: () => {
					u.openCombobox(), g.nextFrame(() => {
						r.value || u.goToOption(a$3.Last);
					});
				}
			});
			case o$2.Home:
			case o$2.PageUp: return T.preventDefault(), T.stopPropagation(), u.goToOption(a$3.First);
			case o$2.End:
			case o$2.PageDown: return T.preventDefault(), T.stopPropagation(), u.goToOption(a$3.Last);
			case o$2.Escape: return r.comboboxState !== 0 ? void 0 : (T.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && T.stopPropagation(), u.closeCombobox());
			case o$2.Tab:
				if (r.comboboxState !== 0) return;
				u.selectActiveOption(), u.closeCombobox();
		}
	}), c = o$4((T) => {
		u.openCombobox(), i?.(T);
	}), m = i$3(() => {
		if (!!r.labelRef.current) return [r.labelRef.current.id].join(" ");
	}, [r.labelRef.current]), U = useMemo(() => ({
		open: r.comboboxState === 0,
		disabled: r.disabled
	}), [r]);
	return _$2({
		ourProps: {
			ref: C,
			id: R,
			role: "combobox",
			type: p,
			"aria-controls": (h = r.optionsRef.current) == null ? void 0 : h.id,
			"aria-expanded": r.disabled ? void 0 : r.comboboxState === 0,
			"aria-activedescendant": r.activeOptionIndex === null || (D = r.options[r.activeOptionIndex]) == null ? void 0 : D.id,
			"aria-multiselectable": r.mode === 1 ? !0 : void 0,
			"aria-labelledby": m,
			disabled: r.disabled,
			onKeyDown: x,
			onChange: c
		},
		theirProps: b,
		slot: U,
		defaultTag: Me$3,
		name: "Combobox.Input"
	});
});
var Fe$2 = "button";
var we$3 = H$3(function(a, o) {
	var x;
	let e = k$3("Combobox.Button"), i = N$6("Combobox.Button"), t = y$3(e.buttonRef, o), p = `headlessui-combobox-button-${I()}`, b = p$5(), r = o$4((c) => {
		switch (c.key) {
			case o$2.ArrowDown: return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && i.openCombobox(), b.nextFrame(() => {
				var m;
				return (m = e.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
			});
			case o$2.ArrowUp: return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && (i.openCombobox(), b.nextFrame(() => {
				e.value || i.goToOption(a$3.Last);
			})), b.nextFrame(() => {
				var m;
				return (m = e.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
			});
			case o$2.Escape: return e.comboboxState !== 0 ? void 0 : (c.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && c.stopPropagation(), i.closeCombobox(), b.nextFrame(() => {
				var m;
				return (m = e.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
			}));
			default: return;
		}
	}), u = o$4((c) => {
		if (r$2(c.currentTarget)) return c.preventDefault();
		e.comboboxState === 0 ? i.closeCombobox() : (c.preventDefault(), i.openCombobox()), b.nextFrame(() => {
			var m;
			return (m = e.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
		});
	}), C = i$3(() => {
		if (!!e.labelRef.current) return [e.labelRef.current.id, p].join(" ");
	}, [e.labelRef.current, p]), f = useMemo(() => ({
		open: e.comboboxState === 0,
		disabled: e.disabled
	}), [e]), R = a;
	return _$2({
		ourProps: {
			ref: t,
			id: p,
			type: s$4(a, e.buttonRef),
			tabIndex: -1,
			"aria-haspopup": !0,
			"aria-controls": (x = e.optionsRef.current) == null ? void 0 : x.id,
			"aria-expanded": e.disabled ? void 0 : e.comboboxState === 0,
			"aria-labelledby": C,
			disabled: e.disabled,
			onClick: u,
			onKeyDown: r
		},
		theirProps: R,
		slot: f,
		defaultTag: Fe$2,
		name: "Combobox.Button"
	});
});
var ke$2 = "label";
var Ue$1 = H$3(function(a, o) {
	let e = k$3("Combobox.Label"), i = `headlessui-combobox-label-${I()}`, t = y$3(e.labelRef, o), p = o$4(() => {
		var C;
		return (C = e.inputRef.current) == null ? void 0 : C.focus({ preventScroll: !0 });
	}), b = useMemo(() => ({
		open: e.comboboxState === 0,
		disabled: e.disabled
	}), [e]);
	return _$2({
		ourProps: {
			ref: t,
			id: i,
			onClick: p
		},
		theirProps: a,
		slot: b,
		defaultTag: ke$2,
		name: "Combobox.Label"
	});
});
var Be$3 = "ul";
var Ve$1 = x$6.RenderStrategy | x$6.Static;
var je$1 = H$3(function(a, o) {
	var g;
	let { hold: e = !1, ...i } = a, t = k$3("Combobox.Options"), p = y$3(t.optionsRef, o), b = `headlessui-combobox-options-${I()}`, r = s$1(), u = (() => r !== null ? r === p$2.Open : t.comboboxState === 0)();
	t$3(() => {
		var x;
		t.optionsPropsRef.current.static = (x = a.static) != null ? x : !1;
	}, [t.optionsPropsRef, a.static]), t$3(() => {
		t.optionsPropsRef.current.hold = e;
	}, [t.optionsPropsRef, e]), F$4({
		container: t.optionsRef.current,
		enabled: t.comboboxState === 0,
		accept(x) {
			return x.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : x.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
		},
		walk(x) {
			x.setAttribute("role", "none");
		}
	});
	let C = i$3(() => {
		var x, c, m;
		return (m = (x = t.labelRef.current) == null ? void 0 : x.id) != null ? m : (c = t.buttonRef.current) == null ? void 0 : c.id;
	}, [t.labelRef.current, t.buttonRef.current]), f = useMemo(() => ({ open: t.comboboxState === 0 }), [t]);
	return _$2({
		ourProps: {
			"aria-activedescendant": t.activeOptionIndex === null || (g = t.options[t.activeOptionIndex]) == null ? void 0 : g.id,
			"aria-labelledby": C,
			role: "listbox",
			id: b,
			ref: p
		},
		theirProps: i,
		slot: f,
		defaultTag: Be$3,
		features: Ve$1,
		visible: u,
		name: "Combobox.Options"
	});
});
var Ge$2 = "li";
var He$2 = H$3(function(a, o) {
	var l, j;
	let { disabled: e = !1, value: i, ...t } = a, p = k$3("Combobox.Option"), b = N$6("Combobox.Option"), r = `headlessui-combobox-option-${I()}`, u = p.activeOptionIndex !== null ? p.options[p.activeOptionIndex].id === r : !1, C = p.isSelected(i), f = useRef(null), R = s$6({
		disabled: e,
		value: i,
		domRef: f,
		textValue: (j = (l = f.current) == null ? void 0 : l.textContent) == null ? void 0 : j.toLowerCase()
	}), g = y$3(o, f), x = o$4(() => b.selectOption(r));
	t$3(() => b.registerOption(r, R), [R, r]);
	let c = useRef(!p.__demoMode);
	t$3(() => {
		if (!p.__demoMode) return;
		let v = o$5();
		return v.requestAnimationFrame(() => {
			c.current = !0;
		}), v.dispose;
	}, []), t$3(() => {
		if (p.comboboxState !== 0 || !u || !c.current || p.activationTrigger === 0) return;
		let v = o$5();
		return v.requestAnimationFrame(() => {
			var P, G;
			(G = (P = f.current) == null ? void 0 : P.scrollIntoView) == null || G.call(P, { block: "nearest" });
		}), v.dispose;
	}, [
		f,
		u,
		p.comboboxState,
		p.activationTrigger,
		p.activeOptionIndex
	]);
	let m = o$4((v) => {
		var P;
		if (e) return v.preventDefault();
		x(), p.mode === 0 && (b.closeCombobox(), (P = p.inputRef.current) == null || P.focus({ preventScroll: !0 }));
	}), U = o$4(() => {
		if (e) return b.goToOption(a$3.Nothing);
		b.goToOption(a$3.Specific, r);
	}), M = o$4(() => {
		e || u || b.goToOption(a$3.Specific, r, 0);
	}), h = o$4(() => {
		e || !u || p.optionsPropsRef.current.hold || b.goToOption(a$3.Nothing);
	}), D = useMemo(() => ({
		active: u,
		selected: C,
		disabled: e
	}), [
		u,
		C,
		e
	]);
	return _$2({
		ourProps: {
			id: r,
			ref: g,
			role: "option",
			tabIndex: e === !0 ? void 0 : -1,
			"aria-disabled": e === !0 ? !0 : void 0,
			"aria-selected": C === !0 ? !0 : void 0,
			disabled: void 0,
			onClick: m,
			onFocus: U,
			onPointerMove: M,
			onMouseMove: M,
			onPointerLeave: h,
			onMouseLeave: h
		},
		theirProps: t,
		slot: D,
		defaultTag: Ge$2,
		name: "Combobox.Option"
	});
});
var Ot = Object.assign(Le$3, {
	Input: _e$3,
	Button: we$3,
	Label: Ue$1,
	Options: je$1,
	Option: He$2
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var s = ((r) => (r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))(s || {});
function n$2() {
	let e = useRef(0);
	return s$5("keydown", (o) => {
		o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
	}, !0), e;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
function f$2() {
	let e = useRef(!1);
	return t$3(() => (e.current = !0, () => {
		e.current = !1;
	}), []), e;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-owner.js
function n$1(...e) {
	return useMemo(() => t$2(...e), [...e]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-event-listener.js
function E$4(n, e, a, t) {
	let i = s$6(a);
	useEffect(() => {
		n = n != null ? n : window;
		function r(o) {
			i.current(o);
		}
		return n.addEventListener(e, r, t), () => n.removeEventListener(e, r, t);
	}, [
		n,
		e,
		t
	]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/micro-task.js
function t$1(e) {
	typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o) => setTimeout(() => {
		throw o;
	}));
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-watch.js
function m$1(o, t) {
	let r = useRef([]), e = o$4(o);
	useEffect(() => {
		for (let [u, f] of t.entries()) if (r.current[u] !== f) {
			let i = e(t);
			return r.current = t, i;
		}
	}, [e, ...t]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js
var N$5 = "div";
var F$3 = ((r) => (r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))(F$3 || {});
var fe$2 = Object.assign(H$3(function(n, e) {
	let l = useRef(null), u = y$3(l, e), { initialFocus: f, containers: r, features: o = 30, ...c } = n;
	a$4() || (o = 1);
	let s$9 = n$1(l);
	V$2({ ownerDocument: s$9 }, Boolean(o & 16));
	G$2({
		ownerDocument: s$9,
		container: l,
		containers: r,
		previousActiveElement: x$5({
			ownerDocument: s$9,
			container: l,
			initialFocus: f
		}, Boolean(o & 2))
	}, Boolean(o & 8));
	let v = n$2(), p = o$4(() => {
		let T = l.current;
		!T || u$4(v.current, {
			[s.Forwards]: () => H$4(T, p$4.First),
			[s.Backwards]: () => H$4(T, p$4.Last)
		});
	}), j = { ref: u };
	return React.createElement(React.Fragment, null, Boolean(o & 4) && React.createElement(h$3, {
		as: "button",
		type: "button",
		onFocus: p,
		features: s$2.Focusable
	}), _$2({
		ourProps: j,
		theirProps: c,
		defaultTag: N$5,
		name: "FocusTrap"
	}), Boolean(o & 4) && React.createElement(h$3, {
		as: "button",
		type: "button",
		onFocus: p,
		features: s$2.Focusable
	}));
}), { features: F$3 });
function V$2({ ownerDocument: t }, n) {
	let e = useRef(null);
	E$4(t == null ? void 0 : t.defaultView, "focusout", (u) => {
		!n || e.current || (e.current = u.target);
	}, !0), m$1(() => {
		n || ((t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && F$5(e.current), e.current = null);
	}, [n]);
	let l = useRef(!1);
	useEffect(() => (l.current = !1, () => {
		l.current = !0, t$1(() => {
			!l.current || (F$5(e.current), e.current = null);
		});
	}), []);
}
function x$5({ ownerDocument: t, container: n, initialFocus: e }, l) {
	let u = useRef(null);
	return m$1(() => {
		if (!l) return;
		let f = n.current;
		if (!f) return;
		let r = t == null ? void 0 : t.activeElement;
		if (e != null && e.current) {
			if ((e == null ? void 0 : e.current) === r) {
				u.current = r;
				return;
			}
		} else if (f.contains(r)) {
			u.current = r;
			return;
		}
		e != null && e.current ? F$5(e.current) : H$4(f, p$4.First) === L$3.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = t == null ? void 0 : t.activeElement;
	}, [l]), u;
}
function G$2({ ownerDocument: t, container: n, containers: e, previousActiveElement: l }, u) {
	let f = f$2();
	E$4(t == null ? void 0 : t.defaultView, "focus", (r) => {
		if (!u || !f.current) return;
		let o = new Set(e == null ? void 0 : e.current);
		o.add(n);
		let c = l.current;
		if (!c) return;
		let s = r.target;
		s && s instanceof HTMLElement ? W$2(o, s) ? (l.current = s, F$5(s)) : (r.preventDefault(), r.stopPropagation(), F$5(c)) : F$5(l.current);
	}, !0);
}
function W$2(t, n) {
	var e;
	for (let l of t) if ((e = l.current) != null && e.contains(n)) return !0;
	return !1;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-inert-others.js
var i = /* @__PURE__ */ new Set();
var r$1 = /* @__PURE__ */ new Map();
function u$2(t) {
	t.setAttribute("aria-hidden", "true"), t.inert = !0;
}
function l$2(t) {
	let n = r$1.get(t);
	!n || (n["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", n["aria-hidden"]), t.inert = n.inert);
}
function M$3(t, n = !0) {
	t$3(() => {
		if (!n || !t.current) return;
		let o = t.current, a = t$2(o);
		if (!!a) {
			i.add(o);
			for (let e of r$1.keys()) e.contains(o) && (l$2(e), r$1.delete(e));
			return a.querySelectorAll("body > *").forEach((e) => {
				if (e instanceof HTMLElement) {
					for (let f of i) if (e.contains(f)) return;
					i.size === 1 && (r$1.set(e, {
						"aria-hidden": e.getAttribute("aria-hidden"),
						inert: e.inert
					}), u$2(e));
				}
			}), () => {
				if (i.delete(o), i.size > 0) a.querySelectorAll("body > *").forEach((e) => {
					if (e instanceof HTMLElement && !r$1.has(e)) {
						for (let f of i) if (e.contains(f)) return;
						r$1.set(e, {
							"aria-hidden": e.getAttribute("aria-hidden"),
							inert: e.inert
						}), u$2(e);
					}
				});
				else for (let e of r$1.keys()) l$2(e), r$1.delete(e);
			};
		}
	}, [n]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/internal/portal-force-root.js
var e$2 = createContext(!1);
function l$1() {
	return useContext(e$2);
}
function P$3(o) {
	return React.createElement(e$2.Provider, { value: o.force }, o.children);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/portal/portal.js
function H$2(i) {
	let u = l$1(), o = useContext(E$3), e = n$1(i), [r, f] = useState(() => {
		if (!u && o !== null || typeof window == "undefined") return null;
		let n = e == null ? void 0 : e.getElementById("headlessui-portal-root");
		if (n) return n;
		if (e === null) return null;
		let t = e.createElement("div");
		return t.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(t);
	});
	return useEffect(() => {
		r !== null && (e != null && e.body.contains(r) || e == null || e.body.appendChild(r));
	}, [r, e]), useEffect(() => {
		u || o !== null && f(o.current);
	}, [
		o,
		f,
		u
	]), r;
}
var x$4 = Fragment;
var _$1 = H$3(function(u, o) {
	let e = u, r = useRef(null), f = y$3(T$4((a) => {
		r.current = a;
	}), o), n = n$1(r), t = H$2(r), [l] = useState(() => {
		var a;
		return typeof window == "undefined" ? null : (a = n == null ? void 0 : n.createElement("div")) != null ? a : null;
	}), A = a$4(), p = useRef(!1);
	return t$3(() => {
		if (p.current = !1, !(!t || !l)) return t.contains(l) || (l.setAttribute("data-headlessui-portal", ""), t.appendChild(l)), () => {
			p.current = !0, t$1(() => {
				var a;
				!p.current || !t || !l || (t.removeChild(l), t.childNodes.length <= 0 && ((a = t.parentElement) == null || a.removeChild(t)));
			});
		};
	}, [t, l]), A ? !t || !l ? null : createPortal(_$2({
		ourProps: { ref: f },
		theirProps: e,
		defaultTag: x$4,
		name: "Portal"
	}), l) : null;
});
var U$1 = Fragment;
var E$3 = createContext(null);
var j$4 = H$3(function(u, o) {
	let { target: e, ...r } = u, n = { ref: y$3(o) };
	return React.createElement(E$3.Provider, { value: e }, _$2({
		ourProps: n,
		theirProps: r,
		defaultTag: U$1,
		name: "Popover.Group"
	}));
});
var X$1 = Object.assign(_$1, { Group: j$4 });
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/description/description.js
var d = createContext(null);
function u$1() {
	let r = useContext(d);
	if (r === null) {
		let t = /* @__PURE__ */ new Error("You used a <Description /> component, but it is not inside a relevant parent.");
		throw Error.captureStackTrace && Error.captureStackTrace(t, u$1), t;
	}
	return r;
}
function k$2() {
	let [r, t] = useState([]);
	return [r.length > 0 ? r.join(" ") : void 0, useMemo(() => function(e) {
		let i = o$4((n) => (t((o) => [...o, n]), () => t((o) => {
			let c = o.slice(), p = c.indexOf(n);
			return p !== -1 && c.splice(p, 1), c;
		}))), s = useMemo(() => ({
			register: i,
			slot: e.slot,
			name: e.name,
			props: e.props
		}), [
			i,
			e.slot,
			e.name,
			e.props
		]);
		return React.createElement(d.Provider, { value: s }, e.children);
	}, [t])];
}
var S$3 = "p";
var F$2 = H$3(function(t, a) {
	let e = u$1(), i = `headlessui-description-${I()}`, s = y$3(a);
	t$3(() => e.register(i), [i, e.register]);
	let n = t;
	return _$2({
		ourProps: {
			ref: s,
			...e.props,
			id: i
		},
		theirProps: n,
		slot: e.slot || {},
		defaultTag: S$3,
		name: e.name || "Description"
	});
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/internal/stack-context.js
var o$1 = createContext(() => {});
o$1.displayName = "StackContext";
var f$1 = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(f$1 || {});
function x$3() {
	return useContext(o$1);
}
function C$5({ children: u, onUpdate: r, type: e, element: n }) {
	let c = x$3(), t = o$4((...a) => {
		r?.(...a), c(...a);
	});
	return t$3(() => (t(0, e, n), () => t(1, e, n)), [
		t,
		e,
		n
	]), React.createElement(o$1.Provider, { value: t }, u);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/dialog/dialog.js
var be$3 = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(be$3 || {});
var Ce$3 = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(Ce$3 || {});
var Oe$1 = { [0](i, e) {
	return i.titleId === e.id ? i : {
		...i,
		titleId: e.id
	};
} };
var M$2 = createContext(null);
M$2.displayName = "DialogContext";
function L$1(i) {
	let e = useContext(M$2);
	if (e === null) {
		let t = /* @__PURE__ */ new Error(`<${i} /> is missing a parent <Dialog /> component.`);
		throw Error.captureStackTrace && Error.captureStackTrace(t, L$1), t;
	}
	return e;
}
function Se$2(i, e) {
	return u$4(e.type, Oe$1, i, e);
}
var Le$2 = "div";
var we$2 = x$6.RenderStrategy | x$6.Static;
var Fe$1 = H$3(function(e, t) {
	let { open: o, onClose: n, initialFocus: d, __demoMode: g = !1, ...c } = e, [m, D] = useState(0), v = s$1();
	o === void 0 && v !== null && (o = u$4(v, {
		[p$2.Open]: !0,
		[p$2.Closed]: !1
	}));
	let a = useRef(/* @__PURE__ */ new Set()), f = useRef(null), J = y$3(f, t), W = useRef(null), P = n$1(f), B = e.hasOwnProperty("open") || v !== null, G = e.hasOwnProperty("onClose");
	if (!B && !G) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
	if (!B) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
	if (!G) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
	if (typeof o != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);
	if (typeof n != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${n}`);
	let s = o ? 0 : 1, [y, Q] = useReducer(Se$2, {
		titleId: null,
		descriptionId: null,
		panelRef: createRef()
	}), R = o$4(() => n(!1)), U = o$4((r) => Q({
		type: 0,
		id: r
	})), _ = a$4() ? g ? !1 : s === 0 : !1, w = m > 1, $ = useContext(M$2) !== null, X = w ? "parent" : "leaf";
	M$3(f, w ? _ : !1), L$2(() => {
		var l, p;
		return [...Array.from((l = P == null ? void 0 : P.querySelectorAll("body > *, [data-headlessui-portal]")) != null ? l : []).filter((T) => !(!(T instanceof HTMLElement) || T.contains(W.current) || y.panelRef.current && T.contains(y.panelRef.current))), (p = y.panelRef.current) != null ? p : f.current];
	}, R, _ && !w), E$4(P == null ? void 0 : P.defaultView, "keydown", (r) => {
		r.defaultPrevented || r.key === o$2.Escape && s === 0 && (w || (r.preventDefault(), r.stopPropagation(), R()));
	}), useEffect(() => {
		var j;
		if (s !== 0 || $) return;
		let r = t$2(f);
		if (!r) return;
		let l = r.documentElement, p = (j = r.defaultView) != null ? j : window, T = l.style.overflow, le = l.style.paddingRight, Y = p.innerWidth - l.clientWidth;
		if (l.style.overflow = "hidden", Y > 0) {
			let ie = Y - (l.clientWidth - l.offsetWidth);
			l.style.paddingRight = `${ie}px`;
		}
		return () => {
			l.style.overflow = T, l.style.paddingRight = le;
		};
	}, [s, $]), useEffect(() => {
		if (s !== 0 || !f.current) return;
		let r = new IntersectionObserver((l) => {
			for (let p of l) p.boundingClientRect.x === 0 && p.boundingClientRect.y === 0 && p.boundingClientRect.width === 0 && p.boundingClientRect.height === 0 && R();
		});
		return r.observe(f.current), () => r.disconnect();
	}, [
		s,
		f,
		R
	]);
	let [Z, ee] = k$2(), te = `headlessui-dialog-${I()}`, oe = useMemo(() => [{
		dialogState: s,
		close: R,
		setTitleId: U
	}, y], [
		s,
		y,
		R,
		U
	]), N = useMemo(() => ({ open: s === 0 }), [s]), re = {
		ref: J,
		id: te,
		role: "dialog",
		"aria-modal": s === 0 ? !0 : void 0,
		"aria-labelledby": y.titleId,
		"aria-describedby": Z
	};
	return React.createElement(C$5, {
		type: "Dialog",
		element: f,
		onUpdate: o$4((r, l, p) => {
			l === "Dialog" && u$4(r, {
				[f$1.Add]() {
					a.current.add(p), D((T) => T + 1);
				},
				[f$1.Remove]() {
					a.current.add(p), D((T) => T - 1);
				}
			});
		})
	}, React.createElement(P$3, { force: !0 }, React.createElement(X$1, null, React.createElement(M$2.Provider, { value: oe }, React.createElement(X$1.Group, { target: f }, React.createElement(P$3, { force: !1 }, React.createElement(ee, {
		slot: N,
		name: "Dialog.Description"
	}, React.createElement(fe$2, {
		initialFocus: d,
		containers: a,
		features: _ ? u$4(X, {
			parent: fe$2.features.RestoreFocus,
			leaf: fe$2.features.All & ~fe$2.features.FocusLock
		}) : fe$2.features.None
	}, _$2({
		ourProps: re,
		theirProps: c,
		slot: N,
		defaultTag: Le$2,
		features: we$2,
		visible: s === 0,
		name: "Dialog"
	})))))))), React.createElement(h$3, {
		features: s$2.Hidden,
		ref: W
	}));
});
var ke$1 = "div";
var Me$2 = H$3(function(e, t) {
	let [{ dialogState: o, close: n }] = L$1("Dialog.Overlay"), d = y$3(t), g = `headlessui-dialog-overlay-${I()}`, c = o$4((a) => {
		if (a.target === a.currentTarget) {
			if (r$2(a.currentTarget)) return a.preventDefault();
			a.preventDefault(), a.stopPropagation(), n();
		}
	}), m = useMemo(() => ({ open: o === 0 }), [o]);
	return _$2({
		ourProps: {
			ref: d,
			id: g,
			"aria-hidden": !0,
			onClick: c
		},
		theirProps: e,
		slot: m,
		defaultTag: ke$1,
		name: "Dialog.Overlay"
	});
});
var _e$2 = "div";
var Ie$1 = H$3(function(e, t) {
	let [{ dialogState: o }, n] = L$1("Dialog.Backdrop"), d = y$3(t), g = `headlessui-dialog-backdrop-${I()}`;
	useEffect(() => {
		if (n.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
	}, [n.panelRef]);
	let c = useMemo(() => ({ open: o === 0 }), [o]);
	return React.createElement(P$3, { force: !0 }, React.createElement(X$1, null, _$2({
		ourProps: {
			ref: d,
			id: g,
			"aria-hidden": !0
		},
		theirProps: e,
		slot: c,
		defaultTag: _e$2,
		name: "Dialog.Backdrop"
	})));
});
var xe$2 = "div";
var He$1 = H$3(function(e, t) {
	let [{ dialogState: o }, n] = L$1("Dialog.Panel"), d = y$3(t, n.panelRef), g = `headlessui-dialog-panel-${I()}`, c = useMemo(() => ({ open: o === 0 }), [o]);
	return _$2({
		ourProps: {
			ref: d,
			id: g,
			onClick: o$4((a) => {
				a.stopPropagation();
			})
		},
		theirProps: e,
		slot: c,
		defaultTag: xe$2,
		name: "Dialog.Panel"
	});
});
var We$2 = "h2";
var Be$2 = H$3(function(e, t) {
	let [{ dialogState: o, setTitleId: n }] = L$1("Dialog.Title"), d = `headlessui-dialog-title-${I()}`, g = y$3(t);
	useEffect(() => (n(d), () => n(null)), [d, n]);
	let c = useMemo(() => ({ open: o === 0 }), [o]);
	return _$2({
		ourProps: {
			ref: g,
			id: d
		},
		theirProps: e,
		slot: c,
		defaultTag: We$2,
		name: "Dialog.Title"
	});
});
var mt$1 = Object.assign(Fe$1, {
	Backdrop: Ie$1,
	Panel: He$1,
	Overlay: Me$2,
	Title: Be$2,
	Description: F$2
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/popover/popover.js
var Ae = ((c) => (c[c.Open = 0] = "Open", c[c.Closed = 1] = "Closed", c))(Ae || {});
var Ce$2 = ((n) => (n[n.TogglePopover = 0] = "TogglePopover", n[n.ClosePopover = 1] = "ClosePopover", n[n.SetButton = 2] = "SetButton", n[n.SetButtonId = 3] = "SetButtonId", n[n.SetPanel = 4] = "SetPanel", n[n.SetPanelId = 5] = "SetPanelId", n))(Ce$2 || {});
var Re$2 = {
	[0]: (r) => ({
		...r,
		popoverState: u$4(r.popoverState, {
			[0]: 1,
			[1]: 0
		})
	}),
	[1](r) {
		return r.popoverState === 1 ? r : {
			...r,
			popoverState: 1
		};
	},
	[2](r, t) {
		return r.button === t.button ? r : {
			...r,
			button: t.button
		};
	},
	[3](r, t) {
		return r.buttonId === t.buttonId ? r : {
			...r,
			buttonId: t.buttonId
		};
	},
	[4](r, t) {
		return r.panel === t.panel ? r : {
			...r,
			panel: t.panel
		};
	},
	[5](r, t) {
		return r.panelId === t.panelId ? r : {
			...r,
			panelId: t.panelId
		};
	}
};
var ee$2 = createContext(null);
ee$2.displayName = "PopoverContext";
function J$3(r) {
	let t = useContext(ee$2);
	if (t === null) {
		let c = /* @__PURE__ */ new Error(`<${r} /> is missing a parent <Popover /> component.`);
		throw Error.captureStackTrace && Error.captureStackTrace(c, J$3), c;
	}
	return t;
}
var te$2 = createContext(null);
te$2.displayName = "PopoverAPIContext";
function oe$1(r) {
	let t = useContext(te$2);
	if (t === null) {
		let c = /* @__PURE__ */ new Error(`<${r} /> is missing a parent <Popover /> component.`);
		throw Error.captureStackTrace && Error.captureStackTrace(c, oe$1), c;
	}
	return t;
}
var re$2 = createContext(null);
re$2.displayName = "PopoverGroupContext";
function ce$1() {
	return useContext(re$2);
}
var ne = createContext(null);
ne.displayName = "PopoverPanelContext";
function Oe() {
	return useContext(ne);
}
function Le$1(r, t) {
	return u$4(t.type, Re$2, r, t);
}
var Fe = "div";
var Ie = H$3(function(t, c) {
	var R;
	let o = `headlessui-popover-button-${I()}`, d = `headlessui-popover-panel-${I()}`, a = useRef(null), n = y$3(c, T$4((e) => {
		a.current = e;
	})), g = useReducer(Le$1, {
		popoverState: 1,
		button: null,
		buttonId: o,
		panel: null,
		panelId: d,
		beforePanelSentinel: createRef(),
		afterPanelSentinel: createRef()
	}), [{ popoverState: m, button: l, panel: v, beforePanelSentinel: p, afterPanelSentinel: B }, s] = g, T = n$1((R = a.current) != null ? R : l);
	useEffect(() => s({
		type: 3,
		buttonId: o
	}), [o, s]), useEffect(() => s({
		type: 5,
		panelId: d
	}), [d, s]);
	let f = useMemo(() => {
		if (!l || !v) return !1;
		for (let e of document.querySelectorAll("body > *")) if (Number(e == null ? void 0 : e.contains(l)) ^ Number(e == null ? void 0 : e.contains(v))) return !0;
		return !1;
	}, [l, v]), P = useMemo(() => ({
		buttonId: o,
		panelId: d,
		close: () => s({ type: 1 })
	}), [
		o,
		d,
		s
	]), y = ce$1(), A = y == null ? void 0 : y.registerPopover, L = o$4(() => {
		var e;
		return (e = y == null ? void 0 : y.isFocusWithinPopoverGroup()) != null ? e : (T == null ? void 0 : T.activeElement) && ((l == null ? void 0 : l.contains(T.activeElement)) || (v == null ? void 0 : v.contains(T.activeElement)));
	});
	useEffect(() => A == null ? void 0 : A(P), [A, P]), E$4(T == null ? void 0 : T.defaultView, "focus", (e) => {
		var i, S, O, N;
		m === 0 && (L() || !l || !v || (S = (i = p.current) == null ? void 0 : i.contains) != null && S.call(i, e.target) || (N = (O = B.current) == null ? void 0 : O.contains) != null && N.call(O, e.target) || s({ type: 1 }));
	}, !0), L$2([l, v], (e, i) => {
		s({ type: 1 }), S$4(i, b$5.Loose) || (e.preventDefault(), l?.focus());
	}, m === 0);
	let F = o$4((e) => {
		s({ type: 1 });
		(() => e ? e instanceof HTMLElement ? e : e.current instanceof HTMLElement ? e.current : l : l)()?.focus();
	}), D = useMemo(() => ({
		close: F,
		isPortalled: f
	}), [F, f]), u = useMemo(() => ({
		open: m === 0,
		close: F
	}), [m, F]), E = t, C = { ref: n };
	return React.createElement(ee$2.Provider, { value: g }, React.createElement(te$2.Provider, { value: D }, React.createElement(C$6, { value: u$4(m, {
		[0]: p$2.Open,
		[1]: p$2.Closed
	}) }, _$2({
		ourProps: C,
		theirProps: E,
		slot: u,
		defaultTag: Fe,
		name: "Popover"
	}))));
});
var Me$1 = "button";
var Be$1 = H$3(function(t, c) {
	let [o, d] = J$3("Popover.Button"), { isPortalled: a } = oe$1("Popover.Button"), n = useRef(null), g = `headlessui-focus-sentinel-${I()}`, m = ce$1(), l = m == null ? void 0 : m.closeOthers, v = Oe(), p = v === null ? !1 : v === o.panelId, B = y$3(n, c, p ? null : (e) => d({
		type: 2,
		button: e
	})), s$7 = y$3(n, c), T = n$1(n), f = o$4((e) => {
		var i, S, O;
		if (p) {
			if (o.popoverState === 1) return;
			switch (e.key) {
				case o$2.Space:
				case o$2.Enter: e.preventDefault(), (S = (i = e.target).click) == null || S.call(i), d({ type: 1 }), (O = o.button) == null || O.focus();
			}
		} else switch (e.key) {
			case o$2.Space:
			case o$2.Enter:
				e.preventDefault(), e.stopPropagation(), o.popoverState === 1 && l?.(o.buttonId), d({ type: 0 });
				break;
			case o$2.Escape:
				if (o.popoverState !== 0) return l == null ? void 0 : l(o.buttonId);
				if (!n.current || (T == null ? void 0 : T.activeElement) && !n.current.contains(T.activeElement)) return;
				e.preventDefault(), e.stopPropagation(), d({ type: 1 });
		}
	}), P = o$4((e) => {
		p || e.key === o$2.Space && e.preventDefault();
	}), y = o$4((e) => {
		var i, S;
		r$2(e.currentTarget) || t.disabled || (p ? (d({ type: 1 }), (i = o.button) == null || i.focus()) : (e.preventDefault(), e.stopPropagation(), o.popoverState === 1 && l?.(o.buttonId), d({ type: 0 }), (S = o.button) == null || S.focus()));
	}), A = o$4((e) => {
		e.preventDefault(), e.stopPropagation();
	}), L = o.popoverState === 0, F = useMemo(() => ({ open: L }), [L]), D = s$4(t, n), u = t, E = p ? {
		ref: s$7,
		type: D,
		onKeyDown: f,
		onClick: y
	} : {
		ref: B,
		id: o.buttonId,
		type: D,
		"aria-expanded": t.disabled ? void 0 : o.popoverState === 0,
		"aria-controls": o.panel ? o.panelId : void 0,
		onKeyDown: f,
		onKeyUp: P,
		onClick: y,
		onMouseDown: A
	}, C = n$2(), R = o$4(() => {
		let e = o.panel;
		if (!e) return;
		function i() {
			u$4(C.current, {
				[s.Forwards]: () => H$4(e, p$4.First),
				[s.Backwards]: () => H$4(e, p$4.Last)
			});
		}
		i();
	});
	return React.createElement(React.Fragment, null, _$2({
		ourProps: E,
		theirProps: u,
		slot: F,
		defaultTag: Me$1,
		name: "Popover.Button"
	}), L && !p && a && React.createElement(h$3, {
		id: g,
		features: s$2.Focusable,
		as: "button",
		type: "button",
		onFocus: R
	}));
});
var he = "div";
var De$1 = x$6.RenderStrategy | x$6.Static;
var xe$1 = H$3(function(t, c) {
	let [{ popoverState: o }, d] = J$3("Popover.Overlay"), a = y$3(c), n = `headlessui-popover-overlay-${I()}`, g = s$1(), m = (() => g !== null ? g === p$2.Open : o === 0)(), l = o$4((s) => {
		if (r$2(s.currentTarget)) return s.preventDefault();
		d({ type: 1 });
	}), v = useMemo(() => ({ open: o === 0 }), [o]);
	return _$2({
		ourProps: {
			ref: a,
			id: n,
			"aria-hidden": !0,
			onClick: l
		},
		theirProps: t,
		slot: v,
		defaultTag: he,
		features: De$1,
		visible: m,
		name: "Popover.Overlay"
	});
});
var He = "div";
var Ge$1 = x$6.RenderStrategy | x$6.Static;
var ke = H$3(function(t, c) {
	let { focus: o = !1, ...d } = t, [a, n] = J$3("Popover.Panel"), { close: g, isPortalled: m } = oe$1("Popover.Panel"), l = `headlessui-focus-sentinel-before-${I()}`, v = `headlessui-focus-sentinel-after-${I()}`, p = useRef(null), B = y$3(p, c, (u) => {
		n({
			type: 4,
			panel: u
		});
	}), s$8 = n$1(p), T = s$1(), f = (() => T !== null ? T === p$2.Open : a.popoverState === 0)(), P = o$4((u) => {
		var E;
		switch (u.key) {
			case o$2.Escape:
				if (a.popoverState !== 0 || !p.current || (s$8 == null ? void 0 : s$8.activeElement) && !p.current.contains(s$8.activeElement)) return;
				u.preventDefault(), u.stopPropagation(), n({ type: 1 }), (E = a.button) == null || E.focus();
		}
	});
	useEffect(() => {
		var u;
		t.static || a.popoverState === 1 && ((u = t.unmount) == null || u) && n({
			type: 4,
			panel: null
		});
	}, [
		a.popoverState,
		t.unmount,
		t.static,
		n
	]), useEffect(() => {
		if (!o || a.popoverState !== 0 || !p.current) return;
		let u = s$8 == null ? void 0 : s$8.activeElement;
		p.current.contains(u) || H$4(p.current, p$4.First);
	}, [
		o,
		p,
		a.popoverState
	]);
	let y = useMemo(() => ({
		open: a.popoverState === 0,
		close: g
	}), [a, g]), A = {
		ref: B,
		id: a.panelId,
		onKeyDown: P,
		onBlur: o && a.popoverState === 0 ? (u) => {
			var C, R, e, i, S;
			let E = u.relatedTarget;
			!E || !p.current || (C = p.current) != null && C.contains(E) || (n({ type: 1 }), ((e = (R = a.beforePanelSentinel.current) == null ? void 0 : R.contains) != null && e.call(R, E) || (S = (i = a.afterPanelSentinel.current) == null ? void 0 : i.contains) != null && S.call(i, E)) && E.focus({ preventScroll: !0 }));
		} : void 0,
		tabIndex: -1
	}, L = n$2(), F = o$4(() => {
		let u = p.current;
		if (!u) return;
		function E() {
			u$4(L.current, {
				[s.Forwards]: () => {
					H$4(u, p$4.First);
				},
				[s.Backwards]: () => {
					var C;
					(C = a.button) == null || C.focus({ preventScroll: !0 });
				}
			});
		}
		E();
	}), D = o$4(() => {
		let u = p.current;
		if (!u) return;
		function E() {
			u$4(L.current, {
				[s.Forwards]: () => {
					var O, N, le;
					if (!a.button) return;
					let C = T$5(), R = C.indexOf(a.button), e = C.slice(0, R + 1), S = [...C.slice(R + 1), ...e];
					for (let K of S.slice()) if (((N = (O = K == null ? void 0 : K.id) == null ? void 0 : O.startsWith) == null ? void 0 : N.call(O, "headlessui-focus-sentinel-")) || ((le = a.panel) == null ? void 0 : le.contains(K))) {
						let ae = S.indexOf(K);
						ae !== -1 && S.splice(ae, 1);
					}
					H$4(S, p$4.First, !1);
				},
				[s.Backwards]: () => H$4(u, p$4.Last)
			});
		}
		E();
	});
	return React.createElement(ne.Provider, { value: a.panelId }, f && m && React.createElement(h$3, {
		id: l,
		ref: a.beforePanelSentinel,
		features: s$2.Focusable,
		as: "button",
		type: "button",
		onFocus: F
	}), _$2({
		ourProps: A,
		theirProps: d,
		slot: y,
		defaultTag: He,
		features: Ge$1,
		visible: f,
		name: "Popover.Panel"
	}), f && m && React.createElement(h$3, {
		id: v,
		ref: a.afterPanelSentinel,
		features: s$2.Focusable,
		as: "button",
		type: "button",
		onFocus: D
	}));
});
var _e$1 = "div";
var we$1 = H$3(function(t, c) {
	let o = useRef(null), d = y$3(o, c), [a, n] = useState([]), g = o$4((f) => {
		n((P) => {
			let y = P.indexOf(f);
			if (y !== -1) {
				let A = P.slice();
				return A.splice(y, 1), A;
			}
			return P;
		});
	}), m = o$4((f) => (n((P) => [...P, f]), () => g(f))), l = o$4(() => {
		var y;
		let f = t$2(o);
		if (!f) return !1;
		let P = f.activeElement;
		return (y = o.current) != null && y.contains(P) ? !0 : a.some((A) => {
			var L, F;
			return ((L = f.getElementById(A.buttonId)) == null ? void 0 : L.contains(P)) || ((F = f.getElementById(A.panelId)) == null ? void 0 : F.contains(P));
		});
	}), v = o$4((f) => {
		for (let P of a) P.buttonId !== f && P.close();
	}), p = useMemo(() => ({
		registerPopover: m,
		unregisterPopover: g,
		isFocusWithinPopoverGroup: l,
		closeOthers: v
	}), [
		m,
		g,
		l,
		v
	]), B = useMemo(() => ({}), []), s = t, T = { ref: d };
	return React.createElement(re$2.Provider, { value: p }, _$2({
		ourProps: T,
		theirProps: s,
		slot: B,
		defaultTag: _e$1,
		name: "Popover.Group"
	}));
});
var Tt$1 = Object.assign(Ie, {
	Button: Be$1,
	Overlay: xe$1,
	Panel: ke,
	Group: we$1
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-flags.js
function b$4(g = 0) {
	let [r, l] = useState(g);
	return {
		addFlag: useCallback((e) => l((a) => a | e), [r]),
		hasFlag: useCallback((e) => Boolean(r & e), [r]),
		removeFlag: useCallback((e) => l((a) => a & ~e), [l]),
		toggleFlag: useCallback((e) => l((a) => a ^ e), [l])
	};
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/label/label.js
var u = createContext(null);
function c$4() {
	let o = useContext(u);
	if (o === null) {
		let t = /* @__PURE__ */ new Error("You used a <Label /> component, but it is not inside a relevant parent.");
		throw Error.captureStackTrace && Error.captureStackTrace(t, c$4), t;
	}
	return o;
}
function M$1() {
	let [o, t] = useState([]);
	return [o.length > 0 ? o.join(" ") : void 0, useMemo(() => function(e) {
		let l = o$4((a) => (t((i) => [...i, a]), () => t((i) => {
			let n = i.slice(), d = n.indexOf(a);
			return d !== -1 && n.splice(d, 1), n;
		}))), r = useMemo(() => ({
			register: l,
			slot: e.slot,
			name: e.name,
			props: e.props
		}), [
			l,
			e.slot,
			e.name,
			e.props
		]);
		return React.createElement(u.Provider, { value: r }, e.children);
	}, [t])];
}
var h$2 = "label";
var F$1 = H$3(function(t, s) {
	let { passive: e = !1, ...l } = t, r = c$4(), a = `headlessui-label-${I()}`, i = y$3(s);
	t$3(() => r.register(a), [a, r.register]);
	let n = {
		ref: i,
		...r.props,
		id: a
	};
	return e && ("onClick" in n && delete n.onClick, "onClick" in l && delete l.onClick), _$2({
		ourProps: n,
		theirProps: l,
		slot: r.slot || {},
		defaultTag: h$2,
		name: r.name || "Label"
	});
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/radio-group/radio-group.js
var ue$1 = ((t) => (t[t.RegisterOption = 0] = "RegisterOption", t[t.UnregisterOption = 1] = "UnregisterOption", t))(ue$1 || {});
var ce = {
	[0](n, i) {
		let t = [...n.options, {
			id: i.id,
			element: i.element,
			propsRef: i.propsRef
		}];
		return {
			...n,
			options: v$4(t, (o) => o.element.current)
		};
	},
	[1](n, i) {
		let t = n.options.slice(), o = n.options.findIndex((T) => T.id === i.id);
		return o === -1 ? n : (t.splice(o, 1), {
			...n,
			options: t
		});
	}
};
var N$4 = createContext(null);
N$4.displayName = "RadioGroupContext";
function Q$1(n) {
	let i = useContext(N$4);
	if (i === null) {
		let t = /* @__PURE__ */ new Error(`<${n} /> is missing a parent <RadioGroup /> component.`);
		throw Error.captureStackTrace && Error.captureStackTrace(t, Q$1), t;
	}
	return i;
}
function fe$1(n, i) {
	return u$4(i.type, ce, n, i);
}
var me = "div";
var be$2 = H$3(function(i, t) {
	let { value: o, name: T, onChange: R, disabled: A = !1, ...L } = i, u = o$4((e, a) => e === a), [x, h] = useReducer(fe$1, { options: [] }), l = x.options, [G, c] = M$1(), [y, w] = k$2(), f = `headlessui-radiogroup-${I()}`, g = useRef(null), I$1 = y$3(g, t), k = useMemo(() => l.find((e) => !e.propsRef.current.disabled), [l]), O = useMemo(() => l.some((e) => u(e.propsRef.current.value, o)), [l, o]), m = o$4((e) => {
		var r;
		if (A || u(e, o)) return !1;
		let a = (r = l.find((s) => u(s.propsRef.current.value, e))) == null ? void 0 : r.propsRef.current;
		return a != null && a.disabled ? !1 : (R(e), !0);
	});
	F$4({
		container: g.current,
		accept(e) {
			return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
		},
		walk(e) {
			e.setAttribute("role", "none");
		}
	});
	let S = o$4((e) => {
		let a = g.current;
		if (!a) return;
		let r = t$2(a), s = l.filter((p) => p.propsRef.current.disabled === !1).map((p) => p.element.current);
		switch (e.key) {
			case o$2.Enter:
				p$3(e.currentTarget);
				break;
			case o$2.ArrowLeft:
			case o$2.ArrowUp:
				if (e.preventDefault(), e.stopPropagation(), H$4(s, p$4.Previous | p$4.WrapAround) === L$3.Success) {
					let d = l.find((v) => v.element.current === (r == null ? void 0 : r.activeElement));
					d && m(d.propsRef.current.value);
				}
				break;
			case o$2.ArrowRight:
			case o$2.ArrowDown:
				if (e.preventDefault(), e.stopPropagation(), H$4(s, p$4.Next | p$4.WrapAround) === L$3.Success) {
					let d = l.find((v) => v.element.current === (r == null ? void 0 : r.activeElement));
					d && m(d.propsRef.current.value);
				}
				break;
			case o$2.Space: {
				e.preventDefault(), e.stopPropagation();
				let p = l.find((d) => d.element.current === (r == null ? void 0 : r.activeElement));
				p && m(p.propsRef.current.value);
			}
		}
	}), C = o$4((e) => (h({
		type: 0,
		...e
	}), () => h({
		type: 1,
		id: e.id
	}))), _ = useMemo(() => ({
		registerOption: C,
		firstOption: k,
		containsCheckedOption: O,
		change: m,
		disabled: A,
		value: o,
		compare: u
	}), [
		C,
		k,
		O,
		m,
		A,
		o,
		u
	]), M = {
		ref: I$1,
		id: f,
		role: "radiogroup",
		"aria-labelledby": G,
		"aria-describedby": y,
		onKeyDown: S
	};
	return React.createElement(w, { name: "RadioGroup.Description" }, React.createElement(c, { name: "RadioGroup.Label" }, React.createElement(N$4.Provider, { value: _ }, T != null && o != null && e$3({ [T]: o }).map(([e, a]) => React.createElement(h$3, {
		features: s$2.Hidden,
		...g$4({
			key: e,
			as: "input",
			type: "radio",
			checked: a != null,
			hidden: !0,
			readOnly: !0,
			name: e,
			value: a
		})
	})), _$2({
		ourProps: M,
		theirProps: L,
		defaultTag: me,
		name: "RadioGroup"
	}))));
});
var Te$1 = ((t) => (t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t))(Te$1 || {});
var Re$1 = "div";
var ye$1 = H$3(function(i, t) {
	let o = useRef(null), T = y$3(o, t), R = `headlessui-radiogroup-option-${I()}`, [A, L] = M$1(), [u, x] = k$2(), { addFlag: h, removeFlag: l, hasFlag: G } = b$4(1), { value: c, disabled: y = !1, ...w } = i, f = useRef({
		value: c,
		disabled: y
	});
	t$3(() => {
		f.current.value = c;
	}, [c, f]), t$3(() => {
		f.current.disabled = y;
	}, [y, f]);
	let { registerOption: g, disabled: I$2, change: k, firstOption: O, containsCheckedOption: m, value: S, compare: C } = Q$1("RadioGroup.Option");
	t$3(() => g({
		id: R,
		element: o,
		propsRef: f
	}), [
		R,
		g,
		o,
		i
	]);
	let _ = o$4(() => {
		var v;
		!k(c) || (h(2), (v = o.current) == null || v.focus());
	}), M = o$4(() => h(2)), e = o$4(() => l(2)), a = (O == null ? void 0 : O.id) === R, r = I$2 || y, s = C(S, c), p = {
		ref: T,
		id: R,
		role: "radio",
		"aria-checked": s ? "true" : "false",
		"aria-labelledby": A,
		"aria-describedby": u,
		"aria-disabled": r ? !0 : void 0,
		tabIndex: (() => r ? -1 : s || !m && a ? 0 : -1)(),
		onClick: r ? void 0 : _,
		onFocus: r ? void 0 : M,
		onBlur: r ? void 0 : e
	}, d = useMemo(() => ({
		checked: s,
		disabled: r,
		active: G(2)
	}), [
		s,
		r,
		G
	]);
	return React.createElement(x, { name: "RadioGroup.Description" }, React.createElement(L, { name: "RadioGroup.Label" }, _$2({
		ourProps: p,
		theirProps: w,
		slot: d,
		defaultTag: Re$1,
		name: "RadioGroup.Option"
	})));
});
var je = Object.assign(be$2, {
	Option: ye$1,
	Label: F$1,
	Description: F$2
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/switch/switch.js
var p$1 = createContext(null);
p$1.displayName = "GroupContext";
var j$3 = Fragment;
function N$3(m) {
	let [n, i] = useState(null), [r, s] = M$1(), [l, c] = k$2(), d = useMemo(() => ({
		switch: n,
		setSwitch: i,
		labelledby: r,
		describedby: l
	}), [
		n,
		i,
		r,
		l
	]), u = {}, e = m;
	return React.createElement(c, { name: "Switch.Description" }, React.createElement(s, {
		name: "Switch.Label",
		props: { onClick() {
			!n || (n.click(), n.focus({ preventScroll: !0 }));
		} }
	}, React.createElement(p$1.Provider, { value: d }, _$2({
		ourProps: u,
		theirProps: e,
		defaultTag: j$3,
		name: "Switch.Group"
	}))));
}
var $$2 = "button";
var q$1 = H$3(function(n, i) {
	let { checked: r, onChange: s, name: l, value: c, ...d } = n, u = `headlessui-switch-${I()}`, e = useContext(p$1), f = useRef(null), S = y$3(f, i, e === null ? null : e.setSwitch), h = o$4(() => s(!r)), E = o$4((t) => {
		if (r$2(t.currentTarget)) return t.preventDefault();
		t.preventDefault(), h();
	}), w = o$4((t) => {
		t.key === o$2.Space ? (t.preventDefault(), h()) : t.key === o$2.Enter && p$3(t.currentTarget);
	}), P = o$4((t) => t.preventDefault()), v = useMemo(() => ({ checked: r }), [r]), g = {
		id: u,
		ref: S,
		role: "switch",
		type: s$4(n, f),
		tabIndex: 0,
		"aria-checked": r,
		"aria-labelledby": e == null ? void 0 : e.labelledby,
		"aria-describedby": e == null ? void 0 : e.describedby,
		onClick: E,
		onKeyUp: w,
		onKeyPress: P
	};
	return React.createElement(React.Fragment, null, l != null && r && React.createElement(h$3, {
		features: s$2.Hidden,
		...g$4({
			as: "input",
			type: "checkbox",
			hidden: !0,
			readOnly: !0,
			checked: r,
			name: l,
			value: c
		})
	}), _$2({
		ourProps: g,
		theirProps: d,
		slot: v,
		defaultTag: $$2,
		name: "Switch"
	}));
});
var ue = Object.assign(q$1, {
	Group: N$3,
	Label: F$1,
	Description: F$2
});
//#endregion
//#region ../../node_modules/@headlessui/react/dist/utils/once.js
function l(r) {
	let e = { called: !1 };
	return (...t) => {
		if (!e.called) return e.called = !0, r(...t);
	};
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function f(t, ...e) {
	t && e.length > 0 && t.classList.add(...e);
}
function g$3(t, ...e) {
	t && e.length > 0 && t.classList.remove(...e);
}
var T$3 = ((n) => (n.Ended = "ended", n.Cancelled = "cancelled", n))(T$3 || {});
function c$3(t, e) {
	let n = o$5();
	if (!t) return n.dispose;
	let { transitionDuration: d, transitionDelay: a } = getComputedStyle(t), [s, u] = [d, a].map((i) => {
		let [o = 0] = i.split(",").filter(Boolean).map((r) => r.includes("ms") ? parseFloat(r) : parseFloat(r) * 1e3).sort((r, l) => l - r);
		return o;
	});
	if (s + u !== 0) {
		let i = [];
		i.push(n.addEventListener(t, "transitionrun", (o) => {
			o.target === o.currentTarget && (i.splice(0).forEach((r) => r()), i.push(n.addEventListener(t, "transitionend", (r) => {
				r.target === r.currentTarget && (e("ended"), i.splice(0).forEach((l) => l()));
			}), n.addEventListener(t, "transitioncancel", (r) => {
				r.target === r.currentTarget && (e("cancelled"), i.splice(0).forEach((l) => l()));
			})));
		}));
	} else e("ended");
	return n.add(() => e("cancelled")), n.dispose;
}
function C$4(t, e, n, d) {
	let a = n ? "enter" : "leave", s = o$5(), u = d !== void 0 ? l(d) : () => {}, m = u$4(a, {
		enter: () => e.enter,
		leave: () => e.leave
	}), i = u$4(a, {
		enter: () => e.enterTo,
		leave: () => e.leaveTo
	}), o = u$4(a, {
		enter: () => e.enterFrom,
		leave: () => e.leaveFrom
	});
	return g$3(t, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), f(t, ...m, ...o), s.nextFrame(() => {
		g$3(t, ...o), f(t, ...i), c$3(t, (r) => (r === "ended" && (g$3(t, ...m), f(t, ...e.entered)), u(r)));
	}), s.dispose;
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/hooks/use-transition.js
function H$1({ container: u, direction: o, classes: c, events: t, onStart: d, onStop: l }) {
	let f = f$2(), m = p$5(), e = s$6(o), b = o$4(() => u$4(e.current, {
		enter: () => t.current.beforeEnter(),
		leave: () => t.current.beforeLeave(),
		idle: () => {}
	})), p = o$4(() => u$4(e.current, {
		enter: () => t.current.afterEnter(),
		leave: () => t.current.afterLeave(),
		idle: () => {}
	}));
	t$3(() => {
		let r = o$5();
		m.add(r.dispose);
		let i = u.current;
		if (!!i && e.current !== "idle" && !!f.current) return r.dispose(), b(), d.current(e.current), r.add(C$4(i, c.current, e.current === "enter", (v) => {
			r.dispose(), u$4(v, {
				[T$3.Ended]() {
					p(), l.current(e.current);
				},
				[T$3.Cancelled]: () => {}
			});
		})), r.dispose;
	}, [o]);
}
//#endregion
//#region ../../node_modules/@headlessui/react/dist/components/transitions/transition.js
function h$1(e = "") {
	return e.split(" ").filter((n) => n.trim().length > 1);
}
var N$2 = createContext(null);
N$2.displayName = "TransitionContext";
var ge$1 = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(ge$1 || {});
function ve$1() {
	let e = useContext(N$2);
	if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
	return e;
}
function Ce$1() {
	let e = useContext(L);
	if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
	return e;
}
var L = createContext(null);
L.displayName = "NestingContext";
function w$3(e) {
	return "children" in e ? w$3(e.children) : e.current.filter(({ state: n }) => n === "visible").length > 0;
}
function Z$1(e) {
	let n = s$6(e), t = useRef([]), r = f$2(), s = o$4((l, o = R.Hidden) => {
		let a = t.current.findIndex(({ id: u }) => u === l);
		a !== -1 && (u$4(o, {
			[R.Unmount]() {
				t.current.splice(a, 1);
			},
			[R.Hidden]() {
				t.current[a].state = "hidden";
			}
		}), t$1(() => {
			var u;
			!w$3(t) && r.current && ((u = n.current) == null || u.call(n));
		}));
	}), g = o$4((l) => {
		let o = t.current.find(({ id: a }) => a === l);
		return o ? o.state !== "visible" && (o.state = "visible") : t.current.push({
			id: l,
			state: "visible"
		}), () => s(l, R.Unmount);
	});
	return useMemo(() => ({
		children: t,
		register: g,
		unregister: s
	}), [
		g,
		s,
		t
	]);
}
function be$1() {}
var Se$1 = [
	"beforeEnter",
	"afterEnter",
	"beforeLeave",
	"afterLeave"
];
function $$1(e) {
	var t;
	let n = {};
	for (let r of Se$1) n[r] = (t = e[r]) != null ? t : be$1;
	return n;
}
function Ee(e) {
	let n = useRef($$1(e));
	return useEffect(() => {
		n.current = $$1(e);
	}, [e]), n;
}
var xe = "div";
var ee$1 = x$6.RenderStrategy;
var te$1 = H$3(function(n, t) {
	let { beforeEnter: r, afterEnter: s, beforeLeave: g, afterLeave: l, enter: o, enterFrom: a, enterTo: u, entered: A, leave: v, leaveFrom: E, leaveTo: x, ...y } = n, d = useRef(null), D = y$3(d, t), [i, C] = useState("visible"), p = y.unmount ? R.Unmount : R.Hidden, { show: b, appear: re, initial: ne } = ve$1(), { register: H, unregister: P } = Ce$1(), F = useRef(null), f = I();
	useEffect(() => {
		if (!!f) return H(f);
	}, [H, f]), useEffect(() => {
		if (p === R.Hidden && !!f) {
			if (b && i !== "visible") {
				C("visible");
				return;
			}
			u$4(i, {
				["hidden"]: () => P(f),
				["visible"]: () => H(f)
			});
		}
	}, [
		i,
		f,
		H,
		P,
		b,
		p
	]);
	let ie = s$6({
		enter: h$1(o),
		enterFrom: h$1(a),
		enterTo: h$1(u),
		entered: h$1(A),
		leave: h$1(v),
		leaveFrom: h$1(E),
		leaveTo: h$1(x)
	}), se = Ee({
		beforeEnter: r,
		afterEnter: s,
		beforeLeave: g,
		afterLeave: l
	}), O = a$4();
	useEffect(() => {
		if (O && i === "visible" && d.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
	}, [
		d,
		i,
		O
	]);
	let M = ne && !re, oe = (() => !O || M || F.current === b ? "idle" : b ? "enter" : "leave")(), _ = useRef(!1), B = Z$1(() => {
		_.current || (C("hidden"), P(f));
	});
	H$1({
		container: d,
		classes: ie,
		events: se,
		direction: oe,
		onStart: s$6(() => {
			_.current = !0;
		}),
		onStop: s$6((ue) => {
			_.current = !1, ue === "leave" && !w$3(B) && (C("hidden"), P(f));
		})
	}), useEffect(() => {
		!M || (p === R.Hidden ? F.current = null : F.current = b);
	}, [
		b,
		M,
		i
	]);
	let le = y, ae = { ref: D };
	return React.createElement(L.Provider, { value: B }, React.createElement(C$6, { value: u$4(i, {
		["visible"]: p$2.Open,
		["hidden"]: p$2.Closed
	}) }, _$2({
		ourProps: ae,
		theirProps: le,
		defaultTag: xe,
		features: ee$1,
		visible: i === "visible",
		name: "Transition.Child"
	})));
});
var G$1 = H$3(function(n, t) {
	let { show: r, appear: s = !1, unmount: g, ...l } = n, o = useRef(null), a = y$3(o, t);
	a$4();
	let u = s$1();
	if (r === void 0 && u !== null && (r = u$4(u, {
		[p$2.Open]: !0,
		[p$2.Closed]: !1
	})), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
	let [A, v] = useState(r ? "visible" : "hidden"), E = Z$1(() => {
		v("hidden");
	}), [x, y] = useState(!0), d = useRef([r]);
	t$3(() => {
		x !== !1 && d.current[d.current.length - 1] !== r && (d.current.push(r), y(!1));
	}, [d, r]);
	let D = useMemo(() => ({
		show: r,
		appear: s,
		initial: x
	}), [
		r,
		s,
		x
	]);
	useEffect(() => {
		if (r) v("visible");
		else if (!w$3(E)) v("hidden");
		else {
			let C = o.current;
			if (!C) return;
			let p = C.getBoundingClientRect();
			p.x === 0 && p.y === 0 && p.width === 0 && p.height === 0 && v("hidden");
		}
	}, [r, E]);
	let i = { unmount: g };
	return React.createElement(L.Provider, { value: E }, React.createElement(N$2.Provider, { value: D }, _$2({
		ourProps: {
			...i,
			as: Fragment,
			children: React.createElement(te$1, {
				ref: a,
				...i,
				...l
			})
		},
		theirProps: {},
		defaultTag: Fragment,
		features: ee$1,
		visible: A === "visible",
		name: "Transition"
	})));
});
var ye = H$3(function(n, t) {
	let r = useContext(N$2) !== null, s = s$1() !== null;
	return React.createElement(React.Fragment, null, !r && s ? React.createElement(G$1, {
		ref: t,
		...n
	}) : React.createElement(te$1, {
		ref: t,
		...n
	}));
});
var We$1 = Object.assign(G$1, {
	Child: ye,
	Root: G$1
});
//#endregion
//#region src/components/atoms/backdrop/Backdrop.tsx
var Backdrop = ({ show }) => /* @__PURE__ */ React.createElement(We$1, {
	show,
	as: Fragment,
	appear: true,
	enter: "ease-in-out duration-100",
	enterFrom: "opacity-50",
	enterTo: "opacity-100",
	leave: "ease-in-out duration-[1200ms]",
	leaveFrom: "opacity-100",
	leaveTo: "opacity-0"
}, /* @__PURE__ */ React.createElement("div", { className: "absolute inset-0 bg-white bg-opacity-75 transition-opacity z-overlay" }));
//#endregion
//#region ../../node_modules/ariakit-utils/esm/dom.js
/**
* It's `true` if it is running in a browser environment or `false` if it is not
* (SSR).
* @example
* const title = canUseDOM ? document.title : "";
*/
var canUseDOM$1 = checkIsBrowser();
function checkIsBrowser() {
	var _window$document;
	return typeof window !== "undefined" && !!((_window$document = window.document) != null && _window$document.createElement);
}
/**
* Returns `element.ownerDocument || document`.
*/
function getDocument(node) {
	return node ? node.ownerDocument || node : document;
}
/**
* Returns `element.ownerDocument.defaultView || window`.
*/
function getWindow$2(node) {
	return getDocument(node).defaultView || window;
}
/**
* Returns `element.ownerDocument.activeElement`.
*/
function getActiveElement(node, activeDescendant) {
	if (activeDescendant === void 0) activeDescendant = false;
	const { activeElement } = getDocument(node);
	if (!(activeElement != null && activeElement.nodeName)) return null;
	if (isFrame(activeElement) && activeElement.contentDocument) return getActiveElement(activeElement.contentDocument.body, activeDescendant);
	if (activeDescendant) {
		const id = activeElement.getAttribute("aria-activedescendant");
		if (id) {
			const element = getDocument(activeElement).getElementById(id);
			if (element) return element;
		}
	}
	return activeElement;
}
/**
* Similar to `Element.prototype.contains`, but a little bit faster when
* `element` is the same as `child`.
* @example
* contains(
*   document.getElementById("parent"),
*   document.getElementById("child")
* );
*/
function contains(parent, child) {
	return parent === child || parent.contains(child);
}
/**
* Checks whether `element` is a frame element.
*/
function isFrame(element) {
	return element.tagName === "IFRAME";
}
/**
* Checks whether `element` is a native HTML button element.
* @example
* isButton(document.querySelector("button")); // true
* isButton(document.querySelector("input[type='button']")); // true
* isButton(document.querySelector("div")); // false
* isButton(document.querySelector("input[type='text']")); // false
* isButton(document.querySelector("div[role='button']")); // false
*/
function isButton(element) {
	const tagName = element.tagName.toLowerCase();
	if (tagName === "button") return true;
	if (tagName === "input" && element.type) return buttonInputTypes.indexOf(element.type) !== -1;
	return false;
}
var buttonInputTypes = [
	"button",
	"color",
	"file",
	"image",
	"reset",
	"submit"
];
/**
* Ponyfill for `Element.prototype.matches`
*
* @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
*/
function matches(element, selectors) {
	if ("matches" in element) return element.matches(selectors);
	if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
	return element.webkitMatchesSelector(selectors);
}
/**
* Checks if the element is visible or not.
*/
function isVisible(element) {
	const htmlElement = element;
	return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element.getClientRects().length > 0;
}
/**
* Ponyfill for `Element.prototype.closest`
* @example
* closest(document.getElementById("id"), "div");
* // same as
* document.getElementById("id").closest("div");
*/
function closest(element, selectors) {
	if ("closest" in element) return element.closest(selectors);
	do {
		if (matches(element, selectors)) return element;
		element = element.parentElement || element.parentNode;
	} while (element !== null && element.nodeType === 1);
	return null;
}
/**
* Check whether the given element is a text field, where text field is defined
* by the ability to select within the input.
* @example
* isTextField(document.querySelector("div")); // false
* isTextField(document.querySelector("input")); // true
* isTextField(document.querySelector("input[type='button']")); // false
* isTextField(document.querySelector("textarea")); // true
*/
function isTextField(element) {
	try {
		const isTextInput = element instanceof HTMLInputElement && element.selectionStart !== null;
		const isTextArea = element.tagName === "TEXTAREA";
		return isTextInput || isTextArea || false;
	} catch (error) {
		return false;
	}
}
/**
* Returns the element's role attribute, if it has one.
*/
function getPopupRole(element, fallback) {
	const allowedPopupRoles = [
		"dialog",
		"menu",
		"listbox",
		"tree",
		"grid"
	];
	const role = element == null ? void 0 : element.getAttribute("role");
	if (role && allowedPopupRoles.indexOf(role) !== -1) return role;
	return fallback;
}
/**
* Returns the item role attribute based on the popup's role.
*/
function getPopupItemRole(element, fallback) {
	var _itemRoleByPopupRole$;
	const itemRoleByPopupRole = {
		menu: "menuitem",
		listbox: "option",
		tree: "treeitem",
		grid: "gridcell"
	};
	const popupRole = getPopupRole(element);
	if (!popupRole) return fallback;
	return (_itemRoleByPopupRole$ = itemRoleByPopupRole[popupRole]) != null ? _itemRoleByPopupRole$ : fallback;
}
/**
* Returns the scrolling container element of a given element.
*/
function getScrollingElement(element) {
	if (!element) return null;
	if (element.clientHeight && element.scrollHeight > element.clientHeight) {
		const { overflowY } = getComputedStyle(element);
		if (overflowY !== "visible" && overflowY !== "hidden") return element;
	}
	return getScrollingElement(element.parentElement) || document.scrollingElement || document.body;
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/platform.js
/**
* Detects if the device has touch capabilities.
*/
function isTouchDevice() {
	return canUseDOM$1 && !!navigator.maxTouchPoints;
}
/**
* Detects Apple device.
*/
function isApple() {
	if (!canUseDOM$1) return false;
	return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
/**
* Detects Safari browser.
*/
function isSafari() {
	return canUseDOM$1 && isApple() && /apple/i.test(navigator.vendor);
}
/**
* Detects Firefox browser.
*/
function isFirefox() {
	return canUseDOM$1 && /firefox\//i.test(navigator.userAgent);
}
/**
* Detects Mac computer.
*/
function isMac() {
	return canUseDOM$1 && navigator.platform.startsWith("Mac") && !isTouchDevice();
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/events.js
/**
* Returns `true` if `event` has been fired within a React Portal element.
*/
function isPortalEvent(event) {
	return !contains(event.currentTarget, event.target);
}
/**
* Returns `true` if `event.target` and `event.currentTarget` are the same.
*/
function isSelfTarget(event) {
	return event.target === event.currentTarget;
}
/**
* Checks whether the user event is triggering a page navigation in a new tab.
*/
function isOpeningInNewTab(event) {
	const element = event.currentTarget;
	if (!element) return false;
	const isAppleDevice = isApple();
	if (isAppleDevice && !event.metaKey) return false;
	if (!isAppleDevice && !event.ctrlKey) return false;
	const tagName = element.tagName.toLowerCase();
	if (tagName === "a") return true;
	if (tagName === "button" && element.type === "submit") return true;
	if (tagName === "input" && element.type === "submit") return true;
	return false;
}
/**
* Checks whether the user event is triggering a download.
*/
function isDownloading(event) {
	const element = event.currentTarget;
	if (!element) return false;
	const tagName = element.tagName.toLowerCase();
	if (!event.altKey) return false;
	if (tagName === "a") return true;
	if (tagName === "button" && element.type === "submit") return true;
	if (tagName === "input" && element.type === "submit") return true;
	return false;
}
/**
* Creates and dispatches a blur event.
* @example
* fireBlurEvent(document.getElementById("id"));
*/
function fireBlurEvent(element, eventInit) {
	const event = new FocusEvent("blur", eventInit);
	const defaultAllowed = element.dispatchEvent(event);
	const bubbleInit = {
		...eventInit,
		bubbles: true
	};
	element.dispatchEvent(new FocusEvent("focusout", bubbleInit));
	return defaultAllowed;
}
/**
* Creates and dispatches a focus event.
* @example
* fireFocusEvent(document.getElementById("id"));
*/
function fireFocusEvent(element, eventInit) {
	const event = new FocusEvent("focus", eventInit);
	const defaultAllowed = element.dispatchEvent(event);
	const bubbleInit = {
		...eventInit,
		bubbles: true
	};
	element.dispatchEvent(new FocusEvent("focusin", bubbleInit));
	return defaultAllowed;
}
/**
* Creates and dispatches a keyboard event.
* @example
* fireKeyboardEvent(document.getElementById("id"), "keydown", {
*   key: "ArrowDown",
*   shiftKey: true,
* });
*/
function fireKeyboardEvent(element, type, eventInit) {
	const event = new KeyboardEvent(type, eventInit);
	return element.dispatchEvent(event);
}
/**
* Creates and dispatches a click event.
* @example
* fireClickEvent(document.getElementById("id"));
*/
function fireClickEvent(element, eventInit) {
	const event = new MouseEvent("click", eventInit);
	return element.dispatchEvent(event);
}
/**
* Checks whether the focus/blur event is happening from/to outside of the
* container element.
* @example
* const element = document.getElementById("id");
* element.addEventListener("blur", (event) => {
*   if (isFocusEventOutside(event)) {
*     // ...
*   }
* });
*/
function isFocusEventOutside(event, container) {
	const containerElement = container || event.currentTarget;
	const relatedTarget = event.relatedTarget;
	return !relatedTarget || !contains(containerElement, relatedTarget);
}
/**
* Runs a callback on the next animation frame, but before a certain event.
*/
function queueBeforeEvent(element, type, callback) {
	const raf = requestAnimationFrame(() => {
		element.removeEventListener(type, callImmediately, true);
		callback();
	});
	const callImmediately = () => {
		cancelAnimationFrame(raf);
		callback();
	};
	element.addEventListener(type, callImmediately, {
		once: true,
		capture: true
	});
	return raf;
}
/**
* Adds a global event listener, including on child frames.
*/
function addGlobalEventListener(type, listener, options, scope) {
	if (scope === void 0) scope = window;
	try {
		scope.document.addEventListener(type, listener, options);
	} catch (e) {}
	const listeners = [];
	for (let i = 0; i < ((_scope$frames = scope.frames) == null ? void 0 : _scope$frames.length); i += 1) {
		var _scope$frames;
		const frameWindow = scope.frames[i];
		if (frameWindow) listeners.push(addGlobalEventListener(type, listener, options, frameWindow));
	}
	const removeEventListener = () => {
		try {
			scope.document.removeEventListener(type, listener, options);
		} catch (e) {}
		listeners.forEach((listener) => listener());
	};
	return removeEventListener;
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/misc.js
/**
* Empty function.
*/
function noop$4() {}
/**
* Compares two objects.
* @example
* shallowEqual({ a: "a" }, {}); // false
* shallowEqual({ a: "a" }, { b: "b" }); // false
* shallowEqual({ a: "a" }, { a: "a" }); // true
* shallowEqual({ a: "a" }, { a: "a", b: "b" }); // false
*/
function shallowEqual(a, b) {
	if (a === b) return true;
	if (!a) return false;
	if (!b) return false;
	if (typeof a !== "object") return false;
	if (typeof b !== "object") return false;
	const aKeys = Object.keys(a);
	const bKeys = Object.keys(b);
	const { length } = aKeys;
	if (bKeys.length !== length) return false;
	for (const key of aKeys) if (a[key] !== b[key]) return false;
	return true;
}
/**
* Receives a `setState` argument and calls it with `currentValue` if it's a
* function. Otherwise return the argument as the new value.
* @example
* applyState((value) => value + 1, 1); // 2
* applyState(2, 1); // 2
*/
function applyState(argument, currentValue) {
	if (isUpdater(argument)) return argument(isLazyValue(currentValue) ? currentValue() : currentValue);
	return argument;
}
function isUpdater(argument) {
	return typeof argument === "function";
}
function isLazyValue(value) {
	return typeof value === "function";
}
/**
* Sets both a function and object React ref.
*/
function setRef(ref, value) {
	if (typeof ref === "function") ref(value);
	else if (ref) ref.current = value;
}
/**
* Checks whether `prop` is an own property of `obj` or not.
*/
function hasOwnProperty(object, prop) {
	return Object.prototype.hasOwnProperty.call(object, prop);
}
/**
* Receives functions as arguments and returns a new function that calls all.
*/
function chain() {
	for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) fns[_key] = arguments[_key];
	return function() {
		for (const fn of fns) if (typeof fn === "function") fn(...arguments);
	};
}
/**
* Returns a string with the truthy values of `args` separated by space.
*/
function cx() {
	for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
	return args.filter(Boolean).join(" ") || void 0;
}
/**
* Removes diatrics from a string.
* TODO: Check if it works on WebView Android.
*/
function normalizeString(str) {
	return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
/**
* Queues a function to be called at the end of the current event loop.
*/
function queueMicrotask$1(callback) {
	if (window.queueMicrotask) return window.queueMicrotask(callback);
	Promise.resolve().then(callback);
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/hooks.js
var useReactId = m$3["useId"];
var useInsertionEffect = m$3["useInsertionEffect"];
/**
* `React.useLayoutEffect` that fallbacks to `React.useEffect` on server side.
*/
var useSafeLayoutEffect = canUseDOM$1 ? useLayoutEffect : useEffect;
/**
* Returns a value that never changes even if the argument is updated.
* @example
* function Component({ prop }) {
*   const initialProp = useInitialValue(prop);
* }
*/
function useInitialValue$1(value) {
	const [initialValue] = useState(value);
	return initialValue;
}
/**
* Returns a value that is lazily initiated and never changes.
* @example
* function Component() {
*   const set = useLazyValue(() => new Set());
* }
*/
function useLazyValue(init) {
	const ref = useRef();
	if (ref.current === void 0) ref.current = init();
	return ref.current;
}
/**
* Creates a `React.RefObject` that is constantly updated with the incoming
* value.
* @example
* function Component({ prop }) {
*   const propRef = useLiveRef(prop);
* }
*/
function useLiveRef(value) {
	const ref = useRef(value);
	useSafeLayoutEffect(() => {
		ref.current = value;
	});
	return ref;
}
/**
* Keeps the reference of the previous value to be used in the render phase.
*/
function usePreviousValue(value) {
	const [previousValue, setPreviousValue] = useState(value);
	if (value !== previousValue) setPreviousValue(value);
	return previousValue;
}
/**
* Creates a stable callback function that has access to the latest state and
* can be used within event handlers and effect callbacks. Throws when used in
* the render phase.
* @example
* function Component(props) {
*   const onClick = useEvent(props.onClick);
*   React.useEffect(() => {}, [onClick]);
* }
*/
function useEvent$1(callback) {
	const ref = useRef(() => {
		throw new Error("Cannot call an event handler while rendering.");
	});
	if (useInsertionEffect) useInsertionEffect(() => {
		ref.current = callback;
	});
	else ref.current = callback;
	return useCallback(function() {
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		return ref.current == null ? void 0 : ref.current(...args);
	}, []);
}
/**
* Merges React Refs into a single memoized function ref so you can pass it to
* an element.
* @example
* const Component = React.forwardRef((props, ref) => {
*   const internalRef = React.useRef();
*   return <div {...props} ref={useForkRef(internalRef, ref)} />;
* });
*/
function useForkRef() {
	for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) refs[_key2] = arguments[_key2];
	return useMemo(() => {
		if (!refs.some(Boolean)) return;
		return (value) => {
			refs.forEach((ref) => {
				setRef(ref, value);
			});
		};
	}, refs);
}
/**
* Returns the ref element's ID.
*/
function useRefId(ref, deps) {
	const [id, setId] = useState(void 0);
	useSafeLayoutEffect(() => {
		var _ref$current;
		setId(ref == null ? void 0 : (_ref$current = ref.current) == null ? void 0 : _ref$current.id);
	}, deps);
	return id;
}
/**
* Generates a unique ID. Uses React's useId if available.
*/
function useId(defaultId) {
	if (useReactId) {
		const reactId = useReactId();
		if (defaultId) return defaultId;
		return reactId;
	}
	const [id, setId] = useState(defaultId);
	useSafeLayoutEffect(() => {
		if (defaultId || id) return;
		const random = Math.random().toString(36).substr(2, 6);
		setId("id-" + random);
	}, [defaultId, id]);
	return defaultId || id;
}
/**
* Returns the tag name by parsing an element ref and the `as` prop.
* @example
* function Component(props) {
*   const ref = React.useRef();
*   const tagName = useTagName(ref, "button"); // div
*   return <div ref={ref} {...props} />;
* }
*/
function useTagName(ref, type) {
	const [tagName, setTagName] = useState(() => stringOrUndefined(type));
	useSafeLayoutEffect(() => {
		var _ref$current2;
		setTagName((ref == null ? void 0 : (_ref$current2 = ref.current) == null ? void 0 : _ref$current2.tagName.toLowerCase()) || stringOrUndefined(type));
	}, [ref, type]);
	return tagName;
}
function stringOrUndefined(type) {
	if (typeof type === "string") return type;
}
/**
* A custom version of `React.useState` that uses the `state` and `setState`
* arguments. If they're not provided, it will use the internal state.
*/
function useControlledState(defaultState, state, setState) {
	const [localState, setLocalState] = useState(defaultState);
	const nextState = state !== void 0 ? state : localState;
	const stateRef = useLiveRef(state);
	const setStateRef = useLiveRef(setState);
	const nextStateRef = useLiveRef(nextState);
	const setNextState = useCallback((prevValue) => {
		const setStateProp = setStateRef.current;
		if (setStateProp) {
			if (isSetNextState(setStateProp)) setStateProp(prevValue);
			else {
				const nextValue = applyState(prevValue, nextStateRef.current);
				nextStateRef.current = nextValue;
				setStateProp(nextValue);
			}
		}
		if (stateRef.current === void 0) setLocalState(prevValue);
	}, []);
	defineSetNextState(setNextState);
	return [nextState, setNextState];
}
var SET_NEXT_STATE = Symbol("setNextState");
function isSetNextState(arg) {
	return arg[SET_NEXT_STATE] === true;
}
function defineSetNextState(arg) {
	if (!isSetNextState(arg)) Object.defineProperty(arg, SET_NEXT_STATE, { value: true });
}
/**
* A React hook similar to `useState` and `useReducer`, but with the only
* purpose of re-rendering the component.
*/
function useForceUpdate$1() {
	return useReducer(() => [], []);
}
/**
* Returns an event callback similar to `useEvent`, but this also accepts a
* boolean value, which will be turned into a function.
*/
function useBooleanEvent(booleanOrCallback) {
	return useEvent$1(typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback);
}
/**
* Returns props with an additional `wrapElement` prop.
*/
function useWrapElement(props, callback, deps) {
	if (deps === void 0) deps = [];
	const wrapElement = useCallback((element) => {
		if (props.wrapElement) element = props.wrapElement(element);
		return callback(element);
	}, [...deps, props.wrapElement]);
	return {
		...props,
		wrapElement
	};
}
/**
* Merges the portalRef prop and returns a `domReady` to be used in the
* components that use Portal underneath.
*/
function usePortalRef(portalProp, portalRefProp) {
	if (portalProp === void 0) portalProp = false;
	const [portalNode, setPortalNode] = useState(null);
	return {
		portalRef: useForkRef(setPortalNode, portalRefProp),
		portalNode,
		domReady: !portalProp || portalNode
	};
}
/**
* Returns a function that checks whether the mouse is moving.
*/
function useIsMouseMoving() {
	useEffect(() => {
		addGlobalEventListener("mousemove", setMouseMoving, true);
		addGlobalEventListener("mousedown", resetMouseMoving, true);
		addGlobalEventListener("mouseup", resetMouseMoving, true);
		addGlobalEventListener("keydown", resetMouseMoving, true);
		addGlobalEventListener("scroll", resetMouseMoving, true);
	}, []);
	return useEvent$1(() => mouseMoving);
}
var mouseMoving = false;
var previousScreenX = 0;
var previousScreenY = 0;
function hasMouseMovement(event) {
	const movementX = event.movementX || event.screenX - previousScreenX;
	const movementY = event.movementY || event.screenY - previousScreenY;
	previousScreenX = event.screenX;
	previousScreenY = event.screenY;
	return movementX || movementY || process.env.NODE_ENV === "test";
}
function setMouseMoving(event) {
	if (!hasMouseMovement(event)) return;
	mouseMoving = true;
}
function resetMouseMoving() {
	mouseMoving = false;
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/system.js
function isRenderProp(children) {
	return typeof children === "function";
}
/**
* Creates a type-safe component with the `as` prop and `React.forwardRef`.
*
* @example
* import { createComponent } from "ariakit-utils/system";
*
* type Props = {
*   as?: "div";
*   customProp?: boolean;
* };
*
* const Component = createComponent<Props>(({ customProp, ...props }) => {
*   return <div {...props} />;
* });
*
* <Component as="button" customProp />
*/
function createComponent(render) {
	const Role = (props, ref) => render({
		ref,
		...props
	});
	return /*#__PURE__*/ forwardRef(Role);
}
/**
* Creates a React element that supports the `as` prop, children as a
* function (render props) and a `wrapElement` function.
*
* @example
* import { createElement } from "ariakit-utils/system";
*
* function Component() {
*   const props = {
*     as: "button" as const,
*     children: (htmlProps) => <button {...htmlProps} />,
*     wrapElement: (element) => <div>{element}</div>,
*   };
*   return createElement("div", props);
* }
*/
function createElement$1(Type, props) {
	const { as: As, wrapElement, ...rest } = props;
	let element;
	if (As && typeof As !== "string") element = /*#__PURE__*/ jsx(As, { ...rest });
	else if (isRenderProp(props.children)) {
		const { children, ...otherProps } = rest;
		element = props.children(otherProps);
	} else if (As) element = /*#__PURE__*/ jsx(As, { ...rest });
	else element = /*#__PURE__*/ jsx(Type, { ...rest });
	if (wrapElement) return wrapElement(element);
	return element;
}
/**
* Creates a component hook that accepts props and returns props so they can be
* passed to a React element.
*
* @example
* import { Options, createHook } from "ariakit-utils/system";
*
* type Props = Options<"div"> & {
*   customProp?: boolean;
* };
*
* const useComponent = createHook<Props>(({ customProp, ...props }) => {
*   return props;
* });
*
* const props = useComponent({ as: "button", customProp: true });
*/
function createHook(useProps) {
	const useRole = function(props) {
		if (props === void 0) props = {};
		const htmlProps = useProps(props);
		const copy = {};
		for (const prop in htmlProps) if (hasOwnProperty(htmlProps, prop) && htmlProps[prop] !== void 0) copy[prop] = htmlProps[prop];
		return copy;
	};
	return useRole;
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/focus.js
var selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function hasNegativeTabIndex(element) {
	return parseInt(element.getAttribute("tabindex") || "0", 10) < 0;
}
/**
* Checks whether `element` is focusable or not.
* @example
* isFocusable(document.querySelector("input")); // true
* isFocusable(document.querySelector("input[tabindex='-1']")); // true
* isFocusable(document.querySelector("input[hidden]")); // false
* isFocusable(document.querySelector("input:disabled")); // false
*/
function isFocusable(element) {
	return matches(element, selector) && isVisible(element);
}
/**
* Checks whether `element` is tabbable or not.
* @example
* isTabbable(document.querySelector("input")); // true
* isTabbable(document.querySelector("input[tabindex='-1']")); // false
* isTabbable(document.querySelector("input[hidden]")); // false
* isTabbable(document.querySelector("input:disabled")); // false
*/
function isTabbable(element) {
	return isFocusable(element) && !hasNegativeTabIndex(element);
}
/**
* Returns all the focusable elements in `container`.
*/
function getAllFocusableIn(container, includeContainer) {
	const elements = Array.from(container.querySelectorAll(selector));
	if (includeContainer) elements.unshift(container);
	const focusableElements = elements.filter(isFocusable);
	focusableElements.forEach((element, i) => {
		if (isFrame(element) && element.contentDocument) {
			const frameBody = element.contentDocument.body;
			focusableElements.splice(i, 1, ...getAllFocusableIn(frameBody));
		}
	});
	return focusableElements;
}
/**
* Returns all the tabbable elements in `container`, including the container
* itself.
*/
function getAllTabbableIn(container, includeContainer, fallbackToFocusable) {
	const elements = Array.from(container.querySelectorAll(selector));
	const tabbableElements = elements.filter(isTabbable);
	if (includeContainer && isTabbable(container)) tabbableElements.unshift(container);
	tabbableElements.forEach((element, i) => {
		if (isFrame(element) && element.contentDocument) {
			const frameBody = element.contentDocument.body;
			const allFrameTabbable = getAllTabbableIn(frameBody, false, fallbackToFocusable);
			tabbableElements.splice(i, 1, ...allFrameTabbable);
		}
	});
	if (!tabbableElements.length && fallbackToFocusable) return elements;
	return tabbableElements;
}
/**
* Returns the first tabbable element in `container`, including the container
* itself if it's tabbable.
*/
function getFirstTabbableIn(container, includeContainer, fallbackToFocusable) {
	const [first] = getAllTabbableIn(container, includeContainer, fallbackToFocusable);
	return first || null;
}
/**
* Returns the next tabbable element in `container`.
*/
function getNextTabbableIn(container, includeContainer, fallbackToFirst, fallbackToFocusable) {
	const activeElement = getActiveElement(container);
	const allFocusable = getAllFocusableIn(container, includeContainer);
	const activeIndex = allFocusable.indexOf(activeElement);
	const nextFocusableElements = allFocusable.slice(activeIndex + 1);
	return nextFocusableElements.find(isTabbable) || (fallbackToFirst ? allFocusable.find(isTabbable) : null) || (fallbackToFocusable ? nextFocusableElements[0] : null) || null;
}
/**
* Returns the next tabbable element in the document.
*/
function getNextTabbable(fallbackToFirst, fallbackToFocusable) {
	return getNextTabbableIn(document.body, false, fallbackToFirst, fallbackToFocusable);
}
/**
* Returns the previous tabbable element in `container`.
*
*/
function getPreviousTabbableIn(container, includeContainer, fallbackToLast, fallbackToFocusable) {
	const activeElement = getActiveElement(container);
	const allFocusable = getAllFocusableIn(container, includeContainer).reverse();
	const activeIndex = allFocusable.indexOf(activeElement);
	const previousFocusableElements = allFocusable.slice(activeIndex + 1);
	return previousFocusableElements.find(isTabbable) || (fallbackToLast ? allFocusable.find(isTabbable) : null) || (fallbackToFocusable ? previousFocusableElements[0] : null) || null;
}
/**
* Returns the previous tabbable element in the document.
*/
function getPreviousTabbable(fallbackToFirst, fallbackToFocusable) {
	return getPreviousTabbableIn(document.body, false, fallbackToFirst, fallbackToFocusable);
}
/**
* Checks if `element` has focus. Elements that are referenced by
* `aria-activedescendant` are also considered.
* @example
* hasFocus(document.getElementById("id"));
*/
function hasFocus(element) {
	const activeElement = getActiveElement(element);
	if (!activeElement) return false;
	if (activeElement === element) return true;
	const activeDescendant = activeElement.getAttribute("aria-activedescendant");
	if (!activeDescendant) return false;
	return activeDescendant === element.id;
}
/**
* Checks if `element` has focus within. Elements that are referenced by
* `aria-activedescendant` are also considered.
* @example
* hasFocusWithin(document.getElementById("id"));
*/
function hasFocusWithin(element) {
	const activeElement = getActiveElement(element);
	if (!activeElement) return false;
	if (contains(element, activeElement)) return true;
	const activeDescendant = activeElement.getAttribute("aria-activedescendant");
	if (!activeDescendant) return false;
	if (!("id" in element)) return false;
	if (activeDescendant === element.id) return true;
	return !!element.querySelector("#" + CSS.escape(activeDescendant));
}
/**
* Focus on an element only if it's not already focused.
*/
function focusIfNeeded(element) {
	if (!hasFocusWithin(element) && isFocusable(element)) element.focus();
}
/**
* Disable focus on `element`.
*/
function disableFocus(element) {
	var _element$getAttribute;
	const currentTabindex = (_element$getAttribute = element.getAttribute("tabindex")) != null ? _element$getAttribute : "";
	element.setAttribute("data-tabindex", currentTabindex);
	element.setAttribute("tabindex", "-1");
}
/**
* Makes elements inside container not tabbable.
*/
function disableFocusIn(container, includeContainer) {
	getAllTabbableIn(container, includeContainer).forEach(disableFocus);
}
/**
* Restores tabbable elements inside container that were affected by
* disableFocusIn.
*/
function restoreFocusIn(container) {
	const elements = container.querySelectorAll("[data-tabindex]");
	const restoreTabIndex = (element) => {
		const tabindex = element.getAttribute("data-tabindex");
		element.removeAttribute("data-tabindex");
		if (tabindex) element.setAttribute("tabindex", tabindex);
		else element.removeAttribute("tabindex");
	};
	if (container.hasAttribute("data-tabindex")) restoreTabIndex(container);
	elements.forEach(restoreTabIndex);
}
/**
* Focus on element and scroll into view.
*/
function focusIntoView(element, options) {
	if (!("scrollIntoView" in element)) element.focus();
	else {
		element.focus({ preventScroll: true });
		element.scrollIntoView({
			block: "nearest",
			inline: "nearest",
			...options
		});
	}
}
//#endregion
//#region ../../node_modules/ariakit/esm/focusable/focusable.js
var isSafariBrowser$1 = isSafari();
var alwaysFocusVisibleInputTypes = [
	"text",
	"search",
	"url",
	"tel",
	"email",
	"password",
	"number",
	"date",
	"month",
	"week",
	"time",
	"datetime",
	"datetime-local"
];
function isAlwaysFocusVisible(element) {
	const { tagName, readOnly, type } = element;
	if (tagName === "TEXTAREA" && !readOnly) return true;
	if (tagName === "SELECT" && !readOnly) return true;
	if (tagName === "INPUT" && !readOnly) return alwaysFocusVisibleInputTypes.includes(type);
	if (element.isContentEditable) return true;
	return false;
}
function isAlwaysFocusVisibleDelayed(element) {
	if (element.getAttribute("role") === "combobox") return true;
	return false;
}
function getLabels(element) {
	if ("labels" in element) return element.labels;
	return null;
}
function isNativeCheckboxOrRadio(element) {
	if (element.tagName.toLowerCase() === "input" && element.type) return element.type === "radio" || element.type === "checkbox";
	return false;
}
function isNativeTabbable(tagName) {
	if (!tagName) return true;
	return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute(tagName) {
	if (!tagName) return true;
	return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function getTabIndex(focusable, trulyDisabled, nativeTabbable, supportsDisabled, tabIndexProp) {
	if (!focusable) return tabIndexProp;
	if (trulyDisabled) {
		if (nativeTabbable && !supportsDisabled) return -1;
		return;
	}
	if (nativeTabbable) return tabIndexProp;
	return tabIndexProp || 0;
}
function useDisableEvent(onEvent, disabled) {
	return useEvent$1((event) => {
		onEvent?.(event);
		if (event.defaultPrevented) return;
		if (disabled) {
			event.stopPropagation();
			event.preventDefault();
		}
	});
}
var isKeyboardModality = true;
function onGlobalMouseDown(event) {
	const target = event.target;
	if (target && "hasAttribute" in target) {
		if (!target.hasAttribute("data-focus-visible")) isKeyboardModality = false;
	}
}
function onGlobalKeyDown(event) {
	if (event.metaKey) return;
	if (event.ctrlKey) return;
	isKeyboardModality = true;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element that can be focused.
* @see https://ariakit.org/components/focusable
* @example
* ```jsx
* const props = useFocusable();
* <Role {...props}>Focusable</Role>
* ```
*/
var useFocusable = createHook((_ref) => {
	let { focusable = true, accessibleWhenDisabled, autoFocus, onFocusVisible, ...props } = _ref;
	const ref = useRef(null);
	useEffect(() => {
		if (!focusable) return;
		addGlobalEventListener("mousedown", onGlobalMouseDown, true);
		addGlobalEventListener("keydown", onGlobalKeyDown, true);
	}, [focusable]);
	if (isSafariBrowser$1) useEffect(() => {
		if (!focusable) return;
		const element = ref.current;
		if (!element) return;
		if (!isNativeCheckboxOrRadio(element)) return;
		const labels = getLabels(element);
		if (!labels) return;
		const onMouseUp = () => queueMicrotask$1(() => element.focus());
		labels.forEach((label) => label.addEventListener("mouseup", onMouseUp));
		return () => {
			labels.forEach((label) => label.removeEventListener("mouseup", onMouseUp));
		};
	}, [focusable]);
	const disabled = focusable && props.disabled;
	const trulyDisabled = !!disabled && !accessibleWhenDisabled;
	const [focusVisible, setFocusVisible] = useState(false);
	useEffect(() => {
		if (!focusable) return;
		if (trulyDisabled && focusVisible) setFocusVisible(false);
	}, [
		focusable,
		trulyDisabled,
		focusVisible
	]);
	useEffect(() => {
		if (!focusable) return;
		if (!focusVisible) return;
		const element = ref.current;
		if (!element) return;
		if (typeof IntersectionObserver === "undefined") return;
		const observer = new IntersectionObserver(() => {
			if (!isFocusable(element)) setFocusVisible(false);
		});
		observer.observe(element);
		return () => observer.disconnect();
	}, [focusable, focusVisible]);
	const onKeyPressCapture = useDisableEvent(props.onKeyPressCapture, disabled);
	const onMouseDownCapture = useDisableEvent(props.onMouseDownCapture, disabled);
	const onClickCapture = useDisableEvent(props.onClickCapture, disabled);
	const onMouseDownProp = props.onMouseDown;
	const onMouseDown = useEvent$1((event) => {
		onMouseDownProp?.(event);
		if (event.defaultPrevented) return;
		if (!focusable) return;
		const element = event.currentTarget;
		if (!isSafariBrowser$1) return;
		if (isPortalEvent(event)) return;
		if (!isButton(element) && !isNativeCheckboxOrRadio(element)) return;
		let receivedFocus = false;
		const onFocus = () => {
			receivedFocus = true;
		};
		element.addEventListener("focusin", onFocus, {
			capture: true,
			once: true
		});
		queueBeforeEvent(element, "mouseup", () => {
			element.removeEventListener("focusin", onFocus, true);
			if (receivedFocus) return;
			focusIfNeeded(element);
		});
	});
	const handleFocusVisible = (event, currentTarget) => {
		if (currentTarget) event.currentTarget = currentTarget;
		onFocusVisible?.(event);
		if (event.defaultPrevented) return;
		if (!focusable) return;
		const element = event.currentTarget;
		if (!element) return;
		if (!hasFocus(element)) return;
		setFocusVisible(true);
	};
	const onKeyDownCaptureProp = props.onKeyDownCapture;
	const onKeyDownCapture = useEvent$1((event) => {
		onKeyDownCaptureProp?.(event);
		if (event.defaultPrevented) return;
		if (!focusable) return;
		if (focusVisible) return;
		if (event.metaKey) return;
		if (event.altKey) return;
		if (event.ctrlKey) return;
		if (!isSelfTarget(event)) return;
		const element = event.currentTarget;
		queueMicrotask$1(() => handleFocusVisible(event, element));
	});
	const onFocusCaptureProp = props.onFocusCapture;
	const onFocusCapture = useEvent$1((event) => {
		onFocusCaptureProp?.(event);
		if (event.defaultPrevented) return;
		if (!focusable) return;
		if (!isSelfTarget(event)) {
			setFocusVisible(false);
			return;
		}
		const element = event.currentTarget;
		const applyFocusVisible = () => handleFocusVisible(event, element);
		if (isKeyboardModality || isAlwaysFocusVisible(event.target)) queueMicrotask$1(applyFocusVisible);
		else if (isAlwaysFocusVisibleDelayed(event.target)) queueBeforeEvent(event.target, "focusout", applyFocusVisible);
		else setFocusVisible(false);
	});
	const onBlurProp = props.onBlur;
	const onBlur = useEvent$1((event) => {
		onBlurProp?.(event);
		if (!focusable) return;
		if (isFocusEventOutside(event)) setFocusVisible(false);
	});
	useSafeLayoutEffect(() => {
		if (!focusable) return;
		if (autoFocus) {
			var _ref$current;
			(_ref$current = ref.current) == null || _ref$current.focus();
		}
	}, [focusable, autoFocus]);
	const tagName = useTagName(ref, props.as);
	const nativeTabbable = focusable && isNativeTabbable(tagName);
	const supportsDisabled = focusable && supportsDisabledAttribute(tagName);
	const style = trulyDisabled ? {
		pointerEvents: "none",
		...props.style
	} : props.style;
	props = {
		"data-focus-visible": focusable && focusVisible ? "" : void 0,
		"aria-disabled": disabled ? true : void 0,
		...props,
		ref: useForkRef(ref, props.ref),
		style,
		tabIndex: getTabIndex(focusable, trulyDisabled, nativeTabbable, supportsDisabled, props.tabIndex),
		disabled: supportsDisabled && trulyDisabled ? true : void 0,
		contentEditable: disabled ? void 0 : props.contentEditable,
		onKeyPressCapture,
		onClickCapture,
		onMouseDownCapture,
		onMouseDown,
		onKeyDownCapture,
		onFocusCapture,
		onBlur
	};
	return props;
});
/**
* A component that renders an element that can be focused.
* @see https://ariakit.org/components/focusable
* @example
* ```jsx
* <Focusable>Focusable</Focusable>
* ```
*/
var Focusable = createComponent((props) => {
	props = useFocusable(props);
	return createElement$1("div", props);
});
if (process.env.NODE_ENV !== "production") Focusable.displayName = "Focusable";
//#endregion
//#region ../../node_modules/ariakit/esm/command/command.js
function isNativeClick(event) {
	if (!event.isTrusted) return false;
	const element = event.currentTarget;
	return isButton(element) || element.tagName === "SUMMARY" || element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "A" || element.tagName === "SELECT";
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component. If the element is not a native clickable element (like a
* button), the hook will return additional props to make sure it's accessible.
* @see https://ariakit.org/components/command
* @example
* ```jsx
* const props = useCommand({ as: "div" });
* <Role {...props}>Accessible button</Role>
* ```
*/
var useCommand = createHook((_ref) => {
	let { clickOnEnter = true, clickOnSpace = true, ...props } = _ref;
	const ref = useRef(null);
	const tagName = useTagName(ref, props.as);
	const [isNativeButton, setIsNativeButton] = useState(() => !!tagName && isButton({
		tagName,
		type: props.type
	}));
	useEffect(() => {
		if (!ref.current) return;
		setIsNativeButton(isButton(ref.current));
	}, []);
	const [active, setActive] = useState(false);
	const activeRef = useRef(false);
	const isDuplicate = "data-command" in props;
	const onKeyDownProp = props.onKeyDown;
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		const element = event.currentTarget;
		if (event.defaultPrevented) return;
		if (isDuplicate) return;
		if (props.disabled) return;
		if (!isSelfTarget(event)) return;
		if (isTextField(element)) return;
		if (element.isContentEditable) return;
		const isEnter = clickOnEnter && event.key === "Enter";
		const isSpace = clickOnSpace && event.key === " ";
		const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
		const shouldPreventSpace = event.key === " " && !clickOnSpace;
		if (shouldPreventEnter || shouldPreventSpace) {
			event.preventDefault();
			return;
		}
		if (isEnter || isSpace) {
			const nativeClick = isNativeClick(event);
			if (isEnter) {
				if (!nativeClick) {
					event.preventDefault();
					const { view, ...eventInit } = event;
					const click = () => fireClickEvent(element, eventInit);
					if (isFirefox()) queueBeforeEvent(element, "keyup", click);
					else queueMicrotask$1(click);
				}
			} else if (isSpace) {
				activeRef.current = true;
				if (!nativeClick) {
					event.preventDefault();
					setActive(true);
				}
			}
		}
	});
	const onKeyUpProp = props.onKeyUp;
	const onKeyUp = useEvent$1((event) => {
		onKeyUpProp?.(event);
		if (event.defaultPrevented) return;
		if (isDuplicate) return;
		if (props.disabled) return;
		if (event.metaKey) return;
		const isSpace = clickOnSpace && event.key === " ";
		if (activeRef.current && isSpace) {
			activeRef.current = false;
			if (!isNativeClick(event)) {
				setActive(false);
				const element = event.currentTarget;
				const { view, ...eventInit } = event;
				queueMicrotask$1(() => fireClickEvent(element, eventInit));
			}
		}
	});
	props = {
		"data-command": "",
		"data-active": active ? "" : void 0,
		type: isNativeButton ? "button" : void 0,
		...props,
		ref: useForkRef(ref, props.ref),
		onKeyDown,
		onKeyUp
	};
	props = useFocusable(props);
	return props;
});
/**
* A component that renders a native clickable element (a button). If another
* element is passed to the `as` prop, this component will make sure the
* rendered element is accessible.
* @see https://ariakit.org/components/command
* @example
* ```jsx
* <Command as="div">Accessible button</Command>
* ```
*/
var Command = createComponent((props) => {
	props = useCommand(props);
	return createElement$1("button", props);
});
if (process.env.NODE_ENV !== "production") Command.displayName = "Command";
//#endregion
//#region ../../node_modules/ariakit/esm/button/button.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component. If the element is not a native button, the hook will
* return additional props to make sure it's accessible.
* @see https://ariakit.org/components/button
* @example
* ```jsx
* const props = useButton({ as: "div" });
* <Role {...props}>Accessible button</Role>
* ```
*/
var useButton = createHook((props) => {
	const ref = useRef(null);
	const tagName = useTagName(ref, props.as || "button");
	const [isNativeButton, setIsNativeButton] = useState(() => !!tagName && isButton({
		tagName,
		type: props.type
	}));
	useEffect(() => {
		if (!ref.current) return;
		setIsNativeButton(isButton(ref.current));
	}, []);
	props = {
		role: !isNativeButton && tagName !== "a" ? "button" : void 0,
		...props,
		ref: useForkRef(ref, props.ref)
	};
	props = useCommand(props);
	return props;
});
/**
* A component that renders a native accessible button. If another element is
* passed to the `as` prop, this component will make sure the rendered element
* is accessible.
* @see https://ariakit.org/components/button
* @example
* ```jsx
* <Button as="div">Accessible button</Button>
* ```
*/
var Button$2 = createComponent((props) => {
	return createElement$1("button", useButton(props));
});
if (process.env.NODE_ENV !== "production") Button$2.displayName = "Button";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-fdd6f8a4.js
var CheckboxCheckedContext = /*#__PURE__*/ createContext(false);
//#endregion
//#region ../../node_modules/ariakit/esm/checkbox/checkbox.js
function getStateChecked(stateValue, elementValue) {
	if (stateValue === void 0) return;
	if (elementValue) {
		if (Array.isArray(stateValue)) return stateValue.includes(elementValue);
		return stateValue === elementValue;
	}
	if (Array.isArray(stateValue)) return false;
	if (typeof stateValue === "boolean") return stateValue;
	return false;
}
function setMixed(element, mixed) {
	if (mixed) element.indeterminate = true;
	else if (element.indeterminate) element.indeterminate = false;
}
function isNativeCheckbox(tagName, type) {
	return tagName === "input" && (!type || type === "checkbox");
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component. If the element is not a native checkbox, the hook will
* return additional props to make sure it's accessible.
* @see https://ariakit.org/components/checkbox
* @example
* ```jsx
* const props = useCheckbox({ as: "div" });
* <Role {...props}>Accessible checkbox</Role>
* ```
*/
var useCheckbox = createHook((_ref) => {
	let { state, value, checked: checkedProp, defaultChecked, ...props } = _ref;
	const [checked, setChecked] = useControlledState(defaultChecked != null ? defaultChecked : false, checkedProp != null ? checkedProp : getStateChecked(state == null ? void 0 : state.value, value));
	const ref = useRef(null);
	const nativeCheckbox = isNativeCheckbox(useTagName(ref, props.as || "input"), props.type);
	const mixed = checked ? checked === "mixed" : void 0;
	const isChecked = checked === "mixed" ? false : checked;
	useEffect(() => {
		const element = ref.current;
		if (!element) return;
		setMixed(element, mixed);
		element.checked = isChecked;
	}, [mixed, isChecked]);
	const onChangeProp = props.onChange;
	const onChange = useEvent$1((event) => {
		if (props.disabled) {
			event.stopPropagation();
			event.preventDefault();
			return;
		}
		setMixed(event.currentTarget, mixed);
		if (!nativeCheckbox) event.currentTarget.checked = !event.currentTarget.checked;
		onChangeProp?.(event);
		if (event.defaultPrevented) return;
		const elementChecked = event.currentTarget.checked;
		setChecked(elementChecked);
		state?.setValue((prevValue) => {
			if (!value) return elementChecked;
			if (!Array.isArray(prevValue)) return value;
			if (elementChecked) return [...prevValue, value];
			return prevValue.filter((v) => v !== value);
		});
	});
	const onClickProp = props.onClick;
	const onClick = useEvent$1((event) => {
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		if (nativeCheckbox) return;
		onChange(event);
	});
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(CheckboxCheckedContext.Provider, {
		value: isChecked,
		children: element
	}), [isChecked]);
	props = {
		role: !nativeCheckbox ? "checkbox" : void 0,
		type: nativeCheckbox ? "checkbox" : void 0,
		"aria-checked": checked,
		...props,
		ref: useForkRef(ref, props.ref),
		onChange,
		onClick
	};
	props = useCommand({
		clickOnEnter: !nativeCheckbox,
		...props
	});
	return {
		value: nativeCheckbox ? value : void 0,
		checked: isChecked,
		...props
	};
});
/**
* A component that renders a native accessible checkbox. If another element is
* passed to the `as` prop, this component will make sure the rendered element
* is accessible.
* @see https://ariakit.org/components/checkbox
* @example
* ```jsx
* <Checkbox as="div">Accessible checkbox</Checkbox>
* ```
*/
var Checkbox$1 = createComponent((props) => {
	return createElement$1("input", useCheckbox(props));
});
if (process.env.NODE_ENV !== "production") Checkbox$1.displayName = "Checkbox";
//#endregion
//#region ../../node_modules/ariakit-utils/esm/array.js
/**
* Transforms `arg` into an array if it's not already.
* @example
* toArray("a"); // ["a"]
* toArray(["a"]); // ["a"]
*/
function toArray$1(arg) {
	if (Array.isArray(arg)) return arg;
	return typeof arg !== "undefined" ? [arg] : [];
}
/**
* Immutably adds an index to an array.
* @example
* addItemToArray(["a", "b", "d"], "c", 2); // ["a", "b", "c", "d"]
* @returns {Array} A new array with the item in the passed array index.
*/
function addItemToArray(array, item, index) {
	if (index === void 0) index = -1;
	if (!(index in array)) return [...array, item];
	return [
		...array.slice(0, index),
		item,
		...array.slice(index)
	];
}
/**
* Flattens a 2D array into a one-dimensional array.
* @example
* flatten2DArray([["a"], ["b"], ["c"]]); // ["a", "b", "c"]
*
* @returns {Array} A one-dimensional array.
*/
function flatten2DArray(array) {
	const flattened = [];
	for (const row of array) flattened.push(...row);
	return flattened;
}
/**
* Immutably reverses an array.
* @example
* reverseArray(["a", "b", "c"]); // ["c", "b", "a"]
* @returns {Array} Reversed array.
*/
function reverseArray(array) {
	return array.slice().reverse();
}
//#endregion
//#region ../../node_modules/ariakit-utils/esm/store.js
var GET_STATE = Symbol("getState");
var SUBSCRIBE$1 = Symbol("subscribe");
var TIMESTAMP = Symbol("timestamp");
var INITIAL_CONTEXT = Symbol("initialContext");
function getState(state) {
	if (!state) return state;
	const fn = state[GET_STATE];
	if (fn) return fn();
	return state;
}
function hasSubscribe(state) {
	if (!state) return false;
	return !!state[SUBSCRIBE$1];
}
function getSubscribe(state) {
	if (!state) return;
	return state[SUBSCRIBE$1];
}
function getLatest(a, b) {
	if (!b) return a;
	if (!a) return b;
	if (!(TIMESTAMP in b)) return a;
	if (!(TIMESTAMP in a)) return b;
	if (a[TIMESTAMP] >= b[TIMESTAMP]) return a;
	return b;
}
function defineGetState(state, currentState) {
	if (currentState === void 0) currentState = state;
	Object.defineProperty(state, GET_STATE, {
		value: () => currentState,
		writable: true
	});
}
function defineSubscribe(state, subscribe) {
	if (!(SUBSCRIBE$1 in state)) Object.defineProperty(state, SUBSCRIBE$1, { value: subscribe });
}
function defineTimestamp(state) {
	if (!(TIMESTAMP in state)) Object.defineProperty(state, TIMESTAMP, {
		value: Date.now(),
		writable: true
	});
}
function patchState(state) {
	Object.defineProperty(state, TIMESTAMP, {
		value: Date.now(),
		writable: true
	});
}
function defineInitialContext(context) {
	const initialContext = /*#__PURE__*/ createContext(void 0);
	Object.defineProperty(context, INITIAL_CONTEXT, { value: initialContext });
	return initialContext;
}
function hasInitialContext(stateOrContext) {
	return stateOrContext && INITIAL_CONTEXT in stateOrContext;
}
function getInitialContext(context) {
	if (!hasInitialContext(context)) return;
	return context[INITIAL_CONTEXT];
}
/**
* Creates a context that can be passed to `useStore` and `useStoreProvider`.
*/
function createStoreContext() {
	const context = /*#__PURE__*/ createContext(void 0);
	defineInitialContext(context);
	return context;
}
/**
* Creates a type-safe component with the `as` prop, `state` prop,
* `React.forwardRef` and `React.memo`.
*
* @example
* import { Options, createMemoComponent } from "ariakit-utils/store";
*
* type Props = Options<"div"> & {
*   state?: { customProp: boolean };
* };
*
* const Component = createMemoComponent<Props>(
*   ({ state, ...props }) => <div {...props} />
* );
*
* <Component as="button" state={{ customProp: true }} />
*/
function createMemoComponent(render, propsAreEqual) {
	if (propsAreEqual === void 0) propsAreEqual = shallowEqual;
	const Role = createComponent(render);
	return /*#__PURE__*/ memo(Role, (prev, next) => {
		const { state: prevState, ...prevProps } = prev;
		const { state: nextState, ...nextProps } = next;
		if (nextState && hasSubscribe(nextState)) return propsAreEqual(prevProps, nextProps);
		return propsAreEqual(prev, next);
	});
}
/**
* Returns props with a `wrapElement` function that wraps an element with a
* React Context Provider that provides a store context to consumers.
* @example
* import * as React from "react";
* import { useStoreProvider } from "ariakit-utils/store";
*
* const StoreContext = createStoreContext();
*
* function Component({ state, ...props }) {
*   const { wrapElement } = useStoreProvider({ state, ...props }, StoreContext);
*   return wrapElement(<div {...props} />);
* }
*/
function useStoreProvider(_ref, context) {
	let { state, ...props } = _ref;
	const initialValue = useInitialValue$1(state);
	const value = state && hasSubscribe(state) ? initialValue : state;
	defineGetState(value, state);
	const initialContext = getInitialContext(context);
	return useWrapElement(props, (element) => {
		if (value && initialContext) element = /*#__PURE__*/ jsx(initialContext.Provider, {
			value,
			children: element
		});
		if (state) element = /*#__PURE__*/ jsx(context.Provider, {
			value: state,
			children: element
		});
		return element;
	}, [
		value,
		initialContext,
		state,
		context
	]);
}
/**
* Adds publishing capabilities to state so it can be passed to `useStore` or
* `useStoreProvider` later.
* @example
* import { useStorePublisher } from "ariakit-utils/store";
*
* function useComponentState() {
*   const state = React.useMemo(() => ({ a: "a" }), []);
*   return useStorePublisher(state);
* }
*/
function useStorePublisher(state) {
	const listeners = useLazyValue(() => /* @__PURE__ */ new Set());
	useSafeLayoutEffect(() => {
		patchState(state);
		for (const listener of listeners) listener(state);
	}, [state]);
	defineSubscribe(state, useCallback((listener) => {
		listeners.add(listener);
		return () => listeners.delete(listener);
	}, []));
	defineGetState(state);
	defineTimestamp(state);
	return state;
}
/**
* Handles state updates on the state or context state passed as the first
* argument based on the filter argument.
* @example
* import { useStore } from "ariakit-utils/store";
*
* const ContextState = createContextState();
*
* function Component({ state }) {
*   state = useStore(state || ContextState, ["stateProp"]);
* }
*/
function useStore(stateOrContext, filter) {
	const contextState = useContext(getContext(stateOrContext, filter));
	const externalState = hasInitialContext(stateOrContext) ? contextState : stateOrContext;
	const [internalState, setState] = useState(() => getState(externalState));
	const state = hasSubscribe(externalState) && hasSubscribe(internalState) ? getLatest(internalState, externalState) : externalState;
	const subscribe = getSubscribe(externalState);
	const prevStateRef = useRef(null);
	const deps = toArray$1(filter);
	const noFilter = !filter;
	useSafeLayoutEffect(() => {
		if (!subscribe || !setState) return;
		if (noFilter) return subscribe(setState);
		if (!deps.length) return;
		return subscribe((nextState) => {
			const prevState = prevStateRef.current;
			prevStateRef.current = nextState;
			const filterDep = (dep) => {
				if (typeof dep === "function") {
					const result = dep(nextState);
					if (typeof result === "boolean") return result || prevState && dep(prevState);
					else if (prevState) return result !== dep(prevState);
					return result;
				}
				const key = dep;
				return (prevState == null ? void 0 : prevState[key]) !== nextState[key];
			};
			if (deps.some(filterDep)) setState(nextState);
		});
	}, [
		subscribe,
		setState,
		noFilter,
		...deps
	]);
	return state;
}
var EmptyContext = /*#__PURE__*/ createContext(void 0);
function getContext(stateOrContext, filter) {
	if (!hasInitialContext(stateOrContext)) return EmptyContext;
	if (filter) return getInitialContext(stateOrContext);
	return stateOrContext;
}
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-4a897e71.js
var CollectionItemContext = /*#__PURE__*/ createContext(void 0);
//#endregion
//#region ../../node_modules/ariakit/esm/collection/collection-item.js
function identity$2(value) {
	return value;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component. This hook will register the item in the collection state.
* If this hook is used in a component that is wrapped by `Collection` or a
* component that implements `useCollection`, there's no need to explicitly pass
* the `state` prop.
* @see https://ariakit.org/components/collection
* @example
* ```jsx
* const state = useCollectionState();
* const props = useCollectionItem({ state });
* <Role {...props}>Item</Role>
* ```
*/
var useCollectionItem = createHook((_ref) => {
	var _state;
	let { state, shouldRegisterItem = true, getItem = identity$2, ...props } = _ref;
	state = useStore(state, ["registerItem"]);
	const contextRegisterItem = useContext(CollectionItemContext);
	const registerItem = ((_state = state) == null ? void 0 : _state.registerItem) || contextRegisterItem;
	const ref = useRef(null);
	useSafeLayoutEffect(() => {
		if (!shouldRegisterItem) return;
		return registerItem == null ? void 0 : registerItem(getItem({ ref }));
	}, [
		shouldRegisterItem,
		getItem,
		registerItem
	]);
	props = {
		...props,
		ref: useForkRef(ref, props.ref)
	};
	return props;
});
/**
* A component that renders an item in a collection. The collection state can be
* passed explicitly through the `state` prop or implicitly through the
* `Collection` component.
* @see https://ariakit.org/components/collection
* @example
* ```jsx
* const state = useCollectionState();
* <CollectionItem state={state}>Item 1</CollectionItem>
* <CollectionItem state={state}>Item 2</CollectionItem>
* <CollectionItem state={state}>Item 3</CollectionItem>
* ```
*/
var CollectionItem = createComponent((props) => {
	return createElement$1("div", useCollectionItem(props));
});
if (process.env.NODE_ENV !== "production") CollectionItem.displayName = "CollectionItem";
//#endregion
//#region ../../node_modules/ariakit/esm/collection/collection-state.js
function isElementPreceding(a, b) {
	return Boolean(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function findDOMIndex(items, item) {
	const itemElement = item.ref.current;
	if (!itemElement) return -1;
	let length = items.length;
	if (!length) return -1;
	while (length--) {
		const currentItem = items[length];
		if (!(currentItem != null && currentItem.ref.current)) continue;
		if (isElementPreceding(currentItem.ref.current, itemElement)) return length + 1;
	}
	return 0;
}
function sortBasedOnDOMPosition(items) {
	const pairs = items.map((item, index) => [index, item]);
	let isOrderDifferent = false;
	pairs.sort((_ref, _ref2) => {
		let [indexA, a] = _ref;
		let [indexB, b] = _ref2;
		const elementA = a.ref.current;
		const elementB = b.ref.current;
		if (elementA === elementB) return 0;
		if (!elementA || !elementB) return 0;
		if (isElementPreceding(elementA, elementB)) {
			if (indexA > indexB) isOrderDifferent = true;
			return -1;
		}
		if (indexA < indexB) isOrderDifferent = true;
		return 1;
	});
	if (isOrderDifferent) return pairs.map((_ref3) => {
		let [_, item] = _ref3;
		return item;
	});
	return items;
}
function setItemsBasedOnDOMPosition(items, setItems) {
	const sortedItems = sortBasedOnDOMPosition(items);
	if (items !== sortedItems) setItems(sortedItems);
}
function getCommonParent(items) {
	var _firstItem$ref$curren;
	const firstItem = items[0];
	const lastItem = items[items.length - 1];
	let parentElement = firstItem == null ? void 0 : (_firstItem$ref$curren = firstItem.ref.current) == null ? void 0 : _firstItem$ref$curren.parentElement;
	while (parentElement) {
		if (lastItem && parentElement.contains(lastItem.ref.current)) return parentElement;
		parentElement = parentElement.parentElement;
	}
	return getDocument(parentElement).body;
}
function useTimeoutObserver(items, setItems) {
	useEffect(() => {
		const callback = () => setItemsBasedOnDOMPosition(items, setItems);
		const timeout = setTimeout(callback);
		return () => clearTimeout(timeout);
	});
}
function useSortBasedOnDOMPosition(items, setItems) {
	// istanbul ignore else: JSDOM doesn't support IntersectionObverser
	if (typeof IntersectionObserver !== "function") {
		useTimeoutObserver(items, setItems);
		return;
	}
	const previousItems = useRef([]);
	useEffect(() => {
		const callback = () => {
			const hasPreviousItems = !!previousItems.current.length;
			previousItems.current = items;
			if (!hasPreviousItems) return;
			setItemsBasedOnDOMPosition(items, setItems);
		};
		const root = getCommonParent(items);
		const observer = new IntersectionObserver(callback, { root });
		items.forEach((item) => {
			if (item.ref.current) observer.observe(item.ref.current);
		});
		return () => observer.disconnect();
	}, [items, setItems]);
}
/**
* Provides state for the `Collection` components.
* @see https://ariakit.org/components/collection
* @example
* ```jsx
* const collection = useCollectionState();
* <Collection state={collection}>
*   <CollectionItem>Item 1</CollectionItem>
*   <CollectionItem>Item 2</CollectionItem>
*   <CollectionItem>Item 3</CollectionItem>
* </Collection>
* ```
*/
function useCollectionState(props) {
	if (props === void 0) props = {};
	const [items, setItems] = useControlledState([], props.items, props.setItems);
	useSortBasedOnDOMPosition(items, setItems);
	const registerItem = useCallback((item) => {
		setItems((prevItems) => {
			return addItemToArray(prevItems, item, findDOMIndex(prevItems, item));
		});
		const unregisterItem = () => {
			setItems((prevItems) => {
				const nextItems = prevItems.filter((_ref4) => {
					let { ref } = _ref4;
					return ref !== item.ref;
				});
				if (prevItems.length === nextItems.length) return prevItems;
				return nextItems;
			});
		};
		return unregisterItem;
	}, []);
	return useMemo(() => ({
		items,
		setItems,
		registerItem
	}), [
		items,
		setItems,
		registerItem
	]);
}
//#endregion
//#region ../../node_modules/ariakit/esm/disclosure/disclosure.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element that controls the visibility of a
* disclosure content element.
* @see https://ariakit.org/components/disclosure
* @example
* ```jsx
* const state = useDisclosureState();
* const props = useDisclosure({ state });
* <Role {...props}>Disclosure</Role>
* <DisclosureContent state={state}>Content</DisclosureContent>
* ```
*/
var useDisclosure = createHook((_ref) => {
	var _state$contentElement;
	let { state, toggleOnClick = true, ...props } = _ref;
	const ref = useRef(null);
	const [expanded, setExpanded] = useState(false);
	useSafeLayoutEffect(() => {
		const currentDisclosure = state.disclosureRef.current;
		if (!currentDisclosure || !currentDisclosure.isConnected) state.disclosureRef.current = ref.current;
		const isCurrentDisclosure = state.disclosureRef.current === ref.current;
		setExpanded(state.open && isCurrentDisclosure);
	}, [state.disclosureRef, state.open]);
	const onMouseDownProp = props.onMouseDown;
	const onMouseDown = useEvent$1((event) => {
		state.disclosureRef.current = event.currentTarget;
		onMouseDownProp?.(event);
	});
	const onClickProp = props.onClick;
	const toggleOnClickProp = useBooleanEvent(toggleOnClick);
	const isDuplicate = "data-disclosure" in props;
	const onClick = useEvent$1((event) => {
		state.disclosureRef.current = event.currentTarget;
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		if (isDuplicate) return;
		if (!toggleOnClickProp(event)) return;
		state.toggle();
	});
	props = {
		"data-disclosure": "",
		"aria-expanded": expanded,
		"aria-controls": (_state$contentElement = state.contentElement) == null ? void 0 : _state$contentElement.id,
		...props,
		ref: useForkRef(ref, props.ref),
		onMouseDown,
		onClick
	};
	props = useButton(props);
	return props;
});
/**
* A component that renders an element that controls the visibility of a
* disclosure content element.
* @see https://ariakit.org/components/disclosure
* @example
* ```jsx
* const disclosure = useDisclosureState();
* <Disclosure state={disclosure}>Disclosure</Disclosure>
* <DisclosureContent state={disclosure}>Content</DisclosureContent>
* ```
*/
var Disclosure = createComponent((props) => {
	return createElement$1("button", useDisclosure(props));
});
if (process.env.NODE_ENV !== "production") Disclosure.displayName = "Disclosure";
//#endregion
//#region ../../node_modules/ariakit/esm/dialog/dialog-disclosure.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a button that shows/hides a dialog.
* @see https://ariakit.org/components/dialog
* @example
* ```jsx
* const state = useDialogState();
* const props = useDialogDisclosure({ state });
* <Role {...props}>Disclosure</Role>
* <Dialog state={state}>Content</Dialog>
* ```
*/
var useDialogDisclosure = createHook((_ref) => {
	let { state, ...props } = _ref;
	props = useDisclosure({
		state,
		...props
	});
	return props;
});
/**
* A component that renders a button that shows/hides a dialog.
* @see https://ariakit.org/components/dialog
* @example
* ```jsx
* const dialog = useDialogState();
* <DialogDisclosure state={dialog}>Disclosure</DialogDisclosure>
* <Dialog state={dialog}>Content</Dialog>
* ```
*/
var DialogDisclosure = createComponent((props) => {
	return createElement$1("button", useDialogDisclosure(props));
});
if (process.env.NODE_ENV !== "production") DialogDisclosure.displayName = "DialogDisclosure";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-33f6902f.js
var GroupLabelContext = /*#__PURE__*/ createContext(void 0);
//#endregion
//#region ../../node_modules/ariakit/esm/group/group.js
var useGroup = createHook((props) => {
	const [labelId, setLabelId] = useState();
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(GroupLabelContext.Provider, {
		value: setLabelId,
		children: element
	}), []);
	props = {
		role: "group",
		"aria-labelledby": labelId,
		...props
	};
	return props;
});
/**
* A component that renders a group element.
* @see https://ariakit.org/components/group
* @example
* ```jsx
* <Group>Group</Group>
* ```
*/
var Group = createComponent((props) => {
	return createElement$1("div", useGroup(props));
});
if (process.env.NODE_ENV !== "production") Group.displayName = "Group";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-7009759c.js
var NULL_ITEM = {
	id: null,
	ref: { current: null }
};
function getMaxRowLength(array) {
	let maxLength = 0;
	for (const { length } of array) if (length > maxLength) maxLength = length;
	return maxLength;
}
/**
* Returns only enabled items.
*/
function getEnabledItems$1(items, excludeId) {
	return items.filter((item) => {
		if (excludeId) return !item.disabled && item.id !== excludeId;
		return !item.disabled;
	});
}
/**
* Finds the first enabled item.
*/
function findFirstEnabledItem(items, excludeId) {
	return items.find((item) => {
		if (excludeId) return !item.disabled && item.id !== excludeId;
		return !item.disabled;
	});
}
/**
* Fills rows with fewer items with empty items so they all have the same
* length.
*/
function normalizeRows(rows, activeId, focusShift) {
	const maxLength = getMaxRowLength(rows);
	for (const row of rows) for (let i = 0; i < maxLength; i += 1) {
		const item = row[i];
		if (!item || focusShift && item.disabled) {
			const previousItem = i === 0 && focusShift ? findFirstEnabledItem(row) : row[i - 1];
			row[i] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem(previousItem == null ? void 0 : previousItem.rowId);
		}
	}
	return rows;
}
function createEmptyItem(rowId) {
	return {
		id: "__EMPTY_ITEM__",
		disabled: true,
		ref: { current: null },
		rowId
	};
}
/**
* Finds the first enabled item by its id.
*/
function findEnabledItemById(items, id) {
	if (!id) return;
	return items.find((item) => item.id === id && !item.disabled);
}
/**
* Gets the active id. If `passedId` is provided, it's going to take
* precedence.
*/
function getActiveId(items, activeId, passedId) {
	var _findFirstEnabledItem;
	if (passedId !== void 0) return passedId;
	if (activeId !== void 0) return activeId;
	return (_findFirstEnabledItem = findFirstEnabledItem(items)) == null ? void 0 : _findFirstEnabledItem.id;
}
/**
* Gets all items with the passed rowId.
*/
function getItemsInRow(items, rowId) {
	return items.filter((item) => item.rowId === rowId);
}
/**
* Gets the opposite orientation.
*/
function getOppositeOrientation(orientation) {
	if (orientation === "vertical") return "horizontal";
	if (orientation === "horizontal") return "vertical";
}
/**
* Creates a two-dimensional array with items grouped by their rowId's.
*/
function groupItemsByRows(items) {
	const rows = [];
	for (const item of items) {
		const row = rows.find((currentRow) => {
			var _currentRow$;
			return ((_currentRow$ = currentRow[0]) == null ? void 0 : _currentRow$.rowId) === item.rowId;
		});
		if (row) row.push(item);
		else rows.push([item]);
	}
	return rows;
}
/**
* Moves all the items before the passed `id` to the end of the array. This is
* useful when we want to loop through the items in the same row or column as
* the first items will be placed after the last items.
*
* The null item that's inserted when `shouldInsertNullItem` is set to `true`
* represents the composite container itself. When the active item is null, the
* composite container has focus.
*/
function flipItems(items, activeId, shouldInsertNullItem) {
	if (shouldInsertNullItem === void 0) shouldInsertNullItem = false;
	const index = items.findIndex((item) => item.id === activeId);
	return [
		...items.slice(index + 1),
		...shouldInsertNullItem ? [NULL_ITEM] : [],
		...items.slice(0, index)
	];
}
/**
* Changes the order of the items list so they are ordered vertically. That is,
* if the active item is the first item in the first row, the next item will be
* the first item in the second row, which is what you would expect when moving
* up/down.
*/
function verticalizeItems(items) {
	const rows = groupItemsByRows(items);
	const maxLength = getMaxRowLength(rows);
	const verticalized = [];
	for (let i = 0; i < maxLength; i += 1) for (const row of rows) {
		const item = row[i];
		if (item) verticalized.push({
			...item,
			rowId: item.rowId ? "" + i : void 0
		});
	}
	return verticalized;
}
/**
* Gets item id.
*/
function getContextId(state, context) {
	return context != null && context.baseRef && context.baseRef === (state == null ? void 0 : state.baseRef) ? context.id : void 0;
}
var FOCUS_SILENTLY = Symbol("FOCUS_SILENTLY");
/**
* Focus an element with a flag. The `silentlyFocused` function needs to be
* called later to check if the focus was silenced and to reset this state.
*/
function focusSilently(element) {
	element[FOCUS_SILENTLY] = true;
	element.focus();
}
/**
* Checks whether the element has been focused with the `focusSilently` function
* and resets the state.
*/
function silentlyFocused(element) {
	const isSilentlyFocused = element[FOCUS_SILENTLY];
	delete element[FOCUS_SILENTLY];
	return isSilentlyFocused;
}
/**
* Determines whether the element is a composite item.
*/
function isItem(items, element, exclude) {
	if (!element) return false;
	return items.some((item) => {
		if (exclude && item.ref.current === exclude) return false;
		return item.ref.current === element;
	});
}
var CompositeContext = createStoreContext();
var CompositeRowContext = /*#__PURE__*/ createContext(void 0);
var CompositeItemContext = /*#__PURE__*/ createContext(void 0);
//#endregion
//#region ../../node_modules/ariakit/esm/composite/composite-hover.js
function getMouseDestination(event) {
	const relatedTarget = event.relatedTarget;
	if ((relatedTarget == null ? void 0 : relatedTarget.nodeType) === Node.ELEMENT_NODE) return relatedTarget;
	return null;
}
function hoveringInside(event) {
	const nextElement = getMouseDestination(event);
	if (!nextElement) return false;
	return contains(event.currentTarget, nextElement);
}
function movingToAnotherItem(event) {
	const dest = getMouseDestination(event);
	if (!dest) return false;
	return !!closest(dest, "[data-composite-hover]");
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element in a composite widget that receives
* focus on mouse move and loses focus to the composite base element on mouse
* leave. This should be combined with the `CompositeItem` component, the
* `useCompositeItem` hook or any component/hook that uses them underneath.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const state = useCompositeState();
* const props = useCompositeHover({ state });
* <CompositeItem state={state} {...props}>Item</CompositeItem>
* ```
*/
var useCompositeHover = createHook((_ref) => {
	let { state, focusOnHover = true, ...props } = _ref;
	state = useStore(state || CompositeContext, ["setActiveId", "baseRef"]);
	const isMouseMoving = useIsMouseMoving();
	const onMouseMoveProp = props.onMouseMove;
	const focusOnHoverProp = useBooleanEvent(focusOnHover);
	const onMouseMove = useEvent$1((event) => {
		var _state2;
		onMouseMoveProp?.(event);
		if (event.defaultPrevented) return;
		if (!isMouseMoving()) return;
		if (!focusOnHoverProp(event)) return;
		if (!hasFocusWithin(event.currentTarget)) {
			var _state, _state$baseRef$curren;
			(_state = state) == null || (_state$baseRef$curren = _state.baseRef.current) == null || _state$baseRef$curren.focus();
		}
		(_state2 = state) == null || _state2.setActiveId(event.currentTarget.id);
	});
	const onMouseLeaveProp = props.onMouseLeave;
	const onMouseLeave = useEvent$1((event) => {
		var _state3, _state4, _state4$baseRef$curre;
		onMouseLeaveProp?.(event);
		if (event.defaultPrevented) return;
		if (!isMouseMoving()) return;
		if (hoveringInside(event)) return;
		if (movingToAnotherItem(event)) return;
		if (!focusOnHoverProp(event)) return;
		(_state3 = state) == null || _state3.setActiveId(null);
		(_state4 = state) == null || (_state4$baseRef$curre = _state4.baseRef.current) == null || _state4$baseRef$curre.focus();
	});
	props = {
		"data-composite-hover": "",
		...props,
		onMouseMove,
		onMouseLeave
	};
	return props;
});
/**
* A component that renders an element in a composite widget that receives focus
* on mouse move and loses focus to the composite base element on mouse leave.
* This should be combined with the `CompositeItem` component, the
* `useCompositeItem` hook or any component/hook that uses them underneath.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const composite = useCompositeState();
* <Composite state={composite}>
*   <CompositeHover as={CompositeItem}>Item</CompositeHover>
* </Composite>
* ```
*/
var CompositeHover = createMemoComponent((props) => {
	return createElement$1("div", useCompositeHover(props));
});
if (process.env.NODE_ENV !== "production") CompositeHover.displayName = "CompositeHover";
//#endregion
//#region ../../node_modules/ariakit/esm/composite/composite-item.js
function isEditableElement(element) {
	if (element.isContentEditable) return true;
	if (isTextField(element)) return true;
	return element.tagName === "INPUT" && !isButton(element);
}
function getNextPageOffset(scrollingElement, pageUp) {
	if (pageUp === void 0) pageUp = false;
	const height = scrollingElement.clientHeight;
	const { top } = scrollingElement.getBoundingClientRect();
	const pageSize = Math.max(height * .875, height - 40) * 1.5;
	const pageOffset = pageUp ? height - pageSize + top : pageSize + top;
	if (scrollingElement.tagName === "HTML") return pageOffset + scrollingElement.scrollTop;
	return pageOffset;
}
function getItemOffset(itemElement, pageUp) {
	if (pageUp === void 0) pageUp = false;
	const { top } = itemElement.getBoundingClientRect();
	if (pageUp) return top + itemElement.clientHeight;
	return top;
}
function findNextPageItemId(element, items, next, pageUp) {
	if (pageUp === void 0) pageUp = false;
	if (!items) return;
	if (!next) return;
	const scrollingElement = getScrollingElement(element);
	if (!scrollingElement) return;
	const nextPageOffset = getNextPageOffset(scrollingElement, pageUp);
	let id;
	let prevDifference;
	for (let i = 0; i < items.length; i += 1) {
		const previousId = id;
		id = next(i);
		if (!id) break;
		if (id === previousId) continue;
		const item = findEnabledItemById(items, id);
		const itemElement = item == null ? void 0 : item.ref.current;
		if (!itemElement) continue;
		const difference = getItemOffset(itemElement, pageUp) - nextPageOffset;
		const absDifference = Math.abs(difference);
		if (pageUp && difference <= 0 || !pageUp && difference >= 0) {
			if (prevDifference !== void 0 && prevDifference < absDifference) id = previousId;
			break;
		}
		prevDifference = absDifference;
	}
	return id;
}
function useItem$1(items, id) {
	return useMemo(() => {
		if (!id) return;
		return items == null ? void 0 : items.find((item) => item.id === id);
	}, [items, id]);
}
function targetIsAnotherItem(event, items) {
	if (isSelfTarget(event)) return false;
	const target = event.target;
	return isItem(items, target, event.currentTarget);
}
function useRole$1(ref, props) {
	const [role, setRole] = useState(props.role);
	useSafeLayoutEffect(() => {
		const element = ref.current;
		if (!element) return;
		setRole(element.getAttribute("role") || props.role);
	}, [props.role]);
	return role;
}
function requiresAriaSelected(role) {
	return role === "option" || role === "treeitem";
}
function supportsAriaSelected(role) {
	if (role === "option") return true;
	if (role === "tab") return true;
	if (role === "treeitem") return true;
	if (role === "gridcell") return true;
	if (role === "row") return true;
	if (role === "columnheader") return true;
	if (role === "rowheader") return true;
	return false;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a composite item.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const state = useCompositeState();
* const props = useCompositeItem({ state });
* <Role {...props}>Item 1</Role>
* ```
*/
var useCompositeItem = createHook((_ref) => {
	var _state6, _state23, _state24, _state26, _state27;
	let { state, rowId: rowIdProp, preventScrollOnKeyDown = false, moveOnKeyPress = true, getItem: getItemProp, ...props } = _ref;
	const id = useId(props.id);
	state = useStore(state || CompositeContext, [
		useCallback((s) => s.activeId === id, [id]),
		"baseRef",
		"items",
		"virtualFocus",
		"registerItem",
		"setActiveId",
		"orientation",
		"up",
		"next",
		"down",
		"previous",
		"first",
		"last",
		"move"
	]);
	const ref = useRef(null);
	const row = useContext(CompositeRowContext);
	const rowId = rowIdProp != null ? rowIdProp : getContextId(state, row);
	const trulyDisabled = props.disabled && !props.accessibleWhenDisabled;
	const getItem = useCallback((item) => {
		const nextItem = {
			...item,
			id,
			rowId,
			disabled: !!trulyDisabled
		};
		if (getItemProp) return getItemProp(nextItem);
		return nextItem;
	}, [
		id,
		rowId,
		trulyDisabled,
		getItemProp
	]);
	const onFocusProp = props.onFocus;
	const hasFocusedComposite = useRef(false);
	const onFocus = useEvent$1((event) => {
		var _state, _state2, _state4;
		onFocusProp?.(event);
		if (event.defaultPrevented) return;
		if (isPortalEvent(event)) return;
		if (!id) return;
		if ((_state = state) != null && _state.items && targetIsAnotherItem(event, state.items)) return;
		if (((_state2 = state) == null ? void 0 : _state2.activeId) !== id) {
			var _state3;
			(_state3 = state) == null || _state3.setActiveId(id);
		}
		if (!((_state4 = state) != null && _state4.virtualFocus)) return;
		if (!isSelfTarget(event)) return;
		if (isEditableElement(event.currentTarget)) return;
		const composite = state.baseRef.current;
		if (!composite) return;
		hasFocusedComposite.current = true;
		if (event.relatedTarget === composite || isItem(state.items, event.relatedTarget)) focusSilently(composite);
		else composite.focus();
	});
	const onBlurCaptureProp = props.onBlurCapture;
	const onBlurCapture = useEvent$1((event) => {
		var _state5;
		onBlurCaptureProp?.(event);
		if (event.defaultPrevented) return;
		if ((_state5 = state) != null && _state5.virtualFocus && hasFocusedComposite.current) {
			hasFocusedComposite.current = false;
			event.preventDefault();
			event.stopPropagation();
		}
	});
	const onKeyDownProp = props.onKeyDown;
	const preventScrollOnKeyDownProp = useBooleanEvent(preventScrollOnKeyDown);
	const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
	const item = useItem$1((_state6 = state) == null ? void 0 : _state6.items, id);
	const isGrid = !!(item != null && item.rowId);
	const onKeyDown = useEvent$1((event) => {
		var _state7, _state8, _state9, _state10, _state11, _state12;
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (!isSelfTarget(event)) return;
		const isVertical = ((_state7 = state) == null ? void 0 : _state7.orientation) !== "horizontal";
		const isHorizontal = ((_state8 = state) == null ? void 0 : _state8.orientation) !== "vertical";
		const action = {
			ArrowUp: (isGrid || isVertical) && ((_state9 = state) == null ? void 0 : _state9.up),
			ArrowRight: (isGrid || isHorizontal) && ((_state10 = state) == null ? void 0 : _state10.next),
			ArrowDown: (isGrid || isVertical) && ((_state11 = state) == null ? void 0 : _state11.down),
			ArrowLeft: (isGrid || isHorizontal) && ((_state12 = state) == null ? void 0 : _state12.previous),
			Home: () => {
				var _state14;
				if (!isGrid || event.ctrlKey) {
					var _state13;
					return (_state13 = state) == null ? void 0 : _state13.first();
				}
				return (_state14 = state) == null ? void 0 : _state14.previous(-1);
			},
			End: () => {
				var _state16;
				if (!isGrid || event.ctrlKey) {
					var _state15;
					return (_state15 = state) == null ? void 0 : _state15.last();
				}
				return (_state16 = state) == null ? void 0 : _state16.next(-1);
			},
			PageUp: () => {
				var _state17, _state18;
				return findNextPageItemId(event.currentTarget, (_state17 = state) == null ? void 0 : _state17.items, (_state18 = state) == null ? void 0 : _state18.up, true);
			},
			PageDown: () => {
				var _state19, _state20;
				return findNextPageItemId(event.currentTarget, (_state19 = state) == null ? void 0 : _state19.items, (_state20 = state) == null ? void 0 : _state20.down);
			}
		}[event.key];
		if (action) {
			const nextId = action();
			if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
				var _state21;
				if (!moveOnKeyPressProp(event)) return;
				event.preventDefault();
				(_state21 = state) == null || _state21.move(nextId);
			}
		}
	});
	const providerValue = useMemo(() => {
		var _state22;
		return {
			id,
			baseRef: (_state22 = state) == null ? void 0 : _state22.baseRef
		};
	}, [id, (_state23 = state) == null ? void 0 : _state23.baseRef]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(CompositeItemContext.Provider, {
		value: providerValue,
		children: element
	}), [providerValue]);
	const isActiveItem = ((_state24 = state) == null ? void 0 : _state24.activeId) === id;
	const role = useRole$1(ref, props);
	let ariaSelected;
	if (isActiveItem) {
		var _state25;
		if (requiresAriaSelected(role)) ariaSelected = true;
		else if ((_state25 = state) != null && _state25.virtualFocus && supportsAriaSelected(role)) ariaSelected = true;
	}
	const shouldTabIndex = !((_state26 = state) != null && _state26.virtualFocus) && isActiveItem || !((_state27 = state) != null && _state27.items.length);
	props = {
		id,
		"aria-selected": ariaSelected,
		"data-active-item": isActiveItem ? "" : void 0,
		...props,
		ref: useForkRef(ref, props.ref),
		tabIndex: shouldTabIndex ? props.tabIndex : -1,
		onFocus,
		onBlurCapture,
		onKeyDown
	};
	props = useCommand(props);
	props = useCollectionItem({
		state,
		...props,
		getItem,
		shouldRegisterItem: !!id ? props.shouldRegisterItem : false
	});
	return props;
});
/**
* A component that renders a composite item.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const composite = useCompositeState();
* <Composite state={composite}>
*   <CompositeItem>Item 1</CompositeItem>
*   <CompositeItem>Item 2</CompositeItem>
*   <CompositeItem>Item 3</CompositeItem>
* </Composite>
* ```
*/
var CompositeItem = createMemoComponent((props) => {
	return createElement$1("button", useCompositeItem(props));
});
if (process.env.NODE_ENV !== "production") CompositeItem.displayName = "CompositeItem";
//#endregion
//#region ../../node_modules/ariakit/esm/disclosure/disclosure-content.js
function afterTimeout(timeoutMs, cb) {
	const timeoutId = setTimeout(cb, timeoutMs);
	return () => clearTimeout(timeoutId);
}
function afterPaint(cb) {
	let raf = requestAnimationFrame(() => {
		raf = requestAnimationFrame(cb);
	});
	return () => cancelAnimationFrame(raf);
}
function parseCSSTime() {
	for (var _len = arguments.length, times = new Array(_len), _key = 0; _key < _len; _key++) times[_key] = arguments[_key];
	return times.join(", ").split(", ").reduce((longestTime, currentTimeString) => {
		const currentTime = parseFloat(currentTimeString || "0s") * 1e3;
		if (currentTime > longestTime) return currentTime;
		return longestTime;
	}, 0);
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element that can be shown or hidden.
* @see https://ariakit.org/components/disclosure
* @example
* ```jsx
* const state = useDisclosureState();
* const props = useDisclosureContent({ state });
* <Disclosure state={state}>Disclosure</Disclosure>
* <Role {...props}>Content</Role>
* ```
*/
var useDisclosureContent = createHook((_ref) => {
	let { state, ...props } = _ref;
	const id = useId(props.id);
	const [transition, setTransition] = useState(null);
	useSafeLayoutEffect(() => {
		var _state$contentElement;
		if (!state.animated) return;
		if (!((_state$contentElement = state.contentElement) != null && _state$contentElement.isConnected)) {
			setTransition(null);
			return;
		}
		return afterPaint(() => {
			setTransition(state.open ? "enter" : "leave");
		});
	}, [
		state.animated,
		state.contentElement,
		state.open
	]);
	useSafeLayoutEffect(() => {
		if (!state.animated) return;
		if (!state.contentElement) return;
		if (!transition) return;
		if (transition === "enter" && !state.open) return;
		if (transition === "leave" && state.open) return;
		if (typeof state.animated === "number") {
			const timeoutMs = state.animated;
			return afterTimeout(timeoutMs, () => flushSync(state.stopAnimation));
		}
		const { transitionDuration, animationDuration, transitionDelay, animationDelay } = getComputedStyle(state.contentElement);
		const timeoutMs = parseCSSTime(transitionDelay, animationDelay) + parseCSSTime(transitionDuration, animationDuration);
		if (!timeoutMs) return;
		return afterTimeout(timeoutMs, () => flushSync(state.stopAnimation));
	}, [
		state.animated,
		state.contentElement,
		transition,
		state.open,
		state.stopAnimation
	]);
	const style = state.mounted || props.hidden === false ? props.style : {
		...props.style,
		display: "none"
	};
	props = {
		id,
		"data-enter": transition === "enter" ? "" : void 0,
		"data-leave": transition === "leave" ? "" : void 0,
		hidden: !state.mounted,
		...props,
		ref: useForkRef(id ? state.setContentElement : null, props.ref),
		style
	};
	return props;
});
/**
* A component that renders an element that can be shown or hidden.
* @see https://ariakit.org/components/disclosure
* @example
* ```jsx
* const disclosure = useDisclosureState();
* <Disclosure state={disclosure}>Disclosure</Disclosure>
* <DisclosureContent state={disclosure}>Content</DisclosureContent>
* ```
*/
var DisclosureContent = createComponent((props) => {
	return createElement$1("div", useDisclosureContent(props));
});
if (process.env.NODE_ENV !== "production") DisclosureContent.displayName = "DisclosureContent";
//#endregion
//#region ../../node_modules/ariakit/esm/visually-hidden/visually-hidden.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component. When applying the props returned by this hook to a
* component, the component will be visually hidden, but still accessible to
* screen readers.
* @see https://ariakit.org/components/visually-hidden
* @example
* ```jsx
* const props = useVisuallyHidden();
* <a href="#">
*   Learn more<Role {...props}> about the Solar System</Role>.
* </a>
* ```
*/
var useVisuallyHidden = createHook((props) => {
	props = {
		...props,
		style: {
			border: 0,
			clip: "rect(0 0 0 0)",
			height: "1px",
			margin: "-1px",
			overflow: "hidden",
			padding: 0,
			position: "absolute",
			whiteSpace: "nowrap",
			width: "1px",
			...props.style
		}
	};
	return props;
});
/**
* A component that renders an element that's visually hidden, but still
* accessible to screen readers.
* @see https://ariakit.org/components/visually-hidden
* @example
* ```jsx
* <a href="#">
*   Learn more<VisuallyHidden> about the Solar System</VisuallyHidden>.
* </a>
* ```
*/
var VisuallyHidden = createComponent((props) => {
	return createElement$1("span", useVisuallyHidden(props));
});
if (process.env.NODE_ENV !== "production") VisuallyHidden.displayName = "VisuallyHidden";
//#endregion
//#region ../../node_modules/ariakit/esm/focus-trap/focus-trap.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a focus trap element.
* @see https://ariakit.org/components/focus-trap
* @example
* ```jsx
* const props = useFocusTrap();
* <Role {...props} />
* ```
*/
var useFocusTrap = createHook((props) => {
	props = {
		"data-focus-trap": "",
		tabIndex: 0,
		"aria-hidden": true,
		...props,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			...props.style
		}
	};
	props = useVisuallyHidden(props);
	return props;
});
/**
* A component that renders a focus trap element.
* @see https://ariakit.org/components/focus-trap
* @example
* ```jsx
* <FocusTrap onFocus={focusSomethingElse} />
* ```
*/
var FocusTrap = createComponent((props) => {
	return createElement$1("span", useFocusTrap(props));
});
if (process.env.NODE_ENV !== "production") FocusTrap.displayName = "FocusTrap";
//#endregion
//#region ../../node_modules/ariakit/esm/focus-trap/focus-trap-region.js
var useFocusTrapRegion = createHook((_ref) => {
	let { enabled = false, ...props } = _ref;
	const ref = useRef(null);
	props = useWrapElement(props, (element) => {
		const renderFocusTrap = () => {
			if (!enabled) return null;
			return /*#__PURE__*/ jsx(FocusTrap, { onFocus: (event) => {
				const container = ref.current;
				if (!container) return;
				const tabbables = getAllTabbableIn(container, true);
				const first = tabbables[0];
				const last = tabbables[tabbables.length - 1];
				if (!tabbables.length) {
					container.focus();
					return;
				}
				if (event.relatedTarget === first) last?.focus();
				else first?.focus();
			} });
		};
		return /*#__PURE__*/ jsxs(Fragment$1, { children: [
			renderFocusTrap(),
			element,
			renderFocusTrap()
		] });
	}, [enabled]);
	props = {
		...props,
		ref: useForkRef(ref, props.ref)
	};
	return props;
});
/**
* A component that renders a focus trap region element.
* @see https://ariakit.org/components/focus-trap-region
* @example
* ```jsx
* <FocusTrapRegion>
*  <Button>click me</Button>
*  <Button>trap focus</Button>
*  <Button disabled>disabled Button</Button>
* </FocusTrapRegion>
* ```
*/
var FocusTrapRegion = createComponent((props) => {
	return createElement$1("div", useFocusTrapRegion(props));
});
if (process.env.NODE_ENV !== "production") FocusTrapRegion.displayName = "FocusTrapRegion";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-5a52896b.js
var HeadingContext = /*#__PURE__*/ createContext(0);
//#endregion
//#region ../../node_modules/ariakit/esm/heading/heading-level.js
function HeadingLevel(_ref) {
	let { level, children } = _ref;
	const contextLevel = useContext(HeadingContext);
	const nextLevel = Math.max(Math.min(level || contextLevel + 1, 6), 1);
	return /*#__PURE__*/ jsx(HeadingContext.Provider, {
		value: nextLevel,
		children
	});
}
//#endregion
//#region ../../node_modules/ariakit/esm/portal/portal-context.js
/**
* Stores the element that will contain the portal. By default, it will be the
* body of the document.
* @example
* ```jsx
* const container = document.getElementById("container");
*
* function App() {
*   return (
*     <PortalContext.Provider value={container}>
*       <Portal />
*     </PortalContext.Provider>
*   );
* }
* ```
*/
var PortalContext = /*#__PURE__*/ createContext(null);
//#endregion
//#region ../../node_modules/ariakit/esm/portal/portal.js
function getRootElement(element) {
	return getDocument(element).body;
}
function getPortalElement(element, portalElement) {
	if (!portalElement) return getDocument(element).createElement("div");
	if (typeof portalElement === "function") return portalElement(element);
	return portalElement;
}
function getRandomId(prefix) {
	if (prefix === void 0) prefix = "id";
	return (prefix ? prefix + "-" : "") + Math.random().toString(36).substr(2, 6);
}
function queueFocus(element) {
	queueMicrotask$1(() => {
		element?.focus();
	});
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element using `ReactDOM.createPortal`.
* @see https://ariakit.org/components/portal
* @example
* ```jsx
* const props = usePortal();
* <Role {...props}>Content</Role>
* ```
*/
var usePortal = createHook((_ref) => {
	let { preserveTabOrder, portalElement, portalRef, portal = true, ...props } = _ref;
	const ref = useRef(null);
	const refProp = useForkRef(ref, props.ref);
	const context = useContext(PortalContext);
	const [portalNode, setPortalNode] = useState(null);
	const beforeOutsideRef = useRef(null);
	const beforeInsideRef = useRef(null);
	const afterInsideRef = useRef(null);
	const afterOutsideRef = useRef(null);
	useSafeLayoutEffect(() => {
		const element = ref.current;
		if (!element || !portal) {
			setPortalNode(null);
			return;
		}
		const portalEl = getPortalElement(element, portalElement);
		if (!portalEl) {
			setPortalNode(null);
			return;
		}
		const isPortalInDocument = portalEl.isConnected;
		if (!isPortalInDocument) (context || getRootElement(element)).appendChild(portalEl);
		if (!portalEl.id) portalEl.id = element.id ? element.id + "-portal" : getRandomId();
		setPortalNode(portalEl);
		setRef(portalRef, portalEl);
		if (isPortalInDocument) return;
		return () => {
			portalEl.remove();
			setRef(portalRef, null);
		};
	}, [
		portal,
		portalElement,
		context,
		portalRef
	]);
	useEffect(() => {
		if (!portalNode) return;
		if (!preserveTabOrder) return;
		let raf = 0;
		const onFocus = (event) => {
			if (isFocusEventOutside(event)) {
				if (event.type === "focusin") return restoreFocusIn(portalNode);
				cancelAnimationFrame(raf);
				raf = requestAnimationFrame(() => {
					disableFocusIn(portalNode, true);
				});
			}
		};
		portalNode.addEventListener("focusin", onFocus, true);
		portalNode.addEventListener("focusout", onFocus, true);
		return () => {
			portalNode.removeEventListener("focusin", onFocus, true);
			portalNode.removeEventListener("focusout", onFocus, true);
		};
	}, [portalNode, preserveTabOrder]);
	props = useWrapElement(props, (element) => {
		element = /*#__PURE__*/ jsx(PortalContext.Provider, {
			value: portalNode || context,
			children: element
		});
		if (!portal) return element;
		if (!portalNode) return /*#__PURE__*/ jsx("span", {
			ref: refProp,
			id: props.id,
			style: { position: "fixed" }
		});
		element = /*#__PURE__*/ jsxs(Fragment$1, { children: [
			preserveTabOrder && portalNode && /*#__PURE__*/ jsx(FocusTrap, {
				ref: beforeInsideRef,
				onFocus: (event) => {
					if (isFocusEventOutside(event, portalNode)) queueFocus(getNextTabbable());
					else queueFocus(beforeOutsideRef.current);
				}
			}),
			element,
			preserveTabOrder && portalNode && /*#__PURE__*/ jsx(FocusTrap, {
				ref: afterInsideRef,
				onFocus: (event) => {
					if (isFocusEventOutside(event, portalNode)) queueFocus(getPreviousTabbable());
					else queueFocus(afterOutsideRef.current);
				}
			})
		] });
		if (portalNode) element = /*#__PURE__*/ createPortal(element, portalNode);
		element = /*#__PURE__*/ jsxs(Fragment$1, { children: [
			preserveTabOrder && portalNode && /*#__PURE__*/ jsx(FocusTrap, {
				ref: beforeOutsideRef,
				onFocus: (event) => {
					if (isFocusEventOutside(event, portalNode)) queueFocus(beforeInsideRef.current);
					else queueFocus(getPreviousTabbable());
				}
			}),
			preserveTabOrder && /*#__PURE__*/ jsx("span", {
				"aria-owns": portalNode == null ? void 0 : portalNode.id,
				style: { position: "fixed" }
			}),
			element,
			preserveTabOrder && portalNode && /*#__PURE__*/ jsx(FocusTrap, {
				ref: afterOutsideRef,
				onFocus: (event) => {
					if (isFocusEventOutside(event, portalNode)) queueFocus(afterInsideRef.current);
					else queueFocus(getNextTabbable());
				}
			})
		] });
		return element;
	}, [
		portalNode,
		context,
		portal,
		props.id,
		preserveTabOrder
	]);
	props = {
		...props,
		ref: refProp
	};
	return props;
});
/**
* A component that renders an element using `ReactDOM.createPortal`.
* @see https://ariakit.org/components/portal
* @example
* ```jsx
* <Portal>Content</Portal>
* ```
*/
var Portal = createComponent((props) => {
	return createElement$1("div", usePortal(props));
});
if (process.env.NODE_ENV !== "production") Portal.displayName = "Portal";
//#endregion
//#region ../../node_modules/ariakit/esm/dialog-context-f963dd70.js
var DialogContext = /*#__PURE__*/ createContext(void 0);
var DialogHeadingContext = /*#__PURE__*/ createContext(void 0);
var DialogDescriptionContext = /*#__PURE__*/ createContext(void 0);
//#endregion
//#region ../../node_modules/ariakit/esm/dialog/dialog.js
function usePreviousMouseDownRef(enabled) {
	const previousMouseDownRef = useRef();
	useEffect(() => {
		if (!enabled) {
			previousMouseDownRef.current = null;
			return;
		}
		const onMouseDown = (event) => {
			previousMouseDownRef.current = event.target;
		};
		return addGlobalEventListener("mousedown", onMouseDown, true);
	}, [enabled]);
	return previousMouseDownRef;
}
function DialogBackdrop(_ref) {
	var _state$contentElement;
	let { state, backdrop, backdropProps, hideOnInteractOutside = true, hideOnEscape = true, hidden, children } = _ref;
	const ref = useRef(null);
	state = useMemo(() => ({
		...state,
		setContentElement: noop$4
	}), [state]);
	useSafeLayoutEffect(() => {
		const backdrop = ref.current;
		const dialog = state.contentElement;
		if (!backdrop) return;
		if (!dialog) return;
		backdrop.style.zIndex = getComputedStyle(dialog).zIndex;
	}, [state.contentElement]);
	const onClickProp = backdropProps == null ? void 0 : backdropProps.onClick;
	const hideOnInteractOutsideProp = useBooleanEvent(hideOnInteractOutside);
	const previousMouseDownRef = usePreviousMouseDownRef(state.mounted);
	const onClick = useEvent$1((event) => {
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		if (!isSelfTarget(event)) return;
		if (previousMouseDownRef.current !== event.currentTarget) return;
		if (!hideOnInteractOutsideProp(event)) return;
		event.stopPropagation();
		state.hide();
	});
	const onKeyDownProp = backdropProps == null ? void 0 : backdropProps.onKeyDown;
	const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (event.key !== "Escape") return;
		if (!isSelfTarget(event)) return;
		if (!hideOnEscapeProp(event)) return;
		state.hide();
	});
	const props = useDisclosureContent({
		state,
		id: void 0,
		role: "presentation",
		tabIndex: -1,
		hidden,
		...backdropProps,
		ref: useForkRef(backdropProps == null ? void 0 : backdropProps.ref, ref),
		onClick,
		onKeyDown,
		style: {
			position: "fixed",
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			...backdropProps == null ? void 0 : backdropProps.style
		}
	});
	return /*#__PURE__*/ jsx(typeof backdrop !== "boolean" ? backdrop || "div" : "div", {
		...props,
		"data-backdrop": (_state$contentElement = state.contentElement) == null ? void 0 : _state$contentElement.id,
		children
	});
}
var ignoreTags = ["SCRIPT", "STYLE"];
function isValidElement$1(element, ignoredElements) {
	if (ignoreTags.includes(element.tagName)) return false;
	return !ignoredElements.some((enabledElement) => enabledElement && contains(element, enabledElement));
}
function walkTreeOutside(elements, callback) {
	for (let element of elements) {
		const document = getDocument(element);
		while ((_element = element) != null && _element.parentElement && element !== document.body) {
			var _element;
			for (const child of element.parentElement.children) if (isValidElement$1(child, elements)) callback(child);
			element = element.parentElement;
		}
	}
}
function disableElement$1(element) {
	const previousAriaHidden = element.getAttribute("aria-hidden") || "";
	element.setAttribute("aria-hidden", "true");
	const enableElement = () => {
		if (previousAriaHidden) element.setAttribute("aria-hidden", previousAriaHidden);
		else element.removeAttribute("aria-hidden");
	};
	return enableElement;
}
function disableAccessibilityTreeOutside() {
	const cleanups = [];
	for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) elements[_key] = arguments[_key];
	walkTreeOutside(elements, (element) => {
		cleanups.unshift(disableElement$1(element));
	});
	const restoreAccessibilityTree = () => {
		cleanups.forEach((fn) => fn());
	};
	return restoreAccessibilityTree;
}
function disableElement(element) {
	if (!("style" in element)) return noop$4;
	const previousPointerEvents = element.style.pointerEvents;
	element.style.pointerEvents = "none";
	const enableElement = () => {
		element.style.pointerEvents = previousPointerEvents != null ? previousPointerEvents : "";
	};
	return enableElement;
}
function disablePointerEventsOutside() {
	const cleanups = [];
	for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) elements[_key] = arguments[_key];
	walkTreeOutside(elements, (element) => {
		cleanups.unshift(disableElement(element));
	});
	const restorePointerEvents = () => {
		cleanups.forEach((fn) => fn());
	};
	return restorePointerEvents;
}
function prependHiddenDismiss(container, onClick) {
	const button = getDocument(container).createElement("button");
	button.type = "button";
	button.tabIndex = -1;
	button.textContent = "Dismiss popup";
	button.style.border = "0px";
	button.style.clip = "rect(0 0 0 0)";
	button.style.height = "1px";
	button.style.margin = "-1px";
	button.style.overflow = "hidden";
	button.style.padding = "0px";
	button.style.position = "absolute";
	button.style.whiteSpace = "nowrap";
	button.style.width = "1px";
	button.addEventListener("click", onClick);
	container.prepend(button);
	const removeHiddenDismiss = () => {
		button.removeEventListener("click", onClick);
		button.remove();
	};
	return removeHiddenDismiss;
}
/**
* Controls which dialog is the champion that will control global behavior such
* as body scrolling and accessibility tree outside.
*/
function useChampionDialog(dialogRef, attribute, enabled) {
	const [updated, retry] = useForceUpdate$1();
	const isChampionDialog = useCallback(() => {
		if (!enabled) return false;
		const dialog = dialogRef.current;
		if (!dialog) return false;
		const { body } = getDocument(dialog);
		const id = body.getAttribute(attribute);
		return !id || id === dialog.id;
	}, [
		updated,
		enabled,
		attribute
	]);
	useSafeLayoutEffect(() => {
		const dialog = dialogRef.current;
		if (!dialog) return;
		if (!enabled) return;
		const { body } = getDocument(dialog);
		if (!isChampionDialog()) {
			const observer = new MutationObserver(() => flushSync(retry));
			observer.observe(body, { attributeFilter: [attribute] });
			return () => observer.disconnect();
		}
		body.setAttribute(attribute, dialog.id);
		return () => {
			body.removeAttribute(attribute);
		};
	}, [
		updated,
		dialogRef,
		enabled,
		isChampionDialog,
		attribute
	]);
	return isChampionDialog;
}
/**
* When the focused child gets removed from the DOM, we make sure to move focus
* to the dialog.
*/
function useFocusOnChildUnmount(dialogRef, state) {
	useEffect(() => {
		if (!state.open) return;
		const dialog = dialogRef.current;
		if (!dialog) return;
		const observer = new MutationObserver((_ref) => {
			let [mutation] = _ref;
			if (!mutation) return;
			if (mutation.target !== dialog) return;
			const document = getDocument(dialog);
			if (getActiveElement(dialog) === document.body) dialog.focus();
		});
		observer.observe(dialog, {
			childList: true,
			subtree: true
		});
		return () => observer.disconnect();
	}, [state.open, dialogRef]);
}
function isInDocument(target) {
	if (target.tagName === "HTML") return true;
	return contains(getDocument(target).body, target);
}
function isDisclosure(disclosure, target) {
	if (contains(disclosure, target)) return true;
	const activeId = target.getAttribute("aria-activedescendant");
	if (activeId) {
		const activeElement = getDocument(disclosure).getElementById(activeId);
		if (activeElement) return contains(disclosure, activeElement);
	}
	return false;
}
function isBackdrop$1(dialog, target) {
	if (!dialog) return false;
	if (!target) return false;
	return target.hasAttribute("data-backdrop") && target.getAttribute("data-backdrop") === dialog.id;
}
function dialogContains(target) {
	return (dialogRef) => {
		const dialog = dialogRef.current;
		if (!dialog) return false;
		if (contains(dialog, target)) return true;
		if (isBackdrop$1(dialog, target)) return true;
		return false;
	};
}
function useEventOutside(_ref) {
	let { type, listener, dialogRef, nestedDialogs, disclosureRef, enabled, capture } = _ref;
	const callListener = useEvent$1(listener);
	const nestedDialogsRef = useLiveRef(nestedDialogs);
	useEffect(() => {
		if (!enabled) return;
		const onEvent = (event) => {
			const container = dialogRef.current;
			const disclosure = disclosureRef == null ? void 0 : disclosureRef.current;
			const target = event.target;
			if (!container) return;
			if (!target) return;
			if (!isInDocument(target)) return;
			if (contains(container, target)) return;
			if (disclosure && isDisclosure(disclosure, target)) return;
			if (target.hasAttribute("data-focus-trap")) return;
			if (nestedDialogsRef.current.some(dialogContains(target))) return;
			callListener(event);
		};
		return addGlobalEventListener(type, onEvent, capture);
	}, [
		enabled,
		dialogRef,
		disclosureRef,
		callListener,
		capture
	]);
}
function shouldHideOnInteractOutside(hideOnInteractOutside, event) {
	if (typeof hideOnInteractOutside === "function") return hideOnInteractOutside(event);
	return !!hideOnInteractOutside;
}
function useHideOnInteractOutside(dialogRef, nestedDialogs, _ref2) {
	let { state, modal, hideOnInteractOutside, enabled = state.open } = _ref2;
	const previousMouseDownRef = usePreviousMouseDownRef(enabled);
	const props = {
		disclosureRef: state.disclosureRef,
		enabled,
		dialogRef,
		nestedDialogs,
		capture: true
	};
	useEventOutside({
		...props,
		type: "mousedown",
		listener: (event) => {
			const dialog = dialogRef.current;
			if (!dialog) return;
			if (modal && !shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
				dialog.focus();
				event.preventDefault();
				event.stopPropagation();
			}
		}
	});
	useEventOutside({
		...props,
		type: "click",
		listener: (event) => {
			const previousMouseDown = previousMouseDownRef.current;
			if (!previousMouseDown) return;
			if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
				if (!modal) return;
				event.preventDefault();
				event.stopPropagation();
				return;
			}
			const dialog = dialogRef.current;
			if (dialog && contains(dialog, previousMouseDown)) return;
			state.hide();
		}
	});
	useEventOutside({
		...props,
		type: "focusin",
		listener: (event) => {
			const dialog = dialogRef.current;
			if (!dialog) return;
			if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
				if (!modal) return;
				dialog.focus();
				event.preventDefault();
				event.stopPropagation();
				return;
			}
			if (event.target === getDocument(dialog)) return;
			state.hide();
		}
	});
	useEventOutside({
		...props,
		type: "contextmenu",
		listener: (event) => {
			const dialog = dialogRef.current;
			if (!dialog) return;
			if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
				if (!modal) return;
				dialog.focus();
				event.preventDefault();
				event.stopPropagation();
				return;
			}
			state.hide();
		}
	});
}
var NestedDialogsContext = /*#__PURE__*/ createContext({});
/**
* Handles nested dialogs.
*/
function useNestedDialogs(dialogRef, _ref) {
	let { state, modal } = _ref;
	const context = useContext(NestedDialogsContext);
	const [openModals, setOpenModals] = useState([]);
	const [nestedDialogs, setNestedDialogs] = useState([]);
	const addDialog = useCallback((ref) => {
		const removeFromContext = context.addDialog == null ? void 0 : context.addDialog(ref);
		setNestedDialogs((dialogs) => [...dialogs, ref]);
		return () => {
			removeFromContext?.();
			setNestedDialogs((dialogs) => dialogs.filter((dialog) => dialog !== ref));
		};
	}, [context.addDialog]);
	const showModal = useCallback((ref) => {
		const hideModal = context.showModal == null ? void 0 : context.showModal(ref);
		setOpenModals((modals) => [...modals, ref]);
		return () => {
			hideModal?.();
			setOpenModals((modals) => modals.filter((modal) => modal !== ref));
		};
	}, [context.showModal]);
	useSafeLayoutEffect(() => {
		return context.addDialog == null ? void 0 : context.addDialog(dialogRef);
	}, [context.addDialog, dialogRef]);
	useSafeLayoutEffect(() => {
		if (!modal) return;
		if (!state.open) return;
		return context.showModal == null ? void 0 : context.showModal(dialogRef);
	}, [
		modal,
		state.open,
		context.showModal,
		dialogRef
	]);
	useSafeLayoutEffect(() => {
		if (context.open === false && state.open) state.hide();
	}, [
		context.open,
		state.open,
		state.hide
	]);
	const providerValue = useMemo(() => ({
		open: state.open,
		addDialog,
		showModal
	}), [
		state.open,
		addDialog,
		showModal
	]);
	return {
		nestedDialogs,
		openModals,
		wrapElement: useCallback((element) => /*#__PURE__*/ jsx(NestedDialogsContext.Provider, {
			value: providerValue,
			children: element
		}), [providerValue])
	};
}
function assignStyle(element, style) {
	if (!element) return () => {};
	const previousStyle = element.style.cssText;
	Object.assign(element.style, style);
	return () => {
		element.style.cssText = previousStyle;
	};
}
function setCSSProperty(element, property, value) {
	if (!element) return () => {};
	const previousValue = element.style.getPropertyValue(property);
	element.style.setProperty(property, value);
	return () => {
		if (previousValue) element.style.setProperty(property, previousValue);
		else element.style.removeProperty(property);
	};
}
function getPaddingProperty(documentElement) {
	const documentLeft = documentElement.getBoundingClientRect().left;
	return Math.round(documentLeft) + documentElement.scrollLeft ? "paddingLeft" : "paddingRight";
}
function usePreventBodyScroll(dialogRef, enabled) {
	const isChampionDialog = useChampionDialog(dialogRef, "data-dialog-body-scroll", enabled);
	useSafeLayoutEffect(() => {
		const dialog = dialogRef.current;
		if (!dialog) return;
		if (!isChampionDialog()) return;
		const doc = getDocument(dialog);
		const win = getWindow$2(dialog);
		const { documentElement, body } = doc;
		const scrollbarWidth = win.innerWidth - documentElement.clientWidth;
		const setScrollbarWidthProperty = () => setCSSProperty(documentElement, "--scrollbar-width", scrollbarWidth + "px");
		const paddingProperty = getPaddingProperty(documentElement);
		const setStyle = () => assignStyle(body, {
			overflow: "hidden",
			[paddingProperty]: scrollbarWidth + "px"
		});
		const setIOSStyle = () => {
			var _visualViewport$offse, _visualViewport$offse2;
			const { scrollX, scrollY, visualViewport } = win;
			const offsetLeft = (_visualViewport$offse = visualViewport == null ? void 0 : visualViewport.offsetLeft) != null ? _visualViewport$offse : 0;
			const offsetTop = (_visualViewport$offse2 = visualViewport == null ? void 0 : visualViewport.offsetTop) != null ? _visualViewport$offse2 : 0;
			const restoreStyle = assignStyle(body, {
				position: "fixed",
				overflow: "hidden",
				top: -(scrollY - Math.floor(offsetTop)) + "px",
				left: -(scrollX - Math.floor(offsetLeft)) + "px",
				right: "0",
				[paddingProperty]: scrollbarWidth + "px"
			});
			return () => {
				restoreStyle();
				if (process.env.NODE_ENV !== "test") win.scrollTo(scrollX, scrollY);
			};
		};
		const isIOS = isApple() && !isMac();
		return chain(setScrollbarWidthProperty(), isIOS ? setIOSStyle() : setStyle());
	}, [dialogRef, isChampionDialog]);
}
var isSafariBrowser = isSafari();
function isBackdrop(dialog, element) {
	const id = dialog.id;
	if (!id) return;
	return element.getAttribute("data-backdrop") === id;
}
function isInDialog(element) {
	return (dialogRef) => dialogRef.current && contains(dialogRef.current, element);
}
function isAlreadyFocusingAnotherElement(dialog, nestedDialogs) {
	const activeElement = getActiveElement();
	if (!activeElement) return false;
	if (contains(dialog, activeElement)) return false;
	if (isBackdrop(dialog, activeElement)) return false;
	if (nestedDialogs != null && nestedDialogs.some(isInDialog(activeElement))) return false;
	if (isFocusable(activeElement)) return true;
	return false;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a dialog element.
* @see https://ariakit.org/components/dialog
* @example
* ```jsx
* const state = useDialogState();
* const props = useDialog({ state });
* <Role {...props}>Dialog</Role>
* ```
*/
var useDialog = createHook((_ref) => {
	let { state, focusable = true, modal = true, portal = !!modal, backdrop = !!modal, backdropProps, hideOnEscape = true, hideOnInteractOutside = true, preventBodyScroll = !!modal, autoFocusOnShow = true, autoFocusOnHide = true, initialFocusRef, finalFocusRef, ...props } = _ref;
	const ref = useRef(null);
	const openRef = useRef(state.open);
	const { portalRef, portalNode, domReady } = usePortalRef(portal, props.portalRef);
	const preserveTabOrder = props.preserveTabOrder && !modal && state.mounted;
	const openStable = state.open && !state.animating;
	const shouldDisableAccessibilityTree = modal || portal && preserveTabOrder && isSafari();
	const id = useId(props.id);
	useSafeLayoutEffect(() => {
		if (!openStable) return;
		const dialog = ref.current;
		const activeElement = getActiveElement(dialog, true);
		if (!activeElement) return;
		if (activeElement.tagName === "BODY") return;
		if (dialog && contains(dialog, activeElement)) return;
		state.disclosureRef.current = activeElement;
	}, [openStable]);
	const { nestedDialogs, openModals, wrapElement } = useNestedDialogs(ref, {
		state,
		modal
	});
	const nestedDialogsRef = useLiveRef(nestedDialogs);
	usePreventBodyScroll(ref, preventBodyScroll && state.mounted);
	useFocusOnChildUnmount(ref, state);
	useHideOnInteractOutside(ref, nestedDialogs, {
		state,
		modal,
		hideOnInteractOutside,
		enabled: state.open
	});
	if (isSafariBrowser) useEffect(() => {
		if (!state.mounted) return;
		const disclosure = state.disclosureRef.current;
		if (!disclosure) return;
		if (!isButton(disclosure)) return;
		const onMouseDown = () => {
			let receivedFocus = false;
			const onFocus = () => {
				receivedFocus = true;
			};
			disclosure.addEventListener("focusin", onFocus, {
				capture: true,
				once: true
			});
			queueBeforeEvent(disclosure, "mouseup", () => {
				disclosure.removeEventListener("focusin", onFocus, true);
				if (receivedFocus) return;
				focusIfNeeded(disclosure);
			});
		};
		disclosure.addEventListener("mousedown", onMouseDown);
		return () => {
			disclosure.removeEventListener("mousedown", onMouseDown);
		};
	}, [state.mounted, state.disclosureRef]);
	useEffect(() => {
		if (!state.mounted) return;
		if (!domReady) return;
		const dialog = ref.current;
		if (!dialog) return;
		if (shouldDisableAccessibilityTree) {
			if (dialog.querySelector("[data-dialog-dismiss]")) return;
			return prependHiddenDismiss(dialog, state.hide);
		}
	}, [
		state.mounted,
		domReady,
		shouldDisableAccessibilityTree,
		state.hide
	]);
	const shouldDisableOutside = useChampionDialog(ref, "data-dialog-disable-outside", openStable && !openModals.length && shouldDisableAccessibilityTree);
	useSafeLayoutEffect(() => {
		if (!shouldDisableOutside()) return;
		const element = portal ? portalNode : ref.current;
		if (modal) return chain(disableAccessibilityTreeOutside(element), !backdrop ? disablePointerEventsOutside(element) : null);
		return disableAccessibilityTreeOutside(element);
	}, [
		shouldDisableOutside,
		portal,
		portalNode,
		modal,
		backdrop
	]);
	const prevInitialFocusRef = useRef();
	const mayAutoFocusOnShow = !!autoFocusOnShow;
	const autoFocusOnShowProp = useBooleanEvent(autoFocusOnShow);
	useEffect(() => {
		var _nestedDialogsRef$cur;
		if (!openStable) return;
		if (!mayAutoFocusOnShow) return;
		if (!domReady) return;
		if ((_nestedDialogsRef$cur = nestedDialogsRef.current) == null ? void 0 : _nestedDialogsRef$cur.some((child) => child.current && !child.current.hidden)) return;
		const dialog = state.contentElement;
		if (!(dialog != null && dialog.isConnected)) return;
		const initialFocus = initialFocusRef == null ? void 0 : initialFocusRef.current;
		const element = initialFocus || getFirstTabbableIn(dialog, true, portal && preserveTabOrder) || dialog;
		const prevInitialFocus = prevInitialFocusRef.current;
		prevInitialFocusRef.current = initialFocus;
		if (initialFocus === prevInitialFocus) {
			const activeElement = getActiveElement(dialog, true);
			if (activeElement && contains(dialog, activeElement)) return;
		}
		if (!autoFocusOnShowProp(element)) return;
		element.focus();
	}, [
		openStable,
		mayAutoFocusOnShow,
		domReady,
		state.contentElement,
		initialFocusRef,
		portal,
		preserveTabOrder,
		autoFocusOnShowProp
	]);
	const mayAutoFocusOnHide = !!autoFocusOnHide;
	const autoFocusOnHideProp = useBooleanEvent(autoFocusOnHide);
	useEffect(() => {
		const dialog = ref.current;
		const prevOpen = openRef.current;
		openRef.current = state.open;
		if (!prevOpen) return;
		if (!mayAutoFocusOnHide) return;
		if (!dialog) return;
		const focusOnHide = () => {
			const dialogs = nestedDialogsRef.current;
			if (isAlreadyFocusingAnotherElement(dialog, dialogs)) return;
			let element = (finalFocusRef == null ? void 0 : finalFocusRef.current) || state.disclosureRef.current;
			if (element) {
				if (element.id) {
					const doc = getDocument(element);
					const selector = "[aria-activedescendant=\"" + element.id + "\"]";
					const composite = doc.querySelector(selector);
					if (composite) element = composite;
				}
				if (!isFocusable(element)) {
					const parentDialog = closest(element, "[data-dialog]");
					if (parentDialog && parentDialog.id) {
						const doc = getDocument(parentDialog);
						const selector = "[aria-controls~=\"" + parentDialog.id + "\"]";
						const control = doc.querySelector(selector);
						if (control) element = control;
					}
				}
				if (!autoFocusOnHideProp(element)) return;
				element.focus();
			}
		};
		if (!state.open) return focusOnHide();
		return focusOnHide;
	}, [
		mayAutoFocusOnHide,
		state.open,
		finalFocusRef,
		state.disclosureRef,
		autoFocusOnHideProp
	]);
	const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
	useEffect(() => {
		if (!domReady) return;
		if (!state.mounted) return;
		const onKeyDown = (event) => {
			const dialog = ref.current;
			if (!dialog) return;
			const target = event.target;
			const disclosure = state.disclosureRef.current;
			if (event.key !== "Escape") return;
			if (event.defaultPrevented) return;
			if (!target) return;
			const isValidTarget = () => {
				if (contains(dialog, target)) {
					if (nestedDialogsRef.current.some(isInDialog(target))) return false;
					return true;
				}
				if (disclosure && contains(disclosure, target)) return true;
				return false;
			};
			if (isValidTarget() && hideOnEscapeProp(event)) state.hide();
		};
		return addGlobalEventListener("keydown", onKeyDown);
	}, [
		domReady,
		state.mounted,
		state.disclosureRef,
		hideOnEscapeProp,
		state.hide
	]);
	props = useWrapElement(props, wrapElement, [wrapElement]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(HeadingLevel, {
		level: modal ? 1 : void 0,
		children: element
	}), [modal]);
	props = useFocusTrapRegion({
		...props,
		enabled: state.open && modal && !openModals.length
	});
	const hiddenProp = props.hidden;
	props = useWrapElement(props, (element) => {
		if (backdrop) return /*#__PURE__*/ jsx(DialogBackdrop, {
			state,
			backdrop,
			backdropProps,
			hideOnInteractOutside,
			hideOnEscape,
			hidden: hiddenProp,
			children: element
		});
		return element;
	}, [
		state,
		backdrop,
		backdropProps,
		hideOnInteractOutside,
		hideOnEscape,
		hiddenProp
	]);
	const [headingId, setHeadingId] = useState();
	const [descriptionId, setDescriptionId] = useState();
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(DialogContext.Provider, {
		value: state,
		children: /*#__PURE__*/ jsx(DialogHeadingContext.Provider, {
			value: setHeadingId,
			children: /*#__PURE__*/ jsx(DialogDescriptionContext.Provider, {
				value: setDescriptionId,
				children: element
			})
		})
	}), [state]);
	props = {
		id,
		"data-dialog": "",
		role: "dialog",
		tabIndex: focusable ? -1 : void 0,
		"aria-labelledby": headingId,
		"aria-describedby": descriptionId,
		...props,
		ref: useForkRef(ref, props.ref)
	};
	props = useDisclosureContent({
		state,
		...props
	});
	props = useFocusable({
		...props,
		focusable
	});
	props = usePortal({
		portal,
		...props,
		portalRef,
		preserveTabOrder
	});
	return props;
});
/**
* A component that renders a dialog element.
* @see https://ariakit.org/components/dialog
* @example
* ```jsx
* const dialog = useDialogState();
* <button onClick={dialog.toggle}>Open dialog</button>
* <Dialog state={dialog}>Dialog</Dialog>
* ```
*/
var Dialog = createComponent((props) => {
	return createElement$1("div", useDialog(props));
});
if (process.env.NODE_ENV !== "production") Dialog.displayName = "Dialog";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-3e6151ed.js
var PopoverContext = /*#__PURE__*/ createContext(void 0);
//#endregion
//#region ../../node_modules/ariakit/esm/popover/popover.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a popover element.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const state = usePopoverState();
* const props = usePopover({ state });
* <Role {...props}>Popover</Role>
* ```
*/
var usePopover = createHook((_ref) => {
	let { state, modal = false, portal = !!modal, preserveTabOrder = true, autoFocusOnShow = true, wrapperProps, ...props } = _ref;
	const popoverRef = state.popoverRef;
	useSafeLayoutEffect(() => {
		const wrapper = popoverRef.current;
		const popover = state.contentElement;
		if (!wrapper) return;
		if (!popover) return;
		wrapper.style.zIndex = getComputedStyle(popover).zIndex;
	}, [popoverRef, state.contentElement]);
	const [canAutoFocusOnShow, setCanAutoFocusOnShow] = useState(false);
	const { portalRef, domReady } = usePortalRef(portal, props.portalRef);
	useSafeLayoutEffect(() => {
		var _state$contentElement;
		if (!domReady) return;
		if (!state.mounted) return;
		if (!((_state$contentElement = state.contentElement) != null && _state$contentElement.isConnected)) return;
		const raf = requestAnimationFrame(() => {
			setCanAutoFocusOnShow(true);
		});
		return () => {
			cancelAnimationFrame(raf);
		};
	}, [
		domReady,
		state.mounted,
		state.contentElement
	]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx("div", {
		role: "presentation",
		...wrapperProps,
		style: {
			position: state.fixed ? "fixed" : "absolute",
			top: 0,
			left: 0,
			...wrapperProps == null ? void 0 : wrapperProps.style
		},
		ref: popoverRef,
		children: element
	}), [
		state.fixed,
		popoverRef,
		wrapperProps
	]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(PopoverContext.Provider, {
		value: state,
		children: element
	}), [state]);
	props = {
		...props,
		style: {
			position: "relative",
			...props.style
		}
	};
	props = useDialog({
		state,
		modal,
		preserveTabOrder,
		portal,
		autoFocusOnShow: canAutoFocusOnShow && autoFocusOnShow,
		...props,
		portalRef
	});
	return props;
});
/**
* A component that renders a popover element.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const popover = usePopoverState();
* <PopoverDisclosure state={popover}>Disclosure</PopoverDisclosure>
* <Popover state={popover}>Popover</Popover>
* ```
*/
var Popover$1 = createComponent((props) => {
	return createElement$1("div", usePopover(props));
});
if (process.env.NODE_ENV !== "production") Popover$1.displayName = "Popover";
//#endregion
//#region ../../node_modules/ariakit/esm/composite/composite-state.js
/**
* Provides state for the `Composite` component.
* @example
* ```jsx
* const composite = useCompositeState();
* <Composite state={composite}>
*   <CompositeItem>Item 1</CompositeItem>
*   <CompositeItem>Item 2</CompositeItem>
*   <CompositeItem>Item 3</CompositeItem>
* </Composite>
* ```
*/
function useCompositeState(_temp) {
	var _props$includesBaseEl;
	let { orientation = "both", rtl = false, virtualFocus = false, focusLoop = false, focusWrap = false, focusShift = false, ...props } = _temp === void 0 ? {} : _temp;
	const collection = useCollectionState(props);
	const baseRef = useRef(null);
	const [moves, setMoves] = useControlledState(0, props.moves, props.setMoves);
	const [_activeId, setActiveId] = useControlledState(props.defaultActiveId, props.activeId, props.setActiveId);
	const activeId = useMemo(() => getActiveId(collection.items, _activeId), [collection.items, _activeId]);
	const initialActiveId = useInitialValue$1(activeId);
	const includesBaseElement = (_props$includesBaseEl = props.includesBaseElement) != null ? _props$includesBaseEl : initialActiveId === null;
	const activeIdRef = useLiveRef(activeId);
	const move = useCallback((id) => {
		if (id === void 0) return;
		setMoves((prevMoves) => prevMoves + 1);
		setActiveId(id);
	}, []);
	const first = useCallback(() => {
		const firstItem = findFirstEnabledItem(collection.items);
		return firstItem == null ? void 0 : firstItem.id;
	}, [collection.items]);
	const last = useCallback(() => {
		const firstItem = findFirstEnabledItem(reverseArray(collection.items));
		return firstItem == null ? void 0 : firstItem.id;
	}, [collection.items]);
	const getNextId = useCallback((items, orientation, hasNullItem, skip) => {
		const allItems = rtl && orientation !== "vertical" ? reverseArray(items) : items;
		if (activeIdRef.current == null) {
			var _findFirstEnabledItem;
			return (_findFirstEnabledItem = findFirstEnabledItem(allItems)) == null ? void 0 : _findFirstEnabledItem.id;
		}
		const activeItem = allItems.find((item) => item.id === activeIdRef.current);
		if (!activeItem) {
			var _findFirstEnabledItem2;
			return (_findFirstEnabledItem2 = findFirstEnabledItem(allItems)) == null ? void 0 : _findFirstEnabledItem2.id;
		}
		const isGrid = !!activeItem.rowId;
		const activeIndex = allItems.indexOf(activeItem);
		const nextItems = allItems.slice(activeIndex + 1);
		const nextItemsInRow = getItemsInRow(nextItems, activeItem.rowId);
		if (skip !== void 0) {
			const nextEnabledItemsInRow = getEnabledItems$1(nextItemsInRow, activeIdRef.current);
			const nextItem = nextEnabledItemsInRow.slice(skip)[0] || nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1];
			return nextItem == null ? void 0 : nextItem.id;
		}
		const oppositeOrientation = getOppositeOrientation(isGrid ? orientation || "horizontal" : orientation);
		const canLoop = focusLoop && focusLoop !== oppositeOrientation;
		const canWrap = isGrid && focusWrap && focusWrap !== oppositeOrientation;
		hasNullItem = hasNullItem || !isGrid && canLoop && includesBaseElement;
		if (canLoop) {
			const nextItem = findFirstEnabledItem(flipItems(canWrap && !hasNullItem ? allItems : getItemsInRow(allItems, activeItem.rowId), activeIdRef.current, hasNullItem), activeIdRef.current);
			return nextItem == null ? void 0 : nextItem.id;
		}
		if (canWrap) {
			const nextItem = findFirstEnabledItem(hasNullItem ? nextItemsInRow : nextItems, activeIdRef.current);
			return hasNullItem ? (nextItem == null ? void 0 : nextItem.id) || null : nextItem == null ? void 0 : nextItem.id;
		}
		const nextItem = findFirstEnabledItem(nextItemsInRow, activeIdRef.current);
		if (!nextItem && hasNullItem) return null;
		return nextItem == null ? void 0 : nextItem.id;
	}, [
		focusLoop,
		focusWrap,
		includesBaseElement
	]);
	const next = useCallback((skip) => {
		return getNextId(collection.items, orientation, false, skip);
	}, [
		getNextId,
		collection.items,
		orientation
	]);
	const previous = useCallback((skip) => {
		var _findFirstEnabledItem3;
		const hasNullItem = !!!((_findFirstEnabledItem3 = findFirstEnabledItem(collection.items)) != null && _findFirstEnabledItem3.rowId) && includesBaseElement;
		return getNextId(reverseArray(collection.items), orientation, hasNullItem, skip);
	}, [
		collection.items,
		getNextId,
		orientation,
		includesBaseElement
	]);
	const down = useCallback((skip) => {
		const shouldShift = focusShift && !skip;
		const verticalItems = verticalizeItems(flatten2DArray(normalizeRows(groupItemsByRows(collection.items), activeIdRef.current, shouldShift)));
		return getNextId(verticalItems, "vertical", focusLoop && focusLoop !== "horizontal" && includesBaseElement, skip);
	}, [
		collection.items,
		getNextId,
		focusShift,
		focusLoop
	]);
	const up = useCallback((skip) => {
		const shouldShift = focusShift && !skip;
		const verticalItems = verticalizeItems(reverseArray(flatten2DArray(normalizeRows(groupItemsByRows(collection.items), activeIdRef.current, shouldShift))));
		return getNextId(verticalItems, "vertical", includesBaseElement, skip);
	}, [
		collection.items,
		getNextId,
		focusShift
	]);
	return useStorePublisher(useMemo(() => ({
		...collection,
		baseRef,
		orientation,
		rtl,
		virtualFocus,
		focusLoop,
		focusWrap,
		focusShift,
		moves,
		setMoves,
		includesBaseElement,
		activeId,
		setActiveId,
		move,
		next,
		previous,
		up,
		down,
		first,
		last
	}), [
		collection,
		baseRef,
		orientation,
		rtl,
		virtualFocus,
		focusLoop,
		focusWrap,
		focusShift,
		moves,
		setMoves,
		includesBaseElement,
		activeId,
		setActiveId,
		move,
		next,
		previous,
		up,
		down,
		first,
		last
	]));
}
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var min$1 = Math.min;
var max$1 = Math.max;
var round$1 = Math.round;
var floor$1 = Math.floor;
var createCoords = (v) => ({
	x: v,
	y: v
});
var oppositeSideMap = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
var oppositeAlignmentMap = {
	start: "end",
	end: "start"
};
function clamp(start, value, end) {
	return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
	return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
	return placement.split("-")[0];
}
function getAlignment(placement) {
	return placement.split("-")[1];
}
function getOppositeAxis(axis) {
	return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
	return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
	return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
	return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
	if (rtl === void 0) rtl = false;
	const alignment = getAlignment(placement);
	const alignmentAxis = getAlignmentAxis(placement);
	const length = getAxisLength(alignmentAxis);
	let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
	if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
	return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
	const oppositePlacement = getOppositePlacement(placement);
	return [
		getOppositeAlignmentPlacement(placement),
		oppositePlacement,
		getOppositeAlignmentPlacement(oppositePlacement)
	];
}
function getOppositeAlignmentPlacement(placement) {
	return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
	const lr = ["left", "right"];
	const rl = ["right", "left"];
	const tb = ["top", "bottom"];
	const bt = ["bottom", "top"];
	switch (side) {
		case "top":
		case "bottom":
			if (rtl) return isStart ? rl : lr;
			return isStart ? lr : rl;
		case "left":
		case "right": return isStart ? tb : bt;
		default: return [];
	}
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
	const alignment = getAlignment(placement);
	let list = getSideList(getSide(placement), direction === "start", rtl);
	if (alignment) {
		list = list.map((side) => side + "-" + alignment);
		if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
	}
	return list;
}
function getOppositePlacement(placement) {
	return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...padding
	};
}
function getPaddingObject(padding) {
	return typeof padding !== "number" ? expandPaddingObject(padding) : {
		top: padding,
		right: padding,
		bottom: padding,
		left: padding
	};
}
function rectToClientRect(rect) {
	return {
		...rect,
		top: rect.y,
		left: rect.x,
		right: rect.x + rect.width,
		bottom: rect.y + rect.height
	};
}
//#endregion
//#region ../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
	let { reference, floating } = _ref;
	const sideAxis = getSideAxis(placement);
	const alignmentAxis = getAlignmentAxis(placement);
	const alignLength = getAxisLength(alignmentAxis);
	const side = getSide(placement);
	const isVertical = sideAxis === "y";
	const commonX = reference.x + reference.width / 2 - floating.width / 2;
	const commonY = reference.y + reference.height / 2 - floating.height / 2;
	const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
	let coords;
	switch (side) {
		case "top":
			coords = {
				x: commonX,
				y: reference.y - floating.height
			};
			break;
		case "bottom":
			coords = {
				x: commonX,
				y: reference.y + reference.height
			};
			break;
		case "right":
			coords = {
				x: reference.x + reference.width,
				y: commonY
			};
			break;
		case "left":
			coords = {
				x: reference.x - floating.width,
				y: commonY
			};
			break;
		default: coords = {
			x: reference.x,
			y: reference.y
		};
	}
	switch (getAlignment(placement)) {
		case "start":
			coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
			break;
		case "end": coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
	}
	return coords;
}
/**
* Computes the `x` and `y` coordinates that will place the floating element
* next to a given reference element.
*
* This export does not have any `platform` interface logic. You will need to
* write one for the platform you are using Floating UI with.
*/
var computePosition$1 = async (reference, floating, config) => {
	const { placement = "bottom", strategy = "absolute", middleware = [], platform } = config;
	const validMiddleware = middleware.filter(Boolean);
	const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
	let rects = await platform.getElementRects({
		reference,
		floating,
		strategy
	});
	let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
	let statefulPlacement = placement;
	let middlewareData = {};
	let resetCount = 0;
	for (let i = 0; i < validMiddleware.length; i++) {
		const { name, fn } = validMiddleware[i];
		const { x: nextX, y: nextY, data, reset } = await fn({
			x,
			y,
			initialPlacement: placement,
			placement: statefulPlacement,
			strategy,
			middlewareData,
			rects,
			platform,
			elements: {
				reference,
				floating
			}
		});
		x = nextX != null ? nextX : x;
		y = nextY != null ? nextY : y;
		middlewareData = {
			...middlewareData,
			[name]: {
				...middlewareData[name],
				...data
			}
		};
		if (reset && resetCount <= 50) {
			resetCount++;
			if (typeof reset === "object") {
				if (reset.placement) statefulPlacement = reset.placement;
				if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
					reference,
					floating,
					strategy
				}) : reset.rects;
				({x, y} = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
			}
			i = -1;
			continue;
		}
	}
	return {
		x,
		y,
		placement: statefulPlacement,
		strategy,
		middlewareData
	};
};
/**
* Resolves with an object of overflow side offsets that determine how much the
* element is overflowing a given clipping boundary on each side.
* - positive = overflowing the boundary by that number of pixels
* - negative = how many pixels left before it will overflow
* - 0 = lies flush with the boundary
* @see https://floating-ui.com/docs/detectOverflow
*/
async function detectOverflow(state, options) {
	var _await$platform$isEle;
	if (options === void 0) options = {};
	const { x, y, platform, rects, elements, strategy } = state;
	const { boundary = "clippingAncestors", rootBoundary = "viewport", elementContext = "floating", altBoundary = false, padding = 0 } = evaluate(options, state);
	const paddingObject = getPaddingObject(padding);
	const element = elements[altBoundary ? elementContext === "floating" ? "reference" : "floating" : elementContext];
	const clippingClientRect = rectToClientRect(await platform.getClippingRect({
		element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
		boundary,
		rootBoundary,
		strategy
	}));
	const rect = elementContext === "floating" ? {
		...rects.floating,
		x,
		y
	} : rects.reference;
	const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
	const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
		x: 1,
		y: 1
	} : {
		x: 1,
		y: 1
	};
	const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
		rect,
		offsetParent,
		strategy
	}) : rect);
	return {
		top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
		bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
		left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
		right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
	};
}
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* @see https://floating-ui.com/docs/arrow
*/
var arrow$1 = (options) => ({
	name: "arrow",
	options,
	async fn(state) {
		const { x, y, placement, rects, platform, elements, middlewareData } = state;
		const { element, padding = 0 } = evaluate(options, state) || {};
		if (element == null) return {};
		const paddingObject = getPaddingObject(padding);
		const coords = {
			x,
			y
		};
		const axis = getAlignmentAxis(placement);
		const length = getAxisLength(axis);
		const arrowDimensions = await platform.getDimensions(element);
		const isYAxis = axis === "y";
		const minProp = isYAxis ? "top" : "left";
		const maxProp = isYAxis ? "bottom" : "right";
		const clientProp = isYAxis ? "clientHeight" : "clientWidth";
		const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
		const startDiff = coords[axis] - rects.reference[axis];
		const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
		let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
		if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
		const centerToReference = endDiff / 2 - startDiff / 2;
		const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
		const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
		const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);
		const min$1$1 = minPadding;
		const max = clientSize - arrowDimensions[length] - maxPadding;
		const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
		const offset = clamp(min$1$1, center, max);
		const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
		const alignmentOffset = shouldAddOffset ? center < min$1$1 ? center - min$1$1 : center - max : 0;
		return {
			[axis]: coords[axis] + alignmentOffset,
			data: {
				[axis]: offset,
				centerOffset: center - offset - alignmentOffset,
				...shouldAddOffset && { alignmentOffset }
			},
			reset: shouldAddOffset
		};
	}
});
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/
var flip$1 = function(options) {
	if (options === void 0) options = {};
	return {
		name: "flip",
		options,
		async fn(state) {
			var _middlewareData$arrow, _middlewareData$flip;
			const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
			const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = "bestFit", fallbackAxisSideDirection = "none", flipAlignment = true, ...detectOverflowOptions } = evaluate(options, state);
			if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
			const side = getSide(placement);
			const isBasePlacement = getSide(initialPlacement) === initialPlacement;
			const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
			const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
			if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
			const placements = [initialPlacement, ...fallbackPlacements];
			const overflow = await detectOverflow(state, detectOverflowOptions);
			const overflows = [];
			let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
			if (checkMainAxis) overflows.push(overflow[side]);
			if (checkCrossAxis) {
				const sides = getAlignmentSides(placement, rects, rtl);
				overflows.push(overflow[sides[0]], overflow[sides[1]]);
			}
			overflowsData = [...overflowsData, {
				placement,
				overflows
			}];
			if (!overflows.every((side) => side <= 0)) {
				var _middlewareData$flip2, _overflowsData$filter;
				const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
				const nextPlacement = placements[nextIndex];
				if (nextPlacement) return {
					data: {
						index: nextIndex,
						overflows: overflowsData
					},
					reset: { placement: nextPlacement }
				};
				let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
				if (!resetPlacement) switch (fallbackStrategy) {
					case "bestFit": {
						var _overflowsData$map$so;
						const placement = (_overflowsData$map$so = overflowsData.map((d) => [d.placement, d.overflows.filter((overflow) => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
						if (placement) resetPlacement = placement;
						break;
					}
					case "initialPlacement": resetPlacement = initialPlacement;
				}
				if (placement !== resetPlacement) return { reset: { placement: resetPlacement } };
			}
			return {};
		}
	};
};
async function convertValueToCoords(state, options) {
	const { placement, platform, elements } = state;
	const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
	const side = getSide(placement);
	const alignment = getAlignment(placement);
	const isVertical = getSideAxis(placement) === "y";
	const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
	const crossAxisMulti = rtl && isVertical ? -1 : 1;
	const rawValue = evaluate(options, state);
	let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === "number" ? {
		mainAxis: rawValue,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: 0,
		crossAxis: 0,
		alignmentAxis: null,
		...rawValue
	};
	if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
	return isVertical ? {
		x: crossAxis * crossAxisMulti,
		y: mainAxis * mainAxisMulti
	} : {
		x: mainAxis * mainAxisMulti,
		y: crossAxis * crossAxisMulti
	};
}
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/
var offset = function(options) {
	if (options === void 0) options = 0;
	return {
		name: "offset",
		options,
		async fn(state) {
			var _middlewareData$offse, _middlewareData$arrow;
			const { x, y, placement, middlewareData } = state;
			const diffCoords = await convertValueToCoords(state, options);
			if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
			return {
				x: x + diffCoords.x,
				y: y + diffCoords.y,
				data: {
					...diffCoords,
					placement
				}
			};
		}
	};
};
/**
* Optimizes the visibility of the floating element by shifting it in order to
* keep it in view when it will overflow the clipping boundary.
* @see https://floating-ui.com/docs/shift
*/
var shift$1 = function(options) {
	if (options === void 0) options = {};
	return {
		name: "shift",
		options,
		async fn(state) {
			const { x, y, placement } = state;
			const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = { fn: (_ref) => {
				let { x, y } = _ref;
				return {
					x,
					y
				};
			} }, ...detectOverflowOptions } = evaluate(options, state);
			const coords = {
				x,
				y
			};
			const overflow = await detectOverflow(state, detectOverflowOptions);
			const crossAxis = getSideAxis(getSide(placement));
			const mainAxis = getOppositeAxis(crossAxis);
			let mainAxisCoord = coords[mainAxis];
			let crossAxisCoord = coords[crossAxis];
			if (checkMainAxis) {
				const minSide = mainAxis === "y" ? "top" : "left";
				const maxSide = mainAxis === "y" ? "bottom" : "right";
				const min = mainAxisCoord + overflow[minSide];
				const max = mainAxisCoord - overflow[maxSide];
				mainAxisCoord = clamp(min, mainAxisCoord, max);
			}
			if (checkCrossAxis) {
				const minSide = crossAxis === "y" ? "top" : "left";
				const maxSide = crossAxis === "y" ? "bottom" : "right";
				const min = crossAxisCoord + overflow[minSide];
				const max = crossAxisCoord - overflow[maxSide];
				crossAxisCoord = clamp(min, crossAxisCoord, max);
			}
			const limitedCoords = limiter.fn({
				...state,
				[mainAxis]: mainAxisCoord,
				[crossAxis]: crossAxisCoord
			});
			return {
				...limitedCoords,
				data: {
					x: limitedCoords.x - x,
					y: limitedCoords.y - y
				}
			};
		}
	};
};
/**
* Provides data that allows you to change the size of the floating element —
* for instance, prevent it from overflowing the clipping boundary or match the
* width of the reference element.
* @see https://floating-ui.com/docs/size
*/
var size$1 = function(options) {
	if (options === void 0) options = {};
	return {
		name: "size",
		options,
		async fn(state) {
			const { placement, rects, platform, elements } = state;
			const { apply = () => {}, ...detectOverflowOptions } = evaluate(options, state);
			const overflow = await detectOverflow(state, detectOverflowOptions);
			const side = getSide(placement);
			const alignment = getAlignment(placement);
			const isYAxis = getSideAxis(placement) === "y";
			const { width, height } = rects.floating;
			let heightSide;
			let widthSide;
			if (side === "top" || side === "bottom") {
				heightSide = side;
				widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
			} else {
				widthSide = side;
				heightSide = alignment === "end" ? "top" : "bottom";
			}
			const overflowAvailableHeight = height - overflow[heightSide];
			const overflowAvailableWidth = width - overflow[widthSide];
			const noShift = !state.middlewareData.shift;
			let availableHeight = overflowAvailableHeight;
			let availableWidth = overflowAvailableWidth;
			if (isYAxis) {
				const maximumClippingWidth = width - overflow.left - overflow.right;
				availableWidth = alignment || noShift ? min$1(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
			} else {
				const maximumClippingHeight = height - overflow.top - overflow.bottom;
				availableHeight = alignment || noShift ? min$1(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
			}
			if (noShift && !alignment) {
				const xMin = max$1(overflow.left, 0);
				const xMax = max$1(overflow.right, 0);
				const yMin = max$1(overflow.top, 0);
				const yMax = max$1(overflow.bottom, 0);
				if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right));
				else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow.top, overflow.bottom));
			}
			await apply({
				...state,
				availableWidth,
				availableHeight
			});
			const nextDimensions = await platform.getDimensions(elements.floating);
			if (width !== nextDimensions.width || height !== nextDimensions.height) return { reset: { rects: true } };
			return {};
		}
	};
};
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function getNodeName(node) {
	if (isNode$1(node)) return (node.nodeName || "").toLowerCase();
	return "#document";
}
function getWindow$1(node) {
	var _node$ownerDocument;
	return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
	var _ref;
	return (_ref = (isNode$1(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode$1(value) {
	return value instanceof Node || value instanceof getWindow$1(value).Node;
}
function isElement(value) {
	return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function isHTMLElement$1(value) {
	return value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement;
}
function isShadowRoot(value) {
	if (typeof ShadowRoot === "undefined") return false;
	return value instanceof ShadowRoot || value instanceof getWindow$1(value).ShadowRoot;
}
function isOverflowElement(element) {
	const { overflow, overflowX, overflowY, display } = getComputedStyle$1(element);
	return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
	return [
		"table",
		"td",
		"th"
	].includes(getNodeName(element));
}
function isContainingBlock(element) {
	const webkit = isWebKit();
	const css = getComputedStyle$1(element);
	return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
		"transform",
		"perspective",
		"filter"
	].some((value) => (css.willChange || "").includes(value)) || [
		"paint",
		"layout",
		"strict",
		"content"
	].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
	let currentNode = getParentNode(element);
	while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) if (isContainingBlock(currentNode)) return currentNode;
	else currentNode = getParentNode(currentNode);
	return null;
}
function isWebKit() {
	if (typeof CSS === "undefined" || !CSS.supports) return false;
	return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
	return [
		"html",
		"body",
		"#document"
	].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
	return getWindow$1(element).getComputedStyle(element);
}
function getNodeScroll(element) {
	if (isElement(element)) return {
		scrollLeft: element.scrollLeft,
		scrollTop: element.scrollTop
	};
	return {
		scrollLeft: element.pageXOffset,
		scrollTop: element.pageYOffset
	};
}
function getParentNode(node) {
	if (getNodeName(node) === "html") return node;
	const result = node.assignedSlot || node.parentNode || isShadowRoot(node) && node.host || getDocumentElement(node);
	return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
	const parentNode = getParentNode(node);
	if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
	if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) return parentNode;
	return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
	var _node$ownerDocument2;
	if (list === void 0) list = [];
	if (traverseIframes === void 0) traverseIframes = true;
	const scrollableAncestor = getNearestOverflowAncestor(node);
	const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
	const win = getWindow$1(scrollableAncestor);
	if (isBody) return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
	return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
//#endregion
//#region ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
	const css = getComputedStyle$1(element);
	let width = parseFloat(css.width) || 0;
	let height = parseFloat(css.height) || 0;
	const hasOffset = isHTMLElement$1(element);
	const offsetWidth = hasOffset ? element.offsetWidth : width;
	const offsetHeight = hasOffset ? element.offsetHeight : height;
	const shouldFallback = round$1(width) !== offsetWidth || round$1(height) !== offsetHeight;
	if (shouldFallback) {
		width = offsetWidth;
		height = offsetHeight;
	}
	return {
		width,
		height,
		$: shouldFallback
	};
}
function unwrapElement(element) {
	return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
	const domElement = unwrapElement(element);
	if (!isHTMLElement$1(domElement)) return createCoords(1);
	const rect = domElement.getBoundingClientRect();
	const { width, height, $ } = getCssDimensions(domElement);
	let x = ($ ? round$1(rect.width) : rect.width) / width;
	let y = ($ ? round$1(rect.height) : rect.height) / height;
	if (!x || !Number.isFinite(x)) x = 1;
	if (!y || !Number.isFinite(y)) y = 1;
	return {
		x,
		y
	};
}
var noOffsets = /*#__PURE__*/ createCoords(0);
function getVisualOffsets(element) {
	const win = getWindow$1(element);
	if (!isWebKit() || !win.visualViewport) return noOffsets;
	return {
		x: win.visualViewport.offsetLeft,
		y: win.visualViewport.offsetTop
	};
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
	if (isFixed === void 0) isFixed = false;
	if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$1(element)) return false;
	return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
	if (includeScale === void 0) includeScale = false;
	if (isFixedStrategy === void 0) isFixedStrategy = false;
	const clientRect = element.getBoundingClientRect();
	const domElement = unwrapElement(element);
	let scale = createCoords(1);
	if (includeScale) {
		if (offsetParent) {
			if (isElement(offsetParent)) scale = getScale(offsetParent);
		} else scale = getScale(element);
	}
	const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
	let x = (clientRect.left + visualOffsets.x) / scale.x;
	let y = (clientRect.top + visualOffsets.y) / scale.y;
	let width = clientRect.width / scale.x;
	let height = clientRect.height / scale.y;
	if (domElement) {
		const win = getWindow$1(domElement);
		const offsetWin = offsetParent && isElement(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
		let currentIFrame = win.frameElement;
		while (currentIFrame && offsetParent && offsetWin !== win) {
			const iframeScale = getScale(currentIFrame);
			const iframeRect = currentIFrame.getBoundingClientRect();
			const css = getComputedStyle$1(currentIFrame);
			const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
			const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
			x *= iframeScale.x;
			y *= iframeScale.y;
			width *= iframeScale.x;
			height *= iframeScale.y;
			x += left;
			y += top;
			currentIFrame = getWindow$1(currentIFrame).frameElement;
		}
	}
	return rectToClientRect({
		width,
		height,
		x,
		y
	});
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
	let { rect, offsetParent, strategy } = _ref;
	const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
	const documentElement = getDocumentElement(offsetParent);
	if (offsetParent === documentElement) return rect;
	let scroll = {
		scrollLeft: 0,
		scrollTop: 0
	};
	let scale = createCoords(1);
	const offsets = createCoords(0);
	if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
		if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
		if (isHTMLElement$1(offsetParent)) {
			const offsetRect = getBoundingClientRect(offsetParent);
			scale = getScale(offsetParent);
			offsets.x = offsetRect.x + offsetParent.clientLeft;
			offsets.y = offsetRect.y + offsetParent.clientTop;
		}
	}
	return {
		width: rect.width * scale.x,
		height: rect.height * scale.y,
		x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
		y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
	};
}
function getClientRects(element) {
	return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
	return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
	const html = getDocumentElement(element);
	const scroll = getNodeScroll(element);
	const body = element.ownerDocument.body;
	const width = max$1(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
	const height = max$1(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
	let x = -scroll.scrollLeft + getWindowScrollBarX(element);
	const y = -scroll.scrollTop;
	if (getComputedStyle$1(body).direction === "rtl") x += max$1(html.clientWidth, body.clientWidth) - width;
	return {
		width,
		height,
		x,
		y
	};
}
function getViewportRect(element, strategy) {
	const win = getWindow$1(element);
	const html = getDocumentElement(element);
	const visualViewport = win.visualViewport;
	let width = html.clientWidth;
	let height = html.clientHeight;
	let x = 0;
	let y = 0;
	if (visualViewport) {
		width = visualViewport.width;
		height = visualViewport.height;
		const visualViewportBased = isWebKit();
		if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
			x = visualViewport.offsetLeft;
			y = visualViewport.offsetTop;
		}
	}
	return {
		width,
		height,
		x,
		y
	};
}
function getInnerBoundingClientRect(element, strategy) {
	const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
	const top = clientRect.top + element.clientTop;
	const left = clientRect.left + element.clientLeft;
	const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
	return {
		width: element.clientWidth * scale.x,
		height: element.clientHeight * scale.y,
		x: left * scale.x,
		y: top * scale.y
	};
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
	let rect;
	if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
	else if (clippingAncestor === "document") rect = getDocumentRect(getDocumentElement(element));
	else if (isElement(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
	else {
		const visualOffsets = getVisualOffsets(element);
		rect = {
			...clippingAncestor,
			x: clippingAncestor.x - visualOffsets.x,
			y: clippingAncestor.y - visualOffsets.y
		};
	}
	return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
	const parentNode = getParentNode(element);
	if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) return false;
	return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
	const cachedResult = cache.get(element);
	if (cachedResult) return cachedResult;
	let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
	let currentContainingBlockComputedStyle = null;
	const elementIsFixed = getComputedStyle$1(element).position === "fixed";
	let currentNode = elementIsFixed ? getParentNode(element) : element;
	while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
		const computedStyle = getComputedStyle$1(currentNode);
		const currentNodeIsContaining = isContainingBlock(currentNode);
		if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
		if (elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode)) result = result.filter((ancestor) => ancestor !== currentNode);
		else currentContainingBlockComputedStyle = computedStyle;
		currentNode = getParentNode(currentNode);
	}
	cache.set(element, result);
	return result;
}
function getClippingRect(_ref) {
	let { element, boundary, rootBoundary, strategy } = _ref;
	const clippingAncestors = [...boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary), rootBoundary];
	const firstClippingAncestor = clippingAncestors[0];
	const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
		const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
		accRect.top = max$1(rect.top, accRect.top);
		accRect.right = min$1(rect.right, accRect.right);
		accRect.bottom = min$1(rect.bottom, accRect.bottom);
		accRect.left = max$1(rect.left, accRect.left);
		return accRect;
	}, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
	return {
		width: clippingRect.right - clippingRect.left,
		height: clippingRect.bottom - clippingRect.top,
		x: clippingRect.left,
		y: clippingRect.top
	};
}
function getDimensions(element) {
	const { width, height } = getCssDimensions(element);
	return {
		width,
		height
	};
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
	const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
	const documentElement = getDocumentElement(offsetParent);
	const isFixed = strategy === "fixed";
	const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
	let scroll = {
		scrollLeft: 0,
		scrollTop: 0
	};
	const offsets = createCoords(0);
	if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
		if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
		if (isOffsetParentAnElement) {
			const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
			offsets.x = offsetRect.x + offsetParent.clientLeft;
			offsets.y = offsetRect.y + offsetParent.clientTop;
		} else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
	}
	return {
		x: rect.left + scroll.scrollLeft - offsets.x,
		y: rect.top + scroll.scrollTop - offsets.y,
		width: rect.width,
		height: rect.height
	};
}
function getTrueOffsetParent(element, polyfill) {
	if (!isHTMLElement$1(element) || getComputedStyle$1(element).position === "fixed") return null;
	if (polyfill) return polyfill(element);
	return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
	const window = getWindow$1(element);
	if (!isHTMLElement$1(element)) return window;
	let offsetParent = getTrueOffsetParent(element, polyfill);
	while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") offsetParent = getTrueOffsetParent(offsetParent, polyfill);
	if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static" && !isContainingBlock(offsetParent))) return window;
	return offsetParent || getContainingBlock(element) || window;
}
var getElementRects = async function(_ref) {
	let { reference, floating, strategy } = _ref;
	const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
	const getDimensionsFn = this.getDimensions;
	return {
		reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
		floating: {
			x: 0,
			y: 0,
			...await getDimensionsFn(floating)
		}
	};
};
function isRTL(element) {
	return getComputedStyle$1(element).direction === "rtl";
}
var platform = {
	convertOffsetParentRelativeRectToViewportRelativeRect,
	getDocumentElement,
	getClippingRect,
	getOffsetParent,
	getElementRects,
	getClientRects,
	getDimensions,
	getScale,
	isElement,
	isRTL
};
function observeMove(element, onMove) {
	let io = null;
	let timeoutId;
	const root = getDocumentElement(element);
	function cleanup() {
		clearTimeout(timeoutId);
		io && io.disconnect();
		io = null;
	}
	function refresh(skip, threshold) {
		if (skip === void 0) skip = false;
		if (threshold === void 0) threshold = 1;
		cleanup();
		const { left, top, width, height } = element.getBoundingClientRect();
		if (!skip) onMove();
		if (!width || !height) return;
		const insetTop = floor$1(top);
		const insetRight = floor$1(root.clientWidth - (left + width));
		const insetBottom = floor$1(root.clientHeight - (top + height));
		const insetLeft = floor$1(left);
		const options = {
			rootMargin: -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px",
			threshold: max$1(0, min$1(1, threshold)) || 1
		};
		let isFirstUpdate = true;
		function handleObserve(entries) {
			const ratio = entries[0].intersectionRatio;
			if (ratio !== threshold) {
				if (!isFirstUpdate) return refresh();
				if (!ratio) timeoutId = setTimeout(() => {
					refresh(false, 1e-7);
				}, 100);
				else refresh(false, ratio);
			}
			isFirstUpdate = false;
		}
		try {
			io = new IntersectionObserver(handleObserve, {
				...options,
				root: root.ownerDocument
			});
		} catch (e) {
			io = new IntersectionObserver(handleObserve, options);
		}
		io.observe(element);
	}
	refresh(true);
	return cleanup;
}
/**
* Automatically updates the position of the floating element when necessary.
* Should only be called when the floating element is mounted on the DOM or
* visible on the screen.
* @returns cleanup function that should be invoked when the floating element is
* removed from the DOM or hidden from the screen.
* @see https://floating-ui.com/docs/autoUpdate
*/
function autoUpdate(reference, floating, update, options) {
	if (options === void 0) options = {};
	const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === "function", layoutShift = typeof IntersectionObserver === "function", animationFrame = false } = options;
	const referenceEl = unwrapElement(reference);
	const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
	ancestors.forEach((ancestor) => {
		ancestorScroll && ancestor.addEventListener("scroll", update, { passive: true });
		ancestorResize && ancestor.addEventListener("resize", update);
	});
	const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
	let reobserveFrame = -1;
	let resizeObserver = null;
	if (elementResize) {
		resizeObserver = new ResizeObserver((_ref) => {
			let [firstEntry] = _ref;
			if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
				resizeObserver.unobserve(floating);
				cancelAnimationFrame(reobserveFrame);
				reobserveFrame = requestAnimationFrame(() => {
					resizeObserver && resizeObserver.observe(floating);
				});
			}
			update();
		});
		if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
		resizeObserver.observe(floating);
	}
	let frameId;
	let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
	if (animationFrame) frameLoop();
	function frameLoop() {
		const nextRefRect = getBoundingClientRect(reference);
		if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
		prevRefRect = nextRefRect;
		frameId = requestAnimationFrame(frameLoop);
	}
	update();
	return () => {
		ancestors.forEach((ancestor) => {
			ancestorScroll && ancestor.removeEventListener("scroll", update);
			ancestorResize && ancestor.removeEventListener("resize", update);
		});
		cleanupIo && cleanupIo();
		resizeObserver && resizeObserver.disconnect();
		resizeObserver = null;
		if (animationFrame) cancelAnimationFrame(frameId);
	};
}
/**
* Optimizes the visibility of the floating element by shifting it in order to
* keep it in view when it will overflow the clipping boundary.
* @see https://floating-ui.com/docs/shift
*/
var shift = shift$1;
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/
var flip = flip$1;
/**
* Provides data that allows you to change the size of the floating element —
* for instance, prevent it from overflowing the clipping boundary or match the
* width of the reference element.
* @see https://floating-ui.com/docs/size
*/
var size = size$1;
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* @see https://floating-ui.com/docs/arrow
*/
var arrow = arrow$1;
/**
* Computes the `x` and `y` coordinates that will place the floating element
* next to a given reference element.
*/
var computePosition = (reference, floating, options) => {
	const cache = /* @__PURE__ */ new Map();
	const mergedOptions = {
		platform,
		...options
	};
	const platformWithCache = {
		...mergedOptions.platform,
		_c: cache
	};
	return computePosition$1(reference, floating, {
		...mergedOptions,
		platform: platformWithCache
	});
};
//#endregion
//#region ../../node_modules/ariakit/esm/disclosure/disclosure-state.js
/**
* Provides state for the `Disclosure` components.
* @example
* ```jsx
* const disclosure = useDisclosureState();
* <Disclosure state={disclosure}>Disclosure</Disclosure>
* <DisclosureContent state={disclosure}>Content</DisclosureContent>
* ```
*/
function useDisclosureState(_temp) {
	var _props$defaultOpen;
	let { animated = false, ...props } = _temp === void 0 ? {} : _temp;
	const disclosureRef = useRef(null);
	const [open, setOpen] = useControlledState((_props$defaultOpen = props.defaultOpen) != null ? _props$defaultOpen : false, props.open, props.setOpen);
	const [contentElement, setContentElement] = useState(null);
	const [animating, setAnimating] = useState(!!animated && open);
	const prevOpen = usePreviousValue(open);
	const mounted = open || animating;
	if (animated && !animating && prevOpen !== open) setAnimating(true);
	const show = useCallback(() => setOpen(true), [setOpen]);
	const hide = useCallback(() => setOpen(false), [setOpen]);
	const toggle = useCallback(() => setOpen((v) => !v), [setOpen]);
	const stopAnimation = useCallback(() => setAnimating(false), []);
	return useMemo(() => ({
		disclosureRef,
		open,
		mounted,
		animated,
		animating,
		contentElement,
		setContentElement,
		setOpen,
		show,
		hide,
		toggle,
		stopAnimation
	}), [
		open,
		mounted,
		animated,
		animating,
		contentElement,
		setContentElement,
		setOpen,
		show,
		hide,
		toggle,
		stopAnimation
	]);
}
//#endregion
//#region ../../node_modules/ariakit/esm/dialog/dialog-state.js
/**
* Provides state for the `Dialog` components.
* @example
* ```jsx
* const dialog = useDialogState();
* <button onClick={dialog.toggle}>Open dialog</button>
* <Dialog state={dialog}>Content</Dialog>
* ```
*/
function useDialogState(props) {
	if (props === void 0) props = {};
	return useDisclosureState(props);
}
//#endregion
//#region ../../node_modules/ariakit/esm/popover/popover-state.js
var middlewares = {
	arrow,
	flip,
	offset,
	shift,
	size
};
function createDOMRect(x, y, width, height) {
	if (x === void 0) x = 0;
	if (y === void 0) y = 0;
	if (width === void 0) width = 0;
	if (height === void 0) height = 0;
	if (typeof DOMRect === "function") return new DOMRect(x, y, width, height);
	const rect = {
		x,
		y,
		width,
		height,
		top: y,
		right: x + width,
		bottom: y + height,
		left: x
	};
	return {
		...rect,
		toJSON: () => rect
	};
}
function getDOMRect(anchorRect) {
	if (!anchorRect) return createDOMRect();
	const { x, y, width, height } = anchorRect;
	return createDOMRect(x, y, width, height);
}
function getAnchorElement(anchorRef, getAnchorRect) {
	return {
		contextElement: anchorRef.current || void 0,
		getBoundingClientRect: () => {
			const anchor = anchorRef.current;
			const anchorRect = getAnchorRect(anchor);
			if (anchorRect || !anchor) return getDOMRect(anchorRect);
			return anchor.getBoundingClientRect();
		}
	};
}
function isValidPlacement(flip) {
	return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(flip);
}
/**
* Provides state for the `Popover` components.
* @example
* ```jsx
* const popover = usePopoverState();
* <PopoverDisclosure state={popover}>Disclosure</PopoverDisclosure>
* <Popover state={popover}>Popover</Popover>
* ```
*/
function usePopoverState(_temp) {
	let { placement = "bottom", fixed = false, gutter, flip = true, shift = 0, slide = true, overlap = false, sameWidth = false, fitViewport = false, arrowPadding = 4, overflowPadding = 8, renderCallback, ...props } = _temp === void 0 ? {} : _temp;
	const dialog = useDialogState(props);
	const defaultGetAnchorRect = (anchor) => (anchor == null ? void 0 : anchor.getBoundingClientRect()) || null;
	const getAnchorRect = useEvent$1(props.getAnchorRect || defaultGetAnchorRect);
	const anchorRef = useRef(null);
	const popoverRef = useRef(null);
	const arrowRef = useRef(null);
	const [currentPlacement, setCurrentPlacement] = useState(placement);
	const [rendered, render] = useForceUpdate$1();
	useSafeLayoutEffect(() => {
		var _dialog$contentElemen;
		if (!((_dialog$contentElemen = dialog.contentElement) != null && _dialog$contentElemen.isConnected)) return;
		const popover = popoverRef.current;
		if (!popover) return;
		const anchor = getAnchorElement(anchorRef, getAnchorRect);
		const arrow = arrowRef.current;
		const arrowOffset = ((arrow == null ? void 0 : arrow.clientHeight) || 0) / 2;
		const finalGutter = typeof gutter === "number" ? gutter + arrowOffset : gutter != null ? gutter : arrowOffset;
		popover.style.setProperty("--popover-overflow-padding", overflowPadding + "px");
		const defaultRenderCallback = () => {
			const update = async () => {
				if (!dialog.mounted) return;
				const middleware = [middlewares.offset((_ref) => {
					let { placement } = _ref;
					return {
						crossAxis: !!!placement.split("-")[1] ? shift : void 0,
						mainAxis: finalGutter,
						alignmentAxis: shift
					};
				})];
				if (flip !== false) {
					const fallbackPlacements = typeof flip === "string" ? flip.split(" ") : void 0;
					if (fallbackPlacements !== void 0 && !fallbackPlacements.every(isValidPlacement)) throw new Error("`flip` expects a spaced-delimited list of placements");
					middleware.push(middlewares.flip({
						padding: overflowPadding,
						fallbackPlacements
					}));
				}
				if (slide || overlap) middleware.push(middlewares.shift({
					mainAxis: slide,
					crossAxis: overlap,
					padding: overflowPadding
				}));
				middleware.push(middlewares.size({
					padding: overflowPadding,
					apply(_ref2) {
						let { availableWidth, availableHeight, rects } = _ref2;
						const referenceWidth = Math.round(rects.reference.width);
						availableWidth = Math.floor(availableWidth);
						availableHeight = Math.floor(availableHeight);
						popover.style.setProperty("--popover-anchor-width", referenceWidth + "px");
						popover.style.setProperty("--popover-available-width", availableWidth + "px");
						popover.style.setProperty("--popover-available-height", availableHeight + "px");
						if (sameWidth) popover.style.width = referenceWidth + "px";
						if (fitViewport) {
							popover.style.maxWidth = availableWidth + "px";
							popover.style.maxHeight = availableHeight + "px";
						}
					}
				}));
				if (arrow) middleware.push(middlewares.arrow({
					element: arrow,
					padding: arrowPadding
				}));
				const pos = await computePosition(anchor, popover, {
					placement,
					strategy: fixed ? "fixed" : "absolute",
					middleware
				});
				flushSync(() => {
					setCurrentPlacement(pos.placement);
				});
				const x = Math.round(pos.x);
				const y = Math.round(pos.y);
				Object.assign(popover.style, {
					top: "0",
					left: "0",
					transform: "translate3d(" + x + "px, " + y + "px, 0)"
				});
				if (arrow && pos.middlewareData.arrow) {
					const { x: arrowX, y: arrowY } = pos.middlewareData.arrow;
					const dir = pos.placement.split("-")[0];
					Object.assign(arrow.style, {
						left: arrowX != null ? arrowX + "px" : "",
						top: arrowY != null ? arrowY + "px" : "",
						[dir]: "100%"
					});
				}
			};
			return autoUpdate(anchor, popover, update, { elementResize: typeof ResizeObserver === "function" });
		};
		if (renderCallback) return renderCallback({
			mounted: dialog.mounted,
			placement,
			fixed,
			gutter: finalGutter,
			shift,
			overlap,
			flip,
			sameWidth,
			fitViewport,
			arrowPadding,
			overflowPadding,
			popover,
			anchor,
			arrow,
			setPlacement: setCurrentPlacement,
			defaultRenderCallback
		});
		return defaultRenderCallback();
	}, [
		rendered,
		dialog.contentElement,
		getAnchorRect,
		gutter,
		dialog.mounted,
		shift,
		overlap,
		flip,
		overflowPadding,
		slide,
		sameWidth,
		fitViewport,
		arrowPadding,
		placement,
		fixed,
		renderCallback
	]);
	return useMemo(() => ({
		...dialog,
		getAnchorRect,
		anchorRef,
		popoverRef,
		arrowRef,
		currentPlacement,
		placement,
		fixed,
		gutter,
		shift,
		flip,
		slide,
		overlap,
		sameWidth,
		fitViewport,
		arrowPadding,
		overflowPadding,
		render,
		renderCallback
	}), [
		dialog,
		getAnchorRect,
		currentPlacement,
		placement,
		fixed,
		gutter,
		shift,
		flip,
		slide,
		overlap,
		sameWidth,
		fitViewport,
		arrowPadding,
		overflowPadding,
		render,
		renderCallback
	]);
}
//#endregion
//#region ../../node_modules/ariakit/esm/composite/composite.js
function isGrid(items) {
	return items.some((item) => !!item.rowId);
}
function isPrintableKey(event) {
	return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey(event) {
	return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function canProxyKeyboardEvent(event, state) {
	if (!isSelfTarget(event)) return false;
	if (isModifierKey(event)) return false;
	const target = event.target;
	if (!target) return true;
	if (isTextField(target)) {
		if (isPrintableKey(event)) return false;
		const grid = isGrid(state.items);
		const focusingInputOnly = state.activeId === null;
		const allowHorizontalNavigationOnItems = grid && !focusingInputOnly;
		const isHomeOrEnd = event.key === "Home" || event.key === "End";
		if (!allowHorizontalNavigationOnItems && isHomeOrEnd) return false;
	}
	return !event.isPropagationStopped();
}
function useKeyboardEventProxy(state, activeItem, onKeyboardEvent, previousElementRef) {
	return useEvent$1((event) => {
		onKeyboardEvent?.(event);
		if (event.defaultPrevented) return;
		const activeElement = activeItem == null ? void 0 : activeItem.ref.current;
		if (!activeElement) return;
		if (!canProxyKeyboardEvent(event, state)) return;
		const { view, ...eventInit } = event;
		if (activeElement !== (previousElementRef == null ? void 0 : previousElementRef.current)) activeElement.focus();
		if (!fireKeyboardEvent(activeElement, event.type, eventInit)) event.preventDefault();
		if (event.currentTarget.contains(activeElement)) event.stopPropagation();
	});
}
function findFirstEnabledItemInTheLastRow(items) {
	return findFirstEnabledItem(flatten2DArray(reverseArray(groupItemsByRows(items))));
}
function useScheduleFocus(activeItem) {
	const [scheduled, setScheduled] = useState(false);
	const schedule = useCallback(() => setScheduled(true), []);
	useEffect(() => {
		const activeElement = activeItem == null ? void 0 : activeItem.ref.current;
		if (scheduled && activeElement) {
			setScheduled(false);
			focusIntoView(activeElement);
		}
	}, [activeItem, scheduled]);
	return schedule;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a composite widget.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const state = useCompositeState();
* const props = useComposite({ state });
* <Role {...props}>
*   <CompositeItem>Item 1</CompositeItem>
*   <CompositeItem>Item 2</CompositeItem>
* </Role>
* ```
*/
var useComposite = createHook((_ref) => {
	let { state, composite = true, focusOnMove = composite, moveOnKeyPress = true, ...props } = _ref;
	const ref = useRef(null);
	const virtualFocus = composite && state.virtualFocus;
	const activeItem = useMemo(() => findEnabledItemById(state.items, state.activeId), [state.items, state.activeId]);
	const activeItemRef = useLiveRef(activeItem);
	const previousElementRef = useRef(null);
	const isSelfAciveRef = useLiveRef(state.activeId === null);
	const scheduleFocus = useScheduleFocus(activeItem);
	useSafeLayoutEffect(() => {
		var _activeItemRef$curren;
		if (!composite) return;
		if (!focusOnMove) return;
		if (!state.moves) return;
		if (!((_activeItemRef$curren = activeItemRef.current) == null ? void 0 : _activeItemRef$curren.ref.current)) return;
		scheduleFocus();
	}, [
		composite,
		focusOnMove,
		state.moves
	]);
	useSafeLayoutEffect(() => {
		if (!composite) return;
		if (!state.moves) return;
		if (!isSelfAciveRef.current) return;
		const element = ref.current;
		if (!element) return;
		const previousElement = previousElementRef.current;
		previousElementRef.current = null;
		if (previousElement) fireBlurEvent(previousElement, { relatedTarget: element });
		if (hasFocus(element)) fireFocusEvent(element, { relatedTarget: previousElement });
		else element.focus();
	}, [composite, state.moves]);
	useSafeLayoutEffect(() => {
		var _activeItemRef$curren2;
		if (!virtualFocus) return;
		if (!composite) return;
		const previousElement = previousElementRef.current;
		previousElementRef.current = null;
		if (!previousElement) return;
		fireBlurEvent(previousElement, { relatedTarget: ((_activeItemRef$curren2 = activeItemRef.current) == null ? void 0 : _activeItemRef$curren2.ref.current) || getActiveElement(previousElement) });
	}, [
		virtualFocus,
		composite,
		state.activeId
	]);
	const onKeyDownCapture = useKeyboardEventProxy(state, activeItem, props.onKeyDownCapture, previousElementRef);
	const onKeyUpCapture = useKeyboardEventProxy(state, activeItem, props.onKeyUpCapture, previousElementRef);
	const onFocusCaptureProp = props.onFocusCapture;
	const onFocusCapture = useEvent$1((event) => {
		onFocusCaptureProp?.(event);
		if (event.defaultPrevented) return;
		if (!virtualFocus) return;
		const previousActiveElement = event.relatedTarget;
		const isSilentlyFocused = silentlyFocused(event.currentTarget);
		if (isSelfTarget(event) && isSilentlyFocused) {
			event.stopPropagation();
			previousElementRef.current = previousActiveElement;
		}
	});
	const onFocusProp = props.onFocus;
	const onFocus = useEvent$1((event) => {
		onFocusProp?.(event);
		if (event.defaultPrevented) return;
		if (!composite) return;
		if (virtualFocus) {
			if (isSelfTarget(event) && !isItem(state.items, event.relatedTarget)) queueMicrotask$1(scheduleFocus);
		} else if (isSelfTarget(event)) state.setActiveId(null);
	});
	const onBlurCaptureProp = props.onBlurCapture;
	const onBlurCapture = useEvent$1((event) => {
		onBlurCaptureProp?.(event);
		if (event.defaultPrevented) return;
		if (!virtualFocus) return;
		const activeElement = (activeItem == null ? void 0 : activeItem.ref.current) || null;
		const nextActiveElement = event.relatedTarget;
		const nextActiveElementIsItem = isItem(state.items, nextActiveElement);
		const previousElement = previousElementRef.current;
		previousElementRef.current = null;
		if (isSelfTarget(event) && nextActiveElementIsItem) {
			if (nextActiveElement === activeElement) {
				if (previousElement && previousElement !== nextActiveElement) fireBlurEvent(previousElement, event);
			} else if (activeElement) fireBlurEvent(activeElement, event);
			event.stopPropagation();
		} else if (!isItem(state.items, event.target) && activeElement) fireBlurEvent(activeElement, event);
	});
	const onKeyDownProp = props.onKeyDown;
	const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (!isSelfTarget(event)) return;
		if (activeItemRef.current) return;
		const isVertical = state.orientation !== "horizontal";
		const isHorizontal = state.orientation !== "vertical";
		const grid = isGrid(state.items);
		const up = () => {
			if (grid) {
				const item = state.items && findFirstEnabledItemInTheLastRow(state.items);
				return item == null ? void 0 : item.id;
			}
			return state.last();
		};
		const action = {
			ArrowUp: (grid || isVertical) && up,
			ArrowRight: (grid || isHorizontal) && state.first,
			ArrowDown: (grid || isVertical) && state.first,
			ArrowLeft: (grid || isHorizontal) && state.last,
			Home: state.first,
			End: state.last,
			PageUp: state.first,
			PageDown: state.last
		}[event.key];
		if (action) {
			const id = action();
			if (id !== void 0) {
				if (!moveOnKeyPressProp(event)) return;
				event.preventDefault();
				state.move(id);
			}
		}
	});
	props = useStoreProvider({
		state,
		...props
	}, CompositeContext);
	const activeId = (activeItem == null ? void 0 : activeItem.id) || void 0;
	props = {
		"aria-activedescendant": virtualFocus ? activeId : void 0,
		...props,
		ref: useForkRef(ref, composite ? state.baseRef : void 0, props.ref),
		onKeyDownCapture,
		onKeyUpCapture,
		onFocusCapture,
		onFocus,
		onBlurCapture,
		onKeyDown
	};
	props = useFocusable({
		focusable: composite && (virtualFocus || state.activeId === null),
		...props
	});
	return props;
});
/**
* A component that renders a composite widget.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const composite = useCompositeState();
* <Composite state={composite}>
*   <CompositeItem>Item 1</CompositeItem>
*   <CompositeItem>Item 2</CompositeItem>
* </Composite>
* ```
*/
var Composite = createComponent((props) => {
	return createElement$1("div", useComposite(props));
});
if (process.env.NODE_ENV !== "production") Composite.displayName = "Composite";
//#endregion
//#region ../../node_modules/ariakit/esm/popover/popover-anchor.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element that will serve as the popover's
* anchor. The popover will be positioned relative to this element.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const state = usePopoverState();
* const props = usePopoverAnchor({ state });
* <Role {...props}>Anchor</Role>
* <Popover state={state}>Popover</Popover>
* ```
*/
var usePopoverAnchor = createHook((_ref) => {
	let { state, ...props } = _ref;
	props = {
		...props,
		ref: useForkRef(state.anchorRef, props.ref)
	};
	return props;
});
/**
* A component that renders an element that will serve as the popover's anchor.
* The popover will be positioned relative to this element.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const popover = usePopoverState();
* <PopoverAnchor state={popover}>Anchor</PopoverAnchor>
* <Popover state={popover}>Popover</Popover>
* ```
*/
var PopoverAnchor = createComponent((props) => {
	return createElement$1("div", usePopoverAnchor(props));
});
if (process.env.NODE_ENV !== "production") PopoverAnchor.displayName = "PopoverAnchor";
//#endregion
//#region ../../node_modules/ariakit/esm/popover/popover-disclosure.js
var usePopoverDisclosure = createHook((_ref) => {
	let { state, ...props } = _ref;
	const onClickProp = props.onClick;
	const onClick = useEvent$1((event) => {
		state.anchorRef.current = event.currentTarget;
		onClickProp?.(event);
	});
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(PopoverContext.Provider, {
		value: state,
		children: element
	}), [state]);
	props = {
		...props,
		onClick
	};
	props = usePopoverAnchor({
		state,
		...props
	});
	props = useDialogDisclosure({
		state,
		...props
	});
	return props;
});
/**
* A component that renders a button that controls the visibility of the popover
* when clicked.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const popover = usePopoverState();
* <PopoverDisclosure state={popover}>Disclosure</PopoverDisclosure>
* <Popover state={popover}>Popover</Popover>
* ```
*/
var PopoverDisclosure = createComponent((props) => {
	return createElement$1("button", usePopoverDisclosure(props));
});
if (process.env.NODE_ENV !== "production") PopoverDisclosure.displayName = "PopoverDisclosure";
//#endregion
//#region ../../node_modules/ariakit/esm/composite/composite-typeahead.js
var chars = "";
function clearChars() {
	chars = "";
}
function isValidTypeaheadEvent(event) {
	const target = event.target;
	if (target && isTextField(target)) return false;
	if (event.key === " " && chars.length) return true;
	return event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey && /^[\p{Letter}\p{Number}]$/u.test(event.key);
}
function isSelfTargetOrItem(event, items) {
	if (isSelfTarget(event)) return true;
	const target = event.target;
	if (!target) return false;
	return items.some((item) => item.ref.current === target);
}
function getEnabledItems(items) {
	return items.filter((item) => !item.disabled);
}
function itemTextStartsWith(item, text) {
	var _item$ref$current;
	const itemText = (_item$ref$current = item.ref.current) == null ? void 0 : _item$ref$current.textContent;
	if (!itemText) return false;
	return normalizeString(itemText).toLowerCase().startsWith(text.toLowerCase());
}
function getSameInitialItems(items, char, activeId) {
	if (!activeId) return items;
	const activeItem = items.find((item) => item.id === activeId);
	if (!activeItem) return items;
	if (!itemTextStartsWith(activeItem, char)) return items;
	if (chars !== char && itemTextStartsWith(activeItem, chars)) return items;
	chars = char;
	return flipItems(items.filter((item) => itemTextStartsWith(item, chars)), activeId).filter((item) => item.id !== activeId);
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to add typeahead functionality to composite components.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const state = useCompositeState();
* const props = useCompositeTypeahead({ state });
* <Composite state={state} {...props}>
*   <CompositeItem>Item 1</CompositeItem>
*   <CompositeItem>Item 2</CompositeItem>
* </Composite>
* ```
*/
var useCompositeTypeahead = createHook((_ref) => {
	let { state, typeahead = true, ...props } = _ref;
	state = useStore(state || CompositeContext, [
		"items",
		"activeId",
		"move"
	]);
	const onKeyDownCaptureProp = props.onKeyDownCapture;
	const cleanupTimeoutRef = useRef(0);
	const onKeyDownCapture = useEvent$1((event) => {
		var _state, _state2;
		onKeyDownCaptureProp?.(event);
		if (event.defaultPrevented) return;
		if (!typeahead) return;
		if (!((_state = state) != null && _state.items)) return;
		if (!isValidTypeaheadEvent(event)) return clearChars();
		let items = getEnabledItems(state.items);
		if (!isSelfTargetOrItem(event, items)) return clearChars();
		event.preventDefault();
		window.clearTimeout(cleanupTimeoutRef.current);
		cleanupTimeoutRef.current = window.setTimeout(() => {
			chars = "";
		}, 500);
		const char = event.key.toLowerCase();
		chars += char;
		items = getSameInitialItems(items, char, (_state2 = state) == null ? void 0 : _state2.activeId);
		const item = items.find((item) => itemTextStartsWith(item, chars));
		if (item) state.move(item.id);
		else clearChars();
	});
	props = {
		...props,
		onKeyDownCapture
	};
	return props;
});
/**
* A component that adds typeahead functionality to composite components.
* @see https://ariakit.org/components/composite
* @example
* ```jsx
* const composite = useCompositeState();
* <Composite state={composite} as={CompositeTypeahead}>
*   <CompositeItem>Item 1</CompositeItem>
*   <CompositeItem>Item 2</CompositeItem>
* </Composite>
* ```
*/
var CompositeTypeahead = createComponent((props) => {
	return createElement$1("div", useCompositeTypeahead(props));
});
if (process.env.NODE_ENV !== "production") CompositeTypeahead.displayName = "CompositeTypeahead";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-6eda8bb9.js
var FormContext = createStoreContext();
//#endregion
//#region ../../node_modules/ariakit/esm/form/form-field.js
function getNamedElement(ref, name) {
	const element = ref.current;
	if (!element) return null;
	if (element.name !== name) {
		if (element.form) return element.form.elements.namedItem(name);
		else return getDocument(element).getElementsByName(name)[0];
	}
	return element;
}
function findItem(items, name, type) {
	return items == null ? void 0 : items.find((item) => item.type === type && item.name === name);
}
function useItem(state, name, type) {
	return useMemo(() => findItem(state == null ? void 0 : state.items, name, type), [
		state == null ? void 0 : state.items,
		name,
		type
	]);
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a form field. Unlike `useFormInput`, this hook
* doesn't automatically returns the `value` and `onChange` props. This is so we
* can use it not only for native form elements but also for custom components
* whose value is not controlled by the native `value` and `onChange` props.
* @see https://ariakit.org/components/form
* @example
* ```jsx
* const state = useFormState({ defaultValues: { content: "" } });
* const props = useFormField({ state, name: state.names.content });
*
* const setValue = useCallback((value) => {
*   state.setValue(state.names.content, value);
* }, [state.setValue, state.names.content]);
*
* <Form state={state}>
*   <FormLabel name={state.names.content}>Content</FormLabel>
*   <Role
*     {...props}
*     as={Editor}
*     value={state.values.content}
*     onChange={setValue}
*   />
* </Form>
* ```
*/
var useFormField = createHook((_ref) => {
	var _state, _state4;
	let { state, name: nameProp, getItem: getItemProp, touchOnBlur = true, ...props } = _ref;
	const name = "" + nameProp;
	state = useStore(state || FormContext, [
		"setFieldTouched",
		"useValidate",
		"setError",
		useCallback((s) => s.getError(name), [name]),
		useCallback((s) => s.getFieldTouched(name).toString(), [name]),
		useCallback((s) => findItem(s.items, name, "label"), [name]),
		useCallback((s) => findItem(s.items, name, "error"), [name]),
		useCallback((s) => findItem(s.items, name, "description"), [name])
	]);
	const ref = useRef(null);
	const id = useId(props.id);
	(_state = state) == null || _state.useValidate(async () => {
		const element = getNamedElement(ref, name);
		if (!element) return;
		await Promise.resolve();
		if ("validity" in element && !element.validity.valid) {
			var _state2;
			(_state2 = state) == null || _state2.setError(name, element.validationMessage);
		}
	});
	const getItem = useCallback((item) => {
		const nextItem = {
			...item,
			id,
			name,
			type: "field"
		};
		if (getItemProp) return getItemProp(nextItem);
		return nextItem;
	}, [
		id,
		name,
		getItemProp
	]);
	const onBlurProp = props.onBlur;
	const touchOnBlurProp = useBooleanEvent(touchOnBlur);
	const onBlur = useEvent$1((event) => {
		var _state3;
		onBlurProp?.(event);
		if (event.defaultPrevented) return;
		if (!touchOnBlurProp(event)) return;
		(_state3 = state) == null || _state3.setFieldTouched(name, true);
	});
	const label = useItem(state, name, "label");
	const error = useItem(state, name, "error");
	const description = useItem(state, name, "description");
	const describedBy = cx(error == null ? void 0 : error.id, description == null ? void 0 : description.id, props["aria-describedby"]);
	const invalid = !!((_state4 = state) != null && _state4.getError(name)) && state.getFieldTouched(name);
	props = {
		id,
		"aria-labelledby": label == null ? void 0 : label.id,
		"aria-invalid": invalid,
		...props,
		"aria-describedby": describedBy || void 0,
		ref: useForkRef(ref, props.ref),
		onBlur
	};
	props = useCollectionItem({
		state,
		...props,
		name,
		getItem
	});
	return props;
});
/**
* A component that renders a form field. Unlike `FormInput`, this component
* doesn't automatically pass the `value` and `onChange` props down to the
* underlying element. This is so we can use it not only for native form
* elements but also for custom components whose value is not controlled by the
* native `value` and `onChange` props.
* @see https://ariakit.org/components/form
* @example
* ```jsx
* const form = useFormState({ defaultValues: { content: "" } });
*
* const setValue = useCallback((value) => {
*   form.setValue(form.names.content, value);
* }, [form.setValue, form.names.content]);
*
* <Form state={form}>
*   <FormLabel name={form.names.content}>Content</FormLabel>
*   <FormField
*     {...props}
*     as={Editor}
*     value={form.values.content}
*     onChange={setValue}
*   />
* </Form>
* ```
*/
var FormField = createMemoComponent((props) => {
	return createElement$1("input", useFormField(props));
});
if (process.env.NODE_ENV !== "production") FormField.displayName = "FormField";
//#endregion
//#region ../../node_modules/ariakit/esm/form/form-input.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a form input. Unlike `useFormField`, this hook
* returns the `value` and `onChange` props that can be passed to a native
* input, select or textarea elements.
* @see https://ariakit.org/components/form
* @example
* ```jsx
* const state = useFormState({ defaultValues: { email: "" } });
* const props = useFormInput({ state, name: state.names.email });
* <Form state={state}>
*   <FormLabel name={state.names.email}>Email</FormLabel>
*   <Role as="input" {...props} />
* </Form>
* ```
*/
var useFormInput = createHook((_ref) => {
	var _state2;
	let { state, name: nameProp, ...props } = _ref;
	const name = "" + nameProp;
	state = useStore(state || FormContext, ["setValue", useCallback((s) => s.getValue(name), [name])]);
	const onChangeProp = props.onChange;
	const onChange = useEvent$1((event) => {
		var _state;
		onChangeProp?.(event);
		if (event.defaultPrevented) return;
		(_state = state) == null || _state.setValue(name, event.target.value);
	});
	props = {
		value: (_state2 = state) == null ? void 0 : _state2.getValue(name),
		...props,
		onChange
	};
	props = useFocusable(props);
	props = useFormField({
		state,
		name,
		...props
	});
	return props;
});
/**
* A component that renders a form input. Unlike `FormField`, this component
* passes the `value` and `onChange` props down to the underlying element that
* can be a native input, select or textarea elements.
* @see https://ariakit.org/components/form
* @example
* ```jsx
* const form = useFormState({ defaultValues: { email: "" } });
* <Form state={form}>
*   <FormLabel name={form.names.email}>Email</FormLabel>
*   <FormInput name={form.names.email} />
* </Form>
* ```
*/
var FormInput = createMemoComponent((props) => {
	return createElement$1("input", useFormInput(props));
});
if (process.env.NODE_ENV !== "production") FormInput.displayName = "FormInput";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-6a5ab864.js
var RadioContextState = createStoreContext();
//#endregion
//#region ../../node_modules/ariakit/esm/radio/radio.js
function getIsChecked(value, stateValue) {
	if (stateValue === void 0) return;
	if (value != null && stateValue != null) return stateValue === value;
	return !!stateValue;
}
function isNativeRadio(tagName, type) {
	return tagName === "input" && (!type || type === "radio");
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a radio button element.
* @see https://ariakit.org/components/radio
* @example
* ```jsx
* const state = useRadioState();
* const props = useRadio({ state, value: "Apple" });
* <RadioGroup state={state}>
*   <Role as="input" {...props} />
*   <Radio value="Orange" />
* </RadioGroup>
* ```
*/
var useRadio = createHook((_ref) => {
	var _state, _state2, _state4;
	let { state, value, checked, ...props } = _ref;
	const id = useId(props.id);
	state = useStore(state || RadioContextState, [
		useCallback((s) => s.activeId === id, [id]),
		useCallback((s) => s.value === value, [value]),
		"setActiveId",
		"setValue"
	]);
	const ref = useRef(null);
	const isActiveItemRef = useLiveRef(((_state = state) == null ? void 0 : _state.activeId) === id);
	const isChecked = checked != null ? checked : getIsChecked(value, (_state2 = state) == null ? void 0 : _state2.value);
	useEffect(() => {
		if (!isActiveItemRef.current && isChecked) {
			var _state3;
			(_state3 = state) == null || _state3.setActiveId(id);
		}
	}, [
		isChecked,
		(_state4 = state) == null ? void 0 : _state4.setActiveId,
		id
	]);
	const onChangeProp = props.onChange;
	const nativeRadio = isNativeRadio(useTagName(ref, props.as || "input"), props.type);
	const onChange = useEvent$1((event) => {
		var _state5;
		if (props.disabled) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}
		if (!nativeRadio) event.currentTarget.checked = true;
		onChangeProp?.(event);
		if (event.defaultPrevented) return;
		(_state5 = state) == null || _state5.setValue(value);
	});
	const onClickProp = props.onClick;
	const onClick = useEvent$1((event) => {
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		if (nativeRadio) return;
		onChange(event);
	});
	const onFocusProp = props.onFocus;
	const onFocus = useEvent$1((event) => {
		var _state6;
		onFocusProp?.(event);
		if (event.defaultPrevented) return;
		if (!nativeRadio) return;
		if (!((_state6 = state) != null && _state6.moves)) return;
		if (!isActiveItemRef.current) return;
		onChange(event);
	});
	props = {
		id,
		role: !nativeRadio ? "radio" : void 0,
		type: nativeRadio ? "radio" : void 0,
		"aria-checked": isChecked,
		...props,
		ref: useForkRef(ref, props.ref),
		onChange,
		onClick,
		onFocus
	};
	props = useCompositeItem({
		state,
		clickOnEnter: !nativeRadio,
		...props
	});
	return {
		value: nativeRadio ? value : void 0,
		checked: isChecked,
		...props
	};
});
/**
* A component that renders a radio button element.
* @see https://ariakit.org/components/radio
* @example
* ```jsx
* const radio = useRadioState();
* <RadioGroup state={radio}>
*   <Radio value="Apple" />
*   <Radio value="Orange" />
* </RadioGroup>
* ```
*/
var Radio$1 = createMemoComponent((props) => {
	return createElement$1("input", useRadio(props));
});
if (process.env.NODE_ENV !== "production") Radio$1.displayName = "Radio";
//#endregion
//#region ../../node_modules/ariakit/esm/hovercard/hovercard-anchor.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an anchor element that will open a popover
* (`Hovercard`) on hover.
* @see https://ariakit.org/components/hovercard
* @example
* ```jsx
* const state = useHovercardState();
* const props = useHovercardAnchor({ state });
* <Role as="a" {...props}>@username</Role>
* <Hovercard state={state}>Details</Hovercard>
* ```
*/
var useHovercardAnchor = createHook((_ref) => {
	let { state, showOnHover = true, ...props } = _ref;
	const disabled = props.disabled || props["aria-disabled"] === true || props["aria-disabled"] === "true";
	const showTimeoutRef = useRef(0);
	useEffect(() => () => window.clearTimeout(showTimeoutRef.current), []);
	useEffect(() => {
		const onMouseLeave = (event) => {
			const element = state.anchorRef.current;
			if (!element) return;
			if (event.target !== element) return;
			window.clearTimeout(showTimeoutRef.current);
			showTimeoutRef.current = 0;
		};
		return addGlobalEventListener("mouseleave", onMouseLeave, true);
	}, [state.anchorRef]);
	const onMouseMoveProp = props.onMouseMove;
	const showOnHoverProp = useBooleanEvent(showOnHover);
	const isMouseMoving = useIsMouseMoving();
	const onMouseMove = useEvent$1((event) => {
		state.anchorRef.current = event.currentTarget;
		onMouseMoveProp?.(event);
		if (disabled) return;
		if (event.defaultPrevented) return;
		if (showTimeoutRef.current) return;
		if (!isMouseMoving()) return;
		if (!showOnHoverProp(event)) return;
		showTimeoutRef.current = window.setTimeout(() => {
			showTimeoutRef.current = 0;
			state.show();
		}, state.showTimeout);
	});
	props = {
		...props,
		ref: useForkRef(state.anchorRef, props.ref),
		onMouseMove
	};
	props = useFocusable(props);
	return props;
});
/**
* A component that renders an anchor element that will open a popover
* (`Hovercard`) on hover.
* @see https://ariakit.org/components/hovercard
* @example
* ```jsx
* const hovercard = useHovercardState();
* <HovercardAnchor state={hovercard}>@username</HovercardAnchor>
* <Hovercard state={hovercard}>Details</Hovercard>
* ```
*/
var HovercardAnchor = createComponent((props) => {
	return createElement$1("a", useHovercardAnchor(props));
});
if (process.env.NODE_ENV !== "production") HovercardAnchor.displayName = "HovercardAnchor";
//#endregion
//#region ../../node_modules/ariakit/esm/popover/popover-arrow.js
var POPOVER_ARROW_PATH = "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z";
var defaultSize = 30;
var rotateMap = {
	top: "rotate(180 15 15)",
	right: "rotate(-90 15 15)",
	bottom: "rotate(0 15 15)",
	left: "rotate(90 15 15)"
};
function useComputedStyle(element) {
	const [style, setStyle] = useState();
	useSafeLayoutEffect(() => {
		if (!element) return;
		const computedStyle = getWindow$2(element).getComputedStyle(element);
		setStyle(computedStyle);
	}, [element]);
	return style;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an arrow inside a popover element.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const state = usePopoverState();
* const props = usePopoverArrow({ state });
* <Popover state={state}>
*   <Role {...props} />
*   Popover
* </Popover>
* ```
*/
var usePopoverArrow = createHook((_ref) => {
	var _state, _state2, _state3;
	let { state, size = defaultSize, ...props } = _ref;
	const context = useContext(PopoverContext);
	state = state || context;
	const dir = (_state = state) == null ? void 0 : _state.currentPlacement.split("-")[0];
	const style = useComputedStyle((_state2 = state) == null ? void 0 : _state2.contentElement);
	const fill = (style == null ? void 0 : style.getPropertyValue("background-color")) || "none";
	const stroke = (style == null ? void 0 : style.getPropertyValue("border-" + dir + "-color")) || "none";
	const borderWidth = (style == null ? void 0 : style.getPropertyValue("border-" + dir + "-width")) || "0px";
	const strokeWidth = parseInt(borderWidth) * 2 * (defaultSize / size);
	const transform = rotateMap[dir];
	props = {
		children: useMemo(() => /*#__PURE__*/ jsx("svg", {
			display: "block",
			viewBox: "0 0 30 30",
			children: /*#__PURE__*/ jsxs("g", {
				transform,
				children: [/*#__PURE__*/ jsx("path", {
					fill: "none",
					d: POPOVER_ARROW_PATH
				}), /*#__PURE__*/ jsx("path", {
					stroke: "none",
					d: POPOVER_ARROW_PATH
				})]
			})
		}), [transform]),
		"aria-hidden": true,
		...props,
		ref: useForkRef((_state3 = state) == null ? void 0 : _state3.arrowRef, props.ref),
		style: {
			position: "absolute",
			fontSize: size,
			width: "1em",
			height: "1em",
			pointerEvents: "none",
			fill,
			stroke,
			strokeWidth,
			...props.style
		}
	};
	return props;
});
/**
* A component that renders an arrow inside a `Popover` component.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const popover = usePopoverState();
* <Popover state={popover}>
*   <PopoverArrow />
*   Popover
* </Popover>
* ```
*/
var PopoverArrow = createComponent((props) => {
	return createElement$1("div", usePopoverArrow(props));
});
if (process.env.NODE_ENV !== "production") PopoverArrow.displayName = "PopoverArrow";
//#endregion
//#region ../../node_modules/ariakit/esm/hovercard/hovercard-state.js
/**
* Provides state for the `Hovercard` components.
* @example
* ```jsx
* const hovercard = useHovercardState({ placement: "top" });
* <HovercardAnchor state={hovercard}>@username</HovercardAnchor>
* <Hovercard state={hovercard}>Details</Hovercard>
* ```
*/
function useHovercardState(_temp) {
	let { timeout = 500, placement = "bottom", showTimeout = timeout, hideTimeout = timeout, ...props } = _temp === void 0 ? {} : _temp;
	const [autoFocusOnShow, setAutoFocusOnShow] = useState(false);
	const popover = usePopoverState({
		placement,
		...props
	});
	return useMemo(() => ({
		...popover,
		timeout,
		showTimeout,
		hideTimeout,
		autoFocusOnShow,
		setAutoFocusOnShow
	}), [
		popover,
		timeout,
		showTimeout,
		hideTimeout,
		autoFocusOnShow,
		setAutoFocusOnShow
	]);
}
//#endregion
//#region ../../node_modules/ariakit/esm/hovercard/hovercard.js
function getEventPoint(event) {
	return [event.clientX, event.clientY];
}
function isPointInPolygon(point, polygon) {
	const [x, y] = point;
	let inside = false;
	const length = polygon.length;
	for (let l = length, i = 0, j = l - 1; i < l; j = i++) {
		const [xi, yi] = polygon[i];
		const [xj, yj] = polygon[j];
		const [, vy] = polygon[j === 0 ? l - 1 : j - 1] || [0, 0];
		const where = (yi - yj) * (x - xi) - (xi - xj) * (y - yi);
		if (yj < yi) {
			if (y >= yj && y < yi) {
				if (where === 0) return true;
				if (where > 0) {
					if (y === yj) {
						if (y > vy) inside = !inside;
					} else inside = !inside;
				}
			}
		} else if (yi < yj) {
			if (y > yi && y <= yj) {
				if (where === 0) return true;
				if (where < 0) {
					if (y === yj) {
						if (y < vy) inside = !inside;
					} else inside = !inside;
				}
			}
		} else if (y == yi && (x >= xj && x <= xi || x >= xi && x <= xj)) return true;
	}
	return inside;
}
function getEnterPointPlacement(enterPoint, rect) {
	const { top, right, bottom, left } = rect;
	const [x, y] = enterPoint;
	return [x < left ? "left" : x > right ? "right" : null, y < top ? "top" : y > bottom ? "bottom" : null];
}
function getElementPolygon(element, enterPoint) {
	const rect = element.getBoundingClientRect();
	const { top, right, bottom, left } = rect;
	const [x, y] = getEnterPointPlacement(enterPoint, rect);
	const polygon = [enterPoint];
	if (x) {
		if (y !== "top") polygon.push([x === "left" ? left : right, top]);
		polygon.push([x === "left" ? right : left, top]);
		polygon.push([x === "left" ? right : left, bottom]);
		if (y !== "bottom") polygon.push([x === "left" ? left : right, bottom]);
	} else if (y === "top") {
		polygon.push([left, top]);
		polygon.push([left, bottom]);
		polygon.push([right, bottom]);
		polygon.push([right, top]);
	} else {
		polygon.push([left, bottom]);
		polygon.push([left, top]);
		polygon.push([right, top]);
		polygon.push([right, bottom]);
	}
	return polygon;
}
function isMovingOnHovercard(target, card, anchor, nested) {
	if (hasFocusWithin(card)) return true;
	if (!target) return false;
	if (contains(card, target)) return true;
	if (anchor && contains(anchor, target)) return true;
	if (nested != null && nested.some((card) => isMovingOnHovercard(target, card, anchor))) return true;
	return false;
}
function useAutoFocusOnShow(_ref) {
	let { state, ...props } = _ref;
	const mountedRef = useLiveRef(state.mounted);
	useEffect(() => {
		if (!state.mounted) state.setAutoFocusOnShow(false);
	}, [state.mounted, state.setAutoFocusOnShow]);
	useEffect(() => () => {
		if (!mountedRef.current) state.setAutoFocusOnShow(false);
	}, [state.setAutoFocusOnShow]);
	return {
		autoFocusOnShow: !!props.modal || state.autoFocusOnShow,
		...props
	};
}
function useAutoFocusOnHide(_ref2) {
	let { state, ...props } = _ref2;
	const [autoFocusOnHide, setAutoFocusOnHide] = useState(false);
	useEffect(() => {
		if (!state.mounted) setAutoFocusOnHide(false);
	}, [state.mounted]);
	const onFocusProp = useEvent$1(props.onFocus);
	const onFocus = useCallback((event) => {
		onFocusProp(event);
		if (event.defaultPrevented) return;
		setAutoFocusOnHide(true);
	}, [onFocusProp]);
	props = {
		autoFocusOnHide,
		finalFocusRef: state.anchorRef,
		...props,
		onFocus
	};
	return props;
}
var NestedHovercardContext = /*#__PURE__*/ createContext(null);
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a hovercard element, which is a popover that's
* usually made visible by hovering the mouse cursor over an anchor element
* (`HovercardAnchor`).
* @see https://ariakit.org/components/hovercard
* @example
* ```jsx
* const state = useHovercardState();
* const props = useHovercard({ state });
* <HovercardAnchor state={state}>@username</HovercardAnchor>
* <Role {...props}>Details</Role>
* ```
*/
var useHovercard = createHook((_ref3) => {
	let { state, modal = false, portal = !!modal, hideOnEscape = true, hideOnControl = false, hideOnHoverOutside = true, disablePointerEventsOnApproach = !!hideOnHoverOutside, ...props } = _ref3;
	const ref = useRef(null);
	const [nestedHovercards, setNestedHovercards] = useState([]);
	const hideTimeoutRef = useRef(0);
	const enterPointRef = useRef(null);
	const { portalRef, domReady } = usePortalRef(portal, props.portalRef);
	const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
	const hideOnControlProp = useBooleanEvent(hideOnControl);
	useEffect(() => {
		if (!state.open) return;
		return addGlobalEventListener("keydown", (event) => {
			if (event.defaultPrevented) return;
			const isEscape = event.key === "Escape" && hideOnEscapeProp(event);
			const isControl = event.key === "Control" && hideOnControlProp(event);
			if (isEscape || isControl) state.hide();
		});
	}, [
		state.open,
		hideOnEscapeProp,
		hideOnControlProp,
		state.hide
	]);
	const mayHideOnHoverOutside = !!hideOnHoverOutside;
	const hideOnHoverOutsideProp = useBooleanEvent(hideOnHoverOutside);
	const mayDisablePointerEvents = !!disablePointerEventsOnApproach;
	const disablePointerEventsProp = useBooleanEvent(disablePointerEventsOnApproach);
	useEffect(() => {
		if (!domReady) return;
		if (!state.mounted) return;
		if (!mayHideOnHoverOutside && !mayDisablePointerEvents) return;
		const element = ref.current;
		if (!element) return;
		const onMouseMove = (event) => {
			const enterPoint = enterPointRef.current;
			const target = event.target;
			const anchor = state.anchorRef.current;
			if (isMovingOnHovercard(target, element, anchor, nestedHovercards)) {
				enterPointRef.current = target && anchor && contains(anchor, target) ? getEventPoint(event) : null;
				window.clearTimeout(hideTimeoutRef.current);
				hideTimeoutRef.current = 0;
				return;
			}
			if (hideTimeoutRef.current) return;
			if (enterPoint) {
				const currentPoint = getEventPoint(event);
				if (isPointInPolygon(currentPoint, getElementPolygon(element, enterPoint))) {
					enterPointRef.current = currentPoint;
					if (!disablePointerEventsProp(event)) return;
					event.preventDefault();
					event.stopPropagation();
					return;
				}
			}
			if (!hideOnHoverOutsideProp(event)) return;
			hideTimeoutRef.current = window.setTimeout(() => {
				hideTimeoutRef.current = 0;
				state.hide();
			}, state.hideTimeout);
		};
		return addGlobalEventListener("mousemove", onMouseMove, true);
	}, [
		domReady,
		state.mounted,
		mayHideOnHoverOutside,
		mayDisablePointerEvents,
		state.anchorRef,
		nestedHovercards,
		disablePointerEventsProp,
		hideOnHoverOutsideProp,
		state.hide,
		state.hideTimeout
	]);
	useEffect(() => {
		if (!domReady) return;
		if (!state.mounted) return;
		if (!mayDisablePointerEvents) return;
		const disableEvent = (event) => {
			const element = ref.current;
			if (!element) return;
			const enterPoint = enterPointRef.current;
			if (!enterPoint) return;
			const polygon = getElementPolygon(element, enterPoint);
			if (isPointInPolygon(getEventPoint(event), polygon)) {
				if (!disablePointerEventsProp(event)) return;
				event.preventDefault();
				event.stopPropagation();
			}
		};
		return chain(addGlobalEventListener("mouseenter", disableEvent, true), addGlobalEventListener("mouseover", disableEvent, true), addGlobalEventListener("mouseout", disableEvent, true), addGlobalEventListener("mouseleave", disableEvent, true));
	}, [
		domReady,
		state.mounted,
		mayDisablePointerEvents,
		disablePointerEventsProp
	]);
	const registerOnParent = useContext(NestedHovercardContext);
	useSafeLayoutEffect(() => {
		if (modal) return;
		if (!portal) return;
		if (!state.mounted) return;
		if (!domReady) return;
		const element = ref.current;
		if (!element) return;
		return registerOnParent == null ? void 0 : registerOnParent(element);
	}, [
		modal,
		portal,
		state.mounted,
		domReady
	]);
	const registerNestedHovercard = useCallback((element) => {
		setNestedHovercards((prevElements) => [...prevElements, element]);
		const parentUnregister = registerOnParent == null ? void 0 : registerOnParent(element);
		return () => {
			setNestedHovercards((prevElements) => prevElements.filter((item) => item !== element));
			parentUnregister?.();
		};
	}, [registerOnParent]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(NestedHovercardContext.Provider, {
		value: registerNestedHovercard,
		children: element
	}), [registerNestedHovercard]);
	props = {
		...props,
		ref: useForkRef(ref, props.ref)
	};
	props = useAutoFocusOnHide({
		state,
		...props
	});
	props = useAutoFocusOnShow({
		state,
		...props
	});
	props = usePopover({
		hideOnEscape,
		state,
		modal,
		portal,
		...props,
		portalRef
	});
	return props;
});
/**
* A component that renders a hovercard element, which is a popover that's
* usually made visible by hovering the mouse cursor over an anchor element
* (`HovercardAnchor`).
* @see https://ariakit.org/components/hovercard
* @example
* ```jsx
* const hovercard = useHovercardState();
* <HovercardAnchor state={hovercard}>@username</HovercardAnchor>
* <Hovercard state={hovercard}>Details</Hovercard>
* ```
*/
var Hovercard = createComponent((props) => {
	return createElement$1("div", useHovercard(props));
});
if (process.env.NODE_ENV !== "production") Hovercard.displayName = "Hovercard";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-07f4a93f.js
var MenuBarContext = createStoreContext();
var MenuContext = createStoreContext();
function hasExpandedMenuButton(items, currentElement) {
	return !!(items != null && items.filter((item) => item.ref.current !== currentElement).some((item) => {
		var _item$ref$current;
		return ((_item$ref$current = item.ref.current) == null ? void 0 : _item$ref$current.getAttribute("aria-expanded")) === "true";
	}));
}
//#endregion
//#region ../../node_modules/ariakit/esm/popover/popover-disclosure-arrow.js
var pointsMap = {
	top: "4,10 8,6 12,10",
	right: "6,4 10,8 6,12",
	bottom: "4,6 8,10 12,6",
	left: "10,4 6,8 10,12"
};
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an arrow pointing to the popover position. It's
* usually rendered inside the `PopoverDisclosure` component.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const state = usePopoverState();
* const props = usePopoverDisclosureArrow({ state });
* <PopoverDisclosure state={state}>
*   Disclosure
*   <Role {...props} />
* </PopoverDisclosure>
* ```
*/
var usePopoverDisclosureArrow = createHook((_ref) => {
	var _placement, _state, _placement2;
	let { state, placement, ...props } = _ref;
	const context = useContext(PopoverContext);
	state = state || context;
	placement = (_placement = placement) != null ? _placement : (_state = state) == null ? void 0 : _state.placement;
	const points = pointsMap[(_placement2 = placement) == null ? void 0 : _placement2.split("-")[0]];
	props = {
		children: useMemo(() => /*#__PURE__*/ jsx("svg", {
			display: "block",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5pt",
			viewBox: "0 0 16 16",
			height: "1em",
			width: "1em",
			children: /*#__PURE__*/ jsx("polyline", { points })
		}), [points]),
		"aria-hidden": true,
		...props,
		style: {
			width: "1em",
			height: "1em",
			pointerEvents: "none",
			...props.style
		}
	};
	return props;
});
/**
* A component that renders an arrow pointing to the popover position. It's
* usually rendered inside the `PopoverDisclosure` component.
* @see https://ariakit.org/components/popover
* @example
* ```jsx
* const popover = usePopoverState();
* <PopoverDisclosure state={popover}>
*   Disclosure
*   <PopoverDisclosureArrow />
* </PopoverDisclosure>
* <Popover state={popover}>Popover</Popover>
* ```
*/
var PopoverDisclosureArrow = createComponent((props) => {
	return createElement$1("span", usePopoverDisclosureArrow(props));
});
if (process.env.NODE_ENV !== "production") PopoverDisclosureArrow.displayName = "PopoverDisclosureArrow";
//#endregion
//#region ../../node_modules/ariakit/esm/menu/menu-button-arrow.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an arrow pointing to the menu position, usually
* inside a `MenuButton`.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const state = useMenuState();
* const props = useMenuButtonArrow({ state });
* <MenuButton state={state}>
*   Edit
*   <Role {...props} />
* </MenuButton>
* <Menu state={state}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
var useMenuButtonArrow = createHook((_ref) => {
	let { state, ...props } = _ref;
	props = usePopoverDisclosureArrow({
		state,
		...props
	});
	return props;
});
/**
* A component that renders an arrow pointing to the menu position, usually
* inside a `MenuButton`.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const menu = useMenuState();
* <MenuButton state={menu}>
*   Edit
*   <MenuButtonArrow />
* </MenuButton>
* <Menu state={menu}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
var MenuButtonArrow = createComponent((props) => {
	return createElement$1("span", useMenuButtonArrow(props));
});
if (process.env.NODE_ENV !== "production") MenuButtonArrow.displayName = "MenuButtonArrow";
//#endregion
//#region ../../node_modules/ariakit/esm/menu/menu-button.js
function getInitialFocus(event, dir) {
	return {
		ArrowDown: dir === "bottom" || dir === "top" ? "first" : false,
		ArrowUp: dir === "bottom" || dir === "top" ? "last" : false,
		ArrowRight: dir === "right" ? "first" : false,
		ArrowLeft: dir === "left" ? "first" : false
	}[event.key];
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a menu button that triggers a dropdown menu.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const state = useMenuState();
* const props = useMenuButton({ state });
* <Role {...props}>Edit</Role>
* <Menu state={state}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
var useMenuButton = createHook((_ref) => {
	let { state, focusable, accessibleWhenDisabled, showOnHover, ...props } = _ref;
	const ref = useRef(null);
	const parentMenu = useStore(MenuContext, [
		"items",
		"move",
		"contentElement"
	]);
	const parentMenuBar = useStore(MenuBarContext, ["items", "move"]);
	const hasParentMenu = !!parentMenu;
	const parentIsMenuBar = !!parentMenuBar && !hasParentMenu;
	const disabled = props.disabled || props["aria-disabled"] === true || props["aria-disabled"] === "true";
	useEffect(() => {
		state.disclosureRef.current = ref.current;
	});
	const onFocusProp = props.onFocus;
	const onFocus = useEvent$1((event) => {
		onFocusProp?.(event);
		if (disabled) return;
		if (event.defaultPrevented) return;
		state.setAutoFocusOnShow(false);
		state.setActiveId(null);
		if (!parentMenuBar) return;
		if (!parentIsMenuBar) return;
		if (hasExpandedMenuButton(parentMenuBar.items, event.currentTarget)) state.show();
	});
	const dir = state.placement.split("-")[0];
	const onKeyDownProp = props.onKeyDown;
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		if (disabled) return;
		if (event.defaultPrevented) return;
		const initialFocus = getInitialFocus(event, dir);
		if (initialFocus) {
			event.preventDefault();
			state.show();
			state.setAutoFocusOnShow(true);
			state.setInitialFocus(initialFocus);
		}
	});
	const onClickProp = props.onClick;
	const onClick = useEvent$1((event) => {
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		const isKeyboardClick = !event.detail;
		if (!state.open || isKeyboardClick) {
			if (!hasParentMenu || isKeyboardClick) state.setAutoFocusOnShow(true);
			state.setInitialFocus(isKeyboardClick ? "first" : "container");
		}
		if (hasParentMenu) state.show();
	});
	if (hasParentMenu) props = {
		as: "div",
		...props
	};
	props = {
		id: useId(props.id),
		role: hasParentMenu || parentIsMenuBar ? getPopupItemRole(parentMenu == null ? void 0 : parentMenu.contentElement, "menuitem") : void 0,
		"aria-haspopup": getPopupRole(state.contentElement, "menu"),
		...props,
		ref: useForkRef(ref, props.ref),
		onFocus,
		onKeyDown,
		onClick
	};
	props = useHovercardAnchor({
		state,
		focusable,
		accessibleWhenDisabled,
		...props,
		showOnHover: (event) => {
			if (typeof showOnHover === "function") return showOnHover(event);
			if (showOnHover != null) return showOnHover;
			if (hasParentMenu) return true;
			return parentIsMenuBar && hasExpandedMenuButton(parentMenuBar.items);
		}
	});
	props = usePopoverDisclosure({
		state,
		toggleOnClick: !hasParentMenu,
		focusable,
		accessibleWhenDisabled,
		...props
	});
	props = useCompositeTypeahead({
		state,
		typeahead: parentIsMenuBar,
		...props
	});
	return props;
});
/**
* A component that renders a menu button that triggers a dropdown menu.
* Usually, this is rendered as a native `button` element, but if it's a submenu
* button rendered as a menu item inside another menu, it'll be rendered as a
* `div`.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const menu = useMenuState();
* <MenuButton state={menu}>Edit</MenuButton>
* <Menu state={menu}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
var MenuButton = createComponent((props) => {
	return createElement$1("button", useMenuButton(props));
});
if (process.env.NODE_ENV !== "production") MenuButton.displayName = "MenuButton";
//#endregion
//#region ../../node_modules/ariakit/esm/menu/menu-item.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a menu item.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const state = useMenuState();
* const undo = useMenuItem({ state });
* const redo = useMenuItem({ state });
* <MenuButton state={state}>Edit</MenuButton>
* <Menu state={state}>
*   <Role {...undo}>Undo</Role>
*   <Role {...redo}>Redo</Role>
* </Menu>
* ```
*/
var useMenuItem = createHook((_ref) => {
	let { state, hideOnClick = true, preventScrollOnKeyDown = true, focusOnHover, ...props } = _ref;
	const menuBarState = useStore(state || MenuBarContext, ["items"]);
	state = useStore(state || MenuContext, [
		"move",
		"hideAll",
		"contentElement"
	]) || menuBarState;
	const onClickProp = props.onClick;
	const hideOnClickProp = useBooleanEvent(hideOnClick);
	const hideMenu = state && "hideAll" in state ? state.hideAll : void 0;
	const isWithinMenu = !!hideMenu;
	const onClick = useEvent$1((event) => {
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		if (isDownloading(event)) return;
		if (isOpeningInNewTab(event)) return;
		if (!hideMenu) return;
		if (event.currentTarget.getAttribute("aria-haspopup") === "menu") return;
		if (!hideOnClickProp(event)) return;
		hideMenu();
	});
	props = {
		role: getPopupItemRole(state && "contentElement" in state ? state.contentElement : null, "menuitem"),
		...props,
		onClick
	};
	props = useCompositeItem({
		state,
		preventScrollOnKeyDown,
		...props
	});
	props = useCompositeHover({
		state,
		...props,
		focusOnHover: (event) => {
			var _state;
			if (typeof focusOnHover === "function") return focusOnHover(event);
			if (focusOnHover != null) return focusOnHover;
			if (event.type === "mouseleave") return isWithinMenu;
			if (isWithinMenu) {
				if (event.currentTarget.hasAttribute("aria-expanded")) event.currentTarget.focus();
				return true;
			} else if (hasExpandedMenuButton((_state = state) == null ? void 0 : _state.items, event.currentTarget)) {
				event.currentTarget.focus();
				return true;
			}
			return false;
		}
	});
	return props;
});
/**
* A component that renders a menu item.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const menu = useMenuState();
* <MenuButton state={menu}>Edit</MenuButton>
* <Menu state={menu}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
var MenuItem$1 = createMemoComponent((props) => {
	return createElement$1("div", useMenuItem(props));
});
if (process.env.NODE_ENV !== "production") MenuItem$1.displayName = "MenuItem";
//#endregion
//#region ../../node_modules/ariakit/esm/menu/menu-list.js
function useAriaLabelledBy(_ref) {
	let { state, ...props } = _ref;
	const [id, setId] = useState(void 0);
	const label = props["aria-label"];
	useEffect(() => {
		const disclosure = state.disclosureRef.current;
		if (!disclosure) return;
		const menu = state.contentElement;
		if (!menu) return;
		if (label || menu.hasAttribute("aria-label")) setId(void 0);
		else if (disclosure.id) setId(disclosure.id);
	}, [
		label,
		state.disclosureRef,
		state.contentElement
	]);
	return id;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a menu list element.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const state = useMenuState();
* const props = useMenuList({ state });
* <MenuButton state={state}>Edit</MenuButton>
* <Role {...props}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Role>
* ```
*/
var useMenuList = createHook((_ref2) => {
	let { state, composite = true, ...props } = _ref2;
	const parentMenu = useStore(MenuContext, []);
	const parentMenuBar = useStore(MenuBarContext, [
		"items",
		"move",
		"next",
		"previous",
		"orientation"
	]);
	const hasParentMenu = !!parentMenu;
	const id = useId(props.id);
	const onKeyDownProp = props.onKeyDown;
	const dir = state.placement.split("-")[0];
	const orientation = state.orientation === "both" ? void 0 : state.orientation;
	const isHorizontal = orientation !== "vertical";
	const isMenuBarHorizontal = !!parentMenuBar && (parentMenuBar == null ? void 0 : parentMenuBar.orientation) !== "vertical";
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (hasParentMenu || parentMenuBar && !isHorizontal) {
			const action = {
				ArrowRight: () => dir === "left" && !isHorizontal,
				ArrowLeft: () => dir === "right" && !isHorizontal,
				ArrowUp: () => dir === "bottom" && isHorizontal,
				ArrowDown: () => dir === "top" && isHorizontal
			}[event.key];
			if (action != null && action()) {
				event.stopPropagation();
				event.preventDefault();
				return state.hide();
			}
		}
		if (parentMenuBar) {
			const action = {
				ArrowRight: () => {
					if (!isMenuBarHorizontal) return;
					return parentMenuBar.next();
				},
				ArrowLeft: () => {
					if (!isMenuBarHorizontal) return;
					return parentMenuBar.previous();
				},
				ArrowDown: () => {
					if (isMenuBarHorizontal) return;
					return parentMenuBar.next();
				},
				ArrowUp: () => {
					if (isMenuBarHorizontal) return;
					return parentMenuBar.previous();
				}
			}[event.key];
			const id = action == null ? void 0 : action();
			if (id !== void 0) {
				event.stopPropagation();
				event.preventDefault();
				parentMenuBar.move(id);
			}
		}
	});
	props = useStoreProvider({
		state,
		...props
	}, MenuContext);
	const ariaLabelledBy = useAriaLabelledBy({
		state,
		...props
	});
	const style = state.mounted ? props.style : {
		...props.style,
		display: "none"
	};
	props = {
		id,
		"aria-labelledby": ariaLabelledBy,
		hidden: !state.mounted,
		...props,
		ref: useForkRef(id ? state.setContentElement : null, props.ref),
		style,
		onKeyDown
	};
	if (composite) props = {
		role: "menu",
		"aria-orientation": orientation,
		...props
	};
	props = useComposite({
		state,
		composite,
		...props
	});
	props = useCompositeTypeahead({
		state,
		...props
	});
	return props;
});
/**
* A component that renders a menu list element.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const menu = useMenuState();
* <MenuButton state={menu}>Edit</MenuButton>
* <MenuList state={menu}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </MenuList>
* ```
*/
var MenuList = createComponent((props) => {
	return createElement$1("div", useMenuList(props));
});
if (process.env.NODE_ENV !== "production") MenuList.displayName = "MenuList";
//#endregion
//#region ../../node_modules/ariakit/esm/menu/menu-state.js
/**
* Provides state for the `Menu` components.
* @example
* ```jsx
* const menu = useMenuState({ placement: "top" });
* <MenuButton state={menu}>Edit</MenuButton>
* <Menu state={menu}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
function useMenuState(_temp) {
	var _timeout;
	let { orientation = "vertical", timeout, hideTimeout = 0, ...props } = _temp === void 0 ? {} : _temp;
	const [initialFocus, setInitialFocus] = useState("container");
	const [values, setValues] = useControlledState(props.defaultValues || {}, props.values, props.setValues);
	const parentMenu = useStore(MenuContext, ["orientation", "hideAll"]);
	const parentMenuBar = useStore(MenuBarContext, ["orientation"]);
	const contextOrientation = (parentMenu == null ? void 0 : parentMenu.orientation) || (parentMenuBar == null ? void 0 : parentMenuBar.orientation);
	const parentIsMenuBar = !!parentMenuBar && !parentMenu;
	const placement = props.placement || (contextOrientation === "vertical" ? "right-start" : "bottom-start");
	timeout = ((_timeout = timeout) != null ? _timeout : parentIsMenuBar) ? 0 : 150;
	const composite = useCompositeState({
		orientation,
		...props
	});
	const hovercard = useHovercardState({
		timeout,
		hideTimeout,
		...props,
		placement
	});
	useEffect(() => {
		if (hovercard.mounted) return;
		composite.setActiveId(null);
	}, [hovercard.mounted, composite.setActiveId]);
	const setValue = useCallback((name, value) => {
		if (name === "__proto__" || name === "constructor") return;
		setValues((prevValues) => {
			const prevValue = prevValues[name];
			const nextValue = applyState(value, prevValue);
			if (nextValue === prevValue) return prevValues;
			return {
				...prevValues,
				[name]: nextValue === void 0 ? !!nextValue : nextValue
			};
		});
	}, [setValues]);
	const hideAll = useCallback(() => {
		hovercard.hide();
		parentMenu?.hideAll();
	}, [hovercard.hide, parentMenu == null ? void 0 : parentMenu.hideAll]);
	return useStorePublisher(useMemo(() => ({
		...composite,
		...hovercard,
		initialFocus,
		setInitialFocus,
		values,
		setValues,
		setValue,
		hideAll
	}), [
		composite,
		hovercard,
		initialFocus,
		setInitialFocus,
		values,
		setValues,
		setValue,
		hideAll
	]));
}
//#endregion
//#region ../../node_modules/ariakit/esm/menu/menu.js
function getItemRefById(items, id) {
	var _items$find;
	if (!id) return;
	return (_items$find = items.find((item) => item.id === id)) == null ? void 0 : _items$find.ref;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a dropdown menu element.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const state = useMenuState();
* const props = useMenu({ state });
* <MenuButton state={state}>Edit</MenuButton>
* <Role {...props}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Role>
* ```
*/
var useMenu = createHook((_ref) => {
	let { state, hideOnEscape = true, autoFocusOnShow = true, hideOnHoverOutside, ...props } = _ref;
	const parentMenu = useStore(MenuContext, []);
	const parentMenuBar = useStore(MenuBarContext, []);
	const hasParentMenu = !!parentMenu;
	const parentIsMenuBar = !!parentMenuBar && !hasParentMenu;
	const onKeyDownProp = props.onKeyDown;
	const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (event.key === "Escape") {
			if (!hideOnEscapeProp(event)) return;
			if (!hasParentMenu) event.stopPropagation();
			return state.hide();
		}
	});
	props = {
		...props,
		onKeyDown
	};
	const { "aria-labelledby": ariaLabelledBy, ...menuListProps } = useMenuList({
		state,
		...props
	});
	props = menuListProps;
	const [initialFocusRef, setInitialFocusRef] = useState();
	useEffect(() => {
		let cleaning = false;
		setInitialFocusRef((prevInitialFocusRef) => {
			if (cleaning) return;
			if (!state.autoFocusOnShow) return;
			if (prevInitialFocusRef) return prevInitialFocusRef;
			switch (state.initialFocus) {
				case "first": return getItemRefById(state.items, state.first());
				case "last": return getItemRefById(state.items, state.last());
				default: return state.baseRef;
			}
		});
		return () => {
			cleaning = true;
		};
	}, [
		state.autoFocusOnShow,
		state.initialFocus,
		state.items,
		state.first,
		state.last,
		state.baseRef
	]);
	const mayAutoFocusOnShow = !!autoFocusOnShow;
	const canAutoFocusOnShow = !!initialFocusRef || !!props.initialFocusRef || !!props.modal;
	props = useHovercard({
		state,
		initialFocusRef,
		autoFocusOnShow: mayAutoFocusOnShow ? canAutoFocusOnShow && autoFocusOnShow : state.autoFocusOnShow || !!props.modal,
		...props,
		hideOnHoverOutside: (event) => {
			if (typeof hideOnHoverOutside === "function") return hideOnHoverOutside(event);
			if (hideOnHoverOutside != null) return hideOnHoverOutside;
			if (hasParentMenu) {
				parentMenu.setActiveId(null);
				return true;
			}
			if (!parentIsMenuBar) return false;
			const disclosure = state.disclosureRef.current;
			if (!disclosure) return true;
			if (hasFocusWithin(disclosure)) return false;
			return true;
		},
		modal: hasParentMenu ? false : props.modal,
		backdrop: hasParentMenu ? false : props.backdrop,
		hideOnEscape: hasParentMenu ? false : hideOnEscape
	});
	props = {
		"aria-labelledby": ariaLabelledBy,
		...props
	};
	return props;
});
/**
* A component that renders a dropdown menu element.
* @see https://ariakit.org/components/menu
* @example
* ```jsx
* const menu = useMenuState();
* <MenuButton state={menu}>Edit</MenuButton>
* <Menu state={menu}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
* </Menu>
* ```
*/
var Menu$1 = createComponent((props) => {
	return createElement$1("div", useMenu(props));
});
if (process.env.NODE_ENV !== "production") Menu$1.displayName = "Menu";
/**
* A component that renders an abstract element that supports the `as` prop,
* `children` as a function and a `wrapElement` prop that can be used to wrap
* the underlying element with React Portal, Context or other component types.
* @see https://ariakit.org/components/role
* @example
* ```jsx
* <Role as="div" />
* ```
*/
var Role = createComponent((props) => {
	return createElement$1("div", props);
});
if (process.env.NODE_ENV !== "production") Role.displayName = "Role";
//#endregion
//#region ../../node_modules/ariakit/esm/select/select-arrow.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an arrow pointing to the select popover position.
* It's usually rendered inside the `Select` component.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const state = useSelectState();
* const props = useSelectArrow({ state });
* <Select state={state}>
*   {state.value}
*   <Role {...props} />
* </Select>
* <SelectPopover state={state}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectPopover>
* ```
*/
var useSelectArrow = createHook((_ref) => {
	let { state, ...props } = _ref;
	props = usePopoverDisclosureArrow({
		state,
		...props
	});
	return props;
});
/**
* A component that renders an arrow pointing to the select popover position.
* It's usually rendered inside the `Select` component.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const select = useSelectState();
* <Select state={select}>
*   {select.value}
*   <SelectArrow />
* </Select>
* <SelectPopover state={select}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectPopover>
* ```
*/
var SelectArrow = createComponent((props) => {
	return createElement$1("span", useSelectArrow(props));
});
if (process.env.NODE_ENV !== "production") SelectArrow.displayName = "SelectArrow";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-ce9ba82e.js
var SelectItemCheckedContext = /*#__PURE__*/ createContext(false);
var SelectContext = createStoreContext();
function findFirstEnabledItemWithValue(items) {
	return items.find((item) => item.value != null && !item.disabled);
}
function findEnabledItemWithValueById(items, id) {
	return items.find((item) => item.value != null && item.id === id && !item.disabled);
}
function findEnabledItemByValue(items, value) {
	return items.find((item) => item.value === value && !item.disabled);
}
//#endregion
//#region ../../node_modules/ariakit/esm/select/select-item.js
function isSelected(stateValue, itemValue) {
	if (stateValue == null) return false;
	if (itemValue == null) return false;
	if (Array.isArray(stateValue)) return stateValue.includes(itemValue);
	return stateValue === itemValue;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a select item.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const state = useSelectState();
* const props = useSelectItem({ state, value: "Apple" });
* <Role {...props} />
* ```
*/
var useSelectItem = createHook((_ref) => {
	var _state, _hideOnClick, _state4, _state5;
	let { state, value, getItem: getItemProp, hideOnClick, setValueOnClick = value != null, preventScrollOnKeyDown = true, focusOnHover = true, ...props } = _ref;
	state = useStore(state || SelectContext, [
		useCallback((s) => isSelected(s.value, value), [value]),
		"setValue",
		"hide",
		"contentElement",
		"open"
	]);
	const disabled = props.disabled;
	const getItem = useCallback((item) => {
		const nextItem = {
			...item,
			value: disabled ? void 0 : value
		};
		if (getItemProp) return getItemProp(nextItem);
		return nextItem;
	}, [
		disabled,
		value,
		getItemProp
	]);
	const multiSelectable = Array.isArray((_state = state) == null ? void 0 : _state.value);
	hideOnClick = (_hideOnClick = hideOnClick) != null ? _hideOnClick : value != null && !multiSelectable;
	const onClickProp = props.onClick;
	const setValueOnClickProp = useBooleanEvent(setValueOnClick);
	const hideOnClickProp = useBooleanEvent(hideOnClick);
	const onClick = useEvent$1((event) => {
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		if (isDownloading(event)) return;
		if (isOpeningInNewTab(event)) return;
		if (setValueOnClickProp(event) && value != null) {
			var _state2;
			(_state2 = state) == null || _state2.setValue((prevValue) => {
				if (!Array.isArray(prevValue)) return value;
				if (prevValue.includes(value)) return prevValue.filter((v) => v !== value);
				return [...prevValue, value];
			});
		}
		if (hideOnClickProp(event)) {
			var _state3;
			(_state3 = state) == null || _state3.hide();
		}
	});
	const selected = isSelected((_state4 = state) == null ? void 0 : _state4.value, value);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(SelectItemCheckedContext.Provider, {
		value: selected,
		children: element
	}), [selected]);
	props = {
		role: getPopupItemRole((_state5 = state) == null ? void 0 : _state5.contentElement),
		"aria-selected": selected,
		children: value,
		...props,
		onClick
	};
	props = useCompositeItem({
		state,
		getItem,
		preventScrollOnKeyDown,
		...props
	});
	const focusOnHoverProp = useBooleanEvent(focusOnHover);
	props = useCompositeHover({
		state,
		...props,
		focusOnHover: (event) => {
			var _state6;
			if (!focusOnHoverProp(event)) return false;
			return !!((_state6 = state) != null && _state6.open);
		}
	});
	return props;
});
/**
* A component that renders a select item inside a select list or select
* popover. The `role` prop will be automatically set based on the `SelectList`
* or `SelectPopover` own `role` prop. For example, if the `SelectPopover`
* component's `role` prop is set to `listbox` (default), the `SelectItem`
* `role` will be set to `option`. By default, the `value` prop will be rendered
* as the children, but this can be overriden.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const select = useSelectState();
* <Select state={select} />
* <SelectPopover state={select}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectPopover>
* ```
*/
var SelectItem = createMemoComponent((props) => {
	return createElement$1("div", useSelectItem(props));
});
if (process.env.NODE_ENV !== "production") SelectItem.displayName = "SelectItem";
//#endregion
//#region ../../node_modules/ariakit/esm/select/select-list.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a select list.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const state = useSelectState();
* const props = useSelectList({ state });
* <Role {...props}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </Role>
* ```
*/
var useSelectList = createHook((_ref) => {
	let { state, resetOnEscape = true, hideOnEnter = true, focusOnMove = true, composite = true, ...props } = _ref;
	const ref = useRef(null);
	const id = useId(props.id);
	const [defaultValue, setDefaultValue] = useState(state.value);
	const multiSelectable = Array.isArray(state.value);
	useEffect(() => {
		if (state.mounted) return;
		setDefaultValue(state.value);
	}, [state.mounted, state.value]);
	resetOnEscape = resetOnEscape && !multiSelectable;
	const onKeyDownProp = props.onKeyDown;
	const resetOnEscapeProp = useBooleanEvent(resetOnEscape);
	const hideOnEnterProp = useBooleanEvent(hideOnEnter);
	const onKeyDown = useEvent$1((event) => {
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (event.key === "Escape" && resetOnEscapeProp(event)) state.setValue(defaultValue);
		if (event.key === " " || event.key === "Enter") {
			if (isSelfTarget(event) && hideOnEnterProp(event)) {
				event.preventDefault();
				state.hide();
			}
		}
	});
	props = useStoreProvider({
		state,
		...props
	}, SelectContext);
	const labelId = useRefId(state.labelRef);
	const style = state.mounted ? props.style : {
		...props.style,
		display: "none"
	};
	if (composite) props = {
		role: "listbox",
		"aria-multiselectable": multiSelectable ? true : void 0,
		...props
	};
	props = {
		id,
		hidden: !state.mounted,
		"aria-labelledby": labelId,
		...props,
		ref: useForkRef(id ? state.setContentElement : null, ref, props.ref),
		style,
		onKeyDown
	};
	props = useComposite({
		state,
		...props,
		composite,
		focusOnMove: state.open && !state.animating && focusOnMove
	});
	props = useCompositeTypeahead({
		state,
		...props
	});
	return props;
});
/**
* A component that renders a select list. The `role` prop is set to `listbox`
* by default, but can be overriden by any other valid select popup role
* (`listbox`, `menu`, `tree`, `grid` or `dialog`). The `aria-labelledby` prop
* is set to the select input element's `id` by default.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const select = useSelectState();
* <Select state={select} />
* <SelectList state={select}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectList>
* ```
*/
var SelectList = createComponent((props) => {
	return createElement$1("div", useSelectList(props));
});
if (process.env.NODE_ENV !== "production") SelectList.displayName = "SelectList";
//#endregion
//#region ../../node_modules/ariakit/esm/select/select-popover.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a select popover.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const state = useSelectState();
* const props = useSelectPopover({ state });
* <Role {...props}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </Role>
* ```
*/
var useSelectPopover = createHook((_ref) => {
	var _values;
	let { state, ...props } = _ref;
	const values = toArray$1(state.value);
	const value = (_values = values[values.length - 1]) != null ? _values : "";
	const [item, setItem] = useState(null);
	useEffect(() => {
		let cleaning = false;
		setItem((prevItem) => {
			if (cleaning) return null;
			if (state.open && prevItem) return prevItem;
			return findEnabledItemByValue(state.items, value) || null;
		});
		return () => {
			cleaning = true;
		};
	}, [
		state.open,
		state.items,
		value
	]);
	props = useSelectList({
		state,
		...props
	});
	props = usePopover({
		state,
		initialFocusRef: (item == null ? void 0 : item.ref) || state.baseRef,
		...props
	});
	return props;
});
/**
* A component that renders a select popover. The `role` prop is set to
* `listbox` by default, but can be overriden by any other valid select popup
* role (`listbox`, `menu`, `tree`, `grid` or `dialog`).
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const select = useSelectState();
* <Select state={select} />
* <SelectPopover state={select}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectPopover>
* ```
*/
var SelectPopover = createComponent((props) => {
	return createElement$1("div", useSelectPopover(props));
});
if (process.env.NODE_ENV !== "production") SelectPopover.displayName = "SelectPopover";
//#endregion
//#region ../../node_modules/ariakit/esm/select/select-state.js
/**
* Provides state for the `Select` components.
* @example
* ```jsx
* const select = useSelectState({ defaultValue: "Apple" });
* <Select state={select} />
* <SelectPopover state={select}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectPopover>
* ```
*/
function useSelectState(_temp) {
	var _props$defaultValue, _props$value;
	let { virtualFocus = true, orientation = "vertical", placement = "bottom-start", setValueOnMove = false, defaultActiveId = null, includesBaseElement = false, ...props } = _temp === void 0 ? {} : _temp;
	const selectRef = useRef(null);
	const labelRef = useRef(null);
	const [value, setValue] = useControlledState((_props$defaultValue = props.defaultValue) != null ? _props$defaultValue : "", props.value, props.setValue);
	const composite = useCompositeState({
		...props,
		virtualFocus,
		orientation,
		defaultActiveId,
		includesBaseElement
	});
	const popover = usePopoverState({
		...props,
		placement
	});
	const initialValue = useInitialValue$1((_props$value = props.value) != null ? _props$value : props.defaultValue);
	const compositeRef = useLiveRef(composite);
	const multiSelectable = Array.isArray(value);
	useEffect(() => {
		if (multiSelectable) return;
		if (initialValue != null) return;
		if (!composite.items.length) return;
		const item = findFirstEnabledItemWithValue(composite.items);
		if (!(item != null && item.value)) return;
		setValue((prevValue) => {
			if (prevValue || !item.value) return prevValue;
			return item.value;
		});
	}, [
		multiSelectable,
		initialValue,
		composite.items,
		setValue
	]);
	useEffect(() => {
		if (popover.mounted) return;
		const values = toArray$1(value);
		const lastValue = values[values.length - 1];
		if (!lastValue) return;
		const item = findEnabledItemByValue(composite.items, lastValue);
		if (!item) return;
		composite.setActiveId(item.id);
	}, [
		popover.mounted,
		composite.items,
		value,
		composite.setActiveId
	]);
	const mountedRef = useLiveRef(popover.mounted);
	useEffect(() => {
		if (multiSelectable) return;
		if (!setValueOnMove && mountedRef.current) return;
		const { activeId, items } = compositeRef.current;
		if (!composite.moves) return;
		if (!activeId) return;
		const item = findEnabledItemWithValueById(items, activeId);
		if ((item == null ? void 0 : item.value) == null) return;
		setValue(item.value);
	}, [
		multiSelectable,
		setValueOnMove,
		composite.moves,
		setValue
	]);
	return useStorePublisher(useMemo(() => ({
		...composite,
		...popover,
		value,
		setValue,
		setValueOnMove,
		selectRef,
		labelRef
	}), [
		composite,
		popover,
		value,
		setValue,
		setValueOnMove
	]));
}
//#endregion
//#region ../../node_modules/ariakit/esm/select/select.js
function getSelectedValues(select) {
	return Array.from(select.selectedOptions).map((option) => option.value);
}
function nextWithValue(items, next) {
	return () => {
		var _nextItem;
		const nextId = next();
		if (!nextId) return;
		let i = 0;
		let nextItem = items.find((item) => item.id === nextId);
		const firstItem = nextItem;
		while (nextItem && nextItem.value == null) {
			const nextId = next(++i);
			if (!nextId) return;
			nextItem = items.find((item) => item.id === nextId);
			if (nextItem === firstItem) break;
		}
		return (_nextItem = nextItem) == null ? void 0 : _nextItem.id;
	};
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a select button.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const state = useSelectState();
* const props = useSelect({ state });
* <Role {...props} />
* ```
*/
var useSelect = createHook((_ref) => {
	let { state, name, form, required, showOnKeyDown = true, moveOnKeyDown = true, toggleOnClick = false, toggleOnPress = !toggleOnClick, ...props } = _ref;
	toggleOnPress = toggleOnClick ? false : toggleOnPress;
	const onKeyDownProp = props.onKeyDown;
	const showOnKeyDownProp = useBooleanEvent(showOnKeyDown);
	const moveOnKeyDownProp = useBooleanEvent(moveOnKeyDown);
	const toggleOnPressProp = useBooleanEvent(toggleOnPress);
	const dir = state.placement.split("-")[0];
	const multiSelectable = Array.isArray(state.value);
	const onKeyDown = useEvent$1((event) => {
		var _findFirstEnabledItem;
		onKeyDownProp?.(event);
		if (event.defaultPrevented) return;
		if (event.key === " " || event.key === "Enter") {
			if (toggleOnPressProp(event)) {
				event.preventDefault();
				state.toggle();
			}
		}
		const isVertical = state.orientation !== "horizontal";
		const isHorizontal = state.orientation !== "vertical";
		const isGrid = !!((_findFirstEnabledItem = findFirstEnabledItemWithValue(state.items)) != null && _findFirstEnabledItem.rowId);
		const getId = {
			ArrowUp: (isGrid || isVertical) && nextWithValue(state.items, state.up),
			ArrowRight: (isGrid || isHorizontal) && nextWithValue(state.items, state.next),
			ArrowDown: (isGrid || isVertical) && nextWithValue(state.items, state.down),
			ArrowLeft: (isGrid || isHorizontal) && nextWithValue(state.items, state.previous)
		}[event.key];
		if (getId && moveOnKeyDownProp(event)) {
			event.preventDefault();
			state.move(getId());
		}
		const isTopOrBottom = dir === "top" || dir === "bottom";
		if ({
			ArrowDown: isTopOrBottom,
			ArrowUp: isTopOrBottom,
			ArrowLeft: dir === "left",
			ArrowRight: dir === "right"
		}[event.key] && showOnKeyDownProp(event)) {
			event.preventDefault();
			state.show();
			state.move(state.activeId);
		}
	});
	const onMouseDownProp = props.onMouseDown;
	const onMouseDown = useEvent$1((event) => {
		onMouseDownProp?.(event);
		if (event.defaultPrevented) return;
		if (event.button) return;
		if (event.ctrlKey) return;
		if (!toggleOnPressProp(event)) return;
		const element = event.currentTarget;
		queueBeforeEvent(element, "focusin", () => {
			state.disclosureRef.current = element;
			state.toggle();
		});
	});
	props = useStoreProvider({
		state,
		...props
	}, SelectContext);
	const [autofill, setAutofill] = useState(false);
	const nativeSelectChangedRef = useRef(false);
	useEffect(() => {
		const nativeSelectChanged = nativeSelectChangedRef.current;
		nativeSelectChangedRef.current = false;
		if (nativeSelectChanged) return;
		setAutofill(false);
	}, [state.value]);
	const labelId = useRefId(state.labelRef);
	const label = props["aria-label"];
	const labelledBy = props["aria-labelledby"] || labelId;
	const values = useMemo(() => [...new Set(state.items.map((i) => i.value).filter((i) => i != null))], [state.items]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsxs(Fragment$1, { children: [/*#__PURE__*/ jsx(VisuallyHidden, {
		as: "select",
		tabIndex: -1,
		"aria-hidden": true,
		"aria-label": label,
		"aria-labelledby": labelledBy,
		name,
		form,
		required,
		value: state.value,
		multiple: multiSelectable,
		onFocus: () => {
			var _state$selectRef$curr;
			return (_state$selectRef$curr = state.selectRef.current) == null ? void 0 : _state$selectRef$curr.focus();
		},
		onChange: (event) => {
			nativeSelectChangedRef.current = true;
			setAutofill(true);
			state.setValue(multiSelectable ? getSelectedValues(event.target) : event.target.value);
		},
		children: values.map((value) => /*#__PURE__*/ jsx("option", {
			value,
			children: value
		}, value))
	}), element] }), [
		label,
		labelledBy,
		name,
		form,
		required,
		state.value,
		multiSelectable,
		state.selectRef,
		state.setValue,
		values
	]);
	const children = /*#__PURE__*/ jsxs(Fragment$1, { children: [state.value, /*#__PURE__*/ jsx(SelectArrow, {})] });
	props = {
		role: "combobox",
		"aria-autocomplete": "none",
		"aria-labelledby": labelId,
		"aria-haspopup": getPopupRole(state.contentElement, "listbox"),
		"data-autofill": autofill ? "" : void 0,
		children,
		...props,
		ref: useForkRef(state.selectRef, props.ref),
		onKeyDown,
		onMouseDown
	};
	props = usePopoverDisclosure({
		state,
		toggleOnClick,
		...props
	});
	props = useCompositeTypeahead({
		state,
		...props
	});
	return props;
});
/**
* A component that renders a select button.
* @see https://ariakit.org/components/select
* @example
* ```jsx
* const select = useSelectState();
* <Select state={select} />
* <SelectPopover state={select}>
*   <SelectItem value="Apple" />
*   <SelectItem value="Orange" />
* </SelectPopover>
* ```
*/
var Select$1 = createComponent((props) => {
	return createElement$1("button", useSelect(props));
});
if (process.env.NODE_ENV !== "production") Select$1.displayName = "Select";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-73a31bac.js
var TabContext = createStoreContext();
//#endregion
//#region ../../node_modules/ariakit/esm/tab/tab-list.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a tab list element.
* @see https://ariakit.org/components/tab
* @example
* ```jsx
* const state = useTabState();
* const props = useTabList({ state });
* <Role {...props}>
*   <Tab>Tab 1</Tab>
*   <Tab>Tab 2</Tab>
* </Role>
* <TabPanel state={state}>Panel 1</TabPanel>
* <TabPanel state={state}>Panel 2</TabPanel>
* ```
*/
var useTabList = createHook((_ref) => {
	let { state, ...props } = _ref;
	props = {
		role: "tablist",
		"aria-orientation": state.orientation === "both" ? void 0 : state.orientation,
		...props
	};
	props = useStoreProvider({
		state,
		...props
	}, TabContext);
	props = useComposite({
		state,
		...props
	});
	return props;
});
/**
* A component that renders a tab list element.
* @see https://ariakit.org/components/tab
* @example
* ```jsx
* const tab = useTabState();
* <TabList state={tab}>
*   <Tab>Tab 1</Tab>
*   <Tab>Tab 2</Tab>
* </TabList>
* <TabPanel state={tab}>Panel 1</TabPanel>
* <TabPanel state={tab}>Panel 2</TabPanel>
* ```
*/
var TabList = createComponent((props) => {
	return createElement$1("div", useTabList(props));
});
if (process.env.NODE_ENV !== "production") TabList.displayName = "TabList";
//#endregion
//#region ../../node_modules/ariakit/esm/tab/tab-panel.js
function getTabId(panels, id) {
	var _panels$items$find;
	if (!id) return;
	return (_panels$items$find = panels.items.find((panel) => panel.id === id)) == null ? void 0 : _panels$items$find.tabId;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a tab panel element.
* @see https://ariakit.org/components/tab
* @example
* ```jsx
* const state = useTabState();
* const props = useTabPanel({ state });
* <TabList state={state}>
*   <Tab>Tab 1</Tab>
* </TabList>
* <Role {...props}>Panel 1</Role>
* ```
*/
var useTabPanel = createHook((_ref) => {
	let { state, tabId: tabIdProp, getItem: getItemProp, ...props } = _ref;
	const ref = useRef(null);
	const id = useId(props.id);
	const [hasTabbableChildren, setHasTabbableChildren] = useState(false);
	useEffect(() => {
		const element = ref.current;
		if (!element) return;
		const tabbable = getAllTabbableIn(element);
		setHasTabbableChildren(!!tabbable.length);
	}, []);
	const getItem = useCallback((item) => {
		const nextItem = {
			...item,
			id,
			tabId: tabIdProp
		};
		if (getItemProp) return getItemProp(nextItem);
		return nextItem;
	}, [
		id,
		tabIdProp,
		getItemProp
	]);
	const tabId = tabIdProp || getTabId(state.panels, id);
	const open = !!tabId && state.selectedId === tabId;
	props = {
		id,
		role: "tabpanel",
		"aria-labelledby": tabId || void 0,
		...props,
		ref: useForkRef(ref, props.ref)
	};
	const disclosure = useDisclosureState({ open });
	props = useFocusable({
		focusable: !hasTabbableChildren,
		...props
	});
	props = useDisclosureContent({
		state: disclosure,
		...props
	});
	props = useCollectionItem({
		state: state.panels,
		...props,
		getItem
	});
	return props;
});
/**
* A component that renders a tab panel element.
* @see https://ariakit.org/components/tab
* @example
* ```jsx
* const tab = useTabState();
* <TabList state={tab}>
*   <Tab>Tab 1</Tab>
*   <Tab>Tab 2</Tab>
* </TabList>
* <TabPanel state={tab}>Panel 1</TabPanel>
* <TabPanel state={tab}>Panel 2</TabPanel>
* ```
*/
var TabPanel = createComponent((props) => {
	return createElement$1("div", useTabPanel(props));
});
if (process.env.NODE_ENV !== "production") TabPanel.displayName = "TabPanel";
//#endregion
//#region ../../node_modules/ariakit/esm/tab/tab-state.js
function findEnabledTabById(items, id) {
	return items.find((item) => item.id === id && !item.disabled && !item.dimmed);
}
function findFirstEnabledTab(items) {
	return items.find((item) => !item.disabled && !item.dimmed);
}
/**
* Provides state for the `Tab` components.
* @example
* ```jsx
* const tab = useTabState();
* <TabList state={tab}>
*   <Tab>Tab 1</Tab>
*   <Tab>Tab 2</Tab>
* </TabList>
* <TabPanel state={tab}>Panel 1</TabPanel>
* <TabPanel state={tab}>Panel 2</TabPanel>
* ```
*/
function useTabState(_temp) {
	let { orientation = "horizontal", focusLoop = true, selectOnMove = true, ...props } = _temp === void 0 ? {} : _temp;
	const [selectedId, setSelectedId] = useControlledState(props.defaultSelectedId, props.selectedId, props.setSelectedId);
	const composite = useCompositeState({
		orientation,
		focusLoop,
		...props
	});
	const panels = useCollectionState();
	const compositeRef = useLiveRef(composite);
	useEffect(() => {
		if (!selectOnMove) return;
		const { activeId, items } = compositeRef.current;
		if (!activeId) return;
		const tab = findEnabledTabById(items, activeId);
		if (!tab) return;
		setSelectedId(tab.id);
	}, [
		composite.moves,
		selectOnMove,
		setSelectedId
	]);
	useEffect(() => {
		if (selectedId === compositeRef.current.activeId) return;
		composite.setActiveId(selectedId);
	}, [selectedId, composite.setActiveId]);
	useEffect(() => {
		if (selectedId !== void 0) return;
		const activeId = compositeRef.current.activeId;
		if (findEnabledTabById(composite.items, activeId)) setSelectedId(activeId);
		else {
			const firstEnabledTab = findFirstEnabledTab(composite.items);
			setSelectedId(firstEnabledTab == null ? void 0 : firstEnabledTab.id);
		}
	}, [
		selectedId,
		composite.items,
		setSelectedId
	]);
	useEffect(() => {
		if (!composite.items.length) return;
		panels.setItems((prevPanels) => {
			if (!prevPanels.some((panel) => !panel.tabId)) return prevPanels;
			return prevPanels.map((panel, i) => {
				if (panel.tabId) return panel;
				const tab = composite.items[i];
				return {
					...panel,
					tabId: tab == null ? void 0 : tab.id
				};
			});
		});
	}, [composite.items, panels.setItems]);
	const select = useCallback((id) => {
		composite.move(id);
		setSelectedId(id);
	}, [composite.move, setSelectedId]);
	return useStorePublisher(useMemo(() => ({
		...composite,
		selectedId,
		setSelectedId,
		select,
		panels
	}), [
		composite,
		selectedId,
		setSelectedId,
		select,
		panels
	]));
}
//#endregion
//#region ../../node_modules/ariakit/esm/tab/tab.js
function getPanelId(panels, id) {
	var _panels$items$find;
	if (!id) return;
	return panels == null ? void 0 : (_panels$items$find = panels.items.find((panel) => panel.tabId === id)) == null ? void 0 : _panels$items$find.id;
}
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a tab element. The underlying element must be
* wrapped in a `TabList` component or a component that implements the
* `useTabList` props.
* @see https://ariakit.org/components/tab
* @example
* ```jsx
* const state = useTabState();
* const props = useTab({ state });
* <TabList state={state}>
*   <Role {...props}>Tab 1</Role>
* </TabList>
* <TabPanel state={state}>Panel 1</TabPanel>
* ```
*/
var useTab = createHook((_ref) => {
	var _state2, _state3;
	let { state, accessibleWhenDisabled = true, getItem: getItemProp, ...props } = _ref;
	const defaultId = useId();
	const id = props.id || defaultId;
	state = useStore(state || TabContext, [
		useCallback((s) => id && s.selectedId === id, [id]),
		"panels",
		"setSelectedId"
	]);
	const dimmed = props.disabled;
	const getItem = useCallback((item) => {
		const nextItem = {
			...item,
			dimmed
		};
		if (getItemProp) return getItemProp(nextItem);
		return nextItem;
	}, [dimmed, getItemProp]);
	const onClickProp = props.onClick;
	const onClick = useEvent$1((event) => {
		var _state;
		onClickProp?.(event);
		if (event.defaultPrevented) return;
		(_state = state) == null || _state.setSelectedId(id);
	});
	const panelId = getPanelId((_state2 = state) == null ? void 0 : _state2.panels, id);
	props = {
		id,
		role: "tab",
		"aria-selected": !!id && ((_state3 = state) == null ? void 0 : _state3.selectedId) === id,
		"aria-controls": panelId || void 0,
		...props,
		onClick
	};
	props = useCompositeItem({
		state,
		...props,
		accessibleWhenDisabled,
		getItem,
		shouldRegisterItem: !!defaultId ? props.shouldRegisterItem : false
	});
	return props;
});
/**
* A component that renders a tab element. The underlying element must be
* wrapped in a `TabList` component.
* @see https://ariakit.org/components/tab
* @example
* ```jsx
* const tab = useTabState();
* <TabList state={tab}>
*   <Tab>Tab 1</Tab>
*   <Tab>Tab 2</Tab>
* </TabList>
* <TabPanel state={tab}>Panel 1</TabPanel>
* <TabPanel state={tab}>Panel 2</TabPanel>
* ```
*/
var Tab = createMemoComponent((props) => {
	return createElement$1("button", useTab(props));
});
if (process.env.NODE_ENV !== "production") Tab.displayName = "Tab";
//#endregion
//#region ../../node_modules/ariakit/esm/tooltip/tooltip-anchor.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an element that will be labelled or described by
* a `Tooltip` component. This component will also be used as the reference to
* position the tooltip on the screen.
* @see https://ariakit.org/components/tooltip
* @example
* ```jsx
* const state = useToolTipState();
* const props = useTooltipAnchor({ state });
* <Role {...props}>Anchor</Role>
* <Tooltip state={state}>Tooltip</Tooltip>
* ```
*/
var useTooltipAnchor = createHook((_ref) => {
	var _state$contentElement, _state$contentElement2;
	let { state, described, ...props } = _ref;
	const onFocusProp = props.onFocus;
	const onFocus = useEvent$1((event) => {
		onFocusProp?.(event);
		if (event.defaultPrevented) return;
		if (state.anchorRef.current !== event.currentTarget) {
			state.anchorRef.current = event.currentTarget;
			state.render();
		}
		state.show();
	});
	const onBlurProp = props.onBlur;
	const onBlur = useEvent$1((event) => {
		onBlurProp?.(event);
		if (event.defaultPrevented) return;
		state.hide();
	});
	const onMouseEnterProp = props.onMouseEnter;
	const onMouseEnter = useEvent$1((event) => {
		onMouseEnterProp?.(event);
		if (event.defaultPrevented) return;
		if (state.anchorRef.current !== event.currentTarget) {
			state.anchorRef.current = event.currentTarget;
			state.render();
		}
		state.show();
	});
	const onMouseLeaveProp = props.onMouseLeave;
	const onMouseLeave = useEvent$1((event) => {
		onMouseLeaveProp?.(event);
		if (event.defaultPrevented) return;
		state.hide();
	});
	props = {
		tabIndex: 0,
		"aria-labelledby": !described ? (_state$contentElement = state.contentElement) == null ? void 0 : _state$contentElement.id : void 0,
		"aria-describedby": described ? (_state$contentElement2 = state.contentElement) == null ? void 0 : _state$contentElement2.id : void 0,
		...props,
		onFocus,
		onBlur,
		onMouseEnter,
		onMouseLeave
	};
	props = usePopoverAnchor({
		state,
		...props
	});
	return props;
});
/**
* A component that renders an element that will be labelled or described by
* a `Tooltip` component. This component will also be used as the reference to
* position the tooltip on the screen.
* @see https://ariakit.org/components/tooltip
* @example
* ```jsx
* const tooltip = useTooltipState();
* <TooltipAnchor state={tooltip}>Anchor</TooltipAnchor>
* <Tooltip state={tooltip}>Tooltip</Tooltip>
* ```
*/
var TooltipAnchor = createComponent((props) => {
	return createElement$1("div", useTooltipAnchor(props));
});
if (process.env.NODE_ENV !== "production") TooltipAnchor.displayName = "TooltipAnchor";
//#endregion
//#region ../../node_modules/ariakit/esm/__utils-30a60887.js
function createGlobalTooltipState() {
	return {
		activeRef: null,
		listeners: /* @__PURE__ */ new Set(),
		subscribe(listener) {
			this.listeners.add(listener);
			return () => {
				this.listeners.delete(listener);
			};
		},
		show(ref) {
			this.activeRef = ref;
			this.listeners.forEach((listener) => listener(ref));
		},
		hide(ref) {
			if (this.activeRef === ref) {
				this.activeRef = null;
				this.listeners.forEach((listener) => listener(null));
			}
		}
	};
}
var TooltipContext = /*#__PURE__*/ createContext(void 0);
//#endregion
//#region ../../node_modules/ariakit/esm/tooltip/tooltip-arrow.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render an arrow inside a tooltip element.
* @see https://ariakit.org/components/tooltip
* @example
* ```jsx
* const state = useToolTipState();
* const props = useTooltipArrow({ state });
* <TooltipAnchor state={state}>Anchor</TooltipAnchor>
* <Tooltip state={state}>
*   <Role {...props} />
*   Tooltip
* </Tooltip>
* ```
*/
var useTooltipArrow = createHook((_ref) => {
	let { state, size = 16, ...props } = _ref;
	const context = useContext(TooltipContext);
	state = state || context;
	props = usePopoverArrow({
		state,
		size,
		...props
	});
	return props;
});
/**
* A component that renders an arrow inside a `Tooltip` component.
* @see https://ariakit.org/components/tooltip
* @example
* ```jsx
* const tooltip = useTooltipState();
* <TooltipAnchor state={tooltip}>Anchor</TooltipAnchor>
* <Tooltip state={tooltip}>
*   <TooltipArrow />
*   Tooltip
* </Tooltip>
* ```
*/
var TooltipArrow = createComponent((props) => {
	return createElement$1("div", useTooltipArrow(props));
});
if (process.env.NODE_ENV !== "production") TooltipArrow.displayName = "TooltipArrow";
//#endregion
//#region ../../node_modules/ariakit/esm/tooltip/tooltip-state.js
var globalState = createGlobalTooltipState();
/**
* Provides state for the `Tooltip` components.
* @example
* ```jsx
* const tooltip = useTooltipState();
* <TooltipAnchor state={tooltip}>Anchor</TooltipAnchor>
* <Tooltip state={tooltip}>Tooltip</Tooltip>
* ```
*/
function useTooltipState(_temp) {
	var _props$defaultOpen, _props$defaultOpen2, _props$open;
	let { placement = "top", timeout = 0, gutter = 8, ...props } = _temp === void 0 ? {} : _temp;
	const ref = useRef();
	const showTimeout = useRef();
	const hideTimeout = useRef();
	const clearTimeouts = useCallback(() => {
		window.clearTimeout(showTimeout.current);
		window.clearTimeout(hideTimeout.current);
	}, []);
	const [_open, __setOpen] = useState((_props$defaultOpen = props.defaultOpen) != null ? _props$defaultOpen : false);
	const _setOpen = (nextOpen) => {
		props.setOpen == null || props.setOpen(nextOpen);
		if (props.open === void 0) __setOpen(nextOpen);
	};
	const [open, setOpen] = useControlledState((_props$defaultOpen2 = props.defaultOpen) != null ? _props$defaultOpen2 : false, (_props$open = props.open) != null ? _props$open : _open, (nextOpen) => {
		clearTimeouts();
		if (nextOpen) {
			if (!timeout || globalState.activeRef) globalState.show(ref);
			else {
				globalState.show(null);
				showTimeout.current = window.setTimeout(() => {
					globalState.show(ref);
					_setOpen(nextOpen);
				}, timeout);
				return;
			}
		} else hideTimeout.current = window.setTimeout(() => {
			globalState.hide(ref);
		}, timeout);
		_setOpen(nextOpen);
	});
	const popover = usePopoverState({
		placement,
		gutter,
		...props,
		open,
		setOpen
	});
	useEffect(() => {
		return globalState.subscribe((activeRef) => {
			if (activeRef !== ref) {
				clearTimeouts();
				if (popover.open) popover.hide();
			}
		});
	}, [
		clearTimeouts,
		popover.open,
		popover.hide
	]);
	useEffect(() => () => {
		clearTimeouts();
		globalState.hide(ref);
	}, [clearTimeouts]);
	return useMemo(() => ({
		...popover,
		timeout
	}), [popover, timeout]);
}
//#endregion
//#region ../../node_modules/ariakit/esm/tooltip/tooltip.js
/**
* A component hook that returns props that can be passed to `Role` or any other
* Ariakit component to render a tooltip element.
* @see https://ariakit.org/components/tooltip
* @example
* ```jsx
* const state = useToolTipState();
* const props = useTooltip({ state });
* <TooltipAnchor state={state}>Anchor</TooltipAnchor>
* <Role {...props}>Tooltip</Role>
* ```
*/
var useTooltip = createHook((_ref) => {
	let { state, portal = true, hideOnEscape = true, hideOnControl = false, wrapperProps, ...props } = _ref;
	const popoverRef = state.popoverRef;
	useSafeLayoutEffect(() => {
		const wrapper = popoverRef.current;
		const tooltip = state.contentElement;
		if (!wrapper) return;
		if (!tooltip) return;
		wrapper.style.zIndex = getComputedStyle(tooltip).zIndex;
	}, [popoverRef, state.contentElement]);
	const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
	const hideOnControlProp = useBooleanEvent(hideOnControl);
	useEffect(() => {
		if (!state.open) return;
		return addGlobalEventListener("keydown", (event) => {
			if (event.defaultPrevented) return;
			const isEscape = event.key === "Escape" && hideOnEscapeProp(event);
			const isControl = event.key === "Control" && hideOnControlProp(event);
			if (isEscape || isControl) state.hide();
		});
	}, [
		state.open,
		hideOnEscapeProp,
		hideOnControlProp,
		state.hide
	]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx("div", {
		role: "presentation",
		...wrapperProps,
		style: {
			position: state.fixed ? "fixed" : "absolute",
			top: 0,
			left: 0,
			...wrapperProps == null ? void 0 : wrapperProps.style
		},
		ref: popoverRef,
		children: element
	}), [
		state.fixed,
		popoverRef,
		wrapperProps
	]);
	props = useWrapElement(props, (element) => /*#__PURE__*/ jsx(TooltipContext.Provider, {
		value: state,
		children: element
	}), [state]);
	props = {
		role: "tooltip",
		...props
	};
	props = useDisclosureContent({
		state,
		...props
	});
	props = usePortal({
		portal,
		...props,
		preserveTabOrder: false
	});
	return props;
});
/**
* A component that renders a tooltip element.
* @see https://ariakit.org/components/tooltip
* @example
* ```jsx
* const tooltip = useTooltipState();
* <TooltipAnchor state={tooltip}>Anchor</TooltipAnchor>
* <Tooltip state={tooltip}>Tooltip</Tooltip>
* ```
*/
var Tooltip$1 = createComponent((props) => {
	return createElement$1("div", useTooltip(props));
});
if (process.env.NODE_ENV !== "production") Tooltip$1.displayName = "Tooltip";
//#endregion
//#region src/components/atoms/card/card.styled.ts
var CARD_ROUNDED_VARIANTS = {
	default: "rounded",
	md: "rounded-md",
	lg: "rounded-lg",
	full: "rounded-full"
};
var StyledCard = (0, import_dist.default)(Role)`
  ${({ $roundedVariant }) => CARD_ROUNDED_VARIANTS[$roundedVariant]}
  ${({ $shadow }) => $shadow ? "shadow" : ""}
  ${({ $shadow }) => $shadow ? "border border-gray-200" : ""}
`;
//#endregion
//#region src/components/atoms/card/Card.tsx
var Card = ({ border = true, children, roundedVariant = "default", shadow = true, ...props }) => /* @__PURE__ */ React.createElement(StyledCard, {
	$roundedVariant: roundedVariant,
	$shadow: shadow,
	$border: border,
	...props
}, children);
var CardMemo = memo(Card);
//#endregion
//#region src/components/atoms/checkbox/checkbox.styled.ts
var CheckboxAtom = (0, import_dist.default)(Checkbox$1)`
    focus:ring-primary-500
    h-4
    w-4
    text-primary-600
    border-gray-300
    rounded
    disabled:cursor-not-allowed
    disabled:bg-gray-100
    disabled:border-gray-200
`;
//#endregion
//#region src/components/atoms/grid/grid.styled.ts
var GRID_TO_COLUMN_STYLE_MAP = {
	1: "grid-cols-1",
	2: "grid-cols-2",
	3: "grid-cols-3",
	4: "grid-cols-4",
	5: "grid-cols-5",
	6: "grid-cols-6",
	7: "grid-cols-7",
	8: "grid-cols-8",
	9: "grid-cols-9",
	10: "grid-cols-10",
	11: "grid-cols-11",
	12: "grid-cols-12"
};
var StyledGrid = import_dist.default.div`
  grid
  ${({ $cols }) => GRID_TO_COLUMN_STYLE_MAP[$cols]}
  ${({ $gap }) => GAP_XY[$gap]}
`;
var SIZE_SPAN_STYLE_MAP = {
	1: "col-span-1",
	2: "col-span-2",
	3: "col-span-3",
	4: "col-span-4",
	5: "col-span-5",
	6: "col-span-6",
	7: "col-span-7",
	8: "col-span-8",
	9: "col-span-9",
	10: "col-span-10",
	11: "col-span-11",
	12: "col-span-12"
};
var StyledGridItem = import_dist.default.div`
  ${({ $size }) => $size ? SIZE_SPAN_STYLE_MAP[$size] : ""}
`;
//#endregion
//#region src/components/atoms/grid/Grid.tsx
var Grid = ({ children, className, cols, gap }) => /* @__PURE__ */ React.createElement(StyledGrid, {
	$cols: cols,
	$gap: gap,
	className
}, children);
memo(Grid);
//#endregion
//#region src/components/atoms/grid/GridItem.tsx
var GridItem = ({ children, className, size }) => /* @__PURE__ */ React.createElement(StyledGridItem, {
	$size: size,
	className
}, children);
//#endregion
//#region src/components/atoms/icon/icon.styled.ts
var IconSizesStyle = {
	2: "h-2 w-2",
	3: "h-3 w-3",
	4: "h-4 w-4",
	[4.5]: "h-[1.125rem] w-[1.125rem]",
	5: "h-5 w-5",
	6: "h-6 w-6",
	8: "h-8 w-8",
	9: "h-9 w-9",
	10: "h-10 w-10",
	12: "h-12 w-12",
	14: "h-14 w-14",
	16: "h-16 w-16"
};
var ICON_COLOR_VARIANTS = {
	default: "",
	primary: "border-2 border-primary-600",
	primaryFilled: "border-2 border-primary-600 bg-primary-600",
	secondary: "border-2 border-blue-600",
	secondaryFilled: "border-2 border-blue-600 bg-blue-600",
	red: "border-2 border-rsbry-700",
	redFilled: "border-2 border-rsbry-700 bg-rsbry-700",
	green: "border-2 border-green-600",
	greenFilled: "border-2 border-green-600 bg-green-600",
	gray: "border-2 border-gray-600",
	grayFilled: "border-2 border-gray-600 bg-gray-600",
	lightGray: "border-2 border-gray-500",
	lightGrayFilled: "border-2 border-gray-500 bg-gray-500",
	info: "text-blue-600",
	success: "text-green-300",
	warning: "text-lemon-400",
	error: "text-rsbry-600",
	none: "text-gray-400"
};
var IconVariantContainerStyles = {
	none: "",
	circular: "rounded-full",
	rounded: "rounded-md"
};
var StyledIconContainer = import_dist.default.div`
  ${({ $colorVariant }) => ICON_COLOR_VARIANTS[$colorVariant]}
  ${({ $size }) => IconSizesStyle[$size]}
  ${({ $variant }) => IconVariantContainerStyles[$variant]}
  flex
  items-center
  justify-center
`;
var StyledIcon$3 = import_dist.default.div`
  ${({ $size }) => IconSizesStyle[$size]}
  flex
  [&>*]:grow
  items-center
  justify-center
`;
//#endregion
//#region src/components/atoms/icon/Icon.tsx
var Icon = ({ className, colorVariant = "default", node, size, nodeSize = size, variant = "none", testId }) => /* @__PURE__ */ React.createElement(StyledIconContainer, {
	$size: size,
	$variant: variant,
	$colorVariant: colorVariant,
	className,
	"data-testid": testId
}, /* @__PURE__ */ React.createElement(StyledIcon$3, { $size: nodeSize }, node));
var IconMemo = memo(Icon);
//#endregion
//#region src/components/atoms/loading/spinner.styled.ts
var getSpinnerType = (variant) => {
	switch (variant) {
		case "secondary": return "border-gray-300 border-t-primary-700";
		case "white": return "border-gray-700 border-t-white";
		default: return "border-gray-300 border-t-primary-600";
	}
};
var getSpinnerSize = (size) => {
	switch (size) {
		case "xs": return "h-2 w-2";
		case "sm": return "h-4 w-4";
		case "base": return "h-6 w-6";
		case "lg": return "h-8 w-8";
		case "xl": return "h-12 w-12";
		default: return "h-6 w-6";
	}
};
var StyledSpinner = import_dist.default.div`
  inline-block
  animate-spin
  rounded-full
  border-2
  ${({ $variant }) => getSpinnerType($variant)}
  ${({ $size }) => getSpinnerSize($size)}
`;
//#endregion
//#region src/components/atoms/loading/Spinner.tsx
var Spinner = ({ className, size = "base", variant = "primary" }) => /* @__PURE__ */ React.createElement(StyledSpinner, {
	role: "status",
	$size: size,
	$variant: variant,
	className
}, /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, "Loading..."));
//#endregion
//#region src/components/atoms/loading/Loading.tsx
var Loading = ({ height }) => /* @__PURE__ */ React.createElement("div", { style: {
	height,
	width: "100%",
	display: "flex",
	alignItems: "center",
	justifyContent: "center"
} }, /* @__PURE__ */ React.createElement(Spinner, { size: height >= 100 ? "xl" : height >= 50 ? "lg" : "base" }));
//#endregion
//#region src/components/atoms/progress-bar/progress-bar.styled.ts
var ProgressContainer = import_dist.default.div`
  bg-gray-300
  rounded-lg
  h-2.5
  w-full
  flex
`;
var ProgressBarSpan = import_dist.default.span`
  bg-blue-600
  rounded-lg
  h-2.5
  w-0
`;
//#endregion
//#region src/components/atoms/progress-bar/ProgressBar.tsx
var ProgressBar = ({ className, maxPercentage = 100 }) => {
	const [percentage, setPercentage] = useState(0);
	useEffect(() => {
		setPercentage(maxPercentage);
	}, [maxPercentage]);
	return /* @__PURE__ */ React.createElement(ProgressContainer, { className }, /* @__PURE__ */ React.createElement(ProgressBarSpan, { style: {
		width: `${percentage}%`,
		transition: "width 30s"
	} }));
};
//#endregion
//#region src/components/form-items/general-form-error/general-form-error.styled.ts
var ErrorText$1 = import_dist.default.p`
  mb-0
  text-sm
  text-rsbry-600
  ${({ $centered }) => $centered ? "text-center" : ""}
`;
//#endregion
//#region src/components/form-items/general-form-error/GeneralFormError.tsx
var GeneralFormError = ({ centered, children, className, error, id }) => error ? /* @__PURE__ */ React.createElement(ErrorText$1, {
	id,
	$centered: centered,
	className,
	role: "alert"
}, children) : null;
var GeneralFormErrorMemo = memo(GeneralFormError);
//#endregion
//#region src/assets/icons/arrow-down-1.svg
var SvgArrowDown1 = (props, ref) => /* @__PURE__ */ jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	enableBackground: "new 0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M12,19.5c-0.7,0-1.3-0.3-1.7-0.8L0.4,7.6C-0.2,6.8-0.1,5.6,0.7,5c0.8-0.6,1.9-0.6,2.5,0.2l8.6,9.8 c0.1,0.1,0.2,0.1,0.4,0c0,0,0,0,0,0l8.6-9.8c0.7-0.8,1.8-0.9,2.6-0.2s0.9,1.8,0.2,2.6c0,0,0,0-0.1,0.1l-9.8,11.1 C13.3,19.2,12.6,19.5,12,19.5z",
		fill: "currentColor"
	})
});
var ForwardRef$28 = forwardRef(SvgArrowDown1);
var Memo$28 = memo(ForwardRef$28);
//#endregion
//#region src/assets/icons/check.svg
var SvgCheck = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M5 13L9 17L19 7",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
var ForwardRef$27 = forwardRef(SvgCheck);
var Memo$27 = memo(ForwardRef$27);
//#endregion
//#region src/components/atoms/select/select.styled.ts
var StyledSelectContainer = import_dist.default.div`
  relative
  [&>div:nth-child(3)]:w-full
  [&>div:nth-child(3)]:!translate-y-[42px]
`;
var StyledSelect = (0, import_dist.default)(Select$1)`
  block
  w-full
  text-left
  rounded-md
  border
  border-gray-300
  py-2
  pl-3
  pr-10
  text-base
  focus:border-primary-500
  focus:outline-none
  focus:ring-primary-500
  sm:text-sm
  ${({ $isPlaceholder }) => $isPlaceholder ? "text-gray-400" : "text-gray-800"}
`;
var StyledArrowSpan = import_dist.default.span`
  pointer-events-none
  absolute
  inset-y-0
  right-0
  flex
  items-center
  pr-2
  w-auto
  h-auto
`;
var StyledSelectPopover = (0, import_dist.default)(SelectPopover)`
  absolute
  z-modal
  max-h-60
  w-full
  overflow-auto
  rounded-md
  bg-white
  py-1
  text-base
  shadow-lg
  ring-1
  ring-black
  ring-opacity-5
  focus:outline-none
  sm:text-sm
`;
var StyledSelectItem = (0, import_dist.default)(SelectItem)`
  relative
  cursor-default
  select-none
  py-2
  pl-3
  pr-9
  text-gray-900
  [&[data-active-item]]:bg-primary-600
  [&[data-active-item]]:text-white
  [&[aria-disabled]]:opacity-50
  transition-colors
  ${({ $active }) => $active ? "font-medium" : ""}
`;
var StyledCheckSpan = import_dist.default.span`
  absolute
  inset-y-0
  right-0
  flex
  items-center
  pr-4
  text-primary-600
`;
var StyledSelectSectionLabel = import_dist.default.div`
  px-2 
  py-0.5 
  bg-gray-200 
  text-xs 
  font-medium 
  text-gray-800
`;
//#endregion
//#region src/components/atoms/select/select.utils.ts
var isSelectSection = (option) => "options" in option && Array.isArray(option.options);
var isSectionedOptions = (options) => options.length > 0 && isSelectSection(options[0]);
var getFlatOptions = (options) => {
	if (!options.length) return [];
	if (isSectionedOptions(options)) return options.flatMap((section) => section.options);
	return options;
};
var getLabel = ({ currentValue, options, placeholder }) => {
	return getFlatOptions(options).find((option) => option.value === currentValue)?.label || placeholder;
};
//#endregion
//#region src/components/atoms/select/Select.tsx
var getSelectPopoverId = (id) => `popover-${id}`;
var Select = ({ className, disabled, error, errorText, id, onChange, options, placeholder, usePortal = false, value }) => {
	const selectState = useSelectState({
		setValue: onChange,
		value,
		defaultValue: placeholder,
		sameWidth: true
	});
	const renderSelectItem = (option, value, selectState) => /* @__PURE__ */ React.createElement(StyledSelectItem, {
		key: option.value,
		value: option.value,
		$active: option.value === value,
		disabled: option.disabled
	}, option.label ? option.label : option.value, option.value === selectState.value && /* @__PURE__ */ React.createElement(StyledCheckSpan, null, /* @__PURE__ */ React.createElement(Memo$27, { className: "h-3 w-3" })));
	const renderOptions = (options) => {
		if (!options.length) return null;
		if (isSectionedOptions(options)) return options.map((section, index) => /* @__PURE__ */ React.createElement(React.Fragment, { key: section.label || `section-${index}` }, section.label && /* @__PURE__ */ React.createElement(StyledSelectSectionLabel, null, section.label), section.options.map((option) => renderSelectItem(option, value, selectState))));
		return options.map((option) => renderSelectItem(option, value, selectState));
	};
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledSelectContainer, { className }, /* @__PURE__ */ React.createElement(StyledSelect, {
		id,
		state: selectState,
		$isPlaceholder: selectState.value === placeholder,
		onChange,
		disabled
	}, getLabel({
		options,
		placeholder,
		currentValue: selectState.value
	}), /* @__PURE__ */ React.createElement(StyledArrowSpan, null, /* @__PURE__ */ React.createElement(Memo$28, { className: "h-[10px] text-gray-400" }))), /* @__PURE__ */ React.createElement(StyledSelectPopover, {
		portal: usePortal,
		state: selectState,
		id: getSelectPopoverId(id)
	}, renderOptions(options))), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!error && !!errorText,
		id: `${id}-error`
	}, errorText));
};
var SelectMemo = memo(Select);
//#endregion
//#region src/components/atoms/select/hooks/useMonthDateOptions.ts
var useMonthDateOptions = (month) => useMemo(() => getMonthDateOptions(month), [month]);
//#endregion
//#region src/components/atoms/stack/stack.styled.ts
var alignItems = {
	normal: "",
	start: "items-start",
	center: "items-center",
	end: "items-end"
};
var justifyContent = {
	normal: "",
	start: "justify-start",
	center: "justify-center",
	end: "justify-end",
	"space-between": "justify-between",
	"space-around": "justify-around",
	"space-evenly": "justify-evenly"
};
var flexDirection = {
	row: "",
	column: "flex-col",
	"row-reverse": "flex-row-reverse"
};
var flexWrap = {
	nowrap: "flex-nowrap",
	wrap: "flex-wrap",
	"wrap-reverse": "flex-wrap-reverse"
};
var getSpace = (space, direction) => {
	if (space === void 0) return "";
	if (typeof space === "number" && space < 0) throw new TypeError("Unexpected negative space");
	return direction === "row" ? getSpaceX(space) : getSpaceY(space);
};
var getGap = (gap) => {
	if (gap === void 0) return "";
	if (typeof gap === "number" || typeof gap === "string") return getGapXY(gap);
	if (Array.isArray(gap)) {
		if (gap.length !== 2) throw new TypeError("Stack 'gap' prop is an array so its length MUST equal 2");
		return [getGapX(gap[0]), getGapY(gap[1])].join(" ");
	}
	if (Object.getPrototypeOf(gap) === Object.prototype) {
		if (!Object.prototype.hasOwnProperty.call(gap, "x") && !Object.prototype.hasOwnProperty.call(gap, "y")) throw new TypeError("Stack 'gap' prop is an object so it MUST include either an 'x' or 'y' key-value pair or both");
		const gapClasses = [];
		if (gap.x != null) gapClasses.push(getGapX(gap.x));
		if (gap.y != null) gapClasses.push(getGapY(gap.y));
		return gapClasses.join(" ");
	}
	throw new TypeError(`Unexpected input for Stack "gap" prop. Value: ${JSON.stringify(gap)}. Type: ${typeof gap}.`);
};
var StyledStack$4 = (0, import_dist.default)(Role)`
  flex
  ${({ $direction }) => flexDirection[$direction]}
  ${({ $alignItems }) => alignItems[$alignItems]}
  ${({ $justifyContent }) => justifyContent[$justifyContent]}
  ${({ $direction, $space }) => getSpace($space, $direction)}
  ${({ $wrap }) => flexWrap[$wrap]}
  ${({ $gap }) => getGap($gap)}
  ${({ $paddingX }) => getPaddingX($paddingX)}
  ${({ $paddingY }) => getPaddingY($paddingY)}
  ${({ $boxShadow }) => getBoxShadow($boxShadow)}
  ${({ $borderRadius }) => getBorderRadius($borderRadius)}
  ${({ $overflow }) => getOverflow($overflow)}
  ${({ $fullWidth }) => $fullWidth ? "w-full" : ""}
  ${({ $fullHeight }) => $fullHeight ? "h-full" : ""}
`;
//#endregion
//#region src/components/atoms/stack/Stack.tsx
var StackWithForwardRef = ({ alignItems = "normal", backgroundColor, borderRadius, boxShadow, children, className, color, direction = "row", fullHeight, fullWidth, gap, justifyContent = "normal", onMouseEnter, onMouseLeave, overflow, paddingX, paddingY, space, style, testId, wrap, ...restProps }, ref) => /* @__PURE__ */ React.createElement(StyledStack$4, {
	ref,
	$alignItems: alignItems,
	$direction: direction,
	$fullHeight: fullHeight,
	$fullWidth: fullWidth,
	$gap: gap,
	$justifyContent: justifyContent,
	$space: space,
	$wrap: wrap,
	$paddingX: paddingX,
	$paddingY: paddingY,
	$boxShadow: boxShadow,
	$borderRadius: borderRadius,
	$overflow: overflow,
	className,
	"data-testid": testId,
	onMouseEnter,
	onMouseLeave,
	style: {
		color,
		backgroundColor,
		...style
	},
	...restProps
}, children);
var Stack = React.forwardRef(StackWithForwardRef);
Stack.displayName = "Stack";
var StackMemo = memo(Stack);
//#endregion
//#region src/components/atoms/typography/typography.styled.ts
var FONT_SIZE = {
	inherit: "",
	"2xs": "text-[0.5rem]",
	xs: "text-xs",
	sm: "text-sm",
	base: "text-base",
	lg: "text-lg",
	xl: "text-xl",
	"2xl": "text-2xl",
	"3xl": "text-3xl",
	"4xl": "text-4xl",
	"5xl": "text-5xl",
	"6xl": "text-6xl",
	"7xl": "text-7xl",
	"8xl": "text-8xl",
	"9xl": "text-9xl"
};
var FONT_WEIGHT = {
	inherit: "",
	thin: "font-thin",
	extralight: "font-extralight",
	light: "font-light",
	normal: "font-normal",
	medium: "font-medium",
	semibold: "font-semibold",
	bold: "font-bold",
	extrabold: "font-extrabold",
	black: "font-black"
};
var FONT_FAMILY = {
	inherit: "",
	caveat: "font-caveat",
	sans: "font-sans",
	serif: "font-serif"
};
var LINE_HEIGHT = {
	inherit: "",
	3: "leading-3",
	4: "leading-4",
	5: "leading-5",
	6: "leading-6",
	7: "leading-7",
	8: "leading-8",
	9: "leading-9",
	10: "leading-10",
	none: "leading-none",
	tight: "leading-tight",
	snug: "leading-snug",
	normal: "leading-normal",
	relaxed: "leading-relaxed",
	loose: "leading-loose"
};
var TEXT_ALIGN = {
	inherit: "",
	left: "text-left",
	center: "text-center",
	right: "text-right",
	justify: "text-justify",
	start: "text-start",
	end: "text-end"
};
var StyledTypography$3 = import_dist.default.span`
  text-gray-900
  ${({ $fontFamily }) => FONT_FAMILY[$fontFamily]}
  ${({ $fontSize }) => FONT_SIZE[$fontSize]}
  ${({ $fontWeight }) => FONT_WEIGHT[$fontWeight]}
  ${({ $lineHeight }) => LINE_HEIGHT[$lineHeight]}
  ${({ $overflow }) => getOverflow($overflow)}
  ${({ $textAlign }) => TEXT_ALIGN[$textAlign]}
  ${({ $textOverflow }) => getTextOverflow($textOverflow)}
  ${({ $textTransform }) => getTextTransform($textTransform)}
  ${({ $textDecoration }) => getTextDecoration($textDecoration)}
  ${({ $whiteSpace }) => getWhiteSpace($whiteSpace)}
`;
//#endregion
//#region src/components/atoms/typography/Typography.tsx
var Typography = ({ as, children, className, color, fontFamily = "sans", fontSize = "base", fontWeight = "normal", id, lineHeight, overflow, textAlign, textDecoration, textOverflow, textTransform, whiteSpace, ...restProps }) => /* @__PURE__ */ React.createElement(StyledTypography$3, {
	$as: as,
	$fontFamily: fontFamily,
	$fontSize: fontSize,
	$fontWeight: fontWeight,
	$lineHeight: lineHeight,
	$overflow: overflow,
	$textAlign: textAlign,
	$textOverflow: textOverflow,
	$textTransform: textTransform,
	$textDecoration: textDecoration,
	$whiteSpace: whiteSpace,
	className,
	"data-testid": `typography-component-${id ?? ""}`,
	id,
	style: { color },
	...restProps
}, children);
var TypographyMemo = memo(Typography);
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends$3() {
	return _extends$3 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$3.apply(null, arguments);
}
//#endregion
//#region ../../node_modules/match-sorter/dist/match-sorter.esm.js
var import_remove_accents = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	var characterMap = {
		"À": "A",
		"Á": "A",
		"Â": "A",
		"Ã": "A",
		"Ä": "A",
		"Å": "A",
		"Ấ": "A",
		"Ắ": "A",
		"Ẳ": "A",
		"Ẵ": "A",
		"Ặ": "A",
		"Æ": "AE",
		"Ầ": "A",
		"Ằ": "A",
		"Ȃ": "A",
		"Ç": "C",
		"Ḉ": "C",
		"È": "E",
		"É": "E",
		"Ê": "E",
		"Ë": "E",
		"Ế": "E",
		"Ḗ": "E",
		"Ề": "E",
		"Ḕ": "E",
		"Ḝ": "E",
		"Ȇ": "E",
		"Ì": "I",
		"Í": "I",
		"Î": "I",
		"Ï": "I",
		"Ḯ": "I",
		"Ȋ": "I",
		"Ð": "D",
		"Ñ": "N",
		"Ò": "O",
		"Ó": "O",
		"Ô": "O",
		"Õ": "O",
		"Ö": "O",
		"Ø": "O",
		"Ố": "O",
		"Ṍ": "O",
		"Ṓ": "O",
		"Ȏ": "O",
		"Ù": "U",
		"Ú": "U",
		"Û": "U",
		"Ü": "U",
		"Ý": "Y",
		"à": "a",
		"á": "a",
		"â": "a",
		"ã": "a",
		"ä": "a",
		"å": "a",
		"ấ": "a",
		"ắ": "a",
		"ẳ": "a",
		"ẵ": "a",
		"ặ": "a",
		"æ": "ae",
		"ầ": "a",
		"ằ": "a",
		"ȃ": "a",
		"ç": "c",
		"ḉ": "c",
		"è": "e",
		"é": "e",
		"ê": "e",
		"ë": "e",
		"ế": "e",
		"ḗ": "e",
		"ề": "e",
		"ḕ": "e",
		"ḝ": "e",
		"ȇ": "e",
		"ì": "i",
		"í": "i",
		"î": "i",
		"ï": "i",
		"ḯ": "i",
		"ȋ": "i",
		"ð": "d",
		"ñ": "n",
		"ò": "o",
		"ó": "o",
		"ô": "o",
		"õ": "o",
		"ö": "o",
		"ø": "o",
		"ố": "o",
		"ṍ": "o",
		"ṓ": "o",
		"ȏ": "o",
		"ù": "u",
		"ú": "u",
		"û": "u",
		"ü": "u",
		"ý": "y",
		"ÿ": "y",
		"Ā": "A",
		"ā": "a",
		"Ă": "A",
		"ă": "a",
		"Ą": "A",
		"ą": "a",
		"Ć": "C",
		"ć": "c",
		"Ĉ": "C",
		"ĉ": "c",
		"Ċ": "C",
		"ċ": "c",
		"Č": "C",
		"č": "c",
		"C̆": "C",
		"c̆": "c",
		"Ď": "D",
		"ď": "d",
		"Đ": "D",
		"đ": "d",
		"Ē": "E",
		"ē": "e",
		"Ĕ": "E",
		"ĕ": "e",
		"Ė": "E",
		"ė": "e",
		"Ę": "E",
		"ę": "e",
		"Ě": "E",
		"ě": "e",
		"Ĝ": "G",
		"Ǵ": "G",
		"ĝ": "g",
		"ǵ": "g",
		"Ğ": "G",
		"ğ": "g",
		"Ġ": "G",
		"ġ": "g",
		"Ģ": "G",
		"ģ": "g",
		"Ĥ": "H",
		"ĥ": "h",
		"Ħ": "H",
		"ħ": "h",
		"Ḫ": "H",
		"ḫ": "h",
		"Ĩ": "I",
		"ĩ": "i",
		"Ī": "I",
		"ī": "i",
		"Ĭ": "I",
		"ĭ": "i",
		"Į": "I",
		"į": "i",
		"İ": "I",
		"ı": "i",
		"Ĳ": "IJ",
		"ĳ": "ij",
		"Ĵ": "J",
		"ĵ": "j",
		"Ķ": "K",
		"ķ": "k",
		"Ḱ": "K",
		"ḱ": "k",
		"K̆": "K",
		"k̆": "k",
		"Ĺ": "L",
		"ĺ": "l",
		"Ļ": "L",
		"ļ": "l",
		"Ľ": "L",
		"ľ": "l",
		"Ŀ": "L",
		"ŀ": "l",
		"Ł": "l",
		"ł": "l",
		"Ḿ": "M",
		"ḿ": "m",
		"M̆": "M",
		"m̆": "m",
		"Ń": "N",
		"ń": "n",
		"Ņ": "N",
		"ņ": "n",
		"Ň": "N",
		"ň": "n",
		"ŉ": "n",
		"N̆": "N",
		"n̆": "n",
		"Ō": "O",
		"ō": "o",
		"Ŏ": "O",
		"ŏ": "o",
		"Ő": "O",
		"ő": "o",
		"Œ": "OE",
		"œ": "oe",
		"P̆": "P",
		"p̆": "p",
		"Ŕ": "R",
		"ŕ": "r",
		"Ŗ": "R",
		"ŗ": "r",
		"Ř": "R",
		"ř": "r",
		"R̆": "R",
		"r̆": "r",
		"Ȓ": "R",
		"ȓ": "r",
		"Ś": "S",
		"ś": "s",
		"Ŝ": "S",
		"ŝ": "s",
		"Ş": "S",
		"Ș": "S",
		"ș": "s",
		"ş": "s",
		"Š": "S",
		"š": "s",
		"Ţ": "T",
		"ţ": "t",
		"ț": "t",
		"Ț": "T",
		"Ť": "T",
		"ť": "t",
		"Ŧ": "T",
		"ŧ": "t",
		"T̆": "T",
		"t̆": "t",
		"Ũ": "U",
		"ũ": "u",
		"Ū": "U",
		"ū": "u",
		"Ŭ": "U",
		"ŭ": "u",
		"Ů": "U",
		"ů": "u",
		"Ű": "U",
		"ű": "u",
		"Ų": "U",
		"ų": "u",
		"Ȗ": "U",
		"ȗ": "u",
		"V̆": "V",
		"v̆": "v",
		"Ŵ": "W",
		"ŵ": "w",
		"Ẃ": "W",
		"ẃ": "w",
		"X̆": "X",
		"x̆": "x",
		"Ŷ": "Y",
		"ŷ": "y",
		"Ÿ": "Y",
		"Y̆": "Y",
		"y̆": "y",
		"Ź": "Z",
		"ź": "z",
		"Ż": "Z",
		"ż": "z",
		"Ž": "Z",
		"ž": "z",
		"ſ": "s",
		"ƒ": "f",
		"Ơ": "O",
		"ơ": "o",
		"Ư": "U",
		"ư": "u",
		"Ǎ": "A",
		"ǎ": "a",
		"Ǐ": "I",
		"ǐ": "i",
		"Ǒ": "O",
		"ǒ": "o",
		"Ǔ": "U",
		"ǔ": "u",
		"Ǖ": "U",
		"ǖ": "u",
		"Ǘ": "U",
		"ǘ": "u",
		"Ǚ": "U",
		"ǚ": "u",
		"Ǜ": "U",
		"ǜ": "u",
		"Ứ": "U",
		"ứ": "u",
		"Ṹ": "U",
		"ṹ": "u",
		"Ǻ": "A",
		"ǻ": "a",
		"Ǽ": "AE",
		"ǽ": "ae",
		"Ǿ": "O",
		"ǿ": "o",
		"Þ": "TH",
		"þ": "th",
		"Ṕ": "P",
		"ṕ": "p",
		"Ṥ": "S",
		"ṥ": "s",
		"X́": "X",
		"x́": "x",
		"Ѓ": "Г",
		"ѓ": "г",
		"Ќ": "К",
		"ќ": "к",
		"A̋": "A",
		"a̋": "a",
		"E̋": "E",
		"e̋": "e",
		"I̋": "I",
		"i̋": "i",
		"Ǹ": "N",
		"ǹ": "n",
		"Ồ": "O",
		"ồ": "o",
		"Ṑ": "O",
		"ṑ": "o",
		"Ừ": "U",
		"ừ": "u",
		"Ẁ": "W",
		"ẁ": "w",
		"Ỳ": "Y",
		"ỳ": "y",
		"Ȁ": "A",
		"ȁ": "a",
		"Ȅ": "E",
		"ȅ": "e",
		"Ȉ": "I",
		"ȉ": "i",
		"Ȍ": "O",
		"ȍ": "o",
		"Ȑ": "R",
		"ȑ": "r",
		"Ȕ": "U",
		"ȕ": "u",
		"B̌": "B",
		"b̌": "b",
		"Č̣": "C",
		"č̣": "c",
		"Ê̌": "E",
		"ê̌": "e",
		"F̌": "F",
		"f̌": "f",
		"Ǧ": "G",
		"ǧ": "g",
		"Ȟ": "H",
		"ȟ": "h",
		"J̌": "J",
		"ǰ": "j",
		"Ǩ": "K",
		"ǩ": "k",
		"M̌": "M",
		"m̌": "m",
		"P̌": "P",
		"p̌": "p",
		"Q̌": "Q",
		"q̌": "q",
		"Ř̩": "R",
		"ř̩": "r",
		"Ṧ": "S",
		"ṧ": "s",
		"V̌": "V",
		"v̌": "v",
		"W̌": "W",
		"w̌": "w",
		"X̌": "X",
		"x̌": "x",
		"Y̌": "Y",
		"y̌": "y",
		"A̧": "A",
		"a̧": "a",
		"B̧": "B",
		"b̧": "b",
		"Ḑ": "D",
		"ḑ": "d",
		"Ȩ": "E",
		"ȩ": "e",
		"Ɛ̧": "E",
		"ɛ̧": "e",
		"Ḩ": "H",
		"ḩ": "h",
		"I̧": "I",
		"i̧": "i",
		"Ɨ̧": "I",
		"ɨ̧": "i",
		"M̧": "M",
		"m̧": "m",
		"O̧": "O",
		"o̧": "o",
		"Q̧": "Q",
		"q̧": "q",
		"U̧": "U",
		"u̧": "u",
		"X̧": "X",
		"x̧": "x",
		"Z̧": "Z",
		"z̧": "z"
	};
	var chars = Object.keys(characterMap).join("|");
	var allAccents = new RegExp(chars, "g");
	var firstAccent = new RegExp(chars, "");
	var removeAccents = function(string) {
		return string.replace(allAccents, function(match) {
			return characterMap[match];
		});
	};
	var hasAccents = function(string) {
		return !!string.match(firstAccent);
	};
	module.exports = removeAccents;
	module.exports.has = hasAccents;
	module.exports.remove = removeAccents;
})))());
var rankings = {
	CASE_SENSITIVE_EQUAL: 7,
	EQUAL: 6,
	STARTS_WITH: 5,
	WORD_STARTS_WITH: 4,
	CONTAINS: 3,
	ACRONYM: 2,
	MATCHES: 1,
	NO_MATCH: 0
};
matchSorter.rankings = rankings;
var defaultBaseSortFn = function defaultBaseSortFn(a, b) {
	return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
* Takes an array of items and a value and returns a new array with the items that match the given value
* @param {Array} items - the items to sort
* @param {String} value - the value to use for ranking
* @param {Object} options - Some options to configure the sorter
* @return {Array} - the new sorted array
*/
function matchSorter(items, value, options) {
	if (options === void 0) options = {};
	var _options = options, keys = _options.keys, _options$threshold = _options.threshold, threshold = _options$threshold === void 0 ? rankings.MATCHES : _options$threshold, _options$baseSort = _options.baseSort, baseSort = _options$baseSort === void 0 ? defaultBaseSortFn : _options$baseSort, _options$sorter = _options.sorter;
	return (_options$sorter === void 0 ? function(matchedItems) {
		return matchedItems.sort(function(a, b) {
			return sortRankedValues(a, b, baseSort);
		});
	} : _options$sorter)(items.reduce(reduceItemsToRanked, [])).map(function(_ref) {
		return _ref.item;
	});
	function reduceItemsToRanked(matches, item, index) {
		var rankingInfo = getHighestRanking(item, keys, value, options);
		var rank = rankingInfo.rank, _rankingInfo$keyThres = rankingInfo.keyThreshold;
		if (rank >= (_rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres)) matches.push(_extends$3({}, rankingInfo, {
			item,
			index
		}));
		return matches;
	}
}
/**
* Gets the highest ranking for value for the given item based on its values for the given keys
* @param {*} item - the item to rank
* @param {Array} keys - the keys to get values from the item for the ranking
* @param {String} value - the value to rank against
* @param {Object} options - options to control the ranking
* @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
*/
function getHighestRanking(item, keys, value, options) {
	if (!keys) {
		var stringItem = item;
		return {
			rankedValue: stringItem,
			rank: getMatchRanking(stringItem, value, options),
			keyIndex: -1,
			keyThreshold: options.threshold
		};
	}
	return getAllValuesToRank(item, keys).reduce(function(_ref2, _ref3, i) {
		var rank = _ref2.rank, rankedValue = _ref2.rankedValue, keyIndex = _ref2.keyIndex, keyThreshold = _ref2.keyThreshold;
		var itemValue = _ref3.itemValue, attributes = _ref3.attributes;
		var newRank = getMatchRanking(itemValue, value, options);
		var newRankedValue = rankedValue;
		var minRanking = attributes.minRanking, maxRanking = attributes.maxRanking, threshold = attributes.threshold;
		if (newRank < minRanking && newRank >= rankings.MATCHES) newRank = minRanking;
		else if (newRank > maxRanking) newRank = maxRanking;
		if (newRank > rank) {
			rank = newRank;
			keyIndex = i;
			keyThreshold = threshold;
			newRankedValue = itemValue;
		}
		return {
			rankedValue: newRankedValue,
			rank,
			keyIndex,
			keyThreshold
		};
	}, {
		rankedValue: item,
		rank: rankings.NO_MATCH,
		keyIndex: -1,
		keyThreshold: options.threshold
	});
}
/**
* Gives a rankings score based on how well the two strings match.
* @param {String} testString - the string to test against
* @param {String} stringToRank - the string to rank
* @param {Object} options - options for the match (like keepDiacritics for comparison)
* @returns {Number} the ranking for how well stringToRank matches testString
*/
function getMatchRanking(testString, stringToRank, options) {
	testString = prepareValueForComparison(testString, options);
	stringToRank = prepareValueForComparison(stringToRank, options);
	if (stringToRank.length > testString.length) return rankings.NO_MATCH;
	if (testString === stringToRank) return rankings.CASE_SENSITIVE_EQUAL;
	testString = testString.toLowerCase();
	stringToRank = stringToRank.toLowerCase();
	if (testString === stringToRank) return rankings.EQUAL;
	if (testString.startsWith(stringToRank)) return rankings.STARTS_WITH;
	if (testString.includes(" " + stringToRank)) return rankings.WORD_STARTS_WITH;
	if (testString.includes(stringToRank)) return rankings.CONTAINS;
	else if (stringToRank.length === 1) return rankings.NO_MATCH;
	if (getAcronym(testString).includes(stringToRank)) return rankings.ACRONYM;
	return getClosenessRanking(testString, stringToRank);
}
/**
* Generates an acronym for a string.
*
* @param {String} string the string for which to produce the acronym
* @returns {String} the acronym
*/
function getAcronym(string) {
	var acronym = "";
	string.split(" ").forEach(function(wordInString) {
		wordInString.split("-").forEach(function(splitByHyphenWord) {
			acronym += splitByHyphenWord.substr(0, 1);
		});
	});
	return acronym;
}
/**
* Returns a score based on how spread apart the
* characters from the stringToRank are within the testString.
* A number close to rankings.MATCHES represents a loose match. A number close
* to rankings.MATCHES + 1 represents a tighter match.
* @param {String} testString - the string to test against
* @param {String} stringToRank - the string to rank
* @returns {Number} the number between rankings.MATCHES and
* rankings.MATCHES + 1 for how well stringToRank matches testString
*/
function getClosenessRanking(testString, stringToRank) {
	var matchingInOrderCharCount = 0;
	var charNumber = 0;
	function findMatchingCharacter(matchChar, string, index) {
		for (var j = index, J = string.length; j < J; j++) if (string[j] === matchChar) {
			matchingInOrderCharCount += 1;
			return j + 1;
		}
		return -1;
	}
	function getRanking(spread) {
		var spreadPercentage = 1 / spread;
		var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
		return rankings.MATCHES + inOrderPercentage * spreadPercentage;
	}
	var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
	if (firstIndex < 0) return rankings.NO_MATCH;
	charNumber = firstIndex;
	for (var i = 1, I = stringToRank.length; i < I; i++) {
		var matchChar = stringToRank[i];
		charNumber = findMatchingCharacter(matchChar, testString, charNumber);
		if (!(charNumber > -1)) return rankings.NO_MATCH;
	}
	return getRanking(charNumber - firstIndex);
}
/**
* Sorts items that have a rank, index, and keyIndex
* @param {Object} a - the first item to sort
* @param {Object} b - the second item to sort
* @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
*/
function sortRankedValues(a, b, baseSort) {
	var aFirst = -1;
	var bFirst = 1;
	var aRank = a.rank, aKeyIndex = a.keyIndex;
	var bRank = b.rank, bKeyIndex = b.keyIndex;
	if (aRank === bRank) {
		if (aKeyIndex === bKeyIndex) return baseSort(a, b);
		else return aKeyIndex < bKeyIndex ? aFirst : bFirst;
	} else return aRank > bRank ? aFirst : bFirst;
}
/**
* Prepares value for comparison by stringifying it, removing diacritics (if specified)
* @param {String} value - the value to clean
* @param {Object} options - {keepDiacritics: whether to remove diacritics}
* @return {String} the prepared value
*/
function prepareValueForComparison(value, _ref4) {
	var keepDiacritics = _ref4.keepDiacritics;
	value = "" + value;
	if (!keepDiacritics) value = (0, import_remove_accents.default)(value);
	return value;
}
/**
* Gets value for key in item at arbitrarily nested keypath
* @param {Object} item - the item
* @param {Object|Function} key - the potentially nested keypath or property callback
* @return {Array} - an array containing the value(s) at the nested keypath
*/
function getItemValues(item, key) {
	if (typeof key === "object") key = key.key;
	var value;
	if (typeof key === "function") value = key(item);
	else if (item == null) value = null;
	else if (Object.hasOwnProperty.call(item, key)) value = item[key];
	else if (key.includes(".")) return getNestedValues(key, item);
	else value = null;
	if (value == null) return [];
	if (Array.isArray(value)) return value;
	return [String(value)];
}
/**
* Given path: "foo.bar.baz"
* And item: {foo: {bar: {baz: 'buzz'}}}
*   -> 'buzz'
* @param path a dot-separated set of keys
* @param item the item to get the value from
*/
function getNestedValues(path, item) {
	var keys = path.split(".");
	var values = [item];
	for (var i = 0, I = keys.length; i < I; i++) {
		var nestedKey = keys[i];
		var nestedValues = [];
		for (var j = 0, J = values.length; j < J; j++) {
			var nestedItem = values[j];
			if (nestedItem == null) continue;
			if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
				var nestedValue = nestedItem[nestedKey];
				if (nestedValue != null) nestedValues.push(nestedValue);
			} else if (nestedKey === "*") nestedValues = nestedValues.concat(nestedItem);
		}
		values = nestedValues;
	}
	if (Array.isArray(values[0])) {
		var result = [];
		return result.concat.apply(result, values);
	}
	return values;
}
/**
* Gets all the values for the given keys in the given item and returns an array of those values
* @param item - the item from which the values will be retrieved
* @param keys - the keys to use to retrieve the values
* @return objects with {itemValue, attributes}
*/
function getAllValuesToRank(item, keys) {
	var allValues = [];
	for (var j = 0, J = keys.length; j < J; j++) {
		var key = keys[j];
		var attributes = getKeyAttributes(key);
		var itemValues = getItemValues(item, key);
		for (var i = 0, I = itemValues.length; i < I; i++) allValues.push({
			itemValue: itemValues[i],
			attributes
		});
	}
	return allValues;
}
var defaultKeyAttributes = {
	maxRanking: Infinity,
	minRanking: -Infinity
};
/**
* Gets all the attributes for the given key
* @param key - the key from which the attributes will be retrieved
* @return object containing the key's attributes
*/
function getKeyAttributes(key) {
	if (typeof key === "string") return defaultKeyAttributes;
	return _extends$3({}, defaultKeyAttributes, key);
}
//#endregion
//#region src/components/form-items/autocomplete/autocomplete.styled.ts
var Button$1 = (0, import_dist.default)(Ot.Button)`
  absolute
  inset-y-0
  right-3
  px-1
  flex
  items-center
`;
var CheckIcon = (0, import_dist.default)(Memo$27)`
  w-5
  h-5
`;
var ChevronDownIcon = (0, import_dist.default)(Memo$28)`
  w-2
  text-gray-400
`;
var ComboboxBaseInput = (0, import_dist.default)(Ot.Input)`
  w-full
  bg-white
  text-sm
  font-normal
  placeholder:text-gray-400
  ${({ $error, disabled }) => {
	if (disabled) return "bg-gray-200 border-primary-600";
	if ($error) return `border-rsbry-300 text-rsbry-900 placeholder:text-rsbry-300
        focus:ring-rsbry-500 focus:border-rsbry-500 animate-shake`;
	return "";
}}
`;
var InputItem = (0, import_dist.default)(ComboboxBaseInput)`
  border-none
  p-0
  overflow-hidden
  focus:ring-0
  focus:ring-offset-0
`;
var Input$2 = (0, import_dist.default)(ComboboxBaseInput)`
  border
  rounded-md
  py-2
  pr-10
  text-gray-900
  font-normal
  text-left
  shadow-sm

  focus:outline-none
  focus:ring-1
  ${({ $hasImage }) => $hasImage ? "pl-[3.25rem]" : "pl-4"}
  ${({ $error, disabled }) => {
	if (disabled) return "bg-gray-200 border-primary-600";
	if ($error) return `border-rsbry-300 text-rsbry-900 placeholder:text-rsbry-300
        focus:ring-rsbry-500 focus:border-rsbry-500 animate-shake`;
	return "border-gray-300 focus:border-primary-600 focus:ring-primary-600 placeholder:text-gray-400";
}}
`;
var ListItem = import_dist.default.li`
  relative
  flex
  flex-row
  items-center
  space-x-3
  py-2
  pl-4
  pr-9
  text-sm
  cursor-default
  select-none
  ${({ $active }) => $active ? "bg-primary-600 text-white" : "text-gray-700"}
  ${({ $isLastOptionInGroup }) => $isLastOptionInGroup ? "border-b border-gray-200" : ""}
`;
var ListItemText = import_dist.default.span`
  block
  truncate
  ${({ $active, $disabled, $selected }) => [$selected ? "font-semibold" : "", $active ? "text-white" : $disabled ? "text-gray-300" : "text-gray-500"].join(" ")}
`;
var OptionImage = import_dist.default.img`
  w-6
  h-6
  flex-shrink-0
  rounded-full
  object-cover
`;
var Options = (0, import_dist.default)(Ot.Options)`
  absolute
  z-10
  w-full
  max-h-56
  mt-1
  py-1
  overflow-auto
  rounded-md
  shadow-lg
  bg-white
  text-base
  ring-1
  ring-black
  ring-opacity-5
  focus:outline-none
`;
var SelectedOptionTrailingIconContainer = import_dist.default.span`
  absolute
  inset-y-0
  right-0
  flex
  items-center
  pr-4
  ${({ $active }) => $active ? "text-white" : "text-inherit"}
`;
var SelectedOptionLeadingIconContainer = import_dist.default.span`
  absolute
  inset-y-0
  left-4
  flex
  items-center
`;
/**
* Makes sure the button is appropriately aligned with the input.
*/
var InputWrapper = import_dist.default.div`
  relative
`;
//#endregion
//#region src/components/form-items/autocomplete/autocomplete.utils.ts
var makeDisplayValueGetter = (options, optionValueKey, optionDisplayKey) => {
	const getDisplayValue = (optionValue) => {
		if (optionValue === void 0 || optionValue === null || optionValueKey === void 0 || optionDisplayKey === void 0) return "";
		return options.find((option) => option[optionValueKey] === optionValue)?.[optionDisplayKey] ?? "";
	};
	return getDisplayValue;
};
//#endregion
//#region src/components/atoms/notification/styled.ts
var NOTIFICATION_COLOR_VARIANTS = {
	red: "bg-rsbry-600",
	green: "bg-green-400",
	gray: "bg-gray-300"
};
var NotificationSizes = {
	.5: "h-1 w-1 ring-1 top-0 right-0",
	1: "h-1.5 w-1.5 ring-2 top-0 right-0",
	1.5: "h-2 w-2 ring-2 top-0 right-0",
	2: "h-2 w-2 ring-2 top-0.5 right-0.5",
	2.5: "h-2.5 w-2.5 ring-2 top-1 right-1",
	3: "h-3 w-3 ring-2 top-1 right-1",
	3.5: "h-3.5 w-3.5 ring-2 top-2 right-2",
	4: "h-4 w-4 ring top-2 right-2"
};
var NOTIFICATION_RING_VARIANTS = {
	gray: "ring-gray-200 group-hover:ring-gray-400",
	darkGray: "",
	white: "ring-white"
};
var StyledNotification = import_dist.default.span`
  ${({ $colorVariant }) => NOTIFICATION_COLOR_VARIANTS[$colorVariant]}
  ${({ $size }) => NotificationSizes[$size]}
  ${({ $ringVariant }) => NOTIFICATION_RING_VARIANTS[$ringVariant]}
  absolute
  block
  -translate-y-1/2
  translate-x-1/2
  transform
  rounded-full
  transition-shadow
`;
//#endregion
//#region src/components/atoms/notification/Notification.tsx
var Notification = ({ className, colorVariant, ringVariant = "white", size }) => /* @__PURE__ */ React.createElement(StyledNotification, {
	className,
	$ringVariant: ringVariant,
	$colorVariant: colorVariant,
	$size: size,
	"data-testid": "notification"
});
memo(Notification);
//#endregion
//#region src/components/molecules/icon-with-notification/styled.ts
var StyledIconWithNotification = import_dist.default.div`
  relative
  inline-block
`;
//#endregion
//#region src/components/molecules/icon-with-notification/IconWithNotification.tsx
var IconToNotificationMapping = {
	2: .5,
	4: .5,
	6: 1,
	8: 2,
	10: 2.5,
	12: 3,
	14: 3.5,
	16: 4
};
var IconWithNotification = ({ className, isNotificationToggled = true, nodeSize, notification, size, ...props }) => /* @__PURE__ */ React.createElement(StyledIconWithNotification, { className }, /* @__PURE__ */ React.createElement(Icon, {
	size,
	nodeSize,
	...props
}), isNotificationToggled && /* @__PURE__ */ React.createElement(Notification, {
	size: IconToNotificationMapping[nodeSize ? nodeSize : size],
	colorVariant: notification.colorVariant,
	ringVariant: notification.ringVariant
}));
var IconWithNotificationMemo = memo(IconWithNotification);
//#endregion
//#region src/components/molecules/icon-button/icon-button.styled.ts
var IconButtonSizesStyle = {
	xs: "h-4 w-4",
	sm: "h-6 w-6",
	base: "h-8 w-8",
	lg: "h-10 w-10",
	xl: "h-12 w-12"
};
var ICON_BUTTON_COLOR_VARIANTS = {
	primary: "text-primary-400 hover:text-primary-800",
	darkGray: "bg-gray-800 text-gray-300 hover:bg-gray-200 hover:text-gray-600",
	darkGrayBorder: "bg-gray-600 text-gray-300 hover:bg-gray-200 hover:text-gray-50",
	gray: "text-gray-600 hover:bg-gray-400 hover:text-gray-50",
	grayBorder: "text-gray-400 hover:bg-gray-400 hover:text-gray-50",
	lightGray: "hover:bg-gray-200",
	transparent: "text-gray-400 hover:text-gray-500 bg-transparent",
	inherit: "text-inherit hover:text-inherit bg-transparent"
};
var ICON_BUTTON_ACTIVE_COLOR_VARIANTS = {
	primary: "bg-transparent text-primary-400",
	darkGray: "bg-gray-200 text-gray-600",
	darkGrayBorder: "text-gray-300",
	gray: "bg-gray-400 text-gray-50",
	grayBorder: "text-gray-400",
	lightGray: "bg-gray-100",
	transparent: "text-gray-400 bg-transparent",
	inherit: "text-inherit hover:text-inherit bg-transparent"
};
var ICON_BUTTON_ROUNDED_VARIANTS = {
	none: "",
	regular: "rounded-md",
	left: "rounded-l",
	right: "rounded-r"
};
var StyledIconButton = (0, import_dist.default)(Button$2)`
  flex
  items-center
  justify-center
  group
  transition-colors
  ${({ $variant }) => ICON_BUTTON_COLOR_VARIANTS[$variant]}
  ${({ $size }) => IconButtonSizesStyle[$size]}
  ${({ $rounded }) => ICON_BUTTON_ROUNDED_VARIANTS[$rounded]}
  ${({ $active, $variant }) => $active ? ICON_BUTTON_ACTIVE_COLOR_VARIANTS[$variant] : ""}
`;
//#endregion
//#region src/components/molecules/icon-button/IconButton.tsx
var GenericToIconSizingMap = {
	xs: 2,
	sm: 4,
	base: 6,
	lg: 8,
	xl: 10
};
var IconButton = ({ active, className, icon, rounded = "regular", size, testId, variant, ...props }) => /* @__PURE__ */ React.createElement(StyledIconButton, {
	$size: size,
	$rounded: rounded,
	$active: active,
	$variant: variant,
	className,
	"data-testid": testId,
	...props
}, /* @__PURE__ */ React.createElement(IconWithNotification, {
	variant: "none",
	size: GenericToIconSizingMap[size],
	...icon,
	notification: {
		colorVariant: "red",
		ringVariant: "gray"
	}
}));
//#endregion
//#region src/assets/icons/menu-vertical-dots.svg
var SvgMenuVerticalDots = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 10 10",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.25 1.25a1.25 1.25 0 1 1 -2.5 0 1.25 1.25 0 0 1 2.5 0ZM5 6.25a1.25 1.25 0 1 0 0 -2.5 1.25 1.25 0 0 0 0 2.5ZM5 10a1.25 1.25 0 1 0 0 -2.5A1.25 1.25 0 0 0 5 10Z",
		clipRule: "evenodd",
		strokeWidth: 1
	})
});
var ForwardRef$26 = forwardRef(SvgMenuVerticalDots);
var Memo$26 = memo(ForwardRef$26);
//#endregion
//#region src/components/form-items/dropdown-menu/dropdown-menu.styled.ts
var StyledDropdownContainer = import_dist.default.div`
    inline-block
    text-left
    flex
    rounded-md
    shadow-sm
`;
var StyledDropdownMenuButton = (0, import_dist.default)(Button$2)`
    ${({ disabled }) => disabled ? "bg-gray-200 text-gray-500 border-primary-600" : "bg-white text-gray-700 hover:bg-gray-50 focus:border-primary-600 focus:ring-primary-600 focus:ring-1 focus:outline-none"}
    ${({ $active }) => $active ? "bg-primary-50 hover:bg-primary-100 ring-1 border-primary-300 ring-primary-300 text-primary-700 [&_span]:!text-primary-700 [&_svg]:!text-primary-600" : "border-gray-300"}
    rounded-md
    relative
    px-4
    py-2
    sm:text-sm
    border
    font-medium
    items-center
    grow
    text-left
    flex
    justify-between
    min-w-0
    shadow-sm
`;
var StyledDropdownMenu = (0, import_dist.default)(Menu$1)`
    origin-top-right
    absolute
    right-0
    mt-2
    w-56
    rounded-md
    shadow-lg
    bg-white
    ring-1
    ring-black
    ring-opacity-5
    focus:outline-none
    z-overlay
    max-h-96
    overflow-y-scroll
    overflow-x-hidden
`;
var StyledDropdownMenuItem = (0, import_dist.default)(MenuItem$1)`
    ${({ $selected }) => $selected ? "font-semibold" : "  font-normal"}
    text-gray-900
    hover:bg-gray-50
    p-2
    leading-5
    text-sm
    cursor-pointer
    flex
    align-center
    gap-1.5
`;
var StyledLeadingIcon = import_dist.default.span`
  -ml-1
  mr-2
  h-5
  w-5
  flex
  items-center
  justify-center
`;
var StyledDropdownArrow = import_dist.default.span`
  -mr-1
  ml-2
  h-5
  w-5
  flex
  items-center
  justify-center
`;
var StyledButtonTitle = (0, import_dist.default)(Typography)`
  truncate
  flex-1
`;
var StyledButtonPlaceholder = (0, import_dist.default)(StyledButtonTitle)`
  text-gray-500
`;
//#endregion
//#region src/components/form-items/dropdown-menu/DropdownButton.tsx
var DropdownButton = ({ active, className, disabled, id, leadingIcon, onMouseEnter, onMouseLeave, placeholder, state, trailingIcon, value, ...restProps }) => /* @__PURE__ */ React.createElement(StyledDropdownMenuButton, {
	$active: active,
	className,
	disabled,
	id,
	placeholder,
	state,
	onMouseEnter,
	onMouseLeave,
	...restProps
}, leadingIcon && /* @__PURE__ */ React.createElement(StyledLeadingIcon, null, leadingIcon), value ? /* @__PURE__ */ React.createElement(StyledButtonTitle, {
	fontSize: "sm",
	className: "menu-value"
}, value) : /* @__PURE__ */ React.createElement(StyledButtonPlaceholder, {
	fontSize: "sm",
	className: "menu-placeholder"
}, placeholder), /* @__PURE__ */ React.createElement(StyledDropdownArrow, null, trailingIcon || /* @__PURE__ */ React.createElement(MenuButtonArrow, null)));
var DropdownButtonMemo = memo(DropdownButton);
//#endregion
//#region src/components/form-items/dropdown-menu/DropdownMenuItem.tsx
var DropdownMenuItem = ({ className, hideOnClick, onClick, option, selected }) => {
	const handleOnClick = useCallback((e) => {
		e.stopPropagation();
		onClick(option.value);
	}, [onClick, option]);
	return /* @__PURE__ */ React.createElement(StyledDropdownMenuItem, {
		hideOnClick,
		onClick: handleOnClick,
		$selected: selected,
		className
	}, /* @__PURE__ */ React.createElement("div", {
		className: "w-3 h-3 text-primary-600",
		"aria-hidden": "true"
	}, selected ? /* @__PURE__ */ React.createElement(Memo$27, null) : null), option.label);
};
var DropdownMenuItemMemo = memo(DropdownMenuItem);
//#endregion
//#region src/components/form-items/dropdown-menu/DropdownMenu.tsx
var createDropdownMenuComponent = (isMemo) => function DropdownMenu({ active, as, className, hideOnClick, id, leadingIcon, onChange, options, disabled = options.length === 0, placeholder = "—", trailingIcon, value, usePortal, ...restProps }) {
	const state = useMenuState({ gutter: 1 });
	const DropdownMenuItemComponent = isMemo ? DropdownMenuItemMemo : DropdownMenuItem;
	const explicitOptions = options.map((option) => typeof option === "object" ? option : {
		value: option,
		label: option.toString()
	});
	const selectedOption = explicitOptions.find((option) => Object.is(option.value, value));
	const commonProps = {
		value: selectedOption?.label,
		active,
		disabled,
		id,
		leadingIcon,
		placeholder,
		state,
		trailingIcon,
		className,
		onClick: (e) => {
			e.stopPropagation();
		}
	};
	return /* @__PURE__ */ React.createElement(React.Fragment, null, as ? /* @__PURE__ */ React.createElement(MenuButton, {
		as,
		...commonProps,
		...restProps
	}) : /* @__PURE__ */ React.createElement(DropdownButton, {
		as: MenuButton,
		...commonProps
	}), /* @__PURE__ */ React.createElement(StyledDropdownMenu, {
		state,
		portal: usePortal
	}, explicitOptions.map((option) => /* @__PURE__ */ React.createElement(DropdownMenuItemComponent, {
		hideOnClick,
		key: option.value,
		option,
		selected: Object.is(option, selectedOption),
		onClick: onChange
	}))));
};
var DropdownMenu = createDropdownMenuComponent(false);
var DropdownMenuMemo = memo(createDropdownMenuComponent(true));
//#endregion
//#region src/components/form-items/dropdown-menu/DropdownMenuWithButton.tsx
var createDropdownMenuWithButtonComponent = (isMemo) => function DropdownMenuWithButton({ button, className, errorText, onChange, options, ...otherProps }) {
	const DropdownMenuComponent = isMemo ? DropdownMenuMemo : DropdownMenu;
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledDropdownContainer, { className }, /* @__PURE__ */ React.createElement(DropdownMenuComponent, {
		className: "rounded-l-md rounded-r-none",
		onChange,
		options,
		id: otherProps.id || void 0,
		disabled: otherProps.disabled || void 0,
		value: otherProps.value || void 0,
		placeholder: otherProps.placeholder || void 0,
		leadingIcon: otherProps.leadingIcon || void 0,
		trailingIcon: otherProps.trailingIcon || void 0,
		active: otherProps.active || void 0,
		hideOnClick: otherProps.hideOnClick || void 0,
		usePortal: otherProps.usePortal || void 0
	}), button), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!errorText,
		id: `${otherProps.id}-error`
	}, errorText));
};
var DropdownMenuWithButton = createDropdownMenuWithButtonComponent(false);
var DropdownMenuWithButtonMemo = memo(createDropdownMenuWithButtonComponent(true));
//#endregion
//#region src/components/form-items/autocomplete/AutocompleteOptions.tsx
var AutocompleteOptions = ({ groupEndValues = [], disabledKey = "disabled", displayKey = "label", options = [], valueKey = "value", query, setQuery, allowCreate = false, isLoading, ...props }) => {
	const trimmedQuery = query.trim();
	const hasExactMatch = options.some((option) => option[displayKey] === trimmedQuery);
	return /* @__PURE__ */ React.createElement(We$1, {
		as: Fragment,
		leave: "transition ease-in duration-100",
		leaveFrom: "opacity-100",
		leaveTo: "opacity-0",
		afterLeave: () => setQuery("")
	}, /* @__PURE__ */ React.createElement(Options, props, options.length > 0 ? options.map((option) => /* @__PURE__ */ React.createElement(Ot.Option, {
		key: option[valueKey],
		value: option,
		disabled: !!option[disabledKey],
		as: Fragment
	}, ({ active, disabled, selected }) => /* @__PURE__ */ React.createElement(ListItem, {
		$active: active,
		$selected: selected,
		$disabled: disabled,
		$isLastOptionInGroup: trimmedQuery === "" && (groupEndValues.includes(option[valueKey]) || option.isLastOptionInGroup)
	}, option?.icon !== void 0 && option?.icon, option?.imageSrc !== void 0 && /* @__PURE__ */ React.createElement(OptionImage, {
		src: option.imageSrc,
		srcSet: option.imageSrcSet,
		alt: ""
	}), /* @__PURE__ */ React.createElement(ListItemText, {
		$active: active,
		$selected: selected,
		$disabled: disabled,
		title: option[displayKey] ?? void 0
	}, option[displayKey] ?? ""), /* @__PURE__ */ React.createElement(SelectedOptionTrailingIconContainer, { $active: active }, selected && /* @__PURE__ */ React.createElement(CheckIcon, {
		"aria-hidden": "true",
		color: colors.primary[600]
	}), option.childMenu && /* @__PURE__ */ React.createElement(DropdownMenu, {
		as: IconButton,
		active: false,
		variant: "inherit",
		size: "xs",
		icon: {
			node: /* @__PURE__ */ React.createElement(Memo$26, null),
			isNotificationToggled: false
		},
		onChange: option.childMenu.onChange,
		options: option.childMenu.options,
		value: null,
		usePortal: true
	}))))) : null, allowCreate && trimmedQuery !== "" && !hasExactMatch ? /* @__PURE__ */ React.createElement(Ot.Option, {
		value: trimmedQuery,
		as: Fragment
	}, ({ active, disabled, selected }) => /* @__PURE__ */ React.createElement(ListItem, {
		$active: active,
		$selected: selected,
		$disabled: disabled
	}, /* @__PURE__ */ React.createElement(ListItemText, {
		$active: active,
		$selected: false
	}, selected ? `Remove "${trimmedQuery}"` : `Create "${trimmedQuery}"`))) : null, isLoading && /* @__PURE__ */ React.createElement(Ot.Option, {
		value: null,
		disabled: true,
		as: Fragment
	}, /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemText, null, "Loading..."))), options.length === 0 && !isLoading && trimmedQuery !== "" && !allowCreate && /* @__PURE__ */ React.createElement(Ot.Option, {
		value: null,
		disabled: true,
		as: Fragment
	}, /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemText, null, "No matches")))));
};
//#endregion
//#region src/components/form-items/autocomplete/AutocompleteInput.tsx
var AutocompleteInput = ({ className, disabled, error, errorText, groupEndValues = [], id, name, onChange, onCreate, optionDisabledKey, optionDisplayKey = "label", options = [], optionValueKey = "value", placeholder = "Type to search", searchKeys = optionDisplayKey !== void 0 ? [optionDisplayKey] : void 0, value, allowCreate = false, ...props }) => {
	const [selectedOption, setSelectedOption] = useState(options.find((option) => option[optionValueKey] === value));
	const [query, setQuery] = useState("");
	const hasInvalidValue = value !== void 0 && value !== null && value !== "" && options.find((option) => option[optionValueKey] === value) === void 0;
	const selectedOptionHasIcon = selectedOption?.icon !== void 0;
	const selectedOptionHasImage = selectedOption?.imageSrc !== void 0;
	const handleChangeInput = (e) => {
		setQuery(e.target.value);
	};
	const handleChangeCombobox = (selectedOption) => {
		if (typeof selectedOption === "string") {
			onCreate?.(selectedOption);
			return;
		}
		const value = selectedOption?.[optionValueKey];
		setSelectedOption(selectedOption);
		onChange?.(value);
	};
	useEffect(() => {
		const option = options.find((option) => option[optionValueKey] === value);
		setSelectedOption(option);
	}, [
		optionValueKey,
		options,
		value
	]);
	const filteredOptions = query === "" ? options : matchSorter(options, query, { keys: searchKeys });
	return /* @__PURE__ */ m$3.createElement(Ot, {
		as: "div",
		name,
		value: selectedOption?.[optionValueKey],
		onChange: handleChangeCombobox,
		className: (0, import_classnames.default)("relative", className),
		id,
		disabled,
		nullable: true,
		...props
	}, /* @__PURE__ */ m$3.createElement(InputWrapper, null, selectedOptionHasIcon && /* @__PURE__ */ m$3.createElement(SelectedOptionLeadingIconContainer, null, selectedOption?.icon), selectedOptionHasImage && /* @__PURE__ */ m$3.createElement(SelectedOptionLeadingIconContainer, null, /* @__PURE__ */ m$3.createElement(OptionImage, {
		src: selectedOption?.imageSrc,
		srcSet: selectedOption?.imageSrcSet,
		alt: ""
	})), /* @__PURE__ */ m$3.createElement(Input$2, {
		onChange: handleChangeInput,
		displayValue: makeDisplayValueGetter(options, optionValueKey, optionDisplayKey),
		placeholder,
		disabled,
		$error: error || hasInvalidValue,
		$hasImage: selectedOptionHasIcon || selectedOptionHasImage
	}), /* @__PURE__ */ m$3.createElement(Button$1, { disabled }, /* @__PURE__ */ m$3.createElement(ChevronDownIcon, { "aria-hidden": "true" }))), /* @__PURE__ */ m$3.createElement(AutocompleteOptions, {
		options: filteredOptions,
		valueKey: optionValueKey,
		displayKey: optionDisplayKey,
		disabledKey: optionDisabledKey,
		groupEndValues,
		query,
		setQuery,
		allowCreate
	}), /* @__PURE__ */ m$3.createElement(GeneralFormError, {
		error: !!error && !!errorText || hasInvalidValue,
		id: `${id}-error`
	}, errorText ? errorText : "Invalid value provided. Please select a new value."));
};
//#endregion
//#region ../../node_modules/use-debounce/esm/useDebouncedCallback.js
/**
* Creates a debounced function that delays invoking `func` until after `wait`
* milliseconds have elapsed since the last time the debounced function was
* invoked, or until the next browser frame is drawn. The debounced function
* comes with a `cancel` method to cancel delayed `func` invocations and a
* `flush` method to immediately invoke them. Provide `options` to indicate
* whether `func` should be invoked on the leading and/or trailing edge of the
* `wait` timeout. The `func` is invoked with the last arguments provided to the
* debounced function. Subsequent calls to the debounced function return the
* result of the last `func` invocation.
*
* **Note:** If `leading` and `trailing` options are `true`, `func` is
* invoked on the trailing edge of the timeout only if the debounced function
* is invoked more than once during the `wait` timeout.
*
* If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
* until the next tick, similar to `setTimeout` with a timeout of `0`.
*
* If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
* invocation will be deferred until the next frame is drawn (typically about
* 16ms).
*
* See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
* for details over the differences between `debounce` and `throttle`.
*
* @category Function
* @param {Function} func The function to debounce.
* @param {number} [wait=0]
*  The number of milliseconds to delay; if omitted, `requestAnimationFrame` is
*  used (if available, otherwise it will be setTimeout(...,0)).
* @param {Object} [options={}] The options object.
*  Specify invoking on the leading edge of the timeout.
* @param {boolean} [options.leading=false]
*  The maximum time `func` is allowed to be delayed before it's invoked.
* @param {number} [options.maxWait]
*  Specify invoking on the trailing edge of the timeout.
* @param {boolean} [options.trailing=true]
* @returns {Function} Returns the new debounced function.
* @example
*
* // Avoid costly calculations while the window size is in flux.
* const resizeHandler = useDebouncedCallback(calculateLayout, 150);
* window.addEventListener('resize', resizeHandler)
*
* // Invoke `sendMail` when clicked, debouncing subsequent calls.
* const clickHandler = useDebouncedCallback(sendMail, 300, {
*   leading: true,
*   trailing: false,
* })
* <button onClick={clickHandler}>click me</button>
*
* // Ensure `batchLog` is invoked once after 1 second of debounced calls.
* const debounced = useDebouncedCallback(batchLog, 250, { 'maxWait': 1000 })
* const source = new EventSource('/stream')
* source.addEventListener('message', debounced)
*
* // Cancel the trailing debounced invocation.
* window.addEventListener('popstate', debounced.cancel)
*
* // Check for pending invocations.
* const status = debounced.pending() ? "Pending..." : "Ready"
*/
function useDebouncedCallback(func, wait, options) {
	var _this = this;
	var lastCallTime = useRef(null);
	var lastInvokeTime = useRef(0);
	var timerId = useRef(null);
	var lastArgs = useRef([]);
	var lastThis = useRef();
	var result = useRef();
	var funcRef = useRef(func);
	var mounted = useRef(true);
	funcRef.current = func;
	var useRAF = !wait && wait !== 0 && typeof window !== "undefined";
	if (typeof func !== "function") throw new TypeError("Expected a function");
	wait = +wait || 0;
	options = options || {};
	var leading = !!options.leading;
	var trailing = "trailing" in options ? !!options.trailing : true;
	var maxing = "maxWait" in options;
	var maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : null;
	useEffect(function() {
		mounted.current = true;
		return function() {
			mounted.current = false;
		};
	}, []);
	return useMemo(function() {
		var invokeFunc = function(time) {
			var args = lastArgs.current;
			var thisArg = lastThis.current;
			lastArgs.current = lastThis.current = null;
			lastInvokeTime.current = time;
			return result.current = funcRef.current.apply(thisArg, args);
		};
		var startTimer = function(pendingFunc, wait) {
			if (useRAF) cancelAnimationFrame(timerId.current);
			timerId.current = useRAF ? requestAnimationFrame(pendingFunc) : setTimeout(pendingFunc, wait);
		};
		var shouldInvoke = function(time) {
			if (!mounted.current) return false;
			var timeSinceLastCall = time - lastCallTime.current;
			var timeSinceLastInvoke = time - lastInvokeTime.current;
			return !lastCallTime.current || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
		};
		var trailingEdge = function(time) {
			timerId.current = null;
			if (trailing && lastArgs.current) return invokeFunc(time);
			lastArgs.current = lastThis.current = null;
			return result.current;
		};
		var timerExpired = function() {
			var time = Date.now();
			if (shouldInvoke(time)) return trailingEdge(time);
			if (!mounted.current) return;
			var timeSinceLastCall = time - lastCallTime.current;
			var timeSinceLastInvoke = time - lastInvokeTime.current;
			var timeWaiting = wait - timeSinceLastCall;
			startTimer(timerExpired, maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting);
		};
		var func = function() {
			var args = [];
			for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
			var time = Date.now();
			var isInvoking = shouldInvoke(time);
			lastArgs.current = args;
			lastThis.current = _this;
			lastCallTime.current = time;
			if (isInvoking) {
				if (!timerId.current && mounted.current) {
					lastInvokeTime.current = lastCallTime.current;
					startTimer(timerExpired, wait);
					return leading ? invokeFunc(lastCallTime.current) : result.current;
				}
				if (maxing) {
					startTimer(timerExpired, wait);
					return invokeFunc(lastCallTime.current);
				}
			}
			if (!timerId.current) startTimer(timerExpired, wait);
			return result.current;
		};
		func.cancel = function() {
			if (timerId.current) useRAF ? cancelAnimationFrame(timerId.current) : clearTimeout(timerId.current);
			lastInvokeTime.current = 0;
			lastArgs.current = lastCallTime.current = lastThis.current = timerId.current = null;
		};
		func.isPending = function() {
			return !!timerId.current;
		};
		func.flush = function() {
			return !timerId.current ? result.current : trailingEdge(Date.now());
		};
		return func;
	}, [
		leading,
		maxing,
		wait,
		maxWait,
		trailing,
		useRAF
	]);
}
//#endregion
//#region src/assets/icons/bold-close.svg
var SvgBoldClose = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M22.66,5.58a1.5,1.5,0,0,0,0-2.12L20.54,1.34a1.49,1.49,0,0,0-2.12,0L12.18,7.58a.27.27,0,0,1-.36,0L5.58,1.34a1.49,1.49,0,0,0-2.12,0L1.34,3.46a1.5,1.5,0,0,0,0,2.12l6.24,6.24a.25.25,0,0,1,0,.36L1.34,18.42a1.5,1.5,0,0,0,0,2.12l2.12,2.12a1.49,1.49,0,0,0,2.12,0l6.24-6.24a.27.27,0,0,1,.36,0l6.24,6.24a1.47,1.47,0,0,0,1.06.44,1.45,1.45,0,0,0,1.06-.44l2.12-2.12a1.5,1.5,0,0,0,0-2.12l-6.24-6.24a.25.25,0,0,1,0-.36Z",
		style: { fill: "currentColor" }
	})
});
var ForwardRef$25 = forwardRef(SvgBoldClose);
var Memo$25 = memo(ForwardRef$25);
//#endregion
//#region src/components/molecules/tag/tag.styled.ts
var TagContainer = (0, import_dist.default)(Stack)`
  ${({ $variant }) => $variant === "primary" ? "bg-primary-100 border-primary-300" : "bg-gray-200 border-gray-400"}
  ${({ $rounded }) => $rounded === "full" ? "rounded-full" : "rounded-md"}
  ${({ $bordered }) => $bordered ? "border" : void 0}
  max-w-full
  px-1
  py-0.5
`;
var TagLabel = (0, import_dist.default)(Typography)`
  ${({ $variant }) => $variant === "primary" ? "text-primary-800" : "text-gray-700"}
  pl-1
  max-w-full
  overflow-hidden
  text-ellipsis
`;
//#endregion
//#region src/components/molecules/tag/Tag.tsx
var Tag = ({ allowRemove = true, as, bordered = false, className, icon, id, label, onRemoveClick, rounded = "full", variant = "primary" }) => /* @__PURE__ */ React.createElement(TagContainer, {
	$variant: variant,
	$rounded: rounded,
	$bordered: bordered,
	as,
	alignItems: "center",
	justifyContent: "center",
	className,
	id
}, icon, /* @__PURE__ */ React.createElement(TagLabel, {
	$variant: variant,
	as: "span",
	fontWeight: "medium",
	fontSize: "xs"
}, label), allowRemove && /* @__PURE__ */ React.createElement(IconButton, {
	active: false,
	variant,
	icon: {
		node: /* @__PURE__ */ React.createElement(Memo$25, null),
		isNotificationToggled: false
	},
	onClick: onRemoveClick,
	rounded: "regular",
	size: "xs"
}));
//#endregion
//#region src/components/form-items/tag-input/tag-input.styled.ts
var TagInputContainer = (0, import_dist.default)(Stack)`
  bg-white
  border
  border-gray-300
  rounded-md
  ${({ $focused }) => $focused ? "ring-1 ring-primary-600 border-primary-600" : ""}
`;
var InputContainer = (0, import_dist.default)(Stack)`
  flex-1
  min-w-[100px]
  w-full
  h-5
`;
var Input$1 = (0, import_dist.default)(FormInput)`
  h-5
  w-full
  border-none
  p-0
  overflow-hidden
  text-sm
  font-normal
  placeholder:text-gray-400
  focus:ring-0
  focus:ring-offset-0
`;
//#endregion
//#region src/components/form-items/tag-input/TagInput.tsx
var TagInput = ({ className, error, errorText, id, placeholder, setTags, tags }) => {
	const [inputValue, setInputValue] = useState("");
	const [focused, setFocused] = useState(false);
	const removeTag = (index) => {
		const newTags = [...tags];
		newTags.splice(index, 1);
		setTags(newTags);
	};
	const commitInput = () => {
		setInputValue("");
		const seen = new Set(tags.map((tag) => tag.toLowerCase()));
		const added = inputValue.split(",").map((tag) => tag.trim()).filter((tag) => {
			if (!tag || seen.has(tag.toLowerCase())) return false;
			seen.add(tag.toLowerCase());
			return true;
		});
		if (added.length === 0) return;
		setTags([...tags, ...added]);
	};
	const inputKeyDown = (e) => {
		if ((e.key === "Enter" || e.key === ",") && inputValue) {
			e.preventDefault();
			commitInput();
		} else if (e.key === "Backspace" && !inputValue) removeTag(tags.length - 1);
	};
	const handleChange = (e) => {
		setInputValue(e.target.value);
	};
	const handleBlur = () => {
		setFocused(false);
		commitInput();
	};
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TagInputContainer, {
		as: "ul",
		alignItems: "center",
		wrap: "wrap",
		paddingY: 2,
		paddingX: 3,
		gap: 2,
		boxShadow: "sm",
		className,
		$focused: focused
	}, tags.map((tag, index) => /* @__PURE__ */ React.createElement(Tag, {
		as: "li",
		key: tag,
		label: tag,
		onRemoveClick: () => removeTag(index)
	})), /* @__PURE__ */ React.createElement(InputContainer, { alignItems: "center" }, /* @__PURE__ */ React.createElement(Input$1, {
		id,
		"aria-errormessage": `${id}-error`,
		"aria-invalid": error,
		placeholder,
		type: "text",
		onKeyDown: inputKeyDown,
		onChange: handleChange,
		value: inputValue,
		onFocus: () => setFocused(true),
		onBlur: handleBlur
	}))), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!error && !!errorText,
		id: `${id}-error`
	}, errorText));
};
//#endregion
//#region src/components/form-items/autocomplete/AutocompleteTagInput.tsx
var AutocompleteTagInput = ({ className, disabled, error, errorText, groupEndValues = [], id, name, onChange, optionDisabledKey, optionDisplayKey = "label", options = [], optionValueKey = "value", placeholder = "Type to search", searchKeys = optionDisplayKey !== void 0 ? [optionDisplayKey] : void 0, values, allowCreate = true, allowRemove = true, tagProps = {}, searchKeyword, searchKeywordDebounce = 200, setSearchKeyword, isLoading, ...props }) => {
	const [selectedOptions, setSelectedOptions] = useState(values ?? []);
	const [query, setQuery] = useState(searchKeyword ?? "");
	const [focused, setFocused] = useState(false);
	const handleChangeInput = (e) => {
		setQuery(e.target.value);
		debouncedSetSearchKeyword(e.target.value);
	};
	const debouncedSetSearchKeyword = useDebouncedCallback((value) => {
		setSearchKeyword?.(value);
	}, searchKeywordDebounce);
	const handleChangeCombobox = (values) => {
		setSelectedOptions(values);
		onChange?.(values);
		setQuery("");
	};
	const removeTag = (index) => {
		const newTags = [...selectedOptions];
		newTags.splice(index, 1);
		setSelectedOptions(newTags);
		onChange?.(newTags);
	};
	const inputKeyDown = (e) => {
		if (allowRemove && e.key === "Backspace" && !query) removeTag(selectedOptions.length - 1);
	};
	const filteredOptions = (query === "" ? options : matchSorter(options, query, { keys: searchKeys })).filter((option) => !selectedOptions.find((selectedOption) => selectedOption.value === option.value));
	useEffect(() => {
		setSelectedOptions(values ?? []);
	}, [values]);
	return /* @__PURE__ */ React.createElement(Ot, {
		as: "div",
		name,
		value: selectedOptions,
		onChange: handleChangeCombobox,
		className: (0, import_classnames.default)("relative", className),
		id,
		disabled,
		nullable: true,
		multiple: true,
		...props
	}, /* @__PURE__ */ React.createElement("div", { className: "relative" }, /* @__PURE__ */ React.createElement(TagInputContainer, {
		as: "ul",
		alignItems: "center",
		wrap: "wrap",
		paddingY: 2,
		paddingX: 3,
		gap: 2,
		boxShadow: "sm",
		$focused: focused
	}, selectedOptions.map((option, index) => /* @__PURE__ */ React.createElement(Tag, {
		as: "li",
		key: option[optionValueKey],
		label: option[optionDisplayKey],
		onRemoveClick: () => removeTag(index),
		allowRemove,
		...option,
		...tagProps
	})), /* @__PURE__ */ React.createElement(InputContainer, { alignItems: "center" }, /* @__PURE__ */ React.createElement(InputItem, {
		onChange: handleChangeInput,
		displayValue: () => query,
		placeholder: !selectedOptions.length ? placeholder : "",
		disabled,
		onKeyDown: inputKeyDown,
		onFocus: () => setFocused(true),
		onBlur: () => setFocused(false)
	})))), /* @__PURE__ */ React.createElement(AutocompleteOptions, {
		options: filteredOptions,
		valueKey: optionValueKey,
		displayKey: optionDisplayKey,
		disabledKey: optionDisabledKey,
		groupEndValues,
		query,
		setQuery,
		allowCreate,
		isLoading
	}), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!error && !!errorText,
		id: `${id}-error`
	}, errorText ? errorText : "Invalid value provided. Please select a new value."));
};
//#endregion
//#region src/components/form-items/check-box/Checkbox.tsx
var Checkbox = ({ alignItems = "start", checked = false, className, disabled = false, icon, id, name, onChange, subtitle, title }) => {
	const handleOnChange = useCallback((e) => onChange?.(e.target.checked), [onChange]);
	return /* @__PURE__ */ React.createElement(Stack, {
		alignItems,
		justifyContent: "start",
		className: (0, import_classnames.default)(disabled ? "opacity-70" : "", className)
	}, /* @__PURE__ */ React.createElement(Stack, {
		alignItems: "center",
		justifyContent: "start",
		className: "h-5"
	}, /* @__PURE__ */ React.createElement(CheckboxAtom, {
		id,
		name,
		checked,
		disabled,
		onChange: handleOnChange
	})), /* @__PURE__ */ React.createElement("div", { className: "ml-3" }, /* @__PURE__ */ React.createElement(Stack, {
		direction: "row",
		alignItems: "start",
		justifyContent: "start"
	}, icon && /* @__PURE__ */ React.createElement("div", { className: "w-5 h-5 mr-1" }, icon), /* @__PURE__ */ React.createElement("label", {
		htmlFor: id,
		className: "font-medium text-gray-700"
	}, title)), subtitle && /* @__PURE__ */ React.createElement("p", { className: "mb-0 text-gray-500" }, subtitle)));
};
var CheckboxMemo = memo(Checkbox);
//#endregion
//#region src/components/form-items/check-box/styled.ts
var StyledCheckboxContainer = import_dist.default.div`
    w-full
`;
//#endregion
//#region src/components/form-items/check-box/CheckBoxContainer.tsx
var CheckboxContainer = ({ children, className }) => /* @__PURE__ */ React.createElement(StyledCheckboxContainer, { className }, /* @__PURE__ */ React.createElement("fieldset", { className: "mt-4 gap-4 grid grid-cols-2" }, children));
var CheckboxContainerMemo = memo(CheckboxContainer);
//#endregion
//#region src/components/form-items/form-section/styled.ts
var StyledFormSection = import_dist.default.div`
    w-full
`;
var FormSectionTitle = import_dist.default.h4`
    block
    text-base
    font-medium
    text-gray-700
`;
var FormSectionSubtitleText = import_dist.default.div`
    mt-1
    text-sm
    text-gray-500
`;
var FormSectionHelpText = FormSectionSubtitleText;
var FormSectionChildren = import_dist.default.div`
    mt-1
    space-y-6
`;
//#endregion
//#region src/components/form-items/form-section/FormSection.tsx
var FormSection = ({ children, className, subtitle, title }) => /* @__PURE__ */ React.createElement(StyledFormSection, { className }, /* @__PURE__ */ React.createElement(FormSectionTitle, null, title), subtitle && /* @__PURE__ */ React.createElement(FormSectionSubtitleText, null, subtitle), children && /* @__PURE__ */ React.createElement(FormSectionChildren, null, children));
var FormSectionMemo = memo(FormSection);
//#endregion
//#region src/components/form-items/indent/styled.ts
var StyledIndent = import_dist.default.div`
${({ $border }) => $border ? "border-l-2 border-gray-200" : ""}
    pl-10
    space-y-8
`;
//#endregion
//#region src/components/form-items/indent/Indent.tsx
var Indent = ({ border = true, children, className }) => /* @__PURE__ */ React.createElement(StyledIndent, {
	$border: border,
	className
}, children);
var IndentMemo = memo(Indent);
//#endregion
//#region ../../node_modules/imask/esm/_rollupPluginBabelHelpers-6b3bd404.js
function _objectWithoutPropertiesLoose$4(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source);
	var key, i = 0;
	for (; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) continue;
		target[key] = source[key];
	}
	return target;
}
//#endregion
//#region ../../node_modules/imask/esm/core/holder.js
/**
* Applies mask on element.
* @constructor
* @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
* @param {Object} opts - Custom mask options
* @return {InputMask}
*/
function IMask(el) {
	let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	return new IMask.InputMask(el, opts);
}
//#endregion
//#region ../../node_modules/imask/esm/core/change-details.js
/**
Provides details of changing model value
@param {Object} [details]
@param {string} [details.inserted] - Inserted symbols
@param {boolean} [details.skip] - Can skip chars
@param {number} [details.removeCount] - Removed symbols count
@param {number} [details.tailShift] - Additional offset if any changes occurred before tail
*/
var ChangeDetails = class {
	/** Inserted symbols */
	/** Can skip chars */
	/** Additional offset if any changes occurred before tail */
	/** Raw inserted is used by dynamic mask */
	constructor(details) {
		Object.assign(this, {
			inserted: "",
			rawInserted: "",
			skip: false,
			tailShift: 0
		}, details);
	}
	/**
	Aggregate changes
	@returns {ChangeDetails} `this`
	*/
	aggregate(details) {
		this.rawInserted += details.rawInserted;
		this.skip = this.skip || details.skip;
		this.inserted += details.inserted;
		this.tailShift += details.tailShift;
		return this;
	}
	/** Total offset considering all changes */
	get offset() {
		return this.tailShift + this.inserted.length;
	}
};
IMask.ChangeDetails = ChangeDetails;
//#endregion
//#region ../../node_modules/imask/esm/core/utils.js
/** Checks if value is string */
function isString(str) {
	return typeof str === "string" || str instanceof String;
}
/**
Direction
@prop {string} NONE
@prop {string} LEFT
@prop {string} FORCE_LEFT
@prop {string} RIGHT
@prop {string} FORCE_RIGHT
*/
var DIRECTION = {
	NONE: "NONE",
	LEFT: "LEFT",
	FORCE_LEFT: "FORCE_LEFT",
	RIGHT: "RIGHT",
	FORCE_RIGHT: "FORCE_RIGHT"
};
/** */
function forceDirection(direction) {
	switch (direction) {
		case DIRECTION.LEFT: return DIRECTION.FORCE_LEFT;
		case DIRECTION.RIGHT: return DIRECTION.FORCE_RIGHT;
		default: return direction;
	}
}
/** Escapes regular expression control chars */
function escapeRegExp(str) {
	return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function normalizePrepare(prep) {
	return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
}
function objectIncludes(b, a) {
	if (a === b) return true;
	var arrA = Array.isArray(a), arrB = Array.isArray(b), i;
	if (arrA && arrB) {
		if (a.length != b.length) return false;
		for (i = 0; i < a.length; i++) if (!objectIncludes(a[i], b[i])) return false;
		return true;
	}
	if (arrA != arrB) return false;
	if (a && b && typeof a === "object" && typeof b === "object") {
		var dateA = a instanceof Date, dateB = b instanceof Date;
		if (dateA && dateB) return a.getTime() == b.getTime();
		if (dateA != dateB) return false;
		var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
		if (regexpA && regexpB) return a.toString() == b.toString();
		if (regexpA != regexpB) return false;
		var keys = Object.keys(a);
		for (i = 0; i < keys.length; i++) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
		for (i = 0; i < keys.length; i++) if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
		return true;
	} else if (a && b && typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
	return false;
}
//#endregion
//#region ../../node_modules/imask/esm/core/action-details.js
/** Provides details of changing input */
var ActionDetails = class {
	/** Current input value */
	/** Current cursor position */
	/** Old input value */
	/** Old selection */
	constructor(value, cursorPos, oldValue, oldSelection) {
		this.value = value;
		this.cursorPos = cursorPos;
		this.oldValue = oldValue;
		this.oldSelection = oldSelection;
		while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) --this.oldSelection.start;
	}
	/**
	Start changing position
	@readonly
	*/
	get startChangePos() {
		return Math.min(this.cursorPos, this.oldSelection.start);
	}
	/**
	Inserted symbols count
	@readonly
	*/
	get insertedCount() {
		return this.cursorPos - this.startChangePos;
	}
	/**
	Inserted symbols
	@readonly
	*/
	get inserted() {
		return this.value.substr(this.startChangePos, this.insertedCount);
	}
	/**
	Removed symbols count
	@readonly
	*/
	get removedCount() {
		return Math.max(this.oldSelection.end - this.startChangePos || this.oldValue.length - this.value.length, 0);
	}
	/**
	Removed symbols
	@readonly
	*/
	get removed() {
		return this.oldValue.substr(this.startChangePos, this.removedCount);
	}
	/**
	Unchanged head symbols
	@readonly
	*/
	get head() {
		return this.value.substring(0, this.startChangePos);
	}
	/**
	Unchanged tail symbols
	@readonly
	*/
	get tail() {
		return this.value.substring(this.startChangePos + this.insertedCount);
	}
	/**
	Remove direction
	@readonly
	*/
	get removeDirection() {
		if (!this.removedCount || this.insertedCount) return DIRECTION.NONE;
		return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
	}
};
//#endregion
//#region ../../node_modules/imask/esm/core/continuous-tail-details.js
/** Provides details of continuous extracted tail */
var ContinuousTailDetails = class {
	/** Tail value as string */
	/** Tail start position */
	/** Start position */
	constructor() {
		let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
		let from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
		let stop = arguments.length > 2 ? arguments[2] : void 0;
		this.value = value;
		this.from = from;
		this.stop = stop;
	}
	toString() {
		return this.value;
	}
	extend(tail) {
		this.value += String(tail);
	}
	appendTo(masked) {
		return masked.append(this.toString(), { tail: true }).aggregate(masked._appendPlaceholder());
	}
	get state() {
		return {
			value: this.value,
			from: this.from,
			stop: this.stop
		};
	}
	set state(state) {
		Object.assign(this, state);
	}
	unshift(beforePos) {
		if (!this.value.length || beforePos != null && this.from >= beforePos) return "";
		const shiftChar = this.value[0];
		this.value = this.value.slice(1);
		return shiftChar;
	}
	shift() {
		if (!this.value.length) return "";
		const shiftChar = this.value[this.value.length - 1];
		this.value = this.value.slice(0, -1);
		return shiftChar;
	}
};
//#endregion
//#region ../../node_modules/imask/esm/masked/base.js
/** Supported mask type */
/** Append flags */
/** Extract flags */
/** Provides common masking stuff */
var Masked = class Masked {
	/** @type {Mask} */
	/** */
	/** Transforms value before mask processing */
	/** Validates if value is acceptable */
	/** Does additional processing in the end of editing */
	/** Format typed value to string */
	/** Parse strgin to get typed value */
	/** Enable characters overwriting */
	/** */
	/** */
	/** */
	constructor(opts) {
		this._value = "";
		this._update(Object.assign({}, Masked.DEFAULTS, opts));
		this.isInitialized = true;
	}
	/** Sets and applies new options */
	updateOptions(opts) {
		if (!Object.keys(opts).length) return;
		this.withValueRefresh(this._update.bind(this, opts));
	}
	/**
	Sets new options
	@protected
	*/
	_update(opts) {
		Object.assign(this, opts);
	}
	/** Mask state */
	get state() {
		return { _value: this.value };
	}
	set state(state) {
		this._value = state._value;
	}
	/** Resets value */
	reset() {
		this._value = "";
	}
	/** */
	get value() {
		return this._value;
	}
	set value(value) {
		this.resolve(value);
	}
	/** Resolve new value */
	resolve(value) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { input: true };
		this.reset();
		this.append(value, flags, "");
		this.doCommit();
		return this.value;
	}
	/** */
	get unmaskedValue() {
		return this.value;
	}
	set unmaskedValue(value) {
		this.reset();
		this.append(value, {}, "");
		this.doCommit();
	}
	/** */
	get typedValue() {
		return this.doParse(this.value);
	}
	set typedValue(value) {
		this.value = this.doFormat(value);
	}
	/** Value that includes raw user input */
	get rawInputValue() {
		return this.extractInput(0, this.value.length, { raw: true });
	}
	set rawInputValue(value) {
		this.reset();
		this.append(value, { raw: true }, "");
		this.doCommit();
	}
	get displayValue() {
		return this.value;
	}
	/** */
	get isComplete() {
		return true;
	}
	/** */
	get isFilled() {
		return this.isComplete;
	}
	/** Finds nearest input position in direction */
	nearestInputPos(cursorPos, direction) {
		return cursorPos;
	}
	totalInputPositions() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		return Math.min(this.value.length, toPos - fromPos);
	}
	/** Extracts value in range considering flags */
	extractInput() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		return this.value.slice(fromPos, toPos);
	}
	/** Extracts tail in range */
	extractTail() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
	}
	/** Appends tail */
	appendTail(tail) {
		if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
		return tail.appendTo(this);
	}
	/** Appends char */
	_appendCharRaw(ch) {
		if (!ch) return new ChangeDetails();
		this._value += ch;
		return new ChangeDetails({
			inserted: ch,
			rawInserted: ch
		});
	}
	/** Appends char */
	_appendChar(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let checkTail = arguments.length > 2 ? arguments[2] : void 0;
		const consistentState = this.state;
		let details;
		[ch, details] = normalizePrepare(this.doPrepare(ch, flags));
		details = details.aggregate(this._appendCharRaw(ch, flags));
		if (details.inserted) {
			let consistentTail;
			let appended = this.doValidate(flags) !== false;
			if (appended && checkTail != null) {
				const beforeTailState = this.state;
				if (this.overwrite === true) {
					consistentTail = checkTail.state;
					checkTail.unshift(this.value.length - details.tailShift);
				}
				let tailDetails = this.appendTail(checkTail);
				appended = tailDetails.rawInserted === checkTail.toString();
				if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
					this.state = beforeTailState;
					consistentTail = checkTail.state;
					checkTail.shift();
					tailDetails = this.appendTail(checkTail);
					appended = tailDetails.rawInserted === checkTail.toString();
				}
				if (appended && tailDetails.inserted) this.state = beforeTailState;
			}
			if (!appended) {
				details = new ChangeDetails();
				this.state = consistentState;
				if (checkTail && consistentTail) checkTail.state = consistentTail;
			}
		}
		return details;
	}
	/** Appends optional placeholder at end */
	_appendPlaceholder() {
		return new ChangeDetails();
	}
	/** Appends optional eager placeholder at end */
	_appendEager() {
		return new ChangeDetails();
	}
	/** Appends symbols considering flags */
	append(str, flags, tail) {
		if (!isString(str)) throw new Error("value should be string");
		const details = new ChangeDetails();
		const checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
		if (flags !== null && flags !== void 0 && flags.tail) flags._beforeTailState = this.state;
		for (let ci = 0; ci < str.length; ++ci) {
			const d = this._appendChar(str[ci], flags, checkTail);
			if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
			details.aggregate(d);
		}
		if ((this.eager === true || this.eager === "append") && flags !== null && flags !== void 0 && flags.input && str) details.aggregate(this._appendEager());
		if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
		return details;
	}
	/** */
	remove() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
		return new ChangeDetails();
	}
	/** Calls function and reapplies current value */
	withValueRefresh(fn) {
		if (this._refreshing || !this.isInitialized) return fn();
		this._refreshing = true;
		const rawInput = this.rawInputValue;
		const value = this.value;
		const ret = fn();
		this.rawInputValue = rawInput;
		if (this.value && this.value !== value && value.indexOf(this.value) === 0) this.append(value.slice(this.value.length), {}, "");
		delete this._refreshing;
		return ret;
	}
	/** */
	runIsolated(fn) {
		if (this._isolated || !this.isInitialized) return fn(this);
		this._isolated = true;
		const state = this.state;
		const ret = fn(this);
		this.state = state;
		delete this._isolated;
		return ret;
	}
	/** */
	doSkipInvalid(ch) {
		return this.skipInvalid;
	}
	/**
	Prepares string before mask processing
	@protected
	*/
	doPrepare(str) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		return this.prepare ? this.prepare(str, this, flags) : str;
	}
	/**
	Validates if value is acceptable
	@protected
	*/
	doValidate(flags) {
		return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
	}
	/**
	Does additional processing in the end of editing
	@protected
	*/
	doCommit() {
		if (this.commit) this.commit(this.value, this);
	}
	/** */
	doFormat(value) {
		return this.format ? this.format(value, this) : value;
	}
	/** */
	doParse(str) {
		return this.parse ? this.parse(str, this) : str;
	}
	/** */
	splice(start, deleteCount, inserted, removeDirection) {
		let flags = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : { input: true };
		const tailPos = start + deleteCount;
		const tail = this.extractTail(tailPos);
		const eagerRemove = this.eager === true || this.eager === "remove";
		let oldRawValue;
		if (eagerRemove) {
			removeDirection = forceDirection(removeDirection);
			oldRawValue = this.extractInput(0, tailPos, { raw: true });
		}
		let startChangePos = start;
		const details = new ChangeDetails();
		if (removeDirection !== DIRECTION.NONE) {
			startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection);
			details.tailShift = startChangePos - start;
		}
		details.aggregate(this.remove(startChangePos));
		if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
			if (removeDirection === DIRECTION.FORCE_LEFT) {
				let valLength;
				while (oldRawValue === this.rawInputValue && (valLength = this.value.length)) details.aggregate(new ChangeDetails({ tailShift: -1 })).aggregate(this.remove(valLength - 1));
			} else if (removeDirection === DIRECTION.FORCE_RIGHT) tail.unshift();
		}
		return details.aggregate(this.append(inserted, flags, tail));
	}
	maskEquals(mask) {
		return this.mask === mask;
	}
	typedValueEquals(value) {
		const tval = this.typedValue;
		return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || this.doFormat(value) === this.doFormat(this.typedValue);
	}
};
Masked.DEFAULTS = {
	format: String,
	parse: (v) => v,
	skipInvalid: true
};
Masked.EMPTY_VALUES = [
	void 0,
	null,
	""
];
IMask.Masked = Masked;
//#endregion
//#region ../../node_modules/imask/esm/masked/factory.js
/** Get Masked class by mask type */
function maskedClass(mask) {
	if (mask == null) throw new Error("mask property should be defined");
	if (mask instanceof RegExp) return IMask.MaskedRegExp;
	if (isString(mask)) return IMask.MaskedPattern;
	if (mask instanceof Date || mask === Date) return IMask.MaskedDate;
	if (mask instanceof Number || typeof mask === "number" || mask === Number) return IMask.MaskedNumber;
	if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic;
	if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask;
	if (mask instanceof IMask.Masked) return mask.constructor;
	if (mask instanceof Function) return IMask.MaskedFunction;
	console.warn("Mask not found for mask", mask);
	return IMask.Masked;
}
/** Creates new {@link Masked} depending on mask type */
function createMask(opts) {
	if (IMask.Masked && opts instanceof IMask.Masked) return opts;
	opts = Object.assign({}, opts);
	const mask = opts.mask;
	if (IMask.Masked && mask instanceof IMask.Masked) return mask;
	const MaskedClass = maskedClass(mask);
	if (!MaskedClass) throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
	return new MaskedClass(opts);
}
IMask.createMask = createMask;
//#endregion
//#region ../../node_modules/imask/esm/masked/pattern/input-definition.js
var _excluded$10 = [
	"parent",
	"isOptional",
	"placeholderChar",
	"displayChar",
	"lazy",
	"eager"
];
/** */
var DEFAULT_INPUT_DEFINITIONS = {
	"0": /\d/,
	"a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
	"*": /./
};
/** */
var PatternInputDefinition = class {
	/** */
	/** */
	/** */
	/** */
	/** */
	/** */
	/** */
	/** */
	constructor(opts) {
		const { parent, isOptional, placeholderChar, displayChar, lazy, eager } = opts, maskOpts = _objectWithoutPropertiesLoose$4(opts, _excluded$10);
		this.masked = createMask(maskOpts);
		Object.assign(this, {
			parent,
			isOptional,
			placeholderChar,
			displayChar,
			lazy,
			eager
		});
	}
	reset() {
		this.isFilled = false;
		this.masked.reset();
	}
	remove() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		if (fromPos === 0 && toPos >= 1) {
			this.isFilled = false;
			return this.masked.remove(fromPos, toPos);
		}
		return new ChangeDetails();
	}
	get value() {
		return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
	}
	get unmaskedValue() {
		return this.masked.unmaskedValue;
	}
	get displayValue() {
		return this.masked.value && this.displayChar || this.value;
	}
	get isComplete() {
		return Boolean(this.masked.value) || this.isOptional;
	}
	_appendChar(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		if (this.isFilled) return new ChangeDetails();
		const state = this.masked.state;
		const details = this.masked._appendChar(ch, flags);
		if (details.inserted && this.doValidate(flags) === false) {
			details.inserted = details.rawInserted = "";
			this.masked.state = state;
		}
		if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
		details.skip = !details.inserted && !this.isOptional;
		this.isFilled = Boolean(details.inserted);
		return details;
	}
	append() {
		return this.masked.append(...arguments);
	}
	_appendPlaceholder() {
		const details = new ChangeDetails();
		if (this.isFilled || this.isOptional) return details;
		this.isFilled = true;
		details.inserted = this.placeholderChar;
		return details;
	}
	_appendEager() {
		return new ChangeDetails();
	}
	extractTail() {
		return this.masked.extractTail(...arguments);
	}
	appendTail() {
		return this.masked.appendTail(...arguments);
	}
	extractInput() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		let flags = arguments.length > 2 ? arguments[2] : void 0;
		return this.masked.extractInput(fromPos, toPos, flags);
	}
	nearestInputPos(cursorPos) {
		let direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
		const minPos = 0;
		const maxPos = this.value.length;
		const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
		switch (direction) {
			case DIRECTION.LEFT:
			case DIRECTION.FORCE_LEFT: return this.isComplete ? boundPos : minPos;
			case DIRECTION.RIGHT:
			case DIRECTION.FORCE_RIGHT: return this.isComplete ? boundPos : maxPos;
			case DIRECTION.NONE:
			default: return boundPos;
		}
	}
	totalInputPositions() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		return this.value.slice(fromPos, toPos).length;
	}
	doValidate() {
		return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
	}
	doCommit() {
		this.masked.doCommit();
	}
	get state() {
		return {
			masked: this.masked.state,
			isFilled: this.isFilled
		};
	}
	set state(state) {
		this.masked.state = state.masked;
		this.isFilled = state.isFilled;
	}
};
//#endregion
//#region ../../node_modules/imask/esm/masked/pattern/fixed-definition.js
/** */
var PatternFixedDefinition = class {
	/** */
	/** */
	/** */
	/** */
	/** */
	/** */
	constructor(opts) {
		Object.assign(this, opts);
		this._value = "";
		this.isFixed = true;
	}
	get value() {
		return this._value;
	}
	get unmaskedValue() {
		return this.isUnmasking ? this.value : "";
	}
	get displayValue() {
		return this.value;
	}
	reset() {
		this._isRawInput = false;
		this._value = "";
	}
	remove() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
		this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
		if (!this._value) this._isRawInput = false;
		return new ChangeDetails();
	}
	nearestInputPos(cursorPos) {
		let direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
		const minPos = 0;
		const maxPos = this._value.length;
		switch (direction) {
			case DIRECTION.LEFT:
			case DIRECTION.FORCE_LEFT: return minPos;
			case DIRECTION.NONE:
			case DIRECTION.RIGHT:
			case DIRECTION.FORCE_RIGHT:
			default: return maxPos;
		}
	}
	totalInputPositions() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
		return this._isRawInput ? toPos - fromPos : 0;
	}
	extractInput() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
		return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
	}
	get isComplete() {
		return true;
	}
	get isFilled() {
		return Boolean(this._value);
	}
	_appendChar(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		const details = new ChangeDetails();
		if (this.isFilled) return details;
		const appendEager = this.eager === true || this.eager === "append";
		const isResolved = this.char === ch && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
		if (isResolved) details.rawInserted = this.char;
		this._value = details.inserted = this.char;
		this._isRawInput = isResolved && (flags.raw || flags.input);
		return details;
	}
	_appendEager() {
		return this._appendChar(this.char, { tail: true });
	}
	_appendPlaceholder() {
		const details = new ChangeDetails();
		if (this.isFilled) return details;
		this._value = details.inserted = this.char;
		return details;
	}
	extractTail() {
		arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		return new ContinuousTailDetails("");
	}
	appendTail(tail) {
		if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
		return tail.appendTo(this);
	}
	append(str, flags, tail) {
		const details = this._appendChar(str[0], flags);
		if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
		return details;
	}
	doCommit() {}
	get state() {
		return {
			_value: this._value,
			_isRawInput: this._isRawInput
		};
	}
	set state(state) {
		Object.assign(this, state);
	}
};
//#endregion
//#region ../../node_modules/imask/esm/masked/pattern/chunk-tail-details.js
var _excluded$9 = ["chunks"];
var ChunksTailDetails = class ChunksTailDetails {
	/** */
	constructor() {
		let chunks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
		let from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
		this.chunks = chunks;
		this.from = from;
	}
	toString() {
		return this.chunks.map(String).join("");
	}
	extend(tailChunk) {
		if (!String(tailChunk)) return;
		if (isString(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
		const lastChunk = this.chunks[this.chunks.length - 1];
		const extendLast = lastChunk && (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && tailChunk.from === lastChunk.from + lastChunk.toString().length;
		if (tailChunk instanceof ContinuousTailDetails) {
			if (extendLast) lastChunk.extend(tailChunk.toString());
			else this.chunks.push(tailChunk);
		} else if (tailChunk instanceof ChunksTailDetails) {
			if (tailChunk.stop == null) {
				let firstTailChunk;
				while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
					firstTailChunk = tailChunk.chunks.shift();
					firstTailChunk.from += tailChunk.from;
					this.extend(firstTailChunk);
				}
			}
			if (tailChunk.toString()) {
				tailChunk.stop = tailChunk.blockIndex;
				this.chunks.push(tailChunk);
			}
		}
	}
	appendTo(masked) {
		if (!(masked instanceof IMask.MaskedPattern)) return new ContinuousTailDetails(this.toString()).appendTo(masked);
		const details = new ChangeDetails();
		for (let ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
			const chunk = this.chunks[ci];
			const lastBlockIter = masked._mapPosToBlock(masked.value.length);
			const stop = chunk.stop;
			let chunkBlock;
			if (stop != null && (!lastBlockIter || lastBlockIter.index <= stop)) {
				if (chunk instanceof ChunksTailDetails || masked._stops.indexOf(stop) >= 0) {
					const phDetails = masked._appendPlaceholder(stop);
					details.aggregate(phDetails);
				}
				chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
			}
			if (chunkBlock) {
				const tailDetails = chunkBlock.appendTail(chunk);
				tailDetails.skip = false;
				details.aggregate(tailDetails);
				masked._value += tailDetails.inserted;
				const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
				if (remainChars) details.aggregate(masked.append(remainChars, { tail: true }));
			} else details.aggregate(masked.append(chunk.toString(), { tail: true }));
		}
		return details;
	}
	get state() {
		return {
			chunks: this.chunks.map((c) => c.state),
			from: this.from,
			stop: this.stop,
			blockIndex: this.blockIndex
		};
	}
	set state(state) {
		const { chunks } = state, props = _objectWithoutPropertiesLoose$4(state, _excluded$9);
		Object.assign(this, props);
		this.chunks = chunks.map((cstate) => {
			const chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
			chunk.state = cstate;
			return chunk;
		});
	}
	unshift(beforePos) {
		if (!this.chunks.length || beforePos != null && this.from >= beforePos) return "";
		const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
		let ci = 0;
		while (ci < this.chunks.length) {
			const chunk = this.chunks[ci];
			const shiftChar = chunk.unshift(chunkShiftPos);
			if (chunk.toString()) {
				if (!shiftChar) break;
				++ci;
			} else this.chunks.splice(ci, 1);
			if (shiftChar) return shiftChar;
		}
		return "";
	}
	shift() {
		if (!this.chunks.length) return "";
		let ci = this.chunks.length - 1;
		while (0 <= ci) {
			const chunk = this.chunks[ci];
			const shiftChar = chunk.shift();
			if (chunk.toString()) {
				if (!shiftChar) break;
				--ci;
			} else this.chunks.splice(ci, 1);
			if (shiftChar) return shiftChar;
		}
		return "";
	}
};
//#endregion
//#region ../../node_modules/imask/esm/masked/pattern/cursor.js
var PatternCursor = class {
	constructor(masked, pos) {
		this.masked = masked;
		this._log = [];
		const { offset, index } = masked._mapPosToBlock(pos) || (pos < 0 ? {
			index: 0,
			offset: 0
		} : {
			index: this.masked._blocks.length,
			offset: 0
		});
		this.offset = offset;
		this.index = index;
		this.ok = false;
	}
	get block() {
		return this.masked._blocks[this.index];
	}
	get pos() {
		return this.masked._blockStartPos(this.index) + this.offset;
	}
	get state() {
		return {
			index: this.index,
			offset: this.offset,
			ok: this.ok
		};
	}
	set state(s) {
		Object.assign(this, s);
	}
	pushState() {
		this._log.push(this.state);
	}
	popState() {
		const s = this._log.pop();
		this.state = s;
		return s;
	}
	bindBlock() {
		if (this.block) return;
		if (this.index < 0) {
			this.index = 0;
			this.offset = 0;
		}
		if (this.index >= this.masked._blocks.length) {
			this.index = this.masked._blocks.length - 1;
			this.offset = this.block.value.length;
		}
	}
	_pushLeft(fn) {
		this.pushState();
		for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0) {
			var _this$block;
			if (fn()) return this.ok = true;
		}
		return this.ok = false;
	}
	_pushRight(fn) {
		this.pushState();
		for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) if (fn()) return this.ok = true;
		return this.ok = false;
	}
	pushLeftBeforeFilled() {
		return this._pushLeft(() => {
			if (this.block.isFixed || !this.block.value) return;
			this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
			if (this.offset !== 0) return true;
		});
	}
	pushLeftBeforeInput() {
		return this._pushLeft(() => {
			if (this.block.isFixed) return;
			this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
			return true;
		});
	}
	pushLeftBeforeRequired() {
		return this._pushLeft(() => {
			if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
			this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
			return true;
		});
	}
	pushRightBeforeFilled() {
		return this._pushRight(() => {
			if (this.block.isFixed || !this.block.value) return;
			this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
			if (this.offset !== this.block.value.length) return true;
		});
	}
	pushRightBeforeInput() {
		return this._pushRight(() => {
			if (this.block.isFixed) return;
			this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
			return true;
		});
	}
	pushRightBeforeRequired() {
		return this._pushRight(() => {
			if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
			this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
			return true;
		});
	}
};
//#endregion
//#region ../../node_modules/imask/esm/masked/regexp.js
/** Masking by RegExp */
var MaskedRegExp = class extends Masked {
	/**
	@override
	@param {Object} opts
	*/
	_update(opts) {
		if (opts.mask) opts.validate = (value) => value.search(opts.mask) >= 0;
		super._update(opts);
	}
};
IMask.MaskedRegExp = MaskedRegExp;
//#endregion
//#region ../../node_modules/imask/esm/masked/pattern.js
var _excluded$8 = ["_blocks"];
/**
Pattern mask
@param {Object} opts
@param {Object} opts.blocks
@param {Object} opts.definitions
@param {string} opts.placeholderChar
@param {string} opts.displayChar
@param {boolean} opts.lazy
*/
var MaskedPattern = class MaskedPattern extends Masked {
	/** */
	/** */
	/** Single char for empty input */
	/** Single char for filled input */
	/** Show placeholder only when needed */
	constructor() {
		let opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
		super(Object.assign({}, MaskedPattern.DEFAULTS, opts));
	}
	/**
	@override
	@param {Object} opts
	*/
	_update() {
		let opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		opts.definitions = Object.assign({}, this.definitions, opts.definitions);
		super._update(opts);
		this._rebuildMask();
	}
	/** */
	_rebuildMask() {
		const defs = this.definitions;
		this._blocks = [];
		this._stops = [];
		this._maskedBlocks = {};
		let pattern = this.mask;
		if (!pattern || !defs) return;
		let unmaskingBlock = false;
		let optionalBlock = false;
		for (let i = 0; i < pattern.length; ++i) {
			var _defs$char, _defs$char2;
			if (this.blocks) {
				const p = pattern.slice(i);
				const bNames = Object.keys(this.blocks).filter((bName) => p.indexOf(bName) === 0);
				bNames.sort((a, b) => b.length - a.length);
				const bName = bNames[0];
				if (bName) {
					const maskedBlock = createMask(Object.assign({
						parent: this,
						lazy: this.lazy,
						eager: this.eager,
						placeholderChar: this.placeholderChar,
						displayChar: this.displayChar,
						overwrite: this.overwrite
					}, this.blocks[bName]));
					if (maskedBlock) {
						this._blocks.push(maskedBlock);
						if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
						this._maskedBlocks[bName].push(this._blocks.length - 1);
					}
					i += bName.length - 1;
					continue;
				}
			}
			let char = pattern[i];
			let isInput = char in defs;
			if (char === MaskedPattern.STOP_CHAR) {
				this._stops.push(this._blocks.length);
				continue;
			}
			if (char === "{" || char === "}") {
				unmaskingBlock = !unmaskingBlock;
				continue;
			}
			if (char === "[" || char === "]") {
				optionalBlock = !optionalBlock;
				continue;
			}
			if (char === MaskedPattern.ESCAPE_CHAR) {
				++i;
				char = pattern[i];
				if (!char) break;
				isInput = false;
			}
			const maskOpts = (_defs$char = defs[char]) !== null && _defs$char !== void 0 && _defs$char.mask && !(((_defs$char2 = defs[char]) === null || _defs$char2 === void 0 ? void 0 : _defs$char2.mask.prototype) instanceof IMask.Masked) ? defs[char] : { mask: defs[char] };
			const def = isInput ? new PatternInputDefinition(Object.assign({
				parent: this,
				isOptional: optionalBlock,
				lazy: this.lazy,
				eager: this.eager,
				placeholderChar: this.placeholderChar,
				displayChar: this.displayChar
			}, maskOpts)) : new PatternFixedDefinition({
				char,
				eager: this.eager,
				isUnmasking: unmaskingBlock
			});
			this._blocks.push(def);
		}
	}
	/**
	@override
	*/
	get state() {
		return Object.assign({}, super.state, { _blocks: this._blocks.map((b) => b.state) });
	}
	set state(state) {
		const { _blocks } = state, maskedState = _objectWithoutPropertiesLoose$4(state, _excluded$8);
		this._blocks.forEach((b, bi) => b.state = _blocks[bi]);
		super.state = maskedState;
	}
	/**
	@override
	*/
	reset() {
		super.reset();
		this._blocks.forEach((b) => b.reset());
	}
	/**
	@override
	*/
	get isComplete() {
		return this._blocks.every((b) => b.isComplete);
	}
	/**
	@override
	*/
	get isFilled() {
		return this._blocks.every((b) => b.isFilled);
	}
	get isFixed() {
		return this._blocks.every((b) => b.isFixed);
	}
	get isOptional() {
		return this._blocks.every((b) => b.isOptional);
	}
	/**
	@override
	*/
	doCommit() {
		this._blocks.forEach((b) => b.doCommit());
		super.doCommit();
	}
	/**
	@override
	*/
	get unmaskedValue() {
		return this._blocks.reduce((str, b) => str += b.unmaskedValue, "");
	}
	set unmaskedValue(unmaskedValue) {
		super.unmaskedValue = unmaskedValue;
	}
	/**
	@override
	*/
	get value() {
		return this._blocks.reduce((str, b) => str += b.value, "");
	}
	set value(value) {
		super.value = value;
	}
	get displayValue() {
		return this._blocks.reduce((str, b) => str += b.displayValue, "");
	}
	/**
	@override
	*/
	appendTail(tail) {
		return super.appendTail(tail).aggregate(this._appendPlaceholder());
	}
	/**
	@override
	*/
	_appendEager() {
		var _this$_mapPosToBlock;
		const details = new ChangeDetails();
		let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
		if (startBlockIndex == null) return details;
		if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
		for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
			const d = this._blocks[bi]._appendEager();
			if (!d.inserted) break;
			details.aggregate(d);
		}
		return details;
	}
	/**
	@override
	*/
	_appendCharRaw(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		const blockIter = this._mapPosToBlock(this.value.length);
		const details = new ChangeDetails();
		if (!blockIter) return details;
		for (let bi = blockIter.index;; ++bi) {
			var _flags$_beforeTailSta, _flags$_beforeTailSta2;
			const block = this._blocks[bi];
			if (!block) break;
			const blockDetails = block._appendChar(ch, Object.assign({}, flags, { _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : (_flags$_beforeTailSta2 = _flags$_beforeTailSta._blocks) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2[bi] }));
			const skip = blockDetails.skip;
			details.aggregate(blockDetails);
			if (skip || blockDetails.rawInserted) break;
		}
		return details;
	}
	/**
	@override
	*/
	extractTail() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		const chunkTail = new ChunksTailDetails();
		if (fromPos === toPos) return chunkTail;
		this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos) => {
			const blockChunk = b.extractTail(bFromPos, bToPos);
			blockChunk.stop = this._findStopBefore(bi);
			blockChunk.from = this._blockStartPos(bi);
			if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
			chunkTail.extend(blockChunk);
		});
		return chunkTail;
	}
	/**
	@override
	*/
	extractInput() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		let flags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		if (fromPos === toPos) return "";
		let input = "";
		this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos) => {
			input += b.extractInput(fromPos, toPos, flags);
		});
		return input;
	}
	_findStopBefore(blockIndex) {
		let stopBefore;
		for (let si = 0; si < this._stops.length; ++si) {
			const stop = this._stops[si];
			if (stop <= blockIndex) stopBefore = stop;
			else break;
		}
		return stopBefore;
	}
	/** Appends placeholder depending on laziness */
	_appendPlaceholder(toBlockIndex) {
		const details = new ChangeDetails();
		if (this.lazy && toBlockIndex == null) return details;
		const startBlockIter = this._mapPosToBlock(this.value.length);
		if (!startBlockIter) return details;
		const startBlockIndex = startBlockIter.index;
		const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
		this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b) => {
			if (!b.lazy || toBlockIndex != null) {
				const args = b._blocks != null ? [b._blocks.length] : [];
				const bDetails = b._appendPlaceholder(...args);
				this._value += bDetails.inserted;
				details.aggregate(bDetails);
			}
		});
		return details;
	}
	/** Finds block in pos */
	_mapPosToBlock(pos) {
		let accVal = "";
		for (let bi = 0; bi < this._blocks.length; ++bi) {
			const block = this._blocks[bi];
			const blockStartPos = accVal.length;
			accVal += block.value;
			if (pos <= accVal.length) return {
				index: bi,
				offset: pos - blockStartPos
			};
		}
	}
	/** */
	_blockStartPos(blockIndex) {
		return this._blocks.slice(0, blockIndex).reduce((pos, b) => pos += b.value.length, 0);
	}
	/** */
	_forEachBlocksInRange(fromPos) {
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		let fn = arguments.length > 2 ? arguments[2] : void 0;
		const fromBlockIter = this._mapPosToBlock(fromPos);
		if (fromBlockIter) {
			const toBlockIter = this._mapPosToBlock(toPos);
			const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
			const fromBlockStartPos = fromBlockIter.offset;
			const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
			fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
			if (toBlockIter && !isSameBlock) {
				for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
				fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
			}
		}
	}
	/**
	@override
	*/
	remove() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		const removeDetails = super.remove(fromPos, toPos);
		this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
			removeDetails.aggregate(b.remove(bFromPos, bToPos));
		});
		return removeDetails;
	}
	/**
	@override
	*/
	nearestInputPos(cursorPos) {
		let direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
		if (!this._blocks.length) return 0;
		const cursor = new PatternCursor(this, cursorPos);
		if (direction === DIRECTION.NONE) {
			if (cursor.pushRightBeforeInput()) return cursor.pos;
			cursor.popState();
			if (cursor.pushLeftBeforeInput()) return cursor.pos;
			return this.value.length;
		}
		if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
			if (direction === DIRECTION.LEFT) {
				cursor.pushRightBeforeFilled();
				if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
				cursor.popState();
			}
			cursor.pushLeftBeforeInput();
			cursor.pushLeftBeforeRequired();
			cursor.pushLeftBeforeFilled();
			if (direction === DIRECTION.LEFT) {
				cursor.pushRightBeforeInput();
				cursor.pushRightBeforeRequired();
				if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
				cursor.popState();
				if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
				cursor.popState();
			}
			if (cursor.ok) return cursor.pos;
			if (direction === DIRECTION.FORCE_LEFT) return 0;
			cursor.popState();
			if (cursor.ok) return cursor.pos;
			cursor.popState();
			if (cursor.ok) return cursor.pos;
			return 0;
		}
		if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
			cursor.pushRightBeforeInput();
			cursor.pushRightBeforeRequired();
			if (cursor.pushRightBeforeFilled()) return cursor.pos;
			if (direction === DIRECTION.FORCE_RIGHT) return this.value.length;
			cursor.popState();
			if (cursor.ok) return cursor.pos;
			cursor.popState();
			if (cursor.ok) return cursor.pos;
			return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
		}
		return cursorPos;
	}
	/**
	@override
	*/
	totalInputPositions() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		let total = 0;
		this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
			total += b.totalInputPositions(bFromPos, bToPos);
		});
		return total;
	}
	/** Get block by name */
	maskedBlock(name) {
		return this.maskedBlocks(name)[0];
	}
	/** Get all blocks by name */
	maskedBlocks(name) {
		const indices = this._maskedBlocks[name];
		if (!indices) return [];
		return indices.map((gi) => this._blocks[gi]);
	}
};
MaskedPattern.DEFAULTS = {
	lazy: true,
	placeholderChar: "_"
};
MaskedPattern.STOP_CHAR = "`";
MaskedPattern.ESCAPE_CHAR = "\\";
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;
//#endregion
//#region ../../node_modules/imask/esm/masked/range.js
/** Pattern which accepts ranges */
var MaskedRange = class extends MaskedPattern {
	/**
	Optionally sets max length of pattern.
	Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
	*/
	/** Min bound */
	/** Max bound */
	/** */
	get _matchFrom() {
		return this.maxLength - String(this.from).length;
	}
	/**
	@override
	*/
	_update(opts) {
		opts = Object.assign({
			to: this.to || 0,
			from: this.from || 0,
			maxLength: this.maxLength || 0
		}, opts);
		let maxLength = String(opts.to).length;
		if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
		opts.maxLength = maxLength;
		const fromStr = String(opts.from).padStart(maxLength, "0");
		const toStr = String(opts.to).padStart(maxLength, "0");
		let sameCharsCount = 0;
		while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
		opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(maxLength - sameCharsCount);
		super._update(opts);
	}
	/**
	@override
	*/
	get isComplete() {
		return super.isComplete && Boolean(this.value);
	}
	boundaries(str) {
		let minstr = "";
		let maxstr = "";
		const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
		if (num) {
			minstr = "0".repeat(placeholder.length) + num;
			maxstr = "9".repeat(placeholder.length) + num;
		}
		minstr = minstr.padEnd(this.maxLength, "0");
		maxstr = maxstr.padEnd(this.maxLength, "9");
		return [minstr, maxstr];
	}
	/**
	@override
	*/
	doPrepare(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let details;
		[ch, details] = normalizePrepare(super.doPrepare(ch.replace(/\D/g, ""), flags));
		if (!this.autofix || !ch) return ch;
		const fromStr = String(this.from).padStart(this.maxLength, "0");
		const toStr = String(this.to).padStart(this.maxLength, "0");
		let nextVal = this.value + ch;
		if (nextVal.length > this.maxLength) return "";
		const [minstr, maxstr] = this.boundaries(nextVal);
		if (Number(maxstr) < this.from) return fromStr[nextVal.length - 1];
		if (Number(minstr) > this.to) {
			if (this.autofix === "pad" && nextVal.length < this.maxLength) return ["", details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))];
			return toStr[nextVal.length - 1];
		}
		return ch;
	}
	/**
	@override
	*/
	doValidate() {
		const str = this.value;
		if (str.search(/[^0]/) === -1 && str.length <= this._matchFrom) return true;
		const [minstr, maxstr] = this.boundaries(str);
		return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(...arguments);
	}
};
IMask.MaskedRange = MaskedRange;
//#endregion
//#region ../../node_modules/imask/esm/masked/date.js
/** Date mask */
var MaskedDate = class MaskedDate extends MaskedPattern {
	/** Pattern mask for date according to {@link MaskedDate#format} */
	/** Start date */
	/** End date */
	/** */
	/**
	@param {Object} opts
	*/
	constructor(opts) {
		super(Object.assign({}, MaskedDate.DEFAULTS, opts));
	}
	/**
	@override
	*/
	_update(opts) {
		if (opts.mask === Date) delete opts.mask;
		if (opts.pattern) opts.mask = opts.pattern;
		const blocks = opts.blocks;
		opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
		if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
		if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();
		if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
			opts.blocks.m.from = opts.min.getMonth() + 1;
			opts.blocks.m.to = opts.max.getMonth() + 1;
			if (opts.blocks.m.from === opts.blocks.m.to) {
				opts.blocks.d.from = opts.min.getDate();
				opts.blocks.d.to = opts.max.getDate();
			}
		}
		Object.assign(opts.blocks, this.blocks, blocks);
		Object.keys(opts.blocks).forEach((bk) => {
			const b = opts.blocks[bk];
			if (!("autofix" in b) && "autofix" in opts) b.autofix = opts.autofix;
		});
		super._update(opts);
	}
	/**
	@override
	*/
	doValidate() {
		const date = this.date;
		return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
	}
	/** Checks if date is exists */
	isDateExist(str) {
		return this.format(this.parse(str, this), this).indexOf(str) >= 0;
	}
	/** Parsed Date */
	get date() {
		return this.typedValue;
	}
	set date(date) {
		this.typedValue = date;
	}
	/**
	@override
	*/
	get typedValue() {
		return this.isComplete ? super.typedValue : null;
	}
	set typedValue(value) {
		super.typedValue = value;
	}
	/**
	@override
	*/
	maskEquals(mask) {
		return mask === Date || super.maskEquals(mask);
	}
};
MaskedDate.DEFAULTS = {
	pattern: "d{.}`m{.}`Y",
	format: (date) => {
		if (!date) return "";
		return [
			String(date.getDate()).padStart(2, "0"),
			String(date.getMonth() + 1).padStart(2, "0"),
			date.getFullYear()
		].join(".");
	},
	parse: (str) => {
		const [day, month, year] = str.split(".");
		return new Date(year, month - 1, day);
	}
};
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
	d: {
		mask: MaskedRange,
		from: 1,
		to: 31,
		maxLength: 2
	},
	m: {
		mask: MaskedRange,
		from: 1,
		to: 12,
		maxLength: 2
	},
	Y: {
		mask: MaskedRange,
		from: 1900,
		to: 9999
	}
});
IMask.MaskedDate = MaskedDate;
//#endregion
//#region ../../node_modules/imask/esm/controls/mask-element.js
/**
Generic element API to use with mask
@interface
*/
var MaskElement = class {
	/** */
	/** */
	/** */
	/** Safely returns selection start */
	get selectionStart() {
		let start;
		try {
			start = this._unsafeSelectionStart;
		} catch (e) {}
		return start != null ? start : this.value.length;
	}
	/** Safely returns selection end */
	get selectionEnd() {
		let end;
		try {
			end = this._unsafeSelectionEnd;
		} catch (e) {}
		return end != null ? end : this.value.length;
	}
	/** Safely sets element selection */
	select(start, end) {
		if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
		try {
			this._unsafeSelect(start, end);
		} catch (e) {}
	}
	/** Should be overriden in subclasses */
	_unsafeSelect(start, end) {}
	/** Should be overriden in subclasses */
	get isActive() {
		return false;
	}
	/** Should be overriden in subclasses */
	bindEvents(handlers) {}
	/** Should be overriden in subclasses */
	unbindEvents() {}
};
IMask.MaskElement = MaskElement;
//#endregion
//#region ../../node_modules/imask/esm/controls/html-mask-element.js
/** Bridge between HTMLElement and {@link Masked} */
var HTMLMaskElement = class HTMLMaskElement extends MaskElement {
	/** Mapping between HTMLElement events and mask internal events */
	/** HTMLElement to use mask on */
	/**
	@param {HTMLInputElement|HTMLTextAreaElement} input
	*/
	constructor(input) {
		super();
		this.input = input;
		this._handlers = {};
	}
	/** */
	get rootElement() {
		var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
		return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
	}
	/**
	Is element in focus
	@readonly
	*/
	get isActive() {
		return this.input === this.rootElement.activeElement;
	}
	/**
	Returns HTMLElement selection start
	@override
	*/
	get _unsafeSelectionStart() {
		return this.input.selectionStart;
	}
	/**
	Returns HTMLElement selection end
	@override
	*/
	get _unsafeSelectionEnd() {
		return this.input.selectionEnd;
	}
	/**
	Sets HTMLElement selection
	@override
	*/
	_unsafeSelect(start, end) {
		this.input.setSelectionRange(start, end);
	}
	/**
	HTMLElement value
	@override
	*/
	get value() {
		return this.input.value;
	}
	set value(value) {
		this.input.value = value;
	}
	/**
	Binds HTMLElement events to mask internal events
	@override
	*/
	bindEvents(handlers) {
		Object.keys(handlers).forEach((event) => this._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]));
	}
	/**
	Unbinds HTMLElement events to mask internal events
	@override
	*/
	unbindEvents() {
		Object.keys(this._handlers).forEach((event) => this._toggleEventHandler(event));
	}
	/** */
	_toggleEventHandler(event, handler) {
		if (this._handlers[event]) {
			this.input.removeEventListener(event, this._handlers[event]);
			delete this._handlers[event];
		}
		if (handler) {
			this.input.addEventListener(event, handler);
			this._handlers[event] = handler;
		}
	}
};
HTMLMaskElement.EVENTS_MAP = {
	selectionChange: "keydown",
	input: "input",
	drop: "drop",
	click: "click",
	focus: "focus",
	commit: "blur"
};
IMask.HTMLMaskElement = HTMLMaskElement;
//#endregion
//#region ../../node_modules/imask/esm/controls/html-contenteditable-mask-element.js
var HTMLContenteditableMaskElement = class extends HTMLMaskElement {
	/**
	Returns HTMLElement selection start
	@override
	*/
	get _unsafeSelectionStart() {
		const root = this.rootElement;
		const selection = root.getSelection && root.getSelection();
		const anchorOffset = selection && selection.anchorOffset;
		const focusOffset = selection && selection.focusOffset;
		if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
		return focusOffset;
	}
	/**
	Returns HTMLElement selection end
	@override
	*/
	get _unsafeSelectionEnd() {
		const root = this.rootElement;
		const selection = root.getSelection && root.getSelection();
		const anchorOffset = selection && selection.anchorOffset;
		const focusOffset = selection && selection.focusOffset;
		if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
		return focusOffset;
	}
	/**
	Sets HTMLElement selection
	@override
	*/
	_unsafeSelect(start, end) {
		if (!this.rootElement.createRange) return;
		const range = this.rootElement.createRange();
		range.setStart(this.input.firstChild || this.input, start);
		range.setEnd(this.input.lastChild || this.input, end);
		const root = this.rootElement;
		const selection = root.getSelection && root.getSelection();
		if (selection) {
			selection.removeAllRanges();
			selection.addRange(range);
		}
	}
	/**
	HTMLElement value
	@override
	*/
	get value() {
		return this.input.textContent;
	}
	set value(value) {
		this.input.textContent = value;
	}
};
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
//#endregion
//#region ../../node_modules/imask/esm/controls/input.js
var _excluded$7 = ["mask"];
/** Listens to element events and controls changes between element and {@link Masked} */
var InputMask$1 = class {
	/**
	View element
	@readonly
	*/
	/**
	Internal {@link Masked} model
	@readonly
	*/
	/**
	@param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
	@param {Object} opts
	*/
	constructor(el, opts) {
		this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
		this.masked = createMask(opts);
		this._listeners = {};
		this._value = "";
		this._unmaskedValue = "";
		this._saveSelection = this._saveSelection.bind(this);
		this._onInput = this._onInput.bind(this);
		this._onChange = this._onChange.bind(this);
		this._onDrop = this._onDrop.bind(this);
		this._onFocus = this._onFocus.bind(this);
		this._onClick = this._onClick.bind(this);
		this.alignCursor = this.alignCursor.bind(this);
		this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
		this._bindEvents();
		this.updateValue();
		this._onChange();
	}
	/** Read or update mask */
	get mask() {
		return this.masked.mask;
	}
	maskEquals(mask) {
		var _this$masked;
		return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
	}
	set mask(mask) {
		if (this.maskEquals(mask)) return;
		if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
			this.masked.updateOptions({ mask });
			return;
		}
		const masked = createMask({ mask });
		masked.unmaskedValue = this.masked.unmaskedValue;
		this.masked = masked;
	}
	/** Raw value */
	get value() {
		return this._value;
	}
	set value(str) {
		if (this.value === str) return;
		this.masked.value = str;
		this.updateControl();
		this.alignCursor();
	}
	/** Unmasked value */
	get unmaskedValue() {
		return this._unmaskedValue;
	}
	set unmaskedValue(str) {
		if (this.unmaskedValue === str) return;
		this.masked.unmaskedValue = str;
		this.updateControl();
		this.alignCursor();
	}
	/** Typed unmasked value */
	get typedValue() {
		return this.masked.typedValue;
	}
	set typedValue(val) {
		if (this.masked.typedValueEquals(val)) return;
		this.masked.typedValue = val;
		this.updateControl();
		this.alignCursor();
	}
	/** Display value */
	get displayValue() {
		return this.masked.displayValue;
	}
	/**
	Starts listening to element events
	@protected
	*/
	_bindEvents() {
		this.el.bindEvents({
			selectionChange: this._saveSelection,
			input: this._onInput,
			drop: this._onDrop,
			click: this._onClick,
			focus: this._onFocus,
			commit: this._onChange
		});
	}
	/**
	Stops listening to element events
	@protected
	*/
	_unbindEvents() {
		if (this.el) this.el.unbindEvents();
	}
	/**
	Fires custom event
	@protected
	*/
	_fireEvent(ev) {
		for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
		const listeners = this._listeners[ev];
		if (!listeners) return;
		listeners.forEach((l) => l(...args));
	}
	/**
	Current selection start
	@readonly
	*/
	get selectionStart() {
		return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
	}
	/** Current cursor position */
	get cursorPos() {
		return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
	}
	set cursorPos(pos) {
		if (!this.el || !this.el.isActive) return;
		this.el.select(pos, pos);
		this._saveSelection();
	}
	/**
	Stores current selection
	@protected
	*/
	_saveSelection() {
		if (this.displayValue !== this.el.value) console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.");
		this._selection = {
			start: this.selectionStart,
			end: this.cursorPos
		};
	}
	/** Syncronizes model value from view */
	updateValue() {
		this.masked.value = this.el.value;
		this._value = this.masked.value;
	}
	/** Syncronizes view from model value, fires change events */
	updateControl() {
		const newUnmaskedValue = this.masked.unmaskedValue;
		const newValue = this.masked.value;
		const newDisplayValue = this.displayValue;
		const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
		this._unmaskedValue = newUnmaskedValue;
		this._value = newValue;
		if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
		if (isChanged) this._fireChangeEvents();
	}
	/** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */
	updateOptions(opts) {
		const { mask } = opts, restOpts = _objectWithoutPropertiesLoose$4(opts, _excluded$7);
		const updateMask = !this.maskEquals(mask);
		const updateOpts = !objectIncludes(this.masked, restOpts);
		if (updateMask) this.mask = mask;
		if (updateOpts) this.masked.updateOptions(restOpts);
		if (updateMask || updateOpts) this.updateControl();
	}
	/** Updates cursor */
	updateCursor(cursorPos) {
		if (cursorPos == null) return;
		this.cursorPos = cursorPos;
		this._delayUpdateCursor(cursorPos);
	}
	/**
	Delays cursor update to support mobile browsers
	@private
	*/
	_delayUpdateCursor(cursorPos) {
		this._abortUpdateCursor();
		this._changingCursorPos = cursorPos;
		this._cursorChanging = setTimeout(() => {
			if (!this.el) return;
			this.cursorPos = this._changingCursorPos;
			this._abortUpdateCursor();
		}, 10);
	}
	/**
	Fires custom events
	@protected
	*/
	_fireChangeEvents() {
		this._fireEvent("accept", this._inputEvent);
		if (this.masked.isComplete) this._fireEvent("complete", this._inputEvent);
	}
	/**
	Aborts delayed cursor update
	@private
	*/
	_abortUpdateCursor() {
		if (this._cursorChanging) {
			clearTimeout(this._cursorChanging);
			delete this._cursorChanging;
		}
	}
	/** Aligns cursor to nearest available position */
	alignCursor() {
		this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
	}
	/** Aligns cursor only if selection is empty */
	alignCursorFriendly() {
		if (this.selectionStart !== this.cursorPos) return;
		this.alignCursor();
	}
	/** Adds listener on custom event */
	on(ev, handler) {
		if (!this._listeners[ev]) this._listeners[ev] = [];
		this._listeners[ev].push(handler);
		return this;
	}
	/** Removes custom event listener */
	off(ev, handler) {
		if (!this._listeners[ev]) return this;
		if (!handler) {
			delete this._listeners[ev];
			return this;
		}
		const hIndex = this._listeners[ev].indexOf(handler);
		if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
		return this;
	}
	/** Handles view input event */
	_onInput(e) {
		this._inputEvent = e;
		this._abortUpdateCursor();
		if (!this._selection) return this.updateValue();
		const details = new ActionDetails(this.el.value, this.cursorPos, this.displayValue, this._selection);
		const oldRawValue = this.masked.rawInputValue;
		const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
			input: true,
			raw: true
		}).offset;
		const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
		let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
		if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
		this.updateControl();
		this.updateCursor(cursorPos);
		delete this._inputEvent;
	}
	/** Handles view change event and commits model value */
	_onChange() {
		if (this.displayValue !== this.el.value) this.updateValue();
		this.masked.doCommit();
		this.updateControl();
		this._saveSelection();
	}
	/** Handles view drop event, prevents by default */
	_onDrop(ev) {
		ev.preventDefault();
		ev.stopPropagation();
	}
	/** Restore last selection on focus */
	_onFocus(ev) {
		this.alignCursorFriendly();
	}
	/** Restore last selection on focus */
	_onClick(ev) {
		this.alignCursorFriendly();
	}
	/** Unbind view events and removes element reference */
	destroy() {
		this._unbindEvents();
		this._listeners.length = 0;
		delete this.el;
	}
};
IMask.InputMask = InputMask$1;
//#endregion
//#region ../../node_modules/imask/esm/masked/enum.js
/** Pattern which validates enum values */
var MaskedEnum = class extends MaskedPattern {
	/**
	@override
	@param {Object} opts
	*/
	_update(opts) {
		if (opts.enum) opts.mask = "*".repeat(opts.enum[0].length);
		super._update(opts);
	}
	/**
	@override
	*/
	doValidate() {
		return this.enum.some((e) => e.indexOf(this.unmaskedValue) >= 0) && super.doValidate(...arguments);
	}
};
IMask.MaskedEnum = MaskedEnum;
//#endregion
//#region ../../node_modules/imask/esm/masked/number.js
/**
Number mask
@param {Object} opts
@param {string} opts.radix - Single char
@param {string} opts.thousandsSeparator - Single char
@param {Array<string>} opts.mapToRadix - Array of single chars
@param {number} opts.min
@param {number} opts.max
@param {number} opts.scale - Digits after point
@param {boolean} opts.signed - Allow negative
@param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
@param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
*/
var MaskedNumber = class MaskedNumber extends Masked {
	/** Single char */
	/** Single char */
	/** Array of single chars */
	/** */
	/** */
	/** Digits after point */
	/** */
	/** Flag to remove leading and trailing zeros in the end of editing */
	/** Flag to pad trailing zeros after point in the end of editing */
	constructor(opts) {
		super(Object.assign({}, MaskedNumber.DEFAULTS, opts));
	}
	/**
	@override
	*/
	_update(opts) {
		super._update(opts);
		this._updateRegExps();
	}
	/** */
	_updateRegExps() {
		let start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
		let mid = "\\d*";
		let end = (this.scale ? "(".concat(escapeRegExp(this.radix), "\\d{0,").concat(this.scale, "})?") : "") + "$";
		this._numberRegExp = new RegExp(start + mid + end);
		this._mapToRadixRegExp = new RegExp("[".concat(this.mapToRadix.map(escapeRegExp).join(""), "]"), "g");
		this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), "g");
	}
	/** */
	_removeThousandsSeparators(value) {
		return value.replace(this._thousandsSeparatorRegExp, "");
	}
	/** */
	_insertThousandsSeparators(value) {
		const parts = value.split(this.radix);
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
		return parts.join(this.radix);
	}
	/**
	@override
	*/
	doPrepare(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		ch = this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch);
		const [prepCh, details] = normalizePrepare(super.doPrepare(ch, flags));
		if (ch && !prepCh) details.skip = true;
		return [prepCh, details];
	}
	/** */
	_separatorsCount(to) {
		let extendOnSeparators = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
		let count = 0;
		for (let pos = 0; pos < to; ++pos) if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
			++count;
			if (extendOnSeparators) to += this.thousandsSeparator.length;
		}
		return count;
	}
	/** */
	_separatorsCountFromSlice() {
		let slice = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._value;
		return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
	}
	/**
	@override
	*/
	extractInput() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		let flags = arguments.length > 2 ? arguments[2] : void 0;
		[fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
		return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
	}
	/**
	@override
	*/
	_appendCharRaw(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		if (!this.thousandsSeparator) return super._appendCharRaw(ch, flags);
		const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
		const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
		this._value = this._removeThousandsSeparators(this.value);
		const appendDetails = super._appendCharRaw(ch, flags);
		this._value = this._insertThousandsSeparators(this._value);
		const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
		const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
		appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
		appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
		return appendDetails;
	}
	/** */
	_findSeparatorAround(pos) {
		if (this.thousandsSeparator) {
			const searchFrom = pos - this.thousandsSeparator.length + 1;
			const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
			if (separatorPos <= pos) return separatorPos;
		}
		return -1;
	}
	_adjustRangeWithSeparators(from, to) {
		const separatorAroundFromPos = this._findSeparatorAround(from);
		if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
		const separatorAroundToPos = this._findSeparatorAround(to);
		if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
		return [from, to];
	}
	/**
	@override
	*/
	remove() {
		let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
		let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
		[fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
		const valueBeforePos = this.value.slice(0, fromPos);
		const valueAfterPos = this.value.slice(toPos);
		const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
		this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
		return new ChangeDetails({ tailShift: (this._separatorsCountFromSlice(valueBeforePos) - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length });
	}
	/**
	@override
	*/
	nearestInputPos(cursorPos, direction) {
		if (!this.thousandsSeparator) return cursorPos;
		switch (direction) {
			case DIRECTION.NONE:
			case DIRECTION.LEFT:
			case DIRECTION.FORCE_LEFT: {
				const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
				if (separatorAtLeftPos >= 0) {
					const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
					if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) return separatorAtLeftPos;
				}
				break;
			}
			case DIRECTION.RIGHT:
			case DIRECTION.FORCE_RIGHT: {
				const separatorAtRightPos = this._findSeparatorAround(cursorPos);
				if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
			}
		}
		return cursorPos;
	}
	/**
	@override
	*/
	doValidate(flags) {
		let valid = Boolean(this._removeThousandsSeparators(this.value).match(this._numberRegExp));
		if (valid) {
			const number = this.number;
			valid = valid && !isNaN(number) && (this.min == null || this.min >= 0 || this.min <= this.number) && (this.max == null || this.max <= 0 || this.number <= this.max);
		}
		return valid && super.doValidate(flags);
	}
	/**
	@override
	*/
	doCommit() {
		if (this.value) {
			const number = this.number;
			let validnum = number;
			if (this.min != null) validnum = Math.max(validnum, this.min);
			if (this.max != null) validnum = Math.min(validnum, this.max);
			if (validnum !== number) this.unmaskedValue = this.doFormat(validnum);
			let formatted = this.value;
			if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
			if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
			this._value = formatted;
		}
		super.doCommit();
	}
	/** */
	_normalizeZeros(value) {
		const parts = this._removeThousandsSeparators(value).split(this.radix);
		parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num) => sign + num);
		if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + "0";
		if (parts.length > 1) {
			parts[1] = parts[1].replace(/0*$/, "");
			if (!parts[1].length) parts.length = 1;
		}
		return this._insertThousandsSeparators(parts.join(this.radix));
	}
	/** */
	_padFractionalZeros(value) {
		if (!value) return value;
		const parts = value.split(this.radix);
		if (parts.length < 2) parts.push("");
		parts[1] = parts[1].padEnd(this.scale, "0");
		return parts.join(this.radix);
	}
	/** */
	doSkipInvalid(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let checkTail = arguments.length > 2 ? arguments[2] : void 0;
		const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
		return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
	}
	/**
	@override
	*/
	get unmaskedValue() {
		return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
	}
	set unmaskedValue(unmaskedValue) {
		super.unmaskedValue = unmaskedValue;
	}
	/**
	@override
	*/
	get typedValue() {
		return this.doParse(this.unmaskedValue);
	}
	set typedValue(n) {
		this.rawInputValue = this.doFormat(n).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
	}
	/** Parsed Number */
	get number() {
		return this.typedValue;
	}
	set number(number) {
		this.typedValue = number;
	}
	/**
	Is negative allowed
	@readonly
	*/
	get allowNegative() {
		return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
	}
	/**
	@override
	*/
	typedValueEquals(value) {
		return (super.typedValueEquals(value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
	}
};
MaskedNumber.UNMASKED_RADIX = ".";
MaskedNumber.DEFAULTS = {
	radix: ",",
	thousandsSeparator: "",
	mapToRadix: [MaskedNumber.UNMASKED_RADIX],
	scale: 2,
	signed: false,
	normalizeZeros: true,
	padFractionalZeros: false,
	parse: Number,
	format: (n) => n.toLocaleString("en-US", {
		useGrouping: false,
		maximumFractionDigits: 20
	})
};
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
IMask.MaskedNumber = MaskedNumber;
//#endregion
//#region ../../node_modules/imask/esm/masked/function.js
/** Masking by custom Function */
var MaskedFunction = class extends Masked {
	/**
	@override
	@param {Object} opts
	*/
	_update(opts) {
		if (opts.mask) opts.validate = opts.mask;
		super._update(opts);
	}
};
IMask.MaskedFunction = MaskedFunction;
//#endregion
//#region ../../node_modules/imask/esm/masked/dynamic.js
var _excluded$6 = [
	"compiledMasks",
	"currentMaskRef",
	"currentMask"
];
var _excluded2$1 = ["mask"];
/** Dynamic mask for choosing apropriate mask in run-time */
var MaskedDynamic = class MaskedDynamic extends Masked {
	/** Currently chosen mask */
	/** Compliled {@link Masked} options */
	/** Chooses {@link Masked} depending on input value */
	/**
	@param {Object} opts
	*/
	constructor(opts) {
		super(Object.assign({}, MaskedDynamic.DEFAULTS, opts));
		this.currentMask = null;
	}
	/**
	@override
	*/
	_update(opts) {
		super._update(opts);
		if ("mask" in opts) this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m) => createMask(m)) : [];
	}
	/**
	@override
	*/
	_appendCharRaw(ch) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		const details = this._applyDispatch(ch, flags);
		if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
		return details;
	}
	_applyDispatch() {
		let appended = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let tail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
		const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
		const inputValue = this.rawInputValue;
		const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
		const tailValue = inputValue.slice(insertValue.length);
		const prevMask = this.currentMask;
		const details = new ChangeDetails();
		const prevMaskState = prevMask === null || prevMask === void 0 ? void 0 : prevMask.state;
		this.currentMask = this.doDispatch(appended, Object.assign({}, flags), tail);
		if (this.currentMask) {
			if (this.currentMask !== prevMask) {
				this.currentMask.reset();
				if (insertValue) details.tailShift = this.currentMask.append(insertValue, { raw: true }).inserted.length - prevValueBeforeTail.length;
				if (tailValue) details.tailShift += this.currentMask.append(tailValue, {
					raw: true,
					tail: true
				}).tailShift;
			} else this.currentMask.state = prevMaskState;
		}
		return details;
	}
	_appendPlaceholder() {
		const details = this._applyDispatch(...arguments);
		if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
		return details;
	}
	/**
	@override
	*/
	_appendEager() {
		const details = this._applyDispatch(...arguments);
		if (this.currentMask) details.aggregate(this.currentMask._appendEager());
		return details;
	}
	appendTail(tail) {
		const details = new ChangeDetails();
		if (tail) details.aggregate(this._applyDispatch("", {}, tail));
		return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
	}
	currentMaskFlags(flags) {
		var _flags$_beforeTailSta, _flags$_beforeTailSta2;
		return Object.assign({}, flags, { _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState });
	}
	/**
	@override
	*/
	doDispatch(appended) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let tail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
		return this.dispatch(appended, this, flags, tail);
	}
	/**
	@override
	*/
	doValidate(flags) {
		return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
	}
	/**
	@override
	*/
	doPrepare(str) {
		let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let [s, details] = normalizePrepare(super.doPrepare(str, flags));
		if (this.currentMask) {
			let currentDetails;
			[s, currentDetails] = normalizePrepare(super.doPrepare(s, this.currentMaskFlags(flags)));
			details = details.aggregate(currentDetails);
		}
		return [s, details];
	}
	/**
	@override
	*/
	reset() {
		var _this$currentMask;
		(_this$currentMask = this.currentMask) === null || _this$currentMask === void 0 || _this$currentMask.reset();
		this.compiledMasks.forEach((m) => m.reset());
	}
	/**
	@override
	*/
	get value() {
		return this.currentMask ? this.currentMask.value : "";
	}
	set value(value) {
		super.value = value;
	}
	/**
	@override
	*/
	get unmaskedValue() {
		return this.currentMask ? this.currentMask.unmaskedValue : "";
	}
	set unmaskedValue(unmaskedValue) {
		super.unmaskedValue = unmaskedValue;
	}
	/**
	@override
	*/
	get typedValue() {
		return this.currentMask ? this.currentMask.typedValue : "";
	}
	set typedValue(value) {
		let unmaskedValue = String(value);
		if (this.currentMask) {
			this.currentMask.typedValue = value;
			unmaskedValue = this.currentMask.unmaskedValue;
		}
		this.unmaskedValue = unmaskedValue;
	}
	get displayValue() {
		return this.currentMask ? this.currentMask.displayValue : "";
	}
	/**
	@override
	*/
	get isComplete() {
		var _this$currentMask2;
		return Boolean((_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.isComplete);
	}
	/**
	@override
	*/
	get isFilled() {
		var _this$currentMask3;
		return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isFilled);
	}
	/**
	@override
	*/
	remove() {
		const details = new ChangeDetails();
		if (this.currentMask) details.aggregate(this.currentMask.remove(...arguments)).aggregate(this._applyDispatch());
		return details;
	}
	/**
	@override
	*/
	get state() {
		var _this$currentMask4;
		return Object.assign({}, super.state, {
			_rawInputValue: this.rawInputValue,
			compiledMasks: this.compiledMasks.map((m) => m.state),
			currentMaskRef: this.currentMask,
			currentMask: (_this$currentMask4 = this.currentMask) === null || _this$currentMask4 === void 0 ? void 0 : _this$currentMask4.state
		});
	}
	set state(state) {
		const { compiledMasks, currentMaskRef, currentMask } = state, maskedState = _objectWithoutPropertiesLoose$4(state, _excluded$6);
		this.compiledMasks.forEach((m, mi) => m.state = compiledMasks[mi]);
		if (currentMaskRef != null) {
			this.currentMask = currentMaskRef;
			this.currentMask.state = currentMask;
		}
		super.state = maskedState;
	}
	/**
	@override
	*/
	extractInput() {
		return this.currentMask ? this.currentMask.extractInput(...arguments) : "";
	}
	/**
	@override
	*/
	extractTail() {
		return this.currentMask ? this.currentMask.extractTail(...arguments) : super.extractTail(...arguments);
	}
	/**
	@override
	*/
	doCommit() {
		if (this.currentMask) this.currentMask.doCommit();
		super.doCommit();
	}
	/**
	@override
	*/
	nearestInputPos() {
		return this.currentMask ? this.currentMask.nearestInputPos(...arguments) : super.nearestInputPos(...arguments);
	}
	get overwrite() {
		return this.currentMask ? this.currentMask.overwrite : super.overwrite;
	}
	set overwrite(overwrite) {
		console.warn("\"overwrite\" option is not available in dynamic mask, use this option in siblings");
	}
	get eager() {
		return this.currentMask ? this.currentMask.eager : super.eager;
	}
	set eager(eager) {
		console.warn("\"eager\" option is not available in dynamic mask, use this option in siblings");
	}
	get skipInvalid() {
		return this.currentMask ? this.currentMask.skipInvalid : super.skipInvalid;
	}
	set skipInvalid(skipInvalid) {
		if (this.isInitialized || skipInvalid !== Masked.DEFAULTS.skipInvalid) console.warn("\"skipInvalid\" option is not available in dynamic mask, use this option in siblings");
	}
	/**
	@override
	*/
	maskEquals(mask) {
		return Array.isArray(mask) && this.compiledMasks.every((m, mi) => {
			if (!mask[mi]) return;
			const _mask$mi = mask[mi], { mask: oldMask } = _mask$mi;
			return objectIncludes(m, _objectWithoutPropertiesLoose$4(_mask$mi, _excluded2$1)) && m.maskEquals(oldMask);
		});
	}
	/**
	@override
	*/
	typedValueEquals(value) {
		var _this$currentMask5;
		return Boolean((_this$currentMask5 = this.currentMask) === null || _this$currentMask5 === void 0 ? void 0 : _this$currentMask5.typedValueEquals(value));
	}
};
MaskedDynamic.DEFAULTS = { dispatch: (appended, masked, flags, tail) => {
	if (!masked.compiledMasks.length) return;
	const inputValue = masked.rawInputValue;
	const inputs = masked.compiledMasks.map((m, index) => {
		const isCurrent = masked.currentMask === m;
		const startInputPos = isCurrent ? m.value.length : m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT);
		if (m.rawInputValue !== inputValue) {
			m.reset();
			m.append(inputValue, { raw: true });
		} else if (!isCurrent) m.remove(startInputPos);
		m.append(appended, masked.currentMaskFlags(flags));
		m.appendTail(tail);
		return {
			index,
			weight: m.rawInputValue.length,
			totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT)))
		};
	});
	inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
	return masked.compiledMasks[inputs[0].index];
} };
IMask.MaskedDynamic = MaskedDynamic;
//#endregion
//#region ../../node_modules/imask/esm/masked/pipe.js
/** Mask pipe source and destination types */
var PIPE_TYPE = {
	MASKED: "value",
	UNMASKED: "unmaskedValue",
	TYPED: "typedValue"
};
/** Creates new pipe function depending on mask type, source and destination options */
function createPipe(mask) {
	let from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : PIPE_TYPE.MASKED;
	let to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : PIPE_TYPE.MASKED;
	const masked = createMask(mask);
	return (value) => masked.runIsolated((m) => {
		m[from] = value;
		return m[to];
	});
}
/** Pipes value through mask depending on mask type, source and destination options */
function pipe$2(value) {
	for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) pipeArgs[_key - 1] = arguments[_key];
	return createPipe(...pipeArgs)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe$2;
//#endregion
//#region ../../node_modules/imask/esm/index.js
try {
	globalThis.IMask = IMask;
} catch (e) {}
//#endregion
//#region ../../node_modules/react-imask/esm/_rollupPluginBabelHelpers-089ae9b3.js
function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}
function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	Object.defineProperty(Constructor, "prototype", { writable: false });
	return Constructor;
}
function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
	subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: {
		value: subClass,
		writable: true,
		configurable: true
	} });
	Object.defineProperty(subClass, "prototype", { writable: false });
	if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
	_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
		return o.__proto__ || Object.getPrototypeOf(o);
	};
	return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
	_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
		o.__proto__ = p;
		return o;
	};
	return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
	if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	if (Reflect.construct.sham) return false;
	if (typeof Proxy === "function") return true;
	try {
		Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
		return true;
	} catch (e) {
		return false;
	}
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source);
	var key, i = 0;
	for (; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) continue;
		target[key] = source[key];
	}
	return target;
}
function _objectWithoutProperties$1(source, excluded) {
	if (source == null) return {};
	var target = _objectWithoutPropertiesLoose$3(source, excluded);
	var key, i;
	if (Object.getOwnPropertySymbols) {
		var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
		for (i = 0; i < sourceSymbolKeys.length; i++) {
			key = sourceSymbolKeys[i];
			if (excluded.indexOf(key) >= 0) continue;
			if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
			target[key] = source[key];
		}
	}
	return target;
}
function _assertThisInitialized(self) {
	if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	return self;
}
function _possibleConstructorReturn(self, call) {
	if (call && (typeof call === "object" || typeof call === "function")) return call;
	else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
	return _assertThisInitialized(self);
}
function _createSuper(Derived) {
	var hasNativeReflectConstruct = _isNativeReflectConstruct();
	return function _createSuperInternal() {
		var Super = _getPrototypeOf(Derived), result;
		if (hasNativeReflectConstruct) {
			var NewTarget = _getPrototypeOf(this).constructor;
			result = Reflect.construct(Super, arguments, NewTarget);
		} else result = Super.apply(this, arguments);
		return _possibleConstructorReturn(this, result);
	};
}
//#endregion
//#region ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
/** @license React v16.13.1
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_is_production_min = /* @__PURE__ */ __commonJSMin(((exports) => {
	var b = "function" === typeof Symbol && Symbol.for;
	var c = b ? Symbol.for("react.element") : 60103;
	var d = b ? Symbol.for("react.portal") : 60106;
	var e = b ? Symbol.for("react.fragment") : 60107;
	var f = b ? Symbol.for("react.strict_mode") : 60108;
	var g = b ? Symbol.for("react.profiler") : 60114;
	var h = b ? Symbol.for("react.provider") : 60109;
	var k = b ? Symbol.for("react.context") : 60110;
	var l = b ? Symbol.for("react.async_mode") : 60111;
	var m = b ? Symbol.for("react.concurrent_mode") : 60111;
	var n = b ? Symbol.for("react.forward_ref") : 60112;
	var p = b ? Symbol.for("react.suspense") : 60113;
	var q = b ? Symbol.for("react.suspense_list") : 60120;
	var r = b ? Symbol.for("react.memo") : 60115;
	var t = b ? Symbol.for("react.lazy") : 60116;
	var v = b ? Symbol.for("react.block") : 60121;
	var w = b ? Symbol.for("react.fundamental") : 60117;
	var x = b ? Symbol.for("react.responder") : 60118;
	var y = b ? Symbol.for("react.scope") : 60119;
	function z(a) {
		if ("object" === typeof a && null !== a) {
			var u = a.$$typeof;
			switch (u) {
				case c: switch (a = a.type, a) {
					case l:
					case m:
					case e:
					case g:
					case f:
					case p: return a;
					default: switch (a = a && a.$$typeof, a) {
						case k:
						case n:
						case t:
						case r:
						case h: return a;
						default: return u;
					}
				}
				case d: return u;
			}
		}
	}
	function A(a) {
		return z(a) === m;
	}
	exports.AsyncMode = l;
	exports.ConcurrentMode = m;
	exports.ContextConsumer = k;
	exports.ContextProvider = h;
	exports.Element = c;
	exports.ForwardRef = n;
	exports.Fragment = e;
	exports.Lazy = t;
	exports.Memo = r;
	exports.Portal = d;
	exports.Profiler = g;
	exports.StrictMode = f;
	exports.Suspense = p;
	exports.isAsyncMode = function(a) {
		return A(a) || z(a) === l;
	};
	exports.isConcurrentMode = A;
	exports.isContextConsumer = function(a) {
		return z(a) === k;
	};
	exports.isContextProvider = function(a) {
		return z(a) === h;
	};
	exports.isElement = function(a) {
		return "object" === typeof a && null !== a && a.$$typeof === c;
	};
	exports.isForwardRef = function(a) {
		return z(a) === n;
	};
	exports.isFragment = function(a) {
		return z(a) === e;
	};
	exports.isLazy = function(a) {
		return z(a) === t;
	};
	exports.isMemo = function(a) {
		return z(a) === r;
	};
	exports.isPortal = function(a) {
		return z(a) === d;
	};
	exports.isProfiler = function(a) {
		return z(a) === g;
	};
	exports.isStrictMode = function(a) {
		return z(a) === f;
	};
	exports.isSuspense = function(a) {
		return z(a) === p;
	};
	exports.isValidElementType = function(a) {
		return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
	};
	exports.typeOf = z;
}));
//#endregion
//#region ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
/** @license React v16.13.1
* react-is.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_is_development = /* @__PURE__ */ __commonJSMin(((exports) => {
	if (process.env.NODE_ENV !== "production") (function() {
		"use strict";
		var hasSymbol = typeof Symbol === "function" && Symbol.for;
		var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
		var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
		var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
		var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
		var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
		var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
		var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
		var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
		var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
		var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
		var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
		var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
		var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
		var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
		var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
		var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
		var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
		var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
		function isValidElementType(type) {
			return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
		}
		function typeOf(object) {
			if (typeof object === "object" && object !== null) {
				var $$typeof = object.$$typeof;
				switch ($$typeof) {
					case REACT_ELEMENT_TYPE:
						var type = object.type;
						switch (type) {
							case REACT_ASYNC_MODE_TYPE:
							case REACT_CONCURRENT_MODE_TYPE:
							case REACT_FRAGMENT_TYPE:
							case REACT_PROFILER_TYPE:
							case REACT_STRICT_MODE_TYPE:
							case REACT_SUSPENSE_TYPE: return type;
							default:
								var $$typeofType = type && type.$$typeof;
								switch ($$typeofType) {
									case REACT_CONTEXT_TYPE:
									case REACT_FORWARD_REF_TYPE:
									case REACT_LAZY_TYPE:
									case REACT_MEMO_TYPE:
									case REACT_PROVIDER_TYPE: return $$typeofType;
									default: return $$typeof;
								}
						}
					case REACT_PORTAL_TYPE: return $$typeof;
				}
			}
		}
		var AsyncMode = REACT_ASYNC_MODE_TYPE;
		var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
		var ContextConsumer = REACT_CONTEXT_TYPE;
		var ContextProvider = REACT_PROVIDER_TYPE;
		var Element = REACT_ELEMENT_TYPE;
		var ForwardRef = REACT_FORWARD_REF_TYPE;
		var Fragment = REACT_FRAGMENT_TYPE;
		var Lazy = REACT_LAZY_TYPE;
		var Memo = REACT_MEMO_TYPE;
		var Portal = REACT_PORTAL_TYPE;
		var Profiler = REACT_PROFILER_TYPE;
		var StrictMode = REACT_STRICT_MODE_TYPE;
		var Suspense = REACT_SUSPENSE_TYPE;
		var hasWarnedAboutDeprecatedIsAsyncMode = false;
		function isAsyncMode(object) {
			if (!hasWarnedAboutDeprecatedIsAsyncMode) {
				hasWarnedAboutDeprecatedIsAsyncMode = true;
				console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
			}
			return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
		}
		function isConcurrentMode(object) {
			return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
		}
		function isContextConsumer(object) {
			return typeOf(object) === REACT_CONTEXT_TYPE;
		}
		function isContextProvider(object) {
			return typeOf(object) === REACT_PROVIDER_TYPE;
		}
		function isElement(object) {
			return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		}
		function isForwardRef(object) {
			return typeOf(object) === REACT_FORWARD_REF_TYPE;
		}
		function isFragment(object) {
			return typeOf(object) === REACT_FRAGMENT_TYPE;
		}
		function isLazy(object) {
			return typeOf(object) === REACT_LAZY_TYPE;
		}
		function isMemo(object) {
			return typeOf(object) === REACT_MEMO_TYPE;
		}
		function isPortal(object) {
			return typeOf(object) === REACT_PORTAL_TYPE;
		}
		function isProfiler(object) {
			return typeOf(object) === REACT_PROFILER_TYPE;
		}
		function isStrictMode(object) {
			return typeOf(object) === REACT_STRICT_MODE_TYPE;
		}
		function isSuspense(object) {
			return typeOf(object) === REACT_SUSPENSE_TYPE;
		}
		exports.AsyncMode = AsyncMode;
		exports.ConcurrentMode = ConcurrentMode;
		exports.ContextConsumer = ContextConsumer;
		exports.ContextProvider = ContextProvider;
		exports.Element = Element;
		exports.ForwardRef = ForwardRef;
		exports.Fragment = Fragment;
		exports.Lazy = Lazy;
		exports.Memo = Memo;
		exports.Portal = Portal;
		exports.Profiler = Profiler;
		exports.StrictMode = StrictMode;
		exports.Suspense = Suspense;
		exports.isAsyncMode = isAsyncMode;
		exports.isConcurrentMode = isConcurrentMode;
		exports.isContextConsumer = isContextConsumer;
		exports.isContextProvider = isContextProvider;
		exports.isElement = isElement;
		exports.isForwardRef = isForwardRef;
		exports.isFragment = isFragment;
		exports.isLazy = isLazy;
		exports.isMemo = isMemo;
		exports.isPortal = isPortal;
		exports.isProfiler = isProfiler;
		exports.isStrictMode = isStrictMode;
		exports.isSuspense = isSuspense;
		exports.isValidElementType = isValidElementType;
		exports.typeOf = typeOf;
	})();
}));
//#endregion
//#region ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_react_is_production_min();
	else module.exports = require_react_is_development();
}));
//#endregion
//#region ../../node_modules/object-assign/index.js
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var require_object_assign = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	function toObject(val) {
		if (val === null || val === void 0) throw new TypeError("Object.assign cannot be called with null or undefined");
		return Object(val);
	}
	function shouldUseNative() {
		try {
			if (!Object.assign) return false;
			var test1 = /* @__PURE__ */ new String("abc");
			test1[5] = "de";
			if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
			var test2 = {};
			for (var i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
			if (Object.getOwnPropertyNames(test2).map(function(n) {
				return test2[n];
			}).join("") !== "0123456789") return false;
			var test3 = {};
			"abcdefghijklmnopqrst".split("").forEach(function(letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
			return true;
		} catch (err) {
			return false;
		}
	}
	module.exports = shouldUseNative() ? Object.assign : function(target, source) {
		var from;
		var to = toObject(target);
		var symbols;
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
			for (var key in from) if (hasOwnProperty.call(from, key)) to[key] = from[key];
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
			}
		}
		return to;
	};
}));
//#endregion
//#region ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_ReactPropTypesSecret = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}));
//#endregion
//#region ../../node_modules/prop-types/lib/has.js
var require_has = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
}));
//#endregion
//#region ../../node_modules/prop-types/checkPropTypes.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_checkPropTypes = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var printWarning = function() {};
	if (process.env.NODE_ENV !== "production") {
		var ReactPropTypesSecret = require_ReactPropTypesSecret();
		var loggedTypeFailures = {};
		var has = require_has();
		printWarning = function(text) {
			var message = "Warning: " + text;
			if (typeof console !== "undefined") console.error(message);
			try {
				throw new Error(message);
			} catch (x) {}
		};
	}
	/**
	* Assert that the values match with the type specs.
	* Error messages are memorized and will only be shown once.
	*
	* @param {object} typeSpecs Map of name to a ReactPropType
	* @param {object} values Runtime values that need to be type-checked
	* @param {string} location e.g. "prop", "context", "child context"
	* @param {string} componentName Name of the component for error messages.
	* @param {?Function} getStack Returns the component stack.
	* @private
	*/
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		if (process.env.NODE_ENV !== "production") {
			for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
				var error;
				try {
					if (typeof typeSpecs[typeSpecName] !== "function") {
						var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						err.name = "Invariant Violation";
						throw err;
					}
					error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
				} catch (ex) {
					error = ex;
				}
				if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
				if (error instanceof Error && !(error.message in loggedTypeFailures)) {
					loggedTypeFailures[error.message] = true;
					var stack = getStack ? getStack() : "";
					printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
				}
			}
		}
	}
	/**
	* Resets warning cache when testing.
	*
	* @private
	*/
	checkPropTypes.resetWarningCache = function() {
		if (process.env.NODE_ENV !== "production") loggedTypeFailures = {};
	};
	module.exports = checkPropTypes;
}));
//#endregion
//#region ../../node_modules/prop-types/factoryWithTypeCheckers.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_factoryWithTypeCheckers = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ReactIs = require_react_is();
	var assign = require_object_assign();
	var ReactPropTypesSecret = require_ReactPropTypesSecret();
	var has = require_has();
	var checkPropTypes = require_checkPropTypes();
	var printWarning = function() {};
	if (process.env.NODE_ENV !== "production") printWarning = function(text) {
		var message = "Warning: " + text;
		if (typeof console !== "undefined") console.error(message);
		try {
			throw new Error(message);
		} catch (x) {}
	};
	function emptyFunctionThatReturnsNull() {
		return null;
	}
	module.exports = function(isValidElement, throwOnDirectAccess) {
		var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = "@@iterator";
		/**
		* Returns the iterator method function contained on the iterable object.
		*
		* Be sure to invoke the function with the iterable as context:
		*
		*     var iteratorFn = getIteratorFn(myIterable);
		*     if (iteratorFn) {
		*       var iterator = iteratorFn.call(myIterable);
		*       ...
		*     }
		*
		* @param {?object} maybeIterable
		* @return {?function}
		*/
		function getIteratorFn(maybeIterable) {
			var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			if (typeof iteratorFn === "function") return iteratorFn;
		}
		/**
		* Collection of methods that allow declaration and validation of props that are
		* supplied to React components. Example usage:
		*
		*   var Props = require('ReactPropTypes');
		*   var MyArticle = React.createClass({
		*     propTypes: {
		*       // An optional string prop named "description".
		*       description: Props.string,
		*
		*       // A required enum prop named "category".
		*       category: Props.oneOf(['News','Photos']).isRequired,
		*
		*       // A prop named "dialog" that requires an instance of Dialog.
		*       dialog: Props.instanceOf(Dialog).isRequired
		*     },
		*     render: function() { ... }
		*   });
		*
		* A more formal specification of how these methods are used:
		*
		*   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		*   decl := ReactPropTypes.{type}(.isRequired)?
		*
		* Each and every declaration produces a function with the same signature. This
		* allows the creation of custom validation functions. For example:
		*
		*  var MyLink = React.createClass({
		*    propTypes: {
		*      // An optional string or URI prop named "href".
		*      href: function(props, propName, componentName) {
		*        var propValue = props[propName];
		*        if (propValue != null && typeof propValue !== 'string' &&
		*            !(propValue instanceof URI)) {
		*          return new Error(
		*            'Expected a string or an URI for ' + propName + ' in ' +
		*            componentName
		*          );
		*        }
		*      }
		*    },
		*    render: function() {...}
		*  });
		*
		* @internal
		*/
		var ANONYMOUS = "<<anonymous>>";
		var ReactPropTypes = {
			array: createPrimitiveTypeChecker("array"),
			bigint: createPrimitiveTypeChecker("bigint"),
			bool: createPrimitiveTypeChecker("boolean"),
			func: createPrimitiveTypeChecker("function"),
			number: createPrimitiveTypeChecker("number"),
			object: createPrimitiveTypeChecker("object"),
			string: createPrimitiveTypeChecker("string"),
			symbol: createPrimitiveTypeChecker("symbol"),
			any: createAnyTypeChecker(),
			arrayOf: createArrayOfTypeChecker,
			element: createElementTypeChecker(),
			elementType: createElementTypeTypeChecker(),
			instanceOf: createInstanceTypeChecker,
			node: createNodeChecker(),
			objectOf: createObjectOfTypeChecker,
			oneOf: createEnumTypeChecker,
			oneOfType: createUnionTypeChecker,
			shape: createShapeTypeChecker,
			exact: createStrictShapeTypeChecker
		};
		/**
		* inlined Object.is polyfill to avoid requiring consumers ship their own
		* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		*/
		function is(x, y) {
			if (x === y) return x !== 0 || 1 / x === 1 / y;
			else return x !== x && y !== y;
		}
		/**
		* We use an Error-like object for backward compatibility as people may call
		* PropTypes directly and inspect their output. However, we don't use real
		* Errors anymore. We don't inspect their stack anyway, and creating them
		* is prohibitively expensive if they are created too often, such as what
		* happens in oneOfType() for any type before the one that matched.
		*/
		function PropTypeError(message, data) {
			this.message = message;
			this.data = data && typeof data === "object" ? data : {};
			this.stack = "";
		}
		PropTypeError.prototype = Error.prototype;
		function createChainableTypeChecker(validate) {
			if (process.env.NODE_ENV !== "production") {
				var manualPropTypeCallCache = {};
				var manualPropTypeWarningCount = 0;
			}
			function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
				componentName = componentName || ANONYMOUS;
				propFullName = propFullName || propName;
				if (secret !== ReactPropTypesSecret) {
					if (throwOnDirectAccess) {
						var err = /* @__PURE__ */ new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						err.name = "Invariant Violation";
						throw err;
					} else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
						var cacheKey = componentName + ":" + propName;
						if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
							printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
							manualPropTypeCallCache[cacheKey] = true;
							manualPropTypeWarningCount++;
						}
					}
				}
				if (props[propName] == null) {
					if (isRequired) {
						if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
						return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
					}
					return null;
				} else return validate(props, propName, componentName, location, propFullName);
			}
			var chainedCheckType = checkType.bind(null, false);
			chainedCheckType.isRequired = checkType.bind(null, true);
			return chainedCheckType;
		}
		function createPrimitiveTypeChecker(expectedType) {
			function validate(props, propName, componentName, location, propFullName, secret) {
				var propValue = props[propName];
				if (getPropType(propValue) !== expectedType) {
					var preciseType = getPreciseType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), { expectedType });
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createAnyTypeChecker() {
			return createChainableTypeChecker(emptyFunctionThatReturnsNull);
		}
		function createArrayOfTypeChecker(typeChecker) {
			function validate(props, propName, componentName, location, propFullName) {
				if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
				var propValue = props[propName];
				if (!Array.isArray(propValue)) {
					var propType = getPropType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
				}
				for (var i = 0; i < propValue.length; i++) {
					var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
					if (error instanceof Error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createElementTypeChecker() {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				if (!isValidElement(propValue)) {
					var propType = getPropType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createElementTypeTypeChecker() {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				if (!ReactIs.isValidElementType(propValue)) {
					var propType = getPropType(propValue);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createInstanceTypeChecker(expectedClass) {
			function validate(props, propName, componentName, location, propFullName) {
				if (!(props[propName] instanceof expectedClass)) {
					var expectedClassName = expectedClass.name || ANONYMOUS;
					var actualClassName = getClassName(props[propName]);
					return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createEnumTypeChecker(expectedValues) {
			if (!Array.isArray(expectedValues)) {
				if (process.env.NODE_ENV !== "production") {
					if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
					else printWarning("Invalid argument supplied to oneOf, expected an array.");
				}
				return emptyFunctionThatReturnsNull;
			}
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				for (var i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
				var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
					if (getPreciseType(value) === "symbol") return String(value);
					return value;
				});
				return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
			}
			return createChainableTypeChecker(validate);
		}
		function createObjectOfTypeChecker(typeChecker) {
			function validate(props, propName, componentName, location, propFullName) {
				if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
				var propValue = props[propName];
				var propType = getPropType(propValue);
				if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
				for (var key in propValue) if (has(propValue, key)) {
					var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
					if (error instanceof Error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createUnionTypeChecker(arrayOfTypeCheckers) {
			if (!Array.isArray(arrayOfTypeCheckers)) {
				process.env.NODE_ENV !== "production" && printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
				return emptyFunctionThatReturnsNull;
			}
			for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
				var checker = arrayOfTypeCheckers[i];
				if (typeof checker !== "function") {
					printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
					return emptyFunctionThatReturnsNull;
				}
			}
			function validate(props, propName, componentName, location, propFullName) {
				var expectedTypes = [];
				for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
					var checker = arrayOfTypeCheckers[i];
					var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
					if (checkerResult == null) return null;
					if (checkerResult.data && has(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
				}
				var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
				return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
			}
			return createChainableTypeChecker(validate);
		}
		function createNodeChecker() {
			function validate(props, propName, componentName, location, propFullName) {
				if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function invalidValidatorError(componentName, location, propFullName, key, type) {
			return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
		}
		function createShapeTypeChecker(shapeTypes) {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				var propType = getPropType(propValue);
				if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
				for (var key in shapeTypes) {
					var checker = shapeTypes[key];
					if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
					var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
					if (error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function createStrictShapeTypeChecker(shapeTypes) {
			function validate(props, propName, componentName, location, propFullName) {
				var propValue = props[propName];
				var propType = getPropType(propValue);
				if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
				for (var key in assign({}, props[propName], shapeTypes)) {
					var checker = shapeTypes[key];
					if (has(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
					if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
					var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
					if (error) return error;
				}
				return null;
			}
			return createChainableTypeChecker(validate);
		}
		function isNode(propValue) {
			switch (typeof propValue) {
				case "number":
				case "string":
				case "undefined": return true;
				case "boolean": return !propValue;
				case "object":
					if (Array.isArray(propValue)) return propValue.every(isNode);
					if (propValue === null || isValidElement(propValue)) return true;
					var iteratorFn = getIteratorFn(propValue);
					if (iteratorFn) {
						var iterator = iteratorFn.call(propValue);
						var step;
						if (iteratorFn !== propValue.entries) {
							while (!(step = iterator.next()).done) if (!isNode(step.value)) return false;
						} else while (!(step = iterator.next()).done) {
							var entry = step.value;
							if (entry) {
								if (!isNode(entry[1])) return false;
							}
						}
					} else return false;
					return true;
				default: return false;
			}
		}
		function isSymbol(propType, propValue) {
			if (propType === "symbol") return true;
			if (!propValue) return false;
			if (propValue["@@toStringTag"] === "Symbol") return true;
			if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
			return false;
		}
		function getPropType(propValue) {
			var propType = typeof propValue;
			if (Array.isArray(propValue)) return "array";
			if (propValue instanceof RegExp) return "object";
			if (isSymbol(propType, propValue)) return "symbol";
			return propType;
		}
		function getPreciseType(propValue) {
			if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
			var propType = getPropType(propValue);
			if (propType === "object") {
				if (propValue instanceof Date) return "date";
				else if (propValue instanceof RegExp) return "regexp";
			}
			return propType;
		}
		function getPostfixForTypeWarning(value) {
			var type = getPreciseType(value);
			switch (type) {
				case "array":
				case "object": return "an " + type;
				case "boolean":
				case "date":
				case "regexp": return "a " + type;
				default: return type;
			}
		}
		function getClassName(propValue) {
			if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
			return propValue.constructor.name;
		}
		ReactPropTypes.checkPropTypes = checkPropTypes;
		ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
		ReactPropTypes.PropTypes = ReactPropTypes;
		return ReactPropTypes;
	};
}));
//#endregion
//#region ../../node_modules/prop-types/factoryWithThrowingShims.js
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_factoryWithThrowingShims = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ReactPropTypesSecret = require_ReactPropTypesSecret();
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	module.exports = function() {
		function shim(props, propName, componentName, location, propFullName, secret) {
			if (secret === ReactPropTypesSecret) return;
			var err = /* @__PURE__ */ new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
			err.name = "Invariant Violation";
			throw err;
		}
		shim.isRequired = shim;
		function getShim() {
			return shim;
		}
		var ReactPropTypes = {
			array: shim,
			bigint: shim,
			bool: shim,
			func: shim,
			number: shim,
			object: shim,
			string: shim,
			symbol: shim,
			any: shim,
			arrayOf: getShim,
			element: shim,
			elementType: shim,
			instanceOf: getShim,
			node: shim,
			objectOf: getShim,
			oneOf: getShim,
			oneOfType: getShim,
			shape: getShim,
			exact: getShim,
			checkPropTypes: emptyFunctionWithReset,
			resetWarningCache: emptyFunction
		};
		ReactPropTypes.PropTypes = ReactPropTypes;
		return ReactPropTypes;
	};
}));
//#endregion
//#region ../../node_modules/react-imask/esm/mixin.js
var import_prop_types = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copyright (c) 2013-present, Facebook, Inc.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*/
	if (process.env.NODE_ENV !== "production") {
		var ReactIs = require_react_is();
		module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, true);
	} else module.exports = require_factoryWithThrowingShims()();
})))());
var MASK_PROPS = {
	mask: import_prop_types.default.oneOfType([
		import_prop_types.default.array,
		import_prop_types.default.func,
		import_prop_types.default.string,
		import_prop_types.default.instanceOf(RegExp),
		import_prop_types.default.oneOf([
			Date,
			Number,
			IMask.Masked
		]),
		import_prop_types.default.instanceOf(IMask.Masked)
	]),
	value: import_prop_types.default.any,
	unmask: import_prop_types.default.oneOfType([import_prop_types.default.bool, import_prop_types.default.oneOf(["typed"])]),
	prepare: import_prop_types.default.func,
	validate: import_prop_types.default.func,
	commit: import_prop_types.default.func,
	overwrite: import_prop_types.default.oneOfType([import_prop_types.default.bool, import_prop_types.default.oneOf(["shift"])]),
	eager: import_prop_types.default.bool,
	onAccept: import_prop_types.default.func,
	onComplete: import_prop_types.default.func,
	placeholderChar: import_prop_types.default.string,
	lazy: import_prop_types.default.bool,
	definitions: import_prop_types.default.object,
	blocks: import_prop_types.default.object,
	pattern: import_prop_types.default.string,
	format: import_prop_types.default.func,
	parse: import_prop_types.default.func,
	autofix: import_prop_types.default.oneOfType([import_prop_types.default.bool, import_prop_types.default.oneOf(["pad"])]),
	radix: import_prop_types.default.string,
	thousandsSeparator: import_prop_types.default.string,
	mapToRadix: import_prop_types.default.arrayOf(import_prop_types.default.string),
	scale: import_prop_types.default.number,
	signed: import_prop_types.default.bool,
	normalizeZeros: import_prop_types.default.bool,
	padFractionalZeros: import_prop_types.default.bool,
	min: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.instanceOf(Date)]),
	max: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.instanceOf(Date)]),
	dispatch: import_prop_types.default.func,
	inputRef: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.shape({ current: import_prop_types.default.object })])
};
var MASK_PROPS_NAMES = Object.keys(MASK_PROPS);
var NON_MASK_OPTIONS_PROPS_NAMES = [
	"value",
	"unmask",
	"onAccept",
	"onComplete",
	"inputRef"
];
var MASK_OPTIONS_PROPS_NAMES = MASK_PROPS_NAMES.filter(function(pName) {
	return NON_MASK_OPTIONS_PROPS_NAMES.indexOf(pName) < 0;
});
function IMaskMixin(ComposedComponent) {
	var MaskedComponent = /*#__PURE__*/ function(_React$Component) {
		_inherits(MaskedComponent, _React$Component);
		var _super = _createSuper(MaskedComponent);
		function MaskedComponent(props) {
			var _this;
			_classCallCheck(this, MaskedComponent);
			_this = _super.call(this, props);
			_this._inputRef = _this._inputRef.bind(_assertThisInitialized(_this));
			return _this;
		}
		_createClass(MaskedComponent, [
			{
				key: "componentDidMount",
				value: function componentDidMount() {
					if (!this.props.mask) return;
					this.initMask();
				}
			},
			{
				key: "componentDidUpdate",
				value: function componentDidUpdate() {
					var props = this.props;
					var maskOptions = this._extractMaskOptionsFromProps(props);
					if (maskOptions.mask) {
						if (this.maskRef) {
							this.maskRef.updateOptions(maskOptions);
							if ("value" in props) this.maskValue = props.value;
						} else this.initMask(maskOptions);
					} else {
						this.destroyMask();
						if ("value" in props) this.element.value = props.value;
					}
				}
			},
			{
				key: "componentWillUnmount",
				value: function componentWillUnmount() {
					this.destroyMask();
				}
			},
			{
				key: "_inputRef",
				value: function _inputRef(el) {
					this.element = el;
					if (this.props.inputRef) {
						if (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current")) this.props.inputRef.current = el;
						else this.props.inputRef(el);
					}
				}
			},
			{
				key: "initMask",
				value: function initMask() {
					var maskOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._extractMaskOptionsFromProps(this.props);
					this.maskRef = IMask(this.element, maskOptions).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this));
					if ("value" in this.props) this.maskValue = this.props.value;
				}
			},
			{
				key: "destroyMask",
				value: function destroyMask() {
					if (this.maskRef) {
						this.maskRef.destroy();
						delete this.maskRef;
					}
				}
			},
			{
				key: "_extractMaskOptionsFromProps",
				value: function _extractMaskOptionsFromProps(props) {
					var cloneProps = Object.assign({}, props);
					Object.keys(cloneProps).filter(function(prop) {
						return MASK_OPTIONS_PROPS_NAMES.indexOf(prop) < 0;
					}).forEach(function(nonMaskProp) {
						delete cloneProps[nonMaskProp];
					});
					return cloneProps;
				}
			},
			{
				key: "_extractNonMaskProps",
				value: function _extractNonMaskProps(props) {
					var cloneProps = Object.assign({}, props);
					MASK_PROPS_NAMES.forEach(function(maskProp) {
						delete cloneProps[maskProp];
					});
					return cloneProps;
				}
			},
			{
				key: "maskValue",
				get: function get() {
					if (this.props.unmask === "typed") return this.maskRef.typedValue;
					if (this.props.unmask) return this.maskRef.unmaskedValue;
					return this.maskRef.value;
				},
				set: function set(value) {
					value = value == null ? "" : value;
					if (this.props.unmask === "typed") this.maskRef.typedValue = value;
					else if (this.props.unmask) this.maskRef.unmaskedValue = value;
					else this.maskRef.value = value;
				}
			},
			{
				key: "_onAccept",
				value: function _onAccept(e) {
					if (this.props.onAccept && this.maskRef) this.props.onAccept(this.maskValue, this.maskRef, e);
				}
			},
			{
				key: "_onComplete",
				value: function _onComplete(e) {
					if (this.props.onComplete && this.maskRef) this.props.onComplete(this.maskValue, this.maskRef, e);
				}
			},
			{
				key: "render",
				value: function render() {
					return React.createElement(ComposedComponent, Object.assign({}, this._extractNonMaskProps(this.props), { inputRef: this._inputRef }));
				}
			}
		]);
		return MaskedComponent;
	}(React.Component);
	var nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || "Component";
	MaskedComponent.displayName = "IMask(".concat(nestedComponentName, ")");
	MaskedComponent.propTypes = MASK_PROPS;
	return MaskedComponent;
}
//#endregion
//#region ../../node_modules/react-imask/esm/input.js
var _excluded$5 = ["inputRef"];
var IMaskInputClass = IMaskMixin(function(_ref) {
	var inputRef = _ref.inputRef, props = _objectWithoutProperties$1(_ref, _excluded$5);
	return React.createElement("input", Object.assign({}, props, { ref: inputRef }));
});
var IMaskInput = React.forwardRef(function IMaskInputFn(props, ref) {
	return React.createElement(IMaskInputClass, Object.assign({}, props, { ref }));
});
//#endregion
//#region src/components/button/button.styled.ts
var getButtonType = (type) => {
	switch (type) {
		case "white": return `text-gray-700 bg-white
        border border-solid border-gray-300
        hover:cursor-pointer hover:bg-gray-50
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500`;
		case "disabled": return "border border-solid border-gray-200 text-gray-400 bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500";
		case "secondary": return `text-primary-700 bg-primary-100
        border border-solid border-primary-100
        hover:bg-primary-200 hover:border-primary-200
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-primary-500`;
		case "form": return "border border-gray-300 bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none";
		case "rsbry": return `border border-solid border-rsbry-600
          text-white bg-rsbry-600
          hover:bg-rsbry-700 hover:border-rsbry-700
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rsbry-500`;
		case "action": return `text-rsbry-700 bg-rsbry-100
        border border-solid border-rsbry-100
        hover:bg-rsbry-200 hover:border-rsbry-200
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-rsbry-500`;
		case "success": return `text-green-800 bg-green-200
        border border-solid border-green-200
        hover:bg-green-300 hover:border-green-300
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-green-500`;
		case "info": return `text-blue-800 bg-blue-100
        border border-solid border-blue-100
        hover:bg-blue-200 hover:border-blue-200
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500`;
		case "warning": return `text-lemon-800 bg-lemon-200
        border border-solid border-lemon-200
        hover:bg-lemon-400 hover:border-lemon-400
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-lemon-500`;
		case "error": return `text-rsbry-800 bg-rsbry-100
        border border-solid border-rsbry-100
        hover:bg-rsbry-200 hover:border-rsbry-200
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-rsbry-500`;
		default: return `
        border border-solid border-primary-600
        text-white bg-primary-600
        hover:bg-primary-700 hover:border-primary-700
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500`;
	}
};
var getButtonSize = (size) => {
	switch (size) {
		case "xl": return "px-6 py-3 text-base";
		case "lg": return "px-4 py-2 text-base";
		case "sm": return "px-3 py-2 text-sm leading-4";
		case "xs": return "px-2.5 py-1.5 text-xs";
		default: return "px-4 py-2 text-sm";
	}
};
var getRoundedClass = (rounded) => {
	switch (rounded) {
		case "left": return "rounded-l";
		case "right": return "rounded-r";
		case "regular": return "rounded-md";
		case "full": return "rounded-full";
		default: return "";
	}
};
var StyledButton$1 = (0, import_dist.default)(Button$2)`
  relative
  inline-flex
  items-center
  justify-center
  font-medium
  shadow-sm
  m-1
  transition duration-300
  whitespace-nowrap
  ${({ $variant }) => getButtonType($variant)}
  ${({ $size }) => getButtonSize($size)}
  ${({ $rounded }) => getRoundedClass($rounded)}
`;
var StyledIcon$2 = import_dist.default.div`
  -ml-0.5
  mr-2
  h-4
  w-4
  flex
  items-center
  justify-center
`;
var StyledSpinnerWrapper = import_dist.default.span`
  absolute
  flex
  items-center
  justify-center
`;
var StyledButtonContent = import_dist.default.span`
  inline-flex
  items-center
  justify-center
  ${({ $isLoading }) => $isLoading ? "invisible" : "visible"}
`;
var StyledButtonCheckbox = (0, import_dist.default)(Checkbox$1)`
  inline-flex
  items-center
  font-medium
  rounded-md
  shadow-sm
  transition duration-300
  ${({ $variant }) => getButtonType($variant)}
  ${({ $size }) => getButtonSize($size)}
  ${({ $rounded }) => getRoundedClass($rounded)}
  ${({ $checked }) => $checked ? "bg-gray-200 text-gray-400 focus:ring-gray-500" : ""}
`;
var getCircularButtonSize = (size) => {
	switch (size) {
		case "xl": return "p-3";
		case "lg": return "p-2";
		case "sm": return "p-1.5";
		case "xs": return "p-1";
		default: return "p-2";
	}
};
var getButtonCircularType = (type) => {
	switch (type) {
		case "gray": return `
        bg-gray-100
        hover:bg-gray-200
        border-0
        shadow-none

        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-primary-500`;
		case "simple": return `
        bg-white
        border-0
        shadow-none

        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-primary-500`;
		case "secondary": return `
        fill-primary-700
        bg-primary-100

        border-solid
        border-primary-600

        hover:bg-primary-200
        hover:border-primary-700

        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-offset-white
        focus:ring-primary-500`;
		case "disabled": return `
        fill-gray-400
        bg-gray-200

        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-gray-500`;
		default: return `
        fill-white
        bg-primary-600

        border-transparent

        hover:bg-primary-700
        hover:border-primary-700

        focus:ring-primary-500`;
	}
};
var StyledCircularButton = (0, import_dist.default)(Button$2)`
  inline-flex
  items-center
  border
  shadow-sm
  rounded-full

  focus:outline-none
  focus:ring-2
  focus:ring-offset-2

  transition duration-300

  ${({ $variant }) => getButtonCircularType($variant)}
  ${({ $size }) => getCircularButtonSize($size)}
`;
var getIconWrapperSize = (size) => {
	switch (size) {
		case "xl":
		case "lg": return "h-6 w-6";
		default: return "h-5 w-5";
	}
};
var StyledIconWrapper$2 = import_dist.default.div`
  ${({ $size }) => getIconWrapperSize($size)}
`;
//#endregion
//#region src/components/button/Button.tsx
var Button = ({ as, children, className, disabled, innerRef, isLoading, onClick, rounded, size = "base", startIcon, type = "button", variant = "primary", ...props }) => /* @__PURE__ */ React.createElement(StyledButton$1, {
	$variant: disabled || isLoading ? "disabled" : variant,
	$size: size,
	$rounded: rounded,
	disabled: disabled || isLoading,
	onClick,
	type,
	className,
	as,
	ref: innerRef,
	...props
}, isLoading && /* @__PURE__ */ React.createElement(StyledSpinnerWrapper, null, /* @__PURE__ */ React.createElement(Spinner, {
	size: "sm",
	variant: "primary"
})), /* @__PURE__ */ React.createElement(StyledButtonContent, { $isLoading: isLoading }, startIcon && /* @__PURE__ */ React.createElement(StyledIcon$2, {
	"aria-hidden": "true",
	"data-testid": "start-icon"
}, startIcon), children));
var ButtonWithForwardRefInner = (props, ref) => /* @__PURE__ */ React.createElement(Button, {
	...props,
	innerRef: ref
});
var ButtonWithForwardRef = React.forwardRef(ButtonWithForwardRefInner);
ButtonWithForwardRef.displayName = "ButtonWithForwardRef";
var ButtonMemo = memo(Button);
//#endregion
//#region src/components/button/ButtonCheckbox.tsx
var ButtonCheckBox = ({ checked, children, className, disabled, onChange, rounded, size = "base", startIcon, variant = "primary" }) => /* @__PURE__ */ React.createElement(StyledButtonCheckbox, {
	$checked: checked,
	$rounded: rounded,
	$size: size,
	$variant: disabled ? "disabled" : variant,
	as: "div",
	checked,
	className,
	disabled,
	onChange
}, startIcon && /* @__PURE__ */ React.createElement("div", {
	className: "-ml-0.5 mr-2 h-4 w-4",
	"aria-hidden": "true",
	"data-testid": "start-icon"
}, startIcon), children);
var ButtonCheckBoxMemo = memo(ButtonCheckBox);
//#endregion
//#region src/components/button/ButtonCircular.tsx
var ButtonCircular = ({ as, className, disabled = false, icon, onClick, size = "base", type = "button", variant = "primary", ...props }) => /* @__PURE__ */ React.createElement(StyledCircularButton, {
	$size: size,
	$variant: disabled ? "disabled" : variant,
	onClick,
	type,
	className,
	as,
	...props
}, /* @__PURE__ */ React.createElement(StyledIconWrapper$2, {
	$size: size,
	"aria-hidden": "true"
}, icon));
var ButtonCircularMemo = memo(ButtonCircular);
//#endregion
//#region src/components/form-items/input/input.styled.ts
var InputContainer$1 = import_dist.default.div`
  flex
  rounded-md
  shadow-sm
`;
var InlineInputContainer = import_dist.default.div`
  relative
  flex
  items-stretch
  flex-grow
  focus-within:z-10
  ${({ $isActive }) => $isActive ? "[&_input]:bg-primary-50 [&_input]:ring-1 [&_input]:border-primary-300 [&_input]:ring-primary-300 [&_input]:text-primary-700 [&_svg]:!text-primary-600" : ""}
`;
var AddOn = import_dist.default.div`
  inline-flex
  items-center
  rounded-l-md
  border
  border-r-0
  border-gray-300
  bg-gray-50
  px-3
  text-gray-500
  sm:text-sm
`;
var LeadingContent = import_dist.default.div`
  absolute
  inset-y-0
  left-0
  pl-3
  flex
  items-center
  pointer-events-none
  text-gray-400
`;
var TrailingContent = import_dist.default.div`
  inline-trailing-content
  absolute
  inset-y-0
  right-0
  pr-3
  flex
  items-center
  pointer-events-none
`;
var StyledInput$2 = import_dist.default.input`
  focus:ring-1
  focus:outline-none
  placeholder:text-gray-400
  shadow-sm
  block
  w-full
  sm:text-sm
  border
  ${({ $trailingButton }) => $trailingButton ? "rounded-l-md" : "rounded-md"}
  ${({ $leadingContent }) => $leadingContent ? "pl-7 pr-3 py-2" : "py-2 px-3"}
  ${({ $addOn }) => $addOn ? "rounded-l-none" : ""}
  ${({ $uppercase }) => $uppercase ? "uppercase" : ""}
  ${({ $error, disabled }) => {
	if (disabled) return "bg-gray-200 border-primary-600";
	if ($error) return `border-rsbry-300 text-rsbry-900 placeholder:text-rsbry-300
        focus:ring-rsbry-500 focus:border-rsbry-500 animate-shake`;
	return "border-gray-300 focus:border-primary-600 focus:ring-primary-600 placeholder:text-gray-400";
}}
`;
(0, import_dist.default)(IMaskInput)`
  focus:ring-1
  focus:outline-none
  placeholder:text-gray-400
  shadow-sm
  block
  w-full
  sm:text-sm
  border
  ${({ $trailingButton }) => $trailingButton ? "rounded-l-md" : "rounded-md"}
  ${({ $leadingContent }) => $leadingContent ? "pl-7 pr-3 py-2" : "py-2 px-3"}
  ${({ $addOn }) => $addOn ? "rounded-l-none" : ""}
  ${({ $uppercase }) => $uppercase ? "uppercase" : ""}
  ${({ $error, disabled }) => {
	if (disabled) return "bg-gray-200 border-primary-600";
	if ($error) return `border-rsbry-300 text-rsbry-900 placeholder-rsbry-300
        focus:ring-rsbry-500 focus:border-rsbry-500 animate-shake`;
	return "border-gray-300 focus:border-primary-600 focus:ring-primary-600 placeholder-gray-200";
}}
`;
var TrailingIcon = (0, import_dist.default)(Stack)`
  absolute
  inset-y-0
  right-0
  pr-3
  pointer-events-none
`;
var StyledTrailingButton = (0, import_dist.default)(Button)`
  ${({ $selected }) => $selected ? "bg-primary-500 text-white border-primary-500 hover:bg-primary-700 hover:text-white" : ""}
  border-l-0
  m-0
`;
import_dist.default.p`
  mb-0
  text-sm
  text-rsbry-600
`;
//#endregion
//#region src/components/form-items/input/constants/input.constants.ts
var InputMasksMap = {
	PHONE: { mask: "(000) 000 0000" },
	EIN: { mask: "00-0000000" },
	NUMBER: {
		mask: Number,
		scale: 2,
		thousandsSeparator: ",",
		radix: ".",
		unmask: "typed"
	},
	PERCENTAGE: {
		mask: "num%",
		lazy: false,
		blocks: { num: {
			mask: Number,
			min: 0,
			max: 100
		} }
	},
	DATE: { mask: "00/00/0000" }
};
//#endregion
//#region src/components/form-items/input/InputMask.tsx
var InputMaskMixin = IMaskMixin(({ inputRef, ...props }) => /* @__PURE__ */ React.createElement(StyledInput$2, {
	...props,
	ref: inputRef
}));
var InputMask = ({ mask, onChange, returnValueType = "typedValue", type: _type, ...props }) => /* @__PURE__ */ React.createElement(InputMaskMixin, {
	autoComplete: "off",
	unmask: "typed",
	onAccept: (_, mask) => {
		if (mask.value === props.value || mask.unmaskedValue === props.value || mask.typedValue === props.value) return;
		onChange?.(mask[returnValueType] ?? "");
	},
	...InputMasksMap[mask],
	...props
});
//#endregion
//#region src/components/form-items/input/Input.tsx
var InputWithForwardRef = ({ addOn, autoComplete, autoFocus, className, disabled, error, errorText, id, inlineLeadingContent, inlineTrailingContent, isActive, mask, maskReturnValueType, max, maxLength, min, name, onBlur, onChange, onClick, pattern, placeholder, trailingButton, trailingIcon, type, value }, ref) => {
	const inputProps = {
		$error: error,
		$leadingContent: inlineLeadingContent !== void 0,
		$addOn: addOn !== void 0,
		$trailingButton: trailingButton !== void 0,
		$uppercase: type === "date",
		"aria-errormessage": `${id}-error`,
		"aria-invalid": error,
		"data-testid": "ui-component-input",
		autoComplete,
		autoFocus,
		disabled,
		id,
		min,
		max,
		maxLength,
		name,
		onChange,
		onClick,
		onBlur,
		pattern,
		placeholder,
		readOnly: !onChange,
		ref,
		type,
		value
	};
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InputContainer$1, { className }, /* @__PURE__ */ React.createElement(InlineInputContainer, { $isActive: isActive }, addOn && /* @__PURE__ */ React.createElement(AddOn, null, addOn), inlineLeadingContent && /* @__PURE__ */ React.createElement(LeadingContent, null, inlineLeadingContent), mask ? /* @__PURE__ */ React.createElement(InputMask, {
		...inputProps,
		mask,
		returnValueType: maskReturnValueType,
		onChange
	}) : /* @__PURE__ */ React.createElement(StyledInput$2, inputProps), inlineTrailingContent && /* @__PURE__ */ React.createElement(TrailingContent, null, inlineTrailingContent), trailingIcon && /* @__PURE__ */ React.createElement(TrailingIcon, { alignItems: "center" }, trailingIcon)), trailingButton), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!error && !!errorText,
		id: `${id}-error`
	}, errorText));
};
var Input = React.forwardRef(InputWithForwardRef);
var InputMemo = memo(Input);
//#endregion
//#region src/components/form-items/input/TrailingButton.tsx
var TrailingButton = ({ children, className, onClick, selected, startIcon }) => /* @__PURE__ */ React.createElement(StyledTrailingButton, {
	$selected: selected,
	startIcon,
	rounded: "right",
	variant: "form",
	size: "base",
	onClick,
	className
}, children);
var TrailingButtonMemo = memo(TrailingButton);
//#endregion
//#region src/components/form-items/input/enums/input-masks.enum.ts
var InputMasks = /* @__PURE__ */ function(InputMasks) {
	InputMasks["PHONE"] = "PHONE";
	InputMasks["EIN"] = "EIN";
	InputMasks["NUMBER"] = "NUMBER";
	InputMasks["PERCENTAGE"] = "PERCENTAGE";
	InputMasks["DATE"] = "DATE";
	return InputMasks;
}({});
//#endregion
//#region src/components/form-items/input-form-container/input-form-container.styled.ts
var StyledInputFormContainer = import_dist.default.div`
  ${({ $withError }) => $withError ? "mb-1" : "mb-6"}
  ${({ $horizontal }) => $horizontal ? "grid grid-cols-7 items-baseline gap-4 pt-5 px-6" : "flex flex-col gap-1"}
  ${({ $border, $horizontal }) => $border && $horizontal ? "border-t border-gray-200 " : ""}
`;
var StyledLabel$4 = import_dist.default.label`
  block
  text-sm
  font-medium
  text-gray-700
  ${({ $horizontal }) => $horizontal ? "col-span-2" : ""}
`;
var StyledInputContainer = import_dist.default.div`
  w-full
  ${({ $horizontal }) => $horizontal ? "col-span-5" : ""}
`;
var StyledHelpText = (0, import_dist.default)(FormSectionHelpText)`
  ${({ $horizontal }) => $horizontal ? "col-span-7" : ""}
`;
//#endregion
//#region src/components/form-items/input-form-container/InputFormLabel.tsx
var InputFormLabel = ({ horizontal = false, inputId, label, secondaryLabel }) => /* @__PURE__ */ React.createElement(React.Fragment, null, typeof label === "string" ? /* @__PURE__ */ React.createElement(StyledLabel$4, {
	$horizontal: horizontal,
	htmlFor: inputId
}, label, !!secondaryLabel && /* @__PURE__ */ React.createElement(Typography, {
	fontSize: "sm",
	color: colors.gray[400]
}, " ", secondaryLabel)) : label);
//#endregion
//#region src/components/form-items/input-form-container/InputFormContainer.tsx
var InputFormContainer = ({ action, border = true, children, className, helpText, horizontal = false, inputId, label, secondaryLabel, withError = false }) => /* @__PURE__ */ React.createElement(StyledInputFormContainer, {
	$horizontal: horizontal,
	$withError: withError,
	className,
	$border: border
}, action ? /* @__PURE__ */ React.createElement(Stack, {
	justifyContent: "space-between",
	alignItems: "end",
	gap: .5
}, /* @__PURE__ */ React.createElement(InputFormLabel, {
	horizontal,
	inputId,
	label,
	secondaryLabel
}), action) : /* @__PURE__ */ React.createElement(InputFormLabel, {
	horizontal,
	inputId,
	label,
	secondaryLabel
}), /* @__PURE__ */ React.createElement(StyledInputContainer, { $horizontal: horizontal }, children), !!helpText && !withError && /* @__PURE__ */ React.createElement(StyledHelpText, { $horizontal: horizontal }, helpText));
var InputFormContainerMemo = memo(InputFormContainer);
//#endregion
//#region src/components/form-items/text-area/styled.ts
var StyledTextAreaContainer = import_dist.default.div`
  relative
`;
var StyledTextArea = import_dist.default.textarea`
  focus:ring-1
  focus:outline-none
  placeholder:text-gray-400
  shadow-sm
  block
  sm:text-sm
  rounded-md
  w-full
  border
  ${({ $error, disabled }) => {
	if (disabled) return "bg-gray-200 border-primary-600";
	if ($error) return `border-rsbry-300 text-rsbry-900 placeholder-rsbry-300
        focus:ring-rsbry-500 focus:border-rsbry-500 animate-shake`;
	return "border-gray-300 focus:border-primary-600 focus:ring-primary-600 placeholder-gray-200";
}}
`;
var StyledTextAreaButton = (0, import_dist.default)(Button)`
  ${({ $selected }) => $selected ? "bg-primary-500 text-white border-primary-500 hover:bg-primary-700 hover:text-white" : ""}
    rounded-md
    absolute
    top-0
    right-0
    -translate-y-[34px]
    m-0
`;
//#endregion
//#region src/components/form-items/text-area/TextArea.tsx
var TextArea = ({ className, disabled, error, errorText, id, onChange, textAreaButton, value, ...props }) => {
	const textAreaProps = {
		$error: error,
		"aria-errormessage": `${id}-error`,
		"aria-invalid": error,
		"data-testid": "ui-component-text-area",
		disabled,
		id,
		...props
	};
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledTextAreaContainer, { className }, /* @__PURE__ */ React.createElement(StyledTextArea, {
		...textAreaProps,
		disabled,
		value,
		onChange
	}), textAreaButton), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!error && !!errorText,
		id: `${id}-error`
	}, errorText));
};
var TextAreaMemo = memo(TextArea);
//#endregion
//#region src/components/form-items/text-area/TextAreaButton.tsx
var TextAreaButton = ({ children, className, onClick, selected, startIcon }) => /* @__PURE__ */ React.createElement(StyledTextAreaButton, {
	$selected: selected,
	startIcon,
	rounded: "regular",
	variant: "form",
	size: "xs",
	onClick,
	className
}, children);
var TextAreaButtonMemo = memo(TextAreaButton);
//#endregion
//#region src/components/form-items/toggle/toggle.styled.ts
var LABEL_COLOR_VARIANTS = {
	white: "text-white",
	gray: "text-gray-700"
};
var toggleSize = {
	xl: "w-[3.25rem] h-7",
	lg: "w-[3.25rem] h-7",
	base: "w-11 h-6",
	sm: "w-9 h-5",
	xs: "w-7 h-4"
};
var getToggleSpanSizeAndTranslation = (size, checked) => {
	switch (size) {
		case "xl": return `w-6 h-6 ${checked ? "translate-x-6" : "translate-x-0"}`;
		case "lg": return `w-6 h-6 ${checked ? "translate-x-6" : "translate-x-0"}`;
		case "sm": return `w-4 h-4 ${checked ? "translate-x-4" : "translate-x-0"}`;
		case "xs": return `w-3 h-3 ${checked ? "translate-x-3" : "translate-x-0"}`;
		default: return `w-5 h-5 ${checked ? "translate-x-5" : "translate-x-0"}`;
	}
};
var StyledToggleContainer = (0, import_dist.default)(Stack)`
  ${({ $disabled }) => $disabled ? "opacity-50" : ""}
`;
var StyledToggle = (0, import_dist.default)(ue)`
  relative
  inline-flex
  flex-shrink-0
  border-2
  border-transparent
  rounded-full
  transition-colors
  ease-in-out duration-200
  focus:outline-none
  focus:ring-2
  focus:ring-offset-2
  focus:ring-current
  text-primary-600
  ${({ $disabled }) => $disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
  ${({ checked }) => checked ? "bg-current" : "bg-gray-200"}
  ${({ $size }) => toggleSize[$size]}
`;
var StyledToggleSpan = import_dist.default.span`
  pointer-events-none
  inline-block
  rounded-full
  bg-white
  shadow
  transform
  ring-0
  transition
  ease-in-out
  duration-200
  flex
  justify-center
  items-center
  ${({ $checked, $size }) => getToggleSpanSizeAndTranslation($size, $checked)}
`;
var StyledLabel$3 = (0, import_dist.default)(Typography)`
  ${({ $colorVariant }) => LABEL_COLOR_VARIANTS[$colorVariant]}
`;
//#endregion
//#region src/assets/icons/bold-check.svg
var SvgBoldCheck = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M23.15,5.4l-2.8-2.8a.5.5,0,0,0-.7,0L7.85,14.4a.5.5,0,0,1-.7,0l-2.8-2.8a.5.5,0,0,0-.7,0L.85,14.4a.5.5,0,0,0,0,.7l6.3,6.3a.5.5,0,0,0,.7,0L23.15,6.1A.5.5,0,0,0,23.15,5.4Z",
		style: { fill: "currentColor" }
	})
});
var ForwardRef$24 = forwardRef(SvgBoldCheck);
var Memo$24 = memo(ForwardRef$24);
//#endregion
//#region src/components/form-items/toggle/ToggleSwitch.tsx
var ToggleSwitch = ({ checked = false, className, disabled, id, onChange, size = "base", withIcon = false }) => /* @__PURE__ */ React.createElement(StyledToggle, {
	"data-analytic-id": id,
	checked,
	onChange,
	disabled,
	$disabled: disabled,
	$size: size,
	className
}, /* @__PURE__ */ React.createElement(StyledToggleSpan, {
	"aria-hidden": "true",
	$checked: checked,
	$size: size
}, withIcon && checked && /* @__PURE__ */ React.createElement(Memo$24, { className: "w-2 h-2" }), withIcon && !checked && /* @__PURE__ */ React.createElement(Memo$25, { className: "w-2 h-2 text-gray-400" })));
var ToggleSwitchMemo = memo(ToggleSwitch);
//#endregion
//#region src/components/form-items/toggle/Toggle.tsx
var Toggle = ({ alignItems = "start", checked = false, className, disabled = false, id, labelColorVariant = "gray", onChange, size = "base", subtitle, title, withIcon = false }) => /* @__PURE__ */ React.createElement(StyledToggleContainer, {
	alignItems,
	$disabled: disabled,
	className
}, /* @__PURE__ */ React.createElement(Stack, {
	alignItems: "center",
	justifyContent: "start"
}, /* @__PURE__ */ React.createElement(ToggleSwitch, {
	checked,
	onChange,
	disabled,
	withIcon,
	size
})), /* @__PURE__ */ React.createElement("div", { className: "ml-3" }, /* @__PURE__ */ React.createElement(StyledLabel$3, {
	as: "label",
	fontWeight: "medium",
	fontSize: size,
	$colorVariant: labelColorVariant,
	htmlFor: id
}, title), subtitle && /* @__PURE__ */ React.createElement(Typography, {
	as: "p",
	fontSize: size,
	className: "text-gray-500"
}, subtitle)));
var ToggleMemo = memo(Toggle);
//#endregion
//#region src/components/tooltip/tooltip.styled.ts
var StyledTooltipAnchor = (0, import_dist.default)(TooltipAnchor)`
  cursor-default
`;
var StyledTooltip = (0, import_dist.default)(Tooltip$1)`
  z-tooltip
  py-2
  px-2
  text-xs
  text-gray-50
  bg-gray-700
  rounded-md
  shadow-sm
`;
//#endregion
//#region src/components/tooltip/Tooltip.tsx
var Tooltip = ({ children, className, anchorClassName, options = { showArrow: false }, text }) => {
	const { showArrow, ...useTooltipStateOpts } = options;
	const tooltip = useTooltipState({
		timeout: 400,
		...useTooltipStateOpts
	});
	if (!text) return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledTooltipAnchor, {
		className: anchorClassName,
		state: tooltip
	}, children), tooltip.open ? /* @__PURE__ */ React.createElement(StyledTooltip, {
		state: tooltip,
		className
	}, showArrow ? /* @__PURE__ */ React.createElement(TooltipArrow, null) : null, text) : null);
};
var TooltipMemo = memo(Tooltip);
//#endregion
//#region src/assets/icons/alert-circle.svg
var SvgAlertCircle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M12,0A12.24,12.24,0,0,0,3.47,3.65,11.85,11.85,0,0,0,0,12.21,11.78,11.78,0,0,0,11.8,24H12A12.11,12.11,0,0,0,24,11.79h0A11.77,11.77,0,0,0,12,0ZM10.5,16.54A1.48,1.48,0,0,1,12,15h0a1.53,1.53,0,0,1,1.52,1.47A1.47,1.47,0,0,1,12.05,18h0A1.53,1.53,0,0,1,10.5,16.54Zm.5-4v-6a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Z",
		fill: "currentColor"
	})
});
var ForwardRef$23 = forwardRef(SvgAlertCircle);
var Memo$23 = memo(ForwardRef$23);
//#endregion
//#region src/components/molecules/allocation-input/allocation-input.styled.ts
var BG_COLOR_VARIANT = {
	gray: "bg-gray-400",
	darkRsbry: "bg-rsbry-600",
	primary: "bg-primary-600",
	secondary: "bg-blue-600",
	green: "bg-green-300",
	lime: "bg-lime-400",
	aqua: "bg-aqua-500",
	avocado: "bg-avocado-800",
	orange: "bg-orange-400",
	lightRsbry: "bg-rsbry-300",
	lemon: "bg-lemon-300"
};
var StyledTypography$2 = (0, import_dist.default)(Typography)`
  w-[276px]
  truncate
`;
var StyledDot = import_dist.default.span`
  inline-block
  rounded-full
  w-2
  h-2
  ${({ $variant }) => BG_COLOR_VARIANT[$variant]}
`;
var StyledInput$1 = (0, import_dist.default)(Input)`
  w-[100px]
  h-[42px]
  m-0
`;
var StyledAlertCircle = (0, import_dist.default)(Memo$23)`
  w-6
  text-rsbry-600
`;
var IconPlaceholder = import_dist.default.div`
  w-6
`;
//#endregion
//#region src/components/molecules/allocation-input/AllocationInput.tsx
var AllocationInput = ({ error, errorText, label, variant, ...rest }) => /* @__PURE__ */ React.createElement(Stack, {
	alignItems: "center",
	justifyContent: "space-between"
}, /* @__PURE__ */ React.createElement(Stack, {
	alignItems: "center",
	gap: 1.5
}, /* @__PURE__ */ React.createElement(StyledDot, { $variant: variant }), /* @__PURE__ */ React.createElement(StyledTypography$2, {
	as: "p",
	fontSize: "base",
	fontWeight: "medium"
}, label)), /* @__PURE__ */ React.createElement(Stack, {
	alignItems: "center",
	gap: 4
}, error && errorText ? /* @__PURE__ */ React.createElement(Tooltip, {
	className: "max-w-[140px] !z-modal",
	text: errorText,
	options: { showArrow: true }
}, /* @__PURE__ */ React.createElement(StyledAlertCircle, null)) : /* @__PURE__ */ React.createElement(IconPlaceholder, null), /* @__PURE__ */ React.createElement(StyledInput$1, {
	mask: InputMasks.PERCENTAGE,
	maskReturnValueType: "unmaskedValue",
	onClick: (event) => {
		if (event.currentTarget.value === "0%") event.currentTarget.select();
	},
	...rest,
	error
})));
memo(AllocationInput);
//#endregion
//#region src/components/molecules/allocation-pill/allocation-pill.styled.ts
var StyledPillContainer = (0, import_dist.default)(Stack)`
  group
  w-full
  h-8
`;
var StyledPill = (0, import_dist.default)(Button$2)`
  block
  h-5
  w-[118px]
  rounded-lg
  border
  border-blue-700
  relative
  overflow-hidden
`;
var StyledTypography$1 = (0, import_dist.default)(Typography)`
  text-gray-400
  m-auto
  relative
`;
var StyledStack$3 = (0, import_dist.default)(Stack)`
  absolute
  top-0
  w-full
  h-5
`;
var StyledSelectedPercentage = import_dist.default.div`
  transition-colors
  bg-gray-800
  group-hover:bg-primary-600
`;
var StyledAlreadyAllocatedPercentage = import_dist.default.div`
  transition-colors
  bg-gray-200
  group-hover:bg-gray-300
`;
var StyledPercentage$1 = (0, import_dist.default)(Typography)`
  w-8
  text-right
  text-gray-800
  transition-colors
  group-hover:text-primary-600
`;
//#endregion
//#region src/components/molecules/allocation-pill/AllocationPill.tsx
var AllocationPill = ({ alreadyAllocatedPercentage = 0, className, onClick, selectedPercentage, showSelectedPercentage = false }) => /* @__PURE__ */ React.createElement(StyledPillContainer, {
	alignItems: "center",
	justifyContent: "center",
	gap: 1
}, /* @__PURE__ */ React.createElement(StyledPill, {
	className,
	onClick
}, /* @__PURE__ */ React.createElement(StyledStack$3, null, /* @__PURE__ */ React.createElement(StyledSelectedPercentage, { style: { width: `${selectedPercentage}%` } }), /* @__PURE__ */ React.createElement(StyledAlreadyAllocatedPercentage, { style: { width: `${alreadyAllocatedPercentage}%` } })), /* @__PURE__ */ React.createElement(StyledTypography$1, {
	as: "p",
	fontSize: "xs",
	fontWeight: "medium"
}, "ADVANCED")), showSelectedPercentage ? /* @__PURE__ */ React.createElement(StyledPercentage$1, {
	as: "span",
	fontSize: "xs",
	fontWeight: "semibold",
	id: "selected-percentage",
	lineHeight: 5
}, selectedPercentage, /* @__PURE__ */ React.createElement(Typography, {
	className: "text-inherit",
	as: "span",
	fontSize: "xs",
	fontWeight: "normal",
	lineHeight: 5
}, "%")) : null);
memo(AllocationPill);
//#endregion
//#region src/components/molecules/allocation-slider/allocation-slider.styled.ts
var HoverInnerSquareColorVariant = {
	base: "group-hover:bg-primary-600 hover:border-primary-600 group-hover:border-primary-600",
	0: "group-hover:bg-primary-100 hover:border-primary-600 group-hover:border-primary-600",
	1: "group-hover:bg-blue-100 hover:border-blue-600 group-hover:border-blue-600",
	2: "group-hover:bg-green-100 hover:border-green-300 group-hover:border-green-300",
	3: "group-hover:bg-lime-100 hover:border-lime-300 group-hover:border-lime-300",
	4: "group-hover:bg-aqua-100 hover:border-aqua-500 group-hover:border-aqua-500",
	5: "group-hover:bg-avocado-100 hover:border-avocado-800 group-hover:border-avocado-800",
	6: "group-hover:bg-orange-100 hover:border-orange-400 group-hover:border-orange-400",
	7: "group-hover:bg-rsbry-100 hover:border-rsbry-300 group-hover:border-rsbry-300",
	8: "group-hover:bg-lemon-100 hover:border-lemon-300 group-hover:border-lemon-300"
};
var BaseSelectedColorVariant = {
	base: "text-gray-800",
	0: "text-primary-800",
	1: "text-blue-800",
	2: "text-green-800",
	3: "text-lime-800",
	4: "text-aqua-800",
	5: "text-avocado-800",
	6: "text-orange-800",
	7: "text-rsbry-800",
	8: "text-lemon-800"
};
var CheckboxSquareColorVariant = {
	base: "peer-checked:bg-gray-600 peer-checked:border-gray-600 hover:bg-primary-600 hover:border-primary-600",
	0: "peer-checked:bg-primary-600 peer-checked:border-primary-600 hover:bg-primary-100 hover:border-primary-600 peer-checked:hover:border-primary-100",
	1: "peer-checked:bg-blue-600 peer-checked:border-blue-600 hover:bg-blue-100 hover:border-blue-600 peer-checked:hover:border-blue-100",
	2: "peer-checked:bg-green-300 peer-checked:border-green-300 hover:bg-green-100 hover:border-green-300 peer-checked:hover:border-green-100",
	3: "peer-checked:bg-lime-300 peer-checked:border-lime-300 hover:bg-lime-100 hover:border-lime-300 peer-checked:hover:border-lime-100",
	4: "peer-checked:bg-aqua-500 peer-checked:border-aqua-500 hover:bg-aqua-100 hover:border-aqua-500 peer-checked:hover:border-aqua-100",
	5: "peer-checked:bg-avocado-800 peer-checked:border-avocado-800 hover:bg-avocado-100 hover:border-avocado-800 peer-checked:hover:border-avocado-100",
	6: "peer-checked:bg-orange-400 peer-checked:border-orange-400 hover:bg-orange-100 hover:border-orange-400 peer-checked:hover:border-orange-100",
	7: "peer-checked:bg-rsbry-300 peer-checked:border-rsbry-300 hover:bg-rsbry-100 hover:border-rsbry-300 peer-checked:hover:border-rsbry-100",
	8: "peer-checked:bg-lemon-300 peer-checked:border-lemon-300 hover:bg-lemon-100 hover:border-lemon-300 peer-checked:hover:border-lemon-100"
};
var CheckboxSquareHighlightColorVariant = {
	base: "!border-primary-600",
	0: "!border-primary-100",
	1: "!border-blue-100",
	2: "!border-green-100",
	3: "!border-lime-100",
	4: "!border-aqua-100",
	5: "!border-avocado-100",
	6: "!border-orange-100",
	7: "!border-rsbry-100",
	8: "!border-lemon-100"
};
var SliderVariant = {
	selected: "bg-gray-800",
	suggested: "bg-gray-400",
	readOnlyBase: "bg-gray-200 border-gray-300",
	readOnlyBaseHover: "bg-gray-800 border-gray-400",
	readOnlyDisabled: "h-1.5 bg-gray-300",
	readOnlySelected: "bg-gray-800 border-gray-400",
	readOnlySelectedHover: "bg-gray-200 border-gray-300",
	disabled: "h-1.5 !bg-gray-300 !border-gray-300 relative top-1/2 -translate-y-1/2 cursor-not-allowed"
};
var PeerSliderVariant = {
	selected: "peer-hover:[&>div]:bg-gray-800",
	suggested: "peer-hover:[&>div]:bg-gray-400",
	readOnlyBase: "",
	readOnlyBaseHover: "",
	readOnlyDisabled: "",
	readOnlySelected: "",
	readOnlySelectedHover: "",
	disabled: ""
};
var PercentageVariant = {
	selected: "text-current",
	suggested: "text-gray-500",
	readOnlyBase: "text-gray-500",
	readOnlyBaseHover: "text-gray-400",
	readOnlyDisabled: "",
	readOnlySelected: "text-current",
	readOnlySelectedHover: "text-gray-200",
	disabled: ""
};
var StyledContainer$5 = (0, import_dist.default)(Stack)`
  pointer-events-auto
  group
  h-5
  ${({ $variant }) => BaseSelectedColorVariant[$variant]}
`;
var StyledAllocationSliderContainer = (0, import_dist.default)(Stack)`
  group
  peer
`;
var StyledSquare = (0, import_dist.default)(je.Option)`
  pointer-events-auto
  group
  peer
  h-5
  rounded-sm
  px-px
  focus:outline-primary-600
  peer-hover:[&>div]:transition-colors
  peer-hover:[&>div]:duration-500
  peer-hover:[&>div]:bg-gray-200
  peer-hover:[&>div]:border-gray-300
  ${({ $variant }) => PeerSliderVariant[$variant]}
`;
var StyledInnerSquare = import_dist.default.div`
  cursor-pointer
  h-5
  w-2.5
  rounded-sm
  border-gray-300
  border
  bg-gray-200
  group-hover:transition-colors
  group-hover:duration-500
  ${({ $hoverVariant }) => HoverInnerSquareColorVariant[$hoverVariant]}
  ${({ $variant }) => SliderVariant[$variant]}
`;
var StyledPercentage = (0, import_dist.default)(Typography)`
  w-8
  text-right
  text-gray-500
  peer-hover:transition-colors
  peer-hover:duration-500
  ${({ $textVariant }) => $textVariant === "base" ? "peer-hover:text-primary-600" : "peer-hover:text-current"}
  ${({ $variant }) => PercentageVariant[$variant]}
`;
var StyledReadOnlySquare = import_dist.default.div`
  h-5
  w-2.5
  rounded-sm
  border
  ease-in-out
  transition-colors
  duration-200
  ${({ $variant }) => SliderVariant[$variant]}
`;
var StyledCheckboxSquare = import_dist.default.div`
  h-1.5
  w-2.5
  rounded-sm
  border
  bg-gray-300
  peer-checked:h-5
  cursor-pointer
  ${({ $colorVariant }) => CheckboxSquareColorVariant[$colorVariant]}
  ${({ $colorVariant, $sympatheticHighlight }) => $sympatheticHighlight ? `${CheckboxSquareHighlightColorVariant[$colorVariant]} shadow-md` : ""}
`;
//#endregion
//#region src/components/molecules/allocation-slider/AllocationCheckbox.tsx
var AllocationCheckbox = ({ checked, colorVariant, squareId }) => {
	const elementId = `${squareId}-${checked ? "checked" : "unchecked"}`;
	const { highlight, isSympatheticHighlighted, removeHighlight } = useSympatheticHighlight(elementId);
	return /* @__PURE__ */ React.createElement(StyledCheckboxSquare, {
		$colorVariant: colorVariant,
		$sympatheticHighlight: isSympatheticHighlighted,
		onMouseEnter: () => {
			const selectedElementId = `${squareId}-checked`;
			if (elementId !== selectedElementId) highlight(selectedElementId);
		},
		onMouseLeave: () => {
			const selectedElementId = `${squareId}-checked`;
			if (elementId !== selectedElementId) removeHighlight(selectedElementId);
		}
	});
};
//#endregion
//#region src/components/molecules/allocation-slider/StepByStepAllocationSlider.tsx
var StepByStepAllocationSlider = ({ namespace = "", onChange, projectId, projects, tooltip, variant = "base" }) => {
	const colorVariant = typeof variant === "string" ? variant : variant % 9;
	const squares = projects.map((stepId, idx) => ({
		"aria-label": `${(idx + 1) * 10}%`,
		key: `${namespace}${(idx + 1) * 10}`,
		checked: stepId === projectId,
		onChange: () => {
			onChange({
				percentage: 10,
				newProjectId: projectId,
				previousProjectId: stepId
			});
		},
		stepId
	}));
	if (squares.length === 0) return /* @__PURE__ */ React.createElement(React.Fragment, null);
	return /* @__PURE__ */ React.createElement(StyledContainer$5, {
		alignItems: "center",
		direction: "row",
		gap: .5
	}, squares.map(({ checked, key, stepId, ...squareProps }) => /* @__PURE__ */ React.createElement(Tooltip, {
		key,
		className: "max-w-[220px] !z-modal bg-opacity-80",
		text: tooltip?.(stepId),
		options: {
			placement: "right",
			showArrow: true,
			gutter: -2
		}
	}, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(Checkbox$1, {
		className: "sr-only peer",
		checked,
		...squareProps
	}), /* @__PURE__ */ React.createElement(AllocationCheckbox, {
		squareId: key,
		checked,
		colorVariant
	})))));
};
var StepByStepAllocationSliderMemo = memo(StepByStepAllocationSlider);
var generateSteps = (totalSteps, startPercentageFrom) => Array.from({ length: totalSteps }, (_, i) => (i + 1 + startPercentageFrom / 10) * 10);
var getSelectedVariant = (percentage, variantWhenTrue, variantWhenFalse = "") => percentage >= 1 ? variantWhenTrue : variantWhenFalse;
//#endregion
//#region src/components/molecules/allocation-slider/AllocationSlider.tsx
var AllocationSlider = ({ alreadyAllocatedPercentage = 0, direction = "ltr", id, name, onChange, onSelect = () => {}, otherAllocations, projectId, projects, selectedPercentage, startPercentageFrom = 0, steps = 10, suggestedPercentage = 0, tooltip, variant = "base" }) => {
	const colorVariant = typeof variant === "string" ? variant : variant % 9;
	const totalPercentage = steps * 10 + startPercentageFrom;
	const isHoverEventEnableRef = useRef(false);
	const [hoveredPercentage, setHoveredPercentage] = useState(0);
	const [selectedVariant, percentageToShow] = selectedPercentage !== 0 ? ["selected", selectedPercentage] : ["suggested", suggestedPercentage];
	const isDisabled = (step) => (totalPercentage - alreadyAllocatedPercentage) / step < 1;
	const { onMouseEnterHoverIntent, onMouseLeaveHoverIntent } = useHoverIntent();
	const { onMouseEnterHoverIntent: onMouseEnterCellHoverIntent, onMouseLeaveHoverIntent: onMouseLeaveCellHoverIntent } = useHoverIntent();
	const squares = generateSteps(steps, startPercentageFrom).map((step) => ({
		"aria-label": `${step}%`,
		value: step,
		$variant: getSelectedVariant(percentageToShow / step, selectedVariant),
		disabled: isDisabled(step),
		onMouseEnter: onMouseEnterCellHoverIntent(() => {
			setHoveredPercentage(step);
		}, isHoverEventEnableRef.current ? 0 : 200),
		onClick: () => {
			setHoveredPercentage(0);
			if (step === selectedPercentage) onSelect?.(0);
		},
		id: `${id}-${step}`
	}));
	return /* @__PURE__ */ React.createElement(StyledContainer$5, {
		$variant: colorVariant,
		alignItems: "center",
		gap: 1
	}, /* @__PURE__ */ React.createElement(Stack, { gap: .5 }, projects && projectId && onChange ? /* @__PURE__ */ React.createElement(StepByStepAllocationSlider, {
		projectId,
		projects,
		onChange,
		variant
	}) : null, squares.length > 0 ? /* @__PURE__ */ React.createElement(je, {
		id,
		className: "peer",
		name,
		value: selectedPercentage,
		onChange: onSelect
	}, /* @__PURE__ */ React.createElement(je.Label, { className: "sr-only" }, "allocation slider"), /* @__PURE__ */ React.createElement(StyledAllocationSliderContainer, {
		alignItems: "center",
		direction: direction === "ltr" ? "row" : "row-reverse",
		justifyContent: "end",
		onMouseEnter: onMouseEnterHoverIntent(() => {
			isHoverEventEnableRef.current = true;
		}, 200),
		onMouseLeave: onMouseLeaveHoverIntent((event) => {
			onMouseLeaveCellHoverIntent(() => {
				isHoverEventEnableRef.current = false;
				setHoveredPercentage(0);
			})(event);
		})
	}, squares.map(({ $variant, id, value, ...squareProps }) => /* @__PURE__ */ React.createElement(StyledSquare, {
		"analytic-id": id,
		$variant,
		value,
		key: value,
		...squareProps
	}, ({ disabled }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(je.Label, { className: "sr-only" }, `${value}%`), /* @__PURE__ */ React.createElement(StyledInnerSquare, {
		$variant: disabled ? "disabled" : $variant,
		$hoverVariant: colorVariant
	})))))) : null, otherAllocations && projectId && onChange ? /* @__PURE__ */ React.createElement(StepByStepAllocationSlider, {
		namespace: "otherAllocations",
		onChange,
		projectId,
		projects: otherAllocations,
		variant,
		tooltip
	}) : null), /* @__PURE__ */ React.createElement(StyledPercentage, {
		$textVariant: colorVariant,
		$variant: selectedVariant,
		as: "span",
		fontSize: "xs",
		fontWeight: "semibold",
		id: "selected-percentage",
		lineHeight: 5
	}, hoveredPercentage || percentageToShow, /* @__PURE__ */ React.createElement(Typography, {
		className: "text-inherit",
		as: "span",
		fontSize: "xs",
		fontWeight: "normal",
		lineHeight: 5
	}, "%")));
};
var AllocationSliderMemo = memo(AllocationSlider);
//#endregion
//#region src/components/molecules/allocation-slider-input/AllocationSliderInput.tsx
var AllocationSliderInput = ({ errorText, hideLabel = false, id, label, name, onChange, onSelect, value }) => /* @__PURE__ */ m$3.createElement(m$3.Fragment, null, /* @__PURE__ */ m$3.createElement(Grid, {
	cols: 2,
	gap: 2
}, /* @__PURE__ */ m$3.createElement(AllocationSlider, {
	name,
	selectedPercentage: value,
	onChange,
	onSelect
}), /* @__PURE__ */ m$3.createElement(Typography, {
	fontSize: "xs",
	fontWeight: "semibold",
	color: colors.gray[500],
	className: hideLabel ? "sr-only" : ""
}, label)), /* @__PURE__ */ m$3.createElement(GeneralFormError, {
	error: !!errorText,
	id: `${id}-error`
}, errorText));
//#endregion
//#region src/components/molecules/allocation-slider/ReadOnlyAllocationSlider.tsx
var steps = generateSteps(10, 0);
var ReadOnlyAllocationSlider = ({ alreadyAllocatedPercentage = 0, hovercardOpen = false, id, selectedPercentage }) => {
	const isDisabled = (step) => (100 - alreadyAllocatedPercentage) / step < 1;
	const squares = steps.map((step) => ({
		"aria-label": `${step}%`,
		value: step,
		$variant: isDisabled(step) ? "readOnlyDisabled" : getSelectedVariant(selectedPercentage / step, hovercardOpen ? "readOnlySelectedHover" : "readOnlySelected", hovercardOpen ? "readOnlyBaseHover" : "readOnlyBase")
	}));
	return /* @__PURE__ */ React.createElement(StyledContainer$5, {
		id,
		alignItems: "center",
		direction: "row",
		gap: .5
	}, squares.map(({ value, ...squareProps }) => /* @__PURE__ */ React.createElement(StyledReadOnlySquare, {
		key: value,
		...squareProps
	})));
};
var ReadOnlyAllocationSliderMemo = memo(ReadOnlyAllocationSlider);
//#endregion
//#region src/components/molecules/change-text/change-text.styled.ts
var CHANGE_TEXT_VARIANTS = {
	gray: "text-gray-400",
	primary: "text-primary-300",
	secondary: "text-blue-100",
	lightGray: "text-gray-50",
	red: "text-rsbry-600",
	green: " text-green-600",
	rsbry: "text-rsbry-500"
};
var StyledChangeText = import_dist.default.span`
  self-end
  leading-5
  ${({ $variant }) => CHANGE_TEXT_VARIANTS[$variant]}
`;
var EmojiContainer = import_dist.default.span`
  pr-1
`;
//#endregion
//#region src/components/molecules/change-text/ChangeText.tsx
var getChangeText = (changeType, replacementText) => {
	if (replacementText) return replacementText;
	return changeType === "plus" ? "Money Back" : "Money Owed";
};
var ChangeText = ({ changeType, className, negativeChangeText, positiveChangeText, variant = "gray" }) => /* @__PURE__ */ React.createElement(StyledChangeText, {
	$variant: variant,
	className
}, changeType === "plus" ? /* @__PURE__ */ React.createElement(React.Fragment, null, !positiveChangeText && /* @__PURE__ */ React.createElement(EmojiContainer, null, /* @__PURE__ */ React.createElement("span", null, "❤️")), /* @__PURE__ */ React.createElement("span", null, getChangeText("plus", positiveChangeText))) : /* @__PURE__ */ React.createElement(React.Fragment, null, !negativeChangeText && /* @__PURE__ */ React.createElement(EmojiContainer, null, /* @__PURE__ */ React.createElement("span", null, "💔")), /* @__PURE__ */ React.createElement("span", null, getChangeText("minus", negativeChangeText))));
memo(ChangeText);
//#endregion
//#region src/components/molecules/colored-amount/colored-amount.styled.ts
var AMOUNT_VARIANTS = {
	gray: "text-gray-400",
	primary: "text-primary-300",
	secondary: "text-blue-100",
	lightGray: "text-gray-50"
};
var CENTS_VARIANTS = {
	gray: "text-gray-500",
	primary: "text-primary-300",
	secondary: "text-blue-300",
	lightGray: "text-gray-300"
};
var StyledAmountRestPart = import_dist.default.span`
  ${({ $variant }) => AMOUNT_VARIANTS[$variant]}
`;
var StyledSignificantAmountPart = (0, import_dist.default)(StyledAmountRestPart)`
  font-semibold
`;
var StyledAmountCents = import_dist.default.span`
  ${({ $variant }) => CENTS_VARIANTS[$variant]}
`;
//#endregion
//#region src/components/molecules/colored-amount/ColoredAmount.tsx
var ColoredAmount = ({ amountCents, showCents = true, variant = "gray", withDollarSign = true, ...props }) => {
	const [wholeNumberPart, decimalPart] = (amountCents != null ? (0, import_lib.formatDollarsFromCents)(amountCents, {
		showCents,
		withDollarSign,
		minimumFractionDigits: 2,
		roundingMethod: import_lib.RoundingMethod.FLOOR
	}) : `${withDollarSign ? "$ " : ""}---`).split(".");
	const [significativePart, ...restAmount] = wholeNumberPart.split(",");
	const restAmountConcat = restAmount.join(",");
	return /* @__PURE__ */ React.createElement(Typography, {
		fontWeight: "light",
		id: "colored-amount",
		...props
	}, /* @__PURE__ */ React.createElement(StyledSignificantAmountPart, { $variant: variant }, significativePart), restAmountConcat ? /* @__PURE__ */ React.createElement(StyledAmountRestPart, { $variant: variant }, ",", restAmountConcat) : null, amountCents != null && showCents ? /* @__PURE__ */ React.createElement(StyledAmountCents, { $variant: variant }, /* @__PURE__ */ React.createElement(StyledAmountCents, { $variant: "gray" }, "."), decimalPart) : null);
};
var ColoredAmountMemo = memo(ColoredAmount);
//#endregion
//#region src/components/molecules/amount-kpi/amount-kpi.styled.ts
var kpiColorVariant = {
	gray: "text-gray-400",
	primary: "text-primary-300",
	secondary: "text-blue-300",
	lightGray: "text-gray-50"
};
var LEADING_CONTENT_VARIANTS = {
	gray: "text-gray-300",
	primary: "text-primary-300",
	secondary: "text-blue-100",
	lightGray: "text-gray-50"
};
var AmountKpiToIconMapping = {
	gray: "grayFilled",
	primary: "primaryFilled",
	secondary: "secondaryFilled",
	lightGray: "lightGrayFilled"
};
var TextContainer = (0, import_dist.default)(Stack)`
  pb-1
`;
var StyledAmountKpiContainer = (0, import_dist.default)(Stack)`
  space-x-3
  max-w-full
`;
var StyledTitleParagraph$1 = (0, import_dist.default)(Typography)`
  mb-0
  overflow-hidden
  text-ellipsis
  whitespace-nowrap
  tracking-wide
  uppercase
  ${({ $variant }) => kpiColorVariant[$variant]}
`;
var StyledTitleLeadingContent = (0, import_dist.default)(Typography)`
  ${({ $variant }) => LEADING_CONTENT_VARIANTS[$variant]}
`;
var SEPARATOR_VARIANTS = {
	gray: "text-gray-500",
	primary: "text-primary-300",
	secondary: "text-blue-300",
	lightGray: "text-gray-300"
};
var StyledSeparator = import_dist.default.span`
  px-1
  leading-4
  ${({ $variant }) => SEPARATOR_VARIANTS[$variant]}
`;
//#endregion
//#region src/components/molecules/amount-kpi/AmountKpi.tsx
var getChangeType = (amount) => {
	if (!amount) return;
	if (amount > 0) return "plus";
	if (amount < 0) return "minus";
};
var AmountKpi = ({ amountCents, className, icon, leadingAmountContent, negativeChangeText, positiveChangeText, showCents = true, showChangeType = false, title, variant = "gray" }) => {
	const changeType = getChangeType(amountCents);
	return /* @__PURE__ */ React.createElement(StyledAmountKpiContainer, {
		className,
		alignItems: "center"
	}, icon != null ? /* @__PURE__ */ React.createElement("div", { "data-testid": "icon-container" }, /* @__PURE__ */ React.createElement(Icon, {
		node: icon,
		nodeSize: 5,
		size: 8,
		variant: "circular",
		colorVariant: AmountKpiToIconMapping[variant]
	}), " ") : null, /* @__PURE__ */ React.createElement(TextContainer, { direction: "column" }, /* @__PURE__ */ React.createElement(StyledTitleParagraph$1, {
		$variant: variant,
		as: "p",
		fontSize: "xs",
		fontWeight: "semibold",
		lineHeight: 4
	}, title), /* @__PURE__ */ React.createElement(Stack, null, leadingAmountContent ? /* @__PURE__ */ React.createElement(StyledTitleLeadingContent, {
		$variant: variant,
		lineHeight: 4
	}, leadingAmountContent) : null, /* @__PURE__ */ React.createElement(ColoredAmount, {
		amountCents,
		as: "p",
		showCents,
		variant,
		lineHeight: 4
	}), showChangeType && changeType && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledSeparator, { $variant: variant }, "|"), /* @__PURE__ */ React.createElement(ChangeText, {
		changeType,
		positiveChangeText,
		negativeChangeText,
		variant: changeType === "plus" ? variant : "rsbry",
		className: (0, import_classnames.default)({
			"leading-4": true,
			"font-light": changeType === "plus",
			"font-semibold": changeType === "minus"
		})
	})))));
};
var AmountKpiMemo = memo(AmountKpi);
//#endregion
//#region src/components/molecules/avatar-group-stacked/styled.ts
var StyledDivStack = import_dist.default.div`flex -space-x-1`;
//#endregion
//#region src/components/molecules/avatar-group-stacked/AvatarGroupStacked.tsx
var StackedGroupAvatars = ({ children, className }) => /* @__PURE__ */ React.createElement(StyledDivStack, { className }, React.Children.map(children, (child) => /* @__PURE__ */ React.createElement(Tooltip, { text: child.props.text || "" }, React.cloneElement(child, { stacked: true }))));
var StackedGroupAvatarsMemo = memo(StackedGroupAvatars);
//#endregion
//#region src/components/molecules/avatar-with-text/styled.ts
var AvatarTextContent = import_dist.default.div`
  ml-2
  max-w-[calc(100%-25px)]
  overflow-hidden
  text-ellipsis
  whitespace-nowrap
`;
var StyledAvatarWithTextContainerDiv = import_dist.default.div`
  flex
  items-center
  max-w-full
  text-gray-700
  leading-5
  text-sm
  font-medium
`;
var StyledTitleParagraph = (0, import_dist.default)(Typography)`
  mb-0
  truncate
`;
var StyledSubtitleParagraph = (0, import_dist.default)(Typography)`
  leading-5
  text-xs
  font-medium
  text-gray-500
  mb-0
`;
//#endregion
//#region src/components/molecules/avatar-with-text/AvatarWithText.tsx
var AvatarWithText = ({ className, imgSrc, placeholder, size, stacked, subtitle, title, variant, ...props }) => /* @__PURE__ */ React.createElement(StyledAvatarWithTextContainerDiv, { className }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Avatar, {
	imgSrc,
	size,
	stacked,
	text: title,
	variant
})), /* @__PURE__ */ React.createElement(AvatarTextContent, null, /* @__PURE__ */ React.createElement(StyledTitleParagraph, props, title ?? placeholder), subtitle ? /* @__PURE__ */ React.createElement(StyledSubtitleParagraph, { as: "p" }, subtitle) : null));
var AvatarWithTextMemo = memo(AvatarWithText);
//#endregion
//#region src/components/molecules/badge/styled.ts
var BADGE_COLOR_VARIANTS = {
	default: "bg-gray-200 text-gray-800",
	primary: "bg-primary-200 text-primary-800",
	darkPrimary: "bg-primary-600 text-white",
	secondary: "bg-blue-200 text-blue-800",
	red: "bg-rsbry-100 text-rsbry-800",
	yellow: "bg-lemon-100 text-lemon-800",
	green: "bg-green-100 text-green-800",
	blue: "bg-blue-100 text-blue-800",
	darkGreen: "bg-green-400 text-white",
	clear: "bg-white text-gray-800 border border-gray-300"
};
var BADGE_ICON_COLOR_VARIANTS = {
	default: "text-gray-400 fill-gray-400 stroke-gray-400",
	primary: "text-primary-400 fill-primary-400 stroke-primary-400",
	darkPrimary: "text-primary-800 fill-primary-800 stroke-primary-800",
	secondary: "text-blue-400 fill-blue-400 stroke-blue-400",
	red: "text-rsbry-400 fill-rsbry-400 stroke-rsbry-400",
	yellow: "text-lemon-400 fill-lemon-400 stroke-lemon-400",
	green: "text-green-400 fill-green-400 stroke-green-400",
	blue: "text-blue-400 fill-blue-400 stroke-blue-400",
	darkGreen: "text-white fill-white stroke-white",
	clear: "text-gray-400 fill-gray-400 stroke-gray-400"
};
var StyledBadge = import_dist.default.div`
  inline-flex
  items-center
  px-2.5
  py-0.5
  rounded-full
  text-xs
  font-medium
  ${({ $maxWidth }) => $maxWidth ? "overflow-hidden" : ""}
  ${({ $colorVariant }) => BADGE_COLOR_VARIANTS[$colorVariant]}
  ${({ $as, disabled }) => {
	const clickable = $as === "button" || $as === "a";
	return clickable && !disabled ? "cursor-pointer" : clickable && disabled ? "cursor-not-allowed opacity-25" : "";
}}
`;
var StyledCustomIcon = (0, import_dist.default)(Icon)`
  mr-1.5
  ${({ $colorVariant }) => BADGE_ICON_COLOR_VARIANTS[$colorVariant]}
`;
var StyledBadgeIcon = import_dist.default.svg`
  -ml-1
  mr-1.5
  h-2
  w-2
  ${({ $colorVariant }) => BADGE_ICON_COLOR_VARIANTS[$colorVariant]}
`;
//#endregion
//#region src/components/molecules/badge/Badge.tsx
var Badge = ({ as, children, className, colorVariant = "default", disabled = false, dot = true, icon, maxWidth, ...props }) => {
	const style = maxWidth ? { maxWidth: `${maxWidth}px` } : {};
	const fullText = typeof children === "string" ? children : "";
	return /* @__PURE__ */ React.createElement(StyledBadge, {
		$as: as ?? "div",
		$colorVariant: colorVariant,
		className,
		disabled,
		style,
		title: maxWidth && fullText ? fullText : void 0,
		...props
	}, icon && /* @__PURE__ */ React.createElement(StyledCustomIcon, {
		node: icon,
		size: 2,
		variant: "none"
	}), !icon && dot && /* @__PURE__ */ React.createElement(StyledBadgeIcon, {
		"data-testid": "badge-dot",
		$colorVariant: colorVariant,
		viewBox: "0 0 8 8",
		xmlns: "http://www.w3.org/2000/svg",
		fill: "currentColor",
		stroke: "currentColor"
	}, /* @__PURE__ */ React.createElement("circle", {
		cx: 4,
		cy: 4,
		r: 3
	})), /* @__PURE__ */ React.createElement("span", { className: maxWidth ? "truncate block" : "" }, children));
};
var BadgeMemo = memo(Badge);
//#endregion
//#region src/components/molecules/cards/cards.styled.ts
var MAIN_CONTENT_ROUNDED_VARIANTS = {
	default: "rounded-r",
	md: "rounded-r-md",
	lg: "rounded-r-lg",
	full: "rounded-r-full"
};
var MainContentContainer = (0, import_dist.default)(Stack)`
  flex-1
  truncate
  transition-colors
  duration-200
  ${({ $roundedVariant }) => MAIN_CONTENT_ROUNDED_VARIANTS[$roundedVariant]}
`;
var TitleContainer$1 = import_dist.default.div`
  flex-1
  px-4
  py-2
  text-sm
  truncate
`;
var StyledSubTitleTypography = (0, import_dist.default)(Typography)`
  text-gray-500
`;
//#endregion
//#region src/components/molecules/cards/card-with-action/card-with-action.styled.ts
var CARD_WITH_ACTION_COLOR_VARIANTS = {
	primary: "bg-primary-600 text-white",
	secondary: "bg-blue-600 text-white",
	action: "bg-rsbry-600 text-white",
	"action-secondary": "bg-rsbry-100 text-rsbry-700"
};
var CARD_WITH_ACTION_FOCUS_COLOR_VARIANTS = {
	primary: "focus:ring-primary-600",
	secondary: "focus:ring-blue-600",
	action: "focus:ring-rsbry-600",
	"action-secondary": "focus:ring-rsbry-700"
};
var StyledCardWithAction = (0, import_dist.default)(Card)`
  focus:outline-none
  focus:ring-2
  focus:ring-offset-2
  ${({ $variant }) => CARD_WITH_ACTION_FOCUS_COLOR_VARIANTS[$variant]}
  ${({ $backgroundColor }) => $backgroundColor === "gray" ? "bg-gray-200 border border-gray-300 hover:bg-gray-300" : "bg-white hover:bg-gray-50"}
`;
var CardWithActionContainer = import_dist.default.div`
  group
  flex
  h-full
  rounded-md
  ${({ $disabled }) => $disabled ? "shadow-none opacity-30" : ""}
`;
var IconContainer$2 = import_dist.default.div`
  flex
  flex-shrink-0
  items-center
  justify-center
  rounded-l-md
  w-16
  ${({ $cardIconShape, $variant }) => $cardIconShape === "square" ? CARD_WITH_ACTION_COLOR_VARIANTS[$variant] : ""}
  ${({ $disabled }) => $disabled ? "bg-gray-600 text-gray-50" : ""}
`;
var CardIconContainer = import_dist.default.div`
  ${({ $variant }) => CARD_WITH_ACTION_COLOR_VARIANTS[$variant]}
  ${({ $cardIconShape }) => $cardIconShape === "circle" ? "h-8 w-8 p-1 rounded-full" : "h-6 w-6"}
`;
var MainIconContainer = import_dist.default.div`
  flex-shrink-0
  pr-2
`;
var StyledIconWrapper$1 = import_dist.default.div`
  h-8
  w-8
  inline-flex
  items-center
  justify-center
`;
var StyledIcon$1 = import_dist.default.div`
  h-5
  w-5
  text-gray-400
  group-hover:text-gray-500
`;
//#endregion
//#region src/components/molecules/cards/card-with-action/CardWithAction.tsx
var CardWithAction = ({ actionIcon, as, backgroundColor, cardIcon, cardIconShape = "square", className, disabled, subTitle, title, variant = "primary", ...props }) => /* @__PURE__ */ React.createElement(StyledCardWithAction, {
	as,
	disabled,
	$variant: variant,
	$backgroundColor: backgroundColor,
	roundedVariant: "md",
	...props
}, /* @__PURE__ */ React.createElement(CardWithActionContainer, {
	$disabled: disabled,
	className
}, /* @__PURE__ */ React.createElement(IconContainer$2, {
	$disabled: disabled,
	$variant: variant,
	$cardIconShape: cardIconShape
}, /* @__PURE__ */ React.createElement(CardIconContainer, {
	$variant: variant,
	$cardIconShape: cardIconShape
}, cardIcon)), /* @__PURE__ */ React.createElement(MainContentContainer, {
	justifyContent: "space-between",
	alignItems: "center",
	$roundedVariant: "md"
}, /* @__PURE__ */ React.createElement(TitleContainer$1, null, /* @__PURE__ */ React.createElement(Typography, {
	as: "p",
	fontSize: "sm",
	fontWeight: "medium"
}, title), subTitle ? /* @__PURE__ */ React.createElement(StyledSubTitleTypography, {
	as: "p",
	fontSize: "sm"
}, subTitle) : null), /* @__PURE__ */ React.createElement(MainIconContainer, null, /* @__PURE__ */ React.createElement(StyledIconWrapper$1, null, /* @__PURE__ */ React.createElement(StyledIcon$1, { "aria-hidden": "true" }, actionIcon))))));
var CardWithActionMemo = memo(CardWithAction);
//#endregion
//#region src/components/molecules/cards/card-with-avatar/card-with-avatar.styled.ts
var StyledCardWithAvatar = (0, import_dist.default)(Card)`
  w-full
  hover:bg-gray-50
  focus:outline-none
  focus:ring-2
  focus:ring-offset-2
  focus:ring-primary-600
  transition-colors
  duration-200
  ${({ $active }) => $active ? "bg-white" : "bg-transparent"}
`;
var CardWithAvatarTitleContainer = (0, import_dist.default)(TitleContainer$1)`
  pl-1
  pr-4
  py-2.5
  text-left
`;
var StyledTitleText = (0, import_dist.default)(Typography)`
  overflow-hidden
  whitespace-nowrap
  text-ellipsis
`;
var AvatarContainerStack = (0, import_dist.default)(Stack)`
  flex-shrink-0
  p-2
`;
var CardWithAvatarStack = (0, import_dist.default)(Stack)`
  group
  h-full
`;
//#endregion
//#region src/components/molecules/cards/card-with-avatar/CardWithAvatar.tsx
var CardWithAvatar = ({ active = false, avatarProps, className, subTitle, title, ...props }) => /* @__PURE__ */ React.createElement(StyledCardWithAvatar, {
	className,
	$active: active,
	roundedVariant: "md",
	shadow: active,
	border: active,
	...props
}, /* @__PURE__ */ React.createElement(CardWithAvatarStack, {
	alignItems: "center",
	justifyContent: "start"
}, avatarProps && /* @__PURE__ */ React.createElement(AvatarContainerStack, {
	justifyContent: "center",
	alignItems: "center",
	testId: "avatar"
}, /* @__PURE__ */ React.createElement(Avatar, {
	size: 6,
	...avatarProps
})), /* @__PURE__ */ React.createElement(MainContentContainer, {
	justifyContent: "space-between",
	alignItems: "center",
	$roundedVariant: "md"
}, /* @__PURE__ */ React.createElement(CardWithAvatarTitleContainer, null, /* @__PURE__ */ React.createElement(StyledTitleText, {
	as: "p",
	fontSize: "sm",
	fontWeight: "medium"
}, title), subTitle ? /* @__PURE__ */ React.createElement(StyledSubTitleTypography, {
	as: "p",
	fontSize: "sm"
}, subTitle) : null))));
var CardWithAvatarMemo = memo(CardWithAvatar);
//#endregion
//#region src/assets/icons/exclamation-point.svg
var SvgExclamationPoint = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 3 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M1.375 1.5415V8.37484M1.375 15.2082H1.39208",
		stroke: "#B91C1C",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "currentColor"
	})
});
var ForwardRef$22 = forwardRef(SvgExclamationPoint);
var Memo$22 = memo(ForwardRef$22);
//#endregion
//#region src/components/molecules/company-logo-icon/CompanyLogo.tsx
var statusIcons = {
	success: {
		size: 8,
		nodeSize: 4,
		node: /* @__PURE__ */ React.createElement(Memo$24, { className: "text-white" }),
		variant: "circular",
		colorVariant: "secondaryFilled",
		testId: "success-avatar"
	},
	error: {
		size: 8,
		nodeSize: 4,
		node: /* @__PURE__ */ React.createElement(Memo$22, { className: "w-full h-full text-rsbry-700" }),
		variant: "circular",
		colorVariant: "red",
		testId: "error-avatar"
	},
	disabled: {
		className: "opacity-50",
		size: 10,
		nodeSize: 8,
		variant: "circular",
		node: null,
		colorVariant: "secondary",
		testId: "disabled-avatar"
	},
	default: {
		size: 8,
		nodeSize: 8,
		variant: "circular",
		node: null,
		colorVariant: "secondary",
		testId: "default-avatar"
	}
};
var CompanyLogo = ({ logo, status }) => {
	if (status === "default" || status === "disabled") statusIcons[status].node = logo;
	const iconProps = statusIcons[status];
	return /* @__PURE__ */ React.createElement(Icon, {
		...iconProps,
		className: "border-none leading-none"
	});
};
//#endregion
//#region src/components/molecules/company-logo-icon/CompanyLogoIcon.tsx
var CompanyLogoIcon = ({ className, companyName, logo, status = "default" }) => /* @__PURE__ */ React.createElement(Stack, {
	className,
	direction: "column",
	alignItems: "center"
}, /* @__PURE__ */ React.createElement(CompanyLogo, {
	status,
	logo
}), /* @__PURE__ */ React.createElement(Typography, {
	as: "p",
	fontSize: "xs",
	fontWeight: "medium",
	lineHeight: 6,
	className: "text-gray-400"
}, companyName));
var CompanyLogoMemo = memo(CompanyLogoIcon);
//#endregion
//#region src/components/molecules/controlled-allocation-slider/ControlledAllocationSlider.tsx
var ControlledAllocationSlider = ({ control, helpText, hideLabel, id, label, name, rules, secondaryLabel }) => /* @__PURE__ */ m$3.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, ...rest }, fieldState: { error } }) => {
		const errorMsg = error?.message;
		return /* @__PURE__ */ m$3.createElement(InputFormContainer, {
			label,
			helpText,
			inputId: id,
			withError: !!errorMsg
		}, /* @__PURE__ */ m$3.createElement(AllocationSliderInput, {
			id,
			label: secondaryLabel,
			hideLabel,
			value: rest.value,
			onSelect: rest.onChange,
			errorText: errorMsg
		}));
	}
});
//#endregion
//#region src/components/molecules/controlled-autocomplete-tag/ControlledAutocompleteTagInput.tsx
var ControlledAutocompleteTagInput = ({ className, control, errorText, helpText, horizontal = false, id, label, name, rules, ...props }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { onChange, ref: _ref, value }, fieldState: { error } }) => {
		const errorMsg = errorText || error?.message;
		return /* @__PURE__ */ React.createElement(InputFormContainer, {
			inputId: id,
			label,
			helpText,
			withError: !!errorMsg,
			horizontal,
			className
		}, /* @__PURE__ */ React.createElement(AutocompleteTagInput, {
			id,
			error: !!errorMsg,
			errorText: errorMsg,
			name,
			onChange,
			values: value,
			...props
		}));
	}
});
//#endregion
//#region src/components/molecules/controlled-autocomplete/ControlledAutocompleteInput.tsx
var ControlledAutocompleteInput = ({ action, allowCreate, className, control, disabled, errorText, groupEndValues, helpText, horizontal = false, id, label, name, onCreate, optionDisabledKey, optionDisplayKey, optionValueKey, options, placeholder, rules, searchKeys }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { name: controllerName, onChange: controllerOnChange, ref: _ref, value: controllerValue }, fieldState: { error } }) => {
		const errorMsg = errorText || error?.message;
		return /* @__PURE__ */ React.createElement(InputFormContainer, {
			inputId: id,
			label,
			helpText,
			withError: !!errorMsg,
			horizontal,
			className,
			action
		}, /* @__PURE__ */ React.createElement(AutocompleteInput, {
			id,
			error: !!errorMsg,
			errorText: errorMsg,
			disabled,
			groupEndValues,
			name: controllerName,
			onChange: controllerOnChange,
			optionDisabledKey,
			optionDisplayKey,
			optionValueKey,
			options,
			placeholder,
			searchKeys,
			value: controllerValue,
			allowCreate,
			onCreate
		}));
	}
});
//#endregion
//#region src/components/button-group/button-group.styled.ts
var StyledGroup = (0, import_dist.default)(Group)`
  flex
`;
var StyledGroupOptionContent = import_dist.default.div`
  px-4
  py-2
  flex
  justify-center
  items-center
  font-medium
`;
var StyledOptionButton = (0, import_dist.default)(Button$2)`
  relative
  flex
  justify-center
  items-center
  border
  first:rounded-l-md
  last:rounded-r-md
  text-sm
  font-medium
  transition
  duration-300
  focus:z-10
  focus:outline-none
  focus:ring-1
  focus:ring-primary-500
  focus:border-primary-500
  ${({ $grow, $selected, $selectedLabelOnly }) => !$grow ? "" : !$selectedLabelOnly ? "grow" : $selected ? "grow" : "grow-2"}
  ${({ $selected, disabled }) => $selected ? disabled ? "bg-gray-400 text-white border-gray-400 cursor-not-allowed focus:ring-0 focus:border-gray-400" : "bg-primary-500 text-white border-primary-500 hover:bg-primary-700" : disabled ? "bg-gray-300 text-gray-400 border-gray-300 cursor-not-allowed focus:ring-0 focus:border-gray-300" : "bg-white text-gray-400 border-gray-300 hover:bg-gray-50"}
`;
var StyledIcon = import_dist.default.div`
  -ml-0.5
  mr-2
  ${({ $selected, disabled }) => $selected ? "text-white" : disabled ? "text-gray-400" : "text-gray-400"}
`;
//#endregion
//#region src/components/button-group/ButtonGroupOptionButton.tsx
var ButtonGroupOptionButton = ({ children, className, disabled = false, grow = false, id, onClick, option, selected = false, selectedLabelOnly = false }) => {
	const handleOnClick = useCallback(() => {
		if (selected) return;
		onClick(option);
	}, [
		onClick,
		option,
		selected
	]);
	return /* @__PURE__ */ React.createElement(StyledOptionButton, {
		onClick: handleOnClick,
		"aria-pressed": selected,
		disabled,
		$grow: grow,
		$selected: selected,
		$selectedLabelOnly: selectedLabelOnly,
		className: (0, import_classnames.default)("button-group-option", className),
		id
	}, children);
};
var ButtonGroupOptionButtonMemo = memo(ButtonGroupOptionButton);
//#endregion
//#region src/components/button-group/ButtonGroup.tsx
var createButtonGroupComponent = (isMemo) => function ButtonGroupComponent({ className, disabled = false, errorText, id, onClick, options, optionsGrow = false, selectedLabelOnly = false, value }) {
	const ButtonGroupOptionComponent = isMemo ? ButtonGroupOptionButtonMemo : ButtonGroupOptionButton;
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledGroup, { className }, options.map((option) => {
		const { icon, label, tooltip, value: optionValue } = option;
		const actualLabel = !selectedLabelOnly || selectedLabelOnly && value === optionValue ? label : "";
		const buttonContents = actualLabel ? /* @__PURE__ */ React.createElement(StyledGroupOptionContent, null, icon && /* @__PURE__ */ React.createElement(StyledIcon, {
			$selected: optionValue === value,
			$disabled: disabled,
			"aria-hidden": "true"
		}, icon), actualLabel) : /* @__PURE__ */ React.createElement("div", { "aria-hidden": "true" }, icon);
		return /* @__PURE__ */ React.createElement(ButtonGroupOptionComponent, {
			key: optionValue,
			option: optionValue,
			selected: optionValue === value,
			disabled: disabled || !!option.disabled,
			grow: optionsGrow,
			selectedLabelOnly,
			onClick,
			className: (0, import_classnames.default)(!actualLabel && "px-2"),
			id: `${id}-${optionValue}`
		}, tooltip ? /* @__PURE__ */ React.createElement(Tooltip, {
			text: tooltip,
			options: { showArrow: true },
			anchorClassName: "cursor-unset"
		}, buttonContents) : buttonContents);
	})), /* @__PURE__ */ React.createElement(GeneralFormError, {
		error: !!errorText,
		id: `${id}-error`
	}, errorText));
};
var ButtonGroup = createButtonGroupComponent(false);
var ButtonGroupMemo = memo(createButtonGroupComponent(true));
ButtonGroupMemo.displayName = "ButtonGroupMemo";
//#endregion
//#region src/components/molecules/controlled-button-group/ControlledButtonGroup.tsx
var ControlledButtonGroup = ({ className, control, errorText, helpText, horizontal = false, id, label, name, rules, ...buttonGroupProps }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { onChange, ref: _ref, value, ...rest }, fieldState: { error } }) => {
		const errorMsg = errorText || error?.message;
		return /* @__PURE__ */ React.createElement(InputFormContainer, {
			inputId: id,
			label,
			helpText,
			withError: !!errorMsg,
			horizontal,
			className
		}, /* @__PURE__ */ React.createElement(ButtonGroup, {
			...rest,
			...buttonGroupProps,
			id,
			value,
			onClick: (value) => onChange(value),
			errorText: errorMsg
		}));
	}
});
//#endregion
//#region src/components/molecules/controlled-checkbox/ControlledCheckbox.tsx
var ControlledCheckbox = ({ className, control, id, label, name, rules, ...checkboxProps }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, value, ...rest } }) => /* @__PURE__ */ React.createElement(Checkbox, {
		...rest,
		...checkboxProps,
		id,
		title: label,
		checked: value,
		className
	})
});
//#endregion
//#region src/components/molecules/controlled-input/ControlledInput.tsx
var ControlledInput = ({ border, className, control, errorText, helpText, horizontal = false, id, label, name, rules, ...inputProps }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, ...rest }, fieldState: { error } }) => {
		const errorMsg = errorText || error?.message;
		return /* @__PURE__ */ React.createElement(InputFormContainer, {
			inputId: id,
			label,
			helpText,
			withError: !!errorMsg,
			horizontal,
			className,
			border
		}, /* @__PURE__ */ React.createElement(Input, {
			...rest,
			...inputProps,
			id,
			error: !!errorMsg,
			errorText: errorMsg
		}));
	}
});
//#endregion
//#region src/components/molecules/controlled-month-date-picker/ControlledMonthDatePicker.tsx
var ControlledMonthDatePicker = ({ control, monthAutoFocus, monthDateAutoFocus, monthDateDisabled, monthDateForm, monthDateHelpText, monthDateId, monthDateLabel, monthDateName, monthDatePlaceholder, monthDateRequired, monthDateRules, monthDateSize, monthDisabled, monthForm, monthHelpText, monthId, monthLabel, monthName, monthPlaceholder, monthRequired, monthRules, monthSize, ...props }) => {
	const monthDateSubscriberRef = useRef(() => {});
	const [month, setMonth] = React.useState("");
	const monthDateOptions = useMonthDateOptions(month);
	return /* @__PURE__ */ React.createElement(Stack, {
		direction: "row",
		space: 11,
		...props
	}, /* @__PURE__ */ React.createElement(Controller, {
		control,
		name: monthName,
		rules: monthRules,
		render: ({ field: { ref: _ref, ...rest }, fieldState: { error } }) => {
			const errorMsg = error?.message;
			const handleChangeMonth = (month) => {
				rest.onChange(month);
				setMonth(month);
				monthDateSubscriberRef.current("");
			};
			return /* @__PURE__ */ React.createElement(InputFormContainer, {
				inputId: monthId,
				label: monthLabel,
				helpText: monthHelpText,
				withError: !!errorMsg,
				horizontal: false
			}, /* @__PURE__ */ React.createElement(Select, {
				...rest,
				id: monthId,
				autoFocus: monthAutoFocus,
				error: !!errorMsg,
				errorText: errorMsg,
				disabled: monthDisabled,
				form: monthForm,
				placeholder: monthPlaceholder,
				required: monthRequired,
				size: monthSize,
				onChange: handleChangeMonth,
				options: monthOptions
			}));
		}
	}), /* @__PURE__ */ React.createElement(Controller, {
		control,
		name: monthDateName,
		rules: monthDateRules,
		render: ({ field: { ref: _ref, ...rest }, fieldState: { error } }) => {
			const errorMsg = error?.message;
			monthDateSubscriberRef.current = rest.onChange;
			return /* @__PURE__ */ React.createElement(InputFormContainer, {
				inputId: monthDateId,
				label: monthDateLabel,
				helpText: monthDateHelpText,
				withError: !!errorMsg,
				horizontal: false
			}, /* @__PURE__ */ React.createElement(Select, {
				...rest,
				id: monthDateId,
				autoFocus: monthDateAutoFocus,
				error: !!errorMsg,
				errorText: errorMsg,
				disabled: monthDateDisabled,
				form: monthDateForm,
				placeholder: monthDatePlaceholder,
				required: monthDateRequired,
				size: monthDateSize,
				options: monthDateOptions
			}));
		}
	}));
};
//#endregion
//#region src/components/molecules/month-picker/MonthPicker.tsx
var MonthPicker = ({ autoFocus, className, disabled, error, errorText, form, helpText, horizontal, id, label, monthOptions: monthOptions$1, name, onChange, placeholder, required, size, usePortal, value, ...props }) => {
	const handleChange = (month) => {
		onChange?.(month);
	};
	return /* @__PURE__ */ React.createElement(InputFormContainer, {
		inputId: id,
		label,
		helpText,
		horizontal,
		withError: error,
		className
	}, /* @__PURE__ */ React.createElement(Select, {
		id,
		autoFocus,
		disabled,
		error,
		errorText,
		form,
		name,
		placeholder,
		required,
		size,
		value,
		onChange: handleChange,
		options: monthOptions$1 ?? monthOptions,
		usePortal,
		...props
	}));
};
//#endregion
//#region src/components/molecules/controlled-month-picker/ControlledMonthPicker.tsx
var ControlledMonthPicker = ({ control, name, rules, ...props }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, ...rest } }) => {
		const handleChange = (month) => {
			rest.onChange(month);
		};
		return /* @__PURE__ */ React.createElement(MonthPicker, {
			...props,
			...rest,
			onChange: handleChange
		});
	}
});
//#endregion
//#region src/components/molecules/radio-group-cards/radio-group-cards.styled.ts
var RadioGroupOptionWrapper = import_dist.default.div`
  -space-y-px rounded-md bg-white
`;
function radioGroupOptionsClassNames(optionIdx, optionsLength, checked) {
	return (0, import_classnames.default)(optionIdx === 0 ? "rounded-tl-md rounded-tr-md" : "", optionIdx === optionsLength - 1 ? "rounded-bl-md rounded-br-md" : "", checked ? "z-10 border-primary-600 bg-primary-50" : "border-gray-200", "relative flex cursor-pointer border p-4 focus:outline-none");
}
var RadioGroupSpan = import_dist.default.span`
  ${({ $checked }) => $checked ? "bg-primary-600 border-transparent" : "bg-white border-gray-300"}
  ${({ $active }) => $active ? "ring-2 ring-offset-2 ring-primary-600" : ""}
  mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded-full border flex items-center justify-center
`;
var RadioCircle = import_dist.default.span`
  rounded-full bg-white w-1.5 h-1.5
`;
var RadioGroupLabelWrapper = import_dist.default.span`
  ml-3 flex flex-col
`;
var RadioGroupLabel = (0, import_dist.default)(je.Label)`
  ${({ $checked }) => $checked ? "text-primary-900" : "text-gray-900"}
  block text-sm font-medium
`;
var RadioGroupDescription = (0, import_dist.default)(je.Description)`
  ${({ $checked }) => $checked ? "text-primary-700" : "text-gray-500"}
  block text-sm
`;
//#endregion
//#region src/components/molecules/radio-group-cards/RadioGroupCards.tsx
var RadioGroupCards = ({ helpText, horizontal = false, id, label, onChange, options, value }) => /* @__PURE__ */ React.createElement(InputFormContainer, {
	inputId: id,
	label,
	helpText,
	horizontal
}, /* @__PURE__ */ React.createElement(je, {
	value,
	onChange
}, /* @__PURE__ */ React.createElement(je.Label, { className: "sr-only" }, label), /* @__PURE__ */ React.createElement(RadioGroupOptionWrapper, null, options.map((option, optionIdx) => /* @__PURE__ */ React.createElement(je.Option, {
	key: option.label,
	value: option.value,
	className: ({ checked }) => radioGroupOptionsClassNames(optionIdx, options.length, checked)
}, ({ active, checked }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RadioGroupSpan, {
	$checked: checked,
	$active: active,
	"aria-hidden": "true"
}, /* @__PURE__ */ React.createElement(RadioCircle, null)), /* @__PURE__ */ React.createElement(RadioGroupLabelWrapper, null, /* @__PURE__ */ React.createElement(RadioGroupLabel, {
	as: "span",
	$checked: checked
}, option.label), /* @__PURE__ */ React.createElement(RadioGroupDescription, {
	as: "span",
	$checked: checked
}, option.description))))))));
//#endregion
//#region src/components/molecules/controlled-radio-group/ControlledRadioGroup.tsx
var ControlledRadioGroup = (params) => {
	const { control, name, rules } = params;
	return /* @__PURE__ */ React.createElement(Controller, {
		control,
		name,
		rules,
		render: ({ field: { ref: _ref, ...rest } }) => /* @__PURE__ */ React.createElement(RadioGroupCards, {
			...params,
			value: rest.value,
			onChange: rest.onChange
		})
	});
};
//#endregion
//#region src/components/molecules/controlled-tag-input/ControlledTagInput.tsx
var ControlledTagInput = ({ className, control, errorText, helpText, horizontal = false, id, label, name, rules, ...props }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { onChange, value }, fieldState: { error } }) => {
		const errorMsg = errorText || error?.message;
		return /* @__PURE__ */ React.createElement(InputFormContainer, {
			inputId: id,
			label,
			helpText,
			withError: !!errorMsg,
			horizontal,
			className
		}, /* @__PURE__ */ React.createElement(TagInput, {
			id,
			error: !!errorMsg,
			errorText: errorMsg,
			tags: value,
			setTags: onChange,
			...props
		}));
	}
});
//#endregion
//#region src/components/molecules/controlled-select/ControlledSelect.tsx
var ControlledSelect = ({ className, control, helpText, horizontal = false, id, label, name, rules, ...selectProps }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, ...rest }, fieldState: { error } }) => {
		const errorMsg = error?.message;
		return /* @__PURE__ */ React.createElement(InputFormContainer, {
			inputId: id,
			label,
			helpText,
			withError: !!errorMsg,
			horizontal,
			className
		}, /* @__PURE__ */ React.createElement(Select, {
			...rest,
			...selectProps,
			id
		}));
	}
});
//#endregion
//#region src/components/molecules/controlled-text-area/ControlledTextArea.tsx
var ControlledTextArea = ({ control, errorText, id, name, rules, type = "text", ...textAreaProps }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, ...rest }, fieldState: { error } }) => {
		const errorMsg = errorText || error?.message;
		return /* @__PURE__ */ React.createElement(TextArea, {
			...rest,
			...textAreaProps,
			id,
			type,
			error: !!errorMsg,
			errorText: errorMsg
		});
	}
});
//#endregion
//#region src/components/molecules/controlled-toggle-switch/ControlledToggleSwitch.tsx
var ControlledToggleSwitch = ({ className, control, id, name, rules, ...toggleSwitchProps }) => /* @__PURE__ */ React.createElement(Controller, {
	control,
	name,
	rules,
	render: ({ field: { ref: _ref, value, ...rest } }) => /* @__PURE__ */ React.createElement(ToggleSwitch, {
		...rest,
		...toggleSwitchProps,
		id,
		checked: value,
		className
	})
});
//#endregion
//#region src/assets/icons/add.svg
var SvgAdd = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M0 12C0 12.3978 0.158035 12.7794 0.43934 13.0607C0.720644 13.342 1.10218 13.5 1.5 13.5H10.25C10.3163 13.5 10.3799 13.5263 10.4268 13.5732C10.4737 13.6201 10.5 13.6837 10.5 13.75V22.5C10.5 22.8978 10.658 23.2794 10.9393 23.5607C11.2206 23.842 11.6022 24 12 24C12.3978 24 12.7794 23.842 13.0607 23.5607C13.342 23.2794 13.5 22.8978 13.5 22.5V13.75C13.5 13.6837 13.5263 13.6201 13.5732 13.5732C13.6201 13.5263 13.6837 13.5 13.75 13.5H22.5C22.8978 13.5 23.2794 13.342 23.5607 13.0607C23.842 12.7794 24 12.3978 24 12C24 11.6022 23.842 11.2206 23.5607 10.9393C23.2794 10.658 22.8978 10.5 22.5 10.5H13.75C13.6837 10.5 13.6201 10.4737 13.5732 10.4268C13.5263 10.3799 13.5 10.3163 13.5 10.25V1.5C13.5 1.10218 13.342 0.720644 13.0607 0.43934C12.7794 0.158035 12.3978 0 12 0C11.6022 0 11.2206 0.158035 10.9393 0.43934C10.658 0.720644 10.5 1.10218 10.5 1.5V10.25C10.5 10.3163 10.4737 10.3799 10.4268 10.4268C10.3799 10.4737 10.3163 10.5 10.25 10.5H1.5C1.10218 10.5 0.720644 10.658 0.43934 10.9393C0.158035 11.2206 0 11.6022 0 12Z",
		fill: "currentColor"
	})
});
var ForwardRef$21 = forwardRef(SvgAdd);
var Memo$21 = memo(ForwardRef$21);
//#endregion
//#region src/assets/icons/mark-arrows-right.svg
var SvgMarkArrowsRight = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 32 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28.9485 13.4456L2.51226 13.4456C1.83693 13.4187 1.19818 13.1314 0.729871 12.6442C0.261557 12.1569 0 11.5071 0 10.8313C0 10.1554 0.261557 9.50572 0.729871 9.01842C1.19818 8.53113 1.83693 8.2439 2.51226 8.21702L22.7679 8.21702L17.3862 4.35052C17.2115 4.21254 17.0629 4.04421 16.9475 3.85375C16.7709 3.57394 16.6527 3.26137 16.5997 2.93471C16.5783 2.79788 16.5672 2.65938 16.5667 2.52076C16.5677 2.3285 16.59 2.13701 16.6328 1.94949C16.7139 1.62693 16.8543 1.32229 17.0468 1.05119C17.2437 0.782389 17.4912 0.55455 17.7754 0.380598C18.0563 0.203318 18.3704 0.0849182 18.6986 0.0328222C19.0261 -0.0201698 19.3606 -0.00890643 19.6838 0.0659736C19.9533 0.141366 20.208 0.261685 20.4373 0.421941L30.7493 7.94386C31.2689 8.32249 31.6552 8.85599 31.8528 9.46783C32.0503 10.0797 32.049 10.7384 31.8491 11.3493C31.649 11.9604 31.2607 12.4923 30.7396 12.8689C30.2185 13.2455 29.5914 13.4474 28.9485 13.4456ZM28.9651 15.9961L2.52876 15.9961H2.52057C1.84524 16.023 1.20652 16.3102 0.738171 16.7975C0.269819 17.2848 0.00831498 17.9345 0.00831495 18.6103C0.00831493 19.2862 0.269818 19.9359 0.73817 20.4232C1.20652 20.9105 1.84524 21.1977 2.52057 21.2246L22.7679 21.2246L17.3862 25.0911C17.2115 25.2292 17.0629 25.3974 16.9475 25.5878C16.7709 25.8677 16.6527 26.1802 16.5997 26.5069C16.5783 26.6438 16.5672 26.7822 16.5667 26.9208C16.5677 27.1131 16.5899 27.3047 16.6328 27.4921C16.7139 27.8147 16.8543 28.1193 17.0468 28.3904C17.2436 28.6593 17.4912 28.8871 17.7755 29.061C18.0564 29.2383 18.3704 29.3567 18.6986 29.4088C19.026 29.4619 19.3607 29.4506 19.6838 29.3756C19.9532 29.3002 20.208 29.1799 20.4373 29.0197L30.7493 21.4978C31.2678 21.12 31.6535 20.588 31.8515 19.9778C32.0495 19.3675 32.0495 18.7104 31.8516 18.1002C31.6537 17.4899 31.268 16.9579 30.7496 16.58C30.2312 16.2021 29.6066 15.9977 28.9651 15.9961Z",
		fill: "currentColor"
	})
});
var ForwardRef$20 = forwardRef(SvgMarkArrowsRight);
var Memo$20 = memo(ForwardRef$20);
//#endregion
//#region src/assets/icons/subtract.svg
var SvgSubtract = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M1.5,13.5h21a1.5,1.5,0,0,0,0-3H1.5a1.5,1.5,0,0,0,0,3Z",
		fill: "currentColor"
	})
});
var ForwardRef$19 = forwardRef(SvgSubtract);
var Memo$19 = memo(ForwardRef$19);
//#endregion
//#region src/components/molecules/equation-operator/equation-operator.styled.ts
var StyledEquationOperatorContainer = (0, import_dist.default)(Stack)`
  bg-gray-50
  h-12
  w-12
  rounded-md
  p-3
`;
//#endregion
//#region src/components/molecules/equation-operator/EquationOperator.tsx
var icons = {
	addition: /* @__PURE__ */ React.createElement(Memo$21, {
		className: "w-6 text-gray-500",
		"data-testid": "addition-icon"
	}),
	equalsTo: /* @__PURE__ */ React.createElement(Memo$20, {
		className: "w-6 text-gray-500",
		"data-testid": "equalsTo-icon"
	}),
	subtraction: /* @__PURE__ */ React.createElement(Memo$19, {
		className: "w-6 text-gray-500",
		"data-testid": "subtraction-icon"
	})
};
var EquationOperator = ({ className, type }) => /* @__PURE__ */ React.createElement(StyledEquationOperatorContainer, {
	className,
	alignItems: "center",
	direction: "row",
	justifyContent: "center"
}, icons[type]);
var EquationOperatorMemo = memo(EquationOperator);
//#endregion
//#region src/components/molecules/equation-term/equation-term.styled.ts
var termColorVariant = {
	"nols-step-1": "text-gray-800",
	"nols-step-2": "text-gray-700",
	"nols-step-3": "text-gray-600",
	"nols-step-4": "text-gray-500",
	"nols-step-5": "text-gray-400",
	"nols-step-6": "text-gray-300",
	"nols-step-7": "text-gray-200",
	"nols-step-8": "text-gray-100",
	"income-step-1": "text-blue-800",
	"income-step-2": "text-blue-700",
	"income-step-3": "text-blue-600",
	"income-step-4": "text-blue-500",
	"income-step-5": "text-blue-400",
	"income-step-6": "text-blue-300",
	"income-step-7": "text-blue-200",
	"income-step-8": "text-blue-100",
	"expenses-step-1": "text-rsbry-800",
	"expenses-step-2": "text-rsbry-700",
	"expenses-step-3": "text-rsbry-600",
	"expenses-step-4": "text-rsbry-500",
	"expenses-step-5": "text-rsbry-400",
	"expenses-step-6": "text-rsbry-300",
	"expenses-step-7": "text-rsbry-200",
	"expenses-step-8": "text-rsbry-100",
	"calculations-step-1": "text-lemon-800",
	"calculations-step-2": "text-lemon-700",
	"calculations-step-3": "text-lemon-600",
	"calculations-step-4": "text-lemon-500",
	"calculations-step-5": "text-lemon-400",
	"calculations-step-6": "text-lemon-300",
	"calculations-step-7": "text-lemon-200",
	"calculations-step-8": "text-lemon-100",
	"outcomes-step-1": "text-lime-800",
	"outcomes-step-2": "text-lime-700",
	"outcomes-step-3": "text-lime-600",
	"outcomes-step-4": "text-lime-500",
	"outcomes-step-5": "text-lime-400",
	"outcomes-step-6": "text-lime-300",
	"outcomes-step-7": "text-lime-200",
	"outcomes-step-8": "text-lime-100"
};
var StyledText$1 = (0, import_dist.default)(Typography)`
  text-left
  ${({ $variant }) => termColorVariant[$variant]}
`;
var StyledStack$2 = (0, import_dist.default)(Stack)`
  max-w-[162px]
`;
//#endregion
//#region src/components/molecules/equation-term/EquationTerm.tsx
var EquationTerm = ({ className, description, step, title, value, variant }) => {
	const termVariant = `${variant}-${step}`;
	return /* @__PURE__ */ React.createElement(StyledStack$2, {
		className,
		direction: "column",
		alignItems: "start"
	}, /* @__PURE__ */ React.createElement(Tooltip, {
		className: "max-w-[160px] !z-modal",
		text: description,
		options: {
			placement: "top",
			showArrow: true
		}
	}, /* @__PURE__ */ React.createElement(StyledText$1, {
		$variant: termVariant,
		as: "p",
		fontSize: "xs",
		fontWeight: "normal"
	}, title), /* @__PURE__ */ React.createElement(StyledText$1, {
		$variant: termVariant,
		as: "p",
		fontSize: "xs",
		fontWeight: "bold"
	}, value)));
};
var EquationTermMemo = memo(EquationTerm);
//#endregion
//#region src/components/molecules/feed-item/feed-item.styled.ts
var FeedItemContainer = (0, import_dist.default)(Stack)`
  space-x-3
`;
var IconContainer$1 = import_dist.default.div`
  h-6
  w-6
  rounded-full
  text-gray-400
`;
var ContentContainer = import_dist.default.div`
  flex-1
  space-y-1
`;
var GrayTypography = (0, import_dist.default)(Typography)`
  text-gray-400
`;
//#endregion
//#region src/components/molecules/feed-item/FeedItem.tsx
var FeedItem = ({ className, description, icon, id, subtitle, supportText, title }) => /* @__PURE__ */ React.createElement(FeedItemContainer, {
	id,
	className
}, /* @__PURE__ */ React.createElement(IconContainer$1, null, icon), /* @__PURE__ */ React.createElement(ContentContainer, null, /* @__PURE__ */ React.createElement(Stack, { justifyContent: "space-between" }, /* @__PURE__ */ React.createElement(Stack, {
	direction: "column",
	alignItems: "start"
}, /* @__PURE__ */ React.createElement(Typography, {
	as: "h3",
	fontSize: "sm",
	lineHeight: 5,
	fontWeight: "medium"
}, title), /* @__PURE__ */ React.createElement(GrayTypography, {
	as: "p",
	fontSize: "sm"
}, description)), /* @__PURE__ */ React.createElement(Stack, {
	direction: "column",
	alignItems: "end"
}, /* @__PURE__ */ React.createElement(GrayTypography, {
	as: "p",
	fontSize: "sm"
}, subtitle), /* @__PURE__ */ React.createElement(GrayTypography, {
	as: "p",
	fontSize: "sm"
}, supportText)))));
//#endregion
//#region src/assets/icons/error-circle.svg
var SvgErrorCircle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289Z",
		fill: "currentColor"
	})
});
var ForwardRef$18 = forwardRef(SvgErrorCircle);
var Memo$18 = memo(ForwardRef$18);
//#endregion
//#region src/assets/icons/info-circle.svg
var SvgInfoCircle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z",
		fill: "currentColor"
	})
});
var ForwardRef$17 = forwardRef(SvgInfoCircle);
var Memo$17 = memo(ForwardRef$17);
//#endregion
//#region src/assets/icons/success-circle.svg
var SvgSuccessCircle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.58579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z",
		fill: "currentColor"
	})
});
var ForwardRef$16 = forwardRef(SvgSuccessCircle);
var Memo$16 = memo(ForwardRef$16);
//#endregion
//#region src/assets/icons/warning-triangle.svg
var SvgWarningTriangle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.25694 1.09882C7.02154 -0.26048 8.97863 -0.260481 9.74324 1.09882L15.3235 11.0194C16.0735 12.3526 15.11 13.9999 13.5804 13.9999H2.41978C0.890129 13.9999 -0.073299 12.3526 0.676631 11.0194L6.25694 1.09882ZM9 11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55229 10 9 10.4477 9 11ZM8 3C7.44772 3 7 3.44772 7 4V7C7 7.55228 7.44772 8 8 8C8.55228 8 9 7.55228 9 7V4C9 3.44772 8.55228 3 8 3Z",
		fill: "currentColor"
	})
});
var ForwardRef$15 = forwardRef(SvgWarningTriangle);
var Memo$15 = memo(ForwardRef$15);
//#endregion
//#region src/components/alert/alert.styled.ts
var getAlertStyle = (severity) => {
	switch (severity) {
		case "neutral": return "bg-gray-50 text-gray-400";
		case "warning": return "bg-lemon-50 text-lemon-700";
		case "success": return "bg-green-50 text-green-700";
		case "info": return "bg-blue-50 text-blue-700";
		default: return "bg-rsbry-50 text-rsbry-700";
	}
};
var getAlertHeaderTextColor = (severity) => {
	switch (severity) {
		case "neutral": return "text-gray-400";
		case "warning": return "text-lemon-800";
		case "success": return "text-green-800";
		case "info": return "text-blue-800";
		default: return "text-rsbry-800";
	}
};
var getTextSizeClass = (size = "sm") => {
	switch (size) {
		case "xs": return "text-xs";
		case "sm": return "text-sm";
		case "base": return "text-base";
		case "lg": return "text-lg";
		case "xl": return "text-xl";
		default: return "text-sm";
	}
};
var StyledAlert = (0, import_dist.default)(Stack)`
    ${({ $severity }) => getAlertStyle($severity)}
    rounded-md
    p-4
`;
var StyledAlertHeader = import_dist.default.h3`
  ${({ $size }) => getTextSizeClass($size)}
  font-medium
  text-inherit
  ${({ $severity }) => getAlertHeaderTextColor($severity)}
`;
var StyledAlertSubHeader = import_dist.default.div`
  ${({ $size }) => getTextSizeClass($size)}
  text-inherit
`;
//#endregion
//#region src/components/alert/Alert.tsx
var getIcon = (severity, icon) => {
	if (icon) return icon;
	switch (severity) {
		case "neutral": return /* @__PURE__ */ React.createElement(Memo$17, {
			"data-testid": "warning-triangle-icon",
			className: "text-gray-400",
			"aria-hidden": "true"
		});
		case "warning": return /* @__PURE__ */ React.createElement(Memo$15, {
			"data-testid": "warning-triangle-icon",
			className: "text-lemon-700",
			"aria-hidden": "true"
		});
		case "success": return /* @__PURE__ */ React.createElement(Memo$16, {
			"data-testid": "success-circle-icon",
			className: "text-green-700",
			"aria-hidden": "true"
		});
		case "info": return /* @__PURE__ */ React.createElement(Memo$17, {
			"data-testid": "info-circle-icon",
			className: "text-blue-700",
			"aria-hidden": "true"
		});
		default: return /* @__PURE__ */ React.createElement(Memo$18, {
			"data-testid": "error-circle-icon",
			className: "text-rsbry-700",
			"aria-hidden": "true"
		});
	}
};
var Alert = ({ actions = [], className, icon, severity, subtitle, subtitleSize, title, titleSize, id }) => /* @__PURE__ */ React.createElement(StyledAlert, {
	$severity: severity,
	className,
	id,
	gap: 4,
	alignItems: (!subtitle || !title) && actions.length === 0 && "center"
}, /* @__PURE__ */ React.createElement(Icon, {
	node: getIcon(severity, icon),
	nodeSize: 4.5,
	size: 6,
	className: "flex-shrink-0",
	"aria-hidden": "true"
}), /* @__PURE__ */ React.createElement("div", { className: "flex flex-col space-y-1 w-full" }, title && /* @__PURE__ */ React.createElement(StyledAlertHeader, {
	$severity: severity,
	$size: titleSize
}, title), subtitle && /* @__PURE__ */ React.createElement(StyledAlertSubHeader, { $size: subtitleSize }, typeof subtitle === "string" ? /* @__PURE__ */ React.createElement("p", null, subtitle) : subtitle), actions.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "flex space-x-2" }, actions.map(({ label, ...props }) => /* @__PURE__ */ React.createElement(Button, {
	key: label,
	size: "sm",
	variant: severity === "none" || severity === "neutral" ? "info" : severity,
	rounded: "regular",
	className: "m-0",
	...props
}, label)))));
var AlertMemo = memo(Alert);
//#endregion
//#region src/components/molecules/form-items/form-button/form-button.styled.ts
var StyledFormButtonWrapper = import_dist.default.div`
  w-full
  max-w-7xl
  py-6
`;
var StyledFormButtonGrid = import_dist.default.div`
  lg:grid
  lg:grid-cols-3
  lg:gap-6
`;
var StyledFormButtonLeftColumn = import_dist.default.div`
  lg:col-span-1
`;
var StyledFormButtonRightColumn = import_dist.default.div`
  flex
  flex-col
  mt-5
  lg:mt-0
  lg:col-span-2
`;
var StyledFormButtonAlertCard = import_dist.default.div`
  shadow
  sm:rounded-md
  sm:overflow-hidden
`;
var StyledFormButtonContainer = import_dist.default.div`
  my-3
  self-end
`;
//#endregion
//#region src/components/molecules/form-items/form-button/FormButton.tsx
var FormButton = ({ alert, className, ...props }) => /* @__PURE__ */ React.createElement(StyledFormButtonWrapper, { className }, /* @__PURE__ */ React.createElement(StyledFormButtonGrid, null, /* @__PURE__ */ React.createElement(StyledFormButtonLeftColumn, null), /* @__PURE__ */ React.createElement(StyledFormButtonRightColumn, null, /* @__PURE__ */ React.createElement(StyledFormButtonAlertCard, null, !!alert && /* @__PURE__ */ React.createElement(Alert, alert)), /* @__PURE__ */ React.createElement(StyledFormButtonContainer, null, /* @__PURE__ */ React.createElement(Button, {
	className: "py-3",
	...props
})))));
//#endregion
//#region src/components/molecules/form-items/form-title/form-title.styled.ts
var IconContainer = import_dist.default.div`
  w-6
  h-6
  flex
  items-center
  justify-center
  text-gray-500
`;
//#endregion
//#region src/components/molecules/form-items/form-title/FormTitle.tsx
var FormTitle = ({ className, icon, subtitle, title }) => /* @__PURE__ */ React.createElement(Stack, {
	direction: "column",
	space: 1,
	className
}, /* @__PURE__ */ React.createElement(Stack, {
	alignItems: "center",
	space: 2.5
}, !!icon && /* @__PURE__ */ React.createElement(IconContainer, null, icon), /* @__PURE__ */ React.createElement(Typography, {
	as: "h3",
	fontSize: "lg",
	fontWeight: "medium",
	lineHeight: 6,
	color: colors.gray[900]
}, title)), subtitle && /* @__PURE__ */ React.createElement(Typography, {
	as: "p",
	fontSize: "sm",
	color: colors.gray[500],
	lineHeight: 5
}, subtitle));
var FormTitleMemo = memo(FormTitle);
//#endregion
//#region src/components/molecules/progress/Progress.tsx
var colorVariant = (completed, total) => {
	if (completed === 0) return "red";
	if (completed < total) return "yellow";
	return "green";
};
var createProgressComponent = (isMemo) => function Progress({ className, completed, total }) {
	const BadgeComponent = isMemo ? BadgeMemo : Badge;
	const stepsCompleted = completed === total;
	return /* @__PURE__ */ React.createElement(BadgeComponent, {
		colorVariant: colorVariant(completed, total),
		icon: stepsCompleted ? /* @__PURE__ */ React.createElement(Memo$27, { style: { color: colors.green[400] } }) : void 0,
		className
	}, completed, "/", total, " Complete");
};
var Progress = createProgressComponent(false);
var ProgressMemo = memo(createProgressComponent(true));
ProgressMemo.displayName = "ProgressMemo";
//#endregion
//#region src/components/molecules/form-items/form-sticky-header/form-sticky-header.styled.ts
var StyledTwoColumnLayoutStickyHeader = import_dist.default.div`
  sticky
  top-0
`;
//#endregion
//#region src/components/molecules/form-items/form-sticky-header/FormStickyHeader.tsx
var createFormStickyHeader = (isMemo) => function FormStickyHeader({ children, icon, progress, subtitle, title }) {
	const FormTitleComponent = isMemo ? FormTitleMemo : FormTitle;
	return /* @__PURE__ */ React.createElement(StyledTwoColumnLayoutStickyHeader, null, /* @__PURE__ */ React.createElement(FormTitleComponent, {
		title,
		subtitle,
		icon
	}), !children && progress && /* @__PURE__ */ React.createElement(Progress, {
		total: progress.total,
		completed: progress.completed
	}), children);
};
var FormStickyHeader = createFormStickyHeader(false);
var FormStickyHeaderMemo = memo(createFormStickyHeader(true));
FormStickyHeaderMemo.displayName = "FormStickyHeaderMemo";
//#endregion
//#region ../../node_modules/react-table/dist/react-table.production.min.js
var require_react_table_production_min = /* @__PURE__ */ __commonJSMin(((exports, module, this$3) => {
	(function(e, t) {
		"object" == typeof exports && "undefined" != typeof module ? t(exports, require_builtin_esm_external_require_react()) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = e || self).ReactTable = {}, e.React);
	})(this$3, (function(e, t) {
		"use strict";
		function n(e, t, n, o, r, i, u) {
			try {
				var l = e[i](u), s = l.value;
			} catch (e) {
				n(e);
				return;
			}
			l.done ? t(s) : Promise.resolve(s).then(o, r);
		}
		function o(e) {
			return function() {
				var t = this, o = arguments;
				return new Promise((function(r, i) {
					var u = e.apply(t, o);
					function l(e) {
						n(u, r, i, l, s, "next", e);
					}
					function s(e) {
						n(u, r, i, l, s, "throw", e);
					}
					l(void 0);
				}));
			};
		}
		function r() {
			return (r = Object.assign || function(e) {
				for (var t = 1; t < arguments.length; t++) {
					var n = arguments[t];
					for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
				}
				return e;
			}).apply(this, arguments);
		}
		function i(e, t) {
			if (null == e) return {};
			var n, o, r = {}, i = Object.keys(e);
			for (o = 0; o < i.length; o++) n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
			return r;
		}
		function u(e) {
			var t = function(e, t) {
				if ("object" != typeof e || null === e) return e;
				var n = e[Symbol.toPrimitive];
				if (void 0 !== n) {
					var o = n.call(e, t || "default");
					if ("object" != typeof o) return o;
					throw new TypeError("@@toPrimitive must return a primitive value.");
				}
				return ("string" === t ? String : Number)(e);
			}(e, "string");
			return "symbol" == typeof t ? t : String(t);
		}
		t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
		var l = { init: "init" }, s = function(e) {
			var t = e.value;
			return void 0 === t ? "" : t;
		}, a = function() {
			return t.createElement(t.Fragment, null, "\xA0");
		}, c = {
			Cell: s,
			width: 150,
			minWidth: 0,
			maxWidth: Number.MAX_SAFE_INTEGER
		};
		function d() {
			for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
			return t.reduce((function(e, t) {
				var n = t.style, o = t.className;
				return e = r({}, e, {}, i(t, ["style", "className"])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
			}), {});
		}
		var f = function(e, t) {
			return void 0 === t && (t = {}), function(n) {
				return void 0 === n && (n = {}), [].concat(e, [n]).reduce((function(e, o) {
					return function e(t, n, o) {
						return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [t].concat(n)) : d(t, n);
					}(e, o, r({}, t, { userProps: n }));
				}), {});
			};
		}, p = function(e, t, n, o) {
			return void 0 === n && (n = {}), e.reduce((function(e, t) {
				return t(e, n);
			}), t);
		}, g = function(e, t, n) {
			return void 0 === n && (n = {}), e.forEach((function(e) {
				e(t, n);
			}));
		};
		function v(e, t, n, o) {
			e.findIndex((function(e) {
				return e.pluginName === n;
			}));
			t.forEach((function(t) {
				e.findIndex((function(e) {
					return e.pluginName === t;
				}));
			}));
		}
		function m(e, t) {
			return "function" == typeof e ? e(t) : e;
		}
		function h(e) {
			var n = t.useRef();
			return n.current = e, t.useCallback((function() {
				return n.current;
			}), []);
		}
		var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
		function w(e, n) {
			var o = t.useRef(!1);
			y((function() {
				o.current && e(), o.current = !0;
			}), n);
		}
		function R(e, t, n) {
			return void 0 === n && (n = {}), function(o, i) {
				void 0 === i && (i = {});
				var u = "string" == typeof o ? t[o] : o;
				if (void 0 === u) throw console.info(t), /* @__PURE__ */ new Error("Renderer Error ☝️");
				return b(u, r({}, e, { column: t }, n, {}, i));
			};
		}
		function b(e, n) {
			return function(e) {
				return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
				var t;
			}(o = e) || "function" == typeof o || function(e) {
				return "object" == typeof e && "symbol" == typeof e.$$typeof && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
			}(o) ? t.createElement(e, n) : e;
			var o;
		}
		function S(e, t, n) {
			return void 0 === n && (n = 0), e.map((function(e) {
				return x(e = r({}, e, {
					parent: t,
					depth: n
				})), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
			}));
		}
		function C(e) {
			return G(e, "columns");
		}
		function x(e) {
			var t = e.id, n = e.accessor, o = e.Header;
			if ("string" == typeof n) {
				t = t || n;
				var r = n.split(".");
				n = function(e) {
					return function(e, t, n) {
						if (!t) return e;
						var o, r = "function" == typeof t ? t : JSON.stringify(t), i = E.get(r) || function() {
							var e = function(e) {
								return function e(t, n) {
									void 0 === n && (n = []);
									if (Array.isArray(t)) for (var o = 0; o < t.length; o += 1) e(t[o], n);
									else n.push(t);
									return n;
								}(e).map((function(e) {
									return String(e).replace(".", "_");
								})).join(".").replace(T, ".").replace(O, "").split(".");
							}(t);
							return E.set(r, e), e;
						}();
						try {
							o = i.reduce((function(e, t) {
								return e[t];
							}), e);
						} catch (e) {}
						return void 0 !== o ? o : n;
					}(e, r);
				};
			}
			if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), /* @__PURE__ */ new Error("A column ID (or unique \"Header\" value) is required!");
			if (!t) throw console.error(e), /* @__PURE__ */ new Error("A column ID (or string accessor) is required!");
			return Object.assign(e, {
				id: t,
				accessor: n
			}), e;
		}
		function P(e, t) {
			if (!t) throw new Error();
			return Object.assign(e, r({
				Header: a,
				Footer: a
			}, c, {}, t, {}, e)), Object.assign(e, { originalWidth: e.width }), e;
		}
		function B(e, t, n) {
			void 0 === n && (n = function() {
				return {};
			});
			for (var o = [], i = e, u = 0, l = function() {
				return u++;
			}, s = function() {
				var e = { headers: [] }, u = [], s = i.some((function(e) {
					return e.parent;
				}));
				i.forEach((function(o) {
					var i, a = [].concat(u).reverse()[0];
					if (s) {
						if (o.parent) i = r({}, o.parent, {
							originalId: o.parent.id,
							id: o.parent.id + "_" + l(),
							headers: [o]
						}, n(o));
						else i = P(r({
							originalId: o.id + "_placeholder",
							id: o.id + "_placeholder_" + l(),
							placeholderOf: o,
							headers: [o]
						}, n(o)), t);
						a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
					}
					e.headers.push(o);
				})), o.push(e), i = u;
			}; i.length;) s();
			return o.reverse();
		}
		var E = /* @__PURE__ */ new Map();
		function I() {
			for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
			for (var o = 0; o < t.length; o += 1) if (void 0 !== t[o]) return t[o];
		}
		function F(e) {
			if ("function" == typeof e) return e;
		}
		function G(e, t) {
			var n = [];
			return function e(o) {
				o.forEach((function(o) {
					o[t] ? e(o[t]) : n.push(o);
				}));
			}(e), n;
		}
		function A(e, t) {
			var n = t.manualExpandedKey, o = t.expanded, r = t.expandSubRows, i = void 0 === r || r, u = [];
			return e.forEach((function(e) {
				return function e(t, r) {
					void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach((function(t) {
						return e(t, i);
					}));
				}(e);
			})), u;
		}
		function k(e, t, n) {
			return F(e) || t[e] || n[e] || n.text;
		}
		function H(e, t, n) {
			return e ? e(t, n) : void 0 === t;
		}
		function W() {
			throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
		}
		var z = null;
		var T = /\[/g, O = /\]/g;
		var M = function(e) {
			return r({ role: "table" }, e);
		}, j = function(e) {
			return r({ role: "rowgroup" }, e);
		}, L = function(e, t) {
			var n = t.column;
			return r({
				key: "header_" + n.id,
				colSpan: n.totalVisibleHeaderCount,
				role: "columnheader"
			}, e);
		}, N = function(e, t) {
			var n = t.column;
			return r({
				key: "footer_" + n.id,
				colSpan: n.totalVisibleHeaderCount
			}, e);
		}, D = function(e, t) {
			return r({
				key: "headerGroup_" + t.index,
				role: "row"
			}, e);
		}, V = function(e, t) {
			return r({ key: "footerGroup_" + t.index }, e);
		}, _ = function(e, t) {
			return r({
				key: "row_" + t.row.id,
				role: "row"
			}, e);
		}, X = function(e, t) {
			var n = t.cell;
			return r({
				key: "cell_" + n.row.id + "_" + n.column.id,
				role: "cell"
			}, e);
		};
		function q() {
			return {
				useOptions: [],
				stateReducers: [],
				useControlledState: [],
				columns: [],
				columnsDeps: [],
				allColumns: [],
				allColumnsDeps: [],
				accessValue: [],
				materializedColumns: [],
				materializedColumnsDeps: [],
				useInstanceAfterData: [],
				visibleColumns: [],
				visibleColumnsDeps: [],
				headerGroups: [],
				headerGroupsDeps: [],
				useInstanceBeforeDimensions: [],
				useInstance: [],
				prepareRow: [],
				getTableProps: [M],
				getTableBodyProps: [j],
				getHeaderGroupProps: [D],
				getFooterGroupProps: [V],
				getHeaderProps: [L],
				getFooterProps: [N],
				getRowProps: [_],
				getCellProps: [X],
				useFinalInstance: []
			};
		}
		l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
		var K = function(e) {
			e.getToggleHiddenProps = [U], e.getToggleHideAllColumnsProps = [$], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push((function(e, t) {
				var n = t.instance;
				return [].concat(e, [n.state.hiddenColumns]);
			})), e.useInstance.push(Q);
		};
		K.pluginName = "useColumnVisibility";
		var U = function(e, t) {
			var n = t.column;
			return [e, {
				onChange: function(e) {
					n.toggleHidden(!e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: n.isVisible,
				title: "Toggle Column Visible"
			}];
		}, $ = function(e, t) {
			var n = t.instance;
			return [e, {
				onChange: function(e) {
					n.toggleHideAllColumns(!e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
				title: "Toggle All Columns Hidden",
				indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
			}];
		};
		function J(e, t, n, o) {
			if (t.type === l.init) return r({ hiddenColumns: [] }, e);
			if (t.type === l.resetHiddenColumns) return r({}, e, { hiddenColumns: o.initialState.hiddenColumns || [] });
			if (t.type === l.toggleHideColumn) {
				var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [t.columnId]) : e.hiddenColumns.filter((function(e) {
					return e !== t.columnId;
				}));
				return r({}, e, { hiddenColumns: i });
			}
			return t.type === l.setHiddenColumns ? r({}, e, { hiddenColumns: m(t.value, e.hiddenColumns) }) : t.type === l.toggleHideAllColumns ? r({}, e, { hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map((function(e) {
				return e.id;
			})) : [] }) : void 0;
		}
		function Y(e) {
			var n = e.headers, o = e.state.hiddenColumns;
			t.useRef(!1).current;
			var r = 0;
			n.forEach((function(e) {
				return r += function e(t, n) {
					t.isVisible = n && !o.includes(t.id);
					var r = 0;
					return t.headers && t.headers.length ? t.headers.forEach((function(n) {
						return r += e(n, t.isVisible);
					})) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
				}(e, !0);
			}));
		}
		function Q(e) {
			var n = e.columns, o = e.flatHeaders, r = e.dispatch, i = e.allColumns, u = e.getHooks, s = e.state.hiddenColumns, a = e.autoResetHiddenColumns, c = void 0 === a || a, d = h(e), p = i.length === s.length, g = t.useCallback((function(e, t) {
				return r({
					type: l.toggleHideColumn,
					columnId: e,
					value: t
				});
			}), [r]), v = t.useCallback((function(e) {
				return r({
					type: l.setHiddenColumns,
					value: e
				});
			}), [r]), m = t.useCallback((function(e) {
				return r({
					type: l.toggleHideAllColumns,
					value: e
				});
			}), [r]), y = f(u().getToggleHideAllColumnsProps, { instance: d() });
			o.forEach((function(e) {
				e.toggleHidden = function(t) {
					r({
						type: l.toggleHideColumn,
						columnId: e.id,
						value: t
					});
				}, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
					instance: d(),
					column: e
				});
			}));
			var R = h(c);
			w((function() {
				R() && r({ type: l.resetHiddenColumns });
			}), [r, n]), Object.assign(e, {
				allColumnsHidden: p,
				toggleHideColumn: g,
				setHiddenColumns: v,
				toggleHideAllColumns: m,
				getToggleHideAllColumnsProps: y
			});
		}
		var Z = {}, ee = {}, te = function(e, t, n) {
			return e;
		}, ne = function(e, t) {
			return e.subRows || [];
		}, oe = function(e, t, n) {
			return "" + (n ? [n.id, t].join(".") : t);
		}, re = function(e) {
			return e;
		};
		function ie(e) {
			var t = e.initialState, n = void 0 === t ? Z : t, o = e.defaultColumn, u = void 0 === o ? ee : o, l = e.getSubRows, s = void 0 === l ? ne : l, a = e.getRowId, c = void 0 === a ? oe : a, d = e.stateReducer, f = void 0 === d ? te : d, p = e.useControlledState, g = void 0 === p ? re : p;
			return r({}, i(e, [
				"initialState",
				"defaultColumn",
				"getSubRows",
				"getRowId",
				"stateReducer",
				"useControlledState"
			]), {
				initialState: n,
				defaultColumn: u,
				getSubRows: s,
				getRowId: c,
				stateReducer: f,
				useControlledState: g
			});
		}
		function ue(e, t) {
			void 0 === t && (t = 0);
			var n = 0, o = 0, r = 0, i = 0;
			return e.forEach((function(e) {
				var u = e.headers;
				if (e.totalLeft = t, u && u.length) {
					var l = ue(u, t), s = l[0], a = l[1], c = l[2], d = l[3];
					e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
				} else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
				e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
			})), [
				n,
				o,
				r,
				i
			];
		}
		function le(e) {
			var t = e.data, n = e.rows, o = e.flatRows, r = e.rowsById, i = e.column, u = e.getRowId, l = e.getSubRows, s = e.accessValueHooks, a = e.getInstance;
			t.forEach((function(e, c) {
				return function e(n, c, d, f, g) {
					void 0 === d && (d = 0);
					var v = n, m = u(n, c, f), h = r[m];
					if (h) h.subRows && h.originalSubRows.forEach((function(t, n) {
						return e(t, n, d + 1, h);
					}));
					else if ((h = {
						id: m,
						original: v,
						index: c,
						depth: d,
						cells: [{}]
					}).cells.map = W, h.cells.filter = W, h.cells.forEach = W, h.cells[0].getCellProps = W, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
						var y = [];
						h.originalSubRows.forEach((function(t, n) {
							return e(t, n, d + 1, h, y);
						})), h.subRows = y;
					}
					i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
						row: h,
						column: i,
						instance: a()
					});
				}(e, c, 0, void 0, n);
			}));
		}
		l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
		var se = function(e) {
			e.getToggleAllRowsExpandedProps = [ae], e.getToggleRowExpandedProps = [ce], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
		};
		se.pluginName = "useExpanded";
		var ae = function(e, t) {
			var n = t.instance;
			return [e, {
				onClick: function(e) {
					n.toggleAllRowsExpanded();
				},
				style: { cursor: "pointer" },
				title: "Toggle All Rows Expanded"
			}];
		}, ce = function(e, t) {
			var n = t.row;
			return [e, {
				onClick: function() {
					n.toggleRowExpanded();
				},
				style: { cursor: "pointer" },
				title: "Toggle Row Expanded"
			}];
		};
		function de(e, t, n, o) {
			if (t.type === l.init) return r({ expanded: {} }, e);
			if (t.type === l.resetExpanded) return r({}, e, { expanded: o.initialState.expanded || {} });
			if (t.type === l.toggleAllRowsExpanded) {
				var s = t.value, a = o.rowsById, c = Object.keys(a).length === Object.keys(e.expanded).length;
				if (void 0 !== s ? s : !c) {
					var d = {};
					return Object.keys(a).forEach((function(e) {
						d[e] = !0;
					})), r({}, e, { expanded: d });
				}
				return r({}, e, { expanded: {} });
			}
			if (t.type === l.toggleRowExpanded) {
				var f, p = t.id, g = t.value, v = e.expanded[p], m = void 0 !== g ? g : !v;
				if (!v && m) return r({}, e, { expanded: r({}, e.expanded, (f = {}, f[p] = !0, f)) });
				if (v && !m) {
					var h = e.expanded;
					h[p];
					return r({}, e, { expanded: i(h, [p].map(u)) });
				}
				return e;
			}
		}
		function fe(e) {
			var n = e.data, o = e.rows, r = e.rowsById, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.paginateExpandedRows, a = void 0 === s || s, c = e.expandSubRows, d = void 0 === c || c, p = e.autoResetExpanded, g = void 0 === p || p, m = e.getHooks, y = e.plugins, R = e.state.expanded, b = e.dispatch;
			v(y, [
				"useSortBy",
				"useGroupBy",
				"usePivotColumns",
				"useGlobalFilter"
			], "useExpanded");
			var S = h(g), C = Boolean(Object.keys(r).length && Object.keys(R).length);
			C && Object.keys(r).some((function(e) {
				return !R[e];
			})) && (C = !1), w((function() {
				S() && b({ type: l.resetExpanded });
			}), [b, n]);
			var x = t.useCallback((function(e, t) {
				b({
					type: l.toggleRowExpanded,
					id: e,
					value: t
				});
			}), [b]), P = t.useCallback((function(e) {
				return b({
					type: l.toggleAllRowsExpanded,
					value: e
				});
			}), [b]), B = t.useMemo((function() {
				return a ? A(o, {
					manualExpandedKey: u,
					expanded: R,
					expandSubRows: d
				}) : o;
			}), [
				a,
				o,
				u,
				R,
				d
			]), E = t.useMemo((function() {
				return function(e) {
					var t = 0;
					return Object.keys(e).forEach((function(e) {
						var n = e.split(".");
						t = Math.max(t, n.length);
					})), t;
				}(R);
			}), [R]), I = h(e), F = f(m().getToggleAllRowsExpandedProps, { instance: I() });
			Object.assign(e, {
				preExpandedRows: o,
				expandedRows: B,
				rows: B,
				expandedDepth: E,
				isAllRowsExpanded: C,
				toggleRowExpanded: x,
				toggleAllRowsExpanded: P,
				getToggleAllRowsExpandedProps: F
			});
		}
		function pe(e, t) {
			var n = t.instance.getHooks, o = t.instance;
			e.toggleRowExpanded = function(t) {
				return o.toggleRowExpanded(e.id, t);
			}, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
				instance: o,
				row: e
			});
		}
		var ge = function(e, t, n) {
			return e = e.filter((function(e) {
				return t.some((function(t) {
					var o = e.values[t];
					return String(o).toLowerCase().includes(String(n).toLowerCase());
				}));
			}));
		};
		ge.autoRemove = function(e) {
			return !e;
		};
		var ve = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					var o = e.values[t];
					return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
				}));
			}));
		};
		ve.autoRemove = function(e) {
			return !e;
		};
		var me = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					var o = e.values[t];
					return void 0 === o || String(o) === String(n);
				}));
			}));
		};
		me.autoRemove = function(e) {
			return !e;
		};
		var he = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					return e.values[t].includes(n);
				}));
			}));
		};
		he.autoRemove = function(e) {
			return !e || !e.length;
		};
		var ye = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					var o = e.values[t];
					return o && o.length && n.every((function(e) {
						return o.includes(e);
					}));
				}));
			}));
		};
		ye.autoRemove = function(e) {
			return !e || !e.length;
		};
		var we = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					var o = e.values[t];
					return o && o.length && n.some((function(e) {
						return o.includes(e);
					}));
				}));
			}));
		};
		we.autoRemove = function(e) {
			return !e || !e.length;
		};
		var Re = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					var o = e.values[t];
					return n.includes(o);
				}));
			}));
		};
		Re.autoRemove = function(e) {
			return !e || !e.length;
		};
		var be = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					return e.values[t] === n;
				}));
			}));
		};
		be.autoRemove = function(e) {
			return void 0 === e;
		};
		var Se = function(e, t, n) {
			return e.filter((function(e) {
				return t.some((function(t) {
					return e.values[t] == n;
				}));
			}));
		};
		Se.autoRemove = function(e) {
			return null == e;
		};
		var Ce = function(e, t, n) {
			var o = n || [], r = o[0], i = o[1];
			if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
				var u = r;
				r = i, i = u;
			}
			return e.filter((function(e) {
				return t.some((function(t) {
					var n = e.values[t];
					return n >= r && n <= i;
				}));
			}));
		};
		Ce.autoRemove = function(e) {
			return !e || "number" != typeof e[0] && "number" != typeof e[1];
		};
		var xe = Object.freeze({
			__proto__: null,
			text: ge,
			exactText: ve,
			exactTextCase: me,
			includes: he,
			includesAll: ye,
			includesSome: we,
			includesValue: Re,
			exact: be,
			equals: Se,
			between: Ce
		});
		l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
		var Pe = function(e) {
			e.stateReducers.push(Be), e.useInstance.push(Ee);
		};
		function Be(e, t, n, o) {
			if (t.type === l.init) return r({ filters: [] }, e);
			if (t.type === l.resetFilters) return r({}, e, { filters: o.initialState.filters || [] });
			if (t.type === l.setFilter) {
				var i = t.columnId, u = t.filterValue, s = o.allColumns, a = o.filterTypes, c = s.find((function(e) {
					return e.id === i;
				}));
				if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
				var d = k(c.filter, a || {}, xe), f = e.filters.find((function(e) {
					return e.id === i;
				})), p = m(u, f && f.value);
				return H(d.autoRemove, p, c) ? r({}, e, { filters: e.filters.filter((function(e) {
					return e.id !== i;
				})) }) : r({}, e, f ? { filters: e.filters.map((function(e) {
					return e.id === i ? {
						id: i,
						value: p
					} : e;
				})) } : { filters: [].concat(e.filters, [{
					id: i,
					value: p
				}]) });
			}
			if (t.type === l.setAllFilters) {
				var g = t.filters, v = o.allColumns, h = o.filterTypes;
				return r({}, e, { filters: m(g, e.filters).filter((function(e) {
					var t = v.find((function(t) {
						return t.id === e.id;
					}));
					return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
				})) });
			}
		}
		function Ee(e) {
			var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.manualFilters, c = e.defaultCanFilter, d = void 0 !== c && c, f = e.disableFilters, p = e.state.filters, g = e.dispatch, v = e.autoResetFilters, m = void 0 === v || v, y = t.useCallback((function(e, t) {
				g({
					type: l.setFilter,
					columnId: e,
					filterValue: t
				});
			}), [g]), R = t.useCallback((function(e) {
				g({
					type: l.setAllFilters,
					filters: e
				});
			}), [g]);
			u.forEach((function(e) {
				var t = e.id, n = e.accessor, o = e.defaultCanFilter, r = e.disableFilters;
				e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function(t) {
					return y(e.id, t);
				};
				var i = p.find((function(e) {
					return e.id === t;
				}));
				e.filterValue = i && i.value;
			}));
			var b = t.useMemo((function() {
				if (a || !p.length) return [
					o,
					r,
					i
				];
				var e = [], t = {};
				return [
					function n(o, r) {
						void 0 === r && (r = 0);
						var i = o;
						return (i = p.reduce((function(e, t) {
							var n = t.id, o = t.value, i = u.find((function(e) {
								return e.id === n;
							}));
							if (!i) return e;
							0 === r && (i.preFilteredRows = e);
							var l = k(i.filter, s || {}, xe);
							return l ? (i.filteredRows = l(e, [n], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
						}), o)).forEach((function(o) {
							e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
						})), i;
					}(o),
					e,
					t
				];
			}), [
				a,
				p,
				o,
				r,
				i,
				u,
				s
			]), S = b[0], C = b[1], x = b[2];
			t.useMemo((function() {
				u.filter((function(e) {
					return !p.find((function(t) {
						return t.id === e.id;
					}));
				})).forEach((function(e) {
					e.preFilteredRows = S, e.filteredRows = S;
				}));
			}), [
				S,
				p,
				u
			]);
			var P = h(m);
			w((function() {
				P() && g({ type: l.resetFilters });
			}), [g, a ? null : n]), Object.assign(e, {
				preFilteredRows: o,
				preFilteredFlatRows: r,
				preFilteredRowsById: i,
				filteredRows: S,
				filteredFlatRows: C,
				filteredRowsById: x,
				rows: S,
				flatRows: C,
				rowsById: x,
				setFilter: y,
				setAllFilters: R
			});
		}
		Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
		var Ie = function(e) {
			e.stateReducers.push(Fe), e.useInstance.push(Ge);
		};
		function Fe(e, t, n, o) {
			if (t.type === l.resetGlobalFilter) return r({}, e, { globalFilter: o.initialState.globalFilter || void 0 });
			if (t.type === l.setGlobalFilter) {
				var u = t.filterValue, s = o.userFilterTypes, a = k(o.globalFilter, s || {}, xe), c = m(u, e.globalFilter);
				if (H(a.autoRemove, c)) {
					e.globalFilter;
					return i(e, ["globalFilter"]);
				}
				return r({}, e, { globalFilter: c });
			}
		}
		function Ge(e) {
			var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.globalFilter, c = e.manualGlobalFilter, d = e.state.globalFilter, f = e.dispatch, p = e.autoResetGlobalFilter, g = void 0 === p || p, v = e.disableGlobalFilter, m = t.useCallback((function(e) {
				f({
					type: l.setGlobalFilter,
					filterValue: e
				});
			}), [f]), y = t.useMemo((function() {
				if (c || void 0 === d) return [
					o,
					r,
					i
				];
				var e = [], t = {}, n = k(a, s || {}, xe);
				if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
				u.forEach((function(e) {
					var t = e.disableGlobalFilter;
					e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
				}));
				var l = u.filter((function(e) {
					return !0 === e.canFilter;
				}));
				return [
					function o(r) {
						return (r = n(r, l.map((function(e) {
							return e.id;
						})), d)).forEach((function(n) {
							e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
						})), r;
					}(o),
					e,
					t
				];
			}), [
				c,
				d,
				a,
				s,
				u,
				o,
				r,
				i,
				v
			]), R = y[0], b = y[1], S = y[2], C = h(g);
			w((function() {
				C() && f({ type: l.resetGlobalFilter });
			}), [f, c ? null : n]), Object.assign(e, {
				preGlobalFilteredRows: o,
				preGlobalFilteredFlatRows: r,
				preGlobalFilteredRowsById: i,
				globalFilteredRows: R,
				globalFilteredFlatRows: b,
				globalFilteredRowsById: S,
				rows: R,
				flatRows: b,
				rowsById: S,
				setGlobalFilter: m,
				disableGlobalFilter: v
			});
		}
		function Ae(e, t) {
			return t.reduce((function(e, t) {
				return e + ("number" == typeof t ? t : 0);
			}), 0);
		}
		Ie.pluginName = "useGlobalFilter";
		var ke = Object.freeze({
			__proto__: null,
			sum: Ae,
			min: function(e) {
				var t = e[0] || 0;
				return e.forEach((function(e) {
					"number" == typeof e && (t = Math.min(t, e));
				})), t;
			},
			max: function(e) {
				var t = e[0] || 0;
				return e.forEach((function(e) {
					"number" == typeof e && (t = Math.max(t, e));
				})), t;
			},
			minMax: function(e) {
				var t = e[0] || 0, n = e[0] || 0;
				return e.forEach((function(e) {
					"number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
				})), t + ".." + n;
			},
			average: function(e) {
				return Ae(0, e) / e.length;
			},
			median: function(e) {
				if (!e.length) return null;
				var t = Math.floor(e.length / 2), n = [].concat(e).sort((function(e, t) {
					return e - t;
				}));
				return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
			},
			unique: function(e) {
				return Array.from(new Set(e).values());
			},
			uniqueCount: function(e) {
				return new Set(e).size;
			},
			count: function(e) {
				return e.length;
			}
		}), He = [], We = {};
		l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
		var ze = function(e) {
			e.getGroupByToggleProps = [Te], e.stateReducers.push(Oe), e.visibleColumnsDeps.push((function(e, t) {
				var n = t.instance;
				return [].concat(e, [n.state.groupBy]);
			})), e.visibleColumns.push(Me), e.useInstance.push(Le), e.prepareRow.push(Ne);
		};
		ze.pluginName = "useGroupBy";
		var Te = function(e, t) {
			var n = t.header;
			return [e, {
				onClick: n.canGroupBy ? function(e) {
					e.persist(), n.toggleGroupBy();
				} : void 0,
				style: { cursor: n.canGroupBy ? "pointer" : void 0 },
				title: "Toggle GroupBy"
			}];
		};
		function Oe(e, t, n, o) {
			if (t.type === l.init) return r({ groupBy: [] }, e);
			if (t.type === l.resetGroupBy) return r({}, e, { groupBy: o.initialState.groupBy || [] });
			if (t.type === l.setGroupBy) return r({}, e, { groupBy: t.value });
			if (t.type === l.toggleGroupBy) {
				var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.groupBy.includes(i);
				return r({}, e, s ? { groupBy: [].concat(e.groupBy, [i]) } : { groupBy: e.groupBy.filter((function(e) {
					return e !== i;
				})) });
			}
		}
		function Me(e, t) {
			var n = t.instance.state.groupBy, o = n.map((function(t) {
				return e.find((function(e) {
					return e.id === t;
				}));
			})).filter(Boolean), r = e.filter((function(e) {
				return !n.includes(e.id);
			}));
			return (e = [].concat(o, r)).forEach((function(e) {
				e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
			})), e;
		}
		var je = {};
		function Le(e) {
			var n = e.data, o = e.rows, i = e.flatRows, u = e.rowsById, s = e.allColumns, a = e.flatHeaders, c = e.groupByFn, d = void 0 === c ? De : c, p = e.manualGroupBy, g = e.aggregations, m = void 0 === g ? je : g, y = e.plugins, R = e.state.groupBy, b = e.dispatch, S = e.autoResetGroupBy, C = void 0 === S || S, x = e.disableGroupBy, P = e.defaultCanGroupBy, B = e.getHooks;
			v(y, ["useColumnOrder", "useFilters"], "useGroupBy");
			var E = h(e);
			s.forEach((function(t) {
				var n = t.accessor, o = t.defaultGroupBy, r = t.disableGroupBy;
				t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== x && void 0, !0) : I(t.canGroupBy, o, P, !1), t.canGroupBy && (t.toggleGroupBy = function() {
					return e.toggleGroupBy(t.id);
				}), t.Aggregated = t.Aggregated || t.Cell;
			}));
			var F = t.useCallback((function(e, t) {
				b({
					type: l.toggleGroupBy,
					columnId: e,
					value: t
				});
			}), [b]), A = t.useCallback((function(e) {
				b({
					type: l.setGroupBy,
					value: e
				});
			}), [b]);
			a.forEach((function(e) {
				e.getGroupByToggleProps = f(B().getGroupByToggleProps, {
					instance: E(),
					header: e
				});
			}));
			var k = t.useMemo((function() {
				if (p || !R.length) return [
					o,
					i,
					u,
					He,
					We,
					i,
					u
				];
				var e = R.filter((function(e) {
					return s.find((function(t) {
						return t.id === e;
					}));
				})), t = [], n = {}, l = [], a = {}, c = [], f = {}, g = function o(i, u, p) {
					if (void 0 === u && (u = 0), u === e.length) return i.map((function(e) {
						return r({}, e, { depth: u });
					}));
					var g = e[u], v = d(i, g);
					return Object.entries(v).map((function(r, i) {
						var d = r[0], v = r[1], h = g + ":" + d, y = o(v, u + 1, h = p ? p + ">" + h : h), w = u ? G(v, "leafRows") : v, R = function(t, n, o) {
							var r = {};
							return s.forEach((function(i) {
								if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;
								else {
									var u = "function" == typeof i.aggregate ? i.aggregate : m[i.aggregate] || ke[i.aggregate];
									if (u) {
										var l = n.map((function(e) {
											return e.values[i.id];
										})), s = t.map((function(e) {
											var t = e.values[i.id];
											if (!o && i.aggregateValue) {
												var n = "function" == typeof i.aggregateValue ? i.aggregateValue : m[i.aggregateValue] || ke[i.aggregateValue];
												if (!n) throw console.info({ column: i }), /* @__PURE__ */ new Error("React Table: Invalid column.aggregateValue option for column listed above");
												t = n(t, e, i);
											}
											return t;
										}));
										r[i.id] = u(s, l);
									} else {
										if (i.aggregate) throw console.info({ column: i }), /* @__PURE__ */ new Error("React Table: Invalid column.aggregate option for column listed above");
										r[i.id] = null;
									}
								}
							})), r;
						}(w, v, u), b = {
							id: h,
							isGrouped: !0,
							groupByID: g,
							groupByVal: d,
							values: R,
							subRows: y,
							leafRows: w,
							depth: u,
							index: i
						};
						return y.forEach((function(e) {
							t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
						})), b;
					}));
				}(o);
				return g.forEach((function(e) {
					t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
				})), [
					g,
					t,
					n,
					l,
					a,
					c,
					f
				];
			}), [
				p,
				R,
				o,
				i,
				u,
				s,
				m,
				d
			]), H = k[0], W = k[1], z = k[2], T = k[3], O = k[4], M = k[5], j = k[6], L = h(C);
			w((function() {
				L() && b({ type: l.resetGroupBy });
			}), [b, p ? null : n]), Object.assign(e, {
				preGroupedRows: o,
				preGroupedFlatRow: i,
				preGroupedRowsById: u,
				groupedRows: H,
				groupedFlatRows: W,
				groupedRowsById: z,
				onlyGroupedFlatRows: T,
				onlyGroupedRowsById: O,
				nonGroupedFlatRows: M,
				nonGroupedRowsById: j,
				rows: H,
				flatRows: W,
				rowsById: z,
				toggleGroupBy: F,
				setGroupBy: A
			});
		}
		function Ne(e) {
			e.allCells.forEach((function(t) {
				var n;
				t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
			}));
		}
		function De(e, t) {
			return e.reduce((function(e, n, o) {
				var r = "" + n.values[t];
				return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
			}), {});
		}
		var Ve = /([0-9]+)/gm;
		function _e(e, t) {
			return e === t ? 0 : e > t ? 1 : -1;
		}
		function Xe(e, t, n) {
			return [e.values[n], t.values[n]];
		}
		function qe(e) {
			return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
		}
		var Ke = Object.freeze({
			__proto__: null,
			alphanumeric: function(e, t, n) {
				var o = Xe(e, t, n), r = o[0], i = o[1];
				for (r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;) {
					var u = r.shift(), l = i.shift(), s = parseInt(u, 10), a = parseInt(l, 10), c = [s, a].sort();
					if (isNaN(c[0])) {
						if (u > l) return 1;
						if (l > u) return -1;
					} else {
						if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
						if (s > a) return 1;
						if (a > s) return -1;
					}
				}
				return r.length - i.length;
			},
			datetime: function(e, t, n) {
				var o = Xe(e, t, n), r = o[0], i = o[1];
				return _e(r = r.getTime(), i = i.getTime());
			},
			basic: function(e, t, n) {
				var o = Xe(e, t, n);
				return _e(o[0], o[1]);
			},
			string: function(e, t, n) {
				var o = Xe(e, t, n), r = o[0], i = o[1];
				for (r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;) {
					var u = r.shift(), l = i.shift(), s = u.toLowerCase(), a = l.toLowerCase();
					if (s > a) return 1;
					if (a > s) return -1;
					if (u > l) return 1;
					if (l > u) return -1;
				}
				return r.length - i.length;
			},
			number: function(e, t, n) {
				var o = Xe(e, t, n), r = o[0], i = o[1], u = /[^0-9.]/gi;
				return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
			}
		});
		l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
		var Ue = function(e) {
			e.getSortByToggleProps = [$e], e.stateReducers.push(Je), e.useInstance.push(Ye);
		};
		Ue.pluginName = "useSortBy";
		var $e = function(e, t) {
			var n = t.instance, o = t.column, r = n.isMultiSortEvent, i = void 0 === r ? function(e) {
				return e.shiftKey;
			} : r;
			return [e, {
				onClick: o.canSort ? function(e) {
					e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
				} : void 0,
				style: { cursor: o.canSort ? "pointer" : void 0 },
				title: o.canSort ? "Toggle SortBy" : void 0
			}];
		};
		function Je(e, t, n, o) {
			if (t.type === l.init) return r({ sortBy: [] }, e);
			if (t.type === l.resetSortBy) return r({}, e, { sortBy: o.initialState.sortBy || [] });
			if (t.type === l.clearSortBy) return r({}, e, { sortBy: e.sortBy.filter((function(e) {
				return e.id !== t.columnId;
			})) });
			if (t.type === l.setSortBy) return r({}, e, { sortBy: t.sortBy });
			if (t.type === l.toggleSortBy) {
				var i, u = t.columnId, s = t.desc, a = t.multi, c = o.allColumns, d = o.disableMultiSort, f = o.disableSortRemove, p = o.disableMultiRemove, g = o.maxMultiSortColCount, v = void 0 === g ? Number.MAX_SAFE_INTEGER : g, m = e.sortBy, h = c.find((function(e) {
					return e.id === u;
				})).sortDescFirst, y = m.find((function(e) {
					return e.id === u;
				})), w = m.findIndex((function(e) {
					return e.id === u;
				})), R = null != s, b = [];
				return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [{
					id: u,
					desc: R ? s : h
				}] : "add" === i ? (b = [].concat(m, [{
					id: u,
					desc: R ? s : h
				}])).splice(0, b.length - v) : "toggle" === i ? b = m.map((function(e) {
					return e.id === u ? r({}, e, { desc: R ? s : !y.desc }) : e;
				})) : "remove" === i && (b = m.filter((function(e) {
					return e.id !== u;
				}))), r({}, e, { sortBy: b });
			}
		}
		function Ye(e) {
			var n = e.data, o = e.rows, r = e.flatRows, i = e.allColumns, u = e.orderByFn, s = void 0 === u ? Qe : u, a = e.sortTypes, c = e.manualSortBy, d = e.defaultCanSort, p = e.disableSortBy, g = e.flatHeaders, m = e.state.sortBy, y = e.dispatch, R = e.plugins, b = e.getHooks, S = e.autoResetSortBy, C = void 0 === S || S;
			v(R, [
				"useFilters",
				"useGlobalFilter",
				"useGroupBy",
				"usePivotColumns"
			], "useSortBy");
			var x = t.useCallback((function(e) {
				y({
					type: l.setSortBy,
					sortBy: e
				});
			}), [y]), P = t.useCallback((function(e, t, n) {
				y({
					type: l.toggleSortBy,
					columnId: e,
					desc: t,
					multi: n
				});
			}), [y]), B = h(e);
			g.forEach((function(e) {
				var t = e.accessor, n = e.canSort, o = e.disableSortBy, r = e.id;
				e.canSort = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1), e.canSort && (e.toggleSortBy = function(t, n) {
					return P(e.id, t, n);
				}, e.clearSortBy = function() {
					y({
						type: l.clearSortBy,
						columnId: e.id
					});
				}), e.getSortByToggleProps = f(b().getSortByToggleProps, {
					instance: B(),
					column: e
				});
				var u = m.find((function(e) {
					return e.id === r;
				}));
				e.isSorted = !!u, e.sortedIndex = m.findIndex((function(e) {
					return e.id === r;
				})), e.isSortedDesc = e.isSorted ? u.desc : void 0;
			}));
			var E = t.useMemo((function() {
				if (c || !m.length) return [o, r];
				var e = [], t = m.filter((function(e) {
					return i.find((function(t) {
						return t.id === e.id;
					}));
				}));
				return [function n(o) {
					var r = s(o, t.map((function(e) {
						var t = i.find((function(t) {
							return t.id === e.id;
						}));
						if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
						var n = t.sortType, o = F(n) || (a || {})[n] || Ke[n];
						if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
						return function(t, n) {
							return o(t, n, e.id, e.desc);
						};
					})), t.map((function(e) {
						var t = i.find((function(t) {
							return t.id === e.id;
						}));
						return t && t.sortInverted ? e.desc : !e.desc;
					})));
					return r.forEach((function(t) {
						e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
					})), r;
				}(o), e];
			}), [
				c,
				m,
				o,
				r,
				i,
				s,
				a
			]), G = E[0], A = E[1], k = h(C);
			w((function() {
				k() && y({ type: l.resetSortBy });
			}), [c ? null : n]), Object.assign(e, {
				preSortedRows: o,
				preSortedFlatRows: r,
				sortedRows: G,
				sortedFlatRows: A,
				rows: G,
				flatRows: A,
				setSortBy: x,
				toggleSortBy: P
			});
		}
		function Qe(e, t, n) {
			return [].concat(e).sort((function(e, o) {
				for (var r = 0; r < t.length; r += 1) {
					var i = t[r], u = !1 === n[r] || "desc" === n[r], l = i(e, o);
					if (0 !== l) return u ? -l : l;
				}
				return n[0] ? e.index - o.index : o.index - e.index;
			}));
		}
		l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
		var Ze = function(e) {
			e.stateReducers.push(et), e.useInstance.push(tt);
		};
		function et(e, t, n, o) {
			if (t.type === l.init) return r({
				pageSize: 10,
				pageIndex: 0
			}, e);
			if (t.type === l.resetPage) return r({}, e, { pageIndex: o.initialState.pageIndex || 0 });
			if (t.type === l.gotoPage) {
				var i = o.pageCount, u = o.page, s = m(t.pageIndex, e.pageIndex), a = !1;
				return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, { pageIndex: s }) : e;
			}
			if (t.type === l.setPageSize) {
				var c = t.pageSize, d = e.pageSize * e.pageIndex;
				return r({}, e, {
					pageIndex: Math.floor(d / c),
					pageSize: c
				});
			}
		}
		function tt(e) {
			var n = e.rows, o = e.autoResetPage, r = void 0 === o || o, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.plugins, a = e.pageCount, c = e.paginateExpandedRows, d = void 0 === c || c, f = e.expandSubRows, p = void 0 === f || f, g = e.state, m = g.pageSize, y = g.pageIndex, R = g.expanded, b = g.globalFilter, S = g.filters, C = g.groupBy, x = g.sortBy, P = e.dispatch, B = e.data, E = e.manualPagination;
			v(s, [
				"useGlobalFilter",
				"useFilters",
				"useGroupBy",
				"useSortBy",
				"useExpanded"
			], "usePagination");
			var I = h(r);
			w((function() {
				I() && P({ type: l.resetPage });
			}), [
				P,
				E ? null : B,
				b,
				S,
				C,
				x
			]);
			var F = E ? a : Math.ceil(n.length / m), G = t.useMemo((function() {
				return F > 0 ? [].concat(new Array(F)).fill(null).map((function(e, t) {
					return t;
				})) : [];
			}), [F]), k = t.useMemo((function() {
				var e;
				if (E) e = n;
				else {
					var t = m * y, o = t + m;
					e = n.slice(t, o);
				}
				return d ? e : A(e, {
					manualExpandedKey: u,
					expanded: R,
					expandSubRows: p
				});
			}), [
				p,
				R,
				u,
				E,
				y,
				m,
				d,
				n
			]), H = y > 0, W = -1 === F ? k.length >= m : y < F - 1, z = t.useCallback((function(e) {
				P({
					type: l.gotoPage,
					pageIndex: e
				});
			}), [P]), T = t.useCallback((function() {
				return z((function(e) {
					return e - 1;
				}));
			}), [z]), O = t.useCallback((function() {
				return z((function(e) {
					return e + 1;
				}));
			}), [z]), M = t.useCallback((function(e) {
				P({
					type: l.setPageSize,
					pageSize: e
				});
			}), [P]);
			Object.assign(e, {
				pageOptions: G,
				pageCount: F,
				page: k,
				canPreviousPage: H,
				canNextPage: W,
				gotoPage: z,
				previousPage: T,
				nextPage: O,
				setPageSize: M
			});
		}
		Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
		var nt = function(e) {
			e.getPivotToggleProps = [rt], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
		};
		nt.pluginName = "usePivotColumns";
		var ot = [], rt = function(e, t) {
			var n = t.header;
			return [e, {
				onClick: n.canPivot ? function(e) {
					e.persist(), n.togglePivot();
				} : void 0,
				style: { cursor: n.canPivot ? "pointer" : void 0 },
				title: "Toggle Pivot"
			}];
		};
		function it(e, t, n, o) {
			if (t.type === l.init) return r({ pivotColumns: ot }, e);
			if (t.type === l.resetPivot) return r({}, e, { pivotColumns: o.initialState.pivotColumns || ot });
			if (t.type === l.togglePivot) {
				var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.pivotColumns.includes(i);
				return r({}, e, s ? { pivotColumns: [].concat(e.pivotColumns, [i]) } : { pivotColumns: e.pivotColumns.filter((function(e) {
					return e !== i;
				})) });
			}
		}
		function ut(e) {
			e.allColumns.forEach((function(t) {
				t.isPivotSource = e.state.pivotColumns.includes(t.id);
			}));
		}
		function lt(e, t) {
			var n = t.instance;
			return e.forEach((function(e) {
				e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = /* @__PURE__ */ new Set();
			})), e;
		}
		function st(e, t) {
			var n = t.column;
			return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
		}
		function at(e, t) {
			var n = t.instance, o = n.allColumns, i = n.state;
			if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
			var u = i.pivotColumns.map((function(e) {
				return o.find((function(t) {
					return t.id === e;
				}));
			})).filter(Boolean), l = o.filter((function(e) {
				return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
			})), s = C(function e(t, n, o) {
				void 0 === t && (t = 0), void 0 === o && (o = []);
				var i = u[t];
				return i ? Array.from(i.uniqueValues).sort().map((function(u) {
					var l = r({}, i, {
						Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
						isPivotGroup: !0,
						parent: n,
						depth: t,
						id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
						pivotValue: u
					});
					return l.columns = e(t + 1, l, [].concat(o, [function(e) {
						return e.values[i.id] === u;
					}])), l;
				})) : l.map((function(e) {
					return r({}, e, {
						canPivot: !1,
						isPivoted: !0,
						parent: n,
						depth: t,
						id: "" + (n ? n.id + "." + e.id : e.id),
						accessor: function(t, n, r) {
							if (o.every((function(e) {
								return e(r);
							}))) return r.values[e.id];
						}
					});
				}));
			}());
			return [].concat(e, s);
		}
		function ct(e, t) {
			var n = t.instance.state, o = n.pivotColumns, r = n.groupBy;
			return [].concat(e, [o, r]);
		}
		function dt(e, t) {
			var n = t.instance.state;
			return e = e.filter((function(e) {
				return !e.isPivotSource;
			})), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter((function(e) {
				return e.isGrouped || e.isPivoted;
			}))), e;
		}
		function ft(e, t) {
			var n = t.instance;
			return [].concat(e, [n.state.pivotColumns, n.state.groupBy]);
		}
		function pt(e) {
			var t = e.columns, n = e.allColumns, o = e.flatHeaders, r = e.getHooks, i = e.plugins, u = e.dispatch, s = e.autoResetPivot, a = void 0 === s || s, c = e.manaulPivot, d = e.disablePivot, p = e.defaultCanPivot;
			v(i, ["useGroupBy"], "usePivotColumns");
			var g = h(e);
			n.forEach((function(t) {
				var n = t.accessor, o = t.defaultPivot, r = t.disablePivot;
				t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function() {
					return e.togglePivot(t.id);
				}), t.Aggregated = t.Aggregated || t.Cell;
			}));
			o.forEach((function(e) {
				e.getPivotToggleProps = f(r().getPivotToggleProps, {
					instance: g(),
					header: e
				});
			}));
			var m = h(a);
			w((function() {
				m() && u({ type: l.resetPivot });
			}), [u, c ? null : t]), Object.assign(e, { togglePivot: function(e, t) {
				u({
					type: l.togglePivot,
					columnId: e,
					value: t
				});
			} });
		}
		function gt(e) {
			e.allCells.forEach((function(e) {
				e.isPivoted = e.column.isPivoted;
			}));
		}
		l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
		var vt = function(e) {
			e.getToggleRowSelectedProps = [mt], e.getToggleAllRowsSelectedProps = [ht], e.getToggleAllPageRowsSelectedProps = [yt], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
		};
		vt.pluginName = "useRowSelect";
		var mt = function(e, t) {
			var n = t.instance, o = t.row, r = n.manualRowSelectedKey, i = void 0 === r ? "isSelected" : r;
			return [e, {
				onChange: function(e) {
					o.toggleRowSelected(e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: !(!o.original || !o.original[i]) || o.isSelected,
				title: "Toggle Row Selected",
				indeterminate: o.isSomeSelected
			}];
		}, ht = function(e, t) {
			var n = t.instance;
			return [e, {
				onChange: function(e) {
					n.toggleAllRowsSelected(e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: n.isAllRowsSelected,
				title: "Toggle All Rows Selected",
				indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
			}];
		}, yt = function(e, t) {
			var n = t.instance;
			return [e, {
				onChange: function(e) {
					n.toggleAllPageRowsSelected(e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: n.isAllPageRowsSelected,
				title: "Toggle All Current Page Rows Selected",
				indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some((function(e) {
					var t = e.id;
					return n.state.selectedRowIds[t];
				})))
			}];
		};
		function wt(e, t, n, o) {
			if (t.type === l.init) return r({ selectedRowIds: {} }, e);
			if (t.type === l.resetSelectedRows) return r({}, e, { selectedRowIds: o.initialState.selectedRowIds || {} });
			if (t.type === l.toggleAllRowsSelected) {
				var i = t.value, u = o.isAllRowsSelected, s = o.rowsById, a = o.nonGroupedRowsById, c = void 0 === a ? s : a, d = void 0 !== i ? i : !u, f = Object.assign({}, e.selectedRowIds);
				return d ? Object.keys(c).forEach((function(e) {
					f[e] = !0;
				})) : Object.keys(c).forEach((function(e) {
					delete f[e];
				})), r({}, e, { selectedRowIds: f });
			}
			if (t.type === l.toggleRowSelected) {
				var p = t.id, g = t.value, v = o.rowsById, m = o.selectSubRows, h = void 0 === m || m, y = o.getSubRows, w = e.selectedRowIds[p], R = void 0 !== g ? g : !w;
				if (w === R) return e;
				var b = r({}, e.selectedRowIds);
				return function e(t) {
					var n = v[t];
					if (n && (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n))) return y(n).forEach((function(t) {
						return e(t.id);
					}));
				}(p), r({}, e, { selectedRowIds: b });
			}
			if (t.type === l.toggleAllPageRowsSelected) {
				var S = t.value, C = o.page, x = o.rowsById, P = o.selectSubRows, B = void 0 === P || P, E = o.isAllPageRowsSelected, I = o.getSubRows, F = void 0 !== S ? S : !E, G = r({}, e.selectedRowIds);
				return C.forEach((function(e) {
					return function e(t) {
						var n = x[t];
						if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach((function(t) {
							return e(t.id);
						}));
					}(e.id);
				})), r({}, e, { selectedRowIds: G });
			}
			return e;
		}
		function Rt(e) {
			var n = e.data, o = e.rows, r = e.getHooks, i = e.plugins, u = e.rowsById, s = e.nonGroupedRowsById, a = void 0 === s ? u : s, c = e.autoResetSelectedRows, d = void 0 === c || c, p = e.state.selectedRowIds, g = e.selectSubRows, m = void 0 === g || g, y = e.dispatch, R = e.page, b = e.getSubRows;
			v(i, [
				"useFilters",
				"useGroupBy",
				"useSortBy",
				"useExpanded",
				"usePagination"
			], "useRowSelect");
			var S = t.useMemo((function() {
				var e = [];
				return o.forEach((function(t) {
					var n = m ? function e(t, n, o) {
						if (n[t.id]) return !0;
						var r = o(t);
						if (r && r.length) {
							var i = !0, u = !1;
							return r.forEach((function(t) {
								u && !i || (e(t, n, o) ? u = !0 : i = !1);
							})), !!i || !!u && null;
						}
						return !1;
					}(t, p, b) : !!p[t.id];
					t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
				})), e;
			}), [
				o,
				m,
				p,
				b
			]), C = Boolean(Object.keys(a).length && Object.keys(p).length), x = C;
			C && Object.keys(a).some((function(e) {
				return !p[e];
			})) && (C = !1), C || R && R.length && R.some((function(e) {
				return !p[e.id];
			})) && (x = !1);
			var P = h(d);
			w((function() {
				P() && y({ type: l.resetSelectedRows });
			}), [y, n]);
			var B = t.useCallback((function(e) {
				return y({
					type: l.toggleAllRowsSelected,
					value: e
				});
			}), [y]), E = t.useCallback((function(e) {
				return y({
					type: l.toggleAllPageRowsSelected,
					value: e
				});
			}), [y]), I = t.useCallback((function(e, t) {
				return y({
					type: l.toggleRowSelected,
					id: e,
					value: t
				});
			}), [y]), F = h(e), G = f(r().getToggleAllRowsSelectedProps, { instance: F() }), A = f(r().getToggleAllPageRowsSelectedProps, { instance: F() });
			Object.assign(e, {
				selectedFlatRows: S,
				isAllRowsSelected: C,
				isAllPageRowsSelected: x,
				toggleRowSelected: I,
				toggleAllRowsSelected: B,
				getToggleAllRowsSelectedProps: G,
				getToggleAllPageRowsSelectedProps: A,
				toggleAllPageRowsSelected: E
			});
		}
		function bt(e, t) {
			var n = t.instance;
			e.toggleRowSelected = function(t) {
				return n.toggleRowSelected(e.id, t);
			}, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
				instance: n,
				row: e
			});
		}
		var St = function(e) {
			return {};
		}, Ct = function(e) {
			return {};
		};
		l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
		var xt = function(e) {
			e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
		};
		function Pt(e, t, n, o) {
			var i = o.initialRowStateAccessor, u = void 0 === i ? St : i, s = o.initialCellStateAccessor, a = void 0 === s ? Ct : s, c = o.rowsById;
			if (t.type === l.init) return r({ rowState: {} }, e);
			if (t.type === l.resetRowState) return r({}, e, { rowState: o.initialState.rowState || {} });
			if (t.type === l.setRowState) {
				var d, f = t.rowId, p = t.value, g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
				return r({}, e, { rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d)) });
			}
			if (t.type === l.setCellState) {
				var v, h, y, w, R, b = t.rowId, S = t.columnId, C = t.value, x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]), P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find((function(e) {
					return e.column.id === S;
				})));
				return r({}, e, { rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, { cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w)) }), R)) });
			}
		}
		function Bt(e) {
			var n = e.autoResetRowState, o = void 0 === n || n, r = e.data, i = e.dispatch, u = t.useCallback((function(e, t) {
				return i({
					type: l.setRowState,
					rowId: e,
					value: t
				});
			}), [i]), s = t.useCallback((function(e, t, n) {
				return i({
					type: l.setCellState,
					rowId: e,
					columnId: t,
					value: n
				});
			}), [i]), a = h(o);
			w((function() {
				a() && i({ type: l.resetRowState });
			}), [r]), Object.assign(e, {
				setRowState: u,
				setCellState: s
			});
		}
		function Et(e, t) {
			var n = t.instance, o = n.initialRowStateAccessor, r = void 0 === o ? St : o, i = n.initialCellStateAccessor, u = void 0 === i ? Ct : i, l = n.state.rowState;
			e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function(t) {
				return n.setRowState(e.id, t);
			}, e.cells.forEach((function(t) {
				e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function(o) {
					return n.setCellState(e.id, t.column.id, o);
				};
			})));
		}
		xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
		var It = function(e) {
			e.stateReducers.push(Ft), e.visibleColumnsDeps.push((function(e, t) {
				var n = t.instance;
				return [].concat(e, [n.state.columnOrder]);
			})), e.visibleColumns.push(Gt), e.useInstance.push(At);
		};
		function Ft(e, t, n, o) {
			return t.type === l.init ? r({ columnOrder: [] }, e) : t.type === l.resetColumnOrder ? r({}, e, { columnOrder: o.initialState.columnOrder || [] }) : t.type === l.setColumnOrder ? r({}, e, { columnOrder: m(t.columnOrder, e.columnOrder) }) : void 0;
		}
		function Gt(e, t) {
			var n = t.instance.state.columnOrder;
			if (!n || !n.length) return e;
			for (var o = [].concat(n), r = [].concat(e), i = [], u = function() {
				var e = o.shift(), t = r.findIndex((function(t) {
					return t.id === e;
				}));
				t > -1 && i.push(r.splice(t, 1)[0]);
			}; r.length && o.length;) u();
			return [].concat(i, r);
		}
		function At(e) {
			var n = e.dispatch;
			e.setColumnOrder = t.useCallback((function(e) {
				return n({
					type: l.setColumnOrder,
					columnOrder: e
				});
			}), [n]);
		}
		It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
		var kt = function(e) {
			e.getResizerProps = [Ht], e.getHeaderProps.push({ style: { position: "relative" } }), e.stateReducers.push(Wt), e.useInstance.push(Tt), e.useInstanceBeforeDimensions.push(zt);
		}, Ht = function(e, t) {
			var n = t.instance, o = t.header, r = n.dispatch, i = function(e, t) {
				var n = !1;
				if ("touchstart" === e.type) {
					if (e.touches && e.touches.length > 1) return;
					n = !0;
				}
				var o, i, u = function(e) {
					var t = [];
					return function e(n) {
						n.columns && n.columns.length && n.columns.map(e);
						t.push(n);
					}(e), t;
				}(t).map((function(e) {
					return [e.id, e.totalWidth];
				})), s = n ? Math.round(e.touches[0].clientX) : e.clientX, a = function() {
					window.cancelAnimationFrame(o), o = null, r({ type: l.columnDoneResizing });
				}, c = function() {
					window.cancelAnimationFrame(o), o = null, r({
						type: l.columnResizing,
						clientX: i
					});
				}, d = function(e) {
					i = e, o || (o = window.requestAnimationFrame(c));
				}, f = {
					mouse: {
						moveEvent: "mousemove",
						moveHandler: function(e) {
							return d(e.clientX);
						},
						upEvent: "mouseup",
						upHandler: function(e) {
							document.removeEventListener("mousemove", f.mouse.moveHandler), document.removeEventListener("mouseup", f.mouse.upHandler), a();
						}
					},
					touch: {
						moveEvent: "touchmove",
						moveHandler: function(e) {
							return e.cancelable && (e.preventDefault(), e.stopPropagation()), d(e.touches[0].clientX), !1;
						},
						upEvent: "touchend",
						upHandler: function(e) {
							document.removeEventListener(f.touch.moveEvent, f.touch.moveHandler), document.removeEventListener(f.touch.upEvent, f.touch.moveHandler), a();
						}
					}
				}, p = n ? f.touch : f.mouse, g = !!function() {
					if ("boolean" == typeof z) return z;
					var e = !1;
					try {
						var t = { get passive() {
							return e = !0, !1;
						} };
						window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
					} catch (t) {
						e = !1;
					}
					return z = e;
				}() && { passive: !1 };
				document.addEventListener(p.moveEvent, p.moveHandler, g), document.addEventListener(p.upEvent, p.upHandler, g), r({
					type: l.columnStartResizing,
					columnId: t.id,
					columnWidth: t.totalWidth,
					headerIdWidths: u,
					clientX: s
				});
			};
			return [e, {
				onMouseDown: function(e) {
					return e.persist() || i(e, o);
				},
				onTouchStart: function(e) {
					return e.persist() || i(e, o);
				},
				style: { cursor: "col-resize" },
				draggable: !1,
				role: "separator"
			}];
		};
		function Wt(e, t) {
			if (t.type === l.init) return r({ columnResizing: { columnWidths: {} } }, e);
			if (t.type === l.resetResize) return r({}, e, { columnResizing: { columnWidths: {} } });
			if (t.type === l.columnStartResizing) {
				var n = t.clientX, o = t.columnId, i = t.columnWidth, u = t.headerIdWidths;
				return r({}, e, { columnResizing: r({}, e.columnResizing, {
					startX: n,
					headerIdWidths: u,
					columnWidth: i,
					isResizingColumn: o
				}) });
			}
			if (t.type === l.columnResizing) {
				var s = t.clientX, a = e.columnResizing, c = a.startX, d = a.columnWidth, f = a.headerIdWidths, p = (s - c) / d, g = {};
				return (void 0 === f ? [] : f).forEach((function(e) {
					var t = e[0], n = e[1];
					g[t] = Math.max(n + n * p, 0);
				})), r({}, e, { columnResizing: r({}, e.columnResizing, { columnWidths: r({}, e.columnResizing.columnWidths, {}, g) }) });
			}
			return t.type === l.columnDoneResizing ? r({}, e, { columnResizing: r({}, e.columnResizing, {
				startX: null,
				isResizingColumn: null
			}) }) : void 0;
		}
		kt.pluginName = "useResizeColumns";
		var zt = function(e) {
			var t = e.flatHeaders, n = e.disableResizing, o = e.getHooks, r = e.state.columnResizing, i = h(e);
			t.forEach((function(e) {
				var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
				e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
					instance: i(),
					header: e
				}));
			}));
		};
		function Tt(e) {
			var n = e.plugins, o = e.dispatch, r = e.autoResetResize, i = void 0 === r || r, u = e.columns;
			v(n, ["useAbsoluteLayout"], "useResizeColumns");
			var s = h(i);
			w((function() {
				s() && o({ type: l.resetResize });
			}), [u]);
			var a = t.useCallback((function() {
				return o({ type: l.resetResize });
			}), [o]);
			Object.assign(e, { resetResizing: a });
		}
		var Ot = {
			position: "absolute",
			top: 0
		}, Mt = function(e) {
			e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push((function(e, t) {
				var n = t.column;
				return [e, { style: r({}, Ot, {
					left: n.totalLeft + "px",
					width: n.totalWidth + "px"
				}) }];
			})), e.getCellProps.push((function(e, t) {
				var n = t.cell;
				return [e, { style: r({}, Ot, {
					left: n.column.totalLeft + "px",
					width: n.column.totalWidth + "px"
				}) }];
			})), e.getFooterProps.push((function(e, t) {
				var n = t.column;
				return [e, { style: r({}, Ot, {
					left: n.totalLeft + "px",
					width: n.totalWidth + "px"
				}) }];
			}));
		};
		Mt.pluginName = "useAbsoluteLayout";
		var jt = function(e, t) {
			return [e, { style: {
				position: "relative",
				width: t.instance.totalColumnsWidth + "px"
			} }];
		}, Lt = {
			display: "inline-block",
			boxSizing: "border-box"
		}, Nt = function(e, t) {
			return [e, { style: {
				display: "flex",
				width: t.instance.totalColumnsWidth + "px"
			} }];
		}, Dt = function(e) {
			e.getRowProps.push(Nt), e.getHeaderGroupProps.push(Nt), e.getFooterGroupProps.push(Nt), e.getHeaderProps.push((function(e, t) {
				var n = t.column;
				return [e, { style: r({}, Lt, { width: n.totalWidth + "px" }) }];
			})), e.getCellProps.push((function(e, t) {
				var n = t.cell;
				return [e, { style: r({}, Lt, { width: n.column.totalWidth + "px" }) }];
			})), e.getFooterProps.push((function(e, t) {
				var n = t.column;
				return [e, { style: r({}, Lt, { width: n.totalWidth + "px" }) }];
			}));
		};
		function Vt(e) {
			e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
		}
		Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
		var _t = function(e, t) {
			return [e, { style: { minWidth: t.instance.totalColumnsMinWidth + "px" } }];
		}, Xt = function(e, t) {
			return [e, { style: {
				display: "flex",
				flex: "1 0 auto",
				minWidth: t.instance.totalColumnsMinWidth + "px"
			} }];
		}, qt = function(e, t) {
			var n = t.column;
			return [e, { style: {
				boxSizing: "border-box",
				flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
				minWidth: n.totalMinWidth + "px",
				width: n.totalWidth + "px"
			} }];
		}, Kt = function(e, t) {
			var n = t.cell;
			return [e, { style: {
				boxSizing: "border-box",
				flex: n.column.totalFlexWidth + " 0 auto",
				minWidth: n.column.totalMinWidth + "px",
				width: n.column.totalWidth + "px"
			} }];
		}, Ut = function(e, t) {
			var n = t.column;
			return [e, { style: {
				boxSizing: "border-box",
				flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
				minWidth: n.totalMinWidth + "px",
				width: n.totalWidth + "px"
			} }];
		};
		function $t(e) {
			e.stateReducers.push(Zt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt), e.getRowProps.push(Qt);
		}
		l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize", $t.pluginName = "useGridLayout";
		var Jt = function(e, t) {
			var n = t.instance;
			return [e, { style: {
				display: "grid",
				gridTemplateColumns: n.visibleColumns.map((function(e) {
					var t;
					return n.state.gridLayout.columnWidths[e.id] ? n.state.gridLayout.columnWidths[e.id] + "px" : (null == (t = n.state.columnResizing) ? void 0 : t.isResizingColumn) ? n.state.gridLayout.startWidths[e.id] + "px" : "number" == typeof e.width ? e.width + "px" : e.width;
				})).join(" ")
			} }];
		}, Yt = function(e, t) {
			var n = t.column;
			return [e, {
				id: "header-cell-" + n.id,
				style: {
					position: "sticky",
					gridColumn: "span " + n.totalVisibleHeaderCount
				}
			}];
		}, Qt = function(e, t) {
			var n = t.row;
			return n.isExpanded ? [e, { style: { gridColumn: "1 / " + (n.cells.length + 1) } }] : [e, {}];
		};
		function Zt(e, t, n, o) {
			if (t.type === l.init) return r({ gridLayout: { columnWidths: {} } }, e);
			if (t.type === l.resetResize) return r({}, e, { gridLayout: { columnWidths: {} } });
			if (t.type === l.columnStartResizing) {
				var i = t.columnId, u = t.headerIdWidths, s = en(i);
				if (void 0 !== s) {
					var a = o.visibleColumns.reduce((function(e, t) {
						var n;
						return r({}, e, ((n = {})[t.id] = en(t.id), n));
					}), {}), c = o.visibleColumns.reduce((function(e, t) {
						var n;
						return r({}, e, ((n = {})[t.id] = t.minWidth, n));
					}), {}), d = o.visibleColumns.reduce((function(e, t) {
						var n;
						return r({}, e, ((n = {})[t.id] = t.maxWidth, n));
					}), {}), f = u.map((function(e) {
						var t = e[0];
						return [t, en(t)];
					}));
					return r({}, e, { gridLayout: r({}, e.gridLayout, {
						startWidths: a,
						minWidths: c,
						maxWidths: d,
						headerIdGridWidths: f,
						columnWidth: s
					}) });
				}
				return e;
			}
			if (t.type === l.columnResizing) {
				var p = t.clientX, g = e.columnResizing.startX, v = e.gridLayout, m = v.columnWidth, h = v.minWidths, y = v.maxWidths, w = v.headerIdGridWidths, R = (p - g) / m, b = {};
				return (void 0 === w ? [] : w).forEach((function(e) {
					var t = e[0], n = e[1];
					b[t] = Math.min(Math.max(h[t], n + n * R), y[t]);
				})), r({}, e, { gridLayout: r({}, e.gridLayout, { columnWidths: r({}, e.gridLayout.columnWidths, {}, b) }) });
			}
			return t.type === l.columnDoneResizing ? r({}, e, { gridLayout: r({}, e.gridLayout, {
				startWidths: {},
				minWidths: {},
				maxWidths: {}
			}) }) : void 0;
		}
		function en(e) {
			var t, n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
			if (void 0 !== n) return n;
		}
		e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e, n) {
			void 0 === n && (n = 0);
			var r = t.useRef({}), i = h(e), u = h(n);
			return t.useCallback(function() {
				var e = o(regeneratorRuntime.mark((function e() {
					var t, n, l, s = arguments;
					return regeneratorRuntime.wrap((function(e) {
						for (;;) switch (e.prev = e.next) {
							case 0:
								for (t = s.length, n = new Array(t), l = 0; l < t; l++) n[l] = s[l];
								return r.current.promise || (r.current.promise = new Promise((function(e, t) {
									r.current.resolve = e, r.current.reject = t;
								}))), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark((function e() {
									return regeneratorRuntime.wrap((function(e) {
										for (;;) switch (e.prev = e.next) {
											case 0: return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
											case 5:
												e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
												break;
											case 9: e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
											case 12: return e.prev = 12, delete r.current.promise, e.finish(12);
											case 15:
											case "end": return e.stop();
										}
									}), e, null, [[
										1,
										9,
										12,
										15
									]]);
								}))), u()), e.abrupt("return", r.current.promise);
							case 5:
							case "end": return e.stop();
						}
					}), e);
				})));
				return function() {
					return e.apply(this, arguments);
				};
			}(), [i, u]);
		}, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e) {
			for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];
			e = ie(e), o = [K].concat(o);
			var s = h(t.useRef({}).current);
			Object.assign(s(), r({}, e, {
				plugins: o,
				hooks: q()
			})), o.filter(Boolean).forEach((function(e) {
				e(s().hooks);
			}));
			var a = h(s().hooks);
			s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
			var c = s(), d = c.data, v = c.columns, m = c.initialState, y = c.defaultColumn, w = c.getSubRows, b = c.getRowId, E = c.stateReducer, I = c.useControlledState, F = h(E), G = t.useCallback((function(e, t) {
				if (!t.type) throw console.info({ action: t }), /* @__PURE__ */ new Error("Unknown Action 👆");
				return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [F()]).reduce((function(n, o) {
					return o(n, t, e, s()) || n;
				}), e);
			}), [
				a,
				F,
				s
			]), A = t.useReducer(G, void 0, (function() {
				return G(m, { type: l.init });
			})), k = A[0], H = A[1], W = p([].concat(a().useControlledState, [I]), k, { instance: s() });
			Object.assign(s(), {
				state: W,
				dispatch: H
			});
			var z = t.useMemo((function() {
				return S(p(a().columns, v, { instance: s() }));
			}), [
				a,
				s,
				v
			].concat(p(a().columnsDeps, [], { instance: s() })));
			s().columns = z;
			var T = t.useMemo((function() {
				return p(a().allColumns, C(z), { instance: s() }).map(x);
			}), [
				z,
				a,
				s
			].concat(p(a().allColumnsDeps, [], { instance: s() })));
			s().allColumns = T;
			var O = t.useMemo((function() {
				for (var e = [], t = [], n = {}, o = [].concat(T); o.length;) le({
					data: d,
					rows: e,
					flatRows: t,
					rowsById: n,
					column: o.shift(),
					getRowId: b,
					getSubRows: w,
					accessValueHooks: a().accessValue,
					getInstance: s
				});
				return [
					e,
					t,
					n
				];
			}), [
				T,
				d,
				b,
				w,
				a,
				s
			]), M = O[0], j = O[1], L = O[2];
			Object.assign(s(), {
				rows: M,
				initialRows: [].concat(M),
				flatRows: j,
				rowsById: L
			}), g(a().useInstanceAfterData, s());
			var N = t.useMemo((function() {
				return p(a().visibleColumns, T, { instance: s() }).map((function(e) {
					return P(e, y);
				}));
			}), [
				a,
				T,
				s,
				y
			].concat(p(a().visibleColumnsDeps, [], { instance: s() })));
			T = t.useMemo((function() {
				var e = [].concat(N);
				return T.forEach((function(t) {
					e.find((function(e) {
						return e.id === t.id;
					})) || e.push(t);
				})), e;
			}), [T, N]), s().allColumns = T;
			var D = t.useMemo((function() {
				return p(a().headerGroups, B(N, y), s());
			}), [
				a,
				N,
				y,
				s
			].concat(p(a().headerGroupsDeps, [], { instance: s() })));
			s().headerGroups = D;
			var V = t.useMemo((function() {
				return D.length ? D[0].headers : [];
			}), [D]);
			s().headers = V, s().flatHeaders = D.reduce((function(e, t) {
				return [].concat(e, t.headers);
			}), []), g(a().useInstanceBeforeDimensions, s());
			var _ = N.filter((function(e) {
				return e.isVisible;
			})).map((function(e) {
				return e.id;
			})).sort().join("_");
			N = t.useMemo((function() {
				return N.filter((function(e) {
					return e.isVisible;
				}));
			}), [N, _]), s().visibleColumns = N;
			var X = ue(V), U = X[0], $ = X[1], J = X[2];
			return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach((function(e) {
				e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
					instance: s(),
					column: e
				}), e.getFooterProps = f(a().getFooterProps, {
					instance: s(),
					column: e
				});
			})), s().headerGroups = t.useMemo((function() {
				return D.filter((function(e, t) {
					return e.headers = e.headers.filter((function(e) {
						return e.headers ? function e(t) {
							return t.filter((function(t) {
								return t.headers ? e(t.headers) : t.isVisible;
							})).length;
						}(e.headers) : e.isVisible;
					})), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
						instance: s(),
						headerGroup: e,
						index: t
					}), e.getFooterGroupProps = f(a().getFooterGroupProps, {
						instance: s(),
						headerGroup: e,
						index: t
					}), !0);
				}));
			}), [
				D,
				s,
				a
			]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback((function(e) {
				e.getRowProps = f(a().getRowProps, {
					instance: s(),
					row: e
				}), e.allCells = T.map((function(t) {
					var n = e.values[t.id], o = {
						column: t,
						row: e,
						value: n
					};
					return o.getCellProps = f(a().getCellProps, {
						instance: s(),
						cell: o
					}), o.render = R(s(), t, {
						row: e,
						cell: o,
						value: n
					}), o;
				})), e.cells = N.map((function(t) {
					return e.allCells.find((function(e) {
						return e.column.id === t.id;
					}));
				})), g(a().prepareRow, e, { instance: s() });
			}), [
				a,
				s,
				T,
				N
			]), s().getTableProps = f(a().getTableProps, { instance: s() }), s().getTableBodyProps = f(a().getTableBodyProps, { instance: s() }), g(a().useFinalInstance, s()), s();
		}, Object.defineProperty(e, "__esModule", { value: !0 });
	}));
}));
//#endregion
//#region ../../node_modules/react-table/dist/react-table.development.js
var require_react_table_development = /* @__PURE__ */ __commonJSMin(((exports, module, this$2) => {
	(function(global, factory) {
		typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_builtin_esm_external_require_react()) : typeof define === "function" && define.amd ? define(["exports", "react"], factory) : (global = global || self, factory(global.ReactTable = {}, global.React));
	})(this$2, (function(exports, React) {
		"use strict";
		React = React && Object.prototype.hasOwnProperty.call(React, "default") ? React["default"] : React;
		function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
			try {
				var info = gen[key](arg);
				var value = info.value;
			} catch (error) {
				reject(error);
				return;
			}
			if (info.done) resolve(value);
			else Promise.resolve(value).then(_next, _throw);
		}
		function _asyncToGenerator(fn) {
			return function() {
				var self = this, args = arguments;
				return new Promise(function(resolve, reject) {
					var gen = fn.apply(self, args);
					function _next(value) {
						asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
					}
					function _throw(err) {
						asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
					}
					_next(void 0);
				});
			};
		}
		function _extends() {
			_extends = Object.assign || function(target) {
				for (var i = 1; i < arguments.length; i++) {
					var source = arguments[i];
					for (var key in source) if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
				}
				return target;
			};
			return _extends.apply(this, arguments);
		}
		function _objectWithoutPropertiesLoose(source, excluded) {
			if (source == null) return {};
			var target = {};
			var sourceKeys = Object.keys(source);
			var key, i = 0;
			for (; i < sourceKeys.length; i++) {
				key = sourceKeys[i];
				if (excluded.indexOf(key) >= 0) continue;
				target[key] = source[key];
			}
			return target;
		}
		function _toPrimitive(input, hint) {
			if (typeof input !== "object" || input === null) return input;
			var prim = input[Symbol.toPrimitive];
			if (prim !== void 0) {
				var res = prim.call(input, hint || "default");
				if (typeof res !== "object") return res;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return (hint === "string" ? String : Number)(input);
		}
		function _toPropertyKey(arg) {
			var key = _toPrimitive(arg, "string");
			return typeof key === "symbol" ? key : String(key);
		}
		var renderErr = "Renderer Error ☝️";
		var actions = { init: "init" };
		var defaultRenderer = function defaultRenderer(_ref) {
			var _ref$value = _ref.value;
			return _ref$value === void 0 ? "" : _ref$value;
		};
		var emptyRenderer = function emptyRenderer() {
			return React.createElement(React.Fragment, null, "\xA0");
		};
		var defaultColumn = {
			Cell: defaultRenderer,
			width: 150,
			minWidth: 0,
			maxWidth: Number.MAX_SAFE_INTEGER
		};
		function mergeProps() {
			for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) propList[_key] = arguments[_key];
			return propList.reduce(function(props, next) {
				var style = next.style, className = next.className, rest = _objectWithoutPropertiesLoose(next, ["style", "className"]);
				props = _extends({}, props, {}, rest);
				if (style) props.style = props.style ? _extends({}, props.style || {}, {}, style || {}) : style;
				if (className) props.className = props.className ? props.className + " " + className : className;
				if (props.className === "") delete props.className;
				return props;
			}, {});
		}
		function handlePropGetter(prevProps, userProps, meta) {
			if (typeof userProps === "function") return handlePropGetter({}, userProps(prevProps, meta));
			if (Array.isArray(userProps)) return mergeProps.apply(void 0, [prevProps].concat(userProps));
			return mergeProps(prevProps, userProps);
		}
		var makePropGetter = function makePropGetter(hooks, meta) {
			if (meta === void 0) meta = {};
			return function(userProps) {
				if (userProps === void 0) userProps = {};
				return [].concat(hooks, [userProps]).reduce(function(prev, next) {
					return handlePropGetter(prev, next, _extends({}, meta, { userProps }));
				}, {});
			};
		};
		var reduceHooks = function reduceHooks(hooks, initial, meta, allowUndefined) {
			if (meta === void 0) meta = {};
			return hooks.reduce(function(prev, next) {
				var nextValue = next(prev, meta);
				if (!allowUndefined && typeof nextValue === "undefined") {
					console.info(next);
					throw new Error("React Table: A reducer hook ☝️ just returned undefined! This is not allowed.");
				}
				return nextValue;
			}, initial);
		};
		var loopHooks = function loopHooks(hooks, context, meta) {
			if (meta === void 0) meta = {};
			return hooks.forEach(function(hook) {
				var nextValue = hook(context, meta);
				if (typeof nextValue !== "undefined") {
					console.info(hook, nextValue);
					throw new Error("React Table: A loop-type hook ☝️ just returned a value! This is not allowed.");
				}
			});
		};
		function ensurePluginOrder(plugins, befores, pluginName, afters) {
			if (afters) throw new Error("Defining plugins in the \"after\" section of ensurePluginOrder is no longer supported (see plugin " + pluginName + ")");
			var pluginIndex = plugins.findIndex(function(plugin) {
				return plugin.pluginName === pluginName;
			});
			if (pluginIndex === -1) throw new Error("The plugin \"" + pluginName + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + pluginName + ".pluginName = '" + pluginName + "'\n");
			befores.forEach(function(before) {
				var beforeIndex = plugins.findIndex(function(plugin) {
					return plugin.pluginName === before;
				});
				if (beforeIndex > -1 && beforeIndex > pluginIndex) throw new Error("React Table: The " + pluginName + " plugin hook must be placed after the " + before + " plugin hook!");
			});
		}
		function functionalUpdate(updater, old) {
			return typeof updater === "function" ? updater(old) : updater;
		}
		function useGetLatest(obj) {
			var ref = React.useRef();
			ref.current = obj;
			return React.useCallback(function() {
				return ref.current;
			}, []);
		}
		var safeUseLayoutEffect = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
		function useMountedLayoutEffect(fn, deps) {
			var mountedRef = React.useRef(false);
			safeUseLayoutEffect(function() {
				if (mountedRef.current) fn();
				mountedRef.current = true;
			}, deps);
		}
		function useAsyncDebounce(defaultFn, defaultWait) {
			if (defaultWait === void 0) defaultWait = 0;
			var debounceRef = React.useRef({});
			var getDefaultFn = useGetLatest(defaultFn);
			var getDefaultWait = useGetLatest(defaultWait);
			return React.useCallback(/*#__PURE__*/ function() {
				var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
					var _len2, args, _key2, _args2 = arguments;
					return regeneratorRuntime.wrap(function _callee2$(_context2) {
						while (1) switch (_context2.prev = _context2.next) {
							case 0:
								for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = _args2[_key2];
								if (!debounceRef.current.promise) debounceRef.current.promise = new Promise(function(resolve, reject) {
									debounceRef.current.resolve = resolve;
									debounceRef.current.reject = reject;
								});
								if (debounceRef.current.timeout) clearTimeout(debounceRef.current.timeout);
								debounceRef.current.timeout = setTimeout(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
									return regeneratorRuntime.wrap(function _callee$(_context) {
										while (1) switch (_context.prev = _context.next) {
											case 0:
												delete debounceRef.current.timeout;
												_context.prev = 1;
												_context.t0 = debounceRef.current;
												_context.next = 5;
												return getDefaultFn().apply(void 0, args);
											case 5:
												_context.t1 = _context.sent;
												_context.t0.resolve.call(_context.t0, _context.t1);
												_context.next = 12;
												break;
											case 9:
												_context.prev = 9;
												_context.t2 = _context["catch"](1);
												debounceRef.current.reject(_context.t2);
											case 12:
												_context.prev = 12;
												delete debounceRef.current.promise;
												return _context.finish(12);
											case 15:
											case "end": return _context.stop();
										}
									}, _callee, null, [[
										1,
										9,
										12,
										15
									]]);
								})), getDefaultWait());
								return _context2.abrupt("return", debounceRef.current.promise);
							case 5:
							case "end": return _context2.stop();
						}
					}, _callee2);
				}));
				return function() {
					return _ref2.apply(this, arguments);
				};
			}(), [getDefaultFn, getDefaultWait]);
		}
		function makeRenderer(instance, column, meta) {
			if (meta === void 0) meta = {};
			return function(type, userProps) {
				if (userProps === void 0) userProps = {};
				var Comp = typeof type === "string" ? column[type] : type;
				if (typeof Comp === "undefined") {
					console.info(column);
					throw new Error(renderErr);
				}
				return flexRender(Comp, _extends({}, instance, { column }, meta, {}, userProps));
			};
		}
		function flexRender(Comp, props) {
			return isReactComponent(Comp) ? React.createElement(Comp, props) : Comp;
		}
		function isReactComponent(component) {
			return isClassComponent(component) || typeof component === "function" || isExoticComponent(component);
		}
		function isClassComponent(component) {
			return typeof component === "function" && function() {
				var proto = Object.getPrototypeOf(component);
				return proto.prototype && proto.prototype.isReactComponent;
			}();
		}
		function isExoticComponent(component) {
			return typeof component === "object" && typeof component.$$typeof === "symbol" && ["react.memo", "react.forward_ref"].includes(component.$$typeof.description);
		}
		function linkColumnStructure(columns, parent, depth) {
			if (depth === void 0) depth = 0;
			return columns.map(function(column) {
				column = _extends({}, column, {
					parent,
					depth
				});
				assignColumnAccessor(column);
				if (column.columns) column.columns = linkColumnStructure(column.columns, column, depth + 1);
				return column;
			});
		}
		function flattenColumns(columns) {
			return flattenBy(columns, "columns");
		}
		function assignColumnAccessor(column) {
			var id = column.id, accessor = column.accessor, Header = column.Header;
			if (typeof accessor === "string") {
				id = id || accessor;
				var accessorPath = accessor.split(".");
				accessor = function accessor(row) {
					return getBy(row, accessorPath);
				};
			}
			if (!id && typeof Header === "string" && Header) id = Header;
			if (!id && column.columns) {
				console.error(column);
				throw new Error("A column ID (or unique \"Header\" value) is required!");
			}
			if (!id) {
				console.error(column);
				throw new Error("A column ID (or string accessor) is required!");
			}
			Object.assign(column, {
				id,
				accessor
			});
			return column;
		}
		function decorateColumn(column, userDefaultColumn) {
			if (!userDefaultColumn) throw new Error();
			Object.assign(column, _extends({
				Header: emptyRenderer,
				Footer: emptyRenderer
			}, defaultColumn, {}, userDefaultColumn, {}, column));
			Object.assign(column, { originalWidth: column.width });
			return column;
		}
		function makeHeaderGroups(allColumns, defaultColumn, additionalHeaderProperties) {
			if (additionalHeaderProperties === void 0) additionalHeaderProperties = function additionalHeaderProperties() {
				return {};
			};
			var headerGroups = [];
			var scanColumns = allColumns;
			var uid = 0;
			var getUID = function getUID() {
				return uid++;
			};
			var _loop = function _loop() {
				var headerGroup = { headers: [] };
				var parentColumns = [];
				var hasParents = scanColumns.some(function(d) {
					return d.parent;
				});
				scanColumns.forEach(function(column) {
					var latestParentColumn = [].concat(parentColumns).reverse()[0];
					var newParent;
					if (hasParents) {
						if (column.parent) newParent = _extends({}, column.parent, {
							originalId: column.parent.id,
							id: column.parent.id + "_" + getUID(),
							headers: [column]
						}, additionalHeaderProperties(column));
						else {
							var originalId = column.id + "_placeholder";
							newParent = decorateColumn(_extends({
								originalId,
								id: column.id + "_placeholder_" + getUID(),
								placeholderOf: column,
								headers: [column]
							}, additionalHeaderProperties(column)), defaultColumn);
						}
						if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) latestParentColumn.headers.push(column);
						else parentColumns.push(newParent);
					}
					headerGroup.headers.push(column);
				});
				headerGroups.push(headerGroup);
				scanColumns = parentColumns;
			};
			while (scanColumns.length) _loop();
			return headerGroups.reverse();
		}
		var pathObjCache = /* @__PURE__ */ new Map();
		function getBy(obj, path, def) {
			if (!path) return obj;
			var cacheKey = typeof path === "function" ? path : JSON.stringify(path);
			var pathObj = pathObjCache.get(cacheKey) || function() {
				var pathObj = makePathArray(path);
				pathObjCache.set(cacheKey, pathObj);
				return pathObj;
			}();
			var val;
			try {
				val = pathObj.reduce(function(cursor, pathPart) {
					return cursor[pathPart];
				}, obj);
			} catch (e) {}
			return typeof val !== "undefined" ? val : def;
		}
		function getFirstDefined() {
			for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
			for (var i = 0; i < args.length; i += 1) if (typeof args[i] !== "undefined") return args[i];
		}
		function isFunction(a) {
			if (typeof a === "function") return a;
		}
		function flattenBy(arr, key) {
			var flat = [];
			(function recurse(arr) {
				arr.forEach(function(d) {
					if (!d[key]) flat.push(d);
					else recurse(d[key]);
				});
			})(arr);
			return flat;
		}
		function expandRows(rows, _ref) {
			var manualExpandedKey = _ref.manualExpandedKey, expanded = _ref.expanded, _ref$expandSubRows = _ref.expandSubRows, expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
			var expandedRows = [];
			var handleRow = function handleRow(row, addToExpandedRows) {
				if (addToExpandedRows === void 0) addToExpandedRows = true;
				row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
				row.canExpand = row.subRows && !!row.subRows.length;
				if (addToExpandedRows) expandedRows.push(row);
				if (row.subRows && row.subRows.length && row.isExpanded) row.subRows.forEach(function(row) {
					return handleRow(row, expandSubRows);
				});
			};
			rows.forEach(function(row) {
				return handleRow(row);
			});
			return expandedRows;
		}
		function getFilterMethod(filter, userFilterTypes, filterTypes) {
			return isFunction(filter) || userFilterTypes[filter] || filterTypes[filter] || filterTypes.text;
		}
		function shouldAutoRemoveFilter(autoRemove, value, column) {
			return autoRemove ? autoRemove(value, column) : typeof value === "undefined";
		}
		function unpreparedAccessWarning() {
			throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
		}
		var passiveSupported = null;
		function passiveEventSupported() {
			if (typeof passiveSupported === "boolean") return passiveSupported;
			var supported = false;
			try {
				var options = { get passive() {
					supported = true;
					return false;
				} };
				window.addEventListener("test", null, options);
				window.removeEventListener("test", null, options);
			} catch (err) {
				supported = false;
			}
			passiveSupported = supported;
			return passiveSupported;
		}
		var reOpenBracket = /\[/g;
		var reCloseBracket = /\]/g;
		function makePathArray(obj) {
			return flattenDeep(obj).map(function(d) {
				return String(d).replace(".", "_");
			}).join(".").replace(reOpenBracket, ".").replace(reCloseBracket, "").split(".");
		}
		function flattenDeep(arr, newArr) {
			if (newArr === void 0) newArr = [];
			if (!Array.isArray(arr)) newArr.push(arr);
			else for (var i = 0; i < arr.length; i += 1) flattenDeep(arr[i], newArr);
			return newArr;
		}
		var defaultGetTableProps = function defaultGetTableProps(props) {
			return _extends({ role: "table" }, props);
		};
		var defaultGetTableBodyProps = function defaultGetTableBodyProps(props) {
			return _extends({ role: "rowgroup" }, props);
		};
		var defaultGetHeaderProps = function defaultGetHeaderProps(props, _ref) {
			var column = _ref.column;
			return _extends({
				key: "header_" + column.id,
				colSpan: column.totalVisibleHeaderCount,
				role: "columnheader"
			}, props);
		};
		var defaultGetFooterProps = function defaultGetFooterProps(props, _ref2) {
			var column = _ref2.column;
			return _extends({
				key: "footer_" + column.id,
				colSpan: column.totalVisibleHeaderCount
			}, props);
		};
		var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps(props, _ref3) {
			var index = _ref3.index;
			return _extends({
				key: "headerGroup_" + index,
				role: "row"
			}, props);
		};
		var defaultGetFooterGroupProps = function defaultGetFooterGroupProps(props, _ref4) {
			var index = _ref4.index;
			return _extends({ key: "footerGroup_" + index }, props);
		};
		var defaultGetRowProps = function defaultGetRowProps(props, _ref5) {
			var row = _ref5.row;
			return _extends({
				key: "row_" + row.id,
				role: "row"
			}, props);
		};
		var defaultGetCellProps = function defaultGetCellProps(props, _ref6) {
			var cell = _ref6.cell;
			return _extends({
				key: "cell_" + cell.row.id + "_" + cell.column.id,
				role: "cell"
			}, props);
		};
		function makeDefaultPluginHooks() {
			return {
				useOptions: [],
				stateReducers: [],
				useControlledState: [],
				columns: [],
				columnsDeps: [],
				allColumns: [],
				allColumnsDeps: [],
				accessValue: [],
				materializedColumns: [],
				materializedColumnsDeps: [],
				useInstanceAfterData: [],
				visibleColumns: [],
				visibleColumnsDeps: [],
				headerGroups: [],
				headerGroupsDeps: [],
				useInstanceBeforeDimensions: [],
				useInstance: [],
				prepareRow: [],
				getTableProps: [defaultGetTableProps],
				getTableBodyProps: [defaultGetTableBodyProps],
				getHeaderGroupProps: [defaultGetHeaderGroupProps],
				getFooterGroupProps: [defaultGetFooterGroupProps],
				getHeaderProps: [defaultGetHeaderProps],
				getFooterProps: [defaultGetFooterProps],
				getRowProps: [defaultGetRowProps],
				getCellProps: [defaultGetCellProps],
				useFinalInstance: []
			};
		}
		actions.resetHiddenColumns = "resetHiddenColumns";
		actions.toggleHideColumn = "toggleHideColumn";
		actions.setHiddenColumns = "setHiddenColumns";
		actions.toggleHideAllColumns = "toggleHideAllColumns";
		var useColumnVisibility = function useColumnVisibility(hooks) {
			hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
			hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
			hooks.stateReducers.push(reducer);
			hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
			hooks.headerGroupsDeps.push(function(deps, _ref) {
				var instance = _ref.instance;
				return [].concat(deps, [instance.state.hiddenColumns]);
			});
			hooks.useInstance.push(useInstance);
		};
		useColumnVisibility.pluginName = "useColumnVisibility";
		var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps(props, _ref2) {
			var column = _ref2.column;
			return [props, {
				onChange: function onChange(e) {
					column.toggleHidden(!e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: column.isVisible,
				title: "Toggle Column Visible"
			}];
		};
		var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps(props, _ref3) {
			var instance = _ref3.instance;
			return [props, {
				onChange: function onChange(e) {
					instance.toggleHideAllColumns(!e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
				title: "Toggle All Columns Hidden",
				indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
			}];
		};
		function reducer(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ hiddenColumns: [] }, state);
			if (action.type === actions.resetHiddenColumns) return _extends({}, state, { hiddenColumns: instance.initialState.hiddenColumns || [] });
			if (action.type === actions.toggleHideColumn) {
				var hiddenColumns = (typeof action.value !== "undefined" ? action.value : !state.hiddenColumns.includes(action.columnId)) ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function(d) {
					return d !== action.columnId;
				});
				return _extends({}, state, { hiddenColumns });
			}
			if (action.type === actions.setHiddenColumns) return _extends({}, state, { hiddenColumns: functionalUpdate(action.value, state.hiddenColumns) });
			if (action.type === actions.toggleHideAllColumns) {
				var shouldAll = typeof action.value !== "undefined" ? action.value : !state.hiddenColumns.length;
				return _extends({}, state, { hiddenColumns: shouldAll ? instance.allColumns.map(function(d) {
					return d.id;
				}) : [] });
			}
		}
		function useInstanceBeforeDimensions(instance) {
			var headers = instance.headers, hiddenColumns = instance.state.hiddenColumns;
			if (!React.useRef(false).current);
			var handleColumn = function handleColumn(column, parentVisible) {
				column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
				var totalVisibleHeaderCount = 0;
				if (column.headers && column.headers.length) column.headers.forEach(function(subColumn) {
					return totalVisibleHeaderCount += handleColumn(subColumn, column.isVisible);
				});
				else totalVisibleHeaderCount = column.isVisible ? 1 : 0;
				column.totalVisibleHeaderCount = totalVisibleHeaderCount;
				return totalVisibleHeaderCount;
			};
			var totalVisibleHeaderCount = 0;
			headers.forEach(function(subHeader) {
				return totalVisibleHeaderCount += handleColumn(subHeader, true);
			});
		}
		function useInstance(instance) {
			var columns = instance.columns, flatHeaders = instance.flatHeaders, dispatch = instance.dispatch, allColumns = instance.allColumns, getHooks = instance.getHooks, hiddenColumns = instance.state.hiddenColumns, _instance$autoResetHi = instance.autoResetHiddenColumns, autoResetHiddenColumns = _instance$autoResetHi === void 0 ? true : _instance$autoResetHi;
			var getInstance = useGetLatest(instance);
			var allColumnsHidden = allColumns.length === hiddenColumns.length;
			var toggleHideColumn = React.useCallback(function(columnId, value) {
				return dispatch({
					type: actions.toggleHideColumn,
					columnId,
					value
				});
			}, [dispatch]);
			var setHiddenColumns = React.useCallback(function(value) {
				return dispatch({
					type: actions.setHiddenColumns,
					value
				});
			}, [dispatch]);
			var toggleHideAllColumns = React.useCallback(function(value) {
				return dispatch({
					type: actions.toggleHideAllColumns,
					value
				});
			}, [dispatch]);
			var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, { instance: getInstance() });
			flatHeaders.forEach(function(column) {
				column.toggleHidden = function(value) {
					dispatch({
						type: actions.toggleHideColumn,
						columnId: column.id,
						value
					});
				};
				column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
					instance: getInstance(),
					column
				});
			});
			var getAutoResetHiddenColumns = useGetLatest(autoResetHiddenColumns);
			useMountedLayoutEffect(function() {
				if (getAutoResetHiddenColumns()) dispatch({ type: actions.resetHiddenColumns });
			}, [dispatch, columns]);
			Object.assign(instance, {
				allColumnsHidden,
				toggleHideColumn,
				setHiddenColumns,
				toggleHideAllColumns,
				getToggleHideAllColumnsProps
			});
		}
		var defaultInitialState = {};
		var defaultColumnInstance = {};
		var defaultReducer = function defaultReducer(state, action, prevState) {
			return state;
		};
		var defaultGetSubRows = function defaultGetSubRows(row, index) {
			return row.subRows || [];
		};
		var defaultGetRowId = function defaultGetRowId(row, index, parent) {
			return "" + (parent ? [parent.id, index].join(".") : index);
		};
		var defaultUseControlledState = function defaultUseControlledState(d) {
			return d;
		};
		function applyDefaults(props) {
			var _props$initialState = props.initialState, initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState, _props$defaultColumn = props.defaultColumn, defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn, _props$getSubRows = props.getSubRows, getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows, _props$getRowId = props.getRowId, getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId, _props$stateReducer = props.stateReducer, stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer, _props$useControlledS = props.useControlledState, useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS, rest = _objectWithoutPropertiesLoose(props, [
				"initialState",
				"defaultColumn",
				"getSubRows",
				"getRowId",
				"stateReducer",
				"useControlledState"
			]);
			return _extends({}, rest, {
				initialState,
				defaultColumn,
				getSubRows,
				getRowId,
				stateReducer,
				useControlledState
			});
		}
		var useTable = function useTable(props) {
			for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) plugins[_key - 1] = arguments[_key];
			props = applyDefaults(props);
			plugins = [useColumnVisibility].concat(plugins);
			var getInstance = useGetLatest(React.useRef({}).current);
			Object.assign(getInstance(), _extends({}, props, {
				plugins,
				hooks: makeDefaultPluginHooks()
			}));
			plugins.filter(Boolean).forEach(function(plugin) {
				plugin(getInstance().hooks);
			});
			var getHooks = useGetLatest(getInstance().hooks);
			getInstance().getHooks = getHooks;
			delete getInstance().hooks;
			Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));
			var _getInstance = getInstance(), data = _getInstance.data, userColumns = _getInstance.columns, initialState = _getInstance.initialState, defaultColumn = _getInstance.defaultColumn, getSubRows = _getInstance.getSubRows, getRowId = _getInstance.getRowId, stateReducer = _getInstance.stateReducer, useControlledState = _getInstance.useControlledState;
			var getStateReducer = useGetLatest(stateReducer);
			var reducer = React.useCallback(function(state, action) {
				if (!action.type) {
					console.info({ action });
					throw new Error("Unknown Action 👆");
				}
				return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function(s, handler) {
					return handler(s, action, state, getInstance()) || s;
				}, state);
			}, [
				getHooks,
				getStateReducer,
				getInstance
			]);
			var _React$useReducer = React.useReducer(reducer, void 0, function() {
				return reducer(initialState, { type: actions.init });
			}), reducerState = _React$useReducer[0], dispatch = _React$useReducer[1];
			var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, { instance: getInstance() });
			Object.assign(getInstance(), {
				state,
				dispatch
			});
			var columns = React.useMemo(function() {
				return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, { instance: getInstance() }));
			}, [
				getHooks,
				getInstance,
				userColumns
			].concat(reduceHooks(getHooks().columnsDeps, [], { instance: getInstance() })));
			getInstance().columns = columns;
			var allColumns = React.useMemo(function() {
				return reduceHooks(getHooks().allColumns, flattenColumns(columns), { instance: getInstance() }).map(assignColumnAccessor);
			}, [
				columns,
				getHooks,
				getInstance
			].concat(reduceHooks(getHooks().allColumnsDeps, [], { instance: getInstance() })));
			getInstance().allColumns = allColumns;
			var _React$useMemo = React.useMemo(function() {
				var rows = [];
				var flatRows = [];
				var rowsById = {};
				var allColumnsQueue = [].concat(allColumns);
				while (allColumnsQueue.length) accessRowsForColumn({
					data,
					rows,
					flatRows,
					rowsById,
					column: allColumnsQueue.shift(),
					getRowId,
					getSubRows,
					accessValueHooks: getHooks().accessValue,
					getInstance
				});
				return [
					rows,
					flatRows,
					rowsById
				];
			}, [
				allColumns,
				data,
				getRowId,
				getSubRows,
				getHooks,
				getInstance
			]), rows = _React$useMemo[0], flatRows = _React$useMemo[1], rowsById = _React$useMemo[2];
			Object.assign(getInstance(), {
				rows,
				initialRows: [].concat(rows),
				flatRows,
				rowsById
			});
			loopHooks(getHooks().useInstanceAfterData, getInstance());
			var visibleColumns = React.useMemo(function() {
				return reduceHooks(getHooks().visibleColumns, allColumns, { instance: getInstance() }).map(function(d) {
					return decorateColumn(d, defaultColumn);
				});
			}, [
				getHooks,
				allColumns,
				getInstance,
				defaultColumn
			].concat(reduceHooks(getHooks().visibleColumnsDeps, [], { instance: getInstance() })));
			allColumns = React.useMemo(function() {
				var columns = [].concat(visibleColumns);
				allColumns.forEach(function(column) {
					if (!columns.find(function(d) {
						return d.id === column.id;
					})) columns.push(column);
				});
				return columns;
			}, [allColumns, visibleColumns]);
			getInstance().allColumns = allColumns;
			var duplicateColumns = allColumns.filter(function(column, i) {
				return allColumns.findIndex(function(d) {
					return d.id === column.id;
				}) !== i;
			});
			if (duplicateColumns.length) {
				console.info(allColumns);
				throw new Error("Duplicate columns were found with ids: \"" + duplicateColumns.map(function(d) {
					return d.id;
				}).join(", ") + "\" in the columns array above");
			}
			var headerGroups = React.useMemo(function() {
				return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
			}, [
				getHooks,
				visibleColumns,
				defaultColumn,
				getInstance
			].concat(reduceHooks(getHooks().headerGroupsDeps, [], { instance: getInstance() })));
			getInstance().headerGroups = headerGroups;
			var headers = React.useMemo(function() {
				return headerGroups.length ? headerGroups[0].headers : [];
			}, [headerGroups]);
			getInstance().headers = headers;
			getInstance().flatHeaders = headerGroups.reduce(function(all, headerGroup) {
				return [].concat(all, headerGroup.headers);
			}, []);
			loopHooks(getHooks().useInstanceBeforeDimensions, getInstance());
			var visibleColumnsDep = visibleColumns.filter(function(d) {
				return d.isVisible;
			}).map(function(d) {
				return d.id;
			}).sort().join("_");
			visibleColumns = React.useMemo(function() {
				return visibleColumns.filter(function(d) {
					return d.isVisible;
				});
			}, [visibleColumns, visibleColumnsDep]);
			getInstance().visibleColumns = visibleColumns;
			var _calculateHeaderWidth = calculateHeaderWidths(headers), totalColumnsMinWidth = _calculateHeaderWidth[0], totalColumnsWidth = _calculateHeaderWidth[1], totalColumnsMaxWidth = _calculateHeaderWidth[2];
			getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
			getInstance().totalColumnsWidth = totalColumnsWidth;
			getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
			loopHooks(getHooks().useInstance, getInstance());
			[].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function(column) {
				column.render = makeRenderer(getInstance(), column);
				column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
					instance: getInstance(),
					column
				});
				column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
					instance: getInstance(),
					column
				});
			});
			getInstance().headerGroups = React.useMemo(function() {
				return headerGroups.filter(function(headerGroup, i) {
					headerGroup.headers = headerGroup.headers.filter(function(column) {
						var recurse = function recurse(headers) {
							return headers.filter(function(column) {
								if (column.headers) return recurse(column.headers);
								return column.isVisible;
							}).length;
						};
						if (column.headers) return recurse(column.headers);
						return column.isVisible;
					});
					if (headerGroup.headers.length) {
						headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
							instance: getInstance(),
							headerGroup,
							index: i
						});
						headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
							instance: getInstance(),
							headerGroup,
							index: i
						});
						return true;
					}
					return false;
				});
			}, [
				headerGroups,
				getInstance,
				getHooks
			]);
			getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse();
			getInstance().prepareRow = React.useCallback(function(row) {
				row.getRowProps = makePropGetter(getHooks().getRowProps, {
					instance: getInstance(),
					row
				});
				row.allCells = allColumns.map(function(column) {
					var value = row.values[column.id];
					var cell = {
						column,
						row,
						value
					};
					cell.getCellProps = makePropGetter(getHooks().getCellProps, {
						instance: getInstance(),
						cell
					});
					cell.render = makeRenderer(getInstance(), column, {
						row,
						cell,
						value
					});
					return cell;
				});
				row.cells = visibleColumns.map(function(column) {
					return row.allCells.find(function(cell) {
						return cell.column.id === column.id;
					});
				});
				loopHooks(getHooks().prepareRow, row, { instance: getInstance() });
			}, [
				getHooks,
				getInstance,
				allColumns,
				visibleColumns
			]);
			getInstance().getTableProps = makePropGetter(getHooks().getTableProps, { instance: getInstance() });
			getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, { instance: getInstance() });
			loopHooks(getHooks().useFinalInstance, getInstance());
			return getInstance();
		};
		function calculateHeaderWidths(headers, left) {
			if (left === void 0) left = 0;
			var sumTotalMinWidth = 0;
			var sumTotalWidth = 0;
			var sumTotalMaxWidth = 0;
			var sumTotalFlexWidth = 0;
			headers.forEach(function(header) {
				var subHeaders = header.headers;
				header.totalLeft = left;
				if (subHeaders && subHeaders.length) {
					var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left), totalMinWidth = _calculateHeaderWidth2[0], totalWidth = _calculateHeaderWidth2[1], totalMaxWidth = _calculateHeaderWidth2[2], totalFlexWidth = _calculateHeaderWidth2[3];
					header.totalMinWidth = totalMinWidth;
					header.totalWidth = totalWidth;
					header.totalMaxWidth = totalMaxWidth;
					header.totalFlexWidth = totalFlexWidth;
				} else {
					header.totalMinWidth = header.minWidth;
					header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
					header.totalMaxWidth = header.maxWidth;
					header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
				}
				if (header.isVisible) {
					left += header.totalWidth;
					sumTotalMinWidth += header.totalMinWidth;
					sumTotalWidth += header.totalWidth;
					sumTotalMaxWidth += header.totalMaxWidth;
					sumTotalFlexWidth += header.totalFlexWidth;
				}
			});
			return [
				sumTotalMinWidth,
				sumTotalWidth,
				sumTotalMaxWidth,
				sumTotalFlexWidth
			];
		}
		function accessRowsForColumn(_ref) {
			var data = _ref.data, rows = _ref.rows, flatRows = _ref.flatRows, rowsById = _ref.rowsById, column = _ref.column, getRowId = _ref.getRowId, getSubRows = _ref.getSubRows, accessValueHooks = _ref.accessValueHooks, getInstance = _ref.getInstance;
			var accessRow = function accessRow(originalRow, rowIndex, depth, parent, parentRows) {
				if (depth === void 0) depth = 0;
				var original = originalRow;
				var id = getRowId(originalRow, rowIndex, parent);
				var row = rowsById[id];
				if (!row) {
					row = {
						id,
						original,
						index: rowIndex,
						depth,
						cells: [{}]
					};
					row.cells.map = unpreparedAccessWarning;
					row.cells.filter = unpreparedAccessWarning;
					row.cells.forEach = unpreparedAccessWarning;
					row.cells[0].getCellProps = unpreparedAccessWarning;
					row.values = {};
					parentRows.push(row);
					flatRows.push(row);
					rowsById[id] = row;
					row.originalSubRows = getSubRows(originalRow, rowIndex);
					if (row.originalSubRows) {
						var subRows = [];
						row.originalSubRows.forEach(function(d, i) {
							return accessRow(d, i, depth + 1, row, subRows);
						});
						row.subRows = subRows;
					}
				} else if (row.subRows) row.originalSubRows.forEach(function(d, i) {
					return accessRow(d, i, depth + 1, row);
				});
				if (column.accessor) row.values[column.id] = column.accessor(originalRow, rowIndex, row, parentRows, data);
				row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
					row,
					column,
					instance: getInstance()
				}, true);
			};
			data.forEach(function(originalRow, rowIndex) {
				return accessRow(originalRow, rowIndex, 0, void 0, rows);
			});
		}
		actions.resetExpanded = "resetExpanded";
		actions.toggleRowExpanded = "toggleRowExpanded";
		actions.toggleAllRowsExpanded = "toggleAllRowsExpanded";
		var useExpanded = function useExpanded(hooks) {
			hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
			hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
			hooks.stateReducers.push(reducer$1);
			hooks.useInstance.push(useInstance$1);
			hooks.prepareRow.push(prepareRow);
		};
		useExpanded.pluginName = "useExpanded";
		var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
			var instance = _ref.instance;
			return [props, {
				onClick: function onClick(e) {
					instance.toggleAllRowsExpanded();
				},
				style: { cursor: "pointer" },
				title: "Toggle All Rows Expanded"
			}];
		};
		var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
			var row = _ref2.row;
			return [props, {
				onClick: function onClick() {
					row.toggleRowExpanded();
				},
				style: { cursor: "pointer" },
				title: "Toggle Row Expanded"
			}];
		};
		function reducer$1(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ expanded: {} }, state);
			if (action.type === actions.resetExpanded) return _extends({}, state, { expanded: instance.initialState.expanded || {} });
			if (action.type === actions.toggleAllRowsExpanded) {
				var value = action.value;
				var rowsById = instance.rowsById;
				var isAllRowsExpanded = Object.keys(rowsById).length === Object.keys(state.expanded).length;
				if (typeof value !== "undefined" ? value : !isAllRowsExpanded) {
					var expanded = {};
					Object.keys(rowsById).forEach(function(rowId) {
						expanded[rowId] = true;
					});
					return _extends({}, state, { expanded });
				}
				return _extends({}, state, { expanded: {} });
			}
			if (action.type === actions.toggleRowExpanded) {
				var id = action.id, setExpanded = action.value;
				var exists = state.expanded[id];
				var shouldExist = typeof setExpanded !== "undefined" ? setExpanded : !exists;
				if (!exists && shouldExist) {
					var _extends2;
					return _extends({}, state, { expanded: _extends({}, state.expanded, (_extends2 = {}, _extends2[id] = true, _extends2)) });
				} else if (exists && !shouldExist) {
					var _state$expanded = state.expanded;
					_state$expanded[id];
					var rest = _objectWithoutPropertiesLoose(_state$expanded, [id].map(_toPropertyKey));
					return _extends({}, state, { expanded: rest });
				} else return state;
			}
		}
		function useInstance$1(instance) {
			var data = instance.data, rows = instance.rows, rowsById = instance.rowsById, _instance$manualExpan = instance.manualExpandedKey, manualExpandedKey = _instance$manualExpan === void 0 ? "expanded" : _instance$manualExpan, _instance$paginateExp = instance.paginateExpandedRows, paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp, _instance$expandSubRo = instance.expandSubRows, expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo, _instance$autoResetEx = instance.autoResetExpanded, autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx, getHooks = instance.getHooks, plugins = instance.plugins, expanded = instance.state.expanded, dispatch = instance.dispatch;
			ensurePluginOrder(plugins, [
				"useSortBy",
				"useGroupBy",
				"usePivotColumns",
				"useGlobalFilter"
			], "useExpanded");
			var getAutoResetExpanded = useGetLatest(autoResetExpanded);
			var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);
			if (isAllRowsExpanded) {
				if (Object.keys(rowsById).some(function(id) {
					return !expanded[id];
				})) isAllRowsExpanded = false;
			}
			useMountedLayoutEffect(function() {
				if (getAutoResetExpanded()) dispatch({ type: actions.resetExpanded });
			}, [dispatch, data]);
			var toggleRowExpanded = React.useCallback(function(id, value) {
				dispatch({
					type: actions.toggleRowExpanded,
					id,
					value
				});
			}, [dispatch]);
			var toggleAllRowsExpanded = React.useCallback(function(value) {
				return dispatch({
					type: actions.toggleAllRowsExpanded,
					value
				});
			}, [dispatch]);
			var expandedRows = React.useMemo(function() {
				if (paginateExpandedRows) return expandRows(rows, {
					manualExpandedKey,
					expanded,
					expandSubRows
				});
				return rows;
			}, [
				paginateExpandedRows,
				rows,
				manualExpandedKey,
				expanded,
				expandSubRows
			]);
			var expandedDepth = React.useMemo(function() {
				return findExpandedDepth(expanded);
			}, [expanded]);
			var getInstance = useGetLatest(instance);
			var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, { instance: getInstance() });
			Object.assign(instance, {
				preExpandedRows: rows,
				expandedRows,
				rows: expandedRows,
				expandedDepth,
				isAllRowsExpanded,
				toggleRowExpanded,
				toggleAllRowsExpanded,
				getToggleAllRowsExpandedProps
			});
		}
		function prepareRow(row, _ref3) {
			var getHooks = _ref3.instance.getHooks, instance = _ref3.instance;
			row.toggleRowExpanded = function(set) {
				return instance.toggleRowExpanded(row.id, set);
			};
			row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
				instance,
				row
			});
		}
		function findExpandedDepth(expanded) {
			var maxDepth = 0;
			Object.keys(expanded).forEach(function(id) {
				var splitId = id.split(".");
				maxDepth = Math.max(maxDepth, splitId.length);
			});
			return maxDepth;
		}
		var text = function text(rows, ids, filterValue) {
			rows = rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
				});
			});
			return rows;
		};
		text.autoRemove = function(val) {
			return !val;
		};
		var exactText = function exactText(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return rowValue !== void 0 ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
				});
			});
		};
		exactText.autoRemove = function(val) {
			return !val;
		};
		var exactTextCase = function exactTextCase(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return rowValue !== void 0 ? String(rowValue) === String(filterValue) : true;
				});
			});
		};
		exactTextCase.autoRemove = function(val) {
			return !val;
		};
		var includes = function includes(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					return row.values[id].includes(filterValue);
				});
			});
		};
		includes.autoRemove = function(val) {
			return !val || !val.length;
		};
		var includesAll = function includesAll(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return rowValue && rowValue.length && filterValue.every(function(val) {
						return rowValue.includes(val);
					});
				});
			});
		};
		includesAll.autoRemove = function(val) {
			return !val || !val.length;
		};
		var includesSome = function includesSome(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return rowValue && rowValue.length && filterValue.some(function(val) {
						return rowValue.includes(val);
					});
				});
			});
		};
		includesSome.autoRemove = function(val) {
			return !val || !val.length;
		};
		var includesValue = function includesValue(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return filterValue.includes(rowValue);
				});
			});
		};
		includesValue.autoRemove = function(val) {
			return !val || !val.length;
		};
		var exact = function exact(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					return row.values[id] === filterValue;
				});
			});
		};
		exact.autoRemove = function(val) {
			return typeof val === "undefined";
		};
		var equals = function equals(rows, ids, filterValue) {
			return rows.filter(function(row) {
				return ids.some(function(id) {
					return row.values[id] == filterValue;
				});
			});
		};
		equals.autoRemove = function(val) {
			return val == null;
		};
		var between = function between(rows, ids, filterValue) {
			var _ref = filterValue || [], min = _ref[0], max = _ref[1];
			min = typeof min === "number" ? min : -Infinity;
			max = typeof max === "number" ? max : Infinity;
			if (min > max) {
				var temp = min;
				min = max;
				max = temp;
			}
			return rows.filter(function(row) {
				return ids.some(function(id) {
					var rowValue = row.values[id];
					return rowValue >= min && rowValue <= max;
				});
			});
		};
		between.autoRemove = function(val) {
			return !val || typeof val[0] !== "number" && typeof val[1] !== "number";
		};
		var filterTypes = /*#__PURE__*/ Object.freeze({
			__proto__: null,
			text,
			exactText,
			exactTextCase,
			includes,
			includesAll,
			includesSome,
			includesValue,
			exact,
			equals,
			between
		});
		actions.resetFilters = "resetFilters";
		actions.setFilter = "setFilter";
		actions.setAllFilters = "setAllFilters";
		var useFilters = function useFilters(hooks) {
			hooks.stateReducers.push(reducer$2);
			hooks.useInstance.push(useInstance$2);
		};
		useFilters.pluginName = "useFilters";
		function reducer$2(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ filters: [] }, state);
			if (action.type === actions.resetFilters) return _extends({}, state, { filters: instance.initialState.filters || [] });
			if (action.type === actions.setFilter) {
				var columnId = action.columnId, filterValue = action.filterValue;
				var allColumns = instance.allColumns, userFilterTypes = instance.filterTypes;
				var column = allColumns.find(function(d) {
					return d.id === columnId;
				});
				if (!column) throw new Error("React-Table: Could not find a column with id: " + columnId);
				var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
				var previousfilter = state.filters.find(function(d) {
					return d.id === columnId;
				});
				var newFilter = functionalUpdate(filterValue, previousfilter && previousfilter.value);
				if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter, column)) return _extends({}, state, { filters: state.filters.filter(function(d) {
					return d.id !== columnId;
				}) });
				if (previousfilter) return _extends({}, state, { filters: state.filters.map(function(d) {
					if (d.id === columnId) return {
						id: columnId,
						value: newFilter
					};
					return d;
				}) });
				return _extends({}, state, { filters: [].concat(state.filters, [{
					id: columnId,
					value: newFilter
				}]) });
			}
			if (action.type === actions.setAllFilters) {
				var filters = action.filters;
				var _allColumns = instance.allColumns, _userFilterTypes = instance.filterTypes;
				return _extends({}, state, { filters: functionalUpdate(filters, state.filters).filter(function(filter) {
					var column = _allColumns.find(function(d) {
						return d.id === filter.id;
					});
					if (shouldAutoRemoveFilter(getFilterMethod(column.filter, _userFilterTypes || {}, filterTypes).autoRemove, filter.value, column)) return false;
					return true;
				}) });
			}
		}
		function useInstance$2(instance) {
			var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, rowsById = instance.rowsById, allColumns = instance.allColumns, userFilterTypes = instance.filterTypes, manualFilters = instance.manualFilters, _instance$defaultCanF = instance.defaultCanFilter, defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF, disableFilters = instance.disableFilters, filters = instance.state.filters, dispatch = instance.dispatch, _instance$autoResetFi = instance.autoResetFilters, autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
			var setFilter = React.useCallback(function(columnId, filterValue) {
				dispatch({
					type: actions.setFilter,
					columnId,
					filterValue
				});
			}, [dispatch]);
			var setAllFilters = React.useCallback(function(filters) {
				dispatch({
					type: actions.setAllFilters,
					filters
				});
			}, [dispatch]);
			allColumns.forEach(function(column) {
				var id = column.id, accessor = column.accessor, columnDefaultCanFilter = column.defaultCanFilter, columnDisableFilters = column.disableFilters;
				column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : void 0, disableFilters === true ? false : void 0, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false);
				column.setFilter = function(val) {
					return setFilter(column.id, val);
				};
				var found = filters.find(function(d) {
					return d.id === id;
				});
				column.filterValue = found && found.value;
			});
			var _React$useMemo = React.useMemo(function() {
				if (manualFilters || !filters.length) return [
					rows,
					flatRows,
					rowsById
				];
				var filteredFlatRows = [];
				var filteredRowsById = {};
				return [
					function filterRows(rows, depth) {
						if (depth === void 0) depth = 0;
						var filteredRows = rows;
						filteredRows = filters.reduce(function(filteredSoFar, _ref) {
							var columnId = _ref.id, filterValue = _ref.value;
							var column = allColumns.find(function(d) {
								return d.id === columnId;
							});
							if (!column) return filteredSoFar;
							if (depth === 0) column.preFilteredRows = filteredSoFar;
							var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
							if (!filterMethod) {
								console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
								return filteredSoFar;
							}
							column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
							return column.filteredRows;
						}, rows);
						filteredRows.forEach(function(row) {
							filteredFlatRows.push(row);
							filteredRowsById[row.id] = row;
							if (!row.subRows) return;
							row.subRows = row.subRows && row.subRows.length > 0 ? filterRows(row.subRows, depth + 1) : row.subRows;
						});
						return filteredRows;
					}(rows),
					filteredFlatRows,
					filteredRowsById
				];
			}, [
				manualFilters,
				filters,
				rows,
				flatRows,
				rowsById,
				allColumns,
				userFilterTypes
			]), filteredRows = _React$useMemo[0], filteredFlatRows = _React$useMemo[1], filteredRowsById = _React$useMemo[2];
			React.useMemo(function() {
				allColumns.filter(function(column) {
					return !filters.find(function(d) {
						return d.id === column.id;
					});
				}).forEach(function(column) {
					column.preFilteredRows = filteredRows;
					column.filteredRows = filteredRows;
				});
			}, [
				filteredRows,
				filters,
				allColumns
			]);
			var getAutoResetFilters = useGetLatest(autoResetFilters);
			useMountedLayoutEffect(function() {
				if (getAutoResetFilters()) dispatch({ type: actions.resetFilters });
			}, [dispatch, manualFilters ? null : data]);
			Object.assign(instance, {
				preFilteredRows: rows,
				preFilteredFlatRows: flatRows,
				preFilteredRowsById: rowsById,
				filteredRows,
				filteredFlatRows,
				filteredRowsById,
				rows: filteredRows,
				flatRows: filteredFlatRows,
				rowsById: filteredRowsById,
				setFilter,
				setAllFilters
			});
		}
		actions.resetGlobalFilter = "resetGlobalFilter";
		actions.setGlobalFilter = "setGlobalFilter";
		var useGlobalFilter = function useGlobalFilter(hooks) {
			hooks.stateReducers.push(reducer$3);
			hooks.useInstance.push(useInstance$3);
		};
		useGlobalFilter.pluginName = "useGlobalFilter";
		function reducer$3(state, action, previousState, instance) {
			if (action.type === actions.resetGlobalFilter) return _extends({}, state, { globalFilter: instance.initialState.globalFilter || void 0 });
			if (action.type === actions.setGlobalFilter) {
				var filterValue = action.filterValue;
				var userFilterTypes = instance.userFilterTypes;
				var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
				var newFilter = functionalUpdate(filterValue, state.globalFilter);
				if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
					state.globalFilter;
					return _objectWithoutPropertiesLoose(state, ["globalFilter"]);
				}
				return _extends({}, state, { globalFilter: newFilter });
			}
		}
		function useInstance$3(instance) {
			var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, rowsById = instance.rowsById, allColumns = instance.allColumns, userFilterTypes = instance.filterTypes, globalFilter = instance.globalFilter, manualGlobalFilter = instance.manualGlobalFilter, globalFilterValue = instance.state.globalFilter, dispatch = instance.dispatch, _instance$autoResetGl = instance.autoResetGlobalFilter, autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl, disableGlobalFilter = instance.disableGlobalFilter;
			var setGlobalFilter = React.useCallback(function(filterValue) {
				dispatch({
					type: actions.setGlobalFilter,
					filterValue
				});
			}, [dispatch]);
			var _React$useMemo = React.useMemo(function() {
				if (manualGlobalFilter || typeof globalFilterValue === "undefined") return [
					rows,
					flatRows,
					rowsById
				];
				var filteredFlatRows = [];
				var filteredRowsById = {};
				var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);
				if (!filterMethod) {
					console.warn("Could not find a valid 'globalFilter' option.");
					return rows;
				}
				allColumns.forEach(function(column) {
					var columnDisableGlobalFilter = column.disableGlobalFilter;
					column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : void 0, disableGlobalFilter === true ? false : void 0, true);
				});
				var filterableColumns = allColumns.filter(function(c) {
					return c.canFilter === true;
				});
				return [
					function filterRows(filteredRows) {
						filteredRows = filterMethod(filteredRows, filterableColumns.map(function(d) {
							return d.id;
						}), globalFilterValue);
						filteredRows.forEach(function(row) {
							filteredFlatRows.push(row);
							filteredRowsById[row.id] = row;
							row.subRows = row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows;
						});
						return filteredRows;
					}(rows),
					filteredFlatRows,
					filteredRowsById
				];
			}, [
				manualGlobalFilter,
				globalFilterValue,
				globalFilter,
				userFilterTypes,
				allColumns,
				rows,
				flatRows,
				rowsById,
				disableGlobalFilter
			]), globalFilteredRows = _React$useMemo[0], globalFilteredFlatRows = _React$useMemo[1], globalFilteredRowsById = _React$useMemo[2];
			var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
			useMountedLayoutEffect(function() {
				if (getAutoResetGlobalFilter()) dispatch({ type: actions.resetGlobalFilter });
			}, [dispatch, manualGlobalFilter ? null : data]);
			Object.assign(instance, {
				preGlobalFilteredRows: rows,
				preGlobalFilteredFlatRows: flatRows,
				preGlobalFilteredRowsById: rowsById,
				globalFilteredRows,
				globalFilteredFlatRows,
				globalFilteredRowsById,
				rows: globalFilteredRows,
				flatRows: globalFilteredFlatRows,
				rowsById: globalFilteredRowsById,
				setGlobalFilter,
				disableGlobalFilter
			});
		}
		function sum(values, aggregatedValues) {
			return aggregatedValues.reduce(function(sum, next) {
				return sum + (typeof next === "number" ? next : 0);
			}, 0);
		}
		function min(values) {
			var min = values[0] || 0;
			values.forEach(function(value) {
				if (typeof value === "number") min = Math.min(min, value);
			});
			return min;
		}
		function max(values) {
			var max = values[0] || 0;
			values.forEach(function(value) {
				if (typeof value === "number") max = Math.max(max, value);
			});
			return max;
		}
		function minMax(values) {
			var min = values[0] || 0;
			var max = values[0] || 0;
			values.forEach(function(value) {
				if (typeof value === "number") {
					min = Math.min(min, value);
					max = Math.max(max, value);
				}
			});
			return min + ".." + max;
		}
		function average(values) {
			return sum(null, values) / values.length;
		}
		function median(values) {
			if (!values.length) return null;
			var mid = Math.floor(values.length / 2);
			var nums = [].concat(values).sort(function(a, b) {
				return a - b;
			});
			return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
		}
		function unique(values) {
			return Array.from(new Set(values).values());
		}
		function uniqueCount(values) {
			return new Set(values).size;
		}
		function count(values) {
			return values.length;
		}
		var aggregations = /*#__PURE__*/ Object.freeze({
			__proto__: null,
			sum,
			min,
			max,
			minMax,
			average,
			median,
			unique,
			uniqueCount,
			count
		});
		var emptyArray = [];
		var emptyObject = {};
		actions.resetGroupBy = "resetGroupBy";
		actions.setGroupBy = "setGroupBy";
		actions.toggleGroupBy = "toggleGroupBy";
		var useGroupBy = function useGroupBy(hooks) {
			hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
			hooks.stateReducers.push(reducer$4);
			hooks.visibleColumnsDeps.push(function(deps, _ref) {
				var instance = _ref.instance;
				return [].concat(deps, [instance.state.groupBy]);
			});
			hooks.visibleColumns.push(visibleColumns);
			hooks.useInstance.push(useInstance$4);
			hooks.prepareRow.push(prepareRow$1);
		};
		useGroupBy.pluginName = "useGroupBy";
		var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
			var header = _ref2.header;
			return [props, {
				onClick: header.canGroupBy ? function(e) {
					e.persist();
					header.toggleGroupBy();
				} : void 0,
				style: { cursor: header.canGroupBy ? "pointer" : void 0 },
				title: "Toggle GroupBy"
			}];
		};
		function reducer$4(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ groupBy: [] }, state);
			if (action.type === actions.resetGroupBy) return _extends({}, state, { groupBy: instance.initialState.groupBy || [] });
			if (action.type === actions.setGroupBy) {
				var value = action.value;
				return _extends({}, state, { groupBy: value });
			}
			if (action.type === actions.toggleGroupBy) {
				var columnId = action.columnId, setGroupBy = action.value;
				if (typeof setGroupBy !== "undefined" ? setGroupBy : !state.groupBy.includes(columnId)) return _extends({}, state, { groupBy: [].concat(state.groupBy, [columnId]) });
				return _extends({}, state, { groupBy: state.groupBy.filter(function(d) {
					return d !== columnId;
				}) });
			}
		}
		function visibleColumns(columns, _ref3) {
			var groupBy = _ref3.instance.state.groupBy;
			var groupByColumns = groupBy.map(function(g) {
				return columns.find(function(col) {
					return col.id === g;
				});
			}).filter(Boolean);
			var nonGroupByColumns = columns.filter(function(col) {
				return !groupBy.includes(col.id);
			});
			columns = [].concat(groupByColumns, nonGroupByColumns);
			columns.forEach(function(column) {
				column.isGrouped = groupBy.includes(column.id);
				column.groupedIndex = groupBy.indexOf(column.id);
			});
			return columns;
		}
		var defaultUserAggregations = {};
		function useInstance$4(instance) {
			var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, rowsById = instance.rowsById, allColumns = instance.allColumns, flatHeaders = instance.flatHeaders, _instance$groupByFn = instance.groupByFn, groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn, manualGroupBy = instance.manualGroupBy, _instance$aggregation = instance.aggregations, userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation, plugins = instance.plugins, groupBy = instance.state.groupBy, dispatch = instance.dispatch, _instance$autoResetGr = instance.autoResetGroupBy, autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr, disableGroupBy = instance.disableGroupBy, defaultCanGroupBy = instance.defaultCanGroupBy, getHooks = instance.getHooks;
			ensurePluginOrder(plugins, ["useColumnOrder", "useFilters"], "useGroupBy");
			var getInstance = useGetLatest(instance);
			allColumns.forEach(function(column) {
				var accessor = column.accessor, defaultColumnGroupBy = column.defaultGroupBy, columnDisableGroupBy = column.disableGroupBy;
				column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : void 0, disableGroupBy === true ? false : void 0, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);
				if (column.canGroupBy) column.toggleGroupBy = function() {
					return instance.toggleGroupBy(column.id);
				};
				column.Aggregated = column.Aggregated || column.Cell;
			});
			var toggleGroupBy = React.useCallback(function(columnId, value) {
				dispatch({
					type: actions.toggleGroupBy,
					columnId,
					value
				});
			}, [dispatch]);
			var setGroupBy = React.useCallback(function(value) {
				dispatch({
					type: actions.setGroupBy,
					value
				});
			}, [dispatch]);
			flatHeaders.forEach(function(header) {
				header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
					instance: getInstance(),
					header
				});
			});
			var _React$useMemo = React.useMemo(function() {
				if (manualGroupBy || !groupBy.length) return [
					rows,
					flatRows,
					rowsById,
					emptyArray,
					emptyObject,
					flatRows,
					rowsById
				];
				var existingGroupBy = groupBy.filter(function(g) {
					return allColumns.find(function(col) {
						return col.id === g;
					});
				});
				var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
					var values = {};
					allColumns.forEach(function(column) {
						if (existingGroupBy.includes(column.id)) {
							values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
							return;
						}
						var aggregateFn = typeof column.aggregate === "function" ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];
						if (aggregateFn) {
							var groupedValues = groupedRows.map(function(row) {
								return row.values[column.id];
							});
							var leafValues = leafRows.map(function(row) {
								var columnValue = row.values[column.id];
								if (!depth && column.aggregateValue) {
									var aggregateValueFn = typeof column.aggregateValue === "function" ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];
									if (!aggregateValueFn) {
										console.info({ column });
										throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
									}
									columnValue = aggregateValueFn(columnValue, row, column);
								}
								return columnValue;
							});
							values[column.id] = aggregateFn(leafValues, groupedValues);
						} else if (column.aggregate) {
							console.info({ column });
							throw new Error("React Table: Invalid column.aggregate option for column listed above");
						} else values[column.id] = null;
					});
					return values;
				};
				var groupedFlatRows = [];
				var groupedRowsById = {};
				var onlyGroupedFlatRows = [];
				var onlyGroupedRowsById = {};
				var nonGroupedFlatRows = [];
				var nonGroupedRowsById = {};
				var groupedRows = function groupUpRecursively(rows, depth, parentId) {
					if (depth === void 0) depth = 0;
					if (depth === existingGroupBy.length) return rows.map(function(row) {
						return _extends({}, row, { depth });
					});
					var columnId = existingGroupBy[depth];
					var rowGroupsMap = groupByFn(rows, columnId);
					return Object.entries(rowGroupsMap).map(function(_ref4, index) {
						var groupByVal = _ref4[0], groupedRows = _ref4[1];
						var id = columnId + ":" + groupByVal;
						id = parentId ? parentId + ">" + id : id;
						var subRows = groupUpRecursively(groupedRows, depth + 1, id);
						var leafRows = depth ? flattenBy(groupedRows, "leafRows") : groupedRows;
						var values = aggregateRowsToValues(leafRows, groupedRows, depth);
						var row = {
							id,
							isGrouped: true,
							groupByID: columnId,
							groupByVal,
							values,
							subRows,
							leafRows,
							depth,
							index
						};
						subRows.forEach(function(subRow) {
							groupedFlatRows.push(subRow);
							groupedRowsById[subRow.id] = subRow;
							if (subRow.isGrouped) {
								onlyGroupedFlatRows.push(subRow);
								onlyGroupedRowsById[subRow.id] = subRow;
							} else {
								nonGroupedFlatRows.push(subRow);
								nonGroupedRowsById[subRow.id] = subRow;
							}
						});
						return row;
					});
				}(rows);
				groupedRows.forEach(function(subRow) {
					groupedFlatRows.push(subRow);
					groupedRowsById[subRow.id] = subRow;
					if (subRow.isGrouped) {
						onlyGroupedFlatRows.push(subRow);
						onlyGroupedRowsById[subRow.id] = subRow;
					} else {
						nonGroupedFlatRows.push(subRow);
						nonGroupedRowsById[subRow.id] = subRow;
					}
				});
				return [
					groupedRows,
					groupedFlatRows,
					groupedRowsById,
					onlyGroupedFlatRows,
					onlyGroupedRowsById,
					nonGroupedFlatRows,
					nonGroupedRowsById
				];
			}, [
				manualGroupBy,
				groupBy,
				rows,
				flatRows,
				rowsById,
				allColumns,
				userAggregations,
				groupByFn
			]), groupedRows = _React$useMemo[0], groupedFlatRows = _React$useMemo[1], groupedRowsById = _React$useMemo[2], onlyGroupedFlatRows = _React$useMemo[3], onlyGroupedRowsById = _React$useMemo[4], nonGroupedFlatRows = _React$useMemo[5], nonGroupedRowsById = _React$useMemo[6];
			var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
			useMountedLayoutEffect(function() {
				if (getAutoResetGroupBy()) dispatch({ type: actions.resetGroupBy });
			}, [dispatch, manualGroupBy ? null : data]);
			Object.assign(instance, {
				preGroupedRows: rows,
				preGroupedFlatRow: flatRows,
				preGroupedRowsById: rowsById,
				groupedRows,
				groupedFlatRows,
				groupedRowsById,
				onlyGroupedFlatRows,
				onlyGroupedRowsById,
				nonGroupedFlatRows,
				nonGroupedRowsById,
				rows: groupedRows,
				flatRows: groupedFlatRows,
				rowsById: groupedRowsById,
				toggleGroupBy,
				setGroupBy
			});
		}
		function prepareRow$1(row) {
			row.allCells.forEach(function(cell) {
				var _row$subRows;
				cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID;
				cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped;
				cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && ((_row$subRows = row.subRows) == null ? void 0 : _row$subRows.length);
			});
		}
		function defaultGroupByFn(rows, columnId) {
			return rows.reduce(function(prev, row, i) {
				var resKey = "" + row.values[columnId];
				prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
				prev[resKey].push(row);
				return prev;
			}, {});
		}
		var reSplitAlphaNumeric = /([0-9]+)/gm;
		var alphanumeric = function alphanumeric(rowA, rowB, columnId) {
			var _getRowValuesByColumn = getRowValuesByColumnID(rowA, rowB, columnId), a = _getRowValuesByColumn[0], b = _getRowValuesByColumn[1];
			a = toString(a);
			b = toString(b);
			a = a.split(reSplitAlphaNumeric).filter(Boolean);
			b = b.split(reSplitAlphaNumeric).filter(Boolean);
			while (a.length && b.length) {
				var aa = a.shift();
				var bb = b.shift();
				var an = parseInt(aa, 10);
				var bn = parseInt(bb, 10);
				var combo = [an, bn].sort();
				if (isNaN(combo[0])) {
					if (aa > bb) return 1;
					if (bb > aa) return -1;
					continue;
				}
				if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
				if (an > bn) return 1;
				if (bn > an) return -1;
			}
			return a.length - b.length;
		};
		function datetime(rowA, rowB, columnId) {
			var _getRowValuesByColumn2 = getRowValuesByColumnID(rowA, rowB, columnId), a = _getRowValuesByColumn2[0], b = _getRowValuesByColumn2[1];
			a = a.getTime();
			b = b.getTime();
			return compareBasic(a, b);
		}
		function basic(rowA, rowB, columnId) {
			var _getRowValuesByColumn3 = getRowValuesByColumnID(rowA, rowB, columnId), a = _getRowValuesByColumn3[0], b = _getRowValuesByColumn3[1];
			return compareBasic(a, b);
		}
		function string(rowA, rowB, columnId) {
			var _getRowValuesByColumn4 = getRowValuesByColumnID(rowA, rowB, columnId), a = _getRowValuesByColumn4[0], b = _getRowValuesByColumn4[1];
			a = a.split("").filter(Boolean);
			b = b.split("").filter(Boolean);
			while (a.length && b.length) {
				var aa = a.shift();
				var bb = b.shift();
				var alower = aa.toLowerCase();
				var blower = bb.toLowerCase();
				if (alower > blower) return 1;
				if (blower > alower) return -1;
				if (aa > bb) return 1;
				if (bb > aa) return -1;
			}
			return a.length - b.length;
		}
		function number(rowA, rowB, columnId) {
			var _getRowValuesByColumn5 = getRowValuesByColumnID(rowA, rowB, columnId), a = _getRowValuesByColumn5[0], b = _getRowValuesByColumn5[1];
			var replaceNonNumeric = /[^0-9.]/gi;
			a = Number(String(a).replace(replaceNonNumeric, ""));
			b = Number(String(b).replace(replaceNonNumeric, ""));
			return compareBasic(a, b);
		}
		function compareBasic(a, b) {
			return a === b ? 0 : a > b ? 1 : -1;
		}
		function getRowValuesByColumnID(row1, row2, columnId) {
			return [row1.values[columnId], row2.values[columnId]];
		}
		function toString(a) {
			if (typeof a === "number") {
				if (isNaN(a) || a === Infinity || a === -Infinity) return "";
				return String(a);
			}
			if (typeof a === "string") return a;
			return "";
		}
		var sortTypes = /*#__PURE__*/ Object.freeze({
			__proto__: null,
			alphanumeric,
			datetime,
			basic,
			string,
			number
		});
		actions.resetSortBy = "resetSortBy";
		actions.setSortBy = "setSortBy";
		actions.toggleSortBy = "toggleSortBy";
		actions.clearSortBy = "clearSortBy";
		defaultColumn.sortType = "alphanumeric";
		defaultColumn.sortDescFirst = false;
		var useSortBy = function useSortBy(hooks) {
			hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
			hooks.stateReducers.push(reducer$5);
			hooks.useInstance.push(useInstance$5);
		};
		useSortBy.pluginName = "useSortBy";
		var defaultGetSortByToggleProps = function defaultGetSortByToggleProps(props, _ref) {
			var instance = _ref.instance, column = _ref.column;
			var _instance$isMultiSort = instance.isMultiSortEvent, isMultiSortEvent = _instance$isMultiSort === void 0 ? function(e) {
				return e.shiftKey;
			} : _instance$isMultiSort;
			return [props, {
				onClick: column.canSort ? function(e) {
					e.persist();
					column.toggleSortBy(void 0, !instance.disableMultiSort && isMultiSortEvent(e));
				} : void 0,
				style: { cursor: column.canSort ? "pointer" : void 0 },
				title: column.canSort ? "Toggle SortBy" : void 0
			}];
		};
		function reducer$5(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ sortBy: [] }, state);
			if (action.type === actions.resetSortBy) return _extends({}, state, { sortBy: instance.initialState.sortBy || [] });
			if (action.type === actions.clearSortBy) {
				var newSortBy = state.sortBy.filter(function(d) {
					return d.id !== action.columnId;
				});
				return _extends({}, state, { sortBy: newSortBy });
			}
			if (action.type === actions.setSortBy) {
				var _sortBy = action.sortBy;
				return _extends({}, state, { sortBy: _sortBy });
			}
			if (action.type === actions.toggleSortBy) {
				var columnId = action.columnId, desc = action.desc, multi = action.multi;
				var allColumns = instance.allColumns, disableMultiSort = instance.disableMultiSort, disableSortRemove = instance.disableSortRemove, disableMultiRemove = instance.disableMultiRemove, _instance$maxMultiSor = instance.maxMultiSortColCount, maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
				var _sortBy2 = state.sortBy;
				var sortDescFirst = allColumns.find(function(d) {
					return d.id === columnId;
				}).sortDescFirst;
				var existingSortBy = _sortBy2.find(function(d) {
					return d.id === columnId;
				});
				var existingIndex = _sortBy2.findIndex(function(d) {
					return d.id === columnId;
				});
				var hasDescDefined = typeof desc !== "undefined" && desc !== null;
				var _newSortBy = [];
				var sortAction;
				if (!disableMultiSort && multi) {
					if (existingSortBy) sortAction = "toggle";
					else sortAction = "add";
				} else if (existingIndex !== _sortBy2.length - 1 || _sortBy2.length !== 1) sortAction = "replace";
				else if (existingSortBy) sortAction = "toggle";
				else sortAction = "replace";
				if (sortAction === "toggle" && !disableSortRemove && !hasDescDefined && (multi ? !disableMultiRemove : true) && (existingSortBy && existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) sortAction = "remove";
				if (sortAction === "replace") _newSortBy = [{
					id: columnId,
					desc: hasDescDefined ? desc : sortDescFirst
				}];
				else if (sortAction === "add") {
					_newSortBy = [].concat(_sortBy2, [{
						id: columnId,
						desc: hasDescDefined ? desc : sortDescFirst
					}]);
					_newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
				} else if (sortAction === "toggle") _newSortBy = _sortBy2.map(function(d) {
					if (d.id === columnId) return _extends({}, d, { desc: hasDescDefined ? desc : !existingSortBy.desc });
					return d;
				});
				else if (sortAction === "remove") _newSortBy = _sortBy2.filter(function(d) {
					return d.id !== columnId;
				});
				return _extends({}, state, { sortBy: _newSortBy });
			}
		}
		function useInstance$5(instance) {
			var data = instance.data, rows = instance.rows, flatRows = instance.flatRows, allColumns = instance.allColumns, _instance$orderByFn = instance.orderByFn, orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn, userSortTypes = instance.sortTypes, manualSortBy = instance.manualSortBy, defaultCanSort = instance.defaultCanSort, disableSortBy = instance.disableSortBy, flatHeaders = instance.flatHeaders, sortBy = instance.state.sortBy, dispatch = instance.dispatch, plugins = instance.plugins, getHooks = instance.getHooks, _instance$autoResetSo = instance.autoResetSortBy, autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
			ensurePluginOrder(plugins, [
				"useFilters",
				"useGlobalFilter",
				"useGroupBy",
				"usePivotColumns"
			], "useSortBy");
			var setSortBy = React.useCallback(function(sortBy) {
				dispatch({
					type: actions.setSortBy,
					sortBy
				});
			}, [dispatch]);
			var toggleSortBy = React.useCallback(function(columnId, desc, multi) {
				dispatch({
					type: actions.toggleSortBy,
					columnId,
					desc,
					multi
				});
			}, [dispatch]);
			var getInstance = useGetLatest(instance);
			flatHeaders.forEach(function(column) {
				var accessor = column.accessor, defaultColumnCanSort = column.canSort, columnDisableSortBy = column.disableSortBy, id = column.id;
				column.canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : void 0, disableSortBy === true ? false : void 0, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
				if (column.canSort) {
					column.toggleSortBy = function(desc, multi) {
						return toggleSortBy(column.id, desc, multi);
					};
					column.clearSortBy = function() {
						dispatch({
							type: actions.clearSortBy,
							columnId: column.id
						});
					};
				}
				column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
					instance: getInstance(),
					column
				});
				var columnSort = sortBy.find(function(d) {
					return d.id === id;
				});
				column.isSorted = !!columnSort;
				column.sortedIndex = sortBy.findIndex(function(d) {
					return d.id === id;
				});
				column.isSortedDesc = column.isSorted ? columnSort.desc : void 0;
			});
			var _React$useMemo = React.useMemo(function() {
				if (manualSortBy || !sortBy.length) return [rows, flatRows];
				var sortedFlatRows = [];
				var availableSortBy = sortBy.filter(function(sort) {
					return allColumns.find(function(col) {
						return col.id === sort.id;
					});
				});
				return [function sortData(rows) {
					var sortedData = orderByFn(rows, availableSortBy.map(function(sort) {
						var column = allColumns.find(function(d) {
							return d.id === sort.id;
						});
						if (!column) throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
						var sortType = column.sortType;
						var sortMethod = isFunction(sortType) || (userSortTypes || {})[sortType] || sortTypes[sortType];
						if (!sortMethod) throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
						return function(a, b) {
							return sortMethod(a, b, sort.id, sort.desc);
						};
					}), availableSortBy.map(function(sort) {
						var column = allColumns.find(function(d) {
							return d.id === sort.id;
						});
						if (column && column.sortInverted) return sort.desc;
						return !sort.desc;
					}));
					sortedData.forEach(function(row) {
						sortedFlatRows.push(row);
						if (!row.subRows || row.subRows.length === 0) return;
						row.subRows = sortData(row.subRows);
					});
					return sortedData;
				}(rows), sortedFlatRows];
			}, [
				manualSortBy,
				sortBy,
				rows,
				flatRows,
				allColumns,
				orderByFn,
				userSortTypes
			]), sortedRows = _React$useMemo[0], sortedFlatRows = _React$useMemo[1];
			var getAutoResetSortBy = useGetLatest(autoResetSortBy);
			useMountedLayoutEffect(function() {
				if (getAutoResetSortBy()) dispatch({ type: actions.resetSortBy });
			}, [manualSortBy ? null : data]);
			Object.assign(instance, {
				preSortedRows: rows,
				preSortedFlatRows: flatRows,
				sortedRows,
				sortedFlatRows,
				rows: sortedRows,
				flatRows: sortedFlatRows,
				setSortBy,
				toggleSortBy
			});
		}
		function defaultOrderByFn(arr, funcs, dirs) {
			return [].concat(arr).sort(function(rowA, rowB) {
				for (var i = 0; i < funcs.length; i += 1) {
					var sortFn = funcs[i];
					var desc = dirs[i] === false || dirs[i] === "desc";
					var sortInt = sortFn(rowA, rowB);
					if (sortInt !== 0) return desc ? -sortInt : sortInt;
				}
				return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
			});
		}
		var pluginName = "usePagination";
		actions.resetPage = "resetPage";
		actions.gotoPage = "gotoPage";
		actions.setPageSize = "setPageSize";
		var usePagination = function usePagination(hooks) {
			hooks.stateReducers.push(reducer$6);
			hooks.useInstance.push(useInstance$6);
		};
		usePagination.pluginName = pluginName;
		function reducer$6(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({
				pageSize: 10,
				pageIndex: 0
			}, state);
			if (action.type === actions.resetPage) return _extends({}, state, { pageIndex: instance.initialState.pageIndex || 0 });
			if (action.type === actions.gotoPage) {
				var pageCount = instance.pageCount, page = instance.page;
				var newPageIndex = functionalUpdate(action.pageIndex, state.pageIndex);
				var canNavigate = false;
				if (newPageIndex > state.pageIndex) canNavigate = pageCount === -1 ? page.length >= state.pageSize : newPageIndex < pageCount;
				else if (newPageIndex < state.pageIndex) canNavigate = newPageIndex > -1;
				if (!canNavigate) return state;
				return _extends({}, state, { pageIndex: newPageIndex });
			}
			if (action.type === actions.setPageSize) {
				var pageSize = action.pageSize;
				var topRowIndex = state.pageSize * state.pageIndex;
				var pageIndex = Math.floor(topRowIndex / pageSize);
				return _extends({}, state, {
					pageIndex,
					pageSize
				});
			}
		}
		function useInstance$6(instance) {
			var rows = instance.rows, _instance$autoResetPa = instance.autoResetPage, autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa, _instance$manualExpan = instance.manualExpandedKey, manualExpandedKey = _instance$manualExpan === void 0 ? "expanded" : _instance$manualExpan, plugins = instance.plugins, userPageCount = instance.pageCount, _instance$paginateExp = instance.paginateExpandedRows, paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp, _instance$expandSubRo = instance.expandSubRows, expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo, _instance$state = instance.state, pageSize = _instance$state.pageSize, pageIndex = _instance$state.pageIndex, expanded = _instance$state.expanded, globalFilter = _instance$state.globalFilter, filters = _instance$state.filters, groupBy = _instance$state.groupBy, sortBy = _instance$state.sortBy, dispatch = instance.dispatch, data = instance.data, manualPagination = instance.manualPagination;
			ensurePluginOrder(plugins, [
				"useGlobalFilter",
				"useFilters",
				"useGroupBy",
				"useSortBy",
				"useExpanded"
			], "usePagination");
			var getAutoResetPage = useGetLatest(autoResetPage);
			useMountedLayoutEffect(function() {
				if (getAutoResetPage()) dispatch({ type: actions.resetPage });
			}, [
				dispatch,
				manualPagination ? null : data,
				globalFilter,
				filters,
				groupBy,
				sortBy
			]);
			var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
			var pageOptions = React.useMemo(function() {
				return pageCount > 0 ? [].concat(new Array(pageCount)).fill(null).map(function(d, i) {
					return i;
				}) : [];
			}, [pageCount]);
			var page = React.useMemo(function() {
				var page;
				if (manualPagination) page = rows;
				else {
					var pageStart = pageSize * pageIndex;
					var pageEnd = pageStart + pageSize;
					page = rows.slice(pageStart, pageEnd);
				}
				if (paginateExpandedRows) return page;
				return expandRows(page, {
					manualExpandedKey,
					expanded,
					expandSubRows
				});
			}, [
				expandSubRows,
				expanded,
				manualExpandedKey,
				manualPagination,
				pageIndex,
				pageSize,
				paginateExpandedRows,
				rows
			]);
			var canPreviousPage = pageIndex > 0;
			var canNextPage = pageCount === -1 ? page.length >= pageSize : pageIndex < pageCount - 1;
			var gotoPage = React.useCallback(function(pageIndex) {
				dispatch({
					type: actions.gotoPage,
					pageIndex
				});
			}, [dispatch]);
			var previousPage = React.useCallback(function() {
				return gotoPage(function(old) {
					return old - 1;
				});
			}, [gotoPage]);
			var nextPage = React.useCallback(function() {
				return gotoPage(function(old) {
					return old + 1;
				});
			}, [gotoPage]);
			var setPageSize = React.useCallback(function(pageSize) {
				dispatch({
					type: actions.setPageSize,
					pageSize
				});
			}, [dispatch]);
			Object.assign(instance, {
				pageOptions,
				pageCount,
				page,
				canPreviousPage,
				canNextPage,
				gotoPage,
				previousPage,
				nextPage,
				setPageSize
			});
		}
		actions.resetPivot = "resetPivot";
		actions.togglePivot = "togglePivot";
		var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
			hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
			hooks.stateReducers.push(reducer$7);
			hooks.useInstanceAfterData.push(useInstanceAfterData);
			hooks.allColumns.push(allColumns);
			hooks.accessValue.push(accessValue);
			hooks.materializedColumns.push(materializedColumns);
			hooks.materializedColumnsDeps.push(materializedColumnsDeps);
			hooks.visibleColumns.push(visibleColumns$1);
			hooks.visibleColumnsDeps.push(visibleColumnsDeps);
			hooks.useInstance.push(useInstance$7);
			hooks.prepareRow.push(prepareRow$2);
		};
		_UNSTABLE_usePivotColumns.pluginName = "usePivotColumns";
		var defaultPivotColumns = [];
		var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
			var header = _ref.header;
			return [props, {
				onClick: header.canPivot ? function(e) {
					e.persist();
					header.togglePivot();
				} : void 0,
				style: { cursor: header.canPivot ? "pointer" : void 0 },
				title: "Toggle Pivot"
			}];
		};
		function reducer$7(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ pivotColumns: defaultPivotColumns }, state);
			if (action.type === actions.resetPivot) return _extends({}, state, { pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns });
			if (action.type === actions.togglePivot) {
				var columnId = action.columnId, setPivot = action.value;
				if (typeof setPivot !== "undefined" ? setPivot : !state.pivotColumns.includes(columnId)) return _extends({}, state, { pivotColumns: [].concat(state.pivotColumns, [columnId]) });
				return _extends({}, state, { pivotColumns: state.pivotColumns.filter(function(d) {
					return d !== columnId;
				}) });
			}
		}
		function useInstanceAfterData(instance) {
			instance.allColumns.forEach(function(column) {
				column.isPivotSource = instance.state.pivotColumns.includes(column.id);
			});
		}
		function allColumns(columns, _ref2) {
			var instance = _ref2.instance;
			columns.forEach(function(column) {
				column.isPivotSource = instance.state.pivotColumns.includes(column.id);
				column.uniqueValues = /* @__PURE__ */ new Set();
			});
			return columns;
		}
		function accessValue(value, _ref3) {
			var column = _ref3.column;
			if (column.uniqueValues && typeof value !== "undefined") column.uniqueValues.add(value);
			return value;
		}
		function materializedColumns(materialized, _ref4) {
			var instance = _ref4.instance;
			var allColumns = instance.allColumns, state = instance.state;
			if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) return materialized;
			var pivotColumns = state.pivotColumns.map(function(id) {
				return allColumns.find(function(d) {
					return d.id === id;
				});
			}).filter(Boolean);
			var sourceColumns = allColumns.filter(function(d) {
				return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
			});
			var newMaterialized = flattenColumns(function buildPivotColumns(depth, parent, pivotFilters) {
				if (depth === void 0) depth = 0;
				if (pivotFilters === void 0) pivotFilters = [];
				var pivotColumn = pivotColumns[depth];
				if (!pivotColumn) return sourceColumns.map(function(sourceColumn) {
					return _extends({}, sourceColumn, {
						canPivot: false,
						isPivoted: true,
						parent,
						depth,
						id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
						accessor: function accessor(originalRow, i, row) {
							if (pivotFilters.every(function(filter) {
								return filter(row);
							})) return row.values[sourceColumn.id];
						}
					});
				});
				return Array.from(pivotColumn.uniqueValues).sort().map(function(uniqueValue) {
					var columnGroup = _extends({}, pivotColumn, {
						Header: pivotColumn.PivotHeader || typeof pivotColumn.header === "string" ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
						isPivotGroup: true,
						parent,
						depth,
						id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
						pivotValue: uniqueValue
					});
					columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(pivotFilters, [function(row) {
						return row.values[pivotColumn.id] === uniqueValue;
					}]));
					return columnGroup;
				});
			}());
			return [].concat(materialized, newMaterialized);
		}
		function materializedColumnsDeps(deps, _ref5) {
			var _ref5$instance$state = _ref5.instance.state, pivotColumns = _ref5$instance$state.pivotColumns, groupBy = _ref5$instance$state.groupBy;
			return [].concat(deps, [pivotColumns, groupBy]);
		}
		function visibleColumns$1(visibleColumns, _ref6) {
			var state = _ref6.instance.state;
			visibleColumns = visibleColumns.filter(function(d) {
				return !d.isPivotSource;
			});
			if (state.pivotColumns.length && state.groupBy && state.groupBy.length) visibleColumns = visibleColumns.filter(function(column) {
				return column.isGrouped || column.isPivoted;
			});
			return visibleColumns;
		}
		function visibleColumnsDeps(deps, _ref7) {
			var instance = _ref7.instance;
			return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
		}
		function useInstance$7(instance) {
			var columns = instance.columns, allColumns = instance.allColumns, flatHeaders = instance.flatHeaders, getHooks = instance.getHooks, plugins = instance.plugins, dispatch = instance.dispatch, _instance$autoResetPi = instance.autoResetPivot, autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi, manaulPivot = instance.manaulPivot, disablePivot = instance.disablePivot, defaultCanPivot = instance.defaultCanPivot;
			ensurePluginOrder(plugins, ["useGroupBy"], "usePivotColumns");
			var getInstance = useGetLatest(instance);
			allColumns.forEach(function(column) {
				var accessor = column.accessor, defaultColumnPivot = column.defaultPivot, columnDisablePivot = column.disablePivot;
				column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : void 0, disablePivot === true ? false : void 0, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);
				if (column.canPivot) column.togglePivot = function() {
					return instance.togglePivot(column.id);
				};
				column.Aggregated = column.Aggregated || column.Cell;
			});
			var togglePivot = function togglePivot(columnId, value) {
				dispatch({
					type: actions.togglePivot,
					columnId,
					value
				});
			};
			flatHeaders.forEach(function(header) {
				header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
					instance: getInstance(),
					header
				});
			});
			var getAutoResetPivot = useGetLatest(autoResetPivot);
			useMountedLayoutEffect(function() {
				if (getAutoResetPivot()) dispatch({ type: actions.resetPivot });
			}, [dispatch, manaulPivot ? null : columns]);
			Object.assign(instance, { togglePivot });
		}
		function prepareRow$2(row) {
			row.allCells.forEach(function(cell) {
				cell.isPivoted = cell.column.isPivoted;
			});
		}
		var pluginName$1 = "useRowSelect";
		actions.resetSelectedRows = "resetSelectedRows";
		actions.toggleAllRowsSelected = "toggleAllRowsSelected";
		actions.toggleRowSelected = "toggleRowSelected";
		actions.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
		var useRowSelect = function useRowSelect(hooks) {
			hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
			hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
			hooks.getToggleAllPageRowsSelectedProps = [defaultGetToggleAllPageRowsSelectedProps];
			hooks.stateReducers.push(reducer$8);
			hooks.useInstance.push(useInstance$8);
			hooks.prepareRow.push(prepareRow$3);
		};
		useRowSelect.pluginName = pluginName$1;
		var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps(props, _ref) {
			var instance = _ref.instance, row = _ref.row;
			var _instance$manualRowSe = instance.manualRowSelectedKey, manualRowSelectedKey = _instance$manualRowSe === void 0 ? "isSelected" : _instance$manualRowSe;
			var checked = false;
			if (row.original && row.original[manualRowSelectedKey]) checked = true;
			else checked = row.isSelected;
			return [props, {
				onChange: function onChange(e) {
					row.toggleRowSelected(e.target.checked);
				},
				style: { cursor: "pointer" },
				checked,
				title: "Toggle Row Selected",
				indeterminate: row.isSomeSelected
			}];
		};
		var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps(props, _ref2) {
			var instance = _ref2.instance;
			return [props, {
				onChange: function onChange(e) {
					instance.toggleAllRowsSelected(e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: instance.isAllRowsSelected,
				title: "Toggle All Rows Selected",
				indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
			}];
		};
		var defaultGetToggleAllPageRowsSelectedProps = function defaultGetToggleAllPageRowsSelectedProps(props, _ref3) {
			var instance = _ref3.instance;
			return [props, {
				onChange: function onChange(e) {
					instance.toggleAllPageRowsSelected(e.target.checked);
				},
				style: { cursor: "pointer" },
				checked: instance.isAllPageRowsSelected,
				title: "Toggle All Current Page Rows Selected",
				indeterminate: Boolean(!instance.isAllPageRowsSelected && instance.page.some(function(_ref4) {
					var id = _ref4.id;
					return instance.state.selectedRowIds[id];
				}))
			}];
		};
		function reducer$8(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ selectedRowIds: {} }, state);
			if (action.type === actions.resetSelectedRows) return _extends({}, state, { selectedRowIds: instance.initialState.selectedRowIds || {} });
			if (action.type === actions.toggleAllRowsSelected) {
				var setSelected = action.value;
				var isAllRowsSelected = instance.isAllRowsSelected, rowsById = instance.rowsById, _instance$nonGroupedR = instance.nonGroupedRowsById, nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
				var selectAll = typeof setSelected !== "undefined" ? setSelected : !isAllRowsSelected;
				var selectedRowIds = Object.assign({}, state.selectedRowIds);
				if (selectAll) Object.keys(nonGroupedRowsById).forEach(function(rowId) {
					selectedRowIds[rowId] = true;
				});
				else Object.keys(nonGroupedRowsById).forEach(function(rowId) {
					delete selectedRowIds[rowId];
				});
				return _extends({}, state, { selectedRowIds });
			}
			if (action.type === actions.toggleRowSelected) {
				var id = action.id, _setSelected = action.value;
				var _rowsById = instance.rowsById, _instance$selectSubRo = instance.selectSubRows, selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo, getSubRows = instance.getSubRows;
				var isSelected = state.selectedRowIds[id];
				var shouldExist = typeof _setSelected !== "undefined" ? _setSelected : !isSelected;
				if (isSelected === shouldExist) return state;
				var newSelectedRowIds = _extends({}, state.selectedRowIds);
				(function handleRowById(id) {
					var row = _rowsById[id];
					if (row) {
						if (!row.isGrouped) {
							if (shouldExist) newSelectedRowIds[id] = true;
							else delete newSelectedRowIds[id];
						}
						if (selectSubRows && getSubRows(row)) return getSubRows(row).forEach(function(row) {
							return handleRowById(row.id);
						});
					}
				})(id);
				return _extends({}, state, { selectedRowIds: newSelectedRowIds });
			}
			if (action.type === actions.toggleAllPageRowsSelected) {
				var _setSelected2 = action.value;
				var page = instance.page, _rowsById2 = instance.rowsById, _instance$selectSubRo2 = instance.selectSubRows, _selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2, isAllPageRowsSelected = instance.isAllPageRowsSelected, _getSubRows = instance.getSubRows;
				var _selectAll = typeof _setSelected2 !== "undefined" ? _setSelected2 : !isAllPageRowsSelected;
				var _newSelectedRowIds = _extends({}, state.selectedRowIds);
				var _handleRowById = function _handleRowById(id) {
					var row = _rowsById2[id];
					if (!row.isGrouped) {
						if (_selectAll) _newSelectedRowIds[id] = true;
						else delete _newSelectedRowIds[id];
					}
					if (_selectSubRows && _getSubRows(row)) return _getSubRows(row).forEach(function(row) {
						return _handleRowById(row.id);
					});
				};
				page.forEach(function(row) {
					return _handleRowById(row.id);
				});
				return _extends({}, state, { selectedRowIds: _newSelectedRowIds });
			}
			return state;
		}
		function useInstance$8(instance) {
			var data = instance.data, rows = instance.rows, getHooks = instance.getHooks, plugins = instance.plugins, rowsById = instance.rowsById, _instance$nonGroupedR2 = instance.nonGroupedRowsById, nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2, _instance$autoResetSe = instance.autoResetSelectedRows, autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe, selectedRowIds = instance.state.selectedRowIds, _instance$selectSubRo3 = instance.selectSubRows, selectSubRows = _instance$selectSubRo3 === void 0 ? true : _instance$selectSubRo3, dispatch = instance.dispatch, page = instance.page, getSubRows = instance.getSubRows;
			ensurePluginOrder(plugins, [
				"useFilters",
				"useGroupBy",
				"useSortBy",
				"useExpanded",
				"usePagination"
			], "useRowSelect");
			var selectedFlatRows = React.useMemo(function() {
				var selectedFlatRows = [];
				rows.forEach(function(row) {
					var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds, getSubRows) : !!selectedRowIds[row.id];
					row.isSelected = !!isSelected;
					row.isSomeSelected = isSelected === null;
					if (isSelected) selectedFlatRows.push(row);
				});
				return selectedFlatRows;
			}, [
				rows,
				selectSubRows,
				selectedRowIds,
				getSubRows
			]);
			var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);
			var isAllPageRowsSelected = isAllRowsSelected;
			if (isAllRowsSelected) {
				if (Object.keys(nonGroupedRowsById).some(function(id) {
					return !selectedRowIds[id];
				})) isAllRowsSelected = false;
			}
			if (!isAllRowsSelected) {
				if (page && page.length && page.some(function(_ref5) {
					return !selectedRowIds[_ref5.id];
				})) isAllPageRowsSelected = false;
			}
			var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
			useMountedLayoutEffect(function() {
				if (getAutoResetSelectedRows()) dispatch({ type: actions.resetSelectedRows });
			}, [dispatch, data]);
			var toggleAllRowsSelected = React.useCallback(function(value) {
				return dispatch({
					type: actions.toggleAllRowsSelected,
					value
				});
			}, [dispatch]);
			var toggleAllPageRowsSelected = React.useCallback(function(value) {
				return dispatch({
					type: actions.toggleAllPageRowsSelected,
					value
				});
			}, [dispatch]);
			var toggleRowSelected = React.useCallback(function(id, value) {
				return dispatch({
					type: actions.toggleRowSelected,
					id,
					value
				});
			}, [dispatch]);
			var getInstance = useGetLatest(instance);
			var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, { instance: getInstance() });
			var getToggleAllPageRowsSelectedProps = makePropGetter(getHooks().getToggleAllPageRowsSelectedProps, { instance: getInstance() });
			Object.assign(instance, {
				selectedFlatRows,
				isAllRowsSelected,
				isAllPageRowsSelected,
				toggleRowSelected,
				toggleAllRowsSelected,
				getToggleAllRowsSelectedProps,
				getToggleAllPageRowsSelectedProps,
				toggleAllPageRowsSelected
			});
		}
		function prepareRow$3(row, _ref6) {
			var instance = _ref6.instance;
			row.toggleRowSelected = function(set) {
				return instance.toggleRowSelected(row.id, set);
			};
			row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
				instance,
				row
			});
		}
		function getRowIsSelected(row, selectedRowIds, getSubRows) {
			if (selectedRowIds[row.id]) return true;
			var subRows = getSubRows(row);
			if (subRows && subRows.length) {
				var allChildrenSelected = true;
				var someSelected = false;
				subRows.forEach(function(subRow) {
					if (someSelected && !allChildrenSelected) return;
					if (getRowIsSelected(subRow, selectedRowIds, getSubRows)) someSelected = true;
					else allChildrenSelected = false;
				});
				return allChildrenSelected ? true : someSelected ? null : false;
			}
			return false;
		}
		var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(row) {
			return {};
		};
		var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(cell) {
			return {};
		};
		actions.setRowState = "setRowState";
		actions.setCellState = "setCellState";
		actions.resetRowState = "resetRowState";
		var useRowState = function useRowState(hooks) {
			hooks.stateReducers.push(reducer$9);
			hooks.useInstance.push(useInstance$9);
			hooks.prepareRow.push(prepareRow$4);
		};
		useRowState.pluginName = "useRowState";
		function reducer$9(state, action, previousState, instance) {
			var _instance$initialRowS = instance.initialRowStateAccessor, initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS, _instance$initialCell = instance.initialCellStateAccessor, initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell, rowsById = instance.rowsById;
			if (action.type === actions.init) return _extends({ rowState: {} }, state);
			if (action.type === actions.resetRowState) return _extends({}, state, { rowState: instance.initialState.rowState || {} });
			if (action.type === actions.setRowState) {
				var _extends2;
				var rowId = action.rowId, value = action.value;
				var oldRowState = typeof state.rowState[rowId] !== "undefined" ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId]);
				return _extends({}, state, { rowState: _extends({}, state.rowState, (_extends2 = {}, _extends2[rowId] = functionalUpdate(value, oldRowState), _extends2)) });
			}
			if (action.type === actions.setCellState) {
				var _oldRowState$cellStat, _rowsById$_rowId, _rowsById$_rowId$cell, _extends3, _extends4;
				var _rowId = action.rowId, columnId = action.columnId, _value = action.value;
				var _oldRowState = typeof state.rowState[_rowId] !== "undefined" ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId]);
				var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== "undefined" ? _oldRowState.cellState[columnId] : initialCellStateAccessor((_rowsById$_rowId = rowsById[_rowId]) == null ? void 0 : (_rowsById$_rowId$cell = _rowsById$_rowId.cells) == null ? void 0 : _rowsById$_rowId$cell.find(function(cell) {
					return cell.column.id === columnId;
				}));
				return _extends({}, state, { rowState: _extends({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends({}, _oldRowState, { cellState: _extends({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate(_value, oldCellState), _extends3)) }), _extends4)) });
			}
		}
		function useInstance$9(instance) {
			var _instance$autoResetRo = instance.autoResetRowState, autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo, data = instance.data, dispatch = instance.dispatch;
			var setRowState = React.useCallback(function(rowId, value) {
				return dispatch({
					type: actions.setRowState,
					rowId,
					value
				});
			}, [dispatch]);
			var setCellState = React.useCallback(function(rowId, columnId, value) {
				return dispatch({
					type: actions.setCellState,
					rowId,
					columnId,
					value
				});
			}, [dispatch]);
			var getAutoResetRowState = useGetLatest(autoResetRowState);
			useMountedLayoutEffect(function() {
				if (getAutoResetRowState()) dispatch({ type: actions.resetRowState });
			}, [data]);
			Object.assign(instance, {
				setRowState,
				setCellState
			});
		}
		function prepareRow$4(row, _ref) {
			var instance = _ref.instance;
			var _instance$initialRowS2 = instance.initialRowStateAccessor, initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2, _instance$initialCell2 = instance.initialCellStateAccessor, initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2, rowState = instance.state.rowState;
			if (row) {
				row.state = typeof rowState[row.id] !== "undefined" ? rowState[row.id] : initialRowStateAccessor(row);
				row.setState = function(updater) {
					return instance.setRowState(row.id, updater);
				};
				row.cells.forEach(function(cell) {
					if (!row.state.cellState) row.state.cellState = {};
					cell.state = typeof row.state.cellState[cell.column.id] !== "undefined" ? row.state.cellState[cell.column.id] : initialCellStateAccessor(cell);
					cell.setState = function(updater) {
						return instance.setCellState(row.id, cell.column.id, updater);
					};
				});
			}
		}
		actions.resetColumnOrder = "resetColumnOrder";
		actions.setColumnOrder = "setColumnOrder";
		var useColumnOrder = function useColumnOrder(hooks) {
			hooks.stateReducers.push(reducer$a);
			hooks.visibleColumnsDeps.push(function(deps, _ref) {
				var instance = _ref.instance;
				return [].concat(deps, [instance.state.columnOrder]);
			});
			hooks.visibleColumns.push(visibleColumns$2);
			hooks.useInstance.push(useInstance$a);
		};
		useColumnOrder.pluginName = "useColumnOrder";
		function reducer$a(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ columnOrder: [] }, state);
			if (action.type === actions.resetColumnOrder) return _extends({}, state, { columnOrder: instance.initialState.columnOrder || [] });
			if (action.type === actions.setColumnOrder) return _extends({}, state, { columnOrder: functionalUpdate(action.columnOrder, state.columnOrder) });
		}
		function visibleColumns$2(columns, _ref2) {
			var columnOrder = _ref2.instance.state.columnOrder;
			if (!columnOrder || !columnOrder.length) return columns;
			var columnOrderCopy = [].concat(columnOrder);
			var columnsCopy = [].concat(columns);
			var columnsInOrder = [];
			var _loop = function _loop() {
				var targetColumnId = columnOrderCopy.shift();
				var foundIndex = columnsCopy.findIndex(function(d) {
					return d.id === targetColumnId;
				});
				if (foundIndex > -1) columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
			};
			while (columnsCopy.length && columnOrderCopy.length) _loop();
			return [].concat(columnsInOrder, columnsCopy);
		}
		function useInstance$a(instance) {
			var dispatch = instance.dispatch;
			instance.setColumnOrder = React.useCallback(function(columnOrder) {
				return dispatch({
					type: actions.setColumnOrder,
					columnOrder
				});
			}, [dispatch]);
		}
		defaultColumn.canResize = true;
		actions.columnStartResizing = "columnStartResizing";
		actions.columnResizing = "columnResizing";
		actions.columnDoneResizing = "columnDoneResizing";
		actions.resetResize = "resetResize";
		var useResizeColumns = function useResizeColumns(hooks) {
			hooks.getResizerProps = [defaultGetResizerProps];
			hooks.getHeaderProps.push({ style: { position: "relative" } });
			hooks.stateReducers.push(reducer$b);
			hooks.useInstance.push(useInstance$b);
			hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
		};
		var defaultGetResizerProps = function defaultGetResizerProps(props, _ref) {
			var instance = _ref.instance, header = _ref.header;
			var dispatch = instance.dispatch;
			var onResizeStart = function onResizeStart(e, header) {
				var isTouchEvent = false;
				if (e.type === "touchstart") {
					if (e.touches && e.touches.length > 1) return;
					isTouchEvent = true;
				}
				var headerIdWidths = getLeafHeaders(header).map(function(d) {
					return [d.id, d.totalWidth];
				});
				var clientX = isTouchEvent ? Math.round(e.touches[0].clientX) : e.clientX;
				var raf;
				var mostRecentClientX;
				var dispatchEnd = function dispatchEnd() {
					window.cancelAnimationFrame(raf);
					raf = null;
					dispatch({ type: actions.columnDoneResizing });
				};
				var dispatchMove = function dispatchMove() {
					window.cancelAnimationFrame(raf);
					raf = null;
					dispatch({
						type: actions.columnResizing,
						clientX: mostRecentClientX
					});
				};
				var scheduleDispatchMoveOnNextAnimationFrame = function scheduleDispatchMoveOnNextAnimationFrame(clientXPos) {
					mostRecentClientX = clientXPos;
					if (!raf) raf = window.requestAnimationFrame(dispatchMove);
				};
				var handlersAndEvents = {
					mouse: {
						moveEvent: "mousemove",
						moveHandler: function moveHandler(e) {
							return scheduleDispatchMoveOnNextAnimationFrame(e.clientX);
						},
						upEvent: "mouseup",
						upHandler: function upHandler(e) {
							document.removeEventListener("mousemove", handlersAndEvents.mouse.moveHandler);
							document.removeEventListener("mouseup", handlersAndEvents.mouse.upHandler);
							dispatchEnd();
						}
					},
					touch: {
						moveEvent: "touchmove",
						moveHandler: function moveHandler(e) {
							if (e.cancelable) {
								e.preventDefault();
								e.stopPropagation();
							}
							scheduleDispatchMoveOnNextAnimationFrame(e.touches[0].clientX);
							return false;
						},
						upEvent: "touchend",
						upHandler: function upHandler(e) {
							document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
							document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
							dispatchEnd();
						}
					}
				};
				var events = isTouchEvent ? handlersAndEvents.touch : handlersAndEvents.mouse;
				var passiveIfSupported = passiveEventSupported() ? { passive: false } : false;
				document.addEventListener(events.moveEvent, events.moveHandler, passiveIfSupported);
				document.addEventListener(events.upEvent, events.upHandler, passiveIfSupported);
				dispatch({
					type: actions.columnStartResizing,
					columnId: header.id,
					columnWidth: header.totalWidth,
					headerIdWidths,
					clientX
				});
			};
			return [props, {
				onMouseDown: function onMouseDown(e) {
					return e.persist() || onResizeStart(e, header);
				},
				onTouchStart: function onTouchStart(e) {
					return e.persist() || onResizeStart(e, header);
				},
				style: { cursor: "col-resize" },
				draggable: false,
				role: "separator"
			}];
		};
		useResizeColumns.pluginName = "useResizeColumns";
		function reducer$b(state, action) {
			if (action.type === actions.init) return _extends({ columnResizing: { columnWidths: {} } }, state);
			if (action.type === actions.resetResize) return _extends({}, state, { columnResizing: { columnWidths: {} } });
			if (action.type === actions.columnStartResizing) {
				var clientX = action.clientX, columnId = action.columnId, columnWidth = action.columnWidth, headerIdWidths = action.headerIdWidths;
				return _extends({}, state, { columnResizing: _extends({}, state.columnResizing, {
					startX: clientX,
					headerIdWidths,
					columnWidth,
					isResizingColumn: columnId
				}) });
			}
			if (action.type === actions.columnResizing) {
				var _clientX = action.clientX;
				var _state$columnResizing = state.columnResizing, startX = _state$columnResizing.startX, _columnWidth = _state$columnResizing.columnWidth, _state$columnResizing2 = _state$columnResizing.headerIdWidths, _headerIdWidths = _state$columnResizing2 === void 0 ? [] : _state$columnResizing2;
				var percentageDeltaX = (_clientX - startX) / _columnWidth;
				var newColumnWidths = {};
				_headerIdWidths.forEach(function(_ref2) {
					var headerId = _ref2[0], headerWidth = _ref2[1];
					newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
				});
				return _extends({}, state, { columnResizing: _extends({}, state.columnResizing, { columnWidths: _extends({}, state.columnResizing.columnWidths, {}, newColumnWidths) }) });
			}
			if (action.type === actions.columnDoneResizing) return _extends({}, state, { columnResizing: _extends({}, state.columnResizing, {
				startX: null,
				isResizingColumn: null
			}) });
		}
		var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions(instance) {
			var flatHeaders = instance.flatHeaders, disableResizing = instance.disableResizing, getHooks = instance.getHooks, columnResizing = instance.state.columnResizing;
			var getInstance = useGetLatest(instance);
			flatHeaders.forEach(function(header) {
				var canResize = getFirstDefined(header.disableResizing === true ? false : void 0, disableResizing === true ? false : void 0, true);
				header.canResize = canResize;
				header.width = columnResizing.columnWidths[header.id] || header.originalWidth || header.width;
				header.isResizing = columnResizing.isResizingColumn === header.id;
				if (canResize) header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
					instance: getInstance(),
					header
				});
			});
		};
		function useInstance$b(instance) {
			var plugins = instance.plugins, dispatch = instance.dispatch, _instance$autoResetRe = instance.autoResetResize, autoResetResize = _instance$autoResetRe === void 0 ? true : _instance$autoResetRe, columns = instance.columns;
			ensurePluginOrder(plugins, ["useAbsoluteLayout"], "useResizeColumns");
			var getAutoResetResize = useGetLatest(autoResetResize);
			useMountedLayoutEffect(function() {
				if (getAutoResetResize()) dispatch({ type: actions.resetResize });
			}, [columns]);
			var resetResizing = React.useCallback(function() {
				return dispatch({ type: actions.resetResize });
			}, [dispatch]);
			Object.assign(instance, { resetResizing });
		}
		function getLeafHeaders(header) {
			var leafHeaders = [];
			(function recurseHeader(header) {
				if (header.columns && header.columns.length) header.columns.map(recurseHeader);
				leafHeaders.push(header);
			})(header);
			return leafHeaders;
		}
		var cellStyles = {
			position: "absolute",
			top: 0
		};
		var useAbsoluteLayout = function useAbsoluteLayout(hooks) {
			hooks.getTableBodyProps.push(getRowStyles);
			hooks.getRowProps.push(getRowStyles);
			hooks.getHeaderGroupProps.push(getRowStyles);
			hooks.getFooterGroupProps.push(getRowStyles);
			hooks.getHeaderProps.push(function(props, _ref) {
				var column = _ref.column;
				return [props, { style: _extends({}, cellStyles, {
					left: column.totalLeft + "px",
					width: column.totalWidth + "px"
				}) }];
			});
			hooks.getCellProps.push(function(props, _ref2) {
				var cell = _ref2.cell;
				return [props, { style: _extends({}, cellStyles, {
					left: cell.column.totalLeft + "px",
					width: cell.column.totalWidth + "px"
				}) }];
			});
			hooks.getFooterProps.push(function(props, _ref3) {
				var column = _ref3.column;
				return [props, { style: _extends({}, cellStyles, {
					left: column.totalLeft + "px",
					width: column.totalWidth + "px"
				}) }];
			});
		};
		useAbsoluteLayout.pluginName = "useAbsoluteLayout";
		var getRowStyles = function getRowStyles(props, _ref4) {
			return [props, { style: {
				position: "relative",
				width: _ref4.instance.totalColumnsWidth + "px"
			} }];
		};
		var cellStyles$1 = {
			display: "inline-block",
			boxSizing: "border-box"
		};
		var getRowStyles$1 = function getRowStyles(props, _ref) {
			return [props, { style: {
				display: "flex",
				width: _ref.instance.totalColumnsWidth + "px"
			} }];
		};
		var useBlockLayout = function useBlockLayout(hooks) {
			hooks.getRowProps.push(getRowStyles$1);
			hooks.getHeaderGroupProps.push(getRowStyles$1);
			hooks.getFooterGroupProps.push(getRowStyles$1);
			hooks.getHeaderProps.push(function(props, _ref2) {
				var column = _ref2.column;
				return [props, { style: _extends({}, cellStyles$1, { width: column.totalWidth + "px" }) }];
			});
			hooks.getCellProps.push(function(props, _ref3) {
				var cell = _ref3.cell;
				return [props, { style: _extends({}, cellStyles$1, { width: cell.column.totalWidth + "px" }) }];
			});
			hooks.getFooterProps.push(function(props, _ref4) {
				var column = _ref4.column;
				return [props, { style: _extends({}, cellStyles$1, { width: column.totalWidth + "px" }) }];
			});
		};
		useBlockLayout.pluginName = "useBlockLayout";
		function useFlexLayout(hooks) {
			hooks.getTableProps.push(getTableProps);
			hooks.getRowProps.push(getRowStyles$2);
			hooks.getHeaderGroupProps.push(getRowStyles$2);
			hooks.getFooterGroupProps.push(getRowStyles$2);
			hooks.getHeaderProps.push(getHeaderProps);
			hooks.getCellProps.push(getCellProps);
			hooks.getFooterProps.push(getFooterProps);
		}
		useFlexLayout.pluginName = "useFlexLayout";
		var getTableProps = function getTableProps(props, _ref) {
			return [props, { style: { minWidth: _ref.instance.totalColumnsMinWidth + "px" } }];
		};
		var getRowStyles$2 = function getRowStyles(props, _ref2) {
			return [props, { style: {
				display: "flex",
				flex: "1 0 auto",
				minWidth: _ref2.instance.totalColumnsMinWidth + "px"
			} }];
		};
		var getHeaderProps = function getHeaderProps(props, _ref3) {
			var column = _ref3.column;
			return [props, { style: {
				boxSizing: "border-box",
				flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : void 0,
				minWidth: column.totalMinWidth + "px",
				width: column.totalWidth + "px"
			} }];
		};
		var getCellProps = function getCellProps(props, _ref4) {
			var cell = _ref4.cell;
			return [props, { style: {
				boxSizing: "border-box",
				flex: cell.column.totalFlexWidth + " 0 auto",
				minWidth: cell.column.totalMinWidth + "px",
				width: cell.column.totalWidth + "px"
			} }];
		};
		var getFooterProps = function getFooterProps(props, _ref5) {
			var column = _ref5.column;
			return [props, { style: {
				boxSizing: "border-box",
				flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : void 0,
				minWidth: column.totalMinWidth + "px",
				width: column.totalWidth + "px"
			} }];
		};
		actions.columnStartResizing = "columnStartResizing";
		actions.columnResizing = "columnResizing";
		actions.columnDoneResizing = "columnDoneResizing";
		actions.resetResize = "resetResize";
		function useGridLayout(hooks) {
			hooks.stateReducers.push(reducer$c);
			hooks.getTableProps.push(getTableProps$1);
			hooks.getHeaderProps.push(getHeaderProps$1);
			hooks.getRowProps.push(getRowProps);
		}
		useGridLayout.pluginName = "useGridLayout";
		var getTableProps$1 = function getTableProps(props, _ref) {
			var instance = _ref.instance;
			return [props, { style: {
				display: "grid",
				gridTemplateColumns: instance.visibleColumns.map(function(column) {
					var _instance$state$colum;
					if (instance.state.gridLayout.columnWidths[column.id]) return instance.state.gridLayout.columnWidths[column.id] + "px";
					if ((_instance$state$colum = instance.state.columnResizing) == null ? void 0 : _instance$state$colum.isResizingColumn) return instance.state.gridLayout.startWidths[column.id] + "px";
					if (typeof column.width === "number") return column.width + "px";
					return column.width;
				}).join(" ")
			} }];
		};
		var getHeaderProps$1 = function getHeaderProps(props, _ref2) {
			var column = _ref2.column;
			return [props, {
				id: "header-cell-" + column.id,
				style: {
					position: "sticky",
					gridColumn: "span " + column.totalVisibleHeaderCount
				}
			}];
		};
		var getRowProps = function getRowProps(props, _ref3) {
			var row = _ref3.row;
			if (row.isExpanded) return [props, { style: { gridColumn: "1 / " + (row.cells.length + 1) } }];
			return [props, {}];
		};
		function reducer$c(state, action, previousState, instance) {
			if (action.type === actions.init) return _extends({ gridLayout: { columnWidths: {} } }, state);
			if (action.type === actions.resetResize) return _extends({}, state, { gridLayout: { columnWidths: {} } });
			if (action.type === actions.columnStartResizing) {
				var columnId = action.columnId, headerIdWidths = action.headerIdWidths;
				var columnWidth = getElementWidth(columnId);
				if (columnWidth !== void 0) {
					var startWidths = instance.visibleColumns.reduce(function(acc, column) {
						var _extends2;
						return _extends({}, acc, (_extends2 = {}, _extends2[column.id] = getElementWidth(column.id), _extends2));
					}, {});
					var minWidths = instance.visibleColumns.reduce(function(acc, column) {
						var _extends3;
						return _extends({}, acc, (_extends3 = {}, _extends3[column.id] = column.minWidth, _extends3));
					}, {});
					var maxWidths = instance.visibleColumns.reduce(function(acc, column) {
						var _extends4;
						return _extends({}, acc, (_extends4 = {}, _extends4[column.id] = column.maxWidth, _extends4));
					}, {});
					var headerIdGridWidths = headerIdWidths.map(function(_ref4) {
						var headerId = _ref4[0];
						return [headerId, getElementWidth(headerId)];
					});
					return _extends({}, state, { gridLayout: _extends({}, state.gridLayout, {
						startWidths,
						minWidths,
						maxWidths,
						headerIdGridWidths,
						columnWidth
					}) });
				} else return state;
			}
			if (action.type === actions.columnResizing) {
				var clientX = action.clientX;
				var startX = state.columnResizing.startX;
				var _state$gridLayout = state.gridLayout, _columnWidth = _state$gridLayout.columnWidth, _minWidths = _state$gridLayout.minWidths, _maxWidths = _state$gridLayout.maxWidths, _state$gridLayout$hea = _state$gridLayout.headerIdGridWidths, _headerIdGridWidths = _state$gridLayout$hea === void 0 ? [] : _state$gridLayout$hea;
				var percentageDeltaX = (clientX - startX) / _columnWidth;
				var newColumnWidths = {};
				_headerIdGridWidths.forEach(function(_ref5) {
					var headerId = _ref5[0], headerWidth = _ref5[1];
					newColumnWidths[headerId] = Math.min(Math.max(_minWidths[headerId], headerWidth + headerWidth * percentageDeltaX), _maxWidths[headerId]);
				});
				return _extends({}, state, { gridLayout: _extends({}, state.gridLayout, { columnWidths: _extends({}, state.gridLayout.columnWidths, {}, newColumnWidths) }) });
			}
			if (action.type === actions.columnDoneResizing) return _extends({}, state, { gridLayout: _extends({}, state.gridLayout, {
				startWidths: {},
				minWidths: {},
				maxWidths: {}
			}) });
		}
		function getElementWidth(columnId) {
			var _document$getElementB;
			var width = (_document$getElementB = document.getElementById("header-cell-" + columnId)) == null ? void 0 : _document$getElementB.offsetWidth;
			if (width !== void 0) return width;
		}
		exports._UNSTABLE_usePivotColumns = _UNSTABLE_usePivotColumns;
		exports.actions = actions;
		exports.defaultColumn = defaultColumn;
		exports.defaultGroupByFn = defaultGroupByFn;
		exports.defaultOrderByFn = defaultOrderByFn;
		exports.defaultRenderer = defaultRenderer;
		exports.emptyRenderer = emptyRenderer;
		exports.ensurePluginOrder = ensurePluginOrder;
		exports.flexRender = flexRender;
		exports.functionalUpdate = functionalUpdate;
		exports.loopHooks = loopHooks;
		exports.makePropGetter = makePropGetter;
		exports.makeRenderer = makeRenderer;
		exports.reduceHooks = reduceHooks;
		exports.safeUseLayoutEffect = safeUseLayoutEffect;
		exports.useAbsoluteLayout = useAbsoluteLayout;
		exports.useAsyncDebounce = useAsyncDebounce;
		exports.useBlockLayout = useBlockLayout;
		exports.useColumnOrder = useColumnOrder;
		exports.useExpanded = useExpanded;
		exports.useFilters = useFilters;
		exports.useFlexLayout = useFlexLayout;
		exports.useGetLatest = useGetLatest;
		exports.useGlobalFilter = useGlobalFilter;
		exports.useGridLayout = useGridLayout;
		exports.useGroupBy = useGroupBy;
		exports.useMountedLayoutEffect = useMountedLayoutEffect;
		exports.usePagination = usePagination;
		exports.useResizeColumns = useResizeColumns;
		exports.useRowSelect = useRowSelect;
		exports.useRowState = useRowState;
		exports.useSortBy = useSortBy;
		exports.useTable = useTable;
		Object.defineProperty(exports, "__esModule", { value: true });
	}));
}));
//#endregion
//#region src/components/molecules/gantt-chart/gantt-chart.styled.ts
var import_react_table = (/* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_react_table_production_min();
	else module.exports = require_react_table_development();
})))();
var ganttStickyColumnShadow = {
	boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.15)",
	clipPath: "inset(0px -10px 0px 0px)"
};
var ganttStickyRowShadow = {
	boxShadow: "0px -2px 4px 3px rgba(0, 0, 0, 0.2)",
	clipPath: "inset(0px 0px -10px 0px)"
};
var GanttChartContainer = (0, import_dist.default)(Stack)`
  max-w-full
  overflow-x-auto
  pb-4
`;
var ProjectLeftBar = import_dist.default.div`
  absolute
  h-full
  float-left
  ${({ $isClicked }) => `${$isClicked ? "w-3" : "w-1"}`}
  ${({ $variant }) => getRecipeClassName($variant, "colorBg").bg}
`;
var ProjectName = import_dist.default.span`
  truncate
  underline
  cursor-pointer
  text-sm
  font-medium
  ${({ $variant }) => getRecipeClassName($variant, "whiteBg").text}
`;
var ColorBlock = import_dist.default.div`
  w-full
  h-full
  ${({ $highlighted, $rowIndex, $variant }) => {
	if ($highlighted) return getRecipeClassName($variant, "colorBg").bg;
	return $rowIndex % 2 === 0 ? "bg-gray-300" : "bg-gray-100";
}}
`;
var TableEndContainer = import_dist.default.div`
  relative
  px-8
  overflow-hidden
`;
var TableEndTextContainer = import_dist.default.div`
  absolute
  top-1/2
  left-1/2
  -rotate-90
  -translate-x-1/2
  -translate-y-1/2
`;
var ProjectColumnHead = import_dist.default.th`
  bg-gray-50
  h-1
  sticky
  top-0
  left-0
  z-10
`;
var ProjectColumnCell = import_dist.default.td`
  relative
  bg-white
  m-0
  p-0
  h-1
  sticky
  top-0
  left-0
  z-10
`;
import_dist.default.div`
  px-6
  h-full
  flex
  items-center
`;
var ProjectNameContainer = import_dist.default.div`
  max-w-[300px]
  px-6
  h-full
  flex
  items-center
  border-b
  border-b-gray-200
`;
//#endregion
//#region src/components/molecules/gantt-chart/gantt-chart.utils.tsx
var COLUMN_ID_PROJECT = "project";
var validateDatePeriod = (period) => !!period.startDate && !!period.endDate;
var calculateDatePeriodUnion = (periods) => {
	if (periods.length === 0) throw new Error("Cannot calculate period on empty data");
	const datePeriodUnion = periods.reduce((result, period) => {
		if (!period.startDate || !period.endDate) return {
			startDate: result.startDate,
			endDate: result.endDate
		};
		if (!result.startDate || !result.endDate) return {
			startDate: period.startDate,
			endDate: period.endDate
		};
		return {
			startDate: period.startDate < result.startDate ? period.startDate : result.startDate,
			endDate: period.endDate > result.endDate ? period.endDate : result.endDate
		};
	}, periods[0]);
	if (!validateDatePeriod(datePeriodUnion)) throw new Error("Cannot calculate period on invalid data");
	return datePeriodUnion;
};
var makeProjectColumn = ({ clickedRowId, data, onRowClick, onRowSelect, selectedRowIds }) => ({
	id: COLUMN_ID_PROJECT,
	accessor: (datum) => datum,
	Header: () => {
		const handleSelectAll = selectedRowIds && onRowSelect ? () => {
			onRowSelect(selectedRowIds.length === data.length ? [] : data.map((datum) => datum.id));
		} : void 0;
		return /* @__PURE__ */ React.createElement(ProjectColumnHead, null, /* @__PURE__ */ React.createElement(Stack, {
			alignItems: "center",
			className: "px-6 h-full",
			style: ganttStickyColumnShadow
		}, selectedRowIds && /* @__PURE__ */ React.createElement(Checkbox, {
			id: "projects",
			name: "projects",
			checked: selectedRowIds.length === data.length,
			onChange: handleSelectAll
		}), /* @__PURE__ */ React.createElement(Typography, {
			as: "span",
			fontSize: "sm",
			fontWeight: "medium"
		}, "Projects")));
	},
	Cell: ({ row, value }) => {
		const checked = selectedRowIds?.includes(row.original.id);
		const clicked = clickedRowId === row.original.id;
		const rowEventHandlerData = { rowData: row.original };
		const handleClick = onRowClick ? () => {
			onRowClick(rowEventHandlerData);
		} : void 0;
		const handleSelect = selectedRowIds && onRowSelect ? () => {
			onRowSelect(checked ? selectedRowIds.filter((id) => id !== row.original.id) : [...selectedRowIds, row.original.id]);
		} : void 0;
		return /* @__PURE__ */ React.createElement(ProjectColumnCell, null, /* @__PURE__ */ React.createElement(ProjectLeftBar, {
			$isClicked: clicked,
			$variant: value.variant
		}), /* @__PURE__ */ React.createElement(ProjectNameContainer, { style: ganttStickyColumnShadow }, selectedRowIds && /* @__PURE__ */ React.createElement(Checkbox, {
			id: row.original.id,
			name: row.original.name,
			checked,
			onChange: handleSelect
		}), /* @__PURE__ */ React.createElement(ProjectName, {
			$variant: value.variant,
			title: value.name,
			onClick: handleClick
		}, value.name)));
	},
	minWidth: 150
});
var makePeriodColumns = ({ endMonthYear, hoveredCellData, onCellClick, onCellHover, startMonthYear }) => {
	const { month: startMonth, year: startYear } = startMonthYear;
	const totalMonthCount = (0, import_lib.getNumberOfMonthsInPeriod)({
		startMonthYear,
		endMonthYear
	});
	return (0, import_lib.range)(startMonth, startMonth + totalMonthCount, 1).map((monthIncrement) => {
		const currentMonth = monthIncrement % 12;
		const currentYear = startYear + Math.floor(monthIncrement / 12);
		const monthAbbreviation = (0, import_lib.getMonthShortAbbreviation)(currentMonth);
		const isHoveredColumn = !!hoveredCellData && hoveredCellData.year === currentYear && hoveredCellData.month === currentMonth;
		return {
			id: `${currentYear}-${currentMonth}`,
			accessor: (datum) => datum,
			Header: () => /* @__PURE__ */ React.createElement("th", { className: "bg-gray-50" }, /* @__PURE__ */ React.createElement(Stack, {
				direction: "column",
				alignItems: "center",
				className: "py-2 w-[60px]",
				style: ganttStickyRowShadow
			}, /* @__PURE__ */ React.createElement(Typography, {
				as: "p",
				fontSize: "xs",
				className: isHoveredColumn ? "" : "text-gray-400"
			}, currentYear), /* @__PURE__ */ React.createElement(Typography, {
				as: "p",
				fontSize: "sm",
				fontWeight: "medium"
			}, monthAbbreviation.toUpperCase()))),
			Cell: ({ column, row }) => {
				const datum = row.original;
				const startMonthYear = datum.startDate ? (0, import_lib.dateToMonthYear)(datum.startDate) : null;
				const endMonthYear = datum.endDate ? (0, import_lib.dateToMonthYear)(datum.endDate) : null;
				const isInProjectPeriod = startMonthYear && endMonthYear && (0, import_lib.isMonthYearInRange)({
					month: currentMonth,
					year: currentYear
				}, startMonthYear, endMonthYear);
				const isClickable = isInProjectPeriod && column.id !== COLUMN_ID_PROJECT && !!onCellClick;
				const cellEventHandlerData = {
					rowData: datum,
					year: currentYear,
					month: currentMonth
				};
				const handleClick = isClickable ? () => {
					onCellClick(cellEventHandlerData);
				} : void 0;
				const handleHover = onCellHover ? (isHovered) => () => {
					onCellHover(isHovered ? cellEventHandlerData : void 0);
				} : void 0;
				return /* @__PURE__ */ React.createElement("td", { className: "m-0 p-0" }, /* @__PURE__ */ React.createElement("div", { className: "h-9" }, /* @__PURE__ */ React.createElement(ColorBlock, {
					$as: isClickable ? "button" : "div",
					$variant: datum.variant,
					$rowIndex: row.index,
					$highlighted: isInProjectPeriod,
					onClick: handleClick,
					onMouseEnter: handleHover?.(true),
					onMouseLeave: handleHover?.(false)
				})));
			}
		};
	});
};
//#endregion
//#region src/components/molecules/gantt-chart/hooks/useColumns.ts
var useColumns = (data, startMonthYear, endMonthYear, clickedRowId, selectedRowIds, onCellClick, onRowClick, onRowSelect) => {
	const [hoveredCellData, setHoveredCellData] = useState(void 0);
	return useMemo(() => {
		return [makeProjectColumn({
			data,
			clickedRowId,
			selectedRowIds,
			onRowClick,
			onRowSelect
		}), ...makePeriodColumns({
			startMonthYear,
			endMonthYear,
			hoveredCellData,
			onCellClick,
			onCellHover: setHoveredCellData
		})];
	}, [
		data,
		startMonthYear,
		endMonthYear,
		clickedRowId,
		selectedRowIds,
		hoveredCellData,
		onCellClick,
		onRowClick,
		onRowSelect
	]);
};
//#endregion
//#region src/components/molecules/gantt-chart/hooks/useDatePeriod.ts
var useDatePeriod = ({ periods, options = {} }) => {
	const { fixedEndMonthYear, fixedStartMonthYear } = options;
	return useMemo(() => {
		if (!!fixedStartMonthYear && !!fixedEndMonthYear) return {
			startMonthYear: fixedStartMonthYear,
			endMonthYear: fixedEndMonthYear
		};
		const datePeriodUnion = calculateDatePeriodUnion(periods);
		const monthYearPeriodUnion = (0, import_lib.toMonthYearPeriod)(datePeriodUnion.startDate, datePeriodUnion.endDate);
		return {
			startMonthYear: fixedStartMonthYear ?? monthYearPeriodUnion.startMonthYear,
			endMonthYear: fixedEndMonthYear ?? monthYearPeriodUnion.endMonthYear
		};
	}, [
		periods,
		fixedStartMonthYear,
		fixedEndMonthYear
	]);
};
//#endregion
//#region src/components/molecules/gantt-chart/GanttChart.tsx
var GanttChart = ({ clickedRowId, data, endMonthYear: fixedEndMonthYear, onCellClick, onRowClick, onRowSelect, selectedRowIds, startMonthYear: fixedStartMonthYear }) => {
	const { endMonthYear, startMonthYear } = useDatePeriod({
		periods: data,
		options: {
			fixedStartMonthYear,
			fixedEndMonthYear
		}
	});
	const columns = useColumns(data, startMonthYear, endMonthYear, clickedRowId, selectedRowIds, onCellClick, onRowClick, onRowSelect);
	const { getTableBodyProps, getTableProps, headerGroups, prepareRow, rows } = (0, import_react_table.useTable)({
		columns,
		data
	});
	return /* @__PURE__ */ React.createElement(GanttChartContainer, null, /* @__PURE__ */ React.createElement("table", getTableProps(), /* @__PURE__ */ React.createElement("thead", null, headerGroups.map((headerGroup) => {
		const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
		return /* @__PURE__ */ React.createElement("tr", {
			key,
			...restHeaderGroupProps
		}, headerGroup.headers.map((column, index) => column.render("Header", { key: index })));
	})), /* @__PURE__ */ React.createElement("tbody", getTableBodyProps(), rows.map((row) => {
		prepareRow(row);
		const { key, ...restRowProps } = row.getRowProps();
		return /* @__PURE__ */ React.createElement("tr", {
			key,
			...restRowProps
		}, row.cells.map((cell, index) => cell.render("Cell", { key: index })));
	}))), /* @__PURE__ */ React.createElement(TableEndContainer, null, /* @__PURE__ */ React.createElement(TableEndTextContainer, null, /* @__PURE__ */ React.createElement(Typography, {
		as: "p",
		title: "END OF PERIOD",
		fontSize: "lg",
		fontWeight: "bold",
		color: colors.gray[300],
		className: "truncate"
	}, "END OF PERIOD"))));
};
//#endregion
//#region src/components/molecules/icon-button-group/icon-button-group.styled.ts
var ICON_BUTTON_GROUP_COLOR_VARIANTS = {
	primary: "bg-transparent",
	darkGray: "bg-gray-800",
	darkGrayBorder: "bg-gray-600 border border-gray-200",
	gray: "bg-gray-200",
	grayBorder: "border border-gray-200",
	lightGray: "bg-gray-100",
	transparent: "bg-transparent",
	inherit: ""
};
var ICON_BUTTON_GROUP_ROUNDED_VARIANTS = {
	none: "",
	regular: "rounded-md",
	top: "rounded-t",
	bottom: "rounded-b",
	left: "rounded-l",
	right: "rounded-r"
};
var StyledIconButtonGroup = (0, import_dist.default)(Stack)`
  gap-px
  overflow-hidden
  px-1
  ${({ $variant }) => ICON_BUTTON_GROUP_COLOR_VARIANTS[$variant]}
  ${({ $rounded }) => ICON_BUTTON_GROUP_ROUNDED_VARIANTS[$rounded]}
`;
//#endregion
//#region src/components/molecules/icon-button-group/IconButtonGroup.tsx
var IconButtonGroup = ({ className, iconButtons, rounded = "regular", variant }) => /* @__PURE__ */ React.createElement(StyledIconButtonGroup, {
	$rounded: rounded,
	$variant: variant,
	className
}, iconButtons.map(({ active, icon, id, size, ...rest }) => /* @__PURE__ */ React.createElement(IconButton, {
	id,
	key: id,
	variant,
	active,
	icon,
	size,
	...rest
})));
//#endregion
//#region src/components/molecules/indexed-scroll-container/hooks/useClearLocationHashOnUnmount.ts
var useClearLocationHashOnUnmount = ({ data, unused, url } = {}) => useEffect(() => () => {
	window.history.replaceState(data ?? "", unused ?? document.title, url ?? window.location.pathname + window.location.search);
}, [
	data,
	unused,
	url
]);
//#endregion
//#region src/components/molecules/indexed-scroll-container/indexed-scroll-container.styled.ts
var TableOfContentsContainer = (0, import_dist.default)(Stack)`
  min-w-[280px]
  overflow-y-auto
`;
var TableOfContentsTypography = (0, import_dist.default)(Typography)`
  py-2
  pl-4
  border-l-2
  hover:font-medium
  ${({ $active }) => $active ? "border-primary-600" : "border-transparent"}
`;
/**
* Developer MUST set height or max-height on a parent element to make the scroll work.
*/
var ScrollContainer = (0, import_dist.default)(Stack)`
  overflow-y-scroll
`;
var HeaderTypography = (0, import_dist.default)(Typography)`
  sticky
  top-0
  text-gray-700
  bg-white
`;
var BodyTypography = (0, import_dist.default)(Typography)`
  text-gray-500
`;
//#endregion
//#region src/components/molecules/indexed-scroll-container/IndexedScrollContainer.tsx
/**
* Developer MUST set height or max-height to make the y-scroll work. Can be done
* by styling the component directly which will affect the `Stack` wrapper.
*/
var IndexedScrollContainer = ({ bodyTypographyProps, currentLocationHash, headerTypographyProps, items, scrollContainerProps, ...stackProps }) => {
	useClearLocationHashOnUnmount();
	return /* @__PURE__ */ m$3.createElement(Stack, {
		direction: "row",
		gap: 4,
		...stackProps
	}, /* @__PURE__ */ m$3.createElement(TableOfContentsContainer, { direction: "column" }, items.map(({ title }) => {
		const itemHash = "#" + (0, import_lib.kebabCase)(title);
		const matchesLocationHash = currentLocationHash === itemHash;
		return /* @__PURE__ */ m$3.createElement(TableOfContentsTypography, {
			key: title,
			as: "a",
			href: itemHash,
			fontSize: "sm",
			fontWeight: matchesLocationHash ? "medium" : void 0,
			$active: matchesLocationHash
		}, title);
	})), /* @__PURE__ */ m$3.createElement(ScrollContainer, {
		direction: "column",
		space: 6,
		...scrollContainerProps
	}, items.map(({ description, title }) => /* @__PURE__ */ m$3.createElement(Stack, {
		key: title,
		id: (0, import_lib.kebabCase)(title),
		direction: "column"
	}, /* @__PURE__ */ m$3.createElement(HeaderTypography, {
		as: "p",
		fontSize: "sm",
		fontWeight: "medium",
		...headerTypographyProps
	}, title), /* @__PURE__ */ m$3.createElement(BodyTypography, {
		as: "p",
		fontSize: "sm",
		...bodyTypographyProps
	}, description)))));
};
//#endregion
//#region src/components/molecules/loading-overlay/loading-overlay.styled.ts
var StackStyled = (0, import_dist.default)(Stack)`
  relative
`;
var Overlay = import_dist.default.div`
  absolute
  inset-0
  z-10
  w-full
  h-full
  flex
  justify-center
  items-center
  bg-white/[0.6]
  backdrop-saturate-0
  !m-0
`;
var LoadingStyled = (0, import_dist.default)(Loading)`
  z-20
`;
//#endregion
//#region src/components/molecules/loading-overlay/LoadingOverlay.tsx
var LoadingOverlay = ({ children, height = 120, loading = false, ...props }) => /* @__PURE__ */ m$3.createElement(StackStyled, {
	direction: "column",
	...props
}, children, loading && /* @__PURE__ */ m$3.createElement(Overlay, null, /* @__PURE__ */ m$3.createElement(LoadingStyled, { height })));
//#endregion
//#region src/components/molecules/loading/loading.styled.ts
var ScreenLoadingContainer = import_dist.default.div`bg-gray-50 w-screen h-screen flex items-center justify-center`;
//#endregion
//#region src/components/molecules/loading/ScreenLoading.tsx
var ScreenLoading = () => /* @__PURE__ */ React.createElement(ScreenLoadingContainer, null, /* @__PURE__ */ React.createElement(Loading, { height: 160 }));
//#endregion
//#region src/assets/icons/mark.svg
var SvgMark = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 27 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M26.686 28.9485V2.51226C26.6592 1.83693 26.3719 1.19819 25.8846 0.729872C25.3973 0.261558 24.7476 0 24.0718 0C23.3959 0 22.7462 0.261558 22.2589 0.729872C21.7716 1.19819 21.4844 1.83693 21.4575 2.51226V22.7679L17.591 17.3862C17.453 17.2115 17.2847 17.0629 17.0942 16.9475C16.8144 16.7709 16.5018 16.6527 16.1752 16.5997C16.0384 16.5783 15.8999 16.5672 15.7612 16.5667C15.569 16.5677 15.3775 16.59 15.19 16.6328C14.8674 16.7139 14.5628 16.8543 14.2917 17.0468C14.0229 17.2437 13.795 17.4912 13.6211 17.7754C13.4438 18.0563 13.3254 18.3704 13.2733 18.6986C13.2203 19.0261 13.2316 19.3606 13.3064 19.6838C13.3818 19.9533 13.5022 20.208 13.6624 20.4373L21.1843 30.7493C21.563 31.2689 22.0965 31.6552 22.7083 31.8528C23.3201 32.0503 23.9788 32.049 24.5898 31.8491C25.2008 31.649 25.7328 31.2607 26.1094 30.7396C26.486 30.2185 26.6878 29.5914 26.686 28.9485ZM0 3.03491V29.4712V29.4794C0.0268794 30.1548 0.314064 30.7935 0.80139 31.2618C1.28872 31.7302 1.93837 31.9917 2.61423 31.9917C3.29011 31.9917 3.93976 31.7302 4.42709 31.2618C4.91441 30.7935 5.20159 30.1548 5.22847 29.4794V9.23207L9.09498 14.6138C9.23306 14.7885 9.40131 14.9371 9.59175 15.0525C9.87157 15.2291 10.1842 15.3473 10.5108 15.4003C10.6477 15.4217 10.7861 15.4328 10.9247 15.4333C11.117 15.4323 11.3086 15.4101 11.496 15.3672C11.8186 15.2861 12.1232 15.1457 12.3943 14.9532C12.6632 14.7564 12.891 14.5088 13.0649 14.2245C13.2422 13.9436 13.3606 13.6296 13.4127 13.3014C13.4658 12.974 13.4545 12.6393 13.3795 12.3162C13.3041 12.0468 13.1838 11.792 13.0236 11.5627L5.5017 1.25069C5.12388 0.732242 4.59186 0.346468 3.98166 0.1485C3.37144 -0.0494672 2.71429 -0.0494994 2.10406 0.148399C1.49384 0.346298 0.961772 0.732007 0.583892 1.25041C0.206012 1.76882 0.00164186 2.3934 0 3.03491Z",
		fill: "currentColor"
	})
});
var ForwardRef$14 = forwardRef(SvgMark);
var Memo$14 = memo(ForwardRef$14);
//#endregion
//#region src/components/molecules/logo/logo.styled.ts
var StyledNeoTaxLogo = (0, import_dist.default)(Memo$14)`
${({ $animated }) => $animated ? "animate-flip" : ""}
  text-primary-600
  inline-block
  h-12
  w-12
`;
//#endregion
//#region src/components/molecules/logo/Logo.tsx
var Logo = ({ animated, className, href, id }) => {
	if (href) return /* @__PURE__ */ React.createElement("a", {
		id,
		className,
		href,
		target: "_blank",
		rel: "noopener noreferrer"
	}, /* @__PURE__ */ React.createElement(StyledNeoTaxLogo, { $animated: animated }));
	return /* @__PURE__ */ React.createElement(StyledNeoTaxLogo, {
		$animated: animated,
		id,
		className
	});
};
//#endregion
//#region src/components/molecules/month-date-picker/MonthDatePicker.tsx
var MonthDatePicker = ({ monthAutoFocus, monthDateAutoFocus, monthDateDisabled, monthDateError, monthDateErrorText, monthDateForm, monthDateHelpText, monthDateId, monthDateLabel, monthDateName, monthDatePlaceholder, monthDateRequired, monthDateSize, monthDateValue, monthDisabled, monthError, monthErrorText, monthForm, monthHelpText, monthId, monthLabel, monthName, monthPlaceholder, monthRequired, monthSize, monthValue, onChangeMonth, onChangeMonthDate, usePortal, ...props }) => {
	const monthDateOptions = useMonthDateOptions(monthValue);
	const handleChangeMonth = (month) => {
		onChangeMonth?.(month);
		onChangeMonthDate?.("");
	};
	return /* @__PURE__ */ React.createElement(Stack, {
		direction: "row",
		space: 11,
		...props
	}, /* @__PURE__ */ React.createElement(InputFormContainer, {
		inputId: monthId,
		label: monthLabel,
		helpText: monthHelpText,
		withError: monthError
	}, /* @__PURE__ */ React.createElement(Select, {
		id: monthId,
		autoFocus: monthAutoFocus,
		disabled: monthDisabled,
		error: monthError,
		errorText: monthErrorText,
		form: monthForm,
		name: monthName,
		placeholder: monthPlaceholder,
		required: monthRequired,
		size: monthSize,
		value: monthValue,
		onChange: handleChangeMonth,
		options: monthOptions,
		usePortal
	})), /* @__PURE__ */ React.createElement(InputFormContainer, {
		inputId: monthDateId,
		label: monthDateLabel,
		helpText: monthDateHelpText,
		withError: monthDateError
	}, /* @__PURE__ */ React.createElement(Select, {
		id: monthDateId,
		autoFocus: monthDateAutoFocus,
		error: monthDateError,
		errorText: monthDateErrorText,
		disabled: monthDateDisabled,
		form: monthDateForm,
		name: monthDateName,
		placeholder: monthDatePlaceholder,
		required: monthDateRequired,
		size: monthDateSize,
		value: monthDateValue,
		onChange: onChangeMonthDate,
		options: monthDateOptions,
		usePortal
	})));
};
//#endregion
//#region src/components/molecules/nav-item/nav-item.context.ts
var NavItemContext = createContext({ open: false });
//#endregion
//#region src/components/molecules/nav-item/nav-item.styled.ts
var NAV_ITEM_VARIANTS = {
	light: "text-gray-600 hover:bg-gray-400 hover:text-gray-50",
	dark: "text-gray-300 hover:bg-primary-600 hover:bg-opacity-75 hover:text-white"
};
var NAV_ITEM_ACTIVE_AND_OPEN_VARIANTS = {
	light: "w-full bg-gray-200 hover:bg-gray-400 text-gray-600",
	dark: "w-full bg-gray-800 text-gray-50 hover:bg-primary-600 hover:text-gray-50"
};
var NAV_ITEM_ACTIVE_VARIANTS = {
	light: "bg-gray-200 hover:bg-gray-400 text-gray-900",
	dark: "bg-gray-800 text-gray-50"
};
var NAV_ITEM_OPEN_VARIANTS = {
	light: "w-full hover:bg-gray-400 text-gray-600 hover:text-gray-50",
	dark: "w-full hover:bg-gray-700 text-gray-300 hover:text-gray-50"
};
var NAV_ITEM_ICON_VARIANTS = {
	light: "text-gray-400 group-hover:text-gray-50",
	dark: "text-inherit"
};
var NAV_ITEM_TEXT_VARIANTS = {
	light: "text-gray-900",
	dark: "text-inherit"
};
var NavItemIcon = (0, import_dist.default)(Icon)`
  flex-shrink-0
  transition-colors
  ${({ $variant }) => NAV_ITEM_ICON_VARIANTS[$variant]}
  ${({ $open }) => $open ? "mr-3" : ""}
`;
var SideNavTitleContainer = import_dist.default.div`
  flex-1
  whitespace-nowrap
  text-inherit
  pr-0.5
`;
var SideNavTitle = (0, import_dist.default)(Typography)`
  ${({ $variant }) => NAV_ITEM_TEXT_VARIANTS[$variant]}
`;
var getNavItemStyling = ($active, $open, $variant) => {
	if ($active && $open) return NAV_ITEM_ACTIVE_AND_OPEN_VARIANTS[$variant];
	if ($active) return NAV_ITEM_ACTIVE_VARIANTS[$variant];
	if ($open) return NAV_ITEM_OPEN_VARIANTS[$variant];
	return NAV_ITEM_VARIANTS[$variant];
};
var StyledNavItemContainer = (0, import_dist.default)(Stack)`
  ${({ $open }) => $open ? "w-full" : ""}
`;
var StyledStack$1 = (0, import_dist.default)(Stack)`
  px-3
  py-2
  group
  flex
  items-center
  text-left
  rounded-md
  transition-[padding]
  transition-colors
  overflow-x-hidden
  focus:outline-primary-600
  ${({ $active, $open, $variant }) => getNavItemStyling($active, $open, $variant)}
`;
//#endregion
//#region src/components/molecules/nav-item/NavItem.tsx
var NavItem = ({ active, badge, className, icon, id, title, ...restProps }) => {
	const { open, variant } = useContext(NavItemContext);
	return /* @__PURE__ */ React.createElement(StyledNavItemContainer, {
		$open: open,
		direction: "column"
	}, /* @__PURE__ */ React.createElement(StyledStack$1, {
		id,
		$active: active,
		$open: open,
		$variant: variant,
		className,
		...restProps
	}, icon ? /* @__PURE__ */ React.createElement(NavItemIcon, {
		$variant: variant,
		node: icon,
		size: 6,
		variant: "none",
		$open: open
	}) : null, open && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SideNavTitleContainer, { $variant: variant }, /* @__PURE__ */ React.createElement(SideNavTitle, {
		$variant: variant,
		fontSize: "sm",
		as: "span",
		fontWeight: "medium"
	}, title)), badge && /* @__PURE__ */ React.createElement(Badge, badge))));
};
//#endregion
//#region src/components/molecules/quick-action-group/quick-action.group.styled.ts
var Label = (0, import_dist.default)(Typography)`
  shrink-2
`;
//#endregion
//#region src/components/molecules/quick-action-group/QuickActionGroup.tsx
var QuickActionGroup = ({ label, onClick, options, ...props }) => {
	const handleClick = (option) => (e) => {
		const handleClick = option.onClick ?? onClick;
		if (!handleClick) throw new Error("Click handler is required for QuickActionGroup. Please provide component `onClick` or `option.onClick` handler.");
		handleClick?.(option.value, e);
	};
	return /* @__PURE__ */ React.createElement(Stack, {
		direction: "row",
		alignItems: "flex-start",
		gap: 2,
		...props
	}, label && /* @__PURE__ */ React.createElement(Label, {
		fontSize: "sm",
		fontWeight: "medium",
		color: colors.gray[500]
	}, label), /* @__PURE__ */ React.createElement(Stack, {
		direction: "row",
		wrap: "wrap",
		gap: 2
	}, options.map((option) => /* @__PURE__ */ React.createElement(Badge, {
		as: "button",
		key: option.value,
		colorVariant: "default",
		dot: false,
		onClick: handleClick(option),
		disabled: option.disabled
	}, option.label))));
};
//#endregion
//#region src/components/atoms/radio/radio.styled.ts
var StyledRadio$1 = (0, import_dist.default)(Radio$1)`
  checked:bg-primary-600
  accent-primary-600
  text-primary-600
  focus:ring-primary-600
  cursor-pointer
`;
var StyledLabel$2 = import_dist.default.label`
  cursor-pointer
`;
//#endregion
//#region src/components/atoms/radio/Radio.tsx
var Radio = ({ alignLabel = "start", checked, className, disabled = false, gap, id, label, onChange, testId, value }) => /* @__PURE__ */ React.createElement(Stack, {
	className,
	alignItems: alignLabel,
	gap
}, /* @__PURE__ */ React.createElement(Stack, { testId }, disabled ? /* @__PURE__ */ React.createElement(Icon, {
	node: /* @__PURE__ */ React.createElement(Memo$19, { className: "text-gray-400" }),
	size: 4,
	variant: "none"
}) : /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledRadio$1, {
	id,
	value,
	checked,
	onChange: () => onChange(value),
	disabled
}))), /* @__PURE__ */ React.createElement(StyledLabel$2, { htmlFor: id }, label));
//#endregion
//#region src/components/molecules/radio-group/RadioGroup.tsx
var RadioGroup = ({ className, cols = 2, currentValue, gap = 2, id, onChange, options, optionsGap = 5 }) => /* @__PURE__ */ React.createElement(Grid, {
	className,
	cols,
	gap: optionsGap,
	id
}, options.map((radio) => /* @__PURE__ */ React.createElement(GridItem, { key: radio.id }, /* @__PURE__ */ React.createElement(Radio, {
	...radio,
	onChange,
	checked: radio.value === currentValue,
	gap,
	label: /* @__PURE__ */ React.createElement(Typography, {
		as: "span",
		fontWeight: "medium",
		fontSize: "sm"
	}, radio.label)
}))));
//#endregion
//#region src/components/molecules/radio-with-icon/radio-with-icon.styled.ts
var StyledRadio = (0, import_dist.default)(Radio)`
  flex
  space-x-6
  px-6
  h-14
  ${({ disabled }) => disabled ? "opacity-50 pointer-events-none" : ""}
`;
//#endregion
//#region src/components/molecules/radio-with-icon/RadioWithIcon.tsx
var RadioWithIcon = ({ checked, className, disabled = false, icon, id, label, onChange, subContent, testId, value }) => /* @__PURE__ */ React.createElement(StyledRadio, {
	label: /* @__PURE__ */ React.createElement(Stack, {
		alignItems: "center",
		space: 2
	}, /* @__PURE__ */ React.createElement(Icon, {
		node: icon.node,
		size: 10,
		variant: icon.variant
	}), /* @__PURE__ */ React.createElement(Stack, {
		direction: "column",
		justifyContent: "center"
	}, /* @__PURE__ */ React.createElement(Typography, {
		as: "span",
		fontWeight: "medium",
		fontSize: "sm"
	}, label), subContent)),
	alignLabel: "center",
	testId,
	onChange,
	id,
	value,
	checked,
	disabled,
	className
});
//#endregion
//#region src/components/molecules/radio-with-icon-group/radio-with-icon-group.styled.ts
var OuterContainer = import_dist.default.div`
  grid
  grid-cols-2
  gap-x-2.5
`;
var InnerContainer = import_dist.default.div`
  ${({ $hasBottomBorder }) => $hasBottomBorder ? "border-b border-gray-200" : ""}
`;
var StyledRadioWithIcon = (0, import_dist.default)(RadioWithIcon)`
  space-x-10
`;
//#endregion
//#region src/components/molecules/radio-with-icon-group/RadioWithIconGroup.tsx
var RadioWithIconGroup = ({ className, currentValue, onChange, radioWithIcons }) => {
	const amountWithoutBottomBorder = radioWithIcons.length % 2 === 0 ? 2 : 1;
	return /* @__PURE__ */ React.createElement(OuterContainer, { className }, radioWithIcons.map((radioWithIcon, index) => /* @__PURE__ */ React.createElement(InnerContainer, {
		key: radioWithIcon.id,
		$hasBottomBorder: index < radioWithIcons.length - amountWithoutBottomBorder
	}, /* @__PURE__ */ React.createElement(StyledRadioWithIcon, {
		...radioWithIcon,
		onChange,
		checked: radioWithIcon.value === currentValue
	}))));
};
//#endregion
//#region src/components/molecules/side-nav-item/side-nav-item.styled.ts
var StyledNavItemDiv = import_dist.default.div`
  ${({ $open }) => $open ? "" : "items-center"}
  ${({ $isFooter }) => $isFooter ? "py-4 px-2 bottom-0" : ""}
  ${({ $isHeader }) => $isHeader ? "border-t border-gray-700 py-4 px-2" : ""}
  ${({ $floatingElement }) => $floatingElement ? "!p-0" : ""}
    flex-shrink-0
    flex
    flex-col
`;
//#endregion
//#region src/components/molecules/side-nav-item/SideNavItem.tsx
var getTestId = (id, active) => `${id}-${active ? "active" : "inactive"}`;
var SideNavItem = ({ active, badge, className, icon, id, isFooter = false, isHeader = false, title, ...rest }) => /* @__PURE__ */ React.createElement(StyledNavItemDiv, {
	$isFooter: isFooter,
	$isHeader: isHeader,
	"data-testid": getTestId(id, active),
	className
}, /* @__PURE__ */ React.createElement(NavItem, {
	id,
	active,
	icon,
	title,
	badge,
	...rest
}));
memo(SideNavItem);
//#endregion
//#region src/components/molecules/slider/slider.styled.ts
var StyledStack = (0, import_dist.default)(Stack)`
  relative
`;
var StyledInput = (0, import_dist.default)(FormInput)`
  w-full
  h-4
  rounded-lg
  [-webkit-appearance:none]
`;
var StyledBottomOutput = import_dist.default.output`
  mt-6
  -translate-x-2/4
  absolute
`;
var StyledRightOutput = (0, import_dist.default)(Stack)`
  w-[45px]
`;
var StyledTypography = (0, import_dist.default)(Typography)`
  text-gray-300
`;
//#endregion
//#region src/components/molecules/slider/Slider.tsx
var variantColors = {
	default: [colors.gray[800], colors.gray[400]],
	active: [colors.primary[600], colors.gray[400]],
	deemphasized: [colors.gray[400], colors.gray[300]]
};
var getPercentageFromLeft = ({ max, min, value }) => (value - min) * 100 / (max - min);
var getLeftPositionCss = (value, min, max) => {
	const leftPercentage = getPercentageFromLeft({
		value,
		min,
		max
	});
	return `calc(${leftPercentage}% + (${10 - leftPercentage * .2}px))`;
};
var getSliderGradient = (variant, value, min, max, isDisabled, isFocused) => {
	const leftPercentage = getPercentageFromLeft({
		value,
		min,
		max
	});
	const bgColors = isFocused ? variantColors["active"] : variantColors[variant];
	return {
		direction: "to right",
		colors: isDisabled ? [[colors.gray[300], leftPercentage], [colors.gray[300], leftPercentage]] : [[bgColors[0], leftPercentage], [bgColors[1], leftPercentage]]
	};
};
var Slider = ({ backgroundColors, border, className, disabled = false, id, max = 100, min = 0, name, onChange, step, value = 0, valuePosition = "right", variant = "default" }) => {
	const [leftCss, setLeftCss] = useState(getLeftPositionCss(value, min, max));
	const [isFocused, setIsFocused] = useState(false);
	useEffect(() => {
		setLeftCss(getLeftPositionCss(value, min, max));
	}, [
		max,
		min,
		value
	]);
	const backgroundImage = createLinearGradientCss(!backgroundColors || disabled ? getSliderGradient(variant, value, min, max, disabled, isFocused) : backgroundColors);
	return /* @__PURE__ */ React.createElement(StyledStack, {
		gap: 1,
		alignItems: valuePosition === "right" && "center"
	}, /* @__PURE__ */ React.createElement(StyledInput, {
		"data-testid": "slider",
		disabled,
		min,
		max,
		step,
		id,
		name,
		onChange,
		onFocus: (e) => {
			if (!e.currentTarget.contains(e.relatedTarget)) setIsFocused(true);
		},
		onBlur: (e) => {
			if (!e.currentTarget.contains(e.relatedTarget)) setIsFocused(false);
		},
		type: "range",
		value,
		className: (0, import_classnames.default)("input-slider", "[&::-webkit-slider-thumb]:bg-white", {
			"border border-gray-300 shadow-sm": !backgroundColors || border,
			"input-slider-disabled": disabled
		}, className),
		style: { backgroundImage }
	}), valuePosition === "right" && /* @__PURE__ */ React.createElement(StyledRightOutput, {
		as: "output",
		alignItems: "center",
		justifyContent: "end",
		"data-testid": "output"
	}, /* @__PURE__ */ React.createElement(Typography, { fontWeight: "medium" }, value), /* @__PURE__ */ React.createElement(StyledTypography, null, "%")), valuePosition === "bottom" && /* @__PURE__ */ React.createElement(StyledBottomOutput, {
		"data-testid": "output",
		style: { left: leftCss }
	}, /* @__PURE__ */ React.createElement(Badge, { colorVariant: backgroundColors ? "blue" : "default" }, value, "%")));
};
var SliderMemo = memo(Slider);
//#endregion
//#region src/components/molecules/toast/toast.constants.ts
var ToastDurationOptions = {
	/** Usage: Success messages that may come in quick succession. */
	SHORT: 1500,
	/** Usage: Typical message w/ title and description. */
	MEDIUM: 3e3,
	/** Usage: Message w/ long description. */
	LONG: 6e3,
	/** Usage: Message we want to ensure the user sees (e.g. errors or notification with immediate CTA). */
	INFINITE: -1
};
var DEFAULT_TOAST_DURATION = ToastDurationOptions.MEDIUM;
/**
* DEFAULT_TOAST_ERROR_DURATION was -1 but set to 5000 until we resolve pointer event issues when notifications open on top of sidedrawer in trouser.
* Ticket: https://linear.app/neo-tax/issue/NEO-2999/fix-toast-notification-pointer-event-issues-when-trouser-side-drawer
*/
var DEFAULT_TOAST_ERROR_DURATION = ToastDurationOptions.MEDIUM;
/**
* The delay before the toast is removed from the DOM after the close animation has completed.
*/
var ON_CLOSE_DELAY = 1e3;
//#endregion
//#region src/components/molecules/toast/toast.styled.ts
var ToastContainer = import_dist.default.div`
  w-full
  max-w-sm
  overflow-hidden
  rounded-lg
  p-4
  flex
  items-start
  space-x-3
  bg-white
  shadow-lg
  ring-1
  ring-black
  ring-opacity-5
  pointer-events-auto
`;
var ToastContent = import_dist.default.div`
  w-0
  flex-1
  pt-0.5
  flex
  flex-col
  space-y-1
`;
import_dist.default.div`
  flex
  items-center
  flex-shrink-0
  h-6
`;
import_dist.default.button`
  inline-flex
  rounded-md
  bg-white
  text-gray-400
  hover:text-gray-500
  focus:outline-none
  focus:ring-2
  focus:ring-blue-500
  focus:ring-offset-2
`;
var ToastRegionContainer = import_dist.default.div`
  fixed
  z-notification
  inset-0
  flex
  items-end
  px-4
  py-6
  pointer-events-none
  sm:items-start
  sm:p-6
`;
var ToastRegionContent = import_dist.default.div`
  flex
  w-full
  flex-col
  items-center
  space-y-4
  sm:items-end
`;
//#endregion
//#region src/components/molecules/toast/toast.utils.tsx
var getIconBySeverity = (severity) => {
	switch (severity) {
		case "error": return /* @__PURE__ */ m$3.createElement(Memo$18, {
			"data-testid": "error-circle-icon",
			"aria-hidden": "true"
		});
		case "info": return /* @__PURE__ */ m$3.createElement(Memo$17, {
			"data-testid": "info-circle-icon",
			"aria-hidden": "true"
		});
		case "success": return /* @__PURE__ */ m$3.createElement(Memo$16, {
			"data-testid": "success-circle-icon",
			"aria-hidden": "true"
		});
		case "warning": return /* @__PURE__ */ m$3.createElement(Memo$15, {
			"data-testid": "warning-triangle-icon",
			"aria-hidden": "true"
		});
		default: return;
	}
};
var getTimeoutByDuration = (duration, severity) => {
	if (typeof duration === "number") return duration;
	if (duration !== void 0) return ToastDurationOptions[duration];
	return severity === "error" ? DEFAULT_TOAST_ERROR_DURATION : DEFAULT_TOAST_DURATION;
};
//#endregion
//#region src/components/molecules/toast/Toast.tsx
/** Dynamically insert this into the notification region when it needs to be displayed. */
var Toast = ({ actions = [], description, duration, icon, onClose, severity = "info", title }) => {
	const [show, setShow] = m$3.useState(true);
	const timeoutRef = m$3.useRef(null);
	const finalIcon = icon ?? getIconBySeverity(severity);
	const handleClose = () => {
		setShow(false);
		if (onClose) setTimeout(() => onClose(), ON_CLOSE_DELAY);
	};
	const cancelTimeout = () => {};
	m$3.useEffect(() => {
		const timeout = getTimeoutByDuration(duration, severity);
		if (timeout < 0) return;
		timeoutRef.current = setTimeout(() => {
			handleClose();
		}, timeout);
		return () => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		};
	}, []);
	return /* @__PURE__ */ m$3.createElement(We$1, {
		appear: true,
		show,
		as: m$3.Fragment,
		enter: "transform transition ease-out duration-300",
		enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
		enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
		leave: "transform transition ease-in duration-300",
		leaveFrom: "opacity-100 min-h-full",
		leaveTo: "opacity-0 min-h-0"
	}, /* @__PURE__ */ m$3.createElement(ToastContainer, { onMouseEnter: cancelTimeout }, !!finalIcon && /* @__PURE__ */ m$3.createElement(Icon, {
		node: finalIcon,
		nodeSize: 4.5,
		size: 6,
		colorVariant: severity === "neutral" ? "default" : severity,
		className: "flex-shrink-0",
		"aria-hidden": "true"
	}), /* @__PURE__ */ m$3.createElement(ToastContent, null, /* @__PURE__ */ m$3.createElement(Typography, {
		as: "p",
		fontSize: "sm",
		fontWeight: "medium"
	}, title), !!description && (typeof description === "string" || typeof description === "number" ? /* @__PURE__ */ m$3.createElement(Typography, {
		as: "p",
		fontSize: "sm",
		className: "text-gray-500"
	}, description) : description), actions?.length > 0 && /* @__PURE__ */ m$3.createElement(Stack, { space: 2 }, actions.map(({ label, ...props }) => /* @__PURE__ */ m$3.createElement(Button, {
		key: label,
		size: "sm",
		variant: severity === "none" || severity === "neutral" ? "info" : severity,
		rounded: "regular",
		className: "m-0",
		...props
	}, label))))));
};
//#endregion
//#region src/components/molecules/toast/ToastRegion.tsx
/** Global notification region. Render this permanently at the end of the document. */
var ToastRegion = ({ toastConfigs = [] }) => /* @__PURE__ */ m$3.createElement(ToastRegionContainer, { "aria-live": "assertive" }, /* @__PURE__ */ m$3.createElement(ToastRegionContent, null, toastConfigs.map((config) => /* @__PURE__ */ m$3.createElement(Toast, {
	key: config.id,
	...config
}))));
//#endregion
//#region ../../node_modules/tslib/tslib.es6.js
function __awaiter(thisArg, _arguments, P, generator) {
	function adopt(value) {
		return value instanceof P ? value : new P(function(resolve) {
			resolve(value);
		});
	}
	return new (P || (P = Promise))(function(resolve, reject) {
		function fulfilled(value) {
			try {
				step(generator.next(value));
			} catch (e) {
				reject(e);
			}
		}
		function rejected(value) {
			try {
				step(generator["throw"](value));
			} catch (e) {
				reject(e);
			}
		}
		function step(result) {
			result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
		}
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
}
function __generator(thisArg, body) {
	var _ = {
		label: 0,
		sent: function() {
			if (t[0] & 1) throw t[1];
			return t[1];
		},
		trys: [],
		ops: []
	}, f, y, t, g = {
		next: verb(0),
		"throw": verb(1),
		"return": verb(2)
	};
	return typeof Symbol === "function" && (g[Symbol.iterator] = function() {
		return this;
	}), g;
	function verb(n) {
		return function(v) {
			return step([n, v]);
		};
	}
	function step(op) {
		if (f) throw new TypeError("Generator is already executing.");
		while (g && (g = 0, op[0] && (_ = 0)), _) try {
			if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
			if (y = 0, t) op = [op[0] & 2, t.value];
			switch (op[0]) {
				case 0:
				case 1:
					t = op;
					break;
				case 4:
					_.label++;
					return {
						value: op[1],
						done: false
					};
				case 5:
					_.label++;
					y = op[1];
					op = [0];
					continue;
				case 7:
					op = _.ops.pop();
					_.trys.pop();
					continue;
				default:
					if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
						_ = 0;
						continue;
					}
					if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
						_.label = op[1];
						break;
					}
					if (op[0] === 6 && _.label < t[1]) {
						_.label = t[1];
						t = op;
						break;
					}
					if (t && _.label < t[2]) {
						_.label = t[2];
						_.ops.push(op);
						break;
					}
					if (t[2]) _.ops.pop();
					_.trys.pop();
					continue;
			}
			op = body.call(thisArg, _);
		} catch (e) {
			op = [6, e];
			y = 0;
		} finally {
			f = t = 0;
		}
		if (op[0] & 5) throw op[1];
		return {
			value: op[0] ? op[1] : void 0,
			done: true
		};
	}
}
function __read(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
}
function __spreadArray(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
}
//#endregion
//#region ../../node_modules/file-selector/dist/es5/file.js
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
	["aac", "audio/aac"],
	["abw", "application/x-abiword"],
	["arc", "application/x-freearc"],
	["avif", "image/avif"],
	["avi", "video/x-msvideo"],
	["azw", "application/vnd.amazon.ebook"],
	["bin", "application/octet-stream"],
	["bmp", "image/bmp"],
	["bz", "application/x-bzip"],
	["bz2", "application/x-bzip2"],
	["cda", "application/x-cdf"],
	["csh", "application/x-csh"],
	["css", "text/css"],
	["csv", "text/csv"],
	["doc", "application/msword"],
	["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
	["eot", "application/vnd.ms-fontobject"],
	["epub", "application/epub+zip"],
	["gz", "application/gzip"],
	["gif", "image/gif"],
	["heic", "image/heic"],
	["heif", "image/heif"],
	["htm", "text/html"],
	["html", "text/html"],
	["ico", "image/vnd.microsoft.icon"],
	["ics", "text/calendar"],
	["jar", "application/java-archive"],
	["jpeg", "image/jpeg"],
	["jpg", "image/jpeg"],
	["js", "text/javascript"],
	["json", "application/json"],
	["jsonld", "application/ld+json"],
	["mid", "audio/midi"],
	["midi", "audio/midi"],
	["mjs", "text/javascript"],
	["mp3", "audio/mpeg"],
	["mp4", "video/mp4"],
	["mpeg", "video/mpeg"],
	["mpkg", "application/vnd.apple.installer+xml"],
	["odp", "application/vnd.oasis.opendocument.presentation"],
	["ods", "application/vnd.oasis.opendocument.spreadsheet"],
	["odt", "application/vnd.oasis.opendocument.text"],
	["oga", "audio/ogg"],
	["ogv", "video/ogg"],
	["ogx", "application/ogg"],
	["opus", "audio/opus"],
	["otf", "font/otf"],
	["png", "image/png"],
	["pdf", "application/pdf"],
	["php", "application/x-httpd-php"],
	["ppt", "application/vnd.ms-powerpoint"],
	["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
	["rar", "application/vnd.rar"],
	["rtf", "application/rtf"],
	["sh", "application/x-sh"],
	["svg", "image/svg+xml"],
	["swf", "application/x-shockwave-flash"],
	["tar", "application/x-tar"],
	["tif", "image/tiff"],
	["tiff", "image/tiff"],
	["ts", "video/mp2t"],
	["ttf", "font/ttf"],
	["txt", "text/plain"],
	["vsd", "application/vnd.visio"],
	["wav", "audio/wav"],
	["weba", "audio/webm"],
	["webm", "video/webm"],
	["webp", "image/webp"],
	["woff", "font/woff"],
	["woff2", "font/woff2"],
	["xhtml", "application/xhtml+xml"],
	["xls", "application/vnd.ms-excel"],
	["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
	["xml", "application/xml"],
	["xul", "application/vnd.mozilla.xul+xml"],
	["zip", "application/zip"],
	["7z", "application/x-7z-compressed"],
	["mkv", "video/x-matroska"],
	["mov", "video/quicktime"],
	["msg", "application/vnd.ms-outlook"]
]);
function toFileWithPath(file, path) {
	var f = withMimeType(file);
	if (typeof f.path !== "string") {
		var webkitRelativePath = file.webkitRelativePath;
		Object.defineProperty(f, "path", {
			value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
			writable: false,
			configurable: false,
			enumerable: true
		});
	}
	return f;
}
function withMimeType(file) {
	var name = file.name;
	if (name && name.lastIndexOf(".") !== -1 && !file.type) {
		var ext = name.split(".").pop().toLowerCase();
		var type = COMMON_MIME_TYPES.get(ext);
		if (type) Object.defineProperty(file, "type", {
			value: type,
			writable: false,
			configurable: false,
			enumerable: true
		});
	}
	return file;
}
//#endregion
//#region ../../node_modules/file-selector/dist/es5/file-selector.js
var FILES_TO_IGNORE = [".DS_Store", "Thumbs.db"];
/**
* Convert a DragEvent's DataTrasfer object to a list of File objects
* NOTE: If some of the items are folders,
* everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
*
* EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
* and a list of File objects will be returned.
*
* @param evt
*/
function fromEvent(evt) {
	return __awaiter(this, void 0, void 0, function() {
		return __generator(this, function(_a) {
			if (isObject(evt) && isDataTransfer(evt.dataTransfer)) return [2, getDataTransferFiles(evt.dataTransfer, evt.type)];
			else if (isChangeEvt(evt)) return [2, getInputFiles(evt)];
			else if (Array.isArray(evt) && evt.every(function(item) {
				return "getFile" in item && typeof item.getFile === "function";
			})) return [2, getFsHandleFiles(evt)];
			return [2, []];
		});
	});
}
function isDataTransfer(value) {
	return isObject(value);
}
function isChangeEvt(value) {
	return isObject(value) && isObject(value.target);
}
function isObject(v) {
	return typeof v === "object" && v !== null;
}
function getInputFiles(evt) {
	return fromList(evt.target.files).map(function(file) {
		return toFileWithPath(file);
	});
}
function getFsHandleFiles(handles) {
	return __awaiter(this, void 0, void 0, function() {
		var files;
		return __generator(this, function(_a) {
			switch (_a.label) {
				case 0: return [4, Promise.all(handles.map(function(h) {
					return h.getFile();
				}))];
				case 1:
					files = _a.sent();
					return [2, files.map(function(file) {
						return toFileWithPath(file);
					})];
			}
		});
	});
}
function getDataTransferFiles(dt, type) {
	return __awaiter(this, void 0, void 0, function() {
		var items, files;
		return __generator(this, function(_a) {
			switch (_a.label) {
				case 0:
					if (!dt.items) return [3, 2];
					items = fromList(dt.items).filter(function(item) {
						return item.kind === "file";
					});
					if (type !== "drop") return [2, items];
					return [4, Promise.all(items.map(toFilePromises))];
				case 1:
					files = _a.sent();
					return [2, noIgnoredFiles(flatten(files))];
				case 2: return [2, noIgnoredFiles(fromList(dt.files).map(function(file) {
					return toFileWithPath(file);
				}))];
			}
		});
	});
}
function noIgnoredFiles(files) {
	return files.filter(function(file) {
		return FILES_TO_IGNORE.indexOf(file.name) === -1;
	});
}
function fromList(items) {
	if (items === null) return [];
	var files = [];
	for (var i = 0; i < items.length; i++) {
		var file = items[i];
		files.push(file);
	}
	return files;
}
function toFilePromises(item) {
	if (typeof item.webkitGetAsEntry !== "function") return fromDataTransferItem(item);
	var entry = item.webkitGetAsEntry();
	if (entry && entry.isDirectory) return fromDirEntry(entry);
	return fromDataTransferItem(item);
}
function flatten(items) {
	return items.reduce(function(acc, files) {
		return __spreadArray(__spreadArray([], __read(acc), false), __read(Array.isArray(files) ? flatten(files) : [files]), false);
	}, []);
}
function fromDataTransferItem(item) {
	var file = item.getAsFile();
	if (!file) return Promise.reject("".concat(item, " is not a File"));
	var fwp = toFileWithPath(file);
	return Promise.resolve(fwp);
}
function fromEntry(entry) {
	return __awaiter(this, void 0, void 0, function() {
		return __generator(this, function(_a) {
			return [2, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
		});
	});
}
function fromDirEntry(entry) {
	var reader = entry.createReader();
	return new Promise(function(resolve, reject) {
		var entries = [];
		function readEntries() {
			var _this = this;
			reader.readEntries(function(batch) {
				return __awaiter(_this, void 0, void 0, function() {
					var files, err_1, items;
					return __generator(this, function(_a) {
						switch (_a.label) {
							case 0:
								if (!!batch.length) return [3, 5];
								_a.label = 1;
							case 1:
								_a.trys.push([
									1,
									3,
									,
									4
								]);
								return [4, Promise.all(entries)];
							case 2:
								files = _a.sent();
								resolve(files);
								return [3, 4];
							case 3:
								err_1 = _a.sent();
								reject(err_1);
								return [3, 4];
							case 4: return [3, 6];
							case 5:
								items = Promise.all(batch.map(fromEntry));
								entries.push(items);
								readEntries();
								_a.label = 6;
							case 6: return [2];
						}
					});
				});
			}, function(err) {
				reject(err);
			});
		}
		readEntries();
	});
}
function fromFileEntry(entry) {
	return __awaiter(this, void 0, void 0, function() {
		return __generator(this, function(_a) {
			return [2, new Promise(function(resolve, reject) {
				entry.file(function(file) {
					resolve(toFileWithPath(file, entry.fullPath));
				}, function(err) {
					reject(err);
				});
			})];
		});
	});
}
//#endregion
//#region ../../node_modules/react-dropzone/dist/es/utils/index.js
var import_es = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.default = function(file, acceptedFiles) {
		if (file && acceptedFiles) {
			var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
			var fileName = file.name || "";
			var mimeType = (file.type || "").toLowerCase();
			var baseMimeType = mimeType.replace(/\/.*$/, "");
			return acceptedFilesArray.some(function(type) {
				var validType = type.trim().toLowerCase();
				if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
				else if (validType.endsWith("/*")) return baseMimeType === validType.replace(/\/.*$/, "");
				return mimeType === validType;
			});
		}
		return true;
	};
})))());
function _toConsumableArray$1(arr) {
	return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
	throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$1(iter) {
	if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
	if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function ownKeys$1(object, enumerableOnly) {
	var keys = Object.keys(object);
	if (Object.getOwnPropertySymbols) {
		var symbols = Object.getOwnPropertySymbols(object);
		enumerableOnly && (symbols = symbols.filter(function(sym) {
			return Object.getOwnPropertyDescriptor(object, sym).enumerable;
		})), keys.push.apply(keys, symbols);
	}
	return keys;
}
function _objectSpread$1(target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = null != arguments[i] ? arguments[i] : {};
		i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
			_defineProperty$1(target, key, source[key]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
			Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
		});
	}
	return target;
}
function _defineProperty$1(obj, key, value) {
	if (key in obj) Object.defineProperty(obj, key, {
		value,
		enumerable: true,
		configurable: true,
		writable: true
	});
	else obj[key] = value;
	return obj;
}
function _slicedToArray$1(arr, i) {
	return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
	throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
	if (!o) return;
	if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
	var n = Object.prototype.toString.call(o).slice(8, -1);
	if (n === "Object" && o.constructor) n = o.constructor.name;
	if (n === "Map" || n === "Set") return Array.from(o);
	if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
	if (len == null || len > arr.length) len = arr.length;
	for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	return arr2;
}
function _iterableToArrayLimit$1(arr, i) {
	var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	if (_i == null) return;
	var _arr = [];
	var _n = true;
	var _d = false;
	var _s, _e;
	try {
		for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
			_arr.push(_s.value);
			if (i && _arr.length === i) break;
		}
	} catch (err) {
		_d = true;
		_e = err;
	} finally {
		try {
			if (!_n && _i["return"] != null) _i["return"]();
		} finally {
			if (_d) throw _e;
		}
	}
	return _arr;
}
function _arrayWithHoles$1(arr) {
	if (Array.isArray(arr)) return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
	accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
	var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
	return {
		code: FILE_INVALID_TYPE,
		message: "File type must be ".concat(messageSuffix)
	};
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
	return {
		code: FILE_TOO_LARGE,
		message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
	};
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
	return {
		code: FILE_TOO_SMALL,
		message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
	};
};
var TOO_MANY_FILES_REJECTION = {
	code: TOO_MANY_FILES,
	message: "Too many files"
};
function fileAccepted(file, accept) {
	var isAcceptable = file.type === "application/x-moz-file" || (0, import_es.default)(file, accept);
	return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
	if (isDefined$1(file.size)) {
		if (isDefined$1(minSize) && isDefined$1(maxSize)) {
			if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
			if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
		} else if (isDefined$1(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
		else if (isDefined$1(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
	}
	return [true, null];
}
function isDefined$1(value) {
	return value !== void 0 && value !== null;
}
/**
*
* @param {object} options
* @param {File[]} options.files
* @param {string|string[]} [options.accept]
* @param {number} [options.minSize]
* @param {number} [options.maxSize]
* @param {boolean} [options.multiple]
* @param {number} [options.maxFiles]
* @param {(f: File) => FileError|FileError[]|null} [options.validator]
* @returns
*/
function allFilesAccepted(_ref) {
	var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
	if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
	return files.every(function(file) {
		var accepted = _slicedToArray$1(fileAccepted(file, accept), 1)[0];
		var sizeMatch = _slicedToArray$1(fileMatchSize(file, minSize, maxSize), 1)[0];
		var customErrors = validator ? validator(file) : null;
		return accepted && sizeMatch && !customErrors;
	});
}
function isPropagationStopped(event) {
	if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
	else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
	return false;
}
function isEvtWithFiles(event) {
	if (!event.dataTransfer) return !!event.target && !!event.target.files;
	return Array.prototype.some.call(event.dataTransfer.types, function(type) {
		return type === "Files" || type === "application/x-moz-file";
	});
}
function onDocumentDragOver(event) {
	event.preventDefault();
}
function isIe(userAgent) {
	return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
	return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
	var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
	return isIe(userAgent) || isEdge(userAgent);
}
/**
* This is intended to be used to compose event handlers
* They are executed in order until one of them calls `event.isPropagationStopped()`.
* Note that the check is done on the first invoke too,
* meaning that if propagation was stopped before invoking the fns,
* no handlers will be executed.
*
* @param {Function} fns the event hanlder functions
* @return {Function} the event handler to add to an element
*/
function composeEventHandlers() {
	for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) fns[_key] = arguments[_key];
	return function(event) {
		for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args[_key2 - 1] = arguments[_key2];
		return fns.some(function(fn) {
			if (!isPropagationStopped(event) && fn) fn.apply(void 0, [event].concat(args));
			return isPropagationStopped(event);
		});
	};
}
/**
* canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
* is supported by the browser.
* @returns {boolean}
*/
function canUseFileSystemAccessAPI() {
	return "showOpenFilePicker" in window;
}
/**
* Convert the `{accept}` dropzone prop to the
* `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
*
* @param {AcceptProp} accept
* @returns {{accept: string[]}[]}
*/
function pickerOptionsFromAccept(accept) {
	if (isDefined$1(accept)) return [{
		description: "Files",
		accept: Object.entries(accept).filter(function(_ref2) {
			var _ref3 = _slicedToArray$1(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
			var ok = true;
			if (!isMIMEType(mimeType)) {
				console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
				ok = false;
			}
			if (!Array.isArray(ext) || !ext.every(isExt)) {
				console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
				ok = false;
			}
			return ok;
		}).reduce(function(agg, _ref4) {
			var _ref5 = _slicedToArray$1(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
			return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
		}, {})
	}];
	return accept;
}
/**
* Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
* @param {AcceptProp} accept
* @returns {string}
*/
function acceptPropAsAcceptAttr(accept) {
	if (isDefined$1(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
		var _ref7 = _slicedToArray$1(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
		return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
	}, []).filter(function(v) {
		return isMIMEType(v) || isExt(v);
	}).join(",");
}
/**
* Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
*
* See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
* @param {any} v
* @returns {boolean} True if v is an abort exception.
*/
function isAbort(v) {
	return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
* Check if v is a security error.
*
* See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
* @param {any} v
* @returns {boolean} True if v is a security error.
*/
function isSecurityError(v) {
	return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
* Check if v is a MIME type string.
*
* See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
*
* @param {string} v
*/
function isMIMEType(v) {
	return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
* Check if v is a file extension.
* @param {string} v
*/
function isExt(v) {
	return /^.*\.[\w]+$/.test(v);
}
/**
* @typedef {Object.<string, string[]>} AcceptProp
*/
/**
* @typedef {object} FileError
* @property {string} message
* @property {ErrorCode|string} code
*/
/**
* @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
*/
//#endregion
//#region ../../node_modules/react-dropzone/dist/es/index.js
var _excluded$4 = ["children"];
var _excluded2 = ["open"];
var _excluded3 = [
	"refKey",
	"role",
	"onKeyDown",
	"onFocus",
	"onBlur",
	"onClick",
	"onDragEnter",
	"onDragOver",
	"onDragLeave",
	"onDrop"
];
var _excluded4 = [
	"refKey",
	"onChange",
	"onClick"
];
function _toConsumableArray(arr) {
	return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
	throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
	if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
	if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
	return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
	throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
	if (!o) return;
	if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	var n = Object.prototype.toString.call(o).slice(8, -1);
	if (n === "Object" && o.constructor) n = o.constructor.name;
	if (n === "Map" || n === "Set") return Array.from(o);
	if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
	if (len == null || len > arr.length) len = arr.length;
	for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	return arr2;
}
function _iterableToArrayLimit(arr, i) {
	var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	if (_i == null) return;
	var _arr = [];
	var _n = true;
	var _d = false;
	var _s, _e;
	try {
		for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
			_arr.push(_s.value);
			if (i && _arr.length === i) break;
		}
	} catch (err) {
		_d = true;
		_e = err;
	} finally {
		try {
			if (!_n && _i["return"] != null) _i["return"]();
		} finally {
			if (_d) throw _e;
		}
	}
	return _arr;
}
function _arrayWithHoles(arr) {
	if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
	var keys = Object.keys(object);
	if (Object.getOwnPropertySymbols) {
		var symbols = Object.getOwnPropertySymbols(object);
		enumerableOnly && (symbols = symbols.filter(function(sym) {
			return Object.getOwnPropertyDescriptor(object, sym).enumerable;
		})), keys.push.apply(keys, symbols);
	}
	return keys;
}
function _objectSpread(target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = null != arguments[i] ? arguments[i] : {};
		i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
			_defineProperty(target, key, source[key]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
			Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
		});
	}
	return target;
}
function _defineProperty(obj, key, value) {
	if (key in obj) Object.defineProperty(obj, key, {
		value,
		enumerable: true,
		configurable: true,
		writable: true
	});
	else obj[key] = value;
	return obj;
}
function _objectWithoutProperties(source, excluded) {
	if (source == null) return {};
	var target = _objectWithoutPropertiesLoose$2(source, excluded);
	var key, i;
	if (Object.getOwnPropertySymbols) {
		var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
		for (i = 0; i < sourceSymbolKeys.length; i++) {
			key = sourceSymbolKeys[i];
			if (excluded.indexOf(key) >= 0) continue;
			if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
			target[key] = source[key];
		}
	}
	return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source);
	var key, i = 0;
	for (; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) continue;
		target[key] = source[key];
	}
	return target;
}
/**
* Convenience wrapper component for the `useDropzone` hook
*
* ```jsx
* <Dropzone>
*   {({getRootProps, getInputProps}) => (
*     <div {...getRootProps()}>
*       <input {...getInputProps()} />
*       <p>Drag 'n' drop some files here, or click to select files</p>
*     </div>
*   )}
* </Dropzone>
* ```
*/
var Dropzone = /*#__PURE__*/ forwardRef(function(_ref, ref) {
	var children = _ref.children;
	var _useDropzone = useDropzone(_objectWithoutProperties(_ref, _excluded$4)), open = _useDropzone.open, props = _objectWithoutProperties(_useDropzone, _excluded2);
	useImperativeHandle(ref, function() {
		return { open };
	}, [open]);
	return /*#__PURE__*/ React.createElement(Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, { open })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
	disabled: false,
	getFilesFromEvent: fromEvent,
	maxSize: Infinity,
	minSize: 0,
	multiple: true,
	maxFiles: 0,
	preventDropOnDocument: true,
	noClick: false,
	noKeyboard: false,
	noDrag: false,
	noDragEventsBubbling: false,
	validator: null,
	useFsAccessApi: true,
	autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
	/**
	* Render function that exposes the dropzone state and prop getter fns
	*
	* @param {object} params
	* @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
	* @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
	* @param {Function} params.open Open the native file selection dialog
	* @param {boolean} params.isFocused Dropzone area is in focus
	* @param {boolean} params.isFileDialogActive File dialog is opened
	* @param {boolean} params.isDragActive Active drag is in progress
	* @param {boolean} params.isDragAccept Dragged files are accepted
	* @param {boolean} params.isDragReject Some dragged files are rejected
	* @param {File[]} params.acceptedFiles Accepted files
	* @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
	*/
	children: import_prop_types.default.func,
	/**
	* Set accepted file types.
	* Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
	* Keep in mind that mime type determination is not reliable across platforms. CSV files,
	* for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	* Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
	*/
	accept: import_prop_types.default.objectOf(import_prop_types.default.arrayOf(import_prop_types.default.string)),
	/**
	* Allow drag 'n' drop (or selection from the file dialog) of multiple files
	*/
	multiple: import_prop_types.default.bool,
	/**
	* If false, allow dropped items to take over the current browser window
	*/
	preventDropOnDocument: import_prop_types.default.bool,
	/**
	* If true, disables click to open the native file selection dialog
	*/
	noClick: import_prop_types.default.bool,
	/**
	* If true, disables SPACE/ENTER to open the native file selection dialog.
	* Note that it also stops tracking the focus state.
	*/
	noKeyboard: import_prop_types.default.bool,
	/**
	* If true, disables drag 'n' drop
	*/
	noDrag: import_prop_types.default.bool,
	/**
	* If true, stops drag event propagation to parents
	*/
	noDragEventsBubbling: import_prop_types.default.bool,
	/**
	* Minimum file size (in bytes)
	*/
	minSize: import_prop_types.default.number,
	/**
	* Maximum file size (in bytes)
	*/
	maxSize: import_prop_types.default.number,
	/**
	* Maximum accepted number of files
	* The default value is 0 which means there is no limitation to how many files are accepted.
	*/
	maxFiles: import_prop_types.default.number,
	/**
	* Enable/disable the dropzone
	*/
	disabled: import_prop_types.default.bool,
	/**
	* Use this to provide a custom file aggregator
	*
	* @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
	*/
	getFilesFromEvent: import_prop_types.default.func,
	/**
	* Cb for when closing the file dialog with no selection
	*/
	onFileDialogCancel: import_prop_types.default.func,
	/**
	* Cb for when opening the file dialog
	*/
	onFileDialogOpen: import_prop_types.default.func,
	/**
	* Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
	* to open the file picker instead of using an `<input type="file">` click event.
	*/
	useFsAccessApi: import_prop_types.default.bool,
	/**
	* Set to true to focus the root element on render
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* Cb for when the `dragenter` event occurs.
	*
	* @param {DragEvent} event
	*/
	onDragEnter: import_prop_types.default.func,
	/**
	* Cb for when the `dragleave` event occurs
	*
	* @param {DragEvent} event
	*/
	onDragLeave: import_prop_types.default.func,
	/**
	* Cb for when the `dragover` event occurs
	*
	* @param {DragEvent} event
	*/
	onDragOver: import_prop_types.default.func,
	/**
	* Cb for when the `drop` event occurs.
	* Note that this callback is invoked after the `getFilesFromEvent` callback is done.
	*
	* Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
	* `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
	* If `multiple` is set to false and additional files are dropped,
	* all files besides the first will be rejected.
	* Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
	*
	* Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
	* If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
	*
	* `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
	* For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
	*
	* ```js
	* function onDrop(acceptedFiles) {
	*   const req = request.post('/upload')
	*   acceptedFiles.forEach(file => {
	*     req.attach(file.name, file)
	*   })
	*   req.end(callback)
	* }
	* ```
	*
	* @param {File[]} acceptedFiles
	* @param {FileRejection[]} fileRejections
	* @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
	*/
	onDrop: import_prop_types.default.func,
	/**
	* Cb for when the `drop` event occurs.
	* Note that if no files are accepted, this callback is not invoked.
	*
	* @param {File[]} files
	* @param {(DragEvent|Event)} event
	*/
	onDropAccepted: import_prop_types.default.func,
	/**
	* Cb for when the `drop` event occurs.
	* Note that if no files are rejected, this callback is not invoked.
	*
	* @param {FileRejection[]} fileRejections
	* @param {(DragEvent|Event)} event
	*/
	onDropRejected: import_prop_types.default.func,
	/**
	* Cb for when there's some error from any of the promises.
	*
	* @param {Error} error
	*/
	onError: import_prop_types.default.func,
	/**
	* Custom validation function. It must return null if there's no errors.
	* @param {File} file
	* @returns {FileError|FileError[]|null}
	*/
	validator: import_prop_types.default.func
};
/**
* A function that is invoked for the `dragenter`,
* `dragover` and `dragleave` events.
* It is not invoked if the items are not files (such as link, text, etc.).
*
* @callback dragCb
* @param {DragEvent} event
*/
/**
* A function that is invoked for the `drop` or input change event.
* It is not invoked if the items are not files (such as link, text, etc.).
*
* @callback dropCb
* @param {File[]} acceptedFiles List of accepted files
* @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
* @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
*/
/**
* A function that is invoked for the `drop` or input change event.
* It is not invoked if the items are files (such as link, text, etc.).
*
* @callback dropAcceptedCb
* @param {File[]} files List of accepted files that meet the given criteria
* (`accept`, `multiple`, `minSize`, `maxSize`)
* @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
*/
/**
* A function that is invoked for the `drop` or input change event.
*
* @callback dropRejectedCb
* @param {File[]} files List of rejected files that do not meet the given criteria
* (`accept`, `multiple`, `minSize`, `maxSize`)
* @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
*/
/**
* A function that is used aggregate files,
* in a asynchronous fashion, from drag or input change events.
*
* @callback getFilesFromEvent
* @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
* @returns {(File[]|Promise<File[]>)}
*/
/**
* An object with the current dropzone state.
*
* @typedef {object} DropzoneState
* @property {boolean} isFocused Dropzone area is in focus
* @property {boolean} isFileDialogActive File dialog is opened
* @property {boolean} isDragActive Active drag is in progress
* @property {boolean} isDragAccept Dragged files are accepted
* @property {boolean} isDragReject Some dragged files are rejected
* @property {File[]} acceptedFiles Accepted files
* @property {FileRejection[]} fileRejections Rejected files and why they were rejected
*/
/**
* An object with the dropzone methods.
*
* @typedef {object} DropzoneMethods
* @property {Function} getRootProps Returns the props you should apply to the root drop container you render
* @property {Function} getInputProps Returns the props you should apply to hidden file input you render
* @property {Function} open Open the native file selection dialog
*/
var initialState = {
	isFocused: false,
	isFileDialogActive: false,
	isDragActive: false,
	isDragAccept: false,
	isDragReject: false,
	acceptedFiles: [],
	fileRejections: []
};
/**
* A React hook that creates a drag 'n' drop area.
*
* ```jsx
* function MyDropzone(props) {
*   const {getRootProps, getInputProps} = useDropzone({
*     onDrop: acceptedFiles => {
*       // do something with the File objects, e.g. upload to some server
*     }
*   });
*   return (
*     <div {...getRootProps()}>
*       <input {...getInputProps()} />
*       <p>Drag and drop some files here, or click to select files</p>
*     </div>
*   )
* }
* ```
*
* @function useDropzone
*
* @param {object} props
* @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
* Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
* Keep in mind that mime type determination is not reliable across platforms. CSV files,
* for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
* Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
* @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
* @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
* @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
* @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
* Note that it also stops tracking the focus state.
* @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
* @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
* @param {number} [props.minSize=0] Minimum file size (in bytes)
* @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
* @param {boolean} [props.disabled=false] Enable/disable the dropzone
* @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
* @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
* @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
* to open the file picker instead of using an `<input type="file">` click event.
* @param {boolean} autoFocus Set to true to auto focus the root element.
* @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
* @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
* @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
* @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
* @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
* Note that this callback is invoked after the `getFilesFromEvent` callback is done.
*
* Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
* `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
* If `multiple` is set to false and additional files are dropped,
* all files besides the first will be rejected.
* Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
*
* Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
* If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
*
* `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
* For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
*
* ```js
* function onDrop(acceptedFiles) {
*   const req = request.post('/upload')
*   acceptedFiles.forEach(file => {
*     req.attach(file.name, file)
*   })
*   req.end(callback)
* }
* ```
* @param {dropAcceptedCb} [props.onDropAccepted]
* @param {dropRejectedCb} [props.onDropRejected]
* @param {(error: Error) => void} [props.onError]
*
* @returns {DropzoneState & DropzoneMethods}
*/
function useDropzone() {
	var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
	var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
	var acceptAttr = useMemo(function() {
		return acceptPropAsAcceptAttr(accept);
	}, [accept]);
	var pickerTypes = useMemo(function() {
		return pickerOptionsFromAccept(accept);
	}, [accept]);
	var onFileDialogOpenCb = useMemo(function() {
		return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$3;
	}, [onFileDialogOpen]);
	var onFileDialogCancelCb = useMemo(function() {
		return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$3;
	}, [onFileDialogCancel]);
	/**
	* @constant
	* @type {React.MutableRefObject<HTMLElement>}
	*/
	var rootRef = useRef(null);
	var inputRef = useRef(null);
	var _useReducer2 = _slicedToArray(useReducer(reducer$1, initialState), 2), state = _useReducer2[0], dispatch = _useReducer2[1];
	var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
	var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
	var onWindowFocus = function onWindowFocus() {
		if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
			if (inputRef.current) {
				if (!inputRef.current.files.length) {
					dispatch({ type: "closeDialog" });
					onFileDialogCancelCb();
				}
			}
		}, 300);
	};
	useEffect(function() {
		window.addEventListener("focus", onWindowFocus, false);
		return function() {
			window.removeEventListener("focus", onWindowFocus, false);
		};
	}, [
		inputRef,
		isFileDialogActive,
		onFileDialogCancelCb,
		fsAccessApiWorksRef
	]);
	var dragTargetsRef = useRef([]);
	var onDocumentDrop = function onDocumentDrop(event) {
		if (rootRef.current && rootRef.current.contains(event.target)) return;
		event.preventDefault();
		dragTargetsRef.current = [];
	};
	useEffect(function() {
		if (preventDropOnDocument) {
			document.addEventListener("dragover", onDocumentDragOver, false);
			document.addEventListener("drop", onDocumentDrop, false);
		}
		return function() {
			if (preventDropOnDocument) {
				document.removeEventListener("dragover", onDocumentDragOver);
				document.removeEventListener("drop", onDocumentDrop);
			}
		};
	}, [rootRef, preventDropOnDocument]);
	useEffect(function() {
		if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
		return function() {};
	}, [
		rootRef,
		autoFocus,
		disabled
	]);
	var onErrCb = useCallback(function(e) {
		if (onError) onError(e);
		else console.error(e);
	}, [onError]);
	var onDragEnterCb = useCallback(function(event) {
		event.preventDefault();
		event.persist();
		stopPropagation(event);
		dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
		if (isEvtWithFiles(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
			if (isPropagationStopped(event) && !noDragEventsBubbling) return;
			var fileCount = files.length;
			var isDragAccept = fileCount > 0 && allFilesAccepted({
				files,
				accept: acceptAttr,
				minSize,
				maxSize,
				multiple,
				maxFiles,
				validator
			});
			dispatch({
				isDragAccept,
				isDragReject: fileCount > 0 && !isDragAccept,
				isDragActive: true,
				type: "setDraggedFiles"
			});
			if (onDragEnter) onDragEnter(event);
		}).catch(function(e) {
			return onErrCb(e);
		});
	}, [
		getFilesFromEvent,
		onDragEnter,
		onErrCb,
		noDragEventsBubbling,
		acceptAttr,
		minSize,
		maxSize,
		multiple,
		maxFiles,
		validator
	]);
	var onDragOverCb = useCallback(function(event) {
		event.preventDefault();
		event.persist();
		stopPropagation(event);
		var hasFiles = isEvtWithFiles(event);
		if (hasFiles && event.dataTransfer) try {
			event.dataTransfer.dropEffect = "copy";
		} catch (_unused) {}
		if (hasFiles && onDragOver) onDragOver(event);
		return false;
	}, [onDragOver, noDragEventsBubbling]);
	var onDragLeaveCb = useCallback(function(event) {
		event.preventDefault();
		event.persist();
		stopPropagation(event);
		var targets = dragTargetsRef.current.filter(function(target) {
			return rootRef.current && rootRef.current.contains(target);
		});
		var targetIdx = targets.indexOf(event.target);
		if (targetIdx !== -1) targets.splice(targetIdx, 1);
		dragTargetsRef.current = targets;
		if (targets.length > 0) return;
		dispatch({
			type: "setDraggedFiles",
			isDragActive: false,
			isDragAccept: false,
			isDragReject: false
		});
		if (isEvtWithFiles(event) && onDragLeave) onDragLeave(event);
	}, [
		rootRef,
		onDragLeave,
		noDragEventsBubbling
	]);
	var setFiles = useCallback(function(files, event) {
		var acceptedFiles = [];
		var fileRejections = [];
		files.forEach(function(file) {
			var _fileAccepted2 = _slicedToArray(fileAccepted(file, acceptAttr), 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
			var _fileMatchSize2 = _slicedToArray(fileMatchSize(file, minSize, maxSize), 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
			var customErrors = validator ? validator(file) : null;
			if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
			else {
				var errors = [acceptError, sizeError];
				if (customErrors) errors = errors.concat(customErrors);
				fileRejections.push({
					file,
					errors: errors.filter(function(e) {
						return e;
					})
				});
			}
		});
		if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
			acceptedFiles.forEach(function(file) {
				fileRejections.push({
					file,
					errors: [TOO_MANY_FILES_REJECTION]
				});
			});
			acceptedFiles.splice(0);
		}
		dispatch({
			acceptedFiles,
			fileRejections,
			type: "setFiles"
		});
		if (onDrop) onDrop(acceptedFiles, fileRejections, event);
		if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
		if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
	}, [
		dispatch,
		multiple,
		acceptAttr,
		minSize,
		maxSize,
		maxFiles,
		onDrop,
		onDropAccepted,
		onDropRejected,
		validator
	]);
	var onDropCb = useCallback(function(event) {
		event.preventDefault();
		event.persist();
		stopPropagation(event);
		dragTargetsRef.current = [];
		if (isEvtWithFiles(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
			if (isPropagationStopped(event) && !noDragEventsBubbling) return;
			setFiles(files, event);
		}).catch(function(e) {
			return onErrCb(e);
		});
		dispatch({ type: "reset" });
	}, [
		getFilesFromEvent,
		setFiles,
		onErrCb,
		noDragEventsBubbling
	]);
	var openFileDialog = useCallback(function() {
		if (fsAccessApiWorksRef.current) {
			dispatch({ type: "openDialog" });
			onFileDialogOpenCb();
			var opts = {
				multiple,
				types: pickerTypes
			};
			window.showOpenFilePicker(opts).then(function(handles) {
				return getFilesFromEvent(handles);
			}).then(function(files) {
				setFiles(files, null);
				dispatch({ type: "closeDialog" });
			}).catch(function(e) {
				if (isAbort(e)) {
					onFileDialogCancelCb(e);
					dispatch({ type: "closeDialog" });
				} else if (isSecurityError(e)) {
					fsAccessApiWorksRef.current = false;
					if (inputRef.current) {
						inputRef.current.value = null;
						inputRef.current.click();
					} else onErrCb(/* @__PURE__ */ new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
				} else onErrCb(e);
			});
			return;
		}
		if (inputRef.current) {
			dispatch({ type: "openDialog" });
			onFileDialogOpenCb();
			inputRef.current.value = null;
			inputRef.current.click();
		}
	}, [
		dispatch,
		onFileDialogOpenCb,
		onFileDialogCancelCb,
		useFsAccessApi,
		setFiles,
		onErrCb,
		pickerTypes,
		multiple
	]);
	var onKeyDownCb = useCallback(function(event) {
		if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
		if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
			event.preventDefault();
			openFileDialog();
		}
	}, [rootRef, openFileDialog]);
	var onFocusCb = useCallback(function() {
		dispatch({ type: "focus" });
	}, []);
	var onBlurCb = useCallback(function() {
		dispatch({ type: "blur" });
	}, []);
	var onClickCb = useCallback(function() {
		if (noClick) return;
		if (isIeOrEdge()) setTimeout(openFileDialog, 0);
		else openFileDialog();
	}, [noClick, openFileDialog]);
	var composeHandler = function composeHandler(fn) {
		return disabled ? null : fn;
	};
	var composeKeyboardHandler = function composeKeyboardHandler(fn) {
		return noKeyboard ? null : composeHandler(fn);
	};
	var composeDragHandler = function composeDragHandler(fn) {
		return noDrag ? null : composeHandler(fn);
	};
	var stopPropagation = function stopPropagation(event) {
		if (noDragEventsBubbling) event.stopPropagation();
	};
	var getRootProps = useMemo(function() {
		return function() {
			var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = _objectWithoutProperties(_ref2, _excluded3);
			return _objectSpread(_objectSpread(_defineProperty({
				onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
				onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
				onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
				onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
				onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
				onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
				onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
				onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
				role: typeof role === "string" && role !== "" ? role : "presentation"
			}, refKey, rootRef), !disabled && !noKeyboard ? { tabIndex: 0 } : {}), rest);
		};
	}, [
		rootRef,
		onKeyDownCb,
		onFocusCb,
		onBlurCb,
		onClickCb,
		onDragEnterCb,
		onDragOverCb,
		onDragLeaveCb,
		onDropCb,
		noKeyboard,
		noDrag,
		disabled
	]);
	var onInputElementClick = useCallback(function(event) {
		event.stopPropagation();
	}, []);
	var getInputProps = useMemo(function() {
		return function() {
			var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties(_ref3, _excluded4);
			return _objectSpread(_objectSpread({}, _defineProperty({
				accept: acceptAttr,
				multiple,
				type: "file",
				style: { display: "none" },
				onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
				onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
				tabIndex: -1
			}, refKey, inputRef)), rest);
		};
	}, [
		inputRef,
		accept,
		multiple,
		onDropCb,
		disabled
	]);
	return _objectSpread(_objectSpread({}, state), {}, {
		isFocused: isFocused && !disabled,
		getRootProps,
		getInputProps,
		rootRef,
		inputRef,
		open: composeHandler(openFileDialog)
	});
}
/**
* @param {DropzoneState} state
* @param {{type: string} & DropzoneState} action
* @returns {DropzoneState}
*/
function reducer$1(state, action) {
	/* istanbul ignore next */
	switch (action.type) {
		case "focus": return _objectSpread(_objectSpread({}, state), {}, { isFocused: true });
		case "blur": return _objectSpread(_objectSpread({}, state), {}, { isFocused: false });
		case "openDialog": return _objectSpread(_objectSpread({}, initialState), {}, { isFileDialogActive: true });
		case "closeDialog": return _objectSpread(_objectSpread({}, state), {}, { isFileDialogActive: false });
		case "setDraggedFiles": return _objectSpread(_objectSpread({}, state), {}, {
			isDragActive: action.isDragActive,
			isDragAccept: action.isDragAccept,
			isDragReject: action.isDragReject
		});
		case "setFiles": return _objectSpread(_objectSpread({}, state), {}, {
			acceptedFiles: action.acceptedFiles,
			fileRejections: action.fileRejections
		});
		case "reset": return _objectSpread({}, initialState);
		default: return state;
	}
}
function noop$3() {}
//#endregion
//#region src/assets/icons/upload-cloud.svg
var SvgUploadCloud = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M24 10.4212C23.9974 9.64474 23.8394 8.8767 23.5354 8.16227C23.2315 7.44783 22.7876 6.80144 22.23 6.26115C21.2956 5.35226 20.078 4.79108 18.78 4.67115C18.7412 4.66737 18.7038 4.65454 18.6708 4.6337C18.6378 4.61287 18.6101 4.5846 18.59 4.55115C17.8008 3.22797 16.6319 2.17274 15.2351 1.52258C13.8383 0.872419 12.2783 0.657387 10.7577 0.905423C9.23715 1.15346 7.82632 1.8531 6.70857 2.91343C5.59082 3.97376 4.81781 5.34576 4.49 6.85115C4.47269 6.89621 4.44271 6.9353 4.40367 6.9637C4.36463 6.99209 4.3182 7.00857 4.27 7.01115C3.32859 7.07558 2.42892 7.42429 1.69 8.01115C1.15504 8.44713 0.725279 8.99812 0.432684 9.62313C0.140088 10.2481 -0.00780742 10.9311 1.52481e-06 11.6212C-0.0236721 12.2125 0.0741493 12.8025 0.287424 13.3546C0.500699 13.9067 0.8249 14.4093 1.24 14.8312C2.23792 15.7043 3.51415 16.1935 4.84 16.2112C5.10522 16.2112 5.35957 16.1058 5.54711 15.9183C5.73464 15.7307 5.84 15.4764 5.84 15.2112C5.84 14.9459 5.73464 14.6916 5.54711 14.504C5.35957 14.3165 5.10522 14.2112 4.84 14.2112C4.04353 14.2069 3.27447 13.9198 2.67 13.4012C2.44045 13.1675 2.26226 12.8885 2.14688 12.582C2.0315 12.2754 1.98147 11.9482 2 11.6212C1.99893 11.2359 2.08416 10.8553 2.24941 10.5073C2.41467 10.1593 2.65576 9.85271 2.955 9.61006C3.25423 9.36741 3.60401 9.19486 3.97865 9.10507C4.35329 9.01527 4.74328 9.01052 5.12 9.09115C5.26074 9.11948 5.40593 9.11718 5.5457 9.08439C5.68547 9.05161 5.81654 8.98911 5.93 8.90115C6.04335 8.81436 6.1368 8.70431 6.20407 8.57839C6.27134 8.45248 6.31087 8.31362 6.32 8.17115C6.38894 6.90659 6.87852 5.70134 7.71094 4.74691C8.54337 3.79248 9.67089 3.14362 10.9143 2.90344C12.1578 2.66325 13.4459 2.84552 14.5738 3.42127C15.7018 3.99702 16.6051 4.93324 17.14 6.08115C17.2239 6.2576 17.3576 6.40561 17.5247 6.50691C17.6917 6.60821 17.8848 6.65835 18.08 6.65115C18.5877 6.62548 19.0952 6.70556 19.5703 6.88631C20.0454 7.06706 20.4778 7.34453 20.84 7.70115C21.2081 8.05188 21.5008 8.47397 21.7002 8.94164C21.8997 9.40931 22.0017 9.91273 22 10.4212C21.995 11.3659 21.641 12.2756 21.0061 12.9752C20.3711 13.6748 19.4999 14.115 18.56 14.2112C18.2948 14.2456 18.0541 14.3841 17.891 14.596C17.7278 14.8079 17.6555 15.0759 17.69 15.3412C17.7245 15.6064 17.8629 15.847 18.0748 16.0102C18.2867 16.1733 18.5548 16.2456 18.82 16.2112C20.245 16.0535 21.5616 15.3754 22.5175 14.307C23.4734 13.2385 24.0013 11.8548 24 10.4212Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M12.71 9.01115C12.617 8.91742 12.5064 8.84303 12.3846 8.79226C12.2627 8.74149 12.132 8.71535 12 8.71535C11.868 8.71535 11.7373 8.74149 11.6154 8.79226C11.4936 8.84303 11.383 8.91742 11.29 9.01115L7.79 12.5112C7.65239 12.6515 7.55922 12.8294 7.52211 13.0224C7.48501 13.2155 7.50562 13.4152 7.58138 13.5965C7.65714 13.7779 7.78468 13.933 7.94806 14.0423C8.11145 14.1516 8.30342 14.2103 8.5 14.2112H10.25C10.3163 14.2112 10.3799 14.2375 10.4268 14.2844C10.4737 14.3313 10.5 14.3948 10.5 14.4612V21.7112C10.5 22.109 10.658 22.4905 10.9393 22.7718C11.2206 23.0531 11.6022 23.2112 12 23.2112C12.3978 23.2112 12.7794 23.0531 13.0607 22.7718C13.342 22.4905 13.5 22.109 13.5 21.7112V14.4612C13.5 14.3948 13.5263 14.3313 13.5732 14.2844C13.6201 14.2375 13.6837 14.2112 13.75 14.2112H15.5C15.6986 14.2123 15.8931 14.1543 16.0586 14.0445C16.2241 13.9347 16.3532 13.7781 16.4294 13.5946C16.5055 13.4112 16.5254 13.2092 16.4863 13.0145C16.4472 12.8197 16.351 12.641 16.21 12.5012L12.71 9.01115Z",
		fill: "currentColor"
	})]
});
var ForwardRef$13 = forwardRef(SvgUploadCloud);
var Memo$13 = memo(ForwardRef$13);
//#endregion
//#region src/components/molecules/file-drop-zone/file-drop-zone.enums.ts
var FileMimeType = /* @__PURE__ */ function(FileMimeType) {
	FileMimeType["ALL"] = "application/octet-stream";
	FileMimeType["CSV"] = "text/csv";
	FileMimeType["EXCEL"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	FileMimeType["GZIP"] = "application/gzip";
	FileMimeType["IMAGE_ALL"] = "image/*";
	FileMimeType["IMAGE_GIF"] = "image/gif";
	FileMimeType["IMAGE_JPEG"] = "image/jpeg";
	FileMimeType["IMAGE_PNG"] = "image/png";
	FileMimeType["JSON"] = "application/json";
	FileMimeType["PDF"] = "application/pdf";
	FileMimeType["POWERPOINT"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
	FileMimeType["TEXT_PLAIN"] = "text/plain";
	FileMimeType["WORD"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
	FileMimeType["ZIP"] = "application/zip";
	return FileMimeType;
}({});
//#endregion
//#region src/components/molecules/file-drop-zone/file-drop-zone.styled.ts
var StyledUploadZoneWrapper = import_dist.default.div`
  border-dashed
  border-gray-300
  border-2
  p-6
  w-full
  rounded-md
  cursor-pointer
`;
var StyledTitle$1 = (0, import_dist.default)(Typography)`
  pt-3
  pb-1
  text-gray-600
`;
var StyledUploadText = (0, import_dist.default)(Typography)`
  text-primary-600
  cursor-pointer
`;
var StyledFormatText = (0, import_dist.default)(Typography)`
  text-gray-500
`;
(0, import_dist.default)(Typography)`
  text-primary-600
`;
//#endregion
//#region src/components/molecules/file-drop-zone/file-drop-zone.constants.ts
var mimeTypeExtensions = {
	[FileMimeType.ALL]: [".*"],
	[FileMimeType.CSV]: [".csv"],
	[FileMimeType.EXCEL]: [".xlsx"],
	[FileMimeType.IMAGE_ALL]: [
		".gif",
		".jpeg",
		".jpg",
		".png"
	],
	[FileMimeType.IMAGE_GIF]: [".gif"],
	[FileMimeType.GZIP]: [".gz"],
	[FileMimeType.IMAGE_JPEG]: [".jpeg", ".jpg"],
	[FileMimeType.IMAGE_PNG]: [".png"],
	[FileMimeType.JSON]: [".json"],
	[FileMimeType.PDF]: [".pdf"],
	[FileMimeType.POWERPOINT]: [".pptx"],
	[FileMimeType.TEXT_PLAIN]: [".txt"],
	[FileMimeType.WORD]: [".docx"],
	[FileMimeType.ZIP]: [".zip"]
};
//#endregion
//#region src/components/molecules/file-drop-zone/file-drop-zone.utils.ts
var makeAcceptMap = (mimeTypes) => {
	if (mimeTypes.includes(FileMimeType.ALL)) return;
	return mimeTypes.reduce((memo, mimeType) => {
		memo[mimeType] = mimeTypeExtensions[mimeType];
		return memo;
	}, {});
};
var getMimeTypeExtensions = (mimeTypes) => mimeTypes.reduce((memo, mimeType) => {
	memo.push(...mimeTypeExtensions[mimeType]);
	return memo;
}, []);
//#endregion
//#region src/components/molecules/file-drop-zone/FileDropZone.tsx
var FileDropZone = ({ addFiles, allowMultipleSelect = false, allowedMimeTypes = [FileMimeType.ALL], className, disable = false, inputId, text }) => {
	const { getInputProps, getRootProps } = useDropzone({
		accept: makeAcceptMap(allowedMimeTypes),
		multiple: allowMultipleSelect,
		noDrag: disable,
		noClick: disable,
		onDropAccepted: addFiles
	});
	return /* @__PURE__ */ React.createElement(StyledUploadZoneWrapper, {
		className,
		...getRootProps()
	}, /* @__PURE__ */ React.createElement(Stack, {
		direction: "column",
		alignItems: "center"
	}, /* @__PURE__ */ React.createElement("input", {
		id: inputId,
		...getInputProps()
	}), /* @__PURE__ */ React.createElement(Icon, {
		node: /* @__PURE__ */ React.createElement(Memo$13, { className: "text-gray-400" }),
		variant: "none",
		size: 9
	}), /* @__PURE__ */ React.createElement(StyledTitle$1, {
		as: "h2",
		fontSize: "sm",
		fontWeight: "medium",
		id: "upload"
	}, /* @__PURE__ */ React.createElement(StyledUploadText, {
		as: "strong",
		fontSize: "sm",
		fontWeight: "medium"
	}, "Upload ", text), " ", "by clicking or drag and drop"), /* @__PURE__ */ React.createElement(StyledFormatText, {
		as: "p",
		fontSize: "xs",
		fontWeight: "normal"
	}, "Expecting", " ", allowedMimeTypes.includes(FileMimeType.ALL) ? "any" : getMimeTypeExtensions(allowedMimeTypes).join(", "), " ", "format")));
};
//#endregion
//#region src/assets/icons/download.svg
var SvgDownload = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsxs("g", { children: [/* @__PURE__ */ jsx("path", {
		d: "M12.46 0.7A1.25 1.25 0 0 0 11.21 2v10.12a0.25 0.25 0 0 1 -0.25 0.25H8.8a1 1 0 0 0 -0.7 1.71l3.65 3.65a1 1 0 0 0 1.41 0l3.66 -3.65A1 1 0 0 0 17 13a1 1 0 0 0 -0.92 -0.62H14a0.25 0.25 0 0 1 -0.25 -0.25V2A1.25 1.25 0 0 0 12.46 0.7Z",
		fill: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ jsx("path", {
		d: "M23.75 22a1.25 1.25 0 0 0 -1.25 -1.25h-21a1.25 1.25 0 0 0 0 2.5h21A1.25 1.25 0 0 0 23.75 22Z",
		fill: "currentColor",
		strokeWidth: 1
	})] })
});
var ForwardRef$12 = forwardRef(SvgDownload);
var Memo$12 = memo(ForwardRef$12);
//#endregion
//#region src/components/molecules/file-display-section/FileDisplaySection.tsx
var FileDisplaySection = ({ disable = false, files, removeFile, ...defaultProps }) => {
	useMemo(() => {
		files.sort((a, b) => a.fileName.localeCompare(b.fileName));
	}, [files]);
	return /* @__PURE__ */ React.createElement("div", defaultProps, /* @__PURE__ */ React.createElement("ul", {
		role: "list",
		className: "divide-y divide-gray-100"
	}, files.map((file) => {
		const isUpdating = file.uploadPercent !== null && file.uploadPercent !== 100;
		return /* @__PURE__ */ React.createElement("li", {
			key: file.fileName,
			className: "flex items-center justify-between gap-x-6 py-3 px-4"
		}, /* @__PURE__ */ React.createElement("div", { className: "flex min-w-0 gap-x-4" }, /* @__PURE__ */ React.createElement("div", { className: "min-w-0 flex-auto" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-center gap-x-2" }, /* @__PURE__ */ React.createElement("p", { className: "text-xs font-semibold leading-6 text-gray-900 truncate" }, file.fileName), file.url && /* @__PURE__ */ React.createElement("a", {
			href: file.url,
			target: "_blank",
			rel: "noopener noreferrer"
		}, /* @__PURE__ */ React.createElement(Icon, {
			node: /* @__PURE__ */ React.createElement(Memo$12, { className: "text-gray-400" }),
			size: 4,
			variant: "none"
		})), file.status === "error" && file.errorMessage && /* @__PURE__ */ React.createElement(Tooltip, {
			text: file.errorMessage,
			className: "!z-modal whitespace-pre-line max-w-sm"
		}, /* @__PURE__ */ React.createElement(Icon, {
			node: getIconBySeverity("error"),
			nodeSize: 4.5,
			size: 6,
			colorVariant: "error",
			className: "flex-shrink-0",
			"aria-hidden": "true"
		}))))), /* @__PURE__ */ React.createElement(Button, {
			variant: "white",
			rounded: "full",
			size: "sm",
			disabled: isUpdating || disable,
			onClick: () => removeFile(file.fileName)
		}, !isUpdating || file.uploadPercent === null ? "Remove" : `${file.uploadPercent.toFixed(0)}%`));
	})));
};
//#endregion
//#region src/assets/icons/question-help-circle.svg
var SvgQuestionHelpCircle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.92,1,1,0,0,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.25a1,1,0,0,1-2,0,4,4,0,1,1,5.6,3.67Z",
		fill: "currentColor"
	})
});
var ForwardRef$11 = forwardRef(SvgQuestionHelpCircle);
var Memo$11 = memo(ForwardRef$11);
//#endregion
//#region src/components/molecules/help-link/help-link.styled.ts
var HelpLinkStyled = import_dist.default.a`
  absolute
  top-0
  right-0
  -translate-y-[25%] translate-x-[125%]
  cursor-pointer
  hover:text-primary-600
`;
//#endregion
//#region src/components/molecules/help-link/HelpLink.tsx
/**
* A help link component that displays a question mark icon linking to help documentation.
*
* Note: This component must be placed within a parent element that has `position: relative` styling.
* When used correctly, the help link will be positioned in the top right corner of the parent element
* using absolute positioning.
*
* @example
* <div style={{ position: 'relative' }}>
*   <HelpLink link="https://help.docs.com/article" />
* </div>
*/
var HelpLink = ({ className, href, id }) => /* @__PURE__ */ React.createElement(HelpLinkStyled, {
	href,
	target: "_blank",
	rel: "noopener noreferrer",
	className,
	id
}, /* @__PURE__ */ React.createElement(Memo$11, {
	height: 12,
	width: 12
}));
//#endregion
//#region src/components/molecules/title-with-help/TitleWithHelp.tsx
var TitleWithHelp = ({ href, title }) => /* @__PURE__ */ React.createElement(Stack, {
	direction: "row",
	alignItems: "center",
	className: "relative inline"
}, /* @__PURE__ */ React.createElement(Typography, {
	as: "h3",
	fontSize: "lg",
	fontWeight: "medium",
	className: "relative inline"
}, title), /* @__PURE__ */ React.createElement(HelpLink, { href }));
//#endregion
//#region src/components/molecules/label-with-help/label-with-help.styled.ts
var StyledLabel$1 = import_dist.default.label`
  block
  text-sm
  font-medium
  text-gray-700
  relative
  self-start
`;
//#endregion
//#region src/components/molecules/label-with-help/LabelWithHelp.tsx
var LabelWithHelp = ({ href, inputId, label }) => /* @__PURE__ */ React.createElement(StyledLabel$1, { htmlFor: inputId }, label, href && /* @__PURE__ */ React.createElement(HelpLink, { href }));
//#endregion
//#region src/assets/icons/close.svg
var SvgClose = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsxs("g", {
		transform: "matrix(2,0,0,2,0,0)",
		children: [/* @__PURE__ */ jsx("path", {
			d: "M0.75 23.249L23.25 0.749",
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ jsx("path", {
			d: "M23.25 23.249L0.75 0.749",
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	})
});
var ForwardRef$10 = forwardRef(SvgClose);
var Memo$10 = memo(ForwardRef$10);
//#endregion
//#region src/components/organisms/trouser-header/trouser-header.styled.ts
var StyledTrouserHeaderContainer = (0, import_dist.default)(Stack)`
  relative
  bg-gray-800
  ${({ $superUserMode }) => $superUserMode ? "bg-blue-900" : "bg-gray-800"}
`;
var TrouserChildrenContainer = (0, import_dist.default)(Stack)`
  min-h-[52px]
  relative
`;
var StyledSuperUserModeContainer = (0, import_dist.default)(Stack)`
  absolute
  left-20
  top-5
  flex
  flex-col
  gap-3
`;
var StyledSuperUserModeText = (0, import_dist.default)(Typography)`
  uppercase
  text-rsbry-500
`;
var StyledMarkIconContainer = (0, import_dist.default)(Stack)`
  pl-7
  w-28
`;
var TrouserHeaderTitleContainer = (0, import_dist.default)(Stack)`
  min-h-[65px]
  border-b
  border-gray-600
  flex-1
`;
var StyledCloseButtonContainer = (0, import_dist.default)(Stack)`
  pr-6
  w-28
`;
var StyledCloseButton = (0, import_dist.default)(ButtonCircular)`
  transition
  duration-300
  hover:rotate-90
`;
//#endregion
//#region src/components/organisms/trouser-header/TrouserHeader.tsx
var TrouserHeader = ({ children, className, onChangeHeight, onClose, superUserMode, superUserToggle, title }) => {
	const [ref, { height }] = useElementSize();
	useEffect(() => {
		onChangeHeight?.(height);
	}, [height, onChangeHeight]);
	return /* @__PURE__ */ React.createElement(StyledTrouserHeaderContainer, {
		ref,
		$superUserMode: superUserMode,
		className,
		direction: "column"
	}, /* @__PURE__ */ React.createElement(Stack, null, /* @__PURE__ */ React.createElement(StyledMarkIconContainer, { alignItems: "center" }, /* @__PURE__ */ React.createElement(Memo$14, { className: "h-8 text-primary-600" })), /* @__PURE__ */ React.createElement(TrouserHeaderTitleContainer, {
		alignItems: "center",
		justifyContent: "center"
	}, title), /* @__PURE__ */ React.createElement(StyledCloseButtonContainer, {
		alignItems: "center",
		justifyContent: "end"
	}, /* @__PURE__ */ React.createElement(StyledCloseButton, {
		onClick: onClose,
		size: "xs",
		icon: /* @__PURE__ */ React.createElement(Memo$10, { className: "text-white m-1" })
	}))), (children || superUserMode) && /* @__PURE__ */ React.createElement(TrouserChildrenContainer, {
		alignItems: "center",
		justifyContent: "center"
	}, superUserMode && /* @__PURE__ */ React.createElement(StyledSuperUserModeContainer, null, /* @__PURE__ */ React.createElement(StyledSuperUserModeText, {
		as: "p",
		fontSize: "l",
		fontWeight: "semibold",
		lineHeight: 4
	}, "super user mode"), superUserToggle && /* @__PURE__ */ React.createElement(Toggle, superUserToggle)), children));
};
//#endregion
//#region src/components/organisms/project-allocation/project-allocation.styled.ts
var TextColorVariant = {
	base: "text-gray-400",
	bold: "text-gray-600",
	0: "text-primary-600",
	1: "text-blue-600",
	2: "text-green-300",
	3: "text-lime-400",
	4: "text-aqua-500",
	5: "text-avocado-800",
	6: "text-orange-400",
	7: "text-rsbry-300",
	8: "text-lemon-300"
};
var StyledProjectName = (0, import_dist.default)(Typography)`
  max-w-[124px]
  truncate
  ${({ $variant }) => TextColorVariant[$variant]}
`;
var StyledAllocationContainer = (0, import_dist.default)(Stack)`
  ${({ $currentPlacement }) => $currentPlacement === "right-end" ? "flex-col-reverse" : "flex-col"}
`;
var StyledAllocationHeader = (0, import_dist.default)(Stack)`
  bg-gray-800
  w-full
  h-8
  pl-6
  overflow-hidden
  ${({ $currentPlacement }) => $currentPlacement === "right-end" ? "rounded-br-md" : "rounded-tr-md"}
`;
var StyledProjectsContainer = (0, import_dist.default)(Stack)`
  w-full
  pl-6
  pr-3
  py-1.5
  ${({ $currentPlacement }) => $currentPlacement === "right-end" ? "flex-col-reverse" : "flex-col"}
`;
var StyledProjectRow = (0, import_dist.default)(Stack)`
  py-1.5
`;
var StyledAdvancedButton = (0, import_dist.default)(Typography)`
  bg-primary-600
  hover:bg-primary-500
  h-full
  w-12
  text-white
`;
var StyledAllocationFooter = import_dist.default.div`
  bg-gray-200
  w-full
  h-8
  pl-6
  pr-3
  ${({ $currentPlacement }) => $currentPlacement === "right-end" ? "rounded-t-md" : "rounded-b-md"}
`;
//#endregion
//#region src/components/organisms/project-allocation/ProjectAllocation.tsx
var ProjectAllocation = ({ allocationSliderId, currentPlacement, onAdvanceBtnClick, onChange, onSelect, otherAllocations, projects, totalAllocated }) => {
	const sliderByProjects = projects.map((project) => Array.from({ length: project.percentage / 10 }, () => project.id)).flat();
	const sliderByOtherAllocations = otherAllocations.map((project) => Array.from({ length: project.percentage / 10 }, () => project.id)).flat();
	const hiddenOtherAllocations = otherAllocations.filter((allocation) => !allocation.visible);
	const getTooltip = (project) => (stepId) => {
		const hiddenAllocation = hiddenOtherAllocations.find((hiddenAllocation) => hiddenAllocation.id === stepId);
		return hiddenAllocation ? `This 10% is already allocated to ${hiddenAllocation.name}, clicking here will relocate that percentage to ${project.name}` : void 0;
	};
	return /* @__PURE__ */ React.createElement(SympatheticHighlightProvider, null, /* @__PURE__ */ React.createElement(StyledAllocationContainer, { $currentPlacement: currentPlacement }, /* @__PURE__ */ React.createElement(StyledAllocationHeader, {
		$currentPlacement: currentPlacement,
		direction: "row-reverse"
	}, /* @__PURE__ */ React.createElement(StyledAdvancedButton, {
		as: Button$2,
		onClick: onAdvanceBtnClick,
		fontSize: "xs",
		fontWeight: "medium"
	}, "ADV")), /* @__PURE__ */ React.createElement(StyledProjectsContainer, {
		$currentPlacement: currentPlacement,
		direction: "column"
	}, projects.map((project, idx) => /* @__PURE__ */ React.createElement(StyledProjectRow, {
		key: project.id,
		gap: 1.5
	}, /* @__PURE__ */ React.createElement(Stack, { gap: .5 }, /* @__PURE__ */ React.createElement(AllocationSlider, {
		onChange,
		onSelect: (percentage) => {
			onSelect({
				percentage,
				projectId: project.id
			});
		},
		otherAllocations: sliderByOtherAllocations,
		projectId: project.id,
		projects: sliderByProjects,
		selectedPercentage: project.percentage,
		startPercentageFrom: project.percentage,
		steps: (100 - totalAllocated) / 10,
		tooltip: getTooltip(project),
		variant: idx,
		id: `${project.name}-${allocationSliderId}`
	})), /* @__PURE__ */ React.createElement(StyledProjectName, {
		$variant: project.percentage === 0 ? "base" : idx % 9,
		as: "p",
		fontSize: "xs",
		fontWeight: "semibold",
		lineHeight: 5
	}, project.name)))), /* @__PURE__ */ React.createElement(StyledAllocationFooter, { $currentPlacement: currentPlacement }, otherAllocations.filter((otherAllocation) => otherAllocation.visible).map((otherAllocation) => /* @__PURE__ */ React.createElement(StyledProjectRow, {
		gap: 1.5,
		key: otherAllocation.id
	}, /* @__PURE__ */ React.createElement(Stack, { gap: .5 }, /* @__PURE__ */ React.createElement(AllocationSlider, {
		direction: "rtl",
		onChange,
		onSelect: (percentage) => {
			onSelect({
				percentage,
				projectId: otherAllocation.id
			});
		},
		otherAllocations: sliderByOtherAllocations,
		projectId: otherAllocation.id,
		projects: sliderByProjects,
		selectedPercentage: otherAllocation.percentage,
		startPercentageFrom: otherAllocation.percentage,
		steps: (100 - totalAllocated) / 10,
		tooltip: getTooltip(otherAllocation),
		variant: "base",
		id: allocationSliderId
	})), /* @__PURE__ */ React.createElement(StyledProjectName, {
		$variant: otherAllocation.percentage === 0 ? "base" : "bold",
		as: "p",
		fontSize: "xs",
		fontWeight: "semibold",
		lineHeight: 5
	}, otherAllocation.name))))));
};
//#endregion
//#region src/components/organisms/summary-equation/summary-equation.styled.ts
var StyledEquationContainer = (0, import_dist.default)(Stack)`
  h-24
  rounded-md
  shadow-md 
  bg-white
  p-6
`;
//#endregion
//#region src/components/organisms/summary-equation/SummaryEquation.tsx
var SummaryEquation = ({ children, className }) => /* @__PURE__ */ React.createElement(StyledEquationContainer, {
	alignItems: "center",
	className,
	direction: "row",
	gap: 2,
	justifyContent: "space-between"
}, children);
memo(SummaryEquation);
//#endregion
//#region src/components/organisms/side-nav/side-nav.styled.ts
var SIDE_NAV_VARIANTS = {
	light: "bg-gray-100",
	dark: "bg-gray-600"
};
var SideNavContainer = (0, import_dist.default)(Stack)`
  bg-gray-100
  z-sidenav
  h-full
  relative
`;
var StyledSideNav$1 = import_dist.default.nav`
  ${({ $open }) => $open ? "flex flex-col w-[275px]" : "w-20"}
  transition-[width]
  duration-300
  ease-in-out
  h-full
  absolute
  overflow-y-hidden
`;
var SideNavPlaceholder = import_dist.default.div`
  ${({ $open }) => $open ? "w-[275px]" : "w-20"}
`;
var SectionsContainer = (0, import_dist.default)(Stack)`
  flex-1
  h-full
  overflow-y-hidden
 ${({ $variant }) => SIDE_NAV_VARIANTS[$variant]}
`;
var SideNavMenu = (0, import_dist.default)(Stack)`
  overflow-y-auto
  flex-1
  pt-5
  pb-4
  px-2
  scrollbar-none
  [&::-webkit-scrollbar]:hidden
  [-ms-overflow-style:none]
  [scrollbar-width:none]
`;
var TitleContainer = (0, import_dist.default)(Stack)`
  h-4
  px-3
`;
var SectionTitle$1 = (0, import_dist.default)(Typography)`
  text-gray-500
`;
//#endregion
//#region src/components/organisms/side-nav/SideNav.tsx
var SideNav = ({ children, className, footer, gap, header, open, variant }) => {
	const { componentRef, hasScroll } = useScrollableElement();
	const [openState, setOpenState] = useState(false);
	const internalOpenState = open || openState;
	const handleMouseEnter = useCallback(() => {
		if (open !== void 0) return;
		setOpenState(true);
	}, [open]);
	const handleMouseLeave = useCallback(() => {
		if (open !== void 0) return;
		setOpenState(false);
	}, [open]);
	const arrayChildren = Children.toArray(children);
	return /* @__PURE__ */ React.createElement(NavItemContext.Provider, { value: {
		open: internalOpenState,
		variant
	} }, /* @__PURE__ */ React.createElement(SideNavContainer, { className }, /* @__PURE__ */ React.createElement(StyledSideNav$1, {
		$open: internalOpenState,
		onMouseEnter: handleMouseEnter,
		onMouseLeave: handleMouseLeave,
		"data-testid": "side-nav"
	}, /* @__PURE__ */ React.createElement(SectionsContainer, {
		direction: "column",
		$variant: variant
	}, header && /* @__PURE__ */ React.createElement(StyledNavItemDiv, {
		"data-testid": "header-wrapper",
		$isHeader: true,
		className
	}, header), /* @__PURE__ */ React.createElement(SideNavMenu, {
		ref: componentRef,
		direction: "column",
		gap,
		as: "ul"
	}, Children.map(arrayChildren, (child) => /* @__PURE__ */ React.createElement("li", null, child))), footer && typeof footer === "function" ? /* @__PURE__ */ React.createElement(StyledNavItemDiv, {
		"data-testid": "footer-wrapper",
		$floatingElement: hasScroll,
		$isFooter: true,
		className
	}, footer({ isFixedBottom: hasScroll })) : /* @__PURE__ */ React.createElement(StyledNavItemDiv, {
		"data-testid": "footer-wrapper",
		$floatingElement: hasScroll,
		$isFooter: true,
		className
	}, footer)))), /* @__PURE__ */ React.createElement(SideNavPlaceholder, { $open: open }));
};
var SideNavMemo = memo(SideNav);
//#endregion
//#region src/components/organisms/side-nav/SideNavSection.tsx
var SideNavSection = ({ children, className, gap = 1, title }) => {
	const arrayChildren = Children.toArray(children);
	const { open } = useContext(NavItemContext);
	return /* @__PURE__ */ React.createElement(Stack, {
		className,
		direction: "column",
		gap: 1
	}, title ? /* @__PURE__ */ React.createElement(TitleContainer, null, open ? /* @__PURE__ */ React.createElement(SectionTitle$1, {
		fontSize: "xs",
		fontWeight: "semibold"
	}, title) : null) : null, /* @__PURE__ */ React.createElement(Stack, {
		direction: "column",
		gap,
		as: "ul"
	}, Children.map(arrayChildren, (child) => /* @__PURE__ */ React.createElement("li", null, child))));
};
var SideNavSectionMemo = memo(SideNavSection);
//#endregion
//#region src/components/organisms/wizard/wizard.styled.ts
var StyledSideNav = (0, import_dist.default)(SideNav)`
  border-0
  min-h-[inherit]
  h-[initial]
  [&>nav]:w-[292px]
`;
var StyledActionContainer = (0, import_dist.default)(Stack)`
  pl-4
  w-full
`;
var StyledItemsContainer = import_dist.default.div`
  px-1
  py-4
`;
var StepsContainer = import_dist.default.div`
  w-[calc(100%-275px)]
`;
//#endregion
//#region src/components/organisms/wizard/Wizard.tsx
var Wizard = ({ className, closeButtonId, navDisabled, nextButtonId, onClose, onStepsComplete, pages }) => {
	const { currentStep, hasNextStep, hasPreviousStep, nextStep, prevStep, setCurrentStep } = useStepper({
		onStepsComplete,
		steps: pages.length
	});
	return /* @__PURE__ */ React.createElement(Stack, { className }, /* @__PURE__ */ React.createElement(StyledSideNav, {
		variant: "light",
		open: true,
		footer: /* @__PURE__ */ React.createElement(StyledActionContainer, { gap: 2 }, /* @__PURE__ */ React.createElement(Button, {
			className: "w-full",
			variant: "white",
			size: "base",
			rounded: "regular",
			disabled: !hasPreviousStep,
			onClick: prevStep
		}, "BACK"), hasNextStep ? /* @__PURE__ */ React.createElement(Button, {
			className: "w-full",
			variant: "primary",
			size: "base",
			rounded: "regular",
			onClick: nextStep,
			id: nextButtonId
		}, "NEXT") : /* @__PURE__ */ React.createElement(Button, {
			className: "w-full",
			variant: "primary",
			size: "base",
			rounded: "regular",
			onClick: onClose,
			id: closeButtonId
		}, "CLOSE"))
	}, /* @__PURE__ */ React.createElement(StyledItemsContainer, null, pages.map((page, idx) => /* @__PURE__ */ React.createElement(SideNavItem, {
		active: idx === currentStep,
		as: "button",
		badge: currentStep > idx ? {
			colorVariant: "darkGreen",
			dot: false,
			children: /* @__PURE__ */ React.createElement(Memo$27, { className: "w-3" })
		} : void 0,
		disabled: navDisabled,
		icon: page.icon,
		id: page.label,
		key: page.label,
		title: page.label,
		onClick: () => {
			setCurrentStep(idx);
		}
	})))), /* @__PURE__ */ React.createElement(StepsContainer, null, pages[currentStep].page));
};
//#endregion
//#region ../../node_modules/react-virtuoso/dist/index.mjs
var PUBLISH = 0;
var SUBSCRIBE = 1;
var RESET = 2;
var VALUE = 4;
function compose(a, b) {
	return (arg) => a(b(arg));
}
function thrush(arg, proc) {
	return proc(arg);
}
function curry2to1(proc, arg1) {
	return (arg2) => proc(arg1, arg2);
}
function curry1to0(proc, arg) {
	return () => proc(arg);
}
function tap(arg, proc) {
	proc(arg);
	return arg;
}
function tup(...args) {
	return args;
}
function call$1(proc) {
	proc();
}
function always(value) {
	return () => value;
}
function joinProc(...procs) {
	return () => {
		procs.map(call$1);
	};
}
function isDefined(arg) {
	return arg !== void 0;
}
function noop$2() {}
function subscribe(emitter, subscription) {
	return emitter(SUBSCRIBE, subscription);
}
function publish(publisher, value) {
	publisher(PUBLISH, value);
}
function reset(emitter) {
	emitter(RESET);
}
function getValue(depot) {
	return depot(VALUE);
}
function connect(emitter, publisher) {
	return subscribe(emitter, curry2to1(publisher, PUBLISH));
}
function handleNext(emitter, subscription) {
	const unsub = emitter(SUBSCRIBE, (value) => {
		unsub();
		subscription(value);
	});
	return unsub;
}
function stream() {
	const subscriptions = [];
	return (action, arg) => {
		switch (action) {
			case RESET:
				subscriptions.splice(0, subscriptions.length);
				return;
			case SUBSCRIBE:
				subscriptions.push(arg);
				return () => {
					const indexOf = subscriptions.indexOf(arg);
					if (indexOf > -1) subscriptions.splice(indexOf, 1);
				};
			case PUBLISH:
				subscriptions.slice().forEach((subscription) => {
					subscription(arg);
				});
				return;
			default: throw new Error(`unrecognized action ${action}`);
		}
	};
}
function statefulStream(initial) {
	let value = initial;
	const innerSubject = stream();
	return (action, arg) => {
		switch (action) {
			case SUBSCRIBE:
				arg(value);
				break;
			case PUBLISH:
				value = arg;
				break;
			case VALUE: return value;
		}
		return innerSubject(action, arg);
	};
}
function eventHandler(emitter) {
	let unsub;
	let currentSubscription;
	const cleanup = () => unsub && unsub();
	return function(action, subscription) {
		switch (action) {
			case SUBSCRIBE: if (subscription) {
				if (currentSubscription === subscription) return;
				cleanup();
				currentSubscription = subscription;
				unsub = subscribe(emitter, subscription);
				return unsub;
			} else {
				cleanup();
				return noop$2;
			}
			case RESET:
				cleanup();
				currentSubscription = null;
				return;
			default: throw new Error(`unrecognized action ${action}`);
		}
	};
}
function streamFromEmitter(emitter) {
	return tap(stream(), (stream2) => connect(emitter, stream2));
}
function statefulStreamFromEmitter(emitter, initial) {
	return tap(statefulStream(initial), (stream2) => connect(emitter, stream2));
}
function combineOperators(...operators) {
	return (subscriber) => {
		return operators.reduceRight(thrush, subscriber);
	};
}
function pipe$1(source, ...operators) {
	const project = combineOperators(...operators);
	return (action, subscription) => {
		switch (action) {
			case SUBSCRIBE: return subscribe(source, project(subscription));
			case RESET:
				reset(source);
				return;
		}
	};
}
function defaultComparator(previous, next) {
	return previous === next;
}
function distinctUntilChanged(comparator = defaultComparator) {
	let current;
	return (done) => (next) => {
		if (!comparator(current, next)) {
			current = next;
			done(next);
		}
	};
}
function filter(predicate) {
	return (done) => (value) => {
		predicate(value) && done(value);
	};
}
function map$2(project) {
	return (done) => compose(done, project);
}
function mapTo(value) {
	return (done) => () => done(value);
}
function scan(scanner, initial) {
	return (done) => (value) => done(initial = scanner(initial, value));
}
function skip(times) {
	return (done) => (value) => {
		times > 0 ? times-- : done(value);
	};
}
function throttleTime(interval) {
	let currentValue = null;
	let timeout;
	return (done) => (value) => {
		currentValue = value;
		if (timeout) return;
		timeout = setTimeout(() => {
			timeout = void 0;
			done(currentValue);
		}, interval);
	};
}
function debounceTime(interval) {
	let currentValue;
	let timeout;
	return (done) => (value) => {
		currentValue = value;
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(() => {
			done(currentValue);
		}, interval);
	};
}
function withLatestFrom(...sources) {
	const values = new Array(sources.length);
	let called = 0;
	let pendingCall = null;
	const allCalled = Math.pow(2, sources.length) - 1;
	sources.forEach((source, index) => {
		const bit = Math.pow(2, index);
		subscribe(source, (value) => {
			const prevCalled = called;
			called = called | bit;
			values[index] = value;
			if (prevCalled !== allCalled && called === allCalled && pendingCall) {
				pendingCall();
				pendingCall = null;
			}
		});
	});
	return (done) => (value) => {
		const call2 = () => done([value].concat(values));
		if (called === allCalled) call2();
		else pendingCall = call2;
	};
}
function merge(...sources) {
	return function(action, subscription) {
		switch (action) {
			case SUBSCRIBE: return joinProc(...sources.map((source) => subscribe(source, subscription)));
			case RESET: return;
			default: throw new Error(`unrecognized action ${action}`);
		}
	};
}
function duc(source, comparator = defaultComparator) {
	return pipe$1(source, distinctUntilChanged(comparator));
}
function combineLatest(...emitters) {
	const innerSubject = stream();
	const values = new Array(emitters.length);
	let called = 0;
	const allCalled = Math.pow(2, emitters.length) - 1;
	emitters.forEach((source, index) => {
		const bit = Math.pow(2, index);
		subscribe(source, (value) => {
			values[index] = value;
			called = called | bit;
			if (called === allCalled) publish(innerSubject, values);
		});
	});
	return function(action, subscription) {
		switch (action) {
			case SUBSCRIBE:
				if (called === allCalled) subscription(values);
				return subscribe(innerSubject, subscription);
			case RESET: return reset(innerSubject);
			default: throw new Error(`unrecognized action ${action}`);
		}
	};
}
function system(constructor, dependencies = [], { singleton } = { singleton: true }) {
	return {
		id: id(),
		constructor,
		dependencies,
		singleton
	};
}
var id = () => Symbol();
function init(systemSpec) {
	const singletons = /* @__PURE__ */ new Map();
	const _init = ({ id: id2, constructor, dependencies, singleton }) => {
		if (singleton && singletons.has(id2)) return singletons.get(id2);
		const system2 = constructor(dependencies.map((e) => _init(e)));
		if (singleton) singletons.set(id2, system2);
		return system2;
	};
	return _init(systemSpec);
}
function omit(keys, obj) {
	const result = {};
	const index = {};
	let idx = 0;
	const len = keys.length;
	while (idx < len) {
		index[keys[idx]] = 1;
		idx += 1;
	}
	for (const prop in obj) if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
	return result;
}
var useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function systemToComponent(systemSpec, map2, Root) {
	const requiredPropNames = Object.keys(map2.required || {});
	const optionalPropNames = Object.keys(map2.optional || {});
	const methodNames = Object.keys(map2.methods || {});
	const eventNames = Object.keys(map2.events || {});
	const Context = React.createContext({});
	function applyPropsToSystem(system2, props) {
		if (system2["propsReady"]) publish(system2["propsReady"], false);
		for (const requiredPropName of requiredPropNames) {
			const stream2 = system2[map2.required[requiredPropName]];
			publish(stream2, props[requiredPropName]);
		}
		for (const optionalPropName of optionalPropNames) if (optionalPropName in props) {
			const stream2 = system2[map2.optional[optionalPropName]];
			publish(stream2, props[optionalPropName]);
		}
		if (system2["propsReady"]) publish(system2["propsReady"], true);
	}
	function buildMethods(system2) {
		return methodNames.reduce((acc, methodName) => {
			acc[methodName] = (value) => {
				const stream2 = system2[map2.methods[methodName]];
				publish(stream2, value);
			};
			return acc;
		}, {});
	}
	function buildEventHandlers(system2) {
		return eventNames.reduce((handlers, eventName) => {
			handlers[eventName] = eventHandler(system2[map2.events[eventName]]);
			return handlers;
		}, {});
	}
	const Component = React.forwardRef((propsWithChildren, ref) => {
		const { children, ...props } = propsWithChildren;
		const [system2] = React.useState(() => {
			return tap(init(systemSpec), (system22) => applyPropsToSystem(system22, props));
		});
		const [handlers] = React.useState(curry1to0(buildEventHandlers, system2));
		useIsomorphicLayoutEffect$2(() => {
			for (const eventName of eventNames) if (eventName in props) subscribe(handlers[eventName], props[eventName]);
			return () => {
				Object.values(handlers).map(reset);
			};
		}, [
			props,
			handlers,
			system2
		]);
		useIsomorphicLayoutEffect$2(() => {
			applyPropsToSystem(system2, props);
		});
		React.useImperativeHandle(ref, always(buildMethods(system2)));
		return React.createElement(Context.Provider, { value: system2 }, Root ? React.createElement(Root, omit([
			...requiredPropNames,
			...optionalPropNames,
			...eventNames
		], props), children) : children);
	});
	const usePublisher2 = (key) => {
		return React.useCallback(curry2to1(publish, React.useContext(Context)[key]), [key]);
	};
	const useEmitterValue18 = (key) => {
		const source = React.useContext(Context)[key];
		const cb = React.useCallback((c) => {
			return subscribe(source, c);
		}, [source]);
		return React.useSyncExternalStore(cb, () => getValue(source), () => getValue(source));
	};
	const useEmitterValueLegacy = (key) => {
		const source = React.useContext(Context)[key];
		const [value, setValue] = React.useState(curry1to0(getValue, source));
		useIsomorphicLayoutEffect$2(() => subscribe(source, (next) => {
			if (next !== value) setValue(always(next));
		}), [source, value]);
		return value;
	};
	const useEmitterValue2 = React.version.startsWith("18") ? useEmitterValue18 : useEmitterValueLegacy;
	const useEmitter2 = (key, callback) => {
		const source = React.useContext(Context)[key];
		useIsomorphicLayoutEffect$2(() => subscribe(source, callback), [callback, source]);
	};
	return {
		Component,
		usePublisher: usePublisher2,
		useEmitterValue: useEmitterValue2,
		useEmitter: useEmitter2
	};
}
var useIsomorphicLayoutEffect$1 = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
	LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
	LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
	LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
	LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
	return LogLevel2;
})(LogLevel || {});
var CONSOLE_METHOD_MAP = {
	[0]: "debug",
	[1]: "log",
	[2]: "warn",
	[3]: "error"
};
var getGlobalThis = () => typeof globalThis === "undefined" ? window : globalThis;
var loggerSystem = system(() => {
	const logLevel = statefulStream(3);
	return {
		log: statefulStream((label, message, level = 1) => {
			var _a;
			if (level >= ((_a = getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : getValue(logLevel))) console[CONSOLE_METHOD_MAP[level]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", label, message);
		}),
		logLevel
	};
}, [], { singleton: true });
function useSizeWithElRef(callback, enabled, skipAnimationFrame) {
	const ref = React.useRef(null);
	let callbackRef = (_el) => {};
	if (typeof ResizeObserver !== "undefined") {
		const observer = React.useMemo(() => {
			return new ResizeObserver((entries) => {
				const code = () => {
					const element = entries[0].target;
					if (element.offsetParent !== null) callback(element);
				};
				skipAnimationFrame ? code() : requestAnimationFrame(code);
			});
		}, [callback]);
		callbackRef = (elRef) => {
			if (elRef && enabled) {
				observer.observe(elRef);
				ref.current = elRef;
			} else {
				if (ref.current) observer.unobserve(ref.current);
				ref.current = null;
			}
		};
	}
	return {
		ref,
		callbackRef
	};
}
function useSize(callback, enabled, skipAnimationFrame) {
	return useSizeWithElRef(callback, enabled, skipAnimationFrame).callbackRef;
}
function useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent, horizontalDirection, skipAnimationFrame) {
	return useSizeWithElRef(React.useCallback((el) => {
		const ranges = getChangedChildSizes(el.children, itemSize, horizontalDirection ? "offsetWidth" : "offsetHeight", log);
		let scrollableElement = el.parentElement;
		while (!scrollableElement.dataset["virtuosoScroller"]) scrollableElement = scrollableElement.parentElement;
		const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
		const scrollTop = customScrollParent ? horizontalDirection ? customScrollParent.scrollLeft : customScrollParent.scrollTop : windowScrolling ? horizontalDirection ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : horizontalDirection ? scrollableElement.scrollLeft : scrollableElement.scrollTop;
		const scrollHeight = customScrollParent ? horizontalDirection ? customScrollParent.scrollWidth : customScrollParent.scrollHeight : windowScrolling ? horizontalDirection ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : horizontalDirection ? scrollableElement.scrollWidth : scrollableElement.scrollHeight;
		const viewportHeight = customScrollParent ? horizontalDirection ? customScrollParent.offsetWidth : customScrollParent.offsetHeight : windowScrolling ? horizontalDirection ? window.innerWidth : window.innerHeight : horizontalDirection ? scrollableElement.offsetWidth : scrollableElement.offsetHeight;
		scrollContainerStateCallback({
			scrollTop: Math.max(scrollTop, 0),
			scrollHeight,
			viewportHeight
		});
		gap?.(horizontalDirection ? resolveGapValue$1("column-gap", getComputedStyle(el).columnGap, log) : resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
		if (ranges !== null) callback(ranges);
	}, [
		callback,
		itemSize,
		log,
		gap,
		customScrollParent,
		scrollContainerStateCallback
	]), enabled, skipAnimationFrame);
}
function getChangedChildSizes(children, itemSize, field, log) {
	const length = children.length;
	if (length === 0) return null;
	const results = [];
	for (let i = 0; i < length; i++) {
		const child = children.item(i);
		if (!child || child.dataset.index === void 0) continue;
		const index = parseInt(child.dataset.index);
		const knownSize = parseFloat(child.dataset.knownSize);
		const size = itemSize(child, field);
		if (size === 0) log("Zero-sized element, this should not happen", { child }, LogLevel.ERROR);
		if (size === knownSize) continue;
		const lastResult = results[results.length - 1];
		if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) results.push({
			startIndex: index,
			endIndex: index,
			size
		});
		else results[results.length - 1].endIndex++;
	}
	return results;
}
function resolveGapValue$1(property, value, log) {
	if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, LogLevel.WARN);
	if (value === "normal") return 0;
	return parseInt(value != null ? value : "0", 10);
}
function correctItemSize(el, dimension) {
	return Math.round(el.getBoundingClientRect()[dimension]);
}
function approximatelyEqual(num1, num2) {
	return Math.abs(num1 - num2) < 1.01;
}
function useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = noop$2, customScrollParent, horizontalDirection) {
	const scrollerRef = React.useRef(null);
	const scrollTopTarget = React.useRef(null);
	const timeoutRef = React.useRef(null);
	const handler = React.useCallback((ev) => {
		const el = ev.target;
		const windowScroll = el === window || el === document;
		const scrollTop = horizontalDirection ? windowScroll ? window.pageXOffset || document.documentElement.scrollLeft : el.scrollLeft : windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
		const scrollHeight = horizontalDirection ? windowScroll ? document.documentElement.scrollWidth : el.scrollWidth : windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
		const viewportHeight = horizontalDirection ? windowScroll ? window.innerWidth : el.offsetWidth : windowScroll ? window.innerHeight : el.offsetHeight;
		const call2 = () => {
			scrollContainerStateCallback({
				scrollTop: Math.max(scrollTop, 0),
				scrollHeight,
				viewportHeight
			});
		};
		if (ev.suppressFlushSync) call2();
		else ReactDOM.flushSync(call2);
		if (scrollTopTarget.current !== null) {
			if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
				scrollTopTarget.current = null;
				smoothScrollTargetReached(true);
				if (timeoutRef.current) {
					clearTimeout(timeoutRef.current);
					timeoutRef.current = null;
				}
			}
		}
	}, [scrollContainerStateCallback, smoothScrollTargetReached]);
	React.useEffect(() => {
		const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
		scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
		handler({
			target: localRef,
			suppressFlushSync: true
		});
		localRef.addEventListener("scroll", handler, { passive: true });
		return () => {
			scrollerRefCallback(null);
			localRef.removeEventListener("scroll", handler);
		};
	}, [
		scrollerRef,
		handler,
		scrollerElement,
		scrollerRefCallback,
		customScrollParent
	]);
	function scrollToCallback(location) {
		const scrollerElement2 = scrollerRef.current;
		if (!scrollerElement2 || (horizontalDirection ? "offsetWidth" in scrollerElement2 && scrollerElement2.offsetWidth === 0 : "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0)) return;
		const isSmooth = location.behavior === "smooth";
		let offsetHeight;
		let scrollHeight;
		let scrollTop;
		if (scrollerElement2 === window) {
			scrollHeight = Math.max(correctItemSize(document.documentElement, horizontalDirection ? "width" : "height"), horizontalDirection ? document.documentElement.scrollWidth : document.documentElement.scrollHeight);
			offsetHeight = horizontalDirection ? window.innerWidth : window.innerHeight;
			scrollTop = horizontalDirection ? document.documentElement.scrollLeft : document.documentElement.scrollTop;
		} else {
			scrollHeight = scrollerElement2[horizontalDirection ? "scrollWidth" : "scrollHeight"];
			offsetHeight = correctItemSize(scrollerElement2, horizontalDirection ? "width" : "height");
			scrollTop = scrollerElement2[horizontalDirection ? "scrollLeft" : "scrollTop"];
		}
		const maxScrollTop = scrollHeight - offsetHeight;
		location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
		if (approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
			scrollContainerStateCallback({
				scrollTop,
				scrollHeight,
				viewportHeight: offsetHeight
			});
			if (isSmooth) smoothScrollTargetReached(true);
			return;
		}
		if (isSmooth) {
			scrollTopTarget.current = location.top;
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => {
				timeoutRef.current = null;
				scrollTopTarget.current = null;
				smoothScrollTargetReached(true);
			}, 1e3);
		} else scrollTopTarget.current = null;
		if (horizontalDirection) location = {
			left: location.top,
			behavior: location.behavior
		};
		scrollerElement2.scrollTo(location);
	}
	function scrollByCallback(location) {
		if (horizontalDirection) location = {
			left: location.top,
			behavior: location.behavior
		};
		scrollerRef.current.scrollBy(location);
	}
	return {
		scrollerRef,
		scrollByCallback,
		scrollToCallback
	};
}
var domIOSystem = system(() => {
	const scrollContainerState = stream();
	const scrollTop = stream();
	const deviation = statefulStream(0);
	const smoothScrollTargetReached = stream();
	const statefulScrollTop = statefulStream(0);
	const viewportHeight = stream();
	const scrollHeight = stream();
	const headerHeight = statefulStream(0);
	const fixedHeaderHeight = statefulStream(0);
	const fixedFooterHeight = statefulStream(0);
	const footerHeight = statefulStream(0);
	const scrollTo = stream();
	const scrollBy = stream();
	const scrollingInProgress = statefulStream(false);
	const horizontalDirection = statefulStream(false);
	const skipAnimationFrameInResizeObserver = statefulStream(false);
	connect(pipe$1(scrollContainerState, map$2(({ scrollTop: scrollTop2 }) => scrollTop2)), scrollTop);
	connect(pipe$1(scrollContainerState, map$2(({ scrollHeight: scrollHeight2 }) => scrollHeight2)), scrollHeight);
	connect(scrollTop, statefulScrollTop);
	return {
		scrollContainerState,
		scrollTop,
		viewportHeight,
		headerHeight,
		fixedHeaderHeight,
		fixedFooterHeight,
		footerHeight,
		scrollHeight,
		smoothScrollTargetReached,
		horizontalDirection,
		skipAnimationFrameInResizeObserver,
		scrollTo,
		scrollBy,
		statefulScrollTop,
		deviation,
		scrollingInProgress
	};
}, [], { singleton: true });
var NIL_NODE = { lvl: 0 };
function newAANode(k, v, lvl, l = NIL_NODE, r = NIL_NODE) {
	return {
		k,
		v,
		lvl,
		l,
		r
	};
}
function empty(node) {
	return node === NIL_NODE;
}
function newTree() {
	return NIL_NODE;
}
function remove(node, key) {
	if (empty(node)) return NIL_NODE;
	const { k, l, r } = node;
	if (key === k) {
		if (empty(l)) return r;
		else if (empty(r)) return l;
		else {
			const [lastKey, lastValue] = last(l);
			return adjust(clone(node, {
				k: lastKey,
				v: lastValue,
				l: deleteLast(l)
			}));
		}
	} else if (key < k) return adjust(clone(node, { l: remove(l, key) }));
	else return adjust(clone(node, { r: remove(r, key) }));
}
function find(node, key) {
	if (empty(node)) return;
	if (key === node.k) return node.v;
	else if (key < node.k) return find(node.l, key);
	else return find(node.r, key);
}
function findMaxKeyValue(node, value, field = "k") {
	if (empty(node)) return [-Infinity, void 0];
	if (Number(node[field]) === value) return [node.k, node.v];
	if (Number(node[field]) < value) {
		const r = findMaxKeyValue(node.r, value, field);
		if (r[0] === -Infinity) return [node.k, node.v];
		else return r;
	}
	return findMaxKeyValue(node.l, value, field);
}
function insert(node, k, v) {
	if (empty(node)) return newAANode(k, v, 1);
	if (k === node.k) return clone(node, {
		k,
		v
	});
	else if (k < node.k) return rebalance(clone(node, { l: insert(node.l, k, v) }));
	else return rebalance(clone(node, { r: insert(node.r, k, v) }));
}
function walkWithin(node, start, end) {
	if (empty(node)) return [];
	const { k, v, l, r } = node;
	let result = [];
	if (k > start) result = result.concat(walkWithin(l, start, end));
	if (k >= start && k <= end) result.push({
		k,
		v
	});
	if (k <= end) result = result.concat(walkWithin(r, start, end));
	return result;
}
function walk(node) {
	if (empty(node)) return [];
	return [
		...walk(node.l),
		{
			k: node.k,
			v: node.v
		},
		...walk(node.r)
	];
}
function last(node) {
	return empty(node.r) ? [node.k, node.v] : last(node.r);
}
function deleteLast(node) {
	return empty(node.r) ? node.l : adjust(clone(node, { r: deleteLast(node.r) }));
}
function clone(node, args) {
	return newAANode(args.k !== void 0 ? args.k : node.k, args.v !== void 0 ? args.v : node.v, args.lvl !== void 0 ? args.lvl : node.lvl, args.l !== void 0 ? args.l : node.l, args.r !== void 0 ? args.r : node.r);
}
function isSingle(node) {
	return empty(node) || node.lvl > node.r.lvl;
}
function rebalance(node) {
	return split(skew(node));
}
function adjust(node) {
	const { l, r, lvl } = node;
	if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) return node;
	else if (lvl > r.lvl + 1) {
		if (isSingle(l)) return skew(clone(node, { lvl: lvl - 1 }));
		else if (!empty(l) && !empty(l.r)) return clone(l.r, {
			l: clone(l, { r: l.r.l }),
			r: clone(node, {
				l: l.r.r,
				lvl: lvl - 1
			}),
			lvl
		});
		else throw new Error("Unexpected empty nodes");
	} else if (isSingle(node)) return split(clone(node, { lvl: lvl - 1 }));
	else if (!empty(r) && !empty(r.l)) {
		const rl = r.l;
		const rlvl = isSingle(rl) ? r.lvl - 1 : r.lvl;
		return clone(rl, {
			l: clone(node, {
				r: rl.l,
				lvl: lvl - 1
			}),
			r: split(clone(r, {
				l: rl.r,
				lvl: rlvl
			})),
			lvl: rl.lvl + 1
		});
	} else throw new Error("Unexpected empty nodes");
}
function rangesWithin(node, startIndex, endIndex) {
	if (empty(node)) return [];
	const adjustedStart = findMaxKeyValue(node, startIndex)[0];
	return toRanges(walkWithin(node, adjustedStart, endIndex));
}
function arrayToRanges(items, parser) {
	const length = items.length;
	if (length === 0) return [];
	let { index: start, value } = parser(items[0]);
	const result = [];
	for (let i = 1; i < length; i++) {
		const { index: nextIndex, value: nextValue } = parser(items[i]);
		result.push({
			start,
			end: nextIndex - 1,
			value
		});
		start = nextIndex;
		value = nextValue;
	}
	result.push({
		start,
		end: Infinity,
		value
	});
	return result;
}
function toRanges(nodes) {
	return arrayToRanges(nodes, ({ k: index, v: value }) => ({
		index,
		value
	}));
}
function split(node) {
	const { r, lvl } = node;
	return !empty(r) && !empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? clone(r, {
		l: clone(node, { r: r.l }),
		lvl: lvl + 1
	}) : node;
}
function skew(node) {
	const { l } = node;
	return !empty(l) && l.lvl === node.lvl ? clone(l, { r: clone(node, { l: l.r }) }) : node;
}
function findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
	let end = items.length - 1;
	while (start <= end) {
		const index = Math.floor((start + end) / 2);
		const item = items[index];
		const match = comparator(item, value);
		if (match === 0) return index;
		if (match === -1) {
			if (end - start < 2) return index - 1;
			end = index - 1;
		} else {
			if (end === start) return index;
			start = index + 1;
		}
	}
	throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function findClosestSmallerOrEqual(items, value, comparator) {
	return items[findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function findRange$1(items, startValue, endValue, comparator) {
	const startIndex = findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
	const endIndex = findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
	return items.slice(startIndex, endIndex + 1);
}
var recalcSystem = system(() => {
	return { recalcInProgress: statefulStream(false) };
}, [], { singleton: true });
function rangeIncludes(refRange) {
	const { size, startIndex, endIndex } = refRange;
	return (range) => {
		return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
	};
}
function affectedGroupCount(offset, groupIndices) {
	let recognizedOffsetItems = 0;
	let groupIndex = 0;
	while (recognizedOffsetItems < offset) {
		recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
		groupIndex++;
	}
	return groupIndex - (recognizedOffsetItems === offset ? 0 : 1);
}
function insertRanges(sizeTree, ranges) {
	let syncStart = empty(sizeTree) ? 0 : Infinity;
	for (const range of ranges) {
		const { size, startIndex, endIndex } = range;
		syncStart = Math.min(syncStart, startIndex);
		if (empty(sizeTree)) {
			sizeTree = insert(sizeTree, 0, size);
			continue;
		}
		const overlappingRanges = rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
		if (overlappingRanges.some(rangeIncludes(range))) continue;
		let firstPassDone = false;
		let shouldInsert = false;
		for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges) {
			if (!firstPassDone) {
				shouldInsert = rangeValue !== size;
				firstPassDone = true;
			} else if (endIndex >= rangeStart || size === rangeValue) sizeTree = remove(sizeTree, rangeStart);
			if (rangeEnd > endIndex && endIndex >= rangeStart) {
				if (rangeValue !== size) sizeTree = insert(sizeTree, endIndex + 1, rangeValue);
			}
		}
		if (shouldInsert) sizeTree = insert(sizeTree, startIndex, size);
	}
	return [sizeTree, syncStart];
}
function initialSizeState() {
	return {
		offsetTree: [],
		sizeTree: newTree(),
		groupOffsetTree: newTree(),
		lastIndex: 0,
		lastOffset: 0,
		lastSize: 0,
		groupIndices: []
	};
}
function indexComparator({ index: itemIndex }, index) {
	return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function offsetComparator({ offset: itemOffset }, offset) {
	return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function offsetPointParser(point) {
	return {
		index: point.index,
		value: point
	};
}
function rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
	if (minStartIndex > 0) startOffset = Math.max(startOffset, findClosestSmallerOrEqual(tree, minStartIndex, indexComparator).offset);
	return arrayToRanges(findRange$1(tree, startOffset, endOffset, offsetComparator), offsetPointParser);
}
function createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
	let offsetTree = prevOffsetTree;
	let prevIndex = 0;
	let prevSize = 0;
	let prevOffset = 0;
	let startIndex = 0;
	if (syncStart !== 0) {
		startIndex = findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, indexComparator);
		prevOffset = offsetTree[startIndex].offset;
		const kv = findMaxKeyValue(sizeTree, syncStart - 1);
		prevIndex = kv[0];
		prevSize = kv[1];
		if (offsetTree.length && offsetTree[startIndex].size === findMaxKeyValue(sizeTree, syncStart)[1]) startIndex -= 1;
		offsetTree = offsetTree.slice(0, startIndex + 1);
	} else offsetTree = [];
	for (const { start: startIndex2, value } of rangesWithin(sizeTree, syncStart, Infinity)) {
		const indexOffset = startIndex2 - prevIndex;
		const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
		offsetTree.push({
			offset: aOffset,
			size: value,
			index: startIndex2
		});
		prevIndex = startIndex2;
		prevOffset = aOffset;
		prevSize = value;
	}
	return {
		offsetTree,
		lastIndex: prevIndex,
		lastOffset: prevOffset,
		lastSize: prevSize
	};
}
function sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
	if (ranges.length > 0) log("received item sizes", ranges, LogLevel.DEBUG);
	const sizeTree = state.sizeTree;
	let newSizeTree = sizeTree;
	let syncStart = 0;
	if (groupIndices.length > 0 && empty(sizeTree) && ranges.length === 2) {
		const groupSize = ranges[0].size;
		const itemSize = ranges[1].size;
		newSizeTree = groupIndices.reduce((tree, groupIndex) => {
			return insert(insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
		}, newSizeTree);
	} else [newSizeTree, syncStart] = insertRanges(newSizeTree, ranges);
	if (newSizeTree === sizeTree) return state;
	const { offsetTree: newOffsetTree, lastIndex, lastSize, lastOffset } = createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
	return {
		sizeTree: newSizeTree,
		offsetTree: newOffsetTree,
		lastIndex,
		lastOffset,
		lastSize,
		groupOffsetTree: groupIndices.reduce((tree, index) => {
			return insert(tree, index, offsetOf(index, newOffsetTree, gap));
		}, newTree()),
		groupIndices
	};
}
function offsetOf(index, tree, gap) {
	if (tree.length === 0) return 0;
	const { offset, index: startIndex, size } = findClosestSmallerOrEqual(tree, index, indexComparator);
	const itemCount = index - startIndex;
	const top = size * itemCount + (itemCount - 1) * gap + offset;
	return top > 0 ? top + gap : top;
}
function isGroupLocation(location) {
	return typeof location.groupIndex !== "undefined";
}
function originalIndexFromLocation(location, sizes, lastIndex) {
	if (isGroupLocation(location)) return sizes.groupIndices[location.groupIndex] + 1;
	else {
		let result = originalIndexFromItemIndex(location.index === "LAST" ? lastIndex : location.index, sizes);
		result = Math.max(0, result, Math.min(lastIndex, result));
		return result;
	}
}
function originalIndexFromItemIndex(itemIndex, sizes) {
	if (!hasGroups(sizes)) return itemIndex;
	let groupOffset = 0;
	while (sizes.groupIndices[groupOffset] <= itemIndex + groupOffset) groupOffset++;
	return itemIndex + groupOffset;
}
function hasGroups(sizes) {
	return !empty(sizes.groupOffsetTree);
}
function sizeTreeToRanges(sizeTree) {
	return walk(sizeTree).map(({ k: startIndex, v: size }, index, sizeArray) => {
		const nextSize = sizeArray[index + 1];
		return {
			startIndex,
			endIndex: nextSize ? nextSize.k - 1 : Infinity,
			size
		};
	});
}
var SIZE_MAP = {
	offsetHeight: "height",
	offsetWidth: "width"
};
var sizeSystem = system(([{ log }, { recalcInProgress }]) => {
	const sizeRanges = stream();
	const totalCount = stream();
	const statefulTotalCount = statefulStreamFromEmitter(totalCount, 0);
	const unshiftWith = stream();
	const shiftWith = stream();
	const firstItemIndex = statefulStream(0);
	const groupIndices = statefulStream([]);
	const fixedItemSize = statefulStream(void 0);
	const defaultItemSize = statefulStream(void 0);
	const itemSize = statefulStream((el, field) => correctItemSize(el, SIZE_MAP[field]));
	const data = statefulStream(void 0);
	const gap = statefulStream(0);
	const initial = initialSizeState();
	const sizes = statefulStreamFromEmitter(pipe$1(sizeRanges, withLatestFrom(groupIndices, log, gap), scan(sizeStateReducer, initial), distinctUntilChanged()), initial);
	const prevGroupIndices = statefulStreamFromEmitter(pipe$1(groupIndices, distinctUntilChanged(), scan((prev, curr) => ({
		prev: prev.current,
		current: curr
	}), {
		prev: [],
		current: []
	}), map$2(({ prev }) => prev)), []);
	connect(pipe$1(groupIndices, filter((indexes) => indexes.length > 0), withLatestFrom(sizes, gap), map$2(([groupIndices2, sizes2, gap2]) => {
		const groupOffsetTree = groupIndices2.reduce((tree, index, idx) => {
			return insert(tree, index, offsetOf(index, sizes2.offsetTree, gap2) || idx);
		}, newTree());
		return {
			...sizes2,
			groupIndices: groupIndices2,
			groupOffsetTree
		};
	})), sizes);
	connect(pipe$1(totalCount, withLatestFrom(sizes), filter(([totalCount2, { lastIndex }]) => {
		return totalCount2 < lastIndex;
	}), map$2(([totalCount2, { lastIndex, lastSize }]) => {
		return [{
			startIndex: totalCount2,
			endIndex: lastIndex,
			size: lastSize
		}];
	})), sizeRanges);
	connect(fixedItemSize, defaultItemSize);
	const trackItemSizes = statefulStreamFromEmitter(pipe$1(fixedItemSize, map$2((size) => size === void 0)), true);
	connect(pipe$1(defaultItemSize, filter((value) => {
		return value !== void 0 && empty(getValue(sizes).sizeTree);
	}), map$2((size) => [{
		startIndex: 0,
		endIndex: 0,
		size
	}])), sizeRanges);
	const listRefresh = streamFromEmitter(pipe$1(sizeRanges, withLatestFrom(sizes), scan(({ sizes: oldSizes }, [_, newSizes]) => {
		return {
			changed: newSizes !== oldSizes,
			sizes: newSizes
		};
	}, {
		changed: false,
		sizes: initial
	}), map$2((value) => value.changed)));
	subscribe(pipe$1(firstItemIndex, scan((prev, next) => {
		return {
			diff: prev.prev - next,
			prev: next
		};
	}, {
		diff: 0,
		prev: 0
	}), map$2((val) => val.diff)), (offset) => {
		const { groupIndices: groupIndices2 } = getValue(sizes);
		if (offset > 0) {
			publish(recalcInProgress, true);
			publish(unshiftWith, offset + affectedGroupCount(offset, groupIndices2));
		} else if (offset < 0) {
			const prevGroupIndicesValue = getValue(prevGroupIndices);
			if (prevGroupIndicesValue.length > 0) offset -= affectedGroupCount(-offset, prevGroupIndicesValue);
			publish(shiftWith, offset);
		}
	});
	subscribe(pipe$1(firstItemIndex, withLatestFrom(log)), ([index, log2]) => {
		if (index < 0) log2("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", { firstItemIndex }, LogLevel.ERROR);
	});
	const beforeUnshiftWith = streamFromEmitter(unshiftWith);
	connect(pipe$1(unshiftWith, withLatestFrom(sizes), map$2(([unshiftWith2, sizes2]) => {
		const groupedMode = sizes2.groupIndices.length > 0;
		const initialRanges = [];
		const defaultSize = sizes2.lastSize;
		if (groupedMode) {
			const firstGroupSize = find(sizes2.sizeTree, 0);
			let prependedGroupItemsCount = 0;
			let groupIndex = 0;
			while (prependedGroupItemsCount < unshiftWith2) {
				const theGroupIndex = sizes2.groupIndices[groupIndex];
				const groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
				initialRanges.push({
					startIndex: theGroupIndex,
					endIndex: theGroupIndex,
					size: firstGroupSize
				});
				initialRanges.push({
					startIndex: theGroupIndex + 1,
					endIndex: theGroupIndex + 1 + groupItemCount - 1,
					size: defaultSize
				});
				groupIndex++;
				prependedGroupItemsCount += groupItemCount + 1;
			}
			const sizeTreeKV = walk(sizes2.sizeTree);
			if (prependedGroupItemsCount !== unshiftWith2) sizeTreeKV.shift();
			return sizeTreeKV.reduce((acc, { k: index, v: size }) => {
				let ranges = acc.ranges;
				if (acc.prevSize !== 0) ranges = [...acc.ranges, {
					startIndex: acc.prevIndex,
					endIndex: index + unshiftWith2 - 1,
					size: acc.prevSize
				}];
				return {
					ranges,
					prevIndex: index + unshiftWith2,
					prevSize: size
				};
			}, {
				ranges: initialRanges,
				prevIndex: unshiftWith2,
				prevSize: 0
			}).ranges;
		}
		return walk(sizes2.sizeTree).reduce((acc, { k: index, v: size }) => {
			return {
				ranges: [...acc.ranges, {
					startIndex: acc.prevIndex,
					endIndex: index + unshiftWith2 - 1,
					size: acc.prevSize
				}],
				prevIndex: index + unshiftWith2,
				prevSize: size
			};
		}, {
			ranges: [],
			prevIndex: 0,
			prevSize: defaultSize
		}).ranges;
	})), sizeRanges);
	const shiftWithOffset = streamFromEmitter(pipe$1(shiftWith, withLatestFrom(sizes, gap), map$2(([shiftWith2, { offsetTree }, gap2]) => {
		return offsetOf(-shiftWith2, offsetTree, gap2);
	})));
	connect(pipe$1(shiftWith, withLatestFrom(sizes, gap), map$2(([shiftWith2, sizes2, gap2]) => {
		if (sizes2.groupIndices.length > 0) {
			if (empty(sizes2.sizeTree)) return sizes2;
			let newSizeTree = newTree();
			const prevGroupIndicesValue = getValue(prevGroupIndices);
			let removedItemsCount = 0;
			let groupIndex = 0;
			let groupOffset = 0;
			while (removedItemsCount < -shiftWith2) {
				groupOffset = prevGroupIndicesValue[groupIndex];
				const groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
				groupIndex++;
				removedItemsCount += groupItemCount + 1;
			}
			newSizeTree = walk(sizes2.sizeTree).reduce((acc, { k, v }) => {
				return insert(acc, Math.max(0, k + shiftWith2), v);
			}, newSizeTree);
			if (removedItemsCount !== -shiftWith2) {
				const firstGroupSize = find(sizes2.sizeTree, groupOffset);
				newSizeTree = insert(newSizeTree, 0, firstGroupSize);
				const nextItemSize = findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
				newSizeTree = insert(newSizeTree, 1, nextItemSize);
			}
			return {
				...sizes2,
				sizeTree: newSizeTree,
				...createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
			};
		} else {
			const newSizeTree = walk(sizes2.sizeTree).reduce((acc, { k, v }) => {
				return insert(acc, Math.max(0, k + shiftWith2), v);
			}, newTree());
			return {
				...sizes2,
				sizeTree: newSizeTree,
				...createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
			};
		}
	})), sizes);
	return {
		data,
		totalCount,
		sizeRanges,
		groupIndices,
		defaultItemSize,
		fixedItemSize,
		unshiftWith,
		shiftWith,
		shiftWithOffset,
		beforeUnshiftWith,
		firstItemIndex,
		gap,
		sizes,
		listRefresh,
		statefulTotalCount,
		trackItemSizes,
		itemSize
	};
}, tup(loggerSystem, recalcSystem), { singleton: true });
var SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function normalizeIndexLocation(location) {
	const result = typeof location === "number" ? { index: location } : location;
	if (!result.align) result.align = "start";
	if (!result.behavior || !SUPPORTS_SCROLL_TO_OPTIONS) result.behavior = "auto";
	if (!result.offset) result.offset = 0;
	return result;
}
var scrollToIndexSystem = system(([{ sizes, totalCount, listRefresh, gap }, { scrollingInProgress, viewportHeight, scrollTo, smoothScrollTargetReached, headerHeight, footerHeight, fixedHeaderHeight, fixedFooterHeight }, { log }]) => {
	const scrollToIndex = stream();
	const scrollTargetReached = stream();
	const topListHeight = statefulStream(0);
	let unsubscribeNextListRefresh = null;
	let cleartTimeoutRef = null;
	let unsubscribeListRefresh = null;
	function cleanup() {
		if (unsubscribeNextListRefresh) {
			unsubscribeNextListRefresh();
			unsubscribeNextListRefresh = null;
		}
		if (unsubscribeListRefresh) {
			unsubscribeListRefresh();
			unsubscribeListRefresh = null;
		}
		if (cleartTimeoutRef) {
			clearTimeout(cleartTimeoutRef);
			cleartTimeoutRef = null;
		}
		publish(scrollingInProgress, false);
	}
	connect(pipe$1(scrollToIndex, withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight), map$2(([[location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2], gap2, fixedHeaderHeight2, fixedFooterHeight2]) => {
		const normalLocation = normalizeIndexLocation(location);
		const { align, behavior, offset } = normalLocation;
		const lastIndex = totalCount2 - 1;
		const index = originalIndexFromLocation(normalLocation, sizes2, lastIndex);
		let top = offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
		if (align === "end") {
			top += fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
			if (index === lastIndex) top += footerHeight2;
		} else if (align === "center") top += (fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
		else top -= topListHeight2;
		if (offset) top += offset;
		const retry = (listChanged) => {
			cleanup();
			if (listChanged) {
				log2("retrying to scroll to", { location }, LogLevel.DEBUG);
				publish(scrollToIndex, location);
			} else {
				publish(scrollTargetReached, true);
				log2("list did not change, scroll successful", {}, LogLevel.DEBUG);
			}
		};
		cleanup();
		if (behavior === "smooth") {
			let listChanged = false;
			unsubscribeListRefresh = subscribe(listRefresh, (changed) => {
				listChanged = listChanged || changed;
			});
			unsubscribeNextListRefresh = handleNext(smoothScrollTargetReached, () => {
				retry(listChanged);
			});
		} else unsubscribeNextListRefresh = handleNext(pipe$1(listRefresh, watchChangesFor(150)), retry);
		cleartTimeoutRef = setTimeout(() => {
			cleanup();
		}, 1200);
		publish(scrollingInProgress, true);
		log2("scrolling from index to", {
			index,
			top,
			behavior
		}, LogLevel.DEBUG);
		return {
			top,
			behavior
		};
	})), scrollTo);
	return {
		scrollToIndex,
		scrollTargetReached,
		topListHeight
	};
}, tup(sizeSystem, domIOSystem, loggerSystem), { singleton: true });
function watchChangesFor(limit) {
	return (done) => {
		const timeoutRef = setTimeout(() => {
			done(false);
		}, limit);
		return (value) => {
			if (value) {
				done(true);
				clearTimeout(timeoutRef);
			}
		};
	};
}
var UP = "up";
var DOWN = "down";
var NONE$1 = "none";
var INITIAL_BOTTOM_STATE = {
	atBottom: false,
	notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
	state: {
		offsetBottom: 0,
		scrollTop: 0,
		viewportHeight: 0,
		scrollHeight: 0
	}
};
var DEFAULT_AT_TOP_THRESHOLD = 0;
var stateFlagsSystem = system(([{ scrollContainerState, scrollTop, viewportHeight, headerHeight, footerHeight, scrollBy }]) => {
	const isAtBottom = statefulStream(false);
	const isAtTop = statefulStream(true);
	const atBottomStateChange = stream();
	const atTopStateChange = stream();
	const atBottomThreshold = statefulStream(4);
	const atTopThreshold = statefulStream(DEFAULT_AT_TOP_THRESHOLD);
	const isScrolling = statefulStreamFromEmitter(pipe$1(merge(pipe$1(duc(scrollTop), skip(1), mapTo(true)), pipe$1(duc(scrollTop), skip(1), mapTo(false), debounceTime(100))), distinctUntilChanged()), false);
	const isScrollingBy = statefulStreamFromEmitter(pipe$1(merge(pipe$1(scrollBy, mapTo(true)), pipe$1(scrollBy, mapTo(false), debounceTime(200))), distinctUntilChanged()), false);
	connect(pipe$1(combineLatest(duc(scrollTop), duc(atTopThreshold)), map$2(([top, atTopThreshold2]) => top <= atTopThreshold2), distinctUntilChanged()), isAtTop);
	connect(pipe$1(isAtTop, throttleTime(50)), atTopStateChange);
	const atBottomState = streamFromEmitter(pipe$1(combineLatest(scrollContainerState, duc(viewportHeight), duc(headerHeight), duc(footerHeight), duc(atBottomThreshold)), scan((current, [{ scrollTop: scrollTop2, scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2]) => {
		const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
		const state = {
			viewportHeight: viewportHeight2,
			scrollTop: scrollTop2,
			scrollHeight
		};
		if (isAtBottom2) {
			let atBottomBecause;
			let scrollTopDelta;
			if (scrollTop2 > current.state.scrollTop) {
				atBottomBecause = "SCROLLED_DOWN";
				scrollTopDelta = current.state.scrollTop - scrollTop2;
			} else {
				atBottomBecause = "SIZE_DECREASED";
				scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
			}
			return {
				atBottom: true,
				state,
				atBottomBecause,
				scrollTopDelta
			};
		}
		let notAtBottomBecause;
		if (state.scrollHeight > current.state.scrollHeight) notAtBottomBecause = "SIZE_INCREASED";
		else if (viewportHeight2 < current.state.viewportHeight) notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
		else if (scrollTop2 < current.state.scrollTop) notAtBottomBecause = "SCROLLING_UPWARDS";
		else notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
		return {
			atBottom: false,
			notAtBottomBecause,
			state
		};
	}, INITIAL_BOTTOM_STATE), distinctUntilChanged((prev, next) => {
		return prev && prev.atBottom === next.atBottom;
	})));
	const lastJumpDueToItemResize = statefulStreamFromEmitter(pipe$1(scrollContainerState, scan((current, { scrollTop: scrollTop2, scrollHeight, viewportHeight: viewportHeight2 }) => {
		if (!approximatelyEqual(current.scrollHeight, scrollHeight)) {
			const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
			if (current.scrollTop !== scrollTop2 && atBottom) return {
				scrollHeight,
				scrollTop: scrollTop2,
				jump: current.scrollTop - scrollTop2,
				changed: true
			};
			else return {
				scrollHeight,
				scrollTop: scrollTop2,
				jump: 0,
				changed: true
			};
		} else return {
			scrollTop: scrollTop2,
			scrollHeight,
			jump: 0,
			changed: false
		};
	}, {
		scrollHeight: 0,
		jump: 0,
		scrollTop: 0,
		changed: false
	}), filter((value) => value.changed), map$2((value) => value.jump)), 0);
	connect(pipe$1(atBottomState, map$2((state) => state.atBottom)), isAtBottom);
	connect(pipe$1(isAtBottom, throttleTime(50)), atBottomStateChange);
	const scrollDirection = statefulStream(DOWN);
	connect(pipe$1(scrollContainerState, map$2(({ scrollTop: scrollTop2 }) => scrollTop2), distinctUntilChanged(), scan((acc, scrollTop2) => {
		if (getValue(isScrollingBy)) return {
			direction: acc.direction,
			prevScrollTop: scrollTop2
		};
		return {
			direction: scrollTop2 < acc.prevScrollTop ? UP : DOWN,
			prevScrollTop: scrollTop2
		};
	}, {
		direction: DOWN,
		prevScrollTop: 0
	}), map$2((value) => value.direction)), scrollDirection);
	connect(pipe$1(scrollContainerState, throttleTime(50), mapTo(NONE$1)), scrollDirection);
	const scrollVelocity = statefulStream(0);
	connect(pipe$1(isScrolling, filter((value) => !value), mapTo(0)), scrollVelocity);
	connect(pipe$1(scrollTop, throttleTime(100), withLatestFrom(isScrolling), filter(([_, isScrolling2]) => !!isScrolling2), scan(([_, prev], [next]) => [prev, next], [0, 0]), map$2(([prev, next]) => next - prev)), scrollVelocity);
	return {
		isScrolling,
		isAtTop,
		isAtBottom,
		atBottomState,
		atTopStateChange,
		atBottomStateChange,
		scrollDirection,
		atBottomThreshold,
		atTopThreshold,
		scrollVelocity,
		lastJumpDueToItemResize
	};
}, tup(domIOSystem));
var propsReadySystem = system(([{ log }]) => {
	const propsReady = statefulStream(false);
	const didMount = streamFromEmitter(pipe$1(propsReady, filter((ready) => ready), distinctUntilChanged()));
	subscribe(propsReady, (value) => {
		value && getValue(log)("props updated", {}, LogLevel.DEBUG);
	});
	return {
		propsReady,
		didMount
	};
}, tup(loggerSystem), { singleton: true });
function skipFrames(frameCount, callback) {
	if (frameCount == 0) callback();
	else requestAnimationFrame(() => skipFrames(frameCount - 1, callback));
}
function getInitialTopMostItemIndexNumber(location, totalCount) {
	const lastIndex = totalCount - 1;
	return typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
}
var initialTopMostItemIndexSystem = system(([{ sizes, listRefresh, defaultItemSize }, { scrollTop }, { scrollToIndex, scrollTargetReached }, { didMount }]) => {
	const scrolledToInitialItem = statefulStream(true);
	const initialTopMostItemIndex = statefulStream(0);
	const initialItemFinalLocationReached = statefulStream(true);
	connect(pipe$1(didMount, withLatestFrom(initialTopMostItemIndex), filter(([_, location]) => !!location), mapTo(false)), scrolledToInitialItem);
	connect(pipe$1(didMount, withLatestFrom(initialTopMostItemIndex), filter(([_, location]) => !!location), mapTo(false)), initialItemFinalLocationReached);
	subscribe(pipe$1(combineLatest(listRefresh, didMount), withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, initialItemFinalLocationReached), filter(([[, didMount2], scrolledToInitialItem2, { sizeTree }, defaultItemSize2, scrollScheduled]) => {
		return didMount2 && (!empty(sizeTree) || isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled;
	}), withLatestFrom(initialTopMostItemIndex)), ([, initialTopMostItemIndex2]) => {
		handleNext(scrollTargetReached, () => {
			publish(initialItemFinalLocationReached, true);
		});
		skipFrames(4, () => {
			handleNext(scrollTop, () => {
				publish(scrolledToInitialItem, true);
			});
			publish(scrollToIndex, initialTopMostItemIndex2);
		});
	});
	return {
		scrolledToInitialItem,
		initialTopMostItemIndex,
		initialItemFinalLocationReached
	};
}, tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem), { singleton: true });
function normalizeFollowOutput(follow) {
	if (!follow) return false;
	return follow === "smooth" ? "smooth" : "auto";
}
var behaviorFromFollowOutput = (follow, isAtBottom) => {
	if (typeof follow === "function") return normalizeFollowOutput(follow(isAtBottom));
	return isAtBottom && normalizeFollowOutput(follow);
};
var followOutputSystem = system(([{ totalCount, listRefresh }, { isAtBottom, atBottomState }, { scrollToIndex }, { scrolledToInitialItem }, { propsReady, didMount }, { log }, { scrollingInProgress }]) => {
	const followOutput = statefulStream(false);
	const autoscrollToBottom = stream();
	let pendingScrollHandle = null;
	function scrollToBottom(followOutputBehavior) {
		publish(scrollToIndex, {
			index: "LAST",
			align: "end",
			behavior: followOutputBehavior
		});
	}
	subscribe(pipe$1(combineLatest(pipe$1(duc(totalCount), skip(1)), didMount), withLatestFrom(duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), map$2(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2]) => {
		let shouldFollow = didMount2 && scrolledToInitialItem2;
		let followOutputBehavior = "auto";
		if (shouldFollow) {
			followOutputBehavior = behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
			shouldFollow = shouldFollow && !!followOutputBehavior;
		}
		return {
			totalCount: totalCount2,
			shouldFollow,
			followOutputBehavior
		};
	}), filter(({ shouldFollow }) => shouldFollow)), ({ totalCount: totalCount2, followOutputBehavior }) => {
		if (pendingScrollHandle) {
			pendingScrollHandle();
			pendingScrollHandle = null;
		}
		pendingScrollHandle = handleNext(listRefresh, () => {
			getValue(log)("following output to ", { totalCount: totalCount2 }, LogLevel.DEBUG);
			scrollToBottom(followOutputBehavior);
			pendingScrollHandle = null;
		});
	});
	function trapNextSizeIncrease(followOutput2) {
		const cancel = handleNext(atBottomState, (state) => {
			if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
				getValue(log)("scrolling to bottom due to increased size", {}, LogLevel.DEBUG);
				scrollToBottom("auto");
			}
		});
		setTimeout(cancel, 100);
	}
	subscribe(pipe$1(combineLatest(duc(followOutput), totalCount, propsReady), filter(([follow, , ready]) => follow && ready), scan(({ value }, [, next]) => {
		return {
			refreshed: value === next,
			value: next
		};
	}, {
		refreshed: false,
		value: 0
	}), filter(({ refreshed }) => refreshed), withLatestFrom(followOutput, totalCount)), ([, followOutput2]) => {
		if (getValue(scrolledToInitialItem)) trapNextSizeIncrease(followOutput2 !== false);
	});
	subscribe(autoscrollToBottom, () => {
		trapNextSizeIncrease(getValue(followOutput) !== false);
	});
	subscribe(combineLatest(duc(followOutput), atBottomState), ([followOutput2, state]) => {
		if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") scrollToBottom("auto");
	});
	return {
		followOutput,
		autoscrollToBottom
	};
}, tup(sizeSystem, stateFlagsSystem, scrollToIndexSystem, initialTopMostItemIndexSystem, propsReadySystem, loggerSystem, domIOSystem));
function groupCountsToIndicesAndCount(counts) {
	return counts.reduce((acc, groupCount) => {
		acc.groupIndices.push(acc.totalCount);
		acc.totalCount += groupCount + 1;
		return acc;
	}, {
		totalCount: 0,
		groupIndices: []
	});
}
var groupedListSystem = system(([{ totalCount, groupIndices, sizes }, { scrollTop, headerHeight }]) => {
	const groupCounts = stream();
	const topItemsIndexes = stream();
	const groupIndicesAndCount = streamFromEmitter(pipe$1(groupCounts, map$2(groupCountsToIndicesAndCount)));
	connect(pipe$1(groupIndicesAndCount, map$2((value) => value.totalCount)), totalCount);
	connect(pipe$1(groupIndicesAndCount, map$2((value) => value.groupIndices)), groupIndices);
	connect(pipe$1(combineLatest(scrollTop, sizes, headerHeight), filter(([_, sizes2]) => hasGroups(sizes2)), map$2(([scrollTop2, state, headerHeight2]) => findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]), distinctUntilChanged(), map$2((index) => [index])), topItemsIndexes);
	return {
		groupCounts,
		topItemsIndexes
	};
}, tup(sizeSystem, domIOSystem));
function tupleComparator(prev, current) {
	return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function rangeComparator(prev, next) {
	return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
var TOP = "top";
var BOTTOM = "bottom";
var NONE = "none";
function getOverscan(overscan, end, direction) {
	if (typeof overscan === "number") return direction === UP && end === TOP || direction === DOWN && end === BOTTOM ? overscan : 0;
	else if (direction === UP) return end === TOP ? overscan.main : overscan.reverse;
	else return end === BOTTOM ? overscan.main : overscan.reverse;
}
function getViewportIncrease(value, end) {
	return typeof value === "number" ? value : value[end] || 0;
}
var sizeRangeSystem = system(([{ scrollTop, viewportHeight, deviation, headerHeight, fixedHeaderHeight }]) => {
	const listBoundary = stream();
	const topListHeight = statefulStream(0);
	const increaseViewportBy = statefulStream(0);
	const overscan = statefulStream(0);
	return {
		listBoundary,
		overscan,
		topListHeight,
		increaseViewportBy,
		visibleRange: statefulStreamFromEmitter(pipe$1(combineLatest(duc(scrollTop), duc(viewportHeight), duc(headerHeight), duc(listBoundary, tupleComparator), duc(overscan), duc(topListHeight), duc(fixedHeaderHeight), duc(deviation), duc(increaseViewportBy)), map$2(([scrollTop2, viewportHeight2, headerHeight2, [listTop, listBottom], overscan2, topListHeight2, fixedHeaderHeight2, deviation2, increaseViewportBy2]) => {
			const top = scrollTop2 - deviation2;
			const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
			const headerVisible = Math.max(headerHeight2 - top, 0);
			let direction = NONE;
			const topViewportAddition = getViewportIncrease(increaseViewportBy2, TOP);
			const bottomViewportAddition = getViewportIncrease(increaseViewportBy2, BOTTOM);
			listTop -= deviation2;
			listTop += headerHeight2 + fixedHeaderHeight2;
			listBottom += headerHeight2 + fixedHeaderHeight2;
			listBottom -= deviation2;
			if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) direction = UP;
			if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) direction = DOWN;
			if (direction !== NONE) return [Math.max(top - headerHeight2 - getOverscan(overscan2, TOP, direction) - topViewportAddition, 0), top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + getOverscan(overscan2, BOTTOM, direction) + bottomViewportAddition];
			return null;
		}), filter((value) => value != null), distinctUntilChanged(tupleComparator)), [0, 0])
	};
}, tup(domIOSystem), { singleton: true });
function probeItemSet(index, sizes, data) {
	if (hasGroups(sizes)) {
		const itemIndex = originalIndexFromItemIndex(index, sizes);
		return [{
			index: findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0],
			size: 0,
			offset: 0
		}, {
			index: itemIndex,
			size: 0,
			offset: 0,
			data: data && data[0]
		}];
	}
	return [{
		index,
		size: 0,
		offset: 0,
		data: data && data[0]
	}];
}
var EMPTY_LIST_STATE = {
	items: [],
	topItems: [],
	offsetTop: 0,
	offsetBottom: 0,
	top: 0,
	bottom: 0,
	topListHeight: 0,
	totalCount: 0,
	firstItemIndex: 0
};
function transposeItems(items, sizes, firstItemIndex) {
	if (items.length === 0) return [];
	if (!hasGroups(sizes)) return items.map((item) => ({
		...item,
		index: item.index + firstItemIndex,
		originalIndex: item.index
	}));
	const startIndex = items[0].index;
	const endIndex = items[items.length - 1].index;
	const transposedItems = [];
	const groupRanges = rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
	let currentRange = void 0;
	let currentGroupIndex = 0;
	for (const item of items) {
		if (!currentRange || currentRange.end < item.index) {
			currentRange = groupRanges.shift();
			currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
		}
		let transposedItem;
		if (item.index === currentRange.start) transposedItem = {
			type: "group",
			index: currentGroupIndex
		};
		else transposedItem = {
			index: item.index - (currentGroupIndex + 1) + firstItemIndex,
			groupIndex: currentGroupIndex
		};
		transposedItems.push({
			...transposedItem,
			size: item.size,
			offset: item.offset,
			originalIndex: item.index,
			data: item.data
		});
	}
	return transposedItems;
}
function buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
	const { lastSize, lastOffset, lastIndex } = sizes;
	let offsetTop = 0;
	let bottom = 0;
	if (items.length > 0) {
		offsetTop = items[0].offset;
		const lastItem = items[items.length - 1];
		bottom = lastItem.offset + lastItem.size;
	}
	const itemCount = totalCount - lastIndex;
	const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
	const top = offsetTop;
	const offsetBottom = total - bottom;
	return {
		items: transposeItems(items, sizes, firstItemIndex),
		topItems: transposeItems(topItems, sizes, firstItemIndex),
		topListHeight: topItems.reduce((height, item) => item.size + height, 0),
		offsetTop,
		offsetBottom,
		top,
		bottom,
		totalCount,
		firstItemIndex
	};
}
function buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
	let includedGroupsCount = 0;
	if (sizes.groupIndices.length > 0) for (const index of sizes.groupIndices) {
		if (index - includedGroupsCount >= itemCount) break;
		includedGroupsCount++;
	}
	const adjustedCount = itemCount + includedGroupsCount;
	const initialTopMostItemIndexNumber = getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
	return buildListState(Array.from({ length: adjustedCount }).map((_, index) => ({
		index: index + initialTopMostItemIndexNumber,
		size: 0,
		offset: 0,
		data: data[index + initialTopMostItemIndexNumber]
	})), [], adjustedCount, gap, sizes, firstItemIndex);
}
var listStateSystem = system(([{ sizes, totalCount, data, firstItemIndex, gap }, groupedListSystem2, { visibleRange, listBoundary, topListHeight: rangeTopListHeight }, { scrolledToInitialItem, initialTopMostItemIndex }, { topListHeight }, stateFlags, { didMount }, { recalcInProgress }]) => {
	const topItemsIndexes = statefulStream([]);
	const initialItemCount = statefulStream(0);
	const itemsRendered = stream();
	connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
	const listState = statefulStreamFromEmitter(pipe$1(combineLatest(didMount, recalcInProgress, duc(visibleRange, tupleComparator), duc(totalCount), duc(sizes), duc(initialTopMostItemIndex), scrolledToInitialItem, duc(topItemsIndexes), duc(firstItemIndex), duc(gap), data), filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2]) => {
		const dataChangeInProgress = data2 && data2.length !== totalCount2;
		return mount && !recalcInProgress2 && !dataChangeInProgress;
	}), map$2(([, , [startOffset, endOffset], totalCount2, sizes2, initialTopMostItemIndex2, scrolledToInitialItem2, topItemsIndexes2, firstItemIndex2, gap2, data2]) => {
		const sizesValue = sizes2;
		const { sizeTree, offsetTree } = sizesValue;
		const initialItemCountValue = getValue(initialItemCount);
		if (totalCount2 === 0) return {
			...EMPTY_LIST_STATE,
			totalCount: totalCount2
		};
		if (startOffset === 0 && endOffset === 0) {
			if (initialItemCountValue === 0) return {
				...EMPTY_LIST_STATE,
				totalCount: totalCount2
			};
			else return buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
		}
		if (empty(sizeTree)) {
			if (initialItemCountValue > 0) return null;
			return buildListState(probeItemSet(getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2), [], totalCount2, gap2, sizesValue, firstItemIndex2);
		}
		const topItems = [];
		if (topItemsIndexes2.length > 0) {
			const startIndex = topItemsIndexes2[0];
			const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
			let offset = 0;
			for (const range of rangesWithin(sizeTree, startIndex, endIndex)) {
				const size = range.value;
				const rangeStartIndex = Math.max(range.start, startIndex);
				const rangeEndIndex = Math.min(range.end, endIndex);
				for (let i = rangeStartIndex; i <= rangeEndIndex; i++) {
					topItems.push({
						index: i,
						size,
						offset,
						data: data2 && data2[i]
					});
					offset += size;
				}
			}
		}
		if (!scrolledToInitialItem2) return buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
		const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
		const offsetPointRanges = rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
		if (offsetPointRanges.length === 0) return null;
		const maxIndex = totalCount2 - 1;
		return buildListState(tap([], (result) => {
			for (const range of offsetPointRanges) {
				const point = range.value;
				let offset = point.offset;
				let rangeStartIndex = range.start;
				const size = point.size;
				if (point.offset < startOffset) {
					rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
					const itemCount = rangeStartIndex - range.start;
					offset += itemCount * size + itemCount * gap2;
				}
				if (rangeStartIndex < minStartIndex) {
					offset += (minStartIndex - rangeStartIndex) * size;
					rangeStartIndex = minStartIndex;
				}
				const endIndex = Math.min(range.end, maxIndex);
				for (let i = rangeStartIndex; i <= endIndex; i++) {
					if (offset >= endOffset) break;
					result.push({
						index: i,
						size,
						offset,
						data: data2 && data2[i]
					});
					offset += size + gap2;
				}
			}
		}), topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
	}), filter((value) => value !== null), distinctUntilChanged()), EMPTY_LIST_STATE);
	connect(pipe$1(data, filter(isDefined), map$2((data2) => data2 == null ? void 0 : data2.length)), totalCount);
	connect(pipe$1(listState, map$2((value) => value.topListHeight)), topListHeight);
	connect(topListHeight, rangeTopListHeight);
	connect(pipe$1(listState, map$2((state) => [state.top, state.bottom])), listBoundary);
	connect(pipe$1(listState, map$2((state) => state.items)), itemsRendered);
	return {
		listState,
		topItemsIndexes,
		endReached: streamFromEmitter(pipe$1(listState, filter(({ items }) => items.length > 0), withLatestFrom(totalCount, data), filter(([{ items }, totalCount2]) => items[items.length - 1].originalIndex === totalCount2 - 1), map$2(([, totalCount2, data2]) => [totalCount2 - 1, data2]), distinctUntilChanged(tupleComparator), map$2(([count]) => count))),
		startReached: streamFromEmitter(pipe$1(listState, throttleTime(200), filter(({ items, topItems }) => {
			return items.length > 0 && items[0].originalIndex === topItems.length;
		}), map$2(({ items }) => items[0].index), distinctUntilChanged())),
		rangeChanged: streamFromEmitter(pipe$1(listState, filter(({ items }) => items.length > 0), map$2(({ items }) => {
			let startIndex = 0;
			let endIndex = items.length - 1;
			while (items[startIndex].type === "group" && startIndex < endIndex) startIndex++;
			while (items[endIndex].type === "group" && endIndex > startIndex) endIndex--;
			return {
				startIndex: items[startIndex].index,
				endIndex: items[endIndex].index
			};
		}), distinctUntilChanged(rangeComparator))),
		itemsRendered,
		initialItemCount,
		...stateFlags
	};
}, tup(sizeSystem, groupedListSystem, sizeRangeSystem, initialTopMostItemIndexSystem, scrollToIndexSystem, stateFlagsSystem, propsReadySystem, recalcSystem), { singleton: true });
var initialItemCountSystem = system(([{ sizes, firstItemIndex, data, gap }, { initialTopMostItemIndex }, { initialItemCount, listState }, { didMount }]) => {
	connect(pipe$1(didMount, withLatestFrom(initialItemCount), filter(([, count]) => count !== 0), withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), map$2(([[, count], initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2 = []]) => {
		return buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
	})), listState);
	return {};
}, tup(sizeSystem, initialTopMostItemIndexSystem, listStateSystem, propsReadySystem), { singleton: true });
var scrollSeekSystem = system(([{ scrollVelocity }]) => {
	const isSeeking = statefulStream(false);
	const rangeChanged = stream();
	const scrollSeekConfiguration = statefulStream(false);
	connect(pipe$1(scrollVelocity, withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), filter(([_, config]) => !!config), map$2(([speed, config, isSeeking2, range]) => {
		const { exit, enter } = config;
		if (isSeeking2) {
			if (exit(speed, range)) return false;
		} else if (enter(speed, range)) return true;
		return isSeeking2;
	}), distinctUntilChanged()), isSeeking);
	subscribe(pipe$1(combineLatest(isSeeking, scrollVelocity, rangeChanged), withLatestFrom(scrollSeekConfiguration)), ([[isSeeking2, velocity, range], config]) => isSeeking2 && config && config.change && config.change(velocity, range));
	return {
		isSeeking,
		scrollSeekConfiguration,
		scrollVelocity,
		scrollSeekRangeChanged: rangeChanged
	};
}, tup(stateFlagsSystem), { singleton: true });
var topItemCountSystem = system(([{ topItemsIndexes }]) => {
	const topItemCount = statefulStream(0);
	connect(pipe$1(topItemCount, filter((length) => length > 0), map$2((length) => Array.from({ length }).map((_, index) => index))), topItemsIndexes);
	return { topItemCount };
}, tup(listStateSystem));
var totalListHeightSystem = system(([{ footerHeight, headerHeight, fixedHeaderHeight, fixedFooterHeight }, { listState }]) => {
	const totalListHeightChanged = stream();
	const totalListHeight = statefulStreamFromEmitter(pipe$1(combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), map$2(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2]) => {
		return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
	})), 0);
	connect(duc(totalListHeight), totalListHeightChanged);
	return {
		totalListHeight,
		totalListHeightChanged
	};
}, tup(domIOSystem, listStateSystem), { singleton: true });
function simpleMemoize(func) {
	let called = false;
	let result;
	return () => {
		if (!called) {
			called = true;
			result = func();
		}
		return result;
	};
}
var isMobileSafari = simpleMemoize(() => {
	return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
var upwardScrollFixSystem = system(([{ scrollBy, scrollTop, deviation, scrollingInProgress }, { isScrolling, isAtBottom, scrollDirection, lastJumpDueToItemResize }, { listState }, { beforeUnshiftWith, shiftWithOffset, sizes, gap }, { log }, { recalcInProgress }]) => {
	const deviationOffset = streamFromEmitter(pipe$1(listState, withLatestFrom(lastJumpDueToItemResize), scan(([, prevItems, prevTotalCount, prevTotalHeight], [{ items, totalCount, bottom, offsetBottom }, lastJumpDueToItemResize2]) => {
		const totalHeight = bottom + offsetBottom;
		let newDev = 0;
		if (prevTotalCount === totalCount) {
			if (prevItems.length > 0 && items.length > 0) {
				if (!(items[0].originalIndex === 0 && prevItems[0].originalIndex === 0)) {
					newDev = totalHeight - prevTotalHeight;
					if (newDev !== 0) newDev += lastJumpDueToItemResize2;
				}
			}
		}
		return [
			newDev,
			items,
			totalCount,
			totalHeight
		];
	}, [
		0,
		[],
		0,
		0
	]), filter(([amount]) => amount !== 0), withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress), filter(([, scrollTop2, scrollDirection2, scrollingInProgress2, , , recalcInProgress2]) => {
		return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === UP;
	}), map$2(([[amount], , , , , log2]) => {
		log2("Upward scrolling compensation", { amount }, LogLevel.DEBUG);
		return amount;
	})));
	function scrollByWith(offset) {
		if (offset > 0) {
			publish(scrollBy, {
				top: -offset,
				behavior: "auto"
			});
			publish(deviation, 0);
		} else {
			publish(deviation, 0);
			publish(scrollBy, {
				top: -offset,
				behavior: "auto"
			});
		}
	}
	subscribe(pipe$1(deviationOffset, withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2]) => {
		if (isScrolling2 && isMobileSafari()) publish(deviation, deviationAmount - offset);
		else scrollByWith(-offset);
	});
	subscribe(pipe$1(combineLatest(statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress), filter(([is, deviation2, recalc]) => !is && !recalc && deviation2 !== 0), map$2(([_, deviation2]) => deviation2), throttleTime(1)), scrollByWith);
	connect(pipe$1(shiftWithOffset, map$2((offset) => {
		return { top: -offset };
	})), scrollBy);
	subscribe(pipe$1(beforeUnshiftWith, withLatestFrom(sizes, gap), map$2(([offset, { lastSize: defaultItemSize, groupIndices, sizeTree }, gap2]) => {
		function getItemOffset(itemCount) {
			return itemCount * (defaultItemSize + gap2);
		}
		if (groupIndices.length === 0) return getItemOffset(offset);
		else {
			let amount = 0;
			const defaultGroupSize = find(sizeTree, 0);
			let recognizedOffsetItems = 0;
			let groupIndex = 0;
			while (recognizedOffsetItems < offset) {
				recognizedOffsetItems++;
				amount += defaultGroupSize;
				let groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
				if (recognizedOffsetItems + groupItemCount > offset) {
					amount -= defaultGroupSize;
					groupItemCount = offset - recognizedOffsetItems + 1;
				}
				recognizedOffsetItems += groupItemCount;
				amount += getItemOffset(groupItemCount);
				groupIndex++;
			}
			return amount;
		}
	})), (offset) => {
		publish(deviation, offset);
		requestAnimationFrame(() => {
			publish(scrollBy, { top: offset });
			requestAnimationFrame(() => {
				publish(deviation, 0);
				publish(recalcInProgress, false);
			});
		});
	});
	return { deviation };
}, tup(domIOSystem, stateFlagsSystem, listStateSystem, sizeSystem, loggerSystem, recalcSystem));
var initialScrollTopSystem = system(([{ didMount }, { scrollTo }, { listState }]) => {
	const initialScrollTop = statefulStream(0);
	subscribe(pipe$1(didMount, withLatestFrom(initialScrollTop), filter(([, offset]) => offset !== 0), map$2(([, offset]) => ({ top: offset }))), (location) => {
		handleNext(pipe$1(listState, skip(1), filter((state) => state.items.length > 1)), () => {
			requestAnimationFrame(() => {
				publish(scrollTo, location);
			});
		});
	});
	return { initialScrollTop };
}, tup(propsReadySystem, domIOSystem, listStateSystem), { singleton: true });
var alignToBottomSystem = system(([{ viewportHeight }, { totalListHeight }]) => {
	const alignToBottom = statefulStream(false);
	return {
		alignToBottom,
		paddingTopAddition: statefulStreamFromEmitter(pipe$1(combineLatest(alignToBottom, viewportHeight, totalListHeight), filter(([enabled]) => enabled), map$2(([, viewportHeight2, totalListHeight2]) => {
			return Math.max(0, viewportHeight2 - totalListHeight2);
		}), throttleTime(0), distinctUntilChanged()), 0)
	};
}, tup(domIOSystem, totalListHeightSystem), { singleton: true });
var windowScrollerSystem = system(([{ scrollTo, scrollContainerState }]) => {
	const windowScrollContainerState = stream();
	const windowViewportRect = stream();
	const windowScrollTo = stream();
	const useWindowScroll = statefulStream(false);
	const customScrollParent = statefulStream(void 0);
	connect(pipe$1(combineLatest(windowScrollContainerState, windowViewportRect), map$2(([{ viewportHeight, scrollTop: windowScrollTop, scrollHeight }, { offsetTop }]) => {
		return {
			scrollTop: Math.max(0, windowScrollTop - offsetTop),
			scrollHeight,
			viewportHeight
		};
	})), scrollContainerState);
	connect(pipe$1(scrollTo, withLatestFrom(windowViewportRect), map$2(([scrollTo2, { offsetTop }]) => {
		return {
			...scrollTo2,
			top: scrollTo2.top + offsetTop
		};
	})), windowScrollTo);
	return {
		useWindowScroll,
		customScrollParent,
		windowScrollContainerState,
		windowViewportRect,
		windowScrollTo
	};
}, tup(domIOSystem));
var defaultCalculateViewLocation = ({ itemTop: itemTop2, itemBottom, viewportTop, viewportBottom, locationParams: { behavior, align, ...rest } }) => {
	if (itemTop2 < viewportTop) return {
		...rest,
		behavior,
		align: align != null ? align : "start"
	};
	if (itemBottom > viewportBottom) return {
		...rest,
		behavior,
		align: align != null ? align : "end"
	};
	return null;
};
var scrollIntoViewSystem = system(([{ sizes, totalCount, gap }, { scrollTop, viewportHeight, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollingInProgress }, { scrollToIndex }]) => {
	const scrollIntoView = stream();
	connect(pipe$1(scrollIntoView, withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), withLatestFrom(gap), map$2(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2]) => {
		const { done, behavior, align, calculateViewLocation = defaultCalculateViewLocation, ...rest } = viewLocation;
		const actualIndex = originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
		const itemTop2 = offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
		const location = calculateViewLocation({
			itemTop: itemTop2,
			itemBottom: itemTop2 + findMaxKeyValue(sizes2.sizeTree, actualIndex)[1],
			viewportTop: scrollTop2 + fixedHeaderHeight2,
			viewportBottom: scrollTop2 + viewportHeight2 - fixedFooterHeight2,
			locationParams: {
				behavior,
				align,
				...rest
			}
		});
		if (location) done && handleNext(pipe$1(scrollingInProgress, filter((value) => value === false), skip(getValue(scrollingInProgress) ? 1 : 2)), done);
		else done && done();
		return location;
	}), filter((value) => value !== null)), scrollToIndex);
	return { scrollIntoView };
}, tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem), { singleton: true });
var stateLoadSystem = system(([{ sizes, sizeRanges }, { scrollTop, headerHeight }, { initialTopMostItemIndex }, { didMount }, { useWindowScroll, windowScrollContainerState, windowViewportRect }]) => {
	const getState = stream();
	const restoreStateFrom = statefulStream(void 0);
	const statefulWindowScrollContainerState = statefulStream(null);
	const statefulWindowViewportRect = statefulStream(null);
	connect(windowScrollContainerState, statefulWindowScrollContainerState);
	connect(windowViewportRect, statefulWindowViewportRect);
	subscribe(pipe$1(getState, withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect, headerHeight)), ([callback, sizes2, scrollTop2, useWindowScroll2, windowScrollContainerState2, windowViewportRect2, headerHeight2]) => {
		const ranges = sizeTreeToRanges(sizes2.sizeTree);
		if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
		scrollTop2 -= headerHeight2;
		callback({
			ranges,
			scrollTop: scrollTop2
		});
	});
	connect(pipe$1(restoreStateFrom, filter(isDefined), map$2(locationFromSnapshot)), initialTopMostItemIndex);
	connect(pipe$1(didMount, withLatestFrom(restoreStateFrom), filter(([, state]) => state !== void 0), distinctUntilChanged(), map$2(([, snapshot]) => {
		return snapshot.ranges;
	})), sizeRanges);
	return {
		getState,
		restoreStateFrom
	};
}, tup(sizeSystem, domIOSystem, initialTopMostItemIndexSystem, propsReadySystem, windowScrollerSystem));
function locationFromSnapshot(snapshot) {
	return {
		offset: snapshot.scrollTop,
		index: 0,
		align: "start"
	};
}
var listSystem = system(([{ totalCount, sizeRanges, fixedItemSize, defaultItemSize, trackItemSizes, itemSize, data, firstItemIndex, groupIndices, statefulTotalCount, gap, sizes }, { initialTopMostItemIndex, scrolledToInitialItem, initialItemFinalLocationReached }, domIO, stateLoad, followOutput, { listState, topItemsIndexes, ...flags }, { scrollToIndex }, _, { topItemCount }, { groupCounts }, featureGroup1]) => {
	connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
	connect(pipe$1(featureGroup1.windowViewportRect, map$2((value) => value.visibleHeight)), domIO.viewportHeight);
	return {
		totalCount,
		data,
		firstItemIndex,
		sizeRanges,
		initialTopMostItemIndex,
		scrolledToInitialItem,
		initialItemFinalLocationReached,
		topItemsIndexes,
		topItemCount,
		groupCounts,
		fixedItemHeight: fixedItemSize,
		defaultItemHeight: defaultItemSize,
		gap,
		...followOutput,
		statefulTotalCount,
		listState,
		scrollToIndex,
		trackItemSizes,
		itemSize,
		groupIndices,
		...flags,
		...featureGroup1,
		...domIO,
		sizes,
		...stateLoad
	};
}, tup(sizeSystem, initialTopMostItemIndexSystem, domIOSystem, stateLoadSystem, followOutputSystem, listStateSystem, scrollToIndexSystem, upwardScrollFixSystem, topItemCountSystem, groupedListSystem, system(([sizeRange, initialItemCount, propsReady, scrollSeek, totalListHeight, initialScrollTopSystem2, alignToBottom, windowScroller, scrollIntoView, logger]) => {
	return {
		...sizeRange,
		...initialItemCount,
		...propsReady,
		...scrollSeek,
		...totalListHeight,
		...initialScrollTopSystem2,
		...alignToBottom,
		...windowScroller,
		...scrollIntoView,
		...logger
	};
}, tup(sizeRangeSystem, initialItemCountSystem, propsReadySystem, scrollSeekSystem, totalListHeightSystem, initialScrollTopSystem, alignToBottomSystem, windowScrollerSystem, scrollIntoViewSystem, loggerSystem))));
var WEBKIT_STICKY = "-webkit-sticky";
var STICKY = "sticky";
var positionStickyCssValue = simpleMemoize(() => {
	if (typeof document === "undefined") return STICKY;
	const node = document.createElement("div");
	node.style.position = WEBKIT_STICKY;
	return node.style.position === WEBKIT_STICKY ? WEBKIT_STICKY : STICKY;
});
function useWindowViewportRectRef(callback, customScrollParent, skipAnimationFrame) {
	const viewportInfo = React.useRef(null);
	const calculateInfo = React.useCallback((element) => {
		if (element === null || !element.offsetParent) return;
		const rect = element.getBoundingClientRect();
		const visibleWidth = rect.width;
		let visibleHeight, offsetTop;
		if (customScrollParent) {
			const customScrollParentRect = customScrollParent.getBoundingClientRect();
			const deltaTop = rect.top - customScrollParentRect.top;
			visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
			offsetTop = deltaTop + customScrollParent.scrollTop;
		} else {
			visibleHeight = window.innerHeight - Math.max(0, rect.top);
			offsetTop = rect.top + window.pageYOffset;
		}
		viewportInfo.current = {
			offsetTop,
			visibleHeight,
			visibleWidth
		};
		callback(viewportInfo.current);
	}, [callback, customScrollParent]);
	const { callbackRef, ref } = useSizeWithElRef(calculateInfo, true, skipAnimationFrame);
	const scrollAndResizeEventHandler = React.useCallback(() => {
		calculateInfo(ref.current);
	}, [calculateInfo, ref]);
	React.useEffect(() => {
		if (customScrollParent) {
			customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
			const observer = new ResizeObserver(() => {
				requestAnimationFrame(scrollAndResizeEventHandler);
			});
			observer.observe(customScrollParent);
			return () => {
				customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
				observer.unobserve(customScrollParent);
			};
		} else {
			window.addEventListener("scroll", scrollAndResizeEventHandler);
			window.addEventListener("resize", scrollAndResizeEventHandler);
			return () => {
				window.removeEventListener("scroll", scrollAndResizeEventHandler);
				window.removeEventListener("resize", scrollAndResizeEventHandler);
			};
		}
	}, [scrollAndResizeEventHandler, customScrollParent]);
	return callbackRef;
}
var VirtuosoMockContext = React.createContext(void 0);
var VirtuosoGridMockContext = React.createContext(void 0);
function identity$1(value) {
	return value;
}
var combinedSystem$2 = /* @__PURE__ */ system(([listSystem2, propsSystem]) => {
	return {
		...listSystem2,
		...propsSystem
	};
}, tup(listSystem, /* @__PURE__ */ system(() => {
	const itemContent = statefulStream((index) => `Item ${index}`);
	const context = statefulStream(null);
	const groupContent = statefulStream((index) => `Group ${index}`);
	const components = statefulStream({});
	const computeItemKey = statefulStream(identity$1);
	const headerFooterTag = statefulStream("div");
	const scrollerRef = statefulStream(noop$2);
	const distinctProp = (propName, defaultValue = null) => {
		return statefulStreamFromEmitter(pipe$1(components, map$2((components2) => components2[propName]), distinctUntilChanged()), defaultValue);
	};
	return {
		context,
		itemContent,
		groupContent,
		components,
		computeItemKey,
		headerFooterTag,
		scrollerRef,
		FooterComponent: distinctProp("Footer"),
		HeaderComponent: distinctProp("Header"),
		TopItemListComponent: distinctProp("TopItemList"),
		ListComponent: distinctProp("List", "div"),
		ItemComponent: distinctProp("Item", "div"),
		GroupComponent: distinctProp("Group", "div"),
		ScrollerComponent: distinctProp("Scroller", "div"),
		EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
		ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
	};
})));
var DefaultScrollSeekPlaceholder$1 = ({ height }) => /* @__PURE__ */ React.createElement("div", { style: { height } });
var GROUP_STYLE = {
	position: positionStickyCssValue(),
	zIndex: 1,
	overflowAnchor: "none"
};
var ITEM_STYLE$1 = { overflowAnchor: "none" };
var HORIZONTAL_ITEM_STYLE = {
	...ITEM_STYLE$1,
	display: "inline-block",
	height: "100%"
};
var Items$1 = /* @__PURE__ */ React.memo(function VirtuosoItems({ showTopList = false }) {
	const listState = useEmitterValue$2("listState");
	const sizeRanges = usePublisher$2("sizeRanges");
	const useWindowScroll = useEmitterValue$2("useWindowScroll");
	const customScrollParent = useEmitterValue$2("customScrollParent");
	const windowScrollContainerStateCallback = usePublisher$2("windowScrollContainerState");
	const _scrollContainerStateCallback = usePublisher$2("scrollContainerState");
	const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
	const itemContent = useEmitterValue$2("itemContent");
	const context = useEmitterValue$2("context");
	const groupContent = useEmitterValue$2("groupContent");
	const trackItemSizes = useEmitterValue$2("trackItemSizes");
	const itemSize = useEmitterValue$2("itemSize");
	const log = useEmitterValue$2("log");
	const listGap = usePublisher$2("gap");
	const horizontalDirection = useEmitterValue$2("horizontalDirection");
	const { callbackRef } = useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, showTopList ? noop$2 : scrollContainerStateCallback, log, listGap, customScrollParent, horizontalDirection, useEmitterValue$2("skipAnimationFrameInResizeObserver"));
	const [deviation, setDeviation] = React.useState(0);
	useEmitter$2("deviation", (value) => {
		if (deviation !== value) setDeviation(value);
	});
	const EmptyPlaceholder = useEmitterValue$2("EmptyPlaceholder");
	const ScrollSeekPlaceholder = useEmitterValue$2("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder$1;
	const ListComponent = useEmitterValue$2("ListComponent");
	const ItemComponent = useEmitterValue$2("ItemComponent");
	const GroupComponent = useEmitterValue$2("GroupComponent");
	const computeItemKey = useEmitterValue$2("computeItemKey");
	const isSeeking = useEmitterValue$2("isSeeking");
	const hasGroups2 = useEmitterValue$2("groupIndices").length > 0;
	const alignToBottom = useEmitterValue$2("alignToBottom");
	const initialItemFinalLocationReached = useEmitterValue$2("initialItemFinalLocationReached");
	const containerStyle = showTopList ? {} : {
		boxSizing: "border-box",
		...horizontalDirection ? {
			whiteSpace: "nowrap",
			display: "inline-block",
			height: "100%",
			paddingLeft: listState.offsetTop,
			paddingRight: listState.offsetBottom,
			marginLeft: deviation !== 0 ? deviation : alignToBottom ? "auto" : 0
		} : {
			marginTop: deviation !== 0 ? deviation : alignToBottom ? "auto" : 0,
			paddingTop: listState.offsetTop,
			paddingBottom: listState.offsetBottom
		},
		...initialItemFinalLocationReached ? {} : { visibility: "hidden" }
	};
	if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) return React.createElement(EmptyPlaceholder, contextPropIfNotDomElement(EmptyPlaceholder, context));
	return React.createElement(ListComponent, {
		...contextPropIfNotDomElement(ListComponent, context),
		ref: callbackRef,
		style: containerStyle,
		"data-testid": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list"
	}, (showTopList ? listState.topItems : listState.items).map((item) => {
		const index = item.originalIndex;
		const key = computeItemKey(index + listState.firstItemIndex, item.data, context);
		if (isSeeking) return React.createElement(ScrollSeekPlaceholder, {
			...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
			key,
			index: item.index,
			height: item.size,
			type: item.type || "item",
			...item.type === "group" ? {} : { groupIndex: item.groupIndex }
		});
		if (item.type === "group") return React.createElement(GroupComponent, {
			...contextPropIfNotDomElement(GroupComponent, context),
			key,
			"data-index": index,
			"data-known-size": item.size,
			"data-item-index": item.index,
			style: GROUP_STYLE
		}, groupContent(item.index, context));
		else return React.createElement(ItemComponent, {
			...contextPropIfNotDomElement(ItemComponent, context),
			...itemPropIfNotDomElement(ItemComponent, item.data),
			key,
			"data-index": index,
			"data-known-size": item.size,
			"data-item-index": item.index,
			"data-item-group-index": item.groupIndex,
			style: horizontalDirection ? HORIZONTAL_ITEM_STYLE : ITEM_STYLE$1
		}, hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context));
	}));
});
var scrollerStyle = {
	height: "100%",
	outline: "none",
	overflowY: "auto",
	position: "relative",
	WebkitOverflowScrolling: "touch"
};
var horizontalScrollerStyle = {
	outline: "none",
	overflowX: "auto",
	position: "relative"
};
var viewportStyle = (alignToBottom) => ({
	width: "100%",
	height: "100%",
	position: "absolute",
	top: 0,
	...alignToBottom ? {
		display: "flex",
		flexDirection: "column"
	} : {}
});
var topItemListStyle = {
	width: "100%",
	position: positionStickyCssValue(),
	top: 0,
	zIndex: 1
};
function contextPropIfNotDomElement(element, context) {
	if (typeof element === "string") return;
	return { context };
}
function itemPropIfNotDomElement(element, item) {
	return { item: typeof element === "string" ? void 0 : item };
}
var Header$1 = /* @__PURE__ */ React.memo(function VirtuosoHeader() {
	const Header2 = useEmitterValue$2("HeaderComponent");
	const headerHeight = usePublisher$2("headerHeight");
	const headerFooterTag = useEmitterValue$2("headerFooterTag");
	const ref = useSize(React.useMemo(() => (el) => headerHeight(correctItemSize(el, "height")), [headerHeight]), true, useEmitterValue$2("skipAnimationFrameInResizeObserver"));
	const context = useEmitterValue$2("context");
	return Header2 ? React.createElement(headerFooterTag, { ref }, React.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
var Footer$1 = /* @__PURE__ */ React.memo(function VirtuosoFooter() {
	const Footer2 = useEmitterValue$2("FooterComponent");
	const footerHeight = usePublisher$2("footerHeight");
	const headerFooterTag = useEmitterValue$2("headerFooterTag");
	const ref = useSize(React.useMemo(() => (el) => footerHeight(correctItemSize(el, "height")), [footerHeight]), true, useEmitterValue$2("skipAnimationFrameInResizeObserver"));
	const context = useEmitterValue$2("context");
	return Footer2 ? React.createElement(headerFooterTag, { ref }, React.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
function buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
	return React.memo(function VirtuosoScroller({ style, children, ...props }) {
		const scrollContainerStateCallback = usePublisher2("scrollContainerState");
		const ScrollerComponent = useEmitterValue2("ScrollerComponent");
		const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
		const scrollerRefCallback = useEmitterValue2("scrollerRef");
		const context = useEmitterValue2("context");
		const horizontalDirection = useEmitterValue2("horizontalDirection") || false;
		const { scrollerRef, scrollByCallback, scrollToCallback } = useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, scrollerRefCallback, void 0, horizontalDirection);
		useEmitter2("scrollTo", scrollToCallback);
		useEmitter2("scrollBy", scrollByCallback);
		const defaultStyle = horizontalDirection ? horizontalScrollerStyle : scrollerStyle;
		return React.createElement(ScrollerComponent, {
			ref: scrollerRef,
			style: {
				...defaultStyle,
				...style
			},
			"data-testid": "virtuoso-scroller",
			"data-virtuoso-scroller": true,
			tabIndex: 0,
			...props,
			...contextPropIfNotDomElement(ScrollerComponent, context)
		}, children);
	});
}
function buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
	return React.memo(function VirtuosoWindowScroller({ style, children, ...props }) {
		const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
		const ScrollerComponent = useEmitterValue2("ScrollerComponent");
		const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
		const totalListHeight = useEmitterValue2("totalListHeight");
		const deviation = useEmitterValue2("deviation");
		const customScrollParent = useEmitterValue2("customScrollParent");
		const context = useEmitterValue2("context");
		const { scrollerRef, scrollByCallback, scrollToCallback } = useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, noop$2, customScrollParent);
		useIsomorphicLayoutEffect$1(() => {
			scrollerRef.current = customScrollParent ? customScrollParent : window;
			return () => {
				scrollerRef.current = null;
			};
		}, [scrollerRef, customScrollParent]);
		useEmitter2("windowScrollTo", scrollToCallback);
		useEmitter2("scrollBy", scrollByCallback);
		return React.createElement(ScrollerComponent, {
			style: {
				position: "relative",
				...style,
				...totalListHeight !== 0 ? { height: totalListHeight + deviation } : {}
			},
			"data-virtuoso-scroller": true,
			...props,
			...contextPropIfNotDomElement(ScrollerComponent, context)
		}, children);
	});
}
var Viewport$2 = ({ children }) => {
	const ctx = React.useContext(VirtuosoMockContext);
	const viewportHeight = usePublisher$2("viewportHeight");
	const fixedItemHeight = usePublisher$2("fixedItemHeight");
	const alignToBottom = useEmitterValue$2("alignToBottom");
	const horizontalDirection = useEmitterValue$2("horizontalDirection");
	const viewportRef = useSize(React.useMemo(() => compose(viewportHeight, (el) => correctItemSize(el, horizontalDirection ? "width" : "height")), [viewportHeight, horizontalDirection]), true, useEmitterValue$2("skipAnimationFrameInResizeObserver"));
	React.useEffect(() => {
		if (ctx) {
			viewportHeight(ctx.viewportHeight);
			fixedItemHeight(ctx.itemHeight);
		}
	}, [
		ctx,
		viewportHeight,
		fixedItemHeight
	]);
	return /* @__PURE__ */ React.createElement("div", {
		style: viewportStyle(alignToBottom),
		ref: viewportRef,
		"data-viewport-type": "element"
	}, children);
};
var WindowViewport$2 = ({ children }) => {
	const ctx = React.useContext(VirtuosoMockContext);
	const windowViewportRect = usePublisher$2("windowViewportRect");
	const fixedItemHeight = usePublisher$2("fixedItemHeight");
	const viewportRef = useWindowViewportRectRef(windowViewportRect, useEmitterValue$2("customScrollParent"), useEmitterValue$2("skipAnimationFrameInResizeObserver"));
	const alignToBottom = useEmitterValue$2("alignToBottom");
	React.useEffect(() => {
		if (ctx) {
			fixedItemHeight(ctx.itemHeight);
			windowViewportRect({
				offsetTop: 0,
				visibleHeight: ctx.viewportHeight,
				visibleWidth: 100
			});
		}
	}, [
		ctx,
		windowViewportRect,
		fixedItemHeight
	]);
	return /* @__PURE__ */ React.createElement("div", {
		ref: viewportRef,
		style: viewportStyle(alignToBottom),
		"data-viewport-type": "window"
	}, children);
};
var TopItemListContainer = ({ children }) => {
	const TopItemList = useEmitterValue$2("TopItemListComponent") || "div";
	const headerHeight = useEmitterValue$2("headerHeight");
	const style = {
		...topItemListStyle,
		marginTop: `${headerHeight}px`
	};
	const context = useEmitterValue$2("context");
	return React.createElement(TopItemList, {
		style,
		...contextPropIfNotDomElement(TopItemList, context)
	}, children);
};
var { Component: List, usePublisher: usePublisher$2, useEmitterValue: useEmitterValue$2, useEmitter: useEmitter$2 } = /* @__PURE__ */ systemToComponent(combinedSystem$2, {
	required: {},
	optional: {
		restoreStateFrom: "restoreStateFrom",
		context: "context",
		followOutput: "followOutput",
		itemContent: "itemContent",
		groupContent: "groupContent",
		overscan: "overscan",
		increaseViewportBy: "increaseViewportBy",
		totalCount: "totalCount",
		groupCounts: "groupCounts",
		topItemCount: "topItemCount",
		firstItemIndex: "firstItemIndex",
		initialTopMostItemIndex: "initialTopMostItemIndex",
		components: "components",
		atBottomThreshold: "atBottomThreshold",
		atTopThreshold: "atTopThreshold",
		computeItemKey: "computeItemKey",
		defaultItemHeight: "defaultItemHeight",
		fixedItemHeight: "fixedItemHeight",
		itemSize: "itemSize",
		scrollSeekConfiguration: "scrollSeekConfiguration",
		headerFooterTag: "headerFooterTag",
		data: "data",
		initialItemCount: "initialItemCount",
		initialScrollTop: "initialScrollTop",
		alignToBottom: "alignToBottom",
		useWindowScroll: "useWindowScroll",
		customScrollParent: "customScrollParent",
		scrollerRef: "scrollerRef",
		logLevel: "logLevel",
		horizontalDirection: "horizontalDirection",
		skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver"
	},
	methods: {
		scrollToIndex: "scrollToIndex",
		scrollIntoView: "scrollIntoView",
		scrollTo: "scrollTo",
		scrollBy: "scrollBy",
		autoscrollToBottom: "autoscrollToBottom",
		getState: "getState"
	},
	events: {
		isScrolling: "isScrolling",
		endReached: "endReached",
		startReached: "startReached",
		rangeChanged: "rangeChanged",
		atBottomStateChange: "atBottomStateChange",
		atTopStateChange: "atTopStateChange",
		totalListHeightChanged: "totalListHeightChanged",
		itemsRendered: "itemsRendered",
		groupIndices: "groupIndices"
	}
}, /* @__PURE__ */ React.memo(function VirtuosoRoot(props) {
	const useWindowScroll = useEmitterValue$2("useWindowScroll");
	const showTopList = useEmitterValue$2("topItemsIndexes").length > 0;
	const customScrollParent = useEmitterValue$2("customScrollParent");
	const TheScroller = customScrollParent || useWindowScroll ? WindowScroller$2 : Scroller$2;
	const TheViewport = customScrollParent || useWindowScroll ? WindowViewport$2 : Viewport$2;
	return /* @__PURE__ */ React.createElement(TheScroller, { ...props }, showTopList && /* @__PURE__ */ React.createElement(TopItemListContainer, null, /* @__PURE__ */ React.createElement(Items$1, { showTopList: true })), /* @__PURE__ */ React.createElement(TheViewport, null, /* @__PURE__ */ React.createElement(Header$1, null), /* @__PURE__ */ React.createElement(Items$1, null), /* @__PURE__ */ React.createElement(Footer$1, null)));
}));
var Scroller$2 = /* @__PURE__ */ buildScroller({
	usePublisher: usePublisher$2,
	useEmitterValue: useEmitterValue$2,
	useEmitter: useEmitter$2
});
var WindowScroller$2 = /* @__PURE__ */ buildWindowScroller({
	usePublisher: usePublisher$2,
	useEmitterValue: useEmitterValue$2,
	useEmitter: useEmitter$2
});
var GroupedVirtuoso = List;
var INITIAL_GRID_STATE = {
	items: [],
	offsetBottom: 0,
	offsetTop: 0,
	top: 0,
	bottom: 0,
	itemHeight: 0,
	itemWidth: 0
};
var PROBE_GRID_STATE = {
	items: [{ index: 0 }],
	offsetBottom: 0,
	offsetTop: 0,
	top: 0,
	bottom: 0,
	itemHeight: 0,
	itemWidth: 0
};
var { round, ceil, floor, min, max } = Math;
function buildProbeGridState(items) {
	return {
		...PROBE_GRID_STATE,
		items
	};
}
function buildItems(startIndex, endIndex, data) {
	return Array.from({ length: endIndex - startIndex + 1 }).map((_, i) => {
		const dataItem = data === null ? null : data[i + startIndex];
		return {
			index: i + startIndex,
			data: dataItem
		};
	});
}
function gapComparator(prev, next) {
	return prev && prev.column === next.column && prev.row === next.row;
}
function dimensionComparator(prev, next) {
	return prev && prev.width === next.width && prev.height === next.height;
}
var gridSystem = /* @__PURE__ */ system(([{ overscan, visibleRange, listBoundary }, { scrollTop, viewportHeight, scrollBy, scrollTo, smoothScrollTargetReached, scrollContainerState, footerHeight, headerHeight }, stateFlags, scrollSeek, { propsReady, didMount }, { windowViewportRect, useWindowScroll, customScrollParent, windowScrollContainerState, windowScrollTo }, log]) => {
	const totalCount = statefulStream(0);
	const initialItemCount = statefulStream(0);
	const gridState = statefulStream(INITIAL_GRID_STATE);
	const viewportDimensions = statefulStream({
		height: 0,
		width: 0
	});
	const itemDimensions = statefulStream({
		height: 0,
		width: 0
	});
	const scrollToIndex = stream();
	const scrollHeight = stream();
	const deviation = statefulStream(0);
	const data = statefulStream(null);
	const gap = statefulStream({
		row: 0,
		column: 0
	});
	const stateChanged = stream();
	const restoreStateFrom = stream();
	const stateRestoreInProgress = statefulStream(false);
	const initialTopMostItemIndex = statefulStream(0);
	const scrolledToInitialItem = statefulStream(true);
	const scrollScheduled = statefulStream(false);
	const horizontalDirection = statefulStream(false);
	subscribe(pipe$1(didMount, withLatestFrom(initialTopMostItemIndex), filter(([_, location]) => !!location)), () => {
		publish(scrolledToInitialItem, false);
		publish(initialItemCount, 0);
	});
	subscribe(pipe$1(combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled), filter(([didMount2, scrolledToInitialItem2, itemDimensions2, viewportDimensions2, , scrollScheduled2]) => {
		return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
	})), ([, , , , initialTopMostItemIndex2]) => {
		publish(scrollScheduled, true);
		skipFrames(1, () => {
			publish(scrollToIndex, initialTopMostItemIndex2);
		});
		handleNext(pipe$1(scrollTop), () => {
			publish(listBoundary, [0, 0]);
			publish(scrolledToInitialItem, true);
		});
	});
	connect(pipe$1(restoreStateFrom, filter((value) => value !== void 0 && value !== null && value.scrollTop > 0), mapTo(0)), initialItemCount);
	subscribe(pipe$1(didMount, withLatestFrom(restoreStateFrom), filter(([, snapshot]) => snapshot !== void 0 && snapshot !== null)), ([, snapshot]) => {
		if (!snapshot) return;
		publish(viewportDimensions, snapshot.viewport), publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
		publish(gap, snapshot.gap);
		if (snapshot.scrollTop > 0) {
			publish(stateRestoreInProgress, true);
			handleNext(pipe$1(scrollTop, skip(1)), (_value) => {
				publish(stateRestoreInProgress, false);
			});
			publish(scrollTo, { top: snapshot.scrollTop });
		}
	});
	connect(pipe$1(viewportDimensions, map$2(({ height }) => height)), viewportHeight);
	connect(pipe$1(combineLatest(duc(viewportDimensions, dimensionComparator), duc(itemDimensions, dimensionComparator), duc(gap, (prev, next) => prev && prev.column === next.column && prev.row === next.row), duc(scrollTop)), map$2(([viewport, item, gap2, scrollTop2]) => ({
		viewport,
		item,
		gap: gap2,
		scrollTop: scrollTop2
	}))), stateChanged);
	connect(pipe$1(combineLatest(duc(totalCount), visibleRange, duc(gap, gapComparator), duc(itemDimensions, dimensionComparator), duc(viewportDimensions, dimensionComparator), duc(data), duc(initialItemCount), duc(stateRestoreInProgress), duc(scrolledToInitialItem), duc(initialTopMostItemIndex)), filter(([, , , , , , , stateRestoreInProgress2]) => {
		return !stateRestoreInProgress2;
	}), map$2(([totalCount2, [startOffset, endOffset], gap2, item, viewport, data2, initialItemCount2, , scrolledToInitialItem2, initialTopMostItemIndex2]) => {
		const { row: rowGap, column: columnGap } = gap2;
		const { height: itemHeight, width: itemWidth } = item;
		const { width: viewportWidth } = viewport;
		if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) return INITIAL_GRID_STATE;
		if (itemWidth === 0) {
			const startIndex2 = getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
			return buildProbeGridState(buildItems(startIndex2, startIndex2 === 0 ? Math.max(initialItemCount2 - 1, 0) : startIndex2, data2));
		}
		const perRow = itemsPerRow(viewportWidth, itemWidth, columnGap);
		let startIndex;
		let endIndex;
		if (!scrolledToInitialItem2) {
			startIndex = 0;
			endIndex = -1;
		} else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
			startIndex = 0;
			endIndex = initialItemCount2 - 1;
		} else {
			startIndex = perRow * floor((startOffset + rowGap) / (itemHeight + rowGap));
			endIndex = perRow * ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
			endIndex = min(totalCount2 - 1, max(endIndex, perRow - 1));
			startIndex = min(endIndex, max(0, startIndex));
		}
		const items = buildItems(startIndex, endIndex, data2);
		const { top, bottom } = gridLayout(viewport, gap2, item, items);
		const rowCount = ceil(totalCount2 / perRow);
		return {
			items,
			offsetTop: top,
			offsetBottom: rowCount * itemHeight + (rowCount - 1) * rowGap - bottom,
			top,
			bottom,
			itemHeight,
			itemWidth
		};
	})), gridState);
	connect(pipe$1(data, filter((data2) => data2 !== null), map$2((data2) => data2.length)), totalCount);
	connect(pipe$1(combineLatest(viewportDimensions, itemDimensions, gridState, gap), filter(([viewportDimensions2, itemDimensions2, { items }]) => {
		return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
	}), map$2(([viewportDimensions2, itemDimensions2, { items }, gap2]) => {
		const { top, bottom } = gridLayout(viewportDimensions2, gap2, itemDimensions2, items);
		return [top, bottom];
	}), distinctUntilChanged(tupleComparator)), listBoundary);
	const hasScrolled = statefulStream(false);
	connect(pipe$1(scrollTop, withLatestFrom(hasScrolled), map$2(([scrollTop2, hasScrolled2]) => {
		return hasScrolled2 || scrollTop2 !== 0;
	})), hasScrolled);
	const endReached = streamFromEmitter(pipe$1(duc(gridState), filter(({ items }) => items.length > 0), withLatestFrom(totalCount, hasScrolled), filter(([{ items }, totalCount2, hasScrolled2]) => hasScrolled2 && items[items.length - 1].index === totalCount2 - 1), map$2(([, totalCount2]) => totalCount2 - 1), distinctUntilChanged()));
	const startReached = streamFromEmitter(pipe$1(duc(gridState), filter(({ items }) => {
		return items.length > 0 && items[0].index === 0;
	}), mapTo(0), distinctUntilChanged()));
	const rangeChanged = streamFromEmitter(pipe$1(duc(gridState), withLatestFrom(stateRestoreInProgress), filter(([{ items }, stateRestoreInProgress2]) => items.length > 0 && !stateRestoreInProgress2), map$2(([{ items }]) => {
		return {
			startIndex: items[0].index,
			endIndex: items[items.length - 1].index
		};
	}), distinctUntilChanged(rangeComparator), throttleTime(0)));
	connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
	connect(pipe$1(scrollToIndex, withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap), map$2(([location, viewportDimensions2, itemDimensions2, totalCount2, gap2]) => {
		const normalLocation = normalizeIndexLocation(location);
		const { align, behavior, offset } = normalLocation;
		let index = normalLocation.index;
		if (index === "LAST") index = totalCount2 - 1;
		index = max(0, index, min(totalCount2 - 1, index));
		let top = itemTop(viewportDimensions2, gap2, itemDimensions2, index);
		if (align === "end") top = round(top - viewportDimensions2.height + itemDimensions2.height);
		else if (align === "center") top = round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
		if (offset) top += offset;
		return {
			top,
			behavior
		};
	})), scrollTo);
	const totalListHeight = statefulStreamFromEmitter(pipe$1(gridState, map$2((gridState2) => {
		return gridState2.offsetBottom + gridState2.bottom;
	})), 0);
	connect(pipe$1(windowViewportRect, map$2((viewportInfo) => ({
		width: viewportInfo.visibleWidth,
		height: viewportInfo.visibleHeight
	}))), viewportDimensions);
	return {
		data,
		totalCount,
		viewportDimensions,
		itemDimensions,
		scrollTop,
		scrollHeight,
		overscan,
		scrollBy,
		scrollTo,
		scrollToIndex,
		smoothScrollTargetReached,
		windowViewportRect,
		windowScrollTo,
		useWindowScroll,
		customScrollParent,
		windowScrollContainerState,
		deviation,
		scrollContainerState,
		footerHeight,
		headerHeight,
		initialItemCount,
		gap,
		restoreStateFrom,
		...scrollSeek,
		initialTopMostItemIndex,
		horizontalDirection,
		gridState,
		totalListHeight,
		...stateFlags,
		startReached,
		endReached,
		rangeChanged,
		stateChanged,
		propsReady,
		stateRestoreInProgress,
		...log
	};
}, tup(sizeRangeSystem, domIOSystem, stateFlagsSystem, scrollSeekSystem, propsReadySystem, windowScrollerSystem, loggerSystem));
function gridLayout(viewport, gap, item, items) {
	const { height: itemHeight } = item;
	if (itemHeight === void 0 || items.length === 0) return {
		top: 0,
		bottom: 0
	};
	return {
		top: itemTop(viewport, gap, item, items[0].index),
		bottom: itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight
	};
}
function itemTop(viewport, gap, item, index) {
	const rowCount = floor(index / itemsPerRow(viewport.width, item.width, gap.column));
	const top = rowCount * item.height + max(0, rowCount - 1) * gap.row;
	return top > 0 ? top + gap.row : top;
}
function itemsPerRow(viewportWidth, itemWidth, gap) {
	return max(1, floor((viewportWidth + gap) / (floor(itemWidth) + gap)));
}
var combinedSystem$1 = /* @__PURE__ */ system(([gridSystem2, gridComponentPropsSystem2]) => {
	return {
		...gridSystem2,
		...gridComponentPropsSystem2
	};
}, tup(gridSystem, /* @__PURE__ */ system(() => {
	const itemContent = statefulStream((index) => `Item ${index}`);
	const components = statefulStream({});
	const context = statefulStream(null);
	const itemClassName = statefulStream("virtuoso-grid-item");
	const listClassName = statefulStream("virtuoso-grid-list");
	const computeItemKey = statefulStream(identity$1);
	const headerFooterTag = statefulStream("div");
	const scrollerRef = statefulStream(noop$2);
	const distinctProp = (propName, defaultValue = null) => {
		return statefulStreamFromEmitter(pipe$1(components, map$2((components2) => components2[propName]), distinctUntilChanged()), defaultValue);
	};
	return {
		context,
		itemContent,
		components,
		computeItemKey,
		itemClassName,
		listClassName,
		headerFooterTag,
		scrollerRef,
		FooterComponent: distinctProp("Footer"),
		HeaderComponent: distinctProp("Header"),
		ListComponent: distinctProp("List", "div"),
		ItemComponent: distinctProp("Item", "div"),
		ScrollerComponent: distinctProp("Scroller", "div"),
		ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
	};
})));
var GridItems = /* @__PURE__ */ React.memo(function GridItems2() {
	const gridState = useEmitterValue$1("gridState");
	const listClassName = useEmitterValue$1("listClassName");
	const itemClassName = useEmitterValue$1("itemClassName");
	const itemContent = useEmitterValue$1("itemContent");
	const computeItemKey = useEmitterValue$1("computeItemKey");
	const isSeeking = useEmitterValue$1("isSeeking");
	const scrollHeightCallback = usePublisher$1("scrollHeight");
	const ItemComponent = useEmitterValue$1("ItemComponent");
	const ListComponent = useEmitterValue$1("ListComponent");
	const ScrollSeekPlaceholder = useEmitterValue$1("ScrollSeekPlaceholder");
	const context = useEmitterValue$1("context");
	const itemDimensions = usePublisher$1("itemDimensions");
	const gridGap = usePublisher$1("gap");
	const log = useEmitterValue$1("log");
	const stateRestoreInProgress = useEmitterValue$1("stateRestoreInProgress");
	const listRef = useSize(React.useMemo(() => (el) => {
		const scrollHeight = el.parentElement.parentElement.scrollHeight;
		scrollHeightCallback(scrollHeight);
		const firstItem = el.firstChild;
		if (firstItem) {
			const { width, height } = firstItem.getBoundingClientRect();
			itemDimensions({
				width,
				height
			});
		}
		gridGap({
			row: resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
			column: resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
		});
	}, [
		scrollHeightCallback,
		itemDimensions,
		gridGap,
		log
	]), true, false);
	if (stateRestoreInProgress) return null;
	return React.createElement(ListComponent, {
		ref: listRef,
		className: listClassName,
		...contextPropIfNotDomElement(ListComponent, context),
		style: {
			paddingTop: gridState.offsetTop,
			paddingBottom: gridState.offsetBottom
		},
		"data-testid": "virtuoso-item-list"
	}, gridState.items.map((item) => {
		const key = computeItemKey(item.index, item.data, context);
		return isSeeking ? React.createElement(ScrollSeekPlaceholder, {
			key,
			...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
			index: item.index,
			height: gridState.itemHeight,
			width: gridState.itemWidth
		}) : React.createElement(ItemComponent, {
			...contextPropIfNotDomElement(ItemComponent, context),
			className: itemClassName,
			"data-index": item.index,
			key
		}, itemContent(item.index, item.data, context));
	}));
});
var Header$2 = React.memo(function VirtuosoHeader2() {
	const Header2 = useEmitterValue$1("HeaderComponent");
	const headerHeight = usePublisher$1("headerHeight");
	const headerFooterTag = useEmitterValue$1("headerFooterTag");
	const ref = useSize(React.useMemo(() => (el) => headerHeight(correctItemSize(el, "height")), [headerHeight]), true, false);
	const context = useEmitterValue$1("context");
	return Header2 ? React.createElement(headerFooterTag, { ref }, React.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
var Footer = React.memo(function VirtuosoGridFooter() {
	const Footer2 = useEmitterValue$1("FooterComponent");
	const footerHeight = usePublisher$1("footerHeight");
	const headerFooterTag = useEmitterValue$1("headerFooterTag");
	const ref = useSize(React.useMemo(() => (el) => footerHeight(correctItemSize(el, "height")), [footerHeight]), true, false);
	const context = useEmitterValue$1("context");
	return Footer2 ? React.createElement(headerFooterTag, { ref }, React.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
var Viewport$1 = ({ children }) => {
	const ctx = React.useContext(VirtuosoGridMockContext);
	const itemDimensions = usePublisher$1("itemDimensions");
	const viewportDimensions = usePublisher$1("viewportDimensions");
	const viewportRef = useSize(React.useMemo(() => (el) => {
		viewportDimensions(el.getBoundingClientRect());
	}, [viewportDimensions]), true, false);
	React.useEffect(() => {
		if (ctx) {
			viewportDimensions({
				height: ctx.viewportHeight,
				width: ctx.viewportWidth
			});
			itemDimensions({
				height: ctx.itemHeight,
				width: ctx.itemWidth
			});
		}
	}, [
		ctx,
		viewportDimensions,
		itemDimensions
	]);
	return /* @__PURE__ */ React.createElement("div", {
		style: viewportStyle(false),
		ref: viewportRef
	}, children);
};
var WindowViewport$1 = ({ children }) => {
	const ctx = React.useContext(VirtuosoGridMockContext);
	const windowViewportRect = usePublisher$1("windowViewportRect");
	const itemDimensions = usePublisher$1("itemDimensions");
	const viewportRef = useWindowViewportRectRef(windowViewportRect, useEmitterValue$1("customScrollParent"), false);
	React.useEffect(() => {
		if (ctx) {
			itemDimensions({
				height: ctx.itemHeight,
				width: ctx.itemWidth
			});
			windowViewportRect({
				offsetTop: 0,
				visibleHeight: ctx.viewportHeight,
				visibleWidth: ctx.viewportWidth
			});
		}
	}, [
		ctx,
		windowViewportRect,
		itemDimensions
	]);
	return /* @__PURE__ */ React.createElement("div", {
		ref: viewportRef,
		style: viewportStyle(false)
	}, children);
};
var { Component: Grid$1, usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 } = /* @__PURE__ */ systemToComponent(combinedSystem$1, {
	optional: {
		context: "context",
		totalCount: "totalCount",
		overscan: "overscan",
		itemContent: "itemContent",
		components: "components",
		computeItemKey: "computeItemKey",
		data: "data",
		initialItemCount: "initialItemCount",
		scrollSeekConfiguration: "scrollSeekConfiguration",
		headerFooterTag: "headerFooterTag",
		listClassName: "listClassName",
		itemClassName: "itemClassName",
		useWindowScroll: "useWindowScroll",
		customScrollParent: "customScrollParent",
		scrollerRef: "scrollerRef",
		logLevel: "logLevel",
		restoreStateFrom: "restoreStateFrom",
		initialTopMostItemIndex: "initialTopMostItemIndex"
	},
	methods: {
		scrollTo: "scrollTo",
		scrollBy: "scrollBy",
		scrollToIndex: "scrollToIndex"
	},
	events: {
		isScrolling: "isScrolling",
		endReached: "endReached",
		startReached: "startReached",
		rangeChanged: "rangeChanged",
		atBottomStateChange: "atBottomStateChange",
		atTopStateChange: "atTopStateChange",
		stateChanged: "stateChanged"
	}
}, /* @__PURE__ */ React.memo(function GridRoot2({ ...props }) {
	const useWindowScroll = useEmitterValue$1("useWindowScroll");
	const customScrollParent = useEmitterValue$1("customScrollParent");
	const TheScroller = customScrollParent || useWindowScroll ? WindowScroller$1 : Scroller$1;
	const TheViewport = customScrollParent || useWindowScroll ? WindowViewport$1 : Viewport$1;
	return /* @__PURE__ */ React.createElement(TheScroller, { ...props }, /* @__PURE__ */ React.createElement(TheViewport, null, /* @__PURE__ */ React.createElement(Header$2, null), /* @__PURE__ */ React.createElement(GridItems, null), /* @__PURE__ */ React.createElement(Footer, null)));
}));
var Scroller$1 = /* @__PURE__ */ buildScroller({
	usePublisher: usePublisher$1,
	useEmitterValue: useEmitterValue$1,
	useEmitter: useEmitter$1
});
var WindowScroller$1 = /* @__PURE__ */ buildWindowScroller({
	usePublisher: usePublisher$1,
	useEmitterValue: useEmitterValue$1,
	useEmitter: useEmitter$1
});
function resolveGapValue(property, value, log) {
	if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, LogLevel.WARN);
	if (value === "normal") return 0;
	return parseInt(value != null ? value : "0", 10);
}
var combinedSystem = /* @__PURE__ */ system(([listSystem2, propsSystem]) => {
	return {
		...listSystem2,
		...propsSystem
	};
}, tup(listSystem, /* @__PURE__ */ system(() => {
	const itemContent = statefulStream((index) => /* @__PURE__ */ React.createElement("td", null, "Item $", index));
	const context = statefulStream(null);
	const fixedHeaderContent = statefulStream(null);
	const fixedFooterContent = statefulStream(null);
	const components = statefulStream({});
	const computeItemKey = statefulStream(identity$1);
	const scrollerRef = statefulStream(noop$2);
	const distinctProp = (propName, defaultValue = null) => {
		return statefulStreamFromEmitter(pipe$1(components, map$2((components2) => components2[propName]), distinctUntilChanged()), defaultValue);
	};
	return {
		context,
		itemContent,
		fixedHeaderContent,
		fixedFooterContent,
		components,
		computeItemKey,
		scrollerRef,
		TableComponent: distinctProp("Table", "table"),
		TableHeadComponent: distinctProp("TableHead", "thead"),
		TableFooterComponent: distinctProp("TableFoot", "tfoot"),
		TableBodyComponent: distinctProp("TableBody", "tbody"),
		TableRowComponent: distinctProp("TableRow", "tr"),
		ScrollerComponent: distinctProp("Scroller", "div"),
		EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
		ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
		FillerRow: distinctProp("FillerRow")
	};
})));
var DefaultScrollSeekPlaceholder = ({ height }) => /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { style: { height } }));
var DefaultFillerRow = ({ height }) => /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { style: {
	height,
	padding: 0,
	border: 0
} }));
var ITEM_STYLE = { overflowAnchor: "none" };
var Items = /* @__PURE__ */ React.memo(function VirtuosoItems2() {
	const listState = useEmitterValue("listState");
	const sizeRanges = usePublisher("sizeRanges");
	const useWindowScroll = useEmitterValue("useWindowScroll");
	const customScrollParent = useEmitterValue("customScrollParent");
	const windowScrollContainerStateCallback = usePublisher("windowScrollContainerState");
	const _scrollContainerStateCallback = usePublisher("scrollContainerState");
	const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
	const itemContent = useEmitterValue("itemContent");
	const trackItemSizes = useEmitterValue("trackItemSizes");
	const { callbackRef, ref } = useChangedListContentsSizes(sizeRanges, useEmitterValue("itemSize"), trackItemSizes, scrollContainerStateCallback, useEmitterValue("log"), void 0, customScrollParent, false, useEmitterValue("skipAnimationFrameInResizeObserver"));
	const [deviation, setDeviation] = React.useState(0);
	useEmitter("deviation", (value) => {
		if (deviation !== value) {
			ref.current.style.marginTop = `${value}px`;
			setDeviation(value);
		}
	});
	const EmptyPlaceholder = useEmitterValue("EmptyPlaceholder");
	const ScrollSeekPlaceholder = useEmitterValue("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder;
	const FillerRow = useEmitterValue("FillerRow") || DefaultFillerRow;
	const TableBodyComponent = useEmitterValue("TableBodyComponent");
	const TableRowComponent = useEmitterValue("TableRowComponent");
	const computeItemKey = useEmitterValue("computeItemKey");
	const isSeeking = useEmitterValue("isSeeking");
	const paddingTopAddition = useEmitterValue("paddingTopAddition");
	const firstItemIndex = useEmitterValue("firstItemIndex");
	const statefulTotalCount = useEmitterValue("statefulTotalCount");
	const context = useEmitterValue("context");
	if (statefulTotalCount === 0 && EmptyPlaceholder) return React.createElement(EmptyPlaceholder, contextPropIfNotDomElement(EmptyPlaceholder, context));
	const paddingTop = listState.offsetTop + paddingTopAddition + deviation;
	const paddingBottom = listState.offsetBottom;
	const paddingTopEl = paddingTop > 0 ? /* @__PURE__ */ React.createElement(FillerRow, {
		height: paddingTop,
		key: "padding-top",
		context
	}) : null;
	const paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */ React.createElement(FillerRow, {
		height: paddingBottom,
		key: "padding-bottom",
		context
	}) : null;
	const items = listState.items.map((item) => {
		const index = item.originalIndex;
		const key = computeItemKey(index + firstItemIndex, item.data, context);
		if (isSeeking) return React.createElement(ScrollSeekPlaceholder, {
			...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
			key,
			index: item.index,
			height: item.size,
			type: item.type || "item"
		});
		return React.createElement(TableRowComponent, {
			...contextPropIfNotDomElement(TableRowComponent, context),
			...itemPropIfNotDomElement(TableRowComponent, item.data),
			key,
			"data-index": index,
			"data-known-size": item.size,
			"data-item-index": item.index,
			style: ITEM_STYLE
		}, itemContent(item.index, item.data, context));
	});
	return React.createElement(TableBodyComponent, {
		ref: callbackRef,
		"data-testid": "virtuoso-item-list",
		...contextPropIfNotDomElement(TableBodyComponent, context)
	}, [
		paddingTopEl,
		...items,
		paddingBottomEl
	]);
});
var Viewport = ({ children }) => {
	const ctx = React.useContext(VirtuosoMockContext);
	const viewportHeight = usePublisher("viewportHeight");
	const fixedItemHeight = usePublisher("fixedItemHeight");
	const viewportRef = useSize(React.useMemo(() => compose(viewportHeight, (el) => correctItemSize(el, "height")), [viewportHeight]), true, useEmitterValue("skipAnimationFrameInResizeObserver"));
	React.useEffect(() => {
		if (ctx) {
			viewportHeight(ctx.viewportHeight);
			fixedItemHeight(ctx.itemHeight);
		}
	}, [
		ctx,
		viewportHeight,
		fixedItemHeight
	]);
	return /* @__PURE__ */ React.createElement("div", {
		style: viewportStyle(false),
		ref: viewportRef,
		"data-viewport-type": "element"
	}, children);
};
var WindowViewport = ({ children }) => {
	const ctx = React.useContext(VirtuosoMockContext);
	const windowViewportRect = usePublisher("windowViewportRect");
	const fixedItemHeight = usePublisher("fixedItemHeight");
	const viewportRef = useWindowViewportRectRef(windowViewportRect, useEmitterValue("customScrollParent"), useEmitterValue("skipAnimationFrameInResizeObserver"));
	React.useEffect(() => {
		if (ctx) {
			fixedItemHeight(ctx.itemHeight);
			windowViewportRect({
				offsetTop: 0,
				visibleHeight: ctx.viewportHeight,
				visibleWidth: 100
			});
		}
	}, [
		ctx,
		windowViewportRect,
		fixedItemHeight
	]);
	return /* @__PURE__ */ React.createElement("div", {
		ref: viewportRef,
		style: viewportStyle(false),
		"data-viewport-type": "window"
	}, children);
};
var { Component: Table$1, usePublisher, useEmitterValue, useEmitter } = /* @__PURE__ */ systemToComponent(combinedSystem, {
	required: {},
	optional: {
		restoreStateFrom: "restoreStateFrom",
		context: "context",
		followOutput: "followOutput",
		firstItemIndex: "firstItemIndex",
		itemContent: "itemContent",
		fixedHeaderContent: "fixedHeaderContent",
		fixedFooterContent: "fixedFooterContent",
		overscan: "overscan",
		increaseViewportBy: "increaseViewportBy",
		totalCount: "totalCount",
		topItemCount: "topItemCount",
		initialTopMostItemIndex: "initialTopMostItemIndex",
		components: "components",
		groupCounts: "groupCounts",
		atBottomThreshold: "atBottomThreshold",
		atTopThreshold: "atTopThreshold",
		computeItemKey: "computeItemKey",
		defaultItemHeight: "defaultItemHeight",
		fixedItemHeight: "fixedItemHeight",
		itemSize: "itemSize",
		scrollSeekConfiguration: "scrollSeekConfiguration",
		data: "data",
		initialItemCount: "initialItemCount",
		initialScrollTop: "initialScrollTop",
		alignToBottom: "alignToBottom",
		useWindowScroll: "useWindowScroll",
		customScrollParent: "customScrollParent",
		scrollerRef: "scrollerRef",
		logLevel: "logLevel"
	},
	methods: {
		scrollToIndex: "scrollToIndex",
		scrollIntoView: "scrollIntoView",
		scrollTo: "scrollTo",
		scrollBy: "scrollBy",
		getState: "getState"
	},
	events: {
		isScrolling: "isScrolling",
		endReached: "endReached",
		startReached: "startReached",
		rangeChanged: "rangeChanged",
		atBottomStateChange: "atBottomStateChange",
		atTopStateChange: "atTopStateChange",
		totalListHeightChanged: "totalListHeightChanged",
		itemsRendered: "itemsRendered",
		groupIndices: "groupIndices"
	}
}, /* @__PURE__ */ React.memo(function TableVirtuosoRoot(props) {
	const useWindowScroll = useEmitterValue("useWindowScroll");
	const customScrollParent = useEmitterValue("customScrollParent");
	const fixedHeaderHeight = usePublisher("fixedHeaderHeight");
	const fixedFooterHeight = usePublisher("fixedFooterHeight");
	const fixedHeaderContent = useEmitterValue("fixedHeaderContent");
	const fixedFooterContent = useEmitterValue("fixedFooterContent");
	const context = useEmitterValue("context");
	const theadRef = useSize(React.useMemo(() => compose(fixedHeaderHeight, (el) => correctItemSize(el, "height")), [fixedHeaderHeight]), true, useEmitterValue("skipAnimationFrameInResizeObserver"));
	const tfootRef = useSize(React.useMemo(() => compose(fixedFooterHeight, (el) => correctItemSize(el, "height")), [fixedFooterHeight]), true, useEmitterValue("skipAnimationFrameInResizeObserver"));
	const TheScroller = customScrollParent || useWindowScroll ? WindowScroller : Scroller;
	const TheViewport = customScrollParent || useWindowScroll ? WindowViewport : Viewport;
	const TheTable = useEmitterValue("TableComponent");
	const TheTHead = useEmitterValue("TableHeadComponent");
	const TheTFoot = useEmitterValue("TableFooterComponent");
	const theHead = fixedHeaderContent ? React.createElement(TheTHead, {
		key: "TableHead",
		style: {
			zIndex: 2,
			position: "sticky",
			top: 0
		},
		ref: theadRef,
		...contextPropIfNotDomElement(TheTHead, context)
	}, fixedHeaderContent()) : null;
	const theFoot = fixedFooterContent ? React.createElement(TheTFoot, {
		key: "TableFoot",
		style: {
			zIndex: 1,
			position: "sticky",
			bottom: 0
		},
		ref: tfootRef,
		...contextPropIfNotDomElement(TheTFoot, context)
	}, fixedFooterContent()) : null;
	return /* @__PURE__ */ React.createElement(TheScroller, { ...props }, /* @__PURE__ */ React.createElement(TheViewport, null, React.createElement(TheTable, {
		style: {
			borderSpacing: 0,
			overflowAnchor: "none"
		},
		...contextPropIfNotDomElement(TheTable, context)
	}, [
		theHead,
		/* @__PURE__ */ React.createElement(Items, { key: "TableBody" }),
		theFoot
	])));
}));
var Scroller = /* @__PURE__ */ buildScroller({
	usePublisher,
	useEmitterValue,
	useEmitter
});
var WindowScroller = /* @__PURE__ */ buildWindowScroller({
	usePublisher,
	useEmitterValue,
	useEmitter
});
var TableVirtuoso = Table$1;
//#endregion
//#region src/components/organisms/sticky-headered-list/sticky-headered-list.styled.ts
var VirtualizedList = (0, import_dist.default)(GroupedVirtuoso)`
  z-0
`;
var Header = import_dist.default.div`
  px-4
  py-1
  overflow-hidden
  text-sm
  font-medium
  text-gray-500
  bg-gray-50
  text-ellipsis
  whitespace-nowrap
`;
var BorderWrapper = import_dist.default.div`
  border-b
  border-b-gray-200
`;
//#endregion
//#region src/components/organisms/sticky-headered-list/StickyHeaderedList.tsx
var StickyHeaderedList = ({ children: _, sections, testId, ...otherProps }) => {
	const allItems = sections.flatMap((s) => s.items);
	return /* @__PURE__ */ React.createElement(VirtualizedList, {
		groupCounts: sections.map((s) => s.items.length),
		groupContent: (index) => /* @__PURE__ */ React.createElement(BorderWrapper, null, /* @__PURE__ */ React.createElement(Header, null, sections[index].title)),
		itemContent: (index) => /* @__PURE__ */ React.createElement(BorderWrapper, null, allItems[index]),
		"data-testid": testId,
		...otherProps
	});
};
var GroupHeader = ({ children }) => /* @__PURE__ */ React.createElement(BorderWrapper, null, /* @__PURE__ */ React.createElement(Header, null, children));
//#endregion
//#region ../../node_modules/@react-spring/shared/node_modules/@react-spring/rafz/dist/react-spring-rafz.esm.js
var updateQueue = makeQueue();
var raf = (fn) => schedule(fn, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn) => schedule(fn, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn) => schedule(fn, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn) => schedule(fn, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn) => schedule(fn, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms) => {
	let time = raf.now() + ms;
	let cancel = () => {
		let i = timeouts.findIndex((t) => t.cancel == cancel);
		if (~i) timeouts.splice(i, 1);
		__raf.count -= ~i ? 1 : 0;
	};
	let timeout = {
		time,
		handler,
		cancel
	};
	timeouts.splice(findTimeout(time), 0, timeout);
	__raf.count += 1;
	start();
	return timeout;
};
var findTimeout = (time) => ~(~timeouts.findIndex((t) => t.time > time) || ~timeouts.length);
raf.cancel = (fn) => {
	updateQueue.delete(fn);
	writeQueue.delete(fn);
};
raf.sync = (fn) => {
	sync = true;
	raf.batchedUpdates(fn);
	sync = false;
};
raf.throttle = (fn) => {
	let lastArgs;
	function queuedFn() {
		try {
			fn(...lastArgs);
		} finally {
			lastArgs = null;
		}
	}
	function throttled(...args) {
		lastArgs = args;
		raf.onStart(queuedFn);
	}
	throttled.handler = fn;
	throttled.cancel = () => {
		onStartQueue.delete(queuedFn);
		lastArgs = null;
	};
	return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : () => {};
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn) => fn();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = () => {
	if (raf.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
	else update$1();
};
var ts = -1;
var sync = false;
function schedule(fn, queue) {
	if (sync) {
		queue.delete(fn);
		fn(0);
	} else {
		queue.add(fn);
		start();
	}
}
function start() {
	if (ts < 0) {
		ts = 0;
		if (raf.frameLoop !== "demand") nativeRaf(loop);
	}
}
function loop() {
	if (~ts) {
		nativeRaf(loop);
		raf.batchedUpdates(update$1);
	}
}
function update$1() {
	let prevTs = ts;
	ts = raf.now();
	let count = findTimeout(ts);
	if (count) {
		eachSafely(timeouts.splice(0, count), (t) => t.handler());
		__raf.count -= count;
	}
	onStartQueue.flush();
	updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
	onFrameQueue.flush();
	writeQueue.flush();
	onFinishQueue.flush();
}
function makeQueue() {
	let next = /* @__PURE__ */ new Set();
	let current = next;
	return {
		add(fn) {
			__raf.count += current == next && !next.has(fn) ? 1 : 0;
			next.add(fn);
		},
		delete(fn) {
			__raf.count -= current == next && next.has(fn) ? 1 : 0;
			return next.delete(fn);
		},
		flush(arg) {
			if (current.size) {
				next = /* @__PURE__ */ new Set();
				__raf.count -= current.size;
				eachSafely(current, (fn) => fn(arg) && next.add(fn));
				__raf.count += next.size;
				current = next;
			}
		}
	};
}
function eachSafely(values, each) {
	values.forEach((value) => {
		try {
			each(value);
		} catch (e) {
			raf.catch(e);
		}
	});
}
var __raf = {
	count: 0,
	clear() {
		ts = -1;
		timeouts = [];
		onStartQueue = makeQueue();
		updateQueue = makeQueue();
		onFrameQueue = makeQueue();
		writeQueue = makeQueue();
		onFinishQueue = makeQueue();
		__raf.count = 0;
	}
};
//#endregion
//#region ../../node_modules/@react-spring/shared/dist/react-spring-shared.esm.js
function noop$1() {}
var defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {
	value,
	writable: true,
	configurable: true
});
var is = {
	arr: Array.isArray,
	obj: (a) => !!a && a.constructor.name === "Object",
	fun: (a) => typeof a === "function",
	str: (a) => typeof a === "string",
	num: (a) => typeof a === "number",
	und: (a) => a === void 0
};
function isEqual(a, b) {
	if (is.arr(a)) {
		if (!is.arr(b) || a.length !== b.length) return false;
		for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
		return true;
	}
	return a === b;
}
var each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
	if (is.arr(obj)) {
		for (let i = 0; i < obj.length; i++) fn.call(ctx, obj[i], `${i}`);
		return;
	}
	for (const key in obj) if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var toArray = (a) => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
	if (queue.size) {
		const items = Array.from(queue);
		queue.clear();
		each(items, iterator);
	}
}
var flushCalls = (queue, ...args) => flush(queue, (fn) => fn(...args));
var createStringInterpolator$1;
var to$1;
var colors$1 = null;
var skipAnimation = false;
var willAdvance = noop$1;
var assign = (globals) => {
	if (globals.to) to$1 = globals.to;
	if (globals.now) raf.now = globals.now;
	if (globals.colors !== void 0) colors$1 = globals.colors;
	if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
	if (globals.createStringInterpolator) createStringInterpolator$1 = globals.createStringInterpolator;
	if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
	if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
	if (globals.willAdvance) willAdvance = globals.willAdvance;
	if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
};
var globals = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	get createStringInterpolator() {
		return createStringInterpolator$1;
	},
	get to() {
		return to$1;
	},
	get colors() {
		return colors$1;
	},
	get skipAnimation() {
		return skipAnimation;
	},
	get willAdvance() {
		return willAdvance;
	},
	assign
});
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
	get idle() {
		return !startQueue.size && !currentFrame.length;
	},
	start(animation) {
		if (priority > animation.priority) {
			startQueue.add(animation);
			raf.onStart(flushStartQueue);
		} else {
			startSafely(animation);
			raf(advance);
		}
	},
	advance,
	sort(animation) {
		if (priority) raf.onFrame(() => frameLoop.sort(animation));
		else {
			const prevIndex = currentFrame.indexOf(animation);
			if (~prevIndex) {
				currentFrame.splice(prevIndex, 1);
				startUnsafely(animation);
			}
		}
	},
	clear() {
		currentFrame = [];
		startQueue.clear();
	}
};
function flushStartQueue() {
	startQueue.forEach(startSafely);
	startQueue.clear();
	raf(advance);
}
function startSafely(animation) {
	if (!currentFrame.includes(animation)) startUnsafely(animation);
}
function startUnsafely(animation) {
	currentFrame.splice(findIndex(currentFrame, (other) => other.priority > animation.priority), 0, animation);
}
function advance(dt) {
	const nextFrame = prevFrame;
	for (let i = 0; i < currentFrame.length; i++) {
		const animation = currentFrame[i];
		priority = animation.priority;
		if (!animation.idle) {
			willAdvance(animation);
			animation.advance(dt);
			if (!animation.idle) nextFrame.push(animation);
		}
	}
	priority = 0;
	prevFrame = currentFrame;
	prevFrame.length = 0;
	currentFrame = nextFrame;
	return currentFrame.length > 0;
}
function findIndex(arr, test) {
	const index = arr.findIndex(test);
	return index < 0 ? arr.length : index;
}
var colors$2 = {
	transparent: 0,
	aliceblue: 4042850303,
	antiquewhite: 4209760255,
	aqua: 16777215,
	aquamarine: 2147472639,
	azure: 4043309055,
	beige: 4126530815,
	bisque: 4293182719,
	black: 255,
	blanchedalmond: 4293643775,
	blue: 65535,
	blueviolet: 2318131967,
	brown: 2771004159,
	burlywood: 3736635391,
	burntsienna: 3934150143,
	cadetblue: 1604231423,
	chartreuse: 2147418367,
	chocolate: 3530104575,
	coral: 4286533887,
	cornflowerblue: 1687547391,
	cornsilk: 4294499583,
	crimson: 3692313855,
	cyan: 16777215,
	darkblue: 35839,
	darkcyan: 9145343,
	darkgoldenrod: 3095792639,
	darkgray: 2846468607,
	darkgreen: 6553855,
	darkgrey: 2846468607,
	darkkhaki: 3182914559,
	darkmagenta: 2332068863,
	darkolivegreen: 1433087999,
	darkorange: 4287365375,
	darkorchid: 2570243327,
	darkred: 2332033279,
	darksalmon: 3918953215,
	darkseagreen: 2411499519,
	darkslateblue: 1211993087,
	darkslategray: 793726975,
	darkslategrey: 793726975,
	darkturquoise: 13554175,
	darkviolet: 2483082239,
	deeppink: 4279538687,
	deepskyblue: 12582911,
	dimgray: 1768516095,
	dimgrey: 1768516095,
	dodgerblue: 512819199,
	firebrick: 2988581631,
	floralwhite: 4294635775,
	forestgreen: 579543807,
	fuchsia: 4278255615,
	gainsboro: 3705462015,
	ghostwhite: 4177068031,
	gold: 4292280575,
	goldenrod: 3668254975,
	gray: 2155905279,
	green: 8388863,
	greenyellow: 2919182335,
	grey: 2155905279,
	honeydew: 4043305215,
	hotpink: 4285117695,
	indianred: 3445382399,
	indigo: 1258324735,
	ivory: 4294963455,
	khaki: 4041641215,
	lavender: 3873897215,
	lavenderblush: 4293981695,
	lawngreen: 2096890111,
	lemonchiffon: 4294626815,
	lightblue: 2916673279,
	lightcoral: 4034953471,
	lightcyan: 3774873599,
	lightgoldenrodyellow: 4210742015,
	lightgray: 3553874943,
	lightgreen: 2431553791,
	lightgrey: 3553874943,
	lightpink: 4290167295,
	lightsalmon: 4288707327,
	lightseagreen: 548580095,
	lightskyblue: 2278488831,
	lightslategray: 2005441023,
	lightslategrey: 2005441023,
	lightsteelblue: 2965692159,
	lightyellow: 4294959359,
	lime: 16711935,
	limegreen: 852308735,
	linen: 4210091775,
	magenta: 4278255615,
	maroon: 2147483903,
	mediumaquamarine: 1724754687,
	mediumblue: 52735,
	mediumorchid: 3126187007,
	mediumpurple: 2473647103,
	mediumseagreen: 1018393087,
	mediumslateblue: 2070474495,
	mediumspringgreen: 16423679,
	mediumturquoise: 1221709055,
	mediumvioletred: 3340076543,
	midnightblue: 421097727,
	mintcream: 4127193855,
	mistyrose: 4293190143,
	moccasin: 4293178879,
	navajowhite: 4292783615,
	navy: 33023,
	oldlace: 4260751103,
	olive: 2155872511,
	olivedrab: 1804477439,
	orange: 4289003775,
	orangered: 4282712319,
	orchid: 3664828159,
	palegoldenrod: 4008225535,
	palegreen: 2566625535,
	paleturquoise: 2951671551,
	palevioletred: 3681588223,
	papayawhip: 4293907967,
	peachpuff: 4292524543,
	peru: 3448061951,
	pink: 4290825215,
	plum: 3718307327,
	powderblue: 2967529215,
	purple: 2147516671,
	rebeccapurple: 1714657791,
	red: 4278190335,
	rosybrown: 3163525119,
	royalblue: 1097458175,
	saddlebrown: 2336560127,
	salmon: 4202722047,
	sandybrown: 4104413439,
	seagreen: 780883967,
	seashell: 4294307583,
	sienna: 2689740287,
	silver: 3233857791,
	skyblue: 2278484991,
	slateblue: 1784335871,
	slategray: 1887473919,
	slategrey: 1887473919,
	snow: 4294638335,
	springgreen: 16744447,
	steelblue: 1182971135,
	tan: 3535047935,
	teal: 8421631,
	thistle: 3636451583,
	tomato: 4284696575,
	turquoise: 1088475391,
	violet: 4001558271,
	wheat: 4125012991,
	white: 4294967295,
	whitesmoke: 4126537215,
	yellow: 4294902015,
	yellowgreen: 2597139199
};
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...parts) {
	return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb$1 = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba$1 = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl$1 = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla$1 = new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;
function normalizeColor(color) {
	let match;
	if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
	if (match = hex6.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
	if (colors$1 && colors$1[color] !== void 0) return colors$1[color];
	if (match = rgb$1.exec(color)) return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 255) >>> 0;
	if (match = rgba$1.exec(color)) return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
	if (match = hex3.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
	if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
	if (match = hex4.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
	if (match = hsl$1.exec(color)) return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 255) >>> 0;
	if (match = hsla$1.exec(color)) return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
	return null;
}
function hue2rgb(p, q, t) {
	if (t < 0) t += 1;
	if (t > 1) t -= 1;
	if (t < 1 / 6) return p + (q - p) * 6 * t;
	if (t < 1 / 2) return q;
	if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	return p;
}
function hslToRgb(h, s, l) {
	const q = l < .5 ? l * (1 + s) : l + s - l * s;
	const p = 2 * l - q;
	const r = hue2rgb(p, q, h + 1 / 3);
	const g = hue2rgb(p, q, h);
	const b = hue2rgb(p, q, h - 1 / 3);
	return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
	const int = parseInt(str, 10);
	if (int < 0) return 0;
	if (int > 255) return 255;
	return int;
}
function parse360(str) {
	return (parseFloat(str) % 360 + 360) % 360 / 360;
}
function parse1(str) {
	const num = parseFloat(str);
	if (num < 0) return 0;
	if (num > 1) return 255;
	return Math.round(num * 255);
}
function parsePercentage(str) {
	const int = parseFloat(str);
	if (int < 0) return 0;
	if (int > 100) return 1;
	return int / 100;
}
function colorToRgba(input) {
	let int32Color = normalizeColor(input);
	if (int32Color === null) return input;
	int32Color = int32Color || 0;
	return `rgba(${(int32Color & 4278190080) >>> 24}, ${(int32Color & 16711680) >>> 16}, ${(int32Color & 65280) >>> 8}, ${(int32Color & 255) / 255})`;
}
var createInterpolator = (range, output, extrapolate) => {
	if (is.fun(range)) return range;
	if (is.arr(range)) return createInterpolator({
		range,
		output,
		extrapolate
	});
	if (is.str(range.output[0])) return createStringInterpolator$1(range);
	const config = range;
	const outputRange = config.output;
	const inputRange = config.range || [0, 1];
	const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
	const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
	const easing = config.easing || ((t) => t);
	return (input) => {
		const range = findRange(input, inputRange);
		return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
	};
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
	let result = map ? map(input) : input;
	if (result < inputMin) {
		if (extrapolateLeft === "identity") return result;
		else if (extrapolateLeft === "clamp") result = inputMin;
	}
	if (result > inputMax) {
		if (extrapolateRight === "identity") return result;
		else if (extrapolateRight === "clamp") result = inputMax;
	}
	if (outputMin === outputMax) return outputMin;
	if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
	if (inputMin === -Infinity) result = -result;
	else if (inputMax === Infinity) result = result - inputMin;
	else result = (result - inputMin) / (inputMax - inputMin);
	result = easing(result);
	if (outputMin === -Infinity) result = -result;
	else if (outputMax === Infinity) result = result + outputMin;
	else result = result * (outputMax - outputMin) + outputMin;
	return result;
}
function findRange(input, inputRange) {
	for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;
	return i - 1;
}
function _extends$2() {
	_extends$2 = Object.assign || function(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			for (var key in source) if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
		}
		return target;
	};
	return _extends$2.apply(this, arguments);
}
var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");
var hasFluidValue = (arg) => Boolean(arg && arg[$get]);
var getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
var getFluidObservers = (target) => target[$observers] || null;
function callFluidObserver(observer, event) {
	if (observer.eventObserved) observer.eventObserved(event);
	else observer(event);
}
function callFluidObservers(target, event) {
	let observers = target[$observers];
	if (observers) observers.forEach((observer) => {
		callFluidObserver(observer, event);
	});
}
var FluidValue = class {
	constructor(get) {
		this[$get] = void 0;
		this[$observers] = void 0;
		if (!get && !(get = this.get)) throw Error("Unknown getter");
		setFluidGetter(this, get);
	}
};
var setFluidGetter = (target, get) => setHidden(target, $get, get);
function addFluidObserver(target, observer) {
	if (target[$get]) {
		let observers = target[$observers];
		if (!observers) setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
		if (!observers.has(observer)) {
			observers.add(observer);
			if (target.observerAdded) target.observerAdded(observers.size, observer);
		}
	}
	return observer;
}
function removeFluidObserver(target, observer) {
	let observers = target[$observers];
	if (observers && observers.has(observer)) {
		const count = observers.size - 1;
		if (count) observers.delete(observer);
		else target[$observers] = null;
		if (target.observerRemoved) target.observerRemoved(count, observer);
	}
}
var setHidden = (target, key, value) => Object.defineProperty(target, key, {
	value,
	writable: true,
	configurable: true
});
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var namedColorRegex;
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator = (config) => {
	if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join("|")})(?!\\w)`, "g") : /^\b$/;
	const output = config.output.map((value) => getFluidValue(value).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba));
	const keyframes = output.map((value) => value.match(numberRegex).map(Number));
	const interpolators = keyframes[0].map((_, i) => keyframes.map((values) => {
		if (!(i in values)) throw Error("The arity of each \"output\" value must be equal");
		return values[i];
	})).map((output) => createInterpolator(_extends$2({}, config, { output })));
	return (input) => {
		var _output$find;
		const missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find((value) => unitRegex.test(value))) == null ? void 0 : _output$find.replace(numberRegex, ""));
		let i = 0;
		return output[0].replace(numberRegex, () => `${interpolators[i++](input)}${missingUnit || ""}`).replace(rgbaRegex, rgbaRound);
	};
};
var prefix = "react-spring: ";
var once = (fn) => {
	const func = fn;
	let called = false;
	if (typeof func != "function") throw new TypeError(`${prefix}once requires a function parameter`);
	return (...args) => {
		if (!called) {
			func(...args);
			called = true;
		}
	};
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
	warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
	warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function isAnimatedString(value) {
	return is.str(value) && (value[0] == "#" || /\d/.test(value) || value in (colors$1 || {}));
}
var useOnce = (effect) => useEffect(effect, emptyDeps);
var emptyDeps = [];
function useForceUpdate() {
	const update = useState()[1];
	const mounted = useState(makeMountedRef)[0];
	useOnce(mounted.unmount);
	return () => {
		if (mounted.current) update({});
	};
}
function makeMountedRef() {
	const mounted = {
		current: true,
		unmount: () => () => {
			mounted.current = false;
		}
	};
	return mounted;
}
function useMemoOne(getResult, inputs) {
	const [initial] = useState(() => ({
		inputs,
		result: getResult()
	}));
	const committed = useRef();
	const prevCache = committed.current;
	let cache = prevCache;
	if (cache) {
		if (!Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs))) cache = {
			inputs,
			result: getResult()
		};
	} else cache = initial;
	useEffect(() => {
		committed.current = cache;
		if (prevCache == initial) initial.inputs = initial.result = void 0;
	}, [cache]);
	return cache.result;
}
function areInputsEqual(next, prev) {
	if (next.length !== prev.length) return false;
	for (let i = 0; i < next.length; i++) if (next[i] !== prev[i]) return false;
	return true;
}
function usePrev(value) {
	const prevRef = useRef();
	useEffect(() => {
		prevRef.current = value;
	});
	return prevRef.current;
}
var useLayoutEffect$1 = typeof window !== "undefined" && window.document && window.document.createElement ? m$3.useLayoutEffect : m$3.useEffect;
//#endregion
//#region ../../node_modules/@react-spring/animated/dist/react-spring-animated.esm.js
var $node = Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node) => defineHidden(owner, $node, node);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
	constructor() {
		this.payload = void 0;
		setAnimated(this, this);
	}
	getPayload() {
		return this.payload || [];
	}
};
var AnimatedValue = class AnimatedValue extends Animated {
	constructor(_value) {
		super();
		this.done = true;
		this.elapsedTime = void 0;
		this.lastPosition = void 0;
		this.lastVelocity = void 0;
		this.v0 = void 0;
		this.durationProgress = 0;
		this._value = _value;
		if (is.num(this._value)) this.lastPosition = this._value;
	}
	static create(value) {
		return new AnimatedValue(value);
	}
	getPayload() {
		return [this];
	}
	getValue() {
		return this._value;
	}
	setValue(value, step) {
		if (is.num(value)) {
			this.lastPosition = value;
			if (step) {
				value = Math.round(value / step) * step;
				if (this.done) this.lastPosition = value;
			}
		}
		if (this._value === value) return false;
		this._value = value;
		return true;
	}
	reset() {
		const { done } = this;
		this.done = false;
		if (is.num(this._value)) {
			this.elapsedTime = 0;
			this.durationProgress = 0;
			this.lastPosition = this._value;
			if (done) this.lastVelocity = null;
			this.v0 = null;
		}
	}
};
var AnimatedString = class AnimatedString extends AnimatedValue {
	constructor(value) {
		super(0);
		this._string = null;
		this._toString = void 0;
		this._toString = createInterpolator({ output: [value, value] });
	}
	static create(value) {
		return new AnimatedString(value);
	}
	getValue() {
		let value = this._string;
		return value == null ? this._string = this._toString(this._value) : value;
	}
	setValue(value) {
		if (is.str(value)) {
			if (value == this._string) return false;
			this._string = value;
			this._value = 1;
		} else if (super.setValue(value)) this._string = null;
		else return false;
		return true;
	}
	reset(goal) {
		if (goal) this._toString = createInterpolator({ output: [this.getValue(), goal] });
		this._value = 0;
		super.reset();
	}
};
var TreeContext = { dependencies: null };
var AnimatedObject = class extends Animated {
	constructor(source) {
		super();
		this.source = source;
		this.setValue(source);
	}
	getValue(animated) {
		const values = {};
		eachProp(this.source, (source, key) => {
			if (isAnimated(source)) values[key] = source.getValue(animated);
			else if (hasFluidValue(source)) values[key] = getFluidValue(source);
			else if (!animated) values[key] = source;
		});
		return values;
	}
	setValue(source) {
		this.source = source;
		this.payload = this._makePayload(source);
	}
	reset() {
		if (this.payload) each(this.payload, (node) => node.reset());
	}
	_makePayload(source) {
		if (source) {
			const payload = /* @__PURE__ */ new Set();
			eachProp(source, this._addToPayload, payload);
			return Array.from(payload);
		}
	}
	_addToPayload(source) {
		if (TreeContext.dependencies && hasFluidValue(source)) TreeContext.dependencies.add(source);
		const payload = getPayload(source);
		if (payload) each(payload, (node) => this.add(node));
	}
};
var AnimatedArray = class AnimatedArray extends AnimatedObject {
	constructor(source) {
		super(source);
	}
	static create(source) {
		return new AnimatedArray(source);
	}
	getValue() {
		return this.source.map((node) => node.getValue());
	}
	setValue(source) {
		const payload = this.getPayload();
		if (source.length == payload.length) return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
		super.setValue(source.map(makeAnimated));
		return true;
	}
};
function makeAnimated(value) {
	return (isAnimatedString(value) ? AnimatedString : AnimatedValue).create(value);
}
function getAnimatedType(value) {
	const parentNode = getAnimated(value);
	return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}
function _extends$1() {
	_extends$1 = Object.assign || function(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			for (var key in source) if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
		}
		return target;
	};
	return _extends$1.apply(this, arguments);
}
var withAnimated = (Component, host) => {
	const hasInstance = !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
	return forwardRef((givenProps, givenRef) => {
		const instanceRef = useRef(null);
		const ref = hasInstance && useCallback((value) => {
			instanceRef.current = updateRef(givenRef, value);
		}, [givenRef]);
		const [props, deps] = getAnimatedState(givenProps, host);
		const forceUpdate = useForceUpdate();
		const callback = () => {
			const instance = instanceRef.current;
			if (hasInstance && !instance) return;
			if ((instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false) === false) forceUpdate();
		};
		const observer = new PropsObserver(callback, deps);
		const observerRef = useRef();
		useLayoutEffect$1(() => {
			const lastObserver = observerRef.current;
			observerRef.current = observer;
			each(deps, (dep) => addFluidObserver(dep, observer));
			if (lastObserver) {
				each(lastObserver.deps, (dep) => removeFluidObserver(dep, lastObserver));
				raf.cancel(lastObserver.update);
			}
		});
		useEffect(callback, []);
		useOnce(() => () => {
			const observer = observerRef.current;
			each(observer.deps, (dep) => removeFluidObserver(dep, observer));
		});
		const usedProps = host.getComponentProps(props.getValue());
		return m$3.createElement(Component, _extends$1({}, usedProps, { ref }));
	});
};
var PropsObserver = class {
	constructor(update, deps) {
		this.update = update;
		this.deps = deps;
	}
	eventObserved(event) {
		if (event.type == "change") raf.write(this.update);
	}
};
function getAnimatedState(props, host) {
	const dependencies = /* @__PURE__ */ new Set();
	TreeContext.dependencies = dependencies;
	if (props.style) props = _extends$1({}, props, { style: host.createAnimatedStyle(props.style) });
	props = new AnimatedObject(props);
	TreeContext.dependencies = null;
	return [props, dependencies];
}
function updateRef(ref, value) {
	if (ref) {
		if (is.fun(ref)) ref(value);
		else ref.current = value;
	}
	return value;
}
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components, { applyAnimatedValues: _applyAnimatedValues = () => false, createAnimatedStyle: _createAnimatedStyle = (style) => new AnimatedObject(style), getComponentProps: _getComponentProps = (props) => props } = {}) => {
	const hostConfig = {
		applyAnimatedValues: _applyAnimatedValues,
		createAnimatedStyle: _createAnimatedStyle,
		getComponentProps: _getComponentProps
	};
	const animated = (Component) => {
		const displayName = getDisplayName(Component) || "Anonymous";
		if (is.str(Component)) Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
		else Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
		Component.displayName = `Animated(${displayName})`;
		return Component;
	};
	eachProp(components, (Component, key) => {
		if (is.arr(components)) key = getDisplayName(Component);
		animated[key] = animated(Component);
	});
	return { animated };
};
var getDisplayName = (arg) => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
//#endregion
//#region ../../node_modules/@react-spring/core/dist/react-spring-core.esm.js
function _extends() {
	_extends = Object.assign || function(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			for (var key in source) if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
		}
		return target;
	};
	return _extends.apply(this, arguments);
}
function callProp(value, ...args) {
	return is.fun(value) ? value(...args) : value;
}
var matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
var resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;
var getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var noopTransform = (value) => value;
var getDefaultProps = (props, transform = noopTransform) => {
	let keys = DEFAULT_PROPS;
	if (props.default && props.default !== true) {
		props = props.default;
		keys = Object.keys(props);
	}
	const defaults = {};
	for (const key of keys) {
		const value = transform(props[key], key);
		if (!is.und(value)) defaults[key] = value;
	}
	return defaults;
};
var DEFAULT_PROPS = [
	"config",
	"onProps",
	"onStart",
	"onChange",
	"onPause",
	"onResume",
	"onRest"
];
var RESERVED_PROPS = {
	config: 1,
	from: 1,
	to: 1,
	ref: 1,
	loop: 1,
	reset: 1,
	pause: 1,
	cancel: 1,
	reverse: 1,
	immediate: 1,
	default: 1,
	delay: 1,
	onProps: 1,
	onStart: 1,
	onChange: 1,
	onPause: 1,
	onResume: 1,
	onRest: 1,
	onResolve: 1,
	items: 1,
	trail: 1,
	sort: 1,
	expires: 1,
	initial: 1,
	enter: 1,
	update: 1,
	leave: 1,
	children: 1,
	onDestroyed: 1,
	keys: 1,
	callId: 1,
	parentId: 1
};
function getForwardProps(props) {
	const forward = {};
	let count = 0;
	eachProp(props, (value, prop) => {
		if (!RESERVED_PROPS[prop]) {
			forward[prop] = value;
			count++;
		}
	});
	if (count) return forward;
}
function inferTo(props) {
	const to = getForwardProps(props);
	if (to) {
		const out = { to };
		eachProp(props, (val, key) => key in to || (out[key] = val));
		return out;
	}
	return _extends({}, props);
}
function computeGoal(value) {
	value = getFluidValue(value);
	return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals.createStringInterpolator({
		range: [0, 1],
		output: [value, value]
	})(1) : value;
}
function hasProps(props) {
	for (const _ in props) return true;
	return false;
}
function isAsyncTo(to) {
	return is.fun(to) || is.arr(to) && is.obj(to[0]);
}
function detachRefs(ctrl, ref) {
	var _ctrl$ref;
	(_ctrl$ref = ctrl.ref) == null || _ctrl$ref.delete(ctrl);
	ref?.delete(ctrl);
}
function replaceRef(ctrl, ref) {
	if (ref && ctrl.ref !== ref) {
		var _ctrl$ref2;
		(_ctrl$ref2 = ctrl.ref) == null || _ctrl$ref2.delete(ctrl);
		ref.add(ctrl);
		ctrl.ref = ref;
	}
}
var config = {
	default: {
		tension: 170,
		friction: 26
	},
	gentle: {
		tension: 120,
		friction: 14
	},
	wobbly: {
		tension: 180,
		friction: 12
	},
	stiff: {
		tension: 210,
		friction: 20
	},
	slow: {
		tension: 280,
		friction: 60
	},
	molasses: {
		tension: 280,
		friction: 120
	}
};
var linear$2 = (t) => t;
var defaults = _extends({}, config.default, {
	mass: 1,
	damping: 1,
	easing: linear$2,
	clamp: false
});
var AnimationConfig = class {
	constructor() {
		this.tension = void 0;
		this.friction = void 0;
		this.frequency = void 0;
		this.damping = void 0;
		this.mass = void 0;
		this.velocity = 0;
		this.restVelocity = void 0;
		this.precision = void 0;
		this.progress = void 0;
		this.duration = void 0;
		this.easing = void 0;
		this.clamp = void 0;
		this.bounce = void 0;
		this.decay = void 0;
		this.round = void 0;
		Object.assign(this, defaults);
	}
};
function mergeConfig(config, newConfig, defaultConfig) {
	if (defaultConfig) {
		defaultConfig = _extends({}, defaultConfig);
		sanitizeConfig(defaultConfig, newConfig);
		newConfig = _extends({}, defaultConfig, newConfig);
	}
	sanitizeConfig(config, newConfig);
	Object.assign(config, newConfig);
	for (const key in defaults) if (config[key] == null) config[key] = defaults[key];
	let { mass, frequency, damping } = config;
	if (!is.und(frequency)) {
		if (frequency < .01) frequency = .01;
		if (damping < 0) damping = 0;
		config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
		config.friction = 4 * Math.PI * damping * mass / frequency;
	}
	return config;
}
function sanitizeConfig(config, props) {
	if (!is.und(props.decay)) config.duration = void 0;
	else {
		const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);
		if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
			config.duration = void 0;
			config.decay = void 0;
		}
		if (isTensionConfig) config.frequency = void 0;
	}
}
var emptyArray = [];
var Animation = class {
	constructor() {
		this.changed = false;
		this.values = emptyArray;
		this.toValues = null;
		this.fromValues = emptyArray;
		this.to = void 0;
		this.from = void 0;
		this.config = new AnimationConfig();
		this.immediate = false;
	}
};
function scheduleProps(callId, { key, props, defaultProps, state, actions }) {
	return new Promise((resolve, reject) => {
		var _props$cancel;
		let delay;
		let timeout;
		let cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
		if (cancel) onStart();
		else {
			if (!is.und(props.pause)) state.paused = matchProp(props.pause, key);
			let pause = defaultProps == null ? void 0 : defaultProps.pause;
			if (pause !== true) pause = state.paused || matchProp(pause, key);
			delay = callProp(props.delay || 0, key);
			if (pause) {
				state.resumeQueue.add(onResume);
				actions.pause();
			} else {
				actions.resume();
				onResume();
			}
		}
		function onPause() {
			state.resumeQueue.add(onResume);
			state.timeouts.delete(timeout);
			timeout.cancel();
			delay = timeout.time - raf.now();
		}
		function onResume() {
			if (delay > 0 && !globals.skipAnimation) {
				timeout = raf.setTimeout(onStart, delay);
				state.pauseQueue.add(onPause);
				state.timeouts.add(timeout);
			} else onStart();
		}
		function onStart() {
			state.pauseQueue.delete(onPause);
			state.timeouts.delete(timeout);
			if (callId <= (state.cancelId || 0)) cancel = true;
			try {
				actions.start(_extends({}, props, {
					callId,
					cancel
				}), resolve);
			} catch (err) {
				reject(err);
			}
		}
	});
}
var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target.get()) : results.every((result) => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every((result) => result.finished));
var getNoopResult = (value) => ({
	value,
	noop: true,
	finished: true,
	cancelled: false
});
var getFinishedResult = (value, finished, cancelled = false) => ({
	value,
	finished,
	cancelled
});
var getCancelledResult = (value) => ({
	value,
	cancelled: true,
	finished: false
});
function runAsync(to, props, state, target) {
	const { callId, parentId, onRest } = props;
	const { asyncTo: prevTo, promise: prevPromise } = state;
	if (!parentId && to === prevTo && !props.reset) return prevPromise;
	return state.promise = (async () => {
		state.asyncId = callId;
		state.asyncTo = to;
		const defaultProps = getDefaultProps(props, (value, key) => key === "onRest" ? void 0 : value);
		let preventBail;
		let bail;
		const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));
		const bailIfEnded = (bailSignal) => {
			const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);
			if (bailResult) {
				bailSignal.result = bailResult;
				bail(bailSignal);
				throw bailSignal;
			}
		};
		const animate = (arg1, arg2) => {
			const bailSignal = new BailSignal();
			const skipAnimationSignal = new SkipAniamtionSignal();
			return (async () => {
				if (globals.skipAnimation) {
					stopAsync(state);
					skipAnimationSignal.result = getFinishedResult(target, false);
					bail(skipAnimationSignal);
					throw skipAnimationSignal;
				}
				bailIfEnded(bailSignal);
				const props = is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, { to: arg1 });
				props.parentId = callId;
				eachProp(defaultProps, (value, key) => {
					if (is.und(props[key])) props[key] = value;
				});
				const result = await target.start(props);
				bailIfEnded(bailSignal);
				if (state.paused) await new Promise((resume) => {
					state.resumeQueue.add(resume);
				});
				return result;
			})();
		};
		let result;
		if (globals.skipAnimation) {
			stopAsync(state);
			return getFinishedResult(target, false);
		}
		try {
			let animating;
			if (is.arr(to)) animating = (async (queue) => {
				for (const props of queue) await animate(props);
			})(to);
			else animating = Promise.resolve(to(animate, target.stop.bind(target)));
			await Promise.all([animating.then(preventBail), bailPromise]);
			result = getFinishedResult(target.get(), true, false);
		} catch (err) {
			if (err instanceof BailSignal) result = err.result;
			else if (err instanceof SkipAniamtionSignal) result = err.result;
			else throw err;
		} finally {
			if (callId == state.asyncId) {
				state.asyncId = parentId;
				state.asyncTo = parentId ? prevTo : void 0;
				state.promise = parentId ? prevPromise : void 0;
			}
		}
		if (is.fun(onRest)) raf.batchedUpdates(() => {
			onRest(result, target, target.item);
		});
		return result;
	})();
}
function stopAsync(state, cancelId) {
	flush(state.timeouts, (t) => t.cancel());
	state.pauseQueue.clear();
	state.resumeQueue.clear();
	state.asyncId = state.asyncTo = state.promise = void 0;
	if (cancelId) state.cancelId = cancelId;
}
var BailSignal = class extends Error {
	constructor() {
		super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
		this.result = void 0;
	}
};
var SkipAniamtionSignal = class extends Error {
	constructor() {
		super("SkipAnimationSignal");
		this.result = void 0;
	}
};
var isFrameValue = (value) => value instanceof FrameValue;
var nextId$1 = 1;
var FrameValue = class extends FluidValue {
	constructor(...args) {
		super(...args);
		this.id = nextId$1++;
		this.key = void 0;
		this._priority = 0;
	}
	get priority() {
		return this._priority;
	}
	set priority(priority) {
		if (this._priority != priority) {
			this._priority = priority;
			this._onPriorityChange(priority);
		}
	}
	get() {
		const node = getAnimated(this);
		return node && node.getValue();
	}
	to(...args) {
		return globals.to(this, args);
	}
	interpolate(...args) {
		deprecateInterpolate();
		return globals.to(this, args);
	}
	toJSON() {
		return this.get();
	}
	observerAdded(count) {
		if (count == 1) this._attach();
	}
	observerRemoved(count) {
		if (count == 0) this._detach();
	}
	_attach() {}
	_detach() {}
	_onChange(value, idle = false) {
		callFluidObservers(this, {
			type: "change",
			parent: this,
			value,
			idle
		});
	}
	_onPriorityChange(priority) {
		if (!this.idle) frameLoop.sort(this);
		callFluidObservers(this, {
			type: "priority",
			parent: this,
			priority
		});
	}
};
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = (target) => (target[$P] & HAS_ANIMATED) > 0;
var isAnimating = (target) => (target[$P] & IS_ANIMATING) > 0;
var isPaused = (target) => (target[$P] & IS_PAUSED) > 0;
var setActiveBit = (target, active) => active ? target[$P] |= 3 : target[$P] &= -3;
var setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= -5;
var SpringValue = class extends FrameValue {
	constructor(arg1, arg2) {
		super();
		this.key = void 0;
		this.animation = new Animation();
		this.queue = void 0;
		this.defaultProps = {};
		this._state = {
			paused: false,
			pauseQueue: /* @__PURE__ */ new Set(),
			resumeQueue: /* @__PURE__ */ new Set(),
			timeouts: /* @__PURE__ */ new Set()
		};
		this._pendingCalls = /* @__PURE__ */ new Set();
		this._lastCallId = 0;
		this._lastToId = 0;
		this._memoizedDuration = 0;
		if (!is.und(arg1) || !is.und(arg2)) {
			const props = is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, { from: arg1 });
			if (is.und(props.default)) props.default = true;
			this.start(props);
		}
	}
	get idle() {
		return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
	}
	get goal() {
		return getFluidValue(this.animation.to);
	}
	get velocity() {
		const node = getAnimated(this);
		return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map((node) => node.lastVelocity || 0);
	}
	get hasAnimated() {
		return hasAnimated(this);
	}
	get isAnimating() {
		return isAnimating(this);
	}
	get isPaused() {
		return isPaused(this);
	}
	advance(dt) {
		let idle = true;
		let changed = false;
		const anim = this.animation;
		let { config, toValues } = anim;
		const payload = getPayload(anim.to);
		if (!payload && hasFluidValue(anim.to)) toValues = toArray(getFluidValue(anim.to));
		anim.values.forEach((node, i) => {
			if (node.done) return;
			const to = node.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
			let finished = anim.immediate;
			let position = to;
			if (!finished) {
				position = node.lastPosition;
				if (config.tension <= 0) {
					node.done = true;
					return;
				}
				let elapsed = node.elapsedTime += dt;
				const from = anim.fromValues[i];
				const v0 = node.v0 != null ? node.v0 : node.v0 = is.arr(config.velocity) ? config.velocity[i] : config.velocity;
				let velocity;
				if (!is.und(config.duration)) {
					let p = 1;
					if (config.duration > 0) {
						if (this._memoizedDuration !== config.duration) {
							this._memoizedDuration = config.duration;
							if (node.durationProgress > 0) {
								node.elapsedTime = config.duration * node.durationProgress;
								elapsed = node.elapsedTime += dt;
							}
						}
						p = (config.progress || 0) + elapsed / this._memoizedDuration;
						p = p > 1 ? 1 : p < 0 ? 0 : p;
						node.durationProgress = p;
					}
					position = from + config.easing(p) * (to - from);
					velocity = (position - node.lastPosition) / dt;
					finished = p == 1;
				} else if (config.decay) {
					const decay = config.decay === true ? .998 : config.decay;
					const e = Math.exp(-(1 - decay) * elapsed);
					position = from + v0 / (1 - decay) * (1 - e);
					finished = Math.abs(node.lastPosition - position) < .1;
					velocity = v0 * e;
				} else {
					velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
					const precision = config.precision || (from == to ? .005 : Math.min(1, Math.abs(to - from) * .001));
					const restVelocity = config.restVelocity || precision / 10;
					const bounceFactor = config.clamp ? 0 : config.bounce;
					const canBounce = !is.und(bounceFactor);
					const isGrowing = from == to ? node.v0 > 0 : from < to;
					let isMoving;
					let isBouncing = false;
					const step = 1;
					const numSteps = Math.ceil(dt / step);
					for (let n = 0; n < numSteps; ++n) {
						isMoving = Math.abs(velocity) > restVelocity;
						if (!isMoving) {
							finished = Math.abs(to - position) <= precision;
							if (finished) break;
						}
						if (canBounce) {
							isBouncing = position == to || position > to == isGrowing;
							if (isBouncing) {
								velocity = -velocity * bounceFactor;
								position = to;
							}
						}
						const acceleration = (-config.tension * 1e-6 * (position - to) + -config.friction * .001 * velocity) / config.mass;
						velocity = velocity + acceleration * step;
						position = position + velocity * step;
					}
				}
				node.lastVelocity = velocity;
				if (Number.isNaN(position)) {
					console.warn(`Got NaN while animating:`, this);
					finished = true;
				}
			}
			if (payload && !payload[i].done) finished = false;
			if (finished) node.done = true;
			else idle = false;
			if (node.setValue(position, config.round)) changed = true;
		});
		const node = getAnimated(this);
		const currVal = node.getValue();
		if (idle) {
			const finalVal = getFluidValue(anim.to);
			if ((currVal !== finalVal || changed) && !config.decay) {
				node.setValue(finalVal);
				this._onChange(finalVal);
			} else if (changed && config.decay) this._onChange(currVal);
			this._stop();
		} else if (changed) this._onChange(currVal);
	}
	set(value) {
		raf.batchedUpdates(() => {
			this._stop();
			this._focus(value);
			this._set(value);
		});
		return this;
	}
	pause() {
		this._update({ pause: true });
	}
	resume() {
		this._update({ pause: false });
	}
	finish() {
		if (isAnimating(this)) {
			const { to, config } = this.animation;
			raf.batchedUpdates(() => {
				this._onStart();
				if (!config.decay) this._set(to, false);
				this._stop();
			});
		}
		return this;
	}
	update(props) {
		(this.queue || (this.queue = [])).push(props);
		return this;
	}
	start(to, arg2) {
		let queue;
		if (!is.und(to)) queue = [is.obj(to) ? to : _extends({}, arg2, { to })];
		else {
			queue = this.queue || [];
			this.queue = [];
		}
		return Promise.all(queue.map((props) => this._update(props))).then((results) => getCombinedResult(this, results));
	}
	stop(cancel) {
		const { to } = this.animation;
		this._focus(this.get());
		stopAsync(this._state, cancel && this._lastCallId);
		raf.batchedUpdates(() => this._stop(to, cancel));
		return this;
	}
	reset() {
		this._update({ reset: true });
	}
	eventObserved(event) {
		if (event.type == "change") this._start();
		else if (event.type == "priority") this.priority = event.priority + 1;
	}
	_prepareNode(props) {
		const key = this.key || "";
		let { to, from } = props;
		to = is.obj(to) ? to[key] : to;
		if (to == null || isAsyncTo(to)) to = void 0;
		from = is.obj(from) ? from[key] : from;
		if (from == null) from = void 0;
		const range = {
			to,
			from
		};
		if (!hasAnimated(this)) {
			if (props.reverse) [to, from] = [from, to];
			from = getFluidValue(from);
			if (!is.und(from)) this._set(from);
			else if (!getAnimated(this)) this._set(to);
		}
		return range;
	}
	_update(_ref, isLoop) {
		let props = _extends({}, _ref);
		const { key, defaultProps } = this;
		if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
		mergeActiveFn(this, props, "onProps");
		sendEvent(this, "onProps", props, this);
		const range = this._prepareNode(props);
		if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
		const state = this._state;
		return scheduleProps(++this._lastCallId, {
			key,
			props,
			defaultProps,
			state,
			actions: {
				pause: () => {
					if (!isPaused(this)) {
						setPausedBit(this, true);
						flushCalls(state.pauseQueue);
						sendEvent(this, "onPause", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
					}
				},
				resume: () => {
					if (isPaused(this)) {
						setPausedBit(this, false);
						if (isAnimating(this)) this._resume();
						flushCalls(state.resumeQueue);
						sendEvent(this, "onResume", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
					}
				},
				start: this._merge.bind(this, range)
			}
		}).then((result) => {
			if (props.loop && result.finished && !(isLoop && result.noop)) {
				const nextProps = createLoopUpdate(props);
				if (nextProps) return this._update(nextProps, true);
			}
			return result;
		});
	}
	_merge(range, props, resolve) {
		if (props.cancel) {
			this.stop(true);
			return resolve(getCancelledResult(this));
		}
		const hasToProp = !is.und(range.to);
		const hasFromProp = !is.und(range.from);
		if (hasToProp || hasFromProp) {
			if (props.callId > this._lastToId) this._lastToId = props.callId;
			else return resolve(getCancelledResult(this));
		}
		const { key, defaultProps, animation: anim } = this;
		const { to: prevTo, from: prevFrom } = anim;
		let { to = prevTo, from = prevFrom } = range;
		if (hasFromProp && !hasToProp && (!props.default || is.und(to))) to = from;
		if (props.reverse) [to, from] = [from, to];
		const hasFromChanged = !isEqual(from, prevFrom);
		if (hasFromChanged) anim.from = from;
		from = getFluidValue(from);
		const hasToChanged = !isEqual(to, prevTo);
		if (hasToChanged) this._focus(to);
		const hasAsyncTo = isAsyncTo(props.to);
		const { config } = anim;
		const { decay, velocity } = config;
		if (hasToProp || hasFromProp) config.velocity = 0;
		if (props.config && !hasAsyncTo) mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
		let node = getAnimated(this);
		if (!node || is.und(to)) return resolve(getFinishedResult(this, true));
		const reset = is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key);
		const value = reset ? from : this.get();
		const goal = computeGoal(to);
		const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
		const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
		if (hasToChanged) {
			const nodeType = getAnimatedType(to);
			if (nodeType !== node.constructor) {
				if (immediate) node = this._set(goal);
				else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
			}
		}
		const goalType = node.constructor;
		let started = hasFluidValue(to);
		let finished = false;
		if (!started) {
			const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
			if (hasToChanged || hasValueChanged) {
				finished = isEqual(computeGoal(value), goal);
				started = !finished;
			}
			if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config.decay, decay) || !isEqual(config.velocity, velocity)) started = true;
		}
		if (finished && isAnimating(this)) {
			if (anim.changed && !reset) started = true;
			else if (!started) this._stop(prevTo);
		}
		if (!hasAsyncTo) {
			if (started || hasFluidValue(prevTo)) {
				anim.values = node.getPayload();
				anim.toValues = hasFluidValue(to) ? null : goalType == AnimatedString ? [1] : toArray(goal);
			}
			if (anim.immediate != immediate) {
				anim.immediate = immediate;
				if (!immediate && !reset) this._set(prevTo);
			}
			if (started) {
				const { onRest } = anim;
				each(ACTIVE_EVENTS, (type) => mergeActiveFn(this, props, type));
				const result = getFinishedResult(this, checkFinished(this, prevTo));
				flushCalls(this._pendingCalls, result);
				this._pendingCalls.add(resolve);
				if (anim.changed) raf.batchedUpdates(() => {
					anim.changed = !reset;
					onRest?.(result, this);
					if (reset) callProp(defaultProps.onRest, result);
					else anim.onStart == null || anim.onStart(result, this);
				});
			}
		}
		if (reset) this._set(value);
		if (hasAsyncTo) resolve(runAsync(props.to, props, this._state, this));
		else if (started) this._start();
		else if (isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
		else resolve(getNoopResult(value));
	}
	_focus(value) {
		const anim = this.animation;
		if (value !== anim.to) {
			if (getFluidObservers(this)) this._detach();
			anim.to = value;
			if (getFluidObservers(this)) this._attach();
		}
	}
	_attach() {
		let priority = 0;
		const { to } = this.animation;
		if (hasFluidValue(to)) {
			addFluidObserver(to, this);
			if (isFrameValue(to)) priority = to.priority + 1;
		}
		this.priority = priority;
	}
	_detach() {
		const { to } = this.animation;
		if (hasFluidValue(to)) removeFluidObserver(to, this);
	}
	_set(arg, idle = true) {
		const value = getFluidValue(arg);
		if (!is.und(value)) {
			const oldNode = getAnimated(this);
			if (!oldNode || !isEqual(value, oldNode.getValue())) {
				const nodeType = getAnimatedType(value);
				if (!oldNode || oldNode.constructor != nodeType) setAnimated(this, nodeType.create(value));
				else oldNode.setValue(value);
				if (oldNode) raf.batchedUpdates(() => {
					this._onChange(value, idle);
				});
			}
		}
		return getAnimated(this);
	}
	_onStart() {
		const anim = this.animation;
		if (!anim.changed) {
			anim.changed = true;
			sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
		}
	}
	_onChange(value, idle) {
		if (!idle) {
			this._onStart();
			callProp(this.animation.onChange, value, this);
		}
		callProp(this.defaultProps.onChange, value, this);
		super._onChange(value, idle);
	}
	_start() {
		const anim = this.animation;
		getAnimated(this).reset(getFluidValue(anim.to));
		if (!anim.immediate) anim.fromValues = anim.values.map((node) => node.lastPosition);
		if (!isAnimating(this)) {
			setActiveBit(this, true);
			if (!isPaused(this)) this._resume();
		}
	}
	_resume() {
		if (globals.skipAnimation) this.finish();
		else frameLoop.start(this);
	}
	_stop(goal, cancel) {
		if (isAnimating(this)) {
			setActiveBit(this, false);
			const anim = this.animation;
			each(anim.values, (node) => {
				node.done = true;
			});
			if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
			callFluidObservers(this, {
				type: "idle",
				parent: this
			});
			const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
			flushCalls(this._pendingCalls, result);
			if (anim.changed) {
				anim.changed = false;
				sendEvent(this, "onRest", result, this);
			}
		}
	}
};
function checkFinished(target, to) {
	const goal = computeGoal(to);
	return isEqual(computeGoal(target.get()), goal);
}
function createLoopUpdate(props, loop = props.loop, to = props.to) {
	let loopRet = callProp(loop);
	if (loopRet) {
		const overrides = loopRet !== true && inferTo(loopRet);
		const reverse = (overrides || props).reverse;
		const reset = !overrides || overrides.reset;
		return createUpdate(_extends({}, props, {
			loop,
			default: false,
			pause: void 0,
			to: !reverse || isAsyncTo(to) ? to : void 0,
			from: reset ? props.from : void 0,
			reset
		}, overrides));
	}
}
function createUpdate(props) {
	const { to, from } = props = inferTo(props);
	const keys = /* @__PURE__ */ new Set();
	if (is.obj(to)) findDefined(to, keys);
	if (is.obj(from)) findDefined(from, keys);
	props.keys = keys.size ? Array.from(keys) : null;
	return props;
}
function declareUpdate(props) {
	const update = createUpdate(props);
	if (is.und(update.default)) update.default = getDefaultProps(update);
	return update;
}
function findDefined(values, keys) {
	eachProp(values, (value, key) => value != null && keys.add(key));
}
var ACTIVE_EVENTS = [
	"onStart",
	"onRest",
	"onChange",
	"onPause",
	"onResume"
];
function mergeActiveFn(target, props, type) {
	target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type, ...args) {
	var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
	(_target$animation$typ = (_target$animation = target.animation)[type]) == null || _target$animation$typ.call(_target$animation, ...args);
	(_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null || _target$defaultProps$.call(_target$defaultProps, ...args);
}
var BATCHED_EVENTS = [
	"onStart",
	"onChange",
	"onRest"
];
var nextId = 1;
var Controller$1 = class {
	constructor(props, flush) {
		this.id = nextId++;
		this.springs = {};
		this.queue = [];
		this.ref = void 0;
		this._flush = void 0;
		this._initialProps = void 0;
		this._lastAsyncId = 0;
		this._active = /* @__PURE__ */ new Set();
		this._changed = /* @__PURE__ */ new Set();
		this._started = false;
		this._item = void 0;
		this._state = {
			paused: false,
			pauseQueue: /* @__PURE__ */ new Set(),
			resumeQueue: /* @__PURE__ */ new Set(),
			timeouts: /* @__PURE__ */ new Set()
		};
		this._events = {
			onStart: /* @__PURE__ */ new Map(),
			onChange: /* @__PURE__ */ new Map(),
			onRest: /* @__PURE__ */ new Map()
		};
		this._onFrame = this._onFrame.bind(this);
		if (flush) this._flush = flush;
		if (props) this.start(_extends({ default: true }, props));
	}
	get idle() {
		return !this._state.asyncTo && Object.values(this.springs).every((spring) => spring.idle);
	}
	get item() {
		return this._item;
	}
	set item(item) {
		this._item = item;
	}
	get() {
		const values = {};
		this.each((spring, key) => values[key] = spring.get());
		return values;
	}
	set(values) {
		for (const key in values) {
			const value = values[key];
			if (!is.und(value)) this.springs[key].set(value);
		}
	}
	update(props) {
		if (props) this.queue.push(createUpdate(props));
		return this;
	}
	start(props) {
		let { queue } = this;
		if (props) queue = toArray(props).map(createUpdate);
		else this.queue = [];
		if (this._flush) return this._flush(this, queue);
		prepareKeys(this, queue);
		return flushUpdateQueue(this, queue);
	}
	stop(arg, keys) {
		if (arg !== !!arg) keys = arg;
		if (keys) {
			const springs = this.springs;
			each(toArray(keys), (key) => springs[key].stop(!!arg));
		} else {
			stopAsync(this._state, this._lastAsyncId);
			this.each((spring) => spring.stop(!!arg));
		}
		return this;
	}
	pause(keys) {
		if (is.und(keys)) this.start({ pause: true });
		else {
			const springs = this.springs;
			each(toArray(keys), (key) => springs[key].pause());
		}
		return this;
	}
	resume(keys) {
		if (is.und(keys)) this.start({ pause: false });
		else {
			const springs = this.springs;
			each(toArray(keys), (key) => springs[key].resume());
		}
		return this;
	}
	each(iterator) {
		eachProp(this.springs, iterator);
	}
	_onFrame() {
		const { onStart, onChange, onRest } = this._events;
		const active = this._active.size > 0;
		const changed = this._changed.size > 0;
		if (active && !this._started || changed && !this._started) {
			this._started = true;
			flush(onStart, ([onStart, result]) => {
				result.value = this.get();
				onStart(result, this, this._item);
			});
		}
		const idle = !active && this._started;
		const values = changed || idle && onRest.size ? this.get() : null;
		if (changed && onChange.size) flush(onChange, ([onChange, result]) => {
			result.value = values;
			onChange(result, this, this._item);
		});
		if (idle) {
			this._started = false;
			flush(onRest, ([onRest, result]) => {
				result.value = values;
				onRest(result, this, this._item);
			});
		}
	}
	eventObserved(event) {
		if (event.type == "change") {
			this._changed.add(event.parent);
			if (!event.idle) this._active.add(event.parent);
		} else if (event.type == "idle") this._active.delete(event.parent);
		else return;
		raf.onFrame(this._onFrame);
	}
};
function flushUpdateQueue(ctrl, queue) {
	return Promise.all(queue.map((props) => flushUpdate(ctrl, props))).then((results) => getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
	const { keys, to, from, loop, onRest, onResolve } = props;
	const defaults = is.obj(props.default) && props.default;
	if (loop) props.loop = false;
	if (to === false) props.to = null;
	if (from === false) props.from = null;
	const asyncTo = is.arr(to) || is.fun(to) ? to : void 0;
	if (asyncTo) {
		props.to = void 0;
		props.onRest = void 0;
		if (defaults) defaults.onRest = void 0;
	} else each(BATCHED_EVENTS, (key) => {
		const handler = props[key];
		if (is.fun(handler)) {
			const queue = ctrl["_events"][key];
			props[key] = ({ finished, cancelled }) => {
				const result = queue.get(handler);
				if (result) {
					if (!finished) result.finished = false;
					if (cancelled) result.cancelled = true;
				} else queue.set(handler, {
					value: null,
					finished: finished || false,
					cancelled: cancelled || false
				});
			};
			if (defaults) defaults[key] = props[key];
		}
	});
	const state = ctrl["_state"];
	if (props.pause === !state.paused) {
		state.paused = props.pause;
		flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
	} else if (state.paused) props.pause = true;
	const promises = (keys || Object.keys(ctrl.springs)).map((key) => ctrl.springs[key].start(props));
	const cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
	if (asyncTo || cancel && state.asyncId) promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
		props,
		state,
		actions: {
			pause: noop$1,
			resume: noop$1,
			start(props, resolve) {
				if (cancel) {
					stopAsync(state, ctrl["_lastAsyncId"]);
					resolve(getCancelledResult(ctrl));
				} else {
					props.onRest = onRest;
					resolve(runAsync(asyncTo, props, state, ctrl));
				}
			}
		}
	}));
	if (state.paused) await new Promise((resume) => {
		state.resumeQueue.add(resume);
	});
	const result = getCombinedResult(ctrl, await Promise.all(promises));
	if (loop && result.finished && !(isLoop && result.noop)) {
		const nextProps = createLoopUpdate(props, loop, to);
		if (nextProps) {
			prepareKeys(ctrl, [nextProps]);
			return flushUpdate(ctrl, nextProps, true);
		}
	}
	if (onResolve) raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
	return result;
}
function getSprings(ctrl, props) {
	const springs = _extends({}, ctrl.springs);
	if (props) each(toArray(props), (props) => {
		if (is.und(props.keys)) props = createUpdate(props);
		if (!is.obj(props.to)) props = _extends({}, props, { to: void 0 });
		prepareSprings(springs, props, (key) => {
			return createSpring(key);
		});
	});
	setSprings(ctrl, springs);
	return springs;
}
function setSprings(ctrl, springs) {
	eachProp(springs, (spring, key) => {
		if (!ctrl.springs[key]) {
			ctrl.springs[key] = spring;
			addFluidObserver(spring, ctrl);
		}
	});
}
function createSpring(key, observer) {
	const spring = new SpringValue();
	spring.key = key;
	if (observer) addFluidObserver(spring, observer);
	return spring;
}
function prepareSprings(springs, props, create) {
	if (props.keys) each(props.keys, (key) => {
		(springs[key] || (springs[key] = create(key)))["_prepareNode"](props);
	});
}
function prepareKeys(ctrl, queue) {
	each(queue, (props) => {
		prepareSprings(ctrl.springs, props, (key) => {
			return createSpring(key, ctrl);
		});
	});
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source);
	var key, i = 0;
	for (; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) continue;
		target[key] = source[key];
	}
	return target;
}
var _excluded$3 = ["children"];
var SpringContext = (_ref) => {
	let { children } = _ref, props = _objectWithoutPropertiesLoose$1(_ref, _excluded$3);
	const inherited = useContext(ctx);
	const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
	props = useMemoOne(() => ({
		pause,
		immediate
	}), [pause, immediate]);
	const { Provider } = ctx;
	return m$3.createElement(Provider, { value: props }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
	Object.assign(target, m$3.createContext(init));
	target.Provider._context = target;
	target.Consumer._context = target;
	return target;
}
var SpringRef = () => {
	const current = [];
	const SpringRef = function SpringRef(props) {
		deprecateDirectCall();
		const results = [];
		each(current, (ctrl, i) => {
			if (is.und(props)) results.push(ctrl.start());
			else {
				const update = _getProps(props, ctrl, i);
				if (update) results.push(ctrl.start(update));
			}
		});
		return results;
	};
	SpringRef.current = current;
	SpringRef.add = function(ctrl) {
		if (!current.includes(ctrl)) current.push(ctrl);
	};
	SpringRef.delete = function(ctrl) {
		const i = current.indexOf(ctrl);
		if (~i) current.splice(i, 1);
	};
	SpringRef.pause = function() {
		each(current, (ctrl) => ctrl.pause(...arguments));
		return this;
	};
	SpringRef.resume = function() {
		each(current, (ctrl) => ctrl.resume(...arguments));
		return this;
	};
	SpringRef.set = function(values) {
		each(current, (ctrl) => ctrl.set(values));
	};
	SpringRef.start = function(props) {
		const results = [];
		each(current, (ctrl, i) => {
			if (is.und(props)) results.push(ctrl.start());
			else {
				const update = this._getProps(props, ctrl, i);
				if (update) results.push(ctrl.start(update));
			}
		});
		return results;
	};
	SpringRef.stop = function() {
		each(current, (ctrl) => ctrl.stop(...arguments));
		return this;
	};
	SpringRef.update = function(props) {
		each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
		return this;
	};
	const _getProps = function _getProps(arg, ctrl, index) {
		return is.fun(arg) ? arg(index, ctrl) : arg;
	};
	SpringRef._getProps = _getProps;
	return SpringRef;
};
function useSprings(length, props, deps) {
	const propsFn = is.fun(props) && props;
	if (propsFn && !deps) deps = [];
	const ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
	const layoutId = useRef(0);
	const forceUpdate = useForceUpdate();
	const state = useMemo(() => ({
		ctrls: [],
		queue: [],
		flush(ctrl, updates) {
			const springs = getSprings(ctrl, updates);
			return layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some((key) => !ctrl.springs[key]) ? flushUpdateQueue(ctrl, updates) : new Promise((resolve) => {
				setSprings(ctrl, springs);
				state.queue.push(() => {
					resolve(flushUpdateQueue(ctrl, updates));
				});
				forceUpdate();
			});
		}
	}), []);
	const ctrls = useRef([...state.ctrls]);
	const updates = [];
	const prevLength = usePrev(length) || 0;
	useMemo(() => {
		each(ctrls.current.slice(length, prevLength), (ctrl) => {
			detachRefs(ctrl, ref);
			ctrl.stop(true);
		});
		ctrls.current.length = length;
		declareUpdates(prevLength, length);
	}, [length]);
	useMemo(() => {
		declareUpdates(0, Math.min(prevLength, length));
	}, deps);
	function declareUpdates(startIndex, endIndex) {
		for (let i = startIndex; i < endIndex; i++) {
			const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller$1(null, state.flush));
			const update = propsFn ? propsFn(i, ctrl) : props[i];
			if (update) updates[i] = declareUpdate(update);
		}
	}
	const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
	const context = useContext(SpringContext);
	const hasContext = context !== usePrev(context) && hasProps(context);
	useLayoutEffect$1(() => {
		layoutId.current++;
		state.ctrls = ctrls.current;
		const { queue } = state;
		if (queue.length) {
			state.queue = [];
			each(queue, (cb) => cb());
		}
		each(ctrls.current, (ctrl, i) => {
			ref?.add(ctrl);
			if (hasContext) ctrl.start({ default: context });
			const update = updates[i];
			if (update) {
				replaceRef(ctrl, update.ref);
				if (ctrl.ref) ctrl.queue.push(update);
				else ctrl.start(update);
			}
		});
	});
	useOnce(() => () => {
		each(state.ctrls, (ctrl) => ctrl.stop(true));
	});
	const values = springs.map((x) => _extends({}, x));
	return ref ? [values, ref] : values;
}
function useSpring(props, deps) {
	const isFn = is.fun(props);
	const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
	return isFn || arguments.length == 2 ? [values, ref] : values;
}
var TransitionPhase;
(function(TransitionPhase) {
	TransitionPhase["MOUNT"] = "mount";
	TransitionPhase["ENTER"] = "enter";
	TransitionPhase["UPDATE"] = "update";
	TransitionPhase["LEAVE"] = "leave";
})(TransitionPhase || (TransitionPhase = {}));
function useTransition(data, props, deps) {
	const propsFn = is.fun(props) && props;
	const { reset, sort, trail = 0, expires = true, onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
	const ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
	const items = toArray(data);
	const transitions = [];
	const usedTransitions = useRef(null);
	const prevTransitions = reset ? null : usedTransitions.current;
	useLayoutEffect$1(() => {
		usedTransitions.current = transitions;
	});
	useOnce(() => () => each(usedTransitions.current, (t) => {
		if (t.expired) clearTimeout(t.expirationId);
		detachRefs(t.ctrl, ref);
		t.ctrl.stop(true);
	}));
	const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
	const expired = reset && usedTransitions.current || [];
	useLayoutEffect$1(() => each(expired, ({ ctrl, item, key }) => {
		detachRefs(ctrl, ref);
		callProp(onDestroyed, item, key);
	}));
	const reused = [];
	if (prevTransitions) each(prevTransitions, (t, i) => {
		if (t.expired) {
			clearTimeout(t.expirationId);
			expired.push(t);
		} else {
			i = reused[i] = keys.indexOf(t.key);
			if (~i) transitions[i] = t;
		}
	});
	each(items, (item, i) => {
		if (!transitions[i]) {
			transitions[i] = {
				key: keys[i],
				item,
				phase: TransitionPhase.MOUNT,
				ctrl: new Controller$1()
			};
			transitions[i].ctrl.item = item;
		}
	});
	if (reused.length) {
		let i = -1;
		const { leave } = propsFn ? propsFn() : props;
		each(reused, (keyIndex, prevIndex) => {
			const t = prevTransitions[prevIndex];
			if (~keyIndex) {
				i = transitions.indexOf(t);
				transitions[i] = _extends({}, t, { item: items[keyIndex] });
			} else if (leave) transitions.splice(++i, 0, t);
		});
	}
	if (is.fun(sort)) transitions.sort((a, b) => sort(a.item, b.item));
	let delay = -trail;
	const forceUpdate = useForceUpdate();
	const defaultProps = getDefaultProps(props);
	const changes = /* @__PURE__ */ new Map();
	each(transitions, (t, i) => {
		const key = t.key;
		const prevPhase = t.phase;
		const p = propsFn ? propsFn() : props;
		let to;
		let phase;
		let propsDelay = callProp(p.delay || 0, key);
		if (prevPhase == TransitionPhase.MOUNT) {
			to = p.enter;
			phase = TransitionPhase.ENTER;
		} else {
			const isLeave = keys.indexOf(key) < 0;
			if (prevPhase != TransitionPhase.LEAVE) {
				if (isLeave) {
					to = p.leave;
					phase = TransitionPhase.LEAVE;
				} else if (to = p.update) phase = TransitionPhase.UPDATE;
				else return;
			} else if (!isLeave) {
				to = p.enter;
				phase = TransitionPhase.ENTER;
			} else return;
		}
		to = callProp(to, t.item, i);
		to = is.obj(to) ? inferTo(to) : { to };
		if (!to.config) {
			const config = propsConfig || defaultProps.config;
			to.config = callProp(config, t.item, i, phase);
		}
		delay += trail;
		const payload = _extends({}, defaultProps, {
			delay: propsDelay + delay,
			ref: propsRef,
			immediate: p.immediate,
			reset: false
		}, to);
		if (phase == TransitionPhase.ENTER && is.und(payload.from)) {
			const _p = propsFn ? propsFn() : props;
			payload.from = callProp(is.und(_p.initial) || prevTransitions ? _p.from : _p.initial, t.item, i);
		}
		const { onResolve } = payload;
		payload.onResolve = (result) => {
			callProp(onResolve, result);
			const transitions = usedTransitions.current;
			const t = transitions.find((t) => t.key === key);
			if (!t) return;
			if (result.cancelled && t.phase != TransitionPhase.UPDATE) return;
			if (t.ctrl.idle) {
				const idle = transitions.every((t) => t.ctrl.idle);
				if (t.phase == TransitionPhase.LEAVE) {
					const expiry = callProp(expires, t.item);
					if (expiry !== false) {
						const expiryMs = expiry === true ? 0 : expiry;
						t.expired = true;
						if (!idle && expiryMs > 0) {
							if (expiryMs <= 2147483647) t.expirationId = setTimeout(forceUpdate, expiryMs);
							return;
						}
					}
				}
				if (idle && transitions.some((t) => t.expired)) forceUpdate();
			}
		};
		const springs = getSprings(t.ctrl, payload);
		changes.set(t, {
			phase,
			springs,
			payload
		});
	});
	const context = useContext(SpringContext);
	const hasContext = context !== usePrev(context) && hasProps(context);
	useLayoutEffect$1(() => {
		if (hasContext) each(transitions, (t) => {
			t.ctrl.start({ default: context });
		});
	}, [context]);
	useLayoutEffect$1(() => {
		each(changes, ({ phase, payload }, t) => {
			const { ctrl } = t;
			t.phase = phase;
			ref?.add(ctrl);
			if (hasContext && phase == TransitionPhase.ENTER) ctrl.start({ default: context });
			if (payload) {
				replaceRef(ctrl, payload.ref);
				if (ctrl.ref) ctrl.update(payload);
				else ctrl.start(payload);
			}
		});
	}, reset ? void 0 : deps);
	const renderTransitions = (render) => m$3.createElement(m$3.Fragment, null, transitions.map((t, i) => {
		const { springs } = changes.get(t) || t.ctrl;
		const elem = render(_extends({}, springs), t.item, t, i);
		return elem && elem.type ? m$3.createElement(elem.type, _extends({}, elem.props, {
			key: is.str(t.key) || is.num(t.key) ? t.key : t.ctrl.id,
			ref: elem.ref
		})) : elem;
	}));
	return ref ? [renderTransitions, ref] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, { key, keys = key }, prevTransitions) {
	if (keys === null) {
		const reused = /* @__PURE__ */ new Set();
		return items.map((item) => {
			const t = prevTransitions && prevTransitions.find((t) => t.item === item && t.phase !== TransitionPhase.LEAVE && !reused.has(t));
			if (t) {
				reused.add(t);
				return t.key;
			}
			return nextKey++;
		});
	}
	return is.und(keys) ? items : is.fun(keys) ? items.map(keys) : toArray(keys);
}
var Interpolation = class extends FrameValue {
	constructor(source, args) {
		super();
		this.key = void 0;
		this.idle = true;
		this.calc = void 0;
		this._active = /* @__PURE__ */ new Set();
		this.source = source;
		this.calc = createInterpolator(...args);
		const value = this._get();
		const nodeType = getAnimatedType(value);
		setAnimated(this, nodeType.create(value));
	}
	advance(_dt) {
		const value = this._get();
		if (!isEqual(value, this.get())) {
			getAnimated(this).setValue(value);
			this._onChange(value, this.idle);
		}
		if (!this.idle && checkIdle(this._active)) becomeIdle(this);
	}
	_get() {
		const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
		return this.calc(...inputs);
	}
	_start() {
		if (this.idle && !checkIdle(this._active)) {
			this.idle = false;
			each(getPayload(this), (node) => {
				node.done = false;
			});
			if (globals.skipAnimation) {
				raf.batchedUpdates(() => this.advance());
				becomeIdle(this);
			} else frameLoop.start(this);
		}
	}
	_attach() {
		let priority = 1;
		each(toArray(this.source), (source) => {
			if (hasFluidValue(source)) addFluidObserver(source, this);
			if (isFrameValue(source)) {
				if (!source.idle) this._active.add(source);
				priority = Math.max(priority, source.priority + 1);
			}
		});
		this.priority = priority;
		this._start();
	}
	_detach() {
		each(toArray(this.source), (source) => {
			if (hasFluidValue(source)) removeFluidObserver(source, this);
		});
		this._active.clear();
		becomeIdle(this);
	}
	eventObserved(event) {
		if (event.type == "change") {
			if (event.idle) this.advance();
			else {
				this._active.add(event.parent);
				this._start();
			}
		} else if (event.type == "idle") this._active.delete(event.parent);
		else if (event.type == "priority") this.priority = toArray(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
	}
};
function isIdle(source) {
	return source.idle !== false;
}
function checkIdle(active) {
	return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
	if (!self.idle) {
		self.idle = true;
		each(getPayload(self), (node) => {
			node.done = true;
		});
		callFluidObservers(self, {
			type: "idle",
			parent: self
		});
	}
}
var to = (source, ...args) => new Interpolation(source, args);
globals.assign({
	createStringInterpolator,
	to: (source, args) => new Interpolation(source, args)
});
frameLoop.advance;
//#endregion
//#region ../../node_modules/@react-spring/web/dist/react-spring-web.esm.js
function _objectWithoutPropertiesLoose(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source);
	var key, i = 0;
	for (; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) continue;
		target[key] = source[key];
	}
	return target;
}
var _excluded$2 = [
	"style",
	"children",
	"scrollTop",
	"scrollLeft"
];
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
	if (value == null || typeof value === "boolean" || value === "") return "";
	if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px";
	return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
	if (!instance.nodeType || !instance.setAttribute) return false;
	const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
	const _ref = props, { style, children, scrollTop, scrollLeft } = _ref, attributes = _objectWithoutPropertiesLoose(_ref, _excluded$2);
	const values = Object.values(attributes);
	const names = Object.keys(attributes).map((name) => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, (n) => "-" + n.toLowerCase())));
	if (children !== void 0) instance.textContent = children;
	for (let name in style) if (style.hasOwnProperty(name)) {
		const value = dangerousStyleValue(name, style[name]);
		if (isCustomPropRE.test(name)) instance.style.setProperty(name, value);
		else instance.style[name] = value;
	}
	names.forEach((name, i) => {
		instance.setAttribute(name, values[i]);
	});
	if (scrollTop !== void 0) instance.scrollTop = scrollTop;
	if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
}
var isUnitlessNumber = {
	animationIterationCount: true,
	borderImageOutset: true,
	borderImageSlice: true,
	borderImageWidth: true,
	boxFlex: true,
	boxFlexGroup: true,
	boxOrdinalGroup: true,
	columnCount: true,
	columns: true,
	flex: true,
	flexGrow: true,
	flexPositive: true,
	flexShrink: true,
	flexNegative: true,
	flexOrder: true,
	gridRow: true,
	gridRowEnd: true,
	gridRowSpan: true,
	gridRowStart: true,
	gridColumn: true,
	gridColumnEnd: true,
	gridColumnSpan: true,
	gridColumnStart: true,
	fontWeight: true,
	lineClamp: true,
	lineHeight: true,
	opacity: true,
	order: true,
	orphans: true,
	tabSize: true,
	widows: true,
	zIndex: true,
	zoom: true,
	fillOpacity: true,
	floodOpacity: true,
	stopOpacity: true,
	strokeDasharray: true,
	strokeDashoffset: true,
	strokeMiterlimit: true,
	strokeOpacity: true,
	strokeWidth: true
};
var prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes$2 = [
	"Webkit",
	"Ms",
	"Moz",
	"O"
];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
	prefixes$2.forEach((prefix) => acc[prefixKey(prefix, prop)] = acc[prop]);
	return acc;
}, isUnitlessNumber);
var _excluded$1 = [
	"x",
	"y",
	"z"
];
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;
var isValueIdentity = (value, id) => is.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends AnimatedObject {
	constructor(_ref) {
		let { x, y, z } = _ref, style = _objectWithoutPropertiesLoose(_ref, _excluded$1);
		const inputs = [];
		const transforms = [];
		if (x || y || z) {
			inputs.push([
				x || 0,
				y || 0,
				z || 0
			]);
			transforms.push((xyz) => [`translate3d(${xyz.map((v) => addUnit(v, "px")).join(",")})`, isValueIdentity(xyz, 0)]);
		}
		eachProp(style, (value, key) => {
			if (key === "transform") {
				inputs.push([value || ""]);
				transforms.push((transform) => [transform, transform === ""]);
			} else if (domTransforms.test(key)) {
				delete style[key];
				if (is.und(value)) return;
				const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
				inputs.push(toArray(value));
				transforms.push(key === "rotate3d" ? ([x, y, z, deg]) => [`rotate3d(${x},${y},${z},${addUnit(deg, unit)})`, isValueIdentity(deg, 0)] : (input) => [`${key}(${input.map((v) => addUnit(v, unit)).join(",")})`, isValueIdentity(input, key.startsWith("scale") ? 1 : 0)]);
			}
		});
		if (inputs.length) style.transform = new FluidTransform(inputs, transforms);
		super(style);
	}
};
var FluidTransform = class extends FluidValue {
	constructor(inputs, transforms) {
		super();
		this._value = null;
		this.inputs = inputs;
		this.transforms = transforms;
	}
	get() {
		return this._value || (this._value = this._get());
	}
	_get() {
		let transform = "";
		let identity = true;
		each(this.inputs, (input, i) => {
			const arg1 = getFluidValue(input[0]);
			const [t, id] = this.transforms[i](is.arr(arg1) ? arg1 : input.map(getFluidValue));
			transform += " " + t;
			identity = identity && id;
		});
		return identity ? "none" : transform;
	}
	observerAdded(count) {
		if (count == 1) each(this.inputs, (input) => each(input, (value) => hasFluidValue(value) && addFluidObserver(value, this)));
	}
	observerRemoved(count) {
		if (count == 0) each(this.inputs, (input) => each(input, (value) => hasFluidValue(value) && removeFluidObserver(value, this)));
	}
	eventObserved(event) {
		if (event.type == "change") this._value = null;
		callFluidObservers(this, event);
	}
};
var primitives = [
	"a",
	"abbr",
	"address",
	"area",
	"article",
	"aside",
	"audio",
	"b",
	"base",
	"bdi",
	"bdo",
	"big",
	"blockquote",
	"body",
	"br",
	"button",
	"canvas",
	"caption",
	"cite",
	"code",
	"col",
	"colgroup",
	"data",
	"datalist",
	"dd",
	"del",
	"details",
	"dfn",
	"dialog",
	"div",
	"dl",
	"dt",
	"em",
	"embed",
	"fieldset",
	"figcaption",
	"figure",
	"footer",
	"form",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hgroup",
	"hr",
	"html",
	"i",
	"iframe",
	"img",
	"input",
	"ins",
	"kbd",
	"keygen",
	"label",
	"legend",
	"li",
	"link",
	"main",
	"map",
	"mark",
	"menu",
	"menuitem",
	"meta",
	"meter",
	"nav",
	"noscript",
	"object",
	"ol",
	"optgroup",
	"option",
	"output",
	"p",
	"param",
	"picture",
	"pre",
	"progress",
	"q",
	"rp",
	"rt",
	"ruby",
	"s",
	"samp",
	"script",
	"section",
	"select",
	"small",
	"source",
	"span",
	"strong",
	"style",
	"sub",
	"summary",
	"sup",
	"table",
	"tbody",
	"td",
	"textarea",
	"tfoot",
	"th",
	"thead",
	"time",
	"title",
	"tr",
	"track",
	"u",
	"ul",
	"var",
	"video",
	"wbr",
	"circle",
	"clipPath",
	"defs",
	"ellipse",
	"foreignObject",
	"g",
	"image",
	"line",
	"linearGradient",
	"mask",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"radialGradient",
	"rect",
	"stop",
	"svg",
	"text",
	"tspan"
];
var _excluded = ["scrollTop", "scrollLeft"];
globals.assign({
	batchedUpdates: unstable_batchedUpdates,
	createStringInterpolator,
	colors: colors$2
});
var animated = createHost(primitives, {
	applyAnimatedValues,
	createAnimatedStyle: (style) => new AnimatedStyle(style),
	getComponentProps: (_ref) => {
		return _objectWithoutPropertiesLoose(_ref, _excluded);
	}
}).animated;
//#endregion
//#region ../../node_modules/@nivo/tooltip/dist/nivo-tooltip.es.js
function v$3() {
	return v$3 = Object.assign || function(t) {
		for (var o = 1; o < arguments.length; o++) {
			var i = arguments[o];
			for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
		}
		return t;
	}, v$3.apply(this, arguments);
}
var x$2 = {
	pointerEvents: "none",
	position: "absolute",
	zIndex: 10,
	top: 0,
	left: 0
};
var m = function(t, o) {
	return "translate(" + t + "px, " + o + "px)";
};
var g$2 = memo((function(t) {
	var i, n = t.position, r = t.anchor, e = t.children, l = Vt(), d = tt(), p = d.animate, f = d.config, g = Ft(), b = g[0], w = g[1], T = useRef(!1), C = void 0, E = !1, P = w.width > 0 && w.height > 0, N = Math.round(n[0]), V = Math.round(n[1]);
	P && ("top" === r ? (N -= w.width / 2, V -= w.height + 14) : "right" === r ? (N += 14, V -= w.height / 2) : "bottom" === r ? (N -= w.width / 2, V += 14) : "left" === r ? (N -= w.width + 14, V -= w.height / 2) : "center" === r && (N -= w.width / 2, V -= w.height / 2), C = { transform: m(N, V) }, T.current || (E = !0), T.current = [N, V]);
	var j = useSpring({
		to: C,
		config: f,
		immediate: !p || E
	}), O = v$3({}, x$2, l.tooltip, { transform: null != (i = j.transform) ? i : m(N, V) });
	return jsx(animated.div, {
		ref: b,
		style: O,
		children: e
	});
}));
g$2.displayName = "TooltipWrapper";
var b$3 = memo((function(t) {
	var o = t.size, i = void 0 === o ? 12 : o, n = t.color, r = t.style;
	return jsx("span", { style: v$3({
		display: "block",
		width: i,
		height: i,
		background: n
	}, void 0 === r ? {} : r) });
}));
var w$2 = memo((function(t) {
	var o, i = t.id, n = t.value, r = t.format, e = t.enableChip, l = void 0 !== e && e, a = t.color, c = t.renderContent, h = Vt(), u = Xt(r);
	if ("function" == typeof c) o = c();
	else {
		var f = n;
		void 0 !== u && void 0 !== f && (f = u(f)), o = jsxs("div", {
			style: h.tooltip.basic,
			children: [l && jsx(b$3, {
				color: a,
				style: h.tooltip.chip
			}), void 0 !== f ? jsxs("span", { children: [
				i,
				": ",
				jsx("strong", { children: "" + f })
			] }) : i]
		});
	}
	return jsx("div", {
		style: h.tooltip.container,
		children: o
	});
}));
var T$2 = {
	width: "100%",
	borderCollapse: "collapse"
};
var C$3 = memo((function(t) {
	var o, i = t.title, n = t.rows, r = void 0 === n ? [] : n, e = t.renderContent, l = Vt();
	return r.length ? (o = "function" == typeof e ? e() : jsxs("div", { children: [i && i, jsx("table", {
		style: v$3({}, T$2, l.tooltip.table),
		children: jsx("tbody", { children: r.map((function(t, o) {
			return jsx("tr", { children: t.map((function(t, o) {
				return jsx("td", {
					style: l.tooltip.tableCell,
					children: t
				}, o);
			})) }, o);
		})) })
	})] }), jsx("div", {
		style: l.tooltip.container,
		children: o
	})) : null;
}));
C$3.displayName = "TableTooltip";
var E$2 = memo((function(t) {
	var o = t.x0, n = t.x1, r = t.y0, e = t.y1, l = Vt(), u = tt(), d = u.animate, p = u.config, f = useMemo((function() {
		return v$3({}, l.crosshair.line, { pointerEvents: "none" });
	}), [l.crosshair.line]), x = useSpring({
		x1: o,
		x2: n,
		y1: r,
		y2: e,
		config: p,
		immediate: !d
	});
	return jsx(animated.line, v$3({}, x, {
		fill: "none",
		style: f
	}));
}));
E$2.displayName = "CrosshairLine";
var P$2 = memo((function(t) {
	var o, i, n = t.width, r = t.height, e = t.type, l = t.x, a = t.y;
	return "cross" === e ? (o = {
		x0: l,
		x1: l,
		y0: 0,
		y1: r
	}, i = {
		x0: 0,
		x1: n,
		y0: a,
		y1: a
	}) : "top-left" === e ? (o = {
		x0: l,
		x1: l,
		y0: 0,
		y1: a
	}, i = {
		x0: 0,
		x1: l,
		y0: a,
		y1: a
	}) : "top" === e ? o = {
		x0: l,
		x1: l,
		y0: 0,
		y1: a
	} : "top-right" === e ? (o = {
		x0: l,
		x1: l,
		y0: 0,
		y1: a
	}, i = {
		x0: l,
		x1: n,
		y0: a,
		y1: a
	}) : "right" === e ? i = {
		x0: l,
		x1: n,
		y0: a,
		y1: a
	} : "bottom-right" === e ? (o = {
		x0: l,
		x1: l,
		y0: a,
		y1: r
	}, i = {
		x0: l,
		x1: n,
		y0: a,
		y1: a
	}) : "bottom" === e ? o = {
		x0: l,
		x1: l,
		y0: a,
		y1: r
	} : "bottom-left" === e ? (o = {
		x0: l,
		x1: l,
		y0: a,
		y1: r
	}, i = {
		x0: 0,
		x1: l,
		y0: a,
		y1: a
	}) : "left" === e ? i = {
		x0: 0,
		x1: l,
		y0: a,
		y1: a
	} : "x" === e ? o = {
		x0: l,
		x1: l,
		y0: 0,
		y1: r
	} : "y" === e && (i = {
		x0: 0,
		x1: n,
		y0: a,
		y1: a
	}), jsxs(Fragment$1, { children: [o && jsx(E$2, {
		x0: o.x0,
		x1: o.x1,
		y0: o.y0,
		y1: o.y1
	}), i && jsx(E$2, {
		x0: i.x0,
		x1: i.x1,
		y0: i.y0,
		y1: i.y1
	})] });
}));
P$2.displayName = "Crosshair";
var N$1 = createContext({
	showTooltipAt: function() {},
	showTooltipFromEvent: function() {},
	hideTooltip: function() {}
});
var V$1 = {
	isVisible: !1,
	position: [null, null],
	content: null,
	anchor: null
};
var j$2 = createContext(V$1);
var O$2 = function(t) {
	var o = useState(V$1), n = o[0], l = o[1], a = useCallback((function(t, o, i) {
		var n = o[0], r = o[1];
		void 0 === i && (i = "top"), l({
			isVisible: !0,
			position: [n, r],
			anchor: i,
			content: t
		});
	}), [l]), c = useCallback((function(o, i, n) {
		void 0 === n && (n = "top");
		var r = t.current.getBoundingClientRect(), e = i.clientX - r.left, a = i.clientY - r.top;
		"left" !== n && "right" !== n || (n = e < r.width / 2 ? "right" : "left"), l({
			isVisible: !0,
			position: [e, a],
			anchor: n,
			content: o
		});
	}), [t, l]), s = useCallback((function() {
		l(V$1);
	}), [l]);
	return {
		actions: useMemo((function() {
			return {
				showTooltipAt: a,
				showTooltipFromEvent: c,
				hideTooltip: s
			};
		}), [
			a,
			c,
			s
		]),
		state: n
	};
};
var k$1 = function() {
	var t = useContext(N$1);
	if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
	return t;
};
var z$2 = function() {
	var t = useContext(j$2);
	if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
	return t;
};
var A$3 = function(t) {
	return t.isVisible;
};
var F = function() {
	var t = z$2();
	return A$3(t) ? jsx(g$2, {
		position: t.position,
		anchor: t.anchor,
		children: t.content
	}) : null;
};
var M = function(t) {
	var o = t.container, i = t.children, n = O$2(o), r = n.actions, e = n.state;
	return jsx(N$1.Provider, {
		value: r,
		children: jsx(j$2.Provider, {
			value: e,
			children: i
		})
	});
};
//#endregion
//#region ../../node_modules/lodash/_listCacheClear.js
var require__listCacheClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Removes all key-value entries from the list cache.
	*
	* @private
	* @name clear
	* @memberOf ListCache
	*/
	function listCacheClear() {
		this.__data__ = [];
		this.size = 0;
	}
	module.exports = listCacheClear;
}));
//#endregion
//#region ../../node_modules/lodash/eq.js
var require_eq = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Performs a
	* [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	* comparison between two values to determine if they are equivalent.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to compare.
	* @param {*} other The other value to compare.
	* @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	* @example
	*
	* var object = { 'a': 1 };
	* var other = { 'a': 1 };
	*
	* _.eq(object, object);
	* // => true
	*
	* _.eq(object, other);
	* // => false
	*
	* _.eq('a', 'a');
	* // => true
	*
	* _.eq('a', Object('a'));
	* // => false
	*
	* _.eq(NaN, NaN);
	* // => true
	*/
	function eq(value, other) {
		return value === other || value !== value && other !== other;
	}
	module.exports = eq;
}));
//#endregion
//#region ../../node_modules/lodash/_assocIndexOf.js
var require__assocIndexOf = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var eq = require_eq();
	/**
	* Gets the index at which the `key` is found in `array` of key-value pairs.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {*} key The key to search for.
	* @returns {number} Returns the index of the matched value, else `-1`.
	*/
	function assocIndexOf(array, key) {
		var length = array.length;
		while (length--) if (eq(array[length][0], key)) return length;
		return -1;
	}
	module.exports = assocIndexOf;
}));
//#endregion
//#region ../../node_modules/lodash/_listCacheDelete.js
var require__listCacheDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/** Built-in value references. */
	var splice = Array.prototype.splice;
	/**
	* Removes `key` and its value from the list cache.
	*
	* @private
	* @name delete
	* @memberOf ListCache
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function listCacheDelete(key) {
		var data = this.__data__, index = assocIndexOf(data, key);
		if (index < 0) return false;
		if (index == data.length - 1) data.pop();
		else splice.call(data, index, 1);
		--this.size;
		return true;
	}
	module.exports = listCacheDelete;
}));
//#endregion
//#region ../../node_modules/lodash/_listCacheGet.js
var require__listCacheGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/**
	* Gets the list cache value for `key`.
	*
	* @private
	* @name get
	* @memberOf ListCache
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function listCacheGet(key) {
		var data = this.__data__, index = assocIndexOf(data, key);
		return index < 0 ? void 0 : data[index][1];
	}
	module.exports = listCacheGet;
}));
//#endregion
//#region ../../node_modules/lodash/_listCacheHas.js
var require__listCacheHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/**
	* Checks if a list cache value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf ListCache
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function listCacheHas(key) {
		return assocIndexOf(this.__data__, key) > -1;
	}
	module.exports = listCacheHas;
}));
//#endregion
//#region ../../node_modules/lodash/_listCacheSet.js
var require__listCacheSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/**
	* Sets the list cache `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf ListCache
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the list cache instance.
	*/
	function listCacheSet(key, value) {
		var data = this.__data__, index = assocIndexOf(data, key);
		if (index < 0) {
			++this.size;
			data.push([key, value]);
		} else data[index][1] = value;
		return this;
	}
	module.exports = listCacheSet;
}));
//#endregion
//#region ../../node_modules/lodash/_ListCache.js
var require__ListCache = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var listCacheClear = require__listCacheClear();
	var listCacheDelete = require__listCacheDelete();
	var listCacheGet = require__listCacheGet();
	var listCacheHas = require__listCacheHas();
	var listCacheSet = require__listCacheSet();
	/**
	* Creates an list cache object.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function ListCache(entries) {
		var index = -1, length = entries == null ? 0 : entries.length;
		this.clear();
		while (++index < length) {
			var entry = entries[index];
			this.set(entry[0], entry[1]);
		}
	}
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype["delete"] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	module.exports = ListCache;
}));
//#endregion
//#region ../../node_modules/lodash/_stackClear.js
var require__stackClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ListCache = require__ListCache();
	/**
	* Removes all key-value entries from the stack.
	*
	* @private
	* @name clear
	* @memberOf Stack
	*/
	function stackClear() {
		this.__data__ = new ListCache();
		this.size = 0;
	}
	module.exports = stackClear;
}));
//#endregion
//#region ../../node_modules/lodash/_stackDelete.js
var require__stackDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Removes `key` and its value from the stack.
	*
	* @private
	* @name delete
	* @memberOf Stack
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function stackDelete(key) {
		var data = this.__data__, result = data["delete"](key);
		this.size = data.size;
		return result;
	}
	module.exports = stackDelete;
}));
//#endregion
//#region ../../node_modules/lodash/_stackGet.js
var require__stackGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Gets the stack value for `key`.
	*
	* @private
	* @name get
	* @memberOf Stack
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function stackGet(key) {
		return this.__data__.get(key);
	}
	module.exports = stackGet;
}));
//#endregion
//#region ../../node_modules/lodash/_stackHas.js
var require__stackHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if a stack value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf Stack
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function stackHas(key) {
		return this.__data__.has(key);
	}
	module.exports = stackHas;
}));
//#endregion
//#region ../../node_modules/lodash/_freeGlobal.js
var require__freeGlobal = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = typeof global == "object" && global && global.Object === Object && global;
}));
//#endregion
//#region ../../node_modules/lodash/_root.js
var require__root = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var freeGlobal = require__freeGlobal();
	/** Detect free variable `self`. */
	var freeSelf = typeof self == "object" && self && self.Object === Object && self;
	module.exports = freeGlobal || freeSelf || Function("return this")();
}));
//#endregion
//#region ../../node_modules/lodash/_Symbol.js
var require__Symbol = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__root().Symbol;
}));
//#endregion
//#region ../../node_modules/lodash/_getRawTag.js
var require__getRawTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	/**
	* Used to resolve the
	* [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	* of values.
	*/
	var nativeObjectToString = objectProto.toString;
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
	/**
	* A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	*
	* @private
	* @param {*} value The value to query.
	* @returns {string} Returns the raw `toStringTag`.
	*/
	function getRawTag(value) {
		var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
		try {
			value[symToStringTag] = void 0;
			var unmasked = true;
		} catch (e) {}
		var result = nativeObjectToString.call(value);
		if (unmasked) {
			if (isOwn) value[symToStringTag] = tag;
			else delete value[symToStringTag];
		}
		return result;
	}
	module.exports = getRawTag;
}));
//#endregion
//#region ../../node_modules/lodash/_objectToString.js
var require__objectToString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Used to resolve the
	* [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	* of values.
	*/
	var nativeObjectToString = Object.prototype.toString;
	/**
	* Converts `value` to a string using `Object.prototype.toString`.
	*
	* @private
	* @param {*} value The value to convert.
	* @returns {string} Returns the converted string.
	*/
	function objectToString(value) {
		return nativeObjectToString.call(value);
	}
	module.exports = objectToString;
}));
//#endregion
//#region ../../node_modules/lodash/_baseGetTag.js
var require__baseGetTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	var getRawTag = require__getRawTag();
	var objectToString = require__objectToString();
	/** `Object#toString` result references. */
	var nullTag = "[object Null]";
	var undefinedTag = "[object Undefined]";
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
	/**
	* The base implementation of `getTag` without fallbacks for buggy environments.
	*
	* @private
	* @param {*} value The value to query.
	* @returns {string} Returns the `toStringTag`.
	*/
	function baseGetTag(value) {
		if (value == null) return value === void 0 ? undefinedTag : nullTag;
		return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
	}
	module.exports = baseGetTag;
}));
//#endregion
//#region ../../node_modules/lodash/isObject.js
var require_isObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is the
	* [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	* of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is an object, else `false`.
	* @example
	*
	* _.isObject({});
	* // => true
	*
	* _.isObject([1, 2, 3]);
	* // => true
	*
	* _.isObject(_.noop);
	* // => true
	*
	* _.isObject(null);
	* // => false
	*/
	function isObject(value) {
		var type = typeof value;
		return value != null && (type == "object" || type == "function");
	}
	module.exports = isObject;
}));
//#endregion
//#region ../../node_modules/lodash/isFunction.js
var require_isFunction = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObject = require_isObject();
	/** `Object#toString` result references. */
	var asyncTag = "[object AsyncFunction]";
	var funcTag = "[object Function]";
	var genTag = "[object GeneratorFunction]";
	var proxyTag = "[object Proxy]";
	/**
	* Checks if `value` is classified as a `Function` object.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a function, else `false`.
	* @example
	*
	* _.isFunction(_);
	* // => true
	*
	* _.isFunction(/abc/);
	* // => false
	*/
	function isFunction(value) {
		if (!isObject(value)) return false;
		var tag = baseGetTag(value);
		return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	module.exports = isFunction;
}));
//#endregion
//#region ../../node_modules/lodash/_coreJsData.js
var require__coreJsData = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__root()["__core-js_shared__"];
}));
//#endregion
//#region ../../node_modules/lodash/_isMasked.js
var require__isMasked = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var coreJsData = require__coreJsData();
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = function() {
		var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
		return uid ? "Symbol(src)_1." + uid : "";
	}();
	/**
	* Checks if `func` has its source masked.
	*
	* @private
	* @param {Function} func The function to check.
	* @returns {boolean} Returns `true` if `func` is masked, else `false`.
	*/
	function isMasked(func) {
		return !!maskSrcKey && maskSrcKey in func;
	}
	module.exports = isMasked;
}));
//#endregion
//#region ../../node_modules/lodash/_toSource.js
var require__toSource = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	/**
	* Converts `func` to its source code.
	*
	* @private
	* @param {Function} func The function to convert.
	* @returns {string} Returns the source code.
	*/
	function toSource(func) {
		if (func != null) {
			try {
				return funcToString.call(func);
			} catch (e) {}
			try {
				return func + "";
			} catch (e) {}
		}
		return "";
	}
	module.exports = toSource;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsNative.js
var require__baseIsNative = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isFunction = require_isFunction();
	var isMasked = require__isMasked();
	var isObject = require_isObject();
	var toSource = require__toSource();
	/**
	* Used to match `RegExp`
	* [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	*/
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	var objectProto = Object.prototype;
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	/** Used to detect if a method is native. */
	var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
	/**
	* The base implementation of `_.isNative` without bad shim checks.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a native function,
	*  else `false`.
	*/
	function baseIsNative(value) {
		if (!isObject(value) || isMasked(value)) return false;
		return (isFunction(value) ? reIsNative : reIsHostCtor).test(toSource(value));
	}
	module.exports = baseIsNative;
}));
//#endregion
//#region ../../node_modules/lodash/_getValue.js
var require__getValue = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Gets the value at `key` of `object`.
	*
	* @private
	* @param {Object} [object] The object to query.
	* @param {string} key The key of the property to get.
	* @returns {*} Returns the property value.
	*/
	function getValue(object, key) {
		return object == null ? void 0 : object[key];
	}
	module.exports = getValue;
}));
//#endregion
//#region ../../node_modules/lodash/_getNative.js
var require__getNative = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsNative = require__baseIsNative();
	var getValue = require__getValue();
	/**
	* Gets the native function at `key` of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {string} key The key of the method to get.
	* @returns {*} Returns the function if it's native, else `undefined`.
	*/
	function getNative(object, key) {
		var value = getValue(object, key);
		return baseIsNative(value) ? value : void 0;
	}
	module.exports = getNative;
}));
//#endregion
//#region ../../node_modules/lodash/_Map.js
var require__Map = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(require__root(), "Map");
}));
//#endregion
//#region ../../node_modules/lodash/_nativeCreate.js
var require__nativeCreate = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(Object, "create");
}));
//#endregion
//#region ../../node_modules/lodash/_hashClear.js
var require__hashClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/**
	* Removes all key-value entries from the hash.
	*
	* @private
	* @name clear
	* @memberOf Hash
	*/
	function hashClear() {
		this.__data__ = nativeCreate ? nativeCreate(null) : {};
		this.size = 0;
	}
	module.exports = hashClear;
}));
//#endregion
//#region ../../node_modules/lodash/_hashDelete.js
var require__hashDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Removes `key` and its value from the hash.
	*
	* @private
	* @name delete
	* @memberOf Hash
	* @param {Object} hash The hash to modify.
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function hashDelete(key) {
		var result = this.has(key) && delete this.__data__[key];
		this.size -= result ? 1 : 0;
		return result;
	}
	module.exports = hashDelete;
}));
//#endregion
//#region ../../node_modules/lodash/_hashGet.js
var require__hashGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = "__lodash_hash_undefined__";
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Gets the hash value for `key`.
	*
	* @private
	* @name get
	* @memberOf Hash
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function hashGet(key) {
		var data = this.__data__;
		if (nativeCreate) {
			var result = data[key];
			return result === HASH_UNDEFINED ? void 0 : result;
		}
		return hasOwnProperty.call(data, key) ? data[key] : void 0;
	}
	module.exports = hashGet;
}));
//#endregion
//#region ../../node_modules/lodash/_hashHas.js
var require__hashHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Checks if a hash value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf Hash
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function hashHas(key) {
		var data = this.__data__;
		return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
	}
	module.exports = hashHas;
}));
//#endregion
//#region ../../node_modules/lodash/_hashSet.js
var require__hashSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = "__lodash_hash_undefined__";
	/**
	* Sets the hash `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf Hash
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the hash instance.
	*/
	function hashSet(key, value) {
		var data = this.__data__;
		this.size += this.has(key) ? 0 : 1;
		data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
		return this;
	}
	module.exports = hashSet;
}));
//#endregion
//#region ../../node_modules/lodash/_Hash.js
var require__Hash = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var hashClear = require__hashClear();
	var hashDelete = require__hashDelete();
	var hashGet = require__hashGet();
	var hashHas = require__hashHas();
	var hashSet = require__hashSet();
	/**
	* Creates a hash object.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function Hash(entries) {
		var index = -1, length = entries == null ? 0 : entries.length;
		this.clear();
		while (++index < length) {
			var entry = entries[index];
			this.set(entry[0], entry[1]);
		}
	}
	Hash.prototype.clear = hashClear;
	Hash.prototype["delete"] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	module.exports = Hash;
}));
//#endregion
//#region ../../node_modules/lodash/_mapCacheClear.js
var require__mapCacheClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Hash = require__Hash();
	var ListCache = require__ListCache();
	var Map = require__Map();
	/**
	* Removes all key-value entries from the map.
	*
	* @private
	* @name clear
	* @memberOf MapCache
	*/
	function mapCacheClear() {
		this.size = 0;
		this.__data__ = {
			"hash": new Hash(),
			"map": new (Map || ListCache)(),
			"string": new Hash()
		};
	}
	module.exports = mapCacheClear;
}));
//#endregion
//#region ../../node_modules/lodash/_isKeyable.js
var require__isKeyable = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is suitable for use as unique object key.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	*/
	function isKeyable(value) {
		var type = typeof value;
		return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
	}
	module.exports = isKeyable;
}));
//#endregion
//#region ../../node_modules/lodash/_getMapData.js
var require__getMapData = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isKeyable = require__isKeyable();
	/**
	* Gets the data for `map`.
	*
	* @private
	* @param {Object} map The map to query.
	* @param {string} key The reference key.
	* @returns {*} Returns the map data.
	*/
	function getMapData(map, key) {
		var data = map.__data__;
		return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
	}
	module.exports = getMapData;
}));
//#endregion
//#region ../../node_modules/lodash/_mapCacheDelete.js
var require__mapCacheDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Removes `key` and its value from the map.
	*
	* @private
	* @name delete
	* @memberOf MapCache
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function mapCacheDelete(key) {
		var result = getMapData(this, key)["delete"](key);
		this.size -= result ? 1 : 0;
		return result;
	}
	module.exports = mapCacheDelete;
}));
//#endregion
//#region ../../node_modules/lodash/_mapCacheGet.js
var require__mapCacheGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Gets the map value for `key`.
	*
	* @private
	* @name get
	* @memberOf MapCache
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function mapCacheGet(key) {
		return getMapData(this, key).get(key);
	}
	module.exports = mapCacheGet;
}));
//#endregion
//#region ../../node_modules/lodash/_mapCacheHas.js
var require__mapCacheHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Checks if a map value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf MapCache
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function mapCacheHas(key) {
		return getMapData(this, key).has(key);
	}
	module.exports = mapCacheHas;
}));
//#endregion
//#region ../../node_modules/lodash/_mapCacheSet.js
var require__mapCacheSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Sets the map `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf MapCache
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the map cache instance.
	*/
	function mapCacheSet(key, value) {
		var data = getMapData(this, key), size = data.size;
		data.set(key, value);
		this.size += data.size == size ? 0 : 1;
		return this;
	}
	module.exports = mapCacheSet;
}));
//#endregion
//#region ../../node_modules/lodash/_MapCache.js
var require__MapCache = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var mapCacheClear = require__mapCacheClear();
	var mapCacheDelete = require__mapCacheDelete();
	var mapCacheGet = require__mapCacheGet();
	var mapCacheHas = require__mapCacheHas();
	var mapCacheSet = require__mapCacheSet();
	/**
	* Creates a map cache object to store key-value pairs.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function MapCache(entries) {
		var index = -1, length = entries == null ? 0 : entries.length;
		this.clear();
		while (++index < length) {
			var entry = entries[index];
			this.set(entry[0], entry[1]);
		}
	}
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype["delete"] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	module.exports = MapCache;
}));
//#endregion
//#region ../../node_modules/lodash/_stackSet.js
var require__stackSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ListCache = require__ListCache();
	var Map = require__Map();
	var MapCache = require__MapCache();
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	/**
	* Sets the stack `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf Stack
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the stack cache instance.
	*/
	function stackSet(key, value) {
		var data = this.__data__;
		if (data instanceof ListCache) {
			var pairs = data.__data__;
			if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
				pairs.push([key, value]);
				this.size = ++data.size;
				return this;
			}
			data = this.__data__ = new MapCache(pairs);
		}
		data.set(key, value);
		this.size = data.size;
		return this;
	}
	module.exports = stackSet;
}));
//#endregion
//#region ../../node_modules/lodash/_Stack.js
var require__Stack = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ListCache = require__ListCache();
	var stackClear = require__stackClear();
	var stackDelete = require__stackDelete();
	var stackGet = require__stackGet();
	var stackHas = require__stackHas();
	var stackSet = require__stackSet();
	/**
	* Creates a stack cache object to store key-value pairs.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function Stack(entries) {
		var data = this.__data__ = new ListCache(entries);
		this.size = data.size;
	}
	Stack.prototype.clear = stackClear;
	Stack.prototype["delete"] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	module.exports = Stack;
}));
//#endregion
//#region ../../node_modules/lodash/_defineProperty.js
var require__defineProperty = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getNative = require__getNative();
	module.exports = function() {
		try {
			var func = getNative(Object, "defineProperty");
			func({}, "", {});
			return func;
		} catch (e) {}
	}();
}));
//#endregion
//#region ../../node_modules/lodash/_baseAssignValue.js
var require__baseAssignValue = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var defineProperty = require__defineProperty();
	/**
	* The base implementation of `assignValue` and `assignMergeValue` without
	* value checks.
	*
	* @private
	* @param {Object} object The object to modify.
	* @param {string} key The key of the property to assign.
	* @param {*} value The value to assign.
	*/
	function baseAssignValue(object, key, value) {
		if (key == "__proto__" && defineProperty) defineProperty(object, key, {
			"configurable": true,
			"enumerable": true,
			"value": value,
			"writable": true
		});
		else object[key] = value;
	}
	module.exports = baseAssignValue;
}));
//#endregion
//#region ../../node_modules/lodash/_assignMergeValue.js
var require__assignMergeValue = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseAssignValue = require__baseAssignValue();
	var eq = require_eq();
	/**
	* This function is like `assignValue` except that it doesn't assign
	* `undefined` values.
	*
	* @private
	* @param {Object} object The object to modify.
	* @param {string} key The key of the property to assign.
	* @param {*} value The value to assign.
	*/
	function assignMergeValue(object, key, value) {
		if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) baseAssignValue(object, key, value);
	}
	module.exports = assignMergeValue;
}));
//#endregion
//#region ../../node_modules/lodash/_createBaseFor.js
var require__createBaseFor = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Creates a base function for methods like `_.forIn` and `_.forOwn`.
	*
	* @private
	* @param {boolean} [fromRight] Specify iterating from right to left.
	* @returns {Function} Returns the new base function.
	*/
	function createBaseFor(fromRight) {
		return function(object, iteratee, keysFunc) {
			var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
			while (length--) {
				var key = props[fromRight ? length : ++index];
				if (iteratee(iterable[key], key, iterable) === false) break;
			}
			return object;
		};
	}
	module.exports = createBaseFor;
}));
//#endregion
//#region ../../node_modules/lodash/_baseFor.js
var require__baseFor = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__createBaseFor()();
}));
//#endregion
//#region ../../node_modules/lodash/_cloneBuffer.js
var require__cloneBuffer = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var root = require__root();
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
	/** Built-in value references. */
	var Buffer = freeModule && freeModule.exports === freeExports ? root.Buffer : void 0;
	var allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
	/**
	* Creates a clone of  `buffer`.
	*
	* @private
	* @param {Buffer} buffer The buffer to clone.
	* @param {boolean} [isDeep] Specify a deep clone.
	* @returns {Buffer} Returns the cloned buffer.
	*/
	function cloneBuffer(buffer, isDeep) {
		if (isDeep) return buffer.slice();
		var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
		buffer.copy(result);
		return result;
	}
	module.exports = cloneBuffer;
}));
//#endregion
//#region ../../node_modules/lodash/_Uint8Array.js
var require__Uint8Array = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__root().Uint8Array;
}));
//#endregion
//#region ../../node_modules/lodash/_cloneArrayBuffer.js
var require__cloneArrayBuffer = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Uint8Array = require__Uint8Array();
	/**
	* Creates a clone of `arrayBuffer`.
	*
	* @private
	* @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	* @returns {ArrayBuffer} Returns the cloned array buffer.
	*/
	function cloneArrayBuffer(arrayBuffer) {
		var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		return result;
	}
	module.exports = cloneArrayBuffer;
}));
//#endregion
//#region ../../node_modules/lodash/_cloneTypedArray.js
var require__cloneTypedArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var cloneArrayBuffer = require__cloneArrayBuffer();
	/**
	* Creates a clone of `typedArray`.
	*
	* @private
	* @param {Object} typedArray The typed array to clone.
	* @param {boolean} [isDeep] Specify a deep clone.
	* @returns {Object} Returns the cloned typed array.
	*/
	function cloneTypedArray(typedArray, isDeep) {
		var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
		return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	module.exports = cloneTypedArray;
}));
//#endregion
//#region ../../node_modules/lodash/_copyArray.js
var require__copyArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copies the values of `source` to `array`.
	*
	* @private
	* @param {Array} source The array to copy values from.
	* @param {Array} [array=[]] The array to copy values to.
	* @returns {Array} Returns `array`.
	*/
	function copyArray(source, array) {
		var index = -1, length = source.length;
		array || (array = Array(length));
		while (++index < length) array[index] = source[index];
		return array;
	}
	module.exports = copyArray;
}));
//#endregion
//#region ../../node_modules/lodash/_baseCreate.js
var require__baseCreate = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isObject = require_isObject();
	/** Built-in value references. */
	var objectCreate = Object.create;
	module.exports = function() {
		function object() {}
		return function(proto) {
			if (!isObject(proto)) return {};
			if (objectCreate) return objectCreate(proto);
			object.prototype = proto;
			var result = new object();
			object.prototype = void 0;
			return result;
		};
	}();
}));
//#endregion
//#region ../../node_modules/lodash/_overArg.js
var require__overArg = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Creates a unary function that invokes `func` with its argument transformed.
	*
	* @private
	* @param {Function} func The function to wrap.
	* @param {Function} transform The argument transform.
	* @returns {Function} Returns the new function.
	*/
	function overArg(func, transform) {
		return function(arg) {
			return func(transform(arg));
		};
	}
	module.exports = overArg;
}));
//#endregion
//#region ../../node_modules/lodash/_getPrototype.js
var require__getPrototype = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__overArg()(Object.getPrototypeOf, Object);
}));
//#endregion
//#region ../../node_modules/lodash/_isPrototype.js
var require__isPrototype = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	/**
	* Checks if `value` is likely a prototype object.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	*/
	function isPrototype(value) {
		var Ctor = value && value.constructor;
		return value === (typeof Ctor == "function" && Ctor.prototype || objectProto);
	}
	module.exports = isPrototype;
}));
//#endregion
//#region ../../node_modules/lodash/_initCloneObject.js
var require__initCloneObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseCreate = require__baseCreate();
	var getPrototype = require__getPrototype();
	var isPrototype = require__isPrototype();
	/**
	* Initializes an object clone.
	*
	* @private
	* @param {Object} object The object to clone.
	* @returns {Object} Returns the initialized clone.
	*/
	function initCloneObject(object) {
		return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
	}
	module.exports = initCloneObject;
}));
//#endregion
//#region ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is object-like. A value is object-like if it's not `null`
	* and has a `typeof` result of "object".
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	* @example
	*
	* _.isObjectLike({});
	* // => true
	*
	* _.isObjectLike([1, 2, 3]);
	* // => true
	*
	* _.isObjectLike(_.noop);
	* // => false
	*
	* _.isObjectLike(null);
	* // => false
	*/
	function isObjectLike(value) {
		return value != null && typeof value == "object";
	}
	module.exports = isObjectLike;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsArguments.js
var require__baseIsArguments = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var argsTag = "[object Arguments]";
	/**
	* The base implementation of `_.isArguments`.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is an `arguments` object,
	*/
	function baseIsArguments(value) {
		return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	module.exports = baseIsArguments;
}));
//#endregion
//#region ../../node_modules/lodash/isArguments.js
var require_isArguments = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsArguments = require__baseIsArguments();
	var isObjectLike = require_isObjectLike();
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	module.exports = baseIsArguments(function() {
		return arguments;
	}()) ? baseIsArguments : function(value) {
		return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
	};
}));
//#endregion
//#region ../../node_modules/lodash/isArray.js
var require_isArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = Array.isArray;
}));
//#endregion
//#region ../../node_modules/lodash/isLength.js
var require_isLength = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	* Checks if `value` is a valid array-like length.
	*
	* **Note:** This method is loosely based on
	* [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	* @example
	*
	* _.isLength(3);
	* // => true
	*
	* _.isLength(Number.MIN_VALUE);
	* // => false
	*
	* _.isLength(Infinity);
	* // => false
	*
	* _.isLength('3');
	* // => false
	*/
	function isLength(value) {
		return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	module.exports = isLength;
}));
//#endregion
//#region ../../node_modules/lodash/isArrayLike.js
var require_isArrayLike = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isFunction = require_isFunction();
	var isLength = require_isLength();
	/**
	* Checks if `value` is array-like. A value is considered array-like if it's
	* not a function and has a `value.length` that's an integer greater than or
	* equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	* @example
	*
	* _.isArrayLike([1, 2, 3]);
	* // => true
	*
	* _.isArrayLike(document.body.children);
	* // => true
	*
	* _.isArrayLike('abc');
	* // => true
	*
	* _.isArrayLike(_.noop);
	* // => false
	*/
	function isArrayLike(value) {
		return value != null && isLength(value.length) && !isFunction(value);
	}
	module.exports = isArrayLike;
}));
//#endregion
//#region ../../node_modules/lodash/isArrayLikeObject.js
var require_isArrayLikeObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isArrayLike = require_isArrayLike();
	var isObjectLike = require_isObjectLike();
	/**
	* This method is like `_.isArrayLike` except that it also checks if `value`
	* is an object.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is an array-like object,
	*  else `false`.
	* @example
	*
	* _.isArrayLikeObject([1, 2, 3]);
	* // => true
	*
	* _.isArrayLikeObject(document.body.children);
	* // => true
	*
	* _.isArrayLikeObject('abc');
	* // => false
	*
	* _.isArrayLikeObject(_.noop);
	* // => false
	*/
	function isArrayLikeObject(value) {
		return isObjectLike(value) && isArrayLike(value);
	}
	module.exports = isArrayLikeObject;
}));
//#endregion
//#region ../../node_modules/lodash/stubFalse.js
var require_stubFalse = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This method returns `false`.
	*
	* @static
	* @memberOf _
	* @since 4.13.0
	* @category Util
	* @returns {boolean} Returns `false`.
	* @example
	*
	* _.times(2, _.stubFalse);
	* // => [false, false]
	*/
	function stubFalse() {
		return false;
	}
	module.exports = stubFalse;
}));
//#endregion
//#region ../../node_modules/lodash/isBuffer.js
var require_isBuffer = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var root = require__root();
	var stubFalse = require_stubFalse();
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
	/** Built-in value references. */
	var Buffer = freeModule && freeModule.exports === freeExports ? root.Buffer : void 0;
	module.exports = (Buffer ? Buffer.isBuffer : void 0) || stubFalse;
}));
//#endregion
//#region ../../node_modules/lodash/isPlainObject.js
var require_isPlainObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var getPrototype = require__getPrototype();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var objectTag = "[object Object]";
	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	var objectProto = Object.prototype;
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	/**
	* Checks if `value` is a plain object, that is, an object created by the
	* `Object` constructor or one with a `[[Prototype]]` of `null`.
	*
	* @static
	* @memberOf _
	* @since 0.8.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	* @example
	*
	* function Foo() {
	*   this.a = 1;
	* }
	*
	* _.isPlainObject(new Foo);
	* // => false
	*
	* _.isPlainObject([1, 2, 3]);
	* // => false
	*
	* _.isPlainObject({ 'x': 0, 'y': 0 });
	* // => true
	*
	* _.isPlainObject(Object.create(null));
	* // => true
	*/
	function isPlainObject(value) {
		if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
		var proto = getPrototype(value);
		if (proto === null) return true;
		var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
		return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
	}
	module.exports = isPlainObject;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsTypedArray.js
var require__baseIsTypedArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isLength = require_isLength();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var argsTag = "[object Arguments]";
	var arrayTag = "[object Array]";
	var boolTag = "[object Boolean]";
	var dateTag = "[object Date]";
	var errorTag = "[object Error]";
	var funcTag = "[object Function]";
	var mapTag = "[object Map]";
	var numberTag = "[object Number]";
	var objectTag = "[object Object]";
	var regexpTag = "[object RegExp]";
	var setTag = "[object Set]";
	var stringTag = "[object String]";
	var weakMapTag = "[object WeakMap]";
	var arrayBufferTag = "[object ArrayBuffer]";
	var dataViewTag = "[object DataView]";
	var float32Tag = "[object Float32Array]";
	var float64Tag = "[object Float64Array]";
	var int8Tag = "[object Int8Array]";
	var int16Tag = "[object Int16Array]";
	var int32Tag = "[object Int32Array]";
	var uint8Tag = "[object Uint8Array]";
	var uint8ClampedTag = "[object Uint8ClampedArray]";
	var uint16Tag = "[object Uint16Array]";
	var uint32Tag = "[object Uint32Array]";
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	/**
	* The base implementation of `_.isTypedArray` without Node.js optimizations.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	*/
	function baseIsTypedArray(value) {
		return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	module.exports = baseIsTypedArray;
}));
//#endregion
//#region ../../node_modules/lodash/_baseUnary.js
var require__baseUnary = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.unary` without support for storing metadata.
	*
	* @private
	* @param {Function} func The function to cap arguments for.
	* @returns {Function} Returns the new capped function.
	*/
	function baseUnary(func) {
		return function(value) {
			return func(value);
		};
	}
	module.exports = baseUnary;
}));
//#endregion
//#region ../../node_modules/lodash/_nodeUtil.js
var require__nodeUtil = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var freeGlobal = require__freeGlobal();
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
	/** Detect free variable `process` from Node.js. */
	var freeProcess = freeModule && freeModule.exports === freeExports && freeGlobal.process;
	module.exports = function() {
		try {
			var types = freeModule && freeModule.require && freeModule.require("util").types;
			if (types) return types;
			return freeProcess && freeProcess.binding && freeProcess.binding("util");
		} catch (e) {}
	}();
}));
//#endregion
//#region ../../node_modules/lodash/isTypedArray.js
var require_isTypedArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsTypedArray = require__baseIsTypedArray();
	var baseUnary = require__baseUnary();
	var nodeUtil = require__nodeUtil();
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	module.exports = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
}));
//#endregion
//#region ../../node_modules/lodash/_safeGet.js
var require__safeGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	*
	* @private
	* @param {Object} object The object to query.
	* @param {string} key The key of the property to get.
	* @returns {*} Returns the property value.
	*/
	function safeGet(object, key) {
		if (key === "constructor" && typeof object[key] === "function") return;
		if (key == "__proto__") return;
		return object[key];
	}
	module.exports = safeGet;
}));
//#endregion
//#region ../../node_modules/lodash/_assignValue.js
var require__assignValue = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseAssignValue = require__baseAssignValue();
	var eq = require_eq();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Assigns `value` to `key` of `object` if the existing value is not equivalent
	* using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	* for equality comparisons.
	*
	* @private
	* @param {Object} object The object to modify.
	* @param {string} key The key of the property to assign.
	* @param {*} value The value to assign.
	*/
	function assignValue(object, key, value) {
		var objValue = object[key];
		if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) baseAssignValue(object, key, value);
	}
	module.exports = assignValue;
}));
//#endregion
//#region ../../node_modules/lodash/_copyObject.js
var require__copyObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assignValue = require__assignValue();
	var baseAssignValue = require__baseAssignValue();
	/**
	* Copies properties of `source` to `object`.
	*
	* @private
	* @param {Object} source The object to copy properties from.
	* @param {Array} props The property identifiers to copy.
	* @param {Object} [object={}] The object to copy properties to.
	* @param {Function} [customizer] The function to customize copied values.
	* @returns {Object} Returns `object`.
	*/
	function copyObject(source, props, object, customizer) {
		var isNew = !object;
		object || (object = {});
		var index = -1, length = props.length;
		while (++index < length) {
			var key = props[index];
			var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
			if (newValue === void 0) newValue = source[key];
			if (isNew) baseAssignValue(object, key, newValue);
			else assignValue(object, key, newValue);
		}
		return object;
	}
	module.exports = copyObject;
}));
//#endregion
//#region ../../node_modules/lodash/_baseTimes.js
var require__baseTimes = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.times` without support for iteratee shorthands
	* or max array length checks.
	*
	* @private
	* @param {number} n The number of times to invoke `iteratee`.
	* @param {Function} iteratee The function invoked per iteration.
	* @returns {Array} Returns the array of results.
	*/
	function baseTimes(n, iteratee) {
		var index = -1, result = Array(n);
		while (++index < n) result[index] = iteratee(index);
		return result;
	}
	module.exports = baseTimes;
}));
//#endregion
//#region ../../node_modules/lodash/_isIndex.js
var require__isIndex = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	/**
	* Checks if `value` is a valid array-like index.
	*
	* @private
	* @param {*} value The value to check.
	* @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	* @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	*/
	function isIndex(value, length) {
		var type = typeof value;
		length = length == null ? MAX_SAFE_INTEGER : length;
		return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
	}
	module.exports = isIndex;
}));
//#endregion
//#region ../../node_modules/lodash/_arrayLikeKeys.js
var require__arrayLikeKeys = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseTimes = require__baseTimes();
	var isArguments = require_isArguments();
	var isArray = require_isArray();
	var isBuffer = require_isBuffer();
	var isIndex = require__isIndex();
	var isTypedArray = require_isTypedArray();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Creates an array of the enumerable property names of the array-like `value`.
	*
	* @private
	* @param {*} value The value to query.
	* @param {boolean} inherited Specify returning inherited property names.
	* @returns {Array} Returns the array of property names.
	*/
	function arrayLikeKeys(value, inherited) {
		var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
		for (var key in value) if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) result.push(key);
		return result;
	}
	module.exports = arrayLikeKeys;
}));
//#endregion
//#region ../../node_modules/lodash/_nativeKeysIn.js
var require__nativeKeysIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This function is like
	* [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	* except that it includes inherited enumerable properties.
	*
	* @private
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names.
	*/
	function nativeKeysIn(object) {
		var result = [];
		if (object != null) for (var key in Object(object)) result.push(key);
		return result;
	}
	module.exports = nativeKeysIn;
}));
//#endregion
//#region ../../node_modules/lodash/_baseKeysIn.js
var require__baseKeysIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isObject = require_isObject();
	var isPrototype = require__isPrototype();
	var nativeKeysIn = require__nativeKeysIn();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	*
	* @private
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names.
	*/
	function baseKeysIn(object) {
		if (!isObject(object)) return nativeKeysIn(object);
		var isProto = isPrototype(object), result = [];
		for (var key in object) if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
		return result;
	}
	module.exports = baseKeysIn;
}));
//#endregion
//#region ../../node_modules/lodash/keysIn.js
var require_keysIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayLikeKeys = require__arrayLikeKeys();
	var baseKeysIn = require__baseKeysIn();
	var isArrayLike = require_isArrayLike();
	/**
	* Creates an array of the own and inherited enumerable property names of `object`.
	*
	* **Note:** Non-object values are coerced to objects.
	*
	* @static
	* @memberOf _
	* @since 3.0.0
	* @category Object
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names.
	* @example
	*
	* function Foo() {
	*   this.a = 1;
	*   this.b = 2;
	* }
	*
	* Foo.prototype.c = 3;
	*
	* _.keysIn(new Foo);
	* // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	*/
	function keysIn(object) {
		return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	module.exports = keysIn;
}));
//#endregion
//#region ../../node_modules/lodash/toPlainObject.js
var require_toPlainObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var copyObject = require__copyObject();
	var keysIn = require_keysIn();
	/**
	* Converts `value` to a plain object flattening inherited enumerable string
	* keyed properties of `value` to own properties of the plain object.
	*
	* @static
	* @memberOf _
	* @since 3.0.0
	* @category Lang
	* @param {*} value The value to convert.
	* @returns {Object} Returns the converted plain object.
	* @example
	*
	* function Foo() {
	*   this.b = 2;
	* }
	*
	* Foo.prototype.c = 3;
	*
	* _.assign({ 'a': 1 }, new Foo);
	* // => { 'a': 1, 'b': 2 }
	*
	* _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	* // => { 'a': 1, 'b': 2, 'c': 3 }
	*/
	function toPlainObject(value) {
		return copyObject(value, keysIn(value));
	}
	module.exports = toPlainObject;
}));
//#endregion
//#region ../../node_modules/lodash/_baseMergeDeep.js
var require__baseMergeDeep = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assignMergeValue = require__assignMergeValue();
	var cloneBuffer = require__cloneBuffer();
	var cloneTypedArray = require__cloneTypedArray();
	var copyArray = require__copyArray();
	var initCloneObject = require__initCloneObject();
	var isArguments = require_isArguments();
	var isArray = require_isArray();
	var isArrayLikeObject = require_isArrayLikeObject();
	var isBuffer = require_isBuffer();
	var isFunction = require_isFunction();
	var isObject = require_isObject();
	var isPlainObject = require_isPlainObject();
	var isTypedArray = require_isTypedArray();
	var safeGet = require__safeGet();
	var toPlainObject = require_toPlainObject();
	/**
	* A specialized version of `baseMerge` for arrays and objects which performs
	* deep merges and tracks traversed objects enabling objects with circular
	* references to be merged.
	*
	* @private
	* @param {Object} object The destination object.
	* @param {Object} source The source object.
	* @param {string} key The key of the value to merge.
	* @param {number} srcIndex The index of `source`.
	* @param {Function} mergeFunc The function to merge values.
	* @param {Function} [customizer] The function to customize assigned values.
	* @param {Object} [stack] Tracks traversed source values and their merged
	*  counterparts.
	*/
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
		var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
		if (stacked) {
			assignMergeValue(object, key, stacked);
			return;
		}
		var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
		var isCommon = newValue === void 0;
		if (isCommon) {
			var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
			newValue = srcValue;
			if (isArr || isBuff || isTyped) {
				if (isArray(objValue)) newValue = objValue;
				else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
				else if (isBuff) {
					isCommon = false;
					newValue = cloneBuffer(srcValue, true);
				} else if (isTyped) {
					isCommon = false;
					newValue = cloneTypedArray(srcValue, true);
				} else newValue = [];
			} else if (isPlainObject(srcValue) || isArguments(srcValue)) {
				newValue = objValue;
				if (isArguments(objValue)) newValue = toPlainObject(objValue);
				else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
			} else isCommon = false;
		}
		if (isCommon) {
			stack.set(srcValue, newValue);
			mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
			stack["delete"](srcValue);
		}
		assignMergeValue(object, key, newValue);
	}
	module.exports = baseMergeDeep;
}));
//#endregion
//#region ../../node_modules/lodash/_baseMerge.js
var require__baseMerge = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Stack = require__Stack();
	var assignMergeValue = require__assignMergeValue();
	var baseFor = require__baseFor();
	var baseMergeDeep = require__baseMergeDeep();
	var isObject = require_isObject();
	var keysIn = require_keysIn();
	var safeGet = require__safeGet();
	/**
	* The base implementation of `_.merge` without support for multiple sources.
	*
	* @private
	* @param {Object} object The destination object.
	* @param {Object} source The source object.
	* @param {number} srcIndex The index of `source`.
	* @param {Function} [customizer] The function to customize merged values.
	* @param {Object} [stack] Tracks traversed source values and their merged
	*  counterparts.
	*/
	function baseMerge(object, source, srcIndex, customizer, stack) {
		if (object === source) return;
		baseFor(source, function(srcValue, key) {
			stack || (stack = new Stack());
			if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
			else {
				var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
				if (newValue === void 0) newValue = srcValue;
				assignMergeValue(object, key, newValue);
			}
		}, keysIn);
	}
	module.exports = baseMerge;
}));
//#endregion
//#region ../../node_modules/lodash/identity.js
var require_identity = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This method returns the first argument it receives.
	*
	* @static
	* @since 0.1.0
	* @memberOf _
	* @category Util
	* @param {*} value Any value.
	* @returns {*} Returns `value`.
	* @example
	*
	* var object = { 'a': 1 };
	*
	* console.log(_.identity(object) === object);
	* // => true
	*/
	function identity(value) {
		return value;
	}
	module.exports = identity;
}));
//#endregion
//#region ../../node_modules/lodash/_apply.js
var require__apply = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A faster alternative to `Function#apply`, this function invokes `func`
	* with the `this` binding of `thisArg` and the arguments of `args`.
	*
	* @private
	* @param {Function} func The function to invoke.
	* @param {*} thisArg The `this` binding of `func`.
	* @param {Array} args The arguments to invoke `func` with.
	* @returns {*} Returns the result of `func`.
	*/
	function apply(func, thisArg, args) {
		switch (args.length) {
			case 0: return func.call(thisArg);
			case 1: return func.call(thisArg, args[0]);
			case 2: return func.call(thisArg, args[0], args[1]);
			case 3: return func.call(thisArg, args[0], args[1], args[2]);
		}
		return func.apply(thisArg, args);
	}
	module.exports = apply;
}));
//#endregion
//#region ../../node_modules/lodash/_overRest.js
var require__overRest = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var apply = require__apply();
	var nativeMax = Math.max;
	/**
	* A specialized version of `baseRest` which transforms the rest array.
	*
	* @private
	* @param {Function} func The function to apply a rest parameter to.
	* @param {number} [start=func.length-1] The start position of the rest parameter.
	* @param {Function} transform The rest array transform.
	* @returns {Function} Returns the new function.
	*/
	function overRest(func, start, transform) {
		start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
		return function() {
			var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
			while (++index < length) array[index] = args[start + index];
			index = -1;
			var otherArgs = Array(start + 1);
			while (++index < start) otherArgs[index] = args[index];
			otherArgs[start] = transform(array);
			return apply(func, this, otherArgs);
		};
	}
	module.exports = overRest;
}));
//#endregion
//#region ../../node_modules/lodash/constant.js
var require_constant = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Creates a function that returns `value`.
	*
	* @static
	* @memberOf _
	* @since 2.4.0
	* @category Util
	* @param {*} value The value to return from the new function.
	* @returns {Function} Returns the new constant function.
	* @example
	*
	* var objects = _.times(2, _.constant({ 'a': 1 }));
	*
	* console.log(objects);
	* // => [{ 'a': 1 }, { 'a': 1 }]
	*
	* console.log(objects[0] === objects[1]);
	* // => true
	*/
	function constant(value) {
		return function() {
			return value;
		};
	}
	module.exports = constant;
}));
//#endregion
//#region ../../node_modules/lodash/_baseSetToString.js
var require__baseSetToString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var constant = require_constant();
	var defineProperty = require__defineProperty();
	var identity = require_identity();
	module.exports = !defineProperty ? identity : function(func, string) {
		return defineProperty(func, "toString", {
			"configurable": true,
			"enumerable": false,
			"value": constant(string),
			"writable": true
		});
	};
}));
//#endregion
//#region ../../node_modules/lodash/_shortOut.js
var require__shortOut = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800;
	var HOT_SPAN = 16;
	var nativeNow = Date.now;
	/**
	* Creates a function that'll short out and invoke `identity` instead
	* of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	* milliseconds.
	*
	* @private
	* @param {Function} func The function to restrict.
	* @returns {Function} Returns the new shortable function.
	*/
	function shortOut(func) {
		var count = 0, lastCalled = 0;
		return function() {
			var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
			lastCalled = stamp;
			if (remaining > 0) {
				if (++count >= HOT_COUNT) return arguments[0];
			} else count = 0;
			return func.apply(void 0, arguments);
		};
	}
	module.exports = shortOut;
}));
//#endregion
//#region ../../node_modules/lodash/_setToString.js
var require__setToString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseSetToString = require__baseSetToString();
	module.exports = require__shortOut()(baseSetToString);
}));
//#endregion
//#region ../../node_modules/lodash/_baseRest.js
var require__baseRest = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var identity = require_identity();
	var overRest = require__overRest();
	var setToString = require__setToString();
	/**
	* The base implementation of `_.rest` which doesn't validate or coerce arguments.
	*
	* @private
	* @param {Function} func The function to apply a rest parameter to.
	* @param {number} [start=func.length-1] The start position of the rest parameter.
	* @returns {Function} Returns the new function.
	*/
	function baseRest(func, start) {
		return setToString(overRest(func, start, identity), func + "");
	}
	module.exports = baseRest;
}));
//#endregion
//#region ../../node_modules/lodash/_isIterateeCall.js
var require__isIterateeCall = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var eq = require_eq();
	var isArrayLike = require_isArrayLike();
	var isIndex = require__isIndex();
	var isObject = require_isObject();
	/**
	* Checks if the given arguments are from an iteratee call.
	*
	* @private
	* @param {*} value The potential iteratee value argument.
	* @param {*} index The potential iteratee index or key argument.
	* @param {*} object The potential iteratee object argument.
	* @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	*  else `false`.
	*/
	function isIterateeCall(value, index, object) {
		if (!isObject(object)) return false;
		var type = typeof index;
		if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
		return false;
	}
	module.exports = isIterateeCall;
}));
//#endregion
//#region ../../node_modules/lodash/_createAssigner.js
var require__createAssigner = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseRest = require__baseRest();
	var isIterateeCall = require__isIterateeCall();
	/**
	* Creates a function like `_.assign`.
	*
	* @private
	* @param {Function} assigner The function to assign values.
	* @returns {Function} Returns the new assigner function.
	*/
	function createAssigner(assigner) {
		return baseRest(function(object, sources) {
			var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
			customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
			if (guard && isIterateeCall(sources[0], sources[1], guard)) {
				customizer = length < 3 ? void 0 : customizer;
				length = 1;
			}
			object = Object(object);
			while (++index < length) {
				var source = sources[index];
				if (source) assigner(object, source, index, customizer);
			}
			return object;
		});
	}
	module.exports = createAssigner;
}));
//#endregion
//#region ../../node_modules/lodash/merge.js
var require_merge = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseMerge = require__baseMerge();
	module.exports = require__createAssigner()(function(object, source, srcIndex) {
		baseMerge(object, source, srcIndex);
	});
}));
//#endregion
//#region ../../node_modules/lodash/isSymbol.js
var require_isSymbol = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var symbolTag = "[object Symbol]";
	/**
	* Checks if `value` is classified as a `Symbol` primitive or object.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	* @example
	*
	* _.isSymbol(Symbol.iterator);
	* // => true
	*
	* _.isSymbol('abc');
	* // => false
	*/
	function isSymbol(value) {
		return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
	}
	module.exports = isSymbol;
}));
//#endregion
//#region ../../node_modules/lodash/_isKey.js
var require__isKey = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isArray = require_isArray();
	var isSymbol = require_isSymbol();
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
	var reIsPlainProp = /^\w*$/;
	/**
	* Checks if `value` is a property name and not a property path.
	*
	* @private
	* @param {*} value The value to check.
	* @param {Object} [object] The object to query keys on.
	* @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	*/
	function isKey(value, object) {
		if (isArray(value)) return false;
		var type = typeof value;
		if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
		return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
	}
	module.exports = isKey;
}));
//#endregion
//#region ../../node_modules/lodash/memoize.js
var require_memoize = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var MapCache = require__MapCache();
	/** Error message constants. */
	var FUNC_ERROR_TEXT = "Expected a function";
	/**
	* Creates a function that memoizes the result of `func`. If `resolver` is
	* provided, it determines the cache key for storing the result based on the
	* arguments provided to the memoized function. By default, the first argument
	* provided to the memoized function is used as the map cache key. The `func`
	* is invoked with the `this` binding of the memoized function.
	*
	* **Note:** The cache is exposed as the `cache` property on the memoized
	* function. Its creation may be customized by replacing the `_.memoize.Cache`
	* constructor with one whose instances implement the
	* [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	* method interface of `clear`, `delete`, `get`, `has`, and `set`.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Function
	* @param {Function} func The function to have its output memoized.
	* @param {Function} [resolver] The function to resolve the cache key.
	* @returns {Function} Returns the new memoized function.
	* @example
	*
	* var object = { 'a': 1, 'b': 2 };
	* var other = { 'c': 3, 'd': 4 };
	*
	* var values = _.memoize(_.values);
	* values(object);
	* // => [1, 2]
	*
	* values(other);
	* // => [3, 4]
	*
	* object.a = 2;
	* values(object);
	* // => [1, 2]
	*
	* // Modify the result cache.
	* values.cache.set(object, ['a', 'b']);
	* values(object);
	* // => ['a', 'b']
	*
	* // Replace `_.memoize.Cache`.
	* _.memoize.Cache = WeakMap;
	*/
	function memoize(func, resolver) {
		if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
		var memoized = function() {
			var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
			if (cache.has(key)) return cache.get(key);
			var result = func.apply(this, args);
			memoized.cache = cache.set(key, result) || cache;
			return result;
		};
		memoized.cache = new (memoize.Cache || MapCache)();
		return memoized;
	}
	memoize.Cache = MapCache;
	module.exports = memoize;
}));
//#endregion
//#region ../../node_modules/lodash/_memoizeCapped.js
var require__memoizeCapped = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var memoize = require_memoize();
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	/**
	* A specialized version of `_.memoize` which clears the memoized function's
	* cache when it exceeds `MAX_MEMOIZE_SIZE`.
	*
	* @private
	* @param {Function} func The function to have its output memoized.
	* @returns {Function} Returns the new memoized function.
	*/
	function memoizeCapped(func) {
		var result = memoize(func, function(key) {
			if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
			return key;
		});
		var cache = result.cache;
		return result;
	}
	module.exports = memoizeCapped;
}));
//#endregion
//#region ../../node_modules/lodash/_stringToPath.js
var require__stringToPath = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var memoizeCapped = require__memoizeCapped();
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	module.exports = memoizeCapped(function(string) {
		var result = [];
		if (string.charCodeAt(0) === 46) result.push("");
		string.replace(rePropName, function(match, number, quote, subString) {
			result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
		});
		return result;
	});
}));
//#endregion
//#region ../../node_modules/lodash/_arrayMap.js
var require__arrayMap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `_.map` for arrays without support for iteratee
	* shorthands.
	*
	* @private
	* @param {Array} [array] The array to iterate over.
	* @param {Function} iteratee The function invoked per iteration.
	* @returns {Array} Returns the new mapped array.
	*/
	function arrayMap(array, iteratee) {
		var index = -1, length = array == null ? 0 : array.length, result = Array(length);
		while (++index < length) result[index] = iteratee(array[index], index, array);
		return result;
	}
	module.exports = arrayMap;
}));
//#endregion
//#region ../../node_modules/lodash/_baseToString.js
var require__baseToString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	var arrayMap = require__arrayMap();
	var isArray = require_isArray();
	var isSymbol = require_isSymbol();
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : void 0;
	var symbolToString = symbolProto ? symbolProto.toString : void 0;
	/**
	* The base implementation of `_.toString` which doesn't convert nullish
	* values to empty strings.
	*
	* @private
	* @param {*} value The value to process.
	* @returns {string} Returns the string.
	*/
	function baseToString(value) {
		if (typeof value == "string") return value;
		if (isArray(value)) return arrayMap(value, baseToString) + "";
		if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
		var result = value + "";
		return result == "0" && 1 / value == -INFINITY ? "-0" : result;
	}
	module.exports = baseToString;
}));
//#endregion
//#region ../../node_modules/lodash/toString.js
var require_toString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseToString = require__baseToString();
	/**
	* Converts `value` to a string. An empty string is returned for `null`
	* and `undefined` values. The sign of `-0` is preserved.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to convert.
	* @returns {string} Returns the converted string.
	* @example
	*
	* _.toString(null);
	* // => ''
	*
	* _.toString(-0);
	* // => '-0'
	*
	* _.toString([1, 2, 3]);
	* // => '1,2,3'
	*/
	function toString(value) {
		return value == null ? "" : baseToString(value);
	}
	module.exports = toString;
}));
//#endregion
//#region ../../node_modules/lodash/_castPath.js
var require__castPath = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isArray = require_isArray();
	var isKey = require__isKey();
	var stringToPath = require__stringToPath();
	var toString = require_toString();
	/**
	* Casts `value` to a path array if it's not one.
	*
	* @private
	* @param {*} value The value to inspect.
	* @param {Object} [object] The object to query keys on.
	* @returns {Array} Returns the cast property path array.
	*/
	function castPath(value, object) {
		if (isArray(value)) return value;
		return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	module.exports = castPath;
}));
//#endregion
//#region ../../node_modules/lodash/_toKey.js
var require__toKey = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isSymbol = require_isSymbol();
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	/**
	* Converts `value` to a string key if it's not a string or symbol.
	*
	* @private
	* @param {*} value The value to inspect.
	* @returns {string|symbol} Returns the key.
	*/
	function toKey(value) {
		if (typeof value == "string" || isSymbol(value)) return value;
		var result = value + "";
		return result == "0" && 1 / value == -INFINITY ? "-0" : result;
	}
	module.exports = toKey;
}));
//#endregion
//#region ../../node_modules/lodash/_baseGet.js
var require__baseGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var castPath = require__castPath();
	var toKey = require__toKey();
	/**
	* The base implementation of `_.get` without support for default values.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {Array|string} path The path of the property to get.
	* @returns {*} Returns the resolved value.
	*/
	function baseGet(object, path) {
		path = castPath(path, object);
		var index = 0, length = path.length;
		while (object != null && index < length) object = object[toKey(path[index++])];
		return index && index == length ? object : void 0;
	}
	module.exports = baseGet;
}));
//#endregion
//#region ../../node_modules/lodash/get.js
var require_get = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGet = require__baseGet();
	/**
	* Gets the value at `path` of `object`. If the resolved value is
	* `undefined`, the `defaultValue` is returned in its place.
	*
	* @static
	* @memberOf _
	* @since 3.7.0
	* @category Object
	* @param {Object} object The object to query.
	* @param {Array|string} path The path of the property to get.
	* @param {*} [defaultValue] The value returned for `undefined` resolved values.
	* @returns {*} Returns the resolved value.
	* @example
	*
	* var object = { 'a': [{ 'b': { 'c': 3 } }] };
	*
	* _.get(object, 'a[0].b.c');
	* // => 3
	*
	* _.get(object, ['a', '0', 'b', 'c']);
	* // => 3
	*
	* _.get(object, 'a.b.c', 'default');
	* // => 'default'
	*/
	function get(object, path, defaultValue) {
		var result = object == null ? void 0 : baseGet(object, path);
		return result === void 0 ? defaultValue : result;
	}
	module.exports = get;
}));
//#endregion
//#region ../../node_modules/lodash/_baseSet.js
var require__baseSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assignValue = require__assignValue();
	var castPath = require__castPath();
	var isIndex = require__isIndex();
	var isObject = require_isObject();
	var toKey = require__toKey();
	/**
	* The base implementation of `_.set`.
	*
	* @private
	* @param {Object} object The object to modify.
	* @param {Array|string} path The path of the property to set.
	* @param {*} value The value to set.
	* @param {Function} [customizer] The function to customize path creation.
	* @returns {Object} Returns `object`.
	*/
	function baseSet(object, path, value, customizer) {
		if (!isObject(object)) return object;
		path = castPath(path, object);
		var index = -1, length = path.length, lastIndex = length - 1, nested = object;
		while (nested != null && ++index < length) {
			var key = toKey(path[index]), newValue = value;
			if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
			if (index != lastIndex) {
				var objValue = nested[key];
				newValue = customizer ? customizer(objValue, key, nested) : void 0;
				if (newValue === void 0) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
			}
			assignValue(nested, key, newValue);
			nested = nested[key];
		}
		return object;
	}
	module.exports = baseSet;
}));
//#endregion
//#region ../../node_modules/lodash/set.js
var require_set = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseSet = require__baseSet();
	/**
	* Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	* it's created. Arrays are created for missing index properties while objects
	* are created for all other missing properties. Use `_.setWith` to customize
	* `path` creation.
	*
	* **Note:** This method mutates `object`.
	*
	* @static
	* @memberOf _
	* @since 3.7.0
	* @category Object
	* @param {Object} object The object to modify.
	* @param {Array|string} path The path of the property to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns `object`.
	* @example
	*
	* var object = { 'a': [{ 'b': { 'c': 3 } }] };
	*
	* _.set(object, 'a[0].b.c', 4);
	* console.log(object.a[0].b.c);
	* // => 4
	*
	* _.set(object, ['x', '0', 'y', 'z'], 5);
	* console.log(object.x[0].y.z);
	* // => 5
	*/
	function set(object, path, value) {
		return object == null ? object : baseSet(object, path, value);
	}
	module.exports = set;
}));
//#endregion
//#region ../../node_modules/d3-color/src/define.js
function define_default(constructor, factory, prototype) {
	constructor.prototype = factory.prototype = prototype;
	prototype.constructor = constructor;
}
function extend(parent, definition) {
	var prototype = Object.create(parent.prototype);
	for (var key in definition) prototype[key] = definition[key];
	return prototype;
}
//#endregion
//#region ../../node_modules/d3-color/src/color.js
function Color() {}
var darker = .7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex = /^#([0-9a-f]{3,8})$/;
var reRgbInteger = new RegExp("^rgb\\(" + [
	reI,
	reI,
	reI
] + "\\)$");
var reRgbPercent = new RegExp("^rgb\\(" + [
	reP,
	reP,
	reP
] + "\\)$");
var reRgbaInteger = new RegExp("^rgba\\(" + [
	reI,
	reI,
	reI,
	reN
] + "\\)$");
var reRgbaPercent = new RegExp("^rgba\\(" + [
	reP,
	reP,
	reP,
	reN
] + "\\)$");
var reHslPercent = new RegExp("^hsl\\(" + [
	reN,
	reP,
	reP
] + "\\)$");
var reHslaPercent = new RegExp("^hsla\\(" + [
	reN,
	reP,
	reP,
	reN
] + "\\)$");
var named = {
	aliceblue: 15792383,
	antiquewhite: 16444375,
	aqua: 65535,
	aquamarine: 8388564,
	azure: 15794175,
	beige: 16119260,
	bisque: 16770244,
	black: 0,
	blanchedalmond: 16772045,
	blue: 255,
	blueviolet: 9055202,
	brown: 10824234,
	burlywood: 14596231,
	cadetblue: 6266528,
	chartreuse: 8388352,
	chocolate: 13789470,
	coral: 16744272,
	cornflowerblue: 6591981,
	cornsilk: 16775388,
	crimson: 14423100,
	cyan: 65535,
	darkblue: 139,
	darkcyan: 35723,
	darkgoldenrod: 12092939,
	darkgray: 11119017,
	darkgreen: 25600,
	darkgrey: 11119017,
	darkkhaki: 12433259,
	darkmagenta: 9109643,
	darkolivegreen: 5597999,
	darkorange: 16747520,
	darkorchid: 10040012,
	darkred: 9109504,
	darksalmon: 15308410,
	darkseagreen: 9419919,
	darkslateblue: 4734347,
	darkslategray: 3100495,
	darkslategrey: 3100495,
	darkturquoise: 52945,
	darkviolet: 9699539,
	deeppink: 16716947,
	deepskyblue: 49151,
	dimgray: 6908265,
	dimgrey: 6908265,
	dodgerblue: 2003199,
	firebrick: 11674146,
	floralwhite: 16775920,
	forestgreen: 2263842,
	fuchsia: 16711935,
	gainsboro: 14474460,
	ghostwhite: 16316671,
	gold: 16766720,
	goldenrod: 14329120,
	gray: 8421504,
	green: 32768,
	greenyellow: 11403055,
	grey: 8421504,
	honeydew: 15794160,
	hotpink: 16738740,
	indianred: 13458524,
	indigo: 4915330,
	ivory: 16777200,
	khaki: 15787660,
	lavender: 15132410,
	lavenderblush: 16773365,
	lawngreen: 8190976,
	lemonchiffon: 16775885,
	lightblue: 11393254,
	lightcoral: 15761536,
	lightcyan: 14745599,
	lightgoldenrodyellow: 16448210,
	lightgray: 13882323,
	lightgreen: 9498256,
	lightgrey: 13882323,
	lightpink: 16758465,
	lightsalmon: 16752762,
	lightseagreen: 2142890,
	lightskyblue: 8900346,
	lightslategray: 7833753,
	lightslategrey: 7833753,
	lightsteelblue: 11584734,
	lightyellow: 16777184,
	lime: 65280,
	limegreen: 3329330,
	linen: 16445670,
	magenta: 16711935,
	maroon: 8388608,
	mediumaquamarine: 6737322,
	mediumblue: 205,
	mediumorchid: 12211667,
	mediumpurple: 9662683,
	mediumseagreen: 3978097,
	mediumslateblue: 8087790,
	mediumspringgreen: 64154,
	mediumturquoise: 4772300,
	mediumvioletred: 13047173,
	midnightblue: 1644912,
	mintcream: 16121850,
	mistyrose: 16770273,
	moccasin: 16770229,
	navajowhite: 16768685,
	navy: 128,
	oldlace: 16643558,
	olive: 8421376,
	olivedrab: 7048739,
	orange: 16753920,
	orangered: 16729344,
	orchid: 14315734,
	palegoldenrod: 15657130,
	palegreen: 10025880,
	paleturquoise: 11529966,
	palevioletred: 14381203,
	papayawhip: 16773077,
	peachpuff: 16767673,
	peru: 13468991,
	pink: 16761035,
	plum: 14524637,
	powderblue: 11591910,
	purple: 8388736,
	rebeccapurple: 6697881,
	red: 16711680,
	rosybrown: 12357519,
	royalblue: 4286945,
	saddlebrown: 9127187,
	salmon: 16416882,
	sandybrown: 16032864,
	seagreen: 3050327,
	seashell: 16774638,
	sienna: 10506797,
	silver: 12632256,
	skyblue: 8900331,
	slateblue: 6970061,
	slategray: 7372944,
	slategrey: 7372944,
	snow: 16775930,
	springgreen: 65407,
	steelblue: 4620980,
	tan: 13808780,
	teal: 32896,
	thistle: 14204888,
	tomato: 16737095,
	turquoise: 4251856,
	violet: 15631086,
	wheat: 16113331,
	white: 16777215,
	whitesmoke: 16119285,
	yellow: 16776960,
	yellowgreen: 10145074
};
define_default(Color, color, {
	copy: function(channels) {
		return Object.assign(new this.constructor(), this, channels);
	},
	displayable: function() {
		return this.rgb().displayable();
	},
	hex: color_formatHex,
	formatHex: color_formatHex,
	formatHsl: color_formatHsl,
	formatRgb: color_formatRgb,
	toString: color_formatRgb
});
function color_formatHex() {
	return this.rgb().formatHex();
}
function color_formatHsl() {
	return hslConvert(this).formatHsl();
}
function color_formatRgb() {
	return this.rgb().formatRgb();
}
function color(format) {
	var m, l;
	format = (format + "").trim().toLowerCase();
	return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
	return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r, g, b, a) {
	if (a <= 0) r = g = b = NaN;
	return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
	if (!(o instanceof Color)) o = color(o);
	if (!o) return new Rgb();
	o = o.rgb();
	return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
	return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
	this.r = +r;
	this.g = +g;
	this.b = +b;
	this.opacity = +opacity;
}
define_default(Rgb, rgb, extend(Color, {
	brighter: function(k) {
		k = k == null ? brighter : Math.pow(brighter, k);
		return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	},
	darker: function(k) {
		k = k == null ? darker : Math.pow(darker, k);
		return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	},
	rgb: function() {
		return this;
	},
	displayable: function() {
		return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
	},
	hex: rgb_formatHex,
	formatHex: rgb_formatHex,
	formatRgb: rgb_formatRgb,
	toString: rgb_formatRgb
}));
function rgb_formatHex() {
	return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
	var a = this.opacity;
	a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
	value = Math.max(0, Math.min(255, Math.round(value) || 0));
	return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
	if (a <= 0) h = s = l = NaN;
	else if (l <= 0 || l >= 1) h = s = NaN;
	else if (s <= 0) h = NaN;
	return new Hsl(h, s, l, a);
}
function hslConvert(o) {
	if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	if (!(o instanceof Color)) o = color(o);
	if (!o) return new Hsl();
	if (o instanceof Hsl) return o;
	o = o.rgb();
	var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
	if (s) {
		if (r === max) h = (g - b) / s + (g < b) * 6;
		else if (g === max) h = (b - r) / s + 2;
		else h = (r - g) / s + 4;
		s /= l < .5 ? max + min : 2 - max - min;
		h *= 60;
	} else s = l > 0 && l < 1 ? 0 : h;
	return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
	return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
	this.h = +h;
	this.s = +s;
	this.l = +l;
	this.opacity = +opacity;
}
define_default(Hsl, hsl, extend(Color, {
	brighter: function(k) {
		k = k == null ? brighter : Math.pow(brighter, k);
		return new Hsl(this.h, this.s, this.l * k, this.opacity);
	},
	darker: function(k) {
		k = k == null ? darker : Math.pow(darker, k);
		return new Hsl(this.h, this.s, this.l * k, this.opacity);
	},
	rgb: function() {
		var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < .5 ? l : 1 - l) * s, m1 = 2 * l - m2;
		return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
	},
	displayable: function() {
		return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
	},
	formatHsl: function() {
		var a = this.opacity;
		a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
		return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
	}
}));
function hsl2rgb(h, m1, m2) {
	return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
//#endregion
//#region ../../node_modules/d3-color/src/math.js
var radians = Math.PI / 180;
var degrees = 180 / Math.PI;
//#endregion
//#region ../../node_modules/d3-color/src/cubehelix.js
var A$2 = -.14861;
var B$1 = 1.78277;
var C$2 = -.29227;
var D$1 = -.90649;
var E$1 = 1.97294;
var ED = E$1 * D$1;
var EB = E$1 * B$1;
var BC_DA = B$1 * C$2 - D$1 * A$2;
function cubehelixConvert(o) {
	if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	if (!(o instanceof Rgb)) o = rgbConvert(o);
	var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E$1 * (g - l) - C$2 * bl) / D$1, s = Math.sqrt(k * k + bl * bl) / (E$1 * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees - 120 : NaN;
	return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix$1(h, s, l, opacity) {
	return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
	this.h = +h;
	this.s = +s;
	this.l = +l;
	this.opacity = +opacity;
}
define_default(Cubehelix, cubehelix$1, extend(Color, {
	brighter: function(k) {
		k = k == null ? brighter : Math.pow(brighter, k);
		return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	},
	darker: function(k) {
		k = k == null ? darker : Math.pow(darker, k);
		return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	},
	rgb: function() {
		var h = isNaN(this.h) ? 0 : (this.h + 120) * radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
		return new Rgb(255 * (l + a * (A$2 * cosh + B$1 * sinh)), 255 * (l + a * (C$2 * cosh + D$1 * sinh)), 255 * (l + a * (E$1 * cosh)), this.opacity);
	}
}));
//#endregion
//#region ../../node_modules/d3-interpolate/src/basis.js
function basis(t1, v0, v1, v2, v3) {
	var t2 = t1 * t1, t3 = t2 * t1;
	return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function basis_default$1(values) {
	var n = values.length - 1;
	return function(t) {
		var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
		return basis((t - i / n) * n, v0, v1, v2, v3);
	};
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/constant.js
var constant_default = (x) => () => x;
//#endregion
//#region ../../node_modules/d3-interpolate/src/color.js
function linear$1(a, d) {
	return function(t) {
		return a + t * d;
	};
}
function exponential(a, b, y) {
	return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
		return Math.pow(a + t * b, y);
	};
}
function hue(a, b) {
	var d = b - a;
	return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant_default(isNaN(a) ? b : a);
}
function gamma(y) {
	return (y = +y) === 1 ? nogamma : function(a, b) {
		return b - a ? exponential(a, b, y) : constant_default(isNaN(a) ? b : a);
	};
}
function nogamma(a, b) {
	var d = b - a;
	return d ? linear$1(a, d) : constant_default(isNaN(a) ? b : a);
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/rgb.js
var rgb_default = (function rgbGamma(y) {
	var color = gamma(y);
	function rgb$2(start, end) {
		var r = color((start = rgb(start)).r, (end = rgb(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
		return function(t) {
			start.r = r(t);
			start.g = g(t);
			start.b = b(t);
			start.opacity = opacity(t);
			return start + "";
		};
	}
	rgb$2.gamma = rgbGamma;
	return rgb$2;
})(1);
function rgbSpline(spline) {
	return function(colors) {
		var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i = 0, color;
		for (; i < n; ++i) {
			color = rgb(colors[i]);
			r[i] = color.r || 0;
			g[i] = color.g || 0;
			b[i] = color.b || 0;
		}
		r = spline(r);
		g = spline(g);
		b = spline(b);
		color.opacity = 1;
		return function(t) {
			color.r = r(t);
			color.g = g(t);
			color.b = b(t);
			return color + "";
		};
	};
}
var rgbBasis = rgbSpline(basis_default$1);
//#endregion
//#region ../../node_modules/d3-interpolate/src/numberArray.js
function numberArray_default(a, b) {
	if (!b) b = [];
	var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
	return function(t) {
		for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
		return c;
	};
}
function isNumberArray(x) {
	return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/array.js
function genericArray(a, b) {
	var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i = 0;
	for (; i < na; ++i) x[i] = value_default(a[i], b[i]);
	for (; i < nb; ++i) c[i] = b[i];
	return function(t) {
		for (i = 0; i < na; ++i) c[i] = x[i](t);
		return c;
	};
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/date.js
function date_default(a, b) {
	var d = /* @__PURE__ */ new Date();
	return a = +a, b = +b, function(t) {
		return d.setTime(a * (1 - t) + b * t), d;
	};
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/number.js
function number_default$1(a, b) {
	return a = +a, b = +b, function(t) {
		return a * (1 - t) + b * t;
	};
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/object.js
function object_default(a, b) {
	var i = {}, c = {}, k;
	if (a === null || typeof a !== "object") a = {};
	if (b === null || typeof b !== "object") b = {};
	for (k in b) if (k in a) i[k] = value_default(a[k], b[k]);
	else c[k] = b[k];
	return function(t) {
		for (k in i) c[k] = i[k](t);
		return c;
	};
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/string.js
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
var reB = new RegExp(reA.source, "g");
function zero(b) {
	return function() {
		return b;
	};
}
function one(b) {
	return function(t) {
		return b(t) + "";
	};
}
function string_default(a, b) {
	var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	a = a + "", b = b + "";
	while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
		if ((bs = bm.index) > bi) {
			bs = b.slice(bi, bs);
			if (s[i]) s[i] += bs;
			else s[++i] = bs;
		}
		if ((am = am[0]) === (bm = bm[0])) {
			if (s[i]) s[i] += bm;
			else s[++i] = bm;
		} else {
			s[++i] = null;
			q.push({
				i,
				x: number_default$1(am, bm)
			});
		}
		bi = reB.lastIndex;
	}
	if (bi < b.length) {
		bs = b.slice(bi);
		if (s[i]) s[i] += bs;
		else s[++i] = bs;
	}
	return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
		for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
		return s.join("");
	});
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/value.js
function value_default(a, b) {
	var t = typeof b, c;
	return b == null || t === "boolean" ? constant_default(b) : (t === "number" ? number_default$1 : t === "string" ? (c = color(b)) ? (b = c, rgb_default) : string_default : b instanceof color ? rgb_default : b instanceof Date ? date_default : isNumberArray(b) ? numberArray_default : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object_default : number_default$1)(a, b);
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/round.js
function round_default(a, b) {
	return a = +a, b = +b, function(t) {
		return Math.round(a * (1 - t) + b * t);
	};
}
//#endregion
//#region ../../node_modules/d3-interpolate/src/cubehelix.js
function cubehelix(hue) {
	return (function cubehelixGamma(y) {
		y = +y;
		function cubehelix(start, end) {
			var h = hue((start = cubehelix$1(start)).h, (end = cubehelix$1(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
			return function(t) {
				start.h = h(t);
				start.s = s(t);
				start.l = l(Math.pow(t, y));
				start.opacity = opacity(t);
				return start + "";
			};
		}
		cubehelix.gamma = cubehelixGamma;
		return cubehelix;
	})(1);
}
cubehelix(hue);
var cubehelixLong = cubehelix(nogamma);
//#endregion
//#region ../../node_modules/d3-interpolate/src/piecewise.js
function piecewise(interpolate, values) {
	if (values === void 0) values = interpolate, interpolate = value_default;
	var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	while (i < n) I[i] = interpolate(v, v = values[++i]);
	return function(t) {
		var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
		return I[i](t - i);
	};
}
//#endregion
//#region ../../node_modules/lodash/isString.js
var require_isString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isArray = require_isArray();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var stringTag = "[object String]";
	/**
	* Checks if `value` is classified as a `String` primitive or object.
	*
	* @static
	* @since 0.1.0
	* @memberOf _
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a string, else `false`.
	* @example
	*
	* _.isString('abc');
	* // => true
	*
	* _.isString(1);
	* // => false
	*/
	function isString(value) {
		return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
	}
	module.exports = isString;
}));
//#endregion
//#region ../../node_modules/lodash/last.js
var require_last = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Gets the last element of `array`.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Array
	* @param {Array} array The array to query.
	* @returns {*} Returns the last element of `array`.
	* @example
	*
	* _.last([1, 2, 3]);
	* // => 3
	*/
	function last(array) {
		var length = array == null ? 0 : array.length;
		return length ? array[length - 1] : void 0;
	}
	module.exports = last;
}));
//#endregion
//#region ../../node_modules/d3-array/src/ascending.js
function ascending_default$1(a, b) {
	return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
//#endregion
//#region ../../node_modules/d3-array/src/bisector.js
function bisector_default(f) {
	let delta = f;
	let compare = f;
	if (f.length === 1) {
		delta = (d, x) => f(d) - x;
		compare = ascendingComparator(f);
	}
	function left(a, x, lo, hi) {
		if (lo == null) lo = 0;
		if (hi == null) hi = a.length;
		while (lo < hi) {
			const mid = lo + hi >>> 1;
			if (compare(a[mid], x) < 0) lo = mid + 1;
			else hi = mid;
		}
		return lo;
	}
	function right(a, x, lo, hi) {
		if (lo == null) lo = 0;
		if (hi == null) hi = a.length;
		while (lo < hi) {
			const mid = lo + hi >>> 1;
			if (compare(a[mid], x) > 0) hi = mid;
			else lo = mid + 1;
		}
		return lo;
	}
	function center(a, x, lo, hi) {
		if (lo == null) lo = 0;
		if (hi == null) hi = a.length;
		const i = left(a, x, lo, hi - 1);
		return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
	}
	return {
		left,
		center,
		right
	};
}
function ascendingComparator(f) {
	return (d, x) => ascending_default$1(f(d), x);
}
//#endregion
//#region ../../node_modules/d3-array/src/number.js
function number_default(x) {
	return x === null ? NaN : +x;
}
//#endregion
//#region ../../node_modules/d3-array/src/bisect.js
var ascendingBisect = bisector_default(ascending_default$1);
var bisectRight = ascendingBisect.right;
ascendingBisect.left;
bisector_default(number_default).center;
//#endregion
//#region ../../node_modules/d3-array/src/ticks.js
var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);
function ticks_default(start, stop, count) {
	var reverse, i = -1, n, ticks, step;
	stop = +stop, start = +start, count = +count;
	if (start === stop && count > 0) return [start];
	if (reverse = stop < start) n = start, start = stop, stop = n;
	if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	if (step > 0) {
		let r0 = Math.round(start / step), r1 = Math.round(stop / step);
		if (r0 * step < start) ++r0;
		if (r1 * step > stop) --r1;
		ticks = new Array(n = r1 - r0 + 1);
		while (++i < n) ticks[i] = (r0 + i) * step;
	} else {
		step = -step;
		let r0 = Math.round(start * step), r1 = Math.round(stop * step);
		if (r0 / step < start) ++r0;
		if (r1 / step > stop) --r1;
		ticks = new Array(n = r1 - r0 + 1);
		while (++i < n) ticks[i] = (r0 + i) / step;
	}
	if (reverse) ticks.reverse();
	return ticks;
}
function tickIncrement(start, stop, count) {
	var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
	return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
	var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
	if (error >= e10) step1 *= 10;
	else if (error >= e5) step1 *= 5;
	else if (error >= e2) step1 *= 2;
	return stop < start ? -step1 : step1;
}
//#endregion
//#region ../../node_modules/d3-array/src/range.js
function range_default(start, stop, step) {
	start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
	while (++i < n) range[i] = start + i * step;
	return range;
}
//#endregion
//#region ../../node_modules/d3-scale/src/init.js
function initRange(domain, range) {
	switch (arguments.length) {
		case 0: break;
		case 1:
			this.range(domain);
			break;
		default: this.range(range).domain(domain);
	}
	return this;
}
function initInterpolator(domain, interpolator) {
	switch (arguments.length) {
		case 0: break;
		case 1:
			if (typeof domain === "function") this.interpolator(domain);
			else this.range(domain);
			break;
		default:
			this.domain(domain);
			if (typeof interpolator === "function") this.interpolator(interpolator);
			else this.range(interpolator);
	}
	return this;
}
//#endregion
//#region ../../node_modules/d3-scale/src/ordinal.js
var implicit = Symbol("implicit");
function ordinal() {
	var index = /* @__PURE__ */ new Map(), domain = [], range = [], unknown = implicit;
	function scale(d) {
		var key = d + "", i = index.get(key);
		if (!i) {
			if (unknown !== implicit) return unknown;
			index.set(key, i = domain.push(d));
		}
		return range[(i - 1) % range.length];
	}
	scale.domain = function(_) {
		if (!arguments.length) return domain.slice();
		domain = [], index = /* @__PURE__ */ new Map();
		for (const value of _) {
			const key = value + "";
			if (index.has(key)) continue;
			index.set(key, domain.push(value));
		}
		return scale;
	};
	scale.range = function(_) {
		return arguments.length ? (range = Array.from(_), scale) : range.slice();
	};
	scale.unknown = function(_) {
		return arguments.length ? (unknown = _, scale) : unknown;
	};
	scale.copy = function() {
		return ordinal(domain, range).unknown(unknown);
	};
	initRange.apply(scale, arguments);
	return scale;
}
//#endregion
//#region ../../node_modules/d3-scale/src/band.js
function band() {
	var scale = ordinal().unknown(void 0), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = .5;
	delete scale.unknown;
	function rescale() {
		var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
		step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
		if (round) step = Math.floor(step);
		start += (stop - start - step * (n - paddingInner)) * align;
		bandwidth = step * (1 - paddingInner);
		if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
		var values = range_default(n).map(function(i) {
			return start + step * i;
		});
		return ordinalRange(reverse ? values.reverse() : values);
	}
	scale.domain = function(_) {
		return arguments.length ? (domain(_), rescale()) : domain();
	};
	scale.range = function(_) {
		return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
	};
	scale.rangeRound = function(_) {
		return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
	};
	scale.bandwidth = function() {
		return bandwidth;
	};
	scale.step = function() {
		return step;
	};
	scale.round = function(_) {
		return arguments.length ? (round = !!_, rescale()) : round;
	};
	scale.padding = function(_) {
		return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	};
	scale.paddingInner = function(_) {
		return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	};
	scale.paddingOuter = function(_) {
		return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	};
	scale.align = function(_) {
		return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	};
	scale.copy = function() {
		return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
	};
	return initRange.apply(rescale(), arguments);
}
//#endregion
//#region ../../node_modules/d3-scale/src/constant.js
function constants(x) {
	return function() {
		return x;
	};
}
//#endregion
//#region ../../node_modules/d3-scale/src/number.js
function number(x) {
	return +x;
}
//#endregion
//#region ../../node_modules/d3-scale/src/continuous.js
var unit = [0, 1];
function identity(x) {
	return x;
}
function normalize(a, b) {
	return (b -= a = +a) ? function(x) {
		return (x - a) / b;
	} : constants(isNaN(b) ? NaN : .5);
}
function clamper(a, b) {
	var t;
	if (a > b) t = a, a = b, b = t;
	return function(x) {
		return Math.max(a, Math.min(b, x));
	};
}
function bimap(domain, range, interpolate) {
	var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	return function(x) {
		return r0(d0(x));
	};
}
function polymap(domain, range, interpolate) {
	var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
	if (domain[j] < domain[0]) {
		domain = domain.slice().reverse();
		range = range.slice().reverse();
	}
	while (++i < j) {
		d[i] = normalize(domain[i], domain[i + 1]);
		r[i] = interpolate(range[i], range[i + 1]);
	}
	return function(x) {
		var i = bisectRight(domain, x, 1, j) - 1;
		return r[i](d[i](x));
	};
}
function copy$1(source, target) {
	return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$2() {
	var domain = unit, range = unit, interpolate = value_default, transform, untransform, unknown, clamp = identity, piecewise, output, input;
	function rescale() {
		var n = Math.min(domain.length, range.length);
		if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
		piecewise = n > 2 ? polymap : bimap;
		output = input = null;
		return scale;
	}
	function scale(x) {
		return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	}
	scale.invert = function(y) {
		return clamp(untransform((input || (input = piecewise(range, domain.map(transform), number_default$1)))(y)));
	};
	scale.domain = function(_) {
		return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
	};
	scale.range = function(_) {
		return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
	};
	scale.rangeRound = function(_) {
		return range = Array.from(_), interpolate = round_default, rescale();
	};
	scale.clamp = function(_) {
		return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
	};
	scale.interpolate = function(_) {
		return arguments.length ? (interpolate = _, rescale()) : interpolate;
	};
	scale.unknown = function(_) {
		return arguments.length ? (unknown = _, scale) : unknown;
	};
	return function(t, u) {
		transform = t, untransform = u;
		return rescale();
	};
}
function continuous() {
	return transformer$2()(identity, identity);
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatDecimal.js
function formatDecimal_default$1(x) {
	return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function formatDecimalParts$1(x, p) {
	if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
	var i, coefficient = x.slice(0, i);
	return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/exponent.js
function exponent_default$1(x) {
	return x = formatDecimalParts$1(Math.abs(x)), x ? x[1] : NaN;
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatGroup.js
function formatGroup_default$1(grouping, thousands) {
	return function(value, width) {
		var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
		while (i > 0 && g > 0) {
			if (length + g + 1 > width) g = Math.max(1, width - length);
			t.push(value.substring(i -= g, i + g));
			if ((length += g + 1) > width) break;
			g = grouping[j = (j + 1) % grouping.length];
		}
		return t.reverse().join(thousands);
	};
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatNumerals.js
function formatNumerals_default$1(numerals) {
	return function(value) {
		return value.replace(/[0-9]/g, function(i) {
			return numerals[+i];
		});
	};
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatSpecifier.js
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier$1(specifier) {
	if (!(match = re$1.exec(specifier))) throw new Error("invalid format: " + specifier);
	var match;
	return new FormatSpecifier$1({
		fill: match[1],
		align: match[2],
		sign: match[3],
		symbol: match[4],
		zero: match[5],
		width: match[6],
		comma: match[7],
		precision: match[8] && match[8].slice(1),
		trim: match[9],
		type: match[10]
	});
}
formatSpecifier$1.prototype = FormatSpecifier$1.prototype;
function FormatSpecifier$1(specifier) {
	this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
	this.align = specifier.align === void 0 ? ">" : specifier.align + "";
	this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
	this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
	this.zero = !!specifier.zero;
	this.width = specifier.width === void 0 ? void 0 : +specifier.width;
	this.comma = !!specifier.comma;
	this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
	this.trim = !!specifier.trim;
	this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier$1.prototype.toString = function() {
	return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatTrim.js
function formatTrim_default$1(s) {
	out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) switch (s[i]) {
		case ".":
			i0 = i1 = i;
			break;
		case "0":
			if (i0 === 0) i0 = i;
			i1 = i;
			break;
		default:
			if (!+s[i]) break out;
			if (i0 > 0) i0 = 0;
	}
	return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatPrefixAuto.js
var prefixExponent$1;
function formatPrefixAuto_default$1(x, p) {
	var d = formatDecimalParts$1(x, p);
	if (!d) return x + "";
	var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent$1 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
	return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts$1(x, Math.max(0, p + i - 1))[0];
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatRounded.js
function formatRounded_default$1(x, p) {
	var d = formatDecimalParts$1(x, p);
	if (!d) return x + "";
	var coefficient = d[0], exponent = d[1];
	return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/formatTypes.js
var formatTypes_default$1 = {
	"%": (x, p) => (x * 100).toFixed(p),
	"b": (x) => Math.round(x).toString(2),
	"c": (x) => x + "",
	"d": formatDecimal_default$1,
	"e": (x, p) => x.toExponential(p),
	"f": (x, p) => x.toFixed(p),
	"g": (x, p) => x.toPrecision(p),
	"o": (x) => Math.round(x).toString(8),
	"p": (x, p) => formatRounded_default$1(x * 100, p),
	"r": formatRounded_default$1,
	"s": formatPrefixAuto_default$1,
	"X": (x) => Math.round(x).toString(16).toUpperCase(),
	"x": (x) => Math.round(x).toString(16)
};
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/identity.js
function identity_default$1(x) {
	return x;
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/locale.js
var map$1 = Array.prototype.map;
var prefixes$1 = [
	"y",
	"z",
	"a",
	"f",
	"p",
	"n",
	"µ",
	"m",
	"",
	"k",
	"M",
	"G",
	"T",
	"P",
	"E",
	"Z",
	"Y"
];
function locale_default$1(locale) {
	var group = locale.grouping === void 0 || locale.thousands === void 0 ? identity_default$1 : formatGroup_default$1(map$1.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === void 0 ? "" : locale.currency[0] + "", currencySuffix = locale.currency === void 0 ? "" : locale.currency[1] + "", decimal = locale.decimal === void 0 ? "." : locale.decimal + "", numerals = locale.numerals === void 0 ? identity_default$1 : formatNumerals_default$1(map$1.call(locale.numerals, String)), percent = locale.percent === void 0 ? "%" : locale.percent + "", minus = locale.minus === void 0 ? "−" : locale.minus + "", nan = locale.nan === void 0 ? "NaN" : locale.nan + "";
	function newFormat(specifier) {
		specifier = formatSpecifier$1(specifier);
		var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
		if (type === "n") comma = true, type = "g";
		else if (!formatTypes_default$1[type]) precision === void 0 && (precision = 12), trim = true, type = "g";
		if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
		var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
		var formatType = formatTypes_default$1[type], maybeSuffix = /[defgprs%]/.test(type);
		precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
		function format(value) {
			var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
			if (type === "c") {
				valueSuffix = formatType(value) + valueSuffix;
				value = "";
			} else {
				value = +value;
				var valueNegative = value < 0 || 1 / value < 0;
				value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
				if (trim) value = formatTrim_default$1(value);
				if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
				valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
				valueSuffix = (type === "s" ? prefixes$1[8 + prefixExponent$1 / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
				if (maybeSuffix) {
					i = -1, n = value.length;
					while (++i < n) if (c = value.charCodeAt(i), 48 > c || c > 57) {
						valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
						value = value.slice(0, i);
						break;
					}
				}
			}
			if (comma && !zero) value = group(value, Infinity);
			var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
			if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
			switch (align) {
				case "<":
					value = valuePrefix + value + valueSuffix + padding;
					break;
				case "=":
					value = valuePrefix + padding + value + valueSuffix;
					break;
				case "^":
					value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
					break;
				default: value = padding + valuePrefix + value + valueSuffix;
			}
			return numerals(value);
		}
		format.toString = function() {
			return specifier + "";
		};
		return format;
	}
	function formatPrefix(specifier, value) {
		var f = newFormat((specifier = formatSpecifier$1(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent_default$1(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes$1[8 + e / 3];
		return function(value) {
			return f(k * value) + prefix;
		};
	}
	return {
		format: newFormat,
		formatPrefix
	};
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/defaultLocale.js
var locale$2;
var format$1;
var formatPrefix$1;
defaultLocale$2({
	thousands: ",",
	grouping: [3],
	currency: ["$", ""]
});
function defaultLocale$2(definition) {
	locale$2 = locale_default$1(definition);
	format$1 = locale$2.format;
	formatPrefix$1 = locale$2.formatPrefix;
	return locale$2;
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/precisionFixed.js
function precisionFixed_default(step) {
	return Math.max(0, -exponent_default$1(Math.abs(step)));
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/precisionPrefix.js
function precisionPrefix_default(step, value) {
	return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent_default$1(value) / 3))) * 3 - exponent_default$1(Math.abs(step)));
}
//#endregion
//#region ../../node_modules/d3-scale/node_modules/d3-format/src/precisionRound.js
function precisionRound_default(step, max) {
	step = Math.abs(step), max = Math.abs(max) - step;
	return Math.max(0, exponent_default$1(max) - exponent_default$1(step)) + 1;
}
//#endregion
//#region ../../node_modules/d3-scale/src/tickFormat.js
function tickFormat(start, stop, count, specifier) {
	var step = tickStep(start, stop, count), precision;
	specifier = formatSpecifier$1(specifier == null ? ",f" : specifier);
	switch (specifier.type) {
		case "s":
			var value = Math.max(Math.abs(start), Math.abs(stop));
			if (specifier.precision == null && !isNaN(precision = precisionPrefix_default(step, value))) specifier.precision = precision;
			return formatPrefix$1(specifier, value);
		case "":
		case "e":
		case "g":
		case "p":
		case "r":
			if (specifier.precision == null && !isNaN(precision = precisionRound_default(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
			break;
		case "f":
		case "%": if (specifier.precision == null && !isNaN(precision = precisionFixed_default(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	}
	return format$1(specifier);
}
//#endregion
//#region ../../node_modules/d3-scale/src/linear.js
function linearish(scale) {
	var domain = scale.domain;
	scale.ticks = function(count) {
		var d = domain();
		return ticks_default(d[0], d[d.length - 1], count == null ? 10 : count);
	};
	scale.tickFormat = function(count, specifier) {
		var d = domain();
		return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	};
	scale.nice = function(count) {
		if (count == null) count = 10;
		var d = domain();
		var i0 = 0;
		var i1 = d.length - 1;
		var start = d[i0];
		var stop = d[i1];
		var prestep;
		var step;
		var maxIter = 10;
		if (stop < start) {
			step = start, start = stop, stop = step;
			step = i0, i0 = i1, i1 = step;
		}
		while (maxIter-- > 0) {
			step = tickIncrement(start, stop, count);
			if (step === prestep) {
				d[i0] = start;
				d[i1] = stop;
				return domain(d);
			} else if (step > 0) {
				start = Math.floor(start / step) * step;
				stop = Math.ceil(stop / step) * step;
			} else if (step < 0) {
				start = Math.ceil(start * step) / step;
				stop = Math.floor(stop * step) / step;
			} else break;
			prestep = step;
		}
		return scale;
	};
	return scale;
}
function linear() {
	var scale = continuous();
	scale.copy = function() {
		return copy$1(scale, linear());
	};
	initRange.apply(scale, arguments);
	return linearish(scale);
}
//#endregion
//#region ../../node_modules/d3-scale/src/quantize.js
function quantize() {
	var x0 = 0, x1 = 1, n = 1, domain = [.5], range = [0, 1], unknown;
	function scale(x) {
		return x != null && x <= x ? range[bisectRight(domain, x, 0, n)] : unknown;
	}
	function rescale() {
		var i = -1;
		domain = new Array(n);
		while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
		return scale;
	}
	scale.domain = function(_) {
		return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
	};
	scale.range = function(_) {
		return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
	};
	scale.invertExtent = function(y) {
		var i = range.indexOf(y);
		return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
	};
	scale.unknown = function(_) {
		return arguments.length ? (unknown = _, scale) : scale;
	};
	scale.thresholds = function() {
		return domain.slice();
	};
	scale.copy = function() {
		return quantize().domain([x0, x1]).range(range).unknown(unknown);
	};
	return initRange.apply(linearish(scale), arguments);
}
//#endregion
//#region ../../node_modules/d3-time/src/interval.js
var t0$1 = /* @__PURE__ */ new Date();
var t1$1 = /* @__PURE__ */ new Date();
function newInterval$1(floori, offseti, count, field) {
	function interval(date) {
		return floori(date = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date)), date;
	}
	interval.floor = function(date) {
		return floori(date = /* @__PURE__ */ new Date(+date)), date;
	};
	interval.ceil = function(date) {
		return floori(date = /* @__PURE__ */ new Date(date - 1)), offseti(date, 1), floori(date), date;
	};
	interval.round = function(date) {
		var d0 = interval(date), d1 = interval.ceil(date);
		return date - d0 < d1 - date ? d0 : d1;
	};
	interval.offset = function(date, step) {
		return offseti(date = /* @__PURE__ */ new Date(+date), step == null ? 1 : Math.floor(step)), date;
	};
	interval.range = function(start, stop, step) {
		var range = [], previous;
		start = interval.ceil(start);
		step = step == null ? 1 : Math.floor(step);
		if (!(start < stop) || !(step > 0)) return range;
		do
			range.push(previous = /* @__PURE__ */ new Date(+start)), offseti(start, step), floori(start);
		while (previous < start && start < stop);
		return range;
	};
	interval.filter = function(test) {
		return newInterval$1(function(date) {
			if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
		}, function(date, step) {
			if (date >= date) {
				if (step < 0) while (++step <= 0) while (offseti(date, -1), !test(date));
				else while (--step >= 0) while (offseti(date, 1), !test(date));
			}
		});
	};
	if (count) {
		interval.count = function(start, end) {
			t0$1.setTime(+start), t1$1.setTime(+end);
			floori(t0$1), floori(t1$1);
			return Math.floor(count(t0$1, t1$1));
		};
		interval.every = function(step) {
			step = Math.floor(step);
			return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
				return field(d) % step === 0;
			} : function(d) {
				return interval.count(0, d) % step === 0;
			});
		};
	}
	return interval;
}
var durationMinute$1 = 6e4;
var durationDay = durationMinute$1 * 60 * 24;
var durationWeek$1 = durationDay * 7;
//#endregion
//#region ../../node_modules/d3-time/src/day.js
var day = newInterval$1((date) => date.setHours(0, 0, 0, 0), (date, step) => date.setDate(date.getDate() + step), (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay, (date) => date.getDate() - 1);
day.range;
//#endregion
//#region ../../node_modules/d3-time/src/week.js
function weekday$1(i) {
	return newInterval$1(function(date) {
		date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
		date.setHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setDate(date.getDate() + step * 7);
	}, function(start, end) {
		return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
	});
}
var sunday$1 = weekday$1(0);
var monday$1 = weekday$1(1);
var tuesday$1 = weekday$1(2);
var wednesday$1 = weekday$1(3);
var thursday$1 = weekday$1(4);
var friday$1 = weekday$1(5);
var saturday$1 = weekday$1(6);
sunday$1.range;
monday$1.range;
tuesday$1.range;
wednesday$1.range;
thursday$1.range;
friday$1.range;
saturday$1.range;
//#endregion
//#region ../../node_modules/d3-time/src/year.js
var year$1 = newInterval$1(function(date) {
	date.setMonth(0, 1);
	date.setHours(0, 0, 0, 0);
}, function(date, step) {
	date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
	return end.getFullYear() - start.getFullYear();
}, function(date) {
	return date.getFullYear();
});
year$1.every = function(k) {
	return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$1(function(date) {
		date.setFullYear(Math.floor(date.getFullYear() / k) * k);
		date.setMonth(0, 1);
		date.setHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setFullYear(date.getFullYear() + step * k);
	});
};
year$1.range;
//#endregion
//#region ../../node_modules/d3-time/src/utcDay.js
var utcDay = newInterval$1(function(date) {
	date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
	date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
	return (end - start) / durationDay;
}, function(date) {
	return date.getUTCDate() - 1;
});
utcDay.range;
//#endregion
//#region ../../node_modules/d3-time/src/utcWeek.js
function utcWeekday$1(i) {
	return newInterval$1(function(date) {
		date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
		date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setUTCDate(date.getUTCDate() + step * 7);
	}, function(start, end) {
		return (end - start) / durationWeek$1;
	});
}
var utcSunday$1 = utcWeekday$1(0);
var utcMonday$1 = utcWeekday$1(1);
var utcTuesday$1 = utcWeekday$1(2);
var utcWednesday$1 = utcWeekday$1(3);
var utcThursday$1 = utcWeekday$1(4);
var utcFriday$1 = utcWeekday$1(5);
var utcSaturday$1 = utcWeekday$1(6);
utcSunday$1.range;
utcMonday$1.range;
utcTuesday$1.range;
utcWednesday$1.range;
utcThursday$1.range;
utcFriday$1.range;
utcSaturday$1.range;
//#endregion
//#region ../../node_modules/d3-time/src/utcYear.js
var utcYear$1 = newInterval$1(function(date) {
	date.setUTCMonth(0, 1);
	date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
	date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
	return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
	return date.getUTCFullYear();
});
utcYear$1.every = function(k) {
	return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$1(function(date) {
		date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
		date.setUTCMonth(0, 1);
		date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setUTCFullYear(date.getUTCFullYear() + step * k);
	});
};
utcYear$1.range;
//#endregion
//#region ../../node_modules/d3-time-format/src/locale.js
function localDate(d) {
	if (0 <= d.y && d.y < 100) {
		var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
		date.setFullYear(d.y);
		return date;
	}
	return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
	if (0 <= d.y && d.y < 100) {
		var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
		date.setUTCFullYear(d.y);
		return date;
	}
	return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
	return {
		y,
		m,
		d,
		H: 0,
		M: 0,
		S: 0,
		L: 0
	};
}
function formatLocale(locale) {
	var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
	var formats = {
		"a": formatShortWeekday,
		"A": formatWeekday,
		"b": formatShortMonth,
		"B": formatMonth,
		"c": null,
		"d": formatDayOfMonth,
		"e": formatDayOfMonth,
		"f": formatMicroseconds,
		"g": formatYearISO,
		"G": formatFullYearISO,
		"H": formatHour24,
		"I": formatHour12,
		"j": formatDayOfYear,
		"L": formatMilliseconds,
		"m": formatMonthNumber,
		"M": formatMinutes,
		"p": formatPeriod,
		"q": formatQuarter,
		"Q": formatUnixTimestamp,
		"s": formatUnixTimestampSeconds,
		"S": formatSeconds,
		"u": formatWeekdayNumberMonday,
		"U": formatWeekNumberSunday,
		"V": formatWeekNumberISO,
		"w": formatWeekdayNumberSunday,
		"W": formatWeekNumberMonday,
		"x": null,
		"X": null,
		"y": formatYear,
		"Y": formatFullYear,
		"Z": formatZone,
		"%": formatLiteralPercent
	};
	var utcFormats = {
		"a": formatUTCShortWeekday,
		"A": formatUTCWeekday,
		"b": formatUTCShortMonth,
		"B": formatUTCMonth,
		"c": null,
		"d": formatUTCDayOfMonth,
		"e": formatUTCDayOfMonth,
		"f": formatUTCMicroseconds,
		"g": formatUTCYearISO,
		"G": formatUTCFullYearISO,
		"H": formatUTCHour24,
		"I": formatUTCHour12,
		"j": formatUTCDayOfYear,
		"L": formatUTCMilliseconds,
		"m": formatUTCMonthNumber,
		"M": formatUTCMinutes,
		"p": formatUTCPeriod,
		"q": formatUTCQuarter,
		"Q": formatUnixTimestamp,
		"s": formatUnixTimestampSeconds,
		"S": formatUTCSeconds,
		"u": formatUTCWeekdayNumberMonday,
		"U": formatUTCWeekNumberSunday,
		"V": formatUTCWeekNumberISO,
		"w": formatUTCWeekdayNumberSunday,
		"W": formatUTCWeekNumberMonday,
		"x": null,
		"X": null,
		"y": formatUTCYear,
		"Y": formatUTCFullYear,
		"Z": formatUTCZone,
		"%": formatLiteralPercent
	};
	var parses = {
		"a": parseShortWeekday,
		"A": parseWeekday,
		"b": parseShortMonth,
		"B": parseMonth,
		"c": parseLocaleDateTime,
		"d": parseDayOfMonth,
		"e": parseDayOfMonth,
		"f": parseMicroseconds,
		"g": parseYear,
		"G": parseFullYear,
		"H": parseHour24,
		"I": parseHour24,
		"j": parseDayOfYear,
		"L": parseMilliseconds,
		"m": parseMonthNumber,
		"M": parseMinutes,
		"p": parsePeriod,
		"q": parseQuarter,
		"Q": parseUnixTimestamp,
		"s": parseUnixTimestampSeconds,
		"S": parseSeconds,
		"u": parseWeekdayNumberMonday,
		"U": parseWeekNumberSunday,
		"V": parseWeekNumberISO,
		"w": parseWeekdayNumberSunday,
		"W": parseWeekNumberMonday,
		"x": parseLocaleDate,
		"X": parseLocaleTime,
		"y": parseYear,
		"Y": parseFullYear,
		"Z": parseZone,
		"%": parseLiteralPercent
	};
	formats.x = newFormat(locale_date, formats);
	formats.X = newFormat(locale_time, formats);
	formats.c = newFormat(locale_dateTime, formats);
	utcFormats.x = newFormat(locale_date, utcFormats);
	utcFormats.X = newFormat(locale_time, utcFormats);
	utcFormats.c = newFormat(locale_dateTime, utcFormats);
	function newFormat(specifier, formats) {
		return function(date) {
			var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
			if (!(date instanceof Date)) date = /* @__PURE__ */ new Date(+date);
			while (++i < n) if (specifier.charCodeAt(i) === 37) {
				string.push(specifier.slice(j, i));
				if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
				else pad = c === "e" ? " " : "0";
				if (format = formats[c]) c = format(date, pad);
				string.push(c);
				j = i + 1;
			}
			string.push(specifier.slice(j, i));
			return string.join("");
		};
	}
	function newParse(specifier, Z) {
		return function(string) {
			var d = newDate(1900, void 0, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day$1;
			if (i != string.length) return null;
			if ("Q" in d) return new Date(d.Q);
			if ("s" in d) return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
			if (Z && !("Z" in d)) d.Z = 0;
			if ("p" in d) d.H = d.H % 12 + d.p * 12;
			if (d.m === void 0) d.m = "q" in d ? d.q : 0;
			if ("V" in d) {
				if (d.V < 1 || d.V > 53) return null;
				if (!("w" in d)) d.w = 1;
				if ("Z" in d) {
					week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
					week = day$1 > 4 || day$1 === 0 ? utcMonday$1.ceil(week) : utcMonday$1(week);
					week = utcDay.offset(week, (d.V - 1) * 7);
					d.y = week.getUTCFullYear();
					d.m = week.getUTCMonth();
					d.d = week.getUTCDate() + (d.w + 6) % 7;
				} else {
					week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
					week = day$1 > 4 || day$1 === 0 ? monday$1.ceil(week) : monday$1(week);
					week = day.offset(week, (d.V - 1) * 7);
					d.y = week.getFullYear();
					d.m = week.getMonth();
					d.d = week.getDate() + (d.w + 6) % 7;
				}
			} else if ("W" in d || "U" in d) {
				if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
				day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
				d.m = 0;
				d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
			}
			if ("Z" in d) {
				d.H += d.Z / 100 | 0;
				d.M += d.Z % 100;
				return utcDate(d);
			}
			return localDate(d);
		};
	}
	function parseSpecifier(d, specifier, string, j) {
		var i = 0, n = specifier.length, m = string.length, c, parse;
		while (i < n) {
			if (j >= m) return -1;
			c = specifier.charCodeAt(i++);
			if (c === 37) {
				c = specifier.charAt(i++);
				parse = parses[c in pads ? specifier.charAt(i++) : c];
				if (!parse || (j = parse(d, string, j)) < 0) return -1;
			} else if (c != string.charCodeAt(j++)) return -1;
		}
		return j;
	}
	function parsePeriod(d, string, i) {
		var n = periodRe.exec(string.slice(i));
		return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	}
	function parseShortWeekday(d, string, i) {
		var n = shortWeekdayRe.exec(string.slice(i));
		return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	}
	function parseWeekday(d, string, i) {
		var n = weekdayRe.exec(string.slice(i));
		return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	}
	function parseShortMonth(d, string, i) {
		var n = shortMonthRe.exec(string.slice(i));
		return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	}
	function parseMonth(d, string, i) {
		var n = monthRe.exec(string.slice(i));
		return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	}
	function parseLocaleDateTime(d, string, i) {
		return parseSpecifier(d, locale_dateTime, string, i);
	}
	function parseLocaleDate(d, string, i) {
		return parseSpecifier(d, locale_date, string, i);
	}
	function parseLocaleTime(d, string, i) {
		return parseSpecifier(d, locale_time, string, i);
	}
	function formatShortWeekday(d) {
		return locale_shortWeekdays[d.getDay()];
	}
	function formatWeekday(d) {
		return locale_weekdays[d.getDay()];
	}
	function formatShortMonth(d) {
		return locale_shortMonths[d.getMonth()];
	}
	function formatMonth(d) {
		return locale_months[d.getMonth()];
	}
	function formatPeriod(d) {
		return locale_periods[+(d.getHours() >= 12)];
	}
	function formatQuarter(d) {
		return 1 + ~~(d.getMonth() / 3);
	}
	function formatUTCShortWeekday(d) {
		return locale_shortWeekdays[d.getUTCDay()];
	}
	function formatUTCWeekday(d) {
		return locale_weekdays[d.getUTCDay()];
	}
	function formatUTCShortMonth(d) {
		return locale_shortMonths[d.getUTCMonth()];
	}
	function formatUTCMonth(d) {
		return locale_months[d.getUTCMonth()];
	}
	function formatUTCPeriod(d) {
		return locale_periods[+(d.getUTCHours() >= 12)];
	}
	function formatUTCQuarter(d) {
		return 1 + ~~(d.getUTCMonth() / 3);
	}
	return {
		format: function(specifier) {
			var f = newFormat(specifier += "", formats);
			f.toString = function() {
				return specifier;
			};
			return f;
		},
		parse: function(specifier) {
			var p = newParse(specifier += "", false);
			p.toString = function() {
				return specifier;
			};
			return p;
		},
		utcFormat: function(specifier) {
			var f = newFormat(specifier += "", utcFormats);
			f.toString = function() {
				return specifier;
			};
			return f;
		},
		utcParse: function(specifier) {
			var p = newParse(specifier += "", true);
			p.toString = function() {
				return specifier;
			};
			return p;
		}
	};
}
var pads = {
	"-": "",
	"_": " ",
	"0": "0"
};
var numberRe = /^\s*\d+/;
var percentRe = /^%/;
var requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
	var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
	return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
	return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
	return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 1));
	return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 1));
	return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 4));
	return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
	var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 1));
	return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 3));
	return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 2));
	return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 3));
	return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
	var n = numberRe.exec(string.slice(i, i + 6));
	return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
	var n = percentRe.exec(string.slice(i, i + 1));
	return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
	var n = numberRe.exec(string.slice(i));
	return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
	var n = numberRe.exec(string.slice(i));
	return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
	return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
	return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
	return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
	return pad(1 + day.count(year$1(d), d), p, 3);
}
function formatMilliseconds(d, p) {
	return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
	return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
	return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
	return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
	return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
	var day = d.getDay();
	return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
	return pad(sunday$1.count(year$1(d) - 1, d), p, 2);
}
function dISO(d) {
	var day = d.getDay();
	return day >= 4 || day === 0 ? thursday$1(d) : thursday$1.ceil(d);
}
function formatWeekNumberISO(d, p) {
	d = dISO(d);
	return pad(thursday$1.count(year$1(d), d) + (year$1(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
	return d.getDay();
}
function formatWeekNumberMonday(d, p) {
	return pad(monday$1.count(year$1(d) - 1, d), p, 2);
}
function formatYear(d, p) {
	return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
	d = dISO(d);
	return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
	return pad(d.getFullYear() % 1e4, p, 4);
}
function formatFullYearISO(d, p) {
	var day = d.getDay();
	d = day >= 4 || day === 0 ? thursday$1(d) : thursday$1.ceil(d);
	return pad(d.getFullYear() % 1e4, p, 4);
}
function formatZone(d) {
	var z = d.getTimezoneOffset();
	return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
	return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
	return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
	return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
	return pad(1 + utcDay.count(utcYear$1(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
	return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
	return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
	return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
	return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
	return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
	var dow = d.getUTCDay();
	return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
	return pad(utcSunday$1.count(utcYear$1(d) - 1, d), p, 2);
}
function UTCdISO(d) {
	var day = d.getUTCDay();
	return day >= 4 || day === 0 ? utcThursday$1(d) : utcThursday$1.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
	d = UTCdISO(d);
	return pad(utcThursday$1.count(utcYear$1(d), d) + (utcYear$1(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
	return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
	return pad(utcMonday$1.count(utcYear$1(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
	return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
	d = UTCdISO(d);
	return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
	return pad(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCFullYearISO(d, p) {
	var day = d.getUTCDay();
	d = day >= 4 || day === 0 ? utcThursday$1(d) : utcThursday$1.ceil(d);
	return pad(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCZone() {
	return "+0000";
}
function formatLiteralPercent() {
	return "%";
}
function formatUnixTimestamp(d) {
	return +d;
}
function formatUnixTimestampSeconds(d) {
	return Math.floor(+d / 1e3);
}
//#endregion
//#region ../../node_modules/d3-time-format/src/defaultLocale.js
var locale$1;
var timeFormat;
defaultLocale$1({
	dateTime: "%x, %X",
	date: "%-m/%-d/%Y",
	time: "%-I:%M:%S %p",
	periods: ["AM", "PM"],
	days: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	],
	shortDays: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	months: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	shortMonths: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	]
});
function defaultLocale$1(definition) {
	locale$1 = formatLocale(definition);
	timeFormat = locale$1.format;
	locale$1.parse;
	locale$1.utcFormat;
	locale$1.utcParse;
	return locale$1;
}
//#endregion
//#region ../../node_modules/d3-scale/src/sequential.js
function transformer$1() {
	var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = identity, clamp = false, unknown;
	function scale(x) {
		return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? .5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	}
	scale.domain = function(_) {
		return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	};
	scale.clamp = function(_) {
		return arguments.length ? (clamp = !!_, scale) : clamp;
	};
	scale.interpolator = function(_) {
		return arguments.length ? (interpolator = _, scale) : interpolator;
	};
	function range(interpolate) {
		return function(_) {
			var r0, r1;
			return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
		};
	}
	scale.range = range(value_default);
	scale.rangeRound = range(round_default);
	scale.unknown = function(_) {
		return arguments.length ? (unknown = _, scale) : unknown;
	};
	return function(t) {
		transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
		return scale;
	};
}
function copy(source, target) {
	return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
	var scale = linearish(transformer$1()(identity));
	scale.copy = function() {
		return copy(scale, sequential());
	};
	return initInterpolator.apply(scale, arguments);
}
//#endregion
//#region ../../node_modules/d3-scale/src/diverging.js
function transformer() {
	var x0 = 0, x1 = .5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = identity, transform, clamp = false, unknown;
	function scale(x) {
		return isNaN(x = +x) ? unknown : (x = .5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	}
	scale.domain = function(_) {
		return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : .5 / (t1 - t0), k21 = t1 === t2 ? 0 : .5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
			x0,
			x1,
			x2
		];
	};
	scale.clamp = function(_) {
		return arguments.length ? (clamp = !!_, scale) : clamp;
	};
	scale.interpolator = function(_) {
		return arguments.length ? (interpolator = _, scale) : interpolator;
	};
	function range(interpolate) {
		return function(_) {
			var r0, r1, r2;
			return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [
				r0,
				r1,
				r2
			]), scale) : [
				interpolator(0),
				interpolator(.5),
				interpolator(1)
			];
		};
	}
	scale.range = range(value_default);
	scale.rangeRound = range(round_default);
	scale.unknown = function(_) {
		return arguments.length ? (unknown = _, scale) : unknown;
	};
	return function(t) {
		transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : .5 / (t1 - t0), k21 = t1 === t2 ? 0 : .5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
		return scale;
	};
}
function diverging() {
	var scale = linearish(transformer()(identity));
	scale.copy = function() {
		return copy(scale, diverging());
	};
	return initInterpolator.apply(scale, arguments);
}
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/colors.js
function colors_default(specifier) {
	var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
	while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
	return colors;
}
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/category10.js
var category10_default = colors_default("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Accent.js
var Accent_default = colors_default("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Dark2.js
var Dark2_default = colors_default("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Paired.js
var Paired_default = colors_default("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Pastel1.js
var Pastel1_default = colors_default("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Pastel2.js
var Pastel2_default = colors_default("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Set1.js
var Set1_default = colors_default("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Set2.js
var Set2_default = colors_default("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/categorical/Set3.js
var Set3_default = colors_default("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/ramp.js
var ramp_default = (scheme) => rgbBasis(scheme[scheme.length - 1]);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/BrBG.js
var scheme$26 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors_default);
var BrBG_default = ramp_default(scheme$26);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/PRGn.js
var scheme$25 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors_default);
var PRGn_default = ramp_default(scheme$25);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/PiYG.js
var scheme$24 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors_default);
var PiYG_default = ramp_default(scheme$24);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/PuOr.js
var scheme$23 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors_default);
var PuOr_default = ramp_default(scheme$23);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/RdBu.js
var scheme$22 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors_default);
var RdBu_default = ramp_default(scheme$22);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/RdGy.js
var scheme$21 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors_default);
var RdGy_default = ramp_default(scheme$21);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/RdYlBu.js
var scheme$20 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors_default);
var RdYlBu_default = ramp_default(scheme$20);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/RdYlGn.js
var scheme$19 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors_default);
var RdYlGn_default = ramp_default(scheme$19);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/diverging/Spectral.js
var scheme$18 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors_default);
var Spectral_default = ramp_default(scheme$18);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/BuGn.js
var scheme$17 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors_default);
var BuGn_default = ramp_default(scheme$17);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/BuPu.js
var scheme$16 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors_default);
var BuPu_default = ramp_default(scheme$16);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/GnBu.js
var scheme$15 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors_default);
var GnBu_default = ramp_default(scheme$15);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/OrRd.js
var scheme$14 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors_default);
var OrRd_default = ramp_default(scheme$14);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/PuBuGn.js
var scheme$13 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors_default);
var PuBuGn_default = ramp_default(scheme$13);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/PuBu.js
var scheme$12 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors_default);
var PuBu_default = ramp_default(scheme$12);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/PuRd.js
var scheme$11 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors_default);
var PuRd_default = ramp_default(scheme$11);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/RdPu.js
var scheme$10 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors_default);
var RdPu_default = ramp_default(scheme$10);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/YlGnBu.js
var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors_default);
var YlGnBu_default = ramp_default(scheme$9);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/YlGn.js
var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors_default);
var YlGn_default = ramp_default(scheme$8);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/YlOrBr.js
var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors_default);
var YlOrBr_default = ramp_default(scheme$7);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/YlOrRd.js
var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors_default);
var YlOrRd_default = ramp_default(scheme$6);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-single/Blues.js
var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors_default);
var Blues_default = ramp_default(scheme$5);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-single/Greens.js
var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors_default);
var Greens_default = ramp_default(scheme$4);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-single/Greys.js
var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors_default);
var Greys_default = ramp_default(scheme$3);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-single/Purples.js
var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors_default);
var Purples_default = ramp_default(scheme$2);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-single/Reds.js
var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors_default);
var Reds_default = ramp_default(scheme$1);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-single/Oranges.js
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors_default);
var Oranges_default = ramp_default(scheme);
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/cividis.js
function cividis_default(t) {
	t = Math.max(0, Math.min(1, t));
	return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/cubehelix.js
var cubehelix_default = cubehelixLong(cubehelix$1(300, .5, 0), cubehelix$1(-240, .5, 1));
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/rainbow.js
var warm = cubehelixLong(cubehelix$1(-100, .75, .35), cubehelix$1(80, 1.5, .8));
var cool = cubehelixLong(cubehelix$1(260, .75, .35), cubehelix$1(80, 1.5, .8));
var c$2 = cubehelix$1();
function rainbow_default(t) {
	if (t < 0 || t > 1) t -= Math.floor(t);
	var ts = Math.abs(t - .5);
	c$2.h = 360 * t - 100;
	c$2.s = 1.5 - 1.5 * ts;
	c$2.l = .8 - .9 * ts;
	return c$2 + "";
}
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/sinebow.js
var c$1 = rgb();
var pi_1_3 = Math.PI / 3;
var pi_2_3 = Math.PI * 2 / 3;
function sinebow_default(t) {
	var x;
	t = (.5 - t) * Math.PI;
	c$1.r = 255 * (x = Math.sin(t)) * x;
	c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
	c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
	return c$1 + "";
}
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/turbo.js
function turbo_default(t) {
	t = Math.max(0, Math.min(1, t));
	return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}
//#endregion
//#region ../../node_modules/d3-scale-chromatic/src/sequential-multi/viridis.js
function ramp(range) {
	var n = range.length;
	return function(t) {
		return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	};
}
var viridis_default = ramp(colors_default("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp(colors_default("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp(colors_default("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp(colors_default("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
//#endregion
//#region ../../node_modules/lodash/_setCacheAdd.js
var require__setCacheAdd = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = "__lodash_hash_undefined__";
	/**
	* Adds `value` to the array cache.
	*
	* @private
	* @name add
	* @memberOf SetCache
	* @alias push
	* @param {*} value The value to cache.
	* @returns {Object} Returns the cache instance.
	*/
	function setCacheAdd(value) {
		this.__data__.set(value, HASH_UNDEFINED);
		return this;
	}
	module.exports = setCacheAdd;
}));
//#endregion
//#region ../../node_modules/lodash/_setCacheHas.js
var require__setCacheHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is in the array cache.
	*
	* @private
	* @name has
	* @memberOf SetCache
	* @param {*} value The value to search for.
	* @returns {boolean} Returns `true` if `value` is found, else `false`.
	*/
	function setCacheHas(value) {
		return this.__data__.has(value);
	}
	module.exports = setCacheHas;
}));
//#endregion
//#region ../../node_modules/lodash/_SetCache.js
var require__SetCache = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var MapCache = require__MapCache();
	var setCacheAdd = require__setCacheAdd();
	var setCacheHas = require__setCacheHas();
	/**
	*
	* Creates an array cache object to store unique values.
	*
	* @private
	* @constructor
	* @param {Array} [values] The values to cache.
	*/
	function SetCache(values) {
		var index = -1, length = values == null ? 0 : values.length;
		this.__data__ = new MapCache();
		while (++index < length) this.add(values[index]);
	}
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	module.exports = SetCache;
}));
//#endregion
//#region ../../node_modules/lodash/_baseFindIndex.js
var require__baseFindIndex = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.findIndex` and `_.findLastIndex` without
	* support for iteratee shorthands.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {Function} predicate The function invoked per iteration.
	* @param {number} fromIndex The index to search from.
	* @param {boolean} [fromRight] Specify iterating from right to left.
	* @returns {number} Returns the index of the matched value, else `-1`.
	*/
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
		var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
		while (fromRight ? index-- : ++index < length) if (predicate(array[index], index, array)) return index;
		return -1;
	}
	module.exports = baseFindIndex;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsNaN.js
var require__baseIsNaN = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.isNaN` without support for number objects.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	*/
	function baseIsNaN(value) {
		return value !== value;
	}
	module.exports = baseIsNaN;
}));
//#endregion
//#region ../../node_modules/lodash/_strictIndexOf.js
var require__strictIndexOf = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `_.indexOf` which performs strict equality
	* comparisons of values, i.e. `===`.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {*} value The value to search for.
	* @param {number} fromIndex The index to search from.
	* @returns {number} Returns the index of the matched value, else `-1`.
	*/
	function strictIndexOf(array, value, fromIndex) {
		var index = fromIndex - 1, length = array.length;
		while (++index < length) if (array[index] === value) return index;
		return -1;
	}
	module.exports = strictIndexOf;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIndexOf.js
var require__baseIndexOf = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseFindIndex = require__baseFindIndex();
	var baseIsNaN = require__baseIsNaN();
	var strictIndexOf = require__strictIndexOf();
	/**
	* The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {*} value The value to search for.
	* @param {number} fromIndex The index to search from.
	* @returns {number} Returns the index of the matched value, else `-1`.
	*/
	function baseIndexOf(array, value, fromIndex) {
		return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	module.exports = baseIndexOf;
}));
//#endregion
//#region ../../node_modules/lodash/_arrayIncludes.js
var require__arrayIncludes = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIndexOf = require__baseIndexOf();
	/**
	* A specialized version of `_.includes` for arrays without support for
	* specifying an index to search from.
	*
	* @private
	* @param {Array} [array] The array to inspect.
	* @param {*} target The value to search for.
	* @returns {boolean} Returns `true` if `target` is found, else `false`.
	*/
	function arrayIncludes(array, value) {
		return !!(array == null ? 0 : array.length) && baseIndexOf(array, value, 0) > -1;
	}
	module.exports = arrayIncludes;
}));
//#endregion
//#region ../../node_modules/lodash/_arrayIncludesWith.js
var require__arrayIncludesWith = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This function is like `arrayIncludes` except that it accepts a comparator.
	*
	* @private
	* @param {Array} [array] The array to inspect.
	* @param {*} target The value to search for.
	* @param {Function} comparator The comparator invoked per element.
	* @returns {boolean} Returns `true` if `target` is found, else `false`.
	*/
	function arrayIncludesWith(array, value, comparator) {
		var index = -1, length = array == null ? 0 : array.length;
		while (++index < length) if (comparator(value, array[index])) return true;
		return false;
	}
	module.exports = arrayIncludesWith;
}));
//#endregion
//#region ../../node_modules/lodash/_cacheHas.js
var require__cacheHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if a `cache` value for `key` exists.
	*
	* @private
	* @param {Object} cache The cache to query.
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function cacheHas(cache, key) {
		return cache.has(key);
	}
	module.exports = cacheHas;
}));
//#endregion
//#region ../../node_modules/lodash/_baseDifference.js
var require__baseDifference = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var SetCache = require__SetCache();
	var arrayIncludes = require__arrayIncludes();
	var arrayIncludesWith = require__arrayIncludesWith();
	var arrayMap = require__arrayMap();
	var baseUnary = require__baseUnary();
	var cacheHas = require__cacheHas();
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	/**
	* The base implementation of methods like `_.difference` without support
	* for excluding multiple arrays or iteratee shorthands.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {Array} values The values to exclude.
	* @param {Function} [iteratee] The iteratee invoked per element.
	* @param {Function} [comparator] The comparator invoked per element.
	* @returns {Array} Returns the new array of filtered values.
	*/
	function baseDifference(array, values, iteratee, comparator) {
		var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
		if (!length) return result;
		if (iteratee) values = arrayMap(values, baseUnary(iteratee));
		if (comparator) {
			includes = arrayIncludesWith;
			isCommon = false;
		} else if (values.length >= LARGE_ARRAY_SIZE) {
			includes = cacheHas;
			isCommon = false;
			values = new SetCache(values);
		}
		outer: while (++index < length) {
			var value = array[index], computed = iteratee == null ? value : iteratee(value);
			value = comparator || value !== 0 ? value : 0;
			if (isCommon && computed === computed) {
				var valuesIndex = valuesLength;
				while (valuesIndex--) if (values[valuesIndex] === computed) continue outer;
				result.push(value);
			} else if (!includes(values, computed, comparator)) result.push(value);
		}
		return result;
	}
	module.exports = baseDifference;
}));
//#endregion
//#region ../../node_modules/lodash/without.js
var require_without = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseDifference = require__baseDifference();
	var baseRest = require__baseRest();
	var isArrayLikeObject = require_isArrayLikeObject();
	module.exports = baseRest(function(array, values) {
		return isArrayLikeObject(array) ? baseDifference(array, values) : [];
	});
}));
var pi$1 = Math.PI;
pi$1 / 2;
2 * pi$1;
//#endregion
//#region ../../node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
	this._context = context;
}
Linear.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._point = 0;
	},
	lineEnd: function() {
		if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
				break;
			case 1: this._point = 2;
			default: this._context.lineTo(x, y);
		}
	}
};
function linear_default(context) {
	return new Linear(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/noop.js
function noop_default() {}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/basis.js
function point$3(that, x, y) {
	that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
	this._context = context;
}
Basis.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._y0 = this._y1 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 3: point$3(this, this._x1, this._y1);
			case 2: this._context.lineTo(this._x1, this._y1);
		}
		if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
				break;
			case 1:
				this._point = 2;
				break;
			case 2:
				this._point = 3;
				this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
			default: point$3(this, x, y);
		}
		this._x0 = this._x1, this._x1 = x;
		this._y0 = this._y1, this._y1 = y;
	}
};
function basis_default(context) {
	return new Basis(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/basisClosed.js
function BasisClosed(context) {
	this._context = context;
}
BasisClosed.prototype = {
	areaStart: noop_default,
	areaEnd: noop_default,
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 1:
				this._context.moveTo(this._x2, this._y2);
				this._context.closePath();
				break;
			case 2:
				this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
				this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
				this._context.closePath();
				break;
			case 3:
				this.point(this._x2, this._y2);
				this.point(this._x3, this._y3);
				this.point(this._x4, this._y4);
		}
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._x2 = x, this._y2 = y;
				break;
			case 1:
				this._point = 2;
				this._x3 = x, this._y3 = y;
				break;
			case 2:
				this._point = 3;
				this._x4 = x, this._y4 = y;
				this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
				break;
			default: point$3(this, x, y);
		}
		this._x0 = this._x1, this._x1 = x;
		this._y0 = this._y1, this._y1 = y;
	}
};
function basisClosed_default(context) {
	return new BasisClosed(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/basisOpen.js
function BasisOpen(context) {
	this._context = context;
}
BasisOpen.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._y0 = this._y1 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				break;
			case 1:
				this._point = 2;
				break;
			case 2:
				this._point = 3;
				var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
				this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
				break;
			case 3: this._point = 4;
			default: point$3(this, x, y);
		}
		this._x0 = this._x1, this._x1 = x;
		this._y0 = this._y1, this._y1 = y;
	}
};
function basisOpen_default(context) {
	return new BasisOpen(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/bundle.js
function Bundle(context, beta) {
	this._basis = new Basis(context);
	this._beta = beta;
}
Bundle.prototype = {
	lineStart: function() {
		this._x = [];
		this._y = [];
		this._basis.lineStart();
	},
	lineEnd: function() {
		var x = this._x, y = this._y, j = x.length - 1;
		if (j > 0) {
			var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
			while (++i <= j) {
				t = i / j;
				this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
			}
		}
		this._x = this._y = null;
		this._basis.lineEnd();
	},
	point: function(x, y) {
		this._x.push(+x);
		this._y.push(+y);
	}
};
var bundle_default = (function custom(beta) {
	function bundle(context) {
		return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	}
	bundle.beta = function(beta) {
		return custom(+beta);
	};
	return bundle;
})(.85);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/cardinal.js
function point$2(that, x, y) {
	that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
	this._context = context;
	this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 2:
				this._context.lineTo(this._x2, this._y2);
				break;
			case 3: point$2(this, this._x1, this._y1);
		}
		if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
				break;
			case 1:
				this._point = 2;
				this._x1 = x, this._y1 = y;
				break;
			case 2: this._point = 3;
			default: point$2(this, x, y);
		}
		this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
		this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	}
};
var cardinal_default = (function custom(tension) {
	function cardinal(context) {
		return new Cardinal(context, tension);
	}
	cardinal.tension = function(tension) {
		return custom(+tension);
	};
	return cardinal;
})(0);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/cardinalClosed.js
function CardinalClosed(context, tension) {
	this._context = context;
	this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
	areaStart: noop_default,
	areaEnd: noop_default,
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 1:
				this._context.moveTo(this._x3, this._y3);
				this._context.closePath();
				break;
			case 2:
				this._context.lineTo(this._x3, this._y3);
				this._context.closePath();
				break;
			case 3:
				this.point(this._x3, this._y3);
				this.point(this._x4, this._y4);
				this.point(this._x5, this._y5);
		}
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._x3 = x, this._y3 = y;
				break;
			case 1:
				this._point = 2;
				this._context.moveTo(this._x4 = x, this._y4 = y);
				break;
			case 2:
				this._point = 3;
				this._x5 = x, this._y5 = y;
				break;
			default: point$2(this, x, y);
		}
		this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
		this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	}
};
var cardinalClosed_default = (function custom(tension) {
	function cardinal(context) {
		return new CardinalClosed(context, tension);
	}
	cardinal.tension = function(tension) {
		return custom(+tension);
	};
	return cardinal;
})(0);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/cardinalOpen.js
function CardinalOpen(context, tension) {
	this._context = context;
	this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				break;
			case 1:
				this._point = 2;
				break;
			case 2:
				this._point = 3;
				this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
				break;
			case 3: this._point = 4;
			default: point$2(this, x, y);
		}
		this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
		this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	}
};
var cardinalOpen_default = (function custom(tension) {
	function cardinal(context) {
		return new CardinalOpen(context, tension);
	}
	cardinal.tension = function(tension) {
		return custom(+tension);
	};
	return cardinal;
})(0);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/catmullRom.js
function point$1(that, x, y) {
	var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
	if (that._l01_a > 1e-12) {
		var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
		x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
		y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	}
	if (that._l23_a > 1e-12) {
		var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
		x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
		y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	}
	that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
	this._context = context;
	this._alpha = alpha;
}
CatmullRom.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
		this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 2:
				this._context.lineTo(this._x2, this._y2);
				break;
			case 3: this.point(this._x2, this._y2);
		}
		if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		if (this._point) {
			var x23 = this._x2 - x, y23 = this._y2 - y;
			this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
		}
		switch (this._point) {
			case 0:
				this._point = 1;
				this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
				break;
			case 1:
				this._point = 2;
				break;
			case 2: this._point = 3;
			default: point$1(this, x, y);
		}
		this._l01_a = this._l12_a, this._l12_a = this._l23_a;
		this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
		this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
		this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	}
};
var catmullRom_default = (function custom(alpha) {
	function catmullRom(context) {
		return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	}
	catmullRom.alpha = function(alpha) {
		return custom(+alpha);
	};
	return catmullRom;
})(.5);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/catmullRomClosed.js
function CatmullRomClosed(context, alpha) {
	this._context = context;
	this._alpha = alpha;
}
CatmullRomClosed.prototype = {
	areaStart: noop_default,
	areaEnd: noop_default,
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
		this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 1:
				this._context.moveTo(this._x3, this._y3);
				this._context.closePath();
				break;
			case 2:
				this._context.lineTo(this._x3, this._y3);
				this._context.closePath();
				break;
			case 3:
				this.point(this._x3, this._y3);
				this.point(this._x4, this._y4);
				this.point(this._x5, this._y5);
		}
	},
	point: function(x, y) {
		x = +x, y = +y;
		if (this._point) {
			var x23 = this._x2 - x, y23 = this._y2 - y;
			this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
		}
		switch (this._point) {
			case 0:
				this._point = 1;
				this._x3 = x, this._y3 = y;
				break;
			case 1:
				this._point = 2;
				this._context.moveTo(this._x4 = x, this._y4 = y);
				break;
			case 2:
				this._point = 3;
				this._x5 = x, this._y5 = y;
				break;
			default: point$1(this, x, y);
		}
		this._l01_a = this._l12_a, this._l12_a = this._l23_a;
		this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
		this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
		this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	}
};
var catmullRomClosed_default = (function custom(alpha) {
	function catmullRom(context) {
		return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	}
	catmullRom.alpha = function(alpha) {
		return custom(+alpha);
	};
	return catmullRom;
})(.5);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/catmullRomOpen.js
function CatmullRomOpen(context, alpha) {
	this._context = context;
	this._alpha = alpha;
}
CatmullRomOpen.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
		this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
	},
	lineEnd: function() {
		if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		if (this._point) {
			var x23 = this._x2 - x, y23 = this._y2 - y;
			this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
		}
		switch (this._point) {
			case 0:
				this._point = 1;
				break;
			case 1:
				this._point = 2;
				break;
			case 2:
				this._point = 3;
				this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
				break;
			case 3: this._point = 4;
			default: point$1(this, x, y);
		}
		this._l01_a = this._l12_a, this._l12_a = this._l23_a;
		this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
		this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
		this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	}
};
var catmullRomOpen_default = (function custom(alpha) {
	function catmullRom(context) {
		return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	}
	catmullRom.alpha = function(alpha) {
		return custom(+alpha);
	};
	return catmullRom;
})(.5);
//#endregion
//#region ../../node_modules/d3-shape/src/curve/linearClosed.js
function LinearClosed(context) {
	this._context = context;
}
LinearClosed.prototype = {
	areaStart: noop_default,
	areaEnd: noop_default,
	lineStart: function() {
		this._point = 0;
	},
	lineEnd: function() {
		if (this._point) this._context.closePath();
	},
	point: function(x, y) {
		x = +x, y = +y;
		if (this._point) this._context.lineTo(x, y);
		else this._point = 1, this._context.moveTo(x, y);
	}
};
function linearClosed_default(context) {
	return new LinearClosed(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/monotone.js
function sign(x) {
	return x < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
	var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
	return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), .5 * Math.abs(p)) || 0;
}
function slope2(that, t) {
	var h = that._x1 - that._x0;
	return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
function point(that, t0, t1) {
	var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
	that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
	this._context = context;
}
MonotoneX.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 2:
				this._context.lineTo(this._x1, this._y1);
				break;
			case 3: point(this, this._t0, slope2(this, this._t0));
		}
		if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
		this._line = 1 - this._line;
	},
	point: function(x, y) {
		var t1 = NaN;
		x = +x, y = +y;
		if (x === this._x1 && y === this._y1) return;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
				break;
			case 1:
				this._point = 2;
				break;
			case 2:
				this._point = 3;
				point(this, slope2(this, t1 = slope3(this, x, y)), t1);
				break;
			default: point(this, this._t0, t1 = slope3(this, x, y));
		}
		this._x0 = this._x1, this._x1 = x;
		this._y0 = this._y1, this._y1 = y;
		this._t0 = t1;
	}
};
function MonotoneY(context) {
	this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
	this._context = context;
}
ReflectContext.prototype = {
	moveTo: function(x, y) {
		this._context.moveTo(y, x);
	},
	closePath: function() {
		this._context.closePath();
	},
	lineTo: function(x, y) {
		this._context.lineTo(y, x);
	},
	bezierCurveTo: function(x1, y1, x2, y2, x, y) {
		this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
	}
};
function monotoneX(context) {
	return new MonotoneX(context);
}
function monotoneY(context) {
	return new MonotoneY(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/natural.js
function Natural(context) {
	this._context = context;
}
Natural.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x = [];
		this._y = [];
	},
	lineEnd: function() {
		var x = this._x, y = this._y, n = x.length;
		if (n) {
			this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
			if (n === 2) this._context.lineTo(x[1], y[1]);
			else {
				var px = controlPoints(x), py = controlPoints(y);
				for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
			}
		}
		if (this._line || this._line !== 0 && n === 1) this._context.closePath();
		this._line = 1 - this._line;
		this._x = this._y = null;
	},
	point: function(x, y) {
		this._x.push(+x);
		this._y.push(+y);
	}
};
function controlPoints(x) {
	var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
	a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	a[n - 1] = r[n - 1] / b[n - 1];
	for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	b[n - 1] = (x[n] + a[n - 1]) / 2;
	for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	return [a, b];
}
function natural_default(context) {
	return new Natural(context);
}
//#endregion
//#region ../../node_modules/d3-shape/src/curve/step.js
function Step(context, t) {
	this._context = context;
	this._t = t;
}
Step.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x = this._y = NaN;
		this._point = 0;
	},
	lineEnd: function() {
		if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
		if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
		if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	},
	point: function(x, y) {
		x = +x, y = +y;
		switch (this._point) {
			case 0:
				this._point = 1;
				this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
				break;
			case 1: this._point = 2;
			default: if (this._t <= 0) {
				this._context.lineTo(this._x, y);
				this._context.lineTo(x, y);
			} else {
				var x1 = this._x * (1 - this._t) + x * this._t;
				this._context.lineTo(x1, this._y);
				this._context.lineTo(x1, y);
			}
		}
		this._x = x, this._y = y;
	}
};
function step_default(context) {
	return new Step(context, .5);
}
function stepBefore(context) {
	return new Step(context, 0);
}
function stepAfter(context) {
	return new Step(context, 1);
}
//#endregion
//#region ../../node_modules/d3-shape/src/offset/none.js
function none_default$1(series, order) {
	if (!((n = series.length) > 1)) return;
	for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
		s0 = s1, s1 = series[order[i]];
		for (j = 0; j < m; ++j) s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	}
}
//#endregion
//#region ../../node_modules/d3-shape/src/order/none.js
function none_default(series) {
	var n = series.length, o = new Array(n);
	while (--n >= 0) o[n] = n;
	return o;
}
//#endregion
//#region ../../node_modules/d3-shape/src/offset/expand.js
function expand_default(series, order) {
	if (!((n = series.length) > 0)) return;
	for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
		for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
		if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	}
	none_default$1(series, order);
}
//#endregion
//#region ../../node_modules/d3-shape/src/offset/diverging.js
function diverging_default(series, order) {
	if (!((n = series.length) > 0)) return;
	for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) for (yp = yn = 0, i = 0; i < n; ++i) if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
	else if (dy < 0) d[1] = yn, d[0] = yn += dy;
	else d[0] = 0, d[1] = dy;
}
//#endregion
//#region ../../node_modules/d3-shape/src/offset/silhouette.js
function silhouette_default(series, order) {
	if (!((n = series.length) > 0)) return;
	for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
		for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
		s0[j][1] += s0[j][0] = -y / 2;
	}
	none_default$1(series, order);
}
//#endregion
//#region ../../node_modules/d3-shape/src/offset/wiggle.js
function wiggle_default(series, order) {
	if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
		for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
			var si = series[order[i]], sij0 = si[j][1] || 0, s3 = (sij0 - (si[j - 1][1] || 0)) / 2;
			for (var k = 0; k < i; ++k) {
				var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
				s3 += skj0 - skj1;
			}
			s1 += sij0, s2 += s3 * sij0;
		}
		s0[j - 1][1] += s0[j - 1][0] = y;
		if (s1) y -= s2 / s1;
	}
	s0[j - 1][1] += s0[j - 1][0] = y;
	none_default$1(series, order);
}
//#endregion
//#region ../../node_modules/d3-shape/src/order/appearance.js
function appearance_default(series) {
	var peaks = series.map(peak);
	return none_default(series).sort(function(a, b) {
		return peaks[a] - peaks[b];
	});
}
function peak(series) {
	var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	return j;
}
//#endregion
//#region ../../node_modules/d3-shape/src/order/ascending.js
function ascending_default(series) {
	var sums = series.map(sum);
	return none_default(series).sort(function(a, b) {
		return sums[a] - sums[b];
	});
}
function sum(series) {
	var s = 0, i = -1, n = series.length, v;
	while (++i < n) if (v = +series[i][1]) s += v;
	return s;
}
//#endregion
//#region ../../node_modules/d3-shape/src/order/descending.js
function descending_default(series) {
	return ascending_default(series).reverse();
}
//#endregion
//#region ../../node_modules/d3-shape/src/order/insideOut.js
function insideOut_default(series) {
	var n = series.length, i, j, sums = series.map(sum), order = appearance_default(series), top = 0, bottom = 0, tops = [], bottoms = [];
	for (i = 0; i < n; ++i) {
		j = order[i];
		if (top < bottom) {
			top += sums[j];
			tops.push(j);
		} else {
			bottom += sums[j];
			bottoms.push(j);
		}
	}
	return bottoms.reverse().concat(tops);
}
//#endregion
//#region ../../node_modules/d3-shape/src/order/reverse.js
function reverse_default(series) {
	return none_default(series).reverse();
}
//#endregion
//#region ../../node_modules/d3-format/src/formatDecimal.js
function formatDecimal_default(x) {
	return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function formatDecimalParts(x, p) {
	if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
	var i, coefficient = x.slice(0, i);
	return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}
//#endregion
//#region ../../node_modules/d3-format/src/exponent.js
function exponent_default(x) {
	return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}
//#endregion
//#region ../../node_modules/d3-format/src/formatGroup.js
function formatGroup_default(grouping, thousands) {
	return function(value, width) {
		var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
		while (i > 0 && g > 0) {
			if (length + g + 1 > width) g = Math.max(1, width - length);
			t.push(value.substring(i -= g, i + g));
			if ((length += g + 1) > width) break;
			g = grouping[j = (j + 1) % grouping.length];
		}
		return t.reverse().join(thousands);
	};
}
//#endregion
//#region ../../node_modules/d3-format/src/formatNumerals.js
function formatNumerals_default(numerals) {
	return function(value) {
		return value.replace(/[0-9]/g, function(i) {
			return numerals[+i];
		});
	};
}
//#endregion
//#region ../../node_modules/d3-format/src/formatSpecifier.js
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
	if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	var match;
	return new FormatSpecifier({
		fill: match[1],
		align: match[2],
		sign: match[3],
		symbol: match[4],
		zero: match[5],
		width: match[6],
		comma: match[7],
		precision: match[8] && match[8].slice(1),
		trim: match[9],
		type: match[10]
	});
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
	this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
	this.align = specifier.align === void 0 ? ">" : specifier.align + "";
	this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
	this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
	this.zero = !!specifier.zero;
	this.width = specifier.width === void 0 ? void 0 : +specifier.width;
	this.comma = !!specifier.comma;
	this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
	this.trim = !!specifier.trim;
	this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
	return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
//#endregion
//#region ../../node_modules/d3-format/src/formatTrim.js
function formatTrim_default(s) {
	out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) switch (s[i]) {
		case ".":
			i0 = i1 = i;
			break;
		case "0":
			if (i0 === 0) i0 = i;
			i1 = i;
			break;
		default:
			if (!+s[i]) break out;
			if (i0 > 0) i0 = 0;
	}
	return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
//#endregion
//#region ../../node_modules/d3-format/src/formatPrefixAuto.js
var prefixExponent;
function formatPrefixAuto_default(x, p) {
	var d = formatDecimalParts(x, p);
	if (!d) return x + "";
	var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
	return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
}
//#endregion
//#region ../../node_modules/d3-format/src/formatRounded.js
function formatRounded_default(x, p) {
	var d = formatDecimalParts(x, p);
	if (!d) return x + "";
	var coefficient = d[0], exponent = d[1];
	return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}
//#endregion
//#region ../../node_modules/d3-format/src/formatTypes.js
var formatTypes_default = {
	"%": function(x, p) {
		return (x * 100).toFixed(p);
	},
	"b": function(x) {
		return Math.round(x).toString(2);
	},
	"c": function(x) {
		return x + "";
	},
	"d": formatDecimal_default,
	"e": function(x, p) {
		return x.toExponential(p);
	},
	"f": function(x, p) {
		return x.toFixed(p);
	},
	"g": function(x, p) {
		return x.toPrecision(p);
	},
	"o": function(x) {
		return Math.round(x).toString(8);
	},
	"p": function(x, p) {
		return formatRounded_default(x * 100, p);
	},
	"r": formatRounded_default,
	"s": formatPrefixAuto_default,
	"X": function(x) {
		return Math.round(x).toString(16).toUpperCase();
	},
	"x": function(x) {
		return Math.round(x).toString(16);
	}
};
//#endregion
//#region ../../node_modules/d3-format/src/identity.js
function identity_default(x) {
	return x;
}
//#endregion
//#region ../../node_modules/d3-format/src/locale.js
var map = Array.prototype.map;
var prefixes = [
	"y",
	"z",
	"a",
	"f",
	"p",
	"n",
	"µ",
	"m",
	"",
	"k",
	"M",
	"G",
	"T",
	"P",
	"E",
	"Z",
	"Y"
];
function locale_default(locale) {
	var group = locale.grouping === void 0 || locale.thousands === void 0 ? identity_default : formatGroup_default(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === void 0 ? "" : locale.currency[0] + "", currencySuffix = locale.currency === void 0 ? "" : locale.currency[1] + "", decimal = locale.decimal === void 0 ? "." : locale.decimal + "", numerals = locale.numerals === void 0 ? identity_default : formatNumerals_default(map.call(locale.numerals, String)), percent = locale.percent === void 0 ? "%" : locale.percent + "", minus = locale.minus === void 0 ? "-" : locale.minus + "", nan = locale.nan === void 0 ? "NaN" : locale.nan + "";
	function newFormat(specifier) {
		specifier = formatSpecifier(specifier);
		var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
		if (type === "n") comma = true, type = "g";
		else if (!formatTypes_default[type]) precision === void 0 && (precision = 12), trim = true, type = "g";
		if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
		var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
		var formatType = formatTypes_default[type], maybeSuffix = /[defgprs%]/.test(type);
		precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
		function format(value) {
			var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
			if (type === "c") {
				valueSuffix = formatType(value) + valueSuffix;
				value = "";
			} else {
				value = +value;
				var valueNegative = value < 0 || 1 / value < 0;
				value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
				if (trim) value = formatTrim_default(value);
				if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
				valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
				valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
				if (maybeSuffix) {
					i = -1, n = value.length;
					while (++i < n) if (c = value.charCodeAt(i), 48 > c || c > 57) {
						valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
						value = value.slice(0, i);
						break;
					}
				}
			}
			if (comma && !zero) value = group(value, Infinity);
			var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
			if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
			switch (align) {
				case "<":
					value = valuePrefix + value + valueSuffix + padding;
					break;
				case "=":
					value = valuePrefix + padding + value + valueSuffix;
					break;
				case "^":
					value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
					break;
				default: value = padding + valuePrefix + value + valueSuffix;
			}
			return numerals(value);
		}
		format.toString = function() {
			return specifier + "";
		};
		return format;
	}
	function formatPrefix(specifier, value) {
		var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent_default(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
		return function(value) {
			return f(k * value) + prefix;
		};
	}
	return {
		format: newFormat,
		formatPrefix
	};
}
//#endregion
//#region ../../node_modules/d3-format/src/defaultLocale.js
var locale;
var format;
defaultLocale({
	decimal: ".",
	thousands: ",",
	grouping: [3],
	currency: ["$", ""],
	minus: "-"
});
function defaultLocale(definition) {
	locale = locale_default(definition);
	format = locale.format;
	locale.formatPrefix;
	return locale;
}
//#endregion
//#region ../../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
var import_isFunction = /* @__PURE__ */ __toESM(require_isFunction());
require_isArray();
var import_merge = /* @__PURE__ */ __toESM(require_merge());
var import_get = /* @__PURE__ */ __toESM(require_get());
var import_set = /* @__PURE__ */ __toESM(require_set());
var import_isString = /* @__PURE__ */ __toESM(require_isString());
var import_last = /* @__PURE__ */ __toESM(require_last());
var import_without = /* @__PURE__ */ __toESM(require_without());
/**
* Copyright (c) 2013-present, Facebook, Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
function componentWillMount() {
	var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	if (state !== null && state !== void 0) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
	function updater(prevState) {
		var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
		return state !== null && state !== void 0 ? state : null;
	}
	this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
	try {
		var prevProps = this.props;
		var prevState = this.state;
		this.props = nextProps;
		this.state = nextState;
		this.__reactInternalSnapshotFlag = true;
		this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
	} finally {
		this.props = prevProps;
		this.state = prevState;
	}
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
//#endregion
//#region ../../node_modules/lodash/_arraySome.js
var require__arraySome = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `_.some` for arrays without support for iteratee
	* shorthands.
	*
	* @private
	* @param {Array} [array] The array to iterate over.
	* @param {Function} predicate The function invoked per iteration.
	* @returns {boolean} Returns `true` if any element passes the predicate check,
	*  else `false`.
	*/
	function arraySome(array, predicate) {
		var index = -1, length = array == null ? 0 : array.length;
		while (++index < length) if (predicate(array[index], index, array)) return true;
		return false;
	}
	module.exports = arraySome;
}));
//#endregion
//#region ../../node_modules/lodash/_equalArrays.js
var require__equalArrays = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var SetCache = require__SetCache();
	var arraySome = require__arraySome();
	var cacheHas = require__cacheHas();
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	var COMPARE_UNORDERED_FLAG = 2;
	/**
	* A specialized version of `baseIsEqualDeep` for arrays with support for
	* partial deep comparisons.
	*
	* @private
	* @param {Array} array The array to compare.
	* @param {Array} other The other array to compare.
	* @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	* @param {Function} customizer The function to customize comparisons.
	* @param {Function} equalFunc The function to determine equivalents of values.
	* @param {Object} stack Tracks traversed `array` and `other` objects.
	* @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	*/
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
		if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
		var arrStacked = stack.get(array);
		var othStacked = stack.get(other);
		if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
		var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
		stack.set(array, other);
		stack.set(other, array);
		while (++index < arrLength) {
			var arrValue = array[index], othValue = other[index];
			if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
			if (compared !== void 0) {
				if (compared) continue;
				result = false;
				break;
			}
			if (seen) {
				if (!arraySome(other, function(othValue, othIndex) {
					if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
				})) {
					result = false;
					break;
				}
			} else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
				result = false;
				break;
			}
		}
		stack["delete"](array);
		stack["delete"](other);
		return result;
	}
	module.exports = equalArrays;
}));
//#endregion
//#region ../../node_modules/lodash/_mapToArray.js
var require__mapToArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Converts `map` to its key-value pairs.
	*
	* @private
	* @param {Object} map The map to convert.
	* @returns {Array} Returns the key-value pairs.
	*/
	function mapToArray(map) {
		var index = -1, result = Array(map.size);
		map.forEach(function(value, key) {
			result[++index] = [key, value];
		});
		return result;
	}
	module.exports = mapToArray;
}));
//#endregion
//#region ../../node_modules/lodash/_setToArray.js
var require__setToArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Converts `set` to an array of its values.
	*
	* @private
	* @param {Object} set The set to convert.
	* @returns {Array} Returns the values.
	*/
	function setToArray(set) {
		var index = -1, result = Array(set.size);
		set.forEach(function(value) {
			result[++index] = value;
		});
		return result;
	}
	module.exports = setToArray;
}));
//#endregion
//#region ../../node_modules/lodash/_equalByTag.js
var require__equalByTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	var Uint8Array = require__Uint8Array();
	var eq = require_eq();
	var equalArrays = require__equalArrays();
	var mapToArray = require__mapToArray();
	var setToArray = require__setToArray();
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	var COMPARE_UNORDERED_FLAG = 2;
	/** `Object#toString` result references. */
	var boolTag = "[object Boolean]";
	var dateTag = "[object Date]";
	var errorTag = "[object Error]";
	var mapTag = "[object Map]";
	var numberTag = "[object Number]";
	var regexpTag = "[object RegExp]";
	var setTag = "[object Set]";
	var stringTag = "[object String]";
	var symbolTag = "[object Symbol]";
	var arrayBufferTag = "[object ArrayBuffer]";
	var dataViewTag = "[object DataView]";
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : void 0;
	var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
	/**
	* A specialized version of `baseIsEqualDeep` for comparing objects of
	* the same `toStringTag`.
	*
	* **Note:** This function only supports comparing values with tags of
	* `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	*
	* @private
	* @param {Object} object The object to compare.
	* @param {Object} other The other object to compare.
	* @param {string} tag The `toStringTag` of the objects to compare.
	* @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	* @param {Function} customizer The function to customize comparisons.
	* @param {Function} equalFunc The function to determine equivalents of values.
	* @param {Object} stack Tracks traversed `object` and `other` objects.
	* @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	*/
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		switch (tag) {
			case dataViewTag:
				if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
				object = object.buffer;
				other = other.buffer;
			case arrayBufferTag:
				if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
				return true;
			case boolTag:
			case dateTag:
			case numberTag: return eq(+object, +other);
			case errorTag: return object.name == other.name && object.message == other.message;
			case regexpTag:
			case stringTag: return object == other + "";
			case mapTag: var convert = mapToArray;
			case setTag:
				var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
				convert || (convert = setToArray);
				if (object.size != other.size && !isPartial) return false;
				var stacked = stack.get(object);
				if (stacked) return stacked == other;
				bitmask |= COMPARE_UNORDERED_FLAG;
				stack.set(object, other);
				var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
				stack["delete"](object);
				return result;
			case symbolTag: if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
		}
		return false;
	}
	module.exports = equalByTag;
}));
//#endregion
//#region ../../node_modules/lodash/_arrayPush.js
var require__arrayPush = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Appends the elements of `values` to `array`.
	*
	* @private
	* @param {Array} array The array to modify.
	* @param {Array} values The values to append.
	* @returns {Array} Returns `array`.
	*/
	function arrayPush(array, values) {
		var index = -1, length = values.length, offset = array.length;
		while (++index < length) array[offset + index] = values[index];
		return array;
	}
	module.exports = arrayPush;
}));
//#endregion
//#region ../../node_modules/lodash/_baseGetAllKeys.js
var require__baseGetAllKeys = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayPush = require__arrayPush();
	var isArray = require_isArray();
	/**
	* The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	* `keysFunc` and `symbolsFunc` to get the enumerable property names and
	* symbols of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {Function} keysFunc The function to get the keys of `object`.
	* @param {Function} symbolsFunc The function to get the symbols of `object`.
	* @returns {Array} Returns the array of property names and symbols.
	*/
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		var result = keysFunc(object);
		return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	module.exports = baseGetAllKeys;
}));
//#endregion
//#region ../../node_modules/lodash/_arrayFilter.js
var require__arrayFilter = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `_.filter` for arrays without support for
	* iteratee shorthands.
	*
	* @private
	* @param {Array} [array] The array to iterate over.
	* @param {Function} predicate The function invoked per iteration.
	* @returns {Array} Returns the new filtered array.
	*/
	function arrayFilter(array, predicate) {
		var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
		while (++index < length) {
			var value = array[index];
			if (predicate(value, index, array)) result[resIndex++] = value;
		}
		return result;
	}
	module.exports = arrayFilter;
}));
//#endregion
//#region ../../node_modules/lodash/stubArray.js
var require_stubArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This method returns a new empty array.
	*
	* @static
	* @memberOf _
	* @since 4.13.0
	* @category Util
	* @returns {Array} Returns the new empty array.
	* @example
	*
	* var arrays = _.times(2, _.stubArray);
	*
	* console.log(arrays);
	* // => [[], []]
	*
	* console.log(arrays[0] === arrays[1]);
	* // => false
	*/
	function stubArray() {
		return [];
	}
	module.exports = stubArray;
}));
//#endregion
//#region ../../node_modules/lodash/_getSymbols.js
var require__getSymbols = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayFilter = require__arrayFilter();
	var stubArray = require_stubArray();
	/** Built-in value references. */
	var propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	module.exports = !nativeGetSymbols ? stubArray : function(object) {
		if (object == null) return [];
		object = Object(object);
		return arrayFilter(nativeGetSymbols(object), function(symbol) {
			return propertyIsEnumerable.call(object, symbol);
		});
	};
}));
//#endregion
//#region ../../node_modules/lodash/_nativeKeys.js
var require__nativeKeys = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__overArg()(Object.keys, Object);
}));
//#endregion
//#region ../../node_modules/lodash/_baseKeys.js
var require__baseKeys = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isPrototype = require__isPrototype();
	var nativeKeys = require__nativeKeys();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	*
	* @private
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names.
	*/
	function baseKeys(object) {
		if (!isPrototype(object)) return nativeKeys(object);
		var result = [];
		for (var key in Object(object)) if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
		return result;
	}
	module.exports = baseKeys;
}));
//#endregion
//#region ../../node_modules/lodash/keys.js
var require_keys = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayLikeKeys = require__arrayLikeKeys();
	var baseKeys = require__baseKeys();
	var isArrayLike = require_isArrayLike();
	/**
	* Creates an array of the own enumerable property names of `object`.
	*
	* **Note:** Non-object values are coerced to objects. See the
	* [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	* for more details.
	*
	* @static
	* @since 0.1.0
	* @memberOf _
	* @category Object
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names.
	* @example
	*
	* function Foo() {
	*   this.a = 1;
	*   this.b = 2;
	* }
	*
	* Foo.prototype.c = 3;
	*
	* _.keys(new Foo);
	* // => ['a', 'b'] (iteration order is not guaranteed)
	*
	* _.keys('hi');
	* // => ['0', '1']
	*/
	function keys(object) {
		return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	module.exports = keys;
}));
//#endregion
//#region ../../node_modules/lodash/_getAllKeys.js
var require__getAllKeys = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetAllKeys = require__baseGetAllKeys();
	var getSymbols = require__getSymbols();
	var keys = require_keys();
	/**
	* Creates an array of own enumerable property names and symbols of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names and symbols.
	*/
	function getAllKeys(object) {
		return baseGetAllKeys(object, keys, getSymbols);
	}
	module.exports = getAllKeys;
}));
//#endregion
//#region ../../node_modules/lodash/_equalObjects.js
var require__equalObjects = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getAllKeys = require__getAllKeys();
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* A specialized version of `baseIsEqualDeep` for objects with support for
	* partial deep comparisons.
	*
	* @private
	* @param {Object} object The object to compare.
	* @param {Object} other The other object to compare.
	* @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	* @param {Function} customizer The function to customize comparisons.
	* @param {Function} equalFunc The function to determine equivalents of values.
	* @param {Object} stack Tracks traversed `object` and `other` objects.
	* @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	*/
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length;
		if (objLength != getAllKeys(other).length && !isPartial) return false;
		var index = objLength;
		while (index--) {
			var key = objProps[index];
			if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
		}
		var objStacked = stack.get(object);
		var othStacked = stack.get(other);
		if (objStacked && othStacked) return objStacked == other && othStacked == object;
		var result = true;
		stack.set(object, other);
		stack.set(other, object);
		var skipCtor = isPartial;
		while (++index < objLength) {
			key = objProps[index];
			var objValue = object[key], othValue = other[key];
			if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
			if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
				result = false;
				break;
			}
			skipCtor || (skipCtor = key == "constructor");
		}
		if (result && !skipCtor) {
			var objCtor = object.constructor, othCtor = other.constructor;
			if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
		}
		stack["delete"](object);
		stack["delete"](other);
		return result;
	}
	module.exports = equalObjects;
}));
//#endregion
//#region ../../node_modules/lodash/_DataView.js
var require__DataView = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(require__root(), "DataView");
}));
//#endregion
//#region ../../node_modules/lodash/_Promise.js
var require__Promise = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(require__root(), "Promise");
}));
//#endregion
//#region ../../node_modules/lodash/_Set.js
var require__Set = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(require__root(), "Set");
}));
//#endregion
//#region ../../node_modules/lodash/_WeakMap.js
var require__WeakMap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(require__root(), "WeakMap");
}));
//#endregion
//#region ../../node_modules/lodash/_getTag.js
var require__getTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var DataView = require__DataView();
	var Map = require__Map();
	var Promise = require__Promise();
	var Set = require__Set();
	var WeakMap = require__WeakMap();
	var baseGetTag = require__baseGetTag();
	var toSource = require__toSource();
	/** `Object#toString` result references. */
	var mapTag = "[object Map]";
	var objectTag = "[object Object]";
	var promiseTag = "[object Promise]";
	var setTag = "[object Set]";
	var weakMapTag = "[object WeakMap]";
	var dataViewTag = "[object DataView]";
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView);
	var mapCtorString = toSource(Map);
	var promiseCtorString = toSource(Promise);
	var setCtorString = toSource(Set);
	var weakMapCtorString = toSource(WeakMap);
	/**
	* Gets the `toStringTag` of `value`.
	*
	* @private
	* @param {*} value The value to query.
	* @returns {string} Returns the `toStringTag`.
	*/
	var getTag = baseGetTag;
	if (DataView && getTag(new DataView(/* @__PURE__ */ new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) getTag = function(value) {
		var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
		if (ctorString) switch (ctorString) {
			case dataViewCtorString: return dataViewTag;
			case mapCtorString: return mapTag;
			case promiseCtorString: return promiseTag;
			case setCtorString: return setTag;
			case weakMapCtorString: return weakMapTag;
		}
		return result;
	};
	module.exports = getTag;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsEqualDeep.js
var require__baseIsEqualDeep = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Stack = require__Stack();
	var equalArrays = require__equalArrays();
	var equalByTag = require__equalByTag();
	var equalObjects = require__equalObjects();
	var getTag = require__getTag();
	var isArray = require_isArray();
	var isBuffer = require_isBuffer();
	var isTypedArray = require_isTypedArray();
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	/** `Object#toString` result references. */
	var argsTag = "[object Arguments]";
	var arrayTag = "[object Array]";
	var objectTag = "[object Object]";
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* A specialized version of `baseIsEqual` for arrays and objects which performs
	* deep comparisons and tracks traversed objects enabling objects with circular
	* references to be compared.
	*
	* @private
	* @param {Object} object The object to compare.
	* @param {Object} other The other object to compare.
	* @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	* @param {Function} customizer The function to customize comparisons.
	* @param {Function} equalFunc The function to determine equivalents of values.
	* @param {Object} [stack] Tracks traversed `object` and `other` objects.
	* @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	*/
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
		objTag = objTag == argsTag ? objectTag : objTag;
		othTag = othTag == argsTag ? objectTag : othTag;
		var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
		if (isSameTag && isBuffer(object)) {
			if (!isBuffer(other)) return false;
			objIsArr = true;
			objIsObj = false;
		}
		if (isSameTag && !objIsObj) {
			stack || (stack = new Stack());
			return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		}
		if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
			var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
			if (objIsWrapped || othIsWrapped) {
				var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
				stack || (stack = new Stack());
				return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
			}
		}
		if (!isSameTag) return false;
		stack || (stack = new Stack());
		return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	module.exports = baseIsEqualDeep;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsEqual.js
var require__baseIsEqual = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsEqualDeep = require__baseIsEqualDeep();
	var isObjectLike = require_isObjectLike();
	/**
	* The base implementation of `_.isEqual` which supports partial comparisons
	* and tracks traversed objects.
	*
	* @private
	* @param {*} value The value to compare.
	* @param {*} other The other value to compare.
	* @param {boolean} bitmask The bitmask flags.
	*  1 - Unordered comparison
	*  2 - Partial comparison
	* @param {Function} [customizer] The function to customize comparisons.
	* @param {Object} [stack] Tracks traversed `value` and `other` objects.
	* @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	*/
	function baseIsEqual(value, other, bitmask, customizer, stack) {
		if (value === other) return true;
		if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
		return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	module.exports = baseIsEqual;
}));
//#endregion
//#region ../../node_modules/lodash/isEqual.js
var require_isEqual = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsEqual = require__baseIsEqual();
	/**
	* Performs a deep comparison between two values to determine if they are
	* equivalent.
	*
	* **Note:** This method supports comparing arrays, array buffers, booleans,
	* date objects, error objects, maps, numbers, `Object` objects, regexes,
	* sets, strings, symbols, and typed arrays. `Object` objects are compared
	* by their own, not inherited, enumerable properties. Functions and DOM
	* nodes are compared by strict equality, i.e. `===`.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Lang
	* @param {*} value The value to compare.
	* @param {*} other The other value to compare.
	* @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	* @example
	*
	* var object = { 'a': 1 };
	* var other = { 'a': 1 };
	*
	* _.isEqual(object, other);
	* // => true
	*
	* object === other;
	* // => false
	*/
	function isEqual(value, other) {
		return baseIsEqual(value, other);
	}
	module.exports = isEqual;
}));
//#endregion
//#region ../../node_modules/lodash/_basePickBy.js
var require__basePickBy = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGet = require__baseGet();
	var baseSet = require__baseSet();
	var castPath = require__castPath();
	/**
	* The base implementation of  `_.pickBy` without support for iteratee shorthands.
	*
	* @private
	* @param {Object} object The source object.
	* @param {string[]} paths The property paths to pick.
	* @param {Function} predicate The function invoked per property.
	* @returns {Object} Returns the new object.
	*/
	function basePickBy(object, paths, predicate) {
		var index = -1, length = paths.length, result = {};
		while (++index < length) {
			var path = paths[index], value = baseGet(object, path);
			if (predicate(value, path)) baseSet(result, castPath(path, object), value);
		}
		return result;
	}
	module.exports = basePickBy;
}));
//#endregion
//#region ../../node_modules/lodash/_baseHasIn.js
var require__baseHasIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.hasIn` without support for deep paths.
	*
	* @private
	* @param {Object} [object] The object to query.
	* @param {Array|string} key The key to check.
	* @returns {boolean} Returns `true` if `key` exists, else `false`.
	*/
	function baseHasIn(object, key) {
		return object != null && key in Object(object);
	}
	module.exports = baseHasIn;
}));
//#endregion
//#region ../../node_modules/lodash/_hasPath.js
var require__hasPath = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var castPath = require__castPath();
	var isArguments = require_isArguments();
	var isArray = require_isArray();
	var isIndex = require__isIndex();
	var isLength = require_isLength();
	var toKey = require__toKey();
	/**
	* Checks if `path` exists on `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {Array|string} path The path to check.
	* @param {Function} hasFunc The function to check properties.
	* @returns {boolean} Returns `true` if `path` exists, else `false`.
	*/
	function hasPath(object, path, hasFunc) {
		path = castPath(path, object);
		var index = -1, length = path.length, result = false;
		while (++index < length) {
			var key = toKey(path[index]);
			if (!(result = object != null && hasFunc(object, key))) break;
			object = object[key];
		}
		if (result || ++index != length) return result;
		length = object == null ? 0 : object.length;
		return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
	}
	module.exports = hasPath;
}));
//#endregion
//#region ../../node_modules/lodash/hasIn.js
var require_hasIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseHasIn = require__baseHasIn();
	var hasPath = require__hasPath();
	/**
	* Checks if `path` is a direct or inherited property of `object`.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Object
	* @param {Object} object The object to query.
	* @param {Array|string} path The path to check.
	* @returns {boolean} Returns `true` if `path` exists, else `false`.
	* @example
	*
	* var object = _.create({ 'a': _.create({ 'b': 2 }) });
	*
	* _.hasIn(object, 'a');
	* // => true
	*
	* _.hasIn(object, 'a.b');
	* // => true
	*
	* _.hasIn(object, ['a', 'b']);
	* // => true
	*
	* _.hasIn(object, 'b');
	* // => false
	*/
	function hasIn(object, path) {
		return object != null && hasPath(object, path, baseHasIn);
	}
	module.exports = hasIn;
}));
//#endregion
//#region ../../node_modules/lodash/_basePick.js
var require__basePick = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var basePickBy = require__basePickBy();
	var hasIn = require_hasIn();
	/**
	* The base implementation of `_.pick` without support for individual
	* property identifiers.
	*
	* @private
	* @param {Object} object The source object.
	* @param {string[]} paths The property paths to pick.
	* @returns {Object} Returns the new object.
	*/
	function basePick(object, paths) {
		return basePickBy(object, paths, function(value, path) {
			return hasIn(object, path);
		});
	}
	module.exports = basePick;
}));
//#endregion
//#region ../../node_modules/lodash/_isFlattenable.js
var require__isFlattenable = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	var isArguments = require_isArguments();
	var isArray = require_isArray();
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : void 0;
	/**
	* Checks if `value` is a flattenable `arguments` object or array.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	*/
	function isFlattenable(value) {
		return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	module.exports = isFlattenable;
}));
//#endregion
//#region ../../node_modules/lodash/_baseFlatten.js
var require__baseFlatten = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayPush = require__arrayPush();
	var isFlattenable = require__isFlattenable();
	/**
	* The base implementation of `_.flatten` with support for restricting flattening.
	*
	* @private
	* @param {Array} array The array to flatten.
	* @param {number} depth The maximum recursion depth.
	* @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	* @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	* @param {Array} [result=[]] The initial result value.
	* @returns {Array} Returns the new flattened array.
	*/
	function baseFlatten(array, depth, predicate, isStrict, result) {
		var index = -1, length = array.length;
		predicate || (predicate = isFlattenable);
		result || (result = []);
		while (++index < length) {
			var value = array[index];
			if (depth > 0 && predicate(value)) {
				if (depth > 1) baseFlatten(value, depth - 1, predicate, isStrict, result);
				else arrayPush(result, value);
			} else if (!isStrict) result[result.length] = value;
		}
		return result;
	}
	module.exports = baseFlatten;
}));
//#endregion
//#region ../../node_modules/lodash/flatten.js
var require_flatten = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseFlatten = require__baseFlatten();
	/**
	* Flattens `array` a single level deep.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Array
	* @param {Array} array The array to flatten.
	* @returns {Array} Returns the new flattened array.
	* @example
	*
	* _.flatten([1, [2, [3, [4]], 5]]);
	* // => [1, 2, [3, [4]], 5]
	*/
	function flatten(array) {
		return (array == null ? 0 : array.length) ? baseFlatten(array, 1) : [];
	}
	module.exports = flatten;
}));
//#endregion
//#region ../../node_modules/lodash/_flatRest.js
var require__flatRest = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var flatten = require_flatten();
	var overRest = require__overRest();
	var setToString = require__setToString();
	/**
	* A specialized version of `baseRest` which flattens the rest array.
	*
	* @private
	* @param {Function} func The function to apply a rest parameter to.
	* @returns {Function} Returns the new function.
	*/
	function flatRest(func) {
		return setToString(overRest(func, void 0, flatten), func + "");
	}
	module.exports = flatRest;
}));
//#endregion
//#region ../../node_modules/lodash/pick.js
var require_pick = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var basePick = require__basePick();
	module.exports = require__flatRest()(function(object, paths) {
		return object == null ? {} : basePick(object, paths);
	});
}));
require_isEqual();
var import_isPlainObject = /* @__PURE__ */ __toESM(require_isPlainObject());
require_pick();
function Gr() {
	return Gr = Object.assign || function(e) {
		for (var r = 1; r < arguments.length; r++) {
			var t = arguments[r];
			for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		}
		return e;
	}, Gr.apply(this, arguments);
}
function Lr(e, r) {
	if (null == e) return {};
	var t, i, n = {}, o = Object.keys(e);
	for (i = 0; i < o.length; i++) t = o[i], r.indexOf(t) >= 0 || (n[t] = e[t]);
	return n;
}
var Ir = {
	fill: import_prop_types.default.string,
	fontSize: import_prop_types.default.number,
	fontFamily: import_prop_types.default.string
};
var Yr = import_prop_types.default.shape({
	domain: import_prop_types.default.shape({ line: import_prop_types.default.shape({
		stroke: import_prop_types.default.string.isRequired,
		strokeWidth: import_prop_types.default.number.isRequired,
		strokeDasharray: import_prop_types.default.string
	}).isRequired }).isRequired,
	ticks: import_prop_types.default.shape({
		line: import_prop_types.default.shape({
			stroke: import_prop_types.default.string.isRequired,
			strokeWidth: import_prop_types.default.number.isRequired,
			strokeDasharray: import_prop_types.default.string
		}).isRequired,
		text: import_prop_types.default.shape(Gr({}, Ir)).isRequired
	}).isRequired,
	legend: import_prop_types.default.shape({ text: import_prop_types.default.shape(Gr({}, Ir)).isRequired }).isRequired
});
var Ar = import_prop_types.default.shape({ line: import_prop_types.default.shape({
	stroke: import_prop_types.default.string.isRequired,
	strokeWidth: import_prop_types.default.number.isRequired,
	strokeDasharray: import_prop_types.default.string
}).isRequired });
var Fr = import_prop_types.default.shape({
	hidden: import_prop_types.default.shape({
		symbol: import_prop_types.default.shape({
			fill: import_prop_types.default.string.isRequired,
			opacity: import_prop_types.default.number
		}).isRequired,
		text: import_prop_types.default.shape(Gr({}, Ir, { opacity: import_prop_types.default.number })).isRequired
	}).isRequired,
	text: import_prop_types.default.shape(Gr({}, Ir)).isRequired
});
var Er = import_prop_types.default.shape({ text: import_prop_types.default.shape(Gr({}, Ir)).isRequired });
var Ur = import_prop_types.default.shape({ text: import_prop_types.default.shape(Gr({}, Ir)).isRequired });
var Xr = import_prop_types.default.shape({ text: import_prop_types.default.shape(Gr({}, Ir)).isRequired });
var Kr = import_prop_types.default.shape({ line: import_prop_types.default.shape({
	stroke: import_prop_types.default.string.isRequired,
	strokeWidth: import_prop_types.default.number.isRequired,
	strokeDasharray: import_prop_types.default.string
}).isRequired });
var Hr = import_prop_types.default.shape({
	text: import_prop_types.default.shape(Gr({}, Ir, {
		outlineWidth: import_prop_types.default.number.isRequired,
		outlineColor: import_prop_types.default.string.isRequired
	})).isRequired,
	link: import_prop_types.default.shape({
		stroke: import_prop_types.default.string.isRequired,
		strokeWidth: import_prop_types.default.number.isRequired,
		outlineWidth: import_prop_types.default.number.isRequired,
		outlineColor: import_prop_types.default.string.isRequired
	}).isRequired,
	outline: import_prop_types.default.shape({
		stroke: import_prop_types.default.string.isRequired,
		strokeWidth: import_prop_types.default.number.isRequired,
		outlineWidth: import_prop_types.default.number.isRequired,
		outlineColor: import_prop_types.default.string.isRequired
	}).isRequired,
	symbol: import_prop_types.default.shape({
		fill: import_prop_types.default.string.isRequired,
		outlineWidth: import_prop_types.default.number.isRequired,
		outlineColor: import_prop_types.default.string.isRequired
	}).isRequired
});
import_prop_types.default.shape({
	background: import_prop_types.default.string.isRequired,
	fontFamily: import_prop_types.default.string.isRequired,
	fontSize: import_prop_types.default.number.isRequired,
	textColor: import_prop_types.default.string.isRequired,
	axis: Yr.isRequired,
	grid: Ar.isRequired,
	legends: Fr.isRequired,
	labels: Er.isRequired,
	dots: Ur.isRequired,
	markers: Xr,
	crosshair: Kr.isRequired,
	annotations: Hr.isRequired
});
var Vr = {
	background: "transparent",
	fontFamily: "sans-serif",
	fontSize: 11,
	textColor: "#333333",
	axis: {
		domain: { line: {
			stroke: "transparent",
			strokeWidth: 1
		} },
		ticks: {
			line: {
				stroke: "#777777",
				strokeWidth: 1
			},
			text: {}
		},
		legend: { text: { fontSize: 12 } }
	},
	grid: { line: {
		stroke: "#dddddd",
		strokeWidth: 1
	} },
	legends: {
		hidden: {
			symbol: {
				fill: "#333333",
				opacity: .6
			},
			text: {
				fill: "#333333",
				opacity: .6
			}
		},
		text: {},
		ticks: {
			line: {
				stroke: "#777777",
				strokeWidth: 1
			},
			text: { fontSize: 10 }
		},
		title: { text: {} }
	},
	labels: { text: {} },
	markers: {
		lineColor: "#000000",
		lineStrokeWidth: 1,
		text: {}
	},
	dots: { text: {} },
	tooltip: {
		container: {
			background: "white",
			color: "inherit",
			fontSize: "inherit",
			borderRadius: "2px",
			boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
			padding: "5px 9px"
		},
		basic: {
			whiteSpace: "pre",
			display: "flex",
			alignItems: "center"
		},
		chip: { marginRight: 7 },
		table: {},
		tableCell: { padding: "3px 5px" },
		tableCellValue: { fontWeight: "bold" }
	},
	crosshair: { line: {
		stroke: "#000000",
		strokeWidth: 1,
		strokeOpacity: .75,
		strokeDasharray: "6 6"
	} },
	annotations: {
		text: {
			fontSize: 13,
			outlineWidth: 2,
			outlineColor: "#ffffff",
			outlineOpacity: 1
		},
		link: {
			stroke: "#000000",
			strokeWidth: 1,
			outlineWidth: 2,
			outlineColor: "#ffffff",
			outlineOpacity: 1
		},
		outline: {
			fill: "none",
			stroke: "#000000",
			strokeWidth: 2,
			outlineWidth: 2,
			outlineColor: "#ffffff",
			outlineOpacity: 1
		},
		symbol: {
			fill: "#000000",
			outlineWidth: 2,
			outlineColor: "#ffffff",
			outlineOpacity: 1
		}
	}
};
var Jr = [
	"axis.ticks.text",
	"axis.legend.text",
	"legends.title.text",
	"legends.text",
	"legends.ticks.text",
	"legends.title.text",
	"labels.text",
	"dots.text",
	"markers.text",
	"annotations.text"
];
var Qr = function(e, r) {
	var t = (0, import_merge.default)({}, e, r);
	return Jr.forEach((function(e) {
		void 0 === (0, import_get.default)(t, e + ".fontFamily") && (0, import_set.default)(t, e + ".fontFamily", t.fontFamily), void 0 === (0, import_get.default)(t, e + ".fontSize") && (0, import_set.default)(t, e + ".fontSize", t.fontSize), void 0 === (0, import_get.default)(t, e + ".fill") && (0, import_set.default)(t, e + ".fill", t.textColor);
	})), t;
};
var Zr = createContext();
var $r = function(e) {
	var t = e.children, i = e.animate, n = e.stiffness, o = e.damping, a = e.config, s = useMemo((function() {
		var e = (0, import_isString.default)(a) ? config[a] : a;
		return {
			animate: i,
			springConfig: {
				stiffness: n,
				damping: o
			},
			config: e
		};
	}), [
		i,
		n,
		o,
		a
	]);
	return jsx(Zr.Provider, {
		value: s,
		children: t
	});
};
var et = {
	animate: import_prop_types.default.bool,
	motionStiffness: import_prop_types.default.number,
	motionDamping: import_prop_types.default.number,
	motionConfig: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(Object.keys(config)), import_prop_types.default.shape({
		mass: import_prop_types.default.number,
		tension: import_prop_types.default.number,
		friction: import_prop_types.default.number,
		clamp: import_prop_types.default.bool,
		precision: import_prop_types.default.number,
		velocity: import_prop_types.default.number,
		duration: import_prop_types.default.number,
		easing: import_prop_types.default.func
	})])
};
$r.propTypes = {
	children: import_prop_types.default.node.isRequired,
	animate: et.animate,
	stiffness: et.motionStiffness,
	damping: et.motionDamping,
	config: et.motionConfig
};
$r.defaultProps = {
	animate: !0,
	stiffness: 90,
	damping: 15,
	config: "default"
};
var tt = function() {
	return useContext(Zr);
};
var nt = {
	nivo: [
		"#d76445",
		"#f47560",
		"#e8c1a0",
		"#97e3d5",
		"#61cdbb",
		"#00b0a7"
	],
	BrBG: (0, import_last.default)(scheme$26),
	PRGn: (0, import_last.default)(scheme$25),
	PiYG: (0, import_last.default)(scheme$24),
	PuOr: (0, import_last.default)(scheme$23),
	RdBu: (0, import_last.default)(scheme$22),
	RdGy: (0, import_last.default)(scheme$21),
	RdYlBu: (0, import_last.default)(scheme$20),
	RdYlGn: (0, import_last.default)(scheme$19),
	spectral: (0, import_last.default)(scheme$18),
	blues: (0, import_last.default)(scheme$5),
	greens: (0, import_last.default)(scheme$4),
	greys: (0, import_last.default)(scheme$3),
	oranges: (0, import_last.default)(scheme),
	purples: (0, import_last.default)(scheme$2),
	reds: (0, import_last.default)(scheme$1),
	BuGn: (0, import_last.default)(scheme$17),
	BuPu: (0, import_last.default)(scheme$16),
	GnBu: (0, import_last.default)(scheme$15),
	OrRd: (0, import_last.default)(scheme$14),
	PuBuGn: (0, import_last.default)(scheme$13),
	PuBu: (0, import_last.default)(scheme$12),
	PuRd: (0, import_last.default)(scheme$11),
	RdPu: (0, import_last.default)(scheme$10),
	YlGnBu: (0, import_last.default)(scheme$9),
	YlGn: (0, import_last.default)(scheme$8),
	YlOrBr: (0, import_last.default)(scheme$7),
	YlOrRd: (0, import_last.default)(scheme$6)
};
var ot = Object.keys(nt);
(0, import_last.default)(scheme$26), (0, import_last.default)(scheme$25), (0, import_last.default)(scheme$24), (0, import_last.default)(scheme$23), (0, import_last.default)(scheme$22), (0, import_last.default)(scheme$21), (0, import_last.default)(scheme$20), (0, import_last.default)(scheme$19), (0, import_last.default)(scheme$18), (0, import_last.default)(scheme$5), (0, import_last.default)(scheme$4), (0, import_last.default)(scheme$3), (0, import_last.default)(scheme), (0, import_last.default)(scheme$2), (0, import_last.default)(scheme$1), (0, import_last.default)(scheme$17), (0, import_last.default)(scheme$16), (0, import_last.default)(scheme$15), (0, import_last.default)(scheme$14), (0, import_last.default)(scheme$13), (0, import_last.default)(scheme$12), (0, import_last.default)(scheme$11), (0, import_last.default)(scheme$10), (0, import_last.default)(scheme$9), (0, import_last.default)(scheme$8), (0, import_last.default)(scheme$7), (0, import_last.default)(scheme$6);
import_prop_types.default.oneOfType([
	import_prop_types.default.oneOf(ot),
	import_prop_types.default.func,
	import_prop_types.default.arrayOf(import_prop_types.default.string)
]);
var gt = Object.keys({
	basis: basis_default,
	basisClosed: basisClosed_default,
	basisOpen: basisOpen_default,
	bundle: bundle_default,
	cardinal: cardinal_default,
	cardinalClosed: cardinalClosed_default,
	cardinalOpen: cardinalOpen_default,
	catmullRom: catmullRom_default,
	catmullRomClosed: catmullRomClosed_default,
	catmullRomOpen: catmullRomOpen_default,
	linear: linear_default,
	linearClosed: linearClosed_default,
	monotoneX,
	monotoneY,
	natural: natural_default,
	step: step_default,
	stepAfter,
	stepBefore
});
import_prop_types.default.oneOf(gt);
gt.filter((function(e) {
	return e.endsWith("Closed");
}));
(0, import_without.default)(gt, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var vt = (0, import_without.default)(gt, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
import_prop_types.default.oneOf(vt);
import_prop_types.default.arrayOf(import_prop_types.default.shape({ id: import_prop_types.default.string.isRequired })).isRequired, import_prop_types.default.arrayOf(import_prop_types.default.shape({
	id: import_prop_types.default.string.isRequired,
	match: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf(["*"]),
		import_prop_types.default.object,
		import_prop_types.default.func
	]).isRequired
})).isRequired;
var wt = Object.keys({
	ascending: ascending_default,
	descending: descending_default,
	insideOut: insideOut_default,
	none: none_default,
	reverse: reverse_default
});
import_prop_types.default.oneOf(wt);
var Wt = Object.keys({
	expand: expand_default,
	diverging: diverging_default,
	none: none_default$1,
	silhouette: silhouette_default,
	wiggle: wiggle_default
});
import_prop_types.default.oneOf(Wt);
import_prop_types.default.shape({
	top: import_prop_types.default.number,
	right: import_prop_types.default.number,
	bottom: import_prop_types.default.number,
	left: import_prop_types.default.number
}).isRequired;
import_prop_types.default.oneOf([
	"normal",
	"multiply",
	"screen",
	"overlay",
	"darken",
	"lighten",
	"color-dodge",
	"color-burn",
	"hard-light",
	"soft-light",
	"difference",
	"exclusion",
	"hue",
	"saturation",
	"color",
	"luminosity"
]);
ordinal(Set3_default);
var Yt = {
	top: 0,
	right: 0,
	bottom: 0,
	left: 0
};
var At = function(e, t, i) {
	return void 0 === i && (i = {}), useMemo((function() {
		var r = Gr({}, Yt, i);
		return {
			margin: r,
			innerWidth: e - r.left - r.right,
			innerHeight: t - r.top - r.bottom,
			outerWidth: e,
			outerHeight: t
		};
	}), [
		e,
		t,
		i.top,
		i.right,
		i.bottom,
		i.left
	]);
};
var Ft = function() {
	var e = useRef(null), r = useState({
		left: 0,
		top: 0,
		width: 0,
		height: 0
	}), t = r[0], a = r[1], s = useState((function() {
		return new ResizeObserver((function(e) {
			var r = e[0];
			return a(r.contentRect);
		}));
	}))[0];
	return useEffect((function() {
		return e.current && s.observe(e.current), function() {
			return s.disconnect();
		};
	}), []), [e, t];
};
var Et = function(e) {
	return useMemo((function() {
		return Qr(Vr, e);
	}), [e]);
};
var Ut = function(e) {
	return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? timeFormat(e.slice("5")) : format(e) : function(e) {
		return "" + e;
	};
};
var Xt = function(e) {
	return useMemo((function() {
		return Ut(e);
	}), [e]);
};
var Kt = createContext();
var Ht = {};
var Nt = function(e) {
	var r = e.theme, t = void 0 === r ? Ht : r, i = e.children, n = Et(t);
	return jsx(Kt.Provider, {
		value: n,
		children: i
	});
};
Nt.propTypes = {
	children: import_prop_types.default.node.isRequired,
	theme: import_prop_types.default.object
};
var Vt = function() {
	return useContext(Kt);
};
var Jt = function(e) {
	var r = e.children, t = e.condition, i = e.wrapper;
	return t ? cloneElement(i, {}, r) : r;
};
Jt.propTypes = {
	children: import_prop_types.default.node.isRequired,
	condition: import_prop_types.default.bool.isRequired,
	wrapper: import_prop_types.default.element.isRequired
};
var Qt = { position: "relative" };
var Zt = function(e) {
	var r = e.children, t = e.theme, n = e.renderWrapper, o = void 0 === n || n, a = e.isInteractive, s = void 0 === a || a, l = e.animate, d = e.motionStiffness, u = e.motionDamping, c = e.motionConfig, h = useRef(null);
	return jsx(Nt, {
		theme: t,
		children: jsx($r, {
			animate: l,
			stiffness: d,
			damping: u,
			config: c,
			children: jsx(M, {
				container: h,
				children: jsxs(Jt, {
					condition: o,
					wrapper: jsx("div", {
						style: Qt,
						ref: h
					}),
					children: [r, s && jsx(F, {})]
				})
			})
		})
	});
};
Zt.propTypes = {
	children: import_prop_types.default.element.isRequired,
	isInteractive: import_prop_types.default.bool,
	renderWrapper: import_prop_types.default.bool,
	theme: import_prop_types.default.object,
	animate: import_prop_types.default.bool,
	motionStiffness: import_prop_types.default.number,
	motionDamping: import_prop_types.default.number,
	motionConfig: import_prop_types.default.string
};
var $t = function() {};
var ei = { position: "relative" };
var ri = function(e) {
	var t = e.children, n = e.theme, o = e.isInteractive, a = void 0 === o || o, l = e.renderWrapper, d = void 0 === l || l, u = e.animate, c = e.motionStiffness, f = e.motionDamping, b = e.motionConfig, y = useRef(null), v = O$2(y), R = v.actions, q = v.state, k = useCallback((function(e, r) {
		return R.showTooltipFromEvent(e, r);
	}), [R.showTooltipFromEvent]), _ = useMemo((function() {
		return {
			showTooltip: a ? k : $t,
			hideTooltip: a ? R.hideTooltip : $t
		};
	}), [
		R.hideTooltip,
		a,
		k
	]);
	return jsx(Nt, {
		theme: n,
		children: jsx($r, {
			animate: u,
			stiffness: c,
			damping: f,
			config: b,
			children: jsx(N$1.Provider, {
				value: R,
				children: jsx(j$2.Provider, {
					value: q,
					children: jsxs(Jt, {
						condition: d,
						wrapper: jsx("div", {
							style: ei,
							ref: y
						}),
						children: [t(_), a && jsx(F, {})]
					})
				})
			})
		})
	});
};
ri.propTypes = {
	children: import_prop_types.default.func.isRequired,
	isInteractive: import_prop_types.default.bool,
	renderWrapper: import_prop_types.default.bool,
	theme: import_prop_types.default.object.isRequired,
	animate: import_prop_types.default.bool.isRequired,
	motionStiffness: import_prop_types.default.number,
	motionDamping: import_prop_types.default.number,
	motionConfig: import_prop_types.default.string
};
var ti = function(e) {
	var r = e.children, t = Ft(), i = t[0], n = t[1], o = n.width > 0 && n.height > 0;
	return jsx("div", {
		ref: i,
		style: {
			width: "100%",
			height: "100%"
		},
		children: o && r({
			width: n.width,
			height: n.height
		})
	});
};
ti.propTypes = { children: import_prop_types.default.func.isRequired };
var ii = ["id", "colors"];
var ni = function(e) {
	var r = e.id, t = e.colors, i = Lr(e, ii);
	return jsx("linearGradient", Gr({
		id: r,
		x1: 0,
		x2: 0,
		y1: 0,
		y2: 1
	}, i, { children: t.map((function(e) {
		var r = e.offset, t = e.color, i = e.opacity;
		return jsx("stop", {
			offset: r + "%",
			stopColor: t,
			stopOpacity: void 0 !== i ? i : 1
		}, r);
	})) }));
};
ni.propTypes = {
	id: import_prop_types.default.string.isRequired,
	colors: import_prop_types.default.arrayOf(import_prop_types.default.shape({
		offset: import_prop_types.default.number.isRequired,
		color: import_prop_types.default.string.isRequired,
		opacity: import_prop_types.default.number
	})).isRequired,
	gradientTransform: import_prop_types.default.string
};
var ai = { linearGradient: ni };
var si = memo((function(e) {
	var r = e.id, t = e.background, i = e.color, n = e.size, o = e.padding, a = e.stagger, s = n + o, l = n / 2, d = o / 2;
	return !0 === a && (s = 2 * n + 2 * o), jsxs("pattern", {
		id: r,
		width: s,
		height: s,
		patternUnits: "userSpaceOnUse",
		children: [
			jsx("rect", {
				width: s,
				height: s,
				fill: t
			}),
			jsx("circle", {
				cx: d + l,
				cy: d + l,
				r: l,
				fill: i
			}),
			a && jsx("circle", {
				cx: 1.5 * o + n + l,
				cy: 1.5 * o + n + l,
				r: l,
				fill: i
			})
		]
	});
}));
si.displayName = "PatternDots", si.propTypes = {
	id: import_prop_types.default.string.isRequired,
	color: import_prop_types.default.string.isRequired,
	background: import_prop_types.default.string.isRequired,
	size: import_prop_types.default.number.isRequired,
	padding: import_prop_types.default.number.isRequired,
	stagger: import_prop_types.default.bool.isRequired
}, si.defaultProps = {
	color: "#000000",
	background: "#ffffff",
	size: 4,
	padding: 4,
	stagger: !1
};
var ui = function(e) {
	return e * Math.PI / 180;
};
var ci = function(e) {
	return 180 * e / Math.PI;
};
var pi = function(e, r) {
	return {
		x: Math.cos(e) * r,
		y: Math.sin(e) * r
	};
};
var hi = function(e) {
	var r = e % 360;
	return r < 0 && (r += 360), r;
};
var yi = {
	svg: {
		align: {
			left: "start",
			center: "middle",
			right: "end",
			start: "start",
			middle: "middle",
			end: "end"
		},
		baseline: {
			top: "text-before-edge",
			center: "central",
			bottom: "alphabetic"
		}
	},
	canvas: {
		align: {
			left: "left",
			center: "center",
			right: "right",
			start: "left",
			middle: "center",
			end: "right"
		},
		baseline: {
			top: "top",
			center: "middle",
			bottom: "bottom"
		}
	}
};
var Ri = memo((function(e) {
	var r = e.id, t = e.spacing, i = e.rotation, n = e.background, o = e.color, a = e.lineWidth, s = Math.round(i) % 360, l = Math.abs(t);
	s > 180 ? s -= 360 : s > 90 ? s -= 180 : s < -180 ? s += 360 : s < -90 && (s += 180);
	var d, u = l, c = l;
	return 0 === s ? d = "\n                M 0 0 L " + u + " 0\n                M 0 " + c + " L " + u + " " + c + "\n            " : 90 === s ? d = "\n                M 0 0 L 0 " + c + "\n                M " + u + " 0 L " + u + " " + c + "\n            " : (u = Math.abs(l / Math.sin(ui(s))), c = l / Math.sin(ui(90 - s)), d = s > 0 ? "\n                    M 0 " + -c + " L " + 2 * u + " " + c + "\n                    M " + -u + " " + -c + " L " + u + " " + c + "\n                    M " + -u + " 0 L " + u + " " + 2 * c + "\n                " : "\n                    M " + -u + " " + c + " L " + u + " " + -c + "\n                    M " + -u + " " + 2 * c + " L " + 2 * u + " " + -c + "\n                    M 0 " + 2 * c + " L " + 2 * u + " 0\n                "), jsxs("pattern", {
		id: r,
		width: u,
		height: c,
		patternUnits: "userSpaceOnUse",
		children: [jsx("rect", {
			width: u,
			height: c,
			fill: n,
			stroke: "rgba(255, 0, 0, 0.1)",
			strokeWidth: 0
		}), jsx("path", {
			d,
			strokeWidth: a,
			stroke: o,
			strokeLinecap: "square"
		})]
	});
}));
Ri.displayName = "PatternLines", Ri.propTypes = {
	id: import_prop_types.default.string.isRequired,
	spacing: import_prop_types.default.number.isRequired,
	rotation: import_prop_types.default.number.isRequired,
	background: import_prop_types.default.string.isRequired,
	color: import_prop_types.default.string.isRequired,
	lineWidth: import_prop_types.default.number.isRequired
}, Ri.defaultProps = {
	spacing: 5,
	rotation: 0,
	color: "#000000",
	background: "#ffffff",
	lineWidth: 2
};
var ki = memo((function(e) {
	var r = e.id, t = e.background, i = e.color, n = e.size, o = e.padding, a = e.stagger, s = n + o, l = o / 2;
	return !0 === a && (s = 2 * n + 2 * o), jsxs("pattern", {
		id: r,
		width: s,
		height: s,
		patternUnits: "userSpaceOnUse",
		children: [
			jsx("rect", {
				width: s,
				height: s,
				fill: t
			}),
			jsx("rect", {
				x: l,
				y: l,
				width: n,
				height: n,
				fill: i
			}),
			a && jsx("rect", {
				x: 1.5 * o + n,
				y: 1.5 * o + n,
				width: n,
				height: n,
				fill: i
			})
		]
	});
}));
ki.displayName = "PatternSquares", ki.propTypes = {
	id: import_prop_types.default.string.isRequired,
	color: import_prop_types.default.string.isRequired,
	background: import_prop_types.default.string.isRequired,
	size: import_prop_types.default.number.isRequired,
	padding: import_prop_types.default.number.isRequired,
	stagger: import_prop_types.default.bool.isRequired
}, ki.defaultProps = {
	color: "#000000",
	background: "#ffffff",
	size: 4,
	padding: 4,
	stagger: !1
};
var wi = {
	patternDots: si,
	patternLines: Ri,
	patternSquares: ki
};
var xi = ["type"];
var Oi = Gr({}, ai, wi);
var Ci = function(e) {
	var r = e.defs;
	return !r || r.length < 1 ? null : jsx("defs", {
		"aria-hidden": !0,
		children: r.map((function(e) {
			var r = e.type, t = Lr(e, xi);
			return Oi[r] ? createElement(Oi[r], Gr({ key: t.id }, t)) : null;
		}))
	});
};
Ci.propTypes = { defs: import_prop_types.default.arrayOf(import_prop_types.default.shape({
	type: import_prop_types.default.oneOf(Object.keys(Oi)).isRequired,
	id: import_prop_types.default.string.isRequired
})) };
var Wi = memo(Ci);
var Si = function(e) {
	var r = e.width, t = e.height, i = e.margin, n = e.defs, o = e.children, a = e.role, s = e.ariaLabel, l = e.ariaLabelledBy, d = e.ariaDescribedBy, u = e.isFocusable, c = Vt();
	return jsxs("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: r,
		height: t,
		role: a,
		"aria-label": s,
		"aria-labelledby": l,
		"aria-describedby": d,
		focusable: u,
		tabIndex: u ? 0 : void 0,
		children: [
			jsx(Wi, { defs: n }),
			jsx("rect", {
				width: r,
				height: t,
				fill: c.background
			}),
			jsx("g", {
				transform: "translate(" + i.left + "," + i.top + ")",
				children: o
			})
		]
	});
};
Si.propTypes = {
	width: import_prop_types.default.number.isRequired,
	height: import_prop_types.default.number.isRequired,
	margin: import_prop_types.default.shape({
		top: import_prop_types.default.number.isRequired,
		left: import_prop_types.default.number.isRequired
	}).isRequired,
	defs: import_prop_types.default.array,
	children: import_prop_types.default.oneOfType([import_prop_types.default.arrayOf(import_prop_types.default.node), import_prop_types.default.node]).isRequired,
	role: import_prop_types.default.string,
	isFocusable: import_prop_types.default.bool,
	ariaLabel: import_prop_types.default.string,
	ariaLabelledBy: import_prop_types.default.string,
	ariaDescribedBy: import_prop_types.default.string
};
var zi = function(e) {
	var r = e.size, t = e.color, i = e.borderWidth, n = e.borderColor;
	return jsx("circle", {
		r: r / 2,
		fill: t,
		stroke: n,
		strokeWidth: i,
		style: { pointerEvents: "none" }
	});
};
zi.propTypes = {
	size: import_prop_types.default.number.isRequired,
	color: import_prop_types.default.string.isRequired,
	borderWidth: import_prop_types.default.number.isRequired,
	borderColor: import_prop_types.default.string.isRequired
};
var Pi = memo(zi);
var Ti = function(e) {
	var r = e.x, t = e.y, i = e.symbol, n = void 0 === i ? Pi : i, o = e.size, a = e.datum, s = e.color, l = e.borderWidth, u = e.borderColor, c = e.label, f = e.labelTextAnchor, p = void 0 === f ? "middle" : f, h = e.labelYOffset, g = void 0 === h ? -12 : h, m = Vt(), b = tt(), y = b.animate, v = b.config, R = useSpring({
		transform: "translate(" + r + ", " + t + ")",
		config: v,
		immediate: !y
	});
	return jsxs(animated.g, {
		transform: R.transform,
		style: { pointerEvents: "none" },
		children: [createElement(n, {
			size: o,
			color: s,
			datum: a,
			borderWidth: l,
			borderColor: u
		}), c && jsx("text", {
			textAnchor: p,
			y: g,
			style: m.dots.text,
			children: c
		})]
	});
};
Ti.propTypes = {
	x: import_prop_types.default.number.isRequired,
	y: import_prop_types.default.number.isRequired,
	datum: import_prop_types.default.object.isRequired,
	size: import_prop_types.default.number.isRequired,
	color: import_prop_types.default.string.isRequired,
	borderWidth: import_prop_types.default.number.isRequired,
	borderColor: import_prop_types.default.string.isRequired,
	symbol: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
	label: import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number]),
	labelTextAnchor: import_prop_types.default.oneOf([
		"start",
		"middle",
		"end"
	]),
	labelYOffset: import_prop_types.default.number.isRequired
};
memo(Ti);
var ji = function(e) {
	var r = e.width, t = e.height, i = e.axis, n = e.scale, o = e.value, a = e.lineStyle, s = e.textStyle, l = e.legend, d = e.legendPosition, u = e.legendOffsetX, c = e.legendOffsetY, f = e.legendOrientation, p = Vt(), h = 0, g = 0, m = 0, b = 0;
	"y" === i ? (m = n(o), g = r) : (h = n(o), b = t);
	var y = null;
	if (l) {
		var v = function(e) {
			var r = e.axis, t = e.width, i = e.height, n = e.position, o = e.offsetX, a = e.offsetY, s = e.orientation, l = 0, d = 0, u = "vertical" === s ? -90 : 0, c = "start";
			if ("x" === r) switch (n) {
				case "top-left":
					l = -o, d = a, c = "end";
					break;
				case "top":
					d = -a, c = "horizontal" === s ? "middle" : "start";
					break;
				case "top-right":
					l = o, d = a, c = "horizontal" === s ? "start" : "end";
					break;
				case "right":
					l = o, d = i / 2, c = "horizontal" === s ? "start" : "middle";
					break;
				case "bottom-right":
					l = o, d = i - a, c = "start";
					break;
				case "bottom":
					d = i + a, c = "horizontal" === s ? "middle" : "end";
					break;
				case "bottom-left":
					d = i - a, l = -o, c = "horizontal" === s ? "end" : "start";
					break;
				case "left": l = -o, d = i / 2, c = "horizontal" === s ? "end" : "middle";
			}
			else switch (n) {
				case "top-left":
					l = o, d = -a, c = "start";
					break;
				case "top":
					l = t / 2, d = -a, c = "horizontal" === s ? "middle" : "start";
					break;
				case "top-right":
					l = t - o, d = -a, c = "horizontal" === s ? "end" : "start";
					break;
				case "right":
					l = t + o, c = "horizontal" === s ? "start" : "middle";
					break;
				case "bottom-right":
					l = t - o, d = a, c = "end";
					break;
				case "bottom":
					l = t / 2, d = a, c = "horizontal" === s ? "middle" : "end";
					break;
				case "bottom-left":
					l = o, d = a, c = "horizontal" === s ? "start" : "end";
					break;
				case "left": l = -o, c = "horizontal" === s ? "end" : "middle";
			}
			return {
				x: l,
				y: d,
				rotation: u,
				textAnchor: c
			};
		}({
			axis: i,
			width: r,
			height: t,
			position: d,
			offsetX: u,
			offsetY: c,
			orientation: f
		});
		y = jsx("text", {
			transform: "translate(" + v.x + ", " + v.y + ") rotate(" + v.rotation + ")",
			textAnchor: v.textAnchor,
			dominantBaseline: "central",
			style: s,
			children: l
		});
	}
	return jsxs("g", {
		transform: "translate(" + h + ", " + m + ")",
		children: [jsx("line", {
			x1: 0,
			x2: g,
			y1: 0,
			y2: b,
			stroke: p.markers.lineColor,
			strokeWidth: p.markers.lineStrokeWidth,
			style: a
		}), y]
	});
};
ji.propTypes = {
	width: import_prop_types.default.number.isRequired,
	height: import_prop_types.default.number.isRequired,
	axis: import_prop_types.default.oneOf(["x", "y"]).isRequired,
	scale: import_prop_types.default.func.isRequired,
	value: import_prop_types.default.oneOfType([
		import_prop_types.default.number,
		import_prop_types.default.string,
		import_prop_types.default.instanceOf(Date)
	]).isRequired,
	lineStyle: import_prop_types.default.object,
	textStyle: import_prop_types.default.object,
	legend: import_prop_types.default.string,
	legendPosition: import_prop_types.default.oneOf([
		"top-left",
		"top",
		"top-right",
		"right",
		"bottom-right",
		"bottom",
		"bottom-left",
		"left"
	]),
	legendOffsetX: import_prop_types.default.number.isRequired,
	legendOffsetY: import_prop_types.default.number.isRequired,
	legendOrientation: import_prop_types.default.oneOf(["horizontal", "vertical"]).isRequired
}, ji.defaultProps = {
	legendPosition: "top-right",
	legendOffsetX: 14,
	legendOffsetY: 14,
	legendOrientation: "horizontal"
};
var Di = memo(ji);
var Gi = function(e) {
	var r = e.markers, t = e.width, i = e.height, n = e.xScale, o = e.yScale;
	return r && 0 !== r.length ? r.map((function(e, r) {
		return jsx(Di, Gr({}, e, {
			width: t,
			height: i,
			scale: "y" === e.axis ? o : n
		}), r);
	})) : null;
};
Gi.propTypes = {
	width: import_prop_types.default.number.isRequired,
	height: import_prop_types.default.number.isRequired,
	xScale: import_prop_types.default.func.isRequired,
	yScale: import_prop_types.default.func.isRequired,
	markers: import_prop_types.default.arrayOf(import_prop_types.default.shape({
		axis: import_prop_types.default.oneOf(["x", "y"]).isRequired,
		value: import_prop_types.default.oneOfType([
			import_prop_types.default.number,
			import_prop_types.default.string,
			import_prop_types.default.instanceOf(Date)
		]).isRequired,
		lineStyle: import_prop_types.default.object,
		textStyle: import_prop_types.default.object
	}))
};
memo(Gi);
var Ui = function(e) {
	return (0, import_isFunction.default)(e) ? e : function(r) {
		return (0, import_get.default)(r, e);
	};
};
var Xi = function(e) {
	return useMemo((function() {
		return Ui(e);
	}), [e]);
};
var Ji = function(e, r, t, i, n, o) {
	return e <= n && n <= e + t && r <= o && o <= r + i;
};
var Qi = function(e, r) {
	var t = r.clientX, i = r.clientY, n = e.getBoundingClientRect();
	return [t - n.left, i - n.top];
};
Object.keys(ai);
Object.keys(wi);
//#endregion
//#region ../../node_modules/lodash/noop.js
var require_noop = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This method returns `undefined`.
	*
	* @static
	* @memberOf _
	* @since 2.3.0
	* @category Util
	* @example
	*
	* _.times(2, _.noop);
	* // => [undefined, undefined]
	*/
	function noop() {}
	module.exports = noop;
}));
//#endregion
//#region ../../node_modules/lodash/_createSet.js
var require__createSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Set = require__Set();
	var noop = require_noop();
	var setToArray = require__setToArray();
	module.exports = !(Set && 1 / setToArray(new Set([, -0]))[1] == 1 / 0) ? noop : function(values) {
		return new Set(values);
	};
}));
//#endregion
//#region ../../node_modules/lodash/_baseUniq.js
var require__baseUniq = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var SetCache = require__SetCache();
	var arrayIncludes = require__arrayIncludes();
	var arrayIncludesWith = require__arrayIncludesWith();
	var cacheHas = require__cacheHas();
	var createSet = require__createSet();
	var setToArray = require__setToArray();
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	/**
	* The base implementation of `_.uniqBy` without support for iteratee shorthands.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {Function} [iteratee] The iteratee invoked per element.
	* @param {Function} [comparator] The comparator invoked per element.
	* @returns {Array} Returns the new duplicate free array.
	*/
	function baseUniq(array, iteratee, comparator) {
		var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
		if (comparator) {
			isCommon = false;
			includes = arrayIncludesWith;
		} else if (length >= LARGE_ARRAY_SIZE) {
			var set = iteratee ? null : createSet(array);
			if (set) return setToArray(set);
			isCommon = false;
			includes = cacheHas;
			seen = new SetCache();
		} else seen = iteratee ? [] : result;
		outer: while (++index < length) {
			var value = array[index], computed = iteratee ? iteratee(value) : value;
			value = comparator || value !== 0 ? value : 0;
			if (isCommon && computed === computed) {
				var seenIndex = seen.length;
				while (seenIndex--) if (seen[seenIndex] === computed) continue outer;
				if (iteratee) seen.push(computed);
				result.push(value);
			} else if (!includes(seen, computed, comparator)) {
				if (seen !== result) seen.push(computed);
				result.push(value);
			}
		}
		return result;
	}
	module.exports = baseUniq;
}));
//#endregion
//#region ../../node_modules/lodash/uniq.js
var require_uniq = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseUniq = require__baseUniq();
	/**
	* Creates a duplicate-free version of an array, using
	* [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	* for equality comparisons, in which only the first occurrence of each element
	* is kept. The order of result values is determined by the order they occur
	* in the array.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Array
	* @param {Array} array The array to inspect.
	* @returns {Array} Returns the new duplicate free array.
	* @example
	*
	* _.uniq([2, 1, 2]);
	* // => [2, 1]
	*/
	function uniq(array) {
		return array && array.length ? baseUniq(array) : [];
	}
	module.exports = uniq;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsMatch.js
var require__baseIsMatch = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Stack = require__Stack();
	var baseIsEqual = require__baseIsEqual();
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	var COMPARE_UNORDERED_FLAG = 2;
	/**
	* The base implementation of `_.isMatch` without support for iteratee shorthands.
	*
	* @private
	* @param {Object} object The object to inspect.
	* @param {Object} source The object of property values to match.
	* @param {Array} matchData The property names, values, and compare flags to match.
	* @param {Function} [customizer] The function to customize comparisons.
	* @returns {boolean} Returns `true` if `object` is a match, else `false`.
	*/
	function baseIsMatch(object, source, matchData, customizer) {
		var index = matchData.length, length = index, noCustomizer = !customizer;
		if (object == null) return !length;
		object = Object(object);
		while (index--) {
			var data = matchData[index];
			if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
		}
		while (++index < length) {
			data = matchData[index];
			var key = data[0], objValue = object[key], srcValue = data[1];
			if (noCustomizer && data[2]) {
				if (objValue === void 0 && !(key in object)) return false;
			} else {
				var stack = new Stack();
				if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
				if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
			}
		}
		return true;
	}
	module.exports = baseIsMatch;
}));
//#endregion
//#region ../../node_modules/lodash/_isStrictComparable.js
var require__isStrictComparable = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isObject = require_isObject();
	/**
	* Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` if suitable for strict
	*  equality comparisons, else `false`.
	*/
	function isStrictComparable(value) {
		return value === value && !isObject(value);
	}
	module.exports = isStrictComparable;
}));
//#endregion
//#region ../../node_modules/lodash/_getMatchData.js
var require__getMatchData = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isStrictComparable = require__isStrictComparable();
	var keys = require_keys();
	/**
	* Gets the property names, values, and compare flags of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @returns {Array} Returns the match data of `object`.
	*/
	function getMatchData(object) {
		var result = keys(object), length = result.length;
		while (length--) {
			var key = result[length], value = object[key];
			result[length] = [
				key,
				value,
				isStrictComparable(value)
			];
		}
		return result;
	}
	module.exports = getMatchData;
}));
//#endregion
//#region ../../node_modules/lodash/_matchesStrictComparable.js
var require__matchesStrictComparable = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `matchesProperty` for source values suitable
	* for strict equality comparisons, i.e. `===`.
	*
	* @private
	* @param {string} key The key of the property to get.
	* @param {*} srcValue The value to match.
	* @returns {Function} Returns the new spec function.
	*/
	function matchesStrictComparable(key, srcValue) {
		return function(object) {
			if (object == null) return false;
			return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
		};
	}
	module.exports = matchesStrictComparable;
}));
//#endregion
//#region ../../node_modules/lodash/_baseMatches.js
var require__baseMatches = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsMatch = require__baseIsMatch();
	var getMatchData = require__getMatchData();
	var matchesStrictComparable = require__matchesStrictComparable();
	/**
	* The base implementation of `_.matches` which doesn't clone `source`.
	*
	* @private
	* @param {Object} source The object of property values to match.
	* @returns {Function} Returns the new spec function.
	*/
	function baseMatches(source) {
		var matchData = getMatchData(source);
		if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
		return function(object) {
			return object === source || baseIsMatch(object, source, matchData);
		};
	}
	module.exports = baseMatches;
}));
//#endregion
//#region ../../node_modules/lodash/_baseMatchesProperty.js
var require__baseMatchesProperty = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsEqual = require__baseIsEqual();
	var get = require_get();
	var hasIn = require_hasIn();
	var isKey = require__isKey();
	var isStrictComparable = require__isStrictComparable();
	var matchesStrictComparable = require__matchesStrictComparable();
	var toKey = require__toKey();
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	var COMPARE_UNORDERED_FLAG = 2;
	/**
	* The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	*
	* @private
	* @param {string} path The path of the property to get.
	* @param {*} srcValue The value to match.
	* @returns {Function} Returns the new spec function.
	*/
	function baseMatchesProperty(path, srcValue) {
		if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
		return function(object) {
			var objValue = get(object, path);
			return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
		};
	}
	module.exports = baseMatchesProperty;
}));
//#endregion
//#region ../../node_modules/lodash/_baseProperty.js
var require__baseProperty = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.property` without support for deep paths.
	*
	* @private
	* @param {string} key The key of the property to get.
	* @returns {Function} Returns the new accessor function.
	*/
	function baseProperty(key) {
		return function(object) {
			return object == null ? void 0 : object[key];
		};
	}
	module.exports = baseProperty;
}));
//#endregion
//#region ../../node_modules/lodash/_basePropertyDeep.js
var require__basePropertyDeep = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGet = require__baseGet();
	/**
	* A specialized version of `baseProperty` which supports deep paths.
	*
	* @private
	* @param {Array|string} path The path of the property to get.
	* @returns {Function} Returns the new accessor function.
	*/
	function basePropertyDeep(path) {
		return function(object) {
			return baseGet(object, path);
		};
	}
	module.exports = basePropertyDeep;
}));
//#endregion
//#region ../../node_modules/lodash/property.js
var require_property = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseProperty = require__baseProperty();
	var basePropertyDeep = require__basePropertyDeep();
	var isKey = require__isKey();
	var toKey = require__toKey();
	/**
	* Creates a function that returns the value at `path` of a given object.
	*
	* @static
	* @memberOf _
	* @since 2.4.0
	* @category Util
	* @param {Array|string} path The path of the property to get.
	* @returns {Function} Returns the new accessor function.
	* @example
	*
	* var objects = [
	*   { 'a': { 'b': 2 } },
	*   { 'a': { 'b': 1 } }
	* ];
	*
	* _.map(objects, _.property('a.b'));
	* // => [2, 1]
	*
	* _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	* // => [1, 2]
	*/
	function property(path) {
		return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	module.exports = property;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIteratee.js
var require__baseIteratee = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseMatches = require__baseMatches();
	var baseMatchesProperty = require__baseMatchesProperty();
	var identity = require_identity();
	var isArray = require_isArray();
	var property = require_property();
	/**
	* The base implementation of `_.iteratee`.
	*
	* @private
	* @param {*} [value=_.identity] The value to convert to an iteratee.
	* @returns {Function} Returns the iteratee.
	*/
	function baseIteratee(value) {
		if (typeof value == "function") return value;
		if (value == null) return identity;
		if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
		return property(value);
	}
	module.exports = baseIteratee;
}));
//#endregion
//#region ../../node_modules/lodash/uniqBy.js
var require_uniqBy = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIteratee = require__baseIteratee();
	var baseUniq = require__baseUniq();
	/**
	* This method is like `_.uniq` except that it accepts `iteratee` which is
	* invoked for each element in `array` to generate the criterion by which
	* uniqueness is computed. The order of result values is determined by the
	* order they occur in the array. The iteratee is invoked with one argument:
	* (value).
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Array
	* @param {Array} array The array to inspect.
	* @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	* @returns {Array} Returns the new duplicate free array.
	* @example
	*
	* _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	* // => [2.1, 1.2]
	*
	* // The `_.property` iteratee shorthand.
	* _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	* // => [{ 'x': 1 }, { 'x': 2 }]
	*/
	function uniqBy(array, iteratee) {
		return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	module.exports = uniqBy;
}));
//#endregion
//#region ../../node_modules/lodash/_baseForOwn.js
var require__baseForOwn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseFor = require__baseFor();
	var keys = require_keys();
	/**
	* The base implementation of `_.forOwn` without support for iteratee shorthands.
	*
	* @private
	* @param {Object} object The object to iterate over.
	* @param {Function} iteratee The function invoked per iteration.
	* @returns {Object} Returns `object`.
	*/
	function baseForOwn(object, iteratee) {
		return object && baseFor(object, iteratee, keys);
	}
	module.exports = baseForOwn;
}));
//#endregion
//#region ../../node_modules/lodash/_createBaseEach.js
var require__createBaseEach = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isArrayLike = require_isArrayLike();
	/**
	* Creates a `baseEach` or `baseEachRight` function.
	*
	* @private
	* @param {Function} eachFunc The function to iterate over a collection.
	* @param {boolean} [fromRight] Specify iterating from right to left.
	* @returns {Function} Returns the new base function.
	*/
	function createBaseEach(eachFunc, fromRight) {
		return function(collection, iteratee) {
			if (collection == null) return collection;
			if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
			var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
			while (fromRight ? index-- : ++index < length) if (iteratee(iterable[index], index, iterable) === false) break;
			return collection;
		};
	}
	module.exports = createBaseEach;
}));
//#endregion
//#region ../../node_modules/lodash/_baseEach.js
var require__baseEach = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseForOwn = require__baseForOwn();
	module.exports = require__createBaseEach()(baseForOwn);
}));
//#endregion
//#region ../../node_modules/lodash/_baseMap.js
var require__baseMap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseEach = require__baseEach();
	var isArrayLike = require_isArrayLike();
	/**
	* The base implementation of `_.map` without support for iteratee shorthands.
	*
	* @private
	* @param {Array|Object} collection The collection to iterate over.
	* @param {Function} iteratee The function invoked per iteration.
	* @returns {Array} Returns the new mapped array.
	*/
	function baseMap(collection, iteratee) {
		var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
		baseEach(collection, function(value, key, collection) {
			result[++index] = iteratee(value, key, collection);
		});
		return result;
	}
	module.exports = baseMap;
}));
//#endregion
//#region ../../node_modules/lodash/_baseSortBy.js
var require__baseSortBy = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.sortBy` which uses `comparer` to define the
	* sort order of `array` and replaces criteria objects with their corresponding
	* values.
	*
	* @private
	* @param {Array} array The array to sort.
	* @param {Function} comparer The function to define sort order.
	* @returns {Array} Returns `array`.
	*/
	function baseSortBy(array, comparer) {
		var length = array.length;
		array.sort(comparer);
		while (length--) array[length] = array[length].value;
		return array;
	}
	module.exports = baseSortBy;
}));
//#endregion
//#region ../../node_modules/lodash/_compareAscending.js
var require__compareAscending = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isSymbol = require_isSymbol();
	/**
	* Compares values to sort them in ascending order.
	*
	* @private
	* @param {*} value The value to compare.
	* @param {*} other The other value to compare.
	* @returns {number} Returns the sort order indicator for `value`.
	*/
	function compareAscending(value, other) {
		if (value !== other) {
			var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
			var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
			if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
			if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
		}
		return 0;
	}
	module.exports = compareAscending;
}));
//#endregion
//#region ../../node_modules/lodash/_compareMultiple.js
var require__compareMultiple = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var compareAscending = require__compareAscending();
	/**
	* Used by `_.orderBy` to compare multiple properties of a value to another
	* and stable sort them.
	*
	* If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	* specify an order of "desc" for descending or "asc" for ascending sort order
	* of corresponding values.
	*
	* @private
	* @param {Object} object The object to compare.
	* @param {Object} other The other object to compare.
	* @param {boolean[]|string[]} orders The order to sort by for each property.
	* @returns {number} Returns the sort order indicator for `object`.
	*/
	function compareMultiple(object, other, orders) {
		var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
		while (++index < length) {
			var result = compareAscending(objCriteria[index], othCriteria[index]);
			if (result) {
				if (index >= ordersLength) return result;
				return result * (orders[index] == "desc" ? -1 : 1);
			}
		}
		return object.index - other.index;
	}
	module.exports = compareMultiple;
}));
//#endregion
//#region ../../node_modules/lodash/_baseOrderBy.js
var require__baseOrderBy = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayMap = require__arrayMap();
	var baseGet = require__baseGet();
	var baseIteratee = require__baseIteratee();
	var baseMap = require__baseMap();
	var baseSortBy = require__baseSortBy();
	var baseUnary = require__baseUnary();
	var compareMultiple = require__compareMultiple();
	var identity = require_identity();
	var isArray = require_isArray();
	/**
	* The base implementation of `_.orderBy` without param guards.
	*
	* @private
	* @param {Array|Object} collection The collection to iterate over.
	* @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	* @param {string[]} orders The sort orders of `iteratees`.
	* @returns {Array} Returns the new sorted array.
	*/
	function baseOrderBy(collection, iteratees, orders) {
		if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
			if (isArray(iteratee)) return function(value) {
				return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
			};
			return iteratee;
		});
		else iteratees = [identity];
		var index = -1;
		iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
		return baseSortBy(baseMap(collection, function(value, key, collection) {
			return {
				"criteria": arrayMap(iteratees, function(iteratee) {
					return iteratee(value);
				}),
				"index": ++index,
				"value": value
			};
		}), function(object, other) {
			return compareMultiple(object, other, orders);
		});
	}
	module.exports = baseOrderBy;
}));
//#endregion
//#region ../../node_modules/lodash/sortBy.js
var require_sortBy = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseFlatten = require__baseFlatten();
	var baseOrderBy = require__baseOrderBy();
	var baseRest = require__baseRest();
	var isIterateeCall = require__isIterateeCall();
	module.exports = baseRest(function(collection, iteratees) {
		if (collection == null) return [];
		var length = iteratees.length;
		if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
		else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [iteratees[0]];
		return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsDate.js
var require__baseIsDate = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var dateTag = "[object Date]";
	/**
	* The base implementation of `_.isDate` without Node.js optimizations.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	*/
	function baseIsDate(value) {
		return isObjectLike(value) && baseGetTag(value) == dateTag;
	}
	module.exports = baseIsDate;
}));
//#endregion
//#region ../../node_modules/lodash/isDate.js
var require_isDate = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsDate = require__baseIsDate();
	var baseUnary = require__baseUnary();
	var nodeUtil = require__nodeUtil();
	var nodeIsDate = nodeUtil && nodeUtil.isDate;
	module.exports = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
}));
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/interval.js
var t0 = /* @__PURE__ */ new Date();
var t1 = /* @__PURE__ */ new Date();
function newInterval(floori, offseti, count, field) {
	function interval(date) {
		return floori(date = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date)), date;
	}
	interval.floor = function(date) {
		return floori(date = /* @__PURE__ */ new Date(+date)), date;
	};
	interval.ceil = function(date) {
		return floori(date = /* @__PURE__ */ new Date(date - 1)), offseti(date, 1), floori(date), date;
	};
	interval.round = function(date) {
		var d0 = interval(date), d1 = interval.ceil(date);
		return date - d0 < d1 - date ? d0 : d1;
	};
	interval.offset = function(date, step) {
		return offseti(date = /* @__PURE__ */ new Date(+date), step == null ? 1 : Math.floor(step)), date;
	};
	interval.range = function(start, stop, step) {
		var range = [], previous;
		start = interval.ceil(start);
		step = step == null ? 1 : Math.floor(step);
		if (!(start < stop) || !(step > 0)) return range;
		do
			range.push(previous = /* @__PURE__ */ new Date(+start)), offseti(start, step), floori(start);
		while (previous < start && start < stop);
		return range;
	};
	interval.filter = function(test) {
		return newInterval(function(date) {
			if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
		}, function(date, step) {
			if (date >= date) {
				if (step < 0) while (++step <= 0) while (offseti(date, -1), !test(date));
				else while (--step >= 0) while (offseti(date, 1), !test(date));
			}
		});
	};
	if (count) {
		interval.count = function(start, end) {
			t0.setTime(+start), t1.setTime(+end);
			floori(t0), floori(t1);
			return Math.floor(count(t0, t1));
		};
		interval.every = function(step) {
			step = Math.floor(step);
			return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
				return field(d) % step === 0;
			} : function(d) {
				return interval.count(0, d) % step === 0;
			});
		};
	}
	return interval;
}
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/millisecond.js
var millisecond = newInterval(function() {}, function(date, step) {
	date.setTime(+date + step);
}, function(start, end) {
	return end - start;
});
millisecond.every = function(k) {
	k = Math.floor(k);
	if (!isFinite(k) || !(k > 0)) return null;
	if (!(k > 1)) return millisecond;
	return newInterval(function(date) {
		date.setTime(Math.floor(date / k) * k);
	}, function(date, step) {
		date.setTime(+date + step * k);
	}, function(start, end) {
		return (end - start) / k;
	});
};
millisecond.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/duration.js
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationWeek = 6048e5;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/second.js
var second = newInterval(function(date) {
	date.setTime(date - date.getMilliseconds());
}, function(date, step) {
	date.setTime(+date + step * durationSecond);
}, function(start, end) {
	return (end - start) / durationSecond;
}, function(date) {
	return date.getUTCSeconds();
});
second.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/minute.js
var minute = newInterval(function(date) {
	date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
	date.setTime(+date + step * durationMinute);
}, function(start, end) {
	return (end - start) / durationMinute;
}, function(date) {
	return date.getMinutes();
});
minute.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/hour.js
var hour = newInterval(function(date) {
	date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
	date.setTime(+date + step * durationHour);
}, function(start, end) {
	return (end - start) / durationHour;
}, function(date) {
	return date.getHours();
});
hour.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/week.js
function weekday(i) {
	return newInterval(function(date) {
		date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
		date.setHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setDate(date.getDate() + step * 7);
	}, function(start, end) {
		return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	});
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
sunday.range;
monday.range;
tuesday.range;
wednesday.range;
thursday.range;
friday.range;
saturday.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/month.js
var month = newInterval(function(date) {
	date.setDate(1);
	date.setHours(0, 0, 0, 0);
}, function(date, step) {
	date.setMonth(date.getMonth() + step);
}, function(start, end) {
	return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
	return date.getMonth();
});
month.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/year.js
var year = newInterval(function(date) {
	date.setMonth(0, 1);
	date.setHours(0, 0, 0, 0);
}, function(date, step) {
	date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
	return end.getFullYear() - start.getFullYear();
}, function(date) {
	return date.getFullYear();
});
year.every = function(k) {
	return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
		date.setFullYear(Math.floor(date.getFullYear() / k) * k);
		date.setMonth(0, 1);
		date.setHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setFullYear(date.getFullYear() + step * k);
	});
};
year.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/utcMinute.js
var utcMinute = newInterval(function(date) {
	date.setUTCSeconds(0, 0);
}, function(date, step) {
	date.setTime(+date + step * durationMinute);
}, function(start, end) {
	return (end - start) / durationMinute;
}, function(date) {
	return date.getUTCMinutes();
});
utcMinute.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/utcHour.js
var utcHour = newInterval(function(date) {
	date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
	date.setTime(+date + step * durationHour);
}, function(start, end) {
	return (end - start) / durationHour;
}, function(date) {
	return date.getUTCHours();
});
utcHour.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/utcWeek.js
function utcWeekday(i) {
	return newInterval(function(date) {
		date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
		date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setUTCDate(date.getUTCDate() + step * 7);
	}, function(start, end) {
		return (end - start) / durationWeek;
	});
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/utcMonth.js
var utcMonth = newInterval(function(date) {
	date.setUTCDate(1);
	date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
	date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
	return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
	return date.getUTCMonth();
});
utcMonth.range;
//#endregion
//#region ../../node_modules/@nivo/scales/node_modules/d3-time/src/utcYear.js
var utcYear = newInterval(function(date) {
	date.setUTCMonth(0, 1);
	date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
	date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
	return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
	return date.getUTCFullYear();
});
utcYear.every = function(k) {
	return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
		date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
		date.setUTCMonth(0, 1);
		date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
		date.setUTCFullYear(date.getUTCFullYear() + step * k);
	});
};
utcYear.range;
require_uniq();
require_uniqBy();
require_sortBy();
require_isDate();
var J$2 = [
	function(n) {
		return n.setMilliseconds(0);
	},
	function(n) {
		return n.setSeconds(0);
	},
	function(n) {
		return n.setMinutes(0);
	},
	function(n) {
		return n.setHours(0);
	},
	function(n) {
		return n.setDate(1);
	},
	function(n) {
		return n.setMonth(0);
	}
];
J$2.slice(0, 1), J$2.slice(0, 2), J$2.slice(0, 3), J$2.slice(0, 4), J$2.slice(0, 5), J$2.slice(0, 6);
var nn = function(n) {
	var t = n;
	return t.type = "band", t;
};
var pn = function(n) {
	var t = n.bandwidth();
	if (0 === t) return n;
	var r = t / 2;
	return n.round() && (r = Math.round(r)), function(t) {
		var e;
		return (null != (e = n(t)) ? e : 0) + r;
	};
};
var hn = {
	millisecond: [millisecond, millisecond],
	second: [second, second],
	minute: [minute, utcMinute],
	hour: [hour, utcHour],
	day: [newInterval((function(n) {
		return n.setHours(0, 0, 0, 0);
	}), (function(n, t) {
		return n.setDate(n.getDate() + t);
	}), (function(n, t) {
		return (t.getTime() - n.getTime()) / 864e5;
	}), (function(n) {
		return Math.floor(n.getTime() / 864e5);
	})), newInterval((function(n) {
		return n.setUTCHours(0, 0, 0, 0);
	}), (function(n, t) {
		return n.setUTCDate(n.getUTCDate() + t);
	}), (function(n, t) {
		return (t.getTime() - n.getTime()) / 864e5;
	}), (function(n) {
		return Math.floor(n.getTime() / 864e5);
	}))],
	week: [sunday, utcSunday],
	sunday: [sunday, utcSunday],
	monday: [monday, utcMonday],
	tuesday: [tuesday, utcTuesday],
	wednesday: [wednesday, utcWednesday],
	thursday: [thursday, utcThursday],
	friday: [friday, utcFriday],
	saturday: [saturday, utcSaturday],
	month: [month, utcMonth],
	year: [year, utcYear]
};
var gn = Object.keys(hn);
var xn = new RegExp("^every\\s*(\\d+)?\\s*(" + gn.join("|") + ")s?$", "i");
var kn = function(n, t) {
	if (Array.isArray(t)) return t;
	if ("string" == typeof t && "useUTC" in n) {
		var r = t.match(xn);
		if (r) {
			var e = r[1], a = r[2], i = hn[a][n.useUTC ? 1 : 0];
			if ("day" === a) {
				var o, u, c = n.domain(), f = c[0], d = c[1], s = new Date(d);
				return s.setDate(s.getDate() + 1), null != (o = null == (u = i.every(Number(null != e ? e : 1))) ? void 0 : u.range(f, s)) ? o : [];
			}
			if (void 0 === e) return n.ticks(i);
			var l = i.every(Number(e));
			if (l) return n.ticks(l);
		}
		throw new Error("Invalid tickValues: " + t);
	}
	if ("ticks" in n) {
		if (void 0 === t) return n.ticks();
		if ("number" == typeof (m = t) && isFinite(m) && Math.floor(m) === m) return n.ticks(t);
	}
	var m;
	return n.domain();
};
//#endregion
//#region ../../node_modules/@nivo/axes/dist/nivo-axes.es.js
function v$1() {
	return v$1 = Object.assign || function(t) {
		for (var e = 1; e < arguments.length; e++) {
			var i = arguments[e];
			for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
		}
		return t;
	}, v$1.apply(this, arguments);
}
var p = function(t) {
	var e, i = t.axis, n = t.scale, r = t.ticksPosition, a = t.tickValues, o = t.tickSize, s = t.tickPadding, c = t.tickRotation, f = t.engine, x = void 0 === f ? "svg" : f, d = kn(n, a), y = yi[x], g = "bandwidth" in n ? pn(n) : n, k = {
		lineX: 0,
		lineY: 0
	}, h = {
		textX: 0,
		textY: 0
	}, p = "object" == typeof document && "rtl" === document.dir, b = y.align.center, P = y.baseline.center;
	return "x" === i ? (e = function(t) {
		var e;
		return {
			x: null != (e = g(t)) ? e : 0,
			y: 0
		};
	}, k.lineY = o * ("after" === r ? 1 : -1), h.textY = (o + s) * ("after" === r ? 1 : -1), P = "after" === r ? y.baseline.top : y.baseline.bottom, 0 === c ? b = y.align.center : "after" === r && c < 0 || "before" === r && c > 0 ? (b = y.align[p ? "left" : "right"], P = y.baseline.center) : ("after" === r && c > 0 || "before" === r && c < 0) && (b = y.align[p ? "right" : "left"], P = y.baseline.center)) : (e = function(t) {
		var e;
		return {
			x: 0,
			y: null != (e = g(t)) ? e : 0
		};
	}, k.lineX = o * ("after" === r ? 1 : -1), h.textX = (o + s) * ("after" === r ? 1 : -1), b = "after" === r ? y.align.left : y.align.right), {
		ticks: d.map((function(t) {
			return v$1({
				key: "number" == typeof t || "string" == typeof t ? t : "" + t,
				value: t
			}, e(t), k, h);
		})),
		textAlign: b,
		textBaseline: P
	};
};
var b$1 = function(t, e) {
	if (void 0 === t || "function" == typeof t) return t;
	if ("time" === e.type) {
		var i = timeFormat(t);
		return function(t) {
			return i(t instanceof Date ? t : new Date(t));
		};
	}
	return format(t);
};
var P$1 = function(t) {
	var e, i = t.width, n = t.height, r = t.scale, a = t.axis, o = t.values, l = (e = o, Array.isArray(e) ? o : void 0) || kn(r, o), s = "bandwidth" in r ? pn(r) : r;
	return "x" === a ? l.map((function(t) {
		var e, i;
		return {
			key: "" + t,
			x1: null != (e = s(t)) ? e : 0,
			x2: null != (i = s(t)) ? i : 0,
			y1: 0,
			y2: n
		};
	})) : l.map((function(t) {
		var e, n;
		return {
			key: "" + t,
			x1: 0,
			x2: i,
			y1: null != (e = s(t)) ? e : 0,
			y2: null != (n = s(t)) ? n : 0
		};
	}));
};
var S$1 = memo((function(t) {
	var e, n = t.value, a = t.format, o = t.lineX, l = t.lineY, c = t.onClick, f = t.textBaseline, x = t.textAnchor, d = t.animatedProps, u = Vt(), m = null != (e = null == a ? void 0 : a(n)) ? e : n, k = useMemo((function() {
		var t = { opacity: d.opacity };
		return c ? {
			style: v$1({}, t, { cursor: "pointer" }),
			onClick: function(t) {
				return c(t, m);
			}
		} : { style: t };
	}), [
		d.opacity,
		c,
		m
	]);
	return jsxs(animated.g, v$1({ transform: d.transform }, k, { children: [jsx("line", {
		x1: 0,
		x2: o,
		y1: 0,
		y2: l,
		style: u.axis.ticks.line
	}), jsx(animated.text, {
		dominantBaseline: f,
		textAnchor: x,
		transform: d.textTransform,
		style: u.axis.ticks.text,
		children: m
	})] }));
}));
var T$1 = memo((function(e) {
	var n = e.axis, l = e.scale, f = e.x, x = void 0 === f ? 0 : f, d = e.y, u = void 0 === d ? 0 : d, m = e.length, k = e.ticksPosition, h = e.tickValues, P = e.tickSize, T = void 0 === P ? 5 : P, w = e.tickPadding, A = void 0 === w ? 5 : w, O = e.tickRotation, X = void 0 === O ? 0 : O, Y = e.format, W = e.renderTick, B = void 0 === W ? S$1 : W, z = e.legend, V = e.legendPosition, C = void 0 === V ? "end" : V, R = e.legendOffset, j = void 0 === R ? 0 : R, E = e.onClick, D = e.ariaHidden, q = Vt(), F = useMemo((function() {
		return b$1(Y, l);
	}), [Y, l]), H = p({
		axis: n,
		scale: l,
		ticksPosition: k,
		tickValues: h,
		tickSize: T,
		tickPadding: A,
		tickRotation: X
	}), N = H.ticks, I = H.textAlign, G = H.textBaseline, J = null;
	if (void 0 !== z) {
		var K, L = 0, M = 0, Q = 0;
		"y" === n ? (Q = -90, L = j, "start" === C ? (K = "start", M = m) : "middle" === C ? (K = "middle", M = m / 2) : "end" === C && (K = "end")) : (M = j, "start" === C ? K = "start" : "middle" === C ? (K = "middle", L = m / 2) : "end" === C && (K = "end", L = m)), J = jsx("text", {
			transform: "translate(" + L + ", " + M + ") rotate(" + Q + ")",
			textAnchor: K,
			style: v$1({ dominantBaseline: "central" }, q.axis.legend.text),
			children: z
		});
	}
	var U = tt(), Z = U.animate, $ = U.config, _ = useSpring({
		transform: "translate(" + x + "," + u + ")",
		lineX2: "x" === n ? m : 0,
		lineY2: "x" === n ? 0 : m,
		config: $,
		immediate: !Z
	}), tt$1 = useTransition(N, {
		keys: function(t) {
			return t.key;
		},
		initial: function(t) {
			return {
				opacity: 1,
				transform: "translate(" + t.x + "," + t.y + ")",
				textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
			};
		},
		from: function(t) {
			return {
				opacity: 0,
				transform: "translate(" + t.x + "," + t.y + ")",
				textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
			};
		},
		enter: function(t) {
			return {
				opacity: 1,
				transform: "translate(" + t.x + "," + t.y + ")",
				textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
			};
		},
		update: function(t) {
			return {
				opacity: 1,
				transform: "translate(" + t.x + "," + t.y + ")",
				textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
			};
		},
		leave: { opacity: 0 },
		config: $,
		immediate: !Z
	});
	return jsxs(animated.g, {
		transform: _.transform,
		"aria-hidden": D,
		children: [
			tt$1((function(e, i, n, r) {
				return m$3.createElement(B, v$1({
					tickIndex: r,
					format: F,
					rotate: X,
					textBaseline: G,
					textAnchor: I,
					animatedProps: e
				}, i, E ? { onClick: E } : {}));
			})),
			jsx(animated.line, {
				style: q.axis.domain.line,
				x1: 0,
				x2: _.lineX2,
				y1: 0,
				y2: _.lineY2
			}),
			J
		]
	});
}));
var w$1 = {
	ticksPosition: import_prop_types.default.oneOf(["before", "after"]),
	tickValues: import_prop_types.default.oneOfType([
		import_prop_types.default.number,
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.number,
			import_prop_types.default.string,
			import_prop_types.default.instanceOf(Date)
		])),
		import_prop_types.default.string
	]),
	tickSize: import_prop_types.default.number,
	tickPadding: import_prop_types.default.number,
	tickRotation: import_prop_types.default.number,
	format: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.string]),
	renderTick: import_prop_types.default.func,
	legend: import_prop_types.default.node,
	legendPosition: import_prop_types.default.oneOf([
		"start",
		"middle",
		"end"
	]),
	legendOffset: import_prop_types.default.number,
	ariaHidden: import_prop_types.default.bool
};
import_prop_types.default.shape(w$1);
var O$1 = [
	"top",
	"right",
	"bottom",
	"left"
];
memo((function(t) {
	var e = t.xScale, i = t.yScale, n = t.width, r = t.height, a = {
		top: t.top,
		right: t.right,
		bottom: t.bottom,
		left: t.left
	};
	return jsx(Fragment$1, { children: O$1.map((function(t) {
		var o = a[t];
		if (!o) return null;
		var l = "top" === t || "bottom" === t;
		return jsx(T$1, v$1({}, o, {
			axis: l ? "x" : "y",
			x: "right" === t ? n : 0,
			y: "bottom" === t ? r : 0,
			scale: l ? e : i,
			length: l ? n : r,
			ticksPosition: "top" === t || "left" === t ? "before" : "after"
		}), t);
	})) });
}));
var Y$1 = memo((function(t) {
	var e = t.animatedProps, i = Vt();
	return jsx(animated.line, v$1({}, e, i.grid.line));
}));
var W = memo((function(t) {
	var e = t.lines, i = tt(), r = i.animate, a = i.config, l = useTransition(e, {
		keys: function(t) {
			return t.key;
		},
		initial: function(t) {
			return {
				opacity: 1,
				x1: t.x1,
				x2: t.x2,
				y1: t.y1,
				y2: t.y2
			};
		},
		from: function(t) {
			return {
				opacity: 0,
				x1: t.x1,
				x2: t.x2,
				y1: t.y1,
				y2: t.y2
			};
		},
		enter: function(t) {
			return {
				opacity: 1,
				x1: t.x1,
				x2: t.x2,
				y1: t.y1,
				y2: t.y2
			};
		},
		update: function(t) {
			return {
				opacity: 1,
				x1: t.x1,
				x2: t.x2,
				y1: t.y1,
				y2: t.y2
			};
		},
		leave: { opacity: 0 },
		config: a,
		immediate: !r
	});
	return jsx("g", { children: l((function(t, e) {
		return createElement(Y$1, v$1({}, e, {
			key: e.key,
			animatedProps: t
		}));
	})) });
}));
memo((function(t) {
	var e = t.width, n = t.height, r = t.xScale, a = t.yScale, o = t.xValues, l = t.yValues, s = useMemo((function() {
		return !!r && P$1({
			width: e,
			height: n,
			scale: r,
			axis: "x",
			values: o
		});
	}), [
		r,
		o,
		e,
		n
	]), c = useMemo((function() {
		return !!a && P$1({
			width: e,
			height: n,
			scale: a,
			axis: "y",
			values: l
		});
	}), [
		n,
		e,
		a,
		l
	]);
	return jsxs(Fragment$1, { children: [s && jsx(W, { lines: s }), c && jsx(W, { lines: c })] });
}));
var z$1 = function(t, e) {
	var i, n = e.axis, r = e.scale, a = e.x, o = void 0 === a ? 0 : a, l = e.y, s = void 0 === l ? 0 : l, c = e.length, x = e.ticksPosition, d = e.tickValues, u = e.tickSize, m = void 0 === u ? 5 : u, y = e.tickPadding, g = void 0 === y ? 5 : y, k = e.tickRotation, h = void 0 === k ? 0 : k, v = e.format, b = e.legend, P = e.legendPosition, S = void 0 === P ? "end" : P, T = e.legendOffset, w = void 0 === T ? 0 : T, A = e.theme, O = p({
		axis: n,
		scale: r,
		ticksPosition: x,
		tickValues: d,
		tickSize: m,
		tickPadding: g,
		tickRotation: h,
		engine: "canvas"
	}), X = O.ticks, Y = O.textAlign, W = O.textBaseline;
	t.save(), t.translate(o, s), t.textAlign = Y, t.textBaseline = W, t.font = (A.axis.ticks.text.fontWeight ? A.axis.ticks.text.fontWeight + " " : "") + A.axis.ticks.text.fontSize + "px " + A.axis.ticks.text.fontFamily, (null != (i = A.axis.domain.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(A.axis.domain.line.strokeWidth), t.lineCap = "square", A.axis.domain.line.stroke && (t.strokeStyle = A.axis.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === n ? c : 0, "x" === n ? 0 : c), t.stroke());
	var B = "function" == typeof v ? v : function(t) {
		return "" + t;
	};
	if (X.forEach((function(e) {
		var i;
		(null != (i = A.axis.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(A.axis.ticks.line.strokeWidth), t.lineCap = "square", A.axis.ticks.line.stroke && (t.strokeStyle = A.axis.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
		var n = B(e.value);
		t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate(ui(h)), A.axis.ticks.text.fill && (t.fillStyle = A.axis.ticks.text.fill), t.fillText(String(n), 0, 0), t.restore();
	})), void 0 !== b) {
		var z = 0, V = 0, C = 0, R = "center";
		"y" === n ? (C = -90, z = w, "start" === S ? (R = "start", V = c) : "middle" === S ? (R = "center", V = c / 2) : "end" === S && (R = "end")) : (V = w, "start" === S ? R = "start" : "middle" === S ? (R = "center", z = c / 2) : "end" === S && (R = "end", z = c)), t.translate(z, V), t.rotate(ui(C)), t.font = (A.axis.legend.text.fontWeight ? A.axis.legend.text.fontWeight + " " : "") + A.axis.legend.text.fontSize + "px " + A.axis.legend.text.fontFamily, A.axis.legend.text.fill && (t.fillStyle = A.axis.legend.text.fill), t.textAlign = R, t.textBaseline = "middle", t.fillText(b, 0, 0);
	}
	t.restore();
};
var V = function(t, e) {
	var i = e.xScale, n = e.yScale, r = e.width, a = e.height, o = e.top, l = e.right, s = e.bottom, c = e.left, f = e.theme, x = {
		top: o,
		right: l,
		bottom: s,
		left: c
	};
	O$1.forEach((function(e) {
		var o = x[e];
		if (!o) return null;
		var l = "top" === e || "bottom" === e, s = "top" === e || "left" === e ? "before" : "after", c = l ? i : n, d = b$1(o.format, c);
		z$1(t, v$1({}, o, {
			axis: l ? "x" : "y",
			x: "right" === e ? r : 0,
			y: "bottom" === e ? a : 0,
			scale: c,
			format: d,
			length: l ? r : a,
			ticksPosition: s,
			theme: f
		}));
	}));
};
var C$1 = function(t, e) {
	var i = e.width, n = e.height, r = e.scale, a = e.axis, o = e.values;
	P$1({
		width: i,
		height: n,
		scale: r,
		axis: a,
		values: o
	}).forEach((function(e) {
		t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
	}));
};
//#endregion
//#region ../../node_modules/@nivo/colors/dist/nivo-colors.es.js
function qe() {
	return qe = Object.assign || function(e) {
		for (var r = 1; r < arguments.length; r++) {
			var n = arguments[r];
			for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
		}
		return e;
	}, qe.apply(this, arguments);
}
function Re(e, r) {
	(null == r || r > e.length) && (r = e.length);
	for (var n = 0, t = new Array(r); n < r; n++) t[n] = e[n];
	return t;
}
function Se(e, r) {
	var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = function(e, r) {
		if (e) {
			if ("string" == typeof e) return Re(e, r);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Re(e, r) : void 0;
		}
	}(e)) || r && e && "number" == typeof e.length) {
		n && (e = n);
		var t = 0;
		return function() {
			return t >= e.length ? { done: !0 } : {
				done: !1,
				value: e[t++]
			};
		};
	}
	throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var Ce = {
	nivo: [
		"#e8c1a0",
		"#f47560",
		"#f1e15b",
		"#e8a838",
		"#61cdbb",
		"#97e3d5"
	],
	category10: category10_default,
	accent: Accent_default,
	dark2: Dark2_default,
	paired: Paired_default,
	pastel1: Pastel1_default,
	pastel2: Pastel2_default,
	set1: Set1_default,
	set2: Set2_default,
	set3: Set3_default
};
Object.keys(Ce);
var Ve = {
	brown_blueGreen: scheme$26,
	purpleRed_green: scheme$25,
	pink_yellowGreen: scheme$24,
	purple_orange: scheme$23,
	red_blue: scheme$22,
	red_grey: scheme$21,
	red_yellow_blue: scheme$20,
	red_yellow_green: scheme$19,
	spectral: scheme$18
};
Object.keys(Ve);
var Pe = {
	brown_blueGreen: BrBG_default,
	purpleRed_green: PRGn_default,
	pink_yellowGreen: PiYG_default,
	purple_orange: PuOr_default,
	red_blue: RdBu_default,
	red_grey: RdGy_default,
	red_yellow_blue: RdYlBu_default,
	red_yellow_green: RdYlGn_default,
	spectral: Spectral_default
};
var Ue = {
	blues: scheme$5,
	greens: scheme$4,
	greys: scheme$3,
	oranges: scheme,
	purples: scheme$2,
	reds: scheme$1,
	blue_green: scheme$17,
	blue_purple: scheme$16,
	green_blue: scheme$15,
	orange_red: scheme$14,
	purple_blue_green: scheme$13,
	purple_blue: scheme$12,
	purple_red: scheme$11,
	red_purple: scheme$10,
	yellow_green_blue: scheme$9,
	yellow_green: scheme$8,
	yellow_orange_brown: scheme$7,
	yellow_orange_red: scheme$6
};
Object.keys(Ue);
var Me = {
	blues: Blues_default,
	greens: Greens_default,
	greys: Greys_default,
	oranges: Oranges_default,
	purples: Purples_default,
	reds: Reds_default,
	turbo: turbo_default,
	viridis: viridis_default,
	inferno,
	magma,
	plasma,
	cividis: cividis_default,
	warm,
	cool,
	cubehelixDefault: cubehelix_default,
	blue_green: BuGn_default,
	blue_purple: BuPu_default,
	green_blue: GnBu_default,
	orange_red: OrRd_default,
	purple_blue_green: PuBuGn_default,
	purple_blue: PuBu_default,
	purple_red: PuRd_default,
	red_purple: RdPu_default,
	yellow_green_blue: YlGnBu_default,
	yellow_green: YlGn_default,
	yellow_orange_brown: YlOrBr_default,
	yellow_orange_red: YlOrRd_default
};
var $e = qe({}, Ce, Ve, Ue);
var Be = Object.keys($e);
var Le = qe({}, Pe, Me, {
	rainbow: rainbow_default,
	sinebow: sinebow_default
});
Object.keys(Le);
var Qe = function(e, r) {
	if ("function" == typeof e) return e;
	if ((0, import_isPlainObject.default)(e)) {
		if (function(e) {
			return void 0 !== e.theme;
		}(e)) {
			if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
			var n = (0, import_get.default)(r, e.theme);
			if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
			return function() {
				return n;
			};
		}
		if (function(e) {
			return void 0 !== e.from;
		}(e)) {
			var t = function(r) {
				return (0, import_get.default)(r, e.from);
			};
			if (Array.isArray(e.modifiers)) {
				for (var o, i = [], u = function() {
					var e = o.value, r = e[0], n = e[1];
					if ("brighter" === r) i.push((function(e) {
						return e.brighter(n);
					}));
					else if ("darker" === r) i.push((function(e) {
						return e.darker(n);
					}));
					else {
						if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
						i.push((function(e) {
							return e.opacity = n, e;
						}));
					}
				}, a = Se(e.modifiers); !(o = a()).done;) u();
				return 0 === i.length ? t : function(e) {
					return i.reduce((function(e, r) {
						return r(e);
					}), rgb(t(e))).toString();
				};
			}
			return t;
		}
		throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
	}
	return function() {
		return e;
	};
};
var We = function(e, r) {
	return useMemo((function() {
		return Qe(e, r);
	}), [e, r]);
};
import_prop_types.default.oneOfType([
	import_prop_types.default.func,
	import_prop_types.default.arrayOf(import_prop_types.default.string),
	import_prop_types.default.shape({
		scheme: import_prop_types.default.oneOf(Be).isRequired,
		size: import_prop_types.default.number
	}),
	import_prop_types.default.shape({ datum: import_prop_types.default.string.isRequired }),
	import_prop_types.default.string
]);
import_prop_types.default.oneOfType([
	import_prop_types.default.string,
	import_prop_types.default.func,
	import_prop_types.default.shape({ theme: import_prop_types.default.string.isRequired }),
	import_prop_types.default.shape({
		from: import_prop_types.default.string.isRequired,
		modifiers: import_prop_types.default.arrayOf(import_prop_types.default.array)
	})
]);
var Ze = { scheme: "turbo" };
var er = function(e, r) {
	var n = e.scheme, t = void 0 === n ? Ze.scheme : n, o = e.minValue, i = e.maxValue, u = void 0 !== o ? o : r.min, a = void 0 !== i ? i : r.max;
	return sequential().domain([u, a]).interpolator(Le[t]);
};
var nr = {
	scheme: "red_yellow_blue",
	divergeAt: .5
};
var tr = function(e, r) {
	var n = e.scheme, t = void 0 === n ? nr.scheme : n, o = e.divergeAt, i = void 0 === o ? nr.divergeAt : o, u = e.minValue, a = e.maxValue, s = void 0 !== u ? u : r.min, c = void 0 !== a ? a : r.max, l = [
		s,
		s + (c - s) / 2,
		c
	], f = Le[t], d = .5 - i;
	return diverging((function(e) {
		return f(e + d);
	})).domain(l).clamp(!0);
};
var ir = {
	scheme: "turbo",
	steps: 7
};
var ur = function(e, r) {
	var n = quantize().domain(e.domain || [r.min, r.max]).nice();
	if ("colors" in e) n.range(e.colors);
	else {
		var t = e.scheme || ir.scheme, o = void 0 === e.steps ? ir.steps : e.steps, i = Le[t], u = Array.from({ length: o }).map((function(e, r) {
			return i(r * (1 / (o - 1)));
		}));
		n.range(u);
	}
	return n;
};
var sr = function(e, r) {
	if (function(e) {
		return "sequential" === e.type;
	}(e)) return er(e, r);
	if (function(e) {
		return "diverging" === e.type;
	}(e)) return tr(e, r);
	if (function(e) {
		return "quantize" === e.type;
	}(e)) return ur(e, r);
	throw new Error("Invalid continuous color scale config");
};
var lr = function(e, r) {
	void 0 === r && (r = 16);
	var n = e.domain();
	if ("thresholds" in e) {
		var t = [], o = linear().domain(n).range([0, 1]);
		return e.range().forEach((function(r, n) {
			var i = e.invertExtent(r), u = i[0], a = i[1];
			t.push({
				key: n + ".0",
				offset: o(u),
				stopColor: r
			}), t.push({
				key: n + ".1",
				offset: o(a),
				stopColor: r
			});
		})), t;
	}
	var i = e.copy();
	return 2 === n.length ? i.domain([0, 1]) : 3 === n.length && i.domain([
		0,
		.5,
		1
	]), i.ticks(r).map((function(e) {
		return {
			key: "" + e,
			offset: e,
			stopColor: "" + i(e)
		};
	}));
};
//#endregion
//#region ../../node_modules/@nivo/legends/dist/nivo-legends.es.js
var y = {
	length: 200,
	thickness: 16,
	direction: "row",
	tickPosition: "after",
	tickSize: 4,
	tickSpacing: 3,
	tickOverlap: !1,
	tickFormat: function(t) {
		return "" + t;
	},
	titleAlign: "start",
	titleOffset: 4
};
var x = function(t) {
	var e = t.anchor, i = t.translateX, n = t.translateY, o = t.containerWidth, r = t.containerHeight, l = t.width, a = t.height, c = i, s = n;
	switch (e) {
		case "top":
			c += (o - l) / 2;
			break;
		case "top-right":
			c += o - l;
			break;
		case "right":
			c += o - l, s += (r - a) / 2;
			break;
		case "bottom-right":
			c += o - l, s += r - a;
			break;
		case "bottom":
			c += (o - l) / 2, s += r - a;
			break;
		case "bottom-left":
			s += r - a;
			break;
		case "left":
			s += (r - a) / 2;
			break;
		case "center": c += (o - l) / 2, s += (r - a) / 2;
	}
	return {
		x: c,
		y: s
	};
};
var A = function(t) {
	var e, o = t.scale, r = t.ticks, a = t.length, c = void 0 === a ? y.length : a, s = t.thickness, d = void 0 === s ? y.thickness : s, h = t.direction, g = void 0 === h ? y.direction : h, m = t.tickPosition, f = void 0 === m ? y.tickPosition : m, u = t.tickSize, v = void 0 === u ? y.tickSize : u, p = t.tickSpacing, b = void 0 === p ? y.tickSpacing : p, k = t.tickOverlap, x = void 0 === k ? y.tickOverlap : k, S = t.tickFormat, A = void 0 === S ? y.tickFormat : S, W = t.title, z = t.titleAlign, C = void 0 === z ? y.titleAlign : z, O = t.titleOffset, B = void 0 === O ? y.titleOffset : O, w = "column" === g ? [].concat(o.domain()).reverse() : o.domain(), X = linear().domain(w);
	2 === w.length ? X.range([0, c]) : 3 === w.length && X.range([
		0,
		c / 2,
		c
	]), e = "thresholds" in o ? [w[0]].concat(o.thresholds(), [w[1]]) : Array.isArray(r) ? r : o.ticks(r);
	var Y, H, E, j, T, L, M = lr(o, 32), F = Ut(A), P = [], R = 0, q = 0;
	if ("row" === g) {
		var V, D, G;
		Y = c, H = d, q = 1;
		var I;
		T = 0, E = "start" === C ? 0 : "middle" === C ? c / 2 : c, "before" === f ? (V = -v, D = x ? d : 0, G = -v - b, I = "alphabetic", j = d + B, L = "hanging") : (V = x ? 0 : d, G = (D = d + v) + b, I = "hanging", j = -B, L = "alphabetic"), e.forEach((function(t) {
			var e = X(t);
			P.push({
				x1: e,
				y1: V,
				x2: e,
				y2: D,
				text: F(t),
				textX: e,
				textY: G,
				textHorizontalAlign: "middle",
				textVerticalAlign: I
			});
		}));
	} else {
		var N, _, J, K;
		Y = d, H = c, R = 1;
		T = -90, j = "start" === C ? c : "middle" === C ? c / 2 : 0, "before" === f ? (_ = x ? d : 0, J = (N = -v) - b, K = "end", E = d + B, L = "hanging") : (N = x ? 0 : d, J = (_ = d + v) + b, K = "start", E = -B, L = "alphabetic"), e.forEach((function(t) {
			var e = X(t);
			P.push({
				x1: N,
				y1: e,
				x2: _,
				y2: e,
				text: F(t),
				textX: J,
				textY: e,
				textHorizontalAlign: K,
				textVerticalAlign: "central"
			});
		}));
	}
	return {
		width: Y,
		height: H,
		gradientX1: 0,
		gradientY1: R,
		gradientX2: q,
		gradientY2: 0,
		colorStops: M,
		ticks: P,
		titleText: W,
		titleX: E,
		titleY: j,
		titleRotation: T,
		titleHorizontalAlign: C,
		titleVerticalAlign: L
	};
};
var E = function(t, e) {
	var i = e.containerWidth, n = e.containerHeight, o = e.anchor, l = e.translateX, a = void 0 === l ? 0 : l, c = e.translateY, s = void 0 === c ? 0 : c, d = e.scale, h = e.length, g = void 0 === h ? y.length : h, m = e.thickness, f = void 0 === m ? y.thickness : m, u = e.direction, v = void 0 === u ? y.direction : u, p = e.ticks, b = e.tickPosition, k = void 0 === b ? y.tickPosition : b, S = e.tickSize, W = void 0 === S ? y.tickSize : S, z = e.tickSpacing, C = void 0 === z ? y.tickSpacing : z, O = e.tickOverlap, B = void 0 === O ? y.tickOverlap : O, w = e.tickFormat, X = void 0 === w ? y.tickFormat : w, Y = e.title, H = e.titleAlign, E = void 0 === H ? y.titleAlign : H, j = e.titleOffset, T = void 0 === j ? y.titleOffset : j, L = e.theme, M = A({
		scale: d,
		ticks: p,
		length: g,
		thickness: f,
		direction: v,
		tickPosition: k,
		tickSize: W,
		tickSpacing: C,
		tickOverlap: B,
		tickFormat: X,
		title: Y,
		titleAlign: E,
		titleOffset: T
	}), F = M.width, P = M.height, R = M.gradientX1, q = M.gradientY1, V = M.gradientX2, D = M.gradientY2, G = M.colorStops, I = M.ticks, N = M.titleText, _ = M.titleX, J = M.titleY, K = M.titleRotation, Q = M.titleVerticalAlign, U = M.titleHorizontalAlign, Z = x({
		anchor: o,
		translateX: a,
		translateY: s,
		containerWidth: i,
		containerHeight: n,
		width: F,
		height: P
	}), $ = Z.x, tt = Z.y, et = {
		font: t.font,
		textAlign: t.textAlign,
		textBaseline: t.textBaseline
	};
	t.save(), t.translate($, tt);
	var it = t.createLinearGradient(R * F, q * P, V * F, D * P);
	G.forEach((function(t) {
		it.addColorStop(t.offset, t.stopColor);
	})), t.fillStyle = it, t.fillRect(0, 0, F, P), t.font = (L.legends.ticks.text.fontWeight ? L.legends.ticks.text.fontWeight + " " : "") + L.legends.ticks.text.fontSize + "px " + L.legends.ticks.text.fontFamily, I.forEach((function(e) {
		var i;
		(null != (i = L.legends.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(L.axis.ticks.line.strokeWidth), L.axis.ticks.line.stroke && (t.strokeStyle = L.axis.ticks.line.stroke), t.lineCap = "square", t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke()), L.legends.ticks.text.fill && (t.fillStyle = L.legends.ticks.text.fill), t.textAlign = "middle" === e.textHorizontalAlign ? "center" : e.textHorizontalAlign, t.textBaseline = "central" === e.textVerticalAlign ? "middle" : e.textVerticalAlign, t.fillText(e.text, e.textX, e.textY);
	})), N && (t.save(), t.translate(_, J), t.rotate(ui(K)), t.font = (L.legends.title.text.fontWeight ? L.legends.title.text.fontWeight + " " : "") + L.legends.title.text.fontSize + "px " + L.legends.title.text.fontFamily, L.legends.title.text.fill && (t.fillStyle = L.legends.title.text.fill), t.textAlign = "middle" === U ? "center" : U, t.textBaseline = Q, t.fillText(N, 0, 0), t.restore()), t.restore(), t.font = et.font, t.textAlign = et.textAlign, t.textBaseline = et.textBaseline;
};
import_prop_types.default.arrayOf(import_prop_types.default.object), import_prop_types.default.oneOf([
	"top",
	"top-right",
	"right",
	"bottom-right",
	"bottom",
	"bottom-left",
	"left",
	"top-left",
	"center"
]).isRequired, import_prop_types.default.number, import_prop_types.default.number, import_prop_types.default.oneOf(["row", "column"]).isRequired, import_prop_types.default.number, import_prop_types.default.number.isRequired, import_prop_types.default.number.isRequired, import_prop_types.default.oneOf([
	"left-to-right",
	"right-to-left",
	"top-to-bottom",
	"bottom-to-top"
]), import_prop_types.default.string, import_prop_types.default.string, import_prop_types.default.number, import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
	"circle",
	"diamond",
	"square",
	"triangle"
]), import_prop_types.default.func]), import_prop_types.default.number, import_prop_types.default.number, import_prop_types.default.number, import_prop_types.default.string, import_prop_types.default.func, import_prop_types.default.func, import_prop_types.default.func, import_prop_types.default.arrayOf(import_prop_types.default.shape({
	on: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["hover"])]).isRequired,
	style: import_prop_types.default.shape({
		itemTextColor: import_prop_types.default.string,
		itemBackground: import_prop_types.default.string,
		itemOpacity: import_prop_types.default.number,
		symbolSize: import_prop_types.default.number,
		symbolBorderWidth: import_prop_types.default.number,
		symbolBorderColor: import_prop_types.default.string
	}).isRequired
}));
//#endregion
//#region ../../node_modules/lodash/_arrayEach.js
var require__arrayEach = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `_.forEach` for arrays without support for
	* iteratee shorthands.
	*
	* @private
	* @param {Array} [array] The array to iterate over.
	* @param {Function} iteratee The function invoked per iteration.
	* @returns {Array} Returns `array`.
	*/
	function arrayEach(array, iteratee) {
		var index = -1, length = array == null ? 0 : array.length;
		while (++index < length) if (iteratee(array[index], index, array) === false) break;
		return array;
	}
	module.exports = arrayEach;
}));
//#endregion
//#region ../../node_modules/lodash/_baseAssign.js
var require__baseAssign = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var copyObject = require__copyObject();
	var keys = require_keys();
	/**
	* The base implementation of `_.assign` without support for multiple sources
	* or `customizer` functions.
	*
	* @private
	* @param {Object} object The destination object.
	* @param {Object} source The source object.
	* @returns {Object} Returns `object`.
	*/
	function baseAssign(object, source) {
		return object && copyObject(source, keys(source), object);
	}
	module.exports = baseAssign;
}));
//#endregion
//#region ../../node_modules/lodash/_baseAssignIn.js
var require__baseAssignIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var copyObject = require__copyObject();
	var keysIn = require_keysIn();
	/**
	* The base implementation of `_.assignIn` without support for multiple sources
	* or `customizer` functions.
	*
	* @private
	* @param {Object} object The destination object.
	* @param {Object} source The source object.
	* @returns {Object} Returns `object`.
	*/
	function baseAssignIn(object, source) {
		return object && copyObject(source, keysIn(source), object);
	}
	module.exports = baseAssignIn;
}));
//#endregion
//#region ../../node_modules/lodash/_copySymbols.js
var require__copySymbols = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var copyObject = require__copyObject();
	var getSymbols = require__getSymbols();
	/**
	* Copies own symbols of `source` to `object`.
	*
	* @private
	* @param {Object} source The object to copy symbols from.
	* @param {Object} [object={}] The object to copy symbols to.
	* @returns {Object} Returns `object`.
	*/
	function copySymbols(source, object) {
		return copyObject(source, getSymbols(source), object);
	}
	module.exports = copySymbols;
}));
//#endregion
//#region ../../node_modules/lodash/_getSymbolsIn.js
var require__getSymbolsIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayPush = require__arrayPush();
	var getPrototype = require__getPrototype();
	var getSymbols = require__getSymbols();
	var stubArray = require_stubArray();
	module.exports = !Object.getOwnPropertySymbols ? stubArray : function(object) {
		var result = [];
		while (object) {
			arrayPush(result, getSymbols(object));
			object = getPrototype(object);
		}
		return result;
	};
}));
//#endregion
//#region ../../node_modules/lodash/_copySymbolsIn.js
var require__copySymbolsIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var copyObject = require__copyObject();
	var getSymbolsIn = require__getSymbolsIn();
	/**
	* Copies own and inherited symbols of `source` to `object`.
	*
	* @private
	* @param {Object} source The object to copy symbols from.
	* @param {Object} [object={}] The object to copy symbols to.
	* @returns {Object} Returns `object`.
	*/
	function copySymbolsIn(source, object) {
		return copyObject(source, getSymbolsIn(source), object);
	}
	module.exports = copySymbolsIn;
}));
//#endregion
//#region ../../node_modules/lodash/_getAllKeysIn.js
var require__getAllKeysIn = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetAllKeys = require__baseGetAllKeys();
	var getSymbolsIn = require__getSymbolsIn();
	var keysIn = require_keysIn();
	/**
	* Creates an array of own and inherited enumerable property names and
	* symbols of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @returns {Array} Returns the array of property names and symbols.
	*/
	function getAllKeysIn(object) {
		return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	module.exports = getAllKeysIn;
}));
//#endregion
//#region ../../node_modules/lodash/_initCloneArray.js
var require__initCloneArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Initializes an array clone.
	*
	* @private
	* @param {Array} array The array to clone.
	* @returns {Array} Returns the initialized clone.
	*/
	function initCloneArray(array) {
		var length = array.length, result = new array.constructor(length);
		if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
			result.index = array.index;
			result.input = array.input;
		}
		return result;
	}
	module.exports = initCloneArray;
}));
//#endregion
//#region ../../node_modules/lodash/_cloneDataView.js
var require__cloneDataView = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var cloneArrayBuffer = require__cloneArrayBuffer();
	/**
	* Creates a clone of `dataView`.
	*
	* @private
	* @param {Object} dataView The data view to clone.
	* @param {boolean} [isDeep] Specify a deep clone.
	* @returns {Object} Returns the cloned data view.
	*/
	function cloneDataView(dataView, isDeep) {
		var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
		return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	module.exports = cloneDataView;
}));
//#endregion
//#region ../../node_modules/lodash/_cloneRegExp.js
var require__cloneRegExp = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	/**
	* Creates a clone of `regexp`.
	*
	* @private
	* @param {Object} regexp The regexp to clone.
	* @returns {Object} Returns the cloned regexp.
	*/
	function cloneRegExp(regexp) {
		var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
		result.lastIndex = regexp.lastIndex;
		return result;
	}
	module.exports = cloneRegExp;
}));
//#endregion
//#region ../../node_modules/lodash/_cloneSymbol.js
var require__cloneSymbol = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : void 0;
	var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
	/**
	* Creates a clone of the `symbol` object.
	*
	* @private
	* @param {Object} symbol The symbol object to clone.
	* @returns {Object} Returns the cloned symbol object.
	*/
	function cloneSymbol(symbol) {
		return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	module.exports = cloneSymbol;
}));
//#endregion
//#region ../../node_modules/lodash/_initCloneByTag.js
var require__initCloneByTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var cloneArrayBuffer = require__cloneArrayBuffer();
	var cloneDataView = require__cloneDataView();
	var cloneRegExp = require__cloneRegExp();
	var cloneSymbol = require__cloneSymbol();
	var cloneTypedArray = require__cloneTypedArray();
	/** `Object#toString` result references. */
	var boolTag = "[object Boolean]";
	var dateTag = "[object Date]";
	var mapTag = "[object Map]";
	var numberTag = "[object Number]";
	var regexpTag = "[object RegExp]";
	var setTag = "[object Set]";
	var stringTag = "[object String]";
	var symbolTag = "[object Symbol]";
	var arrayBufferTag = "[object ArrayBuffer]";
	var dataViewTag = "[object DataView]";
	var float32Tag = "[object Float32Array]";
	var float64Tag = "[object Float64Array]";
	var int8Tag = "[object Int8Array]";
	var int16Tag = "[object Int16Array]";
	var int32Tag = "[object Int32Array]";
	var uint8Tag = "[object Uint8Array]";
	var uint8ClampedTag = "[object Uint8ClampedArray]";
	var uint16Tag = "[object Uint16Array]";
	var uint32Tag = "[object Uint32Array]";
	/**
	* Initializes an object clone based on its `toStringTag`.
	*
	* **Note:** This function only supports cloning values with tags of
	* `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	*
	* @private
	* @param {Object} object The object to clone.
	* @param {string} tag The `toStringTag` of the object to clone.
	* @param {boolean} [isDeep] Specify a deep clone.
	* @returns {Object} Returns the initialized clone.
	*/
	function initCloneByTag(object, tag, isDeep) {
		var Ctor = object.constructor;
		switch (tag) {
			case arrayBufferTag: return cloneArrayBuffer(object);
			case boolTag:
			case dateTag: return new Ctor(+object);
			case dataViewTag: return cloneDataView(object, isDeep);
			case float32Tag:
			case float64Tag:
			case int8Tag:
			case int16Tag:
			case int32Tag:
			case uint8Tag:
			case uint8ClampedTag:
			case uint16Tag:
			case uint32Tag: return cloneTypedArray(object, isDeep);
			case mapTag: return new Ctor();
			case numberTag:
			case stringTag: return new Ctor(object);
			case regexpTag: return cloneRegExp(object);
			case setTag: return new Ctor();
			case symbolTag: return cloneSymbol(object);
		}
	}
	module.exports = initCloneByTag;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsMap.js
var require__baseIsMap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getTag = require__getTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var mapTag = "[object Map]";
	/**
	* The base implementation of `_.isMap` without Node.js optimizations.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a map, else `false`.
	*/
	function baseIsMap(value) {
		return isObjectLike(value) && getTag(value) == mapTag;
	}
	module.exports = baseIsMap;
}));
//#endregion
//#region ../../node_modules/lodash/isMap.js
var require_isMap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsMap = require__baseIsMap();
	var baseUnary = require__baseUnary();
	var nodeUtil = require__nodeUtil();
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	module.exports = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
}));
//#endregion
//#region ../../node_modules/lodash/_baseIsSet.js
var require__baseIsSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getTag = require__getTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var setTag = "[object Set]";
	/**
	* The base implementation of `_.isSet` without Node.js optimizations.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a set, else `false`.
	*/
	function baseIsSet(value) {
		return isObjectLike(value) && getTag(value) == setTag;
	}
	module.exports = baseIsSet;
}));
//#endregion
//#region ../../node_modules/lodash/isSet.js
var require_isSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsSet = require__baseIsSet();
	var baseUnary = require__baseUnary();
	var nodeUtil = require__nodeUtil();
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	module.exports = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
}));
//#endregion
//#region ../../node_modules/lodash/_baseClone.js
var require__baseClone = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Stack = require__Stack();
	var arrayEach = require__arrayEach();
	var assignValue = require__assignValue();
	var baseAssign = require__baseAssign();
	var baseAssignIn = require__baseAssignIn();
	var cloneBuffer = require__cloneBuffer();
	var copyArray = require__copyArray();
	var copySymbols = require__copySymbols();
	var copySymbolsIn = require__copySymbolsIn();
	var getAllKeys = require__getAllKeys();
	var getAllKeysIn = require__getAllKeysIn();
	var getTag = require__getTag();
	var initCloneArray = require__initCloneArray();
	var initCloneByTag = require__initCloneByTag();
	var initCloneObject = require__initCloneObject();
	var isArray = require_isArray();
	var isBuffer = require_isBuffer();
	var isMap = require_isMap();
	var isObject = require_isObject();
	var isSet = require_isSet();
	var keys = require_keys();
	var keysIn = require_keysIn();
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	var CLONE_FLAT_FLAG = 2;
	var CLONE_SYMBOLS_FLAG = 4;
	/** `Object#toString` result references. */
	var argsTag = "[object Arguments]";
	var arrayTag = "[object Array]";
	var boolTag = "[object Boolean]";
	var dateTag = "[object Date]";
	var errorTag = "[object Error]";
	var funcTag = "[object Function]";
	var genTag = "[object GeneratorFunction]";
	var mapTag = "[object Map]";
	var numberTag = "[object Number]";
	var objectTag = "[object Object]";
	var regexpTag = "[object RegExp]";
	var setTag = "[object Set]";
	var stringTag = "[object String]";
	var symbolTag = "[object Symbol]";
	var weakMapTag = "[object WeakMap]";
	var arrayBufferTag = "[object ArrayBuffer]";
	var dataViewTag = "[object DataView]";
	var float32Tag = "[object Float32Array]";
	var float64Tag = "[object Float64Array]";
	var int8Tag = "[object Int8Array]";
	var int16Tag = "[object Int16Array]";
	var int32Tag = "[object Int32Array]";
	var uint8Tag = "[object Uint8Array]";
	var uint8ClampedTag = "[object Uint8ClampedArray]";
	var uint16Tag = "[object Uint16Array]";
	var uint32Tag = "[object Uint32Array]";
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
	/**
	* The base implementation of `_.clone` and `_.cloneDeep` which tracks
	* traversed objects.
	*
	* @private
	* @param {*} value The value to clone.
	* @param {boolean} bitmask The bitmask flags.
	*  1 - Deep clone
	*  2 - Flatten inherited properties
	*  4 - Clone symbols
	* @param {Function} [customizer] The function to customize cloning.
	* @param {string} [key] The key of `value`.
	* @param {Object} [object] The parent object of `value`.
	* @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	* @returns {*} Returns the cloned value.
	*/
	function baseClone(value, bitmask, customizer, key, object, stack) {
		var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
		if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
		if (result !== void 0) return result;
		if (!isObject(value)) return value;
		var isArr = isArray(value);
		if (isArr) {
			result = initCloneArray(value);
			if (!isDeep) return copyArray(value, result);
		} else {
			var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
			if (isBuffer(value)) return cloneBuffer(value, isDeep);
			if (tag == objectTag || tag == argsTag || isFunc && !object) {
				result = isFlat || isFunc ? {} : initCloneObject(value);
				if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
			} else {
				if (!cloneableTags[tag]) return object ? value : {};
				result = initCloneByTag(value, tag, isDeep);
			}
		}
		stack || (stack = new Stack());
		var stacked = stack.get(value);
		if (stacked) return stacked;
		stack.set(value, result);
		if (isSet(value)) value.forEach(function(subValue) {
			result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
		});
		else if (isMap(value)) value.forEach(function(subValue, key) {
			result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
		});
		var props = isArr ? void 0 : (isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys)(value);
		arrayEach(props || value, function(subValue, key) {
			if (props) {
				key = subValue;
				subValue = value[key];
			}
			assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
		});
		return result;
	}
	module.exports = baseClone;
}));
//#endregion
//#region ../../node_modules/lodash/_baseSlice.js
var require__baseSlice = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* The base implementation of `_.slice` without an iteratee call guard.
	*
	* @private
	* @param {Array} array The array to slice.
	* @param {number} [start=0] The start position.
	* @param {number} [end=array.length] The end position.
	* @returns {Array} Returns the slice of `array`.
	*/
	function baseSlice(array, start, end) {
		var index = -1, length = array.length;
		if (start < 0) start = -start > length ? 0 : length + start;
		end = end > length ? length : end;
		if (end < 0) end += length;
		length = start > end ? 0 : end - start >>> 0;
		start >>>= 0;
		var result = Array(length);
		while (++index < length) result[index] = array[index + start];
		return result;
	}
	module.exports = baseSlice;
}));
//#endregion
//#region ../../node_modules/lodash/_parent.js
var require__parent = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGet = require__baseGet();
	var baseSlice = require__baseSlice();
	/**
	* Gets the parent value at `path` of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {Array} path The path to get the parent value of.
	* @returns {*} Returns the parent value.
	*/
	function parent(object, path) {
		return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	module.exports = parent;
}));
//#endregion
//#region ../../node_modules/lodash/_baseUnset.js
var require__baseUnset = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var castPath = require__castPath();
	var last = require_last();
	var parent = require__parent();
	var toKey = require__toKey();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* The base implementation of `_.unset`.
	*
	* @private
	* @param {Object} object The object to modify.
	* @param {Array|string} path The property path to unset.
	* @returns {boolean} Returns `true` if the property is deleted, else `false`.
	*/
	function baseUnset(object, path) {
		path = castPath(path, object);
		var index = -1, length = path.length;
		if (!length) return true;
		while (++index < length) {
			var key = toKey(path[index]);
			if (key === "__proto__" && !hasOwnProperty.call(object, "__proto__")) return false;
			if ((key === "constructor" || key === "prototype") && index < length - 1) return false;
		}
		var obj = parent(object, path);
		return obj == null || delete obj[toKey(last(path))];
	}
	module.exports = baseUnset;
}));
//#endregion
//#region ../../node_modules/lodash/_customOmitClone.js
var require__customOmitClone = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isPlainObject = require_isPlainObject();
	/**
	* Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	* objects.
	*
	* @private
	* @param {*} value The value to inspect.
	* @param {string} key The key of the property to inspect.
	* @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	*/
	function customOmitClone(value) {
		return isPlainObject(value) ? void 0 : value;
	}
	module.exports = customOmitClone;
}));
//#endregion
//#region ../../node_modules/lodash/omit.js
var require_omit = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayMap = require__arrayMap();
	var baseClone = require__baseClone();
	var baseUnset = require__baseUnset();
	var castPath = require__castPath();
	var copyObject = require__copyObject();
	var customOmitClone = require__customOmitClone();
	var flatRest = require__flatRest();
	var getAllKeysIn = require__getAllKeysIn();
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	var CLONE_FLAT_FLAG = 2;
	var CLONE_SYMBOLS_FLAG = 4;
	module.exports = flatRest(function(object, paths) {
		var result = {};
		if (object == null) return result;
		var isDeep = false;
		paths = arrayMap(paths, function(path) {
			path = castPath(path, object);
			isDeep || (isDeep = path.length > 1);
			return path;
		});
		copyObject(object, getAllKeysIn(object), result);
		if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
		var length = paths.length;
		while (length--) baseUnset(result, paths[length]);
		return result;
	});
}));
//#endregion
//#region ../../node_modules/lodash/isNumber.js
var require_isNumber = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var numberTag = "[object Number]";
	/**
	* Checks if `value` is classified as a `Number` primitive or object.
	*
	* **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	* classified as numbers, use the `_.isFinite` method.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a number, else `false`.
	* @example
	*
	* _.isNumber(3);
	* // => true
	*
	* _.isNumber(Number.MIN_VALUE);
	* // => true
	*
	* _.isNumber(Infinity);
	* // => true
	*
	* _.isNumber('3');
	* // => false
	*/
	function isNumber(value) {
		return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
	}
	module.exports = isNumber;
}));
//#endregion
//#region ../../node_modules/lodash/_baseFilter.js
var require__baseFilter = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseEach = require__baseEach();
	/**
	* The base implementation of `_.filter` without support for iteratee shorthands.
	*
	* @private
	* @param {Array|Object} collection The collection to iterate over.
	* @param {Function} predicate The function invoked per iteration.
	* @returns {Array} Returns the new filtered array.
	*/
	function baseFilter(collection, predicate) {
		var result = [];
		baseEach(collection, function(value, index, collection) {
			if (predicate(value, index, collection)) result.push(value);
		});
		return result;
	}
	module.exports = baseFilter;
}));
//#endregion
//#region ../../node_modules/lodash/filter.js
var require_filter = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var arrayFilter = require__arrayFilter();
	var baseFilter = require__baseFilter();
	var baseIteratee = require__baseIteratee();
	var isArray = require_isArray();
	/**
	* Iterates over elements of `collection`, returning an array of all elements
	* `predicate` returns truthy for. The predicate is invoked with three
	* arguments: (value, index|key, collection).
	*
	* **Note:** Unlike `_.remove`, this method returns a new array.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Collection
	* @param {Array|Object} collection The collection to iterate over.
	* @param {Function} [predicate=_.identity] The function invoked per iteration.
	* @returns {Array} Returns the new filtered array.
	* @see _.reject
	* @example
	*
	* var users = [
	*   { 'user': 'barney', 'age': 36, 'active': true },
	*   { 'user': 'fred',   'age': 40, 'active': false }
	* ];
	*
	* _.filter(users, function(o) { return !o.active; });
	* // => objects for ['fred']
	*
	* // The `_.matches` iteratee shorthand.
	* _.filter(users, { 'age': 36, 'active': true });
	* // => objects for ['barney']
	*
	* // The `_.matchesProperty` iteratee shorthand.
	* _.filter(users, ['active', false]);
	* // => objects for ['fred']
	*
	* // The `_.property` iteratee shorthand.
	* _.filter(users, 'active');
	* // => objects for ['barney']
	*
	* // Combining several predicates using `_.overEvery` or `_.overSome`.
	* _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	* // => objects for ['fred', 'barney']
	*/
	function filter(collection, predicate) {
		return (isArray(collection) ? arrayFilter : baseFilter)(collection, baseIteratee(predicate, 3));
	}
	module.exports = filter;
}));
//#endregion
//#region ../../node_modules/@nivo/annotations/dist/nivo-annotations.es.js
var import_omit = /* @__PURE__ */ __toESM(require_omit());
var import_isNumber = /* @__PURE__ */ __toESM(require_isNumber());
var import_filter = /* @__PURE__ */ __toESM(require_filter());
function g() {
	return g = Object.assign || function(t) {
		for (var n = 1; n < arguments.length; n++) {
			var i = arguments[n];
			for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
		}
		return t;
	}, g.apply(this, arguments);
}
var k = {
	dotSize: 4,
	noteWidth: 120,
	noteTextOffset: 8,
	animate: !0,
	motionStiffness: 90,
	motionDamping: 13
};
var v = function(t) {
	var n = typeof t;
	return "string" === n || "function" === n;
};
var b = function(t) {
	return "circle" === t.type;
};
var w = function(t) {
	return "dot" === t.type;
};
var z = function(t) {
	return "rect" === t.type;
};
var P = function(t) {
	var n = t.data, i = t.annotations, e = t.getPosition, r = t.getDimensions;
	return i.reduce((function(t, i) {
		var s = i.offset || 0;
		return [].concat(t, (0, import_filter.default)(n, i.match).map((function(t) {
			var n = e(t), a = r(t);
			return (b(i) || z(i)) && (a.size = a.size + 2 * s, a.width = a.width + 2 * s, a.height = a.height + 2 * s), g({}, (0, import_omit.default)(i, ["match", "offset"]), n, a, {
				size: i.size || a.size,
				datum: t
			});
		})));
	}), []);
};
var S = function(t, n, i, o) {
	return hi(ci(Math.atan2(o - n, i - t)));
};
var C = function(t) {
	var n, i, o = t.x, a = t.y, r = t.noteX, s = t.noteY, h = t.noteWidth, d = void 0 === h ? k.noteWidth : h, c = t.noteTextOffset, f = void 0 === c ? k.noteTextOffset : c;
	if ((0, import_isNumber.default)(r)) n = o + r;
	else {
		if (void 0 === r.abs) throw new Error("noteX should be either a number or an object containing an 'abs' property");
		n = r.abs;
	}
	if ((0, import_isNumber.default)(s)) i = a + s;
	else {
		if (void 0 === s.abs) throw new Error("noteY should be either a number or an object containing an 'abs' property");
		i = s.abs;
	}
	var y = o, x = a, m = S(o, a, n, i);
	if (b(t)) {
		var p = pi(ui(m), t.size / 2);
		y += p.x, x += p.y;
	}
	if (z(t)) {
		var g = Math.round((m + 90) / 45) % 8;
		0 === g && (x -= t.height / 2), 1 === g && (y += t.width / 2, x -= t.height / 2), 2 === g && (y += t.width / 2), 3 === g && (y += t.width / 2, x += t.height / 2), 4 === g && (x += t.height / 2), 5 === g && (y -= t.width / 2, x += t.height / 2), 6 === g && (y -= t.width / 2), 7 === g && (y -= t.width / 2, x -= t.height / 2);
	}
	var W = n, v = n;
	return (m + 90) % 360 > 180 ? (W -= d, v -= d) : v += d, {
		points: [
			[y, x],
			[n, i],
			[v, i]
		],
		text: [W, i - f],
		angle: m + 90
	};
};
var O = function(t) {
	var i = t.data, o = t.annotations, e = t.getPosition, a = t.getDimensions;
	return useMemo((function() {
		return P({
			data: i,
			annotations: o,
			getPosition: e,
			getDimensions: a
		});
	}), [
		i,
		o,
		e,
		a
	]);
};
var j$1 = function(t) {
	var i = t.annotations;
	return useMemo((function() {
		return i.map((function(t) {
			return g({}, t, { computed: C(g({}, t)) });
		}));
	}), [i]);
};
var q = function(t, n) {
	n.forEach((function(n, i) {
		var o = n[0], e = n[1];
		0 === i ? t.moveTo(o, e) : t.lineTo(o, e);
	}));
};
var J$1 = function(t, n) {
	var i = n.annotations, o = n.theme;
	0 !== i.length && (t.save(), i.forEach((function(n) {
		if (!v(n.note)) throw new Error("note is invalid for canvas implementation");
		o.annotations.link.outlineWidth > 0 && (t.lineCap = "square", t.strokeStyle = o.annotations.link.outlineColor, t.lineWidth = o.annotations.link.strokeWidth + 2 * o.annotations.link.outlineWidth, t.beginPath(), q(t, n.computed.points), t.stroke(), t.lineCap = "butt"), b(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), w(n) && o.annotations.symbol.outlineWidth > 0 && (t.strokeStyle = o.annotations.symbol.outlineColor, t.lineWidth = 2 * o.annotations.symbol.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), z(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), t.strokeStyle = o.annotations.link.stroke, t.lineWidth = o.annotations.link.strokeWidth, t.beginPath(), q(t, n.computed.points), t.stroke(), b(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), w(n) && (t.fillStyle = o.annotations.symbol.fill, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.fill()), z(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), "function" == typeof n.note ? n.note(t, {
			datum: n.datum,
			x: n.computed.text[0],
			y: n.computed.text[1],
			theme: o
		}) : (t.font = o.annotations.text.fontSize + "px " + o.annotations.text.fontFamily, t.textAlign = "left", t.textBaseline = "alphabetic", t.fillStyle = o.annotations.text.fill, t.strokeStyle = o.annotations.text.outlineColor, t.lineWidth = 2 * o.annotations.text.outlineWidth, o.annotations.text.outlineWidth > 0 && (t.lineJoin = "round", t.strokeText(n.note, n.computed.text[0], n.computed.text[1]), t.lineJoin = "miter"), t.fillText(n.note, n.computed.text[0], n.computed.text[1]));
	})), t.restore());
};
//#endregion
//#region ../../node_modules/@nivo/heatmap/dist/nivo-heatmap.es.js
function Y() {
	return Y = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var i = arguments[t];
			for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
		}
		return e;
	}, Y.apply(this, arguments);
}
function G(e, t) {
	if (null == e) return {};
	var i, o, n = {}, r = Object.keys(e);
	for (o = 0; o < r.length; o++) i = r[o], t.indexOf(i) >= 0 || (n[i] = e[i]);
	return n;
}
var H = {
	layers: [
		"grid",
		"axes",
		"cells",
		"legends",
		"annotations"
	],
	forceSquare: !1,
	xInnerPadding: 0,
	xOuterPadding: 0,
	yInnerPadding: 0,
	yOuterPadding: 0,
	sizeVariation: !1,
	opacity: 1,
	activeOpacity: 1,
	inactiveOpacity: .15,
	borderWidth: 0,
	borderColor: {
		from: "color",
		modifiers: [["darker", .8]]
	},
	enableGridX: !1,
	enableGridY: !1,
	enableLabels: !0,
	label: "formattedValue",
	labelTextColor: {
		from: "color",
		modifiers: [["darker", 2]]
	},
	colors: {
		type: "sequential",
		scheme: "brown_blueGreen"
	},
	emptyColor: "#000000",
	legends: [],
	annotations: [],
	isInteractive: !0,
	hoverTarget: "rowColumn",
	tooltip: memo((function(e) {
		var t = e.cell;
		return null === t.formattedValue ? null : jsx(w$2, {
			id: t.serieId + " - " + t.data.x,
			value: t.formattedValue,
			enableChip: !0,
			color: t.color
		});
	})),
	animate: !0,
	motionConfig: "gentle"
};
Y({}, H, {
	axisTop: {},
	axisRight: null,
	axisBottom: null,
	axisLeft: {},
	borderRadius: 0,
	cellComponent: "rect"
});
var D = Y({}, H, {
	axisTop: {},
	axisRight: null,
	axisBottom: null,
	axisLeft: {},
	renderCell: "rect",
	pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1
});
var _ = function(e) {
	var t = e.width, i = e.height, o = e.rows, n = e.columns, r = t, a = i, l = 0, d = 0;
	if (e.forceSquare) {
		var c = Math.max(t / n, 0), u = Math.max(i / o, 0), s = Math.min(c, u);
		l = (t - (r = s * n)) / 2, d = (i - (a = s * o)) / 2;
	}
	return {
		offsetX: l,
		offsetY: d,
		width: r,
		height: a
	};
};
var J = function(e) {
	var t = e.data, i = e.width, o = e.height, n = e.xInnerPadding, r = e.xOuterPadding, a = e.yInnerPadding, l = e.yOuterPadding, d = e.forceSquare, c = /* @__PURE__ */ new Set(), u = [], s = [], h = [];
	t.forEach((function(e) {
		u.push(e.id), e.data.forEach((function(t) {
			c.add(t.x);
			var i = null;
			void 0 !== t.y && null !== t.y && (s.push(t.y), i = t.y), h.push({
				id: e.id + "." + t.x,
				serieId: e.id,
				value: i,
				data: t
			});
		}));
	}));
	var v = Array.from(c), f = _({
		width: i,
		height: o,
		columns: v.length,
		rows: u.length,
		forceSquare: d
	}), g = f.width, p = f.height, b = f.offsetX, y = f.offsetY, m = nn(band().domain(v).range([0, g]).paddingOuter(r).paddingInner(n)), x = nn(band().domain(u).range([0, p]).paddingOuter(l).paddingInner(a)), C = m.bandwidth(), w = x.bandwidth(), P = h.map((function(e) {
		return Y({}, e, {
			x: m(e.data.x) + C / 2,
			y: x(e.serieId) + w / 2,
			width: C,
			height: w
		});
	}));
	return {
		width: g,
		height: p,
		offsetX: b,
		offsetY: y,
		xScale: m,
		yScale: x,
		minValue: Math.min.apply(Math, s),
		maxValue: Math.max.apply(Math, s),
		cells: P
	};
};
var K = function(e, t, i) {
	if (!e) return function() {
		return 1;
	};
	var o = linear().domain(e.values ? e.values : [t, i]).range(e.sizes);
	return function(e) {
		return null === e ? 1 : o(e);
	};
};
var N = function(e) {
	return {
		x: e.x,
		y: e.y
	};
};
var Q = function(e) {
	return {
		size: Math.max(e.width, e.height),
		width: e.width,
		height: e.height
	};
};
var U = function(e) {
	var i = e.data, o = e.width, n = e.height, r = e.xInnerPadding, a = e.xOuterPadding, l = e.yInnerPadding, d = e.yOuterPadding, c = e.forceSquare;
	return useMemo((function() {
		return J({
			data: i,
			width: o,
			height: n,
			xInnerPadding: r,
			xOuterPadding: a,
			yInnerPadding: l,
			yOuterPadding: d,
			forceSquare: c
		});
	}), [
		i,
		o,
		n,
		r,
		a,
		l,
		d,
		c
	]);
};
var Z = {
	cell: function(e, t) {
		return e.id === t.id;
	},
	row: function(e, t) {
		return e.serieId === t.serieId;
	},
	column: function(e, t) {
		return e.data.x === t.data.x;
	},
	rowColumn: function(e, t) {
		return e.serieId === t.serieId || e.data.x === t.data.x;
	}
};
var $ = function(e) {
	var i, n, r, a = e.cells, l = e.minValue, s = e.maxValue, h = e.sizeVariation, v = e.colors, f = e.emptyColor, g = e.opacity, p = e.activeOpacity, b = e.inactiveOpacity, y = e.borderColor, m = e.label, x = e.labelTextColor, C = e.valueFormat, w = e.activeIds, P = useMemo((function() {
		return K(i, n, r);
	}), [
		i = h,
		n = l,
		r = s
	]), S = useMemo((function() {
		return "function" == typeof v ? null : sr(v, {
			min: l,
			max: s
		});
	}), [
		v,
		l,
		s
	]), M = useCallback((function(e) {
		if (null !== e.value) {
			if ("function" == typeof v) return v(e);
			if (null !== S) return S(e.value);
		}
		return f;
	}), [
		v,
		S,
		f
	]), T = Vt(), W = We(y, T), L = We(x, T), k = Xt(C), V = Xi(m);
	return {
		cells: useMemo((function() {
			return a.map((function(e) {
				var t = g;
				w.length > 0 && (t = w.includes(e.id) ? p : b);
				var i = P(e.value), o = Y({}, e, {
					width: e.width * i,
					height: e.height * i,
					formattedValue: null !== e.value ? k(e.value) : null,
					opacity: t
				});
				return o.label = V(o), o.color = M(o), o.borderColor = W(o), o.labelTextColor = L(o), o;
			}));
		}), [
			a,
			P,
			M,
			W,
			L,
			k,
			V,
			w,
			g,
			p,
			b
		]),
		colorScale: S
	};
};
var ee = function(e) {
	var o = e.data, n = e.valueFormat, r = e.width, a = e.height, l = e.xOuterPadding, d = void 0 === l ? H.xOuterPadding : l, c = e.xInnerPadding, u = void 0 === c ? H.xInnerPadding : c, s = e.yOuterPadding, h = void 0 === s ? H.yOuterPadding : s, v = e.yInnerPadding, f = void 0 === v ? H.yInnerPadding : v, g = e.forceSquare, p = void 0 === g ? H.forceSquare : g, b = e.sizeVariation, y = void 0 === b ? H.sizeVariation : b, m = e.colors, x = void 0 === m ? H.colors : m, C = e.emptyColor, w = void 0 === C ? H.emptyColor : C, P = e.opacity, O = void 0 === P ? H.opacity : P, I = e.activeOpacity, S = void 0 === I ? H.activeOpacity : I, M = e.inactiveOpacity, T = void 0 === M ? H.inactiveOpacity : M, W = e.borderColor, L = void 0 === W ? H.borderColor : W, k = e.label, V = void 0 === k ? H.label : k, R = e.labelTextColor, B = void 0 === R ? H.labelTextColor : R, q = e.hoverTarget, E = void 0 === q ? H.hoverTarget : q, z = useState(null), A = z[0], F = z[1], X = U({
		data: o,
		width: r,
		height: a,
		xOuterPadding: d,
		xInnerPadding: u,
		yOuterPadding: h,
		yInnerPadding: f,
		forceSquare: p
	}), Y = X.width, G = X.height, j = X.offsetX, D = X.offsetY, _ = X.cells, J = X.xScale, K = X.yScale, N = X.minValue, Q = X.maxValue, te = $({
		cells: _,
		minValue: N,
		maxValue: Q,
		sizeVariation: y,
		colors: x,
		emptyColor: w,
		opacity: O,
		activeOpacity: S,
		inactiveOpacity: T,
		borderColor: L,
		label: V,
		labelTextColor: B,
		valueFormat: n,
		activeIds: useMemo((function() {
			if (!A) return [];
			var e = Z[E];
			return _.filter((function(t) {
				return e(t, A);
			})).map((function(e) {
				return e.id;
			}));
		}), [
			_,
			A,
			E
		])
	});
	return {
		width: Y,
		height: G,
		offsetX: j,
		offsetY: D,
		cells: te.cells,
		xScale: J,
		yScale: K,
		colorScale: te.colorScale,
		activeCell: A,
		setActiveCell: F
	};
};
var te = function(e, t) {
	return O({
		data: e,
		annotations: t,
		getPosition: N,
		getDimensions: Q
	});
};
memo((function(e) {
	var i = e.cell, o = e.borderWidth, n = e.borderRadius, r = e.animatedProps, a = e.onMouseEnter, l = e.onMouseMove, c = e.onMouseLeave, u = e.onClick, s = e.enableLabels, h = Vt(), v = useMemo((function() {
		return {
			onMouseEnter: a ? a(i) : void 0,
			onMouseMove: l ? l(i) : void 0,
			onMouseLeave: c ? c(i) : void 0,
			onClick: u ? u(i) : void 0
		};
	}), [
		i,
		a,
		l,
		c,
		u
	]);
	return jsxs(animated.g, Y({
		"data-testid": "cell." + i.id,
		style: { cursor: "pointer" },
		opacity: r.opacity
	}, v, {
		transform: to([
			r.x,
			r.y,
			r.scale
		], (function(e, t, i) {
			return "translate(" + e + ", " + t + ") scale(" + i + ")";
		})),
		children: [jsx(animated.rect, {
			transform: to([r.width, r.height], (function(e, t) {
				return "translate(" + -.5 * e + ", " + -.5 * t + ")";
			})),
			fill: r.color,
			width: r.width,
			height: r.height,
			stroke: r.borderColor,
			strokeWidth: o,
			rx: n,
			ry: n
		}, i.id), s && jsx(animated.text, {
			textAnchor: "middle",
			dominantBaseline: "central",
			fill: r.labelTextColor,
			style: Y({}, h.labels.text, {
				fill: void 0,
				userSelect: "none"
			}),
			children: i.label
		})]
	}));
}));
memo((function(e) {
	var i = e.cell, o = e.borderWidth, n = e.animatedProps, r = e.onMouseEnter, a = e.onMouseMove, l = e.onMouseLeave, c = e.onClick, u = e.enableLabels, s = Vt(), h = useMemo((function() {
		return {
			onMouseEnter: r ? r(i) : void 0,
			onMouseMove: a ? a(i) : void 0,
			onMouseLeave: l ? l(i) : void 0,
			onClick: c ? c(i) : void 0
		};
	}), [
		i,
		r,
		a,
		l,
		c
	]);
	return jsxs(animated.g, Y({
		"data-testid": "cell." + i.id,
		style: { cursor: "pointer" },
		opacity: n.opacity
	}, h, {
		transform: to([n.x, n.y], (function(e, t) {
			return "translate(" + e + ", " + t + ")";
		})),
		children: [jsx(animated.circle, {
			r: to([n.width, n.height], (function(e, t) {
				return Math.min(e, t) / 2;
			})),
			fill: n.color,
			fillOpacity: n.opacity,
			strokeWidth: o,
			stroke: n.borderColor
		}), u && jsx(animated.text, {
			dominantBaseline: "central",
			textAnchor: "middle",
			fill: n.labelTextColor,
			style: Y({}, s.labels.text, { fill: void 0 }),
			children: i.label
		})]
	}));
}));
var ve = function(e, t) {
	var i = t.cell, o = i.x, n = i.y, r = i.width, a = i.height, l = i.color, d = i.borderColor, c = i.opacity, u = i.labelTextColor, s = i.label, h = t.borderWidth, v = t.enableLabels, f = t.theme;
	e.save(), e.globalAlpha = c, e.fillStyle = l, h > 0 && (e.strokeStyle = d, e.lineWidth = h), e.fillRect(o - r / 2, n - a / 2, r, a), h > 0 && e.strokeRect(o - r / 2, n - a / 2, r, a), v && (e.fillStyle = u, e.font = (f.labels.text.fontWeight ? f.labels.text.fontWeight + " " : "") + f.labels.text.fontSize + "px " + f.labels.text.fontFamily, e.textAlign = "center", e.textBaseline = "middle", e.fillText(s, o, n)), e.restore();
};
var fe = function(e, t) {
	var i = t.cell, o = i.x, n = i.y, r = i.width, a = i.height, l = i.color, d = i.borderColor, c = i.opacity, u = i.labelTextColor, s = i.label, h = t.borderWidth, v = t.enableLabels, f = t.theme;
	e.save(), e.globalAlpha = c;
	var g = Math.min(r, a) / 2;
	e.fillStyle = l, h > 0 && (e.strokeStyle = d, e.lineWidth = h), e.beginPath(), e.arc(o, n, g, 0, 2 * Math.PI), e.fill(), h > 0 && e.stroke(), v && (e.fillStyle = u, e.font = (f.labels.text.fontWeight ? f.labels.text.fontWeight + " " : "") + f.labels.text.fontSize + "px " + f.labels.text.fontFamily, e.textAlign = "center", e.textBaseline = "middle", e.fillText(s, o, n)), e.restore();
};
var ge = [
	"theme",
	"isInteractive",
	"animate",
	"motionConfig",
	"renderWrapper"
];
var pe = function(e) {
	var i, r = e.data, c = e.layers, u = void 0 === c ? D.layers : c, s = e.valueFormat, h = e.width, f = e.height, g = e.margin, y = e.xInnerPadding, m = void 0 === y ? D.xInnerPadding : y, w = e.xOuterPadding, O = void 0 === w ? D.xOuterPadding : w, I = e.yInnerPadding, S = void 0 === I ? D.yInnerPadding : I, M = e.yOuterPadding, L = void 0 === M ? D.yOuterPadding : M, R = e.forceSquare, B = void 0 === R ? D.forceSquare : R, q = e.sizeVariation, E$5 = void 0 === q ? D.sizeVariation : q, z = e.renderCell, A = void 0 === z ? D.renderCell : z, F = e.opacity, X = void 0 === F ? D.opacity : F, G = e.activeOpacity, H = void 0 === G ? D.activeOpacity : G, j = e.inactiveOpacity, _ = void 0 === j ? D.inactiveOpacity : j, J = e.borderWidth, K = void 0 === J ? D.borderWidth : J, N = e.borderColor, Q = void 0 === N ? D.borderColor : N, U = e.enableGridX, Z = void 0 === U ? D.enableGridX : U, $ = e.enableGridY, ie = void 0 === $ ? D.enableGridY : $, oe = e.axisTop, ne = void 0 === oe ? D.axisTop : oe, re = e.axisRight, ae = void 0 === re ? D.axisRight : re, le = e.axisBottom, de = void 0 === le ? D.axisBottom : le, ce = e.axisLeft, ue = void 0 === ce ? D.axisLeft : ce, se = e.enableLabels, he = void 0 === se ? D.enableLabels : se, ge = e.label, pe = void 0 === ge ? D.label : ge, be = e.labelTextColor, ye = void 0 === be ? D.labelTextColor : be, me = e.colors, xe = void 0 === me ? D.colors : me, Ce = e.emptyColor, we = void 0 === Ce ? D.emptyColor : Ce, Pe = e.legends, Oe = void 0 === Pe ? D.legends : Pe, Ie = e.annotations, Se = void 0 === Ie ? D.annotations : Ie, Me = e.isInteractive, Te = void 0 === Me ? D.isInteractive : Me, We = e.onClick, Le = e.hoverTarget, ke = void 0 === Le ? D.hoverTarget : Le, Ve = e.tooltip, Re = void 0 === Ve ? D.tooltip : Ve, Be = e.role, qe = e.ariaLabel, Ee = e.ariaLabelledBy, ze = e.ariaDescribedBy, Ae = e.pixelRatio, Fe = void 0 === Ae ? D.pixelRatio : Ae, Xe = useRef(null), Ye = At(h, f, g), Ge = Ye.margin, He = Ye.innerWidth, je = Ye.innerHeight, De = Ye.outerWidth, _e = Ye.outerHeight, Je = ee({
		data: r,
		valueFormat: s,
		width: He,
		height: je,
		xInnerPadding: m,
		xOuterPadding: O,
		yInnerPadding: S,
		yOuterPadding: L,
		forceSquare: B,
		sizeVariation: E$5,
		colors: xe,
		emptyColor: we,
		opacity: X,
		activeOpacity: H,
		inactiveOpacity: _,
		borderColor: Q,
		label: pe,
		labelTextColor: ye,
		hoverTarget: ke
	}), Ke = Je.width, Ne = Je.height, Qe = Je.offsetX, Ue = Je.offsetY, Ze = Je.xScale, $e = Je.yScale, et = Je.cells, tt = Je.colorScale, it = Je.activeCell, ot = Je.setActiveCell, nt = useMemo((function() {
		return Y({}, Ge, {
			top: Ge.top + Ue,
			left: Ge.left + Qe
		});
	}), [
		Ge,
		Qe,
		Ue
	]), at = j$1({ annotations: te(et, Se) });
	i = "function" == typeof A ? A : "circle" === A ? fe : ve;
	var lt = Vt(), dt = useMemo((function() {
		return {
			cells: et,
			activeCell: it,
			setActiveCell: ot
		};
	}), [
		et,
		it,
		ot
	]);
	useEffect((function() {
		if (null !== Xe.current) {
			var e = Xe.current.getContext("2d");
			e && (Xe.current.width = De * Fe, Xe.current.height = _e * Fe, e.scale(Fe, Fe), e.fillStyle = lt.background, e.fillRect(0, 0, De, _e), e.translate(nt.left, nt.top), u.forEach((function(t) {
				"grid" === t ? (e.lineWidth = lt.grid.line.strokeWidth, e.strokeStyle = lt.grid.line.stroke, Z && C$1(e, {
					width: Ke,
					height: Ne,
					scale: Ze,
					axis: "x"
				}), ie && C$1(e, {
					width: Ke,
					height: Ne,
					scale: $e,
					axis: "y"
				})) : "axes" === t ? V(e, {
					xScale: Ze,
					yScale: $e,
					width: Ke,
					height: Ne,
					top: ne,
					right: ae,
					bottom: de,
					left: ue,
					theme: lt
				}) : "cells" === t ? (e.textAlign = "center", e.textBaseline = "middle", et.forEach((function(t) {
					i(e, {
						cell: t,
						borderWidth: K,
						enableLabels: he,
						theme: lt
					});
				}))) : "legends" === t && null !== tt ? Oe.forEach((function(t) {
					E(e, Y({}, t, {
						containerWidth: Ke,
						containerHeight: Ne,
						scale: tt,
						theme: lt
					}));
				})) : "annotations" === t ? J$1(e, {
					annotations: at,
					theme: lt
				}) : "function" == typeof t && t(e, dt);
			})));
		}
	}), [
		Xe,
		Fe,
		De,
		_e,
		Ke,
		Ne,
		nt,
		u,
		dt,
		et,
		i,
		Z,
		ie,
		ne,
		ae,
		de,
		ue,
		Ze,
		$e,
		lt,
		K,
		he,
		tt,
		Oe,
		at
	]);
	var ct = k$1(), ut = ct.showTooltipFromEvent, st = ct.hideTooltip, ht = useCallback((function(e) {
		if (null !== Xe.current) {
			var t = Qi(Xe.current, e), i = t[0], o = t[1], r = et.find((function(e) {
				return Ji(e.x + nt.left - e.width / 2, e.y + nt.top - e.height / 2, e.width, e.height, i, o);
			}));
			void 0 !== r ? (ot(r), ut(createElement(Re, { cell: r }), e)) : (ot(null), st());
		}
	}), [
		Xe,
		et,
		nt,
		ot,
		ut,
		st,
		Re
	]), vt = useCallback((function() {
		ot(null), st();
	}), [ot, st]), ft = useCallback((function(e) {
		null !== it && We?.(it, e);
	}), [it, We]);
	return jsx("canvas", {
		ref: Xe,
		width: De * Fe,
		height: _e * Fe,
		style: {
			width: De,
			height: _e
		},
		onMouseEnter: Te ? ht : void 0,
		onMouseMove: Te ? ht : void 0,
		onMouseLeave: Te ? vt : void 0,
		onClick: Te ? ft : void 0,
		role: Be,
		"aria-label": qe,
		"aria-labelledby": Ee,
		"aria-describedby": ze
	});
};
var be = function(e) {
	var t = e.theme, i = e.isInteractive, o = void 0 === i ? D.isInteractive : i, n = e.animate, r = void 0 === n ? D.animate : n, a = e.motionConfig, l = void 0 === a ? D.motionConfig : a, d = e.renderWrapper, c = G(e, ge);
	return jsx(Zt, {
		isInteractive: o,
		animate: r,
		motionConfig: l,
		theme: t,
		renderWrapper: d,
		children: jsx(pe, Y({ isInteractive: o }, c))
	});
};
//#endregion
//#region src/components/charts/heatmap/config/axis.ts
var defaultCanvasAxisTop = (legend) => ({
	format: () => "",
	legend,
	legendOffset: -20,
	legendPosition: "middle",
	tickSize: 0
});
var defaultCanvasAxisLeft = (legend) => ({
	format: () => "",
	legend,
	legendOffset: -20,
	legendPosition: "middle",
	tickSize: 0
});
var defaultCanvasAxisBottom = (legend) => ({
	format: () => "",
	legend,
	legendOffset: 20,
	legendPosition: "middle",
	tickSize: 0
});
var defaultCanvasAxisRight = (legend) => ({
	format: () => "",
	legend,
	legendOffset: 20,
	legendPosition: "middle",
	tickSize: 0
});
var getAxis = (axis, defaultAxisGetter) => {
	if (!axis) return null;
	if (typeof axis === "string") return defaultAxisGetter(axis);
	return axis;
};
//#endregion
//#region src/components/charts/heatmap/config/margin.ts
var defaultMargin = {
	top: 36,
	right: 36,
	bottom: 36,
	left: 36
};
//#endregion
//#region src/components/charts/heatmap/config/theme.ts
var theme = {
	axis: {
		legend: { text: {
			fontSize: 18,
			fontWeight: 500
		} },
		ticks: { line: { strokeWidth: 0 } }
	},
	annotations: {
		text: {
			fontSize: 0,
			fill: "transparent",
			outlineWidth: 0,
			outlineColor: "transparent",
			outlineOpacity: 0
		},
		link: {
			stroke: "transparent",
			strokeWidth: 0,
			outlineWidth: 0,
			outlineColor: "transparent",
			outlineOpacity: 0
		},
		outline: {
			stroke: "#ffffff",
			strokeWidth: 3,
			outlineWidth: 3,
			outlineColor: "#000000",
			outlineOpacity: .15
		},
		symbol: {
			fill: "transparent",
			outlineWidth: 0,
			outlineColor: "transparent",
			outlineOpacity: 0
		}
	}
};
//#endregion
//#region src/components/charts/heatmap/config/tile.ts
var defaultTileConfig = {
	borderWidth: 0,
	emptyColor: colors.gray[200],
	enableLabels: false
};
//#endregion
//#region src/components/charts/heatmap/utils/dataManipulation.utils.ts
var generateData = ({ from, generateValue, normalizeValue = (value) => value, xIdGenerator, xRange, xSteps, yIdGenerator, yRange, ySteps }) => {
	const yMin = Math.min(...yRange);
	const yMax = Math.max(...yRange);
	const xMin = Math.min(...xRange);
	const xMax = Math.max(...xRange);
	const yTotalSteps = Math.floor((yMax - yMin) / ySteps) + 1;
	const xTotalSteps = Math.floor((xMax - xMin) / xSteps) + 1;
	const stepCounter = from === "bottom_left" ? yTotalSteps - 1 : 0;
	return Array.from(Array(yTotalSteps).keys()).map((yIndex) => {
		const yId = yIdGenerator?.(yIndex) ?? `y${ySteps * Math.abs(stepCounter - yIndex) + yMin}`;
		return {
			id: yId,
			data: Array.from(Array(xTotalSteps).keys()).map((xIndex) => {
				const xId = xIdGenerator?.(xIndex) ?? `x${xSteps * xIndex + xMin}`;
				const value = generateValue(xId, yId);
				return {
					x: xId,
					y: value,
					normalizedValue: normalizeValue(value)
				};
			})
		};
	});
};
var getSelectedRow = (cell, data) => {
	return (data.find((datum) => datum.id === cell.serieId)?.data).map((datum) => ({
		id: datum.x,
		value: datum.y,
		normalizedValue: datum.normalizedValue
	}));
};
var getSelectedColumn = ({ cell, data, from }) => {
	const selectedColumn = data.map((datum) => ({
		y: datum.id,
		x: datum.data.filter((xDatum) => xDatum.x === cell.data.x)
	})).map((datum) => {
		const [xPoint] = datum.x;
		return {
			id: datum.y,
			value: xPoint.y,
			normalizedValue: xPoint.normalizedValue
		};
	});
	return from === "bottom_left" ? selectedColumn.reverse() : selectedColumn;
};
//#endregion
//#region src/components/charts/heatmap/utils/defaultGetColor.utils.ts
var defaultGradient = [
	[[
		12,
		35,
		62
	], 0],
	[[
		44,
		103,
		171
	], 20],
	[[
		6,
		171,
		171
	], 45],
	[[
		105,
		187,
		80
	], 60],
	[[
		150,
		224,
		128
	], 72],
	[[
		245,
		221,
		142
	], 88],
	[[
		255,
		207,
		51
	], 100]
];
var getRgbTileColor = (selectedColorStop, gradient = defaultGradient) => {
	if (selectedColorStop !== null && selectedColorStop !== void 0) return `rgb(${pickRgbFromGradient(selectedColorStop, gradient).join()})`;
	return colors.gray[200];
};
//#endregion
//#region src/components/charts/heatmap/canvas/customTileRender.ts
var generateSelectedStyle = (ctx, { color, height, width, x, y }) => {
	const xPosition = x - width / 2;
	const yPosition = y - height / 2;
	ctx.shadowColor = "#000000";
	ctx.shadowBlur = 8;
	ctx.shadowOffsetX = 1;
	ctx.shadowOffsetY = 1;
	ctx.fillStyle = color;
	ctx.fillRect(xPosition, yPosition, width, height);
	ctx.lineWidth = 2;
	ctx.strokeStyle = "#FFFFFF";
	ctx.strokeRect(xPosition, yPosition, width, height);
};
var customTileRender = ({ canvasEl, hoverTileEvent, margin, onHover, selectedTile }) => (ctx, cellRenderProps) => {
	const { cell, enableLabels, theme } = cellRenderProps;
	const { labels: { text } } = theme;
	const { left = 0, top = 0 } = margin;
	const { color, height, id, label, labelTextColor, opacity, width, x, y } = cell;
	ctx.save();
	ctx.globalAlpha = opacity;
	if (id === selectedTile) generateSelectedStyle(ctx, cell);
	else {
		if (hoverTileEvent && canvasEl) {
			const [offsetX, offsetY] = Qi(canvasEl, hoverTileEvent);
			if (Ji(x + left - width / 2, y + top - height / 2, width, height, offsetX, offsetY)) {
				generateSelectedStyle(ctx, cell);
				onHover?.(cell, hoverTileEvent);
			}
		}
		ctx.globalCompositeOperation = "destination-over";
		ctx.fillStyle = color;
		ctx.fillRect(x - width / 2, y - height / 2, width, height);
	}
	if (enableLabels) {
		ctx.fillStyle = labelTextColor;
		ctx.font = `${text.fontWeight ? `${text.fontWeight} ` : ""}${text.fontSize}px ${text.fontFamily}`;
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.fillText(label, x, y);
	}
	ctx.restore();
};
//#endregion
//#region src/components/charts/heatmap/canvas/InnerHeatmapCanvas.tsx
var InnerHeatmapCanvas = ({ axisBottom, axisLeft, axisRight, axisTop, colors, data, forceSquare, from, gradient = defaultGradient, height, initialSelectedTile = "", margin = defaultMargin, onChangeSelectedTile, onMouseEnter, onMouseLeave, onSelect, selectedTile, theme: theme$1 = theme, tileConfig = defaultTileConfig, tooltip, width }) => {
	const { selectedItem: innerSelectedTile, setSelectedItem: handleOnSelect } = useSelectable(initialSelectedTile);
	const { selectedItem: hoverTileEvent, setSelectedItem: handleOnHover } = useSelectable(null);
	const hoverTimeoutRef = useRef(null);
	const heatmapContainerRef = useRef(null);
	const lastTileHoveredRef = useRef(null);
	const handleOnMouseMove = useCallback((event) => {
		if (hoverTimeoutRef.current && !lastTileHoveredRef.current) clearTimeout(hoverTimeoutRef.current);
		hoverTimeoutRef.current = setTimeout(() => {
			handleOnHover(event);
		}, lastTileHoveredRef.current ? 0 : 200);
	}, [handleOnHover]);
	const handleOnMouseLeave = useCallback((event) => {
		if (lastTileHoveredRef.current) onMouseLeave?.(event);
		lastTileHoveredRef.current = null;
		if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
		handleOnHover(null);
	}, [handleOnHover]);
	const getCanvasElement = useMemo(() => () => heatmapContainerRef.current?.getElementsByTagName("canvas")[0], []);
	useEventListener({
		eventName: "mousemove",
		handler: handleOnMouseMove,
		element: getCanvasElement
	});
	useEventListener({
		eventName: "mouseleave",
		handler: handleOnMouseLeave,
		element: getCanvasElement
	});
	const handleSelectTile = (cell, event) => {
		if (onChangeSelectedTile) {
			onChangeSelectedTile(cell, {
				selectedRow: getSelectedRow(cell, data),
				selectedColumn: getSelectedColumn({
					cell,
					data,
					from
				})
			}, event);
			return;
		}
		handleOnSelect(cell.id);
		onSelect?.(cell, {
			selectedRow: getSelectedRow(cell, data),
			selectedColumn: getSelectedColumn({
				cell,
				data,
				from
			})
		}, event);
	};
	const handleOnMouseEnterTile = (cell, event) => {
		onMouseEnter?.(cell, {
			selectedRow: getSelectedRow(cell, data),
			selectedColumn: getSelectedColumn({
				cell,
				data,
				from
			})
		}, event);
	};
	const onHover = (cell, event) => {
		if (lastTileHoveredRef.current?.id !== cell.id) handleOnMouseEnterTile(cell, event);
		lastTileHoveredRef.current = cell;
	};
	const getColors = (cell) => getRgbTileColor(cell.data.normalizedValue, gradient);
	return /* @__PURE__ */ React.createElement("div", { ref: heatmapContainerRef }, /* @__PURE__ */ React.createElement(be, {
		height,
		width,
		animate: false,
		axisBottom: getAxis(axisBottom, defaultCanvasAxisBottom),
		axisLeft: getAxis(axisLeft, defaultCanvasAxisLeft),
		axisRight: getAxis(axisRight, defaultCanvasAxisRight),
		axisTop: getAxis(axisTop, defaultCanvasAxisTop),
		borderWidth: tileConfig.borderWidth,
		forceSquare,
		renderCell: customTileRender({
			canvasEl: heatmapContainerRef.current?.getElementsByTagName("canvas")[0],
			hoverTileEvent,
			onHover,
			margin,
			selectedTile: selectedTile ?? innerSelectedTile
		}),
		colors: colors || getColors,
		data,
		emptyColor: tileConfig.emptyColor,
		enableLabels: tileConfig.enableLabels,
		layers: [
			"grid",
			"axes",
			"cells"
		],
		margin,
		onClick: handleSelectTile,
		theme: theme$1,
		tooltip
	}));
};
//#endregion
//#region src/components/charts/heatmap/Heatmap.tsx
var Heatmap = ({ from = "bottom_left", generateValue, normalizeValue, xRange, xSteps, yRange, ySteps, ...restProps }) => {
	const data = generateData({
		from,
		generateValue,
		normalizeValue,
		xRange,
		xSteps,
		yRange,
		ySteps
	});
	return /* @__PURE__ */ React.createElement(InnerHeatmapCanvas, {
		data,
		from,
		...restProps
	});
};
//#endregion
//#region src/components/charts/heatmap/styled.ts
var StyledDiv$1 = import_dist.default.div`py-4 px-6 bg-gray-500 opacity-90 shadow-md rounded-lg`;
//#endregion
//#region src/components/charts/heatmap/HeatmapTooltip.tsx
var HeatmapTooltip = ({ children, className }) => /* @__PURE__ */ React.createElement(StyledDiv$1, { className }, children);
//#endregion
//#region src/components/container/styled.ts
var StyledContainer$4 = import_dist.default.div`
    ${({ $breakpoints }) => $breakpoints ? "container" : "max-w-7xl"}
    mx-auto py-6 sm:px-6 lg:px-8
`;
//#endregion
//#region src/components/container/Container.tsx
var Container = ({ breakpoints, children, className }) => /* @__PURE__ */ React.createElement(StyledContainer$4, {
	$breakpoints: breakpoints,
	className
}, children);
var ContainerMemo = memo(Container);
//#endregion
//#region src/components/divider/styled.ts
var StyledContainer$3 = import_dist.default.div`mt-6 relative`;
var StyledDividerContainer = import_dist.default.div`
  absolute
  inset-0
  flex
  items-center
`;
var StyledDivider = import_dist.default.div`
  w-full
  border-t
  border-gray-300
`;
var StyledChildrenContainer$1 = import_dist.default.div`
  relative
  flex
  justify-center
  text-sm
`;
var StyledChildrenSpan = import_dist.default.span`
  px-2
  bg-white
  text-gray-500
`;
//#endregion
//#region src/components/divider/Divider.tsx
var Divider = ({ children, className }) => /* @__PURE__ */ React.createElement(StyledContainer$3, { className }, /* @__PURE__ */ React.createElement(StyledDividerContainer, {
	"aria-hidden": "true",
	"data-testid": "divider"
}, /* @__PURE__ */ React.createElement(StyledDivider, null)), children ? /* @__PURE__ */ React.createElement(StyledChildrenContainer$1, null, /* @__PURE__ */ React.createElement(StyledChildrenSpan, null, children)) : null);
var DividerMemo = memo(Divider);
//#endregion
//#region src/components/flyout-menu/hooks/useControlledFlyoutMenu.tsx
var useControlledFlyoutMenu = ({ initialIsOpen = false } = {}) => {
	const [isOpen, setIsOpen] = useState(initialIsOpen);
	const toggle = () => setIsOpen((prevState) => !prevState);
	return {
		isOpen,
		setIsOpen,
		toggle
	};
};
//#endregion
//#region src/components/flyout-menu/FlyoutContent.tsx
var FlyoutContent = ({ children, className, open }) => /* @__PURE__ */ React.createElement(We$1, {
	as: Fragment,
	enter: "transform transition ease-in-out duration-700",
	enterFrom: "-translate-y-full",
	enterTo: "translate-y-0",
	leave: "transform transition ease-in-out duration-700",
	leaveFrom: "translate-y-0",
	leaveTo: "-translate-y-full",
	show: open
}, /* @__PURE__ */ React.createElement(Tt$1.Panel, {
	static: true,
	className: (0, import_classnames.default)("absolute z-header inset-x-0 transform shadow-lg", className)
}, children));
//#endregion
//#region src/components/flyout-menu/FlyoutToggler.tsx
var FlyoutToggler = ({ children, className }) => /* @__PURE__ */ React.createElement(Tt$1.Button, { className }, children);
//#endregion
//#region src/components/flyout-menu/FlyoutMenu.tsx
var FlyoutMenu = ({ children, className }) => /* @__PURE__ */ React.createElement(Tt$1, { className: (0, import_classnames.default)("relative", className) }, ({ close, open }) => /* @__PURE__ */ React.createElement(React.Fragment, null, children({
	close,
	FlyoutContent,
	FlyoutToggler,
	open
})));
//#endregion
//#region src/components/layouts/left-column/styled.ts
var COLUMN_VARIANTS = {
	base: "",
	gray: "bg-gray-300"
};
var VISIBILITY_VARIANTS = {
	hiddenOnMinWidth: "hidden lg:flex",
	alwaysOnDisplay: "flex"
};
var StyledLeftColumnLayout = import_dist.default.div`
  min-h-full
  flex
`;
var StyledColumn = import_dist.default.div`
  ${({ $columnVariant }) => COLUMN_VARIANTS[$columnVariant]}
  ${({ $visibilityVariant }) => VISIBILITY_VARIANTS[$visibilityVariant]}
  flex-col
`;
var StyledMainContent = import_dist.default.div`
  flex
  flex-col
  grow
`;
var StyledHeader = import_dist.default.div`
  pt-6
  px-6
  border-b
  border-gray-200
`;
//#endregion
//#region src/components/layouts/left-column/LeftColumnLayout.tsx
var LEFT_COLUMN_PADDING = 48;
var LEFT_COLUMN_BREAKPOINT = 896;
var DEFAULT_COLUMN_WIDTH = 368;
var LeftColumnLayout = ({ children, className, columnContent, columnVariant = "normal", headerContent, leftColumnVisibility = "hiddenOnMinWidth", leftColumnWidth = DEFAULT_COLUMN_WIDTH }) => {
	const [ref, { width }] = useElementSize();
	const childrenWidth = width < LEFT_COLUMN_BREAKPOINT ? width - LEFT_COLUMN_PADDING : width - LEFT_COLUMN_PADDING - leftColumnWidth;
	return /* @__PURE__ */ React.createElement(Stack, {
		direction: "column",
		className
	}, headerContent && /* @__PURE__ */ React.createElement(StyledHeader, null, headerContent), /* @__PURE__ */ React.createElement(StyledLeftColumnLayout, { ref }, /* @__PURE__ */ React.createElement(StyledColumn, {
		$columnVariant: columnVariant,
		$visibilityVariant: leftColumnVisibility,
		style: { width: leftColumnWidth }
	}, columnContent), /* @__PURE__ */ React.createElement(StyledMainContent, null, React.cloneElement(children, { width: childrenWidth }))));
};
var LeftColumnLayoutMemo = memo(LeftColumnLayout);
//#endregion
//#region src/components/layouts/page-header/page-header.styled.ts
var StyledContainer$2 = import_dist.default.div`
  flex
  space-x-4
  ${({ $border }) => $border ? "border-b border-gray-300 pb-6" : ""}
`;
var StyledTextContainer = import_dist.default.div`
  flex
  flex-col
  space-y-2
  sm:flex-auto
`;
var StyledTrailingContent$1 = import_dist.default.div`
`;
//#endregion
//#region src/components/layouts/page-header/PageSubtitle.tsx
var PageSubtitle = ({ children, ...props }) => /* @__PURE__ */ React.createElement(Typography, {
	as: "p",
	color: colors.gray[500],
	fontSize: "sm",
	fontWeight: "normal",
	lineHeight: 5,
	...props
}, children);
var PageSubtitleMemo = React.memo(PageSubtitle);
//#endregion
//#region src/components/layouts/page-header/PageTitle.tsx
var PageTitle = ({ children, ...props }) => /* @__PURE__ */ React.createElement(Typography, {
	as: "h1",
	fontSize: "3xl",
	fontWeight: "semibold",
	lineHeight: 9,
	...props
}, children);
var PageTitleMemo = React.memo(PageTitle);
//#endregion
//#region src/components/layouts/page-header/PageHeader.tsx
var PageHeader = ({ border, className, subtitle, title, trailingContent }) => /* @__PURE__ */ React.createElement(StyledContainer$2, {
	className,
	$border: border
}, /* @__PURE__ */ React.createElement(StyledTextContainer, null, typeof title === "object" ? title : /* @__PURE__ */ React.createElement(PageTitle, null, title), typeof subtitle === "object" ? subtitle : subtitle ? /* @__PURE__ */ React.createElement(PageSubtitle, null, subtitle) : null), trailingContent ? /* @__PURE__ */ React.createElement(StyledTrailingContent$1, null, trailingContent) : null);
var PageHeaderMemo = memo(PageHeader);
//#endregion
//#region src/components/layouts/split-screen/styled.ts
var SplitScreenContainer = import_dist.default.div`
  min-h-full
  flex
`;
var SplitScreenLeftSide = import_dist.default.div`
${({ $collapsibleSide }) => $collapsibleSide === "left" ? "hidden lg:block" : "flex flex-1 flex-col lg:flex-none"}
  h-full
  overflow-auto
`;
var SplitScreenRightSide = import_dist.default.div`
  ${({ $collapsibleSide }) => $collapsibleSide === "right" ? "hidden lg:block" : ""}
  relative
  w-0
  flex-1
`;
//#endregion
//#region src/components/layouts/split-screen/SplitScreen.tsx
var SplitScreen = ({ className, collapsibleSide = "right", leftSide, rightSide }) => /* @__PURE__ */ React.createElement(SplitScreenContainer, { className }, /* @__PURE__ */ React.createElement(SplitScreenLeftSide, { $collapsibleSide: collapsibleSide }, leftSide), /* @__PURE__ */ React.createElement(SplitScreenRightSide, { $collapsibleSide: collapsibleSide }, rightSide));
var SplitScreenMemo = memo(SplitScreen);
//#endregion
//#region src/components/layouts/table-container/table-container.styled.ts
var StyledContainer$1 = import_dist.default.div`
  flex
  flex-col
  h-full
  w-full
  overflow-hidden
`;
var StyledContentContainer = import_dist.default.div`
  inline-block
  min-w-full
  align-middle
  h-full
`;
var StyledChildrenContainer = import_dist.default.div`
  shadow
  ring-1
  ring-black
  ring-opacity-5
  h-full
`;
//#endregion
//#region src/components/layouts/table-container/TableContainer.tsx
var TableContainer = ({ children, className, height }) => /* @__PURE__ */ React.createElement(StyledContainer$1, { className }, /* @__PURE__ */ React.createElement(StyledContentContainer, null, /* @__PURE__ */ React.createElement(StyledChildrenContainer, { style: { height } }, children)));
var TableContainerMemo = memo(TableContainer);
//#endregion
//#region src/components/layouts/two-column-layout/two-column-layout.styled.ts
var StyledTwoColumnLayoutWrapper = import_dist.default.div`
  w-full
  max-w-7xl
  last:mb-10
`;
var StyledTwoColumnLayout = import_dist.default.div`
  ${({ $grid }) => $grid ? "lg:grid lg:grid-cols-3 lg:gap-6" : "flex h-full"}
`;
var StyledTwoColumnLayoutLeftColumn = import_dist.default.div`
  lg:col-span-1
`;
var StyledTwoColumnLayoutRightColumn = import_dist.default.div`
  lg:col-span-2
  ${({ $grid }) => $grid ? "" : "grow"}
  ${({ $disabled }) => $disabled ? "opacity-30" : ""}
`;
//#endregion
//#region src/components/layouts/two-column-layout/TwoColumnLayout.tsx
var TwoColumnLayout = ({ children, className, disabled, grid = true, leftColumn }) => /* @__PURE__ */ React.createElement(StyledTwoColumnLayoutWrapper, { className }, /* @__PURE__ */ React.createElement(StyledTwoColumnLayout, { $grid: grid }, /* @__PURE__ */ React.createElement(StyledTwoColumnLayoutLeftColumn, null, leftColumn), /* @__PURE__ */ React.createElement(StyledTwoColumnLayoutRightColumn, {
	$grid: grid,
	$disabled: disabled
}, children)));
var TwoColumnLayoutMemo = memo(TwoColumnLayout);
//#endregion
//#region src/components/loading/styled.ts
var StyledDiv = import_dist.default.div`
  flex
  bg-gray-100
  w-full
  h-6
  overflow-hidden
`;
var StyledSpan = import_dist.default.span`
  -translate-x-full
  flex-1
  inline-block
  bg-gradient-to-r
  from-[#FFFFFF00]
  via-[#FFFFFF99]
  to-[#FFFFFF00]
  animate-shimmer
`;
//#endregion
//#region src/components/loading/Skeleton.tsx
var Skeleton = ({ className, height, rounded, width }) => /* @__PURE__ */ React.createElement(StyledDiv, { className: (0, import_classnames.default)(getHeight(height), getWidth(width), rounded ? "rounded" : "", className) }, /* @__PURE__ */ React.createElement(StyledSpan, null));
//#endregion
//#region src/assets/icons/exclamation.svg
var SvgExclamation = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	strokeWidth: 1.5,
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			d: "M12 19.5C11.7929 19.5 11.625 19.3321 11.625 19.125C11.625 18.9179 11.7929 18.75 12 18.75"
		}),
		/* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			d: "M12 19.5C12.2071 19.5 12.375 19.3321 12.375 19.125C12.375 18.9179 12.2071 18.75 12 18.75"
		}),
		/* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeMiterlimit: 10,
			d: "M12 15.75V8.25"
		}),
		/* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M13.621 1.76001C13.4722 1.45702 13.2414 1.20181 12.9549 1.02333C12.6684 0.844851 12.3376 0.750244 12 0.750244C11.6624 0.750244 11.3316 0.844851 11.0451 1.02333C10.7586 1.20181 10.5278 1.45702 10.379 1.76001L0.90601 21.058C0.79198 21.29 0.738946 21.5472 0.751916 21.8053C0.764886 22.0635 0.843432 22.3141 0.980137 22.5334C1.11684 22.7528 1.3072 22.9337 1.53324 23.0591C1.75927 23.1845 2.01353 23.2502 2.27201 23.25H21.728C21.9865 23.2502 22.2407 23.1845 22.4668 23.0591C22.6928 22.9337 22.8832 22.7528 23.0199 22.5334C23.1566 22.3141 23.2351 22.0635 23.2481 21.8053C23.2611 21.5472 23.208 21.29 23.094 21.058L13.621 1.76001Z"
		})
	]
});
var ForwardRef$9 = forwardRef(SvgExclamation);
var Memo$9 = memo(ForwardRef$9);
//#endregion
//#region src/components/modal/modal.styled.ts
var StyledDialogPanel$1 = (0, import_dist.default)(mt$1.Panel)`
  relative
  bg-white
  rounded-lg
  px-4
  pt-5
  pb-4
  text-left
  overflow-hidden
  shadow-xl
  transform
  transition-all
  sm:my-8
  sm:p-6
`;
var StyledTransitionAndPanelContainer = import_dist.default.div`
  flex
  items-end
  sm:items-center
  justify-center
  min-h-full
  p-4
  text-center
  sm:p-0
`;
var StyledAlertLayoutContainer = import_dist.default.div`
  sm:flex
  sm:items-start
`;
var StyledAlertLayoutIconContainer = import_dist.default.div`
  mx-auto
  flex-shrink-0
  flex
  items-center
  justify-center
  h-12
  w-12
  rounded-full
  bg-rsbry-100
  sm:mx-0
  sm:h-10
  sm:w-10
`;
var StyledAlertLayoutContent = import_dist.default.div`
  text-center sm:text-left
  mt-3 sm:mt-0 sm:ml-4
`;
var StyledAlertLayoutCopyParagraph = import_dist.default.p`
  text-sm
  text-gray-500
`;
var StyledAlertLayoutTrailingContent = import_dist.default.div`
  flex
  justify-end
`;
var StyledCopyAndChildrenContainer = import_dist.default.div`
  my-2
`;
var StyledModalActions = import_dist.default.div`
${({ $hasTopBorder }) => $hasTopBorder ? "border-t" : ""}
  grid
  grid-cols-2
  gap-2
  items-start
  border-gray-200
  pt-5
`;
var TextWrapper = import_dist.default.div`
  my-2
`;
//#endregion
//#region src/components/modal/AlertModalLayout.tsx
var AlertModalLayout = ({ children, copy, title, trailingContent }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlertLayoutContainer, null, /* @__PURE__ */ React.createElement(StyledAlertLayoutIconContainer, null, /* @__PURE__ */ React.createElement(Memo$9, {
	className: "h-5 w-5 text-rsbry-600",
	"aria-hidden": "true"
})), /* @__PURE__ */ React.createElement(StyledAlertLayoutContent, null, /* @__PURE__ */ React.createElement(mt$1.Title, {
	as: "h3",
	className: "text-lg leading-6 font-medium text-gray-900"
}, title), /* @__PURE__ */ React.createElement(StyledCopyAndChildrenContainer, null, /* @__PURE__ */ React.createElement(StyledAlertLayoutCopyParagraph, null, copy), /* @__PURE__ */ React.createElement(StyledCopyAndChildrenContainer, null, children)))), /* @__PURE__ */ React.createElement(StyledAlertLayoutTrailingContent, null, trailingContent));
var AlertModalLayoutMemo = memo(AlertModalLayout);
//#endregion
//#region src/components/modal/hooks/useModal.ts
var useModal = ({ initialIsOpen = false } = {}) => {
	const [isOpen, setIsOpen] = useState(initialIsOpen);
	const toggle = () => setIsOpen((prevState) => !prevState);
	return {
		isOpen,
		setIsOpen,
		toggle
	};
};
//#endregion
//#region src/components/modal/Modal.tsx
var Modal = ({ children, className, isOpen, setIsOpen = () => {}, topMargin, leftMargin }) => {
	const commonStyle = {
		marginTop: topMargin,
		marginLeft: leftMargin
	};
	return /* @__PURE__ */ React.createElement(We$1.Root, {
		show: isOpen,
		as: Fragment
	}, /* @__PURE__ */ React.createElement(mt$1, {
		as: "div",
		className: "relative z-modal",
		onClose: setIsOpen
	}, /* @__PURE__ */ React.createElement(We$1.Child, {
		as: Fragment,
		enter: "ease-out duration-300",
		enterFrom: "opacity-0",
		enterTo: "opacity-100",
		leave: "ease-in duration-200",
		leaveFrom: "opacity-100",
		leaveTo: "opacity-0"
	}, /* @__PURE__ */ React.createElement("div", {
		style: commonStyle,
		className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
	})), /* @__PURE__ */ React.createElement("div", {
		style: commonStyle,
		className: "fixed z-10 inset-0 overflow-y-auto"
	}, /* @__PURE__ */ React.createElement(StyledTransitionAndPanelContainer, null, /* @__PURE__ */ React.createElement(We$1.Child, {
		as: Fragment,
		enter: "ease-out duration-300",
		enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
		enterTo: "opacity-100 translate-y-0 sm:scale-100",
		leave: "ease-in duration-200",
		leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
		leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
	}, /* @__PURE__ */ React.createElement(StyledDialogPanel$1, { className: (0, import_classnames.default)("modal-children-panel", className) }, children))))));
};
var ModalMemo = memo(Modal);
//#endregion
//#region src/components/modal/ModalActions.tsx
var ModalActions = ({ children, className, hasTopBorder = true }) => /* @__PURE__ */ React.createElement(StyledModalActions, {
	$hasTopBorder: hasTopBorder,
	className
}, children);
var ModalActionsMemo = memo(ModalActions);
//#endregion
//#region src/components/modal/ModalHeader.tsx
var ModalHeader = ({ className, copy, alert, icon, iconBgColor = colors.green[100], subtitle, title }) => /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement("div", {
	style: { backgroundColor: iconBgColor },
	className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full"
}, icon), /* @__PURE__ */ React.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React.createElement(Typography, {
	as: "h3",
	fontSize: "lg",
	fontWeight: "medium"
}, title), subtitle && /* @__PURE__ */ React.createElement(TextWrapper, null, /* @__PURE__ */ React.createElement(Typography, {
	as: "div",
	fontWeight: "medium"
}, subtitle)), copy ? /* @__PURE__ */ React.createElement(TextWrapper, null, /* @__PURE__ */ React.createElement(Typography, {
	as: "div",
	fontSize: "sm",
	className: "text-gray-500"
}, copy)) : null, alert ? /* @__PURE__ */ React.createElement("div", { className: "m-2" }, alert) : null));
var ModalHeaderMemo = memo(ModalHeader);
//#endregion
//#region src/components/navigation-items/top-nav-bar-selector/hooks/useTopNavBarSelector.ts
var useTopNavBarSelector = ({ initialIsOpen = false } = {}) => {
	const [isOpen, setIsOpen] = useState(initialIsOpen);
	const toggle = () => setIsOpen((prevState) => !prevState);
	return {
		isOpen,
		setIsOpen,
		toggle
	};
};
//#endregion
//#region src/assets/icons/chevron-down.svg
var SvgChevronDown = (props, ref) => /* @__PURE__ */ jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 48 48",
	xmlSpace: "preserve",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("g", {
		transform: "matrix(2,0,0,2,0,0)",
		children: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			className: "st0",
			d: "M12,19.5c-0.7,0-1.3-0.3-1.7-0.8L0.4,7.6C-0.2,6.8-0.1,5.6,0.7,5c0.8-0.6,1.9-0.6,2.5,0.2l8.6,9.8 c0.1,0.1,0.2,0.1,0.4,0c0,0,0,0,0,0l8.6-9.8c0.7-0.8,1.8-0.9,2.6-0.2s0.9,1.8,0.2,2.6c0,0,0,0-0.1,0.1l-9.8,11.1 C13.3,19.2,12.6,19.5,12,19.5z"
		})
	})
});
var ForwardRef$8 = forwardRef(SvgChevronDown);
var Memo$8 = memo(ForwardRef$8);
//#endregion
//#region src/components/navigation-items/top-nav-bar-selector/styled.ts
var StyledButton = import_dist.default.button`
  transition duration-300 group
  flex flex-col justify-center items-center
  text-gray-900 h-full rounded-t-md
  px-3 py-2 relative min-h-[60px]
  hover:bg-gray-300
  ${({ $disabled }) => $disabled ? "hover:bg-gray-200 cursor-not-allowed" : ""}
  ${({ $open }) => $open ? "bg-gray-200" : "bg-white"}
`;
var StyledSelectorContainer = import_dist.default.div`
  flex items-center gap-x-2
`;
var StyledSelectorContent = import_dist.default.div`
  ${({ $disabled }) => $disabled ? "" : "w-full"}
`;
var StyledHintSpan = import_dist.default.span`
  text-xs leading-none font-normal text-gray-500
`;
var StyledChevronDownIcon = (0, import_dist.default)(Memo$8)`
  w-5 h-5 p-1.5 text-gray-400
  transition duration-300 group-hover:scale-[1.5]
`;
var StyledCloseIcon = (0, import_dist.default)(Memo$10)`
  transition duration-300
  w-3 h-3 p-1
  rounded-full box-content
  text-white bg-gray-400
  hover:bg-primary-600
  ${({ $disabled }) => $disabled ? "hover:bg-gray-200 bg-gray-200 hover:text-black text-black cursor-not-allowed" : "scale-[0.85] group-hover:scale-100 hover:rotate-90"}
`;
//#endregion
//#region src/components/navigation-items/top-nav-bar-selector/TopNavBarSelector.tsx
var TopNavBarSelector = ({ children, className, disabled, id, onClick, open = false }) => /* @__PURE__ */ React.createElement(StyledButton, {
	id,
	$disabled: disabled,
	$open: open,
	className,
	disabled,
	onClick
}, /* @__PURE__ */ React.createElement(StyledSelectorContainer, null, /* @__PURE__ */ React.createElement(StyledSelectorContent, { $disabled: disabled }, children), !disabled && /* @__PURE__ */ React.createElement(React.Fragment, null, !open ? /* @__PURE__ */ React.createElement(StyledChevronDownIcon, null) : /* @__PURE__ */ React.createElement(StyledCloseIcon, { $disabled: disabled }))), open && !disabled ? /* @__PURE__ */ React.createElement(StyledHintSpan, null, "Click to close") : null);
var TopNavBarSelectorMemo = memo(TopNavBarSelector);
//#endregion
//#region src/components/popover/styled.ts
var StyledPopover = (0, import_dist.default)(Popover$1)`
  bg-white
  z-overlay
  rounded-lg
  py-4
  px-6
  overflow-visible
  shadow-lg
`;
//#endregion
//#region src/components/popover/Popover.tsx
var Popover = ({ children, className, label, onMouseEnter, onMouseLeave, state }) => /* @__PURE__ */ React.createElement(StyledPopover, {
	"aria-label": label,
	state,
	className,
	onMouseEnter,
	onMouseLeave
}, children);
var PopoverMemo = memo(Popover);
//#endregion
//#region src/components/scalable-container/styled.ts
var ForeignObjectContent = import_dist.default.div`
  transparent
`;
//#endregion
//#region src/components/scalable-container/ScalableContainer.tsx
var ScalableContainer = ({ children, className, height, width }) => /* @__PURE__ */ React.createElement("svg", {
	className,
	viewBox: `0 0 ${width} ${height}`,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React.createElement("foreignObject", {
	width: "100%",
	height: "100%"
}, /* @__PURE__ */ React.createElement(ForeignObjectContent, { xmlns: "http://www.w3.org/1999/xhtml" }, children)));
var ScalableContainerMemo = memo(ScalableContainer);
//#endregion
//#region src/components/tabs/styled.ts
var StyledTabWrapper = import_dist.default.div`
  border-b
  border-gray-300
  text-primary-600
`;
var StyledBaseTabList = (0, import_dist.default)(TabList)`
  -mb-px
  flex
  ${({ $isFullWidth }) => $isFullWidth ? "" : "space-x-8"}
`;
var StyledBaseTab = (0, import_dist.default)(Tab)`
  ${({ $isFullWidth }) => $isFullWidth ? "grow" : ""}
  ${({ $current }) => $current ? "border-current" : "border-transparent hover:border-gray-400"}
  whitespace-nowrap
  py-4
  px-1
  border-b-2
  transition-all duration-200
  group
`;
var StyledBaseTabChildContainer = import_dist.default.div`
  ${({ $current }) => $current ? "scale-100 text-current" : "scale-95 text-gray-500 hover:text-gray-700"}
  transition-transform duration-300
  group-hover:scale-100
  font-medium
  text-sm
`;
var StyledBaseTabPanel = (0, import_dist.default)(TabPanel)`
  mt-4
`;
var StyledBaseTabPanelContainer = import_dist.default.div`
  grid
  grid-cols-1
  grid-rows-1
  ${({ $fullHeight }) => $fullHeight ? "h-full" : ""}
`;
import_dist.default.ul`
  -mb-px
  flex
  ${({ $isFullWidth }) => $isFullWidth ? "" : "space-x-8"}
`;
import_dist.default.li`
  list-none
`;
import_dist.default.span`
  transition-transform
  duration-300
  text-gray-500
  font-medium
  text-sm
  group-hover:scale-100
`;
//#endregion
//#region src/components/tabs/base-tabs/BaseTabs.tsx
var BaseTabs = ({ children, className, fullWidth = false, state }) => /* @__PURE__ */ React.createElement(StyledTabWrapper, { className }, /* @__PURE__ */ React.createElement(StyledBaseTabList, {
	$isFullWidth: fullWidth,
	state
}, Array.isArray(children) ? children.filter((child) => child.type !== React.Fragment).map((child) => React.cloneElement(child, {
	fullWidth,
	current: state.selectedId === child.props.tabId,
	key: child.props.tabId
})) : React.cloneElement(children, {
	fullWidth,
	current: state.activeId === children.props.tabId
})));
//#endregion
//#region src/components/tabs/base-tabs/TabPanelContainer.tsx
var TabPanelContainer = ({ children, className, fullHeight }) => /* @__PURE__ */ React.createElement(StyledBaseTabPanelContainer, {
	className,
	$fullHeight: fullHeight
}, children);
//#endregion
//#region src/components/tabs/base-tabs/BaseTabPanel.tsx
var BaseTabPanel = ({ children, className, state, tabId }) => /* @__PURE__ */ React.createElement(We$1, {
	className: (0, import_classnames.default)("row-start-1 col-start-1", className),
	as: StyledBaseTabPanel,
	show: state.selectedId === tabId,
	enter: "transition-opacity ease-[cubic-bezier(0.42,0,0.34,01.01)] duration-300",
	enterFrom: "opacity-0",
	enterTo: "opacity-100",
	leave: "transition-opacity ease-[cubic-bezier(0.42,0,0.34,01.01)] duration-300",
	leaveFrom: "opacity-100",
	leaveTo: "opacity-0",
	state,
	tabId,
	hidden: false
}, children);
//#endregion
//#region src/components/tabs/base-tabs/BaseTab.tsx
var BaseTab = ({ className, current, fullWidth = false, label, tabId }) => /* @__PURE__ */ React.createElement(StyledBaseTab, {
	$current: current,
	$isFullWidth: fullWidth,
	id: tabId,
	className
}, /* @__PURE__ */ React.createElement(StyledBaseTabChildContainer, { $current: current }, label));
//#endregion
//#region src/components/table/cell-content/cell-content.styled.ts
var StyledText = import_dist.default.span`
  truncate
  inline-block
  w-full
  ${({ $alignText }) => $alignText === "start" ? "" : "text-right"}
  ${({ $clickable }) => $clickable ? "text-primary-400 cursor-pointer" : "text-gray-500"}
`;
var StyledTextAction = (0, import_dist.default)(Typography)`
  text-primary-600
  hover:text-primary-400
`;
//#endregion
//#region src/components/table/cell-content/abbrev-number/AbbrevNumberCell.tsx
var AbbrevNumberCell = ({ alignText = "start", className, href, number }) => /* @__PURE__ */ React.createElement(StyledText, {
	$alignText: alignText,
	$clickable: href !== void 0,
	className
}, (0, import_lib.abbreviateNumber)({
	inputNumber: number,
	sigFigs: 2
}).abbreviation);
var AbbrevNumberCellMemo = memo(AbbrevNumberCell);
//#endregion
//#region src/components/table/cell-content/allocation-by-project/allocation-by-project.styled.ts
var StyledReadOnlySliderContainer = (0, import_dist.default)(Stack)`
  w-full
  h-8
  rounded-l-md
  ease-in-out
  ${({ $hover }) => $hover ? "bg-gray-800 transition-colors duration-300" : ""}
`;
var StyledHovercard = (0, import_dist.default)(Hovercard)`
  bg-gray-50
  w-80
  rounded-bl-md
  rounded-tr-md
  shadow-lg
  z-hovercard
`;
//#endregion
//#region src/components/table/cell-content/allocation-by-project/allocation-by-project.utils.ts
var getStyledPercentageVariant = (percentage, hovercardOpen) => hovercardOpen ? percentage > 0 ? "readOnlySelectedHover" : "readOnlyBaseHover" : percentage > 0 ? "readOnlySelected" : "readOnlyBase";
//#endregion
//#region src/components/table/cell-content/allocation-by-project/AllocationByProjectCell.tsx
var AllocationByProjectCell = ({ allocationSliderId, className, disabled = false, onAdvanceBtnClick, onChange, onSelect, otherAllocations, projects, totalDomesticRd, totalForeignRd, totalUnqualifiedRd }) => {
	const hovercard = useHovercardState({
		gutter: 0,
		placement: "right-start",
		timeout: 300,
		slide: false,
		flip: "right-start right-end"
	});
	const totalAllocationPercentage = totalDomesticRd + totalUnqualifiedRd;
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tooltip, {
		text: disabled ? "Create a project to change qualified R&D" : "",
		className: "!z-modal",
		options: {
			placement: "top",
			showArrow: true,
			gutter: -8,
			timeout: 300
		}
	}, /* @__PURE__ */ React.createElement(HovercardAnchor, {
		as: "div",
		disabled,
		state: hovercard
	}, /* @__PURE__ */ React.createElement(StyledReadOnlySliderContainer, {
		$hover: hovercard.open,
		className,
		alignItems: "center"
	}, /* @__PURE__ */ React.createElement(ReadOnlyAllocationSlider, {
		id: allocationSliderId,
		selectedPercentage: totalDomesticRd + totalUnqualifiedRd,
		alreadyAllocatedPercentage: totalForeignRd,
		hovercardOpen: hovercard.open
	}), /* @__PURE__ */ React.createElement(StyledPercentage, {
		$textVariant: "base",
		$variant: getStyledPercentageVariant(totalAllocationPercentage, hovercard.open),
		as: "span",
		fontSize: "xs",
		fontWeight: "semibold",
		lineHeight: 5
	}, totalAllocationPercentage, /* @__PURE__ */ React.createElement(Typography, {
		className: "text-inherit",
		as: "span",
		fontSize: "xs",
		fontWeight: "normal",
		lineHeight: 5
	}, "%"))))), /* @__PURE__ */ React.createElement(We$1, {
		show: hovercard.open,
		enter: "ease-in-out transition-opacity duration-300",
		enterFrom: "opacity-0",
		enterTo: "opacity-100",
		leave: "ease-in-out transition-opacity duration-300",
		leaveFrom: "opacity-100",
		leaveTo: "opacity-0"
	}, /* @__PURE__ */ React.createElement(StyledHovercard, { state: {
		...hovercard,
		open: true
	} }, /* @__PURE__ */ React.createElement(ProjectAllocation, {
		currentPlacement: hovercard.currentPlacement,
		onAdvanceBtnClick,
		onChange,
		onSelect,
		otherAllocations,
		projects,
		totalAllocated: totalDomesticRd + totalForeignRd + totalUnqualifiedRd,
		allocationSliderId
	}))));
};
var AllocationByProjectCellMemo = memo(AllocationByProjectCell);
//#endregion
//#region src/components/table/cell-content/amount/amount.styled.ts
var StyledAmountSpan = import_dist.default.span`
  inline-block
  w-full
  text-right
  text-gray-500
  ${({ $withDollarSign }) => $withDollarSign ? "first-letter:text-gray-300 first-letter:mr-1" : ""}
`;
//#endregion
//#region src/components/table/cell-content/amount/AmountCell.tsx
var AmountCell = ({ amountInCents, className, showCents = true, withDollarSign = true, roundingMethod = import_lib.RoundingMethod.ROUND }) => /* @__PURE__ */ React.createElement(StyledAmountSpan, {
	className,
	$withDollarSign: withDollarSign
}, amountInCents ? (0, import_lib.formatNumberToUsd)(amountInCents / 100, {
	withDollarSign,
	showCents,
	roundingMethod
}) : `${withDollarSign ? "$--" : "--"}`);
var AmountCellMemo = memo(AmountCell);
//#endregion
//#region src/components/table/cell-content/avatar-title/AvatarTitleCell.tsx
var AvatarTitleCell = ({ avatarUrl, className, size = 10, title, ...props }) => /* @__PURE__ */ React.createElement(AvatarWithText, {
	className: (0, import_classnames.default)("text-gray-900", className),
	imgSrc: avatarUrl,
	size: size ?? 10,
	title,
	variant: "circular",
	fontWeight: "medium",
	...props
});
var AvatarTitleCellMemo = memo(AvatarTitleCell);
//#endregion
//#region src/assets/icons/plus.svg
var SvgPlus = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0001 5C10.5524 5 11.0001 5.44772 11.0001 6V9L14.0001 9C14.5524 9 15.0001 9.44772 15.0001 10C15.0001 10.5523 14.5524 11 14.0001 11H11.0001V14C11.0001 14.5523 10.5524 15 10.0001 15C9.44784 15 9.00012 14.5523 9.00012 14V11H6.00012C5.44784 11 5.00012 10.5523 5.00012 10C5.00012 9.44771 5.44784 9 6.00012 9L9.00012 9V6C9.00012 5.44772 9.44784 5 10.0001 5Z",
		fill: "currentColor"
	})
});
var ForwardRef$7 = forwardRef(SvgPlus);
var Memo$7 = memo(ForwardRef$7);
//#endregion
//#region src/components/table/cell-content/avatar-stack-add/avatar-stack-add.styled.ts
var StyledAvatarContainerDiv = import_dist.default.div`
  flex
  items-center
`;
var StyledButtonAddCell = (0, import_dist.default)(Button$2)`
  w-6
  h-6
  rounded-full
`;
var StyledAddMemberContainerSpan = import_dist.default.span`
  w-6
  h-6
  rounded-full
  border-2
  border-dashed
  border-gray-300
  flex
  items-center
  justify-center
  text-gray-400
`;
//#endregion
//#region src/components/table/cell-content/avatar-stack-add/AvatarStackAddCell.tsx
var AvatarStackAddCell = ({ avatars, className, onClick }) => /* @__PURE__ */ React.createElement(StyledAvatarContainerDiv, { className }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StackedGroupAvatars, null, avatars.map((avatar, index) => /* @__PURE__ */ React.createElement(Avatar, {
	imgSrc: avatar.avatarUrl,
	key: `${avatar.name}-${index}`,
	size: 6,
	text: avatar.name,
	variant: "circular"
})))), /* @__PURE__ */ React.createElement("div", { className: "ml-2.5" }, onClick ? /* @__PURE__ */ React.createElement(StyledButtonAddCell, { onClick }, /* @__PURE__ */ React.createElement(StyledAddMemberContainerSpan, null, /* @__PURE__ */ React.createElement(Memo$7, {
	className: "h-5 w-5",
	"aria-hidden": "true"
}))) : null));
var AvatarStackAddCellMemo = memo(AvatarStackAddCell);
//#endregion
//#region src/components/table/cell-content/country/country.styled.ts
var StyledFlag = import_dist.default.img`
  inline-block
  mr-2
`;
var StyledCountryText = (0, import_dist.default)(Stack)`
  truncate
  w-full
`;
//#endregion
//#region src/components/table/cell-content/country/CountryCell.tsx
var CountryCell = ({ children, className, countryCode }) => /* @__PURE__ */ React.createElement(StyledCountryText, { className }, countryCode ? /* @__PURE__ */ React.createElement(StyledFlag, {
	alt: `${countryCode} flag`,
	width: 20,
	src: `https://flagcdn.com/${countryCode}.svg`
}) : null, children);
var CountryCellMemo = memo(CountryCell);
//#endregion
//#region src/components/table/cell-content/icon-and-text/icon-and-text.styled.ts
var StyledEmailSpan = import_dist.default.span`flex gap-x-2 items-center w-full min-w-0 text-gray-400`;
var StyledIconWrapper = import_dist.default.span`flex shrink-0`;
var StyledTruncatedText = import_dist.default.span`min-w-0 truncate`;
//#endregion
//#region src/components/table/cell-content/icon-and-text/IconAndText.tsx
var IconAndTextCell = ({ className, icon, text }) => /* @__PURE__ */ React.createElement(StyledEmailSpan, { className }, /* @__PURE__ */ React.createElement(StyledIconWrapper, null, icon), /* @__PURE__ */ React.createElement(StyledTruncatedText, { title: text }, text));
var IconAndTextCellMemo = memo(IconAndTextCell);
//#endregion
//#region ../../node_modules/dayjs/plugin/relativeTime.js
var require_relativeTime = /* @__PURE__ */ __commonJSMin(((exports, module, this$1) => {
	(function(r, e) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (r = "undefined" != typeof globalThis ? globalThis : r || self).dayjs_plugin_relativeTime = e();
	})(this$1, (function() {
		"use strict";
		return function(r, e, t) {
			r = r || {};
			var n = e.prototype, o = {
				future: "in %s",
				past: "%s ago",
				s: "a few seconds",
				m: "a minute",
				mm: "%d minutes",
				h: "an hour",
				hh: "%d hours",
				d: "a day",
				dd: "%d days",
				M: "a month",
				MM: "%d months",
				y: "a year",
				yy: "%d years"
			};
			function i(r, e, t, o) {
				return n.fromToBase(r, e, t, o);
			}
			t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
				for (var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
					{
						l: "s",
						r: 44,
						d: "second"
					},
					{
						l: "m",
						r: 89
					},
					{
						l: "mm",
						r: 44,
						d: "minute"
					},
					{
						l: "h",
						r: 89
					},
					{
						l: "hh",
						r: 21,
						d: "hour"
					},
					{
						l: "d",
						r: 35
					},
					{
						l: "dd",
						r: 25,
						d: "day"
					},
					{
						l: "M",
						r: 45
					},
					{
						l: "MM",
						r: 10,
						d: "month"
					},
					{
						l: "y",
						r: 17
					},
					{
						l: "yy",
						d: "year"
					}
				], m = h.length, c = 0; c < m; c += 1) {
					var y = h[c];
					y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
					var p = (r.rounding || Math.round)(Math.abs(f));
					if (s = f > 0, p <= y.r || !y.r) {
						p <= 1 && c > 0 && (y = h[c - 1]);
						var v = l[y.l];
						u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
						break;
					}
				}
				if (n) return a;
				var M = s ? l.future : l.past;
				return "function" == typeof M ? M(a) : M.replace("%s", a);
			}, n.to = function(r, e) {
				return i(r, e, this, !0);
			}, n.from = function(r, e) {
				return i(r, e, this);
			};
			var d = function(r) {
				return r.$u ? t.utc() : t();
			};
			n.toNow = function(r) {
				return this.to(d(this), r);
			}, n.fromNow = function(r) {
				return this.from(d(this), r);
			};
		};
	}));
}));
//#endregion
//#region src/components/table/cell-content/humanized-date/humanized-date.styled.ts
var import_dayjs_min = /* @__PURE__ */ __toESM(require_dayjs_min());
var import_relativeTime = /* @__PURE__ */ __toESM(require_relativeTime());
var StyledTimeSpan = import_dist.default.span`
  inline-block
  w-full
  text-right
  text-gray-500
`;
//#endregion
//#region src/components/table/cell-content/humanized-date/HumanizedDateCell.tsx
import_dayjs_min.default.extend(import_relativeTime.default);
var HumanizedDateCell = ({ className, date }) => /* @__PURE__ */ React.createElement(StyledTimeSpan, { className }, (0, import_dayjs_min.default)(date).fromNow());
var HumanizedDateCellMemo = memo(HumanizedDateCell);
//#endregion
//#region src/components/table/cell-content/text/TextCell.tsx
var TextCell = ({ alignText = "start", className, href, text }) => /* @__PURE__ */ React.createElement(StyledText, {
	$alignText: alignText,
	$clickable: href !== void 0,
	className
}, text);
var TextCellMemo = memo(TextCell);
//#endregion
//#region src/components/table/cell-content/status/status.styled.ts
var StatusBox = import_dist.default.div`
  inline-block
  mr-0.5
  w-5
  h-5
  border
  rounded-sm
`;
var StatusLabel = import_dist.default.div`
  w-full
  text-left
`;
//#endregion
//#region src/components/table/cell-content/status/Status.tsx
var stageColor = (stage) => {
	if (stage <= 0) return {
		bg: "white",
		border: "border-gray-500",
		text: "text-gray-500"
	};
	if (stage <= .2) return {
		bg: "bg-rsbry-200",
		border: "border-rsbry-800",
		text: "text-rsbry-800"
	};
	if (stage <= .4) return {
		bg: "bg-pink-100",
		border: "border-pink-800",
		text: "text-pink-800"
	};
	if (stage <= .6) return {
		bg: "bg-purple-200",
		border: "border-purple-800",
		text: "text-purple-800"
	};
	if (stage < 1) return {
		bg: "bg-indigo-100",
		border: "border-indigo-800",
		text: "text-indigo-800"
	};
	return {
		bg: "bg-blue-100",
		border: "border-blue-800",
		text: "text-blue-800"
	};
};
var Status = ({ className, currentStage, currentStageNumber, stagesCount }) => {
	if (currentStageNumber === null || stagesCount === null) return /* @__PURE__ */ React.createElement(StatusLabel, { className: (0, import_classnames.default)("text-gray-500", className) }, currentStage);
	const { bg, border, text } = stageColor(currentStageNumber / stagesCount);
	return /* @__PURE__ */ React.createElement("div", { className }, Array(stagesCount).fill(1).map((_a, i) => /* @__PURE__ */ React.createElement(StatusBox, {
		key: `stage_${i}`,
		className: `${i < currentStageNumber ? bg : "white"} ${border}`
	})), /* @__PURE__ */ React.createElement(StatusLabel, { className: text }, currentStage));
};
var StatusMemo = memo(Status);
//#endregion
//#region src/components/table/column-header-content/column-header-content.styled.ts
var StyledTextRightSpan = import_dist.default.span`font-medium inline-block w-full text-right`;
var StyledTextLeftSpan = import_dist.default.span`font-medium inline-block w-full text-left`;
//#endregion
//#region src/components/table/column-footer-content/footer-cell.styled.ts
var StyledFooterCell = import_dist.default.div`
  ${({ $alignText }) => $alignText === "start" ? "justify-start" : "justify-end"}
  text-gray-600
  font-medium
  tracking-wider
  flex
  items-center
  space-x-1
`;
var StyledPreText = import_dist.default.span`
  text-gray-300
  font-medium
`;
//#endregion
//#region src/components/table/column-footer-content/FooterCell.tsx
var FooterCell = ({ alignText = "start", className, preText, text }) => /* @__PURE__ */ React.createElement(StyledFooterCell, {
	$alignText: alignText,
	className
}, /* @__PURE__ */ React.createElement(StyledPreText, null, preText), /* @__PURE__ */ React.createElement("span", { className: "text-ellipsis overflow-hidden" }, text));
memo(FooterCell);
//#endregion
//#region src/components/table/features/addActionColumn.tsx
var ACTION_COLUMN_ID = "actionColumnId";
var addActionColumn = ({ cellRender, label, onClick, width }) => ({
	customCellClassNames: (cell) => [{ "w-full text-right justify-end": cell.column.id === ACTION_COLUMN_ID }],
	featureHooks: [(hooks) => {
		hooks.visibleColumns.push((columns) => [...columns, {
			id: ACTION_COLUMN_ID,
			width,
			Cell: cellRender ? cellRender : ({ row }) => /* @__PURE__ */ React.createElement(StyledTextAction, {
				as: "button",
				fontSize: "sm",
				fontWeight: "normal",
				onClick: (e) => {
					onClick?.(e, row);
				}
			}, label)
		}]);
	}]
});
//#endregion
//#region src/components/table/features/condensedContent.tsx
var condensedContent = { customCellClassNames: () => "!py-2 !h-[37px]" };
//#endregion
//#region src/components/table/features/grayedOutRowBackground.tsx
var grayedOutRowBackground = (condition) => ({ customRowClassNames: (row) => [{ "bg-gray-100": condition(row) }] });
//#endregion
//#region src/components/table/hooks/useFeatures.ts
var useFeatures = (...features) => {
	const customCellClassNames = features.filter((feature) => feature.customCellClassNames).map((feature) => feature.customCellClassNames);
	const customRowClassNames = features.filter((feature) => feature.customRowClassNames).map((feature) => feature.customRowClassNames);
	const featureHooks = features.filter((feature) => feature.featureHooks).flatMap((feature) => feature.featureHooks);
	const allStateReducers = features.map((feature) => feature.stateReducer).filter((stateReducer) => stateReducer);
	let stateReducer;
	if (Array.isArray(allStateReducers) && allStateReducers.length) stateReducer = (newState, action, previousState, instance) => pipe(...allStateReducers)(newState, action, previousState, instance);
	return {
		customCellClassNames,
		customRowClassNames,
		featureHooks,
		stateReducer
	};
};
//#endregion
//#region src/components/table/hooks/useCommonTable.ts
/**
* Used for common state and business logic between Table and VirtualTable
*/
var useCommonTable = ({ columnOrder, columns, data, featureHooks = [], initialState = {}, stateReducer, tableOptions = {} }) => {
	const columnsToRender = useMemo(() => {
		if (columnOrder) {
			const columnMap = columns.reduce((map, column) => {
				const id = column.id || column.accessor;
				if (typeof id !== "string") throw (0, import_lib.createError)("MissingTableColumnId", "Table column must have an id or string accessor");
				map[id] = column;
				return map;
			}, {});
			return columnOrder.map((columnAccessor) => columnMap[columnAccessor]);
		}
		return columns;
	}, [columnOrder, columns]);
	const { footerGroups, getTableBodyProps, getTableProps, headerGroups, prepareRow, rows, setColumnOrder, state, visibleColumns } = (0, import_react_table.useTable)({
		columns: columnsToRender,
		data,
		initialState,
		stateReducer,
		...tableOptions
	}, ...featureHooks, import_react_table.useColumnOrder);
	const showFooter = useMemo(() => columnsToRender.findIndex((column) => column.Footer !== void 0) !== -1, [columnsToRender]);
	useEffect(() => {
		if (!columnOrder) return;
		setColumnOrder(columnOrder);
	}, [columnOrder, setColumnOrder]);
	return {
		columnsToRender,
		footerGroups,
		getTableBodyProps,
		getTableProps,
		headerGroups,
		prepareRow,
		rows,
		showFooter,
		state,
		visibleColumns
	};
};
import_dist.default.table`
  relative
  min-w-full
  border-separate
  border-spacing-0
`;
import_dist.default.tbody`
  bg-white
`;
import_dist.default.tfoot`
  bg-gray-50
  shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),0_-2px_4px_-1px_rgba(0,0,0,0.06)]
  sticky
  -bottom-px
`;
import_dist.default.th`
  sticky 
  top-0
  z-th
  border-b
  border-gray-200
  bg-gray-50
  bg-opacity-75
  whitespace-nowrap
  px-6
  py-3.5
  leading-5
  text-left
  text-sm
  font-medium
  text-gray-900
  backdrop-blur
  backdrop-filter
`;
import_dist.default.td`
  border-b
  border-gray-200 
  whitespace-nowrap
  px-6
  py-4
  text-sm
`;
import_dist.default.td`
  whitespace-nowrap
  px-6
  py-3.5
  leading-4
  text-left
  text-xs
  font-medium
  text-gray-900
`;
var StyledFilteringOverlay = import_dist.default.div`
  absolute
  inset-0
  flex
  items-center
  justify-center
  z-50
  pointer-events-none
`;
//#endregion
//#region src/components/table/TableBody.tsx
var TableBody = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement("tbody", {
	...props,
	ref,
	className: "flex-1"
}));
TableBody.displayName = "TableBody";
//#endregion
//#region src/components/table/TableFoot.tsx
var TableFoot = React.forwardRef(({ style, ...props }, ref) => /* @__PURE__ */ React.createElement("tfoot", {
	...props,
	className: "bg-gray-50 shadow-[0_8px_26px_0_rgba(0,0,0,0.16)] h-12 sticky z-10",
	style: {
		...style,
		bottom: "-2px"
	},
	ref
}));
TableFoot.displayName = "TableFoot";
var EmptyTableFoot = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement("tfoot", {
	...props,
	className: "border-none",
	ref
}));
EmptyTableFoot.displayName = "EmptyTableFoot";
//#endregion
//#region src/components/table/utils/table.utils.ts
var convertNumberToPx = (value) => `${value}px`;
var getWidthCssValue = (width) => typeof width === "number" ? convertNumberToPx(width) : width;
var getGridColumnWidth = (width) => width ? getWidthCssValue(width) : "minmax(150px, 1fr)";
//#endregion
//#region src/components/table/TableFooterContent.tsx
var TableFooterContent = ({ columns, footerGroups }) => {
	const gridColumnWidths = React.useMemo(() => columns.map(({ width }) => getGridColumnWidth(width)), [columns]);
	return /* @__PURE__ */ React.createElement(React.Fragment, null, footerGroups.map((footerGroup, footerGroupIndex) => /* @__PURE__ */ React.createElement("tr", {
		...footerGroup.getFooterGroupProps({
			className: "tr",
			style: {
				width: "auto",
				display: "grid",
				gridTemplateColumns: gridColumnWidths.join(" ")
			}
		}),
		key: `tr-${footerGroupIndex}`
	}, footerGroup.headers.map((column, index) => /* @__PURE__ */ React.createElement("td", {
		...column.getHeaderProps({ className: (0, import_classnames.default)("whitespace-nowrap px-6 py-3.5 leading-5 text-left text-sm font-medium text-gray-900", index === 0 && "pl-6 pr-5", index === footerGroup.headers.length - 1 && "pl-5 pr-6", "td") }),
		key: column.id
	}, column.render("Footer"))))));
};
//#endregion
//#region src/components/table/TableHead.tsx
var TableHead = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement("thead", {
	...props,
	ref,
	className: "bg-gray-50"
}));
TableHead.displayName = "TableHead";
//#endregion
//#region src/components/table/TableHeaderContent.tsx
var TableHeaderContent = ({ columns, headerGroups }) => {
	const gridColumnWidths = React.useMemo(() => columns.map(({ width }) => getGridColumnWidth(width)), [columns]);
	return /* @__PURE__ */ React.createElement(React.Fragment, null, headerGroups.map((headerGroup, headerGroupIndex) => /* @__PURE__ */ React.createElement("tr", {
		...headerGroup.getHeaderGroupProps({
			className: "tr bg-gray-50",
			style: {
				width: "auto",
				display: "grid",
				gridTemplateColumns: gridColumnWidths.join(" ")
			}
		}),
		key: `tr-${headerGroupIndex}`
	}, headerGroup.headers.map((column, index) => /* @__PURE__ */ React.createElement("td", {
		...column.getHeaderProps({
			className: (0, import_classnames.default)("sticky top-0 z-10 whitespace-nowrap px-6 py-3.5 leading-5 text-left text-sm font-medium text-gray-900", index === 0 && "pl-6 pr-5", index === headerGroup.headers.length - 1 && "pl-5 pr-6", "th"),
			style: { width: "100%" }
		}),
		key: column.id
	}, column.render("Header"))))));
};
React.memo(TableHeaderContent);
//#endregion
//#region src/components/table/TableItemContent.tsx
var TableItemContent = ({ customCellClassNames, row }) => /* @__PURE__ */ React.createElement(React.Fragment, null, row.cells.map((cell, index) => /* @__PURE__ */ React.createElement("td", {
	className: (0, import_classnames.default)("px-6 py-4 text-sm border-b border-gray-200 items-center", ...customCellClassNames.map((cnRule) => cnRule(cell)), index === 0 && "pl-6 pr-5", index === row.cells.length - 1 && "pl-5 pr-6", "td"),
	style: {
		width: "auto",
		display: "flex"
	},
	key: `${row.id}-${index}`
}, cell.render("Cell"))));
//#endregion
//#region src/components/table/TableRow.tsx
var TableRow = ({ children, columns, customRowClassNames, item, style, ...props }) => {
	const gridColumnWidths = React.useMemo(() => columns.map(({ width }) => getGridColumnWidth(width)), [columns]);
	return /* @__PURE__ */ React.createElement("tr", {
		...props,
		className: (0, import_classnames.default)(...customRowClassNames.map((cnRule) => cnRule(item)), "tr bg-white flex-1"),
		style: {
			...style,
			display: "grid",
			gridTemplateColumns: gridColumnWidths.join(" ")
		}
	}, children);
};
//#endregion
//#region src/components/table/Table.tsx
/**
* This is a special use case Table component for efficiently displaying many rows by dynamically rendering
* only the rows in the current scroll view window. To accomplish this, we loose column auto resizing. To control
* the width of each column from the parent component using the `width` property in the `Column` object. Default
* width will be to equally distribute size among all columns. If you don't specify a width for a colum, it will
* follow this rule.
*
* @param input.isFooterLoading - when the table footer should show a loading spinner
* @param input.isBodyLoading - when the table body should show a loading overlay
* @param input.threshold Number of rows from the bottom of the list at which to start fetching more data.
*/
var Table = ({ className, columnOrder, columns, autoHeight = false, customCellClassNames = [], customRowClassNames = [], data, featureHooks = [], initialState = {}, endReached, showZeroState = false, stateReducer, tableOptions, loadMoreRowFromBottomThreshold = 10, zeroState, isFooterLoading, isBodyLoading }) => {
	const { footerGroups, headerGroups, prepareRow, rows, showFooter, visibleColumns } = useCommonTable({
		columns,
		columnOrder,
		data,
		featureHooks: [...featureHooks, import_react_table.useBlockLayout],
		initialState,
		stateReducer,
		tableOptions
	});
	const handleRangeChanged = (range) => {
		const { endIndex } = range;
		if (rows.length - endIndex <= loadMoreRowFromBottomThreshold) endReached?.();
	};
	const getTableFooter = () => {
		if (isFooterLoading) {
			const LoadingFoot = forwardRef((_props, ref) => /* @__PURE__ */ React.createElement("tfoot", {
				ref,
				className: "bg-gray-50 flex justify-center w-full h-12 z-10 sticky bottom-0"
			}, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: "flex justify-center items-center w-full h-full" }, /* @__PURE__ */ React.createElement(Spinner, { size: "sm" })))));
			LoadingFoot.displayName = "LoadingTableFoot";
			return LoadingFoot;
		}
		return showFooter ? TableFoot : EmptyTableFoot;
	};
	if (autoHeight) return /* @__PURE__ */ React.createElement("div", { className: "relative" }, isBodyLoading && /* @__PURE__ */ React.createElement(StyledFilteringOverlay, null, /* @__PURE__ */ React.createElement(Spinner, { size: "lg" })), /* @__PURE__ */ React.createElement("table", { className: (0, import_classnames.default)(className, "flex flex-col min-w-full divide-y divide-gray-300 w-fit", { "pointer-events-none opacity-50": isBodyLoading }) }, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement(TableHeaderContent, {
		headerGroups,
		columns: visibleColumns
	})), /* @__PURE__ */ React.createElement("tbody", { className: "flex-1" }, rows.length === 0 && zeroState ? /* @__PURE__ */ React.createElement("tr", {
		className: "tr bg-white flex-1",
		style: {
			display: "grid",
			gridTemplateColumns: "1fr"
		}
	}, /* @__PURE__ */ React.createElement("td", {
		className: "td px-6 py-4 text-sm border-b border-gray-200 items-center",
		style: { display: "flex" }
	}, zeroState)) : rows.map((row) => {
		prepareRow(row);
		return /* @__PURE__ */ React.createElement(TableRow, {
			key: row.id,
			columns: visibleColumns,
			customRowClassNames,
			item: row
		}, /* @__PURE__ */ React.createElement(TableItemContent, {
			row,
			customCellClassNames
		}));
	})), showFooter && /* @__PURE__ */ React.createElement(TableFoot, null, /* @__PURE__ */ React.createElement(TableFooterContent, {
		footerGroups,
		columns: visibleColumns
	}))));
	return /* @__PURE__ */ React.createElement("div", { className: "relative h-full" }, isBodyLoading && /* @__PURE__ */ React.createElement(StyledFilteringOverlay, null, /* @__PURE__ */ React.createElement(Spinner, { size: "lg" })), /* @__PURE__ */ React.createElement(TableVirtuoso, {
		data: rows,
		totalCount: rows.length,
		rangeChanged: handleRangeChanged,
		itemContent: (_, row) => {
			prepareRow(row);
			return /* @__PURE__ */ React.createElement(TableItemContent, {
				key: row.id,
				row,
				customCellClassNames
			});
		},
		fixedHeaderContent: () => /* @__PURE__ */ React.createElement(TableHeaderContent, {
			headerGroups,
			columns: visibleColumns
		}),
		fixedFooterContent: () => showFooter ? /* @__PURE__ */ React.createElement(TableFooterContent, {
			footerGroups,
			columns: visibleColumns
		}) : /* @__PURE__ */ React.createElement(React.Fragment, null),
		components: {
			EmptyPlaceholder: () => /* @__PURE__ */ React.createElement(We$1, {
				as: "div",
				appear: true,
				show: showZeroState,
				className: "bg-white bg-opacity-75 sticky top-[49px] z-th backdrop-blur backdrop-filter",
				enter: "ease-in-out transition-all duration-500",
				enterFrom: "opacity-25 -translate-x-full",
				enterTo: "opacity-100 translate-x-0",
				leave: "ease-in-out transition-all duration-500",
				leaveFrom: "opacity-100 translate-x-0",
				leaveTo: "opacity-25 translate-x-full"
			}, zeroState),
			Table: ({ ...props }) => /* @__PURE__ */ React.createElement("table", {
				...props,
				className: (0, import_classnames.default)(className, "flex-col min-w-full min-h-full flex justify-between divide-y divide-gray-300 w-fit", { "pointer-events-none opacity-50": isBodyLoading })
			}),
			TableHead,
			TableBody,
			TableRow: ({ children, ...props }) => /* @__PURE__ */ React.createElement(TableRow, {
				columns: visibleColumns,
				customRowClassNames,
				...props
			}, children),
			TableFoot: getTableFooter()
		}
	}));
};
//#endregion
//#region src/assets/icons/collection.svg
var SvgCollection = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	style: { fill: "currentColor" },
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.88839 6.91322C7.88839 7.01196 7.98711 7.11068 8.08588 7.11068H16.4787C16.5775 7.11068 16.6762 7.01196 16.6762 6.91322V3.95103C16.6762 3.85229 16.5775 3.75354 16.4787 3.75354H14.7014V3.45733C14.7014 2.07499 13.6153 0.988846 12.233 0.988846C12.0355 0.988846 11.838 0.988846 11.5418 1.08759C10.4556 1.3838 9.66569 2.37119 9.76447 3.55608V3.75354H8.08588C7.98711 3.6548 7.88839 3.85229 7.88839 3.95103V6.91322ZM12.3317 2.46994C12.7267 2.46994 13.1216 2.76615 13.1216 3.1611C13.1216 3.55608 12.8254 3.95103 12.3317 3.95103C11.9367 3.95103 11.5418 3.6548 11.5418 3.1611C11.5418 2.76615 11.9367 2.46994 12.3317 2.46994ZM21.7119 5.72833C21.7119 4.64219 20.8232 3.75354 19.7371 3.75354H18.5523C18.3548 3.75354 18.256 3.85229 18.256 3.95103V5.43213C18.256 5.53087 18.3548 5.62959 18.4535 5.62959H19.2434C19.5396 5.62959 19.7371 5.82708 19.7371 6.12328V21.9216C19.7371 22.2178 19.5396 22.4153 19.2434 22.4153H5.4199C5.1237 22.4153 4.92621 22.2178 4.92621 21.9216V6.12328C4.92621 5.82708 5.1237 5.62959 5.4199 5.62959H6.20981C6.30858 5.72833 6.4073 5.62959 6.4073 5.43213V3.95103C6.4073 3.85229 6.30858 3.75354 6.11109 3.75354H4.92621C3.8401 3.75354 2.95142 4.64219 2.95142 5.72833V22.5141C2.95142 23.6002 3.8401 24.4888 4.92621 24.4888H19.7371C20.8232 24.4888 21.7119 23.6002 21.7119 22.5141V5.72833ZM9.07328 17.8733C9.07328 18.9594 8.1846 19.7494 7.1972 19.7494C6.50602 19.7494 5.81489 19.3544 5.6174 18.762C5.1237 17.8733 5.51862 16.7872 6.4073 16.2935C6.4073 16.2935 6.50602 16.1947 6.50602 16.096V12.4426C6.50602 11.554 7.1972 10.8628 8.08588 10.8628H9.9619C10.0607 10.8628 10.1594 10.7641 10.1594 10.6653V10.1716C10.1594 9.67791 10.5544 9.28296 11.0481 9.28296H13.8128C14.3065 9.28296 14.7014 9.67791 14.7014 10.1716V10.5666C14.7014 10.6653 14.8002 10.7641 14.8989 10.7641H16.4787C17.3674 10.7641 18.0586 11.4552 18.0586 12.3439V15.9972C18.0586 16.096 18.0586 16.1947 18.1573 16.1947C18.4535 16.2935 18.7497 16.5897 18.9472 16.9846C19.4409 17.8733 19.0459 18.9594 18.1573 19.4531C17.2687 19.9468 16.1825 19.5519 15.6888 18.6632C15.1951 17.7746 15.5901 16.6884 16.4787 16.1947C16.4787 16.1947 16.5775 16.096 16.5775 15.9972V12.3439C16.5775 12.2451 16.4787 12.1464 16.38 12.1464H14.8002C14.7014 12.1464 14.6027 12.2451 14.6027 12.3439V12.8376C14.6027 13.3313 14.2077 13.7262 13.7141 13.7262H13.2204C13.1216 13.7262 13.0229 13.825 13.0229 13.9237V15.9972C13.0229 16.096 13.0229 16.1947 13.1216 16.1947C13.4178 16.2935 13.7141 16.5897 13.9115 16.9846C14.4052 17.8733 14.0103 18.9594 13.1216 19.4531C12.233 19.9468 11.1468 19.5519 10.6531 18.6632C10.1594 17.7746 10.5544 16.6884 11.443 16.1947C11.443 16.1947 11.5418 16.096 11.5418 15.9972V13.9237C11.5418 13.825 11.443 13.7262 11.3443 13.7262H10.8506C10.3569 13.7262 9.9619 13.3313 9.9619 12.8376V12.3439C9.9619 12.2451 9.86318 12.1464 9.76447 12.1464H8.1846C8.08588 12.1464 7.98711 12.2451 7.98711 12.3439V15.9972C7.98711 16.096 7.98711 16.1947 8.08588 16.1947C8.6783 16.5897 9.07328 17.1821 9.07328 17.8733Z"
	})
});
var ForwardRef$6 = forwardRef(SvgCollection);
var Memo$6 = memo(ForwardRef$6);
//#endregion
//#region src/assets/icons/open-link.svg
var SvgOpenLink = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("path", { d: "M15.25 6.91665e-07H23.25C23.4481 0.00259135 23.6374 0.0824405 23.7775 0.222535C23.9176 0.36263 23.9974 0.551894 24 0.750001V8.62C24.0018 8.76666 23.96 8.91055 23.8799 9.03341C23.7998 9.15626 23.685 9.25253 23.55 9.31C23.4585 9.34988 23.3598 9.37031 23.26 9.37C23.1615 9.37047 23.0638 9.35125 22.9728 9.31347C22.8818 9.27569 22.7993 9.22011 22.73 9.15L19.44 5.91L9.96001 15.24C9.77214 15.4211 9.52094 15.5216 9.26001 15.52C9.1277 15.5195 8.99682 15.4927 8.87494 15.4412C8.75307 15.3897 8.64262 15.3145 8.55001 15.22C8.36376 15.0326 8.25922 14.7792 8.25922 14.515C8.25922 14.2508 8.36376 13.9974 8.55001 13.81L18 4.51L14.72 1.28C14.6159 1.17617 14.545 1.04366 14.5165 0.89939C14.488 0.755121 14.5032 0.605632 14.56 0.470001C14.6144 0.331316 14.7093 0.212261 14.8324 0.128405C14.9555 0.0445492 15.1011 -0.000202913 15.25 6.91665e-07Z" }), /* @__PURE__ */ jsx("path", { d: "M17.7929 10.9129C17.9804 10.7254 18.2348 10.62 18.5 10.62C18.7652 10.62 19.0196 10.7254 19.2071 10.9129C19.3946 11.1004 19.5 11.3548 19.5 11.62V22.12C19.5 22.6186 19.3019 23.0968 18.9494 23.4494C18.5968 23.8019 18.1186 24 17.62 24H1.87C1.37313 23.9974 0.897508 23.7981 0.547099 23.4458C0.196691 23.0936 -7.02886e-06 22.6169 1.88379e-10 22.12V6.37C1.88379e-10 5.87405 0.197017 5.3984 0.54771 5.04771C0.898403 4.69702 1.37405 4.5 1.87 4.5H12.37C12.6352 4.5 12.8896 4.60536 13.0771 4.79289C13.2646 4.98043 13.37 5.23478 13.37 5.5C13.37 5.76522 13.2646 6.01957 13.0771 6.20711C12.8896 6.39464 12.6352 6.5 12.37 6.5H2V22H17.5V11.62C17.5 11.3548 17.6054 11.1004 17.7929 10.9129Z" })]
});
var ForwardRef$5 = forwardRef(SvgOpenLink);
var Memo$5 = memo(ForwardRef$5);
//#endregion
//#region src/assets/icons/password.svg
var SvgPassword = (props, ref) => /* @__PURE__ */ jsx("svg", {
	viewBox: "0 0 24 24",
	style: { fill: "currentColor" },
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M23.4999 4.40664e-06H20.4999C20.4344 -0.000795015 20.3693 0.0121378 20.3091 0.0379713C20.2488 0.0638048 20.1946 0.101967 20.1499 0.150004L10.6199 9.68001C9.02075 8.94839 7.21533 8.802 5.51917 9.26641C3.82301 9.73082 2.34398 10.7765 1.34054 12.2207C0.337094 13.6649 -0.126946 15.4158 0.0295069 17.1674C0.18596 18.919 0.952957 20.56 2.19647 21.8035C3.43998 23.047 5.08091 23.814 6.83253 23.9704C8.58414 24.1269 10.335 23.6628 11.7792 22.6594C13.2234 21.6559 14.2691 20.1769 14.7335 18.4808C15.1979 16.7846 15.0515 14.9792 14.3199 13.38L16.6399 11.07L18.5699 11.72C18.7384 11.7808 18.92 11.7952 19.0959 11.7618C19.2718 11.7283 19.4355 11.6483 19.5699 11.53C19.6993 11.4197 19.7984 11.2783 19.8579 11.1191C19.9173 10.9598 19.9353 10.7881 19.9099 10.62L19.5099 8.2L20.2299 7.47L21.6899 8.14001C21.8598 8.21547 22.0474 8.24207 22.2316 8.21682C22.4158 8.19156 22.5894 8.11546 22.7327 7.99704C22.876 7.87863 22.9835 7.7226 23.0431 7.54648C23.1027 7.37036 23.112 7.18112 23.0699 7L22.5599 5.19L23.8499 3.89C23.9033 3.84097 23.9446 3.78025 23.9707 3.71259C23.9967 3.64493 24.0067 3.57218 23.9999 3.5V0.500004C23.9999 0.367396 23.9473 0.240219 23.8535 0.146451C23.7597 0.0526828 23.6325 4.40664e-06 23.4999 4.40664e-06ZM6.99993 18.5C6.99993 18.7967 6.91195 19.0867 6.74713 19.3334C6.58231 19.58 6.34804 19.7723 6.07395 19.8858C5.79986 19.9994 5.49826 20.0291 5.20729 19.9712C4.91632 19.9133 4.64905 19.7704 4.43927 19.5607C4.22949 19.3509 4.08663 19.0836 4.02875 18.7926C3.97087 18.5017 4.00058 18.2001 4.11411 17.926C4.22764 17.6519 4.4199 17.4176 4.66657 17.2528C4.91325 17.088 5.20326 17 5.49993 17C5.89775 17 6.27928 17.158 6.56059 17.4393C6.84189 17.7206 6.99993 18.1022 6.99993 18.5Z" })
});
var ForwardRef$4 = forwardRef(SvgPassword);
var Memo$4 = memo(ForwardRef$4);
//#endregion
//#region src/assets/icons/users.svg
var SvgUsers = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	viewBox: "0 0 24 24",
	style: { fill: "currentColor" },
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("path", { d: "M18.78 14.69L18 14.43C17.93 14.43 17.83 14.29 17.76 14.03C17.5925 13.3865 17.6204 12.7077 17.84 12.08C18.79 11.08 19.71 9.75 19.71 6.55C19.71 3.06 17.33 1.55 14.96 1.55C14.566 1.55219 14.1734 1.59916 13.79 1.69C13.7482 1.70114 13.7099 1.72252 13.6785 1.7522C13.647 1.78189 13.6235 1.81894 13.61 1.86C13.5907 1.89706 13.5807 1.93823 13.5807 1.98C13.5807 2.02178 13.5907 2.06294 13.61 2.1C14.6567 3.3616 15.2078 4.96142 15.16 6.6C15.16 9.88 14.24 11.6 13.16 12.83C13.1447 12.872 13.1447 12.918 13.16 12.96C13.1551 13.0099 13.1551 13.0601 13.16 13.11C13.1565 13.1633 13.1701 13.2163 13.1989 13.2613C13.2277 13.3063 13.2701 13.3409 13.32 13.36C15.73 14.22 19.46 15.56 19.46 20.55V22C19.46 22.07 19.46 22.15 19.46 22.22C19.455 22.2557 19.4578 22.292 19.4681 22.3266C19.4785 22.3611 19.4962 22.393 19.52 22.42C19.5422 22.4458 19.5699 22.4664 19.601 22.4802C19.6321 22.4941 19.6659 22.5008 19.7 22.5H23.5C23.6326 22.5 23.7598 22.4473 23.8536 22.3536C23.9473 22.2598 24 22.1326 24 22V20.5C24 16.55 21.23 15.57 18.78 14.69Z" }), /* @__PURE__ */ jsx("path", { d: "M18 20.5C18 16.55 15.23 15.57 12.78 14.69L12 14.43C11.93 14.43 11.83 14.29 11.76 14.03C11.5925 13.3865 11.6204 12.7077 11.84 12.08C12.79 11.08 13.71 9.75 13.71 6.55C13.71 3.06 11.33 1.55 8.96 1.55C6.59 1.55 4.25 3.06 4.25 6.55C4.25 9.75 5.17 11.04 6.12 12.07C6.34674 12.7135 6.37462 13.4104 6.2 14.07C6.13 14.33 6.03 14.44 5.96 14.47L5.2 14.74C2.76 15.56 0 16.54 0 20.5V22C0 22.1326 0.0526784 22.2598 0.146447 22.3536C0.240215 22.4473 0.367392 22.5 0.5 22.5H17.5C17.6326 22.5 17.7598 22.4473 17.8536 22.3536C17.9473 22.2598 18 22.1326 18 22V20.5Z" })]
});
var ForwardRef$3 = forwardRef(SvgUsers);
var Memo$3 = memo(ForwardRef$3);
//#endregion
//#region src/components/ticket/ticket.styled.ts
var StyledTicketData = (0, import_dist.default)(Stack)`
  grow
  w-0
`;
var StyledTicketName = import_dist.default.div`
  text-ellipsis
  whitespace-nowrap
  overflow-hidden
  text-primary-600
  font-medium
  text-sm
  items-center
`;
var StyledDataItemValue = import_dist.default.div`
  text-ellipsis
  whitespace-nowrap
  overflow-hidden
  font-normal
  text-sm
  ${({ $noValue }) => $noValue ? "text-gray-300" : "text-gray-500"}
`;
//#endregion
//#region src/components/ticket/DataItem.tsx
var DataItem = ({ description, icon, value }) => /* @__PURE__ */ React.createElement(Stack, {
	direction: "row",
	gap: 2,
	alignItems: "center"
}, /* @__PURE__ */ React.createElement("dt", { title: description }, /* @__PURE__ */ React.createElement(Icon, {
	node: icon,
	size: 6,
	colorVariant: "none"
})), /* @__PURE__ */ React.createElement(StyledDataItemValue, {
	$noValue: !value,
	title: value ?? "None"
}, value ?? "None"));
//#endregion
//#region src/components/ticket/Ticket.tsx
var Ticket = ({ children: _, collectionName, contributorName, identifier, name, onSelectedChange, selected, ticketUrl, ...otherProps }) => {
	const selectable = typeof selected !== "undefined";
	return /* @__PURE__ */ React.createElement(Stack, {
		paddingX: 4,
		paddingY: 4,
		gap: 2,
		...otherProps
	}, selectable && /* @__PURE__ */ React.createElement(CheckboxAtom, {
		checked: selected,
		onChange: onSelectedChange && ((e) => onSelectedChange(e.target.checked))
	}), /* @__PURE__ */ React.createElement(StyledTicketData, {
		direction: "column",
		gap: 2
	}, /* @__PURE__ */ React.createElement(Stack, {
		justifyContent: "space-between",
		gap: 2
	}, /* @__PURE__ */ React.createElement(StyledTicketName, { title: name ?? void 0 }, name ?? "-- No Ticket Name --"), ticketUrl && /* @__PURE__ */ React.createElement("a", {
		href: ticketUrl,
		target: "_blank",
		rel: "noreferrer"
	}, /* @__PURE__ */ React.createElement(Icon, {
		node: /* @__PURE__ */ React.createElement(Memo$5, null),
		size: 4,
		colorVariant: "none"
	}))), /* @__PURE__ */ React.createElement(Stack, {
		as: "dl",
		direction: "column",
		gap: 2
	}, /* @__PURE__ */ React.createElement(DataItem, {
		description: "Assignee",
		icon: /* @__PURE__ */ React.createElement(Memo$3, null),
		value: contributorName
	}), /* @__PURE__ */ React.createElement(DataItem, {
		description: "Issue ID",
		icon: /* @__PURE__ */ React.createElement(Memo$4, null),
		value: identifier
	}), /* @__PURE__ */ React.createElement(DataItem, {
		key: collectionName,
		description: "Ticketing System Project",
		icon: /* @__PURE__ */ React.createElement(Memo$6, null),
		value: collectionName
	}))));
};
//#endregion
//#region src/components/side-drawer/side-drawer.styled.ts
var WidthBySide = {
	bottom: "max-w-full",
	left: "max-w-lg",
	right: "max-w-lg",
	top: "max-w-full"
};
var PositionBySide = {
	bottom: "",
	left: "left-0",
	right: "right-0",
	top: ""
};
var StyledOverlay = import_dist.default.div`
    fixed
    inset-0
    bg-gray-500
    bg-opacity-75
    transition-opacity
`;
var StyledDialogPanel = (0, import_dist.default)(mt$1.Panel)`
    pointer-events-auto
    w-screen
    max-w-md
    ${({ $side }) => WidthBySide[$side]}
`;
var StyledSideDrawer = import_dist.default.div`
    flex
    h-full
    flex-col
    bg-white
    shadow-xl
`;
var StyledHeaderBar = import_dist.default.div`
    bg-white
    p-6
`;
var StyledHeaderContentContainer = import_dist.default.div`
    flex
    items-start
`;
var StyledHeaderTextWrapper = import_dist.default.div`
    space-y-1
`;
var StyledHeaderTitle = (0, import_dist.default)(mt$1.Title)`
    text-lg
    font-medium
    text-gray-900
`;
var StyledHeaderSubtitle = import_dist.default.p`
    text-sm
    text-gray-500
`;
var StyledDrawerContainerFixed = import_dist.default.div`
    fixed
    inset-0
    overflow-hidden
`;
var StyledDrawerContainerAbsolute = import_dist.default.div`
    absolute
    inset-0
    overflow-hidden
`;
var StyledDrawerPositionContainer = import_dist.default.div`
    pointer-events-none
    h-full
    fixed
    bottom-0
    flex
    max-w-full
    ${({ $side }) => PositionBySide[$side]}
`;
import_dist.default.h1`
    font-medium
    text-lg
    text-gray-900
`;
var StyledCloseContainer = import_dist.default.div`
    flex
    h-7
    items-center
`;
var StyledCloseButtonIcon = (0, import_dist.default)(Memo$10)`
    h-3
    w-3
    inline-block
`;
var StyledChildrenWrapper = import_dist.default.div`
    flex-1
    overflow-y-hidden
`;
//#endregion
//#region src/components/side-drawer/SideDrawer.tsx
var SideDrawer = ({ afterClose = () => {}, children, className, header, isOpen, setIsOpen = () => {}, side = "right", topMargin }) => {
	const enterFromAndLeaveTo = {
		"-translate-y-full": side === "top",
		"translate-y-full": side === "bottom",
		"translate-x-full": side === "right",
		"-translate-x-full": side === "left"
	};
	const enterToAndLeaveFrom = {
		"translate-y-0": side === "top",
		"-translate-y-0": side === "bottom",
		"-translate-x-0": side === "right",
		"translate-x-0": side === "left"
	};
	return /* @__PURE__ */ React.createElement(We$1.Root, {
		appear: true,
		show: isOpen,
		as: Fragment
	}, /* @__PURE__ */ React.createElement(mt$1, {
		as: "div",
		className: (0, import_classnames.default)("relative z-modal", className),
		onClose: setIsOpen
	}, /* @__PURE__ */ React.createElement(We$1.Child, {
		as: Fragment,
		enter: "ease-in-out duration-500",
		enterFrom: "opacity-0",
		enterTo: "opacity-100",
		leave: "ease-in-out duration-500",
		leaveFrom: "opacity-100",
		leaveTo: "opacity-0"
	}, /* @__PURE__ */ React.createElement(StyledOverlay, { "data-testid": "overlay" })), /* @__PURE__ */ React.createElement(StyledDrawerContainerFixed, null, /* @__PURE__ */ React.createElement(StyledDrawerContainerAbsolute, null, /* @__PURE__ */ React.createElement(StyledDrawerPositionContainer, {
		$side: side,
		style: { height: `calc(100% - ${typeof topMargin === "string" ? topMargin : (topMargin ?? 0) + "px"} )` }
	}, /* @__PURE__ */ React.createElement(We$1.Child, {
		afterLeave: afterClose,
		as: Fragment,
		enter: "transform transition ease-in-out duration-500 sm:duration-700",
		enterFrom: (0, import_classnames.default)(enterFromAndLeaveTo),
		enterTo: (0, import_classnames.default)(enterToAndLeaveFrom),
		leave: "transform transition ease-in-out duration-500 sm:duration-700",
		leaveFrom: (0, import_classnames.default)(enterToAndLeaveFrom),
		leaveTo: (0, import_classnames.default)(enterFromAndLeaveTo)
	}, /* @__PURE__ */ React.createElement(StyledDialogPanel, { $side: side }, /* @__PURE__ */ React.createElement(StyledSideDrawer, null, header, /* @__PURE__ */ React.createElement(StyledChildrenWrapper, null, children)))))))));
};
//#endregion
//#region src/components/side-drawer/SideDrawerHeaderContent.tsx
var SideDrawerHeaderContent = ({ image, showAvatarPlaceholder, subtitle, title, withAvatar }) => {
	if (withAvatar) return /* @__PURE__ */ React.createElement(AvatarWithText, {
		imgSrc: image,
		variant: "circular",
		size: 10,
		title,
		text: showAvatarPlaceholder ? "" : title,
		subtitle
	});
	return /* @__PURE__ */ React.createElement(StyledHeaderTextWrapper, null, /* @__PURE__ */ React.createElement(StyledHeaderTitle, null, title), subtitle && /* @__PURE__ */ React.createElement(StyledHeaderSubtitle, null, subtitle));
};
//#endregion
//#region src/components/side-drawer/SideDrawerHeader.tsx
var SideDrawerHeader = ({ image, setIsOpen, showAvatarPlaceholder, subtitle, title, withAvatar }) => /* @__PURE__ */ React.createElement(StyledHeaderBar, null, /* @__PURE__ */ React.createElement(StyledHeaderContentContainer, null, /* @__PURE__ */ React.createElement(SideDrawerHeaderContent, {
	image,
	title,
	showAvatarPlaceholder,
	subtitle,
	withAvatar
}), /* @__PURE__ */ React.createElement(StyledCloseContainer, null, /* @__PURE__ */ React.createElement(Button, {
	className: "absolute right-6",
	onClick: () => setIsOpen(false),
	rounded: "regular",
	size: "xs",
	variant: "white"
}, /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, "Close panel"), /* @__PURE__ */ React.createElement(StyledCloseButtonIcon, { "aria-hidden": true })))));
//#endregion
//#region src/components/side-drawer/hooks/useSideDrawer.ts
var useSideDrawer = ({ initialOpen } = { initialOpen: false }) => {
	const [isOpen, setOpen] = useState(initialOpen);
	const toggle = () => setOpen((prevState) => !prevState);
	return {
		isOpen,
		setIsOpen: setOpen,
		toggle
	};
};
//#endregion
//#region src/components/split-view/split-view.styled.ts
var StyledSplitViewContainer = import_dist.default.div`
  flex
  w-full
  h-full
  overflow-x-hidden
`;
var StyledMainView = import_dist.default.div`
  flex-grow
  h-full
  ${({ $isResizing }) => $isResizing ? "transition-none" : "transition-all duration-500 ease-in-out"}
`;
var StyledDrawerView = import_dist.default.div`
  h-full
  ${({ $isResizing }) => $isResizing ? "transition-none" : "transition-all duration-500 ease-in-out"}
`;
var StyledDrawerInner = import_dist.default.div`
  h-full
  shadow-2xl
  bg-white
  ${({ $locked }) => $locked ? "opacity-50 pointer-events-none" : ""}
`;
//#endregion
//#region src/components/split-view/SplitView.tsx
var SplitView = ({ drawerView, fixedWidth, isOpen, locked, mainView, minWidth, onTransitionEnd, splitPercentage }) => {
	const drawerRef = useRef(null);
	useEffect(() => {
		drawerRef.current?.toggleAttribute("inert", Boolean(locked));
	}, [locked]);
	const drawerWidth = useMemo(() => {
		if (typeof fixedWidth !== "undefined") return fixedWidth;
		if (typeof splitPercentage !== "undefined") return Math.max(window.innerWidth * (splitPercentage / 100), minWidth ?? 0);
		throw new Error("Either splitPercentage or fixedWidth must be defined");
	}, [
		splitPercentage,
		minWidth,
		fixedWidth
	]);
	const [isResizing, setIsResizing] = useState(false);
	useEffect(() => {
		const handleResize = () => {
			setIsResizing(true);
			setTimeout(() => setIsResizing(false), 0);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	const drawerViewStyle = {
		marginRight: isOpen ? "0" : `-${drawerWidth}px`,
		width: `${drawerWidth}px`
	};
	const mainViewStyle = { width: isOpen ? `calc(100% - ${drawerWidth}px)` : "100%" };
	return /* @__PURE__ */ React.createElement(StyledSplitViewContainer, null, /* @__PURE__ */ React.createElement(StyledMainView, {
		$isResizing: isResizing,
		style: mainViewStyle
	}, mainView), /* @__PURE__ */ React.createElement(StyledDrawerView, {
		$isResizing: isResizing,
		style: drawerViewStyle,
		onTransitionEnd
	}, /* @__PURE__ */ React.createElement(StyledDrawerInner, {
		ref: drawerRef,
		$locked: locked
	}, drawerView)));
};
//#endregion
//#region src/components/split-view/hooks/useSplitView.ts
var INITIAL_SPLIT_PERCENTAGE = 33;
var useSplitView = ({ initialOpen = false, initialSplitPercentage = INITIAL_SPLIT_PERCENTAGE, fixedWidth } = {}) => {
	const [isOpen, setIsOpen] = useState(initialOpen);
	const [splitPercentage, setSplitPercentage] = useState(initialSplitPercentage);
	const [fixedWidthState, setFixedWidth] = useState(fixedWidth);
	return {
		isOpen,
		fixedWidth: fixedWidthState,
		splitPercentage,
		handleToggle: useCallback(() => {
			setIsOpen((prevState) => !prevState);
		}, []),
		handleSplitPercentageChange: useCallback((percentage) => {
			setSplitPercentage(percentage);
		}, []),
		handleFixedWidthChange: useCallback((width) => {
			setFixedWidth(width);
		}, []),
		setIsOpen
	};
};
//#endregion
//#region src/components/section-title/styled.ts
var StyledSectionTitle = import_dist.default.div`
    pb-5
`;
var StyledSectionTitleRow = import_dist.default.div`
    sm:flex
    sm:justify-between
`;
var LargeStyledTitle = import_dist.default.h2`
    text-3xl
    leading-9
    font-semibold
    text-gray-900
`;
var BaseStyledTitle = import_dist.default.h3`
    text-lg
    leading-6
    font-medium
    text-gray-900
`;
var StyledSectionSubtitle = import_dist.default.p`
    mt-2
    mb-0
    text-sm
    text-gray-500
`;
var StyledTrailingContent = import_dist.default.div`
${({ $alignContent }) => $alignContent === "top" ? "items-start" : "items-end"}
    mt-3
    sm:mt-0
    flex
`;
//#endregion
//#region src/components/section-title/SectionTitle.tsx
var SectionTitle = ({ alignTrailingContent = "top", className, size = "base", subtitle, title, trailingContent }) => /* @__PURE__ */ React.createElement(StyledSectionTitle, { className }, /* @__PURE__ */ React.createElement(StyledSectionTitleRow, null, /* @__PURE__ */ React.createElement("div", { className: "sm:w-0 sm:flex-1" }, size === "lg" && /* @__PURE__ */ React.createElement(LargeStyledTitle, null, title), size === "base" && /* @__PURE__ */ React.createElement(BaseStyledTitle, null, title), subtitle && /* @__PURE__ */ React.createElement(StyledSectionSubtitle, null, subtitle)), trailingContent && /* @__PURE__ */ React.createElement(StyledTrailingContent, {
	$alignContent: alignTrailingContent,
	"data-testid": "trailing-content"
}, trailingContent)));
var SectionTitleMemo = memo(SectionTitle);
//#endregion
//#region src/components/menu/actions-menu/actions-menu.styled.ts
var StyledActionsMenu = (0, import_dist.default)(Menu$1)`
  z-modal
  min-w-[248px]
  p-1
  rounded-[10px]
  bg-white
  border
  border-gray-200
  outline-none
  shadow-[0_0_0_1px_rgba(16,24,40,0.04),0_12px_24px_-8px_rgba(16,24,40,0.16),0_4px_8px_-4px_rgba(16,24,40,0.08)]
`;
var StyledActionsMenuItem = (0, import_dist.default)(MenuItem$1)`
  flex
  items-start
  gap-2.5
  px-3
  py-2.5
  rounded-md
  text-sm
  font-medium
  text-left
  text-gray-800
  cursor-pointer
  outline-none
  select-none
  transition-colors
  duration-150
  [&[data-active-item]:not([aria-disabled='true'])]:bg-primary-50
  [&[data-active-item]:not([aria-disabled='true'])]:text-primary-800
  focus-visible:ring-2
  focus-visible:ring-primary-200
  [&[aria-disabled='true']]:cursor-not-allowed
  [&[aria-disabled='true']]:text-gray-400
`;
var StyledActionsMenuItemText = import_dist.default.span`
  flex
  flex-col
  flex-1
  min-w-0
  gap-0.5
`;
var StyledActionsMenuItemLabel = import_dist.default.span`
  truncate
`;
var StyledActionsMenuItemHint = import_dist.default.span`
  text-xs
  font-normal
  text-gray-400
`;
//#endregion
//#region src/components/menu/actions-menu/ActionsMenuButton.tsx
var ActionsMenuButton = ({ actions, collapseSingleAction = false, id, label, size = "sm" }) => {
	const menuState = useMenuState({
		gutter: 6,
		placement: "bottom-end"
	});
	if (actions.length === 0) return /* @__PURE__ */ React.createElement(React.Fragment, null);
	if (collapseSingleAction && actions.length === 1) {
		const [only] = actions;
		return /* @__PURE__ */ React.createElement(Button, {
			id: only.id ?? id,
			size,
			variant: "primary",
			rounded: "regular",
			disabled: only.disabled,
			title: only.disabled ? only.hint : void 0,
			onClick: only.onSelect
		}, only.label);
	}
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
		id,
		as: MenuButton,
		state: menuState,
		size,
		variant: "primary",
		rounded: "regular"
	}, /* @__PURE__ */ React.createElement(Stack, {
		direction: "row",
		alignItems: "center",
		gap: 2
	}, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement(Icon, {
		size: 2,
		node: /* @__PURE__ */ React.createElement(Memo$8, null)
	}))), /* @__PURE__ */ React.createElement(StyledActionsMenu, {
		state: menuState,
		portal: true,
		"aria-label": label
	}, actions.map((action) => /* @__PURE__ */ React.createElement(StyledActionsMenuItem, {
		key: action.label,
		id: action.id,
		disabled: action.disabled,
		onClick: () => {
			menuState.hide();
			action.onSelect();
		}
	}, /* @__PURE__ */ React.createElement(StyledActionsMenuItemText, null, /* @__PURE__ */ React.createElement(StyledActionsMenuItemLabel, null, action.label), action.disabled && action.hint && /* @__PURE__ */ React.createElement(StyledActionsMenuItemHint, null, action.hint))))));
};
//#endregion
//#region src/components/menu/regular/Menu.tsx
var Menu = ({ children, className }) => /* @__PURE__ */ React.createElement("div", { className }, children);
var MenuMemo = memo(Menu);
//#endregion
//#region src/components/menu/menu.styled.ts
var StyledDraggableMenuItem = import_dist.default.div`
    ${({ $isDragging }) => $isDragging ? "opacity-50" : "opacity-100"}
    flex
    justify-between
    items-center
    text-gray-500
    border-t
    first:border-none
    border-gray-200
    text-sm
`;
var StyledMenuItem = import_dist.default.div`
    flex
    justify-between
    items-center
    p-4
    text-gray-500
    border-b
    border-gray-200
    text-sm
    h-14
`;
var IconAndTitle = import_dist.default.div`
    flex
    items-center
`;
var MenuItemIcon = import_dist.default.div`
    w-4
    h-4
    mr-2
    text-inherit
    focus:outline-primary-600
`;
//#endregion
//#region src/components/menu/regular/MenuItem.tsx
var MenuItem = ({ icon, title, toggle }) => /* @__PURE__ */ React.createElement(StyledMenuItem, null, /* @__PURE__ */ React.createElement(IconAndTitle, null, /* @__PURE__ */ React.createElement(MenuItemIcon, { "data-testid": `icon-${title}` }, icon), title), toggle && /* @__PURE__ */ React.createElement("div", { "data-testid": `toggle-${title}` }, /* @__PURE__ */ React.createElement(ToggleSwitch, {
	checked: toggle.checked,
	disabled: toggle.disabled,
	onChange: toggle.onChange,
	withIcon: toggle.withIcon
})));
var MenuItemMemo = memo(MenuItem);
//#endregion
//#region ../../node_modules/@dnd-kit/utilities/dist/utilities.esm.js
function useCombinedRefs() {
	for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) refs[_key] = arguments[_key];
	return useMemo(() => (node) => {
		refs.forEach((ref) => ref(node));
	}, refs);
}
var canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function isWindow(element) {
	const elementString = Object.prototype.toString.call(element);
	return elementString === "[object Window]" || elementString === "[object global]";
}
function isNode(node) {
	return "nodeType" in node;
}
function getWindow(target) {
	var _target$ownerDocument, _target$ownerDocument2;
	if (!target) return window;
	if (isWindow(target)) return target;
	if (!isNode(target)) return window;
	return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node) {
	const { Document } = getWindow(node);
	return node instanceof Document;
}
function isHTMLElement(node) {
	if (isWindow(node)) return false;
	return node instanceof getWindow(node).HTMLElement;
}
function isSVGElement(node) {
	return node instanceof getWindow(node).SVGElement;
}
function getOwnerDocument(target) {
	if (!target) return document;
	if (isWindow(target)) return target.document;
	if (!isNode(target)) return document;
	if (isDocument(target)) return target;
	if (isHTMLElement(target)) return target.ownerDocument;
	return document;
}
/**
* A hook that resolves to useEffect on the server and useLayoutEffect on the client
* @param callback {function} Callback function that is invoked when the dependencies of the hook change
*/
var useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;
function useEvent(handler) {
	const handlerRef = useRef(handler);
	useIsomorphicLayoutEffect(() => {
		handlerRef.current = handler;
	});
	return useCallback(function() {
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		return handlerRef.current == null ? void 0 : handlerRef.current(...args);
	}, []);
}
function useInterval() {
	const intervalRef = useRef(null);
	return [useCallback((listener, duration) => {
		intervalRef.current = setInterval(listener, duration);
	}, []), useCallback(() => {
		if (intervalRef.current !== null) {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		}
	}, [])];
}
function useLatestValue(value, dependencies) {
	if (dependencies === void 0) dependencies = [value];
	const valueRef = useRef(value);
	useIsomorphicLayoutEffect(() => {
		if (valueRef.current !== value) valueRef.current = value;
	}, dependencies);
	return valueRef;
}
function useLazyMemo(callback, dependencies) {
	const valueRef = useRef();
	return useMemo(() => {
		const newValue = callback(valueRef.current);
		valueRef.current = newValue;
		return newValue;
	}, [...dependencies]);
}
function useNodeRef(onChange) {
	const onChangeHandler = useEvent(onChange);
	const node = useRef(null);
	return [node, useCallback((element) => {
		if (element !== node.current) onChangeHandler?.(element, node.current);
		node.current = element;
	}, [])];
}
function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
}
var ids = {};
function useUniqueId(prefix, value) {
	return useMemo(() => {
		if (value) return value;
		const id = ids[prefix] == null ? 0 : ids[prefix] + 1;
		ids[prefix] = id;
		return prefix + "-" + id;
	}, [prefix, value]);
}
function createAdjustmentFn(modifier) {
	return function(object) {
		for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) adjustments[_key - 1] = arguments[_key];
		return adjustments.reduce((accumulator, adjustment) => {
			const entries = Object.entries(adjustment);
			for (const [key, valueAdjustment] of entries) {
				const value = accumulator[key];
				if (value != null) accumulator[key] = value + modifier * valueAdjustment;
			}
			return accumulator;
		}, { ...object });
	};
}
var add = /*#__PURE__*/ createAdjustmentFn(1);
var subtract = /*#__PURE__*/ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
	return "clientX" in event && "clientY" in event;
}
function isKeyboardEvent(event) {
	if (!event) return false;
	const { KeyboardEvent } = getWindow(event.target);
	return KeyboardEvent && event instanceof KeyboardEvent;
}
function isTouchEvent(event) {
	if (!event) return false;
	const { TouchEvent } = getWindow(event.target);
	return TouchEvent && event instanceof TouchEvent;
}
/**
* Returns the normalized x and y coordinates for mouse and touch events.
*/
function getEventCoordinates(event) {
	if (isTouchEvent(event)) {
		if (event.touches && event.touches.length) {
			const { clientX: x, clientY: y } = event.touches[0];
			return {
				x,
				y
			};
		} else if (event.changedTouches && event.changedTouches.length) {
			const { clientX: x, clientY: y } = event.changedTouches[0];
			return {
				x,
				y
			};
		}
	}
	if (hasViewportRelativeCoordinates(event)) return {
		x: event.clientX,
		y: event.clientY
	};
	return null;
}
var CSS$1 = /*#__PURE__*/ Object.freeze({
	Translate: { toString(transform) {
		if (!transform) return;
		const { x, y } = transform;
		return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
	} },
	Scale: { toString(transform) {
		if (!transform) return;
		const { scaleX, scaleY } = transform;
		return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
	} },
	Transform: { toString(transform) {
		if (!transform) return;
		return [CSS$1.Translate.toString(transform), CSS$1.Scale.toString(transform)].join(" ");
	} },
	Transition: { toString(_ref) {
		let { property, duration, easing } = _ref;
		return property + " " + duration + "ms " + easing;
	} }
});
var SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(element) {
	if (element.matches(SELECTOR)) return element;
	return element.querySelector(SELECTOR);
}
//#endregion
//#region ../../node_modules/@dnd-kit/accessibility/dist/accessibility.esm.js
var hiddenStyles = { display: "none" };
function HiddenText(_ref) {
	let { id, value } = _ref;
	return React.createElement("div", {
		id,
		style: hiddenStyles
	}, value);
}
var visuallyHidden = {
	position: "fixed",
	width: 1,
	height: 1,
	margin: -1,
	border: 0,
	padding: 0,
	overflow: "hidden",
	clip: "rect(0 0 0 0)",
	clipPath: "inset(100%)",
	whiteSpace: "nowrap"
};
function LiveRegion(_ref) {
	let { id, announcement } = _ref;
	return React.createElement("div", {
		id,
		style: visuallyHidden,
		role: "status",
		"aria-live": "assertive",
		"aria-atomic": true
	}, announcement);
}
function useAnnouncement() {
	const [announcement, setAnnouncement] = useState("");
	return {
		announce: useCallback((value) => {
			if (value != null) setAnnouncement(value);
		}, []),
		announcement
	};
}
//#endregion
//#region ../../node_modules/@dnd-kit/core/dist/core.esm.js
var DndMonitorContext = /*#__PURE__*/ createContext(null);
function useDndMonitor(listener) {
	const registerListener = useContext(DndMonitorContext);
	useEffect(() => {
		if (!registerListener) throw new Error("useDndMonitor must be used within a children of <DndContext>");
		return registerListener(listener);
	}, [listener, registerListener]);
}
function useDndMonitorProvider() {
	const [listeners] = useState(() => /* @__PURE__ */ new Set());
	const registerListener = useCallback((listener) => {
		listeners.add(listener);
		return () => listeners.delete(listener);
	}, [listeners]);
	return [useCallback((_ref) => {
		let { type, event } = _ref;
		listeners.forEach((listener) => {
			var _listener$type;
			return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
		});
	}, [listeners]), registerListener];
}
var defaultScreenReaderInstructions = { draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  " };
var defaultAnnouncements = {
	onDragStart(_ref) {
		let { active } = _ref;
		return "Picked up draggable item " + active.id + ".";
	},
	onDragOver(_ref2) {
		let { active, over } = _ref2;
		if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
		return "Draggable item " + active.id + " is no longer over a droppable area.";
	},
	onDragEnd(_ref3) {
		let { active, over } = _ref3;
		if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
		return "Draggable item " + active.id + " was dropped.";
	},
	onDragCancel(_ref4) {
		let { active } = _ref4;
		return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
	}
};
function Accessibility(_ref) {
	let { announcements = defaultAnnouncements, container, hiddenTextDescribedById, screenReaderInstructions = defaultScreenReaderInstructions } = _ref;
	const { announce, announcement } = useAnnouncement();
	const liveRegionId = useUniqueId("DndLiveRegion");
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		setMounted(true);
	}, []);
	useDndMonitor(useMemo(() => ({
		onDragStart(_ref2) {
			let { active } = _ref2;
			announce(announcements.onDragStart({ active }));
		},
		onDragMove(_ref3) {
			let { active, over } = _ref3;
			if (announcements.onDragMove) announce(announcements.onDragMove({
				active,
				over
			}));
		},
		onDragOver(_ref4) {
			let { active, over } = _ref4;
			announce(announcements.onDragOver({
				active,
				over
			}));
		},
		onDragEnd(_ref5) {
			let { active, over } = _ref5;
			announce(announcements.onDragEnd({
				active,
				over
			}));
		},
		onDragCancel(_ref6) {
			let { active, over } = _ref6;
			announce(announcements.onDragCancel({
				active,
				over
			}));
		}
	}), [announce, announcements]));
	if (!mounted) return null;
	const markup = React.createElement(React.Fragment, null, React.createElement(HiddenText, {
		id: hiddenTextDescribedById,
		value: screenReaderInstructions.draggable
	}), React.createElement(LiveRegion, {
		id: liveRegionId,
		announcement
	}));
	return container ? createPortal(markup, container) : markup;
}
var Action;
(function(Action) {
	Action["DragStart"] = "dragStart";
	Action["DragMove"] = "dragMove";
	Action["DragEnd"] = "dragEnd";
	Action["DragCancel"] = "dragCancel";
	Action["DragOver"] = "dragOver";
	Action["RegisterDroppable"] = "registerDroppable";
	Action["SetDroppableDisabled"] = "setDroppableDisabled";
	Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop() {}
function useSensor(sensor, options) {
	return useMemo(() => ({
		sensor,
		options: options != null ? options : {}
	}), [sensor, options]);
}
var defaultCoordinates = /*#__PURE__*/ Object.freeze({
	x: 0,
	y: 0
});
/**
* Returns the distance between two points
*/
function distanceBetween(p1, p2) {
	return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
/**
* Sort collisions from smallest to greatest value
*/
function sortCollisionsAsc(_ref, _ref2) {
	let { data: { value: a } } = _ref;
	let { data: { value: b } } = _ref2;
	return a - b;
}
/**
* Sort collisions from greatest to smallest value
*/
function sortCollisionsDesc(_ref3, _ref4) {
	let { data: { value: a } } = _ref3;
	let { data: { value: b } } = _ref4;
	return b - a;
}
function getFirstCollision(collisions, property) {
	if (!collisions || collisions.length === 0) return null;
	const [firstCollision] = collisions;
	return property ? firstCollision[property] : firstCollision;
}
/**
* Returns the coordinates of the center of a given ClientRect
*/
function centerOfRectangle(rect, left, top) {
	if (left === void 0) left = rect.left;
	if (top === void 0) top = rect.top;
	return {
		x: left + rect.width * .5,
		y: top + rect.height * .5
	};
}
/**
* Returns the closest rectangles from an array of rectangles to the center of a given
* rectangle.
*/
var closestCenter = (_ref) => {
	let { collisionRect, droppableRects, droppableContainers } = _ref;
	const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
	const collisions = [];
	for (const droppableContainer of droppableContainers) {
		const { id } = droppableContainer;
		const rect = droppableRects.get(id);
		if (rect) {
			const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
			collisions.push({
				id,
				data: {
					droppableContainer,
					value: distBetween
				}
			});
		}
	}
	return collisions.sort(sortCollisionsAsc);
};
/**
* Returns the intersecting rectangle area between two rectangles
*/
function getIntersectionRatio(entry, target) {
	const top = Math.max(target.top, entry.top);
	const left = Math.max(target.left, entry.left);
	const right = Math.min(target.left + target.width, entry.left + entry.width);
	const bottom = Math.min(target.top + target.height, entry.top + entry.height);
	const width = right - left;
	const height = bottom - top;
	if (left < right && top < bottom) {
		const targetArea = target.width * target.height;
		const entryArea = entry.width * entry.height;
		const intersectionArea = width * height;
		const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
		return Number(intersectionRatio.toFixed(4));
	}
	return 0;
}
/**
* Returns the rectangles that has the greatest intersection area with a given
* rectangle in an array of rectangles.
*/
var rectIntersection = (_ref) => {
	let { collisionRect, droppableRects, droppableContainers } = _ref;
	const collisions = [];
	for (const droppableContainer of droppableContainers) {
		const { id } = droppableContainer;
		const rect = droppableRects.get(id);
		if (rect) {
			const intersectionRatio = getIntersectionRatio(rect, collisionRect);
			if (intersectionRatio > 0) collisions.push({
				id,
				data: {
					droppableContainer,
					value: intersectionRatio
				}
			});
		}
	}
	return collisions.sort(sortCollisionsDesc);
};
function adjustScale(transform, rect1, rect2) {
	return {
		...transform,
		scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
		scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
	};
}
function getRectDelta(rect1, rect2) {
	return rect1 && rect2 ? {
		x: rect1.left - rect2.left,
		y: rect1.top - rect2.top
	} : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
	return function adjustClientRect(rect) {
		for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) adjustments[_key - 1] = arguments[_key];
		return adjustments.reduce((acc, adjustment) => ({
			...acc,
			top: acc.top + modifier * adjustment.y,
			bottom: acc.bottom + modifier * adjustment.y,
			left: acc.left + modifier * adjustment.x,
			right: acc.right + modifier * adjustment.x
		}), { ...rect });
	};
}
var getAdjustedRect = /*#__PURE__*/ createRectAdjustmentFn(1);
function parseTransform(transform) {
	if (transform.startsWith("matrix3d(")) {
		const transformArray = transform.slice(9, -1).split(/, /);
		return {
			x: +transformArray[12],
			y: +transformArray[13],
			scaleX: +transformArray[0],
			scaleY: +transformArray[5]
		};
	} else if (transform.startsWith("matrix(")) {
		const transformArray = transform.slice(7, -1).split(/, /);
		return {
			x: +transformArray[4],
			y: +transformArray[5],
			scaleX: +transformArray[0],
			scaleY: +transformArray[3]
		};
	}
	return null;
}
function inverseTransform(rect, transform, transformOrigin) {
	const parsedTransform = parseTransform(transform);
	if (!parsedTransform) return rect;
	const { scaleX, scaleY, x: translateX, y: translateY } = parsedTransform;
	const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
	const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
	const w = scaleX ? rect.width / scaleX : rect.width;
	const h = scaleY ? rect.height / scaleY : rect.height;
	return {
		width: w,
		height: h,
		top: y,
		right: x + w,
		bottom: y + h,
		left: x
	};
}
var defaultOptions = { ignoreTransform: false };
/**
* Returns the bounding client rect of an element relative to the viewport.
*/
function getClientRect(element, options) {
	if (options === void 0) options = defaultOptions;
	let rect = element.getBoundingClientRect();
	if (options.ignoreTransform) {
		const { getComputedStyle } = getWindow(element);
		const { transform, transformOrigin } = getComputedStyle(element);
		if (transform) rect = inverseTransform(rect, transform, transformOrigin);
	}
	const { top, left, width, height, bottom, right } = rect;
	return {
		top,
		left,
		width,
		height,
		bottom,
		right
	};
}
/**
* Returns the bounding client rect of an element relative to the viewport.
*
* @remarks
* The ClientRect returned by this method does not take into account transforms
* applied to the element it measures.
*
*/
function getTransformAgnosticClientRect(element) {
	return getClientRect(element, { ignoreTransform: true });
}
function getWindowClientRect(element) {
	const width = element.innerWidth;
	const height = element.innerHeight;
	return {
		top: 0,
		left: 0,
		right: width,
		bottom: height,
		width,
		height
	};
}
function isFixed(node, computedStyle) {
	if (computedStyle === void 0) computedStyle = getWindow(node).getComputedStyle(node);
	return computedStyle.position === "fixed";
}
function isScrollable(element, computedStyle) {
	if (computedStyle === void 0) computedStyle = getWindow(element).getComputedStyle(element);
	const overflowRegex = /(auto|scroll|overlay)/;
	return [
		"overflow",
		"overflowX",
		"overflowY"
	].some((property) => {
		const value = computedStyle[property];
		return typeof value === "string" ? overflowRegex.test(value) : false;
	});
}
function getScrollableAncestors(element, limit) {
	const scrollParents = [];
	function findScrollableAncestors(node) {
		if (limit != null && scrollParents.length >= limit) return scrollParents;
		if (!node) return scrollParents;
		if (isDocument(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
			scrollParents.push(node.scrollingElement);
			return scrollParents;
		}
		if (!isHTMLElement(node) || isSVGElement(node)) return scrollParents;
		if (scrollParents.includes(node)) return scrollParents;
		const { getComputedStyle } = getWindow(node);
		const computedStyle = getComputedStyle(node);
		if (node !== element) {
			if (isScrollable(node, computedStyle)) scrollParents.push(node);
		}
		if (isFixed(node, computedStyle)) return scrollParents;
		return findScrollableAncestors(node.parentNode);
	}
	if (!element) return scrollParents;
	return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
	const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
	return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
	if (!canUseDOM || !element) return null;
	if (isWindow(element)) return element;
	if (!isNode(element)) return null;
	if (isDocument(element) || element === getOwnerDocument(element).scrollingElement) return window;
	if (isHTMLElement(element)) return element;
	return null;
}
function getScrollXCoordinate(element) {
	if (isWindow(element)) return element.scrollX;
	return element.scrollLeft;
}
function getScrollYCoordinate(element) {
	if (isWindow(element)) return element.scrollY;
	return element.scrollTop;
}
function getScrollCoordinates(element) {
	return {
		x: getScrollXCoordinate(element),
		y: getScrollYCoordinate(element)
	};
}
var Direction;
(function(Direction) {
	Direction[Direction["Forward"] = 1] = "Forward";
	Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
	if (!canUseDOM || !element) return false;
	return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
	const minScroll = {
		x: 0,
		y: 0
	};
	const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
		height: window.innerHeight,
		width: window.innerWidth
	} : {
		height: scrollingContainer.clientHeight,
		width: scrollingContainer.clientWidth
	};
	const maxScroll = {
		x: scrollingContainer.scrollWidth - dimensions.width,
		y: scrollingContainer.scrollHeight - dimensions.height
	};
	return {
		isTop: scrollingContainer.scrollTop <= minScroll.y,
		isLeft: scrollingContainer.scrollLeft <= minScroll.x,
		isBottom: scrollingContainer.scrollTop >= maxScroll.y,
		isRight: scrollingContainer.scrollLeft >= maxScroll.x,
		maxScroll,
		minScroll
	};
}
var defaultThreshold = {
	x: .2,
	y: .2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
	let { top, left, right, bottom } = _ref;
	if (acceleration === void 0) acceleration = 10;
	if (thresholdPercentage === void 0) thresholdPercentage = defaultThreshold;
	const { isTop, isBottom, isLeft, isRight } = getScrollPosition(scrollContainer);
	const direction = {
		x: 0,
		y: 0
	};
	const speed = {
		x: 0,
		y: 0
	};
	const threshold = {
		height: scrollContainerRect.height * thresholdPercentage.y,
		width: scrollContainerRect.width * thresholdPercentage.x
	};
	if (!isTop && top <= scrollContainerRect.top + threshold.height) {
		direction.y = Direction.Backward;
		speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
	} else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
		direction.y = Direction.Forward;
		speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
	}
	if (!isRight && right >= scrollContainerRect.right - threshold.width) {
		direction.x = Direction.Forward;
		speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
	} else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
		direction.x = Direction.Backward;
		speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
	}
	return {
		direction,
		speed
	};
}
function getScrollElementRect(element) {
	if (element === document.scrollingElement) {
		const { innerWidth, innerHeight } = window;
		return {
			top: 0,
			left: 0,
			right: innerWidth,
			bottom: innerHeight,
			width: innerWidth,
			height: innerHeight
		};
	}
	const { top, left, right, bottom } = element.getBoundingClientRect();
	return {
		top,
		left,
		right,
		bottom,
		width: element.clientWidth,
		height: element.clientHeight
	};
}
function getScrollOffsets(scrollableAncestors) {
	return scrollableAncestors.reduce((acc, node) => {
		return add(acc, getScrollCoordinates(node));
	}, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
	return scrollableAncestors.reduce((acc, node) => {
		return acc + getScrollXCoordinate(node);
	}, 0);
}
function getScrollYOffset(scrollableAncestors) {
	return scrollableAncestors.reduce((acc, node) => {
		return acc + getScrollYCoordinate(node);
	}, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
	if (measure === void 0) measure = getClientRect;
	if (!element) return;
	const { top, left, bottom, right } = measure(element);
	if (!getFirstScrollableAncestor(element)) return;
	if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
		block: "center",
		inline: "center"
	});
}
var properties = [[
	"x",
	["left", "right"],
	getScrollXOffset
], [
	"y",
	["top", "bottom"],
	getScrollYOffset
]];
var Rect = class {
	constructor(rect, element) {
		this.rect = void 0;
		this.width = void 0;
		this.height = void 0;
		this.top = void 0;
		this.bottom = void 0;
		this.right = void 0;
		this.left = void 0;
		const scrollableAncestors = getScrollableAncestors(element);
		const scrollOffsets = getScrollOffsets(scrollableAncestors);
		this.rect = { ...rect };
		this.width = rect.width;
		this.height = rect.height;
		for (const [axis, keys, getScrollOffset] of properties) for (const key of keys) Object.defineProperty(this, key, {
			get: () => {
				const currentOffsets = getScrollOffset(scrollableAncestors);
				const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
				return this.rect[key] + scrollOffsetsDeltla;
			},
			enumerable: true
		});
		Object.defineProperty(this, "rect", { enumerable: false });
	}
};
var Listeners = class {
	constructor(target) {
		this.target = void 0;
		this.listeners = [];
		this.removeAll = () => {
			this.listeners.forEach((listener) => {
				var _this$target;
				return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
			});
		};
		this.target = target;
	}
	add(eventName, handler, options) {
		var _this$target2;
		(_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
		this.listeners.push([
			eventName,
			handler,
			options
		]);
	}
};
function getEventListenerTarget(target) {
	const { EventTarget } = getWindow(target);
	return target instanceof EventTarget ? target : getOwnerDocument(target);
}
function hasExceededDistance(delta, measurement) {
	const dx = Math.abs(delta.x);
	const dy = Math.abs(delta.y);
	if (typeof measurement === "number") return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
	if ("x" in measurement && "y" in measurement) return dx > measurement.x && dy > measurement.y;
	if ("x" in measurement) return dx > measurement.x;
	if ("y" in measurement) return dy > measurement.y;
	return false;
}
var EventName;
(function(EventName) {
	EventName["Click"] = "click";
	EventName["DragStart"] = "dragstart";
	EventName["Keydown"] = "keydown";
	EventName["ContextMenu"] = "contextmenu";
	EventName["Resize"] = "resize";
	EventName["SelectionChange"] = "selectionchange";
	EventName["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
	event.preventDefault();
}
function stopPropagation(event) {
	event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode) {
	KeyboardCode["Space"] = "Space";
	KeyboardCode["Down"] = "ArrowDown";
	KeyboardCode["Right"] = "ArrowRight";
	KeyboardCode["Left"] = "ArrowLeft";
	KeyboardCode["Up"] = "ArrowUp";
	KeyboardCode["Esc"] = "Escape";
	KeyboardCode["Enter"] = "Enter";
})(KeyboardCode || (KeyboardCode = {}));
var defaultKeyboardCodes = {
	start: [KeyboardCode.Space, KeyboardCode.Enter],
	cancel: [KeyboardCode.Esc],
	end: [KeyboardCode.Space, KeyboardCode.Enter]
};
var defaultKeyboardCoordinateGetter = (event, _ref) => {
	let { currentCoordinates } = _ref;
	switch (event.code) {
		case KeyboardCode.Right: return {
			...currentCoordinates,
			x: currentCoordinates.x + 25
		};
		case KeyboardCode.Left: return {
			...currentCoordinates,
			x: currentCoordinates.x - 25
		};
		case KeyboardCode.Down: return {
			...currentCoordinates,
			y: currentCoordinates.y + 25
		};
		case KeyboardCode.Up: return {
			...currentCoordinates,
			y: currentCoordinates.y - 25
		};
	}
};
var KeyboardSensor = class {
	constructor(props) {
		this.props = void 0;
		this.autoScrollEnabled = false;
		this.referenceCoordinates = void 0;
		this.listeners = void 0;
		this.windowListeners = void 0;
		this.props = props;
		const { event: { target } } = props;
		this.props = props;
		this.listeners = new Listeners(getOwnerDocument(target));
		this.windowListeners = new Listeners(getWindow(target));
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.attach();
	}
	attach() {
		this.handleStart();
		this.windowListeners.add(EventName.Resize, this.handleCancel);
		this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
		setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
	}
	handleStart() {
		const { activeNode, onStart } = this.props;
		const node = activeNode.node.current;
		if (node) scrollIntoViewIfNeeded(node);
		onStart(defaultCoordinates);
	}
	handleKeyDown(event) {
		if (isKeyboardEvent(event)) {
			const { active, context, options } = this.props;
			const { keyboardCodes = defaultKeyboardCodes, coordinateGetter = defaultKeyboardCoordinateGetter, scrollBehavior = "smooth" } = options;
			const { code } = event;
			if (keyboardCodes.end.includes(code)) {
				this.handleEnd(event);
				return;
			}
			if (keyboardCodes.cancel.includes(code)) {
				this.handleCancel(event);
				return;
			}
			const { collisionRect } = context.current;
			const currentCoordinates = collisionRect ? {
				x: collisionRect.left,
				y: collisionRect.top
			} : defaultCoordinates;
			if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
			const newCoordinates = coordinateGetter(event, {
				active,
				context: context.current,
				currentCoordinates
			});
			if (newCoordinates) {
				const coordinatesDelta = subtract(newCoordinates, currentCoordinates);
				const scrollDelta = {
					x: 0,
					y: 0
				};
				const { scrollableAncestors } = context.current;
				for (const scrollContainer of scrollableAncestors) {
					const direction = event.code;
					const { isTop, isRight, isLeft, isBottom, maxScroll, minScroll } = getScrollPosition(scrollContainer);
					const scrollElementRect = getScrollElementRect(scrollContainer);
					const clampedCoordinates = {
						x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
						y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
					};
					const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
					const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
					if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
						const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
						const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
						if (canScrollToNewCoordinates && !coordinatesDelta.y) {
							scrollContainer.scrollTo({
								left: newScrollCoordinates,
								behavior: scrollBehavior
							});
							return;
						}
						if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
						else scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
						if (scrollDelta.x) scrollContainer.scrollBy({
							left: -scrollDelta.x,
							behavior: scrollBehavior
						});
						break;
					} else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
						const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
						const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
						if (canScrollToNewCoordinates && !coordinatesDelta.x) {
							scrollContainer.scrollTo({
								top: newScrollCoordinates,
								behavior: scrollBehavior
							});
							return;
						}
						if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
						else scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
						if (scrollDelta.y) scrollContainer.scrollBy({
							top: -scrollDelta.y,
							behavior: scrollBehavior
						});
						break;
					}
				}
				this.handleMove(event, add(subtract(newCoordinates, this.referenceCoordinates), scrollDelta));
			}
		}
	}
	handleMove(event, coordinates) {
		const { onMove } = this.props;
		event.preventDefault();
		onMove(coordinates);
	}
	handleEnd(event) {
		const { onEnd } = this.props;
		event.preventDefault();
		this.detach();
		onEnd();
	}
	handleCancel(event) {
		const { onCancel } = this.props;
		event.preventDefault();
		this.detach();
		onCancel();
	}
	detach() {
		this.listeners.removeAll();
		this.windowListeners.removeAll();
	}
};
KeyboardSensor.activators = [{
	eventName: "onKeyDown",
	handler: (event, _ref, _ref2) => {
		let { keyboardCodes = defaultKeyboardCodes, onActivation } = _ref;
		let { active } = _ref2;
		const { code } = event.nativeEvent;
		if (keyboardCodes.start.includes(code)) {
			const activator = active.activatorNode.current;
			if (activator && event.target !== activator) return false;
			event.preventDefault();
			onActivation?.({ event: event.nativeEvent });
			return true;
		}
		return false;
	}
}];
function isDistanceConstraint(constraint) {
	return Boolean(constraint && "distance" in constraint);
}
function isDelayConstraint(constraint) {
	return Boolean(constraint && "delay" in constraint);
}
var AbstractPointerSensor = class {
	constructor(props, events, listenerTarget) {
		var _getEventCoordinates;
		if (listenerTarget === void 0) listenerTarget = getEventListenerTarget(props.event.target);
		this.props = void 0;
		this.events = void 0;
		this.autoScrollEnabled = true;
		this.document = void 0;
		this.activated = false;
		this.initialCoordinates = void 0;
		this.timeoutId = null;
		this.listeners = void 0;
		this.documentListeners = void 0;
		this.windowListeners = void 0;
		this.props = props;
		this.events = events;
		const { event } = props;
		const { target } = event;
		this.props = props;
		this.events = events;
		this.document = getOwnerDocument(target);
		this.documentListeners = new Listeners(this.document);
		this.listeners = new Listeners(listenerTarget);
		this.windowListeners = new Listeners(getWindow(target));
		this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
		this.handleStart = this.handleStart.bind(this);
		this.handleMove = this.handleMove.bind(this);
		this.handleEnd = this.handleEnd.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleKeydown = this.handleKeydown.bind(this);
		this.removeTextSelection = this.removeTextSelection.bind(this);
		this.attach();
	}
	attach() {
		const { events, props: { options: { activationConstraint } } } = this;
		this.listeners.add(events.move.name, this.handleMove, { passive: false });
		this.listeners.add(events.end.name, this.handleEnd);
		this.windowListeners.add(EventName.Resize, this.handleCancel);
		this.windowListeners.add(EventName.DragStart, preventDefault);
		this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
		this.windowListeners.add(EventName.ContextMenu, preventDefault);
		this.documentListeners.add(EventName.Keydown, this.handleKeydown);
		if (activationConstraint) {
			if (isDistanceConstraint(activationConstraint)) return;
			if (isDelayConstraint(activationConstraint)) {
				this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
				return;
			}
		}
		this.handleStart();
	}
	detach() {
		this.listeners.removeAll();
		this.windowListeners.removeAll();
		setTimeout(this.documentListeners.removeAll, 50);
		if (this.timeoutId !== null) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
	}
	handleStart() {
		const { initialCoordinates } = this;
		const { onStart } = this.props;
		if (initialCoordinates) {
			this.activated = true;
			this.documentListeners.add(EventName.Click, stopPropagation, { capture: true });
			this.removeTextSelection();
			this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
			onStart(initialCoordinates);
		}
	}
	handleMove(event) {
		var _getEventCoordinates2;
		const { activated, initialCoordinates, props } = this;
		const { onMove, options: { activationConstraint } } = props;
		if (!initialCoordinates) return;
		const coordinates = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
		const delta = subtract(initialCoordinates, coordinates);
		if (!activated && activationConstraint) {
			if (isDelayConstraint(activationConstraint)) {
				if (hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
				return;
			}
			if (isDistanceConstraint(activationConstraint)) {
				if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
				if (hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
				return;
			}
		}
		if (event.cancelable) event.preventDefault();
		onMove(coordinates);
	}
	handleEnd() {
		const { onEnd } = this.props;
		this.detach();
		onEnd();
	}
	handleCancel() {
		const { onCancel } = this.props;
		this.detach();
		onCancel();
	}
	handleKeydown(event) {
		if (event.code === KeyboardCode.Esc) this.handleCancel();
	}
	removeTextSelection() {
		var _this$document$getSel;
		(_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
	}
};
var events = {
	move: { name: "pointermove" },
	end: { name: "pointerup" }
};
var PointerSensor = class extends AbstractPointerSensor {
	constructor(props) {
		const { event } = props;
		const listenerTarget = getOwnerDocument(event.target);
		super(props, events, listenerTarget);
	}
};
PointerSensor.activators = [{
	eventName: "onPointerDown",
	handler: (_ref, _ref2) => {
		let { nativeEvent: event } = _ref;
		let { onActivation } = _ref2;
		if (!event.isPrimary || event.button !== 0) return false;
		onActivation?.({ event });
		return true;
	}
}];
var events$1 = {
	move: { name: "mousemove" },
	end: { name: "mouseup" }
};
var MouseButton;
(function(MouseButton) {
	MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
var MouseSensor = class extends AbstractPointerSensor {
	constructor(props) {
		super(props, events$1, getOwnerDocument(props.event.target));
	}
};
MouseSensor.activators = [{
	eventName: "onMouseDown",
	handler: (_ref, _ref2) => {
		let { nativeEvent: event } = _ref;
		let { onActivation } = _ref2;
		if (event.button === MouseButton.RightClick) return false;
		onActivation?.({ event });
		return true;
	}
}];
var events$2 = {
	move: { name: "touchmove" },
	end: { name: "touchend" }
};
var TouchSensor = class extends AbstractPointerSensor {
	constructor(props) {
		super(props, events$2);
	}
	static setup() {
		window.addEventListener(events$2.move.name, noop, {
			capture: false,
			passive: false
		});
		return function teardown() {
			window.removeEventListener(events$2.move.name, noop);
		};
		function noop() {}
	}
};
TouchSensor.activators = [{
	eventName: "onTouchStart",
	handler: (_ref, _ref2) => {
		let { nativeEvent: event } = _ref;
		let { onActivation } = _ref2;
		const { touches } = event;
		if (touches.length > 1) return false;
		onActivation?.({ event });
		return true;
	}
}];
var AutoScrollActivator;
(function(AutoScrollActivator) {
	AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
	AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder) {
	TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
	TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
	let { acceleration, activator = AutoScrollActivator.Pointer, canScroll, draggingRect, enabled, interval = 5, order = TraversalOrder.TreeOrder, pointerCoordinates, scrollableAncestors, scrollableAncestorRects, delta, threshold } = _ref;
	const scrollIntent = useScrollIntent({
		delta,
		disabled: !enabled
	});
	const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
	const scrollSpeed = useRef({
		x: 0,
		y: 0
	});
	const scrollDirection = useRef({
		x: 0,
		y: 0
	});
	const rect = useMemo(() => {
		switch (activator) {
			case AutoScrollActivator.Pointer: return pointerCoordinates ? {
				top: pointerCoordinates.y,
				bottom: pointerCoordinates.y,
				left: pointerCoordinates.x,
				right: pointerCoordinates.x
			} : null;
			case AutoScrollActivator.DraggableRect: return draggingRect;
		}
	}, [
		activator,
		draggingRect,
		pointerCoordinates
	]);
	const scrollContainerRef = useRef(null);
	const autoScroll = useCallback(() => {
		const scrollContainer = scrollContainerRef.current;
		if (!scrollContainer) return;
		const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
		const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
		scrollContainer.scrollBy(scrollLeft, scrollTop);
	}, []);
	const sortedScrollableAncestors = useMemo(() => order === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order, scrollableAncestors]);
	useEffect(() => {
		if (!enabled || !scrollableAncestors.length || !rect) {
			clearAutoScrollInterval();
			return;
		}
		for (const scrollContainer of sortedScrollableAncestors) {
			if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
			const index = scrollableAncestors.indexOf(scrollContainer);
			const scrollContainerRect = scrollableAncestorRects[index];
			if (!scrollContainerRect) continue;
			const { direction, speed } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
			for (const axis of ["x", "y"]) if (!scrollIntent[axis][direction[axis]]) {
				speed[axis] = 0;
				direction[axis] = 0;
			}
			if (speed.x > 0 || speed.y > 0) {
				clearAutoScrollInterval();
				scrollContainerRef.current = scrollContainer;
				setAutoScrollInterval(autoScroll, interval);
				scrollSpeed.current = speed;
				scrollDirection.current = direction;
				return;
			}
		}
		scrollSpeed.current = {
			x: 0,
			y: 0
		};
		scrollDirection.current = {
			x: 0,
			y: 0
		};
		clearAutoScrollInterval();
	}, [
		acceleration,
		autoScroll,
		canScroll,
		clearAutoScrollInterval,
		enabled,
		interval,
		JSON.stringify(rect),
		JSON.stringify(scrollIntent),
		setAutoScrollInterval,
		scrollableAncestors,
		sortedScrollableAncestors,
		scrollableAncestorRects,
		JSON.stringify(threshold)
	]);
}
var defaultScrollIntent = {
	x: {
		[Direction.Backward]: false,
		[Direction.Forward]: false
	},
	y: {
		[Direction.Backward]: false,
		[Direction.Forward]: false
	}
};
function useScrollIntent(_ref2) {
	let { delta, disabled } = _ref2;
	const previousDelta = usePrevious(delta);
	return useLazyMemo((previousIntent) => {
		if (disabled || !previousDelta || !previousIntent) return defaultScrollIntent;
		const direction = {
			x: Math.sign(delta.x - previousDelta.x),
			y: Math.sign(delta.y - previousDelta.y)
		};
		return {
			x: {
				[Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
				[Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
			},
			y: {
				[Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
				[Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
			}
		};
	}, [
		disabled,
		delta,
		previousDelta
	]);
}
function useCachedNode(draggableNodes, id) {
	const draggableNode = id !== null ? draggableNodes.get(id) : void 0;
	const node = draggableNode ? draggableNode.node.current : null;
	return useLazyMemo((cachedNode) => {
		var _ref;
		if (id === null) return null;
		return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
	}, [node, id]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
	return useMemo(() => sensors.reduce((accumulator, sensor) => {
		const { sensor: Sensor } = sensor;
		const sensorActivators = Sensor.activators.map((activator) => ({
			eventName: activator.eventName,
			handler: getSyntheticHandler(activator.handler, sensor)
		}));
		return [...accumulator, ...sensorActivators];
	}, []), [sensors, getSyntheticHandler]);
}
var MeasuringStrategy;
(function(MeasuringStrategy) {
	MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
	MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
	MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency) {
	MeasuringFrequency["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
var defaultValue = /*#__PURE__*/ new Map();
function useDroppableMeasuring(containers, _ref) {
	let { dragging, dependencies, config } = _ref;
	const [containerIdsScheduledForMeasurement, setContainerIdsScheduledForMeasurement] = useState(null);
	const measuringScheduled = containerIdsScheduledForMeasurement != null;
	const { frequency, measure, strategy } = config;
	const containersRef = useRef(containers);
	const disabled = isDisabled();
	const disabledRef = useLatestValue(disabled);
	const measureDroppableContainers = useCallback(function(ids) {
		if (ids === void 0) ids = [];
		if (disabledRef.current) return;
		setContainerIdsScheduledForMeasurement((value) => value ? value.concat(ids) : ids);
	}, [disabledRef]);
	const timeoutId = useRef(null);
	const droppableRects = useLazyMemo((previousValue) => {
		if (disabled && !dragging) return defaultValue;
		const ids = containerIdsScheduledForMeasurement;
		if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || ids != null) {
			const map = /* @__PURE__ */ new Map();
			for (let container of containers) {
				if (!container) continue;
				if (ids && ids.length > 0 && !ids.includes(container.id) && container.rect.current) {
					map.set(container.id, container.rect.current);
					continue;
				}
				const node = container.node.current;
				const rect = node ? new Rect(measure(node), node) : null;
				container.rect.current = rect;
				if (rect) map.set(container.id, rect);
			}
			return map;
		}
		return previousValue;
	}, [
		containers,
		containerIdsScheduledForMeasurement,
		dragging,
		disabled,
		measure
	]);
	useEffect(() => {
		containersRef.current = containers;
	}, [containers]);
	useEffect(() => {
		if (disabled) return;
		requestAnimationFrame(() => measureDroppableContainers());
	}, [dragging, disabled]);
	useEffect(() => {
		if (measuringScheduled) setContainerIdsScheduledForMeasurement(null);
	}, [measuringScheduled]);
	useEffect(() => {
		if (disabled || typeof frequency !== "number" || timeoutId.current !== null) return;
		timeoutId.current = setTimeout(() => {
			measureDroppableContainers();
			timeoutId.current = null;
		}, frequency);
	}, [
		frequency,
		disabled,
		measureDroppableContainers,
		...dependencies
	]);
	return {
		droppableRects,
		measureDroppableContainers,
		measuringScheduled
	};
	function isDisabled() {
		switch (strategy) {
			case MeasuringStrategy.Always: return false;
			case MeasuringStrategy.BeforeDragging: return dragging;
			default: return !dragging;
		}
	}
}
function useInitialValue(value, computeFn) {
	return useLazyMemo((previousValue) => {
		if (!value) return null;
		if (previousValue) return previousValue;
		return typeof computeFn === "function" ? computeFn(value) : value;
	}, [computeFn, value]);
}
function useInitialRect(node, measure) {
	return useInitialValue(node, measure);
}
/**
* Returns a new MutationObserver instance.
* If `MutationObserver` is undefined in the execution environment, returns `undefined`.
*/
function useMutationObserver(_ref) {
	let { callback, disabled } = _ref;
	const handleMutations = useEvent(callback);
	const mutationObserver = useMemo(() => {
		if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") return;
		const { MutationObserver } = window;
		return new MutationObserver(handleMutations);
	}, [handleMutations, disabled]);
	useEffect(() => {
		return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
	}, [mutationObserver]);
	return mutationObserver;
}
/**
* Returns a new ResizeObserver instance bound to the `onResize` callback.
* If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
*/
function useResizeObserver(_ref) {
	let { callback, disabled } = _ref;
	const handleResize = useEvent(callback);
	const resizeObserver = useMemo(() => {
		if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") return;
		const { ResizeObserver } = window;
		return new ResizeObserver(handleResize);
	}, [disabled]);
	useEffect(() => {
		return () => resizeObserver == null ? void 0 : resizeObserver.disconnect();
	}, [resizeObserver]);
	return resizeObserver;
}
function defaultMeasure(element) {
	return new Rect(getClientRect(element), element);
}
function useRect(element, measure, fallbackRect) {
	if (measure === void 0) measure = defaultMeasure;
	const [rect, measureRect] = useReducer(reducer, null);
	const mutationObserver = useMutationObserver({ callback(records) {
		if (!element) return;
		for (const record of records) {
			const { type, target } = record;
			if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
				measureRect();
				break;
			}
		}
	} });
	const resizeObserver = useResizeObserver({ callback: measureRect });
	useIsomorphicLayoutEffect(() => {
		measureRect();
		if (element) {
			resizeObserver?.observe(element);
			mutationObserver?.observe(document.body, {
				childList: true,
				subtree: true
			});
		} else {
			resizeObserver?.disconnect();
			mutationObserver?.disconnect();
		}
	}, [element]);
	return rect;
	function reducer(currentRect) {
		if (!element) return null;
		if (element.isConnected === false) {
			var _ref;
			return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
		}
		const newRect = measure(element);
		if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
		return newRect;
	}
}
function useRectDelta(rect) {
	return getRectDelta(rect, useInitialValue(rect));
}
var defaultValue$1 = [];
function useScrollableAncestors(node) {
	const previousNode = useRef(node);
	const ancestors = useLazyMemo((previousValue) => {
		if (!node) return defaultValue$1;
		if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
		return getScrollableAncestors(node);
	}, [node]);
	useEffect(() => {
		previousNode.current = node;
	}, [node]);
	return ancestors;
}
function useScrollOffsets(elements) {
	const [scrollCoordinates, setScrollCoordinates] = useState(null);
	const prevElements = useRef(elements);
	const handleScroll = useCallback((event) => {
		const scrollingElement = getScrollableElement(event.target);
		if (!scrollingElement) return;
		setScrollCoordinates((scrollCoordinates) => {
			if (!scrollCoordinates) return null;
			scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
			return new Map(scrollCoordinates);
		});
	}, []);
	useEffect(() => {
		const previousElements = prevElements.current;
		if (elements !== previousElements) {
			cleanup(previousElements);
			const entries = elements.map((element) => {
				const scrollableElement = getScrollableElement(element);
				if (scrollableElement) {
					scrollableElement.addEventListener("scroll", handleScroll, { passive: true });
					return [scrollableElement, getScrollCoordinates(scrollableElement)];
				}
				return null;
			}).filter((entry) => entry != null);
			setScrollCoordinates(entries.length ? new Map(entries) : null);
			prevElements.current = elements;
		}
		return () => {
			cleanup(elements);
			cleanup(previousElements);
		};
		function cleanup(elements) {
			elements.forEach((element) => {
				getScrollableElement(element)?.removeEventListener("scroll", handleScroll);
			});
		}
	}, [handleScroll, elements]);
	return useMemo(() => {
		if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates) => add(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
		return defaultCoordinates;
	}, [elements, scrollCoordinates]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
	if (dependencies === void 0) dependencies = [];
	const initialScrollOffsets = useRef(null);
	useEffect(() => {
		initialScrollOffsets.current = null;
	}, dependencies);
	useEffect(() => {
		const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
		if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
		if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
	}, [scrollOffsets]);
	return initialScrollOffsets.current ? subtract(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
	useEffect(() => {
		if (!canUseDOM) return;
		const teardownFns = sensors.map((_ref) => {
			let { sensor } = _ref;
			return sensor.setup == null ? void 0 : sensor.setup();
		});
		return () => {
			for (const teardown of teardownFns) teardown?.();
		};
	}, sensors.map((_ref2) => {
		let { sensor } = _ref2;
		return sensor;
	}));
}
function useSyntheticListeners(listeners, id) {
	return useMemo(() => {
		return listeners.reduce((acc, _ref) => {
			let { eventName, handler } = _ref;
			acc[eventName] = (event) => {
				handler(event, id);
			};
			return acc;
		}, {});
	}, [listeners, id]);
}
function useWindowRect(element) {
	return useMemo(() => element ? getWindowClientRect(element) : null, [element]);
}
var defaultValue$2 = [];
function useRects(elements, measure) {
	if (measure === void 0) measure = getClientRect;
	const [firstElement] = elements;
	const windowRect = useWindowRect(firstElement ? getWindow(firstElement) : null);
	const [rects, measureRects] = useReducer(reducer, defaultValue$2);
	const resizeObserver = useResizeObserver({ callback: measureRects });
	if (elements.length > 0 && rects === defaultValue$2) measureRects();
	useIsomorphicLayoutEffect(() => {
		if (elements.length) elements.forEach((element) => resizeObserver == null ? void 0 : resizeObserver.observe(element));
		else {
			resizeObserver?.disconnect();
			measureRects();
		}
	}, [elements]);
	return rects;
	function reducer() {
		if (!elements.length) return defaultValue$2;
		return elements.map((element) => isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
	}
}
function getMeasurableNode(node) {
	if (!node) return null;
	if (node.children.length > 1) return node;
	const firstChild = node.children[0];
	return isHTMLElement(firstChild) ? firstChild : node;
}
function useDragOverlayMeasuring(_ref) {
	let { measure } = _ref;
	const [rect, setRect] = useState(null);
	const resizeObserver = useResizeObserver({ callback: useCallback((entries) => {
		for (const { target } of entries) if (isHTMLElement(target)) {
			setRect((rect) => {
				const newRect = measure(target);
				return rect ? {
					...rect,
					width: newRect.width,
					height: newRect.height
				} : newRect;
			});
			break;
		}
	}, [measure]) });
	const [nodeRef, setRef] = useNodeRef(useCallback((element) => {
		const node = getMeasurableNode(element);
		resizeObserver?.disconnect();
		if (node) resizeObserver?.observe(node);
		setRect(node ? measure(node) : null);
	}, [measure, resizeObserver]));
	return useMemo(() => ({
		nodeRef,
		rect,
		setRef
	}), [
		rect,
		nodeRef,
		setRef
	]);
}
var defaultSensors = [{
	sensor: PointerSensor,
	options: {}
}, {
	sensor: KeyboardSensor,
	options: {}
}];
var defaultData = { current: {} };
var defaultMeasuringConfiguration = {
	draggable: { measure: getTransformAgnosticClientRect },
	droppable: {
		measure: getTransformAgnosticClientRect,
		strategy: MeasuringStrategy.WhileDragging,
		frequency: MeasuringFrequency.Optimized
	},
	dragOverlay: { measure: getClientRect }
};
var DroppableContainersMap = class extends Map {
	get(id) {
		var _super$get;
		return id != null ? (_super$get = super.get(id)) != null ? _super$get : void 0 : void 0;
	}
	toArray() {
		return Array.from(this.values());
	}
	getEnabled() {
		return this.toArray().filter((_ref) => {
			let { disabled } = _ref;
			return !disabled;
		});
	}
	getNodeFor(id) {
		var _this$get$node$curren, _this$get;
		return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : void 0;
	}
};
var defaultPublicContext = {
	activatorEvent: null,
	active: null,
	activeNode: null,
	activeNodeRect: null,
	collisions: null,
	containerNodeRect: null,
	draggableNodes: /*#__PURE__*/ new Map(),
	droppableRects: /*#__PURE__*/ new Map(),
	droppableContainers: /*#__PURE__*/ new DroppableContainersMap(),
	over: null,
	dragOverlay: {
		nodeRef: { current: null },
		rect: null,
		setRef: noop
	},
	scrollableAncestors: [],
	scrollableAncestorRects: [],
	measuringConfiguration: defaultMeasuringConfiguration,
	measureDroppableContainers: noop,
	windowRect: null,
	measuringScheduled: false
};
var InternalContext = /*#__PURE__*/ createContext({
	activatorEvent: null,
	activators: [],
	active: null,
	activeNodeRect: null,
	ariaDescribedById: { draggable: "" },
	dispatch: noop,
	draggableNodes: /*#__PURE__*/ new Map(),
	over: null,
	measureDroppableContainers: noop
});
var PublicContext = /*#__PURE__*/ createContext(defaultPublicContext);
function getInitialState() {
	return {
		draggable: {
			active: null,
			initialCoordinates: {
				x: 0,
				y: 0
			},
			nodes: /* @__PURE__ */ new Map(),
			translate: {
				x: 0,
				y: 0
			}
		},
		droppable: { containers: new DroppableContainersMap() }
	};
}
function reducer(state, action) {
	switch (action.type) {
		case Action.DragStart: return {
			...state,
			draggable: {
				...state.draggable,
				initialCoordinates: action.initialCoordinates,
				active: action.active
			}
		};
		case Action.DragMove:
			if (!state.draggable.active) return state;
			return {
				...state,
				draggable: {
					...state.draggable,
					translate: {
						x: action.coordinates.x - state.draggable.initialCoordinates.x,
						y: action.coordinates.y - state.draggable.initialCoordinates.y
					}
				}
			};
		case Action.DragEnd:
		case Action.DragCancel: return {
			...state,
			draggable: {
				...state.draggable,
				active: null,
				initialCoordinates: {
					x: 0,
					y: 0
				},
				translate: {
					x: 0,
					y: 0
				}
			}
		};
		case Action.RegisterDroppable: {
			const { element } = action;
			const { id } = element;
			const containers = new DroppableContainersMap(state.droppable.containers);
			containers.set(id, element);
			return {
				...state,
				droppable: {
					...state.droppable,
					containers
				}
			};
		}
		case Action.SetDroppableDisabled: {
			const { id, key, disabled } = action;
			const element = state.droppable.containers.get(id);
			if (!element || key !== element.key) return state;
			const containers = new DroppableContainersMap(state.droppable.containers);
			containers.set(id, {
				...element,
				disabled
			});
			return {
				...state,
				droppable: {
					...state.droppable,
					containers
				}
			};
		}
		case Action.UnregisterDroppable: {
			const { id, key } = action;
			const element = state.droppable.containers.get(id);
			if (!element || key !== element.key) return state;
			const containers = new DroppableContainersMap(state.droppable.containers);
			containers.delete(id);
			return {
				...state,
				droppable: {
					...state.droppable,
					containers
				}
			};
		}
		default: return state;
	}
}
function RestoreFocus(_ref) {
	let { disabled } = _ref;
	const { active, activatorEvent, draggableNodes } = useContext(InternalContext);
	const previousActivatorEvent = usePrevious(activatorEvent);
	const previousActiveId = usePrevious(active == null ? void 0 : active.id);
	useEffect(() => {
		if (disabled) return;
		if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
			if (!isKeyboardEvent(previousActivatorEvent)) return;
			if (document.activeElement === previousActivatorEvent.target) return;
			const draggableNode = draggableNodes.get(previousActiveId);
			if (!draggableNode) return;
			const { activatorNode, node } = draggableNode;
			if (!activatorNode.current && !node.current) return;
			requestAnimationFrame(() => {
				for (const element of [activatorNode.current, node.current]) {
					if (!element) continue;
					const focusableNode = findFirstFocusableNode(element);
					if (focusableNode) {
						focusableNode.focus();
						break;
					}
				}
			});
		}
	}, [
		activatorEvent,
		disabled,
		draggableNodes,
		previousActiveId,
		previousActivatorEvent
	]);
	return null;
}
function applyModifiers(modifiers, _ref) {
	let { transform, ...args } = _ref;
	return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier) => {
		return modifier({
			transform: accumulator,
			...args
		});
	}, transform) : transform;
}
function useMeasuringConfiguration(config) {
	return useMemo(() => ({
		draggable: {
			...defaultMeasuringConfiguration.draggable,
			...config == null ? void 0 : config.draggable
		},
		droppable: {
			...defaultMeasuringConfiguration.droppable,
			...config == null ? void 0 : config.droppable
		},
		dragOverlay: {
			...defaultMeasuringConfiguration.dragOverlay,
			...config == null ? void 0 : config.dragOverlay
		}
	}), [
		config == null ? void 0 : config.draggable,
		config == null ? void 0 : config.droppable,
		config == null ? void 0 : config.dragOverlay
	]);
}
function useLayoutShiftScrollCompensation(_ref) {
	let { activeNode, measure, initialRect, config = true } = _ref;
	const initialized = useRef(false);
	const { x, y } = typeof config === "boolean" ? {
		x: config,
		y: config
	} : config;
	useIsomorphicLayoutEffect(() => {
		if (!x && !y || !activeNode) {
			initialized.current = false;
			return;
		}
		if (initialized.current || !initialRect) return;
		const node = activeNode == null ? void 0 : activeNode.node.current;
		if (!node || node.isConnected === false) return;
		const rectDelta = getRectDelta(measure(node), initialRect);
		if (!x) rectDelta.x = 0;
		if (!y) rectDelta.y = 0;
		initialized.current = true;
		if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
			const firstScrollableAncestor = getFirstScrollableAncestor(node);
			if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
				top: rectDelta.y,
				left: rectDelta.x
			});
		}
	}, [
		activeNode,
		x,
		y,
		initialRect,
		measure
	]);
}
var ActiveDraggableContext = /*#__PURE__*/ createContext({
	...defaultCoordinates,
	scaleX: 1,
	scaleY: 1
});
var Status$1;
(function(Status) {
	Status[Status["Uninitialized"] = 0] = "Uninitialized";
	Status[Status["Initializing"] = 1] = "Initializing";
	Status[Status["Initialized"] = 2] = "Initialized";
})(Status$1 || (Status$1 = {}));
var DndContext = /*#__PURE__*/ memo(function DndContext(_ref) {
	var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
	let { id, accessibility, autoScroll = true, children, sensors = defaultSensors, collisionDetection = rectIntersection, measuring, modifiers, ...props } = _ref;
	const [state, dispatch] = useReducer(reducer, void 0, getInitialState);
	const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
	const [status, setStatus] = useState(Status$1.Uninitialized);
	const isInitialized = status === Status$1.Initialized;
	const { draggable: { active: activeId, nodes: draggableNodes, translate }, droppable: { containers: droppableContainers } } = state;
	const node = activeId ? draggableNodes.get(activeId) : null;
	const activeRects = useRef({
		initial: null,
		translated: null
	});
	const active = useMemo(() => {
		var _node$data;
		return activeId != null ? {
			id: activeId,
			data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
			rect: activeRects
		} : null;
	}, [activeId, node]);
	const activeRef = useRef(null);
	const [activeSensor, setActiveSensor] = useState(null);
	const [activatorEvent, setActivatorEvent] = useState(null);
	const latestProps = useLatestValue(props, Object.values(props));
	const draggableDescribedById = useUniqueId("DndDescribedBy", id);
	const enabledDroppableContainers = useMemo(() => droppableContainers.getEnabled(), [droppableContainers]);
	const measuringConfiguration = useMeasuringConfiguration(measuring);
	const { droppableRects, measureDroppableContainers, measuringScheduled } = useDroppableMeasuring(enabledDroppableContainers, {
		dragging: isInitialized,
		dependencies: [translate.x, translate.y],
		config: measuringConfiguration.droppable
	});
	const activeNode = useCachedNode(draggableNodes, activeId);
	const activationCoordinates = useMemo(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
	const autoScrollOptions = getAutoScrollerOptions();
	const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
	useLayoutShiftScrollCompensation({
		activeNode: activeId ? draggableNodes.get(activeId) : null,
		config: autoScrollOptions.layoutShiftCompensation,
		initialRect: initialActiveNodeRect,
		measure: measuringConfiguration.draggable.measure
	});
	const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
	const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
	const sensorContext = useRef({
		activatorEvent: null,
		active: null,
		activeNode,
		collisionRect: null,
		collisions: null,
		droppableRects,
		draggableNodes,
		draggingNode: null,
		draggingNodeRect: null,
		droppableContainers,
		over: null,
		scrollableAncestors: [],
		scrollAdjustedTranslate: null
	});
	const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
	const dragOverlay = useDragOverlayMeasuring({ measure: measuringConfiguration.dragOverlay.measure });
	const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
	const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
	const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect);
	const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect);
	const windowRect = useWindowRect(draggingNode ? getWindow(draggingNode) : null);
	const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
	const scrollableAncestorRects = useRects(scrollableAncestors);
	const modifiedTranslate = applyModifiers(modifiers, {
		transform: {
			x: translate.x - nodeRectDelta.x,
			y: translate.y - nodeRectDelta.y,
			scaleX: 1,
			scaleY: 1
		},
		activatorEvent,
		active,
		activeNodeRect,
		containerNodeRect,
		draggingNodeRect,
		over: sensorContext.current.over,
		overlayNodeRect: dragOverlay.rect,
		scrollableAncestors,
		scrollableAncestorRects,
		windowRect
	});
	const pointerCoordinates = activationCoordinates ? add(activationCoordinates, translate) : null;
	const scrollOffsets = useScrollOffsets(scrollableAncestors);
	const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets);
	const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
	const scrollAdjustedTranslate = add(modifiedTranslate, scrollAdjustment);
	const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
	const collisions = active && collisionRect ? collisionDetection({
		active,
		collisionRect,
		droppableRects,
		droppableContainers: enabledDroppableContainers,
		pointerCoordinates
	}) : null;
	const overId = getFirstCollision(collisions, "id");
	const [over, setOver] = useState(null);
	const transform = adjustScale(usesDragOverlay ? modifiedTranslate : add(modifiedTranslate, activeNodeScrollDelta), (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
	const instantiateSensor = useCallback((event, _ref2) => {
		let { sensor: Sensor, options } = _ref2;
		if (activeRef.current == null) return;
		const activeNode = draggableNodes.get(activeRef.current);
		if (!activeNode) return;
		const activatorEvent = event.nativeEvent;
		const sensorInstance = new Sensor({
			active: activeRef.current,
			activeNode,
			event: activatorEvent,
			options,
			context: sensorContext,
			onStart(initialCoordinates) {
				const id = activeRef.current;
				if (id == null) return;
				const draggableNode = draggableNodes.get(id);
				if (!draggableNode) return;
				const { onDragStart } = latestProps.current;
				const event = { active: {
					id,
					data: draggableNode.data,
					rect: activeRects
				} };
				unstable_batchedUpdates(() => {
					onDragStart?.(event);
					setStatus(Status$1.Initializing);
					dispatch({
						type: Action.DragStart,
						initialCoordinates,
						active: id
					});
					dispatchMonitorEvent({
						type: "onDragStart",
						event
					});
				});
			},
			onMove(coordinates) {
				dispatch({
					type: Action.DragMove,
					coordinates
				});
			},
			onEnd: createHandler(Action.DragEnd),
			onCancel: createHandler(Action.DragCancel)
		});
		unstable_batchedUpdates(() => {
			setActiveSensor(sensorInstance);
			setActivatorEvent(event.nativeEvent);
		});
		function createHandler(type) {
			return async function handler() {
				const { active, collisions, over, scrollAdjustedTranslate } = sensorContext.current;
				let event = null;
				if (active && scrollAdjustedTranslate) {
					const { cancelDrop } = latestProps.current;
					event = {
						activatorEvent,
						active,
						collisions,
						delta: scrollAdjustedTranslate,
						over
					};
					if (type === Action.DragEnd && typeof cancelDrop === "function") {
						if (await Promise.resolve(cancelDrop(event))) type = Action.DragCancel;
					}
				}
				activeRef.current = null;
				unstable_batchedUpdates(() => {
					dispatch({ type });
					setStatus(Status$1.Uninitialized);
					setOver(null);
					setActiveSensor(null);
					setActivatorEvent(null);
					const eventName = type === Action.DragEnd ? "onDragEnd" : "onDragCancel";
					if (event) {
						const handler = latestProps.current[eventName];
						handler?.(event);
						dispatchMonitorEvent({
							type: eventName,
							event
						});
					}
				});
			};
		}
	}, [draggableNodes]);
	const activators = useCombineActivators(sensors, useCallback((handler, sensor) => {
		return (event, active) => {
			const nativeEvent = event.nativeEvent;
			const activeDraggableNode = draggableNodes.get(active);
			if (activeRef.current !== null || !activeDraggableNode || nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
			const activationContext = { active: activeDraggableNode };
			if (handler(event, sensor.options, activationContext) === true) {
				nativeEvent.dndKit = { capturedBy: sensor.sensor };
				activeRef.current = active;
				instantiateSensor(event, sensor);
			}
		};
	}, [draggableNodes, instantiateSensor]));
	useSensorSetup(sensors);
	useIsomorphicLayoutEffect(() => {
		if (activeNodeRect && status === Status$1.Initializing) setStatus(Status$1.Initialized);
	}, [activeNodeRect, status]);
	useEffect(() => {
		const { onDragMove } = latestProps.current;
		const { active, activatorEvent, collisions, over } = sensorContext.current;
		if (!active || !activatorEvent) return;
		const event = {
			active,
			activatorEvent,
			collisions,
			delta: {
				x: scrollAdjustedTranslate.x,
				y: scrollAdjustedTranslate.y
			},
			over
		};
		unstable_batchedUpdates(() => {
			onDragMove?.(event);
			dispatchMonitorEvent({
				type: "onDragMove",
				event
			});
		});
	}, [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]);
	useEffect(() => {
		const { active, activatorEvent, collisions, droppableContainers, scrollAdjustedTranslate } = sensorContext.current;
		if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
		const { onDragOver } = latestProps.current;
		const overContainer = droppableContainers.get(overId);
		const over = overContainer && overContainer.rect.current ? {
			id: overContainer.id,
			rect: overContainer.rect.current,
			data: overContainer.data,
			disabled: overContainer.disabled
		} : null;
		const event = {
			active,
			activatorEvent,
			collisions,
			delta: {
				x: scrollAdjustedTranslate.x,
				y: scrollAdjustedTranslate.y
			},
			over
		};
		unstable_batchedUpdates(() => {
			setOver(over);
			onDragOver?.(event);
			dispatchMonitorEvent({
				type: "onDragOver",
				event
			});
		});
	}, [overId]);
	useIsomorphicLayoutEffect(() => {
		sensorContext.current = {
			activatorEvent,
			active,
			activeNode,
			collisionRect,
			collisions,
			droppableRects,
			draggableNodes,
			draggingNode,
			draggingNodeRect,
			droppableContainers,
			over,
			scrollableAncestors,
			scrollAdjustedTranslate
		};
		activeRects.current = {
			initial: draggingNodeRect,
			translated: collisionRect
		};
	}, [
		active,
		activeNode,
		collisions,
		collisionRect,
		draggableNodes,
		draggingNode,
		draggingNodeRect,
		droppableRects,
		droppableContainers,
		over,
		scrollableAncestors,
		scrollAdjustedTranslate
	]);
	useAutoScroller({
		...autoScrollOptions,
		delta: translate,
		draggingRect: collisionRect,
		pointerCoordinates,
		scrollableAncestors,
		scrollableAncestorRects
	});
	const publicContext = useMemo(() => {
		return {
			active,
			activeNode,
			activeNodeRect,
			activatorEvent,
			collisions,
			containerNodeRect,
			dragOverlay,
			draggableNodes,
			droppableContainers,
			droppableRects,
			over,
			measureDroppableContainers,
			scrollableAncestors,
			scrollableAncestorRects,
			measuringConfiguration,
			measuringScheduled,
			windowRect
		};
	}, [
		active,
		activeNode,
		activeNodeRect,
		activatorEvent,
		collisions,
		containerNodeRect,
		dragOverlay,
		draggableNodes,
		droppableContainers,
		droppableRects,
		over,
		measureDroppableContainers,
		scrollableAncestors,
		scrollableAncestorRects,
		measuringConfiguration,
		measuringScheduled,
		windowRect
	]);
	const internalContext = useMemo(() => {
		return {
			activatorEvent,
			activators,
			active,
			activeNodeRect,
			ariaDescribedById: { draggable: draggableDescribedById },
			dispatch,
			draggableNodes,
			over,
			measureDroppableContainers
		};
	}, [
		activatorEvent,
		activators,
		active,
		activeNodeRect,
		dispatch,
		draggableDescribedById,
		draggableNodes,
		over,
		measureDroppableContainers
	]);
	return React.createElement(DndMonitorContext.Provider, { value: registerMonitorListener }, React.createElement(InternalContext.Provider, { value: internalContext }, React.createElement(PublicContext.Provider, { value: publicContext }, React.createElement(ActiveDraggableContext.Provider, { value: transform }, children)), React.createElement(RestoreFocus, { disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false })), React.createElement(Accessibility, {
		...accessibility,
		hiddenTextDescribedById: draggableDescribedById
	}));
	function getAutoScrollerOptions() {
		const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
		const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
		const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
		if (typeof autoScroll === "object") return {
			...autoScroll,
			enabled
		};
		return { enabled };
	}
});
var NullContext = /*#__PURE__*/ createContext(null);
var defaultRole = "button";
var ID_PREFIX$2 = "Droppable";
function useDraggable(_ref) {
	let { id, data, disabled = false, attributes } = _ref;
	const key = useUniqueId(ID_PREFIX$2);
	const { activators, activatorEvent, active, activeNodeRect, ariaDescribedById, draggableNodes, over } = useContext(InternalContext);
	const { role = defaultRole, roleDescription = "draggable", tabIndex = 0 } = attributes != null ? attributes : {};
	const isDragging = (active == null ? void 0 : active.id) === id;
	const transform = useContext(isDragging ? ActiveDraggableContext : NullContext);
	const [node, setNodeRef] = useNodeRef();
	const [activatorNode, setActivatorNodeRef] = useNodeRef();
	const listeners = useSyntheticListeners(activators, id);
	const dataRef = useLatestValue(data);
	useIsomorphicLayoutEffect(() => {
		draggableNodes.set(id, {
			id,
			key,
			node,
			activatorNode,
			data: dataRef
		});
		return () => {
			const node = draggableNodes.get(id);
			if (node && node.key === key) draggableNodes.delete(id);
		};
	}, [draggableNodes, id]);
	return {
		active,
		activatorEvent,
		activeNodeRect,
		attributes: useMemo(() => ({
			role,
			tabIndex,
			"aria-disabled": disabled,
			"aria-pressed": isDragging && role === defaultRole ? true : void 0,
			"aria-roledescription": roleDescription,
			"aria-describedby": ariaDescribedById.draggable
		}), [
			disabled,
			role,
			tabIndex,
			isDragging,
			roleDescription,
			ariaDescribedById.draggable
		]),
		isDragging,
		listeners: disabled ? void 0 : listeners,
		node,
		over,
		setNodeRef,
		setActivatorNodeRef,
		transform
	};
}
function useDndContext() {
	return useContext(PublicContext);
}
var ID_PREFIX$1 = "Droppable";
var defaultResizeObserverConfig = { timeout: 25 };
function useDroppable(_ref) {
	let { data, disabled = false, id, resizeObserverConfig } = _ref;
	const key = useUniqueId(ID_PREFIX$1);
	const { active, dispatch, over, measureDroppableContainers } = useContext(InternalContext);
	const previous = useRef({ disabled });
	const resizeObserverConnected = useRef(false);
	const rect = useRef(null);
	const callbackId = useRef(null);
	const { disabled: resizeObserverDisabled, updateMeasurementsFor, timeout: resizeObserverTimeout } = {
		...defaultResizeObserverConfig,
		...resizeObserverConfig
	};
	const ids = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id);
	const resizeObserver = useResizeObserver({
		callback: useCallback(() => {
			if (!resizeObserverConnected.current) {
				resizeObserverConnected.current = true;
				return;
			}
			if (callbackId.current != null) clearTimeout(callbackId.current);
			callbackId.current = setTimeout(() => {
				measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [ids.current]);
				callbackId.current = null;
			}, resizeObserverTimeout);
		}, [resizeObserverTimeout]),
		disabled: resizeObserverDisabled || !active
	});
	const [nodeRef, setNodeRef] = useNodeRef(useCallback((newElement, previousElement) => {
		if (!resizeObserver) return;
		if (previousElement) {
			resizeObserver.unobserve(previousElement);
			resizeObserverConnected.current = false;
		}
		if (newElement) resizeObserver.observe(newElement);
	}, [resizeObserver]));
	const dataRef = useLatestValue(data);
	useEffect(() => {
		if (!resizeObserver || !nodeRef.current) return;
		resizeObserver.disconnect();
		resizeObserverConnected.current = false;
		resizeObserver.observe(nodeRef.current);
	}, [nodeRef, resizeObserver]);
	useIsomorphicLayoutEffect(() => {
		dispatch({
			type: Action.RegisterDroppable,
			element: {
				id,
				key,
				disabled,
				node: nodeRef,
				rect,
				data: dataRef
			}
		});
		return () => dispatch({
			type: Action.UnregisterDroppable,
			key,
			id
		});
	}, [id]);
	useEffect(() => {
		if (disabled !== previous.current.disabled) {
			dispatch({
				type: Action.SetDroppableDisabled,
				id,
				key,
				disabled
			});
			previous.current.disabled = disabled;
		}
	}, [
		id,
		key,
		disabled,
		dispatch
	]);
	return {
		active,
		rect,
		isOver: (over == null ? void 0 : over.id) === id,
		node: nodeRef,
		over,
		setNodeRef
	};
}
//#endregion
//#region ../../node_modules/@dnd-kit/modifiers/dist/modifiers.esm.js
var restrictToVerticalAxis = ({ transform }) => {
	return {
		...transform,
		x: 0
	};
};
//#endregion
//#region ../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js
/**
* Move an array item to a different position. Returns a new array with the item moved to the new position.
*/
function arrayMove(array, from, to) {
	const newArray = array.slice();
	newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
	return newArray;
}
function getSortedRects(items, rects) {
	return items.reduce((accumulator, id, index) => {
		const rect = rects.get(id);
		if (rect) accumulator[index] = rect;
		return accumulator;
	}, Array(items.length));
}
function isValidIndex(index) {
	return index !== null && index >= 0;
}
function itemsEqual(a, b) {
	if (a === b) return true;
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
	return true;
}
function normalizeDisabled(disabled) {
	if (typeof disabled === "boolean") return {
		draggable: disabled,
		droppable: disabled
	};
	return disabled;
}
var rectSortingStrategy = (_ref) => {
	let { rects, activeIndex, overIndex, index } = _ref;
	const newRects = arrayMove(rects, overIndex, activeIndex);
	const oldRect = rects[index];
	const newRect = newRects[index];
	if (!newRect || !oldRect) return null;
	return {
		x: newRect.left - oldRect.left,
		y: newRect.top - oldRect.top,
		scaleX: newRect.width / oldRect.width,
		scaleY: newRect.height / oldRect.height
	};
};
var defaultScale$1 = {
	scaleX: 1,
	scaleY: 1
};
var verticalListSortingStrategy = (_ref) => {
	var _rects$activeIndex;
	let { activeIndex, activeNodeRect: fallbackActiveRect, index, rects, overIndex } = _ref;
	const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
	if (!activeNodeRect) return null;
	if (index === activeIndex) {
		const overIndexRect = rects[overIndex];
		if (!overIndexRect) return null;
		return {
			x: 0,
			y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
			...defaultScale$1
		};
	}
	const itemGap = getItemGap$1(rects, index, activeIndex);
	if (index > activeIndex && index <= overIndex) return {
		x: 0,
		y: -activeNodeRect.height - itemGap,
		...defaultScale$1
	};
	if (index < activeIndex && index >= overIndex) return {
		x: 0,
		y: activeNodeRect.height + itemGap,
		...defaultScale$1
	};
	return {
		x: 0,
		y: 0,
		...defaultScale$1
	};
};
function getItemGap$1(clientRects, index, activeIndex) {
	const currentRect = clientRects[index];
	const previousRect = clientRects[index - 1];
	const nextRect = clientRects[index + 1];
	if (!currentRect) return 0;
	if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
	return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
var ID_PREFIX = "Sortable";
var Context = /*#__PURE__*/ React.createContext({
	activeIndex: -1,
	containerId: ID_PREFIX,
	disableTransforms: false,
	items: [],
	overIndex: -1,
	useDragOverlay: false,
	sortedRects: [],
	strategy: rectSortingStrategy,
	disabled: {
		draggable: false,
		droppable: false
	}
});
function SortableContext(_ref) {
	let { children, id, items: userDefinedItems, strategy = rectSortingStrategy, disabled: disabledProp = false } = _ref;
	const { active, dragOverlay, droppableRects, over, measureDroppableContainers, measuringScheduled } = useDndContext();
	const containerId = useUniqueId(ID_PREFIX, id);
	const useDragOverlay = Boolean(dragOverlay.rect !== null);
	const items = useMemo(() => userDefinedItems.map((item) => typeof item === "object" && "id" in item ? item.id : item), [userDefinedItems]);
	const isDragging = active != null;
	const activeIndex = active ? items.indexOf(active.id) : -1;
	const overIndex = over ? items.indexOf(over.id) : -1;
	const previousItemsRef = useRef(items);
	const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
	const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
	const disabled = normalizeDisabled(disabledProp);
	useIsomorphicLayoutEffect(() => {
		if (itemsHaveChanged && isDragging && !measuringScheduled) measureDroppableContainers(items);
	}, [
		itemsHaveChanged,
		items,
		isDragging,
		measureDroppableContainers,
		measuringScheduled
	]);
	useEffect(() => {
		previousItemsRef.current = items;
	}, [items]);
	const contextValue = useMemo(() => ({
		activeIndex,
		containerId,
		disabled,
		disableTransforms,
		items,
		overIndex,
		useDragOverlay,
		sortedRects: getSortedRects(items, droppableRects),
		strategy
	}), [
		activeIndex,
		containerId,
		disabled.draggable,
		disabled.droppable,
		disableTransforms,
		items,
		overIndex,
		droppableRects,
		useDragOverlay,
		strategy
	]);
	return React.createElement(Context.Provider, { value: contextValue }, children);
}
var defaultNewIndexGetter = (_ref) => {
	let { id, items, activeIndex, overIndex } = _ref;
	return arrayMove(items, activeIndex, overIndex).indexOf(id);
};
var defaultAnimateLayoutChanges = (_ref2) => {
	let { containerId, isSorting, wasDragging, index, items, newIndex, previousItems, previousContainerId, transition } = _ref2;
	if (!transition || !wasDragging) return false;
	if (previousItems !== items && index === newIndex) return false;
	if (isSorting) return true;
	return newIndex !== index && containerId === previousContainerId;
};
var defaultTransition = {
	duration: 200,
	easing: "ease"
};
var transitionProperty = "transform";
var disabledTransition = /*#__PURE__*/ CSS$1.Transition.toString({
	property: transitionProperty,
	duration: 0,
	easing: "linear"
});
var defaultAttributes = { roleDescription: "sortable" };
function useDerivedTransform(_ref) {
	let { disabled, index, node, rect } = _ref;
	const [derivedTransform, setDerivedtransform] = useState(null);
	const previousIndex = useRef(index);
	useIsomorphicLayoutEffect(() => {
		if (!disabled && index !== previousIndex.current && node.current) {
			const initial = rect.current;
			if (initial) {
				const current = getClientRect(node.current, { ignoreTransform: true });
				const delta = {
					x: initial.left - current.left,
					y: initial.top - current.top,
					scaleX: initial.width / current.width,
					scaleY: initial.height / current.height
				};
				if (delta.x || delta.y) setDerivedtransform(delta);
			}
		}
		if (index !== previousIndex.current) previousIndex.current = index;
	}, [
		disabled,
		index,
		node,
		rect
	]);
	useEffect(() => {
		if (derivedTransform) requestAnimationFrame(() => {
			setDerivedtransform(null);
		});
	}, [derivedTransform]);
	return derivedTransform;
}
function useSortable(_ref) {
	let { animateLayoutChanges = defaultAnimateLayoutChanges, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex = defaultNewIndexGetter, id, strategy: localStrategy, resizeObserverConfig, transition = defaultTransition } = _ref;
	const { items, containerId, activeIndex, disabled: globalDisabled, disableTransforms, sortedRects, overIndex, useDragOverlay, strategy: globalStrategy } = useContext(Context);
	const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
	const index = items.indexOf(id);
	const data = useMemo(() => ({
		sortable: {
			containerId,
			index,
			items
		},
		...customData
	}), [
		containerId,
		customData,
		index,
		items
	]);
	const itemsAfterCurrentSortable = useMemo(() => items.slice(items.indexOf(id)), [items, id]);
	const { rect, node, isOver, setNodeRef: setDroppableNodeRef } = useDroppable({
		id,
		data,
		disabled: disabled.droppable,
		resizeObserverConfig: {
			updateMeasurementsFor: itemsAfterCurrentSortable,
			...resizeObserverConfig
		}
	});
	const { active, activatorEvent, activeNodeRect, attributes, setNodeRef: setDraggableNodeRef, listeners, isDragging, over, setActivatorNodeRef, transform } = useDraggable({
		id,
		data,
		attributes: {
			...defaultAttributes,
			...userDefinedAttributes
		},
		disabled: disabled.draggable
	});
	const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
	const isSorting = Boolean(active);
	const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
	const shouldDisplaceDragSource = !useDragOverlay && isDragging;
	const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
	const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : (localStrategy != null ? localStrategy : globalStrategy)({
		rects: sortedRects,
		activeNodeRect,
		activeIndex,
		overIndex,
		index
	}) : null;
	const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
		id,
		items,
		activeIndex,
		overIndex
	}) : index;
	const activeId = active == null ? void 0 : active.id;
	const previous = useRef({
		activeId,
		items,
		newIndex,
		containerId
	});
	const itemsHaveChanged = items !== previous.current.items;
	const shouldAnimateLayoutChanges = animateLayoutChanges({
		active,
		containerId,
		isDragging,
		isSorting,
		id,
		index,
		items,
		newIndex: previous.current.newIndex,
		previousItems: previous.current.items,
		previousContainerId: previous.current.containerId,
		transition,
		wasDragging: previous.current.activeId != null
	});
	const derivedTransform = useDerivedTransform({
		disabled: !shouldAnimateLayoutChanges,
		index,
		node,
		rect
	});
	useEffect(() => {
		if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
		if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
		if (items !== previous.current.items) previous.current.items = items;
	}, [
		isSorting,
		newIndex,
		containerId,
		items
	]);
	useEffect(() => {
		if (activeId === previous.current.activeId) return;
		if (activeId && !previous.current.activeId) {
			previous.current.activeId = activeId;
			return;
		}
		const timeoutId = setTimeout(() => {
			previous.current.activeId = activeId;
		}, 50);
		return () => clearTimeout(timeoutId);
	}, [activeId]);
	return {
		active,
		activeIndex,
		attributes,
		data,
		rect,
		index,
		newIndex,
		items,
		isOver,
		isSorting,
		isDragging,
		listeners,
		node,
		overIndex,
		over,
		setNodeRef,
		setActivatorNodeRef,
		setDroppableNodeRef,
		setDraggableNodeRef,
		transform: derivedTransform != null ? derivedTransform : finalTransform,
		transition: getTransition()
	};
	function getTransition() {
		if (derivedTransform || itemsHaveChanged && previous.current.newIndex === index) return disabledTransition;
		if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition) return;
		if (isSorting || shouldAnimateLayoutChanges) return CSS$1.Transition.toString({
			...transition,
			property: transitionProperty
		});
	}
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
	var _localDisabled$dragga, _localDisabled$droppa;
	if (typeof localDisabled === "boolean") return {
		draggable: localDisabled,
		droppable: false
	};
	return {
		draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
		droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
	};
}
KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left;
//#endregion
//#region src/components/menu/draggable/dragabble.styled.ts
var StyledContainer = (0, import_dist.default)(Stack)`border-b`;
//#endregion
//#region src/components/menu/draggable/DraggableMenu.tsx
var DraggableMenu = ({ children, className, onChange }) => {
	const [sortedChildren, setSortedChildren] = useState(Array.isArray(children) ? children : [children]);
	const sensors = [useSensor(PointerSensor)];
	useEffect(() => {
		setSortedChildren((sortedChildren) => {
			const newChildren = Array.isArray(children) ? children : [children];
			const newSortedChildren = sortedChildren.map((sortedChild) => newChildren.find((child) => child.props.id === sortedChild.props.id)).filter(Boolean);
			if (newChildren.length === newSortedChildren.length) return newSortedChildren;
			else if (newChildren.length > newSortedChildren.length) {
				const addedChildren = newChildren.filter((newChild) => !newSortedChildren.find((child) => child.props.id === newChild.props.id));
				return [...newSortedChildren, ...addedChildren];
			} else return sortedChildren.map((sortedChild) => newChildren.find((newChild) => newChild.props.id === sortedChild.props.id)).filter(Boolean);
		});
	}, [children]);
	const handleDragEnd = ({ active, over }) => {
		if (active.id !== over?.id) {
			const oldIndex = sortedChildren.findIndex((child) => child.props.id === active.id);
			const newIndex = sortedChildren.findIndex((child) => child.props.id === over?.id);
			const newSortedChildren = arrayMove(sortedChildren, oldIndex, newIndex);
			setSortedChildren(newSortedChildren);
			onChange(newSortedChildren.map((child) => child.props.id));
		}
	};
	return /* @__PURE__ */ React.createElement(StyledContainer, {
		className,
		direction: "column",
		gap: 2.5
	}, /* @__PURE__ */ React.createElement(DndContext, {
		sensors,
		collisionDetection: closestCenter,
		onDragEnd: handleDragEnd,
		modifiers: [restrictToVerticalAxis]
	}, /* @__PURE__ */ React.createElement(SortableContext, {
		items: sortedChildren.map((child) => child.props.id),
		strategy: verticalListSortingStrategy
	}, sortedChildren)));
};
var DraggableMenuMemo = memo(DraggableMenu);
//#endregion
//#region src/assets/icons/reorder.svg
var SvgReorder = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsxs("g", { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M14.86,23.27H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M22.5,3.23H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M22.5,9.91H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M22.5,16.59H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z",
			fill: "currentColor"
		})
	] })
});
var ForwardRef$2 = forwardRef(SvgReorder);
var Memo$2 = memo(ForwardRef$2);
//#endregion
//#region src/components/menu/draggable/DraggableMenuItem.tsx
var DraggableMenuItem = ({ children, className, id, title }) => {
	const { attributes, isDragging, listeners, setNodeRef, transform } = useSortable({ id });
	const style = { transform: CSS$1.Transform.toString(transform) };
	return /* @__PURE__ */ React.createElement(StyledDraggableMenuItem, {
		className,
		$isDragging: isDragging,
		ref: setNodeRef,
		style
	}, /* @__PURE__ */ React.createElement(IconAndTitle, null, /* @__PURE__ */ React.createElement(MenuItemIcon, {
		"data-testid": `grabber-${id}`,
		...attributes,
		...listeners
	}, /* @__PURE__ */ React.createElement(Memo$2, { className: "text-gray-200 cursor-grabbing" })), title), children);
};
var DraggableMenuItemMemo = memo(DraggableMenuItem);
//#endregion
//#region src/components/menu/draggable/DraggableMenuItemWithToggle.tsx
var DraggableMenuItemWithToggle = ({ id, title, toggle }) => /* @__PURE__ */ React.createElement(DraggableMenuItem, {
	id,
	title
}, /* @__PURE__ */ React.createElement("div", { "data-testid": `toggle-${id}` }, /* @__PURE__ */ React.createElement(ToggleSwitch, {
	checked: toggle.checked,
	disabled: toggle.disabled,
	onChange: toggle.onChange,
	withIcon: toggle.withIcon
})));
var DraggableMenuItemWithToggleMemo = memo(DraggableMenuItemWithToggle);
//#endregion
//#region src/components/gradient-box/styled.ts
var StyledGradientBox = import_dist.default.div`
    pt-2
    pb-6
    px-4
    flex
`;
var StyledLabel = (0, import_dist.default)(Typography)`
    text-gray-400
    leading-5
`;
var StyledGradient = import_dist.default.div`
    flex-1
    w-full
    h-3
`;
var StyledNotApplicable = import_dist.default.div`
  px-5
  flex
  flex-col
  justify-end
`;
var NotApplicableBox = import_dist.default.div`
  w-8
  h-4
  bg-gray-100
  relative
`;
var NotApplicableLine = import_dist.default.hr`
  border-1
  border-gray-400
  w-[18px]
  absolute
  top-1/2
  left-1/2
  -translate-y-2/4 
  -translate-x-2/4
`;
//#endregion
//#region src/components/gradient-box/NotApplicable.tsx
var NotApplicable = () => /* @__PURE__ */ React.createElement(StyledNotApplicable, { "data-testid": "n/a-legend" }, /* @__PURE__ */ React.createElement(NotApplicableBox, null, /* @__PURE__ */ React.createElement(NotApplicableLine, null)), /* @__PURE__ */ React.createElement(StyledLabel, {
	as: "label",
	fontWeight: "medium",
	fontSize: "sm",
	className: "text-center"
}, "N/A"));
//#endregion
//#region src/components/gradient-box/GradientBox.tsx
var GradientBox = ({ backgroundColors, className, leftTitle, rightTitle, startAdornmentType = "none" }) => /* @__PURE__ */ React.createElement(StyledGradientBox, { className }, startAdornmentType === "n/a" && /* @__PURE__ */ React.createElement(NotApplicable, null), /* @__PURE__ */ React.createElement(Stack, {
	className: "w-full",
	alignItems: "center",
	justifyContent: "space-between",
	gap: 1.5
}, /* @__PURE__ */ React.createElement(StyledLabel, {
	as: "label",
	fontSize: "2xs"
}, leftTitle), /* @__PURE__ */ React.createElement(StyledGradient, {
	"data-testid": "gradient",
	style: { backgroundImage: createLinearGradientCss(backgroundColors) }
}), /* @__PURE__ */ React.createElement(StyledLabel, {
	as: "label",
	fontSize: "2xs"
}, rightTitle)));
var GradientBoxMemo = memo(GradientBox);
//#endregion
//#region src/assets/icons/currency-dollar-circle.svg
var SvgCurrencyDollarCircle = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm1.46,18.59a.25.25,0,0,0-.21.24v.77a1.25,1.25,0,0,1-2.5,0v-.71a.25.25,0,0,0-.25-.25H9.35a1.25,1.25,0,0,1,0-2.5h3.59A1.12,1.12,0,0,0,13.36,14L9.72,12.53a3.6,3.6,0,0,1,.82-6.92.25.25,0,0,0,.21-.25V4.6a1.25,1.25,0,0,1,2.5,0v.7a.25.25,0,0,0,.25.25h1.15a1.25,1.25,0,1,1,0,2.5H11.06a1.12,1.12,0,0,0-.42,2.16l3.64,1.46a3.6,3.6,0,0,1-.82,6.92Z",
		fill: "currentColor"
	})
});
var ForwardRef$1 = forwardRef(SvgCurrencyDollarCircle);
var Memo$1 = memo(ForwardRef$1);
//#endregion
//#region src/assets/icons/pencil-1.svg
var SvgPencil1 = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ jsxs("g", { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M15.07,4a.49.49,0,0,0-.36-.15h0a.5.5,0,0,0-.35.14L3.44,14.91a.5.5,0,0,0,0,.71l4.94,4.94a.51.51,0,0,0,.36.15.49.49,0,0,0,.35-.15L20,9.65a.51.51,0,0,0,0-.71Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M2.43,16.8a.51.51,0,0,0-.84.24L.08,23.31a.49.49,0,0,0,.14.47.51.51,0,0,0,.47.14L7,22.41a.49.49,0,0,0,.36-.35.52.52,0,0,0-.12-.49Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M23.2,2.92,21.08.8a2.52,2.52,0,0,0-3.54,0L16.13,2.22a.48.48,0,0,0,0,.7l4.95,5a.48.48,0,0,0,.7,0L23.2,6.45A2.5,2.5,0,0,0,23.2,2.92Z",
			fill: "currentColor"
		})
	] })
});
var ForwardRef = forwardRef(SvgPencil1);
var Memo = memo(ForwardRef);
//#endregion
//#region src/components/stats/styled.ts
var StyledStats = (0, import_dist.default)(Stack)`rounded-lg gap-px overflow-hidden`;
var StyledStat = import_dist.default.div`
   ${({ $disabled }) => $disabled ? "opacity-50 pointer-events-none" : ""}
   flex-1
   border-gray-200
   overflow-hidden
   bg-gray-50
   px-4
   py-5
   shadow
   sm:px-6
   sm:py-7
`;
var EditButton = (0, import_dist.default)(Button$2)`
   text-primary-600
   cursor-pointer
   flex
   items-center
   rounded-sm
   focus:outline-none
   focus:ring
   focus:ring-1
   focus:ring-primary-300
   [&>*]:focus:outline-none

`;
var IconBox = import_dist.default.div`
   rounded-md
   p-3 
   self-start
`;
var StatIcon = import_dist.default.div`
   flex-shrink-0
   h-6
   w-6
   text-white
   text-inherit
`;
var StatTitle = import_dist.default.p`
   truncate
   text-sm
   font-medium
   text-gray-500
   mb-0
`;
var StatValue = import_dist.default.p`
   text-2xl
   font-semibold
   text-gray-900
   leading-7
   mb-0
`;
import_dist.default.div`
   ml-2
   flex
   items-end
   text-sm
   [&>span]:font-semibold
`;
import_dist.default.span`
   text-green-600
`;
import_dist.default.span`
   text-rsbry-600
`;
import_dist.default.div`
   ml-0.5
`;
var FullStatValue = import_dist.default.p`
   text-sm
   leading-none
   font-semibold
   text-gray-400
   mb-0
`;
var StyledMoneyCircle = (0, import_dist.default)(Memo$1)`
   w-4
   h-4
   text-gray-400
   mr-0.5
`;
var StyledEditPencil = (0, import_dist.default)(Memo)`
   w-5
   h-5
   mr-0.5
`;
//#endregion
//#region src/components/stats/Stat.tsx
var calculateStatValue = ({ disabled, money, stat }) => {
	const { base, suffix = "" } = (0, import_lib.abbreviateNumber)({ inputNumber: stat });
	return disabled || stat === 0 ? "---" : `${(0, import_lib.formatNumberToUsd)(base, { withDollarSign: money })}${suffix}`;
};
var calculateFullStatValue = (stat, disabled) => {
	let numberValue = "";
	if (disabled || stat === 0) numberValue = "---";
	else numberValue = (0, import_lib.formatNumberWithCommas)(stat);
	return numberValue;
};
var Stat = ({ changeType, direction, disabled = false, editButtonText, icon, iconBgColor, money = true, negativeChangeText, onEdit, positiveChangeText, stat, title }) => /* @__PURE__ */ React.createElement(StyledStat, {
	$disabled: disabled,
	$direction: direction
}, /* @__PURE__ */ React.createElement(Stack, {
	direction: "row",
	className: "gap-5"
}, icon && /* @__PURE__ */ React.createElement(IconBox, { style: { backgroundColor: iconBgColor } }, /* @__PURE__ */ React.createElement(StatIcon, { "data-testid": "stat-icon" }, icon)), /* @__PURE__ */ React.createElement("div", { className: "w-full" }, /* @__PURE__ */ React.createElement(Stack, {
	direction: "row",
	justifyContent: "space-between"
}, /* @__PURE__ */ React.createElement(StatTitle, null, title), onEdit && /* @__PURE__ */ React.createElement(EditButton, {
	onClick: onEdit,
	"data-testid": "edit-stat-btn"
}, /* @__PURE__ */ React.createElement(StyledEditPencil, null), editButtonText && /* @__PURE__ */ React.createElement(Typography, {
	fontSize: "sm",
	as: "span",
	fontWeight: "normal"
}, editButtonText))), /* @__PURE__ */ React.createElement(Stack, { justifyContent: "space-between" }, /* @__PURE__ */ React.createElement(StatValue, null, calculateStatValue({
	stat,
	disabled,
	money
})), changeType && /* @__PURE__ */ React.createElement(ChangeText, {
	changeType,
	positiveChangeText,
	negativeChangeText,
	variant: changeType === "plus" ? "green" : "red",
	className: "font-semibold"
}), !changeType && /* @__PURE__ */ React.createElement(Stack, { alignItems: "end" }, money && /* @__PURE__ */ React.createElement(StyledMoneyCircle, null), /* @__PURE__ */ React.createElement(FullStatValue, null, calculateFullStatValue(stat, disabled)))))));
//#endregion
//#region src/components/stats/Stats.tsx
var Stats = ({ className, direction = "column", stats }) => /* @__PURE__ */ React.createElement(StyledStats, {
	className,
	direction
}, stats.map((stat) => /* @__PURE__ */ React.createElement(Stat, {
	key: stat.title,
	title: stat.title,
	stat: stat.stat,
	changeType: stat.changeType,
	onEdit: stat.onEdit,
	editButtonText: stat.editButtonText,
	icon: stat.icon,
	disabled: stat.disabled,
	iconBgColor: stat.iconBgColor,
	direction
})));
//#endregion
export { AbbrevNumberCell, AbbrevNumberCellMemo, ActionsMenuButton, Alert, AlertMemo, AlertModalLayout, AlertModalLayoutMemo, AllocationByProjectCell, AllocationByProjectCellMemo, AllocationInput, AllocationPill, AllocationSlider, AllocationSliderInput, AllocationSliderMemo, AmountCell, AmountCellMemo, AmountKpi, AmountKpiMemo, AutocompleteInput, AutocompleteTagInput, Avatar, AvatarMemo, AvatarStackAddCell, AvatarStackAddCellMemo, AvatarTitleCell, AvatarTitleCellMemo, AvatarWithText, AvatarWithTextMemo, Backdrop, Badge, BadgeMemo, BaseTab, BaseTabPanel, BaseTabs, Button, ButtonCheckBox, ButtonCheckBoxMemo, ButtonCircular, ButtonCircularMemo, ButtonGroup, ButtonGroupMemo, ButtonMemo, ButtonWithForwardRef, Card, CardMemo, CardWithAction, CardWithActionMemo, CardWithAvatar, CardWithAvatarMemo, Checkbox, CheckboxAtom, CheckboxContainer, CheckboxContainerMemo, CheckboxMemo, ColorVariant, ColoredAmount, ColoredAmountMemo, CompanyLogoIcon, CompanyLogoMemo, Container, ContainerMemo, ControlledAllocationSlider, ControlledAutocompleteInput, ControlledAutocompleteTagInput, ControlledButtonGroup, ControlledCheckbox, ControlledInput, ControlledMonthDatePicker, ControlledMonthPicker, ControlledRadioGroup, ControlledSelect, ControlledTagInput, ControlledTextArea, ControlledToggleSwitch, CountryCell, CountryCellMemo, DEFAULT_TOAST_DURATION, DEFAULT_TOAST_ERROR_DURATION, Divider, DividerMemo, DraggableMenu, DraggableMenuItem, DraggableMenuItemMemo, DraggableMenuItemWithToggle, DraggableMenuItemWithToggleMemo, DraggableMenuMemo, DropdownButton, DropdownButtonMemo, DropdownMenu, DropdownMenuMemo, DropdownMenuWithButton, DropdownMenuWithButtonMemo, EquationOperator, EquationOperatorMemo, EquationTerm, EquationTermMemo, FeedItem, FileDisplaySection, FileDropZone, FileMimeType, FlyoutMenu, FooterCell, FormButton, FormSection, FormSectionHelpText, FormSectionMemo, FormStickyHeader, FormStickyHeaderMemo, FormTitle, FormTitleMemo, GAP_X, GAP_XY, GAP_Y, GanttChart, GeneralFormError, GeneralFormErrorMemo, GradientBox, GradientBoxMemo, Grid, GridItem, GroupHeader, Heatmap, HeatmapTooltip, Height, HelpLink, HumanizedDateCell, HumanizedDateCellMemo, Icon, IconAndTextCell, IconAndTextCellMemo, IconButton, IconButtonGroup, IconMemo, IconWithNotification, IconWithNotificationMemo, Indent, IndentMemo, IndexedScrollContainer, Input, InputContainer, InputFormContainer, InputFormContainerMemo, InputMasks, InputMemo, LabelWithHelp, LeftColumnLayout, LeftColumnLayoutMemo, Loading, LoadingOverlay, Logo, Menu, MenuItem, MenuItemMemo, MenuMemo, Modal, ModalActions, ModalActionsMemo, ModalHeader, ModalHeaderMemo, ModalMemo, MonthDatePicker, MonthPicker, NavItem, NavItemContext, PageHeader, PageHeaderMemo, PageSubtitle, PageSubtitleMemo, PageTitle, PageTitleMemo, Popover, PopoverDisclosure, PopoverMemo, Progress, ProgressBar, ProgressMemo, ProjectAllocation, QuickActionGroup, RadioGroup, RadioGroupCards, RadioWithIcon, RadioWithIconGroup, ReadOnlyAllocationSlider, ReadOnlyAllocationSliderMemo, ScalableContainer, ScalableContainerMemo, ScreenLoading, SectionTitle, SectionTitleMemo, Select, SelectMemo, SideDrawer, SideDrawerHeader, SideNav, SideNavItem, SideNavMemo, SideNavSection, SideNavSectionMemo, Skeleton, Slider, SliderMemo, Spinner, SplitScreen, SplitScreenMemo, SplitView, Stack, StackMemo, StackedGroupAvatars, StackedGroupAvatarsMemo, Stat, Stats, Status, StatusMemo, StepByStepAllocationSlider, StepByStepAllocationSliderMemo, StickyHeaderedList, StyledNavItemDiv, StyledPercentage, StyledTextLeftSpan, StyledTextRightSpan, SummaryEquation, SympatheticHighlightProvider, TabPanelContainer, Table, TableContainer, TableContainerMemo, Tag, TagInput, TagInputContainer, TextArea, TextAreaButton, TextAreaButtonMemo, TextAreaMemo, TextCell, TextCellMemo, Ticket, TitleWithHelp, Toast, ToastDurationOptions, ToastRegion, Toggle, ToggleMemo, ToggleSwitch, ToggleSwitchMemo, Tooltip, TooltipMemo, TopNavBarSelector, TopNavBarSelectorMemo, TrailingButton, TrailingButtonMemo, TrouserHeader, TwoColumnLayout, TwoColumnLayoutMemo, Typography, TypographyMemo, Width, Wizard, addActionColumn, colors, condensedContent, convertTextToColor, createLinearGradientCss, defaultGradient, generateData, getBorderRadius, getBoxShadow, getGapX, getGapXY, getGapY, getHeight, getInitials, getMonthDateOptions, getOverflow, getPaddingX, getPaddingY, getRecipeClassName, getRecipeColor, getRgbTileColor, getSelectPopoverId, getSelectedColumn, getSelectedRow, getSpaceX, getSpaceY, getTextDecoration, getTextOverflow, getTextTransform, getWhiteSpace, getWidth, grayedOutRowBackground, monthOptions, normalizeValue, normalizeValueCubicRootExponentialScale, normalizeValueSquareRootExponentialScale, pickRgbColor, pickRgbFromGradient, pipe, possibleMonthDateOptions, sanitizeRgbGradient, useCommonTable, useControlledFlyoutMenu, useElementSize, useEventListener, useFeatures, useHoverIntent, useModal, useMonthDateOptions, usePopoverState, useScrollableElement, useScrollbarWidth, useSelectable, useSideDrawer, useSplitView, useStepper, useSympatheticHighlight, useTabState, useTopNavBarSelector };

//# sourceMappingURL=neo.tax.esm.js.map